/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(326);
	module.exports = __webpack_require__(371);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(435)
	var ieee754 = __webpack_require__(549)
	var isArray = __webpack_require__(235)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(1)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(20);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 6 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
	  'use strict';
	
	  // Utils
	  function assert (val, msg) {
	    if (!val) throw new Error(msg || 'Assertion failed');
	  }
	
	  // Could use `inherits` module, but don't want to move from single file
	  // architecture yet.
	  function inherits (ctor, superCtor) {
	    ctor.super_ = superCtor;
	    var TempCtor = function () {};
	    TempCtor.prototype = superCtor.prototype;
	    ctor.prototype = new TempCtor();
	    ctor.prototype.constructor = ctor;
	  }
	
	  // BN
	
	  function BN (number, base, endian) {
	    if (BN.isBN(number)) {
	      return number;
	    }
	
	    this.negative = 0;
	    this.words = null;
	    this.length = 0;
	
	    // Reduction context
	    this.red = null;
	
	    if (number !== null) {
	      if (base === 'le' || base === 'be') {
	        endian = base;
	        base = 10;
	      }
	
	      this._init(number || 0, base || 10, endian || 'be');
	    }
	  }
	  if (typeof module === 'object') {
	    module.exports = BN;
	  } else {
	    exports.BN = BN;
	  }
	
	  BN.BN = BN;
	  BN.wordSize = 26;
	
	  var Buffer;
	  try {
	    Buffer = __webpack_require__(1).Buffer;
	  } catch (e) {
	  }
	
	  BN.isBN = function isBN (num) {
	    if (num instanceof BN) {
	      return true;
	    }
	
	    return num !== null && typeof num === 'object' &&
	      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
	  };
	
	  BN.max = function max (left, right) {
	    if (left.cmp(right) > 0) return left;
	    return right;
	  };
	
	  BN.min = function min (left, right) {
	    if (left.cmp(right) < 0) return left;
	    return right;
	  };
	
	  BN.prototype._init = function init (number, base, endian) {
	    if (typeof number === 'number') {
	      return this._initNumber(number, base, endian);
	    }
	
	    if (typeof number === 'object') {
	      return this._initArray(number, base, endian);
	    }
	
	    if (base === 'hex') {
	      base = 16;
	    }
	    assert(base === (base | 0) && base >= 2 && base <= 36);
	
	    number = number.toString().replace(/\s+/g, '');
	    var start = 0;
	    if (number[0] === '-') {
	      start++;
	    }
	
	    if (base === 16) {
	      this._parseHex(number, start);
	    } else {
	      this._parseBase(number, base, start);
	    }
	
	    if (number[0] === '-') {
	      this.negative = 1;
	    }
	
	    this.strip();
	
	    if (endian !== 'le') return;
	
	    this._initArray(this.toArray(), base, endian);
	  };
	
	  BN.prototype._initNumber = function _initNumber (number, base, endian) {
	    if (number < 0) {
	      this.negative = 1;
	      number = -number;
	    }
	    if (number < 0x4000000) {
	      this.words = [ number & 0x3ffffff ];
	      this.length = 1;
	    } else if (number < 0x10000000000000) {
	      this.words = [
	        number & 0x3ffffff,
	        (number / 0x4000000) & 0x3ffffff
	      ];
	      this.length = 2;
	    } else {
	      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
	      this.words = [
	        number & 0x3ffffff,
	        (number / 0x4000000) & 0x3ffffff,
	        1
	      ];
	      this.length = 3;
	    }
	
	    if (endian !== 'le') return;
	
	    // Reverse the bytes
	    this._initArray(this.toArray(), base, endian);
	  };
	
	  BN.prototype._initArray = function _initArray (number, base, endian) {
	    // Perhaps a Uint8Array
	    assert(typeof number.length === 'number');
	    if (number.length <= 0) {
	      this.words = [ 0 ];
	      this.length = 1;
	      return this;
	    }
	
	    this.length = Math.ceil(number.length / 3);
	    this.words = new Array(this.length);
	    for (var i = 0; i < this.length; i++) {
	      this.words[i] = 0;
	    }
	
	    var j, w;
	    var off = 0;
	    if (endian === 'be') {
	      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
	        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
	        this.words[j] |= (w << off) & 0x3ffffff;
	        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
	        off += 24;
	        if (off >= 26) {
	          off -= 26;
	          j++;
	        }
	      }
	    } else if (endian === 'le') {
	      for (i = 0, j = 0; i < number.length; i += 3) {
	        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
	        this.words[j] |= (w << off) & 0x3ffffff;
	        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
	        off += 24;
	        if (off >= 26) {
	          off -= 26;
	          j++;
	        }
	      }
	    }
	    return this.strip();
	  };
	
	  function parseHex (str, start, end) {
	    var r = 0;
	    var len = Math.min(str.length, end);
	    for (var i = start; i < len; i++) {
	      var c = str.charCodeAt(i) - 48;
	
	      r <<= 4;
	
	      // 'a' - 'f'
	      if (c >= 49 && c <= 54) {
	        r |= c - 49 + 0xa;
	
	      // 'A' - 'F'
	      } else if (c >= 17 && c <= 22) {
	        r |= c - 17 + 0xa;
	
	      // '0' - '9'
	      } else {
	        r |= c & 0xf;
	      }
	    }
	    return r;
	  }
	
	  BN.prototype._parseHex = function _parseHex (number, start) {
	    // Create possibly bigger array to ensure that it fits the number
	    this.length = Math.ceil((number.length - start) / 6);
	    this.words = new Array(this.length);
	    for (var i = 0; i < this.length; i++) {
	      this.words[i] = 0;
	    }
	
	    var j, w;
	    // Scan 24-bit chunks and add them to the number
	    var off = 0;
	    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
	      w = parseHex(number, i, i + 6);
	      this.words[j] |= (w << off) & 0x3ffffff;
	      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
	      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
	      off += 24;
	      if (off >= 26) {
	        off -= 26;
	        j++;
	      }
	    }
	    if (i + 6 !== start) {
	      w = parseHex(number, start, i + 6);
	      this.words[j] |= (w << off) & 0x3ffffff;
	      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
	    }
	    this.strip();
	  };
	
	  function parseBase (str, start, end, mul) {
	    var r = 0;
	    var len = Math.min(str.length, end);
	    for (var i = start; i < len; i++) {
	      var c = str.charCodeAt(i) - 48;
	
	      r *= mul;
	
	      // 'a'
	      if (c >= 49) {
	        r += c - 49 + 0xa;
	
	      // 'A'
	      } else if (c >= 17) {
	        r += c - 17 + 0xa;
	
	      // '0' - '9'
	      } else {
	        r += c;
	      }
	    }
	    return r;
	  }
	
	  BN.prototype._parseBase = function _parseBase (number, base, start) {
	    // Initialize as zero
	    this.words = [ 0 ];
	    this.length = 1;
	
	    // Find length of limb in base
	    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
	      limbLen++;
	    }
	    limbLen--;
	    limbPow = (limbPow / base) | 0;
	
	    var total = number.length - start;
	    var mod = total % limbLen;
	    var end = Math.min(total, total - mod) + start;
	
	    var word = 0;
	    for (var i = start; i < end; i += limbLen) {
	      word = parseBase(number, i, i + limbLen, base);
	
	      this.imuln(limbPow);
	      if (this.words[0] + word < 0x4000000) {
	        this.words[0] += word;
	      } else {
	        this._iaddn(word);
	      }
	    }
	
	    if (mod !== 0) {
	      var pow = 1;
	      word = parseBase(number, i, number.length, base);
	
	      for (i = 0; i < mod; i++) {
	        pow *= base;
	      }
	
	      this.imuln(pow);
	      if (this.words[0] + word < 0x4000000) {
	        this.words[0] += word;
	      } else {
	        this._iaddn(word);
	      }
	    }
	  };
	
	  BN.prototype.copy = function copy (dest) {
	    dest.words = new Array(this.length);
	    for (var i = 0; i < this.length; i++) {
	      dest.words[i] = this.words[i];
	    }
	    dest.length = this.length;
	    dest.negative = this.negative;
	    dest.red = this.red;
	  };
	
	  BN.prototype.clone = function clone () {
	    var r = new BN(null);
	    this.copy(r);
	    return r;
	  };
	
	  BN.prototype._expand = function _expand (size) {
	    while (this.length < size) {
	      this.words[this.length++] = 0;
	    }
	    return this;
	  };
	
	  // Remove leading `0` from `this`
	  BN.prototype.strip = function strip () {
	    while (this.length > 1 && this.words[this.length - 1] === 0) {
	      this.length--;
	    }
	    return this._normSign();
	  };
	
	  BN.prototype._normSign = function _normSign () {
	    // -0 = 0
	    if (this.length === 1 && this.words[0] === 0) {
	      this.negative = 0;
	    }
	    return this;
	  };
	
	  BN.prototype.inspect = function inspect () {
	    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
	  };
	
	  /*
	
	  var zeros = [];
	  var groupSizes = [];
	  var groupBases = [];
	
	  var s = '';
	  var i = -1;
	  while (++i < BN.wordSize) {
	    zeros[i] = s;
	    s += '0';
	  }
	  groupSizes[0] = 0;
	  groupSizes[1] = 0;
	  groupBases[0] = 0;
	  groupBases[1] = 0;
	  var base = 2 - 1;
	  while (++base < 36 + 1) {
	    var groupSize = 0;
	    var groupBase = 1;
	    while (groupBase < (1 << BN.wordSize) / base) {
	      groupBase *= base;
	      groupSize += 1;
	    }
	    groupSizes[base] = groupSize;
	    groupBases[base] = groupBase;
	  }
	
	  */
	
	  var zeros = [
	    '',
	    '0',
	    '00',
	    '000',
	    '0000',
	    '00000',
	    '000000',
	    '0000000',
	    '00000000',
	    '000000000',
	    '0000000000',
	    '00000000000',
	    '000000000000',
	    '0000000000000',
	    '00000000000000',
	    '000000000000000',
	    '0000000000000000',
	    '00000000000000000',
	    '000000000000000000',
	    '0000000000000000000',
	    '00000000000000000000',
	    '000000000000000000000',
	    '0000000000000000000000',
	    '00000000000000000000000',
	    '000000000000000000000000',
	    '0000000000000000000000000'
	  ];
	
	  var groupSizes = [
	    0, 0,
	    25, 16, 12, 11, 10, 9, 8,
	    8, 7, 7, 7, 7, 6, 6,
	    6, 6, 6, 6, 6, 5, 5,
	    5, 5, 5, 5, 5, 5, 5,
	    5, 5, 5, 5, 5, 5, 5
	  ];
	
	  var groupBases = [
	    0, 0,
	    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
	    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
	    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
	    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
	    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
	  ];
	
	  BN.prototype.toString = function toString (base, padding) {
	    base = base || 10;
	    padding = padding | 0 || 1;
	
	    var out;
	    if (base === 16 || base === 'hex') {
	      out = '';
	      var off = 0;
	      var carry = 0;
	      for (var i = 0; i < this.length; i++) {
	        var w = this.words[i];
	        var word = (((w << off) | carry) & 0xffffff).toString(16);
	        carry = (w >>> (24 - off)) & 0xffffff;
	        if (carry !== 0 || i !== this.length - 1) {
	          out = zeros[6 - word.length] + word + out;
	        } else {
	          out = word + out;
	        }
	        off += 2;
	        if (off >= 26) {
	          off -= 26;
	          i--;
	        }
	      }
	      if (carry !== 0) {
	        out = carry.toString(16) + out;
	      }
	      while (out.length % padding !== 0) {
	        out = '0' + out;
	      }
	      if (this.negative !== 0) {
	        out = '-' + out;
	      }
	      return out;
	    }
	
	    if (base === (base | 0) && base >= 2 && base <= 36) {
	      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
	      var groupSize = groupSizes[base];
	      // var groupBase = Math.pow(base, groupSize);
	      var groupBase = groupBases[base];
	      out = '';
	      var c = this.clone();
	      c.negative = 0;
	      while (!c.isZero()) {
	        var r = c.modn(groupBase).toString(base);
	        c = c.idivn(groupBase);
	
	        if (!c.isZero()) {
	          out = zeros[groupSize - r.length] + r + out;
	        } else {
	          out = r + out;
	        }
	      }
	      if (this.isZero()) {
	        out = '0' + out;
	      }
	      while (out.length % padding !== 0) {
	        out = '0' + out;
	      }
	      if (this.negative !== 0) {
	        out = '-' + out;
	      }
	      return out;
	    }
	
	    assert(false, 'Base should be between 2 and 36');
	  };
	
	  BN.prototype.toNumber = function toNumber () {
	    var ret = this.words[0];
	    if (this.length === 2) {
	      ret += this.words[1] * 0x4000000;
	    } else if (this.length === 3 && this.words[2] === 0x01) {
	      // NOTE: at this stage it is known that the top bit is set
	      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
	    } else if (this.length > 2) {
	      assert(false, 'Number can only safely store up to 53 bits');
	    }
	    return (this.negative !== 0) ? -ret : ret;
	  };
	
	  BN.prototype.toJSON = function toJSON () {
	    return this.toString(16);
	  };
	
	  BN.prototype.toBuffer = function toBuffer (endian, length) {
	    assert(typeof Buffer !== 'undefined');
	    return this.toArrayLike(Buffer, endian, length);
	  };
	
	  BN.prototype.toArray = function toArray (endian, length) {
	    return this.toArrayLike(Array, endian, length);
	  };
	
	  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
	    var byteLength = this.byteLength();
	    var reqLength = length || Math.max(1, byteLength);
	    assert(byteLength <= reqLength, 'byte array longer than desired length');
	    assert(reqLength > 0, 'Requested array length <= 0');
	
	    this.strip();
	    var littleEndian = endian === 'le';
	    var res = new ArrayType(reqLength);
	
	    var b, i;
	    var q = this.clone();
	    if (!littleEndian) {
	      // Assume big-endian
	      for (i = 0; i < reqLength - byteLength; i++) {
	        res[i] = 0;
	      }
	
	      for (i = 0; !q.isZero(); i++) {
	        b = q.andln(0xff);
	        q.iushrn(8);
	
	        res[reqLength - i - 1] = b;
	      }
	    } else {
	      for (i = 0; !q.isZero(); i++) {
	        b = q.andln(0xff);
	        q.iushrn(8);
	
	        res[i] = b;
	      }
	
	      for (; i < reqLength; i++) {
	        res[i] = 0;
	      }
	    }
	
	    return res;
	  };
	
	  if (Math.clz32) {
	    BN.prototype._countBits = function _countBits (w) {
	      return 32 - Math.clz32(w);
	    };
	  } else {
	    BN.prototype._countBits = function _countBits (w) {
	      var t = w;
	      var r = 0;
	      if (t >= 0x1000) {
	        r += 13;
	        t >>>= 13;
	      }
	      if (t >= 0x40) {
	        r += 7;
	        t >>>= 7;
	      }
	      if (t >= 0x8) {
	        r += 4;
	        t >>>= 4;
	      }
	      if (t >= 0x02) {
	        r += 2;
	        t >>>= 2;
	      }
	      return r + t;
	    };
	  }
	
	  BN.prototype._zeroBits = function _zeroBits (w) {
	    // Short-cut
	    if (w === 0) return 26;
	
	    var t = w;
	    var r = 0;
	    if ((t & 0x1fff) === 0) {
	      r += 13;
	      t >>>= 13;
	    }
	    if ((t & 0x7f) === 0) {
	      r += 7;
	      t >>>= 7;
	    }
	    if ((t & 0xf) === 0) {
	      r += 4;
	      t >>>= 4;
	    }
	    if ((t & 0x3) === 0) {
	      r += 2;
	      t >>>= 2;
	    }
	    if ((t & 0x1) === 0) {
	      r++;
	    }
	    return r;
	  };
	
	  // Return number of used bits in a BN
	  BN.prototype.bitLength = function bitLength () {
	    var w = this.words[this.length - 1];
	    var hi = this._countBits(w);
	    return (this.length - 1) * 26 + hi;
	  };
	
	  function toBitArray (num) {
	    var w = new Array(num.bitLength());
	
	    for (var bit = 0; bit < w.length; bit++) {
	      var off = (bit / 26) | 0;
	      var wbit = bit % 26;
	
	      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
	    }
	
	    return w;
	  }
	
	  // Number of trailing zero bits
	  BN.prototype.zeroBits = function zeroBits () {
	    if (this.isZero()) return 0;
	
	    var r = 0;
	    for (var i = 0; i < this.length; i++) {
	      var b = this._zeroBits(this.words[i]);
	      r += b;
	      if (b !== 26) break;
	    }
	    return r;
	  };
	
	  BN.prototype.byteLength = function byteLength () {
	    return Math.ceil(this.bitLength() / 8);
	  };
	
	  BN.prototype.toTwos = function toTwos (width) {
	    if (this.negative !== 0) {
	      return this.abs().inotn(width).iaddn(1);
	    }
	    return this.clone();
	  };
	
	  BN.prototype.fromTwos = function fromTwos (width) {
	    if (this.testn(width - 1)) {
	      return this.notn(width).iaddn(1).ineg();
	    }
	    return this.clone();
	  };
	
	  BN.prototype.isNeg = function isNeg () {
	    return this.negative !== 0;
	  };
	
	  // Return negative clone of `this`
	  BN.prototype.neg = function neg () {
	    return this.clone().ineg();
	  };
	
	  BN.prototype.ineg = function ineg () {
	    if (!this.isZero()) {
	      this.negative ^= 1;
	    }
	
	    return this;
	  };
	
	  // Or `num` with `this` in-place
	  BN.prototype.iuor = function iuor (num) {
	    while (this.length < num.length) {
	      this.words[this.length++] = 0;
	    }
	
	    for (var i = 0; i < num.length; i++) {
	      this.words[i] = this.words[i] | num.words[i];
	    }
	
	    return this.strip();
	  };
	
	  BN.prototype.ior = function ior (num) {
	    assert((this.negative | num.negative) === 0);
	    return this.iuor(num);
	  };
	
	  // Or `num` with `this`
	  BN.prototype.or = function or (num) {
	    if (this.length > num.length) return this.clone().ior(num);
	    return num.clone().ior(this);
	  };
	
	  BN.prototype.uor = function uor (num) {
	    if (this.length > num.length) return this.clone().iuor(num);
	    return num.clone().iuor(this);
	  };
	
	  // And `num` with `this` in-place
	  BN.prototype.iuand = function iuand (num) {
	    // b = min-length(num, this)
	    var b;
	    if (this.length > num.length) {
	      b = num;
	    } else {
	      b = this;
	    }
	
	    for (var i = 0; i < b.length; i++) {
	      this.words[i] = this.words[i] & num.words[i];
	    }
	
	    this.length = b.length;
	
	    return this.strip();
	  };
	
	  BN.prototype.iand = function iand (num) {
	    assert((this.negative | num.negative) === 0);
	    return this.iuand(num);
	  };
	
	  // And `num` with `this`
	  BN.prototype.and = function and (num) {
	    if (this.length > num.length) return this.clone().iand(num);
	    return num.clone().iand(this);
	  };
	
	  BN.prototype.uand = function uand (num) {
	    if (this.length > num.length) return this.clone().iuand(num);
	    return num.clone().iuand(this);
	  };
	
	  // Xor `num` with `this` in-place
	  BN.prototype.iuxor = function iuxor (num) {
	    // a.length > b.length
	    var a;
	    var b;
	    if (this.length > num.length) {
	      a = this;
	      b = num;
	    } else {
	      a = num;
	      b = this;
	    }
	
	    for (var i = 0; i < b.length; i++) {
	      this.words[i] = a.words[i] ^ b.words[i];
	    }
	
	    if (this !== a) {
	      for (; i < a.length; i++) {
	        this.words[i] = a.words[i];
	      }
	    }
	
	    this.length = a.length;
	
	    return this.strip();
	  };
	
	  BN.prototype.ixor = function ixor (num) {
	    assert((this.negative | num.negative) === 0);
	    return this.iuxor(num);
	  };
	
	  // Xor `num` with `this`
	  BN.prototype.xor = function xor (num) {
	    if (this.length > num.length) return this.clone().ixor(num);
	    return num.clone().ixor(this);
	  };
	
	  BN.prototype.uxor = function uxor (num) {
	    if (this.length > num.length) return this.clone().iuxor(num);
	    return num.clone().iuxor(this);
	  };
	
	  // Not ``this`` with ``width`` bitwidth
	  BN.prototype.inotn = function inotn (width) {
	    assert(typeof width === 'number' && width >= 0);
	
	    var bytesNeeded = Math.ceil(width / 26) | 0;
	    var bitsLeft = width % 26;
	
	    // Extend the buffer with leading zeroes
	    this._expand(bytesNeeded);
	
	    if (bitsLeft > 0) {
	      bytesNeeded--;
	    }
	
	    // Handle complete words
	    for (var i = 0; i < bytesNeeded; i++) {
	      this.words[i] = ~this.words[i] & 0x3ffffff;
	    }
	
	    // Handle the residue
	    if (bitsLeft > 0) {
	      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
	    }
	
	    // And remove leading zeroes
	    return this.strip();
	  };
	
	  BN.prototype.notn = function notn (width) {
	    return this.clone().inotn(width);
	  };
	
	  // Set `bit` of `this`
	  BN.prototype.setn = function setn (bit, val) {
	    assert(typeof bit === 'number' && bit >= 0);
	
	    var off = (bit / 26) | 0;
	    var wbit = bit % 26;
	
	    this._expand(off + 1);
	
	    if (val) {
	      this.words[off] = this.words[off] | (1 << wbit);
	    } else {
	      this.words[off] = this.words[off] & ~(1 << wbit);
	    }
	
	    return this.strip();
	  };
	
	  // Add `num` to `this` in-place
	  BN.prototype.iadd = function iadd (num) {
	    var r;
	
	    // negative + positive
	    if (this.negative !== 0 && num.negative === 0) {
	      this.negative = 0;
	      r = this.isub(num);
	      this.negative ^= 1;
	      return this._normSign();
	
	    // positive + negative
	    } else if (this.negative === 0 && num.negative !== 0) {
	      num.negative = 0;
	      r = this.isub(num);
	      num.negative = 1;
	      return r._normSign();
	    }
	
	    // a.length > b.length
	    var a, b;
	    if (this.length > num.length) {
	      a = this;
	      b = num;
	    } else {
	      a = num;
	      b = this;
	    }
	
	    var carry = 0;
	    for (var i = 0; i < b.length; i++) {
	      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
	      this.words[i] = r & 0x3ffffff;
	      carry = r >>> 26;
	    }
	    for (; carry !== 0 && i < a.length; i++) {
	      r = (a.words[i] | 0) + carry;
	      this.words[i] = r & 0x3ffffff;
	      carry = r >>> 26;
	    }
	
	    this.length = a.length;
	    if (carry !== 0) {
	      this.words[this.length] = carry;
	      this.length++;
	    // Copy the rest of the words
	    } else if (a !== this) {
	      for (; i < a.length; i++) {
	        this.words[i] = a.words[i];
	      }
	    }
	
	    return this;
	  };
	
	  // Add `num` to `this`
	  BN.prototype.add = function add (num) {
	    var res;
	    if (num.negative !== 0 && this.negative === 0) {
	      num.negative = 0;
	      res = this.sub(num);
	      num.negative ^= 1;
	      return res;
	    } else if (num.negative === 0 && this.negative !== 0) {
	      this.negative = 0;
	      res = num.sub(this);
	      this.negative = 1;
	      return res;
	    }
	
	    if (this.length > num.length) return this.clone().iadd(num);
	
	    return num.clone().iadd(this);
	  };
	
	  // Subtract `num` from `this` in-place
	  BN.prototype.isub = function isub (num) {
	    // this - (-num) = this + num
	    if (num.negative !== 0) {
	      num.negative = 0;
	      var r = this.iadd(num);
	      num.negative = 1;
	      return r._normSign();
	
	    // -this - num = -(this + num)
	    } else if (this.negative !== 0) {
	      this.negative = 0;
	      this.iadd(num);
	      this.negative = 1;
	      return this._normSign();
	    }
	
	    // At this point both numbers are positive
	    var cmp = this.cmp(num);
	
	    // Optimization - zeroify
	    if (cmp === 0) {
	      this.negative = 0;
	      this.length = 1;
	      this.words[0] = 0;
	      return this;
	    }
	
	    // a > b
	    var a, b;
	    if (cmp > 0) {
	      a = this;
	      b = num;
	    } else {
	      a = num;
	      b = this;
	    }
	
	    var carry = 0;
	    for (var i = 0; i < b.length; i++) {
	      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
	      carry = r >> 26;
	      this.words[i] = r & 0x3ffffff;
	    }
	    for (; carry !== 0 && i < a.length; i++) {
	      r = (a.words[i] | 0) + carry;
	      carry = r >> 26;
	      this.words[i] = r & 0x3ffffff;
	    }
	
	    // Copy rest of the words
	    if (carry === 0 && i < a.length && a !== this) {
	      for (; i < a.length; i++) {
	        this.words[i] = a.words[i];
	      }
	    }
	
	    this.length = Math.max(this.length, i);
	
	    if (a !== this) {
	      this.negative = 1;
	    }
	
	    return this.strip();
	  };
	
	  // Subtract `num` from `this`
	  BN.prototype.sub = function sub (num) {
	    return this.clone().isub(num);
	  };
	
	  function smallMulTo (self, num, out) {
	    out.negative = num.negative ^ self.negative;
	    var len = (self.length + num.length) | 0;
	    out.length = len;
	    len = (len - 1) | 0;
	
	    // Peel one iteration (compiler can't do it, because of code complexity)
	    var a = self.words[0] | 0;
	    var b = num.words[0] | 0;
	    var r = a * b;
	
	    var lo = r & 0x3ffffff;
	    var carry = (r / 0x4000000) | 0;
	    out.words[0] = lo;
	
	    for (var k = 1; k < len; k++) {
	      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
	      // note that ncarry could be >= 0x3ffffff
	      var ncarry = carry >>> 26;
	      var rword = carry & 0x3ffffff;
	      var maxJ = Math.min(k, num.length - 1);
	      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
	        var i = (k - j) | 0;
	        a = self.words[i] | 0;
	        b = num.words[j] | 0;
	        r = a * b + rword;
	        ncarry += (r / 0x4000000) | 0;
	        rword = r & 0x3ffffff;
	      }
	      out.words[k] = rword | 0;
	      carry = ncarry | 0;
	    }
	    if (carry !== 0) {
	      out.words[k] = carry | 0;
	    } else {
	      out.length--;
	    }
	
	    return out.strip();
	  }
	
	  // TODO(indutny): it may be reasonable to omit it for users who don't need
	  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
	  // multiplication (like elliptic secp256k1).
	  var comb10MulTo = function comb10MulTo (self, num, out) {
	    var a = self.words;
	    var b = num.words;
	    var o = out.words;
	    var c = 0;
	    var lo;
	    var mid;
	    var hi;
	    var a0 = a[0] | 0;
	    var al0 = a0 & 0x1fff;
	    var ah0 = a0 >>> 13;
	    var a1 = a[1] | 0;
	    var al1 = a1 & 0x1fff;
	    var ah1 = a1 >>> 13;
	    var a2 = a[2] | 0;
	    var al2 = a2 & 0x1fff;
	    var ah2 = a2 >>> 13;
	    var a3 = a[3] | 0;
	    var al3 = a3 & 0x1fff;
	    var ah3 = a3 >>> 13;
	    var a4 = a[4] | 0;
	    var al4 = a4 & 0x1fff;
	    var ah4 = a4 >>> 13;
	    var a5 = a[5] | 0;
	    var al5 = a5 & 0x1fff;
	    var ah5 = a5 >>> 13;
	    var a6 = a[6] | 0;
	    var al6 = a6 & 0x1fff;
	    var ah6 = a6 >>> 13;
	    var a7 = a[7] | 0;
	    var al7 = a7 & 0x1fff;
	    var ah7 = a7 >>> 13;
	    var a8 = a[8] | 0;
	    var al8 = a8 & 0x1fff;
	    var ah8 = a8 >>> 13;
	    var a9 = a[9] | 0;
	    var al9 = a9 & 0x1fff;
	    var ah9 = a9 >>> 13;
	    var b0 = b[0] | 0;
	    var bl0 = b0 & 0x1fff;
	    var bh0 = b0 >>> 13;
	    var b1 = b[1] | 0;
	    var bl1 = b1 & 0x1fff;
	    var bh1 = b1 >>> 13;
	    var b2 = b[2] | 0;
	    var bl2 = b2 & 0x1fff;
	    var bh2 = b2 >>> 13;
	    var b3 = b[3] | 0;
	    var bl3 = b3 & 0x1fff;
	    var bh3 = b3 >>> 13;
	    var b4 = b[4] | 0;
	    var bl4 = b4 & 0x1fff;
	    var bh4 = b4 >>> 13;
	    var b5 = b[5] | 0;
	    var bl5 = b5 & 0x1fff;
	    var bh5 = b5 >>> 13;
	    var b6 = b[6] | 0;
	    var bl6 = b6 & 0x1fff;
	    var bh6 = b6 >>> 13;
	    var b7 = b[7] | 0;
	    var bl7 = b7 & 0x1fff;
	    var bh7 = b7 >>> 13;
	    var b8 = b[8] | 0;
	    var bl8 = b8 & 0x1fff;
	    var bh8 = b8 >>> 13;
	    var b9 = b[9] | 0;
	    var bl9 = b9 & 0x1fff;
	    var bh9 = b9 >>> 13;
	
	    out.negative = self.negative ^ num.negative;
	    out.length = 19;
	    /* k = 0 */
	    lo = Math.imul(al0, bl0);
	    mid = Math.imul(al0, bh0);
	    mid = (mid + Math.imul(ah0, bl0)) | 0;
	    hi = Math.imul(ah0, bh0);
	    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
	    w0 &= 0x3ffffff;
	    /* k = 1 */
	    lo = Math.imul(al1, bl0);
	    mid = Math.imul(al1, bh0);
	    mid = (mid + Math.imul(ah1, bl0)) | 0;
	    hi = Math.imul(ah1, bh0);
	    lo = (lo + Math.imul(al0, bl1)) | 0;
	    mid = (mid + Math.imul(al0, bh1)) | 0;
	    mid = (mid + Math.imul(ah0, bl1)) | 0;
	    hi = (hi + Math.imul(ah0, bh1)) | 0;
	    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
	    w1 &= 0x3ffffff;
	    /* k = 2 */
	    lo = Math.imul(al2, bl0);
	    mid = Math.imul(al2, bh0);
	    mid = (mid + Math.imul(ah2, bl0)) | 0;
	    hi = Math.imul(ah2, bh0);
	    lo = (lo + Math.imul(al1, bl1)) | 0;
	    mid = (mid + Math.imul(al1, bh1)) | 0;
	    mid = (mid + Math.imul(ah1, bl1)) | 0;
	    hi = (hi + Math.imul(ah1, bh1)) | 0;
	    lo = (lo + Math.imul(al0, bl2)) | 0;
	    mid = (mid + Math.imul(al0, bh2)) | 0;
	    mid = (mid + Math.imul(ah0, bl2)) | 0;
	    hi = (hi + Math.imul(ah0, bh2)) | 0;
	    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
	    w2 &= 0x3ffffff;
	    /* k = 3 */
	    lo = Math.imul(al3, bl0);
	    mid = Math.imul(al3, bh0);
	    mid = (mid + Math.imul(ah3, bl0)) | 0;
	    hi = Math.imul(ah3, bh0);
	    lo = (lo + Math.imul(al2, bl1)) | 0;
	    mid = (mid + Math.imul(al2, bh1)) | 0;
	    mid = (mid + Math.imul(ah2, bl1)) | 0;
	    hi = (hi + Math.imul(ah2, bh1)) | 0;
	    lo = (lo + Math.imul(al1, bl2)) | 0;
	    mid = (mid + Math.imul(al1, bh2)) | 0;
	    mid = (mid + Math.imul(ah1, bl2)) | 0;
	    hi = (hi + Math.imul(ah1, bh2)) | 0;
	    lo = (lo + Math.imul(al0, bl3)) | 0;
	    mid = (mid + Math.imul(al0, bh3)) | 0;
	    mid = (mid + Math.imul(ah0, bl3)) | 0;
	    hi = (hi + Math.imul(ah0, bh3)) | 0;
	    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
	    w3 &= 0x3ffffff;
	    /* k = 4 */
	    lo = Math.imul(al4, bl0);
	    mid = Math.imul(al4, bh0);
	    mid = (mid + Math.imul(ah4, bl0)) | 0;
	    hi = Math.imul(ah4, bh0);
	    lo = (lo + Math.imul(al3, bl1)) | 0;
	    mid = (mid + Math.imul(al3, bh1)) | 0;
	    mid = (mid + Math.imul(ah3, bl1)) | 0;
	    hi = (hi + Math.imul(ah3, bh1)) | 0;
	    lo = (lo + Math.imul(al2, bl2)) | 0;
	    mid = (mid + Math.imul(al2, bh2)) | 0;
	    mid = (mid + Math.imul(ah2, bl2)) | 0;
	    hi = (hi + Math.imul(ah2, bh2)) | 0;
	    lo = (lo + Math.imul(al1, bl3)) | 0;
	    mid = (mid + Math.imul(al1, bh3)) | 0;
	    mid = (mid + Math.imul(ah1, bl3)) | 0;
	    hi = (hi + Math.imul(ah1, bh3)) | 0;
	    lo = (lo + Math.imul(al0, bl4)) | 0;
	    mid = (mid + Math.imul(al0, bh4)) | 0;
	    mid = (mid + Math.imul(ah0, bl4)) | 0;
	    hi = (hi + Math.imul(ah0, bh4)) | 0;
	    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
	    w4 &= 0x3ffffff;
	    /* k = 5 */
	    lo = Math.imul(al5, bl0);
	    mid = Math.imul(al5, bh0);
	    mid = (mid + Math.imul(ah5, bl0)) | 0;
	    hi = Math.imul(ah5, bh0);
	    lo = (lo + Math.imul(al4, bl1)) | 0;
	    mid = (mid + Math.imul(al4, bh1)) | 0;
	    mid = (mid + Math.imul(ah4, bl1)) | 0;
	    hi = (hi + Math.imul(ah4, bh1)) | 0;
	    lo = (lo + Math.imul(al3, bl2)) | 0;
	    mid = (mid + Math.imul(al3, bh2)) | 0;
	    mid = (mid + Math.imul(ah3, bl2)) | 0;
	    hi = (hi + Math.imul(ah3, bh2)) | 0;
	    lo = (lo + Math.imul(al2, bl3)) | 0;
	    mid = (mid + Math.imul(al2, bh3)) | 0;
	    mid = (mid + Math.imul(ah2, bl3)) | 0;
	    hi = (hi + Math.imul(ah2, bh3)) | 0;
	    lo = (lo + Math.imul(al1, bl4)) | 0;
	    mid = (mid + Math.imul(al1, bh4)) | 0;
	    mid = (mid + Math.imul(ah1, bl4)) | 0;
	    hi = (hi + Math.imul(ah1, bh4)) | 0;
	    lo = (lo + Math.imul(al0, bl5)) | 0;
	    mid = (mid + Math.imul(al0, bh5)) | 0;
	    mid = (mid + Math.imul(ah0, bl5)) | 0;
	    hi = (hi + Math.imul(ah0, bh5)) | 0;
	    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
	    w5 &= 0x3ffffff;
	    /* k = 6 */
	    lo = Math.imul(al6, bl0);
	    mid = Math.imul(al6, bh0);
	    mid = (mid + Math.imul(ah6, bl0)) | 0;
	    hi = Math.imul(ah6, bh0);
	    lo = (lo + Math.imul(al5, bl1)) | 0;
	    mid = (mid + Math.imul(al5, bh1)) | 0;
	    mid = (mid + Math.imul(ah5, bl1)) | 0;
	    hi = (hi + Math.imul(ah5, bh1)) | 0;
	    lo = (lo + Math.imul(al4, bl2)) | 0;
	    mid = (mid + Math.imul(al4, bh2)) | 0;
	    mid = (mid + Math.imul(ah4, bl2)) | 0;
	    hi = (hi + Math.imul(ah4, bh2)) | 0;
	    lo = (lo + Math.imul(al3, bl3)) | 0;
	    mid = (mid + Math.imul(al3, bh3)) | 0;
	    mid = (mid + Math.imul(ah3, bl3)) | 0;
	    hi = (hi + Math.imul(ah3, bh3)) | 0;
	    lo = (lo + Math.imul(al2, bl4)) | 0;
	    mid = (mid + Math.imul(al2, bh4)) | 0;
	    mid = (mid + Math.imul(ah2, bl4)) | 0;
	    hi = (hi + Math.imul(ah2, bh4)) | 0;
	    lo = (lo + Math.imul(al1, bl5)) | 0;
	    mid = (mid + Math.imul(al1, bh5)) | 0;
	    mid = (mid + Math.imul(ah1, bl5)) | 0;
	    hi = (hi + Math.imul(ah1, bh5)) | 0;
	    lo = (lo + Math.imul(al0, bl6)) | 0;
	    mid = (mid + Math.imul(al0, bh6)) | 0;
	    mid = (mid + Math.imul(ah0, bl6)) | 0;
	    hi = (hi + Math.imul(ah0, bh6)) | 0;
	    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
	    w6 &= 0x3ffffff;
	    /* k = 7 */
	    lo = Math.imul(al7, bl0);
	    mid = Math.imul(al7, bh0);
	    mid = (mid + Math.imul(ah7, bl0)) | 0;
	    hi = Math.imul(ah7, bh0);
	    lo = (lo + Math.imul(al6, bl1)) | 0;
	    mid = (mid + Math.imul(al6, bh1)) | 0;
	    mid = (mid + Math.imul(ah6, bl1)) | 0;
	    hi = (hi + Math.imul(ah6, bh1)) | 0;
	    lo = (lo + Math.imul(al5, bl2)) | 0;
	    mid = (mid + Math.imul(al5, bh2)) | 0;
	    mid = (mid + Math.imul(ah5, bl2)) | 0;
	    hi = (hi + Math.imul(ah5, bh2)) | 0;
	    lo = (lo + Math.imul(al4, bl3)) | 0;
	    mid = (mid + Math.imul(al4, bh3)) | 0;
	    mid = (mid + Math.imul(ah4, bl3)) | 0;
	    hi = (hi + Math.imul(ah4, bh3)) | 0;
	    lo = (lo + Math.imul(al3, bl4)) | 0;
	    mid = (mid + Math.imul(al3, bh4)) | 0;
	    mid = (mid + Math.imul(ah3, bl4)) | 0;
	    hi = (hi + Math.imul(ah3, bh4)) | 0;
	    lo = (lo + Math.imul(al2, bl5)) | 0;
	    mid = (mid + Math.imul(al2, bh5)) | 0;
	    mid = (mid + Math.imul(ah2, bl5)) | 0;
	    hi = (hi + Math.imul(ah2, bh5)) | 0;
	    lo = (lo + Math.imul(al1, bl6)) | 0;
	    mid = (mid + Math.imul(al1, bh6)) | 0;
	    mid = (mid + Math.imul(ah1, bl6)) | 0;
	    hi = (hi + Math.imul(ah1, bh6)) | 0;
	    lo = (lo + Math.imul(al0, bl7)) | 0;
	    mid = (mid + Math.imul(al0, bh7)) | 0;
	    mid = (mid + Math.imul(ah0, bl7)) | 0;
	    hi = (hi + Math.imul(ah0, bh7)) | 0;
	    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
	    w7 &= 0x3ffffff;
	    /* k = 8 */
	    lo = Math.imul(al8, bl0);
	    mid = Math.imul(al8, bh0);
	    mid = (mid + Math.imul(ah8, bl0)) | 0;
	    hi = Math.imul(ah8, bh0);
	    lo = (lo + Math.imul(al7, bl1)) | 0;
	    mid = (mid + Math.imul(al7, bh1)) | 0;
	    mid = (mid + Math.imul(ah7, bl1)) | 0;
	    hi = (hi + Math.imul(ah7, bh1)) | 0;
	    lo = (lo + Math.imul(al6, bl2)) | 0;
	    mid = (mid + Math.imul(al6, bh2)) | 0;
	    mid = (mid + Math.imul(ah6, bl2)) | 0;
	    hi = (hi + Math.imul(ah6, bh2)) | 0;
	    lo = (lo + Math.imul(al5, bl3)) | 0;
	    mid = (mid + Math.imul(al5, bh3)) | 0;
	    mid = (mid + Math.imul(ah5, bl3)) | 0;
	    hi = (hi + Math.imul(ah5, bh3)) | 0;
	    lo = (lo + Math.imul(al4, bl4)) | 0;
	    mid = (mid + Math.imul(al4, bh4)) | 0;
	    mid = (mid + Math.imul(ah4, bl4)) | 0;
	    hi = (hi + Math.imul(ah4, bh4)) | 0;
	    lo = (lo + Math.imul(al3, bl5)) | 0;
	    mid = (mid + Math.imul(al3, bh5)) | 0;
	    mid = (mid + Math.imul(ah3, bl5)) | 0;
	    hi = (hi + Math.imul(ah3, bh5)) | 0;
	    lo = (lo + Math.imul(al2, bl6)) | 0;
	    mid = (mid + Math.imul(al2, bh6)) | 0;
	    mid = (mid + Math.imul(ah2, bl6)) | 0;
	    hi = (hi + Math.imul(ah2, bh6)) | 0;
	    lo = (lo + Math.imul(al1, bl7)) | 0;
	    mid = (mid + Math.imul(al1, bh7)) | 0;
	    mid = (mid + Math.imul(ah1, bl7)) | 0;
	    hi = (hi + Math.imul(ah1, bh7)) | 0;
	    lo = (lo + Math.imul(al0, bl8)) | 0;
	    mid = (mid + Math.imul(al0, bh8)) | 0;
	    mid = (mid + Math.imul(ah0, bl8)) | 0;
	    hi = (hi + Math.imul(ah0, bh8)) | 0;
	    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
	    w8 &= 0x3ffffff;
	    /* k = 9 */
	    lo = Math.imul(al9, bl0);
	    mid = Math.imul(al9, bh0);
	    mid = (mid + Math.imul(ah9, bl0)) | 0;
	    hi = Math.imul(ah9, bh0);
	    lo = (lo + Math.imul(al8, bl1)) | 0;
	    mid = (mid + Math.imul(al8, bh1)) | 0;
	    mid = (mid + Math.imul(ah8, bl1)) | 0;
	    hi = (hi + Math.imul(ah8, bh1)) | 0;
	    lo = (lo + Math.imul(al7, bl2)) | 0;
	    mid = (mid + Math.imul(al7, bh2)) | 0;
	    mid = (mid + Math.imul(ah7, bl2)) | 0;
	    hi = (hi + Math.imul(ah7, bh2)) | 0;
	    lo = (lo + Math.imul(al6, bl3)) | 0;
	    mid = (mid + Math.imul(al6, bh3)) | 0;
	    mid = (mid + Math.imul(ah6, bl3)) | 0;
	    hi = (hi + Math.imul(ah6, bh3)) | 0;
	    lo = (lo + Math.imul(al5, bl4)) | 0;
	    mid = (mid + Math.imul(al5, bh4)) | 0;
	    mid = (mid + Math.imul(ah5, bl4)) | 0;
	    hi = (hi + Math.imul(ah5, bh4)) | 0;
	    lo = (lo + Math.imul(al4, bl5)) | 0;
	    mid = (mid + Math.imul(al4, bh5)) | 0;
	    mid = (mid + Math.imul(ah4, bl5)) | 0;
	    hi = (hi + Math.imul(ah4, bh5)) | 0;
	    lo = (lo + Math.imul(al3, bl6)) | 0;
	    mid = (mid + Math.imul(al3, bh6)) | 0;
	    mid = (mid + Math.imul(ah3, bl6)) | 0;
	    hi = (hi + Math.imul(ah3, bh6)) | 0;
	    lo = (lo + Math.imul(al2, bl7)) | 0;
	    mid = (mid + Math.imul(al2, bh7)) | 0;
	    mid = (mid + Math.imul(ah2, bl7)) | 0;
	    hi = (hi + Math.imul(ah2, bh7)) | 0;
	    lo = (lo + Math.imul(al1, bl8)) | 0;
	    mid = (mid + Math.imul(al1, bh8)) | 0;
	    mid = (mid + Math.imul(ah1, bl8)) | 0;
	    hi = (hi + Math.imul(ah1, bh8)) | 0;
	    lo = (lo + Math.imul(al0, bl9)) | 0;
	    mid = (mid + Math.imul(al0, bh9)) | 0;
	    mid = (mid + Math.imul(ah0, bl9)) | 0;
	    hi = (hi + Math.imul(ah0, bh9)) | 0;
	    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
	    w9 &= 0x3ffffff;
	    /* k = 10 */
	    lo = Math.imul(al9, bl1);
	    mid = Math.imul(al9, bh1);
	    mid = (mid + Math.imul(ah9, bl1)) | 0;
	    hi = Math.imul(ah9, bh1);
	    lo = (lo + Math.imul(al8, bl2)) | 0;
	    mid = (mid + Math.imul(al8, bh2)) | 0;
	    mid = (mid + Math.imul(ah8, bl2)) | 0;
	    hi = (hi + Math.imul(ah8, bh2)) | 0;
	    lo = (lo + Math.imul(al7, bl3)) | 0;
	    mid = (mid + Math.imul(al7, bh3)) | 0;
	    mid = (mid + Math.imul(ah7, bl3)) | 0;
	    hi = (hi + Math.imul(ah7, bh3)) | 0;
	    lo = (lo + Math.imul(al6, bl4)) | 0;
	    mid = (mid + Math.imul(al6, bh4)) | 0;
	    mid = (mid + Math.imul(ah6, bl4)) | 0;
	    hi = (hi + Math.imul(ah6, bh4)) | 0;
	    lo = (lo + Math.imul(al5, bl5)) | 0;
	    mid = (mid + Math.imul(al5, bh5)) | 0;
	    mid = (mid + Math.imul(ah5, bl5)) | 0;
	    hi = (hi + Math.imul(ah5, bh5)) | 0;
	    lo = (lo + Math.imul(al4, bl6)) | 0;
	    mid = (mid + Math.imul(al4, bh6)) | 0;
	    mid = (mid + Math.imul(ah4, bl6)) | 0;
	    hi = (hi + Math.imul(ah4, bh6)) | 0;
	    lo = (lo + Math.imul(al3, bl7)) | 0;
	    mid = (mid + Math.imul(al3, bh7)) | 0;
	    mid = (mid + Math.imul(ah3, bl7)) | 0;
	    hi = (hi + Math.imul(ah3, bh7)) | 0;
	    lo = (lo + Math.imul(al2, bl8)) | 0;
	    mid = (mid + Math.imul(al2, bh8)) | 0;
	    mid = (mid + Math.imul(ah2, bl8)) | 0;
	    hi = (hi + Math.imul(ah2, bh8)) | 0;
	    lo = (lo + Math.imul(al1, bl9)) | 0;
	    mid = (mid + Math.imul(al1, bh9)) | 0;
	    mid = (mid + Math.imul(ah1, bl9)) | 0;
	    hi = (hi + Math.imul(ah1, bh9)) | 0;
	    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
	    w10 &= 0x3ffffff;
	    /* k = 11 */
	    lo = Math.imul(al9, bl2);
	    mid = Math.imul(al9, bh2);
	    mid = (mid + Math.imul(ah9, bl2)) | 0;
	    hi = Math.imul(ah9, bh2);
	    lo = (lo + Math.imul(al8, bl3)) | 0;
	    mid = (mid + Math.imul(al8, bh3)) | 0;
	    mid = (mid + Math.imul(ah8, bl3)) | 0;
	    hi = (hi + Math.imul(ah8, bh3)) | 0;
	    lo = (lo + Math.imul(al7, bl4)) | 0;
	    mid = (mid + Math.imul(al7, bh4)) | 0;
	    mid = (mid + Math.imul(ah7, bl4)) | 0;
	    hi = (hi + Math.imul(ah7, bh4)) | 0;
	    lo = (lo + Math.imul(al6, bl5)) | 0;
	    mid = (mid + Math.imul(al6, bh5)) | 0;
	    mid = (mid + Math.imul(ah6, bl5)) | 0;
	    hi = (hi + Math.imul(ah6, bh5)) | 0;
	    lo = (lo + Math.imul(al5, bl6)) | 0;
	    mid = (mid + Math.imul(al5, bh6)) | 0;
	    mid = (mid + Math.imul(ah5, bl6)) | 0;
	    hi = (hi + Math.imul(ah5, bh6)) | 0;
	    lo = (lo + Math.imul(al4, bl7)) | 0;
	    mid = (mid + Math.imul(al4, bh7)) | 0;
	    mid = (mid + Math.imul(ah4, bl7)) | 0;
	    hi = (hi + Math.imul(ah4, bh7)) | 0;
	    lo = (lo + Math.imul(al3, bl8)) | 0;
	    mid = (mid + Math.imul(al3, bh8)) | 0;
	    mid = (mid + Math.imul(ah3, bl8)) | 0;
	    hi = (hi + Math.imul(ah3, bh8)) | 0;
	    lo = (lo + Math.imul(al2, bl9)) | 0;
	    mid = (mid + Math.imul(al2, bh9)) | 0;
	    mid = (mid + Math.imul(ah2, bl9)) | 0;
	    hi = (hi + Math.imul(ah2, bh9)) | 0;
	    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
	    w11 &= 0x3ffffff;
	    /* k = 12 */
	    lo = Math.imul(al9, bl3);
	    mid = Math.imul(al9, bh3);
	    mid = (mid + Math.imul(ah9, bl3)) | 0;
	    hi = Math.imul(ah9, bh3);
	    lo = (lo + Math.imul(al8, bl4)) | 0;
	    mid = (mid + Math.imul(al8, bh4)) | 0;
	    mid = (mid + Math.imul(ah8, bl4)) | 0;
	    hi = (hi + Math.imul(ah8, bh4)) | 0;
	    lo = (lo + Math.imul(al7, bl5)) | 0;
	    mid = (mid + Math.imul(al7, bh5)) | 0;
	    mid = (mid + Math.imul(ah7, bl5)) | 0;
	    hi = (hi + Math.imul(ah7, bh5)) | 0;
	    lo = (lo + Math.imul(al6, bl6)) | 0;
	    mid = (mid + Math.imul(al6, bh6)) | 0;
	    mid = (mid + Math.imul(ah6, bl6)) | 0;
	    hi = (hi + Math.imul(ah6, bh6)) | 0;
	    lo = (lo + Math.imul(al5, bl7)) | 0;
	    mid = (mid + Math.imul(al5, bh7)) | 0;
	    mid = (mid + Math.imul(ah5, bl7)) | 0;
	    hi = (hi + Math.imul(ah5, bh7)) | 0;
	    lo = (lo + Math.imul(al4, bl8)) | 0;
	    mid = (mid + Math.imul(al4, bh8)) | 0;
	    mid = (mid + Math.imul(ah4, bl8)) | 0;
	    hi = (hi + Math.imul(ah4, bh8)) | 0;
	    lo = (lo + Math.imul(al3, bl9)) | 0;
	    mid = (mid + Math.imul(al3, bh9)) | 0;
	    mid = (mid + Math.imul(ah3, bl9)) | 0;
	    hi = (hi + Math.imul(ah3, bh9)) | 0;
	    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
	    w12 &= 0x3ffffff;
	    /* k = 13 */
	    lo = Math.imul(al9, bl4);
	    mid = Math.imul(al9, bh4);
	    mid = (mid + Math.imul(ah9, bl4)) | 0;
	    hi = Math.imul(ah9, bh4);
	    lo = (lo + Math.imul(al8, bl5)) | 0;
	    mid = (mid + Math.imul(al8, bh5)) | 0;
	    mid = (mid + Math.imul(ah8, bl5)) | 0;
	    hi = (hi + Math.imul(ah8, bh5)) | 0;
	    lo = (lo + Math.imul(al7, bl6)) | 0;
	    mid = (mid + Math.imul(al7, bh6)) | 0;
	    mid = (mid + Math.imul(ah7, bl6)) | 0;
	    hi = (hi + Math.imul(ah7, bh6)) | 0;
	    lo = (lo + Math.imul(al6, bl7)) | 0;
	    mid = (mid + Math.imul(al6, bh7)) | 0;
	    mid = (mid + Math.imul(ah6, bl7)) | 0;
	    hi = (hi + Math.imul(ah6, bh7)) | 0;
	    lo = (lo + Math.imul(al5, bl8)) | 0;
	    mid = (mid + Math.imul(al5, bh8)) | 0;
	    mid = (mid + Math.imul(ah5, bl8)) | 0;
	    hi = (hi + Math.imul(ah5, bh8)) | 0;
	    lo = (lo + Math.imul(al4, bl9)) | 0;
	    mid = (mid + Math.imul(al4, bh9)) | 0;
	    mid = (mid + Math.imul(ah4, bl9)) | 0;
	    hi = (hi + Math.imul(ah4, bh9)) | 0;
	    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
	    w13 &= 0x3ffffff;
	    /* k = 14 */
	    lo = Math.imul(al9, bl5);
	    mid = Math.imul(al9, bh5);
	    mid = (mid + Math.imul(ah9, bl5)) | 0;
	    hi = Math.imul(ah9, bh5);
	    lo = (lo + Math.imul(al8, bl6)) | 0;
	    mid = (mid + Math.imul(al8, bh6)) | 0;
	    mid = (mid + Math.imul(ah8, bl6)) | 0;
	    hi = (hi + Math.imul(ah8, bh6)) | 0;
	    lo = (lo + Math.imul(al7, bl7)) | 0;
	    mid = (mid + Math.imul(al7, bh7)) | 0;
	    mid = (mid + Math.imul(ah7, bl7)) | 0;
	    hi = (hi + Math.imul(ah7, bh7)) | 0;
	    lo = (lo + Math.imul(al6, bl8)) | 0;
	    mid = (mid + Math.imul(al6, bh8)) | 0;
	    mid = (mid + Math.imul(ah6, bl8)) | 0;
	    hi = (hi + Math.imul(ah6, bh8)) | 0;
	    lo = (lo + Math.imul(al5, bl9)) | 0;
	    mid = (mid + Math.imul(al5, bh9)) | 0;
	    mid = (mid + Math.imul(ah5, bl9)) | 0;
	    hi = (hi + Math.imul(ah5, bh9)) | 0;
	    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
	    w14 &= 0x3ffffff;
	    /* k = 15 */
	    lo = Math.imul(al9, bl6);
	    mid = Math.imul(al9, bh6);
	    mid = (mid + Math.imul(ah9, bl6)) | 0;
	    hi = Math.imul(ah9, bh6);
	    lo = (lo + Math.imul(al8, bl7)) | 0;
	    mid = (mid + Math.imul(al8, bh7)) | 0;
	    mid = (mid + Math.imul(ah8, bl7)) | 0;
	    hi = (hi + Math.imul(ah8, bh7)) | 0;
	    lo = (lo + Math.imul(al7, bl8)) | 0;
	    mid = (mid + Math.imul(al7, bh8)) | 0;
	    mid = (mid + Math.imul(ah7, bl8)) | 0;
	    hi = (hi + Math.imul(ah7, bh8)) | 0;
	    lo = (lo + Math.imul(al6, bl9)) | 0;
	    mid = (mid + Math.imul(al6, bh9)) | 0;
	    mid = (mid + Math.imul(ah6, bl9)) | 0;
	    hi = (hi + Math.imul(ah6, bh9)) | 0;
	    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
	    w15 &= 0x3ffffff;
	    /* k = 16 */
	    lo = Math.imul(al9, bl7);
	    mid = Math.imul(al9, bh7);
	    mid = (mid + Math.imul(ah9, bl7)) | 0;
	    hi = Math.imul(ah9, bh7);
	    lo = (lo + Math.imul(al8, bl8)) | 0;
	    mid = (mid + Math.imul(al8, bh8)) | 0;
	    mid = (mid + Math.imul(ah8, bl8)) | 0;
	    hi = (hi + Math.imul(ah8, bh8)) | 0;
	    lo = (lo + Math.imul(al7, bl9)) | 0;
	    mid = (mid + Math.imul(al7, bh9)) | 0;
	    mid = (mid + Math.imul(ah7, bl9)) | 0;
	    hi = (hi + Math.imul(ah7, bh9)) | 0;
	    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
	    w16 &= 0x3ffffff;
	    /* k = 17 */
	    lo = Math.imul(al9, bl8);
	    mid = Math.imul(al9, bh8);
	    mid = (mid + Math.imul(ah9, bl8)) | 0;
	    hi = Math.imul(ah9, bh8);
	    lo = (lo + Math.imul(al8, bl9)) | 0;
	    mid = (mid + Math.imul(al8, bh9)) | 0;
	    mid = (mid + Math.imul(ah8, bl9)) | 0;
	    hi = (hi + Math.imul(ah8, bh9)) | 0;
	    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
	    w17 &= 0x3ffffff;
	    /* k = 18 */
	    lo = Math.imul(al9, bl9);
	    mid = Math.imul(al9, bh9);
	    mid = (mid + Math.imul(ah9, bl9)) | 0;
	    hi = Math.imul(ah9, bh9);
	    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
	    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
	    w18 &= 0x3ffffff;
	    o[0] = w0;
	    o[1] = w1;
	    o[2] = w2;
	    o[3] = w3;
	    o[4] = w4;
	    o[5] = w5;
	    o[6] = w6;
	    o[7] = w7;
	    o[8] = w8;
	    o[9] = w9;
	    o[10] = w10;
	    o[11] = w11;
	    o[12] = w12;
	    o[13] = w13;
	    o[14] = w14;
	    o[15] = w15;
	    o[16] = w16;
	    o[17] = w17;
	    o[18] = w18;
	    if (c !== 0) {
	      o[19] = c;
	      out.length++;
	    }
	    return out;
	  };
	
	  // Polyfill comb
	  if (!Math.imul) {
	    comb10MulTo = smallMulTo;
	  }
	
	  function bigMulTo (self, num, out) {
	    out.negative = num.negative ^ self.negative;
	    out.length = self.length + num.length;
	
	    var carry = 0;
	    var hncarry = 0;
	    for (var k = 0; k < out.length - 1; k++) {
	      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
	      // note that ncarry could be >= 0x3ffffff
	      var ncarry = hncarry;
	      hncarry = 0;
	      var rword = carry & 0x3ffffff;
	      var maxJ = Math.min(k, num.length - 1);
	      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
	        var i = k - j;
	        var a = self.words[i] | 0;
	        var b = num.words[j] | 0;
	        var r = a * b;
	
	        var lo = r & 0x3ffffff;
	        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
	        lo = (lo + rword) | 0;
	        rword = lo & 0x3ffffff;
	        ncarry = (ncarry + (lo >>> 26)) | 0;
	
	        hncarry += ncarry >>> 26;
	        ncarry &= 0x3ffffff;
	      }
	      out.words[k] = rword;
	      carry = ncarry;
	      ncarry = hncarry;
	    }
	    if (carry !== 0) {
	      out.words[k] = carry;
	    } else {
	      out.length--;
	    }
	
	    return out.strip();
	  }
	
	  function jumboMulTo (self, num, out) {
	    var fftm = new FFTM();
	    return fftm.mulp(self, num, out);
	  }
	
	  BN.prototype.mulTo = function mulTo (num, out) {
	    var res;
	    var len = this.length + num.length;
	    if (this.length === 10 && num.length === 10) {
	      res = comb10MulTo(this, num, out);
	    } else if (len < 63) {
	      res = smallMulTo(this, num, out);
	    } else if (len < 1024) {
	      res = bigMulTo(this, num, out);
	    } else {
	      res = jumboMulTo(this, num, out);
	    }
	
	    return res;
	  };
	
	  // Cooley-Tukey algorithm for FFT
	  // slightly revisited to rely on looping instead of recursion
	
	  function FFTM (x, y) {
	    this.x = x;
	    this.y = y;
	  }
	
	  FFTM.prototype.makeRBT = function makeRBT (N) {
	    var t = new Array(N);
	    var l = BN.prototype._countBits(N) - 1;
	    for (var i = 0; i < N; i++) {
	      t[i] = this.revBin(i, l, N);
	    }
	
	    return t;
	  };
	
	  // Returns binary-reversed representation of `x`
	  FFTM.prototype.revBin = function revBin (x, l, N) {
	    if (x === 0 || x === N - 1) return x;
	
	    var rb = 0;
	    for (var i = 0; i < l; i++) {
	      rb |= (x & 1) << (l - i - 1);
	      x >>= 1;
	    }
	
	    return rb;
	  };
	
	  // Performs "tweedling" phase, therefore 'emulating'
	  // behaviour of the recursive algorithm
	  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
	    for (var i = 0; i < N; i++) {
	      rtws[i] = rws[rbt[i]];
	      itws[i] = iws[rbt[i]];
	    }
	  };
	
	  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
	    this.permute(rbt, rws, iws, rtws, itws, N);
	
	    for (var s = 1; s < N; s <<= 1) {
	      var l = s << 1;
	
	      var rtwdf = Math.cos(2 * Math.PI / l);
	      var itwdf = Math.sin(2 * Math.PI / l);
	
	      for (var p = 0; p < N; p += l) {
	        var rtwdf_ = rtwdf;
	        var itwdf_ = itwdf;
	
	        for (var j = 0; j < s; j++) {
	          var re = rtws[p + j];
	          var ie = itws[p + j];
	
	          var ro = rtws[p + j + s];
	          var io = itws[p + j + s];
	
	          var rx = rtwdf_ * ro - itwdf_ * io;
	
	          io = rtwdf_ * io + itwdf_ * ro;
	          ro = rx;
	
	          rtws[p + j] = re + ro;
	          itws[p + j] = ie + io;
	
	          rtws[p + j + s] = re - ro;
	          itws[p + j + s] = ie - io;
	
	          /* jshint maxdepth : false */
	          if (j !== l) {
	            rx = rtwdf * rtwdf_ - itwdf * itwdf_;
	
	            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
	            rtwdf_ = rx;
	          }
	        }
	      }
	    }
	  };
	
	  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
	    var N = Math.max(m, n) | 1;
	    var odd = N & 1;
	    var i = 0;
	    for (N = N / 2 | 0; N; N = N >>> 1) {
	      i++;
	    }
	
	    return 1 << i + 1 + odd;
	  };
	
	  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
	    if (N <= 1) return;
	
	    for (var i = 0; i < N / 2; i++) {
	      var t = rws[i];
	
	      rws[i] = rws[N - i - 1];
	      rws[N - i - 1] = t;
	
	      t = iws[i];
	
	      iws[i] = -iws[N - i - 1];
	      iws[N - i - 1] = -t;
	    }
	  };
	
	  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
	    var carry = 0;
	    for (var i = 0; i < N / 2; i++) {
	      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
	        Math.round(ws[2 * i] / N) +
	        carry;
	
	      ws[i] = w & 0x3ffffff;
	
	      if (w < 0x4000000) {
	        carry = 0;
	      } else {
	        carry = w / 0x4000000 | 0;
	      }
	    }
	
	    return ws;
	  };
	
	  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
	    var carry = 0;
	    for (var i = 0; i < len; i++) {
	      carry = carry + (ws[i] | 0);
	
	      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
	      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
	    }
	
	    // Pad with zeroes
	    for (i = 2 * len; i < N; ++i) {
	      rws[i] = 0;
	    }
	
	    assert(carry === 0);
	    assert((carry & ~0x1fff) === 0);
	  };
	
	  FFTM.prototype.stub = function stub (N) {
	    var ph = new Array(N);
	    for (var i = 0; i < N; i++) {
	      ph[i] = 0;
	    }
	
	    return ph;
	  };
	
	  FFTM.prototype.mulp = function mulp (x, y, out) {
	    var N = 2 * this.guessLen13b(x.length, y.length);
	
	    var rbt = this.makeRBT(N);
	
	    var _ = this.stub(N);
	
	    var rws = new Array(N);
	    var rwst = new Array(N);
	    var iwst = new Array(N);
	
	    var nrws = new Array(N);
	    var nrwst = new Array(N);
	    var niwst = new Array(N);
	
	    var rmws = out.words;
	    rmws.length = N;
	
	    this.convert13b(x.words, x.length, rws, N);
	    this.convert13b(y.words, y.length, nrws, N);
	
	    this.transform(rws, _, rwst, iwst, N, rbt);
	    this.transform(nrws, _, nrwst, niwst, N, rbt);
	
	    for (var i = 0; i < N; i++) {
	      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
	      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
	      rwst[i] = rx;
	    }
	
	    this.conjugate(rwst, iwst, N);
	    this.transform(rwst, iwst, rmws, _, N, rbt);
	    this.conjugate(rmws, _, N);
	    this.normalize13b(rmws, N);
	
	    out.negative = x.negative ^ y.negative;
	    out.length = x.length + y.length;
	    return out.strip();
	  };
	
	  // Multiply `this` by `num`
	  BN.prototype.mul = function mul (num) {
	    var out = new BN(null);
	    out.words = new Array(this.length + num.length);
	    return this.mulTo(num, out);
	  };
	
	  // Multiply employing FFT
	  BN.prototype.mulf = function mulf (num) {
	    var out = new BN(null);
	    out.words = new Array(this.length + num.length);
	    return jumboMulTo(this, num, out);
	  };
	
	  // In-place Multiplication
	  BN.prototype.imul = function imul (num) {
	    return this.clone().mulTo(num, this);
	  };
	
	  BN.prototype.imuln = function imuln (num) {
	    assert(typeof num === 'number');
	    assert(num < 0x4000000);
	
	    // Carry
	    var carry = 0;
	    for (var i = 0; i < this.length; i++) {
	      var w = (this.words[i] | 0) * num;
	      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
	      carry >>= 26;
	      carry += (w / 0x4000000) | 0;
	      // NOTE: lo is 27bit maximum
	      carry += lo >>> 26;
	      this.words[i] = lo & 0x3ffffff;
	    }
	
	    if (carry !== 0) {
	      this.words[i] = carry;
	      this.length++;
	    }
	
	    return this;
	  };
	
	  BN.prototype.muln = function muln (num) {
	    return this.clone().imuln(num);
	  };
	
	  // `this` * `this`
	  BN.prototype.sqr = function sqr () {
	    return this.mul(this);
	  };
	
	  // `this` * `this` in-place
	  BN.prototype.isqr = function isqr () {
	    return this.imul(this.clone());
	  };
	
	  // Math.pow(`this`, `num`)
	  BN.prototype.pow = function pow (num) {
	    var w = toBitArray(num);
	    if (w.length === 0) return new BN(1);
	
	    // Skip leading zeroes
	    var res = this;
	    for (var i = 0; i < w.length; i++, res = res.sqr()) {
	      if (w[i] !== 0) break;
	    }
	
	    if (++i < w.length) {
	      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
	        if (w[i] === 0) continue;
	
	        res = res.mul(q);
	      }
	    }
	
	    return res;
	  };
	
	  // Shift-left in-place
	  BN.prototype.iushln = function iushln (bits) {
	    assert(typeof bits === 'number' && bits >= 0);
	    var r = bits % 26;
	    var s = (bits - r) / 26;
	    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
	    var i;
	
	    if (r !== 0) {
	      var carry = 0;
	
	      for (i = 0; i < this.length; i++) {
	        var newCarry = this.words[i] & carryMask;
	        var c = ((this.words[i] | 0) - newCarry) << r;
	        this.words[i] = c | carry;
	        carry = newCarry >>> (26 - r);
	      }
	
	      if (carry) {
	        this.words[i] = carry;
	        this.length++;
	      }
	    }
	
	    if (s !== 0) {
	      for (i = this.length - 1; i >= 0; i--) {
	        this.words[i + s] = this.words[i];
	      }
	
	      for (i = 0; i < s; i++) {
	        this.words[i] = 0;
	      }
	
	      this.length += s;
	    }
	
	    return this.strip();
	  };
	
	  BN.prototype.ishln = function ishln (bits) {
	    // TODO(indutny): implement me
	    assert(this.negative === 0);
	    return this.iushln(bits);
	  };
	
	  // Shift-right in-place
	  // NOTE: `hint` is a lowest bit before trailing zeroes
	  // NOTE: if `extended` is present - it will be filled with destroyed bits
	  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
	    assert(typeof bits === 'number' && bits >= 0);
	    var h;
	    if (hint) {
	      h = (hint - (hint % 26)) / 26;
	    } else {
	      h = 0;
	    }
	
	    var r = bits % 26;
	    var s = Math.min((bits - r) / 26, this.length);
	    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
	    var maskedWords = extended;
	
	    h -= s;
	    h = Math.max(0, h);
	
	    // Extended mode, copy masked part
	    if (maskedWords) {
	      for (var i = 0; i < s; i++) {
	        maskedWords.words[i] = this.words[i];
	      }
	      maskedWords.length = s;
	    }
	
	    if (s === 0) {
	      // No-op, we should not move anything at all
	    } else if (this.length > s) {
	      this.length -= s;
	      for (i = 0; i < this.length; i++) {
	        this.words[i] = this.words[i + s];
	      }
	    } else {
	      this.words[0] = 0;
	      this.length = 1;
	    }
	
	    var carry = 0;
	    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
	      var word = this.words[i] | 0;
	      this.words[i] = (carry << (26 - r)) | (word >>> r);
	      carry = word & mask;
	    }
	
	    // Push carried bits as a mask
	    if (maskedWords && carry !== 0) {
	      maskedWords.words[maskedWords.length++] = carry;
	    }
	
	    if (this.length === 0) {
	      this.words[0] = 0;
	      this.length = 1;
	    }
	
	    return this.strip();
	  };
	
	  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
	    // TODO(indutny): implement me
	    assert(this.negative === 0);
	    return this.iushrn(bits, hint, extended);
	  };
	
	  // Shift-left
	  BN.prototype.shln = function shln (bits) {
	    return this.clone().ishln(bits);
	  };
	
	  BN.prototype.ushln = function ushln (bits) {
	    return this.clone().iushln(bits);
	  };
	
	  // Shift-right
	  BN.prototype.shrn = function shrn (bits) {
	    return this.clone().ishrn(bits);
	  };
	
	  BN.prototype.ushrn = function ushrn (bits) {
	    return this.clone().iushrn(bits);
	  };
	
	  // Test if n bit is set
	  BN.prototype.testn = function testn (bit) {
	    assert(typeof bit === 'number' && bit >= 0);
	    var r = bit % 26;
	    var s = (bit - r) / 26;
	    var q = 1 << r;
	
	    // Fast case: bit is much higher than all existing words
	    if (this.length <= s) return false;
	
	    // Check bit and return
	    var w = this.words[s];
	
	    return !!(w & q);
	  };
	
	  // Return only lowers bits of number (in-place)
	  BN.prototype.imaskn = function imaskn (bits) {
	    assert(typeof bits === 'number' && bits >= 0);
	    var r = bits % 26;
	    var s = (bits - r) / 26;
	
	    assert(this.negative === 0, 'imaskn works only with positive numbers');
	
	    if (this.length <= s) {
	      return this;
	    }
	
	    if (r !== 0) {
	      s++;
	    }
	    this.length = Math.min(s, this.length);
	
	    if (r !== 0) {
	      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
	      this.words[this.length - 1] &= mask;
	    }
	
	    return this.strip();
	  };
	
	  // Return only lowers bits of number
	  BN.prototype.maskn = function maskn (bits) {
	    return this.clone().imaskn(bits);
	  };
	
	  // Add plain number `num` to `this`
	  BN.prototype.iaddn = function iaddn (num) {
	    assert(typeof num === 'number');
	    assert(num < 0x4000000);
	    if (num < 0) return this.isubn(-num);
	
	    // Possible sign change
	    if (this.negative !== 0) {
	      if (this.length === 1 && (this.words[0] | 0) < num) {
	        this.words[0] = num - (this.words[0] | 0);
	        this.negative = 0;
	        return this;
	      }
	
	      this.negative = 0;
	      this.isubn(num);
	      this.negative = 1;
	      return this;
	    }
	
	    // Add without checks
	    return this._iaddn(num);
	  };
	
	  BN.prototype._iaddn = function _iaddn (num) {
	    this.words[0] += num;
	
	    // Carry
	    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
	      this.words[i] -= 0x4000000;
	      if (i === this.length - 1) {
	        this.words[i + 1] = 1;
	      } else {
	        this.words[i + 1]++;
	      }
	    }
	    this.length = Math.max(this.length, i + 1);
	
	    return this;
	  };
	
	  // Subtract plain number `num` from `this`
	  BN.prototype.isubn = function isubn (num) {
	    assert(typeof num === 'number');
	    assert(num < 0x4000000);
	    if (num < 0) return this.iaddn(-num);
	
	    if (this.negative !== 0) {
	      this.negative = 0;
	      this.iaddn(num);
	      this.negative = 1;
	      return this;
	    }
	
	    this.words[0] -= num;
	
	    if (this.length === 1 && this.words[0] < 0) {
	      this.words[0] = -this.words[0];
	      this.negative = 1;
	    } else {
	      // Carry
	      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
	        this.words[i] += 0x4000000;
	        this.words[i + 1] -= 1;
	      }
	    }
	
	    return this.strip();
	  };
	
	  BN.prototype.addn = function addn (num) {
	    return this.clone().iaddn(num);
	  };
	
	  BN.prototype.subn = function subn (num) {
	    return this.clone().isubn(num);
	  };
	
	  BN.prototype.iabs = function iabs () {
	    this.negative = 0;
	
	    return this;
	  };
	
	  BN.prototype.abs = function abs () {
	    return this.clone().iabs();
	  };
	
	  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
	    var len = num.length + shift;
	    var i;
	
	    this._expand(len);
	
	    var w;
	    var carry = 0;
	    for (i = 0; i < num.length; i++) {
	      w = (this.words[i + shift] | 0) + carry;
	      var right = (num.words[i] | 0) * mul;
	      w -= right & 0x3ffffff;
	      carry = (w >> 26) - ((right / 0x4000000) | 0);
	      this.words[i + shift] = w & 0x3ffffff;
	    }
	    for (; i < this.length - shift; i++) {
	      w = (this.words[i + shift] | 0) + carry;
	      carry = w >> 26;
	      this.words[i + shift] = w & 0x3ffffff;
	    }
	
	    if (carry === 0) return this.strip();
	
	    // Subtraction overflow
	    assert(carry === -1);
	    carry = 0;
	    for (i = 0; i < this.length; i++) {
	      w = -(this.words[i] | 0) + carry;
	      carry = w >> 26;
	      this.words[i] = w & 0x3ffffff;
	    }
	    this.negative = 1;
	
	    return this.strip();
	  };
	
	  BN.prototype._wordDiv = function _wordDiv (num, mode) {
	    var shift = this.length - num.length;
	
	    var a = this.clone();
	    var b = num;
	
	    // Normalize
	    var bhi = b.words[b.length - 1] | 0;
	    var bhiBits = this._countBits(bhi);
	    shift = 26 - bhiBits;
	    if (shift !== 0) {
	      b = b.ushln(shift);
	      a.iushln(shift);
	      bhi = b.words[b.length - 1] | 0;
	    }
	
	    // Initialize quotient
	    var m = a.length - b.length;
	    var q;
	
	    if (mode !== 'mod') {
	      q = new BN(null);
	      q.length = m + 1;
	      q.words = new Array(q.length);
	      for (var i = 0; i < q.length; i++) {
	        q.words[i] = 0;
	      }
	    }
	
	    var diff = a.clone()._ishlnsubmul(b, 1, m);
	    if (diff.negative === 0) {
	      a = diff;
	      if (q) {
	        q.words[m] = 1;
	      }
	    }
	
	    for (var j = m - 1; j >= 0; j--) {
	      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
	        (a.words[b.length + j - 1] | 0);
	
	      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
	      // (0x7ffffff)
	      qj = Math.min((qj / bhi) | 0, 0x3ffffff);
	
	      a._ishlnsubmul(b, qj, j);
	      while (a.negative !== 0) {
	        qj--;
	        a.negative = 0;
	        a._ishlnsubmul(b, 1, j);
	        if (!a.isZero()) {
	          a.negative ^= 1;
	        }
	      }
	      if (q) {
	        q.words[j] = qj;
	      }
	    }
	    if (q) {
	      q.strip();
	    }
	    a.strip();
	
	    // Denormalize
	    if (mode !== 'div' && shift !== 0) {
	      a.iushrn(shift);
	    }
	
	    return {
	      div: q || null,
	      mod: a
	    };
	  };
	
	  // NOTE: 1) `mode` can be set to `mod` to request mod only,
	  //       to `div` to request div only, or be absent to
	  //       request both div & mod
	  //       2) `positive` is true if unsigned mod is requested
	  BN.prototype.divmod = function divmod (num, mode, positive) {
	    assert(!num.isZero());
	
	    if (this.isZero()) {
	      return {
	        div: new BN(0),
	        mod: new BN(0)
	      };
	    }
	
	    var div, mod, res;
	    if (this.negative !== 0 && num.negative === 0) {
	      res = this.neg().divmod(num, mode);
	
	      if (mode !== 'mod') {
	        div = res.div.neg();
	      }
	
	      if (mode !== 'div') {
	        mod = res.mod.neg();
	        if (positive && mod.negative !== 0) {
	          mod.iadd(num);
	        }
	      }
	
	      return {
	        div: div,
	        mod: mod
	      };
	    }
	
	    if (this.negative === 0 && num.negative !== 0) {
	      res = this.divmod(num.neg(), mode);
	
	      if (mode !== 'mod') {
	        div = res.div.neg();
	      }
	
	      return {
	        div: div,
	        mod: res.mod
	      };
	    }
	
	    if ((this.negative & num.negative) !== 0) {
	      res = this.neg().divmod(num.neg(), mode);
	
	      if (mode !== 'div') {
	        mod = res.mod.neg();
	        if (positive && mod.negative !== 0) {
	          mod.isub(num);
	        }
	      }
	
	      return {
	        div: res.div,
	        mod: mod
	      };
	    }
	
	    // Both numbers are positive at this point
	
	    // Strip both numbers to approximate shift value
	    if (num.length > this.length || this.cmp(num) < 0) {
	      return {
	        div: new BN(0),
	        mod: this
	      };
	    }
	
	    // Very short reduction
	    if (num.length === 1) {
	      if (mode === 'div') {
	        return {
	          div: this.divn(num.words[0]),
	          mod: null
	        };
	      }
	
	      if (mode === 'mod') {
	        return {
	          div: null,
	          mod: new BN(this.modn(num.words[0]))
	        };
	      }
	
	      return {
	        div: this.divn(num.words[0]),
	        mod: new BN(this.modn(num.words[0]))
	      };
	    }
	
	    return this._wordDiv(num, mode);
	  };
	
	  // Find `this` / `num`
	  BN.prototype.div = function div (num) {
	    return this.divmod(num, 'div', false).div;
	  };
	
	  // Find `this` % `num`
	  BN.prototype.mod = function mod (num) {
	    return this.divmod(num, 'mod', false).mod;
	  };
	
	  BN.prototype.umod = function umod (num) {
	    return this.divmod(num, 'mod', true).mod;
	  };
	
	  // Find Round(`this` / `num`)
	  BN.prototype.divRound = function divRound (num) {
	    var dm = this.divmod(num);
	
	    // Fast case - exact division
	    if (dm.mod.isZero()) return dm.div;
	
	    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
	
	    var half = num.ushrn(1);
	    var r2 = num.andln(1);
	    var cmp = mod.cmp(half);
	
	    // Round down
	    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
	
	    // Round up
	    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
	  };
	
	  BN.prototype.modn = function modn (num) {
	    assert(num <= 0x3ffffff);
	    var p = (1 << 26) % num;
	
	    var acc = 0;
	    for (var i = this.length - 1; i >= 0; i--) {
	      acc = (p * acc + (this.words[i] | 0)) % num;
	    }
	
	    return acc;
	  };
	
	  // In-place division by number
	  BN.prototype.idivn = function idivn (num) {
	    assert(num <= 0x3ffffff);
	
	    var carry = 0;
	    for (var i = this.length - 1; i >= 0; i--) {
	      var w = (this.words[i] | 0) + carry * 0x4000000;
	      this.words[i] = (w / num) | 0;
	      carry = w % num;
	    }
	
	    return this.strip();
	  };
	
	  BN.prototype.divn = function divn (num) {
	    return this.clone().idivn(num);
	  };
	
	  BN.prototype.egcd = function egcd (p) {
	    assert(p.negative === 0);
	    assert(!p.isZero());
	
	    var x = this;
	    var y = p.clone();
	
	    if (x.negative !== 0) {
	      x = x.umod(p);
	    } else {
	      x = x.clone();
	    }
	
	    // A * x + B * y = x
	    var A = new BN(1);
	    var B = new BN(0);
	
	    // C * x + D * y = y
	    var C = new BN(0);
	    var D = new BN(1);
	
	    var g = 0;
	
	    while (x.isEven() && y.isEven()) {
	      x.iushrn(1);
	      y.iushrn(1);
	      ++g;
	    }
	
	    var yp = y.clone();
	    var xp = x.clone();
	
	    while (!x.isZero()) {
	      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
	      if (i > 0) {
	        x.iushrn(i);
	        while (i-- > 0) {
	          if (A.isOdd() || B.isOdd()) {
	            A.iadd(yp);
	            B.isub(xp);
	          }
	
	          A.iushrn(1);
	          B.iushrn(1);
	        }
	      }
	
	      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
	      if (j > 0) {
	        y.iushrn(j);
	        while (j-- > 0) {
	          if (C.isOdd() || D.isOdd()) {
	            C.iadd(yp);
	            D.isub(xp);
	          }
	
	          C.iushrn(1);
	          D.iushrn(1);
	        }
	      }
	
	      if (x.cmp(y) >= 0) {
	        x.isub(y);
	        A.isub(C);
	        B.isub(D);
	      } else {
	        y.isub(x);
	        C.isub(A);
	        D.isub(B);
	      }
	    }
	
	    return {
	      a: C,
	      b: D,
	      gcd: y.iushln(g)
	    };
	  };
	
	  // This is reduced incarnation of the binary EEA
	  // above, designated to invert members of the
	  // _prime_ fields F(p) at a maximal speed
	  BN.prototype._invmp = function _invmp (p) {
	    assert(p.negative === 0);
	    assert(!p.isZero());
	
	    var a = this;
	    var b = p.clone();
	
	    if (a.negative !== 0) {
	      a = a.umod(p);
	    } else {
	      a = a.clone();
	    }
	
	    var x1 = new BN(1);
	    var x2 = new BN(0);
	
	    var delta = b.clone();
	
	    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
	      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
	      if (i > 0) {
	        a.iushrn(i);
	        while (i-- > 0) {
	          if (x1.isOdd()) {
	            x1.iadd(delta);
	          }
	
	          x1.iushrn(1);
	        }
	      }
	
	      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
	      if (j > 0) {
	        b.iushrn(j);
	        while (j-- > 0) {
	          if (x2.isOdd()) {
	            x2.iadd(delta);
	          }
	
	          x2.iushrn(1);
	        }
	      }
	
	      if (a.cmp(b) >= 0) {
	        a.isub(b);
	        x1.isub(x2);
	      } else {
	        b.isub(a);
	        x2.isub(x1);
	      }
	    }
	
	    var res;
	    if (a.cmpn(1) === 0) {
	      res = x1;
	    } else {
	      res = x2;
	    }
	
	    if (res.cmpn(0) < 0) {
	      res.iadd(p);
	    }
	
	    return res;
	  };
	
	  BN.prototype.gcd = function gcd (num) {
	    if (this.isZero()) return num.abs();
	    if (num.isZero()) return this.abs();
	
	    var a = this.clone();
	    var b = num.clone();
	    a.negative = 0;
	    b.negative = 0;
	
	    // Remove common factor of two
	    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
	      a.iushrn(1);
	      b.iushrn(1);
	    }
	
	    do {
	      while (a.isEven()) {
	        a.iushrn(1);
	      }
	      while (b.isEven()) {
	        b.iushrn(1);
	      }
	
	      var r = a.cmp(b);
	      if (r < 0) {
	        // Swap `a` and `b` to make `a` always bigger than `b`
	        var t = a;
	        a = b;
	        b = t;
	      } else if (r === 0 || b.cmpn(1) === 0) {
	        break;
	      }
	
	      a.isub(b);
	    } while (true);
	
	    return b.iushln(shift);
	  };
	
	  // Invert number in the field F(num)
	  BN.prototype.invm = function invm (num) {
	    return this.egcd(num).a.umod(num);
	  };
	
	  BN.prototype.isEven = function isEven () {
	    return (this.words[0] & 1) === 0;
	  };
	
	  BN.prototype.isOdd = function isOdd () {
	    return (this.words[0] & 1) === 1;
	  };
	
	  // And first word and num
	  BN.prototype.andln = function andln (num) {
	    return this.words[0] & num;
	  };
	
	  // Increment at the bit position in-line
	  BN.prototype.bincn = function bincn (bit) {
	    assert(typeof bit === 'number');
	    var r = bit % 26;
	    var s = (bit - r) / 26;
	    var q = 1 << r;
	
	    // Fast case: bit is much higher than all existing words
	    if (this.length <= s) {
	      this._expand(s + 1);
	      this.words[s] |= q;
	      return this;
	    }
	
	    // Add bit and propagate, if needed
	    var carry = q;
	    for (var i = s; carry !== 0 && i < this.length; i++) {
	      var w = this.words[i] | 0;
	      w += carry;
	      carry = w >>> 26;
	      w &= 0x3ffffff;
	      this.words[i] = w;
	    }
	    if (carry !== 0) {
	      this.words[i] = carry;
	      this.length++;
	    }
	    return this;
	  };
	
	  BN.prototype.isZero = function isZero () {
	    return this.length === 1 && this.words[0] === 0;
	  };
	
	  BN.prototype.cmpn = function cmpn (num) {
	    var negative = num < 0;
	
	    if (this.negative !== 0 && !negative) return -1;
	    if (this.negative === 0 && negative) return 1;
	
	    this.strip();
	
	    var res;
	    if (this.length > 1) {
	      res = 1;
	    } else {
	      if (negative) {
	        num = -num;
	      }
	
	      assert(num <= 0x3ffffff, 'Number is too big');
	
	      var w = this.words[0] | 0;
	      res = w === num ? 0 : w < num ? -1 : 1;
	    }
	    if (this.negative !== 0) return -res | 0;
	    return res;
	  };
	
	  // Compare two numbers and return:
	  // 1 - if `this` > `num`
	  // 0 - if `this` == `num`
	  // -1 - if `this` < `num`
	  BN.prototype.cmp = function cmp (num) {
	    if (this.negative !== 0 && num.negative === 0) return -1;
	    if (this.negative === 0 && num.negative !== 0) return 1;
	
	    var res = this.ucmp(num);
	    if (this.negative !== 0) return -res | 0;
	    return res;
	  };
	
	  // Unsigned comparison
	  BN.prototype.ucmp = function ucmp (num) {
	    // At this point both numbers have the same sign
	    if (this.length > num.length) return 1;
	    if (this.length < num.length) return -1;
	
	    var res = 0;
	    for (var i = this.length - 1; i >= 0; i--) {
	      var a = this.words[i] | 0;
	      var b = num.words[i] | 0;
	
	      if (a === b) continue;
	      if (a < b) {
	        res = -1;
	      } else if (a > b) {
	        res = 1;
	      }
	      break;
	    }
	    return res;
	  };
	
	  BN.prototype.gtn = function gtn (num) {
	    return this.cmpn(num) === 1;
	  };
	
	  BN.prototype.gt = function gt (num) {
	    return this.cmp(num) === 1;
	  };
	
	  BN.prototype.gten = function gten (num) {
	    return this.cmpn(num) >= 0;
	  };
	
	  BN.prototype.gte = function gte (num) {
	    return this.cmp(num) >= 0;
	  };
	
	  BN.prototype.ltn = function ltn (num) {
	    return this.cmpn(num) === -1;
	  };
	
	  BN.prototype.lt = function lt (num) {
	    return this.cmp(num) === -1;
	  };
	
	  BN.prototype.lten = function lten (num) {
	    return this.cmpn(num) <= 0;
	  };
	
	  BN.prototype.lte = function lte (num) {
	    return this.cmp(num) <= 0;
	  };
	
	  BN.prototype.eqn = function eqn (num) {
	    return this.cmpn(num) === 0;
	  };
	
	  BN.prototype.eq = function eq (num) {
	    return this.cmp(num) === 0;
	  };
	
	  //
	  // A reduce context, could be using montgomery or something better, depending
	  // on the `m` itself.
	  //
	  BN.red = function red (num) {
	    return new Red(num);
	  };
	
	  BN.prototype.toRed = function toRed (ctx) {
	    assert(!this.red, 'Already a number in reduction context');
	    assert(this.negative === 0, 'red works only with positives');
	    return ctx.convertTo(this)._forceRed(ctx);
	  };
	
	  BN.prototype.fromRed = function fromRed () {
	    assert(this.red, 'fromRed works only with numbers in reduction context');
	    return this.red.convertFrom(this);
	  };
	
	  BN.prototype._forceRed = function _forceRed (ctx) {
	    this.red = ctx;
	    return this;
	  };
	
	  BN.prototype.forceRed = function forceRed (ctx) {
	    assert(!this.red, 'Already a number in reduction context');
	    return this._forceRed(ctx);
	  };
	
	  BN.prototype.redAdd = function redAdd (num) {
	    assert(this.red, 'redAdd works only with red numbers');
	    return this.red.add(this, num);
	  };
	
	  BN.prototype.redIAdd = function redIAdd (num) {
	    assert(this.red, 'redIAdd works only with red numbers');
	    return this.red.iadd(this, num);
	  };
	
	  BN.prototype.redSub = function redSub (num) {
	    assert(this.red, 'redSub works only with red numbers');
	    return this.red.sub(this, num);
	  };
	
	  BN.prototype.redISub = function redISub (num) {
	    assert(this.red, 'redISub works only with red numbers');
	    return this.red.isub(this, num);
	  };
	
	  BN.prototype.redShl = function redShl (num) {
	    assert(this.red, 'redShl works only with red numbers');
	    return this.red.shl(this, num);
	  };
	
	  BN.prototype.redMul = function redMul (num) {
	    assert(this.red, 'redMul works only with red numbers');
	    this.red._verify2(this, num);
	    return this.red.mul(this, num);
	  };
	
	  BN.prototype.redIMul = function redIMul (num) {
	    assert(this.red, 'redMul works only with red numbers');
	    this.red._verify2(this, num);
	    return this.red.imul(this, num);
	  };
	
	  BN.prototype.redSqr = function redSqr () {
	    assert(this.red, 'redSqr works only with red numbers');
	    this.red._verify1(this);
	    return this.red.sqr(this);
	  };
	
	  BN.prototype.redISqr = function redISqr () {
	    assert(this.red, 'redISqr works only with red numbers');
	    this.red._verify1(this);
	    return this.red.isqr(this);
	  };
	
	  // Square root over p
	  BN.prototype.redSqrt = function redSqrt () {
	    assert(this.red, 'redSqrt works only with red numbers');
	    this.red._verify1(this);
	    return this.red.sqrt(this);
	  };
	
	  BN.prototype.redInvm = function redInvm () {
	    assert(this.red, 'redInvm works only with red numbers');
	    this.red._verify1(this);
	    return this.red.invm(this);
	  };
	
	  // Return negative clone of `this` % `red modulo`
	  BN.prototype.redNeg = function redNeg () {
	    assert(this.red, 'redNeg works only with red numbers');
	    this.red._verify1(this);
	    return this.red.neg(this);
	  };
	
	  BN.prototype.redPow = function redPow (num) {
	    assert(this.red && !num.red, 'redPow(normalNum)');
	    this.red._verify1(this);
	    return this.red.pow(this, num);
	  };
	
	  // Prime numbers with efficient reduction
	  var primes = {
	    k256: null,
	    p224: null,
	    p192: null,
	    p25519: null
	  };
	
	  // Pseudo-Mersenne prime
	  function MPrime (name, p) {
	    // P = 2 ^ N - K
	    this.name = name;
	    this.p = new BN(p, 16);
	    this.n = this.p.bitLength();
	    this.k = new BN(1).iushln(this.n).isub(this.p);
	
	    this.tmp = this._tmp();
	  }
	
	  MPrime.prototype._tmp = function _tmp () {
	    var tmp = new BN(null);
	    tmp.words = new Array(Math.ceil(this.n / 13));
	    return tmp;
	  };
	
	  MPrime.prototype.ireduce = function ireduce (num) {
	    // Assumes that `num` is less than `P^2`
	    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
	    var r = num;
	    var rlen;
	
	    do {
	      this.split(r, this.tmp);
	      r = this.imulK(r);
	      r = r.iadd(this.tmp);
	      rlen = r.bitLength();
	    } while (rlen > this.n);
	
	    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
	    if (cmp === 0) {
	      r.words[0] = 0;
	      r.length = 1;
	    } else if (cmp > 0) {
	      r.isub(this.p);
	    } else {
	      r.strip();
	    }
	
	    return r;
	  };
	
	  MPrime.prototype.split = function split (input, out) {
	    input.iushrn(this.n, 0, out);
	  };
	
	  MPrime.prototype.imulK = function imulK (num) {
	    return num.imul(this.k);
	  };
	
	  function K256 () {
	    MPrime.call(
	      this,
	      'k256',
	      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
	  }
	  inherits(K256, MPrime);
	
	  K256.prototype.split = function split (input, output) {
	    // 256 = 9 * 26 + 22
	    var mask = 0x3fffff;
	
	    var outLen = Math.min(input.length, 9);
	    for (var i = 0; i < outLen; i++) {
	      output.words[i] = input.words[i];
	    }
	    output.length = outLen;
	
	    if (input.length <= 9) {
	      input.words[0] = 0;
	      input.length = 1;
	      return;
	    }
	
	    // Shift by 9 limbs
	    var prev = input.words[9];
	    output.words[output.length++] = prev & mask;
	
	    for (i = 10; i < input.length; i++) {
	      var next = input.words[i] | 0;
	      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
	      prev = next;
	    }
	    prev >>>= 22;
	    input.words[i - 10] = prev;
	    if (prev === 0 && input.length > 10) {
	      input.length -= 10;
	    } else {
	      input.length -= 9;
	    }
	  };
	
	  K256.prototype.imulK = function imulK (num) {
	    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
	    num.words[num.length] = 0;
	    num.words[num.length + 1] = 0;
	    num.length += 2;
	
	    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
	    var lo = 0;
	    for (var i = 0; i < num.length; i++) {
	      var w = num.words[i] | 0;
	      lo += w * 0x3d1;
	      num.words[i] = lo & 0x3ffffff;
	      lo = w * 0x40 + ((lo / 0x4000000) | 0);
	    }
	
	    // Fast length reduction
	    if (num.words[num.length - 1] === 0) {
	      num.length--;
	      if (num.words[num.length - 1] === 0) {
	        num.length--;
	      }
	    }
	    return num;
	  };
	
	  function P224 () {
	    MPrime.call(
	      this,
	      'p224',
	      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
	  }
	  inherits(P224, MPrime);
	
	  function P192 () {
	    MPrime.call(
	      this,
	      'p192',
	      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
	  }
	  inherits(P192, MPrime);
	
	  function P25519 () {
	    // 2 ^ 255 - 19
	    MPrime.call(
	      this,
	      '25519',
	      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
	  }
	  inherits(P25519, MPrime);
	
	  P25519.prototype.imulK = function imulK (num) {
	    // K = 0x13
	    var carry = 0;
	    for (var i = 0; i < num.length; i++) {
	      var hi = (num.words[i] | 0) * 0x13 + carry;
	      var lo = hi & 0x3ffffff;
	      hi >>>= 26;
	
	      num.words[i] = lo;
	      carry = hi;
	    }
	    if (carry !== 0) {
	      num.words[num.length++] = carry;
	    }
	    return num;
	  };
	
	  // Exported mostly for testing purposes, use plain name instead
	  BN._prime = function prime (name) {
	    // Cached version of prime
	    if (primes[name]) return primes[name];
	
	    var prime;
	    if (name === 'k256') {
	      prime = new K256();
	    } else if (name === 'p224') {
	      prime = new P224();
	    } else if (name === 'p192') {
	      prime = new P192();
	    } else if (name === 'p25519') {
	      prime = new P25519();
	    } else {
	      throw new Error('Unknown prime ' + name);
	    }
	    primes[name] = prime;
	
	    return prime;
	  };
	
	  //
	  // Base reduction engine
	  //
	  function Red (m) {
	    if (typeof m === 'string') {
	      var prime = BN._prime(m);
	      this.m = prime.p;
	      this.prime = prime;
	    } else {
	      assert(m.gtn(1), 'modulus must be greater than 1');
	      this.m = m;
	      this.prime = null;
	    }
	  }
	
	  Red.prototype._verify1 = function _verify1 (a) {
	    assert(a.negative === 0, 'red works only with positives');
	    assert(a.red, 'red works only with red numbers');
	  };
	
	  Red.prototype._verify2 = function _verify2 (a, b) {
	    assert((a.negative | b.negative) === 0, 'red works only with positives');
	    assert(a.red && a.red === b.red,
	      'red works only with red numbers');
	  };
	
	  Red.prototype.imod = function imod (a) {
	    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
	    return a.umod(this.m)._forceRed(this);
	  };
	
	  Red.prototype.neg = function neg (a) {
	    if (a.isZero()) {
	      return a.clone();
	    }
	
	    return this.m.sub(a)._forceRed(this);
	  };
	
	  Red.prototype.add = function add (a, b) {
	    this._verify2(a, b);
	
	    var res = a.add(b);
	    if (res.cmp(this.m) >= 0) {
	      res.isub(this.m);
	    }
	    return res._forceRed(this);
	  };
	
	  Red.prototype.iadd = function iadd (a, b) {
	    this._verify2(a, b);
	
	    var res = a.iadd(b);
	    if (res.cmp(this.m) >= 0) {
	      res.isub(this.m);
	    }
	    return res;
	  };
	
	  Red.prototype.sub = function sub (a, b) {
	    this._verify2(a, b);
	
	    var res = a.sub(b);
	    if (res.cmpn(0) < 0) {
	      res.iadd(this.m);
	    }
	    return res._forceRed(this);
	  };
	
	  Red.prototype.isub = function isub (a, b) {
	    this._verify2(a, b);
	
	    var res = a.isub(b);
	    if (res.cmpn(0) < 0) {
	      res.iadd(this.m);
	    }
	    return res;
	  };
	
	  Red.prototype.shl = function shl (a, num) {
	    this._verify1(a);
	    return this.imod(a.ushln(num));
	  };
	
	  Red.prototype.imul = function imul (a, b) {
	    this._verify2(a, b);
	    return this.imod(a.imul(b));
	  };
	
	  Red.prototype.mul = function mul (a, b) {
	    this._verify2(a, b);
	    return this.imod(a.mul(b));
	  };
	
	  Red.prototype.isqr = function isqr (a) {
	    return this.imul(a, a.clone());
	  };
	
	  Red.prototype.sqr = function sqr (a) {
	    return this.mul(a, a);
	  };
	
	  Red.prototype.sqrt = function sqrt (a) {
	    if (a.isZero()) return a.clone();
	
	    var mod3 = this.m.andln(3);
	    assert(mod3 % 2 === 1);
	
	    // Fast case
	    if (mod3 === 3) {
	      var pow = this.m.add(new BN(1)).iushrn(2);
	      return this.pow(a, pow);
	    }
	
	    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
	    //
	    // Find Q and S, that Q * 2 ^ S = (P - 1)
	    var q = this.m.subn(1);
	    var s = 0;
	    while (!q.isZero() && q.andln(1) === 0) {
	      s++;
	      q.iushrn(1);
	    }
	    assert(!q.isZero());
	
	    var one = new BN(1).toRed(this);
	    var nOne = one.redNeg();
	
	    // Find quadratic non-residue
	    // NOTE: Max is such because of generalized Riemann hypothesis.
	    var lpow = this.m.subn(1).iushrn(1);
	    var z = this.m.bitLength();
	    z = new BN(2 * z * z).toRed(this);
	
	    while (this.pow(z, lpow).cmp(nOne) !== 0) {
	      z.redIAdd(nOne);
	    }
	
	    var c = this.pow(z, q);
	    var r = this.pow(a, q.addn(1).iushrn(1));
	    var t = this.pow(a, q);
	    var m = s;
	    while (t.cmp(one) !== 0) {
	      var tmp = t;
	      for (var i = 0; tmp.cmp(one) !== 0; i++) {
	        tmp = tmp.redSqr();
	      }
	      assert(i < m);
	      var b = this.pow(c, new BN(1).iushln(m - i - 1));
	
	      r = r.redMul(b);
	      c = b.redSqr();
	      t = t.redMul(c);
	      m = i;
	    }
	
	    return r;
	  };
	
	  Red.prototype.invm = function invm (a) {
	    var inv = a._invmp(this.m);
	    if (inv.negative !== 0) {
	      inv.negative = 0;
	      return this.imod(inv).redNeg();
	    } else {
	      return this.imod(inv);
	    }
	  };
	
	  Red.prototype.pow = function pow (a, num) {
	    if (num.isZero()) return new BN(1);
	    if (num.cmpn(1) === 0) return a.clone();
	
	    var windowSize = 4;
	    var wnd = new Array(1 << windowSize);
	    wnd[0] = new BN(1).toRed(this);
	    wnd[1] = a;
	    for (var i = 2; i < wnd.length; i++) {
	      wnd[i] = this.mul(wnd[i - 1], a);
	    }
	
	    var res = wnd[0];
	    var current = 0;
	    var currentLen = 0;
	    var start = num.bitLength() % 26;
	    if (start === 0) {
	      start = 26;
	    }
	
	    for (i = num.length - 1; i >= 0; i--) {
	      var word = num.words[i];
	      for (var j = start - 1; j >= 0; j--) {
	        var bit = (word >> j) & 1;
	        if (res !== wnd[0]) {
	          res = this.sqr(res);
	        }
	
	        if (bit === 0 && current === 0) {
	          currentLen = 0;
	          continue;
	        }
	
	        current <<= 1;
	        current |= bit;
	        currentLen++;
	        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
	
	        res = this.mul(res, wnd[current]);
	        currentLen = 0;
	        current = 0;
	      }
	      start = 26;
	    }
	
	    return res;
	  };
	
	  Red.prototype.convertTo = function convertTo (num) {
	    var r = num.umod(this.m);
	
	    return r === num ? r.clone() : r;
	  };
	
	  Red.prototype.convertFrom = function convertFrom (num) {
	    var res = num.clone();
	    res.red = null;
	    return res;
	  };
	
	  //
	  // Montgomery method engine
	  //
	
	  BN.mont = function mont (num) {
	    return new Mont(num);
	  };
	
	  function Mont (m) {
	    Red.call(this, m);
	
	    this.shift = this.m.bitLength();
	    if (this.shift % 26 !== 0) {
	      this.shift += 26 - (this.shift % 26);
	    }
	
	    this.r = new BN(1).iushln(this.shift);
	    this.r2 = this.imod(this.r.sqr());
	    this.rinv = this.r._invmp(this.m);
	
	    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
	    this.minv = this.minv.umod(this.r);
	    this.minv = this.r.sub(this.minv);
	  }
	  inherits(Mont, Red);
	
	  Mont.prototype.convertTo = function convertTo (num) {
	    return this.imod(num.ushln(this.shift));
	  };
	
	  Mont.prototype.convertFrom = function convertFrom (num) {
	    var r = this.imod(num.mul(this.rinv));
	    r.red = null;
	    return r;
	  };
	
	  Mont.prototype.imul = function imul (a, b) {
	    if (a.isZero() || b.isZero()) {
	      a.words[0] = 0;
	      a.length = 1;
	      return a;
	    }
	
	    var t = a.imul(b);
	    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
	    var u = t.isub(c).iushrn(this.shift);
	    var res = u;
	
	    if (u.cmp(this.m) >= 0) {
	      res = u.isub(this.m);
	    } else if (u.cmpn(0) < 0) {
	      res = u.iadd(this.m);
	    }
	
	    return res._forceRed(this);
	  };
	
	  Mont.prototype.mul = function mul (a, b) {
	    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
	
	    var t = a.mul(b);
	    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
	    var u = t.isub(c).iushrn(this.shift);
	    var res = u;
	    if (u.cmp(this.m) >= 0) {
	      res = u.isub(this.m);
	    } else if (u.cmpn(0) < 0) {
	      res = u.iadd(this.m);
	    }
	
	    return res._forceRed(this);
	  };
	
	  Mont.prototype.invm = function invm (a) {
	    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
	    var res = this.imod(a._invmp(this.m).mul(this.r2));
	    return res._forceRed(this);
	  };
	})(typeof module === 'undefined' || module, this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)(module)))

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var DOMProperty = __webpack_require__(56);
	var ReactDOMComponentFlags = __webpack_require__(262);
	
	var invariant = __webpack_require__(3);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(60);


/***/ },
/* 10 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(595)();
	}


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind,
	    nativeCreate       = Object.create;
	
	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function(){};
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.8.3';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value)) return _.matcher(value);
	    return _.property(value);
	  };
	  _.iteratee = function(value, context) {
	    return cb(value, context, Infinity);
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, undefinedOnly) {
	    return function(obj) {
	      var length = arguments.length;
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };
	
	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  };
	
	  var property = function(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = property('length');
	  var isArrayLike = function(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Optimized iterator function as using arguments.length
	    // in the main function will deoptimize the, see #1991.
	    function iterator(obj, iteratee, memo, keys, index, length) {
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    }
	
	    return function(obj, iteratee, memo, context) {
	      iteratee = optimizeCb(iteratee, context, 4);
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      // Determine the initial value if none is provided.
	      if (arguments.length < 3) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      return iterator(obj, iteratee, memo, keys, index, length);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var key;
	    if (isArrayLike(obj)) {
	      key = _.findIndex(obj, predicate, context);
	    } else {
	      key = _.findKey(obj, predicate, context);
	    }
	    if (key !== void 0 && key !== -1) return obj[key];
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      var func = isFunc ? method : value[method];
	      return func == null ? func : func.apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = isArrayLike(obj) ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, startIndex) {
	    var output = [], idx = 0;
	    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        //flatten current level of array or arguments object
	        if (!shallow) value = flatten(value, shallow, strict);
	        var j = 0, len = value.length;
	        output.length += len;
	        while (j < len) {
	          output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(arguments, true, true, 1);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    return _.unzip(arguments);
	  };
	
	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices
	  _.unzip = function(array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Generator function to create the findIndex and findLastIndex functions
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a predicate test
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Generator function to create the indexOf and lastIndexOf functions
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	            i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments
	  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var args = slice.call(arguments, 2);
	    var bound = function() {
	      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	    };
	    return bound;
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function() {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last >= 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  function collectNonEnumProps(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve all the property names of an object.
	  _.allKeys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Returns the results of applying the iteratee to each element of the object
	  // In contrast to _.map it returns an object
	  _.mapObject = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys =  _.keys(obj),
	          length = keys.length,
	          results = {},
	          currentKey;
	      for (var index = 0; index < length; index++) {
	        currentKey = keys[index];
	        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	      }
	      return results;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);
	
	  // Returns the first key on an object that passes a predicate test
	  _.findKey = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj), key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(object, oiteratee, context) {
	    var result = {}, obj = object, iteratee, keys;
	    if (obj == null) return result;
	    if (_.isFunction(oiteratee)) {
	      keys = _.allKeys(obj);
	      iteratee = optimizeCb(oiteratee, context);
	    } else {
	      keys = flatten(arguments, false, false, 1);
	      iteratee = function(value, key, obj) { return key in obj; };
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(flatten(arguments, false, false, 1), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function(object, attrs) {
	    var keys = _.keys(attrs), length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };
	
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	                               _.isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), and in Safari 8 (#1929).
	  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  _.property = property;
	
	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function(obj) {
	    return obj == null ? function(){} : function(key) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function(attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function(obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property, fallback) {
	    var value = object == null ? void 0 : object[property];
	    if (value === void 0) {
	      value = fallback;
	    }
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function() {
	    return '' + this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}.call(this));


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var elliptic = exports;
	
	elliptic.version = __webpack_require__(555).version;
	elliptic.utils = __webpack_require__(501);
	elliptic.rand = __webpack_require__(202);
	elliptic.curve = __webpack_require__(92);
	elliptic.curves = __webpack_require__(493);
	
	// Protocols
	elliptic.ec = __webpack_require__(494);
	elliptic.eddsa = __webpack_require__(497);


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/*
	    This file is part of web3.js.
	
	    web3.js is free software: you can redistribute it and/or modify
	    it under the terms of the GNU Lesser General Public License as published by
	    the Free Software Foundation, either version 3 of the License, or
	    (at your option) any later version.
	
	    web3.js is distributed in the hope that it will be useful,
	    but WITHOUT ANY WARRANTY; without even the implied warranty of
	    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	    GNU Lesser General Public License for more details.
	
	    You should have received a copy of the GNU Lesser General Public License
	    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	*/
	/**
	 * @file index.js
	 * @author Fabian Vogelsteller <fabian@ethereum.org>
	 * @date 2017
	 */
	
	"use strict";
	
	var errors = __webpack_require__(744);
	var formatters = __webpack_require__(745);
	
	module.exports = {
	    errors: errors,
	    formatters: formatters
	};
	


/***/ },
/* 15 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 17 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.5.3' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 18 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(120)('wks');
	var uid = __webpack_require__(87);
	var Symbol = __webpack_require__(18).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 20 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 21 */
/***/ function(module, exports) {

	module.exports = assert;
	
	function assert(val, msg) {
	  if (!val)
	    throw new Error(msg || 'Assertion failed');
	}
	
	assert.equal = function assertEqual(l, r, msg) {
	  if (l != r)
	    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
	};


/***/ },
/* 22 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 This file is part of web3.js.
	
	 web3.js is free software: you can redistribute it and/or modify
	 it under the terms of the GNU Lesser General Public License as published by
	 the Free Software Foundation, either version 3 of the License, or
	 (at your option) any later version.
	
	 web3.js is distributed in the hope that it will be useful,
	 but WITHOUT ANY WARRANTY; without even the implied warranty of
	 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	 GNU Lesser General Public License for more details.
	
	 You should have received a copy of the GNU Lesser General Public License
	 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	 */
	/**
	 * @file utils.js
	 * @author Marek Kotewicz <marek@parity.io>
	 * @author Fabian Vogelsteller <fabian@ethereum.org>
	 * @date 2017
	 */
	
	
	var _ = __webpack_require__(12);
	var ethjsUnit = __webpack_require__(506);
	var utils = __webpack_require__(323);
	var soliditySha3 = __webpack_require__(774);
	var randomHex = __webpack_require__(609);
	
	
	
	/**
	 * Fires an error in an event emitter and callback and returns the eventemitter
	 *
	 * @method _fireError
	 * @param {Object} error a string, a error, or an object with {message, data}
	 * @param {Object} emitter
	 * @param {Function} reject
	 * @param {Function} callback
	 * @return {Object} the emitter
	 */
	var _fireError = function (error, emitter, reject, callback) {
	    /*jshint maxcomplexity: 10 */
	
	    // add data if given
	    if(_.isObject(error) && !(error instanceof Error) &&  error.data) {
	        if(_.isObject(error.data) || _.isArray(error.data)) {
	            error.data = JSON.stringify(error.data, null, 2);
	        }
	
	        error = error.message +"\n"+ error.data;
	    }
	
	    if(_.isString(error)) {
	        error = new Error(error);
	    }
	
	    if (_.isFunction(callback)) {
	        callback(error);
	    }
	    if (_.isFunction(reject)) {
	        // suppress uncatched error if an error listener is present
	        // OR suppress uncatched error if an callback listener is present
	        if (emitter &&
	            (_.isFunction(emitter.listeners) &&
	            emitter.listeners('error').length) || _.isFunction(callback)) {
	            emitter.catch(function(){});
	        }
	        // reject later, to be able to return emitter
	        setTimeout(function () {
	            reject(error);
	        }, 1);
	    }
	
	    if(emitter && _.isFunction(emitter.emit)) {
	        // emit later, to be able to return emitter
	        setTimeout(function () {
	            emitter.emit('error', error);
	            emitter.removeAllListeners();
	        }, 1);
	    }
	
	    return emitter;
	};
	
	/**
	 * Should be used to create full function/event name from json abi
	 *
	 * @method _jsonInterfaceMethodToString
	 * @param {Object} json
	 * @return {String} full function/event name
	 */
	var _jsonInterfaceMethodToString = function (json) {
	    if (_.isObject(json) && json.name && json.name.indexOf('(') !== -1) {
	        return json.name;
	    }
	
	    var typeName = json.inputs.map(function(i){return i.type; }).join(',');
	    return json.name + '(' + typeName + ')';
	};
	
	
	
	/**
	 * Should be called to get ascii from it's hex representation
	 *
	 * @method hexToAscii
	 * @param {String} hex
	 * @returns {String} ascii string representation of hex value
	 */
	var hexToAscii = function(hex) {
	    if (!utils.isHexStrict(hex))
	        throw new Error('The parameter must be a valid HEX string.');
	
	    var str = "";
	    var i = 0, l = hex.length;
	    if (hex.substring(0, 2) === '0x') {
	        i = 2;
	    }
	    for (; i < l; i+=2) {
	        var code = parseInt(hex.substr(i, 2), 16);
	        str += String.fromCharCode(code);
	    }
	
	    return str;
	};
	
	/**
	 * Should be called to get hex representation (prefixed by 0x) of ascii string
	 *
	 * @method asciiToHex
	 * @param {String} str
	 * @returns {String} hex representation of input string
	 */
	var asciiToHex = function(str) {
	    if(!str)
	        return "0x00";
	    var hex = "";
	    for(var i = 0; i < str.length; i++) {
	        var code = str.charCodeAt(i);
	        var n = code.toString(16);
	        hex += n.length < 2 ? '0' + n : n;
	    }
	
	    return "0x" + hex;
	};
	
	
	
	/**
	 * Returns value of unit in Wei
	 *
	 * @method getUnitValue
	 * @param {String} unit the unit to convert to, default ether
	 * @returns {BN} value of the unit (in Wei)
	 * @throws error if the unit is not correct:w
	 */
	var getUnitValue = function (unit) {
	    unit = unit ? unit.toLowerCase() : 'ether';
	    if (!ethjsUnit.unitMap[unit]) {
	        throw new Error('This unit "'+ unit +'" doesn\'t exist, please use the one of the following units' + JSON.stringify(ethjsUnit.unitMap, null, 2));
	    }
	    return unit;
	};
	
	/**
	 * Takes a number of wei and converts it to any other ether unit.
	 *
	 * Possible units are:
	 *   SI Short   SI Full        Effigy       Other
	 * - kwei       femtoether     babbage
	 * - mwei       picoether      lovelace
	 * - gwei       nanoether      shannon      nano
	 * - --         microether     szabo        micro
	 * - --         milliether     finney       milli
	 * - ether      --             --
	 * - kether                    --           grand
	 * - mether
	 * - gether
	 * - tether
	 *
	 * @method fromWei
	 * @param {Number|String} number can be a number, number string or a HEX of a decimal
	 * @param {String} unit the unit to convert to, default ether
	 * @return {String|Object} When given a BN object it returns one as well, otherwise a number
	 */
	var fromWei = function(number, unit) {
	    unit = getUnitValue(unit);
	
	    if(!utils.isBN(number) && !_.isString(number)) {
	        throw new Error('Please pass numbers as strings or BigNumber objects to avoid precision errors.');
	    }
	
	    return utils.isBN(number) ? ethjsUnit.fromWei(number, unit) : ethjsUnit.fromWei(number, unit).toString(10);
	};
	
	/**
	 * Takes a number of a unit and converts it to wei.
	 *
	 * Possible units are:
	 *   SI Short   SI Full        Effigy       Other
	 * - kwei       femtoether     babbage
	 * - mwei       picoether      lovelace
	 * - gwei       nanoether      shannon      nano
	 * - --         microether     szabo        micro
	 * - --         microether     szabo        micro
	 * - --         milliether     finney       milli
	 * - ether      --             --
	 * - kether                    --           grand
	 * - mether
	 * - gether
	 * - tether
	 *
	 * @method toWei
	 * @param {Number|String|BN} number can be a number, number string or a HEX of a decimal
	 * @param {String} unit the unit to convert from, default ether
	 * @return {String|Object} When given a BN object it returns one as well, otherwise a number
	 */
	var toWei = function(number, unit) {
	    unit = getUnitValue(unit);
	
	    if(!utils.isBN(number) && !_.isString(number)) {
	        throw new Error('Please pass numbers as strings or BigNumber objects to avoid precision errors.');
	    }
	
	    return utils.isBN(number) ? ethjsUnit.toWei(number, unit) : ethjsUnit.toWei(number, unit).toString(10);
	};
	
	
	
	
	/**
	 * Converts to a checksum address
	 *
	 * @method toChecksumAddress
	 * @param {String} address the given HEX address
	 * @return {String}
	 */
	var toChecksumAddress = function (address) {
	    if (typeof address === 'undefined') return '';
	
	    if(!/^(0x)?[0-9a-f]{40}$/i.test(address))
	        throw new Error('Given address "'+ address +'" is not a valid Ethereum address.');
	
	
	
	    address = address.toLowerCase().replace(/^0x/i,'');
	    var addressHash = utils.sha3(address).replace(/^0x/i,'');
	    var checksumAddress = '0x';
	
	    for (var i = 0; i < address.length; i++ ) {
	        // If ith character is 9 to f then make it uppercase
	        if (parseInt(addressHash[i], 16) > 7) {
	            checksumAddress += address[i].toUpperCase();
	        } else {
	            checksumAddress += address[i];
	        }
	    }
	    return checksumAddress;
	};
	
	
	
	module.exports = {
	    _fireError: _fireError,
	    _jsonInterfaceMethodToString: _jsonInterfaceMethodToString,
	    // extractDisplayName: extractDisplayName,
	    // extractTypeName: extractTypeName,
	    randomHex: randomHex,
	    _: _,
	    BN: utils.BN,
	    isBN: utils.isBN,
	    isBigNumber: utils.isBigNumber,
	    isHex: utils.isHex,
	    isHexStrict: utils.isHexStrict,
	    sha3: utils.sha3,
	    keccak256: utils.sha3,
	    soliditySha3: soliditySha3,
	    isAddress: utils.isAddress,
	    checkAddressChecksum: utils.checkAddressChecksum,
	    toChecksumAddress: toChecksumAddress,
	    toHex: utils.toHex,
	    toBN: utils.toBN,
	
	    bytesToHex: utils.bytesToHex,
	    hexToBytes: utils.hexToBytes,
	
	    hexToNumberString: utils.hexToNumberString,
	
	    hexToNumber: utils.hexToNumber,
	    toDecimal: utils.hexToNumber, // alias
	
	    numberToHex: utils.numberToHex,
	    fromDecimal: utils.numberToHex, // alias
	
	    hexToUtf8: utils.hexToUtf8,
	    hexToString: utils.hexToUtf8,
	    toUtf8: utils.hexToUtf8,
	
	    utf8ToHex: utils.utf8ToHex,
	    stringToHex: utils.utf8ToHex,
	    fromUtf8: utils.utf8ToHex,
	
	    hexToAscii: hexToAscii,
	    toAscii: hexToAscii,
	    asciiToHex: asciiToHex,
	    fromAscii: asciiToHex,
	
	    unitMap: ethjsUnit.unitMap,
	    toWei: toWei,
	    fromWei: fromWei,
	
	    padLeft: utils.leftPad,
	    leftPad: utils.leftPad,
	    padRight: utils.rightPad,
	    rightPad: utils.rightPad,
	    toTwosComplement: utils.toTwosComplement
	};
	


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.check = check;
	exports.hasOwn = hasOwn;
	exports.remove = remove;
	exports.deferred = deferred;
	exports.arrayOfDeffered = arrayOfDeffered;
	exports.delay = delay;
	exports.createMockTask = createMockTask;
	exports.autoInc = autoInc;
	exports.makeIterator = makeIterator;
	exports.log = log;
	exports.deprecate = deprecate;
	var sym = exports.sym = function sym(id) {
	  return '@@redux-saga/' + id;
	};
	
	var TASK = /*#__PURE__*/exports.TASK = sym('TASK');
	var HELPER = /*#__PURE__*/exports.HELPER = sym('HELPER');
	var MATCH = /*#__PURE__*/exports.MATCH = sym('MATCH');
	var CANCEL = /*#__PURE__*/exports.CANCEL = sym('CANCEL_PROMISE');
	var SAGA_ACTION = /*#__PURE__*/exports.SAGA_ACTION = sym('SAGA_ACTION');
	var SELF_CANCELLATION = /*#__PURE__*/exports.SELF_CANCELLATION = sym('SELF_CANCELLATION');
	var konst = exports.konst = function konst(v) {
	  return function () {
	    return v;
	  };
	};
	var kTrue = /*#__PURE__*/exports.kTrue = konst(true);
	var kFalse = /*#__PURE__*/exports.kFalse = konst(false);
	var noop = exports.noop = function noop() {};
	var ident = exports.ident = function ident(v) {
	  return v;
	};
	
	function check(value, predicate, error) {
	  if (!predicate(value)) {
	    log('error', 'uncaught at check', error);
	    throw new Error(error);
	  }
	}
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	function hasOwn(object, property) {
	  return is.notUndef(object) && hasOwnProperty.call(object, property);
	}
	
	var is = exports.is = {
	  undef: function undef(v) {
	    return v === null || v === undefined;
	  },
	  notUndef: function notUndef(v) {
	    return v !== null && v !== undefined;
	  },
	  func: function func(f) {
	    return typeof f === 'function';
	  },
	  number: function number(n) {
	    return typeof n === 'number';
	  },
	  string: function string(s) {
	    return typeof s === 'string';
	  },
	  array: Array.isArray,
	  object: function object(obj) {
	    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
	  },
	  promise: function promise(p) {
	    return p && is.func(p.then);
	  },
	  iterator: function iterator(it) {
	    return it && is.func(it.next) && is.func(it.throw);
	  },
	  iterable: function iterable(it) {
	    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
	  },
	  task: function task(t) {
	    return t && t[TASK];
	  },
	  observable: function observable(ob) {
	    return ob && is.func(ob.subscribe);
	  },
	  buffer: function buffer(buf) {
	    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
	  },
	  pattern: function pattern(pat) {
	    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
	  },
	  channel: function channel(ch) {
	    return ch && is.func(ch.take) && is.func(ch.close);
	  },
	  helper: function helper(it) {
	    return it && it[HELPER];
	  },
	  stringableFunc: function stringableFunc(f) {
	    return is.func(f) && hasOwn(f, 'toString');
	  }
	};
	
	var object = exports.object = {
	  assign: function assign(target, source) {
	    for (var i in source) {
	      if (hasOwn(source, i)) {
	        target[i] = source[i];
	      }
	    }
	  }
	};
	
	function remove(array, item) {
	  var index = array.indexOf(item);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	}
	
	var array = exports.array = {
	  from: function from(obj) {
	    var arr = Array(obj.length);
	    for (var i in obj) {
	      if (hasOwn(obj, i)) {
	        arr[i] = obj[i];
	      }
	    }
	    return arr;
	  }
	};
	
	function deferred() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var def = _extends({}, props);
	  var promise = new Promise(function (resolve, reject) {
	    def.resolve = resolve;
	    def.reject = reject;
	  });
	  def.promise = promise;
	  return def;
	}
	
	function arrayOfDeffered(length) {
	  var arr = [];
	  for (var i = 0; i < length; i++) {
	    arr.push(deferred());
	  }
	  return arr;
	}
	
	function delay(ms) {
	  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  var timeoutId = void 0;
	  var promise = new Promise(function (resolve) {
	    timeoutId = setTimeout(function () {
	      return resolve(val);
	    }, ms);
	  });
	
	  promise[CANCEL] = function () {
	    return clearTimeout(timeoutId);
	  };
	
	  return promise;
	}
	
	function createMockTask() {
	  var _ref;
	
	  var running = true;
	  var _result = void 0,
	      _error = void 0;
	
	  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
	    return running;
	  }, _ref.result = function result() {
	    return _result;
	  }, _ref.error = function error() {
	    return _error;
	  }, _ref.setRunning = function setRunning(b) {
	    return running = b;
	  }, _ref.setResult = function setResult(r) {
	    return _result = r;
	  }, _ref.setError = function setError(e) {
	    return _error = e;
	  }, _ref;
	}
	
	function autoInc() {
	  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = /*#__PURE__*/exports.uid = autoInc();
	
	var kThrow = function kThrow(err) {
	  throw err;
	};
	var kReturn = function kReturn(value) {
	  return { value: value, done: true };
	};
	function makeIterator(next) {
	  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
	  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var isHelper = arguments[3];
	
	  var iterator = { name: name, next: next, throw: thro, return: kReturn };
	
	  if (isHelper) {
	    iterator[HELPER] = true;
	  }
	  if (typeof Symbol !== 'undefined') {
	    iterator[Symbol.iterator] = function () {
	      return iterator;
	    };
	  }
	  return iterator;
	}
	
	/**
	  Print error in a useful way whether in a browser environment
	  (with expandable error stack traces), or in a node.js environment
	  (text-only log output)
	 **/
	function log(level, message) {
	  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  /*eslint-disable no-console*/
	  if (typeof window === 'undefined') {
	    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
	  } else {
	    console[level](message, error);
	  }
	}
	
	function deprecate(fn, deprecationWarning) {
	  return function () {
	    if (false) log('warn', deprecationWarning);
	    return fn.apply(undefined, arguments);
	  };
	}
	
	var updateIncentive = exports.updateIncentive = function updateIncentive(deprecated, preferred) {
	  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
	};
	
	var internalErr = exports.internalErr = function internalErr(err) {
	  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
	};
	
	var createSetContextWarning = exports.createSetContextWarning = function createSetContextWarning(ctx, props) {
	  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
	};
	
	var wrapSagaDispatch = exports.wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
	  return function (action) {
	    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
	  };
	};
	
	var cloneableGenerator = exports.cloneableGenerator = function cloneableGenerator(generatorFunc) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var history = [];
	    var gen = generatorFunc.apply(undefined, args);
	    return {
	      next: function next(arg) {
	        history.push(arg);
	        return gen.next(arg);
	      },
	      clone: function clone() {
	        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
	        history.forEach(function (arg) {
	          return clonedGen.next(arg);
	        });
	        return clonedGen;
	      },
	      return: function _return(value) {
	        return gen.return(value);
	      },
	      throw: function _throw(exception) {
	        return gen.throw(exception);
	      }
	    };
	  };
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.check = check;
	exports.hasOwn = hasOwn;
	exports.remove = remove;
	exports.deferred = deferred;
	exports.arrayOfDeffered = arrayOfDeffered;
	exports.delay = delay;
	exports.createMockTask = createMockTask;
	exports.autoInc = autoInc;
	exports.makeIterator = makeIterator;
	exports.log = log;
	exports.deprecate = deprecate;
	var sym = exports.sym = function sym(id) {
	  return '@@redux-saga/' + id;
	};
	
	var TASK = exports.TASK = sym('TASK');
	var HELPER = exports.HELPER = sym('HELPER');
	var MATCH = exports.MATCH = sym('MATCH');
	var CANCEL = exports.CANCEL = sym('CANCEL_PROMISE');
	var SAGA_ACTION = exports.SAGA_ACTION = sym('SAGA_ACTION');
	var SELF_CANCELLATION = exports.SELF_CANCELLATION = sym('SELF_CANCELLATION');
	var konst = exports.konst = function konst(v) {
	  return function () {
	    return v;
	  };
	};
	var kTrue = exports.kTrue = konst(true);
	var kFalse = exports.kFalse = konst(false);
	var noop = exports.noop = function noop() {};
	var ident = exports.ident = function ident(v) {
	  return v;
	};
	
	function check(value, predicate, error) {
	  if (!predicate(value)) {
	    log('error', 'uncaught at check', error);
	    throw new Error(error);
	  }
	}
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	function hasOwn(object, property) {
	  return is.notUndef(object) && hasOwnProperty.call(object, property);
	}
	
	var is = exports.is = {
	  undef: function undef(v) {
	    return v === null || v === undefined;
	  },
	  notUndef: function notUndef(v) {
	    return v !== null && v !== undefined;
	  },
	  func: function func(f) {
	    return typeof f === 'function';
	  },
	  number: function number(n) {
	    return typeof n === 'number';
	  },
	  string: function string(s) {
	    return typeof s === 'string';
	  },
	  array: Array.isArray,
	  object: function object(obj) {
	    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
	  },
	  promise: function promise(p) {
	    return p && is.func(p.then);
	  },
	  iterator: function iterator(it) {
	    return it && is.func(it.next) && is.func(it.throw);
	  },
	  iterable: function iterable(it) {
	    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
	  },
	  task: function task(t) {
	    return t && t[TASK];
	  },
	  observable: function observable(ob) {
	    return ob && is.func(ob.subscribe);
	  },
	  buffer: function buffer(buf) {
	    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
	  },
	  pattern: function pattern(pat) {
	    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
	  },
	  channel: function channel(ch) {
	    return ch && is.func(ch.take) && is.func(ch.close);
	  },
	  helper: function helper(it) {
	    return it && it[HELPER];
	  },
	  stringableFunc: function stringableFunc(f) {
	    return is.func(f) && hasOwn(f, 'toString');
	  }
	};
	
	var object = exports.object = {
	  assign: function assign(target, source) {
	    for (var i in source) {
	      if (hasOwn(source, i)) {
	        target[i] = source[i];
	      }
	    }
	  }
	};
	
	function remove(array, item) {
	  var index = array.indexOf(item);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	}
	
	var array = exports.array = {
	  from: function from(obj) {
	    var arr = Array(obj.length);
	    for (var i in obj) {
	      if (hasOwn(obj, i)) {
	        arr[i] = obj[i];
	      }
	    }
	    return arr;
	  }
	};
	
	function deferred() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var def = _extends({}, props);
	  var promise = new Promise(function (resolve, reject) {
	    def.resolve = resolve;
	    def.reject = reject;
	  });
	  def.promise = promise;
	  return def;
	}
	
	function arrayOfDeffered(length) {
	  var arr = [];
	  for (var i = 0; i < length; i++) {
	    arr.push(deferred());
	  }
	  return arr;
	}
	
	function delay(ms) {
	  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  var timeoutId = void 0;
	  var promise = new Promise(function (resolve) {
	    timeoutId = setTimeout(function () {
	      return resolve(val);
	    }, ms);
	  });
	
	  promise[CANCEL] = function () {
	    return clearTimeout(timeoutId);
	  };
	
	  return promise;
	}
	
	function createMockTask() {
	  var _ref;
	
	  var running = true;
	  var _result = void 0,
	      _error = void 0;
	
	  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
	    return running;
	  }, _ref.result = function result() {
	    return _result;
	  }, _ref.error = function error() {
	    return _error;
	  }, _ref.setRunning = function setRunning(b) {
	    return running = b;
	  }, _ref.setResult = function setResult(r) {
	    return _result = r;
	  }, _ref.setError = function setError(e) {
	    return _error = e;
	  }, _ref;
	}
	
	function autoInc() {
	  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = exports.uid = autoInc();
	
	var kThrow = function kThrow(err) {
	  throw err;
	};
	var kReturn = function kReturn(value) {
	  return { value: value, done: true };
	};
	function makeIterator(next) {
	  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
	  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var isHelper = arguments[3];
	
	  var iterator = { name: name, next: next, throw: thro, return: kReturn };
	
	  if (isHelper) {
	    iterator[HELPER] = true;
	  }
	  if (typeof Symbol !== 'undefined') {
	    iterator[Symbol.iterator] = function () {
	      return iterator;
	    };
	  }
	  return iterator;
	}
	
	/**
	  Print error in a useful way whether in a browser environment
	  (with expandable error stack traces), or in a node.js environment
	  (text-only log output)
	 **/
	function log(level, message) {
	  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  /*eslint-disable no-console*/
	  if (typeof window === 'undefined') {
	    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
	  } else {
	    console[level](message, error);
	  }
	}
	
	function deprecate(fn, deprecationWarning) {
	  return function () {
	    if (false) log('warn', deprecationWarning);
	    return fn.apply(undefined, arguments);
	  };
	}
	
	var updateIncentive = exports.updateIncentive = function updateIncentive(deprecated, preferred) {
	  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
	};
	
	var internalErr = exports.internalErr = function internalErr(err) {
	  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
	};
	
	var createSetContextWarning = exports.createSetContextWarning = function createSetContextWarning(ctx, props) {
	  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
	};
	
	var wrapSagaDispatch = exports.wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
	  return function (action) {
	    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
	  };
	};
	
	var cloneableGenerator = exports.cloneableGenerator = function cloneableGenerator(generatorFunc) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var history = [];
	    var gen = generatorFunc.apply(undefined, args);
	    return {
	      next: function next(arg) {
	        history.push(arg);
	        return gen.next(arg);
	      },
	      clone: function clone() {
	        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
	        history.forEach(function (arg) {
	          return clonedGen.next(arg);
	        });
	        return clonedGen;
	      },
	      return: function _return(value) {
	        return gen.return(value);
	      },
	      throw: function _throw(exception) {
	        return gen.throw(exception);
	      }
	    };
	  };
	};

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var assert = __webpack_require__(21);
	var inherits = __webpack_require__(2);
	
	exports.inherits = inherits;
	
	function toArray(msg, enc) {
	  if (Array.isArray(msg))
	    return msg.slice();
	  if (!msg)
	    return [];
	  var res = [];
	  if (typeof msg === 'string') {
	    if (!enc) {
	      for (var i = 0; i < msg.length; i++) {
	        var c = msg.charCodeAt(i);
	        var hi = c >> 8;
	        var lo = c & 0xff;
	        if (hi)
	          res.push(hi, lo);
	        else
	          res.push(lo);
	      }
	    } else if (enc === 'hex') {
	      msg = msg.replace(/[^a-z0-9]+/ig, '');
	      if (msg.length % 2 !== 0)
	        msg = '0' + msg;
	      for (i = 0; i < msg.length; i += 2)
	        res.push(parseInt(msg[i] + msg[i + 1], 16));
	    }
	  } else {
	    for (i = 0; i < msg.length; i++)
	      res[i] = msg[i] | 0;
	  }
	  return res;
	}
	exports.toArray = toArray;
	
	function toHex(msg) {
	  var res = '';
	  for (var i = 0; i < msg.length; i++)
	    res += zero2(msg[i].toString(16));
	  return res;
	}
	exports.toHex = toHex;
	
	function htonl(w) {
	  var res = (w >>> 24) |
	            ((w >>> 8) & 0xff00) |
	            ((w << 8) & 0xff0000) |
	            ((w & 0xff) << 24);
	  return res >>> 0;
	}
	exports.htonl = htonl;
	
	function toHex32(msg, endian) {
	  var res = '';
	  for (var i = 0; i < msg.length; i++) {
	    var w = msg[i];
	    if (endian === 'little')
	      w = htonl(w);
	    res += zero8(w.toString(16));
	  }
	  return res;
	}
	exports.toHex32 = toHex32;
	
	function zero2(word) {
	  if (word.length === 1)
	    return '0' + word;
	  else
	    return word;
	}
	exports.zero2 = zero2;
	
	function zero8(word) {
	  if (word.length === 7)
	    return '0' + word;
	  else if (word.length === 6)
	    return '00' + word;
	  else if (word.length === 5)
	    return '000' + word;
	  else if (word.length === 4)
	    return '0000' + word;
	  else if (word.length === 3)
	    return '00000' + word;
	  else if (word.length === 2)
	    return '000000' + word;
	  else if (word.length === 1)
	    return '0000000' + word;
	  else
	    return word;
	}
	exports.zero8 = zero8;
	
	function join32(msg, start, end, endian) {
	  var len = end - start;
	  assert(len % 4 === 0);
	  var res = new Array(len / 4);
	  for (var i = 0, k = start; i < res.length; i++, k += 4) {
	    var w;
	    if (endian === 'big')
	      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
	    else
	      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
	    res[i] = w >>> 0;
	  }
	  return res;
	}
	exports.join32 = join32;
	
	function split32(msg, endian) {
	  var res = new Array(msg.length * 4);
	  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
	    var m = msg[i];
	    if (endian === 'big') {
	      res[k] = m >>> 24;
	      res[k + 1] = (m >>> 16) & 0xff;
	      res[k + 2] = (m >>> 8) & 0xff;
	      res[k + 3] = m & 0xff;
	    } else {
	      res[k + 3] = m >>> 24;
	      res[k + 2] = (m >>> 16) & 0xff;
	      res[k + 1] = (m >>> 8) & 0xff;
	      res[k] = m & 0xff;
	    }
	  }
	  return res;
	}
	exports.split32 = split32;
	
	function rotr32(w, b) {
	  return (w >>> b) | (w << (32 - b));
	}
	exports.rotr32 = rotr32;
	
	function rotl32(w, b) {
	  return (w << b) | (w >>> (32 - b));
	}
	exports.rotl32 = rotl32;
	
	function sum32(a, b) {
	  return (a + b) >>> 0;
	}
	exports.sum32 = sum32;
	
	function sum32_3(a, b, c) {
	  return (a + b + c) >>> 0;
	}
	exports.sum32_3 = sum32_3;
	
	function sum32_4(a, b, c, d) {
	  return (a + b + c + d) >>> 0;
	}
	exports.sum32_4 = sum32_4;
	
	function sum32_5(a, b, c, d, e) {
	  return (a + b + c + d + e) >>> 0;
	}
	exports.sum32_5 = sum32_5;
	
	function sum64(buf, pos, ah, al) {
	  var bh = buf[pos];
	  var bl = buf[pos + 1];
	
	  var lo = (al + bl) >>> 0;
	  var hi = (lo < al ? 1 : 0) + ah + bh;
	  buf[pos] = hi >>> 0;
	  buf[pos + 1] = lo;
	}
	exports.sum64 = sum64;
	
	function sum64_hi(ah, al, bh, bl) {
	  var lo = (al + bl) >>> 0;
	  var hi = (lo < al ? 1 : 0) + ah + bh;
	  return hi >>> 0;
	}
	exports.sum64_hi = sum64_hi;
	
	function sum64_lo(ah, al, bh, bl) {
	  var lo = al + bl;
	  return lo >>> 0;
	}
	exports.sum64_lo = sum64_lo;
	
	function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
	  var carry = 0;
	  var lo = al;
	  lo = (lo + bl) >>> 0;
	  carry += lo < al ? 1 : 0;
	  lo = (lo + cl) >>> 0;
	  carry += lo < cl ? 1 : 0;
	  lo = (lo + dl) >>> 0;
	  carry += lo < dl ? 1 : 0;
	
	  var hi = ah + bh + ch + dh + carry;
	  return hi >>> 0;
	}
	exports.sum64_4_hi = sum64_4_hi;
	
	function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
	  var lo = al + bl + cl + dl;
	  return lo >>> 0;
	}
	exports.sum64_4_lo = sum64_4_lo;
	
	function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
	  var carry = 0;
	  var lo = al;
	  lo = (lo + bl) >>> 0;
	  carry += lo < al ? 1 : 0;
	  lo = (lo + cl) >>> 0;
	  carry += lo < cl ? 1 : 0;
	  lo = (lo + dl) >>> 0;
	  carry += lo < dl ? 1 : 0;
	  lo = (lo + el) >>> 0;
	  carry += lo < el ? 1 : 0;
	
	  var hi = ah + bh + ch + dh + eh + carry;
	  return hi >>> 0;
	}
	exports.sum64_5_hi = sum64_5_hi;
	
	function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
	  var lo = al + bl + cl + dl + el;
	
	  return lo >>> 0;
	}
	exports.sum64_5_lo = sum64_5_lo;
	
	function rotr64_hi(ah, al, num) {
	  var r = (al << (32 - num)) | (ah >>> num);
	  return r >>> 0;
	}
	exports.rotr64_hi = rotr64_hi;
	
	function rotr64_lo(ah, al, num) {
	  var r = (ah << (32 - num)) | (al >>> num);
	  return r >>> 0;
	}
	exports.rotr64_lo = rotr64_lo;
	
	function shr64_hi(ah, al, num) {
	  return ah >>> num;
	}
	exports.shr64_hi = shr64_hi;
	
	function shr64_lo(ah, al, num) {
	  var r = (ah << (32 - num)) | (al >>> num);
	  return r >>> 0;
	}
	exports.shr64_lo = shr64_lo;


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(10);
	
	var CallbackQueue = __webpack_require__(260);
	var PooledClass = __webpack_require__(46);
	var ReactFeatureFlags = __webpack_require__(265);
	var ReactReconciler = __webpack_require__(57);
	var Transaction = __webpack_require__(104);
	
	var invariant = __webpack_require__(3);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/*
	    This file is part of web3.js.
	
	    web3.js is free software: you can redistribute it and/or modify
	    it under the terms of the GNU Lesser General Public License as published by
	    the Free Software Foundation, either version 3 of the License, or
	    (at your option) any later version.
	
	    web3.js is distributed in the hope that it will be useful,
	    but WITHOUT ANY WARRANTY; without even the implied warranty of
	    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	    GNU Lesser General Public License for more details.
	
	    You should have received a copy of the GNU Lesser General Public License
	    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	*/
	/**
	 * @file formatters.js
	 * @author Marek Kotewicz <marek@parity.io>
	 * @author Fabian Vogelsteller <fabian@frozeman.de>
	 * @date 2017
	 */
	
	var _ = __webpack_require__(12);
	var utils = __webpack_require__(23);
	var BN = __webpack_require__(7);
	var SolidityParam = __webpack_require__(317);
	
	
	
	/**
	 * Formats input value to byte representation of int
	 * If value is negative, return it's two's complement
	 * If the value is floating point, round it down
	 *
	 * @method formatInputInt
	 * @param {String|Number|BN} value that needs to be formatted
	 * @returns {SolidityParam}
	 */
	var formatInputInt = function (value) {
	    if(_.isNumber(value)) {
	        value = Math.trunc(value);
	    }
	    return new SolidityParam(utils.toTwosComplement(value).replace('0x',''));
	};
	
	/**
	 * Formats input bytes
	 *
	 * @method formatInputBytes
	 * @param {String} value
	 * @returns {SolidityParam}
	 */
	var formatInputBytes = function (value) {
	    if(!utils.isHexStrict(value)) {
	        throw new Error('Given parameter is not bytes: "'+ value + '"');
	    }
	
	    var result = value.replace(/^0x/i,'');
	
	    if(result.length % 2 !== 0) {
	        throw new Error('Given parameter bytes has an invalid length: "'+ value + '"');
	    }
	
	    if (result.length > 64) {
	        throw new Error('Given parameter bytes is too long: "' + value + '"');
	    }
	
	    var l = Math.floor((result.length + 63) / 64);
	    result = utils.padRight(result, l * 64);
	    return new SolidityParam(result);
	};
	
	/**
	 * Formats input bytes
	 *
	 * @method formatDynamicInputBytes
	 * @param {String} value
	 * @returns {SolidityParam}
	 */
	var formatInputDynamicBytes = function (value) {
	    if(!utils.isHexStrict(value)) {
	        throw new Error('Given parameter is not bytes: "'+ value + '"');
	    }
	
	    var result = value.replace(/^0x/i,'');
	
	    if(result.length % 2 !== 0) {
	        throw new Error('Given parameter bytes has an invalid length: "'+ value + '"');
	    }
	
	    var length = result.length / 2;
	    var l = Math.floor((result.length + 63) / 64);
	    result = utils.padRight(result, l * 64);
	    return new SolidityParam(formatInputInt(length).value + result);
	};
	
	/**
	 * Formats input value to byte representation of string
	 *
	 * @method formatInputString
	 * @param {String}
	 * @returns {SolidityParam}
	 */
	var formatInputString = function (value) {
	    if(!_.isString(value)) {
	        throw new Error('Given parameter is not a valid string: ' + value);
	    }
	
	    var result = utils.utf8ToHex(value).replace(/^0x/i,'');
	    var length = result.length / 2;
	    var l = Math.floor((result.length + 63) / 64);
	    result = utils.padRight(result, l * 64);
	    return new SolidityParam(formatInputInt(length).value + result);
	};
	
	/**
	 * Formats input value to byte representation of bool
	 *
	 * @method formatInputBool
	 * @param {Boolean}
	 * @returns {SolidityParam}
	 */
	var formatInputBool = function (value) {
	    var result = '000000000000000000000000000000000000000000000000000000000000000' + (value ?  '1' : '0');
	    return new SolidityParam(result);
	};
	
	
	/**
	 * Check if input value is negative
	 *
	 * @method signedIsNegative
	 * @param {String} value is hex format
	 * @returns {Boolean} true if it is negative, otherwise false
	 */
	var signedIsNegative = function (value) {
	    return (new BN(value.substr(0, 1), 16).toString(2).substr(0, 1)) === '1';
	};
	
	/**
	 * Formats right-aligned output bytes to int
	 *
	 * @method formatOutputInt
	 * @param {SolidityParam} param
	 * @returns {BN} right-aligned output bytes formatted to big number
	 */
	var formatOutputInt = function (param) {
	    var value = param.staticPart();
	
	    if(!value && !param.rawValue) {
	        throw new Error('Couldn\'t decode '+ name +' from ABI: 0x'+ param.rawValue);
	    }
	
	    // check if it's negative number
	    // it it is, return two's complement
	    if (signedIsNegative(value)) {
	        return new BN(value, 16).fromTwos(256).toString(10);
	    }
	    return new BN(value, 16).toString(10);
	};
	
	/**
	 * Formats right-aligned output bytes to uint
	 *
	 * @method formatOutputUInt
	 * @param {SolidityParam} param
	 * @returns {BN} right-aligned output bytes formatted to uint
	 */
	var formatOutputUInt = function (param, name) {
	    var value = param.staticPart();
	
	    if(!value && !param.rawValue) {
	        throw new Error('Couldn\'t decode '+ name +' from ABI: 0x'+ param.rawValue);
	    }
	
	    return new BN(value, 16).toString(10);
	};
	
	
	
	/**
	 * Should be used to format output bool
	 *
	 * @method formatOutputBool
	 * @param {SolidityParam} param
	 * @param {String} name type name
	 * @returns {Boolean} right-aligned input bytes formatted to bool
	 */
	var formatOutputBool = function (param, name) {
	    var value = param.staticPart();
	
	    if(!value && !param.rawValue) {
	        throw new Error('Couldn\'t decode '+ name +' from ABI: 0x'+ param.rawValue);
	    }
	
	    return (value === '0000000000000000000000000000000000000000000000000000000000000001');
	};
	
	/**
	 * Should be used to format output bytes
	 *
	 * @method formatOutputBytes
	 * @param {SolidityParam} param left-aligned hex representation of string
	 * @param {String} name type name
	 * @returns {String} hex string
	 */
	var formatOutputBytes = function (param, name) {
	    var matches = name.match(/^bytes([0-9]*)/);
	    var size = parseInt(matches[1]);
	
	    if(param.staticPart().slice(0, 2 * size).length !== size * 2) {
	        throw new Error('Couldn\'t decode '+ name +' from ABI: 0x'+ param.rawValue + ' The size doesn\'t match.');
	    }
	
	    return '0x' + param.staticPart().slice(0, 2 * size);
	};
	
	/**
	 * Should be used to format output bytes
	 *
	 * @method formatOutputDynamicBytes
	 * @param {SolidityParam} param left-aligned hex representation of string
	 * @param {String} name type name
	 * @returns {String} hex string
	 */
	var formatOutputDynamicBytes = function (param, name) {
	    var hex = param.dynamicPart().slice(0, 64);
	
	    if (!hex) {
	        throw new Error('Couldn\'t decode '+ name +' from ABI: 0x'+ param.rawValue);
	    }
	
	    var length = (new BN(hex, 16)).toNumber() * 2;
	    return '0x' + param.dynamicPart().substr(64, length);
	};
	
	/**
	 * Should be used to format output string
	 *
	 * @method formatOutputString
	 * @param {SolidityParam} left-aligned hex representation of string
	 * @returns {String} ascii string
	 */
	var formatOutputString = function (param) {
	    var hex = param.dynamicPart().slice(0, 64);
	
	    if(!hex) {
	        throw new Error('ERROR: The returned value is not a convertible string:'+ hex);
	    }
	
	    var length = (new BN(hex, 16)).toNumber() * 2;
	    return length ? utils.hexToUtf8('0x'+ param.dynamicPart().substr(64, length).replace(/^0x/i, '')) : '';
	};
	
	/**
	 * Should be used to format output address
	 *
	 * @method formatOutputAddress
	 * @param {SolidityParam} param right-aligned input bytes
	 * @param {String} name type name
	 * @returns {String} address
	 */
	var formatOutputAddress = function (param, name) {
	    var value = param.staticPart();
	
	    if (!value) {
	        throw new Error('Couldn\'t decode '+ name +' from ABI: 0x'+ param.rawValue);
	    }
	
	    return utils.toChecksumAddress("0x" + value.slice(value.length - 40, value.length));
	};
	
	module.exports = {
	    formatInputInt: formatInputInt,
	    formatInputBytes: formatInputBytes,
	    formatInputDynamicBytes: formatInputDynamicBytes,
	    formatInputString: formatInputString,
	    formatInputBool: formatInputBool,
	    formatOutputInt: formatOutputInt,
	    formatOutputUInt: formatOutputUInt,
	    formatOutputBool: formatOutputBool,
	    formatOutputBytes: formatOutputBytes,
	    formatOutputDynamicBytes: formatOutputDynamicBytes,
	    formatOutputString: formatOutputString,
	    formatOutputAddress: formatOutputAddress,
	    toTwosComplement: utils.toTwosComplement
	};


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(36);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(18);
	var core = __webpack_require__(17);
	var ctx = __webpack_require__(69);
	var hide = __webpack_require__(44);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(9);
	var factory = __webpack_require__(208);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var PooledClass = __webpack_require__(46);
	
	var emptyFunction = __webpack_require__(20);
	var warning = __webpack_require__(5);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 34 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(70)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 36 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(30);
	var IE8_DOM_DEFINE = __webpack_require__(185);
	var toPrimitive = __webpack_require__(122);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(35) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var Buffer = __webpack_require__(4).Buffer
	var Transform = __webpack_require__(82).Transform
	var StringDecoder = __webpack_require__(171).StringDecoder
	var inherits = __webpack_require__(2)
	
	function CipherBase (hashMode) {
	  Transform.call(this)
	  this.hashMode = typeof hashMode === 'string'
	  if (this.hashMode) {
	    this[hashMode] = this._finalOrDigest
	  } else {
	    this.final = this._finalOrDigest
	  }
	  if (this._final) {
	    this.__final = this._final
	    this._final = null
	  }
	  this._decoder = null
	  this._encoding = null
	}
	inherits(CipherBase, Transform)
	
	CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
	  if (typeof data === 'string') {
	    data = Buffer.from(data, inputEnc)
	  }
	
	  var outData = this._update(data)
	  if (this.hashMode) return this
	
	  if (outputEnc) {
	    outData = this._toString(outData, outputEnc)
	  }
	
	  return outData
	}
	
	CipherBase.prototype.setAutoPadding = function () {}
	CipherBase.prototype.getAuthTag = function () {
	  throw new Error('trying to get auth tag in unsupported state')
	}
	
	CipherBase.prototype.setAuthTag = function () {
	  throw new Error('trying to set auth tag in unsupported state')
	}
	
	CipherBase.prototype.setAAD = function () {
	  throw new Error('trying to set aad in unsupported state')
	}
	
	CipherBase.prototype._transform = function (data, _, next) {
	  var err
	  try {
	    if (this.hashMode) {
	      this._update(data)
	    } else {
	      this.push(this._update(data))
	    }
	  } catch (e) {
	    err = e
	  } finally {
	    next(err)
	  }
	}
	CipherBase.prototype._flush = function (done) {
	  var err
	  try {
	    this.push(this.__final())
	  } catch (e) {
	    err = e
	  }
	
	  done(err)
	}
	CipherBase.prototype._finalOrDigest = function (outputEnc) {
	  var outData = this.__final() || Buffer.alloc(0)
	  if (outputEnc) {
	    outData = this._toString(outData, outputEnc, true)
	  }
	  return outData
	}
	
	CipherBase.prototype._toString = function (value, enc, fin) {
	  if (!this._decoder) {
	    this._decoder = new StringDecoder(enc)
	    this._encoding = enc
	  }
	
	  if (this._encoding !== enc) throw new Error('can\'t switch encodings')
	
	  var out = this._decoder.write(value)
	  if (fin) {
	    out += this._decoder.end()
	  }
	
	  return out
	}
	
	module.exports = CipherBase


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(11), __webpack_require__(9), __webpack_require__(168), __webpack_require__(90));
		else if(typeof define === 'function' && define.amd)
			define(["prop-types", "react", "redux", "drizzle"], factory);
		else if(typeof exports === 'object')
			exports["drizzle-react"] = factory(require("prop-types"), require("react"), require("redux"), require("drizzle"));
		else
			root["drizzle-react"] = factory(root["prop-types"], root["react"], root["redux"], root["drizzle"]);
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_19__, __WEBPACK_EXTERNAL_MODULE_35__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 9);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports) {
	
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}
	
	/***/ }),
	/* 4 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
	
	
	var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
	  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
	  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
	  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
	  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
	});
	
	var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
	  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
	  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
	  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
	});
	
	/***/ }),
	/* 5 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(14);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(4);
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	
	
	
	
	
	
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (process.env.NODE_ENV !== 'production') {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	          this.initSubscription();
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
	  };
	}
	/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))
	
	/***/ }),
	/* 6 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
	/* unused harmony export getDependsOnOwnProps */
	/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(7);
	
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (process.env.NODE_ENV !== 'production') Object(__WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__["a" /* default */])(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}
	/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))
	
	/***/ }),
	/* 7 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = verifyPlainObject;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(3);
	
	
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
	    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}
	
	/***/ }),
	/* 8 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(22);
	
	
	/** Built-in value references. */
	var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;
	
	/* harmony default export */ __webpack_exports__["a"] = (Symbol);
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DrizzleProvider = exports.drizzleConnect = undefined;
	
	var _drizzleConnect = __webpack_require__(10);
	
	var _drizzleConnect2 = _interopRequireDefault(_drizzleConnect);
	
	var _DrizzleProvider = __webpack_require__(34);
	
	var _DrizzleProvider2 = _interopRequireDefault(_DrizzleProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.drizzleConnect = _drizzleConnect2.default;
	exports.DrizzleProvider = _DrizzleProvider2.default;
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = drizzleConnect;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function drizzleConnect(Component) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  var ConnectedWrappedComponent = _reactRedux.connect.apply(undefined, args)(Component);
	
	  var DrizzledComponent = function DrizzledComponent(props, context) {
	    return _react2.default.createElement(ConnectedWrappedComponent, _extends({}, props, { store: context.drizzleStore }));
	  };
	
	  DrizzledComponent.contextTypes = {
	    drizzleStore: _propTypes2.default.object
	  };
	
	  return DrizzledComponent;
	}
	
	/***/ }),
	/* 11 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(16);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });
	
	
	
	
	
	
	/***/ }),
	/* 12 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(3);
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	
	
	
	
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider() {
	  var _Provider$childContex;
	
	  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
	  var subKey = arguments[1];
	
	  var subscriptionKey = subKey || storeKey + 'Subscription';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    Provider.prototype.render = function render() {
	      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
	    };
	
	    return Provider;
	  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
	
	  if (process.env.NODE_ENV !== 'production') {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
	    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
	
	  return Provider;
	}
	
	/* harmony default export */ __webpack_exports__["b"] = (createProvider());
	/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};
	
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (process.env.NODE_ENV !== 'production') {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 15 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	
	
	/***/ }),
	/* 16 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* unused harmony export createConnect */
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(17);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(30);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(31);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(32);
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	
	
	
	
	
	
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	/* harmony default export */ __webpack_exports__["a"] = (createConnect());
	
	/***/ }),
	/* 17 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	/***/ }),
	/* 18 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* unused harmony export whenMapDispatchToPropsIsFunction */
	/* unused harmony export whenMapDispatchToPropsIsMissing */
	/* unused harmony export whenMapDispatchToPropsIsObject */
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(19);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(6);
	
	
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
	    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_19__;
	
	/***/ }),
	/* 20 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(27);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(29);
	
	
	
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
	    return false;
	  }
	  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);
	
	
	/***/ }),
	/* 21 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(25);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(26);
	
	
	
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
	    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
	}
	
	/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);
	
	
	/***/ }),
	/* 22 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(23);
	
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();
	
	/* harmony default export */ __webpack_exports__["a"] = (root);
	
	
	/***/ }),
	/* 23 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);
	
	/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(24)))
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports) {
	
	var g;
	
	// This works in non-strict mode
	g = (function() {
		return this;
	})();
	
	try {
		// This works if eval is allowed (see CSP)
		g = g || Function("return this")() || (1,eval)("this");
	} catch(e) {
		// This works if the window reference is available
		if(typeof window === "object")
			g = window;
	}
	
	// g can still be undefined, but nothing to do about it...
	// We return undefined, instead of nothing here, so it's
	// easier to handle this case. if(!global) { ...}
	
	module.exports = g;
	
	
	/***/ }),
	/* 25 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(8);
	
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/* harmony default export */ __webpack_exports__["a"] = (getRawTag);
	
	
	/***/ }),
	/* 26 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/* harmony default export */ __webpack_exports__["a"] = (objectToString);
	
	
	/***/ }),
	/* 27 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(28);
	
	
	/** Built-in value references. */
	var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);
	
	/* harmony default export */ __webpack_exports__["a"] = (getPrototype);
	
	
	/***/ }),
	/* 28 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/* harmony default export */ __webpack_exports__["a"] = (overArg);
	
	
	/***/ }),
	/* 29 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);
	
	
	/***/ }),
	/* 30 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* unused harmony export whenMapStateToPropsIsFunction */
	/* unused harmony export whenMapStateToPropsIsMissing */
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(6);
	
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
	    return {};
	  }) : undefined;
	}
	
	/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);
	
	/***/ }),
	/* 31 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {/* unused harmony export defaultMergeProps */
	/* unused harmony export wrapMergePropsFunc */
	/* unused harmony export whenMergePropsIsFunction */
	/* unused harmony export whenMergePropsIsOmitted */
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(7);
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (process.env.NODE_ENV !== 'production') Object(__WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__["a" /* default */])(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);
	/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))
	
	/***/ }),
	/* 32 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {/* unused harmony export impureFinalPropsSelectorFactory */
	/* unused harmony export pureFinalPropsSelectorFactory */
	/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(33);
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (process.env.NODE_ENV !== 'production') {
	    Object(__WEBPACK_IMPORTED_MODULE_0__verifySubselectors__["a" /* default */])(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}
	/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))
	
	/***/ }),
	/* 33 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = verifySubselectors;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(3);
	
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _drizzle = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DrizzleProvider = function (_Component) {
	  _inherits(DrizzleProvider, _Component);
	
	  function DrizzleProvider(context, props) {
	    _classCallCheck(this, DrizzleProvider);
	
	    return _possibleConstructorReturn(this, (DrizzleProvider.__proto__ || Object.getPrototypeOf(DrizzleProvider)).call(this, context, props));
	  }
	
	  // you must specify what you’re adding to the context
	
	
	  _createClass(DrizzleProvider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var drizzleStore = this.props.store ? this.props.store : (0, _drizzle.generateStore)(this.props.options);
	      var drizzle = new _drizzle.Drizzle(this.props.options, drizzleStore);
	
	      return { drizzle: drizzle, drizzleStore: drizzleStore };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // `Children.only` enables us not to add a <div /> for nothing
	      return _react.Children.only(this.props.children);
	    }
	  }]);
	
	  return DrizzleProvider;
	}(_react.Component);
	
	DrizzleProvider.propTypes = {
	  options: _propTypes2.default.object.isRequired,
	  store: _propTypes2.default.object };
	DrizzleProvider.childContextTypes = {
	  drizzle: _propTypes2.default.object.isRequired,
	  drizzleStore: _propTypes2.default.object.isRequired
	};
	exports.default = DrizzleProvider;
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_35__;
	
	/***/ })
	/******/ ]);
	});

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(42);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 43 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(37);
	var createDesc = __webpack_require__(85);
	module.exports = __webpack_require__(35) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.asEffect = exports.takem = exports.detach = undefined;
	exports.take = take;
	exports.put = put;
	exports.all = all;
	exports.race = race;
	exports.call = call;
	exports.apply = apply;
	exports.cps = cps;
	exports.fork = fork;
	exports.spawn = spawn;
	exports.join = join;
	exports.cancel = cancel;
	exports.select = select;
	exports.actionChannel = actionChannel;
	exports.cancelled = cancelled;
	exports.flush = flush;
	exports.getContext = getContext;
	exports.setContext = setContext;
	exports.takeEvery = takeEvery;
	exports.takeLatest = takeLatest;
	exports.throttle = throttle;
	
	var _utils = /*#__PURE__*/__webpack_require__(24);
	
	var _sagaHelpers = /*#__PURE__*/__webpack_require__(220);
	
	var IO = /*#__PURE__*/(0, _utils.sym)('IO');
	var TAKE = 'TAKE';
	var PUT = 'PUT';
	var ALL = 'ALL';
	var RACE = 'RACE';
	var CALL = 'CALL';
	var CPS = 'CPS';
	var FORK = 'FORK';
	var JOIN = 'JOIN';
	var CANCEL = 'CANCEL';
	var SELECT = 'SELECT';
	var ACTION_CHANNEL = 'ACTION_CHANNEL';
	var CANCELLED = 'CANCELLED';
	var FLUSH = 'FLUSH';
	var GET_CONTEXT = 'GET_CONTEXT';
	var SET_CONTEXT = 'SET_CONTEXT';
	
	var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';
	
	var effect = function effect(type, payload) {
	  var _ref;
	
	  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
	};
	
	var detach = exports.detach = function detach(eff) {
	  (0, _utils.check)(asEffect.fork(eff), _utils.is.object, 'detach(eff): argument must be a fork effect');
	  eff[FORK].detached = true;
	  return eff;
	};
	
	function take() {
	  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';
	
	  if (arguments.length) {
	    (0, _utils.check)(arguments[0], _utils.is.notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
	  }
	  if (_utils.is.pattern(patternOrChannel)) {
	    return effect(TAKE, { pattern: patternOrChannel });
	  }
	  if (_utils.is.channel(patternOrChannel)) {
	    return effect(TAKE, { channel: patternOrChannel });
	  }
	  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
	}
	
	take.maybe = function () {
	  var eff = take.apply(undefined, arguments);
	  eff[TAKE].maybe = true;
	  return eff;
	};
	
	var takem = /*#__PURE__*/exports.takem = (0, _utils.deprecate)(take.maybe, /*#__PURE__*/(0, _utils.updateIncentive)('takem', 'take.maybe'));
	
	function put(channel, action) {
	  if (arguments.length > 1) {
	    (0, _utils.check)(channel, _utils.is.notUndef, 'put(channel, action): argument channel is undefined');
	    (0, _utils.check)(channel, _utils.is.channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
	    (0, _utils.check)(action, _utils.is.notUndef, 'put(channel, action): argument action is undefined');
	  } else {
	    (0, _utils.check)(channel, _utils.is.notUndef, 'put(action): argument action is undefined');
	    action = channel;
	    channel = null;
	  }
	  return effect(PUT, { channel: channel, action: action });
	}
	
	put.resolve = function () {
	  var eff = put.apply(undefined, arguments);
	  eff[PUT].resolve = true;
	  return eff;
	};
	
	put.sync = /*#__PURE__*/(0, _utils.deprecate)(put.resolve, /*#__PURE__*/(0, _utils.updateIncentive)('put.sync', 'put.resolve'));
	
	function all(effects) {
	  return effect(ALL, effects);
	}
	
	function race(effects) {
	  return effect(RACE, effects);
	}
	
	function getFnCallDesc(meth, fn, args) {
	  (0, _utils.check)(fn, _utils.is.notUndef, meth + ': argument fn is undefined');
	
	  var context = null;
	  if (_utils.is.array(fn)) {
	    var _fn = fn;
	    context = _fn[0];
	    fn = _fn[1];
	  } else if (fn.fn) {
	    var _fn2 = fn;
	    context = _fn2.context;
	    fn = _fn2.fn;
	  }
	  if (context && _utils.is.string(fn) && _utils.is.func(context[fn])) {
	    fn = context[fn];
	  }
	  (0, _utils.check)(fn, _utils.is.func, meth + ': argument ' + fn + ' is not a function');
	
	  return { context: context, fn: fn, args: args };
	}
	
	function call(fn) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return effect(CALL, getFnCallDesc('call', fn, args));
	}
	
	function apply(context, fn) {
	  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
	}
	
	function cps(fn) {
	  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    args[_key2 - 1] = arguments[_key2];
	  }
	
	  return effect(CPS, getFnCallDesc('cps', fn, args));
	}
	
	function fork(fn) {
	  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    args[_key3 - 1] = arguments[_key3];
	  }
	
	  return effect(FORK, getFnCallDesc('fork', fn, args));
	}
	
	function spawn(fn) {
	  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    args[_key4 - 1] = arguments[_key4];
	  }
	
	  return detach(fork.apply(undefined, [fn].concat(args)));
	}
	
	function join() {
	  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	    tasks[_key5] = arguments[_key5];
	  }
	
	  if (tasks.length > 1) {
	    return all(tasks.map(function (t) {
	      return join(t);
	    }));
	  }
	  var task = tasks[0];
	  (0, _utils.check)(task, _utils.is.notUndef, 'join(task): argument task is undefined');
	  (0, _utils.check)(task, _utils.is.task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
	  return effect(JOIN, task);
	}
	
	function cancel() {
	  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	    tasks[_key6] = arguments[_key6];
	  }
	
	  if (tasks.length > 1) {
	    return all(tasks.map(function (t) {
	      return cancel(t);
	    }));
	  }
	  var task = tasks[0];
	  if (tasks.length === 1) {
	    (0, _utils.check)(task, _utils.is.notUndef, 'cancel(task): argument task is undefined');
	    (0, _utils.check)(task, _utils.is.task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
	  }
	  return effect(CANCEL, task || _utils.SELF_CANCELLATION);
	}
	
	function select(selector) {
	  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
	    args[_key7 - 1] = arguments[_key7];
	  }
	
	  if (arguments.length === 0) {
	    selector = _utils.ident;
	  } else {
	    (0, _utils.check)(selector, _utils.is.notUndef, 'select(selector,[...]): argument selector is undefined');
	    (0, _utils.check)(selector, _utils.is.func, 'select(selector,[...]): argument ' + selector + ' is not a function');
	  }
	  return effect(SELECT, { selector: selector, args: args });
	}
	
	/**
	  channel(pattern, [buffer])    => creates an event channel for store actions
	**/
	function actionChannel(pattern, buffer) {
	  (0, _utils.check)(pattern, _utils.is.notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
	  if (arguments.length > 1) {
	    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
	    (0, _utils.check)(buffer, _utils.is.buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
	  }
	  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
	}
	
	function cancelled() {
	  return effect(CANCELLED, {});
	}
	
	function flush(channel) {
	  (0, _utils.check)(channel, _utils.is.channel, 'flush(channel): argument ' + channel + ' is not valid channel');
	  return effect(FLUSH, channel);
	}
	
	function getContext(prop) {
	  (0, _utils.check)(prop, _utils.is.string, 'getContext(prop): argument ' + prop + ' is not a string');
	  return effect(GET_CONTEXT, prop);
	}
	
	function setContext(props) {
	  (0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)(null, props));
	  return effect(SET_CONTEXT, props);
	}
	
	function takeEvery(patternOrChannel, worker) {
	  for (var _len8 = arguments.length, args = Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
	    args[_key8 - 2] = arguments[_key8];
	  }
	
	  return fork.apply(undefined, [_sagaHelpers.takeEveryHelper, patternOrChannel, worker].concat(args));
	}
	
	function takeLatest(patternOrChannel, worker) {
	  for (var _len9 = arguments.length, args = Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
	    args[_key9 - 2] = arguments[_key9];
	  }
	
	  return fork.apply(undefined, [_sagaHelpers.takeLatestHelper, patternOrChannel, worker].concat(args));
	}
	
	function throttle(ms, pattern, worker) {
	  for (var _len10 = arguments.length, args = Array(_len10 > 3 ? _len10 - 3 : 0), _key10 = 3; _key10 < _len10; _key10++) {
	    args[_key10 - 3] = arguments[_key10];
	  }
	
	  return fork.apply(undefined, [_sagaHelpers.throttleHelper, ms, pattern, worker].concat(args));
	}
	
	var createAsEffectType = function createAsEffectType(type) {
	  return function (effect) {
	    return effect && effect[IO] && effect[type];
	  };
	};
	
	var asEffect = exports.asEffect = {
	  take: /*#__PURE__*/createAsEffectType(TAKE),
	  put: /*#__PURE__*/createAsEffectType(PUT),
	  all: /*#__PURE__*/createAsEffectType(ALL),
	  race: /*#__PURE__*/createAsEffectType(RACE),
	  call: /*#__PURE__*/createAsEffectType(CALL),
	  cps: /*#__PURE__*/createAsEffectType(CPS),
	  fork: /*#__PURE__*/createAsEffectType(FORK),
	  join: /*#__PURE__*/createAsEffectType(JOIN),
	  cancel: /*#__PURE__*/createAsEffectType(CANCEL),
	  select: /*#__PURE__*/createAsEffectType(SELECT),
	  actionChannel: /*#__PURE__*/createAsEffectType(ACTION_CHANNEL),
	  cancelled: /*#__PURE__*/createAsEffectType(CANCELLED),
	  flush: /*#__PURE__*/createAsEffectType(FLUSH),
	  getContext: /*#__PURE__*/createAsEffectType(GET_CONTEXT),
	  setContext: /*#__PURE__*/createAsEffectType(SET_CONTEXT)
	};

/***/ },
/* 46 */
[793, 6],
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(101).nextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = __webpack_require__(73);
	util.inherits = __webpack_require__(2);
	/*</replacement>*/
	
	var Readable = __webpack_require__(296);
	var Writable = __webpack_require__(165);
	
	util.inherits(Duplex, Readable);
	
	var keys = objectKeys(Writable.prototype);
	for (var v = 0; v < keys.length; v++) {
	  var method = keys[v];
	  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  processNextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  processNextTick(cb, err);
	};
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/*
	    This file is part of web3.js.
	
	    web3.js is free software: you can redistribute it and/or modify
	    it under the terms of the GNU Lesser General Public License as published by
	    the Free Software Foundation, either version 3 of the License, or
	    (at your option) any later version.
	
	    web3.js is distributed in the hope that it will be useful,
	    but WITHOUT ANY WARRANTY; without even the implied warranty of
	    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	    GNU Lesser General Public License for more details.
	
	    You should have received a copy of the GNU Lesser General Public License
	    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	*/
	/**
	 * @file index.js
	 * @author Fabian Vogelsteller <fabian@ethereum.org>
	 * @author Marek Kotewicz <marek@parity.io>
	 * @date 2017
	 */
	
	"use strict";
	
	var _ = __webpack_require__(12);
	var errors = __webpack_require__(14).errors;
	var formatters = __webpack_require__(14).formatters;
	var utils = __webpack_require__(23);
	var promiEvent = __webpack_require__(314);
	var Subscriptions = __webpack_require__(109).subscriptions;
	
	var TIMEOUTBLOCK = 50;
	var POLLINGTIMEOUT = 15 * TIMEOUTBLOCK; // ~average block time (seconds) * TIMEOUTBLOCK
	var CONFIRMATIONBLOCKS = 24;
	
	var Method = function Method(options) {
	
	    if(!options.call || !options.name) {
	        throw new Error('When creating a method you need to provide at least the "name" and "call" property.');
	    }
	
	    this.name = options.name;
	    this.call = options.call;
	    this.params = options.params || 0;
	    this.inputFormatter = options.inputFormatter;
	    this.outputFormatter = options.outputFormatter;
	    this.transformPayload = options.transformPayload;
	    this.extraFormatters = options.extraFormatters;
	
	    this.requestManager = options.requestManager;
	
	    // reference to eth.accounts
	    this.accounts = options.accounts;
	
	    this.defaultBlock = options.defaultBlock || 'latest';
	    this.defaultAccount = options.defaultAccount || null;
	};
	
	Method.prototype.setRequestManager = function (requestManager, accounts) {
	    this.requestManager = requestManager;
	
	    // reference to eth.accounts
	    if (accounts) {
	        this.accounts = accounts;
	    }
	
	};
	
	Method.prototype.createFunction = function (requestManager, accounts) {
	    var func = this.buildCall();
	    func.call = this.call;
	
	    this.setRequestManager(requestManager || this.requestManager, accounts || this.accounts);
	
	    return func;
	};
	
	Method.prototype.attachToObject = function (obj) {
	    var func = this.buildCall();
	    func.call = this.call;
	    var name = this.name.split('.');
	    if (name.length > 1) {
	        obj[name[0]] = obj[name[0]] || {};
	        obj[name[0]][name[1]] = func;
	    } else {
	        obj[name[0]] = func;
	    }
	};
	
	/**
	 * Should be used to determine name of the jsonrpc method based on arguments
	 *
	 * @method getCall
	 * @param {Array} arguments
	 * @return {String} name of jsonrpc method
	 */
	Method.prototype.getCall = function (args) {
	    return _.isFunction(this.call) ? this.call(args) : this.call;
	};
	
	/**
	 * Should be used to extract callback from array of arguments. Modifies input param
	 *
	 * @method extractCallback
	 * @param {Array} arguments
	 * @return {Function|Null} callback, if exists
	 */
	Method.prototype.extractCallback = function (args) {
	    if (_.isFunction(args[args.length - 1])) {
	        return args.pop(); // modify the args array!
	    }
	};
	
	/**
	 * Should be called to check if the number of arguments is correct
	 *
	 * @method validateArgs
	 * @param {Array} arguments
	 * @throws {Error} if it is not
	 */
	Method.prototype.validateArgs = function (args) {
	    if (args.length !== this.params) {
	        throw errors.InvalidNumberOfParams(args.length, this.params, this.name);
	    }
	};
	
	/**
	 * Should be called to format input args of method
	 *
	 * @method formatInput
	 * @param {Array}
	 * @return {Array}
	 */
	Method.prototype.formatInput = function (args) {
	    var _this = this;
	
	    if (!this.inputFormatter) {
	        return args;
	    }
	
	    return this.inputFormatter.map(function (formatter, index) {
	        // bind this for defaultBlock, and defaultAccount
	        return formatter ? formatter.call(_this, args[index]) : args[index];
	    });
	};
	
	/**
	 * Should be called to format output(result) of method
	 *
	 * @method formatOutput
	 * @param {Object}
	 * @return {Object}
	 */
	Method.prototype.formatOutput = function (result) {
	    var _this = this;
	
	    if(_.isArray(result)) {
	        return result.map(function(res){
	            return _this.outputFormatter && res ? _this.outputFormatter(res) : res;
	        });
	    } else {
	        return this.outputFormatter && result ? this.outputFormatter(result) : result;
	    }
	};
	
	/**
	 * Should create payload from given input args
	 *
	 * @method toPayload
	 * @param {Array} args
	 * @return {Object}
	 */
	Method.prototype.toPayload = function (args) {
	    var call = this.getCall(args);
	    var callback = this.extractCallback(args);
	    var params = this.formatInput(args);
	    this.validateArgs(params);
	
	    var payload = {
	        method: call,
	        params: params,
	        callback: callback
	    };
	
	    if (this.transformPayload) {
	        payload = this.transformPayload(payload);
	    }
	
	    return payload;
	};
	
	
	Method.prototype._confirmTransaction = function (defer, result, payload) {
	    var method = this,
	        promiseResolved = false,
	        canUnsubscribe = true,
	        timeoutCount = 0,
	        confirmationCount = 0,
	        intervalId = null,
	        gasProvided = (_.isObject(payload.params[0]) && payload.params[0].gas) ? payload.params[0].gas : null,
	        isContractDeployment = _.isObject(payload.params[0]) &&
	            payload.params[0].data &&
	            payload.params[0].from &&
	            !payload.params[0].to;
	
	
	    // add custom send Methods
	    var _ethereumCalls = [
	        new Method({
	            name: 'getTransactionReceipt',
	            call: 'eth_getTransactionReceipt',
	            params: 1,
	            inputFormatter: [null],
	            outputFormatter: formatters.outputTransactionReceiptFormatter
	        }),
	        new Method({
	            name: 'getCode',
	            call: 'eth_getCode',
	            params: 2,
	            inputFormatter: [formatters.inputAddressFormatter, formatters.inputDefaultBlockNumberFormatter]
	        }),
	        new Subscriptions({
	            name: 'subscribe',
	            type: 'eth',
	            subscriptions: {
	                'newBlockHeaders': {
	                    subscriptionName: 'newHeads', // replace subscription with this name
	                    params: 0,
	                    outputFormatter: formatters.outputBlockFormatter
	                }
	            }
	        })
	    ];
	    // attach methods to this._ethereumCall
	    var _ethereumCall = {};
	    _.each(_ethereumCalls, function (mthd) {
	        mthd.attachToObject(_ethereumCall);
	        mthd.requestManager = method.requestManager; // assign rather than call setRequestManager()
	    });
	
	
	    // fire "receipt" and confirmation events and resolve after
	    var checkConfirmation = function (existingReceipt, isPolling, err, blockHeader, sub) {
	        if (!err) {
	            // create fake unsubscribe
	            if (!sub) {
	                sub = {
	                    unsubscribe: function () {
	                        clearInterval(intervalId);
	                    }
	                };
	            }
	            // if we have a valid receipt we don't need to send a request
	            return (existingReceipt ? promiEvent.resolve(existingReceipt) : _ethereumCall.getTransactionReceipt(result))
	            // catch error from requesting receipt
	            .catch(function (err) {
	                sub.unsubscribe();
	                promiseResolved = true;
	                utils._fireError({message: 'Failed to check for transaction receipt:', data: err}, defer.eventEmitter, defer.reject);
	            })
	            // if CONFIRMATION listener exists check for confirmations, by setting canUnsubscribe = false
	            .then(function(receipt) {
	                if (!receipt || !receipt.blockHash) {
	                    throw new Error('Receipt missing or blockHash null');
	                }
	
	                // apply extra formatters
	                if (method.extraFormatters && method.extraFormatters.receiptFormatter) {
	                    receipt = method.extraFormatters.receiptFormatter(receipt);
	                }
	
	                // check if confirmation listener exists
	                if (defer.eventEmitter.listeners('confirmation').length > 0) {
	
	                    // If there was an immediately retrieved receipt, it's already
	                    // been confirmed by the direct call to checkConfirmation needed
	                    // for parity instant-seal
	                    if (existingReceipt === undefined || confirmationCount !== 0){
	                        defer.eventEmitter.emit('confirmation', confirmationCount, receipt);
	                    }
	
	                    canUnsubscribe = false;
	                    confirmationCount++;
	
	                    if (confirmationCount === CONFIRMATIONBLOCKS + 1) { // add 1 so we account for conf 0
	                        sub.unsubscribe();
	                        defer.eventEmitter.removeAllListeners();
	                    }
	                }
	
	                return receipt;
	            })
	            // CHECK for CONTRACT DEPLOYMENT
	            .then(function(receipt) {
	
	                if (isContractDeployment && !promiseResolved) {
	
	                    if (!receipt.contractAddress) {
	
	                        if (canUnsubscribe) {
	                            sub.unsubscribe();
	                            promiseResolved = true;
	                        }
	
	                        utils._fireError(new Error('The transaction receipt didn\'t contain a contract address.'), defer.eventEmitter, defer.reject);
	                        return;
	                    }
	
	                    _ethereumCall.getCode(receipt.contractAddress, function (e, code) {
	
	                        if (!code) {
	                            return;
	                        }
	
	
	                        if (code.length > 2) {
	                            defer.eventEmitter.emit('receipt', receipt);
	
	                            // if contract, return instance instead of receipt
	                            if (method.extraFormatters && method.extraFormatters.contractDeployFormatter) {
	                                defer.resolve(method.extraFormatters.contractDeployFormatter(receipt));
	                            } else {
	                                defer.resolve(receipt);
	                            }
	
	                            // need to remove listeners, as they aren't removed automatically when succesfull
	                            if (canUnsubscribe) {
	                                defer.eventEmitter.removeAllListeners();
	                            }
	
	                        } else {
	                            utils._fireError(new Error('The contract code couldn\'t be stored, please check your gas limit.'), defer.eventEmitter, defer.reject);
	                        }
	
	                        if (canUnsubscribe) {
	                            sub.unsubscribe();
	                        }
	                        promiseResolved = true;
	                    });
	                }
	
	                return receipt;
	            })
	            // CHECK for normal tx check for receipt only
	            .then(function(receipt) {
	
	                if (!isContractDeployment && !promiseResolved) {
	
	                    if(!receipt.outOfGas &&
	                        (!gasProvided || gasProvided !== receipt.gasUsed) &&
	                        (receipt.status === true || receipt.status === '0x1' || typeof receipt.status === 'undefined')) {
	                        defer.eventEmitter.emit('receipt', receipt);
	                        defer.resolve(receipt);
	
	                        // need to remove listeners, as they aren't removed automatically when succesfull
	                        if (canUnsubscribe) {
	                            defer.eventEmitter.removeAllListeners();
	                        }
	
	                    } else {
	                        if(receipt) {
	                            receipt = JSON.stringify(receipt, null, 2);
	                        }
	                        if (receipt.status === false || receipt.status === '0x0') {
	                            utils._fireError(new Error("Transaction has been reverted by the EVM:\n" + receipt),
	                                defer.eventEmitter, defer.reject);
	                        } else {
	                            utils._fireError(
	                                new Error("Transaction ran out of gas. Please provide more gas:\n" + receipt),
	                                defer.eventEmitter, defer.reject);
	                        }
	                    }
	
	                    if (canUnsubscribe) {
	                        sub.unsubscribe();
	                    }
	                    promiseResolved = true;
	                }
	
	            })
	            // time out the transaction if not mined after 50 blocks
	            .catch(function () {
	                timeoutCount++;
	
	                // check to see if we are http polling
	                if(!!isPolling) {
	                    // polling timeout is different than TIMEOUTBLOCK blocks since we are triggering every second
	                    if (timeoutCount - 1 >= POLLINGTIMEOUT) {
	                        sub.unsubscribe();
	                        promiseResolved = true;
	                        utils._fireError(new Error('Transaction was not mined within' + POLLINGTIMEOUT + ' seconds, please make sure your transaction was properly sent. Be aware that it might still be mined!'), defer.eventEmitter, defer.reject);
	                    }
	                } else {
	                    if (timeoutCount - 1 >= TIMEOUTBLOCK) {
	                        sub.unsubscribe();
	                        promiseResolved = true;
	                        utils._fireError(new Error('Transaction was not mined within 50 blocks, please make sure your transaction was properly sent. Be aware that it might still be mined!'), defer.eventEmitter, defer.reject);
	                    }
	                }
	            });
	
	
	        } else {
	            sub.unsubscribe();
	            promiseResolved = true;
	            utils._fireError({message: 'Failed to subscribe to new newBlockHeaders to confirm the transaction receipts.', data: err}, defer.eventEmitter, defer.reject);
	        }
	    };
	
	    // start watching for confirmation depending on the support features of the provider
	    var startWatching = function(existingReceipt) {
	        // if provider allows PUB/SUB
	        if (_.isFunction(this.requestManager.provider.on)) {
	            _ethereumCall.subscribe('newBlockHeaders', checkConfirmation.bind(null, existingReceipt, false));
	        } else {
	            intervalId = setInterval(checkConfirmation.bind(null, existingReceipt, true), 1000);
	        }
	    }.bind(this);
	
	
	    // first check if we already have a confirmed transaction
	    _ethereumCall.getTransactionReceipt(result)
	    .then(function(receipt) {
	        if (receipt && receipt.blockHash) {
	            if (defer.eventEmitter.listeners('confirmation').length > 0) {
	                // We must keep on watching for new Blocks, if a confirmation listener is present
	                startWatching(receipt);
	            }
	            checkConfirmation(receipt, false);
	
	        } else if (!promiseResolved) {
	            startWatching();
	        }
	    })
	    .catch(function(){
	        if (!promiseResolved) startWatching();
	    });
	
	};
	
	
	var getWallet = function(from, accounts) {
	    var wallet = null;
	
	    // is index given
	    if (_.isNumber(from)) {
	        wallet = accounts.wallet[from];
	
	        // is account given
	    } else if (_.isObject(from) && from.address && from.privateKey) {
	        wallet = from;
	
	        // search in wallet for address
	    } else {
	        wallet = accounts.wallet[from.toLowerCase()];
	    }
	
	    return wallet;
	};
	
	Method.prototype.buildCall = function() {
	    var method = this,
	        isSendTx = (method.call === 'eth_sendTransaction' || method.call === 'eth_sendRawTransaction'); // || method.call === 'personal_sendTransaction'
	
	    // actual send function
	    var send = function () {
	        var defer = promiEvent(!isSendTx),
	            payload = method.toPayload(Array.prototype.slice.call(arguments));
	
	
	        // CALLBACK function
	        var sendTxCallback = function (err, result) {
	            try {
	                result = method.formatOutput(result);
	            } catch(e) {
	                err = e;
	            }
	
	            if (result instanceof Error) {
	                err = result;
	            }
	
	            if (!err) {
	                if (payload.callback) {
	                    payload.callback(null, result);
	                }
	            } else {
	                if(err.error) {
	                    err = err.error;
	                }
	
	                return utils._fireError(err, defer.eventEmitter, defer.reject, payload.callback);
	            }
	
	            // return PROMISE
	            if (!isSendTx) {
	
	                if (!err) {
	                    defer.resolve(result);
	
	                }
	
	                // return PROMIEVENT
	            } else {
	                defer.eventEmitter.emit('transactionHash', result);
	
	                method._confirmTransaction(defer, result, payload);
	            }
	
	        };
	
	        // SENDS the SIGNED SIGNATURE
	        var sendSignedTx = function(sign){
	
	            var signedPayload = _.extend({}, payload, {
	                method: 'eth_sendRawTransaction',
	                params: [sign.rawTransaction]
	            });
	
	            method.requestManager.send(signedPayload, sendTxCallback);
	        };
	
	
	        var sendRequest = function(payload, method) {
	
	            if (method && method.accounts && method.accounts.wallet && method.accounts.wallet.length) {
	                var wallet;
	
	                // ETH_SENDTRANSACTION
	                if (payload.method === 'eth_sendTransaction') {
	                    var tx = payload.params[0];
	                    wallet = getWallet((_.isObject(tx)) ? tx.from : null, method.accounts);
	
	
	                    // If wallet was found, sign tx, and send using sendRawTransaction
	                    if (wallet && wallet.privateKey) {
	                        return method.accounts.signTransaction(_.omit(tx, 'from'), wallet.privateKey).then(sendSignedTx);
	                    }
	
	                    // ETH_SIGN
	                } else if (payload.method === 'eth_sign') {
	                    var data = payload.params[1];
	                    wallet = getWallet(payload.params[0], method.accounts);
	
	                    // If wallet was found, sign tx, and send using sendRawTransaction
	                    if (wallet && wallet.privateKey) {
	                        var sign = method.accounts.sign(data, wallet.privateKey);
	
	                        if (payload.callback) {
	                            payload.callback(null, sign.signature);
	                        }
	
	                        defer.resolve(sign.signature);
	                        return;
	                    }
	
	
	                }
	            }
	
	            return method.requestManager.send(payload, sendTxCallback);
	        };
	
	        // Send the actual transaction
	        if(isSendTx && _.isObject(payload.params[0]) && !payload.params[0].gasPrice) {
	
	            var getGasPrice = (new Method({
	                name: 'getGasPrice',
	                call: 'eth_gasPrice',
	                params: 0
	            })).createFunction(method.requestManager);
	
	            getGasPrice(function (err, gasPrice) {
	
	                if (gasPrice) {
	                    payload.params[0].gasPrice = gasPrice;
	                }
	                sendRequest(payload, method);
	            });
	
	        } else {
	            sendRequest(payload, method);
	        }
	
	
	        return defer.eventEmitter;
	    };
	
	    // necessary to attach things to the method
	    send.method = method;
	    // necessary for batch requests
	    send.request = this.request.bind(this);
	    return send;
	};
	
	/**
	 * Should be called to create the pure JSONRPC request which can be used in a batch request
	 *
	 * @method request
	 * @return {Object} jsonrpc request
	 */
	Method.prototype.request = function () {
	    var payload = this.toPayload(Array.prototype.slice.call(arguments));
	    payload.format = this.formatOutput.bind(this);
	    return payload;
	};
	
	module.exports = Method;


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	/*
	    This file is part of web3.js.
	
	    web3.js is free software: you can redistribute it and/or modify
	    it under the terms of the GNU Lesser General Public License as published by
	    the Free Software Foundation, either version 3 of the License, or
	    (at your option) any later version.
	
	    web3.js is distributed in the hope that it will be useful,
	    but WITHOUT ANY WARRANTY; without even the implied warranty of
	    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	    GNU Lesser General Public License for more details.
	
	    You should have received a copy of the GNU Lesser General Public License
	    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	*/
	/**
	 * @file index.js
	 * @author Fabian Vogelsteller <fabian@ethereum.org>
	 * @date 2017
	 */
	
	"use strict";
	
	
	var requestManager = __webpack_require__(749);
	var extend = __webpack_require__(752);
	
	module.exports = {
	    packageInit: function (pkg, args) {
	        args = Array.prototype.slice.call(args);
	
	        if (!pkg) {
	            throw new Error('You need to instantiate using the "new" keyword.');
	        }
	
	
	        // make property of pkg._provider, which can properly set providers
	        Object.defineProperty(pkg, 'currentProvider', {
	            get: function () {
	                return pkg._provider;
	            },
	            set: function (value) {
	                return pkg.setProvider(value);
	            },
	            enumerable: true,
	            configurable: true
	        });
	
	        // inherit from web3 umbrella package
	        if (args[0] && args[0]._requestManager) {
	            pkg._requestManager = new requestManager.Manager(args[0].currentProvider);
	
	        // set requestmanager on package
	        } else {
	            pkg._requestManager = new requestManager.Manager();
	            pkg._requestManager.setProvider(args[0], args[1]);
	        }
	
	        // add givenProvider
	        pkg.givenProvider = requestManager.Manager.givenProvider;
	        pkg.providers = requestManager.Manager.providers;
	
	         pkg._provider =  pkg._requestManager.provider;
	
	        // add SETPROVIDER function (don't overwrite if already existing)
	        if (!pkg.setProvider) {
	            pkg.setProvider = function (provider, net) {
	                pkg._requestManager.setProvider(provider, net);
	                pkg._provider = pkg._requestManager.provider;
	                return true;
	            };
	        }
	
	        // attach batch request creation
	        pkg.BatchRequest = requestManager.BatchManager.bind(null, pkg._requestManager);
	
	        // attach extend function
	        pkg.extend = extend(pkg);
	    },
	    addProviders: function (pkg) {
	        pkg.givenProvider = requestManager.Manager.givenProvider;
	        pkg.providers = requestManager.Manager.providers;
	    }
	};
	


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var f = __webpack_require__(29);
	var SolidityParam = __webpack_require__(317);
	
	/**
	 * SolidityType prototype is used to encode/decode solidity params of certain type
	 */
	var SolidityType = function (config) {
	    this._inputFormatter = config.inputFormatter;
	    this._outputFormatter = config.outputFormatter;
	};
	
	/**
	 * Should be used to determine if this SolidityType do match given name
	 *
	 * @method isType
	 * @param {String} name
	 * @return {Bool} true if type match this SolidityType, otherwise false
	 */
	SolidityType.prototype.isType = function (name) {
	    throw "This method should be overwritten for type " + name;
	};
	
	/**
	 * Should be used to determine what is the length of static part in given type
	 *
	 * @method staticPartLength
	 * @param {String} name
	 * @return {Number} length of static part in bytes
	 */
	SolidityType.prototype.staticPartLength = function (name) {
	    // If name isn't an array then treat it like a single element array.
	    return (this.nestedTypes(name) || ['[1]'])
	        .map(function (type) {
	            // the length of the nested array
	            return parseInt(type.slice(1, -1), 10) || 1;
	        })
	        .reduce(function (previous, current) {
	            return previous * current;
	        // all basic types are 32 bytes long
	        }, 32);
	};
	
	/**
	 * Should be used to determine if type is dynamic array
	 * eg:
	 * "type[]" => true
	 * "type[4]" => false
	 *
	 * @method isDynamicArray
	 * @param {String} name
	 * @return {Bool} true if the type is dynamic array
	 */
	SolidityType.prototype.isDynamicArray = function (name) {
	    var nestedTypes = this.nestedTypes(name);
	    return !!nestedTypes && !nestedTypes[nestedTypes.length - 1].match(/[0-9]{1,}/g);
	};
	
	/**
	 * Should be used to determine if type is static array
	 * eg:
	 * "type[]" => false
	 * "type[4]" => true
	 *
	 * @method isStaticArray
	 * @param {String} name
	 * @return {Bool} true if the type is static array
	 */
	SolidityType.prototype.isStaticArray = function (name) {
	    var nestedTypes = this.nestedTypes(name);
	    return !!nestedTypes && !!nestedTypes[nestedTypes.length - 1].match(/[0-9]{1,}/g);
	};
	
	/**
	 * Should return length of static array
	 * eg.
	 * "int[32]" => 32
	 * "int256[14]" => 14
	 * "int[2][3]" => 3
	 * "int" => 1
	 * "int[1]" => 1
	 * "int[]" => 1
	 *
	 * @method staticArrayLength
	 * @param {String} name
	 * @return {Number} static array length
	 */
	SolidityType.prototype.staticArrayLength = function (name) {
	    var nestedTypes = this.nestedTypes(name);
	    if (nestedTypes) {
	       return parseInt(nestedTypes[nestedTypes.length - 1].match(/[0-9]{1,}/g) || 1);
	    }
	    return 1;
	};
	
	/**
	 * Should return nested type
	 * eg.
	 * "int[32]" => "int"
	 * "int256[14]" => "int256"
	 * "int[2][3]" => "int[2]"
	 * "int" => "int"
	 * "int[]" => "int"
	 *
	 * @method nestedName
	 * @param {String} name
	 * @return {String} nested name
	 */
	SolidityType.prototype.nestedName = function (name) {
	    // remove last [] in name
	    var nestedTypes = this.nestedTypes(name);
	    if (!nestedTypes) {
	        return name;
	    }
	
	    return name.substr(0, name.length - nestedTypes[nestedTypes.length - 1].length);
	};
	
	/**
	 * Should return true if type has dynamic size by default
	 * such types are "string", "bytes"
	 *
	 * @method isDynamicType
	 * @param {String} name
	 * @return {Bool} true if is dynamic, otherwise false
	 */
	SolidityType.prototype.isDynamicType = function () {
	    return false;
	};
	
	/**
	 * Should return array of nested types
	 * eg.
	 * "int[2][3][]" => ["[2]", "[3]", "[]"]
	 * "int[] => ["[]"]
	 * "int" => null
	 *
	 * @method nestedTypes
	 * @param {String} name
	 * @return {Array} array of nested types
	 */
	SolidityType.prototype.nestedTypes = function (name) {
	    // return list of strings eg. "[]", "[3]", "[]", "[2]"
	    return name.match(/(\[[0-9]*\])/g);
	};
	
	/**
	 * Should be used to encode the value
	 *
	 * @method encode
	 * @param {Object} value
	 * @param {String} name
	 * @return {String} encoded value
	 */
	SolidityType.prototype.encode = function (value, name) {
	    var self = this;
	    if (this.isDynamicArray(name)) {
	
	        return (function () {
	            var length = value.length;                          // in int
	            var nestedName = self.nestedName(name);
	
	            var result = [];
	            result.push(f.formatInputInt(length).encode());
	
	            value.forEach(function (v) {
	                result.push(self.encode(v, nestedName));
	            });
	
	            return result;
	        })();
	
	    } else if (this.isStaticArray(name)) {
	
	        return (function () {
	            var length = self.staticArrayLength(name);          // in int
	            var nestedName = self.nestedName(name);
	
	            var result = [];
	            for (var i = 0; i < length; i++) {
	                result.push(self.encode(value[i], nestedName));
	            }
	
	            return result;
	        })();
	
	    }
	
	    return this._inputFormatter(value, name).encode();
	};
	
	/**
	 * Should be used to decode value from bytes
	 *
	 * @method decode
	 * @param {String} bytes
	 * @param {Number} offset in bytes
	 * @param {String} name type name
	 * @returns {Object} decoded value
	 */
	SolidityType.prototype.decode = function (bytes, offset, name) {
	    var self = this;
	
	    if (this.isDynamicArray(name)) {
	
	        return (function () {
	            var arrayOffset = parseInt('0x' + bytes.substr(offset * 2, 64)); // in bytes
	            var length = parseInt('0x' + bytes.substr(arrayOffset * 2, 64)); // in int
	            var arrayStart = arrayOffset + 32; // array starts after length; // in bytes
	
	            var nestedName = self.nestedName(name);
	            var nestedStaticPartLength = self.staticPartLength(nestedName);  // in bytes
	            var roundedNestedStaticPartLength = Math.floor((nestedStaticPartLength + 31) / 32) * 32;
	            var result = [];
	
	            for (var i = 0; i < length * roundedNestedStaticPartLength; i += roundedNestedStaticPartLength) {
	                result.push(self.decode(bytes, arrayStart + i, nestedName));
	            }
	
	            return result;
	        })();
	
	    } else if (this.isStaticArray(name)) {
	
	        return (function () {
	            var length = self.staticArrayLength(name);                      // in int
	            var arrayStart = offset;                                        // in bytes
	
	            var nestedName = self.nestedName(name);
	            var nestedStaticPartLength = self.staticPartLength(nestedName); // in bytes
	            var roundedNestedStaticPartLength = Math.floor((nestedStaticPartLength + 31) / 32) * 32;
	            var result = [];
	
	            for (var i = 0; i < length * roundedNestedStaticPartLength; i += roundedNestedStaticPartLength) {
	                result.push(self.decode(bytes, arrayStart + i, nestedName));
	            }
	
	            return result;
	        })();
	    } else if (this.isDynamicType(name)) {
	
	        return (function () {
	            var dynamicOffset = parseInt('0x' + bytes.substr(offset * 2, 64));      // in bytes
	            var length = parseInt('0x' + bytes.substr(dynamicOffset * 2, 64));      // in bytes
	            var roundedLength = Math.floor((length + 31) / 32);                     // in int
	            var param = new SolidityParam(bytes.substr(dynamicOffset * 2, ( 1 + roundedLength) * 64), 0, bytes);
	            return self._outputFormatter(param, name);
	        })();
	    }
	
	    var length = this.staticPartLength(name);
	    var param = new SolidityParam(bytes.substr(offset * 2, length * 2), undefined, bytes);
	    return this._outputFormatter(param, name);
	};
	
	module.exports = SolidityType;


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(405);
	var defined = __webpack_require__(112);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.UNDEFINED_INPUT_ERROR = exports.INVALID_BUFFER = exports.isEnd = exports.END = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.emitter = emitter;
	exports.channel = channel;
	exports.eventChannel = eventChannel;
	exports.stdChannel = stdChannel;
	
	var _utils = /*#__PURE__*/__webpack_require__(24);
	
	var _buffers = /*#__PURE__*/__webpack_require__(91);
	
	var _scheduler = /*#__PURE__*/__webpack_require__(221);
	
	var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
	var END = exports.END = { type: CHANNEL_END_TYPE };
	var isEnd = exports.isEnd = function isEnd(a) {
	  return a && a.type === CHANNEL_END_TYPE;
	};
	
	function emitter() {
	  var subscribers = [];
	
	  function subscribe(sub) {
	    subscribers.push(sub);
	    return function () {
	      return (0, _utils.remove)(subscribers, sub);
	    };
	  }
	
	  function emit(item) {
	    var arr = subscribers.slice();
	    for (var i = 0, len = arr.length; i < len; i++) {
	      arr[i](item);
	    }
	  }
	
	  return {
	    subscribe: subscribe,
	    emit: emit
	  };
	}
	
	var INVALID_BUFFER = exports.INVALID_BUFFER = 'invalid buffer passed to channel factory function';
	var UNDEFINED_INPUT_ERROR = exports.UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';
	
	if (false) {
	  exports.UNDEFINED_INPUT_ERROR = UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
	}
	
	function channel() {
	  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _buffers.buffers.fixed();
	
	  var closed = false;
	  var takers = [];
	
	  (0, _utils.check)(buffer, _utils.is.buffer, INVALID_BUFFER);
	
	  function checkForbiddenStates() {
	    if (closed && takers.length) {
	      throw (0, _utils.internalErr)('Cannot have a closed channel with pending takers');
	    }
	    if (takers.length && !buffer.isEmpty()) {
	      throw (0, _utils.internalErr)('Cannot have pending takers with non empty buffer');
	    }
	  }
	
	  function put(input) {
	    checkForbiddenStates();
	    (0, _utils.check)(input, _utils.is.notUndef, UNDEFINED_INPUT_ERROR);
	    if (closed) {
	      return;
	    }
	    if (!takers.length) {
	      return buffer.put(input);
	    }
	    for (var i = 0; i < takers.length; i++) {
	      var cb = takers[i];
	      if (!cb[_utils.MATCH] || cb[_utils.MATCH](input)) {
	        takers.splice(i, 1);
	        return cb(input);
	      }
	    }
	  }
	
	  function take(cb) {
	    checkForbiddenStates();
	    (0, _utils.check)(cb, _utils.is.func, "channel.take's callback must be a function");
	
	    if (closed && buffer.isEmpty()) {
	      cb(END);
	    } else if (!buffer.isEmpty()) {
	      cb(buffer.take());
	    } else {
	      takers.push(cb);
	      cb.cancel = function () {
	        return (0, _utils.remove)(takers, cb);
	      };
	    }
	  }
	
	  function flush(cb) {
	    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
	    (0, _utils.check)(cb, _utils.is.func, "channel.flush' callback must be a function");
	    if (closed && buffer.isEmpty()) {
	      cb(END);
	      return;
	    }
	    cb(buffer.flush());
	  }
	
	  function close() {
	    checkForbiddenStates();
	    if (!closed) {
	      closed = true;
	      if (takers.length) {
	        var arr = takers;
	        takers = [];
	        for (var i = 0, len = arr.length; i < len; i++) {
	          arr[i](END);
	        }
	      }
	    }
	  }
	
	  return {
	    take: take,
	    put: put,
	    flush: flush,
	    close: close,
	    get __takers__() {
	      return takers;
	    },
	    get __closed__() {
	      return closed;
	    }
	  };
	}
	
	function eventChannel(subscribe) {
	  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _buffers.buffers.none();
	  var matcher = arguments[2];
	
	  /**
	    should be if(typeof matcher !== undefined) instead?
	    see PR #273 for a background discussion
	  **/
	  if (arguments.length > 2) {
	    (0, _utils.check)(matcher, _utils.is.func, 'Invalid match function passed to eventChannel');
	  }
	
	  var chan = channel(buffer);
	  var close = function close() {
	    if (!chan.__closed__) {
	      if (unsubscribe) {
	        unsubscribe();
	      }
	      chan.close();
	    }
	  };
	  var unsubscribe = subscribe(function (input) {
	    if (isEnd(input)) {
	      close();
	      return;
	    }
	    if (matcher && !matcher(input)) {
	      return;
	    }
	    chan.put(input);
	  });
	  if (chan.__closed__) {
	    unsubscribe();
	  }
	
	  if (!_utils.is.func(unsubscribe)) {
	    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
	  }
	
	  return {
	    take: chan.take,
	    flush: chan.flush,
	    close: close
	  };
	}
	
	function stdChannel(subscribe) {
	  var chan = eventChannel(function (cb) {
	    return subscribe(function (input) {
	      if (input[_utils.SAGA_ACTION]) {
	        cb(input);
	        return;
	      }
	      (0, _scheduler.asap)(function () {
	        return cb(input);
	      });
	    });
	  });
	
	  return _extends({}, chan, {
	    take: function take(cb, matcher) {
	      if (arguments.length > 1) {
	        (0, _utils.check)(matcher, _utils.is.func, "channel.take's matcher argument must be a function");
	        cb[_utils.MATCH] = matcher;
	      }
	      chan.take(cb);
	    }
	  });
	}

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(42);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(40);
	
	var _Actions = __webpack_require__(96);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {'use strict'
	
	function oldBrowser () {
	  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
	}
	
	var Buffer = __webpack_require__(4).Buffer
	var crypto = global.crypto || global.msCrypto
	
	if (crypto && crypto.getRandomValues) {
	  module.exports = randomBytes
	} else {
	  module.exports = oldBrowser
	}
	
	function randomBytes (size, cb) {
	  // phantomjs needs to throw
	  if (size > 65536) throw new Error('requested too many random bytes')
	  // in case browserify  isn't using the Uint8Array version
	  var rawBytes = new global.Uint8Array(size)
	
	  // This will not work in older browsers.
	  // See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
	  if (size > 0) {  // getRandomValues fails on IE if size == 0
	    crypto.getRandomValues(rawBytes)
	  }
	
	  // XXX: phantomjs doesn't like a buffer being passed here
	  var bytes = Buffer.from(rawBytes.buffer)
	
	  if (typeof cb === 'function') {
	    return process.nextTick(function () {
	      cb(null, bytes)
	    })
	  }
	
	  return bytes
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(22)))

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(144);
	var setInnerHTML = __webpack_require__(106);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(152);
	var setTextContent = __webpack_require__(278);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(3);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(647);
	var ReactInstrumentation = __webpack_require__(25);
	
	var warning = __webpack_require__(5);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(42);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(164);
	
	var ReactBaseClasses = __webpack_require__(291);
	var ReactChildren = __webpack_require__(694);
	var ReactDOMFactories = __webpack_require__(695);
	var ReactElement = __webpack_require__(61);
	var ReactPropTypes = __webpack_require__(696);
	var ReactVersion = __webpack_require__(697);
	
	var createReactClass = __webpack_require__(698);
	var onlyChild = __webpack_require__(702);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(164);
	
	var ReactCurrentOwner = __webpack_require__(34);
	
	var warning = __webpack_require__(5);
	var canDefineProperty = __webpack_require__(295);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(293);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.UNDEFINED_INPUT_ERROR = exports.INVALID_BUFFER = exports.isEnd = exports.END = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.emitter = emitter;
	exports.channel = channel;
	exports.eventChannel = eventChannel;
	exports.stdChannel = stdChannel;
	
	var _utils = __webpack_require__(26);
	
	var _buffers = __webpack_require__(107);
	
	var _scheduler = __webpack_require__(304);
	
	var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
	var END = exports.END = { type: CHANNEL_END_TYPE };
	var isEnd = exports.isEnd = function isEnd(a) {
	  return a && a.type === CHANNEL_END_TYPE;
	};
	
	function emitter() {
	  var subscribers = [];
	
	  function subscribe(sub) {
	    subscribers.push(sub);
	    return function () {
	      return (0, _utils.remove)(subscribers, sub);
	    };
	  }
	
	  function emit(item) {
	    var arr = subscribers.slice();
	    for (var i = 0, len = arr.length; i < len; i++) {
	      arr[i](item);
	    }
	  }
	
	  return {
	    subscribe: subscribe,
	    emit: emit
	  };
	}
	
	var INVALID_BUFFER = exports.INVALID_BUFFER = 'invalid buffer passed to channel factory function';
	var UNDEFINED_INPUT_ERROR = exports.UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';
	
	if (false) {
	  exports.UNDEFINED_INPUT_ERROR = UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
	}
	
	function channel() {
	  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _buffers.buffers.fixed();
	
	  var closed = false;
	  var takers = [];
	
	  (0, _utils.check)(buffer, _utils.is.buffer, INVALID_BUFFER);
	
	  function checkForbiddenStates() {
	    if (closed && takers.length) {
	      throw (0, _utils.internalErr)('Cannot have a closed channel with pending takers');
	    }
	    if (takers.length && !buffer.isEmpty()) {
	      throw (0, _utils.internalErr)('Cannot have pending takers with non empty buffer');
	    }
	  }
	
	  function put(input) {
	    checkForbiddenStates();
	    (0, _utils.check)(input, _utils.is.notUndef, UNDEFINED_INPUT_ERROR);
	    if (closed) {
	      return;
	    }
	    if (!takers.length) {
	      return buffer.put(input);
	    }
	    for (var i = 0; i < takers.length; i++) {
	      var cb = takers[i];
	      if (!cb[_utils.MATCH] || cb[_utils.MATCH](input)) {
	        takers.splice(i, 1);
	        return cb(input);
	      }
	    }
	  }
	
	  function take(cb) {
	    checkForbiddenStates();
	    (0, _utils.check)(cb, _utils.is.func, "channel.take's callback must be a function");
	
	    if (closed && buffer.isEmpty()) {
	      cb(END);
	    } else if (!buffer.isEmpty()) {
	      cb(buffer.take());
	    } else {
	      takers.push(cb);
	      cb.cancel = function () {
	        return (0, _utils.remove)(takers, cb);
	      };
	    }
	  }
	
	  function flush(cb) {
	    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
	    (0, _utils.check)(cb, _utils.is.func, "channel.flush' callback must be a function");
	    if (closed && buffer.isEmpty()) {
	      cb(END);
	      return;
	    }
	    cb(buffer.flush());
	  }
	
	  function close() {
	    checkForbiddenStates();
	    if (!closed) {
	      closed = true;
	      if (takers.length) {
	        var arr = takers;
	        takers = [];
	        for (var i = 0, len = arr.length; i < len; i++) {
	          arr[i](END);
	        }
	      }
	    }
	  }
	
	  return {
	    take: take,
	    put: put,
	    flush: flush,
	    close: close,
	    get __takers__() {
	      return takers;
	    },
	    get __closed__() {
	      return closed;
	    }
	  };
	}
	
	function eventChannel(subscribe) {
	  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _buffers.buffers.none();
	  var matcher = arguments[2];
	
	  /**
	    should be if(typeof matcher !== undefined) instead?
	    see PR #273 for a background discussion
	  **/
	  if (arguments.length > 2) {
	    (0, _utils.check)(matcher, _utils.is.func, 'Invalid match function passed to eventChannel');
	  }
	
	  var chan = channel(buffer);
	  var close = function close() {
	    if (!chan.__closed__) {
	      if (unsubscribe) {
	        unsubscribe();
	      }
	      chan.close();
	    }
	  };
	  var unsubscribe = subscribe(function (input) {
	    if (isEnd(input)) {
	      close();
	      return;
	    }
	    if (matcher && !matcher(input)) {
	      return;
	    }
	    chan.put(input);
	  });
	  if (chan.__closed__) {
	    unsubscribe();
	  }
	
	  if (!_utils.is.func(unsubscribe)) {
	    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
	  }
	
	  return {
	    take: chan.take,
	    flush: chan.flush,
	    close: close
	  };
	}
	
	function stdChannel(subscribe) {
	  var chan = eventChannel(function (cb) {
	    return subscribe(function (input) {
	      if (input[_utils.SAGA_ACTION]) {
	        cb(input);
	        return;
	      }
	      (0, _scheduler.asap)(function () {
	        return cb(input);
	      });
	    });
	  });
	
	  return _extends({}, chan, {
	    take: function take(cb, matcher) {
	      if (arguments.length > 1) {
	        (0, _utils.check)(matcher, _utils.is.func, "channel.take's matcher argument must be a function");
	        cb[_utils.MATCH] = matcher;
	      }
	      chan.take(cb);
	    }
	  });
	}

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.asEffect = exports.takem = undefined;
	exports.take = take;
	exports.put = put;
	exports.all = all;
	exports.race = race;
	exports.call = call;
	exports.apply = apply;
	exports.cps = cps;
	exports.fork = fork;
	exports.spawn = spawn;
	exports.join = join;
	exports.cancel = cancel;
	exports.select = select;
	exports.actionChannel = actionChannel;
	exports.cancelled = cancelled;
	exports.flush = flush;
	exports.getContext = getContext;
	exports.setContext = setContext;
	exports.takeEvery = takeEvery;
	exports.takeLatest = takeLatest;
	exports.throttle = throttle;
	
	var _utils = __webpack_require__(26);
	
	var _sagaHelpers = __webpack_require__(303);
	
	var IO = (0, _utils.sym)('IO');
	var TAKE = 'TAKE';
	var PUT = 'PUT';
	var ALL = 'ALL';
	var RACE = 'RACE';
	var CALL = 'CALL';
	var CPS = 'CPS';
	var FORK = 'FORK';
	var JOIN = 'JOIN';
	var CANCEL = 'CANCEL';
	var SELECT = 'SELECT';
	var ACTION_CHANNEL = 'ACTION_CHANNEL';
	var CANCELLED = 'CANCELLED';
	var FLUSH = 'FLUSH';
	var GET_CONTEXT = 'GET_CONTEXT';
	var SET_CONTEXT = 'SET_CONTEXT';
	
	var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';
	
	var effect = function effect(type, payload) {
	  var _ref;
	
	  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
	};
	
	function take() {
	  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';
	
	  if (arguments.length) {
	    (0, _utils.check)(arguments[0], _utils.is.notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
	  }
	  if (_utils.is.pattern(patternOrChannel)) {
	    return effect(TAKE, { pattern: patternOrChannel });
	  }
	  if (_utils.is.channel(patternOrChannel)) {
	    return effect(TAKE, { channel: patternOrChannel });
	  }
	  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
	}
	
	take.maybe = function () {
	  var eff = take.apply(undefined, arguments);
	  eff[TAKE].maybe = true;
	  return eff;
	};
	
	var takem = /*#__PURE__*/exports.takem = (0, _utils.deprecate)(take.maybe, /*#__PURE__*/(0, _utils.updateIncentive)('takem', 'take.maybe'));
	
	function put(channel, action) {
	  if (arguments.length > 1) {
	    (0, _utils.check)(channel, _utils.is.notUndef, 'put(channel, action): argument channel is undefined');
	    (0, _utils.check)(channel, _utils.is.channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
	    (0, _utils.check)(action, _utils.is.notUndef, 'put(channel, action): argument action is undefined');
	  } else {
	    (0, _utils.check)(channel, _utils.is.notUndef, 'put(action): argument action is undefined');
	    action = channel;
	    channel = null;
	  }
	  return effect(PUT, { channel: channel, action: action });
	}
	
	put.resolve = function () {
	  var eff = put.apply(undefined, arguments);
	  eff[PUT].resolve = true;
	  return eff;
	};
	
	put.sync = (0, _utils.deprecate)(put.resolve, (0, _utils.updateIncentive)('put.sync', 'put.resolve'));
	
	function all(effects) {
	  return effect(ALL, effects);
	}
	
	function race(effects) {
	  return effect(RACE, effects);
	}
	
	function getFnCallDesc(meth, fn, args) {
	  (0, _utils.check)(fn, _utils.is.notUndef, meth + ': argument fn is undefined');
	
	  var context = null;
	  if (_utils.is.array(fn)) {
	    var _fn = fn;
	    context = _fn[0];
	    fn = _fn[1];
	  } else if (fn.fn) {
	    var _fn2 = fn;
	    context = _fn2.context;
	    fn = _fn2.fn;
	  }
	  if (context && _utils.is.string(fn) && _utils.is.func(context[fn])) {
	    fn = context[fn];
	  }
	  (0, _utils.check)(fn, _utils.is.func, meth + ': argument ' + fn + ' is not a function');
	
	  return { context: context, fn: fn, args: args };
	}
	
	function call(fn) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return effect(CALL, getFnCallDesc('call', fn, args));
	}
	
	function apply(context, fn) {
	  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
	}
	
	function cps(fn) {
	  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    args[_key2 - 1] = arguments[_key2];
	  }
	
	  return effect(CPS, getFnCallDesc('cps', fn, args));
	}
	
	function fork(fn) {
	  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    args[_key3 - 1] = arguments[_key3];
	  }
	
	  return effect(FORK, getFnCallDesc('fork', fn, args));
	}
	
	function spawn(fn) {
	  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    args[_key4 - 1] = arguments[_key4];
	  }
	
	  var eff = fork.apply(undefined, [fn].concat(args));
	  eff[FORK].detached = true;
	  return eff;
	}
	
	function join() {
	  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	    tasks[_key5] = arguments[_key5];
	  }
	
	  if (tasks.length > 1) {
	    return all(tasks.map(function (t) {
	      return join(t);
	    }));
	  }
	  var task = tasks[0];
	  (0, _utils.check)(task, _utils.is.notUndef, 'join(task): argument task is undefined');
	  (0, _utils.check)(task, _utils.is.task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
	  return effect(JOIN, task);
	}
	
	function cancel() {
	  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	    tasks[_key6] = arguments[_key6];
	  }
	
	  if (tasks.length > 1) {
	    return all(tasks.map(function (t) {
	      return cancel(t);
	    }));
	  }
	  var task = tasks[0];
	  if (tasks.length === 1) {
	    (0, _utils.check)(task, _utils.is.notUndef, 'cancel(task): argument task is undefined');
	    (0, _utils.check)(task, _utils.is.task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
	  }
	  return effect(CANCEL, task || _utils.SELF_CANCELLATION);
	}
	
	function select(selector) {
	  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
	    args[_key7 - 1] = arguments[_key7];
	  }
	
	  if (arguments.length === 0) {
	    selector = _utils.ident;
	  } else {
	    (0, _utils.check)(selector, _utils.is.notUndef, 'select(selector,[...]): argument selector is undefined');
	    (0, _utils.check)(selector, _utils.is.func, 'select(selector,[...]): argument ' + selector + ' is not a function');
	  }
	  return effect(SELECT, { selector: selector, args: args });
	}
	
	/**
	  channel(pattern, [buffer])    => creates an event channel for store actions
	**/
	function actionChannel(pattern, buffer) {
	  (0, _utils.check)(pattern, _utils.is.notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
	  if (arguments.length > 1) {
	    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
	    (0, _utils.check)(buffer, _utils.is.buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
	  }
	  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
	}
	
	function cancelled() {
	  return effect(CANCELLED, {});
	}
	
	function flush(channel) {
	  (0, _utils.check)(channel, _utils.is.channel, 'flush(channel): argument ' + channel + ' is not valid channel');
	  return effect(FLUSH, channel);
	}
	
	function getContext(prop) {
	  (0, _utils.check)(prop, _utils.is.string, 'getContext(prop): argument ' + prop + ' is not a string');
	  return effect(GET_CONTEXT, prop);
	}
	
	function setContext(props) {
	  (0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)(null, props));
	  return effect(SET_CONTEXT, props);
	}
	
	function takeEvery(patternOrChannel, worker) {
	  for (var _len8 = arguments.length, args = Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
	    args[_key8 - 2] = arguments[_key8];
	  }
	
	  return fork.apply(undefined, [_sagaHelpers.takeEveryHelper, patternOrChannel, worker].concat(args));
	}
	
	function takeLatest(patternOrChannel, worker) {
	  for (var _len9 = arguments.length, args = Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
	    args[_key9 - 2] = arguments[_key9];
	  }
	
	  return fork.apply(undefined, [_sagaHelpers.takeLatestHelper, patternOrChannel, worker].concat(args));
	}
	
	function throttle(ms, pattern, worker) {
	  for (var _len10 = arguments.length, args = Array(_len10 > 3 ? _len10 - 3 : 0), _key10 = 3; _key10 < _len10; _key10++) {
	    args[_key10 - 3] = arguments[_key10];
	  }
	
	  return fork.apply(undefined, [_sagaHelpers.throttleHelper, ms, pattern, worker].concat(args));
	}
	
	var createAsEffectType = function createAsEffectType(type) {
	  return function (effect) {
	    return effect && effect[IO] && effect[type];
	  };
	};
	
	var asEffect = exports.asEffect = {
	  take: createAsEffectType(TAKE),
	  put: createAsEffectType(PUT),
	  all: createAsEffectType(ALL),
	  race: createAsEffectType(RACE),
	  call: createAsEffectType(CALL),
	  cps: createAsEffectType(CPS),
	  fork: createAsEffectType(FORK),
	  join: createAsEffectType(JOIN),
	  cancel: createAsEffectType(CANCEL),
	  select: createAsEffectType(SELECT),
	  actionChannel: createAsEffectType(ACTION_CHANNEL),
	  cancelled: createAsEffectType(CANCELLED),
	  flush: createAsEffectType(FLUSH),
	  getContext: createAsEffectType(GET_CONTEXT),
	  setContext: createAsEffectType(SET_CONTEXT)
	};

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var Buffer = __webpack_require__(4).Buffer
	
	// prototype class for hash functions
	function Hash (blockSize, finalSize) {
	  this._block = Buffer.alloc(blockSize)
	  this._finalSize = finalSize
	  this._blockSize = blockSize
	  this._len = 0
	}
	
	Hash.prototype.update = function (data, enc) {
	  if (typeof data === 'string') {
	    enc = enc || 'utf8'
	    data = Buffer.from(data, enc)
	  }
	
	  var block = this._block
	  var blockSize = this._blockSize
	  var length = data.length
	  var accum = this._len
	
	  for (var offset = 0; offset < length;) {
	    var assigned = accum % blockSize
	    var remainder = Math.min(length - offset, blockSize - assigned)
	
	    for (var i = 0; i < remainder; i++) {
	      block[assigned + i] = data[offset + i]
	    }
	
	    accum += remainder
	    offset += remainder
	
	    if ((accum % blockSize) === 0) {
	      this._update(block)
	    }
	  }
	
	  this._len += length
	  return this
	}
	
	Hash.prototype.digest = function (enc) {
	  var rem = this._len % this._blockSize
	
	  this._block[rem] = 0x80
	
	  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	  this._block.fill(0, rem + 1)
	
	  if (rem >= this._finalSize) {
	    this._update(this._block)
	    this._block.fill(0)
	  }
	
	  var bits = this._len * 8
	
	  // uint32
	  if (bits <= 0xffffffff) {
	    this._block.writeUInt32BE(bits, this._blockSize - 4)
	
	  // uint64
	  } else {
	    var lowBits = (bits & 0xffffffff) >>> 0
	    var highBits = (bits - lowBits) / 0x100000000
	
	    this._block.writeUInt32BE(highBits, this._blockSize - 8)
	    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
	  }
	
	  this._update(this._block)
	  var hash = this._hash()
	
	  return enc ? hash.toString(enc) : hash
	}
	
	Hash.prototype._update = function () {
	  throw new Error('_update must be implemented by subclass')
	}
	
	module.exports = Hash


/***/ },
/* 65 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var asn1 = exports;
	
	asn1.bignum = __webpack_require__(7);
	
	asn1.define = __webpack_require__(330).define;
	asn1.base = __webpack_require__(67);
	asn1.constants = __webpack_require__(175);
	asn1.decoders = __webpack_require__(334);
	asn1.encoders = __webpack_require__(336);


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var base = exports;
	
	base.Reporter = __webpack_require__(332).Reporter;
	base.DecoderBuffer = __webpack_require__(174).DecoderBuffer;
	base.EncoderBuffer = __webpack_require__(174).EncoderBuffer;
	base.Node = __webpack_require__(331);


/***/ },
/* 68 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(83);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 70 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 71 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function xor (a, b) {
	  var length = Math.min(a.length, b.length)
	  var buffer = new Buffer(length)
	
	  for (var i = 0; i < length; ++i) {
	    buffer[i] = a[i] ^ b[i]
	  }
	
	  return buffer
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict'
	var inherits = __webpack_require__(2)
	var md5 = __webpack_require__(128)
	var RIPEMD160 = __webpack_require__(169)
	var sha = __webpack_require__(170)
	
	var Base = __webpack_require__(38)
	
	function HashNoConstructor (hash) {
	  Base.call(this, 'digest')
	
	  this._hash = hash
	  this.buffers = []
	}
	
	inherits(HashNoConstructor, Base)
	
	HashNoConstructor.prototype._update = function (data) {
	  this.buffers.push(data)
	}
	
	HashNoConstructor.prototype._final = function () {
	  var buf = Buffer.concat(this.buffers)
	  var r = this._hash(buf)
	  this.buffers = null
	
	  return r
	}
	
	function Hash (hash) {
	  Base.call(this, 'digest')
	
	  this._hash = hash
	}
	
	inherits(Hash, Base)
	
	Hash.prototype._update = function (data) {
	  this._hash.update(data)
	}
	
	Hash.prototype._final = function () {
	  return this._hash.digest()
	}
	
	module.exports = function createHash (alg) {
	  alg = alg.toLowerCase()
	  if (alg === 'md5') return new HashNoConstructor(md5)
	  if (alg === 'rmd160' || alg === 'ripemd160') return new Hash(new RIPEMD160())
	
	  return new Hash(sha(alg))
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(27);
	var assert = __webpack_require__(21);
	
	function BlockHash() {
	  this.pending = null;
	  this.pendingTotal = 0;
	  this.blockSize = this.constructor.blockSize;
	  this.outSize = this.constructor.outSize;
	  this.hmacStrength = this.constructor.hmacStrength;
	  this.padLength = this.constructor.padLength / 8;
	  this.endian = 'big';
	
	  this._delta8 = this.blockSize / 8;
	  this._delta32 = this.blockSize / 32;
	}
	exports.BlockHash = BlockHash;
	
	BlockHash.prototype.update = function update(msg, enc) {
	  // Convert message to array, pad it, and join into 32bit blocks
	  msg = utils.toArray(msg, enc);
	  if (!this.pending)
	    this.pending = msg;
	  else
	    this.pending = this.pending.concat(msg);
	  this.pendingTotal += msg.length;
	
	  // Enough data, try updating
	  if (this.pending.length >= this._delta8) {
	    msg = this.pending;
	
	    // Process pending data in blocks
	    var r = msg.length % this._delta8;
	    this.pending = msg.slice(msg.length - r, msg.length);
	    if (this.pending.length === 0)
	      this.pending = null;
	
	    msg = utils.join32(msg, 0, msg.length - r, this.endian);
	    for (var i = 0; i < msg.length; i += this._delta32)
	      this._update(msg, i, i + this._delta32);
	  }
	
	  return this;
	};
	
	BlockHash.prototype.digest = function digest(enc) {
	  this.update(this._pad());
	  assert(this.pending === null);
	
	  return this._digest(enc);
	};
	
	BlockHash.prototype._pad = function pad() {
	  var len = this.pendingTotal;
	  var bytes = this._delta8;
	  var k = bytes - ((len + this.padLength) % bytes);
	  var res = new Array(k + this.padLength);
	  res[0] = 0x80;
	  for (var i = 1; i < k; i++)
	    res[i] = 0;
	
	  // Append length
	  len <<= 3;
	  if (this.endian === 'big') {
	    for (var t = 8; t < this.padLength; t++)
	      res[i++] = 0;
	
	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = (len >>> 24) & 0xff;
	    res[i++] = (len >>> 16) & 0xff;
	    res[i++] = (len >>> 8) & 0xff;
	    res[i++] = len & 0xff;
	  } else {
	    res[i++] = len & 0xff;
	    res[i++] = (len >>> 8) & 0xff;
	    res[i++] = (len >>> 16) & 0xff;
	    res[i++] = (len >>> 24) & 0xff;
	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = 0;
	    res[i++] = 0;
	
	    for (t = 8; t < this.padLength; t++)
	      res[i++] = 0;
	  }
	
	  return res;
	};


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var EventPluginRegistry = __webpack_require__(145);
	var EventPluginUtils = __webpack_require__(146);
	var ReactErrorUtils = __webpack_require__(150);
	
	var accumulateInto = __webpack_require__(271);
	var forEachAccumulated = __webpack_require__(272);
	var invariant = __webpack_require__(3);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(76);
	var EventPluginUtils = __webpack_require__(146);
	
	var accumulateInto = __webpack_require__(271);
	var forEachAccumulated = __webpack_require__(272);
	var warning = __webpack_require__(5);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 78 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(33);
	
	var getEventTarget = __webpack_require__(155);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__(11);
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string]);
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ },
/* 81 */
6,
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(93).EventEmitter;
	var inherits = __webpack_require__(2);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(166);
	Stream.Writable = __webpack_require__(709);
	Stream.Duplex = __webpack_require__(704);
	Stream.Transform = __webpack_require__(708);
	Stream.PassThrough = __webpack_require__(707);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ },
/* 83 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 84 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 85 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(37).f;
	var has = __webpack_require__(43);
	var TAG = __webpack_require__(19)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 87 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	// based on the aes implimentation in triple sec
	// https://github.com/keybase/triplesec
	// which is in turn based on the one from crypto-js
	// https://code.google.com/p/crypto-js/
	
	var Buffer = __webpack_require__(4).Buffer
	
	function asUInt32Array (buf) {
	  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)
	
	  var len = (buf.length / 4) | 0
	  var out = new Array(len)
	
	  for (var i = 0; i < len; i++) {
	    out[i] = buf.readUInt32BE(i * 4)
	  }
	
	  return out
	}
	
	function scrubVec (v) {
	  for (var i = 0; i < v.length; v++) {
	    v[i] = 0
	  }
	}
	
	function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
	  var SUB_MIX0 = SUB_MIX[0]
	  var SUB_MIX1 = SUB_MIX[1]
	  var SUB_MIX2 = SUB_MIX[2]
	  var SUB_MIX3 = SUB_MIX[3]
	
	  var s0 = M[0] ^ keySchedule[0]
	  var s1 = M[1] ^ keySchedule[1]
	  var s2 = M[2] ^ keySchedule[2]
	  var s3 = M[3] ^ keySchedule[3]
	  var t0, t1, t2, t3
	  var ksRow = 4
	
	  for (var round = 1; round < nRounds; round++) {
	    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
	    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
	    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
	    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
	    s0 = t0
	    s1 = t1
	    s2 = t2
	    s3 = t3
	  }
	
	  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
	  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
	  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
	  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
	  t0 = t0 >>> 0
	  t1 = t1 >>> 0
	  t2 = t2 >>> 0
	  t3 = t3 >>> 0
	
	  return [t0, t1, t2, t3]
	}
	
	// AES constants
	var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
	var G = (function () {
	  // Compute double table
	  var d = new Array(256)
	  for (var j = 0; j < 256; j++) {
	    if (j < 128) {
	      d[j] = j << 1
	    } else {
	      d[j] = (j << 1) ^ 0x11b
	    }
	  }
	
	  var SBOX = []
	  var INV_SBOX = []
	  var SUB_MIX = [[], [], [], []]
	  var INV_SUB_MIX = [[], [], [], []]
	
	  // Walk GF(2^8)
	  var x = 0
	  var xi = 0
	  for (var i = 0; i < 256; ++i) {
	    // Compute sbox
	    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
	    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
	    SBOX[x] = sx
	    INV_SBOX[sx] = x
	
	    // Compute multiplication
	    var x2 = d[x]
	    var x4 = d[x2]
	    var x8 = d[x4]
	
	    // Compute sub bytes, mix columns tables
	    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
	    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
	    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
	    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
	    SUB_MIX[3][x] = t
	
	    // Compute inv sub bytes, inv mix columns tables
	    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
	    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
	    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
	    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
	    INV_SUB_MIX[3][sx] = t
	
	    if (x === 0) {
	      x = xi = 1
	    } else {
	      x = x2 ^ d[d[d[x8 ^ x2]]]
	      xi ^= d[d[xi]]
	    }
	  }
	
	  return {
	    SBOX: SBOX,
	    INV_SBOX: INV_SBOX,
	    SUB_MIX: SUB_MIX,
	    INV_SUB_MIX: INV_SUB_MIX
	  }
	})()
	
	function AES (key) {
	  this._key = asUInt32Array(key)
	  this._reset()
	}
	
	AES.blockSize = 4 * 4
	AES.keySize = 256 / 8
	AES.prototype.blockSize = AES.blockSize
	AES.prototype.keySize = AES.keySize
	AES.prototype._reset = function () {
	  var keyWords = this._key
	  var keySize = keyWords.length
	  var nRounds = keySize + 6
	  var ksRows = (nRounds + 1) * 4
	
	  var keySchedule = []
	  for (var k = 0; k < keySize; k++) {
	    keySchedule[k] = keyWords[k]
	  }
	
	  for (k = keySize; k < ksRows; k++) {
	    var t = keySchedule[k - 1]
	
	    if (k % keySize === 0) {
	      t = (t << 8) | (t >>> 24)
	      t =
	        (G.SBOX[t >>> 24] << 24) |
	        (G.SBOX[(t >>> 16) & 0xff] << 16) |
	        (G.SBOX[(t >>> 8) & 0xff] << 8) |
	        (G.SBOX[t & 0xff])
	
	      t ^= RCON[(k / keySize) | 0] << 24
	    } else if (keySize > 6 && k % keySize === 4) {
	      t =
	        (G.SBOX[t >>> 24] << 24) |
	        (G.SBOX[(t >>> 16) & 0xff] << 16) |
	        (G.SBOX[(t >>> 8) & 0xff] << 8) |
	        (G.SBOX[t & 0xff])
	    }
	
	    keySchedule[k] = keySchedule[k - keySize] ^ t
	  }
	
	  var invKeySchedule = []
	  for (var ik = 0; ik < ksRows; ik++) {
	    var ksR = ksRows - ik
	    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]
	
	    if (ik < 4 || ksR <= 4) {
	      invKeySchedule[ik] = tt
	    } else {
	      invKeySchedule[ik] =
	        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
	        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
	        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
	        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
	    }
	  }
	
	  this._nRounds = nRounds
	  this._keySchedule = keySchedule
	  this._invKeySchedule = invKeySchedule
	}
	
	AES.prototype.encryptBlockRaw = function (M) {
	  M = asUInt32Array(M)
	  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
	}
	
	AES.prototype.encryptBlock = function (M) {
	  var out = this.encryptBlockRaw(M)
	  var buf = Buffer.allocUnsafe(16)
	  buf.writeUInt32BE(out[0], 0)
	  buf.writeUInt32BE(out[1], 4)
	  buf.writeUInt32BE(out[2], 8)
	  buf.writeUInt32BE(out[3], 12)
	  return buf
	}
	
	AES.prototype.decryptBlock = function (M) {
	  M = asUInt32Array(M)
	
	  // swap
	  var m1 = M[1]
	  M[1] = M[3]
	  M[3] = m1
	
	  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
	  var buf = Buffer.allocUnsafe(16)
	  buf.writeUInt32BE(out[0], 0)
	  buf.writeUInt32BE(out[3], 4)
	  buf.writeUInt32BE(out[2], 8)
	  buf.writeUInt32BE(out[1], 12)
	  return buf
	}
	
	AES.prototype.scrub = function () {
	  scrubVec(this._keySchedule)
	  scrubVec(this._invKeySchedule)
	  scrubVec(this._key)
	}
	
	module.exports.AES = AES


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = xor;
	function xor(a, b) {
	  var len = Math.min(a.length, b.length);
	  var out = new Buffer(len);
	  var i = -1;
	  while (++i < len) {
	    out.writeUInt8(a[i] ^ b[i], i);
	  }
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(472), __webpack_require__(503), __webpack_require__(551), __webpack_require__(488), __webpack_require__(482), __webpack_require__(775));
		else if(typeof define === 'function' && define.amd)
			define(["deepmerge", "eth-block-tracker-es5", "is-plain-object", "redux", "redux-saga", "web3"], factory);
		else if(typeof exports === 'object')
			exports["drizzle"] = factory(require("deepmerge"), require("eth-block-tracker-es5"), require("is-plain-object"), require("redux"), require("redux-saga"), require("web3"));
		else
			root["drizzle"] = factory(root["deepmerge"], root["eth-block-tracker-es5"], root["is-plain-object"], root["redux"], root["redux-saga"], root["web3"]);
	})(window, function(__WEBPACK_EXTERNAL_MODULE_deepmerge__, __WEBPACK_EXTERNAL_MODULE_eth_block_tracker__, __WEBPACK_EXTERNAL_MODULE_is_plain_object__, __WEBPACK_EXTERNAL_MODULE_redux__, __WEBPACK_EXTERNAL_MODULE_redux_saga__, __WEBPACK_EXTERNAL_MODULE_web3__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.js");
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ "./node_modules/babel-runtime/core-js/array/from.js":
	/*!**********************************************************!*\
	  !*** ./node_modules/babel-runtime/core-js/array/from.js ***!
	  \**********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(/*! core-js/library/fn/array/from */ "./node_modules/core-js/library/fn/array/from.js"), __esModule: true };
	
	/***/ }),
	
	/***/ "./node_modules/babel-runtime/core-js/json/stringify.js":
	/*!**************************************************************!*\
	  !*** ./node_modules/babel-runtime/core-js/json/stringify.js ***!
	  \**************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(/*! core-js/library/fn/json/stringify */ "./node_modules/core-js/library/fn/json/stringify.js"), __esModule: true };
	
	/***/ }),
	
	/***/ "./node_modules/babel-runtime/core-js/object/assign.js":
	/*!*************************************************************!*\
	  !*** ./node_modules/babel-runtime/core-js/object/assign.js ***!
	  \*************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(/*! core-js/library/fn/object/assign */ "./node_modules/core-js/library/fn/object/assign.js"), __esModule: true };
	
	/***/ }),
	
	/***/ "./node_modules/babel-runtime/core-js/object/define-property.js":
	/*!**********************************************************************!*\
	  !*** ./node_modules/babel-runtime/core-js/object/define-property.js ***!
	  \**********************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(/*! core-js/library/fn/object/define-property */ "./node_modules/core-js/library/fn/object/define-property.js"), __esModule: true };
	
	/***/ }),
	
	/***/ "./node_modules/babel-runtime/core-js/object/keys.js":
	/*!***********************************************************!*\
	  !*** ./node_modules/babel-runtime/core-js/object/keys.js ***!
	  \***********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(/*! core-js/library/fn/object/keys */ "./node_modules/core-js/library/fn/object/keys.js"), __esModule: true };
	
	/***/ }),
	
	/***/ "./node_modules/babel-runtime/core-js/promise.js":
	/*!*******************************************************!*\
	  !*** ./node_modules/babel-runtime/core-js/promise.js ***!
	  \*******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(/*! core-js/library/fn/promise */ "./node_modules/core-js/library/fn/promise.js"), __esModule: true };
	
	/***/ }),
	
	/***/ "./node_modules/babel-runtime/core-js/symbol.js":
	/*!******************************************************!*\
	  !*** ./node_modules/babel-runtime/core-js/symbol.js ***!
	  \******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(/*! core-js/library/fn/symbol */ "./node_modules/core-js/library/fn/symbol/index.js"), __esModule: true };
	
	/***/ }),
	
	/***/ "./node_modules/babel-runtime/core-js/symbol/iterator.js":
	/*!***************************************************************!*\
	  !*** ./node_modules/babel-runtime/core-js/symbol/iterator.js ***!
	  \***************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = { "default": __webpack_require__(/*! core-js/library/fn/symbol/iterator */ "./node_modules/core-js/library/fn/symbol/iterator.js"), __esModule: true };
	
	/***/ }),
	
	/***/ "./node_modules/babel-runtime/helpers/classCallCheck.js":
	/*!**************************************************************!*\
	  !*** ./node_modules/babel-runtime/helpers/classCallCheck.js ***!
	  \**************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	/***/ }),
	
	/***/ "./node_modules/babel-runtime/helpers/createClass.js":
	/*!***********************************************************!*\
	  !*** ./node_modules/babel-runtime/helpers/createClass.js ***!
	  \***********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(/*! ../core-js/object/define-property */ "./node_modules/babel-runtime/core-js/object/define-property.js");
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	/***/ }),
	
	/***/ "./node_modules/babel-runtime/helpers/defineProperty.js":
	/*!**************************************************************!*\
	  !*** ./node_modules/babel-runtime/helpers/defineProperty.js ***!
	  \**************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(/*! ../core-js/object/define-property */ "./node_modules/babel-runtime/core-js/object/define-property.js");
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	/***/ }),
	
	/***/ "./node_modules/babel-runtime/helpers/extends.js":
	/*!*******************************************************!*\
	  !*** ./node_modules/babel-runtime/helpers/extends.js ***!
	  \*******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(/*! ../core-js/object/assign */ "./node_modules/babel-runtime/core-js/object/assign.js");
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/***/ }),
	
	/***/ "./node_modules/babel-runtime/helpers/toConsumableArray.js":
	/*!*****************************************************************!*\
	  !*** ./node_modules/babel-runtime/helpers/toConsumableArray.js ***!
	  \*****************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(/*! ../core-js/array/from */ "./node_modules/babel-runtime/core-js/array/from.js");
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};
	
	/***/ }),
	
	/***/ "./node_modules/babel-runtime/helpers/typeof.js":
	/*!******************************************************!*\
	  !*** ./node_modules/babel-runtime/helpers/typeof.js ***!
	  \******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(/*! ../core-js/symbol/iterator */ "./node_modules/babel-runtime/core-js/symbol/iterator.js");
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(/*! ../core-js/symbol */ "./node_modules/babel-runtime/core-js/symbol.js");
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};
	
	/***/ }),
	
	/***/ "./node_modules/babel-runtime/regenerator/index.js":
	/*!*********************************************************!*\
	  !*** ./node_modules/babel-runtime/regenerator/index.js ***!
	  \*********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(/*! regenerator-runtime */ "./node_modules/regenerator-runtime/runtime-module.js");
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/fn/array/from.js":
	/*!*******************************************************!*\
	  !*** ./node_modules/core-js/library/fn/array/from.js ***!
	  \*******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(/*! ../../modules/es6.string.iterator */ "./node_modules/core-js/library/modules/es6.string.iterator.js");
	__webpack_require__(/*! ../../modules/es6.array.from */ "./node_modules/core-js/library/modules/es6.array.from.js");
	module.exports = __webpack_require__(/*! ../../modules/_core */ "./node_modules/core-js/library/modules/_core.js").Array.from;
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/fn/json/stringify.js":
	/*!***********************************************************!*\
	  !*** ./node_modules/core-js/library/fn/json/stringify.js ***!
	  \***********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var core = __webpack_require__(/*! ../../modules/_core */ "./node_modules/core-js/library/modules/_core.js");
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/fn/object/assign.js":
	/*!**********************************************************!*\
	  !*** ./node_modules/core-js/library/fn/object/assign.js ***!
	  \**********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(/*! ../../modules/es6.object.assign */ "./node_modules/core-js/library/modules/es6.object.assign.js");
	module.exports = __webpack_require__(/*! ../../modules/_core */ "./node_modules/core-js/library/modules/_core.js").Object.assign;
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/fn/object/define-property.js":
	/*!*******************************************************************!*\
	  !*** ./node_modules/core-js/library/fn/object/define-property.js ***!
	  \*******************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(/*! ../../modules/es6.object.define-property */ "./node_modules/core-js/library/modules/es6.object.define-property.js");
	var $Object = __webpack_require__(/*! ../../modules/_core */ "./node_modules/core-js/library/modules/_core.js").Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/fn/object/keys.js":
	/*!********************************************************!*\
	  !*** ./node_modules/core-js/library/fn/object/keys.js ***!
	  \********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(/*! ../../modules/es6.object.keys */ "./node_modules/core-js/library/modules/es6.object.keys.js");
	module.exports = __webpack_require__(/*! ../../modules/_core */ "./node_modules/core-js/library/modules/_core.js").Object.keys;
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/fn/promise.js":
	/*!****************************************************!*\
	  !*** ./node_modules/core-js/library/fn/promise.js ***!
	  \****************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(/*! ../modules/es6.object.to-string */ "./node_modules/core-js/library/modules/es6.object.to-string.js");
	__webpack_require__(/*! ../modules/es6.string.iterator */ "./node_modules/core-js/library/modules/es6.string.iterator.js");
	__webpack_require__(/*! ../modules/web.dom.iterable */ "./node_modules/core-js/library/modules/web.dom.iterable.js");
	__webpack_require__(/*! ../modules/es6.promise */ "./node_modules/core-js/library/modules/es6.promise.js");
	__webpack_require__(/*! ../modules/es7.promise.finally */ "./node_modules/core-js/library/modules/es7.promise.finally.js");
	__webpack_require__(/*! ../modules/es7.promise.try */ "./node_modules/core-js/library/modules/es7.promise.try.js");
	module.exports = __webpack_require__(/*! ../modules/_core */ "./node_modules/core-js/library/modules/_core.js").Promise;
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/fn/symbol/index.js":
	/*!*********************************************************!*\
	  !*** ./node_modules/core-js/library/fn/symbol/index.js ***!
	  \*********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(/*! ../../modules/es6.symbol */ "./node_modules/core-js/library/modules/es6.symbol.js");
	__webpack_require__(/*! ../../modules/es6.object.to-string */ "./node_modules/core-js/library/modules/es6.object.to-string.js");
	__webpack_require__(/*! ../../modules/es7.symbol.async-iterator */ "./node_modules/core-js/library/modules/es7.symbol.async-iterator.js");
	__webpack_require__(/*! ../../modules/es7.symbol.observable */ "./node_modules/core-js/library/modules/es7.symbol.observable.js");
	module.exports = __webpack_require__(/*! ../../modules/_core */ "./node_modules/core-js/library/modules/_core.js").Symbol;
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/fn/symbol/iterator.js":
	/*!************************************************************!*\
	  !*** ./node_modules/core-js/library/fn/symbol/iterator.js ***!
	  \************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(/*! ../../modules/es6.string.iterator */ "./node_modules/core-js/library/modules/es6.string.iterator.js");
	__webpack_require__(/*! ../../modules/web.dom.iterable */ "./node_modules/core-js/library/modules/web.dom.iterable.js");
	module.exports = __webpack_require__(/*! ../../modules/_wks-ext */ "./node_modules/core-js/library/modules/_wks-ext.js").f('iterator');
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_a-function.js":
	/*!*************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_a-function.js ***!
	  \*************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_add-to-unscopables.js":
	/*!*********************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_add-to-unscopables.js ***!
	  \*********************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	module.exports = function () { /* empty */ };
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_an-instance.js":
	/*!**************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_an-instance.js ***!
	  \**************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_an-object.js":
	/*!************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_an-object.js ***!
	  \************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var isObject = __webpack_require__(/*! ./_is-object */ "./node_modules/core-js/library/modules/_is-object.js");
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_array-includes.js":
	/*!*****************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_array-includes.js ***!
	  \*****************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(/*! ./_to-iobject */ "./node_modules/core-js/library/modules/_to-iobject.js");
	var toLength = __webpack_require__(/*! ./_to-length */ "./node_modules/core-js/library/modules/_to-length.js");
	var toAbsoluteIndex = __webpack_require__(/*! ./_to-absolute-index */ "./node_modules/core-js/library/modules/_to-absolute-index.js");
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_classof.js":
	/*!**********************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_classof.js ***!
	  \**********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(/*! ./_cof */ "./node_modules/core-js/library/modules/_cof.js");
	var TAG = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/library/modules/_wks.js")('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_cof.js":
	/*!******************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_cof.js ***!
	  \******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_core.js":
	/*!*******************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_core.js ***!
	  \*******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	var core = module.exports = { version: '2.5.3' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_create-property.js":
	/*!******************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_create-property.js ***!
	  \******************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var $defineProperty = __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/library/modules/_object-dp.js");
	var createDesc = __webpack_require__(/*! ./_property-desc */ "./node_modules/core-js/library/modules/_property-desc.js");
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_ctx.js":
	/*!******************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_ctx.js ***!
	  \******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// optional / simple context binding
	var aFunction = __webpack_require__(/*! ./_a-function */ "./node_modules/core-js/library/modules/_a-function.js");
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_defined.js":
	/*!**********************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_defined.js ***!
	  \**********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_descriptors.js":
	/*!**************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_descriptors.js ***!
	  \**************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(/*! ./_fails */ "./node_modules/core-js/library/modules/_fails.js")(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_dom-create.js":
	/*!*************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_dom-create.js ***!
	  \*************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var isObject = __webpack_require__(/*! ./_is-object */ "./node_modules/core-js/library/modules/_is-object.js");
	var document = __webpack_require__(/*! ./_global */ "./node_modules/core-js/library/modules/_global.js").document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_enum-bug-keys.js":
	/*!****************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_enum-bug-keys.js ***!
	  \****************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_enum-keys.js":
	/*!************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_enum-keys.js ***!
	  \************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(/*! ./_object-keys */ "./node_modules/core-js/library/modules/_object-keys.js");
	var gOPS = __webpack_require__(/*! ./_object-gops */ "./node_modules/core-js/library/modules/_object-gops.js");
	var pIE = __webpack_require__(/*! ./_object-pie */ "./node_modules/core-js/library/modules/_object-pie.js");
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_export.js":
	/*!*********************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_export.js ***!
	  \*********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var global = __webpack_require__(/*! ./_global */ "./node_modules/core-js/library/modules/_global.js");
	var core = __webpack_require__(/*! ./_core */ "./node_modules/core-js/library/modules/_core.js");
	var ctx = __webpack_require__(/*! ./_ctx */ "./node_modules/core-js/library/modules/_ctx.js");
	var hide = __webpack_require__(/*! ./_hide */ "./node_modules/core-js/library/modules/_hide.js");
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_fails.js":
	/*!********************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_fails.js ***!
	  \********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_for-of.js":
	/*!*********************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_for-of.js ***!
	  \*********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var ctx = __webpack_require__(/*! ./_ctx */ "./node_modules/core-js/library/modules/_ctx.js");
	var call = __webpack_require__(/*! ./_iter-call */ "./node_modules/core-js/library/modules/_iter-call.js");
	var isArrayIter = __webpack_require__(/*! ./_is-array-iter */ "./node_modules/core-js/library/modules/_is-array-iter.js");
	var anObject = __webpack_require__(/*! ./_an-object */ "./node_modules/core-js/library/modules/_an-object.js");
	var toLength = __webpack_require__(/*! ./_to-length */ "./node_modules/core-js/library/modules/_to-length.js");
	var getIterFn = __webpack_require__(/*! ./core.get-iterator-method */ "./node_modules/core-js/library/modules/core.get-iterator-method.js");
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_global.js":
	/*!*********************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_global.js ***!
	  \*********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_has.js":
	/*!******************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_has.js ***!
	  \******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_hide.js":
	/*!*******************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_hide.js ***!
	  \*******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var dP = __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/library/modules/_object-dp.js");
	var createDesc = __webpack_require__(/*! ./_property-desc */ "./node_modules/core-js/library/modules/_property-desc.js");
	module.exports = __webpack_require__(/*! ./_descriptors */ "./node_modules/core-js/library/modules/_descriptors.js") ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_html.js":
	/*!*******************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_html.js ***!
	  \*******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var document = __webpack_require__(/*! ./_global */ "./node_modules/core-js/library/modules/_global.js").document;
	module.exports = document && document.documentElement;
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_ie8-dom-define.js":
	/*!*****************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_ie8-dom-define.js ***!
	  \*****************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = !__webpack_require__(/*! ./_descriptors */ "./node_modules/core-js/library/modules/_descriptors.js") && !__webpack_require__(/*! ./_fails */ "./node_modules/core-js/library/modules/_fails.js")(function () {
	  return Object.defineProperty(__webpack_require__(/*! ./_dom-create */ "./node_modules/core-js/library/modules/_dom-create.js")('div'), 'a', { get: function () { return 7; } }).a != 7;
	});
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_invoke.js":
	/*!*********************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_invoke.js ***!
	  \*********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_iobject.js":
	/*!**********************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_iobject.js ***!
	  \**********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(/*! ./_cof */ "./node_modules/core-js/library/modules/_cof.js");
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_is-array-iter.js":
	/*!****************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_is-array-iter.js ***!
	  \****************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// check on default Array iterator
	var Iterators = __webpack_require__(/*! ./_iterators */ "./node_modules/core-js/library/modules/_iterators.js");
	var ITERATOR = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/library/modules/_wks.js")('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_is-array.js":
	/*!***********************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_is-array.js ***!
	  \***********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(/*! ./_cof */ "./node_modules/core-js/library/modules/_cof.js");
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_is-object.js":
	/*!************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_is-object.js ***!
	  \************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_iter-call.js":
	/*!************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_iter-call.js ***!
	  \************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(/*! ./_an-object */ "./node_modules/core-js/library/modules/_an-object.js");
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_iter-create.js":
	/*!**************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_iter-create.js ***!
	  \**************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var create = __webpack_require__(/*! ./_object-create */ "./node_modules/core-js/library/modules/_object-create.js");
	var descriptor = __webpack_require__(/*! ./_property-desc */ "./node_modules/core-js/library/modules/_property-desc.js");
	var setToStringTag = __webpack_require__(/*! ./_set-to-string-tag */ "./node_modules/core-js/library/modules/_set-to-string-tag.js");
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(/*! ./_hide */ "./node_modules/core-js/library/modules/_hide.js")(IteratorPrototype, __webpack_require__(/*! ./_wks */ "./node_modules/core-js/library/modules/_wks.js")('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_iter-define.js":
	/*!**************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_iter-define.js ***!
	  \**************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var LIBRARY = __webpack_require__(/*! ./_library */ "./node_modules/core-js/library/modules/_library.js");
	var $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/library/modules/_export.js");
	var redefine = __webpack_require__(/*! ./_redefine */ "./node_modules/core-js/library/modules/_redefine.js");
	var hide = __webpack_require__(/*! ./_hide */ "./node_modules/core-js/library/modules/_hide.js");
	var has = __webpack_require__(/*! ./_has */ "./node_modules/core-js/library/modules/_has.js");
	var Iterators = __webpack_require__(/*! ./_iterators */ "./node_modules/core-js/library/modules/_iterators.js");
	var $iterCreate = __webpack_require__(/*! ./_iter-create */ "./node_modules/core-js/library/modules/_iter-create.js");
	var setToStringTag = __webpack_require__(/*! ./_set-to-string-tag */ "./node_modules/core-js/library/modules/_set-to-string-tag.js");
	var getPrototypeOf = __webpack_require__(/*! ./_object-gpo */ "./node_modules/core-js/library/modules/_object-gpo.js");
	var ITERATOR = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/library/modules/_wks.js")('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_iter-detect.js":
	/*!**************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_iter-detect.js ***!
	  \**************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var ITERATOR = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/library/modules/_wks.js")('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_iter-step.js":
	/*!************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_iter-step.js ***!
	  \************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_iterators.js":
	/*!************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_iterators.js ***!
	  \************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	module.exports = {};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_library.js":
	/*!**********************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_library.js ***!
	  \**********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	module.exports = true;
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_meta.js":
	/*!*******************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_meta.js ***!
	  \*******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var META = __webpack_require__(/*! ./_uid */ "./node_modules/core-js/library/modules/_uid.js")('meta');
	var isObject = __webpack_require__(/*! ./_is-object */ "./node_modules/core-js/library/modules/_is-object.js");
	var has = __webpack_require__(/*! ./_has */ "./node_modules/core-js/library/modules/_has.js");
	var setDesc = __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/library/modules/_object-dp.js").f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(/*! ./_fails */ "./node_modules/core-js/library/modules/_fails.js")(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_microtask.js":
	/*!************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_microtask.js ***!
	  \************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var global = __webpack_require__(/*! ./_global */ "./node_modules/core-js/library/modules/_global.js");
	var macrotask = __webpack_require__(/*! ./_task */ "./node_modules/core-js/library/modules/_task.js").set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(/*! ./_cof */ "./node_modules/core-js/library/modules/_cof.js")(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve();
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_new-promise-capability.js":
	/*!*************************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_new-promise-capability.js ***!
	  \*************************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(/*! ./_a-function */ "./node_modules/core-js/library/modules/_a-function.js");
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_object-assign.js":
	/*!****************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_object-assign.js ***!
	  \****************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(/*! ./_object-keys */ "./node_modules/core-js/library/modules/_object-keys.js");
	var gOPS = __webpack_require__(/*! ./_object-gops */ "./node_modules/core-js/library/modules/_object-gops.js");
	var pIE = __webpack_require__(/*! ./_object-pie */ "./node_modules/core-js/library/modules/_object-pie.js");
	var toObject = __webpack_require__(/*! ./_to-object */ "./node_modules/core-js/library/modules/_to-object.js");
	var IObject = __webpack_require__(/*! ./_iobject */ "./node_modules/core-js/library/modules/_iobject.js");
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(/*! ./_fails */ "./node_modules/core-js/library/modules/_fails.js")(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_object-create.js":
	/*!****************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_object-create.js ***!
	  \****************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(/*! ./_an-object */ "./node_modules/core-js/library/modules/_an-object.js");
	var dPs = __webpack_require__(/*! ./_object-dps */ "./node_modules/core-js/library/modules/_object-dps.js");
	var enumBugKeys = __webpack_require__(/*! ./_enum-bug-keys */ "./node_modules/core-js/library/modules/_enum-bug-keys.js");
	var IE_PROTO = __webpack_require__(/*! ./_shared-key */ "./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(/*! ./_dom-create */ "./node_modules/core-js/library/modules/_dom-create.js")('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(/*! ./_html */ "./node_modules/core-js/library/modules/_html.js").appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_object-dp.js":
	/*!************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_object-dp.js ***!
	  \************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var anObject = __webpack_require__(/*! ./_an-object */ "./node_modules/core-js/library/modules/_an-object.js");
	var IE8_DOM_DEFINE = __webpack_require__(/*! ./_ie8-dom-define */ "./node_modules/core-js/library/modules/_ie8-dom-define.js");
	var toPrimitive = __webpack_require__(/*! ./_to-primitive */ "./node_modules/core-js/library/modules/_to-primitive.js");
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(/*! ./_descriptors */ "./node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_object-dps.js":
	/*!*************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_object-dps.js ***!
	  \*************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var dP = __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/library/modules/_object-dp.js");
	var anObject = __webpack_require__(/*! ./_an-object */ "./node_modules/core-js/library/modules/_an-object.js");
	var getKeys = __webpack_require__(/*! ./_object-keys */ "./node_modules/core-js/library/modules/_object-keys.js");
	
	module.exports = __webpack_require__(/*! ./_descriptors */ "./node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_object-gopd.js":
	/*!**************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_object-gopd.js ***!
	  \**************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var pIE = __webpack_require__(/*! ./_object-pie */ "./node_modules/core-js/library/modules/_object-pie.js");
	var createDesc = __webpack_require__(/*! ./_property-desc */ "./node_modules/core-js/library/modules/_property-desc.js");
	var toIObject = __webpack_require__(/*! ./_to-iobject */ "./node_modules/core-js/library/modules/_to-iobject.js");
	var toPrimitive = __webpack_require__(/*! ./_to-primitive */ "./node_modules/core-js/library/modules/_to-primitive.js");
	var has = __webpack_require__(/*! ./_has */ "./node_modules/core-js/library/modules/_has.js");
	var IE8_DOM_DEFINE = __webpack_require__(/*! ./_ie8-dom-define */ "./node_modules/core-js/library/modules/_ie8-dom-define.js");
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(/*! ./_descriptors */ "./node_modules/core-js/library/modules/_descriptors.js") ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_object-gopn-ext.js":
	/*!******************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_object-gopn-ext.js ***!
	  \******************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(/*! ./_to-iobject */ "./node_modules/core-js/library/modules/_to-iobject.js");
	var gOPN = __webpack_require__(/*! ./_object-gopn */ "./node_modules/core-js/library/modules/_object-gopn.js").f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_object-gopn.js":
	/*!**************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_object-gopn.js ***!
	  \**************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(/*! ./_object-keys-internal */ "./node_modules/core-js/library/modules/_object-keys-internal.js");
	var hiddenKeys = __webpack_require__(/*! ./_enum-bug-keys */ "./node_modules/core-js/library/modules/_enum-bug-keys.js").concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_object-gops.js":
	/*!**************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_object-gops.js ***!
	  \**************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	exports.f = Object.getOwnPropertySymbols;
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_object-gpo.js":
	/*!*************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_object-gpo.js ***!
	  \*************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(/*! ./_has */ "./node_modules/core-js/library/modules/_has.js");
	var toObject = __webpack_require__(/*! ./_to-object */ "./node_modules/core-js/library/modules/_to-object.js");
	var IE_PROTO = __webpack_require__(/*! ./_shared-key */ "./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_object-keys-internal.js":
	/*!***********************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_object-keys-internal.js ***!
	  \***********************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var has = __webpack_require__(/*! ./_has */ "./node_modules/core-js/library/modules/_has.js");
	var toIObject = __webpack_require__(/*! ./_to-iobject */ "./node_modules/core-js/library/modules/_to-iobject.js");
	var arrayIndexOf = __webpack_require__(/*! ./_array-includes */ "./node_modules/core-js/library/modules/_array-includes.js")(false);
	var IE_PROTO = __webpack_require__(/*! ./_shared-key */ "./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_object-keys.js":
	/*!**************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_object-keys.js ***!
	  \**************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(/*! ./_object-keys-internal */ "./node_modules/core-js/library/modules/_object-keys-internal.js");
	var enumBugKeys = __webpack_require__(/*! ./_enum-bug-keys */ "./node_modules/core-js/library/modules/_enum-bug-keys.js");
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_object-pie.js":
	/*!*************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_object-pie.js ***!
	  \*************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	exports.f = {}.propertyIsEnumerable;
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_object-sap.js":
	/*!*************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_object-sap.js ***!
	  \*************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/library/modules/_export.js");
	var core = __webpack_require__(/*! ./_core */ "./node_modules/core-js/library/modules/_core.js");
	var fails = __webpack_require__(/*! ./_fails */ "./node_modules/core-js/library/modules/_fails.js");
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_perform.js":
	/*!**********************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_perform.js ***!
	  \**********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_promise-resolve.js":
	/*!******************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_promise-resolve.js ***!
	  \******************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var anObject = __webpack_require__(/*! ./_an-object */ "./node_modules/core-js/library/modules/_an-object.js");
	var isObject = __webpack_require__(/*! ./_is-object */ "./node_modules/core-js/library/modules/_is-object.js");
	var newPromiseCapability = __webpack_require__(/*! ./_new-promise-capability */ "./node_modules/core-js/library/modules/_new-promise-capability.js");
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_property-desc.js":
	/*!****************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_property-desc.js ***!
	  \****************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_redefine-all.js":
	/*!***************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_redefine-all.js ***!
	  \***************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var hide = __webpack_require__(/*! ./_hide */ "./node_modules/core-js/library/modules/_hide.js");
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_redefine.js":
	/*!***********************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_redefine.js ***!
	  \***********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(/*! ./_hide */ "./node_modules/core-js/library/modules/_hide.js");
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_set-species.js":
	/*!**************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_set-species.js ***!
	  \**************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var global = __webpack_require__(/*! ./_global */ "./node_modules/core-js/library/modules/_global.js");
	var core = __webpack_require__(/*! ./_core */ "./node_modules/core-js/library/modules/_core.js");
	var dP = __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/library/modules/_object-dp.js");
	var DESCRIPTORS = __webpack_require__(/*! ./_descriptors */ "./node_modules/core-js/library/modules/_descriptors.js");
	var SPECIES = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/library/modules/_wks.js")('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_set-to-string-tag.js":
	/*!********************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_set-to-string-tag.js ***!
	  \********************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var def = __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/library/modules/_object-dp.js").f;
	var has = __webpack_require__(/*! ./_has */ "./node_modules/core-js/library/modules/_has.js");
	var TAG = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/library/modules/_wks.js")('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_shared-key.js":
	/*!*************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_shared-key.js ***!
	  \*************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var shared = __webpack_require__(/*! ./_shared */ "./node_modules/core-js/library/modules/_shared.js")('keys');
	var uid = __webpack_require__(/*! ./_uid */ "./node_modules/core-js/library/modules/_uid.js");
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_shared.js":
	/*!*********************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_shared.js ***!
	  \*********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var global = __webpack_require__(/*! ./_global */ "./node_modules/core-js/library/modules/_global.js");
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_species-constructor.js":
	/*!**********************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_species-constructor.js ***!
	  \**********************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(/*! ./_an-object */ "./node_modules/core-js/library/modules/_an-object.js");
	var aFunction = __webpack_require__(/*! ./_a-function */ "./node_modules/core-js/library/modules/_a-function.js");
	var SPECIES = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/library/modules/_wks.js")('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_string-at.js":
	/*!************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_string-at.js ***!
	  \************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var toInteger = __webpack_require__(/*! ./_to-integer */ "./node_modules/core-js/library/modules/_to-integer.js");
	var defined = __webpack_require__(/*! ./_defined */ "./node_modules/core-js/library/modules/_defined.js");
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_task.js":
	/*!*******************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_task.js ***!
	  \*******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var ctx = __webpack_require__(/*! ./_ctx */ "./node_modules/core-js/library/modules/_ctx.js");
	var invoke = __webpack_require__(/*! ./_invoke */ "./node_modules/core-js/library/modules/_invoke.js");
	var html = __webpack_require__(/*! ./_html */ "./node_modules/core-js/library/modules/_html.js");
	var cel = __webpack_require__(/*! ./_dom-create */ "./node_modules/core-js/library/modules/_dom-create.js");
	var global = __webpack_require__(/*! ./_global */ "./node_modules/core-js/library/modules/_global.js");
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(/*! ./_cof */ "./node_modules/core-js/library/modules/_cof.js")(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_to-absolute-index.js":
	/*!********************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_to-absolute-index.js ***!
	  \********************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var toInteger = __webpack_require__(/*! ./_to-integer */ "./node_modules/core-js/library/modules/_to-integer.js");
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_to-integer.js":
	/*!*************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_to-integer.js ***!
	  \*************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_to-iobject.js":
	/*!*************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_to-iobject.js ***!
	  \*************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(/*! ./_iobject */ "./node_modules/core-js/library/modules/_iobject.js");
	var defined = __webpack_require__(/*! ./_defined */ "./node_modules/core-js/library/modules/_defined.js");
	module.exports = function (it) {
	  return IObject(defined(it));
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_to-length.js":
	/*!************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_to-length.js ***!
	  \************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 7.1.15 ToLength
	var toInteger = __webpack_require__(/*! ./_to-integer */ "./node_modules/core-js/library/modules/_to-integer.js");
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_to-object.js":
	/*!************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_to-object.js ***!
	  \************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(/*! ./_defined */ "./node_modules/core-js/library/modules/_defined.js");
	module.exports = function (it) {
	  return Object(defined(it));
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_to-primitive.js":
	/*!***************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_to-primitive.js ***!
	  \***************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(/*! ./_is-object */ "./node_modules/core-js/library/modules/_is-object.js");
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_uid.js":
	/*!******************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_uid.js ***!
	  \******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_wks-define.js":
	/*!*************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_wks-define.js ***!
	  \*************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var global = __webpack_require__(/*! ./_global */ "./node_modules/core-js/library/modules/_global.js");
	var core = __webpack_require__(/*! ./_core */ "./node_modules/core-js/library/modules/_core.js");
	var LIBRARY = __webpack_require__(/*! ./_library */ "./node_modules/core-js/library/modules/_library.js");
	var wksExt = __webpack_require__(/*! ./_wks-ext */ "./node_modules/core-js/library/modules/_wks-ext.js");
	var defineProperty = __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/library/modules/_object-dp.js").f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_wks-ext.js":
	/*!**********************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_wks-ext.js ***!
	  \**********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	exports.f = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/library/modules/_wks.js");
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/_wks.js":
	/*!******************************************************!*\
	  !*** ./node_modules/core-js/library/modules/_wks.js ***!
	  \******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var store = __webpack_require__(/*! ./_shared */ "./node_modules/core-js/library/modules/_shared.js")('wks');
	var uid = __webpack_require__(/*! ./_uid */ "./node_modules/core-js/library/modules/_uid.js");
	var Symbol = __webpack_require__(/*! ./_global */ "./node_modules/core-js/library/modules/_global.js").Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/core.get-iterator-method.js":
	/*!**************************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/core.get-iterator-method.js ***!
	  \**************************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var classof = __webpack_require__(/*! ./_classof */ "./node_modules/core-js/library/modules/_classof.js");
	var ITERATOR = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/library/modules/_wks.js")('iterator');
	var Iterators = __webpack_require__(/*! ./_iterators */ "./node_modules/core-js/library/modules/_iterators.js");
	module.exports = __webpack_require__(/*! ./_core */ "./node_modules/core-js/library/modules/_core.js").getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/es6.array.from.js":
	/*!****************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/es6.array.from.js ***!
	  \****************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var ctx = __webpack_require__(/*! ./_ctx */ "./node_modules/core-js/library/modules/_ctx.js");
	var $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/library/modules/_export.js");
	var toObject = __webpack_require__(/*! ./_to-object */ "./node_modules/core-js/library/modules/_to-object.js");
	var call = __webpack_require__(/*! ./_iter-call */ "./node_modules/core-js/library/modules/_iter-call.js");
	var isArrayIter = __webpack_require__(/*! ./_is-array-iter */ "./node_modules/core-js/library/modules/_is-array-iter.js");
	var toLength = __webpack_require__(/*! ./_to-length */ "./node_modules/core-js/library/modules/_to-length.js");
	var createProperty = __webpack_require__(/*! ./_create-property */ "./node_modules/core-js/library/modules/_create-property.js");
	var getIterFn = __webpack_require__(/*! ./core.get-iterator-method */ "./node_modules/core-js/library/modules/core.get-iterator-method.js");
	
	$export($export.S + $export.F * !__webpack_require__(/*! ./_iter-detect */ "./node_modules/core-js/library/modules/_iter-detect.js")(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/es6.array.iterator.js":
	/*!********************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/es6.array.iterator.js ***!
	  \********************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var addToUnscopables = __webpack_require__(/*! ./_add-to-unscopables */ "./node_modules/core-js/library/modules/_add-to-unscopables.js");
	var step = __webpack_require__(/*! ./_iter-step */ "./node_modules/core-js/library/modules/_iter-step.js");
	var Iterators = __webpack_require__(/*! ./_iterators */ "./node_modules/core-js/library/modules/_iterators.js");
	var toIObject = __webpack_require__(/*! ./_to-iobject */ "./node_modules/core-js/library/modules/_to-iobject.js");
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(/*! ./_iter-define */ "./node_modules/core-js/library/modules/_iter-define.js")(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/es6.object.assign.js":
	/*!*******************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/es6.object.assign.js ***!
	  \*******************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/library/modules/_export.js");
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(/*! ./_object-assign */ "./node_modules/core-js/library/modules/_object-assign.js") });
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/es6.object.define-property.js":
	/*!****************************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/es6.object.define-property.js ***!
	  \****************************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	var $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/library/modules/_export.js");
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(/*! ./_descriptors */ "./node_modules/core-js/library/modules/_descriptors.js"), 'Object', { defineProperty: __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/library/modules/_object-dp.js").f });
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/es6.object.keys.js":
	/*!*****************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/es6.object.keys.js ***!
	  \*****************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(/*! ./_to-object */ "./node_modules/core-js/library/modules/_to-object.js");
	var $keys = __webpack_require__(/*! ./_object-keys */ "./node_modules/core-js/library/modules/_object-keys.js");
	
	__webpack_require__(/*! ./_object-sap */ "./node_modules/core-js/library/modules/_object-sap.js")('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/es6.object.to-string.js":
	/*!**********************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/es6.object.to-string.js ***!
	  \**********************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/es6.promise.js":
	/*!*************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/es6.promise.js ***!
	  \*************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var LIBRARY = __webpack_require__(/*! ./_library */ "./node_modules/core-js/library/modules/_library.js");
	var global = __webpack_require__(/*! ./_global */ "./node_modules/core-js/library/modules/_global.js");
	var ctx = __webpack_require__(/*! ./_ctx */ "./node_modules/core-js/library/modules/_ctx.js");
	var classof = __webpack_require__(/*! ./_classof */ "./node_modules/core-js/library/modules/_classof.js");
	var $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/library/modules/_export.js");
	var isObject = __webpack_require__(/*! ./_is-object */ "./node_modules/core-js/library/modules/_is-object.js");
	var aFunction = __webpack_require__(/*! ./_a-function */ "./node_modules/core-js/library/modules/_a-function.js");
	var anInstance = __webpack_require__(/*! ./_an-instance */ "./node_modules/core-js/library/modules/_an-instance.js");
	var forOf = __webpack_require__(/*! ./_for-of */ "./node_modules/core-js/library/modules/_for-of.js");
	var speciesConstructor = __webpack_require__(/*! ./_species-constructor */ "./node_modules/core-js/library/modules/_species-constructor.js");
	var task = __webpack_require__(/*! ./_task */ "./node_modules/core-js/library/modules/_task.js").set;
	var microtask = __webpack_require__(/*! ./_microtask */ "./node_modules/core-js/library/modules/_microtask.js")();
	var newPromiseCapabilityModule = __webpack_require__(/*! ./_new-promise-capability */ "./node_modules/core-js/library/modules/_new-promise-capability.js");
	var perform = __webpack_require__(/*! ./_perform */ "./node_modules/core-js/library/modules/_perform.js");
	var promiseResolve = __webpack_require__(/*! ./_promise-resolve */ "./node_modules/core-js/library/modules/_promise-resolve.js");
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(/*! ./_wks */ "./node_modules/core-js/library/modules/_wks.js")('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value);
	            if (domain) domain.exit();
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(/*! ./_redefine-all */ "./node_modules/core-js/library/modules/_redefine-all.js")($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(/*! ./_set-to-string-tag */ "./node_modules/core-js/library/modules/_set-to-string-tag.js")($Promise, PROMISE);
	__webpack_require__(/*! ./_set-species */ "./node_modules/core-js/library/modules/_set-species.js")(PROMISE);
	Wrapper = __webpack_require__(/*! ./_core */ "./node_modules/core-js/library/modules/_core.js")[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(/*! ./_iter-detect */ "./node_modules/core-js/library/modules/_iter-detect.js")(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/es6.string.iterator.js":
	/*!*********************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/es6.string.iterator.js ***!
	  \*********************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var $at = __webpack_require__(/*! ./_string-at */ "./node_modules/core-js/library/modules/_string-at.js")(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(/*! ./_iter-define */ "./node_modules/core-js/library/modules/_iter-define.js")(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/es6.symbol.js":
	/*!************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/es6.symbol.js ***!
	  \************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(/*! ./_global */ "./node_modules/core-js/library/modules/_global.js");
	var has = __webpack_require__(/*! ./_has */ "./node_modules/core-js/library/modules/_has.js");
	var DESCRIPTORS = __webpack_require__(/*! ./_descriptors */ "./node_modules/core-js/library/modules/_descriptors.js");
	var $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/library/modules/_export.js");
	var redefine = __webpack_require__(/*! ./_redefine */ "./node_modules/core-js/library/modules/_redefine.js");
	var META = __webpack_require__(/*! ./_meta */ "./node_modules/core-js/library/modules/_meta.js").KEY;
	var $fails = __webpack_require__(/*! ./_fails */ "./node_modules/core-js/library/modules/_fails.js");
	var shared = __webpack_require__(/*! ./_shared */ "./node_modules/core-js/library/modules/_shared.js");
	var setToStringTag = __webpack_require__(/*! ./_set-to-string-tag */ "./node_modules/core-js/library/modules/_set-to-string-tag.js");
	var uid = __webpack_require__(/*! ./_uid */ "./node_modules/core-js/library/modules/_uid.js");
	var wks = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/library/modules/_wks.js");
	var wksExt = __webpack_require__(/*! ./_wks-ext */ "./node_modules/core-js/library/modules/_wks-ext.js");
	var wksDefine = __webpack_require__(/*! ./_wks-define */ "./node_modules/core-js/library/modules/_wks-define.js");
	var enumKeys = __webpack_require__(/*! ./_enum-keys */ "./node_modules/core-js/library/modules/_enum-keys.js");
	var isArray = __webpack_require__(/*! ./_is-array */ "./node_modules/core-js/library/modules/_is-array.js");
	var anObject = __webpack_require__(/*! ./_an-object */ "./node_modules/core-js/library/modules/_an-object.js");
	var isObject = __webpack_require__(/*! ./_is-object */ "./node_modules/core-js/library/modules/_is-object.js");
	var toIObject = __webpack_require__(/*! ./_to-iobject */ "./node_modules/core-js/library/modules/_to-iobject.js");
	var toPrimitive = __webpack_require__(/*! ./_to-primitive */ "./node_modules/core-js/library/modules/_to-primitive.js");
	var createDesc = __webpack_require__(/*! ./_property-desc */ "./node_modules/core-js/library/modules/_property-desc.js");
	var _create = __webpack_require__(/*! ./_object-create */ "./node_modules/core-js/library/modules/_object-create.js");
	var gOPNExt = __webpack_require__(/*! ./_object-gopn-ext */ "./node_modules/core-js/library/modules/_object-gopn-ext.js");
	var $GOPD = __webpack_require__(/*! ./_object-gopd */ "./node_modules/core-js/library/modules/_object-gopd.js");
	var $DP = __webpack_require__(/*! ./_object-dp */ "./node_modules/core-js/library/modules/_object-dp.js");
	var $keys = __webpack_require__(/*! ./_object-keys */ "./node_modules/core-js/library/modules/_object-keys.js");
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(/*! ./_object-gopn */ "./node_modules/core-js/library/modules/_object-gopn.js").f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(/*! ./_object-pie */ "./node_modules/core-js/library/modules/_object-pie.js").f = $propertyIsEnumerable;
	  __webpack_require__(/*! ./_object-gops */ "./node_modules/core-js/library/modules/_object-gops.js").f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(/*! ./_library */ "./node_modules/core-js/library/modules/_library.js")) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(/*! ./_hide */ "./node_modules/core-js/library/modules/_hide.js")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/es7.promise.finally.js":
	/*!*********************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/es7.promise.finally.js ***!
	  \*********************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	// https://github.com/tc39/proposal-promise-finally
	
	var $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/library/modules/_export.js");
	var core = __webpack_require__(/*! ./_core */ "./node_modules/core-js/library/modules/_core.js");
	var global = __webpack_require__(/*! ./_global */ "./node_modules/core-js/library/modules/_global.js");
	var speciesConstructor = __webpack_require__(/*! ./_species-constructor */ "./node_modules/core-js/library/modules/_species-constructor.js");
	var promiseResolve = __webpack_require__(/*! ./_promise-resolve */ "./node_modules/core-js/library/modules/_promise-resolve.js");
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/es7.promise.try.js":
	/*!*****************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/es7.promise.try.js ***!
	  \*****************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(/*! ./_export */ "./node_modules/core-js/library/modules/_export.js");
	var newPromiseCapability = __webpack_require__(/*! ./_new-promise-capability */ "./node_modules/core-js/library/modules/_new-promise-capability.js");
	var perform = __webpack_require__(/*! ./_perform */ "./node_modules/core-js/library/modules/_perform.js");
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/es7.symbol.async-iterator.js":
	/*!***************************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/es7.symbol.async-iterator.js ***!
	  \***************************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(/*! ./_wks-define */ "./node_modules/core-js/library/modules/_wks-define.js")('asyncIterator');
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/es7.symbol.observable.js":
	/*!***********************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/es7.symbol.observable.js ***!
	  \***********************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(/*! ./_wks-define */ "./node_modules/core-js/library/modules/_wks-define.js")('observable');
	
	
	/***/ }),
	
	/***/ "./node_modules/core-js/library/modules/web.dom.iterable.js":
	/*!******************************************************************!*\
	  !*** ./node_modules/core-js/library/modules/web.dom.iterable.js ***!
	  \******************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(/*! ./es6.array.iterator */ "./node_modules/core-js/library/modules/es6.array.iterator.js");
	var global = __webpack_require__(/*! ./_global */ "./node_modules/core-js/library/modules/_global.js");
	var hide = __webpack_require__(/*! ./_hide */ "./node_modules/core-js/library/modules/_hide.js");
	var Iterators = __webpack_require__(/*! ./_iterators */ "./node_modules/core-js/library/modules/_iterators.js");
	var TO_STRING_TAG = __webpack_require__(/*! ./_wks */ "./node_modules/core-js/library/modules/_wks.js")('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}
	
	
	/***/ }),
	
	/***/ "./node_modules/redux-saga/es/effects.js":
	/*!***********************************************!*\
	  !*** ./node_modules/redux-saga/es/effects.js ***!
	  \***********************************************/
	/*! exports provided: take, takem, put, all, race, call, apply, cps, fork, spawn, join, cancel, select, actionChannel, cancelled, flush, getContext, setContext, takeEvery, takeLatest, throttle */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _internal_io__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./internal/io */ "./node_modules/redux-saga/es/internal/io.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "take", function() { return _internal_io__WEBPACK_IMPORTED_MODULE_0__["take"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "takem", function() { return _internal_io__WEBPACK_IMPORTED_MODULE_0__["takem"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "put", function() { return _internal_io__WEBPACK_IMPORTED_MODULE_0__["put"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "all", function() { return _internal_io__WEBPACK_IMPORTED_MODULE_0__["all"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "race", function() { return _internal_io__WEBPACK_IMPORTED_MODULE_0__["race"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "call", function() { return _internal_io__WEBPACK_IMPORTED_MODULE_0__["call"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "apply", function() { return _internal_io__WEBPACK_IMPORTED_MODULE_0__["apply"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "cps", function() { return _internal_io__WEBPACK_IMPORTED_MODULE_0__["cps"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fork", function() { return _internal_io__WEBPACK_IMPORTED_MODULE_0__["fork"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "spawn", function() { return _internal_io__WEBPACK_IMPORTED_MODULE_0__["spawn"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "join", function() { return _internal_io__WEBPACK_IMPORTED_MODULE_0__["join"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "cancel", function() { return _internal_io__WEBPACK_IMPORTED_MODULE_0__["cancel"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "select", function() { return _internal_io__WEBPACK_IMPORTED_MODULE_0__["select"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "actionChannel", function() { return _internal_io__WEBPACK_IMPORTED_MODULE_0__["actionChannel"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "cancelled", function() { return _internal_io__WEBPACK_IMPORTED_MODULE_0__["cancelled"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return _internal_io__WEBPACK_IMPORTED_MODULE_0__["flush"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return _internal_io__WEBPACK_IMPORTED_MODULE_0__["getContext"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setContext", function() { return _internal_io__WEBPACK_IMPORTED_MODULE_0__["setContext"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "takeEvery", function() { return _internal_io__WEBPACK_IMPORTED_MODULE_0__["takeEvery"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "takeLatest", function() { return _internal_io__WEBPACK_IMPORTED_MODULE_0__["takeLatest"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return _internal_io__WEBPACK_IMPORTED_MODULE_0__["throttle"]; });
	
	
	
	/***/ }),
	
	/***/ "./node_modules/redux-saga/es/internal/buffers.js":
	/*!********************************************************!*\
	  !*** ./node_modules/redux-saga/es/internal/buffers.js ***!
	  \********************************************************/
	/*! exports provided: BUFFER_OVERFLOW, buffers */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUFFER_OVERFLOW", function() { return BUFFER_OVERFLOW; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buffers", function() { return buffers; });
	/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils */ "./node_modules/redux-saga/es/internal/utils.js");
	
	
	var BUFFER_OVERFLOW = "Channel's Buffer overflow!";
	
	var ON_OVERFLOW_THROW = 1;
	var ON_OVERFLOW_DROP = 2;
	var ON_OVERFLOW_SLIDE = 3;
	var ON_OVERFLOW_EXPAND = 4;
	
	var zeroBuffer = { isEmpty: _utils__WEBPACK_IMPORTED_MODULE_0__["kTrue"], put: _utils__WEBPACK_IMPORTED_MODULE_0__["noop"], take: _utils__WEBPACK_IMPORTED_MODULE_0__["noop"] };
	
	function ringBuffer() {
	  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
	  var overflowAction = arguments[1];
	
	  var arr = new Array(limit);
	  var length = 0;
	  var pushIndex = 0;
	  var popIndex = 0;
	
	  var push = function push(it) {
	    arr[pushIndex] = it;
	    pushIndex = (pushIndex + 1) % limit;
	    length++;
	  };
	
	  var take = function take() {
	    if (length != 0) {
	      var it = arr[popIndex];
	      arr[popIndex] = null;
	      length--;
	      popIndex = (popIndex + 1) % limit;
	      return it;
	    }
	  };
	
	  var flush = function flush() {
	    var items = [];
	    while (length) {
	      items.push(take());
	    }
	    return items;
	  };
	
	  return {
	    isEmpty: function isEmpty() {
	      return length == 0;
	    },
	    put: function put(it) {
	      if (length < limit) {
	        push(it);
	      } else {
	        var doubledLimit = void 0;
	        switch (overflowAction) {
	          case ON_OVERFLOW_THROW:
	            throw new Error(BUFFER_OVERFLOW);
	          case ON_OVERFLOW_SLIDE:
	            arr[pushIndex] = it;
	            pushIndex = (pushIndex + 1) % limit;
	            popIndex = pushIndex;
	            break;
	          case ON_OVERFLOW_EXPAND:
	            doubledLimit = 2 * limit;
	
	            arr = flush();
	
	            length = arr.length;
	            pushIndex = arr.length;
	            popIndex = 0;
	
	            arr.length = doubledLimit;
	            limit = doubledLimit;
	
	            push(it);
	            break;
	          default:
	          // DROP
	        }
	      }
	    },
	    take: take,
	    flush: flush
	  };
	}
	
	var buffers = {
	  none: function none() {
	    return zeroBuffer;
	  },
	  fixed: function fixed(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_THROW);
	  },
	  dropping: function dropping(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_DROP);
	  },
	  sliding: function sliding(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
	  },
	  expanding: function expanding(initialSize) {
	    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
	  }
	};
	
	/***/ }),
	
	/***/ "./node_modules/redux-saga/es/internal/channel.js":
	/*!********************************************************!*\
	  !*** ./node_modules/redux-saga/es/internal/channel.js ***!
	  \********************************************************/
	/*! exports provided: END, isEnd, emitter, INVALID_BUFFER, UNDEFINED_INPUT_ERROR, channel, eventChannel, stdChannel */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "END", function() { return END; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isEnd", function() { return isEnd; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "emitter", function() { return emitter; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INVALID_BUFFER", function() { return INVALID_BUFFER; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNDEFINED_INPUT_ERROR", function() { return UNDEFINED_INPUT_ERROR; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "channel", function() { return channel; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eventChannel", function() { return eventChannel; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stdChannel", function() { return stdChannel; });
	/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils */ "./node_modules/redux-saga/es/internal/utils.js");
	/* harmony import */ var _buffers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./buffers */ "./node_modules/redux-saga/es/internal/buffers.js");
	/* harmony import */ var _scheduler__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./scheduler */ "./node_modules/redux-saga/es/internal/scheduler.js");
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	
	
	
	
	var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
	var END = { type: CHANNEL_END_TYPE };
	var isEnd = function isEnd(a) {
	  return a && a.type === CHANNEL_END_TYPE;
	};
	
	function emitter() {
	  var subscribers = [];
	
	  function subscribe(sub) {
	    subscribers.push(sub);
	    return function () {
	      return Object(_utils__WEBPACK_IMPORTED_MODULE_0__["remove"])(subscribers, sub);
	    };
	  }
	
	  function emit(item) {
	    var arr = subscribers.slice();
	    for (var i = 0, len = arr.length; i < len; i++) {
	      arr[i](item);
	    }
	  }
	
	  return {
	    subscribe: subscribe,
	    emit: emit
	  };
	}
	
	var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
	var UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';
	
	if (true) {
	  UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
	}
	
	function channel() {
	  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _buffers__WEBPACK_IMPORTED_MODULE_1__["buffers"].fixed();
	
	  var closed = false;
	  var takers = [];
	
	  Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(buffer, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].buffer, INVALID_BUFFER);
	
	  function checkForbiddenStates() {
	    if (closed && takers.length) {
	      throw Object(_utils__WEBPACK_IMPORTED_MODULE_0__["internalErr"])('Cannot have a closed channel with pending takers');
	    }
	    if (takers.length && !buffer.isEmpty()) {
	      throw Object(_utils__WEBPACK_IMPORTED_MODULE_0__["internalErr"])('Cannot have pending takers with non empty buffer');
	    }
	  }
	
	  function put(input) {
	    checkForbiddenStates();
	    Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(input, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, UNDEFINED_INPUT_ERROR);
	    if (closed) {
	      return;
	    }
	    if (!takers.length) {
	      return buffer.put(input);
	    }
	    for (var i = 0; i < takers.length; i++) {
	      var cb = takers[i];
	      if (!cb[_utils__WEBPACK_IMPORTED_MODULE_0__["MATCH"]] || cb[_utils__WEBPACK_IMPORTED_MODULE_0__["MATCH"]](input)) {
	        takers.splice(i, 1);
	        return cb(input);
	      }
	    }
	  }
	
	  function take(cb) {
	    checkForbiddenStates();
	    Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(cb, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].func, "channel.take's callback must be a function");
	
	    if (closed && buffer.isEmpty()) {
	      cb(END);
	    } else if (!buffer.isEmpty()) {
	      cb(buffer.take());
	    } else {
	      takers.push(cb);
	      cb.cancel = function () {
	        return Object(_utils__WEBPACK_IMPORTED_MODULE_0__["remove"])(takers, cb);
	      };
	    }
	  }
	
	  function flush(cb) {
	    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
	    Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(cb, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].func, "channel.flush' callback must be a function");
	    if (closed && buffer.isEmpty()) {
	      cb(END);
	      return;
	    }
	    cb(buffer.flush());
	  }
	
	  function close() {
	    checkForbiddenStates();
	    if (!closed) {
	      closed = true;
	      if (takers.length) {
	        var arr = takers;
	        takers = [];
	        for (var i = 0, len = arr.length; i < len; i++) {
	          arr[i](END);
	        }
	      }
	    }
	  }
	
	  return {
	    take: take,
	    put: put,
	    flush: flush,
	    close: close,
	    get __takers__() {
	      return takers;
	    },
	    get __closed__() {
	      return closed;
	    }
	  };
	}
	
	function eventChannel(subscribe) {
	  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _buffers__WEBPACK_IMPORTED_MODULE_1__["buffers"].none();
	  var matcher = arguments[2];
	
	  /**
	    should be if(typeof matcher !== undefined) instead?
	    see PR #273 for a background discussion
	  **/
	  if (arguments.length > 2) {
	    Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(matcher, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].func, 'Invalid match function passed to eventChannel');
	  }
	
	  var chan = channel(buffer);
	  var close = function close() {
	    if (!chan.__closed__) {
	      if (unsubscribe) {
	        unsubscribe();
	      }
	      chan.close();
	    }
	  };
	  var unsubscribe = subscribe(function (input) {
	    if (isEnd(input)) {
	      close();
	      return;
	    }
	    if (matcher && !matcher(input)) {
	      return;
	    }
	    chan.put(input);
	  });
	  if (chan.__closed__) {
	    unsubscribe();
	  }
	
	  if (!_utils__WEBPACK_IMPORTED_MODULE_0__["is"].func(unsubscribe)) {
	    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
	  }
	
	  return {
	    take: chan.take,
	    flush: chan.flush,
	    close: close
	  };
	}
	
	function stdChannel(subscribe) {
	  var chan = eventChannel(function (cb) {
	    return subscribe(function (input) {
	      if (input[_utils__WEBPACK_IMPORTED_MODULE_0__["SAGA_ACTION"]]) {
	        cb(input);
	        return;
	      }
	      Object(_scheduler__WEBPACK_IMPORTED_MODULE_2__["asap"])(function () {
	        return cb(input);
	      });
	    });
	  });
	
	  return _extends({}, chan, {
	    take: function take(cb, matcher) {
	      if (arguments.length > 1) {
	        Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(matcher, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].func, "channel.take's matcher argument must be a function");
	        cb[_utils__WEBPACK_IMPORTED_MODULE_0__["MATCH"]] = matcher;
	      }
	      chan.take(cb);
	    }
	  });
	}
	
	/***/ }),
	
	/***/ "./node_modules/redux-saga/es/internal/io.js":
	/*!***************************************************!*\
	  !*** ./node_modules/redux-saga/es/internal/io.js ***!
	  \***************************************************/
	/*! exports provided: detach, take, takem, put, all, race, call, apply, cps, fork, spawn, join, cancel, select, actionChannel, cancelled, flush, getContext, setContext, takeEvery, takeLatest, throttle, asEffect */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "detach", function() { return detach; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "take", function() { return take; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "takem", function() { return takem; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "put", function() { return put; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "all", function() { return all; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "race", function() { return race; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "call", function() { return call; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "apply", function() { return apply; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cps", function() { return cps; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fork", function() { return fork; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "spawn", function() { return spawn; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "join", function() { return join; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cancel", function() { return cancel; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "select", function() { return select; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionChannel", function() { return actionChannel; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cancelled", function() { return cancelled; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return flush; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return getContext; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setContext", function() { return setContext; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "takeEvery", function() { return takeEvery; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "takeLatest", function() { return takeLatest; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return throttle; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asEffect", function() { return asEffect; });
	/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils */ "./node_modules/redux-saga/es/internal/utils.js");
	/* harmony import */ var _sagaHelpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./sagaHelpers */ "./node_modules/redux-saga/es/internal/sagaHelpers/index.js");
	
	
	
	var IO = /*#__PURE__*/Object(_utils__WEBPACK_IMPORTED_MODULE_0__["sym"])('IO');
	var TAKE = 'TAKE';
	var PUT = 'PUT';
	var ALL = 'ALL';
	var RACE = 'RACE';
	var CALL = 'CALL';
	var CPS = 'CPS';
	var FORK = 'FORK';
	var JOIN = 'JOIN';
	var CANCEL = 'CANCEL';
	var SELECT = 'SELECT';
	var ACTION_CHANNEL = 'ACTION_CHANNEL';
	var CANCELLED = 'CANCELLED';
	var FLUSH = 'FLUSH';
	var GET_CONTEXT = 'GET_CONTEXT';
	var SET_CONTEXT = 'SET_CONTEXT';
	
	var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';
	
	var effect = function effect(type, payload) {
	  var _ref;
	
	  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
	};
	
	var detach = function detach(eff) {
	  Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(asEffect.fork(eff), _utils__WEBPACK_IMPORTED_MODULE_0__["is"].object, 'detach(eff): argument must be a fork effect');
	  eff[FORK].detached = true;
	  return eff;
	};
	
	function take() {
	  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';
	
	  if (arguments.length) {
	    Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(arguments[0], _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
	  }
	  if (_utils__WEBPACK_IMPORTED_MODULE_0__["is"].pattern(patternOrChannel)) {
	    return effect(TAKE, { pattern: patternOrChannel });
	  }
	  if (_utils__WEBPACK_IMPORTED_MODULE_0__["is"].channel(patternOrChannel)) {
	    return effect(TAKE, { channel: patternOrChannel });
	  }
	  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
	}
	
	take.maybe = function () {
	  var eff = take.apply(undefined, arguments);
	  eff[TAKE].maybe = true;
	  return eff;
	};
	
	var takem = /*#__PURE__*/Object(_utils__WEBPACK_IMPORTED_MODULE_0__["deprecate"])(take.maybe, /*#__PURE__*/Object(_utils__WEBPACK_IMPORTED_MODULE_0__["updateIncentive"])('takem', 'take.maybe'));
	
	function put(channel, action) {
	  if (arguments.length > 1) {
	    Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(channel, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'put(channel, action): argument channel is undefined');
	    Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(channel, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
	    Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(action, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'put(channel, action): argument action is undefined');
	  } else {
	    Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(channel, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'put(action): argument action is undefined');
	    action = channel;
	    channel = null;
	  }
	  return effect(PUT, { channel: channel, action: action });
	}
	
	put.resolve = function () {
	  var eff = put.apply(undefined, arguments);
	  eff[PUT].resolve = true;
	  return eff;
	};
	
	put.sync = /*#__PURE__*/Object(_utils__WEBPACK_IMPORTED_MODULE_0__["deprecate"])(put.resolve, /*#__PURE__*/Object(_utils__WEBPACK_IMPORTED_MODULE_0__["updateIncentive"])('put.sync', 'put.resolve'));
	
	function all(effects) {
	  return effect(ALL, effects);
	}
	
	function race(effects) {
	  return effect(RACE, effects);
	}
	
	function getFnCallDesc(meth, fn, args) {
	  Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(fn, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, meth + ': argument fn is undefined');
	
	  var context = null;
	  if (_utils__WEBPACK_IMPORTED_MODULE_0__["is"].array(fn)) {
	    var _fn = fn;
	    context = _fn[0];
	    fn = _fn[1];
	  } else if (fn.fn) {
	    var _fn2 = fn;
	    context = _fn2.context;
	    fn = _fn2.fn;
	  }
	  if (context && _utils__WEBPACK_IMPORTED_MODULE_0__["is"].string(fn) && _utils__WEBPACK_IMPORTED_MODULE_0__["is"].func(context[fn])) {
	    fn = context[fn];
	  }
	  Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(fn, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].func, meth + ': argument ' + fn + ' is not a function');
	
	  return { context: context, fn: fn, args: args };
	}
	
	function call(fn) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return effect(CALL, getFnCallDesc('call', fn, args));
	}
	
	function apply(context, fn) {
	  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
	}
	
	function cps(fn) {
	  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    args[_key2 - 1] = arguments[_key2];
	  }
	
	  return effect(CPS, getFnCallDesc('cps', fn, args));
	}
	
	function fork(fn) {
	  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    args[_key3 - 1] = arguments[_key3];
	  }
	
	  return effect(FORK, getFnCallDesc('fork', fn, args));
	}
	
	function spawn(fn) {
	  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    args[_key4 - 1] = arguments[_key4];
	  }
	
	  return detach(fork.apply(undefined, [fn].concat(args)));
	}
	
	function join() {
	  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	    tasks[_key5] = arguments[_key5];
	  }
	
	  if (tasks.length > 1) {
	    return all(tasks.map(function (t) {
	      return join(t);
	    }));
	  }
	  var task = tasks[0];
	  Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(task, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'join(task): argument task is undefined');
	  Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(task, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
	  return effect(JOIN, task);
	}
	
	function cancel() {
	  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	    tasks[_key6] = arguments[_key6];
	  }
	
	  if (tasks.length > 1) {
	    return all(tasks.map(function (t) {
	      return cancel(t);
	    }));
	  }
	  var task = tasks[0];
	  if (tasks.length === 1) {
	    Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(task, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'cancel(task): argument task is undefined');
	    Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(task, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
	  }
	  return effect(CANCEL, task || _utils__WEBPACK_IMPORTED_MODULE_0__["SELF_CANCELLATION"]);
	}
	
	function select(selector) {
	  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
	    args[_key7 - 1] = arguments[_key7];
	  }
	
	  if (arguments.length === 0) {
	    selector = _utils__WEBPACK_IMPORTED_MODULE_0__["ident"];
	  } else {
	    Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(selector, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'select(selector,[...]): argument selector is undefined');
	    Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(selector, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].func, 'select(selector,[...]): argument ' + selector + ' is not a function');
	  }
	  return effect(SELECT, { selector: selector, args: args });
	}
	
	/**
	  channel(pattern, [buffer])    => creates an event channel for store actions
	**/
	function actionChannel(pattern, buffer) {
	  Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(pattern, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
	  if (arguments.length > 1) {
	    Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(buffer, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
	    Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(buffer, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
	  }
	  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
	}
	
	function cancelled() {
	  return effect(CANCELLED, {});
	}
	
	function flush(channel) {
	  Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(channel, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].channel, 'flush(channel): argument ' + channel + ' is not valid channel');
	  return effect(FLUSH, channel);
	}
	
	function getContext(prop) {
	  Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(prop, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].string, 'getContext(prop): argument ' + prop + ' is not a string');
	  return effect(GET_CONTEXT, prop);
	}
	
	function setContext(props) {
	  Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(props, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].object, Object(_utils__WEBPACK_IMPORTED_MODULE_0__["createSetContextWarning"])(null, props));
	  return effect(SET_CONTEXT, props);
	}
	
	function takeEvery(patternOrChannel, worker) {
	  for (var _len8 = arguments.length, args = Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
	    args[_key8 - 2] = arguments[_key8];
	  }
	
	  return fork.apply(undefined, [_sagaHelpers__WEBPACK_IMPORTED_MODULE_1__["takeEveryHelper"], patternOrChannel, worker].concat(args));
	}
	
	function takeLatest(patternOrChannel, worker) {
	  for (var _len9 = arguments.length, args = Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
	    args[_key9 - 2] = arguments[_key9];
	  }
	
	  return fork.apply(undefined, [_sagaHelpers__WEBPACK_IMPORTED_MODULE_1__["takeLatestHelper"], patternOrChannel, worker].concat(args));
	}
	
	function throttle(ms, pattern, worker) {
	  for (var _len10 = arguments.length, args = Array(_len10 > 3 ? _len10 - 3 : 0), _key10 = 3; _key10 < _len10; _key10++) {
	    args[_key10 - 3] = arguments[_key10];
	  }
	
	  return fork.apply(undefined, [_sagaHelpers__WEBPACK_IMPORTED_MODULE_1__["throttleHelper"], ms, pattern, worker].concat(args));
	}
	
	var createAsEffectType = function createAsEffectType(type) {
	  return function (effect) {
	    return effect && effect[IO] && effect[type];
	  };
	};
	
	var asEffect = {
	  take: /*#__PURE__*/createAsEffectType(TAKE),
	  put: /*#__PURE__*/createAsEffectType(PUT),
	  all: /*#__PURE__*/createAsEffectType(ALL),
	  race: /*#__PURE__*/createAsEffectType(RACE),
	  call: /*#__PURE__*/createAsEffectType(CALL),
	  cps: /*#__PURE__*/createAsEffectType(CPS),
	  fork: /*#__PURE__*/createAsEffectType(FORK),
	  join: /*#__PURE__*/createAsEffectType(JOIN),
	  cancel: /*#__PURE__*/createAsEffectType(CANCEL),
	  select: /*#__PURE__*/createAsEffectType(SELECT),
	  actionChannel: /*#__PURE__*/createAsEffectType(ACTION_CHANNEL),
	  cancelled: /*#__PURE__*/createAsEffectType(CANCELLED),
	  flush: /*#__PURE__*/createAsEffectType(FLUSH),
	  getContext: /*#__PURE__*/createAsEffectType(GET_CONTEXT),
	  setContext: /*#__PURE__*/createAsEffectType(SET_CONTEXT)
	};
	
	/***/ }),
	
	/***/ "./node_modules/redux-saga/es/internal/sagaHelpers/fsmIterator.js":
	/*!************************************************************************!*\
	  !*** ./node_modules/redux-saga/es/internal/sagaHelpers/fsmIterator.js ***!
	  \************************************************************************/
	/*! exports provided: qEnd, safeName, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "qEnd", function() { return qEnd; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "safeName", function() { return safeName; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return fsmIterator; });
	/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils */ "./node_modules/redux-saga/es/internal/utils.js");
	
	
	var done = { done: true, value: undefined };
	var qEnd = {};
	
	function safeName(patternOrChannel) {
	  if (_utils__WEBPACK_IMPORTED_MODULE_0__["is"].channel(patternOrChannel)) {
	    return 'channel';
	  } else if (Array.isArray(patternOrChannel)) {
	    return String(patternOrChannel.map(function (entry) {
	      return String(entry);
	    }));
	  } else {
	    return String(patternOrChannel);
	  }
	}
	
	function fsmIterator(fsm, q0) {
	  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';
	
	  var updateState = void 0,
	      qNext = q0;
	
	  function next(arg, error) {
	    if (qNext === qEnd) {
	      return done;
	    }
	
	    if (error) {
	      qNext = qEnd;
	      throw error;
	    } else {
	      updateState && updateState(arg);
	
	      var _fsm$qNext = fsm[qNext](),
	          q = _fsm$qNext[0],
	          output = _fsm$qNext[1],
	          _updateState = _fsm$qNext[2];
	
	      qNext = q;
	      updateState = _updateState;
	      return qNext === qEnd ? done : output;
	    }
	  }
	
	  return Object(_utils__WEBPACK_IMPORTED_MODULE_0__["makeIterator"])(next, function (error) {
	    return next(null, error);
	  }, name, true);
	}
	
	/***/ }),
	
	/***/ "./node_modules/redux-saga/es/internal/sagaHelpers/index.js":
	/*!******************************************************************!*\
	  !*** ./node_modules/redux-saga/es/internal/sagaHelpers/index.js ***!
	  \******************************************************************/
	/*! exports provided: takeEvery, takeLatest, throttle, takeEveryHelper, takeLatestHelper, throttleHelper */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "takeEvery", function() { return takeEvery; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "takeLatest", function() { return takeLatest; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return throttle; });
	/* harmony import */ var _takeEvery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./takeEvery */ "./node_modules/redux-saga/es/internal/sagaHelpers/takeEvery.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "takeEveryHelper", function() { return _takeEvery__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _takeLatest__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./takeLatest */ "./node_modules/redux-saga/es/internal/sagaHelpers/takeLatest.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "takeLatestHelper", function() { return _takeLatest__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _throttle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./throttle */ "./node_modules/redux-saga/es/internal/sagaHelpers/throttle.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "throttleHelper", function() { return _throttle__WEBPACK_IMPORTED_MODULE_2__["default"]; });
	
	/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils */ "./node_modules/redux-saga/es/internal/utils.js");
	
	
	
	
	
	
	var deprecationWarning = function deprecationWarning(helperName) {
	  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
	};
	
	var takeEvery = /*#__PURE__*/Object(_utils__WEBPACK_IMPORTED_MODULE_3__["deprecate"])(_takeEvery__WEBPACK_IMPORTED_MODULE_0__["default"], /*#__PURE__*/deprecationWarning('takeEvery'));
	var takeLatest = /*#__PURE__*/Object(_utils__WEBPACK_IMPORTED_MODULE_3__["deprecate"])(_takeLatest__WEBPACK_IMPORTED_MODULE_1__["default"], /*#__PURE__*/deprecationWarning('takeLatest'));
	var throttle = /*#__PURE__*/Object(_utils__WEBPACK_IMPORTED_MODULE_3__["deprecate"])(_throttle__WEBPACK_IMPORTED_MODULE_2__["default"], /*#__PURE__*/deprecationWarning('throttle'));
	
	
	
	/***/ }),
	
	/***/ "./node_modules/redux-saga/es/internal/sagaHelpers/takeEvery.js":
	/*!**********************************************************************!*\
	  !*** ./node_modules/redux-saga/es/internal/sagaHelpers/takeEvery.js ***!
	  \**********************************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return takeEvery; });
	/* harmony import */ var _fsmIterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./fsmIterator */ "./node_modules/redux-saga/es/internal/sagaHelpers/fsmIterator.js");
	/* harmony import */ var _io__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../io */ "./node_modules/redux-saga/es/internal/io.js");
	/* harmony import */ var _channel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../channel */ "./node_modules/redux-saga/es/internal/channel.js");
	
	
	
	
	function takeEvery(patternOrChannel, worker) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var yTake = { done: false, value: Object(_io__WEBPACK_IMPORTED_MODULE_1__["take"])(patternOrChannel) };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io__WEBPACK_IMPORTED_MODULE_1__["fork"].apply(undefined, [worker].concat(args, [ac])) };
	  };
	
	  var action = void 0,
	      setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return Object(_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["default"])({
	    q1: function q1() {
	      return ['q2', yTake, setAction];
	    },
	    q2: function q2() {
	      return action === _channel__WEBPACK_IMPORTED_MODULE_2__["END"] ? [_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["qEnd"]] : ['q1', yFork(action)];
	    }
	  }, 'q1', 'takeEvery(' + Object(_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["safeName"])(patternOrChannel) + ', ' + worker.name + ')');
	}
	
	/***/ }),
	
	/***/ "./node_modules/redux-saga/es/internal/sagaHelpers/takeLatest.js":
	/*!***********************************************************************!*\
	  !*** ./node_modules/redux-saga/es/internal/sagaHelpers/takeLatest.js ***!
	  \***********************************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return takeLatest; });
	/* harmony import */ var _fsmIterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./fsmIterator */ "./node_modules/redux-saga/es/internal/sagaHelpers/fsmIterator.js");
	/* harmony import */ var _io__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../io */ "./node_modules/redux-saga/es/internal/io.js");
	/* harmony import */ var _channel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../channel */ "./node_modules/redux-saga/es/internal/channel.js");
	
	
	
	
	function takeLatest(patternOrChannel, worker) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var yTake = { done: false, value: Object(_io__WEBPACK_IMPORTED_MODULE_1__["take"])(patternOrChannel) };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io__WEBPACK_IMPORTED_MODULE_1__["fork"].apply(undefined, [worker].concat(args, [ac])) };
	  };
	  var yCancel = function yCancel(task) {
	    return { done: false, value: Object(_io__WEBPACK_IMPORTED_MODULE_1__["cancel"])(task) };
	  };
	
	  var task = void 0,
	      action = void 0;
	  var setTask = function setTask(t) {
	    return task = t;
	  };
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return Object(_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["default"])({
	    q1: function q1() {
	      return ['q2', yTake, setAction];
	    },
	    q2: function q2() {
	      return action === _channel__WEBPACK_IMPORTED_MODULE_2__["END"] ? [_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["qEnd"]] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
	    },
	    q3: function q3() {
	      return ['q1', yFork(action), setTask];
	    }
	  }, 'q1', 'takeLatest(' + Object(_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["safeName"])(patternOrChannel) + ', ' + worker.name + ')');
	}
	
	/***/ }),
	
	/***/ "./node_modules/redux-saga/es/internal/sagaHelpers/throttle.js":
	/*!*********************************************************************!*\
	  !*** ./node_modules/redux-saga/es/internal/sagaHelpers/throttle.js ***!
	  \*********************************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return throttle; });
	/* harmony import */ var _fsmIterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./fsmIterator */ "./node_modules/redux-saga/es/internal/sagaHelpers/fsmIterator.js");
	/* harmony import */ var _io__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../io */ "./node_modules/redux-saga/es/internal/io.js");
	/* harmony import */ var _channel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../channel */ "./node_modules/redux-saga/es/internal/channel.js");
	/* harmony import */ var _buffers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../buffers */ "./node_modules/redux-saga/es/internal/buffers.js");
	/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../utils */ "./node_modules/redux-saga/es/internal/utils.js");
	
	
	
	
	
	
	function throttle(delayLength, pattern, worker) {
	  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    args[_key - 3] = arguments[_key];
	  }
	
	  var action = void 0,
	      channel = void 0;
	
	  var yActionChannel = { done: false, value: Object(_io__WEBPACK_IMPORTED_MODULE_1__["actionChannel"])(pattern, _buffers__WEBPACK_IMPORTED_MODULE_3__["buffers"].sliding(1)) };
	  var yTake = function yTake() {
	    return { done: false, value: Object(_io__WEBPACK_IMPORTED_MODULE_1__["take"])(channel) };
	  };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io__WEBPACK_IMPORTED_MODULE_1__["fork"].apply(undefined, [worker].concat(args, [ac])) };
	  };
	  var yDelay = { done: false, value: Object(_io__WEBPACK_IMPORTED_MODULE_1__["call"])(_utils__WEBPACK_IMPORTED_MODULE_4__["delay"], delayLength) };
	
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	  var setChannel = function setChannel(ch) {
	    return channel = ch;
	  };
	
	  return Object(_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["default"])({
	    q1: function q1() {
	      return ['q2', yActionChannel, setChannel];
	    },
	    q2: function q2() {
	      return ['q3', yTake(), setAction];
	    },
	    q3: function q3() {
	      return action === _channel__WEBPACK_IMPORTED_MODULE_2__["END"] ? [_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["qEnd"]] : ['q4', yFork(action)];
	    },
	    q4: function q4() {
	      return ['q2', yDelay];
	    }
	  }, 'q1', 'throttle(' + Object(_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["safeName"])(pattern) + ', ' + worker.name + ')');
	}
	
	/***/ }),
	
	/***/ "./node_modules/redux-saga/es/internal/scheduler.js":
	/*!**********************************************************!*\
	  !*** ./node_modules/redux-saga/es/internal/scheduler.js ***!
	  \**********************************************************/
	/*! exports provided: asap, suspend, flush */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asap", function() { return asap; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "suspend", function() { return suspend; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return flush; });
	var queue = [];
	/**
	  Variable to hold a counting semaphore
	  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
	    already suspended)
	  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
	    triggers flushing the queued tasks.
	**/
	var semaphore = 0;
	
	/**
	  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
	  and flushed after this task has finished (assuming the scheduler endup in a released
	  state).
	**/
	function exec(task) {
	  try {
	    suspend();
	    task();
	  } finally {
	    release();
	  }
	}
	
	/**
	  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
	**/
	function asap(task) {
	  queue.push(task);
	
	  if (!semaphore) {
	    suspend();
	    flush();
	  }
	}
	
	/**
	  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
	  scheduler is released.
	**/
	function suspend() {
	  semaphore++;
	}
	
	/**
	  Puts the scheduler in a `released` state.
	**/
	function release() {
	  semaphore--;
	}
	
	/**
	  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
	**/
	function flush() {
	  release();
	
	  var task = void 0;
	  while (!semaphore && (task = queue.shift()) !== undefined) {
	    exec(task);
	  }
	}
	
	/***/ }),
	
	/***/ "./node_modules/redux-saga/es/internal/utils.js":
	/*!******************************************************!*\
	  !*** ./node_modules/redux-saga/es/internal/utils.js ***!
	  \******************************************************/
	/*! exports provided: sym, TASK, HELPER, MATCH, CANCEL, SAGA_ACTION, SELF_CANCELLATION, konst, kTrue, kFalse, noop, ident, check, hasOwn, is, object, remove, array, deferred, arrayOfDeffered, delay, createMockTask, autoInc, uid, makeIterator, log, deprecate, updateIncentive, internalErr, createSetContextWarning, wrapSagaDispatch, cloneableGenerator */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sym", function() { return sym; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TASK", function() { return TASK; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HELPER", function() { return HELPER; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MATCH", function() { return MATCH; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CANCEL", function() { return CANCEL; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAGA_ACTION", function() { return SAGA_ACTION; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SELF_CANCELLATION", function() { return SELF_CANCELLATION; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "konst", function() { return konst; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "kTrue", function() { return kTrue; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "kFalse", function() { return kFalse; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "noop", function() { return noop; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ident", function() { return ident; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "check", function() { return check; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasOwn", function() { return hasOwn; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "is", function() { return is; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "object", function() { return object; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "remove", function() { return remove; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "array", function() { return array; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deferred", function() { return deferred; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayOfDeffered", function() { return arrayOfDeffered; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return delay; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createMockTask", function() { return createMockTask; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "autoInc", function() { return autoInc; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uid", function() { return uid; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeIterator", function() { return makeIterator; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "log", function() { return log; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deprecate", function() { return deprecate; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateIncentive", function() { return updateIncentive; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "internalErr", function() { return internalErr; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSetContextWarning", function() { return createSetContextWarning; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrapSagaDispatch", function() { return wrapSagaDispatch; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneableGenerator", function() { return cloneableGenerator; });
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var sym = function sym(id) {
	  return '@@redux-saga/' + id;
	};
	
	var TASK = /*#__PURE__*/sym('TASK');
	var HELPER = /*#__PURE__*/sym('HELPER');
	var MATCH = /*#__PURE__*/sym('MATCH');
	var CANCEL = /*#__PURE__*/sym('CANCEL_PROMISE');
	var SAGA_ACTION = /*#__PURE__*/sym('SAGA_ACTION');
	var SELF_CANCELLATION = /*#__PURE__*/sym('SELF_CANCELLATION');
	var konst = function konst(v) {
	  return function () {
	    return v;
	  };
	};
	var kTrue = /*#__PURE__*/konst(true);
	var kFalse = /*#__PURE__*/konst(false);
	var noop = function noop() {};
	var ident = function ident(v) {
	  return v;
	};
	
	function check(value, predicate, error) {
	  if (!predicate(value)) {
	    log('error', 'uncaught at check', error);
	    throw new Error(error);
	  }
	}
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	function hasOwn(object, property) {
	  return is.notUndef(object) && hasOwnProperty.call(object, property);
	}
	
	var is = {
	  undef: function undef(v) {
	    return v === null || v === undefined;
	  },
	  notUndef: function notUndef(v) {
	    return v !== null && v !== undefined;
	  },
	  func: function func(f) {
	    return typeof f === 'function';
	  },
	  number: function number(n) {
	    return typeof n === 'number';
	  },
	  string: function string(s) {
	    return typeof s === 'string';
	  },
	  array: Array.isArray,
	  object: function object(obj) {
	    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
	  },
	  promise: function promise(p) {
	    return p && is.func(p.then);
	  },
	  iterator: function iterator(it) {
	    return it && is.func(it.next) && is.func(it.throw);
	  },
	  iterable: function iterable(it) {
	    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
	  },
	  task: function task(t) {
	    return t && t[TASK];
	  },
	  observable: function observable(ob) {
	    return ob && is.func(ob.subscribe);
	  },
	  buffer: function buffer(buf) {
	    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
	  },
	  pattern: function pattern(pat) {
	    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
	  },
	  channel: function channel(ch) {
	    return ch && is.func(ch.take) && is.func(ch.close);
	  },
	  helper: function helper(it) {
	    return it && it[HELPER];
	  },
	  stringableFunc: function stringableFunc(f) {
	    return is.func(f) && hasOwn(f, 'toString');
	  }
	};
	
	var object = {
	  assign: function assign(target, source) {
	    for (var i in source) {
	      if (hasOwn(source, i)) {
	        target[i] = source[i];
	      }
	    }
	  }
	};
	
	function remove(array, item) {
	  var index = array.indexOf(item);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	}
	
	var array = {
	  from: function from(obj) {
	    var arr = Array(obj.length);
	    for (var i in obj) {
	      if (hasOwn(obj, i)) {
	        arr[i] = obj[i];
	      }
	    }
	    return arr;
	  }
	};
	
	function deferred() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var def = _extends({}, props);
	  var promise = new Promise(function (resolve, reject) {
	    def.resolve = resolve;
	    def.reject = reject;
	  });
	  def.promise = promise;
	  return def;
	}
	
	function arrayOfDeffered(length) {
	  var arr = [];
	  for (var i = 0; i < length; i++) {
	    arr.push(deferred());
	  }
	  return arr;
	}
	
	function delay(ms) {
	  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  var timeoutId = void 0;
	  var promise = new Promise(function (resolve) {
	    timeoutId = setTimeout(function () {
	      return resolve(val);
	    }, ms);
	  });
	
	  promise[CANCEL] = function () {
	    return clearTimeout(timeoutId);
	  };
	
	  return promise;
	}
	
	function createMockTask() {
	  var _ref;
	
	  var running = true;
	  var _result = void 0,
	      _error = void 0;
	
	  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
	    return running;
	  }, _ref.result = function result() {
	    return _result;
	  }, _ref.error = function error() {
	    return _error;
	  }, _ref.setRunning = function setRunning(b) {
	    return running = b;
	  }, _ref.setResult = function setResult(r) {
	    return _result = r;
	  }, _ref.setError = function setError(e) {
	    return _error = e;
	  }, _ref;
	}
	
	function autoInc() {
	  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = /*#__PURE__*/autoInc();
	
	var kThrow = function kThrow(err) {
	  throw err;
	};
	var kReturn = function kReturn(value) {
	  return { value: value, done: true };
	};
	function makeIterator(next) {
	  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
	  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var isHelper = arguments[3];
	
	  var iterator = { name: name, next: next, throw: thro, return: kReturn };
	
	  if (isHelper) {
	    iterator[HELPER] = true;
	  }
	  if (typeof Symbol !== 'undefined') {
	    iterator[Symbol.iterator] = function () {
	      return iterator;
	    };
	  }
	  return iterator;
	}
	
	/**
	  Print error in a useful way whether in a browser environment
	  (with expandable error stack traces), or in a node.js environment
	  (text-only log output)
	 **/
	function log(level, message) {
	  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  /*eslint-disable no-console*/
	  if (typeof window === 'undefined') {
	    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
	  } else {
	    console[level](message, error);
	  }
	}
	
	function deprecate(fn, deprecationWarning) {
	  return function () {
	    if (true) log('warn', deprecationWarning);
	    return fn.apply(undefined, arguments);
	  };
	}
	
	var updateIncentive = function updateIncentive(deprecated, preferred) {
	  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
	};
	
	var internalErr = function internalErr(err) {
	  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
	};
	
	var createSetContextWarning = function createSetContextWarning(ctx, props) {
	  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
	};
	
	var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
	  return function (action) {
	    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
	  };
	};
	
	var cloneableGenerator = function cloneableGenerator(generatorFunc) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var history = [];
	    var gen = generatorFunc.apply(undefined, args);
	    return {
	      next: function next(arg) {
	        history.push(arg);
	        return gen.next(arg);
	      },
	      clone: function clone() {
	        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
	        history.forEach(function (arg) {
	          return clonedGen.next(arg);
	        });
	        return clonedGen;
	      },
	      return: function _return(value) {
	        return gen.return(value);
	      },
	      throw: function _throw(exception) {
	        return gen.throw(exception);
	      }
	    };
	  };
	};
	
	/***/ }),
	
	/***/ "./node_modules/regenerator-runtime/runtime-module.js":
	/*!************************************************************!*\
	  !*** ./node_modules/regenerator-runtime/runtime-module.js ***!
	  \************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(/*! ./runtime */ "./node_modules/regenerator-runtime/runtime.js");
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	
	/***/ }),
	
	/***/ "./node_modules/regenerator-runtime/runtime.js":
	/*!*****************************************************!*\
	  !*** ./node_modules/regenerator-runtime/runtime.js ***!
	  \*****************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);
	
	
	/***/ }),
	
	/***/ "./src/Drizzle.js":
	/*!************************!*\
	  !*** ./src/Drizzle.js ***!
	  \************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ "./node_modules/babel-runtime/core-js/promise.js");
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Load as promise so that async Drizzle initialization can still resolve
	var windowPromise = new _promise2.default(function (resolve, reject) {
	  window.addEventListener('load', resolve);
	});
	
	var Drizzle = function () {
	  function Drizzle(options, store) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, Drizzle);
	
	    // Variables
	    this.contracts = {};
	    this.contractList = [];
	    this.options = options;
	    this.store = store;
	    this.web3 = {};
	
	    this.loadingContract = {};
	
	    // Wait for window load event in case of injected web3.
	    windowPromise.then(function () {
	      // Begin Drizzle initialization.
	      store.dispatch({ type: 'DRIZZLE_INITIALIZING', drizzle: _this, options: options });
	    });
	  }
	
	  (0, _createClass3.default)(Drizzle, [{
	    key: 'addContract',
	    value: function addContract(contractConfig) {
	      var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	      this.store.dispatch({ type: 'ADD_CONTRACT', drizzle: this, contractConfig: contractConfig, events: events, web3: this.web3 });
	    }
	  }, {
	    key: '_addContract',
	    value: function _addContract(drizzleContract) {
	      if (this.contracts[drizzleContract.contractName]) {
	        throw 'Contract already exists: ' + drizzleContract.contractName;
	      }
	      this.contracts[drizzleContract.contractName] = drizzleContract;
	      this.contractList.push(drizzleContract);
	    }
	  }, {
	    key: 'findContractByAddress',
	    value: function findContractByAddress(address) {
	      return this.contractList.find(function (contract) {
	        return contract.address.toLowerCase() === address.toLowerCase();
	      });
	    }
	  }]);
	  return Drizzle;
	}();
	
	exports.default = Drizzle;
	
	/***/ }),
	
	/***/ "./src/DrizzleContract.js":
	/*!********************************!*\
	  !*** ./src/DrizzleContract.js ***!
	  \********************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(/*! babel-runtime/core-js/json/stringify */ "./node_modules/babel-runtime/core-js/json/stringify.js");
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(/*! babel-runtime/helpers/typeof */ "./node_modules/babel-runtime/helpers/typeof.js");
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ "./node_modules/babel-runtime/core-js/object/assign.js");
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ "./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ "./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DrizzleContract = function () {
	  function DrizzleContract(web3Contract, web3, name, store) {
	    var events = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	    var contractArtifact = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	    (0, _classCallCheck3.default)(this, DrizzleContract);
	
	    this.abi = web3Contract.options.jsonInterface;
	    this.address = web3Contract.options.address;
	    this.web3 = web3;
	    this.contractName = name;
	    this.contractArtifact = contractArtifact;
	    this.store = store;
	
	    // Merge web3 contract instance into DrizzleContract instance.
	    (0, _assign2.default)(this, web3Contract);
	
	    for (var i = 0; i < this.abi.length; i++) {
	      var item = this.abi[i];
	
	      if (item.type == "function" && item.constant === true) {
	        this.methods[item.name].cacheCall = this.cacheCallFunction(item.name, i);
	      }
	
	      if (item.type == "function" && item.constant === false) {
	        this.methods[item.name].cacheSend = this.cacheSendFunction(item.name, i);
	      }
	    }
	
	    // Register event listeners if any events.
	    if (events.length > 0) {
	      for (i = 0; i < events.length; i++) {
	        var event = events[i];
	
	        if ((typeof event === "undefined" ? "undefined" : (0, _typeof3.default)(event)) === 'object') {
	          store.dispatch({ type: 'LISTEN_FOR_EVENT', contract: this, eventName: event.eventName, eventOptions: event.eventOptions });
	        } else {
	          store.dispatch({ type: 'LISTEN_FOR_EVENT', contract: this, eventName: event });
	        }
	      }
	    }
	  }
	
	  (0, _createClass3.default)(DrizzleContract, [{
	    key: "cacheCallFunction",
	    value: function cacheCallFunction(fnName, fnIndex, fn) {
	      var contract = this;
	
	      return function () {
	        // Collect args and hash to use as key, 0x0 if no args
	        var argsHash = '0x0';
	        var args = arguments;
	
	        if (args.length > 0) {
	          argsHash = contract.generateArgsHash(args);
	        }
	        var contractName = contract.contractName;
	        var functionState = contract.store.getState().contracts[contractName][fnName];
	
	        // If call result is in state and fresh, return value instead of calling
	        if (argsHash in functionState) {
	          if (contract.store.getState().contracts[contractName].synced === true) {
	            return argsHash;
	          }
	        }
	
	        // Otherwise, call function and update store
	        contract.store.dispatch({ type: 'CALL_CONTRACT_FN', contract: contract, fnName: fnName, fnIndex: fnIndex, args: args, argsHash: argsHash });
	
	        // Return nothing because state is currently empty.
	        return argsHash;
	      };
	    }
	  }, {
	    key: "cacheSendFunction",
	    value: function cacheSendFunction(fnName, fnIndex, fn) {
	      // NOTE: May not need fn index
	      var contract = this;
	
	      return function () {
	        var args = arguments;
	
	        // Generate temporary ID
	        var stackId = contract.store.getState().transactionStack.length;
	
	        // Add ID to "transactionStack" with empty value
	        contract.store.dispatch({ type: 'PUSH_TO_STACK' });
	
	        // Dispatch tx to saga
	        // When txhash received, will be value of stack ID
	        contract.store.dispatch({ type: 'SEND_CONTRACT_TX', contract: contract, fnName: fnName, fnIndex: fnIndex, args: args, stackId: stackId });
	
	        // return stack ID
	        return stackId;
	      };
	    }
	  }, {
	    key: "generateArgsHash",
	    value: function generateArgsHash(args) {
	      var web3 = this.web3;
	      var hashString = '';
	
	      for (var i = 0; i < args.length; i++) {
	        if (typeof args[i] !== 'function') {
	          var argToHash = args[i];
	
	          // Stringify objects to allow hashing
	          if ((typeof argToHash === "undefined" ? "undefined" : (0, _typeof3.default)(argToHash)) === 'object') {
	            argToHash = (0, _stringify2.default)(argToHash);
	          }
	
	          // Convert number to strong to allow hashing
	          if (typeof argToHash === 'number') {
	            argToHash = argToHash.toString();
	          }
	
	          // This check is in place for web3 v0.x
	          if ('utils' in web3) {
	            var hashPiece = web3.utils.sha3(argToHash);
	          } else {
	            var hashPiece = web3.sha3(argToHash);
	          }
	
	          hashString += hashPiece;
	        }
	      }
	
	      return web3.utils.sha3(hashString);
	    }
	  }]);
	  return DrizzleContract;
	}();
	
	exports.default = DrizzleContract;
	
	/***/ }),
	
	/***/ "./src/accountBalances/accountBalancesReducer.js":
	/*!*******************************************************!*\
	  !*** ./src/accountBalances/accountBalancesReducer.js ***!
	  \*******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(/*! babel-runtime/helpers/defineProperty */ "./node_modules/babel-runtime/helpers/defineProperty.js");
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(/*! babel-runtime/helpers/extends */ "./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {};
	
	var accountBalancesReducer = function accountBalancesReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  if (action.type === 'ACCOUNT_BALANCE_FETCHED') {
	    return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.account, action.accountBalance));
	  }
	
	  return state;
	};
	
	exports.default = accountBalancesReducer;
	
	/***/ }),
	
	/***/ "./src/accountBalances/accountBalancesSaga.js":
	/*!****************************************************!*\
	  !*** ./src/accountBalances/accountBalancesSaga.js ***!
	  \****************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ "./node_modules/babel-runtime/regenerator/index.js");
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.getAccountBalances = getAccountBalances;
	
	var _effects = __webpack_require__(/*! redux-saga/effects */ "./node_modules/redux-saga/es/effects.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(getAccountBalances),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(accountBalancesSaga);
	
	function getAccountBalances(action) {
	  var accounts, web3, i, account, accountBalance;
	  return _regenerator2.default.wrap(function getAccountBalances$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(getAccountsState);
	
	        case 2:
	          accounts = _context.sent;
	          web3 = action.web3;
	
	
	          if (!accounts) {
	            console.error('No accounts found while attempting to fetch balances!');
	          }
	
	          _context.prev = 5;
	          _context.t0 = _regenerator2.default.keys(accounts);
	
	        case 7:
	          if ((_context.t1 = _context.t0()).done) {
	            _context.next = 17;
	            break;
	          }
	
	          i = _context.t1.value;
	          account = accounts[i];
	          _context.next = 12;
	          return (0, _effects.call)(web3.eth.getBalance, account);
	
	        case 12:
	          accountBalance = _context.sent;
	          _context.next = 15;
	          return (0, _effects.put)({ type: 'ACCOUNT_BALANCE_FETCHED', account: account, accountBalance: accountBalance });
	
	        case 15:
	          _context.next = 7;
	          break;
	
	        case 17:
	          _context.next = 25;
	          break;
	
	        case 19:
	          _context.prev = 19;
	          _context.t2 = _context['catch'](5);
	          _context.next = 23;
	          return (0, _effects.put)({ type: 'ACCOUNT_BALANCE_FAILED', error: _context.t2 });
	
	        case 23:
	          console.error('Error fetching account ' + account + ' balance:');
	          console.error(_context.t2);
	
	        case 25:
	          _context.next = 27;
	          return (0, _effects.put)({ type: 'ACCOUNT_BALANCES_FETCHED' });
	
	        case 27:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this, [[5, 19]]);
	}
	
	var getAccountsState = function getAccountsState(state) {
	  return state.accounts;
	};
	
	function accountBalancesSaga() {
	  return _regenerator2.default.wrap(function accountBalancesSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)('ACCOUNT_BALANCES_FETCHING', getAccountBalances);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	exports.default = accountBalancesSaga;
	
	/***/ }),
	
	/***/ "./src/accounts/accountsReducer.js":
	/*!*****************************************!*\
	  !*** ./src/accounts/accountsReducer.js ***!
	  \*****************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ "./node_modules/babel-runtime/core-js/object/assign.js");
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {};
	
	var accountsReducer = function accountsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  if (action.type === 'ACCOUNTS_FETCHING') {
	    return state;
	  }
	
	  if (action.type === 'ACCOUNTS_FETCHED') {
	    return (0, _assign2.default)({}, state, action.accounts);
	  }
	
	  return state;
	};
	
	exports.default = accountsReducer;
	
	/***/ }),
	
	/***/ "./src/accounts/accountsSaga.js":
	/*!**************************************!*\
	  !*** ./src/accounts/accountsSaga.js ***!
	  \**************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ "./node_modules/babel-runtime/regenerator/index.js");
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.getAccounts = getAccounts;
	
	var _reduxSaga = __webpack_require__(/*! redux-saga */ "redux-saga");
	
	var _effects = __webpack_require__(/*! redux-saga/effects */ "./node_modules/redux-saga/es/effects.js");
	
	var _accountBalancesSaga = __webpack_require__(/*! ../accountBalances/accountBalancesSaga */ "./src/accountBalances/accountBalancesSaga.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(getAccounts),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(createAccountsPollChannel),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(callCreateAccountsPollChannel),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(accountsSaga);
	
	/*
	 * Fetch Accounts List
	 */
	
	function getAccounts(action) {
	  var web3, accounts;
	  return _regenerator2.default.wrap(function getAccounts$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          web3 = action.web3;
	          _context.prev = 1;
	          _context.next = 4;
	          return (0, _effects.call)(web3.eth.getAccounts);
	
	        case 4:
	          accounts = _context.sent;
	
	          if (accounts) {
	            _context.next = 7;
	            break;
	          }
	
	          throw 'No accounts found!';
	
	        case 7:
	          _context.next = 9;
	          return (0, _effects.put)({ type: 'ACCOUNTS_FETCHED', accounts: accounts });
	
	        case 9:
	          _context.next = 17;
	          break;
	
	        case 11:
	          _context.prev = 11;
	          _context.t0 = _context['catch'](1);
	          _context.next = 15;
	          return (0, _effects.put)({ type: 'ACCOUNTS_FAILED', error: _context.t0 });
	
	        case 15:
	          console.error('Error fetching accounts:');
	          console.error(_context.t0);
	
	        case 17:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this, [[1, 11]]);
	}
	
	/*
	 * Poll for Account Changes
	 */
	
	function createAccountsPollChannel(_ref) {
	  var interval = _ref.interval,
	      web3 = _ref.web3;
	  return _regenerator2.default.wrap(function createAccountsPollChannel$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          return _context2.abrupt('return', (0, _reduxSaga.eventChannel)(function (emit) {
	            var persistedWeb3 = web3;
	
	            var accountsPoller = setInterval(function () {
	              emit({ type: 'SYNCING_ACCOUNTS', persistedWeb3: persistedWeb3 });
	            }, interval); // options.polls.accounts
	
	            var unsubscribe = function unsubscribe() {
	              clearInterval(accountsPoller);
	            };
	
	            return unsubscribe;
	          }));
	
	        case 1:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function callCreateAccountsPollChannel(_ref2) {
	  var interval = _ref2.interval,
	      web3 = _ref2.web3;
	  var accountsChannel, event;
	  return _regenerator2.default.wrap(function callCreateAccountsPollChannel$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.call)(createAccountsPollChannel, { interval: interval, web3: web3 });
	
	        case 2:
	          accountsChannel = _context3.sent;
	          _context3.prev = 3;
	
	        case 4:
	          if (false) {}
	
	          _context3.next = 7;
	          return (0, _effects.take)(accountsChannel);
	
	        case 7:
	          event = _context3.sent;
	
	          if (!(event.type === 'SYNCING_ACCOUNTS')) {
	            _context3.next = 13;
	            break;
	          }
	
	          _context3.next = 11;
	          return (0, _effects.call)(getAccounts, { web3: event.persistedWeb3 });
	
	        case 11:
	          _context3.next = 13;
	          return (0, _effects.call)(_accountBalancesSaga.getAccountBalances, { web3: event.persistedWeb3 });
	
	        case 13:
	          _context3.next = 15;
	          return (0, _effects.put)(event);
	
	        case 15:
	          _context3.next = 4;
	          break;
	
	        case 17:
	          _context3.prev = 17;
	
	          accountsChannel.close();
	          return _context3.finish(17);
	
	        case 20:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this, [[3,, 17, 20]]);
	}
	
	function accountsSaga() {
	  return _regenerator2.default.wrap(function accountsSaga$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.takeLatest)('ACCOUNTS_FETCHING', getAccounts);
	
	        case 2:
	          _context4.next = 4;
	          return (0, _effects.takeLatest)('ACCOUNTS_POLLING', callCreateAccountsPollChannel);
	
	        case 4:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	exports.default = accountsSaga;
	
	/***/ }),
	
	/***/ "./src/blocks/blocksSaga.js":
	/*!**********************************!*\
	  !*** ./src/blocks/blocksSaga.js ***!
	  \**********************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(/*! babel-runtime/core-js/object/keys */ "./node_modules/babel-runtime/core-js/object/keys.js");
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ "./node_modules/babel-runtime/regenerator/index.js");
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _reduxSaga = __webpack_require__(/*! redux-saga */ "redux-saga");
	
	var _effects = __webpack_require__(/*! redux-saga/effects */ "./node_modules/redux-saga/es/effects.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(callCreateBlockChannel),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(callCreateBlockPollChannel),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(processBlockHeader),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(processBlock),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(blocksSaga);
	
	var BlockTracker = __webpack_require__(/*! eth-block-tracker */ "eth-block-tracker");
	
	/*
	 * Listen for Blocks
	 */
	
	function createBlockChannel(_ref) {
	  var drizzle = _ref.drizzle,
	      web3 = _ref.web3,
	      syncAlways = _ref.syncAlways;
	
	  return (0, _reduxSaga.eventChannel)(function (emit) {
	    var blockEvents = web3.eth.subscribe('newBlockHeaders', function (error, result) {
	      if (error) {
	        emit({ type: 'BLOCKS_FAILED', error: error });
	
	        console.error('Error in block header subscription:');
	        console.error(error);
	
	        emit(_reduxSaga.END);
	      }
	    }).on('data', function (blockHeader) {
	      emit({ type: 'BLOCK_RECEIVED', blockHeader: blockHeader, drizzle: drizzle, web3: web3, syncAlways: syncAlways });
	    }).on('error', function (error) {
	      emit({ type: 'BLOCKS_FAILED', error: error });
	      emit(_reduxSaga.END);
	    });
	
	    var unsubscribe = function unsubscribe() {
	      blockEvents.off();
	    };
	
	    return unsubscribe;
	  });
	}
	
	function callCreateBlockChannel(_ref2) {
	  var drizzle = _ref2.drizzle,
	      web3 = _ref2.web3,
	      syncAlways = _ref2.syncAlways;
	  var blockChannel, event;
	  return _regenerator2.default.wrap(function callCreateBlockChannel$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.call)(createBlockChannel, { drizzle: drizzle, web3: web3, syncAlways: syncAlways });
	
	        case 2:
	          blockChannel = _context.sent;
	          _context.prev = 3;
	
	        case 4:
	          if (false) {}
	
	          _context.next = 7;
	          return (0, _effects.take)(blockChannel);
	
	        case 7:
	          event = _context.sent;
	          _context.next = 10;
	          return (0, _effects.put)(event);
	
	        case 10:
	          _context.next = 4;
	          break;
	
	        case 12:
	          _context.prev = 12;
	
	          blockChannel.close();
	          return _context.finish(12);
	
	        case 15:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this, [[3,, 12, 15]]);
	}
	
	/*
	 * Poll for Blocks
	 */
	
	function createBlockPollChannel(_ref3) {
	  var drizzle = _ref3.drizzle,
	      interval = _ref3.interval,
	      web3 = _ref3.web3,
	      syncAlways = _ref3.syncAlways;
	
	  return (0, _reduxSaga.eventChannel)(function (emit) {
	    var blockTracker = new BlockTracker({ provider: web3.currentProvider, pollingInterval: interval });
	
	    blockTracker.on('latest', function (block) {
	      emit({ type: 'BLOCK_FOUND', block: block, drizzle: drizzle, web3: web3, syncAlways: syncAlways });
	    });
	
	    blockTracker.start().catch(function (error) {
	      emit({ type: 'BLOCKS_FAILED', error: error });
	      emit(_reduxSaga.END);
	    });
	
	    var unsubscribe = function unsubscribe() {
	      blockTracker.stop();
	    };
	
	    return unsubscribe;
	  });
	}
	
	function callCreateBlockPollChannel(_ref4) {
	  var drizzle = _ref4.drizzle,
	      interval = _ref4.interval,
	      web3 = _ref4.web3,
	      syncAlways = _ref4.syncAlways;
	  var blockChannel, event;
	  return _regenerator2.default.wrap(function callCreateBlockPollChannel$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.call)(createBlockPollChannel, { drizzle: drizzle, interval: interval, web3: web3, syncAlways: syncAlways });
	
	        case 2:
	          blockChannel = _context2.sent;
	          _context2.prev = 3;
	
	        case 4:
	          if (false) {}
	
	          _context2.next = 7;
	          return (0, _effects.take)(blockChannel);
	
	        case 7:
	          event = _context2.sent;
	          _context2.next = 10;
	          return (0, _effects.put)(event);
	
	        case 10:
	          _context2.next = 4;
	          break;
	
	        case 12:
	          _context2.prev = 12;
	
	          blockChannel.close();
	          return _context2.finish(12);
	
	        case 15:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this, [[3,, 12, 15]]);
	}
	
	/*
	 * Process Blocks
	 */
	
	function processBlockHeader(_ref5) {
	  var blockHeader = _ref5.blockHeader,
	      drizzle = _ref5.drizzle,
	      web3 = _ref5.web3,
	      syncAlways = _ref5.syncAlways;
	  var blockNumber, block;
	  return _regenerator2.default.wrap(function processBlockHeader$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          blockNumber = blockHeader.number;
	          _context3.prev = 1;
	          _context3.next = 4;
	          return (0, _effects.call)(web3.eth.getBlock, blockNumber, true);
	
	        case 4:
	          block = _context3.sent;
	          _context3.next = 7;
	          return (0, _effects.call)(processBlock, { block: block, drizzle: drizzle, web3: web3, syncAlways: syncAlways });
	
	        case 7:
	          _context3.next = 16;
	          break;
	
	        case 9:
	          _context3.prev = 9;
	          _context3.t0 = _context3['catch'](1);
	
	          console.error('Error in block processing:');
	          console.error(_context3.t0);
	
	          _context3.next = 15;
	          return (0, _effects.put)({ type: 'BLOCK_FAILED', error: _context3.t0 });
	
	        case 15:
	          return _context3.abrupt('return');
	
	        case 16:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this, [[1, 9]]);
	}
	
	function processBlock(_ref6) {
	  var block = _ref6.block,
	      drizzle = _ref6.drizzle,
	      web3 = _ref6.web3,
	      syncAlways = _ref6.syncAlways;
	  var txs, i, from, fromContract, to, toContract;
	  return _regenerator2.default.wrap(function processBlock$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.prev = 0;
	
	          if (!syncAlways) {
	            _context4.next = 5;
	            break;
	          }
	
	          _context4.next = 4;
	          return (0, _effects.all)((0, _keys2.default)(drizzle.contracts).map(function (key) {
	            return (0, _effects.put)({ type: 'CONTRACT_SYNCING', contract: drizzle.contracts[key] });
	          }));
	
	        case 4:
	          return _context4.abrupt('return');
	
	        case 5:
	          txs = block.transactions;
	
	          if (!(txs.length > 0)) {
	            _context4.next = 22;
	            break;
	          }
	
	          i = 0;
	
	        case 8:
	          if (!(i < txs.length)) {
	            _context4.next = 22;
	            break;
	          }
	
	          from = txs[i].from || '';
	          fromContract = drizzle.findContractByAddress(from.toLowerCase());
	
	          if (!fromContract) {
	            _context4.next = 14;
	            break;
	          }
	
	          _context4.next = 14;
	          return (0, _effects.put)({ type: 'CONTRACT_SYNCING', contract: fromContract });
	
	        case 14:
	          to = txs[i].to || '';
	          toContract = drizzle.findContractByAddress(to.toLowerCase());
	
	          if (!toContract) {
	            _context4.next = 19;
	            break;
	          }
	
	          _context4.next = 19;
	          return (0, _effects.put)({ type: 'CONTRACT_SYNCING', contract: toContract });
	
	        case 19:
	          i++;
	          _context4.next = 8;
	          break;
	
	        case 22:
	          _context4.next = 31;
	          break;
	
	        case 24:
	          _context4.prev = 24;
	          _context4.t0 = _context4['catch'](0);
	
	          console.error('Error in block processing:');
	          console.error(_context4.t0);
	
	          _context4.next = 30;
	          return (0, _effects.put)({ type: 'BLOCK_FAILED', error: _context4.t0 });
	
	        case 30:
	          return _context4.abrupt('return');
	
	        case 31:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this, [[0, 24]]);
	}
	
	function blocksSaga() {
	  return _regenerator2.default.wrap(function blocksSaga$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.takeLatest)('BLOCKS_LISTENING', callCreateBlockChannel);
	
	        case 2:
	          _context5.next = 4;
	          return (0, _effects.takeEvery)('BLOCK_RECEIVED', processBlockHeader);
	
	        case 4:
	          _context5.next = 6;
	          return (0, _effects.takeLatest)('BLOCKS_POLLING', callCreateBlockPollChannel);
	
	        case 6:
	          _context5.next = 8;
	          return (0, _effects.takeEvery)('BLOCK_FOUND', processBlock);
	
	        case 8:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	exports.default = blocksSaga;
	
	/***/ }),
	
	/***/ "./src/contracts/contractsReducer.js":
	/*!*******************************************!*\
	  !*** ./src/contracts/contractsReducer.js ***!
	  \*******************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ "./node_modules/babel-runtime/helpers/toConsumableArray.js");
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _defineProperty2 = __webpack_require__(/*! babel-runtime/helpers/defineProperty */ "./node_modules/babel-runtime/helpers/defineProperty.js");
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends14 = __webpack_require__(/*! babel-runtime/helpers/extends */ "./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends15 = _interopRequireDefault(_extends14);
	
	var _generateContractInitialState = __webpack_require__(/*! ../generateContractInitialState */ "./src/generateContractInitialState.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {};
	
	var contractsReducer = function contractsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  /*
	   * Contract Status
	   */
	
	  if (action.type === 'CONTRACT_INITIALIZING') {
	    return (0, _extends15.default)({}, state, (0, _defineProperty3.default)({}, action.contractConfig.contractName, (0, _generateContractInitialState.generateContractInitialState)(action.contractConfig)));
	  }
	
	  if (action.type === 'CONTRACT_INITIALIZED') {
	    return (0, _extends15.default)({}, state, (0, _defineProperty3.default)({}, action.name, (0, _extends15.default)({}, state[action.name], {
	      initialized: true,
	      synced: true,
	      events: []
	    })));
	  }
	
	  if (action.type === 'CONTRACT_SYNCING') {
	    var contractName = action.contract.contractName;
	
	    return (0, _extends15.default)({}, state, (0, _defineProperty3.default)({}, contractName, (0, _extends15.default)({}, state[contractName], {
	      synced: false
	    })));
	  }
	
	  if (action.type === 'CONTRACT_SYNCED') {
	    return (0, _extends15.default)({}, state, (0, _defineProperty3.default)({}, action.contractName, (0, _extends15.default)({}, state[action.contractName], {
	      synced: true
	    })));
	  }
	
	  if (action.type === 'CONTRACT_SYNC_IND') {
	    return (0, _extends15.default)({}, state, (0, _defineProperty3.default)({}, action.contractName, (0, _extends15.default)({}, state[action.contractName], {
	      synced: false
	    })));
	  }
	
	  /*
	   * Contract Functions
	   */
	
	  if (action.type === 'GOT_CONTRACT_VAR') {
	    return (0, _extends15.default)({}, state, (0, _defineProperty3.default)({}, action.name, (0, _extends15.default)({}, state[action.name], (0, _defineProperty3.default)({}, action.variable, (0, _extends15.default)({}, state[action.name][action.variable], (0, _defineProperty3.default)({}, action.argsHash, (0, _extends15.default)({}, state[action.name][action.variable][action.argsHash], {
	      args: action.args,
	      fnIndex: action.fnIndex,
	      value: action.value
	    })))))));
	  }
	
	  if (action.type === 'ERROR_CONTRACT_VAR') {
	    return (0, _extends15.default)({}, state, (0, _defineProperty3.default)({}, action.name, (0, _extends15.default)({}, state[action.name], (0, _defineProperty3.default)({}, action.variable, (0, _extends15.default)({}, state[action.name][action.variable], (0, _defineProperty3.default)({}, action.argsHash, (0, _extends15.default)({}, state[action.name][action.variable][action.argsHash], {
	      args: action.args,
	      fnIndex: action.fnIndex,
	      error: action.error
	    })))))));
	  }
	
	  /*
	   * Contract Events
	   */
	
	  if (action.type === 'EVENT_FIRED') {
	    return (0, _extends15.default)({}, state, (0, _defineProperty3.default)({}, action.name, (0, _extends15.default)({}, state[action.name], {
	      events: [].concat((0, _toConsumableArray3.default)(state[action.name].events), [action.event])
	    })));
	  }
	
	  return state;
	};
	
	exports.default = contractsReducer;
	
	/***/ }),
	
	/***/ "./src/contracts/contractsSaga.js":
	/*!****************************************!*\
	  !*** ./src/contracts/contractsSaga.js ***!
	  \****************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ "./node_modules/babel-runtime/core-js/object/assign.js");
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(/*! babel-runtime/helpers/extends */ "./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ "./node_modules/babel-runtime/helpers/toConsumableArray.js");
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _typeof2 = __webpack_require__(/*! babel-runtime/helpers/typeof */ "./node_modules/babel-runtime/helpers/typeof.js");
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ "./node_modules/babel-runtime/regenerator/index.js");
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.addContract = addContract;
	exports.instantiateWeb3Contract = instantiateWeb3Contract;
	exports.instantiateContract = instantiateContract;
	
	var _reduxSaga = __webpack_require__(/*! redux-saga */ "redux-saga");
	
	var _effects = __webpack_require__(/*! redux-saga/effects */ "./node_modules/redux-saga/es/effects.js");
	
	var _DrizzleContract = __webpack_require__(/*! ../DrizzleContract */ "./src/DrizzleContract.js");
	
	var _DrizzleContract2 = _interopRequireDefault(_DrizzleContract);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(addContract),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(instantiateWeb3Contract),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(instantiateContract),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(callListenForContractEvent),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(callSendContractTx),
	    _marked6 = /*#__PURE__*/_regenerator2.default.mark(callCallContractFn),
	    _marked7 = /*#__PURE__*/_regenerator2.default.mark(callSyncContract),
	    _marked8 = /*#__PURE__*/_regenerator2.default.mark(contractsSaga);
	
	function addContract(_ref) {
	  var drizzle = _ref.drizzle,
	      contractConfig = _ref.contractConfig,
	      events = _ref.events,
	      web3 = _ref.web3;
	  var drizzleContract;
	  return _regenerator2.default.wrap(function addContract$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (!drizzle.loadingContract[contractConfig.contractName]) {
	            _context.next = 2;
	            break;
	          }
	
	          return _context.abrupt('return', false);
	
	        case 2:
	
	          drizzle.loadingContract[contractConfig.contractName] = true;
	
	          _context.next = 5;
	          return (0, _effects.put)({ type: 'CONTRACT_INITIALIZING', contractConfig: contractConfig });
	
	        case 5:
	          drizzleContract = void 0;
	
	          if (!contractConfig.web3Contract) {
	            _context.next = 12;
	            break;
	          }
	
	          _context.next = 9;
	          return (0, _effects.call)(instantiateWeb3Contract, { web3Contract: contractConfig.web3Contract, name: contractConfig.contractName, events: events, store: drizzle.store, web3: web3 });
	
	        case 9:
	          drizzleContract = _context.sent;
	          _context.next = 15;
	          break;
	
	        case 12:
	          _context.next = 14;
	          return (0, _effects.call)(instantiateContract, { contractArtifact: contractConfig, events: events, store: drizzle.store, web3: web3 });
	
	        case 14:
	          drizzleContract = _context.sent;
	
	        case 15:
	
	          drizzle._addContract(drizzleContract);
	
	          _context.next = 18;
	          return (0, _effects.put)({ type: 'CONTRACT_INITIALIZED', name: contractConfig.contractName });
	
	        case 18:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	/*
	 * Instantiation
	 */
	
	function instantiateWeb3Contract(_ref2) {
	  var web3Contract = _ref2.web3Contract,
	      name = _ref2.name,
	      events = _ref2.events,
	      store = _ref2.store,
	      web3 = _ref2.web3;
	  return _regenerator2.default.wrap(function instantiateWeb3Contract$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          return _context2.abrupt('return', new _DrizzleContract2.default(web3Contract, web3, name, store, events));
	
	        case 1:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function instantiateContract(_ref3) {
	  var contractArtifact = _ref3.contractArtifact,
	      events = _ref3.events,
	      store = _ref3.store,
	      web3 = _ref3.web3;
	  var networkId, web3Contract;
	  return _regenerator2.default.wrap(function instantiateContract$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.select)(getNetworkId);
	
	        case 2:
	          networkId = _context3.sent;
	
	
	          // Instantiate the contract.
	          web3Contract = new web3.eth.Contract(contractArtifact.abi, contractArtifact.networks[networkId].address, {
	            from: store.getState().accounts[0],
	            data: contractArtifact.deployedBytecode
	          });
	          return _context3.abrupt('return', new _DrizzleContract2.default(web3Contract, web3, contractArtifact.contractName, store, events, contractArtifact));
	
	        case 5:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	/*
	 * Events
	 */
	
	function createContractEventChannel(_ref4) {
	  var contract = _ref4.contract,
	      eventName = _ref4.eventName,
	      eventOptions = _ref4.eventOptions;
	
	  var name = contract.contractName;
	
	  return (0, _reduxSaga.eventChannel)(function (emit) {
	    var eventListener = contract.events[eventName](eventOptions).on('data', function (event) {
	      emit({ type: 'EVENT_FIRED', name: name, event: event });
	    }).on('changed', function (event) {
	      emit({ type: 'EVENT_CHANGED', name: name, event: event });
	    }).on('error', function (error) {
	      emit({ type: 'EVENT_ERROR', name: name, error: error });
	      emit(_reduxSaga.END);
	    });
	
	    var unsubscribe = function unsubscribe() {
	      eventListener.removeListener(eventName);
	    };
	
	    return unsubscribe;
	  });
	}
	
	function callListenForContractEvent(_ref5) {
	  var contract = _ref5.contract,
	      eventName = _ref5.eventName,
	      eventOptions = _ref5.eventOptions;
	  var contractEventChannel, event;
	  return _regenerator2.default.wrap(function callListenForContractEvent$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.call)(createContractEventChannel, { contract: contract, eventName: eventName, eventOptions: eventOptions });
	
	        case 2:
	          contractEventChannel = _context4.sent;
	
	        case 3:
	          if (false) {}
	
	          _context4.next = 6;
	          return (0, _effects.take)(contractEventChannel);
	
	        case 6:
	          event = _context4.sent;
	          _context4.next = 9;
	          return (0, _effects.put)(event);
	
	        case 9:
	          _context4.next = 3;
	          break;
	
	        case 11:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	/*
	 * Send and Cache
	 */
	
	function createTxChannel(_ref6) {
	  var txObject = _ref6.txObject,
	      stackId = _ref6.stackId,
	      _ref6$sendArgs = _ref6.sendArgs,
	      sendArgs = _ref6$sendArgs === undefined ? {} : _ref6$sendArgs,
	      contractName = _ref6.contractName;
	
	  var persistTxHash;
	
	  return (0, _reduxSaga.eventChannel)(function (emit) {
	    var txPromiEvent = txObject.send(sendArgs).on('transactionHash', function (txHash) {
	      persistTxHash = txHash;
	
	      emit({ type: 'TX_BROADCASTED', txHash: txHash, stackId: stackId });
	      emit({ type: 'CONTRACT_SYNC_IND', contractName: contractName });
	    }).on('confirmation', function (confirmationNumber, receipt) {
	      emit({ type: 'TX_CONFIRMAITON', confirmationReceipt: receipt, txHash: persistTxHash });
	    }).on('receipt', function (receipt) {
	      emit({ type: 'TX_SUCCESSFUL', receipt: receipt, txHash: persistTxHash });
	      emit(_reduxSaga.END);
	    }).on('error', function (error) {
	      emit({ type: 'TX_ERROR', error: error, txHash: persistTxHash });
	      emit(_reduxSaga.END);
	    });
	
	    var unsubscribe = function unsubscribe() {
	      txPromiEvent.off();
	    };
	
	    return unsubscribe;
	  });
	}
	
	function callSendContractTx(_ref7) {
	  var contract = _ref7.contract,
	      fnName = _ref7.fnName,
	      fnIndex = _ref7.fnIndex,
	      args = _ref7.args,
	      stackId = _ref7.stackId;
	  var finalArg, sendArgs, finalArgTest, contractName, txObject, txChannel, event;
	  return _regenerator2.default.wrap(function callSendContractTx$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          // Check for type of object and properties indicative of call/send options.
	          if (args.length) {
	            finalArg = args.length > 1 ? args[args.length - 1] : args[0];
	            sendArgs = {};
	            finalArgTest = false;
	
	
	            if ((typeof finalArg === 'undefined' ? 'undefined' : (0, _typeof3.default)(finalArg)) === 'object') {
	              finalArgTest = (0, _effects.call)(isSendOrCallOptions, finalArg);
	            }
	
	            if (finalArgTest) {
	              sendArgs = finalArg;
	
	              args.length > 1 ? delete args[args.length - 1] : delete args[0];
	              args.length = args.length - 1;
	            }
	          }
	
	          // Get name to mark as desynchronized on tx creation
	          contractName = contract.contractName;
	
	          // Create the transaction object and execute the tx.
	
	          _context5.next = 4;
	          return _effects.call.apply(undefined, [contract.methods[fnName]].concat((0, _toConsumableArray3.default)(args)));
	
	        case 4:
	          txObject = _context5.sent;
	          _context5.next = 7;
	          return (0, _effects.call)(createTxChannel, { txObject: txObject, stackId: stackId, sendArgs: sendArgs, contractName: contractName });
	
	        case 7:
	          txChannel = _context5.sent;
	          _context5.prev = 8;
	
	        case 9:
	          if (false) {}
	
	          _context5.next = 12;
	          return (0, _effects.take)(txChannel);
	
	        case 12:
	          event = _context5.sent;
	          _context5.next = 15;
	          return (0, _effects.put)(event);
	
	        case 15:
	          _context5.next = 9;
	          break;
	
	        case 17:
	          _context5.prev = 17;
	
	          txChannel.close();
	          return _context5.finish(17);
	
	        case 20:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this, [[8,, 17, 20]]);
	}
	
	/*
	 * Call and Cache
	 */
	
	function callCallContractFn(_ref8) {
	  var contract = _ref8.contract,
	      fnName = _ref8.fnName,
	      fnIndex = _ref8.fnIndex,
	      args = _ref8.args,
	      argsHash = _ref8.argsHash,
	      _ref8$sync = _ref8.sync,
	      sync = _ref8$sync === undefined ? false : _ref8$sync;
	  var finalArg, callArgs, finalArgTest, txObject, callResult, dispatchArgs, errorArgs;
	  return _regenerator2.default.wrap(function callCallContractFn$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          if (!sync) {
	            _context6.next = 2;
	            break;
	          }
	
	          return _context6.abrupt('return');
	
	        case 2:
	
	          // Check for type of object and properties indicative of call/send options.
	          if (args.length) {
	            finalArg = args.length > 1 ? args[args.length - 1] : args[0];
	            callArgs = {};
	            finalArgTest = false;
	
	
	            if ((typeof finalArg === 'undefined' ? 'undefined' : (0, _typeof3.default)(finalArg)) === 'object') {
	              finalArgTest = (0, _effects.call)(isSendOrCallOptions, finalArg);
	            }
	
	            if (finalArgTest) {
	              callArgs = finalArg;
	
	              args.length > 1 ? delete args[args.length - 1] : delete args[0];
	              args.length = args.length - 1;
	            }
	          }
	
	          // Create the transaction object and execute the call.
	          _context6.next = 5;
	          return _effects.call.apply(undefined, [contract.methods[fnName]].concat((0, _toConsumableArray3.default)(args)));
	
	        case 5:
	          txObject = _context6.sent;
	          _context6.prev = 6;
	          _context6.next = 9;
	          return (0, _effects.call)(txObject.call, callArgs);
	
	        case 9:
	          callResult = _context6.sent;
	          dispatchArgs = {
	            name: contract.contractName,
	            variable: contract.abi[fnIndex].name,
	            argsHash: argsHash,
	            args: args,
	            value: callResult,
	            fnIndex: fnIndex
	          };
	          _context6.next = 13;
	          return (0, _effects.put)((0, _extends3.default)({ type: 'GOT_CONTRACT_VAR' }, dispatchArgs));
	
	        case 13:
	          _context6.next = 21;
	          break;
	
	        case 15:
	          _context6.prev = 15;
	          _context6.t0 = _context6['catch'](6);
	
	          console.error(_context6.t0);
	
	          errorArgs = {
	            name: contract.contractName,
	            variable: contract.abi[fnIndex].name,
	            argsHash: argsHash,
	            args: args,
	            error: _context6.t0,
	            fnIndex: fnIndex
	          };
	          _context6.next = 21;
	          return (0, _effects.put)((0, _extends3.default)({ type: 'ERROR_CONTRACT_VAR' }, errorArgs));
	
	        case 21:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this, [[6, 15]]);
	}
	
	/*
	 * Sync Contract
	 */
	
	function callSyncContract(action) {
	  var contract, contractName, contractsState, contractFnsState, fnName, argsHash, fnIndex, args;
	  return _regenerator2.default.wrap(function callSyncContract$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          // Get contract state from store
	          contract = action.contract;
	          contractName = contract.contractName;
	          _context7.next = 4;
	          return (0, _effects.select)(getContractsState);
	
	        case 4:
	          contractsState = _context7.sent;
	          contractFnsState = (0, _assign2.default)({}, contractsState[contractName]);
	
	          // Remove unnecessary keys
	
	          delete contractFnsState.initialized;
	          delete contractFnsState.synced;
	          delete contractFnsState.events;
	
	          // Iterate over functions and hashes
	          _context7.t0 = _regenerator2.default.keys(contractFnsState);
	
	        case 10:
	          if ((_context7.t1 = _context7.t0()).done) {
	            _context7.next = 25;
	            break;
	          }
	
	          fnName = _context7.t1.value;
	          _context7.t2 = _regenerator2.default.keys(contractFnsState[fnName]);
	
	        case 13:
	          if ((_context7.t3 = _context7.t2()).done) {
	            _context7.next = 23;
	            break;
	          }
	
	          argsHash = _context7.t3.value;
	          fnIndex = contractFnsState[fnName][argsHash].fnIndex;
	          args = contractFnsState[fnName][argsHash].args;
	
	          // Pull args and call fn for each given function
	          // keeping for pre-v1.1.5 compatibility with CALL_CONTRACT_FN event.
	
	          _context7.next = 19;
	          return (0, _effects.put)({ type: 'CALL_CONTRACT_FN', contract: contract, fnName: fnName, fnIndex: fnIndex, args: args, argsHash: argsHash, sync: true });
	
	        case 19:
	          _context7.next = 21;
	          return (0, _effects.call)(callCallContractFn, { contract: contract, fnName: fnName, fnIndex: fnIndex, args: args, argsHash: argsHash });
	
	        case 21:
	          _context7.next = 13;
	          break;
	
	        case 23:
	          _context7.next = 10;
	          break;
	
	        case 25:
	          _context7.next = 27;
	          return (0, _effects.put)({ type: 'CONTRACT_SYNCED', contractName: contractName });
	
	        case 27:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked7, this);
	}
	
	var getContractsState = function getContractsState(state) {
	  return state.contracts;
	};
	var getNetworkId = function getNetworkId(state) {
	  return state.web3.networkId;
	};
	
	function isSendOrCallOptions(options) {
	  if ('from' in options) return true;
	  if ('gas' in options) return true;
	  if ('gasPrice' in options) return true;
	  if ('value' in options) return true;
	
	  return false;
	}
	
	function contractsSaga() {
	  return _regenerator2.default.wrap(function contractsSaga$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          _context8.next = 2;
	          return (0, _effects.takeEvery)('SEND_CONTRACT_TX', callSendContractTx);
	
	        case 2:
	          _context8.next = 4;
	          return (0, _effects.takeEvery)('CALL_CONTRACT_FN', callCallContractFn);
	
	        case 4:
	          _context8.next = 6;
	          return (0, _effects.takeEvery)('CONTRACT_SYNCING', callSyncContract);
	
	        case 6:
	          _context8.next = 8;
	          return (0, _effects.takeEvery)('LISTEN_FOR_EVENT', callListenForContractEvent);
	
	        case 8:
	          _context8.next = 10;
	          return (0, _effects.takeEvery)('ADD_CONTRACT', addContract);
	
	        case 10:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked8, this);
	}
	
	exports.default = contractsSaga;
	
	/***/ }),
	
	/***/ "./src/defaultOptions.js":
	/*!*******************************!*\
	  !*** ./src/defaultOptions.js ***!
	  \*******************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var defaultOptions = {
	  web3: {
	    // `block` no longer needed;
	    // keeping for pre-v1.1.1 compatibility with drizzle-react.
	    block: false,
	    fallback: {
	      type: 'ws',
	      url: 'ws://127.0.0.1:8545'
	    }
	  },
	  contracts: [],
	  events: {},
	  polls: {
	    blocks: 3000
	  },
	  syncAlways: false
	};
	
	exports.default = defaultOptions;
	
	/***/ }),
	
	/***/ "./src/drizzleStatus/drizzleStatusReducer.js":
	/*!***************************************************!*\
	  !*** ./src/drizzleStatus/drizzleStatusReducer.js ***!
	  \***************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(/*! babel-runtime/helpers/extends */ "./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  initialized: false
	};
	
	var drizzleStatusReducer = function drizzleStatusReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  /*
	   * Drizzle Status
	   */
	
	  if (action.type === 'DRIZZLE_INITIALIZED') {
	    return (0, _extends3.default)({}, state, {
	      initialized: true
	    });
	  }
	  return state;
	};
	
	exports.default = drizzleStatusReducer;
	
	/***/ }),
	
	/***/ "./src/drizzleStatus/drizzleStatusSaga.js":
	/*!************************************************!*\
	  !*** ./src/drizzleStatus/drizzleStatusSaga.js ***!
	  \************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ "./node_modules/babel-runtime/regenerator/index.js");
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _effects = __webpack_require__(/*! redux-saga/effects */ "./node_modules/redux-saga/es/effects.js");
	
	var _defaultOptions = __webpack_require__(/*! ../defaultOptions */ "./src/defaultOptions.js");
	
	var _defaultOptions2 = _interopRequireDefault(_defaultOptions);
	
	var _mergeOptions = __webpack_require__(/*! ../mergeOptions */ "./src/mergeOptions.js");
	
	var _mergeOptions2 = _interopRequireDefault(_mergeOptions);
	
	var _web3Saga = __webpack_require__(/*! ../web3/web3Saga */ "./src/web3/web3Saga.js");
	
	var _accountsSaga = __webpack_require__(/*! ../accounts/accountsSaga */ "./src/accounts/accountsSaga.js");
	
	var _accountBalancesSaga = __webpack_require__(/*! ../accountBalances/accountBalancesSaga */ "./src/accountBalances/accountBalancesSaga.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(initializeDrizzle),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(drizzleStatusSaga);
	
	// Initialization Functions
	
	
	function initializeDrizzle(action) {
	  var options, web3Options, drizzle, web3, i, contractConfig, events, contractName, syncAlways, interval;
	  return _regenerator2.default.wrap(function initializeDrizzle$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.prev = 0;
	          options = (0, _mergeOptions2.default)(_defaultOptions2.default, action.options);
	          web3Options = options.web3;
	          drizzle = action.drizzle;
	
	          // Initialize web3 and get the current network ID.
	
	          _context.next = 6;
	          return (0, _effects.call)(_web3Saga.initializeWeb3, { options: web3Options });
	
	        case 6:
	          web3 = _context.sent;
	
	          drizzle.web3 = web3;
	
	          _context.next = 10;
	          return (0, _effects.call)(_web3Saga.getNetworkId, { web3: web3 });
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.call)(_accountsSaga.getAccounts, { web3: web3 });
	
	        case 12:
	          _context.next = 14;
	          return (0, _effects.call)(_accountBalancesSaga.getAccountBalances, { web3: web3 });
	
	        case 14:
	          i = 0;
	
	        case 15:
	          if (!(i < options.contracts.length)) {
	            _context.next = 25;
	            break;
	          }
	
	          contractConfig = options.contracts[i];
	          events = [];
	          contractName = contractConfig.contractName;
	
	
	          if (contractName in options.events) {
	            events = options.events[contractName];
	          }
	
	          _context.next = 22;
	          return (0, _effects.put)({ type: 'ADD_CONTRACT', drizzle: drizzle, contractConfig: contractConfig, events: events, web3: web3 });
	
	        case 22:
	          i++;
	          _context.next = 15;
	          break;
	
	        case 25:
	          syncAlways = options.syncAlways;
	
	          if (!web3.currentProvider.isMetaMask) {
	            _context.next = 32;
	            break;
	          }
	
	          // Using MetaMask, attempt block polling.
	          interval = options.polls.blocks;
	          _context.next = 30;
	          return (0, _effects.put)({ type: 'BLOCKS_POLLING', drizzle: drizzle, interval: interval, web3: web3, syncAlways: syncAlways });
	
	        case 30:
	          _context.next = 34;
	          break;
	
	        case 32:
	          _context.next = 34;
	          return (0, _effects.put)({ type: 'BLOCKS_LISTENING', drizzle: drizzle, web3: web3, syncAlways: syncAlways });
	
	        case 34:
	          if (!('accounts' in options.polls)) {
	            _context.next = 37;
	            break;
	          }
	
	          _context.next = 37;
	          return (0, _effects.put)({ type: 'ACCOUNTS_POLLING', interval: options.polls.accounts, web3: web3 });
	
	        case 37:
	          _context.next = 46;
	          break;
	
	        case 39:
	          _context.prev = 39;
	          _context.t0 = _context['catch'](0);
	          _context.next = 43;
	          return (0, _effects.put)({ type: 'DRIZZLE_FAILED', error: _context.t0 });
	
	        case 43:
	
	          console.error('Error initializing Drizzle:');
	          console.error(_context.t0);
	
	          return _context.abrupt('return');
	
	        case 46:
	          _context.next = 48;
	          return (0, _effects.put)({ type: 'DRIZZLE_INITIALIZED' });
	
	        case 48:
	          return _context.abrupt('return');
	
	        case 49:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this, [[0, 39]]);
	}
	
	function drizzleStatusSaga() {
	  return _regenerator2.default.wrap(function drizzleStatusSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)('DRIZZLE_INITIALIZING', initializeDrizzle);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	exports.default = drizzleStatusSaga;
	
	/***/ }),
	
	/***/ "./src/generateContractInitialState.js":
	/*!*********************************************!*\
	  !*** ./src/generateContractInitialState.js ***!
	  \*********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.generateContractInitialState = generateContractInitialState;
	
	var _getAbi = __webpack_require__(/*! ./getAbi */ "./src/getAbi.js");
	
	var _getAbi2 = _interopRequireDefault(_getAbi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function generateContractInitialState(contractConfig) {
	  var state = {
	    initialized: false,
	    synced: false
	
	    // Constant getters
	  };var abi = (0, _getAbi2.default)(contractConfig);
	  for (var i2 = 0; i2 < abi.length; i2++) {
	    var item = abi[i2];
	
	    if (item.type == "function" && item.constant === true) {
	      state[item.name] = {};
	    }
	  }
	
	  return state;
	}
	
	/***/ }),
	
	/***/ "./src/generateContractsInitialState.js":
	/*!**********************************************!*\
	  !*** ./src/generateContractsInitialState.js ***!
	  \**********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.generateContractsInitialState = generateContractsInitialState;
	
	var _generateContractInitialState = __webpack_require__(/*! ./generateContractInitialState */ "./src/generateContractInitialState.js");
	
	function generateContractsInitialState(options) {
	  // Preloaded state
	  var contractsInitialState = {};
	
	  for (var i = 0; i < options.contracts.length; i++) {
	    // Initial contract details
	    var contractName = options.contracts[i].contractName;
	    contractsInitialState[contractName] = (0, _generateContractInitialState.generateContractInitialState)(options.contracts[i]);
	  }
	
	  return contractsInitialState;
	}
	
	/***/ }),
	
	/***/ "./src/generateStore.js":
	/*!******************************!*\
	  !*** ./src/generateStore.js ***!
	  \******************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.generateStore = generateStore;
	
	var _redux = __webpack_require__(/*! redux */ "redux");
	
	var _reduxSaga = __webpack_require__(/*! redux-saga */ "redux-saga");
	
	var _reduxSaga2 = _interopRequireDefault(_reduxSaga);
	
	var _rootSaga = __webpack_require__(/*! ./rootSaga */ "./src/rootSaga.js");
	
	var _rootSaga2 = _interopRequireDefault(_rootSaga);
	
	var _reducer = __webpack_require__(/*! ./reducer */ "./src/reducer.js");
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _generateContractsInitialState = __webpack_require__(/*! ./generateContractsInitialState */ "./src/generateContractsInitialState.js");
	
	var _getAbi = __webpack_require__(/*! ./getAbi */ "./src/getAbi.js");
	
	var _getAbi2 = _interopRequireDefault(_getAbi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function generateStore(options) {
	  // Redux DevTools
	  var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
	
	  // Preloaded state
	  var preloadedState = {
	    contracts: (0, _generateContractsInitialState.generateContractsInitialState)(options)
	
	    // create the saga middleware
	  };var sagaMiddleware = (0, _reduxSaga2.default)();
	
	  var store = (0, _redux.createStore)(_reducer2.default, preloadedState, composeEnhancers((0, _redux.applyMiddleware)(sagaMiddleware)));
	
	  sagaMiddleware.run(_rootSaga2.default);
	
	  return store;
	}
	
	/***/ }),
	
	/***/ "./src/getAbi.js":
	/*!***********************!*\
	  !*** ./src/getAbi.js ***!
	  \***********************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getAbi;
	function getAbi(contractEntry) {
	  if (contractEntry.web3Contract) {
	    return contractEntry.web3Contract.options.jsonInterface;
	  } else {
	    return contractEntry.abi;
	  }
	}
	
	/***/ }),
	
	/***/ "./src/index.js":
	/*!**********************!*\
	  !*** ./src/index.js ***!
	  \**********************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.drizzleSagas = exports.drizzleReducers = exports.generateStore = exports.generateContractsInitialState = exports.Drizzle = undefined;
	
	var _Drizzle = __webpack_require__(/*! ./Drizzle.js */ "./src/Drizzle.js");
	
	var _Drizzle2 = _interopRequireDefault(_Drizzle);
	
	var _generateStore = __webpack_require__(/*! ./generateStore */ "./src/generateStore.js");
	
	var _generateContractsInitialState = __webpack_require__(/*! ./generateContractsInitialState */ "./src/generateContractsInitialState.js");
	
	var _accountsReducer = __webpack_require__(/*! ./accounts/accountsReducer */ "./src/accounts/accountsReducer.js");
	
	var _accountsReducer2 = _interopRequireDefault(_accountsReducer);
	
	var _accountBalancesReducer = __webpack_require__(/*! ./accountBalances/accountBalancesReducer */ "./src/accountBalances/accountBalancesReducer.js");
	
	var _accountBalancesReducer2 = _interopRequireDefault(_accountBalancesReducer);
	
	var _contractsReducer = __webpack_require__(/*! ./contracts/contractsReducer */ "./src/contracts/contractsReducer.js");
	
	var _contractsReducer2 = _interopRequireDefault(_contractsReducer);
	
	var _drizzleStatusReducer = __webpack_require__(/*! ./drizzleStatus/drizzleStatusReducer */ "./src/drizzleStatus/drizzleStatusReducer.js");
	
	var _drizzleStatusReducer2 = _interopRequireDefault(_drizzleStatusReducer);
	
	var _transactionsReducer = __webpack_require__(/*! ./transactions/transactionsReducer */ "./src/transactions/transactionsReducer.js");
	
	var _transactionsReducer2 = _interopRequireDefault(_transactionsReducer);
	
	var _transactionStackReducer = __webpack_require__(/*! ./transactions/transactionStackReducer */ "./src/transactions/transactionStackReducer.js");
	
	var _transactionStackReducer2 = _interopRequireDefault(_transactionStackReducer);
	
	var _web3Reducer = __webpack_require__(/*! ./web3/web3Reducer */ "./src/web3/web3Reducer.js");
	
	var _web3Reducer2 = _interopRequireDefault(_web3Reducer);
	
	var _accountsSaga = __webpack_require__(/*! ./accounts/accountsSaga */ "./src/accounts/accountsSaga.js");
	
	var _accountsSaga2 = _interopRequireDefault(_accountsSaga);
	
	var _accountBalancesSaga = __webpack_require__(/*! ./accountBalances/accountBalancesSaga */ "./src/accountBalances/accountBalancesSaga.js");
	
	var _accountBalancesSaga2 = _interopRequireDefault(_accountBalancesSaga);
	
	var _blocksSaga = __webpack_require__(/*! ./blocks/blocksSaga */ "./src/blocks/blocksSaga.js");
	
	var _blocksSaga2 = _interopRequireDefault(_blocksSaga);
	
	var _contractsSaga = __webpack_require__(/*! ./contracts/contractsSaga */ "./src/contracts/contractsSaga.js");
	
	var _contractsSaga2 = _interopRequireDefault(_contractsSaga);
	
	var _drizzleStatusSaga = __webpack_require__(/*! ./drizzleStatus/drizzleStatusSaga */ "./src/drizzleStatus/drizzleStatusSaga.js");
	
	var _drizzleStatusSaga2 = _interopRequireDefault(_drizzleStatusSaga);
	
	var _web3Saga = __webpack_require__(/*! ./web3/web3Saga */ "./src/web3/web3Saga.js");
	
	var _web3Saga2 = _interopRequireDefault(_web3Saga);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var drizzleReducers = {
	  accounts: _accountsReducer2.default,
	  accountBalances: _accountBalancesReducer2.default,
	  contracts: _contractsReducer2.default,
	  drizzleStatus: _drizzleStatusReducer2.default,
	  transactions: _transactionsReducer2.default,
	  transactionStack: _transactionStackReducer2.default,
	  web3: _web3Reducer2.default
	
	  // Sagas
	};
	
	// Reducers
	
	
	var drizzleSagas = [_accountsSaga2.default, _accountBalancesSaga2.default, _blocksSaga2.default, _contractsSaga2.default, _drizzleStatusSaga2.default, _web3Saga2.default];
	
	exports.Drizzle = _Drizzle2.default;
	exports.generateContractsInitialState = _generateContractsInitialState.generateContractsInitialState;
	exports.generateStore = _generateStore.generateStore;
	exports.drizzleReducers = drizzleReducers;
	exports.drizzleSagas = drizzleSagas;
	
	/***/ }),
	
	/***/ "./src/mergeOptions.js":
	/*!*****************************!*\
	  !*** ./src/mergeOptions.js ***!
	  \*****************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (defaultOptions, newOptions) {
	  return (0, _deepmerge2.default)(defaultOptions, newOptions, {
	    isMergeableObject: isPlainObject
	  });
	};
	
	var _deepmerge = __webpack_require__(/*! deepmerge */ "deepmerge");
	
	var _deepmerge2 = _interopRequireDefault(_deepmerge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isPlainObject = __webpack_require__(/*! is-plain-object */ "is-plain-object");
	
	/***/ }),
	
	/***/ "./src/reducer.js":
	/*!************************!*\
	  !*** ./src/reducer.js ***!
	  \************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(/*! redux */ "redux");
	
	var _accountsReducer = __webpack_require__(/*! ./accounts/accountsReducer */ "./src/accounts/accountsReducer.js");
	
	var _accountsReducer2 = _interopRequireDefault(_accountsReducer);
	
	var _accountBalancesReducer = __webpack_require__(/*! ./accountBalances/accountBalancesReducer */ "./src/accountBalances/accountBalancesReducer.js");
	
	var _accountBalancesReducer2 = _interopRequireDefault(_accountBalancesReducer);
	
	var _contractsReducer = __webpack_require__(/*! ./contracts/contractsReducer */ "./src/contracts/contractsReducer.js");
	
	var _contractsReducer2 = _interopRequireDefault(_contractsReducer);
	
	var _drizzleStatusReducer = __webpack_require__(/*! ./drizzleStatus/drizzleStatusReducer */ "./src/drizzleStatus/drizzleStatusReducer.js");
	
	var _drizzleStatusReducer2 = _interopRequireDefault(_drizzleStatusReducer);
	
	var _transactionsReducer = __webpack_require__(/*! ./transactions/transactionsReducer */ "./src/transactions/transactionsReducer.js");
	
	var _transactionsReducer2 = _interopRequireDefault(_transactionsReducer);
	
	var _transactionStackReducer = __webpack_require__(/*! ./transactions/transactionStackReducer */ "./src/transactions/transactionStackReducer.js");
	
	var _transactionStackReducer2 = _interopRequireDefault(_transactionStackReducer);
	
	var _web3Reducer = __webpack_require__(/*! ./web3/web3Reducer */ "./src/web3/web3Reducer.js");
	
	var _web3Reducer2 = _interopRequireDefault(_web3Reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reducer = (0, _redux.combineReducers)({
	  accounts: _accountsReducer2.default,
	  accountBalances: _accountBalancesReducer2.default,
	  contracts: _contractsReducer2.default,
	  drizzleStatus: _drizzleStatusReducer2.default,
	  transactions: _transactionsReducer2.default,
	  transactionStack: _transactionStackReducer2.default,
	  web3: _web3Reducer2.default
	});
	
	exports.default = reducer;
	
	/***/ }),
	
	/***/ "./src/rootSaga.js":
	/*!*************************!*\
	  !*** ./src/rootSaga.js ***!
	  \*************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ "./node_modules/babel-runtime/regenerator/index.js");
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = root;
	
	var _effects = __webpack_require__(/*! redux-saga/effects */ "./node_modules/redux-saga/es/effects.js");
	
	var _accountsSaga = __webpack_require__(/*! ./accounts/accountsSaga */ "./src/accounts/accountsSaga.js");
	
	var _accountsSaga2 = _interopRequireDefault(_accountsSaga);
	
	var _accountBalancesSaga = __webpack_require__(/*! ./accountBalances/accountBalancesSaga */ "./src/accountBalances/accountBalancesSaga.js");
	
	var _accountBalancesSaga2 = _interopRequireDefault(_accountBalancesSaga);
	
	var _blocksSaga = __webpack_require__(/*! ./blocks/blocksSaga */ "./src/blocks/blocksSaga.js");
	
	var _blocksSaga2 = _interopRequireDefault(_blocksSaga);
	
	var _contractsSaga = __webpack_require__(/*! ./contracts/contractsSaga */ "./src/contracts/contractsSaga.js");
	
	var _contractsSaga2 = _interopRequireDefault(_contractsSaga);
	
	var _drizzleStatusSaga = __webpack_require__(/*! ./drizzleStatus/drizzleStatusSaga */ "./src/drizzleStatus/drizzleStatusSaga.js");
	
	var _drizzleStatusSaga2 = _interopRequireDefault(_drizzleStatusSaga);
	
	var _web3Saga = __webpack_require__(/*! ./web3/web3Saga */ "./src/web3/web3Saga.js");
	
	var _web3Saga2 = _interopRequireDefault(_web3Saga);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(root);
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.all)([(0, _effects.fork)(_accountsSaga2.default), (0, _effects.fork)(_accountBalancesSaga2.default), (0, _effects.fork)(_blocksSaga2.default), (0, _effects.fork)(_contractsSaga2.default), (0, _effects.fork)(_drizzleStatusSaga2.default), (0, _effects.fork)(_web3Saga2.default)]);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	/***/ }),
	
	/***/ "./src/transactions/transactionStackReducer.js":
	/*!*****************************************************!*\
	  !*** ./src/transactions/transactionStackReducer.js ***!
	  \*****************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ "./node_modules/babel-runtime/helpers/toConsumableArray.js");
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = [];
	
	var transactionStackReducer = function transactionStackReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    if (action.type === 'PUSH_TO_TXSTACK') {
	        state.push('');
	
	        return [].concat((0, _toConsumableArray3.default)(state));
	    }
	
	    if (action.type === 'POP_FROM_TXSTACK') {
	        state.pop();
	
	        return [].concat((0, _toConsumableArray3.default)(state));
	    }
	
	    if (action.type === 'TX_BROADCASTED') {
	        state[action.stackId] = action.txHash;
	
	        return [].concat((0, _toConsumableArray3.default)(state));
	    }
	
	    return state;
	};
	
	exports.default = transactionStackReducer;
	
	/***/ }),
	
	/***/ "./src/transactions/transactionsReducer.js":
	/*!*************************************************!*\
	  !*** ./src/transactions/transactionsReducer.js ***!
	  \*************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ "./node_modules/babel-runtime/helpers/toConsumableArray.js");
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _defineProperty2 = __webpack_require__(/*! babel-runtime/helpers/defineProperty */ "./node_modules/babel-runtime/helpers/defineProperty.js");
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends6 = __webpack_require__(/*! babel-runtime/helpers/extends */ "./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends7 = _interopRequireDefault(_extends6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {};
	
	var transactionsReducer = function transactionsReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    if (action.type === 'TX_BROADCASTED') {
	        return (0, _extends7.default)({}, state, (0, _defineProperty3.default)({}, action.txHash, {
	            status: 'pending',
	            confirmations: []
	        }));
	    }
	
	    if (action.type === 'TX_CONFIRMAITON') {
	        return (0, _extends7.default)({}, state, (0, _defineProperty3.default)({}, action.txHash, (0, _extends7.default)({}, state[action.txHash], {
	            confirmations: [].concat((0, _toConsumableArray3.default)(state[action.txHash].confirmations), [action.confirmationReceipt])
	        })));
	    }
	
	    if (action.type === 'TX_SUCCESSFUL') {
	        return (0, _extends7.default)({}, state, (0, _defineProperty3.default)({}, action.txHash, (0, _extends7.default)({}, state[action.txHash], {
	            status: 'success',
	            receipt: action.receipt
	        })));
	    }
	
	    if (action.type === 'TX_ERROR') {
	        return (0, _extends7.default)({}, state, (0, _defineProperty3.default)({}, action.txHash, (0, _extends7.default)({}, state[action.txHash], {
	            status: 'error',
	            error: action.error
	        })));
	    }
	
	    return state;
	};
	
	exports.default = transactionsReducer;
	
	/***/ }),
	
	/***/ "./src/web3/web3Reducer.js":
	/*!*********************************!*\
	  !*** ./src/web3/web3Reducer.js ***!
	  \*********************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(/*! babel-runtime/helpers/extends */ "./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  status: ''
	};
	
	var web3Reducer = function web3Reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  if (action.type === 'WEB3_INITIALIZING') {
	    return (0, _extends3.default)({}, state, {
	      status: 'initializing'
	    });
	  }
	
	  if (action.type === 'WEB3_INITIALIZED') {
	    return (0, _extends3.default)({}, state, {
	      status: 'initialized'
	    });
	  }
	
	  if (action.type === 'WEB3_FAILED') {
	    return (0, _extends3.default)({}, state, {
	      status: 'failed'
	    });
	  }
	
	  if (action.type === 'NETWORK_ID_FETCHED') {
	    return (0, _extends3.default)({}, state, {
	      networkId: action.networkId
	    });
	  }
	
	  if (action.type === 'NETWORK_ID_FAILED') {
	    return (0, _extends3.default)({}, state, {
	      networkId: action.networkId
	    });
	  }
	
	  return state;
	};
	
	exports.default = web3Reducer;
	
	/***/ }),
	
	/***/ "./src/web3/web3Saga.js":
	/*!******************************!*\
	  !*** ./src/web3/web3Saga.js ***!
	  \******************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ "./node_modules/babel-runtime/regenerator/index.js");
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.initializeWeb3 = initializeWeb3;
	exports.getNetworkId = getNetworkId;
	
	var _effects = __webpack_require__(/*! redux-saga/effects */ "./node_modules/redux-saga/es/effects.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(initializeWeb3),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getNetworkId),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(callSendTx),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(web3Saga);
	
	var Web3 = __webpack_require__(/*! web3 */ "web3");
	
	/*
	 * Initialization
	 */
	
	function initializeWeb3(_ref) {
	  var options = _ref.options;
	  var web3, provider;
	  return _regenerator2.default.wrap(function initializeWeb3$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.prev = 0;
	          web3 = {};
	
	          // Checking if Web3 has been injected by the browser (Mist/MetaMask)
	
	          if (!(typeof window.web3 !== 'undefined')) {
	            _context.next = 11;
	            break;
	          }
	
	          // Use Mist/MetaMask's provider.
	          web3 = new Web3(window.web3.currentProvider);
	          web3.eth.cacheSendTransaction = function (txObject) {
	            return (0, _effects.put)({ type: 'SEND_WEB3_TX', txObject: txObject, stackId: stackId, web3: web3 });
	          };
	
	          console.log('Injected web3 detected.');
	
	          _context.next = 8;
	          return (0, _effects.put)({ type: 'WEB3_INITIALIZED' });
	
	        case 8:
	          return _context.abrupt('return', web3);
	
	        case 11:
	          if (!options.fallback) {
	            _context.next = 24;
	            break;
	          }
	
	          // Attempt fallback if no web3 injection.
	          console.log('No web3 instance injected, using fallback.');
	
	          _context.t0 = options.fallback.type;
	          _context.next = _context.t0 === 'ws' ? 16 : 23;
	          break;
	
	        case 16:
	          provider = new Web3.providers.WebsocketProvider(options.fallback.url);
	
	          web3 = new Web3(provider);
	
	          // Attach drizzle functions
	          web3.eth['cacheSendTransaction'] = function (txObject) {
	            return (0, _effects.put)({ type: 'SEND_WEB3_TX', txObject: txObject, stackId: stackId, web3: web3 });
	          };
	
	          _context.next = 21;
	          return (0, _effects.put)({ type: 'WEB3_INITIALIZED' });
	
	        case 21:
	          return _context.abrupt('return', web3);
	
	        case 23:
	          throw "Invalid web3 fallback provided.";
	
	        case 24:
	          throw "Cannot find injected web3 or valid fallback.";
	
	        case 25:
	          _context.next = 33;
	          break;
	
	        case 27:
	          _context.prev = 27;
	          _context.t1 = _context['catch'](0);
	          _context.next = 31;
	          return (0, _effects.put)({ type: 'WEB3_FAILED', error: _context.t1 });
	
	        case 31:
	          console.error('Error intializing web3:');
	          console.error(_context.t1);
	
	        case 33:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this, [[0, 27]]);
	}
	
	/*
	 * Network ID
	 */
	
	function getNetworkId(_ref2) {
	  var web3 = _ref2.web3;
	  var networkId;
	  return _regenerator2.default.wrap(function getNetworkId$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.prev = 0;
	          _context2.next = 3;
	          return (0, _effects.call)(web3.eth.net.getId);
	
	        case 3:
	          networkId = _context2.sent;
	          _context2.next = 6;
	          return (0, _effects.put)({ type: 'NETWORK_ID_FETCHED', networkId: networkId });
	
	        case 6:
	          return _context2.abrupt('return', networkId);
	
	        case 9:
	          _context2.prev = 9;
	          _context2.t0 = _context2['catch'](0);
	          _context2.next = 13;
	          return (0, _effects.put)({ type: 'NETWORK_ID_FAILED', error: _context2.t0 });
	
	        case 13:
	
	          console.error('Error fetching network ID:');
	          console.error(_context2.t0);
	
	          return _context2.abrupt('return');
	
	        case 16:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this, [[0, 9]]);
	}
	
	/*
	 * Send Transaction
	 */
	
	function createTxChannel(_ref3) {
	  var txObject = _ref3.txObject,
	      stackId = _ref3.stackId,
	      web3 = _ref3.web3;
	
	  var persistTxHash;
	
	  return eventChannel(function (emit) {
	    var txPromiEvent = web3.eth.sendTransaction(txObject).on('transactionHash', function (txHash) {
	      persistTxHash = txHash;
	
	      emit({ type: 'W3TX_BROADCASTED', txHash: txHash, stackId: stackId });
	    }).on('confirmation', function (confirmationNumber, receipt) {
	      emit({ type: 'W3TX_CONFIRMAITON', confirmationReceipt: receipt, txHash: persistTxHash });
	    }).on('receipt', function (receipt) {
	      emit({ type: 'W3TX_SUCCESSFUL', receipt: receipt, txHash: persistTxHash });
	      emit(END);
	    }).on('error', function (error) {
	      emit({ type: 'W3TX_ERROR', error: error, txHash: persistTxHash });
	      emit(END);
	    });
	
	    var unsubscribe = function unsubscribe() {
	      txPromiEvent.off();
	    };
	
	    return unsubscribe;
	  });
	}
	
	function callSendTx(_ref4) {
	  var txObject = _ref4.txObject,
	      stackId = _ref4.stackId,
	      web3 = _ref4.web3;
	  var txChannel, event;
	  return _regenerator2.default.wrap(function callSendTx$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.call)(createTxChannel, { txObject: txObject, stackId: stackId, web3: web3 });
	
	        case 2:
	          txChannel = _context3.sent;
	          _context3.prev = 3;
	
	        case 4:
	          if (false) {}
	
	          _context3.next = 7;
	          return take(txChannel);
	
	        case 7:
	          event = _context3.sent;
	          _context3.next = 10;
	          return (0, _effects.put)(event);
	
	        case 10:
	          _context3.next = 4;
	          break;
	
	        case 12:
	          _context3.prev = 12;
	
	          txChannel.close();
	          return _context3.finish(12);
	
	        case 15:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this, [[3,, 12, 15]]);
	}
	
	function web3Saga() {
	  return _regenerator2.default.wrap(function web3Saga$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.takeLatest)('NETWORK_ID_FETCHING', getNetworkId);
	
	        case 2:
	          _context4.next = 4;
	          return (0, _effects.takeEvery)('SEND_WEB3_TX', callSendTx);
	
	        case 4:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	exports.default = web3Saga;
	
	/***/ }),
	
	/***/ "deepmerge":
	/*!****************************!*\
	  !*** external "deepmerge" ***!
	  \****************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_deepmerge__;
	
	/***/ }),
	
	/***/ "eth-block-tracker":
	/*!****************************************!*\
	  !*** external "eth-block-tracker-es5" ***!
	  \****************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_eth_block_tracker__;
	
	/***/ }),
	
	/***/ "is-plain-object":
	/*!**********************************!*\
	  !*** external "is-plain-object" ***!
	  \**********************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_is_plain_object__;
	
	/***/ }),
	
	/***/ "redux":
	/*!************************!*\
	  !*** external "redux" ***!
	  \************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_redux__;
	
	/***/ }),
	
	/***/ "redux-saga":
	/*!*****************************!*\
	  !*** external "redux-saga" ***!
	  \*****************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_redux_saga__;
	
	/***/ }),
	
	/***/ "web3":
	/*!***********************!*\
	  !*** external "web3" ***!
	  \***********************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_web3__;
	
	/***/ })
	
	/******/ });
	});
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.buffers = exports.BUFFER_OVERFLOW = undefined;
	
	var _utils = /*#__PURE__*/__webpack_require__(24);
	
	var BUFFER_OVERFLOW = exports.BUFFER_OVERFLOW = "Channel's Buffer overflow!";
	
	var ON_OVERFLOW_THROW = 1;
	var ON_OVERFLOW_DROP = 2;
	var ON_OVERFLOW_SLIDE = 3;
	var ON_OVERFLOW_EXPAND = 4;
	
	var zeroBuffer = { isEmpty: _utils.kTrue, put: _utils.noop, take: _utils.noop };
	
	function ringBuffer() {
	  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
	  var overflowAction = arguments[1];
	
	  var arr = new Array(limit);
	  var length = 0;
	  var pushIndex = 0;
	  var popIndex = 0;
	
	  var push = function push(it) {
	    arr[pushIndex] = it;
	    pushIndex = (pushIndex + 1) % limit;
	    length++;
	  };
	
	  var take = function take() {
	    if (length != 0) {
	      var it = arr[popIndex];
	      arr[popIndex] = null;
	      length--;
	      popIndex = (popIndex + 1) % limit;
	      return it;
	    }
	  };
	
	  var flush = function flush() {
	    var items = [];
	    while (length) {
	      items.push(take());
	    }
	    return items;
	  };
	
	  return {
	    isEmpty: function isEmpty() {
	      return length == 0;
	    },
	    put: function put(it) {
	      if (length < limit) {
	        push(it);
	      } else {
	        var doubledLimit = void 0;
	        switch (overflowAction) {
	          case ON_OVERFLOW_THROW:
	            throw new Error(BUFFER_OVERFLOW);
	          case ON_OVERFLOW_SLIDE:
	            arr[pushIndex] = it;
	            pushIndex = (pushIndex + 1) % limit;
	            popIndex = pushIndex;
	            break;
	          case ON_OVERFLOW_EXPAND:
	            doubledLimit = 2 * limit;
	
	            arr = flush();
	
	            length = arr.length;
	            pushIndex = arr.length;
	            popIndex = 0;
	
	            arr.length = doubledLimit;
	            limit = doubledLimit;
	
	            push(it);
	            break;
	          default:
	          // DROP
	        }
	      }
	    },
	    take: take,
	    flush: flush
	  };
	}
	
	var buffers = exports.buffers = {
	  none: function none() {
	    return zeroBuffer;
	  },
	  fixed: function fixed(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_THROW);
	  },
	  dropping: function dropping(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_DROP);
	  },
	  sliding: function sliding(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
	  },
	  expanding: function expanding(initialSize) {
	    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
	  }
	};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var curve = exports;
	
	curve.base = __webpack_require__(489);
	curve.short = __webpack_require__(492);
	curve.mont = __webpack_require__(491);
	curve.edwards = __webpack_require__(490);


/***/ },
/* 93 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var Buffer = __webpack_require__(4).Buffer
	var MD5 = __webpack_require__(581)
	
	/* eslint-disable camelcase */
	function EVP_BytesToKey (password, salt, keyBits, ivLen) {
	  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
	  if (salt) {
	    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
	    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
	  }
	
	  var keyLen = keyBits / 8
	  var key = Buffer.alloc(keyLen)
	  var iv = Buffer.alloc(ivLen || 0)
	  var tmp = Buffer.alloc(0)
	
	  while (keyLen > 0 || ivLen > 0) {
	    var hash = new MD5()
	    hash.update(tmp)
	    hash.update(password)
	    if (salt) hash.update(salt)
	    tmp = hash.digest()
	
	    var used = 0
	
	    if (keyLen > 0) {
	      var keyStart = key.length - keyLen
	      used = Math.min(keyLen, tmp.length)
	      tmp.copy(key, keyStart, 0, used)
	      keyLen -= used
	    }
	
	    if (used < tmp.length && ivLen > 0) {
	      var ivStart = iv.length - ivLen
	      var length = Math.min(ivLen, tmp.length - used)
	      tmp.copy(iv, ivStart, used, used + length)
	      ivLen -= length
	    }
	  }
	
	  tmp.fill(0)
	  return { key: key, iv: iv }
	}
	
	module.exports = EVP_BytesToKey


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 96 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ },
/* 97 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(239),
	    getRawTag = __webpack_require__(567),
	    objectToString = __webpack_require__(572);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 99 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var asn1 = __webpack_require__(585)
	var aesid = __webpack_require__(556)
	var fixProc = __webpack_require__(587)
	var ciphers = __webpack_require__(125)
	var compat = __webpack_require__(142)
	module.exports = parseKeys
	
	function parseKeys (buffer) {
	  var password
	  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
	    password = buffer.passphrase
	    buffer = buffer.key
	  }
	  if (typeof buffer === 'string') {
	    buffer = new Buffer(buffer)
	  }
	
	  var stripped = fixProc(buffer, password)
	
	  var type = stripped.tag
	  var data = stripped.data
	  var subtype, ndata
	  switch (type) {
	    case 'CERTIFICATE':
	      ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo
	      // falls through
	    case 'PUBLIC KEY':
	      if (!ndata) {
	        ndata = asn1.PublicKey.decode(data, 'der')
	      }
	      subtype = ndata.algorithm.algorithm.join('.')
	      switch (subtype) {
	        case '1.2.840.113549.1.1.1':
	          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
	        case '1.2.840.10045.2.1':
	          ndata.subjectPrivateKey = ndata.subjectPublicKey
	          return {
	            type: 'ec',
	            data: ndata
	          }
	        case '1.2.840.10040.4.1':
	          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
	          return {
	            type: 'dsa',
	            data: ndata.algorithm.params
	          }
	        default: throw new Error('unknown key id ' + subtype)
	      }
	      throw new Error('unknown key type ' + type)
	    case 'ENCRYPTED PRIVATE KEY':
	      data = asn1.EncryptedPrivateKey.decode(data, 'der')
	      data = decrypt(data, password)
	      // falls through
	    case 'PRIVATE KEY':
	      ndata = asn1.PrivateKey.decode(data, 'der')
	      subtype = ndata.algorithm.algorithm.join('.')
	      switch (subtype) {
	        case '1.2.840.113549.1.1.1':
	          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
	        case '1.2.840.10045.2.1':
	          return {
	            curve: ndata.algorithm.curve,
	            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
	          }
	        case '1.2.840.10040.4.1':
	          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
	          return {
	            type: 'dsa',
	            params: ndata.algorithm.params
	          }
	        default: throw new Error('unknown key id ' + subtype)
	      }
	      throw new Error('unknown key type ' + type)
	    case 'RSA PUBLIC KEY':
	      return asn1.RSAPublicKey.decode(data, 'der')
	    case 'RSA PRIVATE KEY':
	      return asn1.RSAPrivateKey.decode(data, 'der')
	    case 'DSA PRIVATE KEY':
	      return {
	        type: 'dsa',
	        params: asn1.DSAPrivateKey.decode(data, 'der')
	      }
	    case 'EC PRIVATE KEY':
	      data = asn1.ECPrivateKey.decode(data, 'der')
	      return {
	        curve: data.parameters.value,
	        privateKey: data.privateKey
	      }
	    default: throw new Error('unknown key type ' + type)
	  }
	}
	parseKeys.signature = asn1.signature
	function decrypt (data, password) {
	  var salt = data.algorithm.decrypt.kde.kdeparams.salt
	  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
	  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
	  var iv = data.algorithm.decrypt.cipher.iv
	  var cipherText = data.subjectPrivateKey
	  var keylen = parseInt(algo.split('-')[1], 10) / 8
	  var key = compat.pbkdf2Sync(password, salt, iters, keylen)
	  var cipher = ciphers.createDecipheriv(algo, key, iv)
	  var out = []
	  out.push(cipher.update(cipherText))
	  out.push(cipher.final())
	  return Buffer.concat(out)
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (!process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = { nextTick: nextTick };
	} else {
	  module.exports = process
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var EventPluginRegistry = __webpack_require__(145);
	var ReactEventEmitterMixin = __webpack_require__(639);
	var ViewportMetrics = __webpack_require__(270);
	
	var getVendorPrefixedEventName = __webpack_require__(671);
	var isEventSupported = __webpack_require__(156);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(79);
	var ViewportMetrics = __webpack_require__(270);
	
	var getEventModifierState = __webpack_require__(154);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(3);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 105 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(15);
	var DOMNamespaces = __webpack_require__(144);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(152);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.buffers = exports.BUFFER_OVERFLOW = undefined;
	
	var _utils = __webpack_require__(26);
	
	var BUFFER_OVERFLOW = exports.BUFFER_OVERFLOW = "Channel's Buffer overflow!";
	
	var ON_OVERFLOW_THROW = 1;
	var ON_OVERFLOW_DROP = 2;
	var ON_OVERFLOW_SLIDE = 3;
	var ON_OVERFLOW_EXPAND = 4;
	
	var zeroBuffer = { isEmpty: _utils.kTrue, put: _utils.noop, take: _utils.noop };
	
	function ringBuffer() {
	  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
	  var overflowAction = arguments[1];
	
	  var arr = new Array(limit);
	  var length = 0;
	  var pushIndex = 0;
	  var popIndex = 0;
	
	  var push = function push(it) {
	    arr[pushIndex] = it;
	    pushIndex = (pushIndex + 1) % limit;
	    length++;
	  };
	
	  var take = function take() {
	    if (length != 0) {
	      var it = arr[popIndex];
	      arr[popIndex] = null;
	      length--;
	      popIndex = (popIndex + 1) % limit;
	      return it;
	    }
	  };
	
	  var flush = function flush() {
	    var items = [];
	    while (length) {
	      items.push(take());
	    }
	    return items;
	  };
	
	  return {
	    isEmpty: function isEmpty() {
	      return length == 0;
	    },
	    put: function put(it) {
	      if (length < limit) {
	        push(it);
	      } else {
	        var doubledLimit = void 0;
	        switch (overflowAction) {
	          case ON_OVERFLOW_THROW:
	            throw new Error(BUFFER_OVERFLOW);
	          case ON_OVERFLOW_SLIDE:
	            arr[pushIndex] = it;
	            pushIndex = (pushIndex + 1) % limit;
	            popIndex = pushIndex;
	            break;
	          case ON_OVERFLOW_EXPAND:
	            doubledLimit = 2 * limit;
	
	            arr = flush();
	
	            length = arr.length;
	            pushIndex = arr.length;
	            popIndex = 0;
	
	            arr.length = doubledLimit;
	            limit = doubledLimit;
	
	            push(it);
	            break;
	          default:
	          // DROP
	        }
	      }
	    },
	    take: take,
	    flush: flush
	  };
	}
	
	var buffers = exports.buffers = {
	  none: function none() {
	    return zeroBuffer;
	  },
	  fixed: function fixed(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_THROW);
	  },
	  dropping: function dropping(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_DROP);
	  },
	  sliding: function sliding(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
	  },
	  expanding: function expanding(initialSize) {
	    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
	  }
	};

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production","PUBLIC_URL":""}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(741);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(740);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(22)))

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	/*
	    This file is part of web3.js.
	
	    web3.js is free software: you can redistribute it and/or modify
	    it under the terms of the GNU Lesser General Public License as published by
	    the Free Software Foundation, either version 3 of the License, or
	    (at your option) any later version.
	
	    web3.js is distributed in the hope that it will be useful,
	    but WITHOUT ANY WARRANTY; without even the implied warranty of
	    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	    GNU Lesser General Public License for more details.
	
	    You should have received a copy of the GNU Lesser General Public License
	    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	*/
	/**
	 * @file index.js
	 * @author Fabian Vogelsteller <fabian@ethereum.org>
	 * @date 2017
	 */
	
	"use strict";
	
	var Subscription = __webpack_require__(751);
	
	
	var Subscriptions = function Subscriptions(options) {
	    this.name = options.name;
	    this.type = options.type;
	    this.subscriptions = options.subscriptions || {};
	    this.requestManager = null;
	};
	
	
	Subscriptions.prototype.setRequestManager = function (rm) {
	    this.requestManager = rm;
	};
	
	
	Subscriptions.prototype.attachToObject = function (obj) {
	    var func = this.buildCall();
	    func.call = this.call;
	    var name = this.name.split('.');
	    if (name.length > 1) {
	        obj[name[0]] = obj[name[0]] || {};
	        obj[name[0]][name[1]] = func;
	    } else {
	        obj[name[0]] = func;
	    }
	};
	
	
	Subscriptions.prototype.buildCall = function() {
	    var _this = this;
	
	    return function(){
	        if(!_this.subscriptions[arguments[0]]) {
	            console.warn('Subscription '+ JSON.stringify(arguments[0]) +' doesn\'t exist. Subscribing anyway.');
	        }
	
	        var subscription = new Subscription({
	            subscription: _this.subscriptions[arguments[0]],
	            requestManager: _this.requestManager,
	            type: _this.type
	        });
	
	        return subscription.subscribe.apply(subscription, arguments);
	    };
	};
	
	
	module.exports = {
	    subscriptions: Subscriptions,
	    subscription: Subscription
	};


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	/*
	    This file is part of web3.js.
	
	    web3.js is free software: you can redistribute it and/or modify
	    it under the terms of the GNU Lesser General Public License as published by
	    the Free Software Foundation, either version 3 of the License, or
	    (at your option) any later version.
	
	    web3.js is distributed in the hope that it will be useful,
	    but WITHOUT ANY WARRANTY; without even the implied warranty of
	    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	    GNU Lesser General Public License for more details.
	
	    You should have received a copy of the GNU Lesser General Public License
	    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	*/
	/**
	 * @file index.js
	 * @author Fabian Vogelsteller <fabian@ethereum.org>
	 * @date 2017
	 */
	
	"use strict";
	
	var core = __webpack_require__(49);
	var Method = __webpack_require__(48);
	var utils = __webpack_require__(23);
	
	
	var Net = function () {
	    var _this = this;
	
	    // sets _requestmanager
	    core.packageInit(this, arguments);
	
	
	    [
	        new Method({
	            name: 'getId',
	            call: 'net_version',
	            params: 0,
	            outputFormatter: utils.hexToNumber
	        }),
	        new Method({
	            name: 'isListening',
	            call: 'net_listening',
	            params: 0
	        }),
	        new Method({
	            name: 'getPeerCount',
	            call: 'net_peerCount',
	            params: 0,
	            outputFormatter: utils.hexToNumber
	        })
	    ].forEach(function(method) {
	        method.attachToObject(_this);
	        method.setRequestManager(_this._requestManager);
	    });
	
	};
	
	core.addProviders(Net);
	
	
	module.exports = Net;
	
	


/***/ },
/* 111 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectPage = selectPage;
	exports.openGame = openGame;
	exports.syncGameCount = syncGameCount;
	exports.syncGamesForAddress = syncGamesForAddress;
	function selectPage(page) {
	  return function (dispatch) {
	    dispatch({
	      type: 'SELECT_PAGE',
	      payload: page
	    });
	  };
	}
	
	function openGame(gameId) {
	  return function (dispatch) {
	    dispatch({
	      type: 'OPEN_GAME',
	      payload: gameId
	    });
	  };
	}
	
	function syncGameCount(drizzle) {
	  return function (dispatch) {
	
	    var dataKey = drizzle.contracts.WorldGame.methods.numberOfGames.cacheCall();
	
	    dispatch({
	      type: 'SET_GAME_COUNT_KEY',
	      payload: dataKey
	    });
	  };
	}
	
	function syncGamesForAddress(drizzle) {
	  return function (dispatch) {
	
	    var dataKey = drizzle.contracts.WorldGame.methods.listGamesForAddress.cacheCall(0);
	
	    dispatch({
	      type: 'SET_GAMES_FOR_ADDRESS',
	      payload: dataKey
	    });
	  };
	}

/***/ },
/* 112 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(36);
	var document = __webpack_require__(18).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 114 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(83);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(30);
	var dPs = __webpack_require__(414);
	var enumBugKeys = __webpack_require__(114);
	var IE_PROTO = __webpack_require__(119)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(113)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(184).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(191);
	var enumBugKeys = __webpack_require__(114);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 118 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(120)('keys');
	var uid = __webpack_require__(87);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(18);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ },
/* 121 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(36);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(18);
	var core = __webpack_require__(17);
	var LIBRARY = __webpack_require__(84);
	var wksExt = __webpack_require__(124);
	var defineProperty = __webpack_require__(37).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(19);


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	var ciphers = __webpack_require__(437)
	var deciphers = __webpack_require__(436)
	var modes = __webpack_require__(236)
	
	function getCiphers () {
	  return Object.keys(modes)
	}
	
	exports.createCipher = exports.Cipher = ciphers.createCipher
	exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
	exports.createDecipher = exports.Decipher = deciphers.createDecipher
	exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
	exports.listCiphers = exports.getCiphers = getCiphers


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	var modeModules = {
	  ECB: __webpack_require__(443),
	  CBC: __webpack_require__(439),
	  CFB: __webpack_require__(440),
	  CFB8: __webpack_require__(442),
	  CFB1: __webpack_require__(441),
	  OFB: __webpack_require__(444),
	  CTR: __webpack_require__(205),
	  GCM: __webpack_require__(205)
	}
	
	var modes = __webpack_require__(236)
	
	for (var key in modes) {
	  modes[key].module = modeModules[modes[key].mode]
	}
	
	module.exports = modes


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var bn = __webpack_require__(7);
	var randomBytes = __webpack_require__(54);
	module.exports = crt;
	function blind(priv) {
	  var r = getr(priv);
	  var blinder = r.toRed(bn.mont(priv.modulus))
	  .redPow(new bn(priv.publicExponent)).fromRed();
	  return {
	    blinder: blinder,
	    unblinder:r.invm(priv.modulus)
	  };
	}
	function crt(msg, priv) {
	  var blinds = blind(priv);
	  var len = priv.modulus.byteLength();
	  var mod = bn.mont(priv.modulus);
	  var blinded = new bn(msg).mul(blinds.blinder).umod(priv.modulus);
	  var c1 = blinded.toRed(bn.mont(priv.prime1));
	  var c2 = blinded.toRed(bn.mont(priv.prime2));
	  var qinv = priv.coefficient;
	  var p = priv.prime1;
	  var q = priv.prime2;
	  var m1 = c1.redPow(priv.exponent1);
	  var m2 = c2.redPow(priv.exponent2);
	  m1 = m1.fromRed();
	  m2 = m2.fromRed();
	  var h = m1.isub(m2).imul(qinv).umod(p);
	  h.imul(q);
	  m2.iadd(h);
	  return new Buffer(m2.imul(blinds.unblinder).umod(priv.modulus).toArray(false, len));
	}
	crt.getr = getr;
	function getr(priv) {
	  var len = priv.modulus.byteLength();
	  var r = new bn(randomBytes(len));
	  while (r.cmp(priv.modulus) >=  0 || !r.umod(priv.prime1) || !r.umod(priv.prime2)) {
	    r = new bn(randomBytes(len));
	  }
	  return r;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	var makeHash = __webpack_require__(454)
	
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length
	 */
	function core_md5 (x, len) {
	  /* append padding */
	  x[len >> 5] |= 0x80 << ((len) % 32)
	  x[(((len + 64) >>> 9) << 4) + 14] = len
	
	  var a = 1732584193
	  var b = -271733879
	  var c = -1732584194
	  var d = 271733878
	
	  for (var i = 0; i < x.length; i += 16) {
	    var olda = a
	    var oldb = b
	    var oldc = c
	    var oldd = d
	
	    a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936)
	    d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586)
	    c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819)
	    b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330)
	    a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897)
	    d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426)
	    c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341)
	    b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983)
	    a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416)
	    d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417)
	    c = md5_ff(c, d, a, b, x[i + 10], 17, -42063)
	    b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162)
	    a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682)
	    d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101)
	    c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290)
	    b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329)
	
	    a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510)
	    d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632)
	    c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713)
	    b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302)
	    a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691)
	    d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083)
	    c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335)
	    b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848)
	    a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438)
	    d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690)
	    c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961)
	    b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501)
	    a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467)
	    d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784)
	    c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473)
	    b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734)
	
	    a = md5_hh(a, b, c, d, x[i + 5], 4, -378558)
	    d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463)
	    c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562)
	    b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556)
	    a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060)
	    d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353)
	    c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632)
	    b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640)
	    a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174)
	    d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222)
	    c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979)
	    b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189)
	    a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487)
	    d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835)
	    c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520)
	    b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651)
	
	    a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844)
	    d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415)
	    c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905)
	    b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055)
	    a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571)
	    d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606)
	    c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523)
	    b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799)
	    a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359)
	    d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744)
	    c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380)
	    b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649)
	    a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070)
	    d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379)
	    c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259)
	    b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551)
	
	    a = safe_add(a, olda)
	    b = safe_add(b, oldb)
	    c = safe_add(c, oldc)
	    d = safe_add(d, oldd)
	  }
	
	  return [a, b, c, d]
	}
	
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	function md5_cmn (q, a, b, x, s, t) {
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b)
	}
	
	function md5_ff (a, b, c, d, x, s, t) {
	  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t)
	}
	
	function md5_gg (a, b, c, d, x, s, t) {
	  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t)
	}
	
	function md5_hh (a, b, c, d, x, s, t) {
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t)
	}
	
	function md5_ii (a, b, c, d, x, s, t) {
	  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t)
	}
	
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add (x, y) {
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF)
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16)
	  return (msw << 16) | (lsw & 0xFFFF)
	}
	
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function bit_rol (num, cnt) {
	  return (num << cnt) | (num >>> (32 - cnt))
	}
	
	module.exports = function md5 (buf) {
	  return makeHash(buf, core_md5)
	}


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var rng = __webpack_require__(470)
	
	function error () {
	  var m = [].slice.call(arguments).join(' ')
	  throw new Error([
	    m,
	    'we accept pull requests',
	    'http://github.com/dominictarr/crypto-browserify'
	    ].join('\n'))
	}
	
	exports.createHash = __webpack_require__(209)
	
	exports.createHmac = __webpack_require__(457)
	
	exports.randomBytes = function(size, callback) {
	  if (callback && callback.call) {
	    try {
	      callback.call(this, undefined, new Buffer(rng(size)))
	    } catch (err) { callback(err) }
	  } else {
	    return new Buffer(rng(size))
	  }
	}
	
	function each(a, f) {
	  for(var i in a)
	    f(a[i], i)
	}
	
	exports.getHashes = function () {
	  return ['sha1', 'sha256', 'sha512', 'md5', 'rmd160']
	}
	
	var p = __webpack_require__(469)(exports)
	exports.pbkdf2 = p.pbkdf2
	exports.pbkdf2Sync = p.pbkdf2Sync
	__webpack_require__(462)(exports, module.exports);
	
	// the least I can do is make error messages for the rest of the node.js/crypto api.
	each(['createCredentials'
	, 'createSign'
	, 'createVerify'
	, 'createDiffieHellman'
	], function (name) {
	  exports[name] = function () {
	    error('sorry,', name, 'is not implemented yet')
	  }
	})
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var uint_max = Math.pow(2, 32);
	function fixup_uint32(x) {
	    var ret, x_pos;
	    ret = x > uint_max || x < 0 ? (x_pos = Math.abs(x) % uint_max, x < 0 ? uint_max - x_pos : x_pos) : x;
	    return ret;
	}
	function scrub_vec(v) {
	  var i, _i, _ref;
	  for (i = _i = 0, _ref = v.length; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
	    v[i] = 0;
	  }
	  return false;
	}
	
	function Global() {
	  var i;
	  this.SBOX = [];
	  this.INV_SBOX = [];
	  this.SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.INV_SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.init();
	  this.RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	}
	
	Global.prototype.init = function() {
	  var d, i, sx, t, x, x2, x4, x8, xi, _i;
	  d = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 256; i = ++_i) {
	      if (i < 128) {
	        _results.push(i << 1);
	      } else {
	        _results.push((i << 1) ^ 0x11b);
	      }
	    }
	    return _results;
	  })();
	  x = 0;
	  xi = 0;
	  for (i = _i = 0; _i < 256; i = ++_i) {
	    sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	    this.SBOX[x] = sx;
	    this.INV_SBOX[sx] = x;
	    x2 = d[x];
	    x4 = d[x2];
	    x8 = d[x4];
	    t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	    this.SUB_MIX[0][x] = (t << 24) | (t >>> 8);
	    this.SUB_MIX[1][x] = (t << 16) | (t >>> 16);
	    this.SUB_MIX[2][x] = (t << 8) | (t >>> 24);
	    this.SUB_MIX[3][x] = t;
	    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	    this.INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8);
	    this.INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16);
	    this.INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24);
	    this.INV_SUB_MIX[3][sx] = t;
	    if (x === 0) {
	      x = xi = 1;
	    } else {
	      x = x2 ^ d[d[d[x8 ^ x2]]];
	      xi ^= d[d[xi]];
	    }
	  }
	  return true;
	};
	
	var G = new Global();
	
	
	AES.blockSize = 4 * 4;
	
	AES.prototype.blockSize = AES.blockSize;
	
	AES.keySize = 256 / 8;
	
	AES.prototype.keySize = AES.keySize;
	
	AES.ivSize = AES.blockSize;
	
	AES.prototype.ivSize = AES.ivSize;
	
	 function bufferToArray(buf) {
	  var len = buf.length/4;
	  var out = new Array(len);
	  var i = -1;
	  while (++i < len) {
	    out[i] = buf.readUInt32BE(i * 4);
	  }
	  return out;
	 }
	function AES(key) {
	  this._key = bufferToArray(key);
	  this._doReset();
	}
	
	AES.prototype._doReset = function() {
	  var invKsRow, keySize, keyWords, ksRow, ksRows, t, _i, _j;
	  keyWords = this._key;
	  keySize = keyWords.length;
	  this._nRounds = keySize + 6;
	  ksRows = (this._nRounds + 1) * 4;
	  this._keySchedule = [];
	  for (ksRow = _i = 0; 0 <= ksRows ? _i < ksRows : _i > ksRows; ksRow = 0 <= ksRows ? ++_i : --_i) {
	    this._keySchedule[ksRow] = ksRow < keySize ? keyWords[ksRow] : (t = this._keySchedule[ksRow - 1], (ksRow % keySize) === 0 ? (t = (t << 8) | (t >>> 24), t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff], t ^= G.RCON[(ksRow / keySize) | 0] << 24) : keySize > 6 && ksRow % keySize === 4 ? t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff] : void 0, this._keySchedule[ksRow - keySize] ^ t);
	  }
	  this._invKeySchedule = [];
	  for (invKsRow = _j = 0; 0 <= ksRows ? _j < ksRows : _j > ksRows; invKsRow = 0 <= ksRows ? ++_j : --_j) {
	    ksRow = ksRows - invKsRow;
	    t = this._keySchedule[ksRow - (invKsRow % 4 ? 0 : 4)];
	    this._invKeySchedule[invKsRow] = invKsRow < 4 || ksRow <= 4 ? t : G.INV_SUB_MIX[0][G.SBOX[t >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[(t >>> 16) & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[(t >>> 8) & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[t & 0xff]];
	  }
	  return true;
	};
	
	AES.prototype.encryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var out = this._doCryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[1], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[3], 12);
	  return buf;
	};
	
	AES.prototype.decryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var temp = [M[3], M[1]];
	  M[1] = temp[0];
	  M[3] = temp[1];
	  var out = this._doCryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[3], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[1], 12);
	  return buf;
	};
	
	AES.prototype.scrub = function() {
	  scrub_vec(this._keySchedule);
	  scrub_vec(this._invKeySchedule);
	  scrub_vec(this._key);
	};
	
	AES.prototype._doCryptBlock = function(M, keySchedule, SUB_MIX, SBOX) {
	  var ksRow, round, s0, s1, s2, s3, t0, t1, t2, t3, _i, _ref;
	
	  s0 = M[0] ^ keySchedule[0];
	  s1 = M[1] ^ keySchedule[1];
	  s2 = M[2] ^ keySchedule[2];
	  s3 = M[3] ^ keySchedule[3];
	  ksRow = 4;
	  for (round = _i = 1, _ref = this._nRounds; 1 <= _ref ? _i < _ref : _i > _ref; round = 1 <= _ref ? ++_i : --_i) {
	    t0 = SUB_MIX[0][s0 >>> 24] ^ SUB_MIX[1][(s1 >>> 16) & 0xff] ^ SUB_MIX[2][(s2 >>> 8) & 0xff] ^ SUB_MIX[3][s3 & 0xff] ^ keySchedule[ksRow++];
	    t1 = SUB_MIX[0][s1 >>> 24] ^ SUB_MIX[1][(s2 >>> 16) & 0xff] ^ SUB_MIX[2][(s3 >>> 8) & 0xff] ^ SUB_MIX[3][s0 & 0xff] ^ keySchedule[ksRow++];
	    t2 = SUB_MIX[0][s2 >>> 24] ^ SUB_MIX[1][(s3 >>> 16) & 0xff] ^ SUB_MIX[2][(s0 >>> 8) & 0xff] ^ SUB_MIX[3][s1 & 0xff] ^ keySchedule[ksRow++];
	    t3 = SUB_MIX[0][s3 >>> 24] ^ SUB_MIX[1][(s0 >>> 16) & 0xff] ^ SUB_MIX[2][(s1 >>> 8) & 0xff] ^ SUB_MIX[3][s2 & 0xff] ^ keySchedule[ksRow++];
	    s0 = t0;
	    s1 = t1;
	    s2 = t2;
	    s3 = t3;
	  }
	  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	  return [
	    fixup_uint32(t0),
	    fixup_uint32(t1),
	    fixup_uint32(t2),
	    fixup_uint32(t3)
	  ];
	
	};
	
	
	
	
	  exports.AES = AES;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var Transform = __webpack_require__(82).Transform;
	var inherits = __webpack_require__(2);
	
	module.exports = CipherBase;
	inherits(CipherBase, Transform);
	function CipherBase() {
	  Transform.call(this);
	}
	CipherBase.prototype.update = function (data, inputEnd, outputEnc) {
	  this.write(data, inputEnd);
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	CipherBase.prototype.final = function (outputEnc) {
	  this.end();
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 132 */
/***/ function(module, exports) {

	exports['aes-128-ecb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-192-ecb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-256-ecb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-128-cbc'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-192-cbc'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-256-cbc'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes128'] = exports['aes-128-cbc'];
	exports['aes192'] = exports['aes-192-cbc'];
	exports['aes256'] = exports['aes-256-cbc'];
	exports['aes-128-cfb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-192-cfb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-256-cfb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-128-ofb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-192-ofb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-256-ofb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-128-ctr'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-192-ctr'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-256-ctr'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.utils = __webpack_require__(477);
	exports.Cipher = __webpack_require__(474);
	exports.DES = __webpack_require__(475);
	exports.CBC = __webpack_require__(473);
	exports.EDE = __webpack_require__(476);


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.qEnd = undefined;
	exports.safeName = safeName;
	exports.default = fsmIterator;
	
	var _utils = /*#__PURE__*/__webpack_require__(24);
	
	var done = { done: true, value: undefined };
	var qEnd = exports.qEnd = {};
	
	function safeName(patternOrChannel) {
	  if (_utils.is.channel(patternOrChannel)) {
	    return 'channel';
	  } else if (Array.isArray(patternOrChannel)) {
	    return String(patternOrChannel.map(function (entry) {
	      return String(entry);
	    }));
	  } else {
	    return String(patternOrChannel);
	  }
	}
	
	function fsmIterator(fsm, q0) {
	  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';
	
	  var updateState = void 0,
	      qNext = q0;
	
	  function next(arg, error) {
	    if (qNext === qEnd) {
	      return done;
	    }
	
	    if (error) {
	      qNext = qEnd;
	      throw error;
	    } else {
	      updateState && updateState(arg);
	
	      var _fsm$qNext = fsm[qNext](),
	          q = _fsm$qNext[0],
	          output = _fsm$qNext[1],
	          _updateState = _fsm$qNext[2];
	
	      qNext = q;
	      updateState = _updateState;
	      return qNext === qEnd ? done : output;
	    }
	  }
	
	  return (0, _utils.makeIterator)(next, function (error) {
	    return next(null, error);
	  }, name, true);
	}

/***/ },
/* 135 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 136 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	var hash = exports;
	
	hash.utils = __webpack_require__(27);
	hash.common = __webpack_require__(75);
	hash.sha = __webpack_require__(537);
	hash.ripemd = __webpack_require__(536);
	hash.hmac = __webpack_require__(535);
	
	// Proxy hash functions to the main object
	hash.sha1 = hash.sha.sha1;
	hash.sha256 = hash.sha.sha256;
	hash.sha224 = hash.sha.sha224;
	hash.sha384 = hash.sha.sha384;
	hash.sha512 = hash.sha.sha512;
	hash.ripemd160 = hash.ripemd.ripemd160;


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(53);
	
	var _DOMUtils = __webpack_require__(97);
	
	var _DOMStateStorage = __webpack_require__(230);
	
	var _PathUtils = __webpack_require__(40);
	
	var _ExecutionEnvironment = __webpack_require__(139);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ },
/* 139 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(541);
	
	var _PathUtils = __webpack_require__(40);
	
	var _runTransitionHook = __webpack_require__(141);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(96);
	
	var _LocationUtils = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(42);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	
	exports.pbkdf2 = __webpack_require__(590)
	
	exports.pbkdf2Sync = __webpack_require__(252)


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(55);
	var Danger = __webpack_require__(616);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactInstrumentation = __webpack_require__(25);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(152);
	var setInnerHTML = __webpack_require__(106);
	var setTextContent = __webpack_require__(278);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 144 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactErrorUtils = __webpack_require__(150);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 147 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactPropTypesSecret = __webpack_require__(645);
	var propTypesFactory = __webpack_require__(254);
	
	var React = __webpack_require__(60);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(3);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(34);
	var ReactInstanceMap = __webpack_require__(78);
	var ReactInstrumentation = __webpack_require__(25);
	var ReactUpdates = __webpack_require__(28);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 152 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 153 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 154 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 155 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(15);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 157 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var emptyFunction = __webpack_require__(20);
	var warning = __webpack_require__(5);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;
	
	var _reducer = __webpack_require__(281);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(280);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _sync = __webpack_require__(675);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _middleware = __webpack_require__(674);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.syncHistoryWithStore = _sync2['default'];
	exports.routerMiddleware = _middleware2['default'];

/***/ },
/* 160 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	function ContextProvider(name) {
	  var _childContextTypes, _ref2;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  return _ref2 = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _ref2[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _ref2;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _ref4;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  return _ref4 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref3;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _ref4;
	}

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__(11);
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(32);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(11);
	
	var _getRouteParams = __webpack_require__(686);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(161);
	
	var _RouteUtils = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 164 */
10,
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(101).nextTick;
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = __webpack_require__(73);
	util.inherits = __webpack_require__(2);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(739)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(299);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(4).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(298);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(47);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(47);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  processNextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    processNextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    processNextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    processNextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      processNextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22), __webpack_require__(313).setImmediate, (function() { return this; }())))

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(296);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(165);
	exports.Duplex = __webpack_require__(47);
	exports.Transform = __webpack_require__(297);
	exports.PassThrough = __webpack_require__(705);


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.qEnd = undefined;
	exports.safeName = safeName;
	exports.default = fsmIterator;
	
	var _utils = __webpack_require__(26);
	
	var done = { done: true, value: undefined };
	var qEnd = exports.qEnd = {};
	
	function safeName(patternOrChannel) {
	  if (_utils.is.channel(patternOrChannel)) {
	    return 'channel';
	  } else if (Array.isArray(patternOrChannel)) {
	    return String(patternOrChannel.map(function (entry) {
	      return String(entry);
	    }));
	  } else {
	    return String(patternOrChannel);
	  }
	}
	
	function fsmIterator(fsm, q0) {
	  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';
	
	  var updateState = void 0,
	      qNext = q0;
	
	  function next(arg, error) {
	    if (qNext === qEnd) {
	      return done;
	    }
	
	    if (error) {
	      qNext = qEnd;
	      throw error;
	    } else {
	      updateState && updateState(arg);
	
	      var _fsm$qNext = fsm[qNext](),
	          q = _fsm$qNext[0],
	          output = _fsm$qNext[1],
	          _updateState = _fsm$qNext[2];
	
	      qNext = q;
	      updateState = _updateState;
	      return qNext === qEnd ? done : output;
	    }
	  }
	
	  return (0, _utils.makeIterator)(next, function (error) {
	    return next(null, error);
	  }, name, true);
	}

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(306);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(719);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(718);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(717);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(305);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(307);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict'
	var inherits = __webpack_require__(2)
	var HashBase = __webpack_require__(534)
	
	function RIPEMD160 () {
	  HashBase.call(this, 64)
	
	  // state
	  this._a = 0x67452301
	  this._b = 0xefcdab89
	  this._c = 0x98badcfe
	  this._d = 0x10325476
	  this._e = 0xc3d2e1f0
	}
	
	inherits(RIPEMD160, HashBase)
	
	RIPEMD160.prototype._update = function () {
	  var m = new Array(16)
	  for (var i = 0; i < 16; ++i) m[i] = this._block.readInt32LE(i * 4)
	
	  var al = this._a
	  var bl = this._b
	  var cl = this._c
	  var dl = this._d
	  var el = this._e
	
	  // Mj = 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15
	  // K = 0x00000000
	  // Sj = 11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8
	  al = fn1(al, bl, cl, dl, el, m[0], 0x00000000, 11); cl = rotl(cl, 10)
	  el = fn1(el, al, bl, cl, dl, m[1], 0x00000000, 14); bl = rotl(bl, 10)
	  dl = fn1(dl, el, al, bl, cl, m[2], 0x00000000, 15); al = rotl(al, 10)
	  cl = fn1(cl, dl, el, al, bl, m[3], 0x00000000, 12); el = rotl(el, 10)
	  bl = fn1(bl, cl, dl, el, al, m[4], 0x00000000, 5); dl = rotl(dl, 10)
	  al = fn1(al, bl, cl, dl, el, m[5], 0x00000000, 8); cl = rotl(cl, 10)
	  el = fn1(el, al, bl, cl, dl, m[6], 0x00000000, 7); bl = rotl(bl, 10)
	  dl = fn1(dl, el, al, bl, cl, m[7], 0x00000000, 9); al = rotl(al, 10)
	  cl = fn1(cl, dl, el, al, bl, m[8], 0x00000000, 11); el = rotl(el, 10)
	  bl = fn1(bl, cl, dl, el, al, m[9], 0x00000000, 13); dl = rotl(dl, 10)
	  al = fn1(al, bl, cl, dl, el, m[10], 0x00000000, 14); cl = rotl(cl, 10)
	  el = fn1(el, al, bl, cl, dl, m[11], 0x00000000, 15); bl = rotl(bl, 10)
	  dl = fn1(dl, el, al, bl, cl, m[12], 0x00000000, 6); al = rotl(al, 10)
	  cl = fn1(cl, dl, el, al, bl, m[13], 0x00000000, 7); el = rotl(el, 10)
	  bl = fn1(bl, cl, dl, el, al, m[14], 0x00000000, 9); dl = rotl(dl, 10)
	  al = fn1(al, bl, cl, dl, el, m[15], 0x00000000, 8); cl = rotl(cl, 10)
	
	  // Mj = 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8
	  // K = 0x5a827999
	  // Sj = 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12
	  el = fn2(el, al, bl, cl, dl, m[7], 0x5a827999, 7); bl = rotl(bl, 10)
	  dl = fn2(dl, el, al, bl, cl, m[4], 0x5a827999, 6); al = rotl(al, 10)
	  cl = fn2(cl, dl, el, al, bl, m[13], 0x5a827999, 8); el = rotl(el, 10)
	  bl = fn2(bl, cl, dl, el, al, m[1], 0x5a827999, 13); dl = rotl(dl, 10)
	  al = fn2(al, bl, cl, dl, el, m[10], 0x5a827999, 11); cl = rotl(cl, 10)
	  el = fn2(el, al, bl, cl, dl, m[6], 0x5a827999, 9); bl = rotl(bl, 10)
	  dl = fn2(dl, el, al, bl, cl, m[15], 0x5a827999, 7); al = rotl(al, 10)
	  cl = fn2(cl, dl, el, al, bl, m[3], 0x5a827999, 15); el = rotl(el, 10)
	  bl = fn2(bl, cl, dl, el, al, m[12], 0x5a827999, 7); dl = rotl(dl, 10)
	  al = fn2(al, bl, cl, dl, el, m[0], 0x5a827999, 12); cl = rotl(cl, 10)
	  el = fn2(el, al, bl, cl, dl, m[9], 0x5a827999, 15); bl = rotl(bl, 10)
	  dl = fn2(dl, el, al, bl, cl, m[5], 0x5a827999, 9); al = rotl(al, 10)
	  cl = fn2(cl, dl, el, al, bl, m[2], 0x5a827999, 11); el = rotl(el, 10)
	  bl = fn2(bl, cl, dl, el, al, m[14], 0x5a827999, 7); dl = rotl(dl, 10)
	  al = fn2(al, bl, cl, dl, el, m[11], 0x5a827999, 13); cl = rotl(cl, 10)
	  el = fn2(el, al, bl, cl, dl, m[8], 0x5a827999, 12); bl = rotl(bl, 10)
	
	  // Mj = 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12
	  // K = 0x6ed9eba1
	  // Sj = 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5
	  dl = fn3(dl, el, al, bl, cl, m[3], 0x6ed9eba1, 11); al = rotl(al, 10)
	  cl = fn3(cl, dl, el, al, bl, m[10], 0x6ed9eba1, 13); el = rotl(el, 10)
	  bl = fn3(bl, cl, dl, el, al, m[14], 0x6ed9eba1, 6); dl = rotl(dl, 10)
	  al = fn3(al, bl, cl, dl, el, m[4], 0x6ed9eba1, 7); cl = rotl(cl, 10)
	  el = fn3(el, al, bl, cl, dl, m[9], 0x6ed9eba1, 14); bl = rotl(bl, 10)
	  dl = fn3(dl, el, al, bl, cl, m[15], 0x6ed9eba1, 9); al = rotl(al, 10)
	  cl = fn3(cl, dl, el, al, bl, m[8], 0x6ed9eba1, 13); el = rotl(el, 10)
	  bl = fn3(bl, cl, dl, el, al, m[1], 0x6ed9eba1, 15); dl = rotl(dl, 10)
	  al = fn3(al, bl, cl, dl, el, m[2], 0x6ed9eba1, 14); cl = rotl(cl, 10)
	  el = fn3(el, al, bl, cl, dl, m[7], 0x6ed9eba1, 8); bl = rotl(bl, 10)
	  dl = fn3(dl, el, al, bl, cl, m[0], 0x6ed9eba1, 13); al = rotl(al, 10)
	  cl = fn3(cl, dl, el, al, bl, m[6], 0x6ed9eba1, 6); el = rotl(el, 10)
	  bl = fn3(bl, cl, dl, el, al, m[13], 0x6ed9eba1, 5); dl = rotl(dl, 10)
	  al = fn3(al, bl, cl, dl, el, m[11], 0x6ed9eba1, 12); cl = rotl(cl, 10)
	  el = fn3(el, al, bl, cl, dl, m[5], 0x6ed9eba1, 7); bl = rotl(bl, 10)
	  dl = fn3(dl, el, al, bl, cl, m[12], 0x6ed9eba1, 5); al = rotl(al, 10)
	
	  // Mj = 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2
	  // K = 0x8f1bbcdc
	  // Sj = 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12
	  cl = fn4(cl, dl, el, al, bl, m[1], 0x8f1bbcdc, 11); el = rotl(el, 10)
	  bl = fn4(bl, cl, dl, el, al, m[9], 0x8f1bbcdc, 12); dl = rotl(dl, 10)
	  al = fn4(al, bl, cl, dl, el, m[11], 0x8f1bbcdc, 14); cl = rotl(cl, 10)
	  el = fn4(el, al, bl, cl, dl, m[10], 0x8f1bbcdc, 15); bl = rotl(bl, 10)
	  dl = fn4(dl, el, al, bl, cl, m[0], 0x8f1bbcdc, 14); al = rotl(al, 10)
	  cl = fn4(cl, dl, el, al, bl, m[8], 0x8f1bbcdc, 15); el = rotl(el, 10)
	  bl = fn4(bl, cl, dl, el, al, m[12], 0x8f1bbcdc, 9); dl = rotl(dl, 10)
	  al = fn4(al, bl, cl, dl, el, m[4], 0x8f1bbcdc, 8); cl = rotl(cl, 10)
	  el = fn4(el, al, bl, cl, dl, m[13], 0x8f1bbcdc, 9); bl = rotl(bl, 10)
	  dl = fn4(dl, el, al, bl, cl, m[3], 0x8f1bbcdc, 14); al = rotl(al, 10)
	  cl = fn4(cl, dl, el, al, bl, m[7], 0x8f1bbcdc, 5); el = rotl(el, 10)
	  bl = fn4(bl, cl, dl, el, al, m[15], 0x8f1bbcdc, 6); dl = rotl(dl, 10)
	  al = fn4(al, bl, cl, dl, el, m[14], 0x8f1bbcdc, 8); cl = rotl(cl, 10)
	  el = fn4(el, al, bl, cl, dl, m[5], 0x8f1bbcdc, 6); bl = rotl(bl, 10)
	  dl = fn4(dl, el, al, bl, cl, m[6], 0x8f1bbcdc, 5); al = rotl(al, 10)
	  cl = fn4(cl, dl, el, al, bl, m[2], 0x8f1bbcdc, 12); el = rotl(el, 10)
	
	  // Mj = 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
	  // K = 0xa953fd4e
	  // Sj = 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
	  bl = fn5(bl, cl, dl, el, al, m[4], 0xa953fd4e, 9); dl = rotl(dl, 10)
	  al = fn5(al, bl, cl, dl, el, m[0], 0xa953fd4e, 15); cl = rotl(cl, 10)
	  el = fn5(el, al, bl, cl, dl, m[5], 0xa953fd4e, 5); bl = rotl(bl, 10)
	  dl = fn5(dl, el, al, bl, cl, m[9], 0xa953fd4e, 11); al = rotl(al, 10)
	  cl = fn5(cl, dl, el, al, bl, m[7], 0xa953fd4e, 6); el = rotl(el, 10)
	  bl = fn5(bl, cl, dl, el, al, m[12], 0xa953fd4e, 8); dl = rotl(dl, 10)
	  al = fn5(al, bl, cl, dl, el, m[2], 0xa953fd4e, 13); cl = rotl(cl, 10)
	  el = fn5(el, al, bl, cl, dl, m[10], 0xa953fd4e, 12); bl = rotl(bl, 10)
	  dl = fn5(dl, el, al, bl, cl, m[14], 0xa953fd4e, 5); al = rotl(al, 10)
	  cl = fn5(cl, dl, el, al, bl, m[1], 0xa953fd4e, 12); el = rotl(el, 10)
	  bl = fn5(bl, cl, dl, el, al, m[3], 0xa953fd4e, 13); dl = rotl(dl, 10)
	  al = fn5(al, bl, cl, dl, el, m[8], 0xa953fd4e, 14); cl = rotl(cl, 10)
	  el = fn5(el, al, bl, cl, dl, m[11], 0xa953fd4e, 11); bl = rotl(bl, 10)
	  dl = fn5(dl, el, al, bl, cl, m[6], 0xa953fd4e, 8); al = rotl(al, 10)
	  cl = fn5(cl, dl, el, al, bl, m[15], 0xa953fd4e, 5); el = rotl(el, 10)
	  bl = fn5(bl, cl, dl, el, al, m[13], 0xa953fd4e, 6); dl = rotl(dl, 10)
	
	  var ar = this._a
	  var br = this._b
	  var cr = this._c
	  var dr = this._d
	  var er = this._e
	
	  // M'j = 5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12
	  // K' = 0x50a28be6
	  // S'j = 8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6
	  ar = fn5(ar, br, cr, dr, er, m[5], 0x50a28be6, 8); cr = rotl(cr, 10)
	  er = fn5(er, ar, br, cr, dr, m[14], 0x50a28be6, 9); br = rotl(br, 10)
	  dr = fn5(dr, er, ar, br, cr, m[7], 0x50a28be6, 9); ar = rotl(ar, 10)
	  cr = fn5(cr, dr, er, ar, br, m[0], 0x50a28be6, 11); er = rotl(er, 10)
	  br = fn5(br, cr, dr, er, ar, m[9], 0x50a28be6, 13); dr = rotl(dr, 10)
	  ar = fn5(ar, br, cr, dr, er, m[2], 0x50a28be6, 15); cr = rotl(cr, 10)
	  er = fn5(er, ar, br, cr, dr, m[11], 0x50a28be6, 15); br = rotl(br, 10)
	  dr = fn5(dr, er, ar, br, cr, m[4], 0x50a28be6, 5); ar = rotl(ar, 10)
	  cr = fn5(cr, dr, er, ar, br, m[13], 0x50a28be6, 7); er = rotl(er, 10)
	  br = fn5(br, cr, dr, er, ar, m[6], 0x50a28be6, 7); dr = rotl(dr, 10)
	  ar = fn5(ar, br, cr, dr, er, m[15], 0x50a28be6, 8); cr = rotl(cr, 10)
	  er = fn5(er, ar, br, cr, dr, m[8], 0x50a28be6, 11); br = rotl(br, 10)
	  dr = fn5(dr, er, ar, br, cr, m[1], 0x50a28be6, 14); ar = rotl(ar, 10)
	  cr = fn5(cr, dr, er, ar, br, m[10], 0x50a28be6, 14); er = rotl(er, 10)
	  br = fn5(br, cr, dr, er, ar, m[3], 0x50a28be6, 12); dr = rotl(dr, 10)
	  ar = fn5(ar, br, cr, dr, er, m[12], 0x50a28be6, 6); cr = rotl(cr, 10)
	
	  // M'j = 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2
	  // K' = 0x5c4dd124
	  // S'j = 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11
	  er = fn4(er, ar, br, cr, dr, m[6], 0x5c4dd124, 9); br = rotl(br, 10)
	  dr = fn4(dr, er, ar, br, cr, m[11], 0x5c4dd124, 13); ar = rotl(ar, 10)
	  cr = fn4(cr, dr, er, ar, br, m[3], 0x5c4dd124, 15); er = rotl(er, 10)
	  br = fn4(br, cr, dr, er, ar, m[7], 0x5c4dd124, 7); dr = rotl(dr, 10)
	  ar = fn4(ar, br, cr, dr, er, m[0], 0x5c4dd124, 12); cr = rotl(cr, 10)
	  er = fn4(er, ar, br, cr, dr, m[13], 0x5c4dd124, 8); br = rotl(br, 10)
	  dr = fn4(dr, er, ar, br, cr, m[5], 0x5c4dd124, 9); ar = rotl(ar, 10)
	  cr = fn4(cr, dr, er, ar, br, m[10], 0x5c4dd124, 11); er = rotl(er, 10)
	  br = fn4(br, cr, dr, er, ar, m[14], 0x5c4dd124, 7); dr = rotl(dr, 10)
	  ar = fn4(ar, br, cr, dr, er, m[15], 0x5c4dd124, 7); cr = rotl(cr, 10)
	  er = fn4(er, ar, br, cr, dr, m[8], 0x5c4dd124, 12); br = rotl(br, 10)
	  dr = fn4(dr, er, ar, br, cr, m[12], 0x5c4dd124, 7); ar = rotl(ar, 10)
	  cr = fn4(cr, dr, er, ar, br, m[4], 0x5c4dd124, 6); er = rotl(er, 10)
	  br = fn4(br, cr, dr, er, ar, m[9], 0x5c4dd124, 15); dr = rotl(dr, 10)
	  ar = fn4(ar, br, cr, dr, er, m[1], 0x5c4dd124, 13); cr = rotl(cr, 10)
	  er = fn4(er, ar, br, cr, dr, m[2], 0x5c4dd124, 11); br = rotl(br, 10)
	
	  // M'j = 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13
	  // K' = 0x6d703ef3
	  // S'j = 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5
	  dr = fn3(dr, er, ar, br, cr, m[15], 0x6d703ef3, 9); ar = rotl(ar, 10)
	  cr = fn3(cr, dr, er, ar, br, m[5], 0x6d703ef3, 7); er = rotl(er, 10)
	  br = fn3(br, cr, dr, er, ar, m[1], 0x6d703ef3, 15); dr = rotl(dr, 10)
	  ar = fn3(ar, br, cr, dr, er, m[3], 0x6d703ef3, 11); cr = rotl(cr, 10)
	  er = fn3(er, ar, br, cr, dr, m[7], 0x6d703ef3, 8); br = rotl(br, 10)
	  dr = fn3(dr, er, ar, br, cr, m[14], 0x6d703ef3, 6); ar = rotl(ar, 10)
	  cr = fn3(cr, dr, er, ar, br, m[6], 0x6d703ef3, 6); er = rotl(er, 10)
	  br = fn3(br, cr, dr, er, ar, m[9], 0x6d703ef3, 14); dr = rotl(dr, 10)
	  ar = fn3(ar, br, cr, dr, er, m[11], 0x6d703ef3, 12); cr = rotl(cr, 10)
	  er = fn3(er, ar, br, cr, dr, m[8], 0x6d703ef3, 13); br = rotl(br, 10)
	  dr = fn3(dr, er, ar, br, cr, m[12], 0x6d703ef3, 5); ar = rotl(ar, 10)
	  cr = fn3(cr, dr, er, ar, br, m[2], 0x6d703ef3, 14); er = rotl(er, 10)
	  br = fn3(br, cr, dr, er, ar, m[10], 0x6d703ef3, 13); dr = rotl(dr, 10)
	  ar = fn3(ar, br, cr, dr, er, m[0], 0x6d703ef3, 13); cr = rotl(cr, 10)
	  er = fn3(er, ar, br, cr, dr, m[4], 0x6d703ef3, 7); br = rotl(br, 10)
	  dr = fn3(dr, er, ar, br, cr, m[13], 0x6d703ef3, 5); ar = rotl(ar, 10)
	
	  // M'j = 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14
	  // K' = 0x7a6d76e9
	  // S'j = 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8
	  cr = fn2(cr, dr, er, ar, br, m[8], 0x7a6d76e9, 15); er = rotl(er, 10)
	  br = fn2(br, cr, dr, er, ar, m[6], 0x7a6d76e9, 5); dr = rotl(dr, 10)
	  ar = fn2(ar, br, cr, dr, er, m[4], 0x7a6d76e9, 8); cr = rotl(cr, 10)
	  er = fn2(er, ar, br, cr, dr, m[1], 0x7a6d76e9, 11); br = rotl(br, 10)
	  dr = fn2(dr, er, ar, br, cr, m[3], 0x7a6d76e9, 14); ar = rotl(ar, 10)
	  cr = fn2(cr, dr, er, ar, br, m[11], 0x7a6d76e9, 14); er = rotl(er, 10)
	  br = fn2(br, cr, dr, er, ar, m[15], 0x7a6d76e9, 6); dr = rotl(dr, 10)
	  ar = fn2(ar, br, cr, dr, er, m[0], 0x7a6d76e9, 14); cr = rotl(cr, 10)
	  er = fn2(er, ar, br, cr, dr, m[5], 0x7a6d76e9, 6); br = rotl(br, 10)
	  dr = fn2(dr, er, ar, br, cr, m[12], 0x7a6d76e9, 9); ar = rotl(ar, 10)
	  cr = fn2(cr, dr, er, ar, br, m[2], 0x7a6d76e9, 12); er = rotl(er, 10)
	  br = fn2(br, cr, dr, er, ar, m[13], 0x7a6d76e9, 9); dr = rotl(dr, 10)
	  ar = fn2(ar, br, cr, dr, er, m[9], 0x7a6d76e9, 12); cr = rotl(cr, 10)
	  er = fn2(er, ar, br, cr, dr, m[7], 0x7a6d76e9, 5); br = rotl(br, 10)
	  dr = fn2(dr, er, ar, br, cr, m[10], 0x7a6d76e9, 15); ar = rotl(ar, 10)
	  cr = fn2(cr, dr, er, ar, br, m[14], 0x7a6d76e9, 8); er = rotl(er, 10)
	
	  // M'j = 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
	  // K' = 0x00000000
	  // S'j = 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
	  br = fn1(br, cr, dr, er, ar, m[12], 0x00000000, 8); dr = rotl(dr, 10)
	  ar = fn1(ar, br, cr, dr, er, m[15], 0x00000000, 5); cr = rotl(cr, 10)
	  er = fn1(er, ar, br, cr, dr, m[10], 0x00000000, 12); br = rotl(br, 10)
	  dr = fn1(dr, er, ar, br, cr, m[4], 0x00000000, 9); ar = rotl(ar, 10)
	  cr = fn1(cr, dr, er, ar, br, m[1], 0x00000000, 12); er = rotl(er, 10)
	  br = fn1(br, cr, dr, er, ar, m[5], 0x00000000, 5); dr = rotl(dr, 10)
	  ar = fn1(ar, br, cr, dr, er, m[8], 0x00000000, 14); cr = rotl(cr, 10)
	  er = fn1(er, ar, br, cr, dr, m[7], 0x00000000, 6); br = rotl(br, 10)
	  dr = fn1(dr, er, ar, br, cr, m[6], 0x00000000, 8); ar = rotl(ar, 10)
	  cr = fn1(cr, dr, er, ar, br, m[2], 0x00000000, 13); er = rotl(er, 10)
	  br = fn1(br, cr, dr, er, ar, m[13], 0x00000000, 6); dr = rotl(dr, 10)
	  ar = fn1(ar, br, cr, dr, er, m[14], 0x00000000, 5); cr = rotl(cr, 10)
	  er = fn1(er, ar, br, cr, dr, m[0], 0x00000000, 15); br = rotl(br, 10)
	  dr = fn1(dr, er, ar, br, cr, m[3], 0x00000000, 13); ar = rotl(ar, 10)
	  cr = fn1(cr, dr, er, ar, br, m[9], 0x00000000, 11); er = rotl(er, 10)
	  br = fn1(br, cr, dr, er, ar, m[11], 0x00000000, 11); dr = rotl(dr, 10)
	
	  // change state
	  var t = (this._b + cl + dr) | 0
	  this._b = (this._c + dl + er) | 0
	  this._c = (this._d + el + ar) | 0
	  this._d = (this._e + al + br) | 0
	  this._e = (this._a + bl + cr) | 0
	  this._a = t
	}
	
	RIPEMD160.prototype._digest = function () {
	  // create padding and handle blocks
	  this._block[this._blockOffset++] = 0x80
	  if (this._blockOffset > 56) {
	    this._block.fill(0, this._blockOffset, 64)
	    this._update()
	    this._blockOffset = 0
	  }
	
	  this._block.fill(0, this._blockOffset, 56)
	  this._block.writeUInt32LE(this._length[0], 56)
	  this._block.writeUInt32LE(this._length[1], 60)
	  this._update()
	
	  // produce result
	  var buffer = new Buffer(20)
	  buffer.writeInt32LE(this._a, 0)
	  buffer.writeInt32LE(this._b, 4)
	  buffer.writeInt32LE(this._c, 8)
	  buffer.writeInt32LE(this._d, 12)
	  buffer.writeInt32LE(this._e, 16)
	  return buffer
	}
	
	function rotl (x, n) {
	  return (x << n) | (x >>> (32 - n))
	}
	
	function fn1 (a, b, c, d, e, m, k, s) {
	  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
	}
	
	function fn2 (a, b, c, d, e, m, k, s) {
	  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
	}
	
	function fn3 (a, b, c, d, e, m, k, s) {
	  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
	}
	
	function fn4 (a, b, c, d, e, m, k, s) {
	  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
	}
	
	function fn5 (a, b, c, d, e, m, k, s) {
	  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
	}
	
	module.exports = RIPEMD160
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	var exports = module.exports = function SHA (algorithm) {
	  algorithm = algorithm.toLowerCase()
	
	  var Algorithm = exports[algorithm]
	  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')
	
	  return new Algorithm()
	}
	
	exports.sha = __webpack_require__(725)
	exports.sha1 = __webpack_require__(726)
	exports.sha224 = __webpack_require__(727)
	exports.sha256 = __webpack_require__(308)
	exports.sha384 = __webpack_require__(728)
	exports.sha512 = __webpack_require__(309)


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Buffer = __webpack_require__(4).Buffer;
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return -1;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// UTF-8 replacement characters ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd'.repeat(p);
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd'.repeat(p + 1);
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd'.repeat(p + 2);
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character for each buffered byte of a (partial)
	// character needs to be added to the output.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd'.repeat(this.lastTotal - this.lastNeed);
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ },
/* 172 */
[792, 762],
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(328)().Promise


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(2);
	var Reporter = __webpack_require__(67).Reporter;
	var Buffer = __webpack_require__(1).Buffer;
	
	function DecoderBuffer(base, options) {
	  Reporter.call(this, options);
	  if (!Buffer.isBuffer(base)) {
	    this.error('Input not Buffer');
	    return;
	  }
	
	  this.base = base;
	  this.offset = 0;
	  this.length = base.length;
	}
	inherits(DecoderBuffer, Reporter);
	exports.DecoderBuffer = DecoderBuffer;
	
	DecoderBuffer.prototype.save = function save() {
	  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
	};
	
	DecoderBuffer.prototype.restore = function restore(save) {
	  // Return skipped data
	  var res = new DecoderBuffer(this.base);
	  res.offset = save.offset;
	  res.length = this.offset;
	
	  this.offset = save.offset;
	  Reporter.prototype.restore.call(this, save.reporter);
	
	  return res;
	};
	
	DecoderBuffer.prototype.isEmpty = function isEmpty() {
	  return this.offset === this.length;
	};
	
	DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
	  if (this.offset + 1 <= this.length)
	    return this.base.readUInt8(this.offset++, true);
	  else
	    return this.error(fail || 'DecoderBuffer overrun');
	}
	
	DecoderBuffer.prototype.skip = function skip(bytes, fail) {
	  if (!(this.offset + bytes <= this.length))
	    return this.error(fail || 'DecoderBuffer overrun');
	
	  var res = new DecoderBuffer(this.base);
	
	  // Share reporter state
	  res._reporterState = this._reporterState;
	
	  res.offset = this.offset;
	  res.length = this.offset + bytes;
	  this.offset += bytes;
	  return res;
	}
	
	DecoderBuffer.prototype.raw = function raw(save) {
	  return this.base.slice(save ? save.offset : this.offset, this.length);
	}
	
	function EncoderBuffer(value, reporter) {
	  if (Array.isArray(value)) {
	    this.length = 0;
	    this.value = value.map(function(item) {
	      if (!(item instanceof EncoderBuffer))
	        item = new EncoderBuffer(item, reporter);
	      this.length += item.length;
	      return item;
	    }, this);
	  } else if (typeof value === 'number') {
	    if (!(0 <= value && value <= 0xff))
	      return reporter.error('non-byte EncoderBuffer value');
	    this.value = value;
	    this.length = 1;
	  } else if (typeof value === 'string') {
	    this.value = value;
	    this.length = Buffer.byteLength(value);
	  } else if (Buffer.isBuffer(value)) {
	    this.value = value;
	    this.length = value.length;
	  } else {
	    return reporter.error('Unsupported type: ' + typeof value);
	  }
	}
	exports.EncoderBuffer = EncoderBuffer;
	
	EncoderBuffer.prototype.join = function join(out, offset) {
	  if (!out)
	    out = new Buffer(this.length);
	  if (!offset)
	    offset = 0;
	
	  if (this.length === 0)
	    return out;
	
	  if (Array.isArray(this.value)) {
	    this.value.forEach(function(item) {
	      item.join(out, offset);
	      offset += item.length;
	    });
	  } else {
	    if (typeof this.value === 'number')
	      out[offset] = this.value;
	    else if (typeof this.value === 'string')
	      out.write(this.value, offset);
	    else if (Buffer.isBuffer(this.value))
	      this.value.copy(out, offset);
	    offset += this.length;
	  }
	
	  return out;
	};


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	var constants = exports;
	
	// Helper
	constants._reverse = function reverse(map) {
	  var res = {};
	
	  Object.keys(map).forEach(function(key) {
	    // Convert key to integer if it is stringified
	    if ((key | 0) == key)
	      key = key | 0;
	
	    var value = map[key];
	    res[value] = key;
	  });
	
	  return res;
	};
	
	constants.der = __webpack_require__(333);


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(2);
	
	var asn1 = __webpack_require__(66);
	var base = asn1.base;
	var bignum = asn1.bignum;
	
	// Import DER constants
	var der = asn1.constants.der;
	
	function DERDecoder(entity) {
	  this.enc = 'der';
	  this.name = entity.name;
	  this.entity = entity;
	
	  // Construct base tree
	  this.tree = new DERNode();
	  this.tree._init(entity.body);
	};
	module.exports = DERDecoder;
	
	DERDecoder.prototype.decode = function decode(data, options) {
	  if (!(data instanceof base.DecoderBuffer))
	    data = new base.DecoderBuffer(data, options);
	
	  return this.tree._decode(data, options);
	};
	
	// Tree methods
	
	function DERNode(parent) {
	  base.Node.call(this, 'der', parent);
	}
	inherits(DERNode, base.Node);
	
	DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
	  if (buffer.isEmpty())
	    return false;
	
	  var state = buffer.save();
	  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
	  if (buffer.isError(decodedTag))
	    return decodedTag;
	
	  buffer.restore(state);
	
	  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
	    (decodedTag.tagStr + 'of') === tag || any;
	};
	
	DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
	  var decodedTag = derDecodeTag(buffer,
	                                'Failed to decode tag of "' + tag + '"');
	  if (buffer.isError(decodedTag))
	    return decodedTag;
	
	  var len = derDecodeLen(buffer,
	                         decodedTag.primitive,
	                         'Failed to get length of "' + tag + '"');
	
	  // Failure
	  if (buffer.isError(len))
	    return len;
	
	  if (!any &&
	      decodedTag.tag !== tag &&
	      decodedTag.tagStr !== tag &&
	      decodedTag.tagStr + 'of' !== tag) {
	    return buffer.error('Failed to match tag: "' + tag + '"');
	  }
	
	  if (decodedTag.primitive || len !== null)
	    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
	
	  // Indefinite length... find END tag
	  var state = buffer.save();
	  var res = this._skipUntilEnd(
	      buffer,
	      'Failed to skip indefinite length body: "' + this.tag + '"');
	  if (buffer.isError(res))
	    return res;
	
	  len = buffer.offset - state.offset;
	  buffer.restore(state);
	  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
	};
	
	DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
	  while (true) {
	    var tag = derDecodeTag(buffer, fail);
	    if (buffer.isError(tag))
	      return tag;
	    var len = derDecodeLen(buffer, tag.primitive, fail);
	    if (buffer.isError(len))
	      return len;
	
	    var res;
	    if (tag.primitive || len !== null)
	      res = buffer.skip(len)
	    else
	      res = this._skipUntilEnd(buffer, fail);
	
	    // Failure
	    if (buffer.isError(res))
	      return res;
	
	    if (tag.tagStr === 'end')
	      break;
	  }
	};
	
	DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
	                                                    options) {
	  var result = [];
	  while (!buffer.isEmpty()) {
	    var possibleEnd = this._peekTag(buffer, 'end');
	    if (buffer.isError(possibleEnd))
	      return possibleEnd;
	
	    var res = decoder.decode(buffer, 'der', options);
	    if (buffer.isError(res) && possibleEnd)
	      break;
	    result.push(res);
	  }
	  return result;
	};
	
	DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
	  if (tag === 'bitstr') {
	    var unused = buffer.readUInt8();
	    if (buffer.isError(unused))
	      return unused;
	    return { unused: unused, data: buffer.raw() };
	  } else if (tag === 'bmpstr') {
	    var raw = buffer.raw();
	    if (raw.length % 2 === 1)
	      return buffer.error('Decoding of string type: bmpstr length mismatch');
	
	    var str = '';
	    for (var i = 0; i < raw.length / 2; i++) {
	      str += String.fromCharCode(raw.readUInt16BE(i * 2));
	    }
	    return str;
	  } else if (tag === 'numstr') {
	    var numstr = buffer.raw().toString('ascii');
	    if (!this._isNumstr(numstr)) {
	      return buffer.error('Decoding of string type: ' +
	                          'numstr unsupported characters');
	    }
	    return numstr;
	  } else if (tag === 'octstr') {
	    return buffer.raw();
	  } else if (tag === 'objDesc') {
	    return buffer.raw();
	  } else if (tag === 'printstr') {
	    var printstr = buffer.raw().toString('ascii');
	    if (!this._isPrintstr(printstr)) {
	      return buffer.error('Decoding of string type: ' +
	                          'printstr unsupported characters');
	    }
	    return printstr;
	  } else if (/str$/.test(tag)) {
	    return buffer.raw().toString();
	  } else {
	    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
	  }
	};
	
	DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
	  var result;
	  var identifiers = [];
	  var ident = 0;
	  while (!buffer.isEmpty()) {
	    var subident = buffer.readUInt8();
	    ident <<= 7;
	    ident |= subident & 0x7f;
	    if ((subident & 0x80) === 0) {
	      identifiers.push(ident);
	      ident = 0;
	    }
	  }
	  if (subident & 0x80)
	    identifiers.push(ident);
	
	  var first = (identifiers[0] / 40) | 0;
	  var second = identifiers[0] % 40;
	
	  if (relative)
	    result = identifiers;
	  else
	    result = [first, second].concat(identifiers.slice(1));
	
	  if (values) {
	    var tmp = values[result.join(' ')];
	    if (tmp === undefined)
	      tmp = values[result.join('.')];
	    if (tmp !== undefined)
	      result = tmp;
	  }
	
	  return result;
	};
	
	DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
	  var str = buffer.raw().toString();
	  if (tag === 'gentime') {
	    var year = str.slice(0, 4) | 0;
	    var mon = str.slice(4, 6) | 0;
	    var day = str.slice(6, 8) | 0;
	    var hour = str.slice(8, 10) | 0;
	    var min = str.slice(10, 12) | 0;
	    var sec = str.slice(12, 14) | 0;
	  } else if (tag === 'utctime') {
	    var year = str.slice(0, 2) | 0;
	    var mon = str.slice(2, 4) | 0;
	    var day = str.slice(4, 6) | 0;
	    var hour = str.slice(6, 8) | 0;
	    var min = str.slice(8, 10) | 0;
	    var sec = str.slice(10, 12) | 0;
	    if (year < 70)
	      year = 2000 + year;
	    else
	      year = 1900 + year;
	  } else {
	    return buffer.error('Decoding ' + tag + ' time is not supported yet');
	  }
	
	  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
	};
	
	DERNode.prototype._decodeNull = function decodeNull(buffer) {
	  return null;
	};
	
	DERNode.prototype._decodeBool = function decodeBool(buffer) {
	  var res = buffer.readUInt8();
	  if (buffer.isError(res))
	    return res;
	  else
	    return res !== 0;
	};
	
	DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
	  // Bigint, return as it is (assume big endian)
	  var raw = buffer.raw();
	  var res = new bignum(raw);
	
	  if (values)
	    res = values[res.toString(10)] || res;
	
	  return res;
	};
	
	DERNode.prototype._use = function use(entity, obj) {
	  if (typeof entity === 'function')
	    entity = entity(obj);
	  return entity._getDecoder('der').tree;
	};
	
	// Utility methods
	
	function derDecodeTag(buf, fail) {
	  var tag = buf.readUInt8(fail);
	  if (buf.isError(tag))
	    return tag;
	
	  var cls = der.tagClass[tag >> 6];
	  var primitive = (tag & 0x20) === 0;
	
	  // Multi-octet tag - load
	  if ((tag & 0x1f) === 0x1f) {
	    var oct = tag;
	    tag = 0;
	    while ((oct & 0x80) === 0x80) {
	      oct = buf.readUInt8(fail);
	      if (buf.isError(oct))
	        return oct;
	
	      tag <<= 7;
	      tag |= oct & 0x7f;
	    }
	  } else {
	    tag &= 0x1f;
	  }
	  var tagStr = der.tag[tag];
	
	  return {
	    cls: cls,
	    primitive: primitive,
	    tag: tag,
	    tagStr: tagStr
	  };
	}
	
	function derDecodeLen(buf, primitive, fail) {
	  var len = buf.readUInt8(fail);
	  if (buf.isError(len))
	    return len;
	
	  // Indefinite form
	  if (!primitive && len === 0x80)
	    return null;
	
	  // Definite form
	  if ((len & 0x80) === 0) {
	    // Short form
	    return len;
	  }
	
	  // Long form
	  var num = len & 0x7f;
	  if (num > 4)
	    return buf.error('length octect is too long');
	
	  len = 0;
	  for (var i = 0; i < num; i++) {
	    len <<= 8;
	    var j = buf.readUInt8(fail);
	    if (buf.isError(j))
	      return j;
	    len |= j;
	  }
	
	  return len;
	}


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(2);
	var Buffer = __webpack_require__(1).Buffer;
	
	var asn1 = __webpack_require__(66);
	var base = asn1.base;
	
	// Import DER constants
	var der = asn1.constants.der;
	
	function DEREncoder(entity) {
	  this.enc = 'der';
	  this.name = entity.name;
	  this.entity = entity;
	
	  // Construct base tree
	  this.tree = new DERNode();
	  this.tree._init(entity.body);
	};
	module.exports = DEREncoder;
	
	DEREncoder.prototype.encode = function encode(data, reporter) {
	  return this.tree._encode(data, reporter).join();
	};
	
	// Tree methods
	
	function DERNode(parent) {
	  base.Node.call(this, 'der', parent);
	}
	inherits(DERNode, base.Node);
	
	DERNode.prototype._encodeComposite = function encodeComposite(tag,
	                                                              primitive,
	                                                              cls,
	                                                              content) {
	  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);
	
	  // Short form
	  if (content.length < 0x80) {
	    var header = new Buffer(2);
	    header[0] = encodedTag;
	    header[1] = content.length;
	    return this._createEncoderBuffer([ header, content ]);
	  }
	
	  // Long form
	  // Count octets required to store length
	  var lenOctets = 1;
	  for (var i = content.length; i >= 0x100; i >>= 8)
	    lenOctets++;
	
	  var header = new Buffer(1 + 1 + lenOctets);
	  header[0] = encodedTag;
	  header[1] = 0x80 | lenOctets;
	
	  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
	    header[i] = j & 0xff;
	
	  return this._createEncoderBuffer([ header, content ]);
	};
	
	DERNode.prototype._encodeStr = function encodeStr(str, tag) {
	  if (tag === 'bitstr') {
	    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
	  } else if (tag === 'bmpstr') {
	    var buf = new Buffer(str.length * 2);
	    for (var i = 0; i < str.length; i++) {
	      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
	    }
	    return this._createEncoderBuffer(buf);
	  } else if (tag === 'numstr') {
	    if (!this._isNumstr(str)) {
	      return this.reporter.error('Encoding of string type: numstr supports ' +
	                                 'only digits and space');
	    }
	    return this._createEncoderBuffer(str);
	  } else if (tag === 'printstr') {
	    if (!this._isPrintstr(str)) {
	      return this.reporter.error('Encoding of string type: printstr supports ' +
	                                 'only latin upper and lower case letters, ' +
	                                 'digits, space, apostrophe, left and rigth ' +
	                                 'parenthesis, plus sign, comma, hyphen, ' +
	                                 'dot, slash, colon, equal sign, ' +
	                                 'question mark');
	    }
	    return this._createEncoderBuffer(str);
	  } else if (/str$/.test(tag)) {
	    return this._createEncoderBuffer(str);
	  } else if (tag === 'objDesc') {
	    return this._createEncoderBuffer(str);
	  } else {
	    return this.reporter.error('Encoding of string type: ' + tag +
	                               ' unsupported');
	  }
	};
	
	DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
	  if (typeof id === 'string') {
	    if (!values)
	      return this.reporter.error('string objid given, but no values map found');
	    if (!values.hasOwnProperty(id))
	      return this.reporter.error('objid not found in values map');
	    id = values[id].split(/[\s\.]+/g);
	    for (var i = 0; i < id.length; i++)
	      id[i] |= 0;
	  } else if (Array.isArray(id)) {
	    id = id.slice();
	    for (var i = 0; i < id.length; i++)
	      id[i] |= 0;
	  }
	
	  if (!Array.isArray(id)) {
	    return this.reporter.error('objid() should be either array or string, ' +
	                               'got: ' + JSON.stringify(id));
	  }
	
	  if (!relative) {
	    if (id[1] >= 40)
	      return this.reporter.error('Second objid identifier OOB');
	    id.splice(0, 2, id[0] * 40 + id[1]);
	  }
	
	  // Count number of octets
	  var size = 0;
	  for (var i = 0; i < id.length; i++) {
	    var ident = id[i];
	    for (size++; ident >= 0x80; ident >>= 7)
	      size++;
	  }
	
	  var objid = new Buffer(size);
	  var offset = objid.length - 1;
	  for (var i = id.length - 1; i >= 0; i--) {
	    var ident = id[i];
	    objid[offset--] = ident & 0x7f;
	    while ((ident >>= 7) > 0)
	      objid[offset--] = 0x80 | (ident & 0x7f);
	  }
	
	  return this._createEncoderBuffer(objid);
	};
	
	function two(num) {
	  if (num < 10)
	    return '0' + num;
	  else
	    return num;
	}
	
	DERNode.prototype._encodeTime = function encodeTime(time, tag) {
	  var str;
	  var date = new Date(time);
	
	  if (tag === 'gentime') {
	    str = [
	      two(date.getFullYear()),
	      two(date.getUTCMonth() + 1),
	      two(date.getUTCDate()),
	      two(date.getUTCHours()),
	      two(date.getUTCMinutes()),
	      two(date.getUTCSeconds()),
	      'Z'
	    ].join('');
	  } else if (tag === 'utctime') {
	    str = [
	      two(date.getFullYear() % 100),
	      two(date.getUTCMonth() + 1),
	      two(date.getUTCDate()),
	      two(date.getUTCHours()),
	      two(date.getUTCMinutes()),
	      two(date.getUTCSeconds()),
	      'Z'
	    ].join('');
	  } else {
	    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
	  }
	
	  return this._encodeStr(str, 'octstr');
	};
	
	DERNode.prototype._encodeNull = function encodeNull() {
	  return this._createEncoderBuffer('');
	};
	
	DERNode.prototype._encodeInt = function encodeInt(num, values) {
	  if (typeof num === 'string') {
	    if (!values)
	      return this.reporter.error('String int or enum given, but no values map');
	    if (!values.hasOwnProperty(num)) {
	      return this.reporter.error('Values map doesn\'t contain: ' +
	                                 JSON.stringify(num));
	    }
	    num = values[num];
	  }
	
	  // Bignum, assume big endian
	  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
	    var numArray = num.toArray();
	    if (!num.sign && numArray[0] & 0x80) {
	      numArray.unshift(0);
	    }
	    num = new Buffer(numArray);
	  }
	
	  if (Buffer.isBuffer(num)) {
	    var size = num.length;
	    if (num.length === 0)
	      size++;
	
	    var out = new Buffer(size);
	    num.copy(out);
	    if (num.length === 0)
	      out[0] = 0
	    return this._createEncoderBuffer(out);
	  }
	
	  if (num < 0x80)
	    return this._createEncoderBuffer(num);
	
	  if (num < 0x100)
	    return this._createEncoderBuffer([0, num]);
	
	  var size = 1;
	  for (var i = num; i >= 0x100; i >>= 8)
	    size++;
	
	  var out = new Array(size);
	  for (var i = out.length - 1; i >= 0; i--) {
	    out[i] = num & 0xff;
	    num >>= 8;
	  }
	  if(out[0] & 0x80) {
	    out.unshift(0);
	  }
	
	  return this._createEncoderBuffer(new Buffer(out));
	};
	
	DERNode.prototype._encodeBool = function encodeBool(value) {
	  return this._createEncoderBuffer(value ? 0xff : 0);
	};
	
	DERNode.prototype._use = function use(entity, obj) {
	  if (typeof entity === 'function')
	    entity = entity(obj);
	  return entity._getEncoder('der').tree;
	};
	
	DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
	  var state = this._baseState;
	  var i;
	  if (state['default'] === null)
	    return false;
	
	  var data = dataBuffer.join();
	  if (state.defaultBuffer === undefined)
	    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
	
	  if (data.length !== state.defaultBuffer.length)
	    return false;
	
	  for (i=0; i < data.length; i++)
	    if (data[i] !== state.defaultBuffer[i])
	      return false;
	
	  return true;
	};
	
	// Utility methods
	
	function encodeTag(tag, primitive, cls, reporter) {
	  var res;
	
	  if (tag === 'seqof')
	    tag = 'seq';
	  else if (tag === 'setof')
	    tag = 'set';
	
	  if (der.tagByName.hasOwnProperty(tag))
	    res = der.tagByName[tag];
	  else if (typeof tag === 'number' && (tag | 0) === tag)
	    res = tag;
	  else
	    return reporter.error('Unknown tag: ' + tag);
	
	  if (res >= 0x1f)
	    return reporter.error('Multi-octet tag encoding unsupported');
	
	  if (!primitive)
	    res |= 0x20;
	
	  res |= (der.tagClassByName[cls || 'universal'] << 6);
	
	  return res;
	}


/***/ },
/* 178 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = slice;
	function slice(arrayLike, start) {
	    start = start | 0;
	    var newLen = Math.max(arrayLike.length - start, 0);
	    var newArr = Array(newLen);
	    for (var idx = 0; idx < newLen; idx++) {
	        newArr[idx] = arrayLike[start + idx];
	    }
	    return newArr;
	}
	module.exports = exports["default"];

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _WorldGame = __webpack_require__(553);
	
	var _WorldGame2 = _interopRequireDefault(_WorldGame);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var drizzleOptions = {
	  web3: {
	    block: false,
	    fallback: {
	      type: 'ws',
	      url: 'ws://127.0.0.1:8545'
	    }
	  },
	  contracts: [_WorldGame2.default],
	  events: {
	    WorldGame: ['NewGame', 'NextTurn', 'Winner']
	  },
	  syncAlways: true,
	  polls: {
	    accounts: 1500,
	    blocks: 3000
	  }
	};
	
	exports.default = drizzleOptions;

/***/ },
/* 180 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.showOverlay = showOverlay;
	exports.closeOverlay = closeOverlay;
	exports.selectTile = selectTile;
	exports.hoverTile = hoverTile;
	exports.syncGameData = syncGameData;
	exports.updateInput = updateInput;
	exports.updateValidation = updateValidation;
	exports.moveOrAttack = moveOrAttack;
	exports.deployAndEndTurn = deployAndEndTurn;
	exports.endOpponentsTurn = endOpponentsTurn;
	exports.cacheBlockHash = cacheBlockHash;
	exports.declareWinner = declareWinner;
	function showOverlay(val) {
	  return function (dispatch) {
	    dispatch({
	      type: 'SHOW_OVERLAY',
	      payload: val
	    });
	  };
	}
	
	function closeOverlay() {
	  return function (dispatch) {
	    dispatch({
	      type: 'CLOSE_OVERLAY'
	    });
	  };
	}
	
	function selectTile(regionId, soldiers, turnNum) {
	  return function (dispatch) {
	    dispatch({
	      type: 'SELECT_TILE',
	      payload: { regionId: regionId, soldiers: soldiers, turnNum: turnNum }
	    });
	
	    dispatch(closeOverlay());
	  };
	}
	
	function hoverTile(val) {
	  return function (dispatch) {
	    dispatch({
	      type: 'HOVER_TILE',
	      payload: val
	    });
	  };
	}
	
	function syncGameData(drizzle, gameId) {
	  return function (dispatch) {
	
	    var soldiersByRegion = drizzle.contracts.WorldGame.methods.soldiersByRegion.cacheCall(gameId);
	    var undeployedSoldiers = drizzle.contracts.WorldGame.methods.undeployedSoldiers.cacheCall(gameId);
	    var pendingActions = drizzle.contracts.WorldGame.methods.pendingActions.cacheCall(gameId);
	    var pendingActionOutcomes = drizzle.contracts.WorldGame.methods.pendingActionOutcomes.cacheCall(gameId);
	    var turnAndPlayerInfo = drizzle.contracts.WorldGame.methods.turnAndPlayerInfo.cacheCall(gameId);
	    var dataKeys = { soldiersByRegion: soldiersByRegion, undeployedSoldiers: undeployedSoldiers, pendingActions: pendingActions, pendingActionOutcomes: pendingActionOutcomes, turnAndPlayerInfo: turnAndPlayerInfo };
	
	    dispatch({
	      type: 'SET_DATA_KEYS',
	      payload: { gameId: gameId, dataKeys: dataKeys }
	    });
	  };
	}
	
	function updateInput(name, value) {
	  return function (dispatch) {
	    dispatch({
	      type: 'UPDATE_INPUT',
	      payload: { name: name, value: value }
	    });
	  };
	}
	
	function updateValidation(validationMap) {
	  return function (dispatch) {
	    dispatch({
	      type: 'UPDATE_VALIDATION',
	      payload: validationMap
	    });
	  };
	}
	
	function moveOrAttack(drizzle, gameId, turnNum, regionFrom, regionTo, soldiers) {
	  return function (dispatch) {
	    var eth = drizzle.web3.eth;
	
	    var gameInstance = drizzle.contracts.WorldGame;
	
	    var _eth$currentProvider$ = eth.currentProvider.publicConfigStore.getState(),
	        _eth$currentProvider$2 = _eth$currentProvider$.selectedAddress,
	        selectedAddress = _eth$currentProvider$2 === undefined ? "" : _eth$currentProvider$2;
	
	    var stackId = gameInstance.methods.attackOrMove.cacheSend(gameId.toString(), turnNum.toString(), regionFrom.toString(), regionTo.toString(), soldiers.toString(), { from: selectedAddress });
	
	    dispatch({
	      type: 'PENDING_ATTACK_OR_MOVE',
	      payload: stackId
	    });
	  };
	}
	
	function deployAndEndTurn(drizzle, gameId, turnNum, regionDeploy, soldiers) {
	  return function (dispatch) {
	    var eth = drizzle.web3.eth;
	
	    var gameInstance = drizzle.contracts.WorldGame;
	
	    var _eth$currentProvider$3 = eth.currentProvider.publicConfigStore.getState(),
	        _eth$currentProvider$4 = _eth$currentProvider$3.selectedAddress,
	        selectedAddress = _eth$currentProvider$4 === undefined ? "" : _eth$currentProvider$4;
	
	    var stackId = gameInstance.methods.deploySoldiersAndEndTurn.cacheSend(gameId.toString(), turnNum.toString(), regionDeploy.toString(), soldiers.toString(), { from: selectedAddress });
	
	    dispatch({
	      type: 'PENDING_DEPLOY_END_TURN',
	      payload: stackId
	    });
	  };
	}
	
	function endOpponentsTurn(drizzle, gameId, turnNum) {
	  return function (dispatch) {
	    var eth = drizzle.web3.eth;
	
	    var gameInstance = drizzle.contracts.WorldGame;
	
	    var _eth$currentProvider$5 = eth.currentProvider.publicConfigStore.getState(),
	        _eth$currentProvider$6 = _eth$currentProvider$5.selectedAddress,
	        selectedAddress = _eth$currentProvider$6 === undefined ? "" : _eth$currentProvider$6;
	
	    var stackId = gameInstance.methods.forceEndOfTurn.cacheSend(gameId.toString(), turnNum.toString(), { from: selectedAddress });
	
	    dispatch({
	      type: 'PENDING_END_OPPONENTS_TURN',
	      payload: stackId
	    });
	  };
	}
	
	function cacheBlockHash(drizzle, blockNum) {
	  return function (dispatch) {
	    var eth = drizzle.web3.eth;
	
	    var gameInstance = drizzle.contracts.WorldGame;
	
	    var _eth$currentProvider$7 = eth.currentProvider.publicConfigStore.getState(),
	        _eth$currentProvider$8 = _eth$currentProvider$7.selectedAddress,
	        selectedAddress = _eth$currentProvider$8 === undefined ? "" : _eth$currentProvider$8;
	
	    gameInstance.methods.cacheBlockHash32.cacheSend(blockNum.toString(), { from: selectedAddress });
	  };
	}
	
	function declareWinner(drizzle, gameId, winnerId) {
	  return function (dispatch) {
	    var eth = drizzle.web3.eth;
	
	    var gameInstance = drizzle.contracts.WorldGame;
	
	    var _eth$currentProvider$9 = eth.currentProvider.publicConfigStore.getState(),
	        _eth$currentProvider$10 = _eth$currentProvider$9.selectedAddress,
	        selectedAddress = _eth$currentProvider$10 === undefined ? "" : _eth$currentProvider$10;
	
	    gameInstance.methods.declareWinner.cacheSend(gameId.toString(), winnerId.toString(), { from: selectedAddress });
	  };
	}

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(396), __esModule: true };

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(386);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(385);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(68);
	var TAG = __webpack_require__(19)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(18).document;
	module.exports = document && document.documentElement;


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(35) && !__webpack_require__(70)(function () {
	  return Object.defineProperty(__webpack_require__(113)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(84);
	var $export = __webpack_require__(31);
	var redefine = __webpack_require__(194);
	var hide = __webpack_require__(44);
	var has = __webpack_require__(43);
	var Iterators = __webpack_require__(71);
	var $iterCreate = __webpack_require__(409);
	var setToStringTag = __webpack_require__(86);
	var getPrototypeOf = __webpack_require__(190);
	var ITERATOR = __webpack_require__(19)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(118);
	var createDesc = __webpack_require__(85);
	var toIObject = __webpack_require__(51);
	var toPrimitive = __webpack_require__(122);
	var has = __webpack_require__(43);
	var IE8_DOM_DEFINE = __webpack_require__(185);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(35) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(191);
	var hiddenKeys = __webpack_require__(114).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 189 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(43);
	var toObject = __webpack_require__(198);
	var IE_PROTO = __webpack_require__(119)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(43);
	var toIObject = __webpack_require__(51);
	var arrayIndexOf = __webpack_require__(401)(false);
	var IE_PROTO = __webpack_require__(119)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 192 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(30);
	var isObject = __webpack_require__(36);
	var newPromiseCapability = __webpack_require__(115);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(44);


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(30);
	var aFunction = __webpack_require__(83);
	var SPECIES = __webpack_require__(19)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(69);
	var invoke = __webpack_require__(404);
	var html = __webpack_require__(184);
	var cel = __webpack_require__(113);
	var global = __webpack_require__(18);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(68)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(121);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(112);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 199 */
/***/ function(module, exports) {



/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(420)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(186)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(423);
	var global = __webpack_require__(18);
	var hide = __webpack_require__(44);
	var Iterators = __webpack_require__(71);
	var TO_STRING_TAG = __webpack_require__(19)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	var r;
	
	module.exports = function rand(len) {
	  if (!r)
	    r = new Rand(null);
	
	  return r.generate(len);
	};
	
	function Rand(rand) {
	  this.rand = rand;
	}
	module.exports.Rand = Rand;
	
	Rand.prototype.generate = function generate(len) {
	  return this._rand(len);
	};
	
	// Emulate crypto API using randy
	Rand.prototype._rand = function _rand(n) {
	  if (this.rand.getBytes)
	    return this.rand.getBytes(n);
	
	  var res = new Uint8Array(n);
	  for (var i = 0; i < res.length; i++)
	    res[i] = this.rand.getByte();
	  return res;
	};
	
	if (typeof self === 'object') {
	  if (self.crypto && self.crypto.getRandomValues) {
	    // Modern browsers
	    Rand.prototype._rand = function _rand(n) {
	      var arr = new Uint8Array(n);
	      self.crypto.getRandomValues(arr);
	      return arr;
	    };
	  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
	    // IE
	    Rand.prototype._rand = function _rand(n) {
	      var arr = new Uint8Array(n);
	      self.msCrypto.getRandomValues(arr);
	      return arr;
	    };
	
	  // Safari's WebWorkers do not have `crypto`
	  } else if (typeof window === 'object') {
	    // Old junk
	    Rand.prototype._rand = function() {
	      throw new Error('Not implemented yet');
	    };
	  }
	} else {
	  // Node.js or Web worker with no crypto support
	  try {
	    var crypto = __webpack_require__(787);
	    if (typeof crypto.randomBytes !== 'function')
	      throw new Error('Not supported');
	
	    Rand.prototype._rand = function _rand(n) {
	      return crypto.randomBytes(n);
	    };
	  } catch (e) {
	  }
	}


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	var aes = __webpack_require__(88)
	var Buffer = __webpack_require__(4).Buffer
	var Transform = __webpack_require__(38)
	var inherits = __webpack_require__(2)
	var GHASH = __webpack_require__(438)
	var xor = __webpack_require__(72)
	var incr32 = __webpack_require__(204)
	
	function xorTest (a, b) {
	  var out = 0
	  if (a.length !== b.length) out++
	
	  var len = Math.min(a.length, b.length)
	  for (var i = 0; i < len; ++i) {
	    out += (a[i] ^ b[i])
	  }
	
	  return out
	}
	
	function calcIv (self, iv, ck) {
	  if (iv.length === 12) {
	    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
	    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
	  }
	  var ghash = new GHASH(ck)
	  var len = iv.length
	  var toPad = len % 16
	  ghash.update(iv)
	  if (toPad) {
	    toPad = 16 - toPad
	    ghash.update(Buffer.alloc(toPad, 0))
	  }
	  ghash.update(Buffer.alloc(8, 0))
	  var ivBits = len * 8
	  var tail = Buffer.alloc(8)
	  tail.writeUIntBE(ivBits, 0, 8)
	  ghash.update(tail)
	  self._finID = ghash.state
	  var out = Buffer.from(self._finID)
	  incr32(out)
	  return out
	}
	function StreamCipher (mode, key, iv, decrypt) {
	  Transform.call(this)
	
	  var h = Buffer.alloc(4, 0)
	
	  this._cipher = new aes.AES(key)
	  var ck = this._cipher.encryptBlock(h)
	  this._ghash = new GHASH(ck)
	  iv = calcIv(this, iv, ck)
	
	  this._prev = Buffer.from(iv)
	  this._cache = Buffer.allocUnsafe(0)
	  this._secCache = Buffer.allocUnsafe(0)
	  this._decrypt = decrypt
	  this._alen = 0
	  this._len = 0
	  this._mode = mode
	
	  this._authTag = null
	  this._called = false
	}
	
	inherits(StreamCipher, Transform)
	
	StreamCipher.prototype._update = function (chunk) {
	  if (!this._called && this._alen) {
	    var rump = 16 - (this._alen % 16)
	    if (rump < 16) {
	      rump = Buffer.alloc(rump, 0)
	      this._ghash.update(rump)
	    }
	  }
	
	  this._called = true
	  var out = this._mode.encrypt(this, chunk)
	  if (this._decrypt) {
	    this._ghash.update(chunk)
	  } else {
	    this._ghash.update(out)
	  }
	  this._len += chunk.length
	  return out
	}
	
	StreamCipher.prototype._final = function () {
	  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')
	
	  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
	  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')
	
	  this._authTag = tag
	  this._cipher.scrub()
	}
	
	StreamCipher.prototype.getAuthTag = function getAuthTag () {
	  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')
	
	  return this._authTag
	}
	
	StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
	  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')
	
	  this._authTag = tag
	}
	
	StreamCipher.prototype.setAAD = function setAAD (buf) {
	  if (this._called) throw new Error('Attempting to set AAD in unsupported state')
	
	  this._ghash.update(buf)
	  this._alen += buf.length
	}
	
	module.exports = StreamCipher


/***/ },
/* 204 */
/***/ function(module, exports) {

	function incr32 (iv) {
	  var len = iv.length
	  var item
	  while (len--) {
	    item = iv.readUInt8(len)
	    if (item === 255) {
	      iv.writeUInt8(0, len)
	    } else {
	      item++
	      iv.writeUInt8(item, len)
	      break
	    }
	  }
	}
	module.exports = incr32


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var xor = __webpack_require__(72)
	var Buffer = __webpack_require__(4).Buffer
	var incr32 = __webpack_require__(204)
	
	function getBlock (self) {
	  var out = self._cipher.encryptBlockRaw(self._prev)
	  incr32(self._prev)
	  return out
	}
	
	var blockSize = 16
	exports.encrypt = function (self, chunk) {
	  var chunkNum = Math.ceil(chunk.length / blockSize)
	  var start = self._cache.length
	  self._cache = Buffer.concat([
	    self._cache,
	    Buffer.allocUnsafe(chunkNum * blockSize)
	  ])
	  for (var i = 0; i < chunkNum; i++) {
	    var out = getBlock(self)
	    var offset = start + i * blockSize
	    self._cache.writeUInt32BE(out[0], offset + 0)
	    self._cache.writeUInt32BE(out[1], offset + 4)
	    self._cache.writeUInt32BE(out[2], offset + 8)
	    self._cache.writeUInt32BE(out[3], offset + 12)
	  }
	  var pad = self._cache.slice(0, chunk.length)
	  self._cache = self._cache.slice(chunk.length)
	  return xor(chunk, pad)
	}


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	var aes = __webpack_require__(88)
	var Buffer = __webpack_require__(4).Buffer
	var Transform = __webpack_require__(38)
	var inherits = __webpack_require__(2)
	
	function StreamCipher (mode, key, iv, decrypt) {
	  Transform.call(this)
	
	  this._cipher = new aes.AES(key)
	  this._prev = Buffer.from(iv)
	  this._cache = Buffer.allocUnsafe(0)
	  this._secCache = Buffer.allocUnsafe(0)
	  this._decrypt = decrypt
	  this._mode = mode
	}
	
	inherits(StreamCipher, Transform)
	
	StreamCipher.prototype._update = function (chunk) {
	  return this._mode.encrypt(this, chunk, this._decrypt)
	}
	
	StreamCipher.prototype._final = function () {
	  this._cipher.scrub()
	}
	
	module.exports = StreamCipher


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	var inherits = __webpack_require__(2)
	var Legacy = __webpack_require__(455)
	var Base = __webpack_require__(38)
	var Buffer = __webpack_require__(4).Buffer
	var md5 = __webpack_require__(128)
	var RIPEMD160 = __webpack_require__(169)
	
	var sha = __webpack_require__(170)
	
	var ZEROS = Buffer.alloc(128)
	
	function Hmac (alg, key) {
	  Base.call(this, 'digest')
	  if (typeof key === 'string') {
	    key = Buffer.from(key)
	  }
	
	  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64
	
	  this._alg = alg
	  this._key = key
	  if (key.length > blocksize) {
	    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
	    key = hash.update(key).digest()
	  } else if (key.length < blocksize) {
	    key = Buffer.concat([key, ZEROS], blocksize)
	  }
	
	  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
	  var opad = this._opad = Buffer.allocUnsafe(blocksize)
	
	  for (var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36
	    opad[i] = key[i] ^ 0x5C
	  }
	  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
	  this._hash.update(ipad)
	}
	
	inherits(Hmac, Base)
	
	Hmac.prototype._update = function (data) {
	  this._hash.update(data)
	}
	
	Hmac.prototype._final = function () {
	  var h = this._hash.digest()
	  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
	  return hash.update(this._opad).update(h).digest()
	}
	
	module.exports = function createHmac (alg, key) {
	  alg = alg.toLowerCase()
	  if (alg === 'rmd160' || alg === 'ripemd160') {
	    return new Hmac('rmd160', key)
	  }
	  if (alg === 'md5') {
	    return new Legacy(md5, key)
	  }
	  return new Hmac(alg, key)
	}


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(456);
	
	var emptyObject = __webpack_require__(95);
	var _invariant = __webpack_require__(3);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(465)
	
	var md5 = toConstructor(__webpack_require__(459))
	var rmd160 = toConstructor(__webpack_require__(463))
	
	function toConstructor (fn) {
	  return function () {
	    var buffers = []
	    var m= {
	      update: function (data, enc) {
	        if(!Buffer.isBuffer(data)) data = new Buffer(data, enc)
	        buffers.push(data)
	        return this
	      },
	      digest: function (enc) {
	        var buf = Buffer.concat(buffers)
	        var r = fn(buf)
	        buffers = null
	        return enc ? r.toString(enc) : r
	      }
	    }
	    return m
	  }
	}
	
	module.exports = function (alg) {
	  if('md5' === alg) return new md5()
	  if('rmd160' === alg) return new rmd160()
	  return createHash(alg)
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = function (crypto, password, keyLen, ivLen) {
	  keyLen = keyLen/8;
	  ivLen = ivLen || 0;
	  var ki = 0;
	  var ii = 0;
	  var key = new Buffer(keyLen);
	  var iv = new Buffer(ivLen);
	  var addmd = 0;
	  var md, md_buf;
	  var i;
	  while (true) {
	    md = crypto.createHash('md5');
	    if(addmd++ > 0) {
	       md.update(md_buf);
	    }
	    md.update(password);
	    md_buf = md.digest();
	    i = 0;
	    if(keyLen > 0) {
	      while(true) {
	        if(keyLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	        key[ki++] = md_buf[i];
	        keyLen--;
	        i++;
	       }
	    }
	    if(ivLen > 0 && i !== md_buf.length) {
	      while(true) {
	        if(ivLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	       iv[ii++] = md_buf[i];
	       ivLen--;
	       i++;
	     }
	   }
	   if(keyLen === 0 && ivLen === 0) {
	      break;
	    }
	  }
	  for(i=0;i<md_buf.length;i++) {
	    md_buf[i] = 0;
	  }
	  return {
	    key: key,
	    iv: iv
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var xor = __webpack_require__(89);
	exports.encrypt = function (self, block) {
	  var data = xor(block, self._prev);
	  self._prev = self._cipher.encryptBlock(data);
	  return self._prev;
	};
	exports.decrypt = function (self, block) {
	  var pad = self._prev;
	  self._prev = block;
	  var out = self._cipher.decryptBlock(block);
	  return xor(out, pad);
	};

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(89);
	exports.encrypt = function (self, data, decrypt) {
	  var out = new Buffer('');
	  var len;
	  while (data.length) {
	    if (self._cache.length === 0) {
	      self._cache = self._cipher.encryptBlock(self._prev);
	      self._prev = new Buffer('');
	    }
	    if (self._cache.length <= data.length) {
	      len = self._cache.length;
	      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)]);
	      data = data.slice(len);
	    } else {
	      out = Buffer.concat([out, encryptStart(self, data, decrypt)]);
	      break;
	    }
	  }
	  return out;
	};
	function encryptStart(self, data, decrypt) {
	  var len = data.length;
	  var out = xor(data, self._cache);
	  self._cache = self._cache.slice(len);
	  self._prev = Buffer.concat([self._prev, decrypt?data:out]);
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(89);
	function getBlock(self) {
	  var out = self._cipher.encryptBlock(self._prev);
	  incr32(self._prev);
	  return out;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	function incr32(iv) {
	  var len = iv.length;
	  var item;
	  while (len--) {
	    item = iv.readUInt8(len);
	    if (item === 255) {
	      iv.writeUInt8(0, len);
	    } else {
	      item++;
	      iv.writeUInt8(item, len);
	      break;
	    }
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 214 */
/***/ function(module, exports) {

	exports.encrypt = function (self, block) {
	  return self._cipher.encryptBlock(block);
	};
	exports.decrypt = function (self, block) {
	  return self._cipher.decryptBlock(block);
	};

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(89);
	function getBlock(self) {
	  self._prev = self._cipher.encryptBlock(self._prev);
	  return self._prev;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(130);
	var Transform = __webpack_require__(131);
	var inherits = __webpack_require__(2);
	
	inherits(StreamCipher, Transform);
	module.exports = StreamCipher;
	function StreamCipher(mode, key, iv, decrypt) {
	  if (!(this instanceof StreamCipher)) {
	    return new StreamCipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  this._cache = new Buffer('');
	  this._secCache = new Buffer('');
	  this._decrypt = decrypt;
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	StreamCipher.prototype._transform = function (chunk, _, next) {
	  next(null, this._mode.encrypt(this, chunk, this._decrypt));
	};
	StreamCipher.prototype._flush = function (next) {
	  this._cipher.scrub();
	  next();
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	var randomBytes = __webpack_require__(54);
	module.exports = findPrime;
	findPrime.simpleSieve = simpleSieve;
	findPrime.fermatTest = fermatTest;
	var BN = __webpack_require__(7);
	var TWENTYFOUR = new BN(24);
	var MillerRabin = __webpack_require__(247);
	var millerRabin = new MillerRabin();
	var ONE = new BN(1);
	var TWO = new BN(2);
	var FIVE = new BN(5);
	var SIXTEEN = new BN(16);
	var EIGHT = new BN(8);
	var TEN = new BN(10);
	var THREE = new BN(3);
	var SEVEN = new BN(7);
	var ELEVEN = new BN(11);
	var FOUR = new BN(4);
	var TWELVE = new BN(12);
	var primes = null;
	
	function _getPrimes() {
	  if (primes !== null)
	    return primes;
	
	  var limit = 0x100000;
	  var res = [];
	  res[0] = 2;
	  for (var i = 1, k = 3; k < limit; k += 2) {
	    var sqrt = Math.ceil(Math.sqrt(k));
	    for (var j = 0; j < i && res[j] <= sqrt; j++)
	      if (k % res[j] === 0)
	        break;
	
	    if (i !== j && res[j] <= sqrt)
	      continue;
	
	    res[i++] = k;
	  }
	  primes = res;
	  return res;
	}
	
	function simpleSieve(p) {
	  var primes = _getPrimes();
	
	  for (var i = 0; i < primes.length; i++)
	    if (p.modn(primes[i]) === 0) {
	      if (p.cmpn(primes[i]) === 0) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	
	  return true;
	}
	
	function fermatTest(p) {
	  var red = BN.mont(p);
	  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
	}
	
	function findPrime(bits, gen) {
	  if (bits < 16) {
	    // this is what openssl does
	    if (gen === 2 || gen === 5) {
	      return new BN([0x8c, 0x7b]);
	    } else {
	      return new BN([0x8c, 0x27]);
	    }
	  }
	  gen = new BN(gen);
	
	  var num, n2;
	
	  while (true) {
	    num = new BN(randomBytes(Math.ceil(bits / 8)));
	    while (num.bitLength() > bits) {
	      num.ishrn(1);
	    }
	    if (num.isEven()) {
	      num.iadd(ONE);
	    }
	    if (!num.testn(1)) {
	      num.iadd(TWO);
	    }
	    if (!gen.cmp(TWO)) {
	      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
	        num.iadd(FOUR);
	      }
	    } else if (!gen.cmp(FIVE)) {
	      while (num.mod(TEN).cmp(THREE)) {
	        num.iadd(FOUR);
	      }
	    }
	    n2 = num.shrn(1);
	    if (simpleSieve(n2) && simpleSieve(num) &&
	      fermatTest(n2) && fermatTest(num) &&
	      millerRabin.test(n2) && millerRabin.test(num)) {
	      return num;
	    }
	  }
	
	}


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TASK_CANCEL = exports.CHANNEL_END = exports.NOT_ITERATOR_ERROR = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = proc;
	
	var _utils = /*#__PURE__*/__webpack_require__(24);
	
	var _scheduler = /*#__PURE__*/__webpack_require__(221);
	
	var _io = /*#__PURE__*/__webpack_require__(45);
	
	var _channel = /*#__PURE__*/__webpack_require__(52);
	
	var _buffers = /*#__PURE__*/__webpack_require__(91);
	
	function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }
	
	var NOT_ITERATOR_ERROR = exports.NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';
	
	var CHANNEL_END = exports.CHANNEL_END = {
	  toString: function toString() {
	    return '@@redux-saga/CHANNEL_END';
	  }
	};
	var TASK_CANCEL = exports.TASK_CANCEL = {
	  toString: function toString() {
	    return '@@redux-saga/TASK_CANCEL';
	  }
	};
	
	var matchers = {
	  wildcard: function wildcard() {
	    return _utils.kTrue;
	  },
	  default: function _default(pattern) {
	    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
	      return input.type === pattern;
	    } : function (input) {
	      return input.type === String(pattern);
	    };
	  },
	  array: function array(patterns) {
	    return function (input) {
	      return patterns.some(function (p) {
	        return matcher(p)(input);
	      });
	    };
	  },
	  predicate: function predicate(_predicate) {
	    return function (input) {
	      return _predicate(input);
	    };
	  }
	};
	
	function matcher(pattern) {
	  // prettier-ignore
	  return (pattern === '*' ? matchers.wildcard : _utils.is.array(pattern) ? matchers.array : _utils.is.stringableFunc(pattern) ? matchers.default : _utils.is.func(pattern) ? matchers.predicate : matchers.default)(pattern);
	}
	
	/**
	  Used to track a parent task and its forks
	  In the new fork model, forked tasks are attached by default to their parent
	  We model this using the concept of Parent task && main Task
	  main task is the main flow of the current Generator, the parent tasks is the
	  aggregation of the main tasks + all its forked tasks.
	  Thus the whole model represents an execution tree with multiple branches (vs the
	  linear execution tree in sequential (non parallel) programming)
	
	  A parent tasks has the following semantics
	  - It completes if all its forks either complete or all cancelled
	  - If it's cancelled, all forks are cancelled as well
	  - It aborts if any uncaught error bubbles up from forks
	  - If it completes, the return value is the one returned by the main task
	**/
	function forkQueue(name, mainTask, cb) {
	  var tasks = [],
	      result = void 0,
	      completed = false;
	  addTask(mainTask);
	
	  function abort(err) {
	    cancelAll();
	    cb(err, true);
	  }
	
	  function addTask(task) {
	    tasks.push(task);
	    task.cont = function (res, isErr) {
	      if (completed) {
	        return;
	      }
	
	      (0, _utils.remove)(tasks, task);
	      task.cont = _utils.noop;
	      if (isErr) {
	        abort(res);
	      } else {
	        if (task === mainTask) {
	          result = res;
	        }
	        if (!tasks.length) {
	          completed = true;
	          cb(result);
	        }
	      }
	    };
	    // task.cont.cancel = task.cancel
	  }
	
	  function cancelAll() {
	    if (completed) {
	      return;
	    }
	    completed = true;
	    tasks.forEach(function (t) {
	      t.cont = _utils.noop;
	      t.cancel();
	    });
	    tasks = [];
	  }
	
	  return {
	    addTask: addTask,
	    cancelAll: cancelAll,
	    abort: abort,
	    getTasks: function getTasks() {
	      return tasks;
	    },
	    taskNames: function taskNames() {
	      return tasks.map(function (t) {
	        return t.name;
	      });
	    }
	  };
	}
	
	function createTaskIterator(_ref) {
	  var context = _ref.context,
	      fn = _ref.fn,
	      args = _ref.args;
	
	  if (_utils.is.iterator(fn)) {
	    return fn;
	  }
	
	  // catch synchronous failures; see #152 and #441
	  var result = void 0,
	      error = void 0;
	  try {
	    result = fn.apply(context, args);
	  } catch (err) {
	    error = err;
	  }
	
	  // i.e. a generator function returns an iterator
	  if (_utils.is.iterator(result)) {
	    return result;
	  }
	
	  // do not bubble up synchronous failures for detached forks
	  // instead create a failed task. See #152 and #441
	  return error ? (0, _utils.makeIterator)(function () {
	    throw error;
	  }) : (0, _utils.makeIterator)(function () {
	    var pc = void 0;
	    var eff = { done: false, value: result };
	    var ret = function ret(value) {
	      return { done: true, value: value };
	    };
	    return function (arg) {
	      if (!pc) {
	        pc = true;
	        return eff;
	      } else {
	        return ret(arg);
	      }
	    };
	  }());
	}
	
	var wrapHelper = function wrapHelper(helper) {
	  return { fn: helper };
	};
	
	function proc(iterator) {
	  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
	    return _utils.noop;
	  };
	  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _utils.noop;
	  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _utils.noop;
	  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
	  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
	  var cont = arguments[8];
	
	  (0, _utils.check)(iterator, _utils.is.iterator, NOT_ITERATOR_ERROR);
	
	  var effectsString = '[...effects]';
	  var runParallelEffect = (0, _utils.deprecate)(runAllEffect, (0, _utils.updateIncentive)(effectsString, 'all(' + effectsString + ')'));
	
	  var sagaMonitor = options.sagaMonitor,
	      logger = options.logger,
	      onError = options.onError;
	
	  var log = logger || _utils.log;
	  var logError = function logError(err) {
	    var message = err.sagaStack;
	
	    if (!message && err.stack) {
	      message = err.stack.split('\n')[0].indexOf(err.message) !== -1 ? err.stack : 'Error: ' + err.message + '\n' + err.stack;
	    }
	
	    log('error', 'uncaught at ' + name, message || err.message || err);
	  };
	  var stdChannel = (0, _channel.stdChannel)(subscribe);
	  var taskContext = Object.create(parentContext);
	  /**
	    Tracks the current effect cancellation
	    Each time the generator progresses. calling runEffect will set a new value
	    on it. It allows propagating cancellation to child effects
	  **/
	  next.cancel = _utils.noop;
	
	  /**
	    Creates a new task descriptor for this generator, We'll also create a main task
	    to track the main flow (besides other forked tasks)
	  **/
	  var task = newTask(parentEffectId, name, iterator, cont);
	  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
	  var taskQueue = forkQueue(name, mainTask, end);
	
	  /**
	    cancellation of the main task. We'll simply resume the Generator with a Cancel
	  **/
	  function cancelMain() {
	    if (mainTask.isRunning && !mainTask.isCancelled) {
	      mainTask.isCancelled = true;
	      next(TASK_CANCEL);
	    }
	  }
	
	  /**
	    This may be called by a parent generator to trigger/propagate cancellation
	    cancel all pending tasks (including the main task), then end the current task.
	     Cancellation propagates down to the whole execution tree holded by this Parent task
	    It's also propagated to all joiners of this task and their execution tree/joiners
	     Cancellation is noop for terminated/Cancelled tasks tasks
	  **/
	  function cancel() {
	    /**
	      We need to check both Running and Cancelled status
	      Tasks can be Cancelled but still Running
	    **/
	    if (iterator._isRunning && !iterator._isCancelled) {
	      iterator._isCancelled = true;
	      taskQueue.cancelAll();
	      /**
	        Ending with a Never result will propagate the Cancellation to all joiners
	      **/
	      end(TASK_CANCEL);
	    }
	  }
	  /**
	    attaches cancellation logic to this task's continuation
	    this will permit cancellation to propagate down the call chain
	  **/
	  cont && (cont.cancel = cancel);
	
	  // tracks the running status
	  iterator._isRunning = true;
	
	  // kicks up the generator
	  next();
	
	  // then return the task descriptor to the caller
	  return task;
	
	  /**
	    This is the generator driver
	    It's a recursive async/continuation function which calls itself
	    until the generator terminates or throws
	  **/
	  function next(arg, isErr) {
	    // Preventive measure. If we end up here, then there is really something wrong
	    if (!mainTask.isRunning) {
	      throw new Error('Trying to resume an already finished generator');
	    }
	
	    try {
	      var result = void 0;
	      if (isErr) {
	        result = iterator.throw(arg);
	      } else if (arg === TASK_CANCEL) {
	        /**
	          getting TASK_CANCEL automatically cancels the main task
	          We can get this value here
	           - By cancelling the parent task manually
	          - By joining a Cancelled task
	        **/
	        mainTask.isCancelled = true;
	        /**
	          Cancels the current effect; this will propagate the cancellation down to any called tasks
	        **/
	        next.cancel();
	        /**
	          If this Generator has a `return` method then invokes it
	          This will jump to the finally block
	        **/
	        result = _utils.is.func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
	      } else if (arg === CHANNEL_END) {
	        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
	        result = _utils.is.func(iterator.return) ? iterator.return() : { done: true };
	      } else {
	        result = iterator.next(arg);
	      }
	
	      if (!result.done) {
	        runEffect(result.value, parentEffectId, '', next);
	      } else {
	        /**
	          This Generator has ended, terminate the main task and notify the fork queue
	        **/
	        mainTask.isMainRunning = false;
	        mainTask.cont && mainTask.cont(result.value);
	      }
	    } catch (error) {
	      if (mainTask.isCancelled) {
	        logError(error);
	      }
	      mainTask.isMainRunning = false;
	      mainTask.cont(error, true);
	    }
	  }
	
	  function end(result, isErr) {
	    iterator._isRunning = false;
	    stdChannel.close();
	    if (!isErr) {
	      iterator._result = result;
	      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
	    } else {
	      if (result instanceof Error) {
	        Object.defineProperty(result, 'sagaStack', {
	          value: 'at ' + name + ' \n ' + (result.sagaStack || result.stack),
	          configurable: true
	        });
	      }
	      if (!task.cont) {
	        if (result instanceof Error && onError) {
	          onError(result);
	        } else {
	          logError(result);
	        }
	      }
	      iterator._error = result;
	      iterator._isAborted = true;
	      iterator._deferredEnd && iterator._deferredEnd.reject(result);
	    }
	    task.cont && task.cont(result, isErr);
	    task.joiners.forEach(function (j) {
	      return j.cb(result, isErr);
	    });
	    task.joiners = null;
	  }
	
	  function runEffect(effect, parentEffectId) {
	    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var cb = arguments[3];
	
	    var effectId = (0, _utils.uid)();
	    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });
	
	    /**
	      completion callback and cancel callback are mutually exclusive
	      We can't cancel an already completed effect
	      And We can't complete an already cancelled effectId
	    **/
	    var effectSettled = void 0;
	
	    // Completion callback passed to the appropriate effect runner
	    function currCb(res, isErr) {
	      if (effectSettled) {
	        return;
	      }
	
	      effectSettled = true;
	      cb.cancel = _utils.noop; // defensive measure
	      if (sagaMonitor) {
	        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
	      }
	      cb(res, isErr);
	    }
	    // tracks down the current cancel
	    currCb.cancel = _utils.noop;
	
	    // setup cancellation logic on the parent cb
	    cb.cancel = function () {
	      // prevents cancelling an already completed effect
	      if (effectSettled) {
	        return;
	      }
	
	      effectSettled = true;
	      /**
	        propagates cancel downward
	        catch uncaught cancellations errors; since we can no longer call the completion
	        callback, log errors raised during cancellations into the console
	      **/
	      try {
	        currCb.cancel();
	      } catch (err) {
	        logError(err);
	      }
	      currCb.cancel = _utils.noop; // defensive measure
	
	      sagaMonitor && sagaMonitor.effectCancelled(effectId);
	    };
	
	    /**
	      each effect runner must attach its own logic of cancellation to the provided callback
	      it allows this generator to propagate cancellation downward.
	       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
	      And the setup must occur before calling the callback
	       This is a sort of inversion of control: called async functions are responsible
	      for completing the flow by calling the provided continuation; while caller functions
	      are responsible for aborting the current flow by calling the attached cancel function
	       Library users can attach their own cancellation logic to promises by defining a
	      promise[CANCEL] method in their returned promises
	      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
	    **/
	    var data = void 0;
	    // prettier-ignore
	    return (
	      // Non declarative effect
	      _utils.is.promise(effect) ? resolvePromise(effect, currCb) : _utils.is.helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : _utils.is.iterator(effect) ? resolveIterator(effect, effectId, name, currCb)
	
	      // declarative effects
	      : _utils.is.array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = _io.asEffect.take(effect)) ? runTakeEffect(data, currCb) : (data = _io.asEffect.put(effect)) ? runPutEffect(data, currCb) : (data = _io.asEffect.all(effect)) ? runAllEffect(data, effectId, currCb) : (data = _io.asEffect.race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = _io.asEffect.call(effect)) ? runCallEffect(data, effectId, currCb) : (data = _io.asEffect.cps(effect)) ? runCPSEffect(data, currCb) : (data = _io.asEffect.fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = _io.asEffect.join(effect)) ? runJoinEffect(data, currCb) : (data = _io.asEffect.cancel(effect)) ? runCancelEffect(data, currCb) : (data = _io.asEffect.select(effect)) ? runSelectEffect(data, currCb) : (data = _io.asEffect.actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = _io.asEffect.flush(effect)) ? runFlushEffect(data, currCb) : (data = _io.asEffect.cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = _io.asEffect.getContext(effect)) ? runGetContextEffect(data, currCb) : (data = _io.asEffect.setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */currCb(effect)
	    );
	  }
	
	  function resolvePromise(promise, cb) {
	    var cancelPromise = promise[_utils.CANCEL];
	    if (_utils.is.func(cancelPromise)) {
	      cb.cancel = cancelPromise;
	    } else if (_utils.is.func(promise.abort)) {
	      cb.cancel = function () {
	        return promise.abort();
	      };
	      // TODO: add support for the fetch API, whenever they get around to
	      // adding cancel support
	    }
	    promise.then(cb, function (error) {
	      return cb(error, true);
	    });
	  }
	
	  function resolveIterator(iterator, effectId, name, cb) {
	    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
	  }
	
	  function runTakeEffect(_ref2, cb) {
	    var channel = _ref2.channel,
	        pattern = _ref2.pattern,
	        maybe = _ref2.maybe;
	
	    channel = channel || stdChannel;
	    var takeCb = function takeCb(inp) {
	      return inp instanceof Error ? cb(inp, true) : (0, _channel.isEnd)(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
	    };
	    try {
	      channel.take(takeCb, matcher(pattern));
	    } catch (err) {
	      return cb(err, true);
	    }
	    cb.cancel = takeCb.cancel;
	  }
	
	  function runPutEffect(_ref3, cb) {
	    var channel = _ref3.channel,
	        action = _ref3.action,
	        resolve = _ref3.resolve;
	
	    /**
	      Schedule the put in case another saga is holding a lock.
	      The put will be executed atomically. ie nested puts will execute after
	      this put has terminated.
	    **/
	    (0, _scheduler.asap)(function () {
	      var result = void 0;
	      try {
	        result = (channel ? channel.put : dispatch)(action);
	      } catch (error) {
	        // If we have a channel or `put.resolve` was used then bubble up the error.
	        if (channel || resolve) return cb(error, true);
	        logError(error);
	      }
	
	      if (resolve && _utils.is.promise(result)) {
	        resolvePromise(result, cb);
	      } else {
	        return cb(result);
	      }
	    });
	    // Put effects are non cancellables
	  }
	
	  function runCallEffect(_ref4, effectId, cb) {
	    var context = _ref4.context,
	        fn = _ref4.fn,
	        args = _ref4.args;
	
	    var result = void 0;
	    // catch synchronous failures; see #152
	    try {
	      result = fn.apply(context, args);
	    } catch (error) {
	      return cb(error, true);
	    }
	    return _utils.is.promise(result) ? resolvePromise(result, cb) : _utils.is.iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
	  }
	
	  function runCPSEffect(_ref5, cb) {
	    var context = _ref5.context,
	        fn = _ref5.fn,
	        args = _ref5.args;
	
	    // CPS (ie node style functions) can define their own cancellation logic
	    // by setting cancel field on the cb
	
	    // catch synchronous failures; see #152
	    try {
	      var cpsCb = function cpsCb(err, res) {
	        return _utils.is.undef(err) ? cb(res) : cb(err, true);
	      };
	      fn.apply(context, args.concat(cpsCb));
	      if (cpsCb.cancel) {
	        cb.cancel = function () {
	          return cpsCb.cancel();
	        };
	      }
	    } catch (error) {
	      return cb(error, true);
	    }
	  }
	
	  function runForkEffect(_ref6, effectId, cb) {
	    var context = _ref6.context,
	        fn = _ref6.fn,
	        args = _ref6.args,
	        detached = _ref6.detached;
	
	    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });
	
	    try {
	      (0, _scheduler.suspend)();
	      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : _utils.noop);
	
	      if (detached) {
	        cb(_task);
	      } else {
	        if (taskIterator._isRunning) {
	          taskQueue.addTask(_task);
	          cb(_task);
	        } else if (taskIterator._error) {
	          taskQueue.abort(taskIterator._error);
	        } else {
	          cb(_task);
	        }
	      }
	    } finally {
	      (0, _scheduler.flush)();
	    }
	    // Fork effects are non cancellables
	  }
	
	  function runJoinEffect(t, cb) {
	    if (t.isRunning()) {
	      var joiner = { task: task, cb: cb };
	      cb.cancel = function () {
	        return (0, _utils.remove)(t.joiners, joiner);
	      };
	      t.joiners.push(joiner);
	    } else {
	      t.isAborted() ? cb(t.error(), true) : cb(t.result());
	    }
	  }
	
	  function runCancelEffect(taskToCancel, cb) {
	    if (taskToCancel === _utils.SELF_CANCELLATION) {
	      taskToCancel = task;
	    }
	    if (taskToCancel.isRunning()) {
	      taskToCancel.cancel();
	    }
	    cb();
	    // cancel effects are non cancellables
	  }
	
	  function runAllEffect(effects, effectId, cb) {
	    var keys = Object.keys(effects);
	
	    if (!keys.length) {
	      return cb(_utils.is.array(effects) ? [] : {});
	    }
	
	    var completedCount = 0;
	    var completed = void 0;
	    var results = {};
	    var childCbs = {};
	
	    function checkEffectEnd() {
	      if (completedCount === keys.length) {
	        completed = true;
	        cb(_utils.is.array(effects) ? _utils.array.from(_extends({}, results, { length: keys.length })) : results);
	      }
	    }
	
	    keys.forEach(function (key) {
	      var chCbAtKey = function chCbAtKey(res, isErr) {
	        if (completed) {
	          return;
	        }
	        if (isErr || (0, _channel.isEnd)(res) || res === CHANNEL_END || res === TASK_CANCEL) {
	          cb.cancel();
	          cb(res, isErr);
	        } else {
	          results[key] = res;
	          completedCount++;
	          checkEffectEnd();
	        }
	      };
	      chCbAtKey.cancel = _utils.noop;
	      childCbs[key] = chCbAtKey;
	    });
	
	    cb.cancel = function () {
	      if (!completed) {
	        completed = true;
	        keys.forEach(function (key) {
	          return childCbs[key].cancel();
	        });
	      }
	    };
	
	    keys.forEach(function (key) {
	      return runEffect(effects[key], effectId, key, childCbs[key]);
	    });
	  }
	
	  function runRaceEffect(effects, effectId, cb) {
	    var completed = void 0;
	    var keys = Object.keys(effects);
	    var childCbs = {};
	
	    keys.forEach(function (key) {
	      var chCbAtKey = function chCbAtKey(res, isErr) {
	        if (completed) {
	          return;
	        }
	
	        if (isErr) {
	          // Race Auto cancellation
	          cb.cancel();
	          cb(res, true);
	        } else if (!(0, _channel.isEnd)(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
	          var _response;
	
	          cb.cancel();
	          completed = true;
	          var response = (_response = {}, _response[key] = res, _response);
	          cb(_utils.is.array(effects) ? [].slice.call(_extends({}, response, { length: keys.length })) : response);
	        }
	      };
	      chCbAtKey.cancel = _utils.noop;
	      childCbs[key] = chCbAtKey;
	    });
	
	    cb.cancel = function () {
	      // prevents unnecessary cancellation
	      if (!completed) {
	        completed = true;
	        keys.forEach(function (key) {
	          return childCbs[key].cancel();
	        });
	      }
	    };
	    keys.forEach(function (key) {
	      if (completed) {
	        return;
	      }
	      runEffect(effects[key], effectId, key, childCbs[key]);
	    });
	  }
	
	  function runSelectEffect(_ref7, cb) {
	    var selector = _ref7.selector,
	        args = _ref7.args;
	
	    try {
	      var state = selector.apply(undefined, [getState()].concat(args));
	      cb(state);
	    } catch (error) {
	      cb(error, true);
	    }
	  }
	
	  function runChannelEffect(_ref8, cb) {
	    var pattern = _ref8.pattern,
	        buffer = _ref8.buffer;
	
	    var match = matcher(pattern);
	    match.pattern = pattern;
	    cb((0, _channel.eventChannel)(subscribe, buffer || _buffers.buffers.fixed(), match));
	  }
	
	  function runCancelledEffect(data, cb) {
	    cb(!!mainTask.isCancelled);
	  }
	
	  function runFlushEffect(channel, cb) {
	    channel.flush(cb);
	  }
	
	  function runGetContextEffect(prop, cb) {
	    cb(taskContext[prop]);
	  }
	
	  function runSetContextEffect(props, cb) {
	    _utils.object.assign(taskContext, props);
	    cb();
	  }
	
	  function newTask(id, name, iterator, cont) {
	    var _done, _ref9, _mutatorMap;
	
	    iterator._deferredEnd = null;
	    return _ref9 = {}, _ref9[_utils.TASK] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
	      if (iterator._deferredEnd) {
	        return iterator._deferredEnd.promise;
	      } else {
	        var def = (0, _utils.deferred)();
	        iterator._deferredEnd = def;
	        if (!iterator._isRunning) {
	          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
	        }
	        return def.promise;
	      }
	    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
	      return iterator._isRunning;
	    }, _ref9.isCancelled = function isCancelled() {
	      return iterator._isCancelled;
	    }, _ref9.isAborted = function isAborted() {
	      return iterator._isAborted;
	    }, _ref9.result = function result() {
	      return iterator._result;
	    }, _ref9.error = function error() {
	      return iterator._error;
	    }, _ref9.setContext = function setContext(props) {
	      (0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)('task', props));
	      _utils.object.assign(taskContext, props);
	    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
	  }
	}

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runSaga = runSaga;
	
	var _utils = /*#__PURE__*/__webpack_require__(24);
	
	var _proc = /*#__PURE__*/__webpack_require__(218);
	
	var _proc2 = /*#__PURE__*/_interopRequireDefault(_proc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
	var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';
	
	function runSaga(storeInterface, saga) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var iterator = void 0;
	
	  if (_utils.is.iterator(storeInterface)) {
	    if (false) {
	      (0, _utils.log)('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
	    }
	    iterator = storeInterface;
	    storeInterface = saga;
	  } else {
	    (0, _utils.check)(saga, _utils.is.func, NON_GENERATOR_ERR);
	    iterator = saga.apply(undefined, args);
	    (0, _utils.check)(iterator, _utils.is.iterator, NON_GENERATOR_ERR);
	  }
	
	  var _storeInterface = storeInterface,
	      subscribe = _storeInterface.subscribe,
	      dispatch = _storeInterface.dispatch,
	      getState = _storeInterface.getState,
	      context = _storeInterface.context,
	      sagaMonitor = _storeInterface.sagaMonitor,
	      logger = _storeInterface.logger,
	      onError = _storeInterface.onError;
	
	
	  var effectId = (0, _utils.uid)();
	
	  if (sagaMonitor) {
	    // monitors are expected to have a certain interface, let's fill-in any missing ones
	    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || _utils.noop;
	    sagaMonitor.effectResolved = sagaMonitor.effectResolved || _utils.noop;
	    sagaMonitor.effectRejected = sagaMonitor.effectRejected || _utils.noop;
	    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || _utils.noop;
	    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || _utils.noop;
	
	    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
	  }
	
	  var task = (0, _proc2.default)(iterator, subscribe, (0, _utils.wrapSagaDispatch)(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);
	
	  if (sagaMonitor) {
	    sagaMonitor.effectResolved(effectId, task);
	  }
	
	  return task;
	}

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.throttleHelper = exports.takeLatestHelper = exports.takeEveryHelper = exports.throttle = exports.takeLatest = exports.takeEvery = undefined;
	
	var _takeEvery = /*#__PURE__*/__webpack_require__(484);
	
	var _takeEvery2 = /*#__PURE__*/_interopRequireDefault(_takeEvery);
	
	var _takeLatest = /*#__PURE__*/__webpack_require__(485);
	
	var _takeLatest2 = /*#__PURE__*/_interopRequireDefault(_takeLatest);
	
	var _throttle = /*#__PURE__*/__webpack_require__(486);
	
	var _throttle2 = /*#__PURE__*/_interopRequireDefault(_throttle);
	
	var _utils = /*#__PURE__*/__webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var deprecationWarning = function deprecationWarning(helperName) {
	  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
	};
	
	var takeEvery = /*#__PURE__*/(0, _utils.deprecate)(_takeEvery2.default, /*#__PURE__*/deprecationWarning('takeEvery'));
	var takeLatest = /*#__PURE__*/(0, _utils.deprecate)(_takeLatest2.default, /*#__PURE__*/deprecationWarning('takeLatest'));
	var throttle = /*#__PURE__*/(0, _utils.deprecate)(_throttle2.default, /*#__PURE__*/deprecationWarning('throttle'));
	
	exports.takeEvery = takeEvery;
	exports.takeLatest = takeLatest;
	exports.throttle = throttle;
	exports.takeEveryHelper = _takeEvery2.default;
	exports.takeLatestHelper = _takeLatest2.default;
	exports.throttleHelper = _throttle2.default;

/***/ },
/* 221 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.asap = asap;
	exports.suspend = suspend;
	exports.flush = flush;
	var queue = [];
	/**
	  Variable to hold a counting semaphore
	  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
	    already suspended)
	  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
	    triggers flushing the queued tasks.
	**/
	var semaphore = 0;
	
	/**
	  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
	  and flushed after this task has finished (assuming the scheduler endup in a released
	  state).
	**/
	function exec(task) {
	  try {
	    suspend();
	    task();
	  } finally {
	    release();
	  }
	}
	
	/**
	  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
	**/
	function asap(task) {
	  queue.push(task);
	
	  if (!semaphore) {
	    suspend();
	    flush();
	  }
	}
	
	/**
	  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
	  scheduler is released.
	**/
	function suspend() {
	  semaphore++;
	}
	
	/**
	  Puts the scheduler in a `released` state.
	**/
	function release() {
	  semaphore--;
	}
	
	/**
	  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
	**/
	function flush() {
	  release();
	
	  var task = void 0;
	  while (!semaphore && (task = queue.shift()) !== undefined) {
	    exec(task);
	  }
	}

/***/ },
/* 222 */
[792, 504],
/* 223 */
/***/ function(module, exports) {

	// This was ported from https://github.com/emn178/js-sha3, with some minor
	// modifications and pruning. It is licensed under MIT:
	//
	// Copyright 2015-2016 Chen, Yi-Cyuan
	//  
	// Permission is hereby granted, free of charge, to any person obtaining
	// a copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to
	// permit persons to whom the Software is furnished to do so, subject to
	// the following conditions:
	// 
	// The above copyright notice and this permission notice shall be
	// included in all copies or substantial portions of the Software.
	// 
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	// LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
	// OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var HEX_CHARS = '0123456789abcdef'.split('');
	var KECCAK_PADDING = [1, 256, 65536, 16777216];
	var SHIFT = [0, 8, 16, 24];
	var RC = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648];
	
	var Keccak = function Keccak(bits) {
	  return {
	    blocks: [],
	    reset: true,
	    block: 0,
	    start: 0,
	    blockCount: 1600 - (bits << 1) >> 5,
	    outputBlocks: bits >> 5,
	    s: function (s) {
	      return [].concat(s, s, s, s, s);
	    }([0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
	  };
	};
	
	var update = function update(state, message) {
	  var length = message.length,
	      blocks = state.blocks,
	      byteCount = state.blockCount << 2,
	      blockCount = state.blockCount,
	      outputBlocks = state.outputBlocks,
	      s = state.s,
	      index = 0,
	      i,
	      code;
	
	  // update
	  while (index < length) {
	    if (state.reset) {
	      state.reset = false;
	      blocks[0] = state.block;
	      for (i = 1; i < blockCount + 1; ++i) {
	        blocks[i] = 0;
	      }
	    }
	    if (typeof message !== "string") {
	      for (i = state.start; index < length && i < byteCount; ++index) {
	        blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
	      }
	    } else {
	      for (i = state.start; index < length && i < byteCount; ++index) {
	        code = message.charCodeAt(index);
	        if (code < 0x80) {
	          blocks[i >> 2] |= code << SHIFT[i++ & 3];
	        } else if (code < 0x800) {
	          blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
	          blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
	        } else if (code < 0xd800 || code >= 0xe000) {
	          blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
	          blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
	          blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
	        } else {
	          code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
	          blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
	          blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
	          blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
	          blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
	        }
	      }
	    }
	    state.lastByteIndex = i;
	    if (i >= byteCount) {
	      state.start = i - byteCount;
	      state.block = blocks[blockCount];
	      for (i = 0; i < blockCount; ++i) {
	        s[i] ^= blocks[i];
	      }
	      f(s);
	      state.reset = true;
	    } else {
	      state.start = i;
	    }
	  }
	
	  // finalize
	  i = state.lastByteIndex;
	  blocks[i >> 2] |= KECCAK_PADDING[i & 3];
	  if (state.lastByteIndex === byteCount) {
	    blocks[0] = blocks[blockCount];
	    for (i = 1; i < blockCount + 1; ++i) {
	      blocks[i] = 0;
	    }
	  }
	  blocks[blockCount - 1] |= 0x80000000;
	  for (i = 0; i < blockCount; ++i) {
	    s[i] ^= blocks[i];
	  }
	  f(s);
	
	  // toString
	  var hex = '',
	      i = 0,
	      j = 0,
	      block;
	  while (j < outputBlocks) {
	    for (i = 0; i < blockCount && j < outputBlocks; ++i, ++j) {
	      block = s[i];
	      hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
	    }
	    if (j % blockCount === 0) {
	      f(s);
	      i = 0;
	    }
	  }
	  return "0x" + hex;
	};
	
	var f = function f(s) {
	  var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
	
	  for (n = 0; n < 48; n += 2) {
	    c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
	    c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
	    c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
	    c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
	    c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
	    c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
	    c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
	    c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
	    c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
	    c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
	
	    h = c8 ^ (c2 << 1 | c3 >>> 31);
	    l = c9 ^ (c3 << 1 | c2 >>> 31);
	    s[0] ^= h;
	    s[1] ^= l;
	    s[10] ^= h;
	    s[11] ^= l;
	    s[20] ^= h;
	    s[21] ^= l;
	    s[30] ^= h;
	    s[31] ^= l;
	    s[40] ^= h;
	    s[41] ^= l;
	    h = c0 ^ (c4 << 1 | c5 >>> 31);
	    l = c1 ^ (c5 << 1 | c4 >>> 31);
	    s[2] ^= h;
	    s[3] ^= l;
	    s[12] ^= h;
	    s[13] ^= l;
	    s[22] ^= h;
	    s[23] ^= l;
	    s[32] ^= h;
	    s[33] ^= l;
	    s[42] ^= h;
	    s[43] ^= l;
	    h = c2 ^ (c6 << 1 | c7 >>> 31);
	    l = c3 ^ (c7 << 1 | c6 >>> 31);
	    s[4] ^= h;
	    s[5] ^= l;
	    s[14] ^= h;
	    s[15] ^= l;
	    s[24] ^= h;
	    s[25] ^= l;
	    s[34] ^= h;
	    s[35] ^= l;
	    s[44] ^= h;
	    s[45] ^= l;
	    h = c4 ^ (c8 << 1 | c9 >>> 31);
	    l = c5 ^ (c9 << 1 | c8 >>> 31);
	    s[6] ^= h;
	    s[7] ^= l;
	    s[16] ^= h;
	    s[17] ^= l;
	    s[26] ^= h;
	    s[27] ^= l;
	    s[36] ^= h;
	    s[37] ^= l;
	    s[46] ^= h;
	    s[47] ^= l;
	    h = c6 ^ (c0 << 1 | c1 >>> 31);
	    l = c7 ^ (c1 << 1 | c0 >>> 31);
	    s[8] ^= h;
	    s[9] ^= l;
	    s[18] ^= h;
	    s[19] ^= l;
	    s[28] ^= h;
	    s[29] ^= l;
	    s[38] ^= h;
	    s[39] ^= l;
	    s[48] ^= h;
	    s[49] ^= l;
	
	    b0 = s[0];
	    b1 = s[1];
	    b32 = s[11] << 4 | s[10] >>> 28;
	    b33 = s[10] << 4 | s[11] >>> 28;
	    b14 = s[20] << 3 | s[21] >>> 29;
	    b15 = s[21] << 3 | s[20] >>> 29;
	    b46 = s[31] << 9 | s[30] >>> 23;
	    b47 = s[30] << 9 | s[31] >>> 23;
	    b28 = s[40] << 18 | s[41] >>> 14;
	    b29 = s[41] << 18 | s[40] >>> 14;
	    b20 = s[2] << 1 | s[3] >>> 31;
	    b21 = s[3] << 1 | s[2] >>> 31;
	    b2 = s[13] << 12 | s[12] >>> 20;
	    b3 = s[12] << 12 | s[13] >>> 20;
	    b34 = s[22] << 10 | s[23] >>> 22;
	    b35 = s[23] << 10 | s[22] >>> 22;
	    b16 = s[33] << 13 | s[32] >>> 19;
	    b17 = s[32] << 13 | s[33] >>> 19;
	    b48 = s[42] << 2 | s[43] >>> 30;
	    b49 = s[43] << 2 | s[42] >>> 30;
	    b40 = s[5] << 30 | s[4] >>> 2;
	    b41 = s[4] << 30 | s[5] >>> 2;
	    b22 = s[14] << 6 | s[15] >>> 26;
	    b23 = s[15] << 6 | s[14] >>> 26;
	    b4 = s[25] << 11 | s[24] >>> 21;
	    b5 = s[24] << 11 | s[25] >>> 21;
	    b36 = s[34] << 15 | s[35] >>> 17;
	    b37 = s[35] << 15 | s[34] >>> 17;
	    b18 = s[45] << 29 | s[44] >>> 3;
	    b19 = s[44] << 29 | s[45] >>> 3;
	    b10 = s[6] << 28 | s[7] >>> 4;
	    b11 = s[7] << 28 | s[6] >>> 4;
	    b42 = s[17] << 23 | s[16] >>> 9;
	    b43 = s[16] << 23 | s[17] >>> 9;
	    b24 = s[26] << 25 | s[27] >>> 7;
	    b25 = s[27] << 25 | s[26] >>> 7;
	    b6 = s[36] << 21 | s[37] >>> 11;
	    b7 = s[37] << 21 | s[36] >>> 11;
	    b38 = s[47] << 24 | s[46] >>> 8;
	    b39 = s[46] << 24 | s[47] >>> 8;
	    b30 = s[8] << 27 | s[9] >>> 5;
	    b31 = s[9] << 27 | s[8] >>> 5;
	    b12 = s[18] << 20 | s[19] >>> 12;
	    b13 = s[19] << 20 | s[18] >>> 12;
	    b44 = s[29] << 7 | s[28] >>> 25;
	    b45 = s[28] << 7 | s[29] >>> 25;
	    b26 = s[38] << 8 | s[39] >>> 24;
	    b27 = s[39] << 8 | s[38] >>> 24;
	    b8 = s[48] << 14 | s[49] >>> 18;
	    b9 = s[49] << 14 | s[48] >>> 18;
	
	    s[0] = b0 ^ ~b2 & b4;
	    s[1] = b1 ^ ~b3 & b5;
	    s[10] = b10 ^ ~b12 & b14;
	    s[11] = b11 ^ ~b13 & b15;
	    s[20] = b20 ^ ~b22 & b24;
	    s[21] = b21 ^ ~b23 & b25;
	    s[30] = b30 ^ ~b32 & b34;
	    s[31] = b31 ^ ~b33 & b35;
	    s[40] = b40 ^ ~b42 & b44;
	    s[41] = b41 ^ ~b43 & b45;
	    s[2] = b2 ^ ~b4 & b6;
	    s[3] = b3 ^ ~b5 & b7;
	    s[12] = b12 ^ ~b14 & b16;
	    s[13] = b13 ^ ~b15 & b17;
	    s[22] = b22 ^ ~b24 & b26;
	    s[23] = b23 ^ ~b25 & b27;
	    s[32] = b32 ^ ~b34 & b36;
	    s[33] = b33 ^ ~b35 & b37;
	    s[42] = b42 ^ ~b44 & b46;
	    s[43] = b43 ^ ~b45 & b47;
	    s[4] = b4 ^ ~b6 & b8;
	    s[5] = b5 ^ ~b7 & b9;
	    s[14] = b14 ^ ~b16 & b18;
	    s[15] = b15 ^ ~b17 & b19;
	    s[24] = b24 ^ ~b26 & b28;
	    s[25] = b25 ^ ~b27 & b29;
	    s[34] = b34 ^ ~b36 & b38;
	    s[35] = b35 ^ ~b37 & b39;
	    s[44] = b44 ^ ~b46 & b48;
	    s[45] = b45 ^ ~b47 & b49;
	    s[6] = b6 ^ ~b8 & b0;
	    s[7] = b7 ^ ~b9 & b1;
	    s[16] = b16 ^ ~b18 & b10;
	    s[17] = b17 ^ ~b19 & b11;
	    s[26] = b26 ^ ~b28 & b20;
	    s[27] = b27 ^ ~b29 & b21;
	    s[36] = b36 ^ ~b38 & b30;
	    s[37] = b37 ^ ~b39 & b31;
	    s[46] = b46 ^ ~b48 & b40;
	    s[47] = b47 ^ ~b49 & b41;
	    s[8] = b8 ^ ~b0 & b2;
	    s[9] = b9 ^ ~b1 & b3;
	    s[18] = b18 ^ ~b10 & b12;
	    s[19] = b19 ^ ~b11 & b13;
	    s[28] = b28 ^ ~b20 & b22;
	    s[29] = b29 ^ ~b21 & b23;
	    s[38] = b38 ^ ~b30 & b32;
	    s[39] = b39 ^ ~b31 & b33;
	    s[48] = b48 ^ ~b40 & b42;
	    s[49] = b49 ^ ~b41 & b43;
	
	    s[0] ^= RC[n];
	    s[1] ^= RC[n + 1];
	  }
	};
	
	var keccak = function keccak(bits) {
	  return function (str) {
	    var msg;
	    if (str.slice(0, 2) === "0x") {
	      msg = [];
	      for (var i = 2, l = str.length; i < l; i += 2) {
	        msg.push(parseInt(str.slice(i, i + 2), 16));
	      }
	    } else {
	      msg = str;
	    }
	    return update(Keccak(bits, bits), msg);
	  };
	};
	
	module.exports = {
	  keccak256: keccak(256),
	  keccak512: keccak(512),
	  keccak256s: keccak(256),
	  keccak512s: keccak(512)
	};

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(20);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 225 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 226 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(27);
	var common = __webpack_require__(75);
	var shaCommon = __webpack_require__(229);
	var assert = __webpack_require__(21);
	
	var sum32 = utils.sum32;
	var sum32_4 = utils.sum32_4;
	var sum32_5 = utils.sum32_5;
	var ch32 = shaCommon.ch32;
	var maj32 = shaCommon.maj32;
	var s0_256 = shaCommon.s0_256;
	var s1_256 = shaCommon.s1_256;
	var g0_256 = shaCommon.g0_256;
	var g1_256 = shaCommon.g1_256;
	
	var BlockHash = common.BlockHash;
	
	var sha256_K = [
	  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
	  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
	  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
	  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
	  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
	  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
	  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
	  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
	  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
	  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
	  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
	  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
	  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
	  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
	  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
	  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
	];
	
	function SHA256() {
	  if (!(this instanceof SHA256))
	    return new SHA256();
	
	  BlockHash.call(this);
	  this.h = [
	    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
	    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
	  ];
	  this.k = sha256_K;
	  this.W = new Array(64);
	}
	utils.inherits(SHA256, BlockHash);
	module.exports = SHA256;
	
	SHA256.blockSize = 512;
	SHA256.outSize = 256;
	SHA256.hmacStrength = 192;
	SHA256.padLength = 64;
	
	SHA256.prototype._update = function _update(msg, start) {
	  var W = this.W;
	
	  for (var i = 0; i < 16; i++)
	    W[i] = msg[start + i];
	  for (; i < W.length; i++)
	    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);
	
	  var a = this.h[0];
	  var b = this.h[1];
	  var c = this.h[2];
	  var d = this.h[3];
	  var e = this.h[4];
	  var f = this.h[5];
	  var g = this.h[6];
	  var h = this.h[7];
	
	  assert(this.k.length === W.length);
	  for (i = 0; i < W.length; i++) {
	    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
	    var T2 = sum32(s0_256(a), maj32(a, b, c));
	    h = g;
	    g = f;
	    f = e;
	    e = sum32(d, T1);
	    d = c;
	    c = b;
	    b = a;
	    a = sum32(T1, T2);
	  }
	
	  this.h[0] = sum32(this.h[0], a);
	  this.h[1] = sum32(this.h[1], b);
	  this.h[2] = sum32(this.h[2], c);
	  this.h[3] = sum32(this.h[3], d);
	  this.h[4] = sum32(this.h[4], e);
	  this.h[5] = sum32(this.h[5], f);
	  this.h[6] = sum32(this.h[6], g);
	  this.h[7] = sum32(this.h[7], h);
	};
	
	SHA256.prototype._digest = function digest(enc) {
	  if (enc === 'hex')
	    return utils.toHex32(this.h, 'big');
	  else
	    return utils.split32(this.h, 'big');
	};


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(27);
	var common = __webpack_require__(75);
	var assert = __webpack_require__(21);
	
	var rotr64_hi = utils.rotr64_hi;
	var rotr64_lo = utils.rotr64_lo;
	var shr64_hi = utils.shr64_hi;
	var shr64_lo = utils.shr64_lo;
	var sum64 = utils.sum64;
	var sum64_hi = utils.sum64_hi;
	var sum64_lo = utils.sum64_lo;
	var sum64_4_hi = utils.sum64_4_hi;
	var sum64_4_lo = utils.sum64_4_lo;
	var sum64_5_hi = utils.sum64_5_hi;
	var sum64_5_lo = utils.sum64_5_lo;
	
	var BlockHash = common.BlockHash;
	
	var sha512_K = [
	  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	];
	
	function SHA512() {
	  if (!(this instanceof SHA512))
	    return new SHA512();
	
	  BlockHash.call(this);
	  this.h = [
	    0x6a09e667, 0xf3bcc908,
	    0xbb67ae85, 0x84caa73b,
	    0x3c6ef372, 0xfe94f82b,
	    0xa54ff53a, 0x5f1d36f1,
	    0x510e527f, 0xade682d1,
	    0x9b05688c, 0x2b3e6c1f,
	    0x1f83d9ab, 0xfb41bd6b,
	    0x5be0cd19, 0x137e2179 ];
	  this.k = sha512_K;
	  this.W = new Array(160);
	}
	utils.inherits(SHA512, BlockHash);
	module.exports = SHA512;
	
	SHA512.blockSize = 1024;
	SHA512.outSize = 512;
	SHA512.hmacStrength = 192;
	SHA512.padLength = 128;
	
	SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
	  var W = this.W;
	
	  // 32 x 32bit words
	  for (var i = 0; i < 32; i++)
	    W[i] = msg[start + i];
	  for (; i < W.length; i += 2) {
	    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
	    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
	    var c1_hi = W[i - 14];  // i - 7
	    var c1_lo = W[i - 13];
	    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
	    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
	    var c3_hi = W[i - 32];  // i - 16
	    var c3_lo = W[i - 31];
	
	    W[i] = sum64_4_hi(
	      c0_hi, c0_lo,
	      c1_hi, c1_lo,
	      c2_hi, c2_lo,
	      c3_hi, c3_lo);
	    W[i + 1] = sum64_4_lo(
	      c0_hi, c0_lo,
	      c1_hi, c1_lo,
	      c2_hi, c2_lo,
	      c3_hi, c3_lo);
	  }
	};
	
	SHA512.prototype._update = function _update(msg, start) {
	  this._prepareBlock(msg, start);
	
	  var W = this.W;
	
	  var ah = this.h[0];
	  var al = this.h[1];
	  var bh = this.h[2];
	  var bl = this.h[3];
	  var ch = this.h[4];
	  var cl = this.h[5];
	  var dh = this.h[6];
	  var dl = this.h[7];
	  var eh = this.h[8];
	  var el = this.h[9];
	  var fh = this.h[10];
	  var fl = this.h[11];
	  var gh = this.h[12];
	  var gl = this.h[13];
	  var hh = this.h[14];
	  var hl = this.h[15];
	
	  assert(this.k.length === W.length);
	  for (var i = 0; i < W.length; i += 2) {
	    var c0_hi = hh;
	    var c0_lo = hl;
	    var c1_hi = s1_512_hi(eh, el);
	    var c1_lo = s1_512_lo(eh, el);
	    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
	    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
	    var c3_hi = this.k[i];
	    var c3_lo = this.k[i + 1];
	    var c4_hi = W[i];
	    var c4_lo = W[i + 1];
	
	    var T1_hi = sum64_5_hi(
	      c0_hi, c0_lo,
	      c1_hi, c1_lo,
	      c2_hi, c2_lo,
	      c3_hi, c3_lo,
	      c4_hi, c4_lo);
	    var T1_lo = sum64_5_lo(
	      c0_hi, c0_lo,
	      c1_hi, c1_lo,
	      c2_hi, c2_lo,
	      c3_hi, c3_lo,
	      c4_hi, c4_lo);
	
	    c0_hi = s0_512_hi(ah, al);
	    c0_lo = s0_512_lo(ah, al);
	    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
	    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);
	
	    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
	    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
	
	    hh = gh;
	    hl = gl;
	
	    gh = fh;
	    gl = fl;
	
	    fh = eh;
	    fl = el;
	
	    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
	    el = sum64_lo(dl, dl, T1_hi, T1_lo);
	
	    dh = ch;
	    dl = cl;
	
	    ch = bh;
	    cl = bl;
	
	    bh = ah;
	    bl = al;
	
	    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
	    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
	  }
	
	  sum64(this.h, 0, ah, al);
	  sum64(this.h, 2, bh, bl);
	  sum64(this.h, 4, ch, cl);
	  sum64(this.h, 6, dh, dl);
	  sum64(this.h, 8, eh, el);
	  sum64(this.h, 10, fh, fl);
	  sum64(this.h, 12, gh, gl);
	  sum64(this.h, 14, hh, hl);
	};
	
	SHA512.prototype._digest = function digest(enc) {
	  if (enc === 'hex')
	    return utils.toHex32(this.h, 'big');
	  else
	    return utils.split32(this.h, 'big');
	};
	
	function ch64_hi(xh, xl, yh, yl, zh) {
	  var r = (xh & yh) ^ ((~xh) & zh);
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}
	
	function ch64_lo(xh, xl, yh, yl, zh, zl) {
	  var r = (xl & yl) ^ ((~xl) & zl);
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}
	
	function maj64_hi(xh, xl, yh, yl, zh) {
	  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}
	
	function maj64_lo(xh, xl, yh, yl, zh, zl) {
	  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}
	
	function s0_512_hi(xh, xl) {
	  var c0_hi = rotr64_hi(xh, xl, 28);
	  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
	  var c2_hi = rotr64_hi(xl, xh, 7);  // 39
	
	  var r = c0_hi ^ c1_hi ^ c2_hi;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}
	
	function s0_512_lo(xh, xl) {
	  var c0_lo = rotr64_lo(xh, xl, 28);
	  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
	  var c2_lo = rotr64_lo(xl, xh, 7);  // 39
	
	  var r = c0_lo ^ c1_lo ^ c2_lo;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}
	
	function s1_512_hi(xh, xl) {
	  var c0_hi = rotr64_hi(xh, xl, 14);
	  var c1_hi = rotr64_hi(xh, xl, 18);
	  var c2_hi = rotr64_hi(xl, xh, 9);  // 41
	
	  var r = c0_hi ^ c1_hi ^ c2_hi;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}
	
	function s1_512_lo(xh, xl) {
	  var c0_lo = rotr64_lo(xh, xl, 14);
	  var c1_lo = rotr64_lo(xh, xl, 18);
	  var c2_lo = rotr64_lo(xl, xh, 9);  // 41
	
	  var r = c0_lo ^ c1_lo ^ c2_lo;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}
	
	function g0_512_hi(xh, xl) {
	  var c0_hi = rotr64_hi(xh, xl, 1);
	  var c1_hi = rotr64_hi(xh, xl, 8);
	  var c2_hi = shr64_hi(xh, xl, 7);
	
	  var r = c0_hi ^ c1_hi ^ c2_hi;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}
	
	function g0_512_lo(xh, xl) {
	  var c0_lo = rotr64_lo(xh, xl, 1);
	  var c1_lo = rotr64_lo(xh, xl, 8);
	  var c2_lo = shr64_lo(xh, xl, 7);
	
	  var r = c0_lo ^ c1_lo ^ c2_lo;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}
	
	function g1_512_hi(xh, xl) {
	  var c0_hi = rotr64_hi(xh, xl, 19);
	  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
	  var c2_hi = shr64_hi(xh, xl, 6);
	
	  var r = c0_hi ^ c1_hi ^ c2_hi;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}
	
	function g1_512_lo(xh, xl) {
	  var c0_lo = rotr64_lo(xh, xl, 19);
	  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
	  var c2_lo = shr64_lo(xh, xl, 6);
	
	  var r = c0_lo ^ c1_lo ^ c2_lo;
	  if (r < 0)
	    r += 0x100000000;
	  return r;
	}


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(27);
	var rotr32 = utils.rotr32;
	
	function ft_1(s, x, y, z) {
	  if (s === 0)
	    return ch32(x, y, z);
	  if (s === 1 || s === 3)
	    return p32(x, y, z);
	  if (s === 2)
	    return maj32(x, y, z);
	}
	exports.ft_1 = ft_1;
	
	function ch32(x, y, z) {
	  return (x & y) ^ ((~x) & z);
	}
	exports.ch32 = ch32;
	
	function maj32(x, y, z) {
	  return (x & y) ^ (x & z) ^ (y & z);
	}
	exports.maj32 = maj32;
	
	function p32(x, y, z) {
	  return x ^ y ^ z;
	}
	exports.p32 = p32;
	
	function s0_256(x) {
	  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
	}
	exports.s0_256 = s0_256;
	
	function s1_256(x) {
	  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
	}
	exports.s1_256 = s1_256;
	
	function g0_256(x) {
	  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
	}
	exports.g0_256 = g0_256;
	
	function g1_256(x) {
	  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
	}
	exports.g1_256 = g1_256;


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(42);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(141);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(601);
	
	var _runTransitionHook = __webpack_require__(141);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(53);
	
	var _PathUtils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ },
/* 233 */
/***/ function(module, exports) {

	module.exports = isFunction
	
	var toString = Object.prototype.toString
	
	function isFunction (fn) {
	  var string = toString.call(fn)
	  return string === '[object Function]' ||
	    (typeof fn === 'function' && string !== '[object RegExp]') ||
	    (typeof window !== 'undefined' &&
	     // IE8 and below
	     (fn === window.setTimeout ||
	      fn === window.alert ||
	      fn === window.confirm ||
	      fn === window.prompt))
	};


/***/ },
/* 234 */
/***/ function(module, exports) {

	/**
	 * Returns a `Boolean` on whether or not the a `String` starts with '0x'
	 * @param {String} str the string input value
	 * @return {Boolean} a boolean if it is or is not hex prefixed
	 * @throws if the str input is not a string
	 */
	module.exports = function isHexPrefixed(str) {
	  if (typeof str !== 'string') {
	    throw new Error("[is-hex-prefixed] value must be type 'string', is currently type " + (typeof str) + ", while checking isHexPrefixed.");
	  }
	
	  return str.slice(0, 2) === '0x';
	}


/***/ },
/* 235 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 236 */
/***/ function(module, exports) {

	module.exports = {
		"aes-128-ecb": {
			"cipher": "AES",
			"key": 128,
			"iv": 0,
			"mode": "ECB",
			"type": "block"
		},
		"aes-192-ecb": {
			"cipher": "AES",
			"key": 192,
			"iv": 0,
			"mode": "ECB",
			"type": "block"
		},
		"aes-256-ecb": {
			"cipher": "AES",
			"key": 256,
			"iv": 0,
			"mode": "ECB",
			"type": "block"
		},
		"aes-128-cbc": {
			"cipher": "AES",
			"key": 128,
			"iv": 16,
			"mode": "CBC",
			"type": "block"
		},
		"aes-192-cbc": {
			"cipher": "AES",
			"key": 192,
			"iv": 16,
			"mode": "CBC",
			"type": "block"
		},
		"aes-256-cbc": {
			"cipher": "AES",
			"key": 256,
			"iv": 16,
			"mode": "CBC",
			"type": "block"
		},
		"aes128": {
			"cipher": "AES",
			"key": 128,
			"iv": 16,
			"mode": "CBC",
			"type": "block"
		},
		"aes192": {
			"cipher": "AES",
			"key": 192,
			"iv": 16,
			"mode": "CBC",
			"type": "block"
		},
		"aes256": {
			"cipher": "AES",
			"key": 256,
			"iv": 16,
			"mode": "CBC",
			"type": "block"
		},
		"aes-128-cfb": {
			"cipher": "AES",
			"key": 128,
			"iv": 16,
			"mode": "CFB",
			"type": "stream"
		},
		"aes-192-cfb": {
			"cipher": "AES",
			"key": 192,
			"iv": 16,
			"mode": "CFB",
			"type": "stream"
		},
		"aes-256-cfb": {
			"cipher": "AES",
			"key": 256,
			"iv": 16,
			"mode": "CFB",
			"type": "stream"
		},
		"aes-128-cfb8": {
			"cipher": "AES",
			"key": 128,
			"iv": 16,
			"mode": "CFB8",
			"type": "stream"
		},
		"aes-192-cfb8": {
			"cipher": "AES",
			"key": 192,
			"iv": 16,
			"mode": "CFB8",
			"type": "stream"
		},
		"aes-256-cfb8": {
			"cipher": "AES",
			"key": 256,
			"iv": 16,
			"mode": "CFB8",
			"type": "stream"
		},
		"aes-128-cfb1": {
			"cipher": "AES",
			"key": 128,
			"iv": 16,
			"mode": "CFB1",
			"type": "stream"
		},
		"aes-192-cfb1": {
			"cipher": "AES",
			"key": 192,
			"iv": 16,
			"mode": "CFB1",
			"type": "stream"
		},
		"aes-256-cfb1": {
			"cipher": "AES",
			"key": 256,
			"iv": 16,
			"mode": "CFB1",
			"type": "stream"
		},
		"aes-128-ofb": {
			"cipher": "AES",
			"key": 128,
			"iv": 16,
			"mode": "OFB",
			"type": "stream"
		},
		"aes-192-ofb": {
			"cipher": "AES",
			"key": 192,
			"iv": 16,
			"mode": "OFB",
			"type": "stream"
		},
		"aes-256-ofb": {
			"cipher": "AES",
			"key": 256,
			"iv": 16,
			"mode": "OFB",
			"type": "stream"
		},
		"aes-128-ctr": {
			"cipher": "AES",
			"key": 128,
			"iv": 16,
			"mode": "CTR",
			"type": "stream"
		},
		"aes-192-ctr": {
			"cipher": "AES",
			"key": 192,
			"iv": 16,
			"mode": "CTR",
			"type": "stream"
		},
		"aes-256-ctr": {
			"cipher": "AES",
			"key": 256,
			"iv": 16,
			"mode": "CTR",
			"type": "stream"
		},
		"aes-128-gcm": {
			"cipher": "AES",
			"key": 128,
			"iv": 12,
			"mode": "GCM",
			"type": "auth"
		},
		"aes-192-gcm": {
			"cipher": "AES",
			"key": 192,
			"iv": 12,
			"mode": "GCM",
			"type": "auth"
		},
		"aes-256-gcm": {
			"cipher": "AES",
			"key": 256,
			"iv": 12,
			"mode": "GCM",
			"type": "auth"
		}
	};

/***/ },
/* 237 */
/***/ function(module, exports) {

	module.exports = {
		"sha224WithRSAEncryption": {
			"sign": "rsa",
			"hash": "sha224",
			"id": "302d300d06096086480165030402040500041c"
		},
		"RSA-SHA224": {
			"sign": "ecdsa/rsa",
			"hash": "sha224",
			"id": "302d300d06096086480165030402040500041c"
		},
		"sha256WithRSAEncryption": {
			"sign": "rsa",
			"hash": "sha256",
			"id": "3031300d060960864801650304020105000420"
		},
		"RSA-SHA256": {
			"sign": "ecdsa/rsa",
			"hash": "sha256",
			"id": "3031300d060960864801650304020105000420"
		},
		"sha384WithRSAEncryption": {
			"sign": "rsa",
			"hash": "sha384",
			"id": "3041300d060960864801650304020205000430"
		},
		"RSA-SHA384": {
			"sign": "ecdsa/rsa",
			"hash": "sha384",
			"id": "3041300d060960864801650304020205000430"
		},
		"sha512WithRSAEncryption": {
			"sign": "rsa",
			"hash": "sha512",
			"id": "3051300d060960864801650304020305000440"
		},
		"RSA-SHA512": {
			"sign": "ecdsa/rsa",
			"hash": "sha512",
			"id": "3051300d060960864801650304020305000440"
		},
		"RSA-SHA1": {
			"sign": "rsa",
			"hash": "sha1",
			"id": "3021300906052b0e03021a05000414"
		},
		"ecdsa-with-SHA1": {
			"sign": "ecdsa",
			"hash": "sha1",
			"id": ""
		},
		"sha256": {
			"sign": "ecdsa",
			"hash": "sha256",
			"id": ""
		},
		"sha224": {
			"sign": "ecdsa",
			"hash": "sha224",
			"id": ""
		},
		"sha384": {
			"sign": "ecdsa",
			"hash": "sha384",
			"id": ""
		},
		"sha512": {
			"sign": "ecdsa",
			"hash": "sha512",
			"id": ""
		},
		"DSA-SHA": {
			"sign": "dsa",
			"hash": "sha1",
			"id": ""
		},
		"DSA-SHA1": {
			"sign": "dsa",
			"hash": "sha1",
			"id": ""
		},
		"DSA": {
			"sign": "dsa",
			"hash": "sha1",
			"id": ""
		},
		"DSA-WITH-SHA224": {
			"sign": "dsa",
			"hash": "sha224",
			"id": ""
		},
		"DSA-SHA224": {
			"sign": "dsa",
			"hash": "sha224",
			"id": ""
		},
		"DSA-WITH-SHA256": {
			"sign": "dsa",
			"hash": "sha256",
			"id": ""
		},
		"DSA-SHA256": {
			"sign": "dsa",
			"hash": "sha256",
			"id": ""
		},
		"DSA-WITH-SHA384": {
			"sign": "dsa",
			"hash": "sha384",
			"id": ""
		},
		"DSA-SHA384": {
			"sign": "dsa",
			"hash": "sha384",
			"id": ""
		},
		"DSA-WITH-SHA512": {
			"sign": "dsa",
			"hash": "sha512",
			"id": ""
		},
		"DSA-SHA512": {
			"sign": "dsa",
			"hash": "sha512",
			"id": ""
		},
		"DSA-RIPEMD160": {
			"sign": "dsa",
			"hash": "rmd160",
			"id": ""
		},
		"ripemd160WithRSA": {
			"sign": "rsa",
			"hash": "rmd160",
			"id": "3021300906052b2403020105000414"
		},
		"RSA-RIPEMD160": {
			"sign": "rsa",
			"hash": "rmd160",
			"id": "3021300906052b2403020105000414"
		},
		"md5WithRSAEncryption": {
			"sign": "rsa",
			"hash": "md5",
			"id": "3020300c06082a864886f70d020505000410"
		},
		"RSA-MD5": {
			"sign": "rsa",
			"hash": "md5",
			"id": "3020300c06082a864886f70d020505000410"
		}
	};

/***/ },
/* 238 */
/***/ function(module, exports) {

	module.exports = {
		"1.3.132.0.10": "secp256k1",
		"1.3.132.0.33": "p224",
		"1.2.840.10045.3.1.1": "p192",
		"1.2.840.10045.3.1.7": "p256",
		"1.3.132.0.34": "p384",
		"1.3.132.0.35": "p521"
	};

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(242);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 240 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 241 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(240);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(576),
	    isLength = __webpack_require__(244);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 244 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 245 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(98),
	    getPrototype = __webpack_require__(566),
	    isObjectLike = __webpack_require__(99);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	var bn = __webpack_require__(7);
	var brorand = __webpack_require__(202);
	
	function MillerRabin(rand) {
	  this.rand = rand || new brorand.Rand();
	}
	module.exports = MillerRabin;
	
	MillerRabin.create = function create(rand) {
	  return new MillerRabin(rand);
	};
	
	MillerRabin.prototype._randbelow = function _randbelow(n) {
	  var len = n.bitLength();
	  var min_bytes = Math.ceil(len / 8);
	
	  // Generage random bytes until a number less than n is found.
	  // This ensures that 0..n-1 have an equal probability of being selected.
	  do
	    var a = new bn(this.rand.generate(min_bytes));
	  while (a.cmp(n) >= 0);
	
	  return a;
	};
	
	MillerRabin.prototype._randrange = function _randrange(start, stop) {
	  // Generate a random number greater than or equal to start and less than stop.
	  var size = stop.sub(start);
	  return start.add(this._randbelow(size));
	};
	
	MillerRabin.prototype.test = function test(n, k, cb) {
	  var len = n.bitLength();
	  var red = bn.mont(n);
	  var rone = new bn(1).toRed(red);
	
	  if (!k)
	    k = Math.max(1, (len / 48) | 0);
	
	  // Find d and s, (n - 1) = (2 ^ s) * d;
	  var n1 = n.subn(1);
	  for (var s = 0; !n1.testn(s); s++) {}
	  var d = n.shrn(s);
	
	  var rn1 = n1.toRed(red);
	
	  var prime = true;
	  for (; k > 0; k--) {
	    var a = this._randrange(new bn(2), n1);
	    if (cb)
	      cb(a);
	
	    var x = a.toRed(red).redPow(d);
	    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
	      continue;
	
	    for (var i = 1; i < s; i++) {
	      x = x.redSqr();
	
	      if (x.cmp(rone) === 0)
	        return false;
	      if (x.cmp(rn1) === 0)
	        break;
	    }
	
	    if (i === s)
	      return false;
	  }
	
	  return prime;
	};
	
	MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
	  var len = n.bitLength();
	  var red = bn.mont(n);
	  var rone = new bn(1).toRed(red);
	
	  if (!k)
	    k = Math.max(1, (len / 48) | 0);
	
	  // Find d and s, (n - 1) = (2 ^ s) * d;
	  var n1 = n.subn(1);
	  for (var s = 0; !n1.testn(s); s++) {}
	  var d = n.shrn(s);
	
	  var rn1 = n1.toRed(red);
	
	  for (; k > 0; k--) {
	    var a = this._randrange(new bn(2), n1);
	
	    var g = n.gcd(a);
	    if (g.cmpn(1) !== 0)
	      return g;
	
	    var x = a.toRed(red).redPow(d);
	    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
	      continue;
	
	    for (var i = 1; i < s; i++) {
	      x = x.redSqr();
	
	      if (x.cmp(rone) === 0)
	        return x.fromRed().subn(1).gcd(n);
	      if (x.cmp(rn1) === 0)
	        break;
	    }
	
	    if (i === s) {
	      x = x.redSqr();
	      return x.fromRed().subn(1).gcd(n);
	    }
	  }
	
	  return false;
	};


/***/ },
/* 248 */
/***/ function(module, exports) {

	'use strict';
	
	var utils = exports;
	
	function toArray(msg, enc) {
	  if (Array.isArray(msg))
	    return msg.slice();
	  if (!msg)
	    return [];
	  var res = [];
	  if (typeof msg !== 'string') {
	    for (var i = 0; i < msg.length; i++)
	      res[i] = msg[i] | 0;
	    return res;
	  }
	  if (enc === 'hex') {
	    msg = msg.replace(/[^a-z0-9]+/ig, '');
	    if (msg.length % 2 !== 0)
	      msg = '0' + msg;
	    for (var i = 0; i < msg.length; i += 2)
	      res.push(parseInt(msg[i] + msg[i + 1], 16));
	  } else {
	    for (var i = 0; i < msg.length; i++) {
	      var c = msg.charCodeAt(i);
	      var hi = c >> 8;
	      var lo = c & 0xff;
	      if (hi)
	        res.push(hi, lo);
	      else
	        res.push(lo);
	    }
	  }
	  return res;
	}
	utils.toArray = toArray;
	
	function zero2(word) {
	  if (word.length === 1)
	    return '0' + word;
	  else
	    return word;
	}
	utils.zero2 = zero2;
	
	function toHex(msg) {
	  var res = '';
	  for (var i = 0; i < msg.length; i++)
	    res += zero2(msg[i].toString(16));
	  return res;
	}
	utils.toHex = toHex;
	
	utils.encode = function encode(arr, enc) {
	  if (enc === 'hex')
	    return toHex(arr);
	  else
	    return arr;
	};


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	var BN = __webpack_require__(7);
	var stripHexPrefix = __webpack_require__(311);
	
	/**
	 * Returns a BN object, converts a number value to a BN
	 * @param {String|Number|Object} `arg` input a string number, hex string number, number, BigNumber or BN object
	 * @return {Object} `output` BN object of the number
	 * @throws if the argument is not an array, object that isn't a bignumber, not a string number or number
	 */
	module.exports = function numberToBN(arg) {
	  if (typeof arg === 'string' || typeof arg === 'number') {
	    var multiplier = new BN(1); // eslint-disable-line
	    var formattedString = String(arg).toLowerCase().trim();
	    var isHexPrefixed = formattedString.substr(0, 2) === '0x' || formattedString.substr(0, 3) === '-0x';
	    var stringArg = stripHexPrefix(formattedString); // eslint-disable-line
	    if (stringArg.substr(0, 1) === '-') {
	      stringArg = stripHexPrefix(stringArg.slice(1));
	      multiplier = new BN(-1, 10);
	    }
	    stringArg = stringArg === '' ? '0' : stringArg;
	
	    if ((!stringArg.match(/^-?[0-9]+$/) && stringArg.match(/^[0-9A-Fa-f]+$/))
	      || stringArg.match(/^[a-fA-F]+$/)
	      || (isHexPrefixed === true && stringArg.match(/^[0-9A-Fa-f]+$/))) {
	      return new BN(stringArg, 16).mul(multiplier);
	    }
	
	    if ((stringArg.match(/^-?[0-9]+$/) || stringArg === '') && isHexPrefixed === false) {
	      return new BN(stringArg, 10).mul(multiplier);
	    }
	  } else if (typeof arg === 'object' && arg.toString && (!arg.pop && !arg.push)) {
	    if (arg.toString(10).match(/^-?[0-9]+$/) && (arg.mul || arg.dividedToIntegerBy)) {
	      return new BN(arg.toString(10), 10);
	    }
	  }
	
	  throw new Error('[number-to-bn] while converting number ' + JSON.stringify(arg) + ' to BN.js instance, error: invalid number value. Value must be an integer, hex string, BN or BigNumber instance. Note, decimals are not supported.');
	}


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var defaultEncoding
	/* istanbul ignore next */
	if (process.browser) {
	  defaultEncoding = 'utf-8'
	} else {
	  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)
	
	  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
	}
	module.exports = defaultEncoding
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ },
/* 251 */
/***/ function(module, exports) {

	var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
	module.exports = function (iterations, keylen) {
	  if (typeof iterations !== 'number') {
	    throw new TypeError('Iterations not a number')
	  }
	
	  if (iterations < 0) {
	    throw new TypeError('Bad iterations')
	  }
	
	  if (typeof keylen !== 'number') {
	    throw new TypeError('Key length not a number')
	  }
	
	  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
	    throw new TypeError('Bad key length')
	  }
	}


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	var md5 = __webpack_require__(128)
	var rmd160 = __webpack_require__(169)
	var sha = __webpack_require__(170)
	
	var checkParameters = __webpack_require__(251)
	var defaultEncoding = __webpack_require__(250)
	var Buffer = __webpack_require__(4).Buffer
	var ZEROS = Buffer.alloc(128)
	var sizes = {
	  md5: 16,
	  sha1: 20,
	  sha224: 28,
	  sha256: 32,
	  sha384: 48,
	  sha512: 64,
	  rmd160: 20,
	  ripemd160: 20
	}
	
	function Hmac (alg, key, saltLen) {
	  var hash = getDigest(alg)
	  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64
	
	  if (key.length > blocksize) {
	    key = hash(key)
	  } else if (key.length < blocksize) {
	    key = Buffer.concat([key, ZEROS], blocksize)
	  }
	
	  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg])
	  var opad = Buffer.allocUnsafe(blocksize + sizes[alg])
	  for (var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36
	    opad[i] = key[i] ^ 0x5C
	  }
	
	  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4)
	  ipad.copy(ipad1, 0, 0, blocksize)
	  this.ipad1 = ipad1
	  this.ipad2 = ipad
	  this.opad = opad
	  this.alg = alg
	  this.blocksize = blocksize
	  this.hash = hash
	  this.size = sizes[alg]
	}
	
	Hmac.prototype.run = function (data, ipad) {
	  data.copy(ipad, this.blocksize)
	  var h = this.hash(ipad)
	  h.copy(this.opad, this.blocksize)
	  return this.hash(this.opad)
	}
	
	function getDigest (alg) {
	  function shaFunc (data) {
	    return sha(alg).update(data).digest()
	  }
	
	  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160
	  if (alg === 'md5') return md5
	  return shaFunc
	}
	
	function pbkdf2 (password, salt, iterations, keylen, digest) {
	  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
	  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)
	
	  checkParameters(iterations, keylen)
	
	  digest = digest || 'sha1'
	
	  var hmac = new Hmac(digest, password, salt.length)
	
	  var DK = Buffer.allocUnsafe(keylen)
	  var block1 = Buffer.allocUnsafe(salt.length + 4)
	  salt.copy(block1, 0, 0, salt.length)
	
	  var destPos = 0
	  var hLen = sizes[digest]
	  var l = Math.ceil(keylen / hLen)
	
	  for (var i = 1; i <= l; i++) {
	    block1.writeUInt32BE(i, salt.length)
	
	    var T = hmac.run(block1, hmac.ipad1)
	    var U = T
	
	    for (var j = 1; j < iterations; j++) {
	      U = hmac.run(U, hmac.ipad2)
	      for (var k = 0; k < hLen; k++) T[k] ^= U[k]
	    }
	
	    T.copy(DK, destPos)
	    destPos += hLen
	  }
	
	  return DK
	}
	
	module.exports = pbkdf2


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(329);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(596);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 255 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(74);
	module.exports = function (seed, len) {
	  var t = new Buffer('');
	  var  i = 0, c;
	  while (t.length < len) {
	    c = i2ops(i++);
	    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()]);
	  }
	  return t.slice(0, len);
	};
	
	function i2ops(c) {
	  var out = new Buffer(4);
	  out.writeUInt32BE(c,0);
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var bn = __webpack_require__(7);
	function withPublic(paddedMsg, key) {
	  return new Buffer(paddedMsg
	    .toRed(bn.mont(key.modulus))
	    .redPow(new bn(key.publicExponent))
	    .fromRed()
	    .toArray());
	}
	
	module.exports = withPublic;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 258 */
/***/ function(module, exports) {

	module.exports = function xor(a, b) {
	  var len = a.length;
	  var i = -1;
	  while (++i < len) {
	    a[i] ^= b[i];
	  }
	  return a
	};

/***/ },
/* 259 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(46);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(56);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactInstrumentation = __webpack_require__(25);
	
	var quoteAttributeValueForBrowser = __webpack_require__(672);
	var warning = __webpack_require__(5);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 262 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var LinkedValueUtils = __webpack_require__(148);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(28);
	
	var warning = __webpack_require__(5);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 264 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 265 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(3);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(632);
	
	var containsNode = __webpack_require__(522);
	var focusNode = __webpack_require__(225);
	var getActiveElement = __webpack_require__(226);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var DOMLazyTree = __webpack_require__(55);
	var DOMProperty = __webpack_require__(56);
	var React = __webpack_require__(60);
	var ReactBrowserEventEmitter = __webpack_require__(102);
	var ReactCurrentOwner = __webpack_require__(34);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDOMContainerInfo = __webpack_require__(626);
	var ReactDOMFeatureFlags = __webpack_require__(628);
	var ReactFeatureFlags = __webpack_require__(265);
	var ReactInstanceMap = __webpack_require__(78);
	var ReactInstrumentation = __webpack_require__(25);
	var ReactMarkupChecksum = __webpack_require__(642);
	var ReactReconciler = __webpack_require__(57);
	var ReactUpdateQueue = __webpack_require__(151);
	var ReactUpdates = __webpack_require__(28);
	
	var emptyObject = __webpack_require__(95);
	var instantiateReactComponent = __webpack_require__(276);
	var invariant = __webpack_require__(3);
	var setInnerHTML = __webpack_require__(106);
	var shouldUpdateReactComponent = __webpack_require__(157);
	var warning = __webpack_require__(5);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var React = __webpack_require__(60);
	
	var invariant = __webpack_require__(3);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 270 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 272 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(269);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(15);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(8);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(10);
	
	var ReactCompositeComponent = __webpack_require__(623);
	var ReactEmptyComponent = __webpack_require__(264);
	var ReactHostComponent = __webpack_require__(266);
	
	var getNextDebugID = __webpack_require__(700);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 277 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(15);
	var escapeTextContentForBrowser = __webpack_require__(105);
	var setInnerHTML = __webpack_require__(106);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(34);
	var REACT_ELEMENT_TYPE = __webpack_require__(638);
	
	var getIteratorFn = __webpack_require__(669);
	var invariant = __webpack_require__(3);
	var KeyEscapeUtils = __webpack_require__(147);
	var warning = __webpack_require__(5);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 280 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ },
/* 281 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  locationBeforeTransitions: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { locationBeforeTransitions: payload });
	  }
	
	  return state;
	}

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(32);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(11);
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(162);
	
	var _ContextUtils = __webpack_require__(161);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 283 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(32);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(11);
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(41);
	
	var _PatternUtils = __webpack_require__(58);
	
	var _InternalPropTypes = __webpack_require__(80);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 285 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(232);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(231);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(546);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__(290);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(59);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(684);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(681);
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__(688);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(685);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(690);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(41);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(162);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(58);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(680);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(282);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(676);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(691);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(677);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(678);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(284);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(679);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(163);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(689);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(290);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(682);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(683);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(687);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(286);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(232);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(231);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(81),
	    _assign = __webpack_require__(164);
	
	var ReactNoopUpdateQueue = __webpack_require__(294);
	
	var canDefineProperty = __webpack_require__(295);
	var emptyObject = __webpack_require__(95);
	var invariant = __webpack_require__(3);
	var lowPriorityWarning = __webpack_require__(701);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(81);
	
	var ReactCurrentOwner = __webpack_require__(34);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 293 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(5);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(101).nextTick;
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(235);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(93).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(299);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(4).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(73);
	util.inherits = __webpack_require__(2);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(789);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(706);
	var destroyImpl = __webpack_require__(298);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
	
	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(47);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(171).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(47);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(171).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    processNextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        processNextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    processNextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;
	
	  var state = this._readableState;
	  var paused = false;
	
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }
	
	    _this.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return this;
	};
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    processNextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(22)))

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(47);
	
	/*<replacement>*/
	var util = __webpack_require__(73);
	util.inherits = __webpack_require__(2);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);
	
	  cb(er);
	
	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}
	
	function prefinish() {
	  var _this = this;
	
	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(101).nextTick;
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      processNextTick(emitErrorNT, this, err);
	    }
	    return this;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      processNextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	
	  return this;
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(93).EventEmitter;


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _io = __webpack_require__(63);
	
	Object.defineProperty(exports, 'take', {
	  enumerable: true,
	  get: function get() {
	    return _io.take;
	  }
	});
	Object.defineProperty(exports, 'takem', {
	  enumerable: true,
	  get: function get() {
	    return _io.takem;
	  }
	});
	Object.defineProperty(exports, 'put', {
	  enumerable: true,
	  get: function get() {
	    return _io.put;
	  }
	});
	Object.defineProperty(exports, 'all', {
	  enumerable: true,
	  get: function get() {
	    return _io.all;
	  }
	});
	Object.defineProperty(exports, 'race', {
	  enumerable: true,
	  get: function get() {
	    return _io.race;
	  }
	});
	Object.defineProperty(exports, 'call', {
	  enumerable: true,
	  get: function get() {
	    return _io.call;
	  }
	});
	Object.defineProperty(exports, 'apply', {
	  enumerable: true,
	  get: function get() {
	    return _io.apply;
	  }
	});
	Object.defineProperty(exports, 'cps', {
	  enumerable: true,
	  get: function get() {
	    return _io.cps;
	  }
	});
	Object.defineProperty(exports, 'fork', {
	  enumerable: true,
	  get: function get() {
	    return _io.fork;
	  }
	});
	Object.defineProperty(exports, 'spawn', {
	  enumerable: true,
	  get: function get() {
	    return _io.spawn;
	  }
	});
	Object.defineProperty(exports, 'join', {
	  enumerable: true,
	  get: function get() {
	    return _io.join;
	  }
	});
	Object.defineProperty(exports, 'cancel', {
	  enumerable: true,
	  get: function get() {
	    return _io.cancel;
	  }
	});
	Object.defineProperty(exports, 'select', {
	  enumerable: true,
	  get: function get() {
	    return _io.select;
	  }
	});
	Object.defineProperty(exports, 'actionChannel', {
	  enumerable: true,
	  get: function get() {
	    return _io.actionChannel;
	  }
	});
	Object.defineProperty(exports, 'cancelled', {
	  enumerable: true,
	  get: function get() {
	    return _io.cancelled;
	  }
	});
	Object.defineProperty(exports, 'flush', {
	  enumerable: true,
	  get: function get() {
	    return _io.flush;
	  }
	});
	Object.defineProperty(exports, 'getContext', {
	  enumerable: true,
	  get: function get() {
	    return _io.getContext;
	  }
	});
	Object.defineProperty(exports, 'setContext', {
	  enumerable: true,
	  get: function get() {
	    return _io.setContext;
	  }
	});
	Object.defineProperty(exports, 'takeEvery', {
	  enumerable: true,
	  get: function get() {
	    return _io.takeEvery;
	  }
	});
	Object.defineProperty(exports, 'takeLatest', {
	  enumerable: true,
	  get: function get() {
	    return _io.takeLatest;
	  }
	});
	Object.defineProperty(exports, 'throttle', {
	  enumerable: true,
	  get: function get() {
	    return _io.throttle;
	  }
	});

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TASK_CANCEL = exports.CHANNEL_END = exports.NOT_ITERATOR_ERROR = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = proc;
	
	var _utils = __webpack_require__(26);
	
	var _scheduler = __webpack_require__(304);
	
	var _io = __webpack_require__(63);
	
	var _channel = __webpack_require__(62);
	
	var _buffers = __webpack_require__(107);
	
	function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }
	
	var NOT_ITERATOR_ERROR = exports.NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';
	
	var CHANNEL_END = exports.CHANNEL_END = {
	  toString: function toString() {
	    return '@@redux-saga/CHANNEL_END';
	  }
	};
	var TASK_CANCEL = exports.TASK_CANCEL = {
	  toString: function toString() {
	    return '@@redux-saga/TASK_CANCEL';
	  }
	};
	
	var matchers = {
	  wildcard: function wildcard() {
	    return _utils.kTrue;
	  },
	  default: function _default(pattern) {
	    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
	      return input.type === pattern;
	    } : function (input) {
	      return input.type === String(pattern);
	    };
	  },
	  array: function array(patterns) {
	    return function (input) {
	      return patterns.some(function (p) {
	        return matcher(p)(input);
	      });
	    };
	  },
	  predicate: function predicate(_predicate) {
	    return function (input) {
	      return _predicate(input);
	    };
	  }
	};
	
	function matcher(pattern) {
	  // prettier-ignore
	  return (pattern === '*' ? matchers.wildcard : _utils.is.array(pattern) ? matchers.array : _utils.is.stringableFunc(pattern) ? matchers.default : _utils.is.func(pattern) ? matchers.predicate : matchers.default)(pattern);
	}
	
	/**
	  Used to track a parent task and its forks
	  In the new fork model, forked tasks are attached by default to their parent
	  We model this using the concept of Parent task && main Task
	  main task is the main flow of the current Generator, the parent tasks is the
	  aggregation of the main tasks + all its forked tasks.
	  Thus the whole model represents an execution tree with multiple branches (vs the
	  linear execution tree in sequential (non parallel) programming)
	
	  A parent tasks has the following semantics
	  - It completes if all its forks either complete or all cancelled
	  - If it's cancelled, all forks are cancelled as well
	  - It aborts if any uncaught error bubbles up from forks
	  - If it completes, the return value is the one returned by the main task
	**/
	function forkQueue(name, mainTask, cb) {
	  var tasks = [],
	      result = void 0,
	      completed = false;
	  addTask(mainTask);
	
	  function abort(err) {
	    cancelAll();
	    cb(err, true);
	  }
	
	  function addTask(task) {
	    tasks.push(task);
	    task.cont = function (res, isErr) {
	      if (completed) {
	        return;
	      }
	
	      (0, _utils.remove)(tasks, task);
	      task.cont = _utils.noop;
	      if (isErr) {
	        abort(res);
	      } else {
	        if (task === mainTask) {
	          result = res;
	        }
	        if (!tasks.length) {
	          completed = true;
	          cb(result);
	        }
	      }
	    };
	    // task.cont.cancel = task.cancel
	  }
	
	  function cancelAll() {
	    if (completed) {
	      return;
	    }
	    completed = true;
	    tasks.forEach(function (t) {
	      t.cont = _utils.noop;
	      t.cancel();
	    });
	    tasks = [];
	  }
	
	  return {
	    addTask: addTask,
	    cancelAll: cancelAll,
	    abort: abort,
	    getTasks: function getTasks() {
	      return tasks;
	    },
	    taskNames: function taskNames() {
	      return tasks.map(function (t) {
	        return t.name;
	      });
	    }
	  };
	}
	
	function createTaskIterator(_ref) {
	  var context = _ref.context,
	      fn = _ref.fn,
	      args = _ref.args;
	
	  if (_utils.is.iterator(fn)) {
	    return fn;
	  }
	
	  // catch synchronous failures; see #152 and #441
	  var result = void 0,
	      error = void 0;
	  try {
	    result = fn.apply(context, args);
	  } catch (err) {
	    error = err;
	  }
	
	  // i.e. a generator function returns an iterator
	  if (_utils.is.iterator(result)) {
	    return result;
	  }
	
	  // do not bubble up synchronous failures for detached forks
	  // instead create a failed task. See #152 and #441
	  return error ? (0, _utils.makeIterator)(function () {
	    throw error;
	  }) : (0, _utils.makeIterator)(function () {
	    var pc = void 0;
	    var eff = { done: false, value: result };
	    var ret = function ret(value) {
	      return { done: true, value: value };
	    };
	    return function (arg) {
	      if (!pc) {
	        pc = true;
	        return eff;
	      } else {
	        return ret(arg);
	      }
	    };
	  }());
	}
	
	var wrapHelper = function wrapHelper(helper) {
	  return { fn: helper };
	};
	
	function proc(iterator) {
	  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
	    return _utils.noop;
	  };
	  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _utils.noop;
	  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _utils.noop;
	  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
	  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
	  var cont = arguments[8];
	
	  (0, _utils.check)(iterator, _utils.is.iterator, NOT_ITERATOR_ERROR);
	
	  var effectsString = '[...effects]';
	  var runParallelEffect = (0, _utils.deprecate)(runAllEffect, (0, _utils.updateIncentive)(effectsString, 'all(' + effectsString + ')'));
	
	  var sagaMonitor = options.sagaMonitor,
	      logger = options.logger,
	      onError = options.onError;
	
	  var log = logger || _utils.log;
	  var stdChannel = (0, _channel.stdChannel)(subscribe);
	  var taskContext = Object.create(parentContext);
	  /**
	    Tracks the current effect cancellation
	    Each time the generator progresses. calling runEffect will set a new value
	    on it. It allows propagating cancellation to child effects
	  **/
	  next.cancel = _utils.noop;
	
	  /**
	    Creates a new task descriptor for this generator, We'll also create a main task
	    to track the main flow (besides other forked tasks)
	  **/
	  var task = newTask(parentEffectId, name, iterator, cont);
	  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
	  var taskQueue = forkQueue(name, mainTask, end);
	
	  /**
	    cancellation of the main task. We'll simply resume the Generator with a Cancel
	  **/
	  function cancelMain() {
	    if (mainTask.isRunning && !mainTask.isCancelled) {
	      mainTask.isCancelled = true;
	      next(TASK_CANCEL);
	    }
	  }
	
	  /**
	    This may be called by a parent generator to trigger/propagate cancellation
	    cancel all pending tasks (including the main task), then end the current task.
	     Cancellation propagates down to the whole execution tree holded by this Parent task
	    It's also propagated to all joiners of this task and their execution tree/joiners
	     Cancellation is noop for terminated/Cancelled tasks tasks
	  **/
	  function cancel() {
	    /**
	      We need to check both Running and Cancelled status
	      Tasks can be Cancelled but still Running
	    **/
	    if (iterator._isRunning && !iterator._isCancelled) {
	      iterator._isCancelled = true;
	      taskQueue.cancelAll();
	      /**
	        Ending with a Never result will propagate the Cancellation to all joiners
	      **/
	      end(TASK_CANCEL);
	    }
	  }
	  /**
	    attaches cancellation logic to this task's continuation
	    this will permit cancellation to propagate down the call chain
	  **/
	  cont && (cont.cancel = cancel);
	
	  // tracks the running status
	  iterator._isRunning = true;
	
	  // kicks up the generator
	  next();
	
	  // then return the task descriptor to the caller
	  return task;
	
	  /**
	    This is the generator driver
	    It's a recursive async/continuation function which calls itself
	    until the generator terminates or throws
	  **/
	  function next(arg, isErr) {
	    // Preventive measure. If we end up here, then there is really something wrong
	    if (!mainTask.isRunning) {
	      throw new Error('Trying to resume an already finished generator');
	    }
	
	    try {
	      var result = void 0;
	      if (isErr) {
	        result = iterator.throw(arg);
	      } else if (arg === TASK_CANCEL) {
	        /**
	          getting TASK_CANCEL automatically cancels the main task
	          We can get this value here
	           - By cancelling the parent task manually
	          - By joining a Cancelled task
	        **/
	        mainTask.isCancelled = true;
	        /**
	          Cancels the current effect; this will propagate the cancellation down to any called tasks
	        **/
	        next.cancel();
	        /**
	          If this Generator has a `return` method then invokes it
	          This will jump to the finally block
	        **/
	        result = _utils.is.func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
	      } else if (arg === CHANNEL_END) {
	        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
	        result = _utils.is.func(iterator.return) ? iterator.return() : { done: true };
	      } else {
	        result = iterator.next(arg);
	      }
	
	      if (!result.done) {
	        runEffect(result.value, parentEffectId, '', next);
	      } else {
	        /**
	          This Generator has ended, terminate the main task and notify the fork queue
	        **/
	        mainTask.isMainRunning = false;
	        mainTask.cont && mainTask.cont(result.value);
	      }
	    } catch (error) {
	      if (mainTask.isCancelled) {
	        log('error', 'uncaught at ' + name, error.message);
	      }
	      mainTask.isMainRunning = false;
	      mainTask.cont(error, true);
	    }
	  }
	
	  function end(result, isErr) {
	    iterator._isRunning = false;
	    stdChannel.close();
	    if (!isErr) {
	      if (false) {
	        log('info', name + ' has been cancelled', '');
	      }
	      iterator._result = result;
	      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
	    } else {
	      if (result instanceof Error) {
	        result.sagaStack = 'at ' + name + ' \n ' + (result.sagaStack || result.stack);
	      }
	      if (!task.cont) {
	        log('error', 'uncaught', result.sagaStack || result.stack);
	        if (result instanceof Error && onError) {
	          onError(result);
	        }
	      }
	      iterator._error = result;
	      iterator._isAborted = true;
	      iterator._deferredEnd && iterator._deferredEnd.reject(result);
	    }
	    task.cont && task.cont(result, isErr);
	    task.joiners.forEach(function (j) {
	      return j.cb(result, isErr);
	    });
	    task.joiners = null;
	  }
	
	  function runEffect(effect, parentEffectId) {
	    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var cb = arguments[3];
	
	    var effectId = (0, _utils.uid)();
	    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });
	
	    /**
	      completion callback and cancel callback are mutually exclusive
	      We can't cancel an already completed effect
	      And We can't complete an already cancelled effectId
	    **/
	    var effectSettled = void 0;
	
	    // Completion callback passed to the appropriate effect runner
	    function currCb(res, isErr) {
	      if (effectSettled) {
	        return;
	      }
	
	      effectSettled = true;
	      cb.cancel = _utils.noop; // defensive measure
	      if (sagaMonitor) {
	        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
	      }
	      cb(res, isErr);
	    }
	    // tracks down the current cancel
	    currCb.cancel = _utils.noop;
	
	    // setup cancellation logic on the parent cb
	    cb.cancel = function () {
	      // prevents cancelling an already completed effect
	      if (effectSettled) {
	        return;
	      }
	
	      effectSettled = true;
	      /**
	        propagates cancel downward
	        catch uncaught cancellations errors; since we can no longer call the completion
	        callback, log errors raised during cancellations into the console
	      **/
	      try {
	        currCb.cancel();
	      } catch (err) {
	        log('error', 'uncaught at ' + name, err.message);
	      }
	      currCb.cancel = _utils.noop; // defensive measure
	
	      sagaMonitor && sagaMonitor.effectCancelled(effectId);
	    };
	
	    /**
	      each effect runner must attach its own logic of cancellation to the provided callback
	      it allows this generator to propagate cancellation downward.
	       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
	      And the setup must occur before calling the callback
	       This is a sort of inversion of control: called async functions are responsible
	      for completing the flow by calling the provided continuation; while caller functions
	      are responsible for aborting the current flow by calling the attached cancel function
	       Library users can attach their own cancellation logic to promises by defining a
	      promise[CANCEL] method in their returned promises
	      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
	    **/
	    var data = void 0;
	    // prettier-ignore
	    return (
	      // Non declarative effect
	      _utils.is.promise(effect) ? resolvePromise(effect, currCb) : _utils.is.helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : _utils.is.iterator(effect) ? resolveIterator(effect, effectId, name, currCb)
	
	      // declarative effects
	      : _utils.is.array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = _io.asEffect.take(effect)) ? runTakeEffect(data, currCb) : (data = _io.asEffect.put(effect)) ? runPutEffect(data, currCb) : (data = _io.asEffect.all(effect)) ? runAllEffect(data, effectId, currCb) : (data = _io.asEffect.race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = _io.asEffect.call(effect)) ? runCallEffect(data, effectId, currCb) : (data = _io.asEffect.cps(effect)) ? runCPSEffect(data, currCb) : (data = _io.asEffect.fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = _io.asEffect.join(effect)) ? runJoinEffect(data, currCb) : (data = _io.asEffect.cancel(effect)) ? runCancelEffect(data, currCb) : (data = _io.asEffect.select(effect)) ? runSelectEffect(data, currCb) : (data = _io.asEffect.actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = _io.asEffect.flush(effect)) ? runFlushEffect(data, currCb) : (data = _io.asEffect.cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = _io.asEffect.getContext(effect)) ? runGetContextEffect(data, currCb) : (data = _io.asEffect.setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */currCb(effect)
	    );
	  }
	
	  function resolvePromise(promise, cb) {
	    var cancelPromise = promise[_utils.CANCEL];
	    if (_utils.is.func(cancelPromise)) {
	      cb.cancel = cancelPromise;
	    } else if (_utils.is.func(promise.abort)) {
	      cb.cancel = function () {
	        return promise.abort();
	      };
	      // TODO: add support for the fetch API, whenever they get around to
	      // adding cancel support
	    }
	    promise.then(cb, function (error) {
	      return cb(error, true);
	    });
	  }
	
	  function resolveIterator(iterator, effectId, name, cb) {
	    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
	  }
	
	  function runTakeEffect(_ref2, cb) {
	    var channel = _ref2.channel,
	        pattern = _ref2.pattern,
	        maybe = _ref2.maybe;
	
	    channel = channel || stdChannel;
	    var takeCb = function takeCb(inp) {
	      return inp instanceof Error ? cb(inp, true) : (0, _channel.isEnd)(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
	    };
	    try {
	      channel.take(takeCb, matcher(pattern));
	    } catch (err) {
	      return cb(err, true);
	    }
	    cb.cancel = takeCb.cancel;
	  }
	
	  function runPutEffect(_ref3, cb) {
	    var channel = _ref3.channel,
	        action = _ref3.action,
	        resolve = _ref3.resolve;
	
	    /**
	      Schedule the put in case another saga is holding a lock.
	      The put will be executed atomically. ie nested puts will execute after
	      this put has terminated.
	    **/
	    (0, _scheduler.asap)(function () {
	      var result = void 0;
	      try {
	        result = (channel ? channel.put : dispatch)(action);
	      } catch (error) {
	        // If we have a channel or `put.resolve` was used then bubble up the error.
	        if (channel || resolve) return cb(error, true);
	        log('error', 'uncaught at ' + name, error.stack || error.message || error);
	      }
	
	      if (resolve && _utils.is.promise(result)) {
	        resolvePromise(result, cb);
	      } else {
	        return cb(result);
	      }
	    });
	    // Put effects are non cancellables
	  }
	
	  function runCallEffect(_ref4, effectId, cb) {
	    var context = _ref4.context,
	        fn = _ref4.fn,
	        args = _ref4.args;
	
	    var result = void 0;
	    // catch synchronous failures; see #152
	    try {
	      result = fn.apply(context, args);
	    } catch (error) {
	      return cb(error, true);
	    }
	    return _utils.is.promise(result) ? resolvePromise(result, cb) : _utils.is.iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
	  }
	
	  function runCPSEffect(_ref5, cb) {
	    var context = _ref5.context,
	        fn = _ref5.fn,
	        args = _ref5.args;
	
	    // CPS (ie node style functions) can define their own cancellation logic
	    // by setting cancel field on the cb
	
	    // catch synchronous failures; see #152
	    try {
	      var cpsCb = function cpsCb(err, res) {
	        return _utils.is.undef(err) ? cb(res) : cb(err, true);
	      };
	      fn.apply(context, args.concat(cpsCb));
	      if (cpsCb.cancel) {
	        cb.cancel = function () {
	          return cpsCb.cancel();
	        };
	      }
	    } catch (error) {
	      return cb(error, true);
	    }
	  }
	
	  function runForkEffect(_ref6, effectId, cb) {
	    var context = _ref6.context,
	        fn = _ref6.fn,
	        args = _ref6.args,
	        detached = _ref6.detached;
	
	    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });
	
	    try {
	      (0, _scheduler.suspend)();
	      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : _utils.noop);
	
	      if (detached) {
	        cb(_task);
	      } else {
	        if (taskIterator._isRunning) {
	          taskQueue.addTask(_task);
	          cb(_task);
	        } else if (taskIterator._error) {
	          taskQueue.abort(taskIterator._error);
	        } else {
	          cb(_task);
	        }
	      }
	    } finally {
	      (0, _scheduler.flush)();
	    }
	    // Fork effects are non cancellables
	  }
	
	  function runJoinEffect(t, cb) {
	    if (t.isRunning()) {
	      var joiner = { task: task, cb: cb };
	      cb.cancel = function () {
	        return (0, _utils.remove)(t.joiners, joiner);
	      };
	      t.joiners.push(joiner);
	    } else {
	      t.isAborted() ? cb(t.error(), true) : cb(t.result());
	    }
	  }
	
	  function runCancelEffect(taskToCancel, cb) {
	    if (taskToCancel === _utils.SELF_CANCELLATION) {
	      taskToCancel = task;
	    }
	    if (taskToCancel.isRunning()) {
	      taskToCancel.cancel();
	    }
	    cb();
	    // cancel effects are non cancellables
	  }
	
	  function runAllEffect(effects, effectId, cb) {
	    var keys = Object.keys(effects);
	
	    if (!keys.length) {
	      return cb(_utils.is.array(effects) ? [] : {});
	    }
	
	    var completedCount = 0;
	    var completed = void 0;
	    var results = {};
	    var childCbs = {};
	
	    function checkEffectEnd() {
	      if (completedCount === keys.length) {
	        completed = true;
	        cb(_utils.is.array(effects) ? _utils.array.from(_extends({}, results, { length: keys.length })) : results);
	      }
	    }
	
	    keys.forEach(function (key) {
	      var chCbAtKey = function chCbAtKey(res, isErr) {
	        if (completed) {
	          return;
	        }
	        if (isErr || (0, _channel.isEnd)(res) || res === CHANNEL_END || res === TASK_CANCEL) {
	          cb.cancel();
	          cb(res, isErr);
	        } else {
	          results[key] = res;
	          completedCount++;
	          checkEffectEnd();
	        }
	      };
	      chCbAtKey.cancel = _utils.noop;
	      childCbs[key] = chCbAtKey;
	    });
	
	    cb.cancel = function () {
	      if (!completed) {
	        completed = true;
	        keys.forEach(function (key) {
	          return childCbs[key].cancel();
	        });
	      }
	    };
	
	    keys.forEach(function (key) {
	      return runEffect(effects[key], effectId, key, childCbs[key]);
	    });
	  }
	
	  function runRaceEffect(effects, effectId, cb) {
	    var completed = void 0;
	    var keys = Object.keys(effects);
	    var childCbs = {};
	
	    keys.forEach(function (key) {
	      var chCbAtKey = function chCbAtKey(res, isErr) {
	        if (completed) {
	          return;
	        }
	
	        if (isErr) {
	          // Race Auto cancellation
	          cb.cancel();
	          cb(res, true);
	        } else if (!(0, _channel.isEnd)(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
	          var _cb;
	
	          cb.cancel();
	          completed = true;
	          cb((_cb = {}, _cb[key] = res, _cb));
	        }
	      };
	      chCbAtKey.cancel = _utils.noop;
	      childCbs[key] = chCbAtKey;
	    });
	
	    cb.cancel = function () {
	      // prevents unnecessary cancellation
	      if (!completed) {
	        completed = true;
	        keys.forEach(function (key) {
	          return childCbs[key].cancel();
	        });
	      }
	    };
	    keys.forEach(function (key) {
	      if (completed) {
	        return;
	      }
	      runEffect(effects[key], effectId, key, childCbs[key]);
	    });
	  }
	
	  function runSelectEffect(_ref7, cb) {
	    var selector = _ref7.selector,
	        args = _ref7.args;
	
	    try {
	      var state = selector.apply(undefined, [getState()].concat(args));
	      cb(state);
	    } catch (error) {
	      cb(error, true);
	    }
	  }
	
	  function runChannelEffect(_ref8, cb) {
	    var pattern = _ref8.pattern,
	        buffer = _ref8.buffer;
	
	    var match = matcher(pattern);
	    match.pattern = pattern;
	    cb((0, _channel.eventChannel)(subscribe, buffer || _buffers.buffers.fixed(), match));
	  }
	
	  function runCancelledEffect(data, cb) {
	    cb(!!mainTask.isCancelled);
	  }
	
	  function runFlushEffect(channel, cb) {
	    channel.flush(cb);
	  }
	
	  function runGetContextEffect(prop, cb) {
	    cb(taskContext[prop]);
	  }
	
	  function runSetContextEffect(props, cb) {
	    _utils.object.assign(taskContext, props);
	    cb();
	  }
	
	  function newTask(id, name, iterator, cont) {
	    var _done, _ref9, _mutatorMap;
	
	    iterator._deferredEnd = null;
	    return _ref9 = {}, _ref9[_utils.TASK] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
	      if (iterator._deferredEnd) {
	        return iterator._deferredEnd.promise;
	      } else {
	        var def = (0, _utils.deferred)();
	        iterator._deferredEnd = def;
	        if (!iterator._isRunning) {
	          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
	        }
	        return def.promise;
	      }
	    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
	      return iterator._isRunning;
	    }, _ref9.isCancelled = function isCancelled() {
	      return iterator._isCancelled;
	    }, _ref9.isAborted = function isAborted() {
	      return iterator._isAborted;
	    }, _ref9.result = function result() {
	      return iterator._result;
	    }, _ref9.error = function error() {
	      return iterator._error;
	    }, _ref9.setContext = function setContext(props) {
	      (0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)('task', props));
	      _utils.object.assign(taskContext, props);
	    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
	  }
	}

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runSaga = runSaga;
	
	var _utils = __webpack_require__(26);
	
	var _proc = __webpack_require__(301);
	
	var _proc2 = _interopRequireDefault(_proc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
	var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';
	
	function runSaga(storeInterface, saga) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var iterator = void 0;
	
	  if (_utils.is.iterator(storeInterface)) {
	    if (false) {
	      (0, _utils.log)('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
	    }
	    iterator = storeInterface;
	    storeInterface = saga;
	  } else {
	    (0, _utils.check)(saga, _utils.is.func, NON_GENERATOR_ERR);
	    iterator = saga.apply(undefined, args);
	    (0, _utils.check)(iterator, _utils.is.iterator, NON_GENERATOR_ERR);
	  }
	
	  var _storeInterface = storeInterface,
	      subscribe = _storeInterface.subscribe,
	      dispatch = _storeInterface.dispatch,
	      getState = _storeInterface.getState,
	      context = _storeInterface.context,
	      sagaMonitor = _storeInterface.sagaMonitor,
	      logger = _storeInterface.logger,
	      onError = _storeInterface.onError;
	
	
	  var effectId = (0, _utils.uid)();
	
	  if (sagaMonitor) {
	    // monitors are expected to have a certain interface, let's fill-in any missing ones
	    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || _utils.noop;
	    sagaMonitor.effectResolved = sagaMonitor.effectResolved || _utils.noop;
	    sagaMonitor.effectRejected = sagaMonitor.effectRejected || _utils.noop;
	    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || _utils.noop;
	    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || _utils.noop;
	
	    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
	  }
	
	  var task = (0, _proc2.default)(iterator, subscribe, (0, _utils.wrapSagaDispatch)(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);
	
	  if (sagaMonitor) {
	    sagaMonitor.effectResolved(effectId, task);
	  }
	
	  return task;
	}

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.throttleHelper = exports.takeLatestHelper = exports.takeEveryHelper = exports.throttle = exports.takeLatest = exports.takeEvery = undefined;
	
	var _takeEvery = __webpack_require__(712);
	
	var _takeEvery2 = _interopRequireDefault(_takeEvery);
	
	var _takeLatest = __webpack_require__(713);
	
	var _takeLatest2 = _interopRequireDefault(_takeLatest);
	
	var _throttle = __webpack_require__(714);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _utils = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var deprecationWarning = function deprecationWarning(helperName) {
	  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
	};
	
	var takeEvery = /*#__PURE__*/(0, _utils.deprecate)(_takeEvery2.default, /*#__PURE__*/deprecationWarning('takeEvery'));
	var takeLatest = /*#__PURE__*/(0, _utils.deprecate)(_takeLatest2.default, /*#__PURE__*/deprecationWarning('takeLatest'));
	var throttle = /*#__PURE__*/(0, _utils.deprecate)(_throttle2.default, /*#__PURE__*/deprecationWarning('throttle'));
	
	exports.takeEvery = takeEvery;
	exports.takeLatest = takeLatest;
	exports.throttle = throttle;
	exports.takeEveryHelper = _takeEvery2.default;
	exports.takeLatestHelper = _takeLatest2.default;
	exports.throttleHelper = _throttle2.default;

/***/ },
/* 304 */
221,
/* 305 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(246);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(312);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 307 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(2)
	var Hash = __webpack_require__(64)
	var Buffer = __webpack_require__(4).Buffer
	
	var K = [
	  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
	  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
	  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
	  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
	  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
	  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
	  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
	  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
	  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
	  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
	  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
	  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
	  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
	  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
	  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
	  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
	]
	
	var W = new Array(64)
	
	function Sha256 () {
	  this.init()
	
	  this._w = W // new Array(64)
	
	  Hash.call(this, 64, 56)
	}
	
	inherits(Sha256, Hash)
	
	Sha256.prototype.init = function () {
	  this._a = 0x6a09e667
	  this._b = 0xbb67ae85
	  this._c = 0x3c6ef372
	  this._d = 0xa54ff53a
	  this._e = 0x510e527f
	  this._f = 0x9b05688c
	  this._g = 0x1f83d9ab
	  this._h = 0x5be0cd19
	
	  return this
	}
	
	function ch (x, y, z) {
	  return z ^ (x & (y ^ z))
	}
	
	function maj (x, y, z) {
	  return (x & y) | (z & (x | y))
	}
	
	function sigma0 (x) {
	  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
	}
	
	function sigma1 (x) {
	  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
	}
	
	function gamma0 (x) {
	  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
	}
	
	function gamma1 (x) {
	  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
	}
	
	Sha256.prototype._update = function (M) {
	  var W = this._w
	
	  var a = this._a | 0
	  var b = this._b | 0
	  var c = this._c | 0
	  var d = this._d | 0
	  var e = this._e | 0
	  var f = this._f | 0
	  var g = this._g | 0
	  var h = this._h | 0
	
	  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
	  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0
	
	  for (var j = 0; j < 64; ++j) {
	    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
	    var T2 = (sigma0(a) + maj(a, b, c)) | 0
	
	    h = g
	    g = f
	    f = e
	    e = (d + T1) | 0
	    d = c
	    c = b
	    b = a
	    a = (T1 + T2) | 0
	  }
	
	  this._a = (a + this._a) | 0
	  this._b = (b + this._b) | 0
	  this._c = (c + this._c) | 0
	  this._d = (d + this._d) | 0
	  this._e = (e + this._e) | 0
	  this._f = (f + this._f) | 0
	  this._g = (g + this._g) | 0
	  this._h = (h + this._h) | 0
	}
	
	Sha256.prototype._hash = function () {
	  var H = Buffer.allocUnsafe(32)
	
	  H.writeInt32BE(this._a, 0)
	  H.writeInt32BE(this._b, 4)
	  H.writeInt32BE(this._c, 8)
	  H.writeInt32BE(this._d, 12)
	  H.writeInt32BE(this._e, 16)
	  H.writeInt32BE(this._f, 20)
	  H.writeInt32BE(this._g, 24)
	  H.writeInt32BE(this._h, 28)
	
	  return H
	}
	
	module.exports = Sha256


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(2)
	var Hash = __webpack_require__(64)
	var Buffer = __webpack_require__(4).Buffer
	
	var K = [
	  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	]
	
	var W = new Array(160)
	
	function Sha512 () {
	  this.init()
	  this._w = W
	
	  Hash.call(this, 128, 112)
	}
	
	inherits(Sha512, Hash)
	
	Sha512.prototype.init = function () {
	  this._ah = 0x6a09e667
	  this._bh = 0xbb67ae85
	  this._ch = 0x3c6ef372
	  this._dh = 0xa54ff53a
	  this._eh = 0x510e527f
	  this._fh = 0x9b05688c
	  this._gh = 0x1f83d9ab
	  this._hh = 0x5be0cd19
	
	  this._al = 0xf3bcc908
	  this._bl = 0x84caa73b
	  this._cl = 0xfe94f82b
	  this._dl = 0x5f1d36f1
	  this._el = 0xade682d1
	  this._fl = 0x2b3e6c1f
	  this._gl = 0xfb41bd6b
	  this._hl = 0x137e2179
	
	  return this
	}
	
	function Ch (x, y, z) {
	  return z ^ (x & (y ^ z))
	}
	
	function maj (x, y, z) {
	  return (x & y) | (z & (x | y))
	}
	
	function sigma0 (x, xl) {
	  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
	}
	
	function sigma1 (x, xl) {
	  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
	}
	
	function Gamma0 (x, xl) {
	  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
	}
	
	function Gamma0l (x, xl) {
	  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
	}
	
	function Gamma1 (x, xl) {
	  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
	}
	
	function Gamma1l (x, xl) {
	  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
	}
	
	function getCarry (a, b) {
	  return (a >>> 0) < (b >>> 0) ? 1 : 0
	}
	
	Sha512.prototype._update = function (M) {
	  var W = this._w
	
	  var ah = this._ah | 0
	  var bh = this._bh | 0
	  var ch = this._ch | 0
	  var dh = this._dh | 0
	  var eh = this._eh | 0
	  var fh = this._fh | 0
	  var gh = this._gh | 0
	  var hh = this._hh | 0
	
	  var al = this._al | 0
	  var bl = this._bl | 0
	  var cl = this._cl | 0
	  var dl = this._dl | 0
	  var el = this._el | 0
	  var fl = this._fl | 0
	  var gl = this._gl | 0
	  var hl = this._hl | 0
	
	  for (var i = 0; i < 32; i += 2) {
	    W[i] = M.readInt32BE(i * 4)
	    W[i + 1] = M.readInt32BE(i * 4 + 4)
	  }
	  for (; i < 160; i += 2) {
	    var xh = W[i - 15 * 2]
	    var xl = W[i - 15 * 2 + 1]
	    var gamma0 = Gamma0(xh, xl)
	    var gamma0l = Gamma0l(xl, xh)
	
	    xh = W[i - 2 * 2]
	    xl = W[i - 2 * 2 + 1]
	    var gamma1 = Gamma1(xh, xl)
	    var gamma1l = Gamma1l(xl, xh)
	
	    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	    var Wi7h = W[i - 7 * 2]
	    var Wi7l = W[i - 7 * 2 + 1]
	
	    var Wi16h = W[i - 16 * 2]
	    var Wi16l = W[i - 16 * 2 + 1]
	
	    var Wil = (gamma0l + Wi7l) | 0
	    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
	    Wil = (Wil + gamma1l) | 0
	    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
	    Wil = (Wil + Wi16l) | 0
	    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0
	
	    W[i] = Wih
	    W[i + 1] = Wil
	  }
	
	  for (var j = 0; j < 160; j += 2) {
	    Wih = W[j]
	    Wil = W[j + 1]
	
	    var majh = maj(ah, bh, ch)
	    var majl = maj(al, bl, cl)
	
	    var sigma0h = sigma0(ah, al)
	    var sigma0l = sigma0(al, ah)
	    var sigma1h = sigma1(eh, el)
	    var sigma1l = sigma1(el, eh)
	
	    // t1 = h + sigma1 + ch + K[j] + W[j]
	    var Kih = K[j]
	    var Kil = K[j + 1]
	
	    var chh = Ch(eh, fh, gh)
	    var chl = Ch(el, fl, gl)
	
	    var t1l = (hl + sigma1l) | 0
	    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
	    t1l = (t1l + chl) | 0
	    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
	    t1l = (t1l + Kil) | 0
	    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
	    t1l = (t1l + Wil) | 0
	    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0
	
	    // t2 = sigma0 + maj
	    var t2l = (sigma0l + majl) | 0
	    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0
	
	    hh = gh
	    hl = gl
	    gh = fh
	    gl = fl
	    fh = eh
	    fl = el
	    el = (dl + t1l) | 0
	    eh = (dh + t1h + getCarry(el, dl)) | 0
	    dh = ch
	    dl = cl
	    ch = bh
	    cl = bl
	    bh = ah
	    bl = al
	    al = (t1l + t2l) | 0
	    ah = (t1h + t2h + getCarry(al, t1l)) | 0
	  }
	
	  this._al = (this._al + al) | 0
	  this._bl = (this._bl + bl) | 0
	  this._cl = (this._cl + cl) | 0
	  this._dl = (this._dl + dl) | 0
	  this._el = (this._el + el) | 0
	  this._fl = (this._fl + fl) | 0
	  this._gl = (this._gl + gl) | 0
	  this._hl = (this._hl + hl) | 0
	
	  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
	  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
	  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
	  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
	  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
	  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
	  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
	  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
	}
	
	Sha512.prototype._hash = function () {
	  var H = Buffer.allocUnsafe(64)
	
	  function writeInt64BE (h, l, offset) {
	    H.writeInt32BE(h, offset)
	    H.writeInt32BE(l, offset + 4)
	  }
	
	  writeInt64BE(this._ah, this._al, 0)
	  writeInt64BE(this._bh, this._bl, 8)
	  writeInt64BE(this._ch, this._cl, 16)
	  writeInt64BE(this._dh, this._dl, 24)
	  writeInt64BE(this._eh, this._el, 32)
	  writeInt64BE(this._fh, this._fl, 40)
	  writeInt64BE(this._gh, this._gl, 48)
	  writeInt64BE(this._hh, this._hl, 56)
	
	  return H
	}
	
	module.exports = Sha512


/***/ },
/* 310 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	var isHexPrefixed = __webpack_require__(234);
	
	/**
	 * Removes '0x' from a given `String` is present
	 * @param {String} str the string value
	 * @return {String|Optional} a string by pass if necessary
	 */
	module.exports = function stripHexPrefix(str) {
	  if (typeof str !== 'string') {
	    return str;
	  }
	
	  return isHexPrefixed(str) ? str.slice(2) : str;
	}


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(733);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(65)(module)))

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(724);
	// On some exotic environments, it's not clear which object `setimmeidate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 This file is part of web3.js.
	
	 web3.js is free software: you can redistribute it and/or modify
	 it under the terms of the GNU Lesser General Public License as published by
	 the Free Software Foundation, either version 3 of the License, or
	 (at your option) any later version.
	
	 web3.js is distributed in the hope that it will be useful,
	 but WITHOUT ANY WARRANTY; without even the implied warranty of
	 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	 GNU Lesser General Public License for more details.
	
	 You should have received a copy of the GNU Lesser General Public License
	 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	 */
	/**
	 * @file index.js
	 * @author Fabian Vogelsteller <fabian@ethereum.org>
	 * @date 2016
	 */
	
	"use strict";
	
	var EventEmitter = __webpack_require__(746);
	var Promise = __webpack_require__(173);
	
	/**
	 * This function generates a defer promise and adds eventEmitter functionality to it
	 *
	 * @method eventifiedPromise
	 */
	var PromiEvent = function PromiEvent(justPromise) {
	    var resolve, reject,
	        eventEmitter = new Promise(function() {
	            resolve = arguments[0];
	            reject = arguments[1];
	        });
	
	    if(justPromise) {
	        return {
	            resolve: resolve,
	            reject: reject,
	            eventEmitter: eventEmitter
	        };
	    }
	
	    // get eventEmitter
	    var emitter = new EventEmitter();
	
	    // add eventEmitter to the promise
	    eventEmitter._events = emitter._events;
	    eventEmitter.emit = emitter.emit;
	    eventEmitter.on = emitter.on;
	    eventEmitter.once = emitter.once;
	    eventEmitter.off = emitter.off;
	    eventEmitter.listeners = emitter.listeners;
	    eventEmitter.addListener = emitter.addListener;
	    eventEmitter.removeListener = emitter.removeListener;
	    eventEmitter.removeAllListeners = emitter.removeAllListeners;
	
	    return {
	        resolve: resolve,
	        reject: reject,
	        eventEmitter: eventEmitter
	    };
	};
	
	PromiEvent.resolve = function(value) {
	    var promise = PromiEvent(true);
	    promise.resolve(value);
	    return promise.eventEmitter;
	};
	
	module.exports = PromiEvent;


/***/ },
/* 315 */
/***/ function(module, exports) {

	/*
	    This file is part of web3.js.
	
	    web3.js is free software: you can redistribute it and/or modify
	    it under the terms of the GNU Lesser General Public License as published by
	    the Free Software Foundation, either version 3 of the License, or
	    (at your option) any later version.
	
	    web3.js is distributed in the hope that it will be useful,
	    but WITHOUT ANY WARRANTY; without even the implied warranty of
	    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	    GNU Lesser General Public License for more details.
	
	    You should have received a copy of the GNU Lesser General Public License
	    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	*/
	/** @file jsonrpc.js
	 * @authors:
	 *   Fabian Vogelsteller <fabian@ethereum.org>
	 *   Marek Kotewicz <marek@ethdev.com>
	 *   Aaron Kumavis <aaron@kumavis.me>
	 * @date 2015
	 */
	
	"use strict";
	
	// Initialize Jsonrpc as a simple object with utility functions.
	var Jsonrpc = {
	    messageId: 0
	};
	
	/**
	 * Should be called to valid json create payload object
	 *
	 * @method toPayload
	 * @param {Function} method of jsonrpc call, required
	 * @param {Array} params, an array of method params, optional
	 * @returns {Object} valid jsonrpc payload object
	 */
	Jsonrpc.toPayload = function (method, params) {
	    if (!method) {
	        throw new Error('JSONRPC method should be specified for params: "'+ JSON.stringify(params) +'"!');
	    }
	
	    // advance message ID
	    Jsonrpc.messageId++;
	
	    return {
	        jsonrpc: '2.0',
	        id: Jsonrpc.messageId,
	        method: method,
	        params: params || []
	    };
	};
	
	/**
	 * Should be called to check if jsonrpc response is valid
	 *
	 * @method isValidResponse
	 * @param {Object}
	 * @returns {Boolean} true if response is valid, otherwise false
	 */
	Jsonrpc.isValidResponse = function (response) {
	    return Array.isArray(response) ? response.every(validateSingleMessage) : validateSingleMessage(response);
	
	    function validateSingleMessage(message){
	      return !!message &&
	        !message.error &&
	        message.jsonrpc === '2.0' &&
	        (typeof message.id === 'number' || typeof message.id === 'string') &&
	        message.result !== undefined; // only undefined is not valid json object
	    }
	};
	
	/**
	 * Should be called to create batch payload object
	 *
	 * @method toBatchPayload
	 * @param {Array} messages, an array of objects with method (required) and params (optional) fields
	 * @returns {Array} batch payload
	 */
	Jsonrpc.toBatchPayload = function (messages) {
	    return messages.map(function (message) {
	        return Jsonrpc.toPayload(message.method, message.params);
	    });
	};
	
	module.exports = Jsonrpc;
	


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 This file is part of web3.js.
	
	 web3.js is free software: you can redistribute it and/or modify
	 it under the terms of the GNU Lesser General Public License as published by
	 the Free Software Foundation, either version 3 of the License, or
	 (at your option) any later version.
	
	 web3.js is distributed in the hope that it will be useful,
	 but WITHOUT ANY WARRANTY; without even the implied warranty of
	 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	 GNU Lesser General Public License for more details.
	
	 You should have received a copy of the GNU Lesser General Public License
	 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	 */
	/**
	 * @file index.js
	 * @author Marek Kotewicz <marek@parity.io>
	 * @author Fabian Vogelsteller <fabian@frozeman.de>
	 * @date 2017
	 */
	
	var _ = __webpack_require__(12);
	var utils = __webpack_require__(23);
	
	var f = __webpack_require__(29);
	
	var SolidityTypeAddress = __webpack_require__(753);
	var SolidityTypeBool = __webpack_require__(754);
	var SolidityTypeInt = __webpack_require__(757);
	var SolidityTypeUInt = __webpack_require__(759);
	var SolidityTypeDynamicBytes = __webpack_require__(756);
	var SolidityTypeString = __webpack_require__(758);
	var SolidityTypeBytes = __webpack_require__(755);
	
	var isDynamic = function (solidityType, type) {
	    return solidityType.isDynamicType(type) ||
	        solidityType.isDynamicArray(type);
	};
	
	
	// result method
	function Result() {}
	
	
	/**
	 * ABICoder prototype should be used to encode/decode solidity params of any type
	 */
	var ABICoder = function (types) {
	    this._types = types;
	};
	
	/**
	 * This method should be used to transform type to SolidityType
	 *
	 * @method _requireType
	 * @param {String} type
	 * @returns {SolidityType}
	 * @throws {Error} throws if no matching type is found
	 */
	ABICoder.prototype._requireType = function (type) {
	    var solidityType = this._types.filter(function (t) {
	        return t.isType(type);
	    })[0];
	
	    if (!solidityType) {
	        throw Error('Invalid solidity type: ' + type);
	    }
	
	    return solidityType;
	};
	
	
	
	ABICoder.prototype._getOffsets = function (types, solidityTypes) {
	    var lengths =  solidityTypes.map(function (solidityType, index) {
	        return solidityType.staticPartLength(types[index]);
	    });
	
	    for (var i = 1; i < lengths.length; i++) {
	        // sum with length of previous element
	        lengths[i] += lengths[i - 1];
	    }
	
	    return lengths.map(function (length, index) {
	        // remove the current length, so the length is sum of previous elements
	        var staticPartLength = solidityTypes[index].staticPartLength(types[index]);
	        return length - staticPartLength;
	    });
	};
	
	ABICoder.prototype._getSolidityTypes = function (types) {
	    var self = this;
	    return types.map(function (type) {
	        return self._requireType(type);
	    });
	};
	
	
	ABICoder.prototype._encodeMultiWithOffset = function (types, solidityTypes, encodeds, dynamicOffset) {
	    var result = "";
	    var self = this;
	
	    types.forEach(function (type, i) {
	        if (isDynamic(solidityTypes[i], types[i])) {
	            result += f.formatInputInt(dynamicOffset).encode();
	            var e = self._encodeWithOffset(types[i], solidityTypes[i], encodeds[i], dynamicOffset);
	            dynamicOffset += e.length / 2;
	        } else {
	            // don't add length to dynamicOffset. it's already counted
	            result += self._encodeWithOffset(types[i], solidityTypes[i], encodeds[i], dynamicOffset);
	        }
	
	        // TODO: figure out nested arrays
	    });
	
	    types.forEach(function (type, i) {
	        if (isDynamic(solidityTypes[i], types[i])) {
	            var e = self._encodeWithOffset(types[i], solidityTypes[i], encodeds[i], dynamicOffset);
	            dynamicOffset += e.length / 2;
	            result += e;
	        }
	    });
	    return result;
	};
	
	// TODO: refactor whole encoding!
	ABICoder.prototype._encodeWithOffset = function (type, solidityType, encoded, offset) {
	    var self = this;
	    if (solidityType.isDynamicArray(type)) {
	        return (function () {
	            // offset was already set
	            var nestedName = solidityType.nestedName(type);
	            var nestedStaticPartLength = solidityType.staticPartLength(nestedName);
	            var result = encoded[0];
	
	            (function () {
	                var previousLength = 2; // in int
	                if (solidityType.isDynamicArray(nestedName)) {
	                    for (var i = 1; i < encoded.length; i++) {
	                        previousLength += +(encoded[i - 1])[0] || 0;
	                        result += f.formatInputInt(offset + i * nestedStaticPartLength + previousLength * 32).encode();
	                    }
	                }
	            })();
	
	            // first element is length, skip it
	            (function () {
	                for (var i = 0; i < encoded.length - 1; i++) {
	                    var additionalOffset = result / 2;
	                    result += self._encodeWithOffset(nestedName, solidityType, encoded[i + 1], offset +  additionalOffset);
	                }
	            })();
	
	            return result;
	        })();
	
	    } else if (solidityType.isStaticArray(type)) {
	        return (function () {
	            var nestedName = solidityType.nestedName(type);
	            var nestedStaticPartLength = solidityType.staticPartLength(nestedName);
	            var result = "";
	
	
	            if (solidityType.isDynamicArray(nestedName)) {
	                (function () {
	                    var previousLength = 0; // in int
	                    for (var i = 0; i < encoded.length; i++) {
	                        // calculate length of previous item
	                        previousLength += +(encoded[i - 1] || [])[0] || 0;
	                        result += f.formatInputInt(offset + i * nestedStaticPartLength + previousLength * 32).encode();
	                    }
	                })();
	            }
	
	            (function () {
	                for (var i = 0; i < encoded.length; i++) {
	                    var additionalOffset = result / 2;
	                    result += self._encodeWithOffset(nestedName, solidityType, encoded[i], offset + additionalOffset);
	                }
	            })();
	
	            return result;
	        })();
	    }
	
	    return encoded;
	};
	
	
	/**
	 * Encodes the function name to its ABI representation, which are the first 4 bytes of the sha3 of the function name including  types.
	 *
	 * @method encodeFunctionSignature
	 * @param {String|Object} functionName
	 * @return {String} encoded function name
	 */
	ABICoder.prototype.encodeFunctionSignature = function (functionName) {
	    if(_.isObject(functionName)) {
	        functionName = utils._jsonInterfaceMethodToString(functionName);
	    }
	
	    return utils.sha3(functionName).slice(0, 10);
	};
	
	
	/**
	 * Encodes the function name to its ABI representation, which are the first 4 bytes of the sha3 of the function name including  types.
	 *
	 * @method encodeEventSignature
	 * @param {String|Object} functionName
	 * @return {String} encoded function name
	 */
	ABICoder.prototype.encodeEventSignature = function (functionName) {
	    if(_.isObject(functionName)) {
	        functionName = utils._jsonInterfaceMethodToString(functionName);
	    }
	
	    return utils.sha3(functionName);
	};
	
	
	/**
	 * Should be used to encode plain param
	 *
	 * @method encodeParameter
	 * @param {String} type
	 * @param {Object} param
	 * @return {String} encoded plain param
	 */
	ABICoder.prototype.encodeParameter = function (type, param) {
	    return this.encodeParameters([type], [param]);
	};
	
	/**
	 * Should be used to encode list of params
	 *
	 * @method encodeParameters
	 * @param {Array} types
	 * @param {Array} params
	 * @return {String} encoded list of params
	 */
	ABICoder.prototype.encodeParameters = function (types, params) {
	    // given a json interface
	    if(_.isObject(types) && types.inputs) {
	        types = _.map(types.inputs, function (input) {
	            return input.type;
	        });
	    }
	
	    var solidityTypes = this._getSolidityTypes(types);
	
	    var encodeds = solidityTypes.map(function (solidityType, index) {
	        return solidityType.encode(params[index], types[index]);
	    });
	
	    var dynamicOffset = solidityTypes.reduce(function (acc, solidityType, index) {
	        var staticPartLength = solidityType.staticPartLength(types[index]);
	        var roundedStaticPartLength = Math.floor((staticPartLength + 31) / 32) * 32;
	
	        return acc + (isDynamic(solidityTypes[index], types[index]) ?
	                32 :
	                roundedStaticPartLength);
	    }, 0);
	
	    return '0x'+ this._encodeMultiWithOffset(types, solidityTypes, encodeds, dynamicOffset);
	};
	
	
	/**
	 * Encodes a function call from its json interface and parameters.
	 *
	 * @method encodeFunctionCall
	 * @param {Array} jsonInterface
	 * @param {Array} params
	 * @return {String} The encoded ABI for this function call
	 */
	ABICoder.prototype.encodeFunctionCall = function (jsonInterface, params) {
	    return this.encodeFunctionSignature(jsonInterface) + this.encodeParameters(jsonInterface, params).replace('0x','');
	};
	
	
	/**
	 * Should be used to decode bytes to plain param
	 *
	 * @method decodeParameter
	 * @param {String} type
	 * @param {String} bytes
	 * @return {Object} plain param
	 */
	ABICoder.prototype.decodeParameter = function (type, bytes) {
	
	    if (!_.isString(type)) {
	        throw new Error('Given parameter type is not a string: '+ type);
	    }
	
	    return this.decodeParameters([{type: type}], bytes)[0];
	};
	
	/**
	 * Should be used to decode list of params
	 *
	 * @method decodeParameter
	 * @param {Array} outputs
	 * @param {String} bytes
	 * @return {Array} array of plain params
	 */
	ABICoder.prototype.decodeParameters = function (outputs, bytes) {
	    var isTypeArray = _.isArray(outputs) && _.isString(outputs[0]);
	    var types = (isTypeArray) ? outputs : [];
	
	    if(!isTypeArray) {
	        outputs.forEach(function (output) {
	            types.push(output.type);
	        });
	    }
	
	    var solidityTypes = this._getSolidityTypes(types);
	    var offsets = this._getOffsets(types, solidityTypes);
	
	    var returnValue = new Result();
	    returnValue.__length__ = 0;
	    var count = 0;
	
	    outputs.forEach(function (output, i) {
	        var decodedValue = solidityTypes[count].decode(bytes.replace(/^0x/i,''), offsets[count],  types[count], count);
	        decodedValue = (decodedValue === '0x') ? null : decodedValue;
	
	        returnValue[i] = decodedValue;
	
	        if (_.isObject(output) && output.name) {
	            returnValue[output.name] = decodedValue;
	        }
	
	        returnValue.__length__++;
	        count++;
	    });
	
	    return returnValue;
	};
	
	/**
	 * Decodes events non- and indexed parameters.
	 *
	 * @method decodeLog
	 * @param {Object} inputs
	 * @param {String} data
	 * * @param {Array} topics
	 * @return {Array} array of plain params
	 */
	ABICoder.prototype.decodeLog = function (inputs, data, topics) {
	
	    data = data || '';
	
	    var notIndexedInputs = [];
	    var indexedInputs = [];
	
	    inputs.forEach(function (input, i) {
	        if (input.indexed) {
	            indexedInputs[i] = input;
	        } else {
	            notIndexedInputs[i] = input;
	        }
	    });
	
	    var nonIndexedData = data.slice(2);
	    var indexedData = _.isArray(topics) ? topics.map(function (topic) { return topic.slice(2); }).join('') : topics;
	
	    var notIndexedParams = this.decodeParameters(notIndexedInputs, nonIndexedData);
	    var indexedParams = this.decodeParameters(indexedInputs, indexedData);
	
	
	    var returnValue = new Result();
	    returnValue.__length__ = 0;
	
	    inputs.forEach(function (res, i) {
	        returnValue[i] = (res.type === 'string') ? '' : null;
	
	        if (notIndexedParams[i]) {
	            returnValue[i] = notIndexedParams[i];
	        }
	        if (indexedParams[i]) {
	            returnValue[i] = indexedParams[i];
	        }
	
	        if(res.name) {
	            returnValue[res.name] = returnValue[i];
	        }
	
	        returnValue.__length__++;
	    });
	
	    return returnValue;
	};
	
	
	var coder = new ABICoder([
	    new SolidityTypeAddress(),
	    new SolidityTypeBool(),
	    new SolidityTypeInt(),
	    new SolidityTypeUInt(),
	    new SolidityTypeDynamicBytes(),
	    new SolidityTypeBytes(),
	    new SolidityTypeString()
	]);
	
	module.exports = coder;


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	/*
	    This file is part of web3.js.
	
	    web3.js is free software: you can redistribute it and/or modify
	    it under the terms of the GNU Lesser General Public License as published by
	    the Free Software Foundation, either version 3 of the License, or
	    (at your option) any later version.
	
	    web3.js is distributed in the hope that it will be useful,
	    but WITHOUT ANY WARRANTY; without even the implied warranty of
	    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	    GNU Lesser General Public License for more details.
	
	    You should have received a copy of the GNU Lesser General Public License
	    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	*/
	/**
	 * @file param.js
	 * @author Marek Kotewicz <marek@parity.io>
	 * @date 2015
	 */
	
	var formatters = __webpack_require__(29);
	
	/**
	 * SolidityParam object prototype.
	 * Should be used when encoding, decoding solidity bytes
	 */
	var SolidityParam = function (value, offset, rawValue) {
	    this.value = value || '';
	    this.offset = offset; // offset in bytes
	    this.rawValue = rawValue; // used for debugging
	};
	
	/**
	 * This method should be used to get length of params's dynamic part
	 *
	 * @method dynamicPartLength
	 * @returns {Number} length of dynamic part (in bytes)
	 */
	SolidityParam.prototype.dynamicPartLength = function () {
	    return this.dynamicPart().length / 2;
	};
	
	/**
	 * This method should be used to create copy of solidity param with different offset
	 *
	 * @method withOffset
	 * @param {Number} offset length in bytes
	 * @returns {SolidityParam} new solidity param with applied offset
	 */
	SolidityParam.prototype.withOffset = function (offset) {
	    return new SolidityParam(this.value, offset);
	};
	
	/**
	 * This method should be used to combine solidity params together
	 * eg. when appending an array
	 *
	 * @method combine
	 * @param {SolidityParam} param with which we should combine
	 * @param {SolidityParam} result of combination
	 */
	SolidityParam.prototype.combine = function (param) {
	    return new SolidityParam(this.value + param.value);
	};
	
	/**
	 * This method should be called to check if param has dynamic size.
	 * If it has, it returns true, otherwise false
	 *
	 * @method isDynamic
	 * @returns {Boolean}
	 */
	SolidityParam.prototype.isDynamic = function () {
	    return this.offset !== undefined;
	};
	
	/**
	 * This method should be called to transform offset to bytes
	 *
	 * @method offsetAsBytes
	 * @returns {String} bytes representation of offset
	 */
	SolidityParam.prototype.offsetAsBytes = function () {
	    return !this.isDynamic() ? '' : formatters.toTwosComplement(this.offset).replace('0x','');
	};
	
	/**
	 * This method should be called to get static part of param
	 *
	 * @method staticPart
	 * @returns {String} offset if it is a dynamic param, otherwise value
	 */
	SolidityParam.prototype.staticPart = function () {
	    if (!this.isDynamic()) {
	        return this.value;
	    }
	    return this.offsetAsBytes();
	};
	
	/**
	 * This method should be called to get dynamic part of param
	 *
	 * @method dynamicPart
	 * @returns {String} returns a value if it is a dynamic param, otherwise empty string
	 */
	SolidityParam.prototype.dynamicPart = function () {
	    return this.isDynamic() ? this.value : '';
	};
	
	/**
	 * This method should be called to encode param
	 *
	 * @method encode
	 * @returns {String}
	 */
	SolidityParam.prototype.encode = function () {
	    return this.staticPart() + this.dynamicPart();
	};
	
	/**
	 * This method should be called to encode array of params
	 *
	 * @method encodeList
	 * @param {Array[SolidityParam]} params
	 * @returns {String}
	 */
	SolidityParam.encodeList = function (params) {
	
	    // updating offsets
	    var totalOffset = params.length * 32;
	    var offsetParams = params.map(function (param) {
	        if (!param.isDynamic()) {
	            return param;
	        }
	        var offset = totalOffset;
	        totalOffset += param.dynamicPartLength();
	        return param.withOffset(offset);
	    });
	
	    // encode everything!
	    return offsetParams.reduce(function (result, param) {
	        return result + param.dynamicPart();
	    }, offsetParams.reduce(function (result, param) {
	        return result + param.staticPart();
	    }, ''));
	};
	
	
	
	module.exports = SolidityParam;
	


/***/ },
/* 318 */
223,
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	var BN = __webpack_require__(7);
	var Bytes = __webpack_require__(172);
	
	var fromBN = function fromBN(bn) {
	  return "0x" + bn.toString("hex");
	};
	
	var toBN = function toBN(str) {
	  return new BN(str.slice(2), 16);
	};
	
	var fromString = function fromString(str) {
	  var bn = "0x" + (str.slice(0, 2) === "0x" ? new BN(str.slice(2), 16) : new BN(str, 10)).toString("hex");
	  return bn === "0x0" ? "0x" : bn;
	};
	
	var toEther = function toEther(wei) {
	  return toNumber(div(wei, fromString("10000000000"))) / 100000000;
	};
	
	var fromEther = function fromEther(eth) {
	  return mul(fromNumber(Math.floor(eth * 100000000)), fromString("10000000000"));
	};
	
	var toString = function toString(a) {
	  return toBN(a).toString(10);
	};
	
	var fromNumber = function fromNumber(a) {
	  return typeof a === "string" ? /^0x/.test(a) ? a : "0x" + a : "0x" + new BN(a).toString("hex");
	};
	
	var toNumber = function toNumber(a) {
	  return toBN(a).toNumber();
	};
	
	var toUint256 = function toUint256(a) {
	  return Bytes.pad(32, a);
	};
	
	var bin = function bin(method) {
	  return function (a, b) {
	    return fromBN(toBN(a)[method](toBN(b)));
	  };
	};
	
	var add = bin("add");
	var mul = bin("mul");
	var div = bin("div");
	var sub = bin("sub");
	
	module.exports = {
	  toString: toString,
	  fromString: fromString,
	  toNumber: toNumber,
	  fromNumber: fromNumber,
	  toEther: toEther,
	  fromEther: fromEther,
	  toUint256: toUint256,
	  add: add,
	  mul: mul,
	  div: div,
	  sub: sub
	};

/***/ },
/* 320 */
/***/ function(module, exports) {

	// The RLP format
	// Serialization and deserialization for the BytesTree type, under the following grammar:
	// | First byte | Meaning                                                                    |
	// | ---------- | -------------------------------------------------------------------------- |
	// | 0   to 127 | HEX(leaf)                                                                  |
	// | 128 to 183 | HEX(length_of_leaf + 128) + HEX(leaf)                                      |
	// | 184 to 191 | HEX(length_of_length_of_leaf + 128 + 55) + HEX(length_of_leaf) + HEX(leaf) |
	// | 192 to 247 | HEX(length_of_node + 192) + HEX(node)                                      |
	// | 248 to 255 | HEX(length_of_length_of_node + 128 + 55) + HEX(length_of_node) + HEX(node) |
	
	var encode = function encode(tree) {
	  var padEven = function padEven(str) {
	    return str.length % 2 === 0 ? str : "0" + str;
	  };
	
	  var uint = function uint(num) {
	    return padEven(num.toString(16));
	  };
	
	  var length = function length(len, add) {
	    return len < 56 ? uint(add + len) : uint(add + uint(len).length / 2 + 55) + uint(len);
	  };
	
	  var dataTree = function dataTree(tree) {
	    if (typeof tree === "string") {
	      var hex = tree.slice(2);
	      var pre = hex.length != 2 || hex >= "80" ? length(hex.length / 2, 128) : "";
	      return pre + hex;
	    } else {
	      var _hex = tree.map(dataTree).join("");
	      var _pre = length(_hex.length / 2, 192);
	      return _pre + _hex;
	    }
	  };
	
	  return "0x" + dataTree(tree);
	};
	
	var decode = function decode(hex) {
	  var i = 2;
	
	  var parseTree = function parseTree() {
	    if (i >= hex.length) throw "";
	    var head = hex.slice(i, i + 2);
	    return head < "80" ? (i += 2, "0x" + head) : head < "c0" ? parseHex() : parseList();
	  };
	
	  var parseLength = function parseLength() {
	    var len = parseInt(hex.slice(i, i += 2), 16) % 64;
	    return len < 56 ? len : parseInt(hex.slice(i, i += (len - 55) * 2), 16);
	  };
	
	  var parseHex = function parseHex() {
	    var len = parseLength();
	    return "0x" + hex.slice(i, i += len * 2);
	  };
	
	  var parseList = function parseList() {
	    var lim = parseLength() * 2 + i;
	    var list = [];
	    while (i < lim) {
	      list.push(parseTree());
	    }return list;
	  };
	
	  try {
	    return parseTree();
	  } catch (e) {
	    return [];
	  }
	};
	
	module.exports = { encode: encode, decode: decode };

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	/*
	    This file is part of web3.js.
	
	    web3.js is free software: you can redistribute it and/or modify
	    it under the terms of the GNU Lesser General Public License as published by
	    the Free Software Foundation, either version 3 of the License, or
	    (at your option) any later version.
	
	    web3.js is distributed in the hope that it will be useful,
	    but WITHOUT ANY WARRANTY; without even the implied warranty of
	    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	    GNU Lesser General Public License for more details.
	
	    You should have received a copy of the GNU Lesser General Public License
	    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	*/
	/**
	 * @file iban.js
	 *
	 * Details: https://github.com/ethereum/wiki/wiki/ICAP:-Inter-exchange-Client-Address-Protocol
	 *
	 * @author Marek Kotewicz <marek@parity.io>
	 * @date 2015
	 */
	
	"use strict";
	
	var utils = __webpack_require__(23);
	var BigNumber = __webpack_require__(7);
	
	
	var leftPad = function (string, bytes) {
	    var result = string;
	    while (result.length < bytes * 2) {
	        result = '0' + result;
	    }
	    return result;
	};
	
	/**
	 * Prepare an IBAN for mod 97 computation by moving the first 4 chars to the end and transforming the letters to
	 * numbers (A = 10, B = 11, ..., Z = 35), as specified in ISO13616.
	 *
	 * @method iso13616Prepare
	 * @param {String} iban the IBAN
	 * @returns {String} the prepared IBAN
	 */
	var iso13616Prepare = function (iban) {
	    var A = 'A'.charCodeAt(0);
	    var Z = 'Z'.charCodeAt(0);
	
	    iban = iban.toUpperCase();
	    iban = iban.substr(4) + iban.substr(0,4);
	
	    return iban.split('').map(function(n){
	        var code = n.charCodeAt(0);
	        if (code >= A && code <= Z){
	            // A = 10, B = 11, ... Z = 35
	            return code - A + 10;
	        } else {
	            return n;
	        }
	    }).join('');
	};
	
	/**
	 * Calculates the MOD 97 10 of the passed IBAN as specified in ISO7064.
	 *
	 * @method mod9710
	 * @param {String} iban
	 * @returns {Number}
	 */
	var mod9710 = function (iban) {
	    var remainder = iban,
	        block;
	
	    while (remainder.length > 2){
	        block = remainder.slice(0, 9);
	        remainder = parseInt(block, 10) % 97 + remainder.slice(block.length);
	    }
	
	    return parseInt(remainder, 10) % 97;
	};
	
	/**
	 * This prototype should be used to create iban object from iban correct string
	 *
	 * @param {String} iban
	 */
	var Iban = function Iban(iban) {
	    this._iban = iban;
	};
	
	/**
	 * This method should be used to create an ethereum address from a direct iban address
	 *
	 * @method toAddress
	 * @param {String} iban address
	 * @return {String} the ethereum address
	 */
	Iban.toAddress = function (ib) {
	    ib = new Iban(ib);
	
	    if(!ib.isDirect()) {
	        throw new Error('IBAN is indirect and can\'t be converted');
	    }
	
	    return ib.toAddress();
	};
	
	/**
	 * This method should be used to create iban address from an ethereum address
	 *
	 * @method toIban
	 * @param {String} address
	 * @return {String} the IBAN address
	 */
	Iban.toIban = function (address) {
	    return Iban.fromAddress(address).toString();
	};
	
	/**
	 * This method should be used to create iban object from an ethereum address
	 *
	 * @method fromAddress
	 * @param {String} address
	 * @return {Iban} the IBAN object
	 */
	Iban.fromAddress = function (address) {
	    if(!utils.isAddress(address)){
	        throw new Error('Provided address is not a valid address: '+ address);
	    }
	
	    address = address.replace('0x','').replace('0X','');
	
	    var asBn = new BigNumber(address, 16);
	    var base36 = asBn.toString(36);
	    var padded = leftPad(base36, 15);
	    return Iban.fromBban(padded.toUpperCase());
	};
	
	/**
	 * Convert the passed BBAN to an IBAN for this country specification.
	 * Please note that <i>"generation of the IBAN shall be the exclusive responsibility of the bank/branch servicing the account"</i>.
	 * This method implements the preferred algorithm described in http://en.wikipedia.org/wiki/International_Bank_Account_Number#Generating_IBAN_check_digits
	 *
	 * @method fromBban
	 * @param {String} bban the BBAN to convert to IBAN
	 * @returns {Iban} the IBAN object
	 */
	Iban.fromBban = function (bban) {
	    var countryCode = 'XE';
	
	    var remainder = mod9710(iso13616Prepare(countryCode + '00' + bban));
	    var checkDigit = ('0' + (98 - remainder)).slice(-2);
	
	    return new Iban(countryCode + checkDigit + bban);
	};
	
	/**
	 * Should be used to create IBAN object for given institution and identifier
	 *
	 * @method createIndirect
	 * @param {Object} options, required options are "institution" and "identifier"
	 * @return {Iban} the IBAN object
	 */
	Iban.createIndirect = function (options) {
	    return Iban.fromBban('ETH' + options.institution + options.identifier);
	};
	
	/**
	 * This method should be used to check if given string is valid iban object
	 *
	 * @method isValid
	 * @param {String} iban string
	 * @return {Boolean} true if it is valid IBAN
	 */
	Iban.isValid = function (iban) {
	    var i = new Iban(iban);
	    return i.isValid();
	};
	
	/**
	 * Should be called to check if iban is correct
	 *
	 * @method isValid
	 * @returns {Boolean} true if it is, otherwise false
	 */
	Iban.prototype.isValid = function () {
	    return /^XE[0-9]{2}(ETH[0-9A-Z]{13}|[0-9A-Z]{30,31})$/.test(this._iban) &&
	        mod9710(iso13616Prepare(this._iban)) === 1;
	};
	
	/**
	 * Should be called to check if iban number is direct
	 *
	 * @method isDirect
	 * @returns {Boolean} true if it is, otherwise false
	 */
	Iban.prototype.isDirect = function () {
	    return this._iban.length === 34 || this._iban.length === 35;
	};
	
	/**
	 * Should be called to check if iban number if indirect
	 *
	 * @method isIndirect
	 * @returns {Boolean} true if it is, otherwise false
	 */
	Iban.prototype.isIndirect = function () {
	    return this._iban.length === 20;
	};
	
	/**
	 * Should be called to get iban checksum
	 * Uses the mod-97-10 checksumming protocol (ISO/IEC 7064:2003)
	 *
	 * @method checksum
	 * @returns {String} checksum
	 */
	Iban.prototype.checksum = function () {
	    return this._iban.substr(2, 2);
	};
	
	/**
	 * Should be called to get institution identifier
	 * eg. XREG
	 *
	 * @method institution
	 * @returns {String} institution identifier
	 */
	Iban.prototype.institution = function () {
	    return this.isIndirect() ? this._iban.substr(7, 4) : '';
	};
	
	/**
	 * Should be called to get client identifier within institution
	 * eg. GAVOFYORK
	 *
	 * @method client
	 * @returns {String} client identifier
	 */
	Iban.prototype.client = function () {
	    return this.isIndirect() ? this._iban.substr(11) : '';
	};
	
	/**
	 * Should be called to get client direct address
	 *
	 * @method toAddress
	 * @returns {String} ethereum address
	 */
	Iban.prototype.toAddress = function () {
	    if (this.isDirect()) {
	        var base36 = this._iban.substr(4);
	        var asBn = new BigNumber(base36, 36);
	        return utils.toChecksumAddress(asBn.toString(16, 20));
	    }
	
	    return '';
	};
	
	Iban.prototype.toString = function () {
	    return this._iban;
	};
	
	module.exports = Iban;


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	/*
	    This file is part of web3.js.
	
	    web3.js is free software: you can redistribute it and/or modify
	    it under the terms of the GNU Lesser General Public License as published by
	    the Free Software Foundation, either version 3 of the License, or
	    (at your option) any later version.
	
	    web3.js is distributed in the hope that it will be useful,
	    but WITHOUT ANY WARRANTY; without even the implied warranty of
	    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	    GNU Lesser General Public License for more details.
	
	    You should have received a copy of the GNU Lesser General Public License
	    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	*/
	/**
	 * @file index.js
	 * @author Fabian Vogelsteller <fabian@ethereum.org>
	 * @date 2017
	 */
	
	"use strict";
	
	var core = __webpack_require__(49);
	var Method = __webpack_require__(48);
	var utils = __webpack_require__(23);
	var Net = __webpack_require__(110);
	
	var formatters = __webpack_require__(14).formatters;
	
	
	var Personal = function Personal() {
	    var _this = this;
	
	    // sets _requestmanager
	    core.packageInit(this, arguments);
	
	    this.net = new Net(this.currentProvider);
	
	    var defaultAccount = null;
	    var defaultBlock = 'latest';
	
	    Object.defineProperty(this, 'defaultAccount', {
	        get: function () {
	            return defaultAccount;
	        },
	        set: function (val) {
	            if(val) {
	                defaultAccount = utils.toChecksumAddress(formatters.inputAddressFormatter(val));
	            }
	
	            // update defaultBlock
	            methods.forEach(function(method) {
	                method.defaultAccount = defaultAccount;
	            });
	
	            return val;
	        },
	        enumerable: true
	    });
	    Object.defineProperty(this, 'defaultBlock', {
	        get: function () {
	            return defaultBlock;
	        },
	        set: function (val) {
	            defaultBlock = val;
	
	            // update defaultBlock
	            methods.forEach(function(method) {
	                method.defaultBlock = defaultBlock;
	            });
	
	            return val;
	        },
	        enumerable: true
	    });
	
	
	    var methods = [
	        new Method({
	            name: 'getAccounts',
	            call: 'personal_listAccounts',
	            params: 0,
	            outputFormatter: utils.toChecksumAddress
	        }),
	        new Method({
	            name: 'newAccount',
	            call: 'personal_newAccount',
	            params: 1,
	            inputFormatter: [null],
	            outputFormatter: utils.toChecksumAddress
	        }),
	        new Method({
	            name: 'unlockAccount',
	            call: 'personal_unlockAccount',
	            params: 3,
	            inputFormatter: [formatters.inputAddressFormatter, null, null]
	        }),
	        new Method({
	            name: 'lockAccount',
	            call: 'personal_lockAccount',
	            params: 1,
	            inputFormatter: [formatters.inputAddressFormatter]
	        }),
	        new Method({
	            name: 'importRawKey',
	            call: 'personal_importRawKey',
	            params: 2
	        }),
	        new Method({
	            name: 'sendTransaction',
	            call: 'personal_sendTransaction',
	            params: 2,
	            inputFormatter: [formatters.inputTransactionFormatter, null]
	        }),
	        new Method({
	            name: 'signTransaction',
	            call: 'personal_signTransaction',
	            params: 2,
	            inputFormatter: [formatters.inputTransactionFormatter, null]
	        }),
	        new Method({
	            name: 'sign',
	            call: 'personal_sign',
	            params: 3,
	            inputFormatter: [formatters.inputSignFormatter, formatters.inputAddressFormatter, null]
	        }),
	        new Method({
	            name: 'ecRecover',
	            call: 'personal_ecRecover',
	            params: 2,
	            inputFormatter: [formatters.inputSignFormatter, null]
	        })
	    ];
	    methods.forEach(function(method) {
	        method.attachToObject(_this);
	        method.setRequestManager(_this._requestManager);
	        method.defaultBlock = _this.defaultBlock;
	        method.defaultAccount = _this.defaultAccount;
	    });
	};
	
	core.addProviders(Personal);
	
	
	
	module.exports = Personal;
	
	


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 This file is part of web3.js.
	
	 web3.js is free software: you can redistribute it and/or modify
	 it under the terms of the GNU Lesser General Public License as published by
	 the Free Software Foundation, either version 3 of the License, or
	 (at your option) any later version.
	
	 web3.js is distributed in the hope that it will be useful,
	 but WITHOUT ANY WARRANTY; without even the implied warranty of
	 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	 GNU Lesser General Public License for more details.
	
	 You should have received a copy of the GNU Lesser General Public License
	 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	 */
	/**
	 * @file utils.js
	 * @author Fabian Vogelsteller <fabian@ethereum.org>
	 * @date 2017
	 */
	
	var _ = __webpack_require__(12);
	var BN = __webpack_require__(7);
	var numberToBN = __webpack_require__(249);
	var utf8 = __webpack_require__(773);
	var Hash = __webpack_require__(223);
	
	
	/**
	 * Returns true if object is BN, otherwise false
	 *
	 * @method isBN
	 * @param {Object} object
	 * @return {Boolean}
	 */
	var isBN = function (object) {
	    return object instanceof BN ||
	        (object && object.constructor && object.constructor.name === 'BN');
	};
	
	/**
	 * Returns true if object is BigNumber, otherwise false
	 *
	 * @method isBigNumber
	 * @param {Object} object
	 * @return {Boolean}
	 */
	var isBigNumber = function (object) {
	    return object && object.constructor && object.constructor.name === 'BigNumber';
	};
	
	/**
	 * Takes an input and transforms it into an BN
	 *
	 * @method toBN
	 * @param {Number|String|BN} number, string, HEX string or BN
	 * @return {BN} BN
	 */
	var toBN = function(number){
	    try {
	        return numberToBN.apply(null, arguments);
	    } catch(e) {
	        throw new Error(e + ' Given value: "'+ number +'"');
	    }
	};
	
	
	/**
	 * Takes and input transforms it into BN and if it is negative value, into two's complement
	 *
	 * @method toTwosComplement
	 * @param {Number|String|BN} number
	 * @return {String}
	 */
	var toTwosComplement = function (number) {
	    return '0x'+ toBN(number).toTwos(256).toString(16, 64);
	};
	
	/**
	 * Checks if the given string is an address
	 *
	 * @method isAddress
	 * @param {String} address the given HEX address
	 * @return {Boolean}
	 */
	var isAddress = function (address) {
	    // check if it has the basic requirements of an address
	    if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) {
	        return false;
	        // If it's ALL lowercase or ALL upppercase
	    } else if (/^(0x|0X)?[0-9a-f]{40}$/.test(address) || /^(0x|0X)?[0-9A-F]{40}$/.test(address)) {
	        return true;
	        // Otherwise check each case
	    } else {
	        return checkAddressChecksum(address);
	    }
	};
	
	
	
	/**
	 * Checks if the given string is a checksummed address
	 *
	 * @method checkAddressChecksum
	 * @param {String} address the given HEX address
	 * @return {Boolean}
	 */
	var checkAddressChecksum = function (address) {
	    // Check each case
	    address = address.replace(/^0x/i,'');
	    var addressHash = sha3(address.toLowerCase()).replace(/^0x/i,'');
	
	    for (var i = 0; i < 40; i++ ) {
	        // the nth letter should be uppercase if the nth digit of casemap is 1
	        if ((parseInt(addressHash[i], 16) > 7 && address[i].toUpperCase() !== address[i]) || (parseInt(addressHash[i], 16) <= 7 && address[i].toLowerCase() !== address[i])) {
	            return false;
	        }
	    }
	    return true;
	};
	
	/**
	 * Should be called to pad string to expected length
	 *
	 * @method leftPad
	 * @param {String} string to be padded
	 * @param {Number} chars that result string should have
	 * @param {String} sign, by default 0
	 * @returns {String} right aligned string
	 */
	var leftPad = function (string, chars, sign) {
	    var hasPrefix = /^0x/i.test(string) || typeof string === 'number';
	    string = string.toString(16).replace(/^0x/i,'');
	
	    var padding = (chars - string.length + 1 >= 0) ? chars - string.length + 1 : 0;
	
	    return (hasPrefix ? '0x' : '') + new Array(padding).join(sign ? sign : "0") + string;
	};
	
	/**
	 * Should be called to pad string to expected length
	 *
	 * @method rightPad
	 * @param {String} string to be padded
	 * @param {Number} chars that result string should have
	 * @param {String} sign, by default 0
	 * @returns {String} right aligned string
	 */
	var rightPad = function (string, chars, sign) {
	    var hasPrefix = /^0x/i.test(string) || typeof string === 'number';
	    string = string.toString(16).replace(/^0x/i,'');
	
	    var padding = (chars - string.length + 1 >= 0) ? chars - string.length + 1 : 0;
	
	    return (hasPrefix ? '0x' : '') + string + (new Array(padding).join(sign ? sign : "0"));
	};
	
	
	/**
	 * Should be called to get hex representation (prefixed by 0x) of utf8 string
	 *
	 * @method utf8ToHex
	 * @param {String} str
	 * @returns {String} hex representation of input string
	 */
	var utf8ToHex = function(str) {
	    str = utf8.encode(str);
	    var hex = "";
	
	    // remove \u0000 padding from either side
	    str = str.replace(/^(?:\u0000)*/,'');
	    str = str.split("").reverse().join("");
	    str = str.replace(/^(?:\u0000)*/,'');
	    str = str.split("").reverse().join("");
	
	    for(var i = 0; i < str.length; i++) {
	        var code = str.charCodeAt(i);
	        // if (code !== 0) {
	        var n = code.toString(16);
	        hex += n.length < 2 ? '0' + n : n;
	        // }
	    }
	
	    return "0x" + hex;
	};
	
	/**
	 * Should be called to get utf8 from it's hex representation
	 *
	 * @method hexToUtf8
	 * @param {String} hex
	 * @returns {String} ascii string representation of hex value
	 */
	var hexToUtf8 = function(hex) {
	    if (!isHexStrict(hex))
	        throw new Error('The parameter "'+ hex +'" must be a valid HEX string.');
	
	    var str = "";
	    var code = 0;
	    hex = hex.replace(/^0x/i,'');
	
	    // remove 00 padding from either side
	    hex = hex.replace(/^(?:00)*/,'');
	    hex = hex.split("").reverse().join("");
	    hex = hex.replace(/^(?:00)*/,'');
	    hex = hex.split("").reverse().join("");
	
	    var l = hex.length;
	
	    for (var i=0; i < l; i+=2) {
	        code = parseInt(hex.substr(i, 2), 16);
	        // if (code !== 0) {
	        str += String.fromCharCode(code);
	        // }
	    }
	
	    return utf8.decode(str);
	};
	
	
	/**
	 * Converts value to it's number representation
	 *
	 * @method hexToNumber
	 * @param {String|Number|BN} value
	 * @return {String}
	 */
	var hexToNumber = function (value) {
	    if (!value) {
	        return value;
	    }
	
	    return toBN(value).toNumber();
	};
	
	/**
	 * Converts value to it's decimal representation in string
	 *
	 * @method hexToNumberString
	 * @param {String|Number|BN} value
	 * @return {String}
	 */
	var hexToNumberString = function (value) {
	    if (!value) return value;
	
	    return toBN(value).toString(10);
	};
	
	
	/**
	 * Converts value to it's hex representation
	 *
	 * @method numberToHex
	 * @param {String|Number|BN} value
	 * @return {String}
	 */
	var numberToHex = function (value) {
	    if (_.isNull(value) || _.isUndefined(value)) {
	        return value;
	    }
	
	    if (!isFinite(value) && !isHexStrict(value)) {
	        throw new Error('Given input "'+value+'" is not a number.');
	    }
	
	    var number = toBN(value);
	    var result = number.toString(16);
	
	    return number.lt(new BN(0)) ? '-0x' + result.substr(1) : '0x' + result;
	};
	
	
	/**
	 * Convert a byte array to a hex string
	 *
	 * Note: Implementation from crypto-js
	 *
	 * @method bytesToHex
	 * @param {Array} bytes
	 * @return {String} the hex string
	 */
	var bytesToHex = function(bytes) {
	    for (var hex = [], i = 0; i < bytes.length; i++) {
	        /* jshint ignore:start */
	        hex.push((bytes[i] >>> 4).toString(16));
	        hex.push((bytes[i] & 0xF).toString(16));
	        /* jshint ignore:end */
	    }
	    return '0x'+ hex.join("");
	};
	
	/**
	 * Convert a hex string to a byte array
	 *
	 * Note: Implementation from crypto-js
	 *
	 * @method hexToBytes
	 * @param {string} hex
	 * @return {Array} the byte array
	 */
	var hexToBytes = function(hex) {
	    hex = hex.toString(16);
	
	    if (!isHexStrict(hex)) {
	        throw new Error('Given value "'+ hex +'" is not a valid hex string.');
	    }
	
	    hex = hex.replace(/^0x/i,'');
	
	    for (var bytes = [], c = 0; c < hex.length; c += 2)
	        bytes.push(parseInt(hex.substr(c, 2), 16));
	    return bytes;
	};
	
	/**
	 * Auto converts any given value into it's hex representation.
	 *
	 * And even stringifys objects before.
	 *
	 * @method toHex
	 * @param {String|Number|BN|Object} value
	 * @param {Boolean} returnType
	 * @return {String}
	 */
	var toHex = function (value, returnType) {
	    /*jshint maxcomplexity: false */
	
	    if (isAddress(value)) {
	        return returnType ? 'address' : '0x'+ value.toLowerCase().replace(/^0x/i,'');
	    }
	
	    if (_.isBoolean(value)) {
	        return returnType ? 'bool' : value ? '0x01' : '0x00';
	    }
	
	
	    if (_.isObject(value) && !isBigNumber(value) && !isBN(value)) {
	        return returnType ? 'string' : utf8ToHex(JSON.stringify(value));
	    }
	
	    // if its a negative number, pass it through numberToHex
	    if (_.isString(value)) {
	        if (value.indexOf('-0x') === 0 || value.indexOf('-0X') === 0) {
	            return returnType ? 'int256' : numberToHex(value);
	        } else if(value.indexOf('0x') === 0 || value.indexOf('0X') === 0) {
	            return returnType ? 'bytes' : value;
	        } else if (!isFinite(value)) {
	            return returnType ? 'string' : utf8ToHex(value);
	        }
	    }
	
	    return returnType ? (value < 0 ? 'int256' : 'uint256') : numberToHex(value);
	};
	
	
	/**
	 * Check if string is HEX, requires a 0x in front
	 *
	 * @method isHexStrict
	 * @param {String} hex to be checked
	 * @returns {Boolean}
	 */
	var isHexStrict = function (hex) {
	    return ((_.isString(hex) || _.isNumber(hex)) && /^(-)?0x[0-9a-f]*$/i.test(hex));
	};
	
	/**
	 * Check if string is HEX
	 *
	 * @method isHex
	 * @param {String} hex to be checked
	 * @returns {Boolean}
	 */
	var isHex = function (hex) {
	    return ((_.isString(hex) || _.isNumber(hex)) && /^(-0x|0x)?[0-9a-f]*$/i.test(hex));
	};
	
	
	/**
	 * Returns true if given string is a valid Ethereum block header bloom.
	 *
	 * TODO UNDOCUMENTED
	 *
	 * @method isBloom
	 * @param {String} hex encoded bloom filter
	 * @return {Boolean}
	 */
	var isBloom = function (bloom) {
	    if (!/^(0x)?[0-9a-f]{512}$/i.test(bloom)) {
	        return false;
	    } else if (/^(0x)?[0-9a-f]{512}$/.test(bloom) || /^(0x)?[0-9A-F]{512}$/.test(bloom)) {
	        return true;
	    }
	    return false;
	};
	
	/**
	 * Returns true if given string is a valid log topic.
	 *
	 * TODO UNDOCUMENTED
	 *
	 * @method isTopic
	 * @param {String} hex encoded topic
	 * @return {Boolean}
	 */
	var isTopic = function (topic) {
	    if (!/^(0x)?[0-9a-f]{64}$/i.test(topic)) {
	        return false;
	    } else if (/^(0x)?[0-9a-f]{64}$/.test(topic) || /^(0x)?[0-9A-F]{64}$/.test(topic)) {
	        return true;
	    }
	    return false;
	};
	
	
	/**
	 * Hashes values to a sha3 hash using keccak 256
	 *
	 * To hash a HEX string the hex must have 0x in front.
	 *
	 * @method sha3
	 * @return {String} the sha3 string
	 */
	var SHA3_NULL_S = '0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470';
	
	var sha3 = function (value) {
	    if (isHexStrict(value) && /^0x/i.test((value).toString())) {
	        value = hexToBytes(value);
	    }
	
	    var returnValue = Hash.keccak256(value); // jshint ignore:line
	
	    if(returnValue === SHA3_NULL_S) {
	        return null;
	    } else {
	        return returnValue;
	    }
	};
	// expose the under the hood keccak256
	sha3._Hash = Hash;
	
	
	module.exports = {
	    BN: BN,
	    isBN: isBN,
	    isBigNumber: isBigNumber,
	    toBN: toBN,
	    isAddress: isAddress,
	    isBloom: isBloom, // TODO UNDOCUMENTED
	    isTopic: isTopic, // TODO UNDOCUMENTED
	    checkAddressChecksum: checkAddressChecksum,
	    utf8ToHex: utf8ToHex,
	    hexToUtf8: hexToUtf8,
	    hexToNumber: hexToNumber,
	    hexToNumberString: hexToNumberString,
	    numberToHex: numberToHex,
	    toHex: toHex,
	    hexToBytes: hexToBytes,
	    bytesToHex: bytesToHex,
	    isHex: isHex,
	    isHexStrict: isHexStrict,
	    leftPad: leftPad,
	    rightPad: rightPad,
	    toTwosComplement: toTwosComplement,
	    sha3: sha3
	};


/***/ },
/* 324 */
10,
/* 325 */
/***/ function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(593).enable();
	  window.Promise = __webpack_require__(592);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(778);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(583);


/***/ },
/* 327 */
/***/ function(module, exports) {

	"use strict"
	    // global key for user preferred registration
	var REGISTRATION_KEY = '@@any-promise/REGISTRATION',
	    // Prior registration (preferred or detected)
	    registered = null
	
	/**
	 * Registers the given implementation.  An implementation must
	 * be registered prior to any call to `require("any-promise")`,
	 * typically on application load.
	 *
	 * If called with no arguments, will return registration in
	 * following priority:
	 *
	 * For Node.js:
	 *
	 * 1. Previous registration
	 * 2. global.Promise if node.js version >= 0.12
	 * 3. Auto detected promise based on first sucessful require of
	 *    known promise libraries. Note this is a last resort, as the
	 *    loaded library is non-deterministic. node.js >= 0.12 will
	 *    always use global.Promise over this priority list.
	 * 4. Throws error.
	 *
	 * For Browser:
	 *
	 * 1. Previous registration
	 * 2. window.Promise
	 * 3. Throws error.
	 *
	 * Options:
	 *
	 * Promise: Desired Promise constructor
	 * global: Boolean - Should the registration be cached in a global variable to
	 * allow cross dependency/bundle registration?  (default true)
	 */
	module.exports = function(root, loadImplementation){
	  return function register(implementation, opts){
	    implementation = implementation || null
	    opts = opts || {}
	    // global registration unless explicitly  {global: false} in options (default true)
	    var registerGlobal = opts.global !== false;
	
	    // load any previous global registration
	    if(registered === null && registerGlobal){
	      registered = root[REGISTRATION_KEY] || null
	    }
	
	    if(registered !== null
	        && implementation !== null
	        && registered.implementation !== implementation){
	      // Throw error if attempting to redefine implementation
	      throw new Error('any-promise already defined as "'+registered.implementation+
	        '".  You can only register an implementation before the first '+
	        ' call to require("any-promise") and an implementation cannot be changed')
	    }
	
	    if(registered === null){
	      // use provided implementation
	      if(implementation !== null && typeof opts.Promise !== 'undefined'){
	        registered = {
	          Promise: opts.Promise,
	          implementation: implementation
	        }
	      } else {
	        // require implementation if implementation is specified but not provided
	        registered = loadImplementation(implementation)
	      }
	
	      if(registerGlobal){
	        // register preference globally in case multiple installations
	        root[REGISTRATION_KEY] = registered
	      }
	    }
	
	    return registered
	  }
	}


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = __webpack_require__(327)(window, loadImplementation)
	
	/**
	 * Browser specific loadImplementation.  Always uses `window.Promise`
	 *
	 * To register a custom implementation, must register with `Promise` option.
	 */
	function loadImplementation(){
	  if(typeof window.Promise === 'undefined'){
	    throw new Error("any-promise browser requires a polyfill or explicit registration"+
	      " e.g: require('any-promise/register/bluebird')")
	  }
	  return {
	    Promise: window.Promise,
	    implementation: 'window.Promise'
	  }
	}


/***/ },
/* 329 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	var asn1 = __webpack_require__(66);
	var inherits = __webpack_require__(2);
	
	var api = exports;
	
	api.define = function define(name, body) {
	  return new Entity(name, body);
	};
	
	function Entity(name, body) {
	  this.name = name;
	  this.body = body;
	
	  this.decoders = {};
	  this.encoders = {};
	};
	
	Entity.prototype._createNamed = function createNamed(base) {
	  var named;
	  try {
	    named = __webpack_require__(742).runInThisContext(
	      '(function ' + this.name + '(entity) {\n' +
	      '  this._initNamed(entity);\n' +
	      '})'
	    );
	  } catch (e) {
	    named = function (entity) {
	      this._initNamed(entity);
	    };
	  }
	  inherits(named, base);
	  named.prototype._initNamed = function initnamed(entity) {
	    base.call(this, entity);
	  };
	
	  return new named(this);
	};
	
	Entity.prototype._getDecoder = function _getDecoder(enc) {
	  enc = enc || 'der';
	  // Lazily create decoder
	  if (!this.decoders.hasOwnProperty(enc))
	    this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
	  return this.decoders[enc];
	};
	
	Entity.prototype.decode = function decode(data, enc, options) {
	  return this._getDecoder(enc).decode(data, options);
	};
	
	Entity.prototype._getEncoder = function _getEncoder(enc) {
	  enc = enc || 'der';
	  // Lazily create encoder
	  if (!this.encoders.hasOwnProperty(enc))
	    this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
	  return this.encoders[enc];
	};
	
	Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
	  return this._getEncoder(enc).encode(data, reporter);
	};


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	var Reporter = __webpack_require__(67).Reporter;
	var EncoderBuffer = __webpack_require__(67).EncoderBuffer;
	var DecoderBuffer = __webpack_require__(67).DecoderBuffer;
	var assert = __webpack_require__(21);
	
	// Supported tags
	var tags = [
	  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
	  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
	  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
	  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
	];
	
	// Public methods list
	var methods = [
	  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
	  'any', 'contains'
	].concat(tags);
	
	// Overrided methods list
	var overrided = [
	  '_peekTag', '_decodeTag', '_use',
	  '_decodeStr', '_decodeObjid', '_decodeTime',
	  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',
	
	  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
	  '_encodeNull', '_encodeInt', '_encodeBool'
	];
	
	function Node(enc, parent) {
	  var state = {};
	  this._baseState = state;
	
	  state.enc = enc;
	
	  state.parent = parent || null;
	  state.children = null;
	
	  // State
	  state.tag = null;
	  state.args = null;
	  state.reverseArgs = null;
	  state.choice = null;
	  state.optional = false;
	  state.any = false;
	  state.obj = false;
	  state.use = null;
	  state.useDecoder = null;
	  state.key = null;
	  state['default'] = null;
	  state.explicit = null;
	  state.implicit = null;
	  state.contains = null;
	
	  // Should create new instance on each method
	  if (!state.parent) {
	    state.children = [];
	    this._wrap();
	  }
	}
	module.exports = Node;
	
	var stateProps = [
	  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
	  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
	  'implicit', 'contains'
	];
	
	Node.prototype.clone = function clone() {
	  var state = this._baseState;
	  var cstate = {};
	  stateProps.forEach(function(prop) {
	    cstate[prop] = state[prop];
	  });
	  var res = new this.constructor(cstate.parent);
	  res._baseState = cstate;
	  return res;
	};
	
	Node.prototype._wrap = function wrap() {
	  var state = this._baseState;
	  methods.forEach(function(method) {
	    this[method] = function _wrappedMethod() {
	      var clone = new this.constructor(this);
	      state.children.push(clone);
	      return clone[method].apply(clone, arguments);
	    };
	  }, this);
	};
	
	Node.prototype._init = function init(body) {
	  var state = this._baseState;
	
	  assert(state.parent === null);
	  body.call(this);
	
	  // Filter children
	  state.children = state.children.filter(function(child) {
	    return child._baseState.parent === this;
	  }, this);
	  assert.equal(state.children.length, 1, 'Root node can have only one child');
	};
	
	Node.prototype._useArgs = function useArgs(args) {
	  var state = this._baseState;
	
	  // Filter children and args
	  var children = args.filter(function(arg) {
	    return arg instanceof this.constructor;
	  }, this);
	  args = args.filter(function(arg) {
	    return !(arg instanceof this.constructor);
	  }, this);
	
	  if (children.length !== 0) {
	    assert(state.children === null);
	    state.children = children;
	
	    // Replace parent to maintain backward link
	    children.forEach(function(child) {
	      child._baseState.parent = this;
	    }, this);
	  }
	  if (args.length !== 0) {
	    assert(state.args === null);
	    state.args = args;
	    state.reverseArgs = args.map(function(arg) {
	      if (typeof arg !== 'object' || arg.constructor !== Object)
	        return arg;
	
	      var res = {};
	      Object.keys(arg).forEach(function(key) {
	        if (key == (key | 0))
	          key |= 0;
	        var value = arg[key];
	        res[value] = key;
	      });
	      return res;
	    });
	  }
	};
	
	//
	// Overrided methods
	//
	
	overrided.forEach(function(method) {
	  Node.prototype[method] = function _overrided() {
	    var state = this._baseState;
	    throw new Error(method + ' not implemented for encoding: ' + state.enc);
	  };
	});
	
	//
	// Public methods
	//
	
	tags.forEach(function(tag) {
	  Node.prototype[tag] = function _tagMethod() {
	    var state = this._baseState;
	    var args = Array.prototype.slice.call(arguments);
	
	    assert(state.tag === null);
	    state.tag = tag;
	
	    this._useArgs(args);
	
	    return this;
	  };
	});
	
	Node.prototype.use = function use(item) {
	  assert(item);
	  var state = this._baseState;
	
	  assert(state.use === null);
	  state.use = item;
	
	  return this;
	};
	
	Node.prototype.optional = function optional() {
	  var state = this._baseState;
	
	  state.optional = true;
	
	  return this;
	};
	
	Node.prototype.def = function def(val) {
	  var state = this._baseState;
	
	  assert(state['default'] === null);
	  state['default'] = val;
	  state.optional = true;
	
	  return this;
	};
	
	Node.prototype.explicit = function explicit(num) {
	  var state = this._baseState;
	
	  assert(state.explicit === null && state.implicit === null);
	  state.explicit = num;
	
	  return this;
	};
	
	Node.prototype.implicit = function implicit(num) {
	  var state = this._baseState;
	
	  assert(state.explicit === null && state.implicit === null);
	  state.implicit = num;
	
	  return this;
	};
	
	Node.prototype.obj = function obj() {
	  var state = this._baseState;
	  var args = Array.prototype.slice.call(arguments);
	
	  state.obj = true;
	
	  if (args.length !== 0)
	    this._useArgs(args);
	
	  return this;
	};
	
	Node.prototype.key = function key(newKey) {
	  var state = this._baseState;
	
	  assert(state.key === null);
	  state.key = newKey;
	
	  return this;
	};
	
	Node.prototype.any = function any() {
	  var state = this._baseState;
	
	  state.any = true;
	
	  return this;
	};
	
	Node.prototype.choice = function choice(obj) {
	  var state = this._baseState;
	
	  assert(state.choice === null);
	  state.choice = obj;
	  this._useArgs(Object.keys(obj).map(function(key) {
	    return obj[key];
	  }));
	
	  return this;
	};
	
	Node.prototype.contains = function contains(item) {
	  var state = this._baseState;
	
	  assert(state.use === null);
	  state.contains = item;
	
	  return this;
	};
	
	//
	// Decoding
	//
	
	Node.prototype._decode = function decode(input, options) {
	  var state = this._baseState;
	
	  // Decode root node
	  if (state.parent === null)
	    return input.wrapResult(state.children[0]._decode(input, options));
	
	  var result = state['default'];
	  var present = true;
	
	  var prevKey = null;
	  if (state.key !== null)
	    prevKey = input.enterKey(state.key);
	
	  // Check if tag is there
	  if (state.optional) {
	    var tag = null;
	    if (state.explicit !== null)
	      tag = state.explicit;
	    else if (state.implicit !== null)
	      tag = state.implicit;
	    else if (state.tag !== null)
	      tag = state.tag;
	
	    if (tag === null && !state.any) {
	      // Trial and Error
	      var save = input.save();
	      try {
	        if (state.choice === null)
	          this._decodeGeneric(state.tag, input, options);
	        else
	          this._decodeChoice(input, options);
	        present = true;
	      } catch (e) {
	        present = false;
	      }
	      input.restore(save);
	    } else {
	      present = this._peekTag(input, tag, state.any);
	
	      if (input.isError(present))
	        return present;
	    }
	  }
	
	  // Push object on stack
	  var prevObj;
	  if (state.obj && present)
	    prevObj = input.enterObject();
	
	  if (present) {
	    // Unwrap explicit values
	    if (state.explicit !== null) {
	      var explicit = this._decodeTag(input, state.explicit);
	      if (input.isError(explicit))
	        return explicit;
	      input = explicit;
	    }
	
	    var start = input.offset;
	
	    // Unwrap implicit and normal values
	    if (state.use === null && state.choice === null) {
	      if (state.any)
	        var save = input.save();
	      var body = this._decodeTag(
	        input,
	        state.implicit !== null ? state.implicit : state.tag,
	        state.any
	      );
	      if (input.isError(body))
	        return body;
	
	      if (state.any)
	        result = input.raw(save);
	      else
	        input = body;
	    }
	
	    if (options && options.track && state.tag !== null)
	      options.track(input.path(), start, input.length, 'tagged');
	
	    if (options && options.track && state.tag !== null)
	      options.track(input.path(), input.offset, input.length, 'content');
	
	    // Select proper method for tag
	    if (state.any)
	      result = result;
	    else if (state.choice === null)
	      result = this._decodeGeneric(state.tag, input, options);
	    else
	      result = this._decodeChoice(input, options);
	
	    if (input.isError(result))
	      return result;
	
	    // Decode children
	    if (!state.any && state.choice === null && state.children !== null) {
	      state.children.forEach(function decodeChildren(child) {
	        // NOTE: We are ignoring errors here, to let parser continue with other
	        // parts of encoded data
	        child._decode(input, options);
	      });
	    }
	
	    // Decode contained/encoded by schema, only in bit or octet strings
	    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
	      var data = new DecoderBuffer(result);
	      result = this._getUse(state.contains, input._reporterState.obj)
	          ._decode(data, options);
	    }
	  }
	
	  // Pop object
	  if (state.obj && present)
	    result = input.leaveObject(prevObj);
	
	  // Set key
	  if (state.key !== null && (result !== null || present === true))
	    input.leaveKey(prevKey, state.key, result);
	  else if (prevKey !== null)
	    input.exitKey(prevKey);
	
	  return result;
	};
	
	Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
	  var state = this._baseState;
	
	  if (tag === 'seq' || tag === 'set')
	    return null;
	  if (tag === 'seqof' || tag === 'setof')
	    return this._decodeList(input, tag, state.args[0], options);
	  else if (/str$/.test(tag))
	    return this._decodeStr(input, tag, options);
	  else if (tag === 'objid' && state.args)
	    return this._decodeObjid(input, state.args[0], state.args[1], options);
	  else if (tag === 'objid')
	    return this._decodeObjid(input, null, null, options);
	  else if (tag === 'gentime' || tag === 'utctime')
	    return this._decodeTime(input, tag, options);
	  else if (tag === 'null_')
	    return this._decodeNull(input, options);
	  else if (tag === 'bool')
	    return this._decodeBool(input, options);
	  else if (tag === 'objDesc')
	    return this._decodeStr(input, tag, options);
	  else if (tag === 'int' || tag === 'enum')
	    return this._decodeInt(input, state.args && state.args[0], options);
	
	  if (state.use !== null) {
	    return this._getUse(state.use, input._reporterState.obj)
	        ._decode(input, options);
	  } else {
	    return input.error('unknown tag: ' + tag);
	  }
	};
	
	Node.prototype._getUse = function _getUse(entity, obj) {
	
	  var state = this._baseState;
	  // Create altered use decoder if implicit is set
	  state.useDecoder = this._use(entity, obj);
	  assert(state.useDecoder._baseState.parent === null);
	  state.useDecoder = state.useDecoder._baseState.children[0];
	  if (state.implicit !== state.useDecoder._baseState.implicit) {
	    state.useDecoder = state.useDecoder.clone();
	    state.useDecoder._baseState.implicit = state.implicit;
	  }
	  return state.useDecoder;
	};
	
	Node.prototype._decodeChoice = function decodeChoice(input, options) {
	  var state = this._baseState;
	  var result = null;
	  var match = false;
	
	  Object.keys(state.choice).some(function(key) {
	    var save = input.save();
	    var node = state.choice[key];
	    try {
	      var value = node._decode(input, options);
	      if (input.isError(value))
	        return false;
	
	      result = { type: key, value: value };
	      match = true;
	    } catch (e) {
	      input.restore(save);
	      return false;
	    }
	    return true;
	  }, this);
	
	  if (!match)
	    return input.error('Choice not matched');
	
	  return result;
	};
	
	//
	// Encoding
	//
	
	Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
	  return new EncoderBuffer(data, this.reporter);
	};
	
	Node.prototype._encode = function encode(data, reporter, parent) {
	  var state = this._baseState;
	  if (state['default'] !== null && state['default'] === data)
	    return;
	
	  var result = this._encodeValue(data, reporter, parent);
	  if (result === undefined)
	    return;
	
	  if (this._skipDefault(result, reporter, parent))
	    return;
	
	  return result;
	};
	
	Node.prototype._encodeValue = function encode(data, reporter, parent) {
	  var state = this._baseState;
	
	  // Decode root node
	  if (state.parent === null)
	    return state.children[0]._encode(data, reporter || new Reporter());
	
	  var result = null;
	
	  // Set reporter to share it with a child class
	  this.reporter = reporter;
	
	  // Check if data is there
	  if (state.optional && data === undefined) {
	    if (state['default'] !== null)
	      data = state['default']
	    else
	      return;
	  }
	
	  // Encode children first
	  var content = null;
	  var primitive = false;
	  if (state.any) {
	    // Anything that was given is translated to buffer
	    result = this._createEncoderBuffer(data);
	  } else if (state.choice) {
	    result = this._encodeChoice(data, reporter);
	  } else if (state.contains) {
	    content = this._getUse(state.contains, parent)._encode(data, reporter);
	    primitive = true;
	  } else if (state.children) {
	    content = state.children.map(function(child) {
	      if (child._baseState.tag === 'null_')
	        return child._encode(null, reporter, data);
	
	      if (child._baseState.key === null)
	        return reporter.error('Child should have a key');
	      var prevKey = reporter.enterKey(child._baseState.key);
	
	      if (typeof data !== 'object')
	        return reporter.error('Child expected, but input is not object');
	
	      var res = child._encode(data[child._baseState.key], reporter, data);
	      reporter.leaveKey(prevKey);
	
	      return res;
	    }, this).filter(function(child) {
	      return child;
	    });
	    content = this._createEncoderBuffer(content);
	  } else {
	    if (state.tag === 'seqof' || state.tag === 'setof') {
	      // TODO(indutny): this should be thrown on DSL level
	      if (!(state.args && state.args.length === 1))
	        return reporter.error('Too many args for : ' + state.tag);
	
	      if (!Array.isArray(data))
	        return reporter.error('seqof/setof, but data is not Array');
	
	      var child = this.clone();
	      child._baseState.implicit = null;
	      content = this._createEncoderBuffer(data.map(function(item) {
	        var state = this._baseState;
	
	        return this._getUse(state.args[0], data)._encode(item, reporter);
	      }, child));
	    } else if (state.use !== null) {
	      result = this._getUse(state.use, parent)._encode(data, reporter);
	    } else {
	      content = this._encodePrimitive(state.tag, data);
	      primitive = true;
	    }
	  }
	
	  // Encode data itself
	  var result;
	  if (!state.any && state.choice === null) {
	    var tag = state.implicit !== null ? state.implicit : state.tag;
	    var cls = state.implicit === null ? 'universal' : 'context';
	
	    if (tag === null) {
	      if (state.use === null)
	        reporter.error('Tag could be omitted only for .use()');
	    } else {
	      if (state.use === null)
	        result = this._encodeComposite(tag, primitive, cls, content);
	    }
	  }
	
	  // Wrap in explicit
	  if (state.explicit !== null)
	    result = this._encodeComposite(state.explicit, false, 'context', result);
	
	  return result;
	};
	
	Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
	  var state = this._baseState;
	
	  var node = state.choice[data.type];
	  if (!node) {
	    assert(
	        false,
	        data.type + ' not found in ' +
	            JSON.stringify(Object.keys(state.choice)));
	  }
	  return node._encode(data.value, reporter);
	};
	
	Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
	  var state = this._baseState;
	
	  if (/str$/.test(tag))
	    return this._encodeStr(data, tag);
	  else if (tag === 'objid' && state.args)
	    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
	  else if (tag === 'objid')
	    return this._encodeObjid(data, null, null);
	  else if (tag === 'gentime' || tag === 'utctime')
	    return this._encodeTime(data, tag);
	  else if (tag === 'null_')
	    return this._encodeNull();
	  else if (tag === 'int' || tag === 'enum')
	    return this._encodeInt(data, state.args && state.reverseArgs[0]);
	  else if (tag === 'bool')
	    return this._encodeBool(data);
	  else if (tag === 'objDesc')
	    return this._encodeStr(data, tag);
	  else
	    throw new Error('Unsupported tag: ' + tag);
	};
	
	Node.prototype._isNumstr = function isNumstr(str) {
	  return /^[0-9 ]*$/.test(str);
	};
	
	Node.prototype._isPrintstr = function isPrintstr(str) {
	  return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
	};


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(2);
	
	function Reporter(options) {
	  this._reporterState = {
	    obj: null,
	    path: [],
	    options: options || {},
	    errors: []
	  };
	}
	exports.Reporter = Reporter;
	
	Reporter.prototype.isError = function isError(obj) {
	  return obj instanceof ReporterError;
	};
	
	Reporter.prototype.save = function save() {
	  var state = this._reporterState;
	
	  return { obj: state.obj, pathLen: state.path.length };
	};
	
	Reporter.prototype.restore = function restore(data) {
	  var state = this._reporterState;
	
	  state.obj = data.obj;
	  state.path = state.path.slice(0, data.pathLen);
	};
	
	Reporter.prototype.enterKey = function enterKey(key) {
	  return this._reporterState.path.push(key);
	};
	
	Reporter.prototype.exitKey = function exitKey(index) {
	  var state = this._reporterState;
	
	  state.path = state.path.slice(0, index - 1);
	};
	
	Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
	  var state = this._reporterState;
	
	  this.exitKey(index);
	  if (state.obj !== null)
	    state.obj[key] = value;
	};
	
	Reporter.prototype.path = function path() {
	  return this._reporterState.path.join('/');
	};
	
	Reporter.prototype.enterObject = function enterObject() {
	  var state = this._reporterState;
	
	  var prev = state.obj;
	  state.obj = {};
	  return prev;
	};
	
	Reporter.prototype.leaveObject = function leaveObject(prev) {
	  var state = this._reporterState;
	
	  var now = state.obj;
	  state.obj = prev;
	  return now;
	};
	
	Reporter.prototype.error = function error(msg) {
	  var err;
	  var state = this._reporterState;
	
	  var inherited = msg instanceof ReporterError;
	  if (inherited) {
	    err = msg;
	  } else {
	    err = new ReporterError(state.path.map(function(elem) {
	      return '[' + JSON.stringify(elem) + ']';
	    }).join(''), msg.message || msg, msg.stack);
	  }
	
	  if (!state.options.partial)
	    throw err;
	
	  if (!inherited)
	    state.errors.push(err);
	
	  return err;
	};
	
	Reporter.prototype.wrapResult = function wrapResult(result) {
	  var state = this._reporterState;
	  if (!state.options.partial)
	    return result;
	
	  return {
	    result: this.isError(result) ? null : result,
	    errors: state.errors
	  };
	};
	
	function ReporterError(path, msg) {
	  this.path = path;
	  this.rethrow(msg);
	};
	inherits(ReporterError, Error);
	
	ReporterError.prototype.rethrow = function rethrow(msg) {
	  this.message = msg + ' at: ' + (this.path || '(shallow)');
	  if (Error.captureStackTrace)
	    Error.captureStackTrace(this, ReporterError);
	
	  if (!this.stack) {
	    try {
	      // IE only adds stack when thrown
	      throw new Error(this.message);
	    } catch (e) {
	      this.stack = e.stack;
	    }
	  }
	  return this;
	};


/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	var constants = __webpack_require__(175);
	
	exports.tagClass = {
	  0: 'universal',
	  1: 'application',
	  2: 'context',
	  3: 'private'
	};
	exports.tagClassByName = constants._reverse(exports.tagClass);
	
	exports.tag = {
	  0x00: 'end',
	  0x01: 'bool',
	  0x02: 'int',
	  0x03: 'bitstr',
	  0x04: 'octstr',
	  0x05: 'null_',
	  0x06: 'objid',
	  0x07: 'objDesc',
	  0x08: 'external',
	  0x09: 'real',
	  0x0a: 'enum',
	  0x0b: 'embed',
	  0x0c: 'utf8str',
	  0x0d: 'relativeOid',
	  0x10: 'seq',
	  0x11: 'set',
	  0x12: 'numstr',
	  0x13: 'printstr',
	  0x14: 't61str',
	  0x15: 'videostr',
	  0x16: 'ia5str',
	  0x17: 'utctime',
	  0x18: 'gentime',
	  0x19: 'graphstr',
	  0x1a: 'iso646str',
	  0x1b: 'genstr',
	  0x1c: 'unistr',
	  0x1d: 'charstr',
	  0x1e: 'bmpstr'
	};
	exports.tagByName = constants._reverse(exports.tag);


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	var decoders = exports;
	
	decoders.der = __webpack_require__(176);
	decoders.pem = __webpack_require__(335);


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(2);
	var Buffer = __webpack_require__(1).Buffer;
	
	var DERDecoder = __webpack_require__(176);
	
	function PEMDecoder(entity) {
	  DERDecoder.call(this, entity);
	  this.enc = 'pem';
	};
	inherits(PEMDecoder, DERDecoder);
	module.exports = PEMDecoder;
	
	PEMDecoder.prototype.decode = function decode(data, options) {
	  var lines = data.toString().split(/[\r\n]+/g);
	
	  var label = options.label.toUpperCase();
	
	  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
	  var start = -1;
	  var end = -1;
	  for (var i = 0; i < lines.length; i++) {
	    var match = lines[i].match(re);
	    if (match === null)
	      continue;
	
	    if (match[2] !== label)
	      continue;
	
	    if (start === -1) {
	      if (match[1] !== 'BEGIN')
	        break;
	      start = i;
	    } else {
	      if (match[1] !== 'END')
	        break;
	      end = i;
	      break;
	    }
	  }
	  if (start === -1 || end === -1)
	    throw new Error('PEM section not found for: ' + label);
	
	  var base64 = lines.slice(start + 1, end).join('');
	  // Remove excessive symbols
	  base64.replace(/[^a-z0-9\+\/=]+/gi, '');
	
	  var input = new Buffer(base64, 'base64');
	  return DERDecoder.prototype.decode.call(this, input, options);
	};


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	var encoders = exports;
	
	encoders.der = __webpack_require__(177);
	encoders.pem = __webpack_require__(337);


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(2);
	
	var DEREncoder = __webpack_require__(177);
	
	function PEMEncoder(entity) {
	  DEREncoder.call(this, entity);
	  this.enc = 'pem';
	};
	inherits(PEMEncoder, DEREncoder);
	module.exports = PEMEncoder;
	
	PEMEncoder.prototype.encode = function encode(data, options) {
	  var buf = DEREncoder.prototype.encode.call(this, data);
	
	  var p = buf.toString('base64');
	  var out = [ '-----BEGIN ' + options.label + '-----' ];
	  for (var i = 0; i < p.length; i += 64)
	    out.push(p.slice(i, i + 64));
	  out.push('-----END ' + options.label + '-----');
	  return out.join('\n');
	};


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(339);


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var EventEmitter = __webpack_require__(93).EventEmitter,
	    util = __webpack_require__(108),
	    eachSeries = __webpack_require__(342),
	    AsyncEventEmitter;
	
	
	module.exports = exports = AsyncEventEmitter = function AsyncEventEmitter () {
	  EventEmitter.call(this);
	};
	
	util.inherits(AsyncEventEmitter, EventEmitter);
	
	
	/* Public methods
	============================================================================= */
	
	AsyncEventEmitter.prototype.emit = function(event, data, callback) {
	  var self = this,
	      listeners = self._events[event] || [];
	
	  // Optional data argument
	  if(!callback && typeof data === 'function') {
	    callback = data;
	    data = undefined;
	  }
	
	  // Special treatment of internal newListener and removeListener events
	  if(event === 'newListener' || event === 'removeListener') {
	    data = {
	      event: data,
	      fn: callback
	    };
	
	    callback = undefined;
	  }
	
	  // A single listener is just a function not an array...
	  listeners = Array.isArray(listeners) ? listeners : [listeners];
	
	  eachSeries(listeners.slice(), function (fn, next) {
	    var err;
	
	    // Support synchronous functions
	    if(fn.length < 2) {
	      try {
	        fn.call(self, data);
	      }
	      catch (e) {
	        err = e;
	      }
	
	      return next(err);
	    }
	
	    // Async
	    fn.call(self, data, next);
	  }, callback);
	
	  return self;
	};
	
	
	AsyncEventEmitter.prototype.once = function (type, listener) {
	  var self = this,
	      g;
	
	  if (typeof listener !== 'function') {
	    throw new TypeError('listener must be a function');
	  }
	
	  // Hack to support set arity
	  if(listener.length >= 2) {
	    g = function (e, next) {
	      self.removeListener(type, g);
	      listener(e, next);
	    };
	  }
	  else {
	    g = function (e) {
	      self.removeListener(type, g);
	      listener(e);
	    };
	  }
	
	  g.listener = listener;
	  self.on(type, g);
	
	  return self;
	};
	
	
	AsyncEventEmitter.prototype.first = function(event, listener) {
	  var listeners = this._events[event] || [];
	
	  // Contract
	  if(typeof listener !== 'function') {
	    throw new TypeError('listener must be a function');
	  }
	
	  // Listeners are not always an array
	  if(!Array.isArray(listeners)) {
	    this._events[event] = listeners = [listeners];
	  }
	
	  listeners.unshift(listener);
	
	  return this;
	};
	
	
	AsyncEventEmitter.prototype.at = function(event, index, listener) {
	  var listeners = this._events[event] || [];
	
	  // Contract
	  if(typeof listener !== 'function') {
	    throw new TypeError('listener must be a function');
	  }
	  if(typeof index !== 'number' || index < 0) {
	    throw new TypeError('index must be a non-negative integer');
	  }
	
	  // Listeners are not always an array
	  if(!Array.isArray(listeners)) {
	    this._events[event] = listeners = [listeners];
	  }
	
	  listeners.splice(index, 0, listener);
	
	  return this;
	};
	
	
	AsyncEventEmitter.prototype.before = function(event, target, listener) {
	  return this._beforeOrAfter(event, target, listener);
	};
	
	
	AsyncEventEmitter.prototype.after = function(event, target, listener) {
	  return this._beforeOrAfter(event, target, listener, 'after');
	};
	
	
	/* Private methods
	============================================================================= */
	
	AsyncEventEmitter.prototype._beforeOrAfter = function(event, target, listener, beforeOrAfter) {
	  var listeners = this._events[event] || [],
	      i, index,
	      add = beforeOrAfter === 'after' ? 1 : 0;
	
	  // Contract
	  if(typeof listener !== 'function') {
	    throw new TypeError('listener must be a function');
	  }
	  if(typeof target !== 'function') {
	    throw new TypeError('target must be a function');
	  }
	
	  // Listeners are not always an array
	  if(!Array.isArray(listeners)) {
	    this._events[event] = listeners = [listeners];
	  }
	
	  index = listeners.length;
	  
	  for(i = listeners.length; i--;) {
	    if(listeners[i] === target) {
	      index = i + add;
	      break;
	    }
	  }
	
	  listeners.splice(index, 0, listener);
	
	  return this;
	};


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = asyncify;
	
	var _isObject = __webpack_require__(245);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _initialParams = __webpack_require__(347);
	
	var _initialParams2 = _interopRequireDefault(_initialParams);
	
	var _setImmediate = __webpack_require__(351);
	
	var _setImmediate2 = _interopRequireDefault(_setImmediate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Take a sync function and make it async, passing its return value to a
	 * callback. This is useful for plugging sync functions into a waterfall,
	 * series, or other async functions. Any arguments passed to the generated
	 * function will be passed to the wrapped function (except for the final
	 * callback argument). Errors thrown will be passed to the callback.
	 *
	 * If the function passed to `asyncify` returns a Promise, that promises's
	 * resolved/rejected state will be used to call the callback, rather than simply
	 * the synchronous return value.
	 *
	 * This also means you can asyncify ES2017 `async` functions.
	 *
	 * @name asyncify
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @alias wrapSync
	 * @category Util
	 * @param {Function} func - The synchronous function, or Promise-returning
	 * function to convert to an {@link AsyncFunction}.
	 * @returns {AsyncFunction} An asynchronous wrapper of the `func`. To be
	 * invoked with `(args..., callback)`.
	 * @example
	 *
	 * // passing a regular synchronous function
	 * async.waterfall([
	 *     async.apply(fs.readFile, filename, "utf8"),
	 *     async.asyncify(JSON.parse),
	 *     function (data, next) {
	 *         // data is the result of parsing the text.
	 *         // If there was a parsing error, it would have been caught.
	 *     }
	 * ], callback);
	 *
	 * // passing a function returning a promise
	 * async.waterfall([
	 *     async.apply(fs.readFile, filename, "utf8"),
	 *     async.asyncify(function (contents) {
	 *         return db.model.create(contents);
	 *     }),
	 *     function (model, next) {
	 *         // `model` is the instantiated model object.
	 *         // If there was an error, this function would be skipped.
	 *     }
	 * ], callback);
	 *
	 * // es2017 example, though `asyncify` is not needed if your JS environment
	 * // supports async functions out of the box
	 * var q = async.queue(async.asyncify(async function(file) {
	 *     var intermediateStep = await processFile(file);
	 *     return await somePromise(intermediateStep)
	 * }));
	 *
	 * q.push(files);
	 */
	function asyncify(func) {
	    return (0, _initialParams2.default)(function (args, callback) {
	        var result;
	        try {
	            result = func.apply(this, args);
	        } catch (e) {
	            return callback(e);
	        }
	        // if result is Promise object
	        if ((0, _isObject2.default)(result) && typeof result.then === 'function') {
	            result.then(function (value) {
	                invokeCallback(callback, null, value);
	            }, function (err) {
	                invokeCallback(callback, err.message ? err : new Error(err));
	            });
	        } else {
	            callback(null, result);
	        }
	    });
	}
	
	function invokeCallback(callback, error, value) {
	    try {
	        callback(error, value);
	    } catch (e) {
	        (0, _setImmediate2.default)(rethrow, e);
	    }
	}
	
	function rethrow(error) {
	    throw error;
	}
	module.exports = exports['default'];

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachLimit;
	
	var _eachOfLimit = __webpack_require__(345);
	
	var _eachOfLimit2 = _interopRequireDefault(_eachOfLimit);
	
	var _withoutIndex = __webpack_require__(352);
	
	var _withoutIndex2 = _interopRequireDefault(_withoutIndex);
	
	var _wrapAsync = __webpack_require__(353);
	
	var _wrapAsync2 = _interopRequireDefault(_wrapAsync);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The same as [`each`]{@link module:Collections.each} but runs a maximum of `limit` async operations at a time.
	 *
	 * @name eachLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.each]{@link module:Collections.each}
	 * @alias forEachLimit
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {AsyncFunction} iteratee - An async function to apply to each item in
	 * `coll`.
	 * The array index is not passed to the iteratee.
	 * If you need the index, use `eachOfLimit`.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called when all
	 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
	 */
	function eachLimit(coll, limit, iteratee, callback) {
	  (0, _eachOfLimit2.default)(limit)(coll, (0, _withoutIndex2.default)((0, _wrapAsync2.default)(iteratee)), callback);
	}
	module.exports = exports['default'];

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eachLimit = __webpack_require__(341);
	
	var _eachLimit2 = _interopRequireDefault(_eachLimit);
	
	var _doLimit = __webpack_require__(344);
	
	var _doLimit2 = _interopRequireDefault(_doLimit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The same as [`each`]{@link module:Collections.each} but runs only a single async operation at a time.
	 *
	 * @name eachSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.each]{@link module:Collections.each}
	 * @alias forEachSeries
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {AsyncFunction} iteratee - An async function to apply to each
	 * item in `coll`.
	 * The array index is not passed to the iteratee.
	 * If you need the index, use `eachOfSeries`.
	 * Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called when all
	 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
	 */
	exports.default = (0, _doLimit2.default)(_eachLimit2.default, 1);
	module.exports = exports['default'];

/***/ },
/* 343 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// A temporary value used to identify if the loop should be broken.
	// See #1064, #1293
	exports.default = {};
	module.exports = exports["default"];

/***/ },
/* 344 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = doLimit;
	function doLimit(fn, limit) {
	    return function (iterable, iteratee, callback) {
	        return fn(iterable, limit, iteratee, callback);
	    };
	}
	module.exports = exports["default"];

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = _eachOfLimit;
	
	var _noop = __webpack_require__(579);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _once = __webpack_require__(349);
	
	var _once2 = _interopRequireDefault(_once);
	
	var _iterator = __webpack_require__(348);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _onlyOnce = __webpack_require__(350);
	
	var _onlyOnce2 = _interopRequireDefault(_onlyOnce);
	
	var _breakLoop = __webpack_require__(343);
	
	var _breakLoop2 = _interopRequireDefault(_breakLoop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _eachOfLimit(limit) {
	    return function (obj, iteratee, callback) {
	        callback = (0, _once2.default)(callback || _noop2.default);
	        if (limit <= 0 || !obj) {
	            return callback(null);
	        }
	        var nextElem = (0, _iterator2.default)(obj);
	        var done = false;
	        var running = 0;
	
	        function iterateeCallback(err, value) {
	            running -= 1;
	            if (err) {
	                done = true;
	                callback(err);
	            } else if (value === _breakLoop2.default || done && running <= 0) {
	                done = true;
	                return callback(null);
	            } else {
	                replenish();
	            }
	        }
	
	        function replenish() {
	            while (running < limit && !done) {
	                var elem = nextElem();
	                if (elem === null) {
	                    done = true;
	                    if (running <= 0) {
	                        callback(null);
	                    }
	                    return;
	                }
	                running += 1;
	                iteratee(elem.value, elem.key, (0, _onlyOnce2.default)(iterateeCallback));
	            }
	        }
	
	        replenish();
	    };
	}
	module.exports = exports['default'];

/***/ },
/* 346 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (coll) {
	    return iteratorSymbol && coll[iteratorSymbol] && coll[iteratorSymbol]();
	};
	
	var iteratorSymbol = typeof Symbol === 'function' && Symbol.iterator;
	
	module.exports = exports['default'];

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (fn) {
	    return function () /*...args, callback*/{
	        var args = (0, _slice2.default)(arguments);
	        var callback = args.pop();
	        fn.call(this, args, callback);
	    };
	};
	
	var _slice = __webpack_require__(178);
	
	var _slice2 = _interopRequireDefault(_slice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = iterator;
	
	var _isArrayLike = __webpack_require__(243);
	
	var _isArrayLike2 = _interopRequireDefault(_isArrayLike);
	
	var _getIterator = __webpack_require__(346);
	
	var _getIterator2 = _interopRequireDefault(_getIterator);
	
	var _keys = __webpack_require__(578);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createArrayIterator(coll) {
	    var i = -1;
	    var len = coll.length;
	    return function next() {
	        return ++i < len ? { value: coll[i], key: i } : null;
	    };
	}
	
	function createES2015Iterator(iterator) {
	    var i = -1;
	    return function next() {
	        var item = iterator.next();
	        if (item.done) return null;
	        i++;
	        return { value: item.value, key: i };
	    };
	}
	
	function createObjectIterator(obj) {
	    var okeys = (0, _keys2.default)(obj);
	    var i = -1;
	    var len = okeys.length;
	    return function next() {
	        var key = okeys[++i];
	        return i < len ? { value: obj[key], key: key } : null;
	    };
	}
	
	function iterator(coll) {
	    if ((0, _isArrayLike2.default)(coll)) {
	        return createArrayIterator(coll);
	    }
	
	    var iterator = (0, _getIterator2.default)(coll);
	    return iterator ? createES2015Iterator(iterator) : createObjectIterator(coll);
	}
	module.exports = exports['default'];

/***/ },
/* 349 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = once;
	function once(fn) {
	    return function () {
	        if (fn === null) return;
	        var callFn = fn;
	        fn = null;
	        callFn.apply(this, arguments);
	    };
	}
	module.exports = exports["default"];

/***/ },
/* 350 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = onlyOnce;
	function onlyOnce(fn) {
	    return function () {
	        if (fn === null) throw new Error("Callback was already called.");
	        var callFn = fn;
	        fn = null;
	        callFn.apply(this, arguments);
	    };
	}
	module.exports = exports["default"];

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.hasNextTick = exports.hasSetImmediate = undefined;
	exports.fallback = fallback;
	exports.wrap = wrap;
	
	var _slice = __webpack_require__(178);
	
	var _slice2 = _interopRequireDefault(_slice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasSetImmediate = exports.hasSetImmediate = typeof setImmediate === 'function' && setImmediate;
	var hasNextTick = exports.hasNextTick = typeof process === 'object' && typeof process.nextTick === 'function';
	
	function fallback(fn) {
	    setTimeout(fn, 0);
	}
	
	function wrap(defer) {
	    return function (fn /*, ...args*/) {
	        var args = (0, _slice2.default)(arguments, 1);
	        defer(function () {
	            fn.apply(null, args);
	        });
	    };
	}
	
	var _defer;
	
	if (hasSetImmediate) {
	    _defer = setImmediate;
	} else if (hasNextTick) {
	    _defer = process.nextTick;
	} else {
	    _defer = fallback;
	}
	
	exports.default = wrap(_defer);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(313).setImmediate, __webpack_require__(22)))

/***/ },
/* 352 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = _withoutIndex;
	function _withoutIndex(iteratee) {
	    return function (value, index, callback) {
	        return iteratee(value, callback);
	    };
	}
	module.exports = exports["default"];

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isAsync = undefined;
	
	var _asyncify = __webpack_require__(340);
	
	var _asyncify2 = _interopRequireDefault(_asyncify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var supportsSymbol = typeof Symbol === 'function';
	
	function isAsync(fn) {
	    return supportsSymbol && fn[Symbol.toStringTag] === 'AsyncFunction';
	}
	
	function wrapAsync(asyncFn) {
	    return isAsync(asyncFn) ? (0, _asyncify2.default)(asyncFn) : asyncFn;
	}
	
	exports.default = wrapAsync;
	exports.isAsync = isAsync;

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(510);
	
	__webpack_require__(509);
	
	__webpack_require__(511);
	
	__webpack_require__(508);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'App' },
	        this.props.children
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(512);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArrowControl = function (_Component) {
	  _inherits(ArrowControl, _Component);
	
	  function ArrowControl() {
	    _classCallCheck(this, ArrowControl);
	
	    return _possibleConstructorReturn(this, (ArrowControl.__proto__ || Object.getPrototypeOf(ArrowControl)).apply(this, arguments));
	  }
	
	  _createClass(ArrowControl, [{
	    key: 'shorten',
	    value: function shorten(x, y, w, h, amount, shortenX, shortenY, shortenW, shortenH) {
	      var length = Math.sqrt(w * w + h * h);
	      var amountW = Math.max(Math.floor(amount * w / length), 0);
	      var amountH = Math.max(Math.floor(amount * h / length), 0);
	      var xPrime = x + (shortenX ? amountW : 0);
	      var yPrime = y + (shortenY ? amountH : 0);
	
	      var factorW = 0;
	      var factorH = 0;
	      if (shortenX) {
	        factorW++;
	      }
	      if (shortenW) {
	        factorW++;
	      }
	      if (shortenY) {
	        factorH++;
	      }
	      if (shortenH) {
	        factorH++;
	      }
	
	      var wPrime = Math.max(w - amountW * factorW, 2);
	      var hPrime = Math.max(h - amountH * factorH, 2);
	
	      return { xPrime: xPrime, yPrime: yPrime, wPrime: wPrime, hPrime: hPrime };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var isFriendly = this.props.isFriendly;
	      var shortenDest = this.props.shortenDest;
	      var shortenX = true;
	      var shortenY = true;
	      var shortenW = true;
	      var shortenH = true;
	
	      var x1 = this.props.x1;
	      var y1 = this.props.y1 - 5;
	      var x2 = this.props.x2;
	      var y2 = this.props.y2 - 5;
	
	      var normalOrientation = true;
	      var x = 0;
	      var w = 0;
	      if (x2 > x1) {
	        x = x1;
	        w = Math.max(x2 - x1, 2);
	        shortenW = shortenDest;
	      } else {
	        x = x2;
	        w = Math.max(x1 - x2, 2);
	        normalOrientation = !normalOrientation;
	        shortenX = shortenDest;
	      }
	
	      var y = 0;
	      var h = 0;
	      if (y2 > y1) {
	        y = y1;
	        h = Math.max(y2 - y1, 2);
	        shortenH = shortenDest;
	      } else {
	        y = y2;
	        h = Math.max(y1 - y2, 2);
	        normalOrientation = !normalOrientation;
	        shortenY = shortenDest;
	      }
	
	      var _shorten = this.shorten(x, y, w, h, 43, shortenX, shortenY, shortenW, shortenH),
	          xPrime = _shorten.xPrime,
	          yPrime = _shorten.yPrime,
	          wPrime = _shorten.wPrime,
	          hPrime = _shorten.hPrime;
	
	      var arrowClass = "arrowLineA_enemy";
	      if (isFriendly) {
	        arrowClass = "arrowLineA_friend";
	        if (!normalOrientation) {
	          arrowClass = "arrowLineB_friend";
	        }
	      } else if (!normalOrientation) {
	        arrowClass = "arrowLineB_enemy";
	      }
	
	      return _react2.default.createElement('div', { onClick: this.props.onClick, className: arrowClass, style: { zIndex: 8, position: "absolute", top: yPrime, left: xPrime, width: wPrime, height: hPrime } });
	    }
	  }]);
	
	  return ArrowControl;
	}(_react.Component);
	
	exports.default = ArrowControl;

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CreateGameActions = __webpack_require__(357);
	
	var _MenuActions = __webpack_require__(111);
	
	__webpack_require__(513);
	
	__webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreateGame = function (_Component) {
	    _inherits(CreateGame, _Component);
	
	    function CreateGame(props, context) {
	        _classCallCheck(this, CreateGame);
	
	        // This binding is necessary to make `this` work in the callback
	        var _this = _possibleConstructorReturn(this, (CreateGame.__proto__ || Object.getPrototypeOf(CreateGame)).call(this, props));
	
	        _this.handleInputChange = _this.handleInputChange.bind(_this);
	        _this.increasePlayerCount = _this.increasePlayerCount.bind(_this);
	        _this.reducePlayerCount = _this.reducePlayerCount.bind(_this);
	        _this.startNewGame = _this.startNewGame.bind(_this);
	        _this.openGame = _this.openGame.bind(_this);
	        _this.getAvatarFromTeamId = _this.getAvatarFromTeamId.bind(_this);
	        _this.swapAvatar = _this.swapAvatar.bind(_this);
	        return _this;
	    }
	
	    _createClass(CreateGame, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var eth = this.context.drizzle.web3.eth;
	
	            var _eth$currentProvider$ = eth.currentProvider.publicConfigStore.getState(),
	                _eth$currentProvider$2 = _eth$currentProvider$.selectedAddress,
	                selectedAddress = _eth$currentProvider$2 === undefined ? "" : _eth$currentProvider$2;
	
	            this.props.dispatch((0, _CreateGameActions.updateInput)("player1", selectedAddress));
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {}
	    }, {
	        key: 'handleInputChange',
	        value: function handleInputChange(event) {
	            this.props.dispatch((0, _CreateGameActions.updateInput)(event.target.getAttribute("name"), event.target.value));
	        }
	    }, {
	        key: 'increasePlayerCount',
	        value: function increasePlayerCount(event) {
	            this.props.dispatch((0, _CreateGameActions.increasePlayerCount)());
	        }
	    }, {
	        key: 'reducePlayerCount',
	        value: function reducePlayerCount(event) {
	            this.props.dispatch((0, _CreateGameActions.reducePlayerCount)());
	        }
	    }, {
	        key: 'openGame',
	        value: function openGame(event, gameId) {
	            this.props.dispatch((0, _MenuActions.openGame)(gameId));
	        }
	    }, {
	        key: 'startNewGame',
	        value: function startNewGame(event) {
	            var utils = this.context.drizzle.web3.utils;
	
	            var playerMap = {};
	            var avatarMap = {};
	            var validationMap = {};
	
	            var _props$createGame = this.props.createGame,
	                input = _props$createGame.input,
	                playerCount = _props$createGame.playerCount;
	
	            var validAddresses = true;
	            for (var i = 1; i <= playerCount; i++) {
	                var playerVal = input["player" + i] || "";
	                var avatarId = this.props.createGame.avatar[i];
	
	                if (playerVal === "" || !utils.isAddress(playerVal) || playerMap.hasOwnProperty(playerVal.toLowerCase()) || avatarMap.hasOwnProperty(avatarId)) {
	                    validAddresses = false;
	                    validationMap["player" + i] = false;
	                } else {
	                    playerMap[playerVal.toLowerCase()] = true;
	                    avatarMap[avatarId] = true;
	                    validationMap["player" + i] = true;
	                }
	            }
	
	            if (validAddresses) {
	                this.props.dispatch((0, _CreateGameActions.startNewGame)(this.context.drizzle, playerCount, input, this.props.createGame.avatar));
	            } else {
	                this.props.dispatch((0, _CreateGameActions.updateValidation)(validationMap));
	            }
	        }
	    }, {
	        key: 'getAvatarFromTeamId',
	        value: function getAvatarFromTeamId(teamId) {
	            var AVATAR_STRINGS = ["unicorn", "moose", "eagle", "grizzly", "penguin", "elephant", "panda", "lion", "zebra", "owl", "chicken", "triceratops", "crocodile", "spider", "monkey", "mouse", "dog", "cat", "beaver", "monster", "llama", "pig", "dragon", "owl_guitar", "alien", "dino", "rawr", "penguin_jacket", "snail", "polar_bear", "bird", "bird_red", "horse", "monster_pink", "gnu", "koala", "wolf", "baby", "giraffe", "safari_girl", "bat", "hippo", "shark", "tiger", "kitten", "teddybear", "fish", "kraken", "turtle", "frog", "ninja", "whale", "germ", "pirate_bird", "whale_pink", "ghost"];
	            var avatarId = this.props.createGame.avatar[teamId];
	            return AVATAR_STRINGS[avatarId];
	        }
	    }, {
	        key: 'swapAvatar',
	        value: function swapAvatar(event, i, next) {
	            this.props.dispatch((0, _CreateGameActions.swapAvatar)(i, next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props$createGame2 = this.props.createGame,
	                input = _props$createGame2.input,
	                playerCount = _props$createGame2.playerCount,
	                validationMap = _props$createGame2.validationMap,
	                pendingNewGame = _props$createGame2.pendingNewGame;
	
	
	            var playerAddressInputs = [];
	
	            var _loop = function _loop(i) {
	                var playerVal = input["player" + i] || "";
	                var notValid = validationMap.hasOwnProperty("player" + i) && validationMap["player" + i] === false;
	                playerAddressInputs.push(_react2.default.createElement(
	                    'div',
	                    { key: i },
	                    _react2.default.createElement('input', { disabled: false, autoComplete: 'off', placeholder: "Player " + i, type: 'text', className: "inputBox" + (notValid ? " notValid" : ""), name: "player" + i, value: playerVal, onChange: _this2.handleInputChange }),
	                    _react2.default.createElement(
	                        'table',
	                        { style: { marginTop: 5 } },
	                        _react2.default.createElement(
	                            'tbody',
	                            null,
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    _react2.default.createElement('img', { onClick: function onClick(event) {
	                                            return _this2.swapAvatar(event, i - 1, false);
	                                        }, src: "/leftarrow.png", alt: '', style: { width: 70, height: 70, cursor: "pointer" } })
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { onClick: function onClick(event) {
	                                            return _this2.swapAvatar(event, i - 1, true);
	                                        }, style: { cursor: "pointer", width: 70, height: 70, textAlign: "center", verticalAlign: "middle", background: notValid ? "#fdd" : "" } },
	                                    _react2.default.createElement('img', { src: "/" + _this2.getAvatarFromTeamId(i - 1) + ".png", alt: '', style: { maxWidth: 70, maxHeight: 70 } })
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    _react2.default.createElement('img', { onClick: function onClick(event) {
	                                            return _this2.swapAvatar(event, i - 1, true);
	                                        }, src: "/rightarrow.png", alt: '', style: { width: 70, height: 70, cursor: "pointer" } })
	                                )
	                            )
	                        )
	                    )
	                ));
	            };
	
	            for (var i = 1; i <= playerCount; i++) {
	                _loop(i);
	            }
	
	            var txHash = null;
	            var txStatus = "";
	            var gameId = "";
	            if (pendingNewGame !== null) {
	                var state = this.context.drizzle.store.getState();
	
	                if (state.transactionStack[pendingNewGame]) {
	                    txHash = state.transactionStack[pendingNewGame];
	                    txStatus = state.transactions[txHash].status;
	
	                    if (txStatus === "success") {
	                        var events = state.transactions[txHash].receipt.events;
	                        gameId = events.NewGame.returnValues.gameId;
	                    }
	                }
	            }
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('div', { className: 'menuGap' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inputContainer' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'groupTitle groupMargin' },
	                        'Create a new game'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { marginTop: 5 } },
	                        'Enter Ethereum wallet address and choose avatar for each player.'
	                    ),
	                    txHash === null ? _react2.default.createElement(
	                        'div',
	                        null,
	                        playerAddressInputs,
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn', onClick: this.increasePlayerCount },
	                            '+ Add player'
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn', onClick: this.reducePlayerCount },
	                            '- Remove player'
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn', onClick: this.startNewGame },
	                            'Start new game'
	                        )
	                    ) : _react2.default.createElement(
	                        'div',
	                        { className: 'pendingGameMsg' },
	                        txStatus === "success" ? _react2.default.createElement(
	                            'span',
	                            { className: 'linkSpan', onClick: function onClick(event) {
	                                    return _this2.openGame(event, gameId);
	                                } },
	                            'New game created with id #',
	                            gameId
	                        ) : _react2.default.createElement(
	                            'span',
	                            null,
	                            'Initializing new game ...'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CreateGame;
	}(_react.Component);
	
	CreateGame.contextTypes = {
	    drizzle: _propTypes2.default.object
	};
	
	exports.default = CreateGame;

/***/ },
/* 357 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.increasePlayerCount = increasePlayerCount;
	exports.reducePlayerCount = reducePlayerCount;
	exports.updateInput = updateInput;
	exports.updateValidation = updateValidation;
	exports.swapAvatar = swapAvatar;
	exports.startNewGame = startNewGame;
	function increasePlayerCount() {
	    return function (dispatch) {
	        dispatch({
	            type: 'INCREASE_PLAYER_COUNT'
	        });
	    };
	}
	
	function reducePlayerCount() {
	    return function (dispatch) {
	        dispatch({
	            type: 'REDUCE_PLAYER_COUNT'
	        });
	    };
	}
	
	function updateInput(name, value) {
	    return function (dispatch) {
	        dispatch({
	            type: 'UPDATE_INPUT',
	            payload: { name: name, value: value }
	        });
	    };
	}
	
	function updateValidation(validationMap) {
	    return function (dispatch) {
	        dispatch({
	            type: 'UPDATE_VALIDATION',
	            payload: validationMap
	        });
	    };
	}
	
	function swapAvatar(teamId, next) {
	    return function (dispatch) {
	        dispatch({
	            type: 'SWAP_AVATAR',
	            payload: { teamId: teamId, next: next }
	        });
	    };
	}
	
	function startNewGame(drizzle, playerCount, input, avatarIds) {
	    return function (dispatch) {
	        var _drizzle$web = drizzle.web3,
	            eth = _drizzle$web.eth,
	            utils = _drizzle$web.utils;
	
	        var gameInstance = drizzle.contracts.WorldGame;
	
	        var _eth$currentProvider$ = eth.currentProvider.publicConfigStore.getState(),
	            _eth$currentProvider$2 = _eth$currentProvider$.selectedAddress,
	            selectedAddress = _eth$currentProvider$2 === undefined ? "" : _eth$currentProvider$2;
	
	        var maxBlocksPerTurn = 3000;
	        var playerAddresses = [];
	        for (var i = 1; i <= playerCount; i++) {
	            var address = input["player" + i];
	            playerAddresses.push(address);
	        }
	
	        var avatarList = [];
	        for (var _i = 0; _i < playerCount; _i++) {
	            avatarList.push(String.fromCharCode(48 + avatarIds[_i]));
	        }
	
	        var teamAvatars = utils.asciiToHex(avatarList.join(""));
	
	        var stackId = gameInstance.methods.newGame.cacheSend(playerCount, maxBlocksPerTurn, playerAddresses, teamAvatars, { from: selectedAddress });
	
	        dispatch({
	            type: 'PENDING_NEW_GAME',
	            payload: stackId
	        });
	    };
	}

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CreateGame = __webpack_require__(356);
	
	var _CreateGame2 = _interopRequireDefault(_CreateGame);
	
	var _drizzleReact = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    createGame: state.createGame,
	    accounts: state.accounts,
	    WorldGame: state.contracts.WorldGame,
	    drizzleStatus: state.drizzleStatus,
	    web3: state.web3
	  };
	};
	
	var CreateGameContainer = (0, _drizzleReact.drizzleConnect)(_CreateGame2.default, mapStateToProps);
	exports.default = CreateGameContainer;

/***/ },
/* 359 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	    input: {},
	    playerCount: 2,
	    validationMap: {},
	    pendingNewGame: null,
	    avatar: [0, 1, 2, 3, 4, 5, 6, 7]
	};
	
	var CreateGameReducer = function CreateGameReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	
	    if (action.type === 'INCREASE_PLAYER_COUNT') {
	        var newValue = state.playerCount;
	        if (newValue < 8) {
	            newValue++;
	        }
	
	        return Object.assign({}, state, {
	            playerCount: newValue
	        });
	    }
	
	    if (action.type === 'REDUCE_PLAYER_COUNT') {
	        var _newValue = state.playerCount;
	        if (_newValue > 2) {
	            _newValue--;
	        }
	
	        return Object.assign({}, state, {
	            playerCount: _newValue
	        });
	    }
	
	    if (action.type === 'UPDATE_INPUT') {
	        var _action$payload = action.payload,
	            name = _action$payload.name,
	            value = _action$payload.value;
	
	        var inputObj = state.input;
	
	        var newInputObj = Object.assign({}, inputObj, _defineProperty({}, name, value));
	
	        return Object.assign({}, state, {
	            input: newInputObj
	        });
	    }
	
	    if (action.type === 'UPDATE_VALIDATION') {
	        var _newValue2 = action.payload;
	
	        return Object.assign({}, state, {
	            validationMap: _newValue2
	        });
	    }
	
	    if (action.type === 'PENDING_NEW_GAME') {
	        var _newValue3 = action.payload;
	
	        return Object.assign({}, state, {
	            pendingNewGame: _newValue3
	        });
	    }
	
	    if (action.type === 'SELECT_PAGE') {
	        return Object.assign({}, state, {
	            pendingNewGame: false
	        });
	    }
	
	    if (action.type === 'SWAP_AVATAR') {
	        var AVATAR_COUNT = 56;
	        var _action$payload2 = action.payload,
	            teamId = _action$payload2.teamId,
	            next = _action$payload2.next;
	
	
	        var _newValue4 = state.avatar[teamId];
	        if (next) {
	            _newValue4 = (_newValue4 + 1) % AVATAR_COUNT;
	        } else {
	            _newValue4 = (_newValue4 + AVATAR_COUNT - 1) % AVATAR_COUNT;
	        }
	
	        var newAvatarArray = Object.assign([], [].concat(_toConsumableArray(state.avatar)), _defineProperty({}, teamId, _newValue4));
	        return Object.assign({}, state, {
	            avatar: newAvatarArray
	        });
	    }
	
	    return state;
	};
	
	exports.default = CreateGameReducer;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GameActions = __webpack_require__(180);
	
	var _ArrowControl = __webpack_require__(355);
	
	var _ArrowControl2 = _interopRequireDefault(_ArrowControl);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(514);
	
	__webpack_require__(135);
	
	var _OverlayContainer = __webpack_require__(368);
	
	var _OverlayContainer2 = _interopRequireDefault(_OverlayContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Game = function (_Component) {
	    _inherits(Game, _Component);
	
	    function Game(props, context) {
	        _classCallCheck(this, Game);
	
	        // This binding is necessary to make `this` work in the callback
	        var _this = _possibleConstructorReturn(this, (Game.__proto__ || Object.getPrototypeOf(Game)).call(this, props));
	
	        _this.showOverlay = _this.showOverlay.bind(_this);
	        _this.moveOrAttack = _this.moveOrAttack.bind(_this);
	        _this.endTurn = _this.endTurn.bind(_this);
	        _this.endOpponentsTurn = _this.endOpponentsTurn.bind(_this);
	        _this.cancelTile = _this.cancelTile.bind(_this);
	        _this.outsideClick = _this.outsideClick.bind(_this);
	        _this.hoverTile = _this.hoverTile.bind(_this);
	        _this.cancelHover = _this.cancelHover.bind(_this);
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.getColor = _this.getColor.bind(_this);
	        _this.regionNameToId = _this.regionNameToId.bind(_this);
	        _this.regionIdToName = _this.regionIdToName.bind(_this);
	        _this.regionIdToDisplay = _this.regionIdToDisplay.bind(_this);
	        _this.getTilesFromData = _this.getTilesFromData.bind(_this);
	        _this.forceNextBlock = _this.forceNextBlock.bind(_this);
	        _this.declareWinner = _this.declareWinner.bind(_this);
	
	        _this.regionNames = ["HAWAII", "WESTERN_CANADA", "EASTERN_CANADA", "WESTERN_USA", "EASTERN_USA", "GREENLAND", "NORTHERN_SOUTH_AMERICA", "SOUTHERN_SOUTH_AMERICA", "WEST_ANTARCTICA", "EAST_ANTARCTICA", "WESTERN_EUROPE", "EASTERN_EUROPE", "CENTRAL_RUSSIA", "EASTERN_RUSSIA", "WEST_AFRICA", "MIDDLE_EAST", "EAST_AFRICA", "SOUTH_AFRICA", "INDIA", "EASTERN_CHINA", "SOUTHEAST_ASIA", "WESTERN_AUSTRALIA", "EASTERN_AUSTRALIA", "NEW_ZEALAND", "FIJI"];
	
	        _this.regionDisplay = ["Hawaii", "Western Canada and Alaska", "Eastern Canada", "Western United States and Mexico", "Eastern United States and Caribbean", "Greenland", "Brazil, Peru and the Amazon Basin", "Argentina, Chile and the Southern Cone", "West Antarctica", "East Antarctica", "Western Europe", "Eastern Europe", "Central Russia", "Eastern Russia", "West and Central Africa", "Middle East", "East Africa", "South Africa", "India", "Eastern China", "Southeast Asia", "Western Australia", "Eastern Australia", "New Zealand", "Fiji and the Solomon Islands"];
	        return _this;
	    }
	
	    _createClass(Game, [{
	        key: 'regionNameToId',
	        value: function regionNameToId(name) {
	            for (var i = 0; i < this.regionNames.length; i++) {
	                if (this.regionNames[i] === name) {
	                    return i;
	                }
	            }
	            return 255;
	        }
	    }, {
	        key: 'regionIdToName',
	        value: function regionIdToName(id) {
	            if (id >= 0 && id < this.regionNames.length) {
	                return this.regionNames[id];
	            }
	            return "";
	        }
	    }, {
	        key: 'regionIdToDisplay',
	        value: function regionIdToDisplay(id) {
	            if (id >= 0 && id < this.regionDisplay.length) {
	                return this.regionDisplay[id];
	            }
	            return "";
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.dispatch((0, _GameActions.syncGameData)(this.context.drizzle, this.props.gameId));
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.gameId !== this.props.gameId) {
	                this.props.dispatch((0, _GameActions.syncGameData)(this.context.drizzle, nextProps.gameId));
	            }
	        }
	    }, {
	        key: 'handleChange',
	        value: function handleChange(event) {}
	    }, {
	        key: 'showOverlay',
	        value: function showOverlay(event) {
	            event.preventDefault();
	            var id = event.currentTarget.id;
	            this.props.dispatch((0, _GameActions.showOverlay)(id));
	        }
	    }, {
	        key: 'moveOrAttack',
	        value: function moveOrAttack(event) {
	            event.preventDefault();
	            var toRegionName = event.currentTarget.id;
	            var fromRegionName = this.props.game.selectedTileRegion;
	            var toRegionId = this.regionNameToId(toRegionName);
	            var fromRegionId = this.regionNameToId(fromRegionName);
	            var soldiers = this.props.game.selectedTileSoldiers;
	            var turnNum = this.props.game.selectedTileTurnNum;
	
	            this.props.dispatch((0, _GameActions.moveOrAttack)(this.context.drizzle, this.props.gameId, turnNum, fromRegionId, toRegionId, soldiers));
	        }
	    }, {
	        key: 'endTurn',
	        value: function endTurn(event, turnNum, waitingForActions, waitingForBlock) {
	            var NO_REGION = 255;
	            if (!waitingForActions) {
	                this.props.dispatch((0, _GameActions.deployAndEndTurn)(this.context.drizzle, this.props.gameId, turnNum, NO_REGION, 0));
	            } else {
	                alert("You cannot end turn until block #" + waitingForBlock);
	            }
	        }
	    }, {
	        key: 'endOpponentsTurn',
	        value: function endOpponentsTurn(event, turnNum) {
	            this.props.dispatch((0, _GameActions.endOpponentsTurn)(this.context.drizzle, this.props.gameId, turnNum));
	        }
	    }, {
	        key: 'forceNextBlock',
	        value: function forceNextBlock(event, blockNumber) {
	            event.preventDefault();
	
	            this.props.dispatch((0, _GameActions.cacheBlockHash)(this.context.drizzle, blockNumber));
	        }
	    }, {
	        key: 'declareWinner',
	        value: function declareWinner(event, winnerId) {
	            event.preventDefault();
	
	            this.props.dispatch((0, _GameActions.declareWinner)(this.context.drizzle, this.props.gameId, winnerId));
	        }
	    }, {
	        key: 'cancelTile',
	        value: function cancelTile(event) {
	            event.preventDefault();
	            this.props.dispatch((0, _GameActions.selectTile)(null, null, null));
	        }
	    }, {
	        key: 'outsideClick',
	        value: function outsideClick(event) {
	            this.props.dispatch((0, _GameActions.selectTile)(null, null, null));
	        }
	    }, {
	        key: 'hoverTile',
	        value: function hoverTile(event) {
	            event.preventDefault();
	            var id = event.currentTarget.id;
	            this.props.dispatch((0, _GameActions.hoverTile)(id));
	        }
	    }, {
	        key: 'cancelHover',
	        value: function cancelHover(event) {
	            event.preventDefault();
	            this.props.dispatch((0, _GameActions.hoverTile)(null));
	        }
	    }, {
	        key: 'getColor',
	        value: function getColor(colorIndex) {
	            var redStrength = colorIndex % 4;
	            var blueStrength = Math.floor(colorIndex / 4) % 4;
	            var greenStrength = Math.floor(colorIndex / 3) % 3;
	
	            if (blueStrength > 1 && greenStrength > 0 && redStrength === 0) {
	                redStrength = 2;
	            }
	
	            var red = 85 * redStrength;
	            var blue = 85 * blueStrength;
	            var green = 127 * greenStrength;
	
	            return "rgba(" + red + ", " + blue + ", " + green + ", 0.2)";
	        }
	    }, {
	        key: 'getAvatarFromTeamId',
	        value: function getAvatarFromTeamId(avatarIds, teamId) {
	
	            var AVATAR_STRINGS = ["unicorn", "moose", "eagle", "grizzly", "penguin", "elephant", "panda", "lion", "zebra", "owl", "chicken", "triceratops", "crocodile", "spider", "monkey", "mouse", "dog", "cat", "beaver", "monster", "llama", "pig", "dragon", "owl_guitar", "alien", "dino", "rawr", "penguin_jacket", "snail", "polar_bear", "bird", "bird_red", "horse", "monster_pink", "gnu", "koala", "wolf", "baby", "giraffe", "safari_girl", "bat", "hippo", "shark", "tiger", "kitten", "teddybear", "fish", "kraken", "turtle", "frog", "ninja", "whale", "germ", "pirate_bird", "whale_pink", "ghost"];
	
	            if (avatarIds) {
	                if (teamId < avatarIds.length) {
	                    var charCode = avatarIds.charCodeAt(teamId);
	                    charCode = charCode >= 48 ? charCode - 48 : 0;
	                    if (charCode < AVATAR_STRINGS.length) {
	                        return AVATAR_STRINGS[charCode];
	                    }
	                }
	            }
	
	            if (teamId === 0) {
	                return "unicorn";
	            } else if (teamId === 1) {
	                return "moose";
	            } else if (teamId === 2) {
	                return "eagle";
	            } else if (teamId === 3) {
	                return "grizzly";
	            } else if (teamId === 4) {
	                return "penguin";
	            } else if (teamId === 5) {
	                return "elephant";
	            } else if (teamId === 6) {
	                return "panda";
	            } else if (teamId === 7) {
	                return "lion";
	            }
	
	            return null;
	        }
	    }, {
	        key: 'getTilesFromData',
	        value: function getTilesFromData(regionOwnersList, regionSoldiers, avatarIds) {
	            var colorIndex = 0;
	            var mapTiles = [];
	            var gapTiles = [];
	
	            gapTiles.push({ top: 175, left: 0, width: 205, height: 105 });
	            gapTiles.push({ top: 400, left: 0, width: 375, height: 350 });
	            gapTiles.push({ top: 380, left: 205, width: 170, height: 20 });
	            gapTiles.push({ top: 750, left: 0, width: 255, height: 120 });
	            gapTiles.push({ top: 175, left: 605, width: 160, height: 70 });
	            gapTiles.push({ top: 245, left: 605, width: 110, height: 135 });
	            gapTiles.push({ top: 380, left: 675, width: 40, height: 250 });
	            gapTiles.push({ top: 630, left: 675, width: 630, height: 120 });
	            gapTiles.push({ top: 690, left: 1305, width: 210, height: 60 });
	            gapTiles.push({ top: 490, left: 1115, width: 190, height: 140 });
	            gapTiles.push({ top: 420, left: 1115, width: 110, height: 70 });
	            gapTiles.push({ top: 800, left: 1515, width: 195, height: 70 });
	            gapTiles.push({ top: 175, left: 1515, width: 195, height: 155 });
	
	            mapTiles.push({
	                top: 280, left: 0, width: 205, height: 120,
	                color: this.getColor(colorIndex++),
	                name: "HAWAII",
	                neighbors: { WESTERN_USA: true, FIJI: true },
	                points: 3
	            });
	
	            mapTiles.push({
	                top: 0, left: 0, width: 405, height: 175,
	                color: this.getColor(colorIndex++),
	                name: "WESTERN_CANADA",
	                neighbors: { WESTERN_USA: true, EASTERN_CANADA: true, EASTERN_RUSSIA: true },
	                points: 6
	            });
	
	            mapTiles.push({
	                top: 0, left: 405, width: 200, height: 175,
	                color: this.getColor(colorIndex++),
	                name: "EASTERN_CANADA",
	                neighbors: { WESTERN_CANADA: true, GREENLAND: true, EASTERN_USA: true },
	                points: 5
	            });
	
	            mapTiles.push({
	                top: 175, left: 205, width: 200, height: 205,
	                color: this.getColor(colorIndex++),
	                name: "WESTERN_USA",
	                neighbors: { HAWAII: true, WESTERN_CANADA: true, EASTERN_USA: true, NORTHERN_SOUTH_AMERICA: true },
	                points: 11
	            });
	
	            mapTiles.push({
	                top: 175, left: 405, width: 200, height: 205,
	                color: this.getColor(colorIndex++),
	                name: "EASTERN_USA",
	                neighbors: { WESTERN_USA: true, EASTERN_CANADA: true, NORTHERN_SOUTH_AMERICA: true },
	                points: 8
	            });
	
	            mapTiles.push({
	                top: 0, left: 605, width: 160, height: 175,
	                color: this.getColor(colorIndex++),
	                name: "GREENLAND",
	                neighbors: { EASTERN_CANADA: true, WESTERN_EUROPE: true },
	                points: 3
	            });
	
	            mapTiles.push({
	                top: 380, left: 375, width: 300, height: 180,
	                color: this.getColor(colorIndex++),
	                name: "NORTHERN_SOUTH_AMERICA",
	                neighbors: { WESTERN_USA: true, EASTERN_USA: true, SOUTHERN_SOUTH_AMERICA: true },
	                points: 3
	            });
	
	            mapTiles.push({
	                top: 560, left: 375, width: 300, height: 190,
	                color: this.getColor(colorIndex++),
	                name: "SOUTHERN_SOUTH_AMERICA",
	                neighbors: { NORTHERN_SOUTH_AMERICA: true, WEST_ANTARCTICA: true },
	                points: 4
	            });
	
	            mapTiles.push({
	                top: 750, left: 255, width: 630, height: 120,
	                color: this.getColor(colorIndex++),
	                name: "WEST_ANTARCTICA",
	                neighbors: { SOUTHERN_SOUTH_AMERICA: true, EAST_ANTARCTICA: true },
	                points: 2
	            });
	
	            mapTiles.push({
	                top: 750, left: 885, width: 630, height: 120,
	                color: this.getColor(colorIndex++),
	                name: "EAST_ANTARCTICA",
	                neighbors: { WEST_ANTARCTICA: true, NEW_ZEALAND: true },
	                points: 2
	            });
	
	            mapTiles.push({
	                top: 0, left: 765, width: 120, height: 245,
	                color: this.getColor(colorIndex++),
	                name: "WESTERN_EUROPE",
	                neighbors: { GREENLAND: true, EASTERN_EUROPE: true, WEST_AFRICA: true },
	                points: 10
	            });
	
	            mapTiles.push({
	                top: 0, left: 885, width: 120, height: 245,
	                color: this.getColor(colorIndex++),
	                name: "EASTERN_EUROPE",
	                neighbors: { WESTERN_EUROPE: true, WEST_AFRICA: true, MIDDLE_EAST: true, CENTRAL_RUSSIA: true },
	                points: 6
	            });
	
	            mapTiles.push({
	                top: 0, left: 1005, width: 220, height: 245,
	                color: this.getColor(colorIndex++),
	                name: "CENTRAL_RUSSIA",
	                neighbors: { EASTERN_EUROPE: true, MIDDLE_EAST: true, INDIA: true, EASTERN_CHINA: true, EASTERN_RUSSIA: true },
	                points: 4
	            });
	
	            mapTiles.push({
	                top: 0, left: 1225, width: 485, height: 175,
	                color: this.getColor(colorIndex++),
	                name: "EASTERN_RUSSIA",
	                neighbors: { EASTERN_CHINA: true, CENTRAL_RUSSIA: true, WESTERN_CANADA: true },
	                points: 3
	            });
	
	            mapTiles.push({
	                top: 245, left: 715, width: 220, height: 255,
	                color: this.getColor(colorIndex++),
	                name: "WEST_AFRICA",
	                neighbors: { WESTERN_EUROPE: true, EASTERN_EUROPE: true, MIDDLE_EAST: true, EAST_AFRICA: true, SOUTH_AFRICA: true },
	                points: 3
	            });
	
	            mapTiles.push({
	                top: 245, left: 935, width: 180, height: 135,
	                color: this.getColor(colorIndex++),
	                name: "MIDDLE_EAST",
	                neighbors: { EASTERN_EUROPE: true, CENTRAL_RUSSIA: true, INDIA: true, EAST_AFRICA: true, WEST_AFRICA: true },
	                points: 4
	            });
	
	            mapTiles.push({
	                top: 380, left: 935, width: 180, height: 120,
	                color: this.getColor(colorIndex++),
	                name: "EAST_AFRICA",
	                neighbors: { WEST_AFRICA: true, SOUTH_AFRICA: true, MIDDLE_EAST: true, INDIA: true },
	                points: 3
	            });
	
	            mapTiles.push({
	                top: 500, left: 715, width: 400, height: 130,
	                color: this.getColor(colorIndex++),
	                name: "SOUTH_AFRICA",
	                neighbors: { WEST_AFRICA: true, EAST_AFRICA: true },
	                points: 5
	            });
	
	            mapTiles.push({
	                top: 245, left: 1115, width: 110, height: 175,
	                color: this.getColor(colorIndex++),
	                name: "INDIA",
	                neighbors: { EAST_AFRICA: true, MIDDLE_EAST: true, CENTRAL_RUSSIA: true, EASTERN_CHINA: true, SOUTHEAST_ASIA: true },
	                points: 7
	            });
	
	            mapTiles.push({
	                top: 175, left: 1225, width: 290, height: 155,
	                color: this.getColor(colorIndex++),
	                name: "EASTERN_CHINA",
	                neighbors: { INDIA: true, CENTRAL_RUSSIA: true, EASTERN_RUSSIA: true, SOUTHEAST_ASIA: true },
	                points: 10
	            });
	
	            mapTiles.push({
	                top: 330, left: 1225, width: 290, height: 160,
	                color: this.getColor(colorIndex++),
	                name: "SOUTHEAST_ASIA",
	                neighbors: { INDIA: true, EASTERN_CHINA: true, WESTERN_AUSTRALIA: true, EASTERN_AUSTRALIA: true, FIJI: true },
	                points: 5
	            });
	
	            mapTiles.push({
	                top: 490, left: 1305, width: 110, height: 200,
	                color: this.getColor(colorIndex++),
	                name: "WESTERN_AUSTRALIA",
	                neighbors: { EASTERN_AUSTRALIA: true, SOUTHEAST_ASIA: true },
	                points: 4
	            });
	
	            mapTiles.push({
	                top: 490, left: 1415, width: 100, height: 200,
	                color: this.getColor(colorIndex++),
	                name: "EASTERN_AUSTRALIA",
	                neighbors: { WESTERN_AUSTRALIA: true, SOUTHEAST_ASIA: true, FIJI: true, NEW_ZEALAND: true },
	                points: 6
	            });
	
	            mapTiles.push({
	                top: 600, left: 1515, width: 195, height: 200,
	                color: this.getColor(colorIndex++),
	                name: "NEW_ZEALAND",
	                neighbors: { EASTERN_AUSTRALIA: true, FIJI: true, EAST_ANTARCTICA: true },
	                points: 4
	            });
	
	            mapTiles.push({
	                top: 330, left: 1515, width: 195, height: 270,
	                color: this.getColor(colorIndex++),
	                name: "FIJI",
	                neighbors: { NEW_ZEALAND: true, EASTERN_AUSTRALIA: true, SOUTHEAST_ASIA: true, HAWAII: true },
	                points: 2
	            });
	
	            for (var i = 0; i < mapTiles.length; i++) {
	                var regionOwner = regionOwnersList ? parseInt(regionOwnersList[i], 10) : 255;
	                var soldierCount = regionSoldiers ? parseInt(regionSoldiers[i], 10) : 0;
	                mapTiles[i].teamId = regionOwner;
	                mapTiles[i].avatar = this.getAvatarFromTeamId(avatarIds, regionOwner);
	                mapTiles[i].soliders = soldierCount;
	                mapTiles[i].regionId = this.regionNameToId(mapTiles[i].name);
	                mapTiles[i].display = this.regionIdToDisplay(mapTiles[i].regionId);
	            }
	
	            return { mapTiles: mapTiles, gapTiles: gapTiles };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var pendingEndTurnKey = this.props.game.pendingEndTurn;
	            var pendingAttackOrMoveKey = this.props.game.pendingAttackOrMove;
	            var hasEndTurnTransaction = false;
	            var hasAttackOrMoveTransaction = false;
	            if (pendingEndTurnKey !== null) {
	                var state = this.context.drizzle.store.getState();
	                if (state.transactionStack[pendingEndTurnKey]) {
	                    hasEndTurnTransaction = true;
	                }
	            }
	
	            if (pendingAttackOrMoveKey !== null) {
	                var _state = this.context.drizzle.store.getState();
	                if (_state.transactionStack[pendingAttackOrMoveKey]) {
	                    hasAttackOrMoveTransaction = true;
	                }
	            }
	
	            var NO_PLAYER = 255;
	            var _context$drizzle$web = this.context.drizzle.web3,
	                eth = _context$drizzle$web.eth,
	                utils = _context$drizzle$web.utils;
	
	            var _eth$currentProvider$ = eth.currentProvider.publicConfigStore.getState(),
	                _eth$currentProvider$2 = _eth$currentProvider$.selectedAddress,
	                selectedAddress = _eth$currentProvider$2 === undefined ? "" : _eth$currentProvider$2,
	                _eth$currentProvider$3 = _eth$currentProvider$.networkVersion,
	                networkVersion = _eth$currentProvider$3 === undefined ? "" : _eth$currentProvider$3;
	
	            var showForceNextBlock = true;
	            if (networkVersion === "1" || networkVersion === "3" || networkVersion === "4" || networkVersion === "42") {
	                showForceNextBlock = false;
	            }
	
	            var gameId = this.props.gameId;
	            var dataKeysByGame = this.props.game.dataKeysByGame;
	            var dataKeys = dataKeysByGame.hasOwnProperty(gameId) ? dataKeysByGame[gameId] : null;
	            var soldiersByRegionKey = null;
	            var undeployedSoldiersKey = null;
	            var pendingActionsKey = null;
	            var pendingActionOutcomesKey = null;
	            var turnAndPlayerInfoKey = null;
	            if (dataKeys) {
	                soldiersByRegionKey = dataKeys.soldiersByRegion;
	                undeployedSoldiersKey = dataKeys.undeployedSoldiers;
	                pendingActionsKey = dataKeys.pendingActions;
	                pendingActionOutcomesKey = dataKeys.pendingActionOutcomes;
	                turnAndPlayerInfoKey = dataKeys.turnAndPlayerInfo;
	            }
	            var initialized = false;
	            var regionOwnersList = null;
	            var regionSoldiers = null;
	
	            var undeployedSoldiers = null;
	            var playerRewardPoints = null;
	
	            var actionCount = 0;
	            var actionList = [];
	
	            var blockNumber = 0;
	            var turnTeamId = null;
	            var turnNum = null;
	            var maxBlocksPerTurn = null;
	            var playerCount = null;
	            var playerAddresses = null;
	            var avatarIds = null;
	            if (this.props.WorldGame.initialized && soldiersByRegionKey !== null && undeployedSoldiersKey !== null && pendingActionsKey !== null && pendingActionOutcomesKey !== null && turnAndPlayerInfoKey !== null && this.props.WorldGame.soldiersByRegion.hasOwnProperty(soldiersByRegionKey) && this.props.WorldGame.undeployedSoldiers.hasOwnProperty(undeployedSoldiersKey) && this.props.WorldGame.pendingActions.hasOwnProperty(pendingActionsKey) && this.props.WorldGame.pendingActionOutcomes.hasOwnProperty(pendingActionOutcomesKey) && this.props.WorldGame.turnAndPlayerInfo.hasOwnProperty(turnAndPlayerInfoKey)) {
	                var soldiersByRegion = this.props.WorldGame.soldiersByRegion[soldiersByRegionKey].value;
	                regionOwnersList = soldiersByRegion[0];
	                regionSoldiers = soldiersByRegion[1];
	
	                var undeployedSoldiersResp = this.props.WorldGame.undeployedSoldiers[undeployedSoldiersKey].value;
	                undeployedSoldiers = undeployedSoldiersResp[0];
	                playerRewardPoints = undeployedSoldiersResp[1];
	
	                var turnAndPlayerInfo = this.props.WorldGame.turnAndPlayerInfo[turnAndPlayerInfoKey].value;
	                turnTeamId = parseInt(turnAndPlayerInfo[0], 10);
	                turnNum = parseInt(turnAndPlayerInfo[1], 10);
	                maxBlocksPerTurn = parseInt(turnAndPlayerInfo[2], 10);
	                playerCount = parseInt(turnAndPlayerInfo[3], 10);
	                playerAddresses = turnAndPlayerInfo[4];
	                avatarIds = utils.hexToAscii(turnAndPlayerInfo[5]);
	
	                var pendingActions = this.props.WorldGame.pendingActions[pendingActionsKey].value;
	                var pendingActionOutcomes = this.props.WorldGame.pendingActionOutcomes[pendingActionOutcomesKey].value;
	                actionCount = pendingActions[0];
	                var fromRegionList = pendingActions[1];
	                var toRegionList = pendingActions[2];
	                var moveSoldierCountList = pendingActions[3];
	                blockNumber = parseInt(pendingActionOutcomes[0], 10);
	                var actionCountOutcomes = pendingActionOutcomes[1];
	                var submitBlockList = pendingActionOutcomes[2];
	                var remainingAttackerList = pendingActionOutcomes[3];
	                var remainingDefenderList = pendingActionOutcomes[4];
	
	                actionCount = Math.min(actionCount, actionCountOutcomes, fromRegionList.length, toRegionList.length, moveSoldierCountList.length, submitBlockList.length, remainingAttackerList.length, remainingDefenderList.length);
	                for (var i = 0; i < actionCount; i++) {
	                    var toRegion = parseInt(toRegionList[i], 10);
	                    var owner = parseInt(regionOwnersList[toRegion], 10);
	                    var submitBlock = parseInt(submitBlockList[i], 10);
	                    var isFriendly = false;
	                    var outcomeBlock = submitBlock + 2;
	                    if (owner === turnTeamId || owner === NO_PLAYER) {
	                        isFriendly = true;
	                        outcomeBlock = submitBlock;
	                    }
	
	                    actionList.push({
	                        fromRegion: parseInt(fromRegionList[i], 10),
	                        toRegion: toRegion,
	                        soldierCount: parseInt(moveSoldierCountList[i], 10),
	                        submitBlock: submitBlock,
	                        hasOutcome: blockNumber >= outcomeBlock,
	                        outcomeBlock: outcomeBlock,
	                        remainingAttackers: parseInt(remainingAttackerList[i], 10),
	                        remainingDefenders: parseInt(remainingDefenderList[i], 10),
	                        owner: owner,
	                        isFriendly: isFriendly
	                    });
	                }
	
	                if (playerAddresses !== null && playerCount !== null && avatarIds !== null) {
	                    playerAddresses = playerAddresses.slice(0, playerCount);
	                    avatarIds = avatarIds.substring(0, playerCount);
	
	                    // Prevents duplicate avatars being registered
	                    var checkDuplicateAvatar = {};
	                    for (var _i = 0; _i < avatarIds.length; _i++) {
	                        var id = avatarIds[_i];
	                        if (checkDuplicateAvatar.hasOwnProperty(id)) {
	                            avatarIds = null;
	                            break;
	                        }
	
	                        checkDuplicateAvatar[id] = true;
	                    }
	                }
	
	                initialized = true;
	            }
	
	            var yourUndeployedSoldiers = 0;
	            var youPlayerRewardPoints = 0;
	            var playerNum = NO_PLAYER;
	            if (selectedAddress && playerAddresses) {
	                for (var _i2 = 0; _i2 < playerAddresses.length; _i2++) {
	                    if (selectedAddress.toLowerCase() === playerAddresses[_i2].toLowerCase()) {
	                        playerNum = _i2;
	                        yourUndeployedSoldiers = _i2 < undeployedSoldiers.length ? parseInt(undeployedSoldiers[_i2], 10) : 0;
	                        youPlayerRewardPoints = _i2 < playerRewardPoints.length ? parseInt(playerRewardPoints[_i2], 10) : 0;
	                    }
	                }
	            }
	
	            var currentPlayerStr = "";
	            if (playerAddresses) {
	                for (var _i3 = 0; _i3 < playerAddresses.length; _i3++) {
	                    if (_i3 === turnTeamId) {
	                        currentPlayerStr = "Player " + (_i3 + 1);
	                        if (_i3 === playerNum) {
	                            currentPlayerStr += " (you)";
	                        }
	                    }
	                }
	            }
	
	            var yourTurn = playerNum === turnTeamId;
	            var selectedOverlayId = null;
	            if (!hasAttackOrMoveTransaction && !hasEndTurnTransaction) {
	                selectedOverlayId = this.props.game.selectedOverlayId;
	            }
	
	            var selectedTileRegion = null;
	            if (!hasAttackOrMoveTransaction && !hasEndTurnTransaction) {
	                selectedTileRegion = this.props.game.selectedTileRegion;
	            }
	
	            var hoverTile = this.props.game.hoverTile;
	
	            var actionMessageByRegion = {};
	            var actionSoldiersByRegion = {};
	            var waitingForActions = false;
	            var endTurnByBlock = null;
	            var canEndOpponentsTurnBlock = null;
	            if (turnNum !== null && maxBlocksPerTurn !== null) {
	                endTurnByBlock = turnNum + maxBlocksPerTurn;
	                canEndOpponentsTurnBlock = turnNum + maxBlocksPerTurn;
	            }
	
	            var waitingForBlock = 0;
	            var renderedActions = [];
	            for (var _i4 = 0; _i4 < actionList.length; _i4++) {
	                var actionEntry = actionList[_i4];
	
	                actionMessageByRegion[actionEntry.toRegion] = "ATTACKING";
	                var actionType = "Attack with";
	                var _isFriendly = false;
	                if (actionEntry.owner === turnTeamId || actionEntry.owner === NO_PLAYER) {
	                    _isFriendly = true;
	                    actionType = "Move";
	                    actionMessageByRegion[actionEntry.toRegion] = "MOVING";
	                }
	
	                var initialDefenders = regionSoldiers ? parseInt(regionSoldiers[actionEntry.toRegion], 10) : 0;
	                var initialAttackers = actionEntry.soldierCount;
	                var remainingDefenders = actionEntry.remainingDefenders;
	                var remainingAttackers = actionEntry.remainingAttackers;
	
	                if (!actionSoldiersByRegion.hasOwnProperty(actionEntry.toRegion)) {
	                    actionSoldiersByRegion[actionEntry.toRegion] = 0;
	                }
	                actionSoldiersByRegion[actionEntry.toRegion] += initialAttackers;
	
	                var outcomeClass = "outcomePending";
	                var outcomeText = "Waiting for block #" + actionEntry.outcomeBlock + ".  Current block is #" + blockNumber + ".";
	                if (actionEntry.hasOutcome) {
	                    if (_isFriendly) {
	                        outcomeClass = "outcomeWon";
	                        outcomeText = currentPlayerStr + " moved " + initialAttackers + " " + (initialAttackers === 1 ? "soldier" : "soldiers") + ".";
	                    } else {
	                        var lostDefenders = initialDefenders > remainingDefenders ? initialDefenders - remainingDefenders : 0;
	                        var lostAttackers = initialAttackers > remainingAttackers ? initialAttackers - remainingAttackers : 0;
	
	                        if (remainingDefenders === 0) {
	                            outcomeClass = "outcomeWon";
	                            outcomeText = currentPlayerStr + " won the attack!  " + currentPlayerStr + " lost " + lostAttackers + " " + (lostAttackers === 1 ? "soldier" : "soldiers") + ", and killed " + lostDefenders + " " + (lostDefenders === 1 ? "soldier" : "soldiers") + ".";
	                        } else {
	                            outcomeClass = "outcomeLost";
	                            outcomeText = currentPlayerStr + " failed the attack!  " + currentPlayerStr + " lost " + lostAttackers + " " + (lostAttackers === 1 ? "soldier" : "soldiers") + ", and killed " + lostDefenders + " " + (lostDefenders === 1 ? "soldier" : "soldiers") + ".";
	                        }
	                    }
	                } else {
	                    waitingForActions = true;
	                    waitingForBlock = Math.max(waitingForBlock, actionEntry.outcomeBlock);
	                }
	
	                var BLOCKHASHES_EXPIRE_BLOCKS = 256;
	                var finishTurnBlock = actionEntry.outcomeBlock + (BLOCKHASHES_EXPIRE_BLOCKS - 1);
	                endTurnByBlock = endTurnByBlock === null ? finishTurnBlock : Math.min(endTurnByBlock, finishTurnBlock);
	
	                renderedActions.push(_react2.default.createElement(
	                    'li',
	                    { key: _i4 },
	                    actionType,
	                    ' ',
	                    actionEntry.soldierCount,
	                    ' ',
	                    actionEntry.soldierCount === 1 ? "soldier" : "soldiers",
	                    ' from',
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        ' "',
	                        this.regionIdToDisplay(actionEntry.fromRegion),
	                        '" '
	                    ),
	                    ' to',
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        ' "',
	                        this.regionIdToDisplay(actionEntry.toRegion),
	                        '"'
	                    ),
	                    '.',
	                    _react2.default.createElement(
	                        'span',
	                        { className: outcomeClass },
	                        ' ',
	                        outcomeText
	                    )
	                ));
	            }
	
	            var endTurnMinutes = 0;
	            if (endTurnByBlock !== null && endTurnByBlock > blockNumber) {
	                var remainingBlocks = endTurnByBlock - blockNumber;
	                endTurnMinutes = Math.floor(remainingBlocks / 4);
	            }
	
	            var endTurnHours = Math.floor(endTurnMinutes / 60);
	            endTurnMinutes %= 60;
	
	            var canEndOpponentsTurn = false;
	            if (waitingForActions === false && canEndOpponentsTurnBlock !== null && endTurnByBlock !== null && blockNumber > canEndOpponentsTurnBlock + 1 && blockNumber > endTurnByBlock) {
	                canEndOpponentsTurn = true;
	            }
	
	            var _getTilesFromData = this.getTilesFromData(regionOwnersList, regionSoldiers, avatarIds),
	                mapTiles = _getTilesFromData.mapTiles,
	                gapTiles = _getTilesFromData.gapTiles;
	
	            var selectedTeam = NO_PLAYER;
	            var selectedCenterPos = { left: 0, top: 0 };
	            var selectedNeighbors = {};
	            for (var _i5 = 0; _i5 < mapTiles.length; _i5++) {
	                var tile = mapTiles[_i5];
	                var isSelected = selectedTileRegion === tile.name;
	
	                if (isSelected) {
	                    selectedNeighbors = tile.neighbors;
	                    selectedTeam = tile.teamId;
	                    selectedCenterPos = { left: tile.left + Math.floor(tile.width / 2), top: tile.top + Math.floor(tile.height / 2) };
	                }
	            }
	
	            var firstTilePlayer = mapTiles.length > 0 ? mapTiles[0].teamId : NO_PLAYER;
	            var testWinnerRegionCount = 0;
	            var yourRegionCount = 0;
	            var overlayData = null;
	            var neighborCenterPosList = [];
	            var renderedTiles = [];
	            for (var _i6 = 0; _i6 < mapTiles.length; _i6++) {
	                var _tile = mapTiles[_i6];
	
	                var leftPos = Math.floor(Math.max(0, _tile.width - 70) / 2);
	                var topPos = Math.floor(Math.max(0, _tile.height - 90) / 2) + 5;
	
	                var _isSelected = selectedTileRegion === _tile.name;
	                var hasHover = hoverTile === _tile.name;
	                var isSelectedOverlay = selectedOverlayId === _tile.name;
	
	                var isNeighbor = false;
	                if (selectedNeighbors.hasOwnProperty(_tile.name)) {
	                    isNeighbor = true;
	                }
	
	                var _isFriendly2 = false;
	                if (selectedTeam === _tile.teamId || _tile.teamId === NO_PLAYER) {
	                    _isFriendly2 = true;
	                }
	
	                var isYourTeam = false;
	                if (playerNum === _tile.teamId) {
	                    isYourTeam = true;
	                    yourRegionCount++;
	                }
	
	                if (firstTilePlayer === _tile.teamId) {
	                    testWinnerRegionCount++;
	                }
	
	                var isUnowned = false;
	                if (_tile.teamId === NO_PLAYER) {
	                    isUnowned = true;
	                }
	
	                var queuedAction = null;
	                var queuedSoldiers = 0;
	                if (actionMessageByRegion.hasOwnProperty(_i6)) {
	                    queuedAction = actionMessageByRegion[_i6];
	                    queuedSoldiers = actionSoldiersByRegion[_i6];
	                }
	
	                if (isSelectedOverlay) {
	                    var soldiers = _tile.soliders;
	                    var isNotOwned = _tile.teamId === NO_PLAYER;
	                    overlayData = {
	                        tile: _tile, isYourTeam: isYourTeam, isNotOwned: isNotOwned, soldiers: soldiers, yourUndeployedSoldiers: yourUndeployedSoldiers, yourTurn: yourTurn
	                    };
	                }
	
	                var hideQueueSummary = hasHover && yourTurn && (isYourTeam || isUnowned);
	
	                if (queuedAction === null && isNeighbor) {
	                    if (selectedTileRegion === "HAWAII" && _tile.name === "FIJI") {
	                        neighborCenterPosList.push({ isFriendly: _isFriendly2, shortenDest: false, x1: selectedCenterPos.left, y1: selectedCenterPos.top, x2: 0, y2: selectedCenterPos.top + 20 });
	                        neighborCenterPosList.push({ isFriendly: _isFriendly2, shortenDest: false, x1: _tile.left + Math.floor(_tile.width / 2), y1: _tile.top + Math.floor(_tile.height / 2), x2: 1710, y2: _tile.top + Math.floor(_tile.height / 2) - 20 });
	                    } else if (selectedTileRegion === "FIJI" && _tile.name === "HAWAII") {
	                        neighborCenterPosList.push({ isFriendly: _isFriendly2, shortenDest: false, x1: selectedCenterPos.left, y1: selectedCenterPos.top, x2: 1710, y2: selectedCenterPos.top - 20 });
	                        neighborCenterPosList.push({ isFriendly: _isFriendly2, shortenDest: false, x1: _tile.left + Math.floor(_tile.width / 2), y1: _tile.top + Math.floor(_tile.height / 2), x2: 0, y2: _tile.top + Math.floor(_tile.height / 2) + 20 });
	                    } else if (selectedTileRegion === "WESTERN_CANADA" && _tile.name === "EASTERN_RUSSIA") {
	                        neighborCenterPosList.push({ isFriendly: _isFriendly2, shortenDest: false, x1: selectedCenterPos.left, y1: selectedCenterPos.top, x2: 0, y2: selectedCenterPos.top });
	                        neighborCenterPosList.push({ isFriendly: _isFriendly2, shortenDest: false, x1: _tile.left + Math.floor(_tile.width / 2), y1: _tile.top + Math.floor(_tile.height / 2), x2: 1710, y2: _tile.top + Math.floor(_tile.height / 2) });
	                    } else if (selectedTileRegion === "EASTERN_RUSSIA" && _tile.name === "WESTERN_CANADA") {
	                        neighborCenterPosList.push({ isFriendly: _isFriendly2, shortenDest: false, x1: selectedCenterPos.left, y1: selectedCenterPos.top, x2: 1710, y2: selectedCenterPos.top });
	                        neighborCenterPosList.push({ isFriendly: _isFriendly2, shortenDest: false, x1: _tile.left + Math.floor(_tile.width / 2), y1: _tile.top + Math.floor(_tile.height / 2), x2: 0, y2: _tile.top + Math.floor(_tile.height / 2) });
	                    } else {
	                        neighborCenterPosList.push({ isFriendly: _isFriendly2, shortenDest: true, x1: selectedCenterPos.left, y1: selectedCenterPos.top, x2: _tile.left + Math.floor(_tile.width / 2), y2: _tile.top + Math.floor(_tile.height / 2) });
	                    }
	                }
	
	                renderedTiles.push(_react2.default.createElement(
	                    'div',
	                    {
	                        onMouseEnter: this.hoverTile,
	                        onMouseLeave: this.cancelHover,
	                        onClick: selectedTileRegion === null ? this.showOverlay : queuedAction === null && isNeighbor ? this.moveOrAttack : this.cancelTile,
	                        id: _tile.name,
	                        key: _tile.name,
	                        style: {
	                            cursor: "pointer",
	                            position: "absolute",
	                            textAlign: "center",
	                            top: _tile.top,
	                            left: _tile.left,
	                            width: _tile.width,
	                            height: _tile.height,
	                            background: _tile.color
	                        }
	                    },
	                    _tile.display,
	                    selectedTileRegion === null && yourTurn && hasHover && (isYourTeam || isUnowned) && !_isSelected ? _react2.default.createElement(
	                        'div',
	                        { style: { position: "absolute", zIndex: 5, color: "#00cc00", background: "rgba(0,0,0,0.7)", textAlign: "center", width: 90, padding: 10, fontSize: 24, top: topPos + 10, left: leftPos - 20 } },
	                        'SELECT'
	                    ) : null,
	                    queuedAction === null && isNeighbor && hasHover && _isFriendly2 ? _react2.default.createElement(
	                        'div',
	                        { style: { position: "absolute", zIndex: 5, color: "#00cc00", background: "rgba(0,0,0,0.7)", textAlign: "center", width: 90, padding: 10, fontSize: 24, top: topPos + 10, left: leftPos - 20 } },
	                        'MOVE'
	                    ) : null,
	                    queuedAction === null && isNeighbor && hasHover && !_isFriendly2 ? _react2.default.createElement(
	                        'div',
	                        { style: { position: "absolute", zIndex: 5, color: "#ff0000", background: "rgba(0,0,0,0.7)", textAlign: "center", width: 90, padding: 10, fontSize: 24, top: topPos + 10, left: leftPos - 20 } },
	                        'ATTACK'
	                    ) : null,
	                    !hideQueueSummary && queuedAction ? _react2.default.createElement(
	                        'div',
	                        { style: { position: "absolute", zIndex: 5, color: queuedAction === "ATTACKING" ? "#ff0000" : "#00cc00", background: "rgba(80,80,80,0.9)", textAlign: "center", width: 90, padding: 10, fontSize: 16, top: topPos + 5, left: leftPos - 20 } },
	                        queuedAction,
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            "+" + queuedSoldiers
	                        )
	                    ) : null,
	                    queuedAction === null && isNeighbor && _isFriendly2 ? _react2.default.createElement('img', { src: "/circle_lightblue.png", alt: '', style: { width: 90, height: 90, position: "absolute", top: topPos - 10, left: leftPos - 10 } }) : null,
	                    queuedAction === null && isNeighbor && !_isFriendly2 ? _react2.default.createElement('img', { src: "/circle_red2.png", alt: '', style: { width: 90, height: 90, position: "absolute", top: topPos - 10, left: leftPos - 10 } }) : null,
	                    _isSelected ? _react2.default.createElement('img', { src: "/circle_green.png", alt: '', style: { width: 90, height: 90, position: "absolute", top: topPos - 10, left: leftPos - 10 } }) : null,
	                    _tile.avatar !== null && _react2.default.createElement(
	                        'div',
	                        { style: { width: 70, height: 90, textAlign: "center", position: "absolute", top: topPos, left: leftPos } },
	                        _react2.default.createElement('img', { src: "/" + _tile.avatar + ".png", alt: '', style: { maxWidth: 70, maxHeight: 70 } }),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _tile.soliders
	                        )
	                    )
	                ));
	            }
	
	            var renderedGaps = [];
	            for (var _i7 = 0; _i7 < gapTiles.length; _i7++) {
	                var _tile2 = gapTiles[_i7];
	                renderedGaps.push(_react2.default.createElement('div', { key: _i7, onClick: this.cancelTile, style: { position: "absolute", top: _tile2.top, left: _tile2.left, width: _tile2.width, height: _tile2.height, background: "rgba(64, 196, 255, 0.3)" } }));
	            }
	
	            var renderedArrows = [];
	            for (var _i8 = 0; _i8 < neighborCenterPosList.length; _i8++) {
	                var neighborCenterPos = neighborCenterPosList[_i8];
	                renderedArrows.push(_react2.default.createElement(_ArrowControl2.default, { isFriendly: neighborCenterPos.isFriendly, shortenDest: neighborCenterPos.shortenDest, onClick: this.cancelTile, key: _i8, x1: neighborCenterPos.x1, y1: neighborCenterPos.y1, x2: neighborCenterPos.x2, y2: neighborCenterPos.y2 }));
	            }
	
	            var hasWinner = false;
	            var winnerId = NO_PLAYER;
	            if (testWinnerRegionCount === mapTiles.length && firstTilePlayer !== NO_PLAYER) {
	                hasWinner = true;
	                winnerId = firstTilePlayer;
	            }
	
	            var renderPlayerList = [];
	            if (playerAddresses) {
	                for (var _i9 = 0; _i9 < playerAddresses.length; _i9++) {
	                    var avatar = this.getAvatarFromTeamId(avatarIds, _i9);
	                    var extraMsg = "";
	                    if (_i9 === playerNum) {
	                        extraMsg = "(you)";
	                    }
	
	                    var borderStyle = "1px solid #999";
	                    var backgroundStyle = "";
	                    if (hasWinner) {
	                        if (_i9 === winnerId) {
	                            borderStyle = "1px solid #1Aa239";
	                            backgroundStyle = "#1Aa239";
	                        }
	                    } else {
	                        if (_i9 === turnTeamId) {
	                            borderStyle = "1px solid #1Aa239";
	                            backgroundStyle = "#1Aa239";
	                        }
	                    }
	
	                    renderPlayerList.push(_react2.default.createElement(
	                        'td',
	                        { style: { border: borderStyle, background: backgroundStyle }, key: _i9 },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { width: 70, height: 120, textAlign: "center", padding: 10 } },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                'player ',
	                                _i9 + 1
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement('img', { src: "/" + avatar + ".png", alt: '', style: { maxWidth: 70, maxHeight: 70, marginTop: 5 } })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                extraMsg
	                            )
	                        )
	                    ));
	                }
	            }
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                selectedOverlayId !== null && _react2.default.createElement(_OverlayContainer2.default, {
	                    data: overlayData,
	                    gameId: gameId,
	                    turnNum: turnNum,
	                    playerNum: playerNum,
	                    waitingForActions: waitingForActions,
	                    waitingForBlock: waitingForBlock,
	                    actionCount: actionCount
	                }),
	                _react2.default.createElement('div', { className: 'menuGap' }),
	                _react2.default.createElement(
	                    'div',
	                    { onClick: this.outsideClick, style: { background: "#fafafa", width: 1710 } },
	                    initialized && _react2.default.createElement(
	                        'div',
	                        { style: { padding: 20 } },
	                        hasWinner ? _react2.default.createElement(
	                            'div',
	                            null,
	                            winnerId === playerNum ? _react2.default.createElement(
	                                'span',
	                                { style: { fontSize: 20, fontWeight: "bold", color: "#1Aa239" } },
	                                "You win the game!"
	                            ) : _react2.default.createElement(
	                                'span',
	                                { style: { fontSize: 20, fontWeight: "bold", color: "#1Aa239" } },
	                                "Player " + (winnerId + 1) + " wins the game!"
	                            ),
	                            _react2.default.createElement(
	                                'table',
	                                { style: { marginTop: 20 } },
	                                _react2.default.createElement(
	                                    'tbody',
	                                    null,
	                                    _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        renderPlayerList
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                { onClick: function onClick(event) {
	                                        return _this2.declareWinner(event, winnerId);
	                                    }, className: 'btn' },
	                                'Declare winner on blockchain'
	                            )
	                        ) : _react2.default.createElement(
	                            'div',
	                            null,
	                            yourTurn ? _react2.default.createElement(
	                                'span',
	                                { style: { fontSize: 20, fontWeight: "bold", color: "#1Aa239" } },
	                                "It's your turn. "
	                            ) : _react2.default.createElement(
	                                'span',
	                                { style: { fontSize: 20, fontWeight: "bold", color: "#dd2010" } },
	                                playerNum === NO_PLAYER ? "You are not playing. " : "",
	                                "It's player " + (turnTeamId + 1) + "'s turn. "
	                            ),
	                            playerNum === NO_PLAYER ? _react2.default.createElement('span', null) : _react2.default.createElement(
	                                'span',
	                                null,
	                                "You are player " + (playerNum + 1) + ". ",
	                                "You control " + yourRegionCount + " regions (worth " + youPlayerRewardPoints + " points) and have " + yourUndeployedSoldiers + " undeployed " + (yourUndeployedSoldiers === 1 ? "soldier" : "soldiers") + ". ",
	                                yourTurn && endTurnByBlock !== null ? _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    'You must end your turn by block #',
	                                    endTurnByBlock,
	                                    ' (~',
	                                    endTurnHours,
	                                    'h ',
	                                    endTurnMinutes,
	                                    'min). '
	                                ) : "",
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    'Interact with the map to move, attack or deploy soldiers. '
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'table',
	                                { style: { marginTop: 20 } },
	                                _react2.default.createElement(
	                                    'tbody',
	                                    null,
	                                    _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        renderPlayerList
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { style: { marginTop: 20 } },
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    'Queued moves and attacks for current player. Max 8 per turn:'
	                                ),
	                                _react2.default.createElement(
	                                    'ul',
	                                    null,
	                                    renderedActions.length > 0 ? renderedActions : _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'None.'
	                                    )
	                                )
	                            ),
	                            yourTurn && _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'button',
	                                    { onClick: function onClick(event) {
	                                            return _this2.endTurn(event, turnNum, waitingForActions, waitingForBlock);
	                                        }, className: waitingForActions ? "btnDisabled" : "btn", style: { marginBottom: 0 } },
	                                    'End your turn without deploying soldiers'
	                                ),
	                                showForceNextBlock && _react2.default.createElement(
	                                    'button',
	                                    { onClick: function onClick(event) {
	                                            return _this2.forceNextBlock(event, blockNumber);
	                                        }, className: 'btn', style: { marginBottom: 0 } },
	                                    'Force next block'
	                                ),
	                                waitingForActions && _react2.default.createElement(
	                                    'div',
	                                    { className: 'errorExplainer' },
	                                    'You cannot end turn until block #',
	                                    waitingForBlock
	                                )
	                            ),
	                            !yourTurn && playerNum !== NO_PLAYER && canEndOpponentsTurn && _react2.default.createElement(
	                                'button',
	                                { onClick: function onClick(event) {
	                                        return _this2.endOpponentsTurn(event, turnNum);
	                                    }, className: 'btn', style: { marginBottom: 0 } },
	                                'End opponent\'s turn since their time is up'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { background: "url('/world_blank.png') no-repeat -65px -35px", width: 1710, height: 870, position: "relative" } },
	                    renderedTiles,
	                    renderedGaps,
	                    renderedArrows
	                ),
	                _react2.default.createElement('div', { onClick: this.outsideClick, style: { background: "#fafafa", width: 1710, height: 100 } })
	            );
	        }
	    }]);
	
	    return Game;
	}(_react.Component);
	
	Game.contextTypes = {
	    drizzle: _propTypes2.default.object
	};
	
	exports.default = Game;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Game = __webpack_require__(360);
	
	var _Game2 = _interopRequireDefault(_Game);
	
	var _drizzleReact = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    gameId: ownProps.gameId,
	    game: state.game,
	    menu: state.menu,
	    accounts: state.accounts,
	    WorldGame: state.contracts.WorldGame,
	    drizzleStatus: state.drizzleStatus,
	    web3: state.web3
	  };
	};
	
	var GameContainer = (0, _drizzleReact.drizzleConnect)(_Game2.default, mapStateToProps);
	exports.default = GameContainer;

/***/ },
/* 362 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	    input: {},
	    validationMap: {},
	    selectedTileRegion: null,
	    selectedTileSoldiers: null,
	    selectedTileTurnNum: null,
	    hoverTile: null,
	    web3Instance: null,
	    dataKeysByGame: {},
	    selectedOverlayId: null,
	    pendingEndTurn: null,
	    pendingAttackOrMove: null,
	    pendingEndOpponentsTurn: null
	};
	
	var gameReducer = function gameReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	
	    if (action.type === 'SHOW_OVERLAY') {
	        var newValue = action.payload;
	
	        return Object.assign({}, state, {
	            selectedOverlayId: newValue,
	            input: {},
	            validationMap: {},
	            pendingEndTurn: null,
	            pendingAttackOrMove: null,
	            pendingEndOpponentsTurn: null,
	            selectedTileRegion: null,
	            selectedTileSoldiers: null,
	            selectedTileTurnNum: null
	        });
	    }
	
	    if (action.type === 'CLOSE_OVERLAY') {
	        return Object.assign({}, state, {
	            selectedOverlayId: null,
	            input: {},
	            validationMap: {}
	        });
	    }
	
	    if (action.type === 'SELECT_TILE') {
	        var _action$payload = action.payload,
	            regionId = _action$payload.regionId,
	            soldiers = _action$payload.soldiers,
	            turnNum = _action$payload.turnNum;
	
	        return Object.assign({}, state, {
	            selectedTileRegion: regionId,
	            selectedTileSoldiers: soldiers,
	            selectedTileTurnNum: turnNum
	        });
	    }
	
	    if (action.type === 'HOVER_TILE') {
	        var _newValue = action.payload;
	        return Object.assign({}, state, {
	            hoverTile: _newValue
	        });
	    }
	
	    if (action.type === 'UPDATE_INPUT') {
	        var _action$payload2 = action.payload,
	            name = _action$payload2.name,
	            value = _action$payload2.value;
	
	        var inputObj = state.input;
	
	        var newInputObj = Object.assign({}, inputObj, _defineProperty({}, name, value));
	
	        return Object.assign({}, state, {
	            input: newInputObj
	        });
	    }
	
	    if (action.type === 'UPDATE_VALIDATION') {
	        var _newValue2 = action.payload;
	
	        return Object.assign({}, state, {
	            validationMap: _newValue2
	        });
	    }
	
	    if (action.type === 'SET_DATA_KEYS') {
	        var _action$payload3 = action.payload,
	            gameId = _action$payload3.gameId,
	            dataKeys = _action$payload3.dataKeys;
	
	
	        var _newValue3 = Object.assign({}, state.dataKeysByGame, _defineProperty({}, gameId, dataKeys));
	
	        return Object.assign({}, state, {
	            dataKeysByGame: _newValue3
	        });
	    }
	
	    if (action.type === 'PENDING_DEPLOY_END_TURN') {
	        var _newValue4 = action.payload;
	
	        return Object.assign({}, state, {
	            pendingEndTurn: _newValue4
	        });
	    }
	
	    if (action.type === 'PENDING_ATTACK_OR_MOVE') {
	        var _newValue5 = action.payload;
	
	        return Object.assign({}, state, {
	            pendingAttackOrMove: _newValue5
	        });
	    }
	
	    if (action.type === 'PENDING_END_OPPONENTS_TURN') {
	        var _newValue6 = action.payload;
	
	        return Object.assign({}, state, {
	            pendingEndOpponentsTurn: _newValue6
	        });
	    }
	
	    return state;
	};
	
	exports.default = gameReducer;

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(515);
	
	var _MenuActions = __webpack_require__(111);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Menu = function (_Component) {
	  _inherits(Menu, _Component);
	
	  function Menu(props, context) {
	    _classCallCheck(this, Menu);
	
	    // This binding is necessary to make `this` work in the callback
	    var _this = _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this, props));
	
	    _this.navigate = _this.navigate.bind(_this);
	    return _this;
	  }
	
	  _createClass(Menu, [{
	    key: 'navigate',
	    value: function navigate(event) {
	      this.props.dispatch((0, _MenuActions.selectPage)(event.target.getAttribute("name")));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var selectedPage = this.props.menu.selectedPage;
	      var gameId = this.props.menu.selectedGameId;
	
	      var eth = this.context.drizzle.web3.eth;
	
	      var _eth$currentProvider$ = eth.currentProvider.publicConfigStore.getState(),
	          _eth$currentProvider$2 = _eth$currentProvider$.selectedAddress,
	          selectedAddress = _eth$currentProvider$2 === undefined ? "" : _eth$currentProvider$2;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'menuBar' },
	          _react2.default.createElement(
	            'div',
	            { className: 'menuInner' },
	            _react2.default.createElement(
	              'span',
	              { name: 'open', onClick: this.navigate, className: "menuBtn" + (selectedPage === "open" ? " selectedBtn" : "") },
	              'Open Game'
	            ),
	            _react2.default.createElement(
	              'span',
	              { name: 'create', onClick: this.navigate, className: "menuBtn" + (selectedPage === "create" ? " selectedBtn" : "") },
	              'Create New Game'
	            ),
	            gameId !== null && _react2.default.createElement(
	              'span',
	              { name: 'game', onClick: this.navigate, className: "menuBtn" + (selectedPage === "game" ? " selectedBtn" : "") },
	              'Game #',
	              gameId
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'menuInnerRight' },
	            selectedAddress
	          )
	        )
	      );
	    }
	  }]);
	
	  return Menu;
	}(_react.Component);
	
	Menu.contextTypes = {
	  drizzle: _propTypes2.default.object
	};
	
	exports.default = Menu;

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Menu = __webpack_require__(363);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _drizzleReact = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    menu: state.menu,
	    accounts: state.accounts,
	    WorldGame: state.contracts.WorldGame,
	    drizzleStatus: state.drizzleStatus,
	    web3: state.web3
	  };
	};
	
	var MenuContainer = (0, _drizzleReact.drizzleConnect)(_Menu2.default, mapStateToProps);
	exports.default = MenuContainer;

/***/ },
/* 365 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var initialState = {
	    selectedPage: "open",
	    selectedGameId: null,
	    gameCountKey: null,
	    gamesForAddressKey: null
	};
	
	var MenuReducer = function MenuReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	
	    if (action.type === 'SELECT_PAGE') {
	        var newValue = action.payload;
	
	        return Object.assign({}, state, {
	            selectedPage: newValue
	        });
	    }
	
	    if (action.type === 'OPEN_GAME') {
	        var _newValue = action.payload;
	
	        return Object.assign({}, state, {
	            selectedGameId: _newValue,
	            selectedPage: "game"
	        });
	    }
	
	    if (action.type === 'SET_GAME_COUNT_KEY') {
	        var _newValue2 = action.payload;
	
	        return Object.assign({}, state, {
	            gameCountKey: _newValue2
	        });
	    }
	
	    if (action.type === 'SET_GAMES_FOR_ADDRESS') {
	        var _newValue3 = action.payload;
	
	        return Object.assign({}, state, {
	            gamesForAddressKey: _newValue3
	        });
	    }
	
	    return state;
	};
	
	exports.default = MenuReducer;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(516);
	
	__webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OpenGame = function (_Component) {
	    _inherits(OpenGame, _Component);
	
	    function OpenGame(props) {
	        _classCallCheck(this, OpenGame);
	
	        var _this = _possibleConstructorReturn(this, (OpenGame.__proto__ || Object.getPrototypeOf(OpenGame)).call(this, props));
	
	        _this.state = {
	            inputGameId: "",
	            invalid: false
	        };
	
	        _this.handleInputChange = _this.handleInputChange.bind(_this);
	        _this.openGame = _this.openGame.bind(_this);
	        _this.openGameById = _this.openGameById.bind(_this);
	        return _this;
	    }
	
	    _createClass(OpenGame, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setState({ invalid: false });
	        }
	    }, {
	        key: 'handleInputChange',
	        value: function handleInputChange(event) {
	            var newValue = event.target.value;
	            newValue = newValue.replace(/[^0-9]/gi, '');
	            this.setState({ inputGameId: newValue, invalid: false });
	        }
	    }, {
	        key: 'openGame',
	        value: function openGame(event) {
	            if (this.state.inputGameId !== "" && parseInt(this.state.inputGameId, 10) >= 0 && parseInt(this.state.inputGameId, 10) < parseInt(this.props.gameCount, 10)) {
	                this.props.onOpenGame(this.state.inputGameId);
	            } else {
	                this.setState({ invalid: true });
	            }
	        }
	    }, {
	        key: 'openGameById',
	        value: function openGameById(event, gameId) {
	            if (parseInt(gameId, 10) >= 0 && parseInt(gameId, 10) < parseInt(this.props.gameCount, 10)) {
	                this.props.onOpenGame(gameId);
	            }
	        }
	    }, {
	        key: 'createGame',
	        value: function createGame(event) {
	            this.props.onSelectPage("create");
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var yourGameLinks = [];
	            if (this.props.gamesForAddressList && this.props.gamesForAddressList.length > 0) {
	                var _loop = function _loop(i) {
	                    var gameId = parseInt(_this2.props.gamesForAddressList[i], 10);
	                    yourGameLinks.push(_react2.default.createElement(
	                        'div',
	                        { key: i, style: { marginTop: 5 } },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'linkSpan', onClick: function onClick(event) {
	                                    return _this2.openGameById(event, gameId);
	                                } },
	                            'Game #',
	                            gameId
	                        )
	                    ));
	                };
	
	                for (var i = 0; i < this.props.gamesForAddressList.length; i++) {
	                    _loop(i);
	                }
	            } else {
	                yourGameLinks.push(_react2.default.createElement(
	                    'div',
	                    { key: 'create', style: { marginTop: 5 } },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'linkSpan', onClick: function onClick(event) {
	                                return _this2.createGame(event);
	                            } },
	                        'No recent games.  Click to create a new game.'
	                    )
	                ));
	            }
	
	            var gameLinks = [];
	            if (this.props.gameCount > 0) {
	                var _loop2 = function _loop2(i) {
	                    gameLinks.push(_react2.default.createElement(
	                        'div',
	                        { key: i, style: { marginTop: 5 } },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'linkSpan', onClick: function onClick(event) {
	                                    return _this2.openGameById(event, i);
	                                } },
	                            'Game #',
	                            i
	                        )
	                    ));
	                };
	
	                for (var i = this.props.gameCount - 1; i >= 0 && i + 10 > this.props.gameCount; i--) {
	                    _loop2(i);
	                }
	            } else {
	                gameLinks.push(_react2.default.createElement(
	                    'div',
	                    { key: 'create', style: { marginTop: 5 } },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'linkSpan', onClick: function onClick(event) {
	                                return _this2.createGame(event);
	                            } },
	                        'No existing games.  Click to create a new game.'
	                    )
	                ));
	            }
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('div', { className: 'menuGap' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inputContainer' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'groupTitle' },
	                        'Your recent games'
	                    ),
	                    yourGameLinks,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'groupTitle titleMargin' },
	                        'All recently created games'
	                    ),
	                    gameLinks,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'groupTitle titleMargin' },
	                        'Load a game by id'
	                    ),
	                    _react2.default.createElement('input', { disabled: false, autoComplete: 'off', placeholder: "Game id", type: 'text', className: 'inputBox', name: 'gameid', value: this.state.inputGameId, onChange: this.handleInputChange }),
	                    this.state.invalid && _react2.default.createElement(
	                        'div',
	                        { className: 'errorMsg' },
	                        'Invalid game id'
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { onClick: this.openGame, className: 'btn' },
	                        'Open game'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return OpenGame;
	}(_react.Component);
	
	exports.default = OpenGame;

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(517);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GameActions = __webpack_require__(180);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Overlay = function (_Component) {
	    _inherits(Overlay, _Component);
	
	    function Overlay(props, context) {
	        _classCallCheck(this, Overlay);
	
	        // This binding is necessary to make `this` work in the callback
	        var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props));
	
	        _this.closeOverlay = _this.closeOverlay.bind(_this);
	        _this.handleOutsideClick = _this.handleOutsideClick.bind(_this);
	        _this.handleInputChange = _this.handleInputChange.bind(_this);
	        _this.moveOrAttack = _this.moveOrAttack.bind(_this);
	        _this.deployAndEndTurn = _this.deployAndEndTurn.bind(_this);
	        _this.getContext = _this.getContext.bind(_this);
	        _this.node = null;
	        return _this;
	    }
	
	    _createClass(Overlay, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.dispatch((0, _GameActions.updateValidation)({}));
	            document.addEventListener('mousedown', this.handleOutsideClick, false);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            document.removeEventListener('mousedown', this.handleOutsideClick, false);
	        }
	    }, {
	        key: 'closeOverlay',
	        value: function closeOverlay(event) {
	            this.props.dispatch((0, _GameActions.closeOverlay)(null));
	        }
	    }, {
	        key: 'handleOutsideClick',
	        value: function handleOutsideClick(event) {
	            if (this.node.contains(event.target)) {
	                return;
	            }
	
	            this.closeOverlay(event);
	        }
	    }, {
	        key: 'moveOrAttack',
	        value: function moveOrAttack(event) {
	            var input = this.props.game.input;
	            var moveSoldiers = parseInt(input.moveSoldiers, 10) || 0;
	
	            var _getContext = this.getContext(),
	                movableSoldiers = _getContext.movableSoldiers,
	                regionName = _getContext.regionName;
	
	            if (moveSoldiers > 0 && moveSoldiers <= movableSoldiers) {
	                this.props.dispatch((0, _GameActions.selectTile)(regionName, moveSoldiers, this.props.turnNum));
	            } else {
	                this.props.dispatch((0, _GameActions.updateValidation)({ moveSoldiers: false, deploySoldiers: true }));
	            }
	        }
	    }, {
	        key: 'deployAndEndTurn',
	        value: function deployAndEndTurn(event) {
	            var input = this.props.game.input;
	            var deploySoldiers = parseInt(input.deploySoldiers, 10) || 0;
	
	            var _getContext2 = this.getContext(),
	                yourUndeployedSoldiers = _getContext2.yourUndeployedSoldiers,
	                regionId = _getContext2.regionId;
	
	            if (input.deploySoldiers !== "" && deploySoldiers >= 0 && deploySoldiers <= yourUndeployedSoldiers) {
	                if (!this.props.waitingForActions) {
	                    this.props.dispatch((0, _GameActions.deployAndEndTurn)(this.context.drizzle, this.props.gameId, this.props.turnNum, regionId, deploySoldiers));
	                } else {
	                    this.props.dispatch((0, _GameActions.updateValidation)({ moveSoldiers: true, deploySoldiers: false }));
	                    alert("You cannot end turn until block #" + this.props.waitingForBlock);
	                }
	            } else {
	                this.props.dispatch((0, _GameActions.updateValidation)({ moveSoldiers: true, deploySoldiers: false }));
	            }
	        }
	    }, {
	        key: 'handleInputChange',
	        value: function handleInputChange(event) {
	            var newValue = event.target.value;
	            newValue = newValue.replace(/[^0-9]/gi, '');
	            this.props.dispatch((0, _GameActions.updateInput)(event.target.getAttribute("name"), newValue));
	        }
	    }, {
	        key: 'getContext',
	        value: function getContext() {
	            var selectedOverlayId = this.props.game.selectedOverlayId;
	
	            var MAX_ACTIONS_PER_TURN = 8;
	            var NO_PLAYER = 255;
	            var NO_REGION = 255;
	            var regionDisplay = "";
	            var isYourTeam = false;
	            var isNotOwned = false;
	            var yourUndeployedSoldiers = 0;
	            var soldiers = 0;
	            var movableSoldiers = 0;
	            var points = 0;
	            var avatar = null;
	            var canMoveOrAttack = false;
	            var canDeploySoldiers = false;
	            var teamId = NO_PLAYER;
	            var ownedByStr = "no one";
	            var regionId = NO_REGION;
	            var regionName = null;
	            var yourTurn = false;
	            var notPlaying = this.props.playerNum === NO_PLAYER;
	            if (selectedOverlayId !== null && this.props.data !== null) {
	                var data = this.props.data;
	                var tile = data.tile;
	                yourTurn = data.yourTurn;
	                regionDisplay = tile.display;
	                isYourTeam = data.isYourTeam;
	                isNotOwned = data.isNotOwned;
	                soldiers = data.soldiers;
	                points = tile.points;
	                avatar = tile.avatar;
	                teamId = tile.teamId;
	                yourUndeployedSoldiers = data.yourUndeployedSoldiers;
	                if (soldiers > 0) {
	                    movableSoldiers = soldiers - 1;
	                }
	
	                if (avatar !== null && teamId !== NO_PLAYER) {
	
	                    if (notPlaying) {
	                        ownedByStr = "player " + (teamId + 1);
	                    } else {
	                        if (isYourTeam) {
	                            ownedByStr = "you";
	                        } else {
	                            ownedByStr = "opponent";
	                        }
	
	                        ownedByStr += " (player " + (teamId + 1) + ")";
	                    }
	                }
	
	                regionId = tile.regionId;
	                regionName = tile.name;
	
	                canMoveOrAttack = yourTurn && isYourTeam && movableSoldiers > 0 && this.props.actionCount < MAX_ACTIONS_PER_TURN;
	                canDeploySoldiers = yourTurn && (isYourTeam || isNotOwned) && yourUndeployedSoldiers > 0;
	            }
	
	            var reachedMaxActions = this.props.actionCount >= MAX_ACTIONS_PER_TURN;
	
	            return {
	                NO_PLAYER: NO_PLAYER,
	                yourTurn: yourTurn,
	                selectedOverlayId: selectedOverlayId,
	                regionDisplay: regionDisplay,
	                isYourTeam: isYourTeam,
	                notPlaying: notPlaying,
	                isNotOwned: isNotOwned,
	                yourUndeployedSoldiers: yourUndeployedSoldiers,
	                soldiers: soldiers,
	                movableSoldiers: movableSoldiers,
	                points: points,
	                avatar: avatar,
	                canMoveOrAttack: canMoveOrAttack,
	                canDeploySoldiers: canDeploySoldiers,
	                teamId: teamId,
	                ownedByStr: ownedByStr,
	                regionId: regionId,
	                regionName: regionName,
	                reachedMaxActions: reachedMaxActions
	            };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var input = this.props.game.input;
	            var validationMap = this.props.game.validationMap;
	            var notValidMoveSoldiers = validationMap.hasOwnProperty("moveSoldiers") && validationMap["moveSoldiers"] === false;
	            var notValidDeploySoldiers = validationMap.hasOwnProperty("deploySoldiers") && validationMap["deploySoldiers"] === false;
	
	            var _getContext3 = this.getContext(),
	                selectedOverlayId = _getContext3.selectedOverlayId,
	                yourTurn = _getContext3.yourTurn,
	                notPlaying = _getContext3.notPlaying,
	                regionDisplay = _getContext3.regionDisplay,
	                yourUndeployedSoldiers = _getContext3.yourUndeployedSoldiers,
	                soldiers = _getContext3.soldiers,
	                movableSoldiers = _getContext3.movableSoldiers,
	                points = _getContext3.points,
	                avatar = _getContext3.avatar,
	                canMoveOrAttack = _getContext3.canMoveOrAttack,
	                canDeploySoldiers = _getContext3.canDeploySoldiers,
	                ownedByStr = _getContext3.ownedByStr,
	                reachedMaxActions = _getContext3.reachedMaxActions;
	
	            var showOverlay = selectedOverlayId !== null;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('div', { className: "fadeOverlay" + (showOverlay ? "" : " hide") }),
	                _react2.default.createElement(
	                    'div',
	                    { className: "contentOverlay" + (showOverlay ? "" : " hide") },
	                    _react2.default.createElement('div', { className: 'menuPlaceholder' }),
	                    _react2.default.createElement(
	                        'div',
	                        { ref: function ref(node) {
	                                return _this2.node = node;
	                            }, className: 'dialog' },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'groupTitle' },
	                                regionDisplay
	                            ),
	                            yourTurn ? _react2.default.createElement(
	                                'div',
	                                { className: 'yourTurnMsg' },
	                                'It\'s your turn'
	                            ) : _react2.default.createElement(
	                                'div',
	                                { className: 'notYourTurnMsg' },
	                                notPlaying ? "You are not playing" : "It's not your turn"
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'summaryText' },
	                                'Owned by: ',
	                                ownedByStr
	                            ),
	                            avatar !== null && _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement('img', { src: "/" + avatar + ".png", alt: '', style: { maxWidth: 70, maxHeight: 70 } })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'summaryText' },
	                                'Soldiers: ',
	                                soldiers
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'summaryText' },
	                                'Points for owning: ',
	                                points
	                            ),
	                            reachedMaxActions && _react2.default.createElement(
	                                'div',
	                                { className: 'errorExplainer' },
	                                yourTurn ? "You've reached" : "Reached",
	                                ' the limit of 8 moves and attacks per turn'
	                            ),
	                            canMoveOrAttack && _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement('input', { disabled: false, autoComplete: 'off', placeholder: 'Soldiers', type: 'text', className: 'inputBoxShort', name: 'moveSoldiers', value: input.moveSoldiers || "", onChange: this.handleInputChange }),
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: 'btn', onClick: this.moveOrAttack },
	                                    'Move or attack'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: notValidMoveSoldiers ? "errorExplainer" : "inputExplainer" },
	                                    'Maximum ',
	                                    movableSoldiers,
	                                    ' ',
	                                    movableSoldiers === 1 ? "soldier" : "soldiers"
	                                )
	                            ),
	                            canDeploySoldiers && _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement('input', { disabled: false, autoComplete: 'off', placeholder: 'Soldiers', type: 'text', className: 'inputBoxShort', name: 'deploySoldiers', value: input.deploySoldiers || "", onChange: this.handleInputChange }),
	                                _react2.default.createElement(
	                                    'button',
	                                    { className: this.props.waitingForActions ? "btnDisabled" : "btn", onClick: this.deployAndEndTurn },
	                                    'Deploy and end turn'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: notValidDeploySoldiers ? "errorExplainer" : "inputExplainer" },
	                                    'Maximum ',
	                                    yourUndeployedSoldiers,
	                                    ' ',
	                                    yourUndeployedSoldiers === 1 ? "soldier" : "soldiers"
	                                ),
	                                this.props.waitingForActions && _react2.default.createElement(
	                                    'div',
	                                    { className: notValidDeploySoldiers ? "errorExplainer" : "inputExplainer" },
	                                    'You cannot end turn until block #',
	                                    this.props.waitingForBlock
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Overlay;
	}(_react.Component);
	
	Overlay.contextTypes = {
	    drizzle: _propTypes2.default.object
	};
	
	exports.default = Overlay;

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Overlay = __webpack_require__(367);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _drizzleReact = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    game: state.game,
	    menu: state.menu,
	    accounts: state.accounts,
	    WorldGame: state.contracts.WorldGame,
	    drizzleStatus: state.drizzleStatus,
	    web3: state.web3
	  };
	};
	
	var OverlayContainer = (0, _drizzleReact.drizzleConnect)(_Overlay2.default, mapStateToProps);
	exports.default = OverlayContainer;

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GameContainer = __webpack_require__(361);
	
	var _GameContainer2 = _interopRequireDefault(_GameContainer);
	
	var _MenuContainer = __webpack_require__(364);
	
	var _MenuContainer2 = _interopRequireDefault(_MenuContainer);
	
	var _CreateGameContainer = __webpack_require__(358);
	
	var _CreateGameContainer2 = _interopRequireDefault(_CreateGameContainer);
	
	var _OpenGame = __webpack_require__(366);
	
	var _OpenGame2 = _interopRequireDefault(_OpenGame);
	
	__webpack_require__(518);
	
	var _MenuActions = __webpack_require__(111);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WorldGame = function (_Component) {
	    _inherits(WorldGame, _Component);
	
	    function WorldGame(props, context) {
	        _classCallCheck(this, WorldGame);
	
	        // This binding is necessary to make `this` work in the callback
	        var _this = _possibleConstructorReturn(this, (WorldGame.__proto__ || Object.getPrototypeOf(WorldGame)).call(this, props));
	
	        _this.openGame = _this.openGame.bind(_this);
	        _this.selectPage = _this.selectPage.bind(_this);
	        return _this;
	    }
	
	    _createClass(WorldGame, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.dispatch((0, _MenuActions.syncGameCount)(this.context.drizzle));
	            this.props.dispatch((0, _MenuActions.syncGamesForAddress)(this.context.drizzle));
	        }
	    }, {
	        key: 'openGame',
	        value: function openGame(gameId) {
	            this.props.dispatch((0, _MenuActions.openGame)(gameId));
	        }
	    }, {
	        key: 'selectPage',
	        value: function selectPage(page) {
	            this.props.dispatch((0, _MenuActions.selectPage)(page));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var selectedPage = this.props.menu.selectedPage;
	            var gameCountKey = this.props.menu.gameCountKey;
	            var gamesForAddressKey = this.props.menu.gamesForAddressKey;
	            var gameCount = 0;
	            var gamesForAddressList = [];
	            var gamesForAddressCount = [];
	
	            if (gameCountKey !== null && this.props.WorldGame.initialized && this.props.WorldGame.numberOfGames.hasOwnProperty(gameCountKey) && this.props.WorldGame.listGamesForAddress.hasOwnProperty(gamesForAddressKey)) {
	                gameCount = this.props.WorldGame.numberOfGames[gameCountKey].value;
	                var gamesForAddressResp = this.props.WorldGame.listGamesForAddress[gamesForAddressKey].value;
	                gamesForAddressList = gamesForAddressResp[0];
	                gamesForAddressCount = parseInt(gamesForAddressResp[1], 10);
	                gamesForAddressList = gamesForAddressList.slice(0, gamesForAddressCount);
	            }
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_MenuContainer2.default, null),
	                selectedPage === "open" && _react2.default.createElement(_OpenGame2.default, { onOpenGame: this.openGame, onSelectPage: this.selectPage, gameCount: gameCount, gamesForAddressList: gamesForAddressList }),
	                selectedPage === "create" && _react2.default.createElement(_CreateGameContainer2.default, null),
	                selectedPage === "game" && _react2.default.createElement(_GameContainer2.default, { gameId: this.props.menu.selectedGameId })
	            );
	        }
	    }]);
	
	    return WorldGame;
	}(_react.Component);
	
	WorldGame.contextTypes = {
	    drizzle: _propTypes2.default.object
	};
	
	exports.default = WorldGame;

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _WorldGame = __webpack_require__(369);
	
	var _WorldGame2 = _interopRequireDefault(_WorldGame);
	
	var _drizzleReact = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    game: state.game,
	    menu: state.menu,
	    accounts: state.accounts,
	    WorldGame: state.contracts.WorldGame,
	    drizzleStatus: state.drizzleStatus,
	    web3: state.web3
	  };
	};
	
	var WorldGameContainer = (0, _drizzleReact.drizzleConnect)(_WorldGame2.default, mapStateToProps);
	exports.default = WorldGameContainer;

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(610);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(289);
	
	var _reactRouterRedux = __webpack_require__(159);
	
	var _drizzleReact = __webpack_require__(39);
	
	var _App = __webpack_require__(354);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _HomeContainer = __webpack_require__(373);
	
	var _HomeContainer2 = _interopRequireDefault(_HomeContainer);
	
	var _WrongNetwork = __webpack_require__(374);
	
	var _WrongNetwork2 = _interopRequireDefault(_WrongNetwork);
	
	var _drizzleReactComponents = __webpack_require__(480);
	
	var _store = __webpack_require__(377);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _drizzleOptions = __webpack_require__(179);
	
	var _drizzleOptions2 = _interopRequireDefault(_drizzleOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Initialize react-router-redux.
	
	
	// Layouts
	var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, _store2.default);
	
	_reactDom2.default.render(_react2.default.createElement(
	  _drizzleReact.DrizzleProvider,
	  { options: _drizzleOptions2.default, store: _store2.default },
	  _react2.default.createElement(
	    _drizzleReactComponents.LoadingContainer,
	    { loadingComp: _react2.default.createElement(_WrongNetwork2.default, null) },
	    _react2.default.createElement(
	      _reactRouter.Router,
	      { history: history },
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: '/', component: _App2.default },
	        _react2.default.createElement(_reactRouter.IndexRoute, { component: _HomeContainer2.default })
	      )
	    )
	  )
	), document.getElementById('root'));

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WorldGameContainer = __webpack_require__(370);
	
	var _WorldGameContainer2 = _interopRequireDefault(_WorldGameContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Home = function (_Component) {
	    _inherits(Home, _Component);
	
	    function Home() {
	        _classCallCheck(this, Home);
	
	        return _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).apply(this, arguments));
	    }
	
	    _createClass(Home, [{
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'main',
	                null,
	                _react2.default.createElement(_WorldGameContainer2.default, null)
	            );
	        }
	    }]);
	
	    return Home;
	}(_react.Component);
	
	exports.default = Home;

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Home = __webpack_require__(372);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _drizzleReact = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// May still need this even with data function to refresh component on updates for this contract.
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    game: state.game,
	    accounts: state.accounts,
	    WorldGame: state.contracts.WorldGame,
	    drizzleStatus: state.drizzleStatus
	  };
	};
	
	var HomeContainer = (0, _drizzleReact.drizzleConnect)(_Home2.default, mapStateToProps);
	
	exports.default = HomeContainer;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(519);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WrongNetwork = function (_Component) {
	    _inherits(WrongNetwork, _Component);
	
	    function WrongNetwork(props) {
	        _classCallCheck(this, WrongNetwork);
	
	        var _this = _possibleConstructorReturn(this, (WrongNetwork.__proto__ || Object.getPrototypeOf(WrongNetwork)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(WrongNetwork, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'loadingCnt' },
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    '\uD83E\uDD8A'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Please check and make sure Metamask is using Rinkeby Test Network...'
	                )
	            );
	        }
	    }]);
	
	    return WrongNetwork;
	}(_react.Component);
	
	exports.default = WrongNetwork;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(168);
	
	var _reactRouterRedux = __webpack_require__(159);
	
	var _drizzle = __webpack_require__(90);
	
	var _GameReducer = __webpack_require__(362);
	
	var _GameReducer2 = _interopRequireDefault(_GameReducer);
	
	var _CreateGameReducer = __webpack_require__(359);
	
	var _CreateGameReducer2 = _interopRequireDefault(_CreateGameReducer);
	
	var _MenuReducer = __webpack_require__(365);
	
	var _MenuReducer2 = _interopRequireDefault(_MenuReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reducer = (0, _redux.combineReducers)(Object.assign({
	  game: _GameReducer2.default,
	  createGame: _CreateGameReducer2.default,
	  menu: _MenuReducer2.default,
	  routing: _reactRouterRedux.routerReducer
	}, _drizzle.drizzleReducers));
	
	exports.default = reducer;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(378);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = root;
	
	var _effects = __webpack_require__(300);
	
	var _drizzle = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [root].map(_regenerator2.default.mark);
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.all)(_drizzle.drizzleSagas.map(function (saga) {
	            return (0, _effects.fork)(saga);
	          }));
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRouter = __webpack_require__(289);
	
	var _redux = __webpack_require__(168);
	
	var _reduxThunk = __webpack_require__(716);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reactRouterRedux = __webpack_require__(159);
	
	var _reducer = __webpack_require__(375);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _rootSaga = __webpack_require__(376);
	
	var _rootSaga2 = _interopRequireDefault(_rootSaga);
	
	var _reduxSaga = __webpack_require__(710);
	
	var _reduxSaga2 = _interopRequireDefault(_reduxSaga);
	
	var _drizzle = __webpack_require__(90);
	
	var _drizzleOptions = __webpack_require__(179);
	
	var _drizzleOptions2 = _interopRequireDefault(_drizzleOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Redux DevTools
	var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
	
	var routingMiddleware = (0, _reactRouterRedux.routerMiddleware)(_reactRouter.browserHistory);
	var sagaMiddleware = (0, _reduxSaga2.default)();
	
	var initialState = {
	  contracts: (0, _drizzle.generateContractsInitialState)(_drizzleOptions2.default)
	};
	
	var store = (0, _redux.createStore)(_reducer2.default, initialState, composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk2.default, routingMiddleware, sagaMiddleware)));
	
	sagaMiddleware.run(_rootSaga2.default);
	
	exports.default = store;

/***/ },
/* 378 */
[791, 379],
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(380);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 380 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(392), __esModule: true };

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(393), __esModule: true };

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(394), __esModule: true };

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(395), __esModule: true };

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(397), __esModule: true };

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(398), __esModule: true };

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _promise = __webpack_require__(181);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new _promise2.default(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return _promise2.default.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};

/***/ },
/* 388 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(382);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(384);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(381);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(182);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(182);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(424);
	var $Object = __webpack_require__(17).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(425);
	var $Object = __webpack_require__(17).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(426);
	module.exports = __webpack_require__(17).Object.getPrototypeOf;


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(427);
	module.exports = __webpack_require__(17).Object.setPrototypeOf;


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(199);
	__webpack_require__(200);
	__webpack_require__(201);
	__webpack_require__(428);
	__webpack_require__(430);
	__webpack_require__(431);
	module.exports = __webpack_require__(17).Promise;


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(429);
	__webpack_require__(199);
	__webpack_require__(432);
	__webpack_require__(433);
	module.exports = __webpack_require__(17).Symbol;


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(200);
	__webpack_require__(201);
	module.exports = __webpack_require__(124).f('iterator');


/***/ },
/* 399 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 400 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(51);
	var toLength = __webpack_require__(197);
	var toAbsoluteIndex = __webpack_require__(421);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(117);
	var gOPS = __webpack_require__(189);
	var pIE = __webpack_require__(118);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(69);
	var call = __webpack_require__(408);
	var isArrayIter = __webpack_require__(406);
	var anObject = __webpack_require__(30);
	var toLength = __webpack_require__(197);
	var getIterFn = __webpack_require__(422);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 404 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(68);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(71);
	var ITERATOR = __webpack_require__(19)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(68);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(30);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(116);
	var descriptor = __webpack_require__(85);
	var setToStringTag = __webpack_require__(86);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(44)(IteratorPrototype, __webpack_require__(19)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(19)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 411 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(87)('meta');
	var isObject = __webpack_require__(36);
	var has = __webpack_require__(43);
	var setDesc = __webpack_require__(37).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(70)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(18);
	var macrotask = __webpack_require__(196).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(68)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve();
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(37);
	var anObject = __webpack_require__(30);
	var getKeys = __webpack_require__(117);
	
	module.exports = __webpack_require__(35) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(51);
	var gOPN = __webpack_require__(188).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(31);
	var core = __webpack_require__(17);
	var fails = __webpack_require__(70);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(44);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(36);
	var anObject = __webpack_require__(30);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(69)(Function.call, __webpack_require__(187).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(18);
	var core = __webpack_require__(17);
	var dP = __webpack_require__(37);
	var DESCRIPTORS = __webpack_require__(35);
	var SPECIES = __webpack_require__(19)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(121);
	var defined = __webpack_require__(112);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(121);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(183);
	var ITERATOR = __webpack_require__(19)('iterator');
	var Iterators = __webpack_require__(71);
	module.exports = __webpack_require__(17).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(399);
	var step = __webpack_require__(411);
	var Iterators = __webpack_require__(71);
	var toIObject = __webpack_require__(51);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(186)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(31);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(116) });


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(31);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(35), 'Object', { defineProperty: __webpack_require__(37).f });


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(198);
	var $getPrototypeOf = __webpack_require__(190);
	
	__webpack_require__(416)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(31);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(418).set });


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(84);
	var global = __webpack_require__(18);
	var ctx = __webpack_require__(69);
	var classof = __webpack_require__(183);
	var $export = __webpack_require__(31);
	var isObject = __webpack_require__(36);
	var aFunction = __webpack_require__(83);
	var anInstance = __webpack_require__(400);
	var forOf = __webpack_require__(403);
	var speciesConstructor = __webpack_require__(195);
	var task = __webpack_require__(196).set;
	var microtask = __webpack_require__(413)();
	var newPromiseCapabilityModule = __webpack_require__(115);
	var perform = __webpack_require__(192);
	var promiseResolve = __webpack_require__(193);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(19)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value);
	            if (domain) domain.exit();
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(417)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(86)($Promise, PROMISE);
	__webpack_require__(419)(PROMISE);
	Wrapper = __webpack_require__(17)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(410)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(18);
	var has = __webpack_require__(43);
	var DESCRIPTORS = __webpack_require__(35);
	var $export = __webpack_require__(31);
	var redefine = __webpack_require__(194);
	var META = __webpack_require__(412).KEY;
	var $fails = __webpack_require__(70);
	var shared = __webpack_require__(120);
	var setToStringTag = __webpack_require__(86);
	var uid = __webpack_require__(87);
	var wks = __webpack_require__(19);
	var wksExt = __webpack_require__(124);
	var wksDefine = __webpack_require__(123);
	var enumKeys = __webpack_require__(402);
	var isArray = __webpack_require__(407);
	var anObject = __webpack_require__(30);
	var isObject = __webpack_require__(36);
	var toIObject = __webpack_require__(51);
	var toPrimitive = __webpack_require__(122);
	var createDesc = __webpack_require__(85);
	var _create = __webpack_require__(116);
	var gOPNExt = __webpack_require__(415);
	var $GOPD = __webpack_require__(187);
	var $DP = __webpack_require__(37);
	var $keys = __webpack_require__(117);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(188).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(118).f = $propertyIsEnumerable;
	  __webpack_require__(189).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(84)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(44)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(31);
	var core = __webpack_require__(17);
	var global = __webpack_require__(18);
	var speciesConstructor = __webpack_require__(195);
	var promiseResolve = __webpack_require__(193);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(31);
	var newPromiseCapability = __webpack_require__(115);
	var perform = __webpack_require__(192);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(123)('asyncIterator');


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(123)('observable');


/***/ },
/* 434 */
[791, 720],
/* 435 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}
	
	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return (b64.length * 3 / 4) - placeHoldersCount(b64)
	}
	
	function toByteArray (b64) {
	  var i, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)
	
	  arr = new Arr((len * 3 / 4) - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0; i < l; i += 4) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = ((uint8[i] << 16) & 0xFF0000) + ((uint8[i + 1] << 8) & 0xFF00) + (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	var AuthCipher = __webpack_require__(203)
	var Buffer = __webpack_require__(4).Buffer
	var MODES = __webpack_require__(126)
	var StreamCipher = __webpack_require__(206)
	var Transform = __webpack_require__(38)
	var aes = __webpack_require__(88)
	var ebtk = __webpack_require__(94)
	var inherits = __webpack_require__(2)
	
	function Decipher (mode, key, iv) {
	  Transform.call(this)
	
	  this._cache = new Splitter()
	  this._last = void 0
	  this._cipher = new aes.AES(key)
	  this._prev = Buffer.from(iv)
	  this._mode = mode
	  this._autopadding = true
	}
	
	inherits(Decipher, Transform)
	
	Decipher.prototype._update = function (data) {
	  this._cache.add(data)
	  var chunk
	  var thing
	  var out = []
	  while ((chunk = this._cache.get(this._autopadding))) {
	    thing = this._mode.decrypt(this, chunk)
	    out.push(thing)
	  }
	  return Buffer.concat(out)
	}
	
	Decipher.prototype._final = function () {
	  var chunk = this._cache.flush()
	  if (this._autopadding) {
	    return unpad(this._mode.decrypt(this, chunk))
	  } else if (chunk) {
	    throw new Error('data not multiple of block length')
	  }
	}
	
	Decipher.prototype.setAutoPadding = function (setTo) {
	  this._autopadding = !!setTo
	  return this
	}
	
	function Splitter () {
	  this.cache = Buffer.allocUnsafe(0)
	}
	
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data])
	}
	
	Splitter.prototype.get = function (autoPadding) {
	  var out
	  if (autoPadding) {
	    if (this.cache.length > 16) {
	      out = this.cache.slice(0, 16)
	      this.cache = this.cache.slice(16)
	      return out
	    }
	  } else {
	    if (this.cache.length >= 16) {
	      out = this.cache.slice(0, 16)
	      this.cache = this.cache.slice(16)
	      return out
	    }
	  }
	
	  return null
	}
	
	Splitter.prototype.flush = function () {
	  if (this.cache.length) return this.cache
	}
	
	function unpad (last) {
	  var padded = last[15]
	  var i = -1
	  while (++i < padded) {
	    if (last[(i + (16 - padded))] !== padded) {
	      throw new Error('unable to decrypt data')
	    }
	  }
	  if (padded === 16) return
	
	  return last.slice(0, 16 - padded)
	}
	
	function createDecipheriv (suite, password, iv) {
	  var config = MODES[suite.toLowerCase()]
	  if (!config) throw new TypeError('invalid suite type')
	
	  if (typeof iv === 'string') iv = Buffer.from(iv)
	  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)
	
	  if (typeof password === 'string') password = Buffer.from(password)
	  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)
	
	  if (config.type === 'stream') {
	    return new StreamCipher(config.module, password, iv, true)
	  } else if (config.type === 'auth') {
	    return new AuthCipher(config.module, password, iv, true)
	  }
	
	  return new Decipher(config.module, password, iv)
	}
	
	function createDecipher (suite, password) {
	  var config = MODES[suite.toLowerCase()]
	  if (!config) throw new TypeError('invalid suite type')
	
	  var keys = ebtk(password, false, config.key, config.iv)
	  return createDecipheriv(suite, keys.key, keys.iv)
	}
	
	exports.createDecipher = createDecipher
	exports.createDecipheriv = createDecipheriv


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	var MODES = __webpack_require__(126)
	var AuthCipher = __webpack_require__(203)
	var Buffer = __webpack_require__(4).Buffer
	var StreamCipher = __webpack_require__(206)
	var Transform = __webpack_require__(38)
	var aes = __webpack_require__(88)
	var ebtk = __webpack_require__(94)
	var inherits = __webpack_require__(2)
	
	function Cipher (mode, key, iv) {
	  Transform.call(this)
	
	  this._cache = new Splitter()
	  this._cipher = new aes.AES(key)
	  this._prev = Buffer.from(iv)
	  this._mode = mode
	  this._autopadding = true
	}
	
	inherits(Cipher, Transform)
	
	Cipher.prototype._update = function (data) {
	  this._cache.add(data)
	  var chunk
	  var thing
	  var out = []
	
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.encrypt(this, chunk)
	    out.push(thing)
	  }
	
	  return Buffer.concat(out)
	}
	
	var PADDING = Buffer.alloc(16, 0x10)
	
	Cipher.prototype._final = function () {
	  var chunk = this._cache.flush()
	  if (this._autopadding) {
	    chunk = this._mode.encrypt(this, chunk)
	    this._cipher.scrub()
	    return chunk
	  }
	
	  if (!chunk.equals(PADDING)) {
	    this._cipher.scrub()
	    throw new Error('data not multiple of block length')
	  }
	}
	
	Cipher.prototype.setAutoPadding = function (setTo) {
	  this._autopadding = !!setTo
	  return this
	}
	
	function Splitter () {
	  this.cache = Buffer.allocUnsafe(0)
	}
	
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data])
	}
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 15) {
	    var out = this.cache.slice(0, 16)
	    this.cache = this.cache.slice(16)
	    return out
	  }
	  return null
	}
	
	Splitter.prototype.flush = function () {
	  var len = 16 - this.cache.length
	  var padBuff = Buffer.allocUnsafe(len)
	
	  var i = -1
	  while (++i < len) {
	    padBuff.writeUInt8(len, i)
	  }
	
	  return Buffer.concat([this.cache, padBuff])
	}
	
	function createCipheriv (suite, password, iv) {
	  var config = MODES[suite.toLowerCase()]
	  if (!config) throw new TypeError('invalid suite type')
	
	  if (typeof password === 'string') password = Buffer.from(password)
	  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)
	
	  if (typeof iv === 'string') iv = Buffer.from(iv)
	  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)
	
	  if (config.type === 'stream') {
	    return new StreamCipher(config.module, password, iv)
	  } else if (config.type === 'auth') {
	    return new AuthCipher(config.module, password, iv)
	  }
	
	  return new Cipher(config.module, password, iv)
	}
	
	function createCipher (suite, password) {
	  var config = MODES[suite.toLowerCase()]
	  if (!config) throw new TypeError('invalid suite type')
	
	  var keys = ebtk(password, false, config.key, config.iv)
	  return createCipheriv(suite, keys.key, keys.iv)
	}
	
	exports.createCipheriv = createCipheriv
	exports.createCipher = createCipher


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	var Buffer = __webpack_require__(4).Buffer
	var ZEROES = Buffer.alloc(16, 0)
	
	function toArray (buf) {
	  return [
	    buf.readUInt32BE(0),
	    buf.readUInt32BE(4),
	    buf.readUInt32BE(8),
	    buf.readUInt32BE(12)
	  ]
	}
	
	function fromArray (out) {
	  var buf = Buffer.allocUnsafe(16)
	  buf.writeUInt32BE(out[0] >>> 0, 0)
	  buf.writeUInt32BE(out[1] >>> 0, 4)
	  buf.writeUInt32BE(out[2] >>> 0, 8)
	  buf.writeUInt32BE(out[3] >>> 0, 12)
	  return buf
	}
	
	function GHASH (key) {
	  this.h = key
	  this.state = Buffer.alloc(16, 0)
	  this.cache = Buffer.allocUnsafe(0)
	}
	
	// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
	// by Juho Vähä-Herttua
	GHASH.prototype.ghash = function (block) {
	  var i = -1
	  while (++i < block.length) {
	    this.state[i] ^= block[i]
	  }
	  this._multiply()
	}
	
	GHASH.prototype._multiply = function () {
	  var Vi = toArray(this.h)
	  var Zi = [0, 0, 0, 0]
	  var j, xi, lsbVi
	  var i = -1
	  while (++i < 128) {
	    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
	    if (xi) {
	      // Z_i+1 = Z_i ^ V_i
	      Zi[0] ^= Vi[0]
	      Zi[1] ^= Vi[1]
	      Zi[2] ^= Vi[2]
	      Zi[3] ^= Vi[3]
	    }
	
	    // Store the value of LSB(V_i)
	    lsbVi = (Vi[3] & 1) !== 0
	
	    // V_i+1 = V_i >> 1
	    for (j = 3; j > 0; j--) {
	      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
	    }
	    Vi[0] = Vi[0] >>> 1
	
	    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
	    if (lsbVi) {
	      Vi[0] = Vi[0] ^ (0xe1 << 24)
	    }
	  }
	  this.state = fromArray(Zi)
	}
	
	GHASH.prototype.update = function (buf) {
	  this.cache = Buffer.concat([this.cache, buf])
	  var chunk
	  while (this.cache.length >= 16) {
	    chunk = this.cache.slice(0, 16)
	    this.cache = this.cache.slice(16)
	    this.ghash(chunk)
	  }
	}
	
	GHASH.prototype.final = function (abl, bl) {
	  if (this.cache.length) {
	    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
	  }
	
	  this.ghash(fromArray([0, abl, 0, bl]))
	  return this.state
	}
	
	module.exports = GHASH


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	var xor = __webpack_require__(72)
	
	exports.encrypt = function (self, block) {
	  var data = xor(block, self._prev)
	
	  self._prev = self._cipher.encryptBlock(data)
	  return self._prev
	}
	
	exports.decrypt = function (self, block) {
	  var pad = self._prev
	
	  self._prev = block
	  var out = self._cipher.decryptBlock(block)
	
	  return xor(out, pad)
	}


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	var Buffer = __webpack_require__(4).Buffer
	var xor = __webpack_require__(72)
	
	function encryptStart (self, data, decrypt) {
	  var len = data.length
	  var out = xor(data, self._cache)
	  self._cache = self._cache.slice(len)
	  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
	  return out
	}
	
	exports.encrypt = function (self, data, decrypt) {
	  var out = Buffer.allocUnsafe(0)
	  var len
	
	  while (data.length) {
	    if (self._cache.length === 0) {
	      self._cache = self._cipher.encryptBlock(self._prev)
	      self._prev = Buffer.allocUnsafe(0)
	    }
	
	    if (self._cache.length <= data.length) {
	      len = self._cache.length
	      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
	      data = data.slice(len)
	    } else {
	      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
	      break
	    }
	  }
	
	  return out
	}


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	var Buffer = __webpack_require__(4).Buffer
	
	function encryptByte (self, byteParam, decrypt) {
	  var pad
	  var i = -1
	  var len = 8
	  var out = 0
	  var bit, value
	  while (++i < len) {
	    pad = self._cipher.encryptBlock(self._prev)
	    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
	    value = pad[0] ^ bit
	    out += ((value & 0x80) >> (i % 8))
	    self._prev = shiftIn(self._prev, decrypt ? bit : value)
	  }
	  return out
	}
	
	function shiftIn (buffer, value) {
	  var len = buffer.length
	  var i = -1
	  var out = Buffer.allocUnsafe(buffer.length)
	  buffer = Buffer.concat([buffer, Buffer.from([value])])
	
	  while (++i < len) {
	    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
	  }
	
	  return out
	}
	
	exports.encrypt = function (self, chunk, decrypt) {
	  var len = chunk.length
	  var out = Buffer.allocUnsafe(len)
	  var i = -1
	
	  while (++i < len) {
	    out[i] = encryptByte(self, chunk[i], decrypt)
	  }
	
	  return out
	}


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	var Buffer = __webpack_require__(4).Buffer
	
	function encryptByte (self, byteParam, decrypt) {
	  var pad = self._cipher.encryptBlock(self._prev)
	  var out = pad[0] ^ byteParam
	
	  self._prev = Buffer.concat([
	    self._prev.slice(1),
	    Buffer.from([decrypt ? byteParam : out])
	  ])
	
	  return out
	}
	
	exports.encrypt = function (self, chunk, decrypt) {
	  var len = chunk.length
	  var out = Buffer.allocUnsafe(len)
	  var i = -1
	
	  while (++i < len) {
	    out[i] = encryptByte(self, chunk[i], decrypt)
	  }
	
	  return out
	}


/***/ },
/* 443 */
/***/ function(module, exports) {

	exports.encrypt = function (self, block) {
	  return self._cipher.encryptBlock(block)
	}
	
	exports.decrypt = function (self, block) {
	  return self._cipher.decryptBlock(block)
	}


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(72)
	
	function getBlock (self) {
	  self._prev = self._cipher.encryptBlock(self._prev)
	  return self._prev
	}
	
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)])
	  }
	
	  var pad = self._cache.slice(0, chunk.length)
	  self._cache = self._cache.slice(chunk.length)
	  return xor(chunk, pad)
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	var DES = __webpack_require__(446)
	var aes = __webpack_require__(125)
	var aesModes = __webpack_require__(126)
	var desModes = __webpack_require__(447)
	var ebtk = __webpack_require__(94)
	
	function createCipher (suite, password) {
	  suite = suite.toLowerCase()
	
	  var keyLen, ivLen
	  if (aesModes[suite]) {
	    keyLen = aesModes[suite].key
	    ivLen = aesModes[suite].iv
	  } else if (desModes[suite]) {
	    keyLen = desModes[suite].key * 8
	    ivLen = desModes[suite].iv
	  } else {
	    throw new TypeError('invalid suite type')
	  }
	
	  var keys = ebtk(password, false, keyLen, ivLen)
	  return createCipheriv(suite, keys.key, keys.iv)
	}
	
	function createDecipher (suite, password) {
	  suite = suite.toLowerCase()
	
	  var keyLen, ivLen
	  if (aesModes[suite]) {
	    keyLen = aesModes[suite].key
	    ivLen = aesModes[suite].iv
	  } else if (desModes[suite]) {
	    keyLen = desModes[suite].key * 8
	    ivLen = desModes[suite].iv
	  } else {
	    throw new TypeError('invalid suite type')
	  }
	
	  var keys = ebtk(password, false, keyLen, ivLen)
	  return createDecipheriv(suite, keys.key, keys.iv)
	}
	
	function createCipheriv (suite, key, iv) {
	  suite = suite.toLowerCase()
	  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
	  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })
	
	  throw new TypeError('invalid suite type')
	}
	
	function createDecipheriv (suite, key, iv) {
	  suite = suite.toLowerCase()
	  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
	  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })
	
	  throw new TypeError('invalid suite type')
	}
	
	function getCiphers () {
	  return Object.keys(desModes).concat(aes.getCiphers())
	}
	
	exports.createCipher = exports.Cipher = createCipher
	exports.createCipheriv = exports.Cipheriv = createCipheriv
	exports.createDecipher = exports.Decipher = createDecipher
	exports.createDecipheriv = exports.Decipheriv = createDecipheriv
	exports.listCiphers = exports.getCiphers = getCiphers


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	var CipherBase = __webpack_require__(38)
	var des = __webpack_require__(133)
	var inherits = __webpack_require__(2)
	var Buffer = __webpack_require__(448).Buffer
	
	var modes = {
	  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
	  'des-ede3': des.EDE,
	  'des-ede-cbc': des.CBC.instantiate(des.EDE),
	  'des-ede': des.EDE,
	  'des-cbc': des.CBC.instantiate(des.DES),
	  'des-ecb': des.DES
	}
	modes.des = modes['des-cbc']
	modes.des3 = modes['des-ede3-cbc']
	module.exports = DES
	inherits(DES, CipherBase)
	function DES (opts) {
	  CipherBase.call(this)
	  var modeName = opts.mode.toLowerCase()
	  var mode = modes[modeName]
	  var type
	  if (opts.decrypt) {
	    type = 'decrypt'
	  } else {
	    type = 'encrypt'
	  }
	  var key = opts.key
	  if (!Buffer.isBuffer(key)) {
	    key = Buffer.from(key)
	  }
	  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
	    key = Buffer.concat([key, key.slice(0, 8)])
	  }
	  var iv = opts.iv
	  if (!Buffer.isBuffer(iv)) {
	    iv = Buffer.from(iv)
	  }
	  this._des = mode.create({
	    key: key,
	    iv: iv,
	    type: type
	  })
	}
	DES.prototype._update = function (data) {
	  return Buffer.from(this._des.update(data))
	}
	DES.prototype._final = function () {
	  return Buffer.from(this._des.final())
	}


/***/ },
/* 447 */
/***/ function(module, exports) {

	exports['des-ecb'] = {
	  key: 8,
	  iv: 0
	}
	exports['des-cbc'] = exports.des = {
	  key: 8,
	  iv: 8
	}
	exports['des-ede3-cbc'] = exports.des3 = {
	  key: 24,
	  iv: 8
	}
	exports['des-ede3'] = {
	  key: 24,
	  iv: 0
	}
	exports['des-ede-cbc'] = {
	  key: 16,
	  iv: 8
	}
	exports['des-ede'] = {
	  key: 16,
	  iv: 0
	}


/***/ },
/* 448 */
4,
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(237)


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(74)
	var stream = __webpack_require__(82)
	var inherits = __webpack_require__(2)
	var sign = __webpack_require__(451)
	var verify = __webpack_require__(452)
	
	var algorithms = __webpack_require__(237)
	Object.keys(algorithms).forEach(function (key) {
	  algorithms[key].id = new Buffer(algorithms[key].id, 'hex')
	  algorithms[key.toLowerCase()] = algorithms[key]
	})
	
	function Sign (algorithm) {
	  stream.Writable.call(this)
	
	  var data = algorithms[algorithm]
	  if (!data) throw new Error('Unknown message digest')
	
	  this._hashType = data.hash
	  this._hash = createHash(data.hash)
	  this._tag = data.id
	  this._signType = data.sign
	}
	inherits(Sign, stream.Writable)
	
	Sign.prototype._write = function _write (data, _, done) {
	  this._hash.update(data)
	  done()
	}
	
	Sign.prototype.update = function update (data, enc) {
	  if (typeof data === 'string') data = new Buffer(data, enc)
	
	  this._hash.update(data)
	  return this
	}
	
	Sign.prototype.sign = function signMethod (key, enc) {
	  this.end()
	  var hash = this._hash.digest()
	  var sig = sign(hash, key, this._hashType, this._signType, this._tag)
	
	  return enc ? sig.toString(enc) : sig
	}
	
	function Verify (algorithm) {
	  stream.Writable.call(this)
	
	  var data = algorithms[algorithm]
	  if (!data) throw new Error('Unknown message digest')
	
	  this._hash = createHash(data.hash)
	  this._tag = data.id
	  this._signType = data.sign
	}
	inherits(Verify, stream.Writable)
	
	Verify.prototype._write = function _write (data, _, done) {
	  this._hash.update(data)
	  done()
	}
	
	Verify.prototype.update = function update (data, enc) {
	  if (typeof data === 'string') data = new Buffer(data, enc)
	
	  this._hash.update(data)
	  return this
	}
	
	Verify.prototype.verify = function verifyMethod (key, sig, enc) {
	  if (typeof sig === 'string') sig = new Buffer(sig, enc)
	
	  this.end()
	  var hash = this._hash.digest()
	  return verify(sig, hash, key, this._signType, this._tag)
	}
	
	function createSign (algorithm) {
	  return new Sign(algorithm)
	}
	
	function createVerify (algorithm) {
	  return new Verify(algorithm)
	}
	
	module.exports = {
	  Sign: createSign,
	  Verify: createVerify,
	  createSign: createSign,
	  createVerify: createVerify
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
	var createHmac = __webpack_require__(207)
	var crt = __webpack_require__(127)
	var EC = __webpack_require__(13).ec
	var BN = __webpack_require__(7)
	var parseKeys = __webpack_require__(100)
	var curves = __webpack_require__(238)
	
	function sign (hash, key, hashType, signType, tag) {
	  var priv = parseKeys(key)
	  if (priv.curve) {
	    // rsa keys can be interpreted as ecdsa ones in openssl
	    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
	    return ecSign(hash, priv)
	  } else if (priv.type === 'dsa') {
	    if (signType !== 'dsa') throw new Error('wrong private key type')
	    return dsaSign(hash, priv, hashType)
	  } else {
	    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
	  }
	  hash = Buffer.concat([tag, hash])
	  var len = priv.modulus.byteLength()
	  var pad = [ 0, 1 ]
	  while (hash.length + pad.length + 1 < len) pad.push(0xff)
	  pad.push(0x00)
	  var i = -1
	  while (++i < hash.length) pad.push(hash[i])
	
	  var out = crt(pad, priv)
	  return out
	}
	
	function ecSign (hash, priv) {
	  var curveId = curves[priv.curve.join('.')]
	  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))
	
	  var curve = new EC(curveId)
	  var key = curve.keyFromPrivate(priv.privateKey)
	  var out = key.sign(hash)
	
	  return new Buffer(out.toDER())
	}
	
	function dsaSign (hash, priv, algo) {
	  var x = priv.params.priv_key
	  var p = priv.params.p
	  var q = priv.params.q
	  var g = priv.params.g
	  var r = new BN(0)
	  var k
	  var H = bits2int(hash, q).mod(q)
	  var s = false
	  var kv = getKey(x, q, hash, algo)
	  while (s === false) {
	    k = makeKey(q, kv, algo)
	    r = makeR(g, k, p, q)
	    s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
	    if (s.cmpn(0) === 0) {
	      s = false
	      r = new BN(0)
	    }
	  }
	  return toDER(r, s)
	}
	
	function toDER (r, s) {
	  r = r.toArray()
	  s = s.toArray()
	
	  // Pad values
	  if (r[0] & 0x80) r = [ 0 ].concat(r)
	  if (s[0] & 0x80) s = [ 0 ].concat(s)
	
	  var total = r.length + s.length + 4
	  var res = [ 0x30, total, 0x02, r.length ]
	  res = res.concat(r, [ 0x02, s.length ], s)
	  return new Buffer(res)
	}
	
	function getKey (x, q, hash, algo) {
	  x = new Buffer(x.toArray())
	  if (x.length < q.byteLength()) {
	    var zeros = new Buffer(q.byteLength() - x.length)
	    zeros.fill(0)
	    x = Buffer.concat([ zeros, x ])
	  }
	  var hlen = hash.length
	  var hbits = bits2octets(hash, q)
	  var v = new Buffer(hlen)
	  v.fill(1)
	  var k = new Buffer(hlen)
	  k.fill(0)
	  k = createHmac(algo, k).update(v).update(new Buffer([ 0 ])).update(x).update(hbits).digest()
	  v = createHmac(algo, k).update(v).digest()
	  k = createHmac(algo, k).update(v).update(new Buffer([ 1 ])).update(x).update(hbits).digest()
	  v = createHmac(algo, k).update(v).digest()
	  return { k: k, v: v }
	}
	
	function bits2int (obits, q) {
	  var bits = new BN(obits)
	  var shift = (obits.length << 3) - q.bitLength()
	  if (shift > 0) bits.ishrn(shift)
	  return bits
	}
	
	function bits2octets (bits, q) {
	  bits = bits2int(bits, q)
	  bits = bits.mod(q)
	  var out = new Buffer(bits.toArray())
	  if (out.length < q.byteLength()) {
	    var zeros = new Buffer(q.byteLength() - out.length)
	    zeros.fill(0)
	    out = Buffer.concat([ zeros, out ])
	  }
	  return out
	}
	
	function makeKey (q, kv, algo) {
	  var t
	  var k
	
	  do {
	    t = new Buffer(0)
	
	    while (t.length * 8 < q.bitLength()) {
	      kv.v = createHmac(algo, kv.k).update(kv.v).digest()
	      t = Buffer.concat([ t, kv.v ])
	    }
	
	    k = bits2int(t, q)
	    kv.k = createHmac(algo, kv.k).update(kv.v).update(new Buffer([ 0 ])).digest()
	    kv.v = createHmac(algo, kv.k).update(kv.v).digest()
	  } while (k.cmp(q) !== -1)
	
	  return k
	}
	
	function makeR (g, k, p, q) {
	  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
	}
	
	module.exports = sign
	module.exports.getKey = getKey
	module.exports.makeKey = makeKey
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
	var BN = __webpack_require__(7)
	var EC = __webpack_require__(13).ec
	var parseKeys = __webpack_require__(100)
	var curves = __webpack_require__(238)
	
	function verify (sig, hash, key, signType, tag) {
	  var pub = parseKeys(key)
	  if (pub.type === 'ec') {
	    // rsa keys can be interpreted as ecdsa ones in openssl
	    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
	    return ecVerify(sig, hash, pub)
	  } else if (pub.type === 'dsa') {
	    if (signType !== 'dsa') throw new Error('wrong public key type')
	    return dsaVerify(sig, hash, pub)
	  } else {
	    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
	  }
	  hash = Buffer.concat([tag, hash])
	  var len = pub.modulus.byteLength()
	  var pad = [ 1 ]
	  var padNum = 0
	  while (hash.length + pad.length + 2 < len) {
	    pad.push(0xff)
	    padNum++
	  }
	  pad.push(0x00)
	  var i = -1
	  while (++i < hash.length) {
	    pad.push(hash[i])
	  }
	  pad = new Buffer(pad)
	  var red = BN.mont(pub.modulus)
	  sig = new BN(sig).toRed(red)
	
	  sig = sig.redPow(new BN(pub.publicExponent))
	  sig = new Buffer(sig.fromRed().toArray())
	  var out = padNum < 8 ? 1 : 0
	  len = Math.min(sig.length, pad.length)
	  if (sig.length !== pad.length) out = 1
	
	  i = -1
	  while (++i < len) out |= sig[i] ^ pad[i]
	  return out === 0
	}
	
	function ecVerify (sig, hash, pub) {
	  var curveId = curves[pub.data.algorithm.curve.join('.')]
	  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))
	
	  var curve = new EC(curveId)
	  var pubkey = pub.data.subjectPrivateKey.data
	
	  return curve.verify(hash, sig, pubkey)
	}
	
	function dsaVerify (sig, hash, pub) {
	  var p = pub.data.p
	  var q = pub.data.q
	  var g = pub.data.g
	  var y = pub.data.pub_key
	  var unpacked = parseKeys.signature.decode(sig, 'der')
	  var s = unpacked.s
	  var r = unpacked.r
	  checkValue(s, q)
	  checkValue(r, q)
	  var montp = BN.mont(p)
	  var w = s.invm(q)
	  var v = g.toRed(montp)
	    .redPow(new BN(hash).mul(w).mod(q))
	    .fromRed()
	    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
	    .mod(p)
	    .mod(q)
	  return v.cmp(r) === 0
	}
	
	function checkValue (b, q) {
	  if (b.cmpn(0) <= 0) throw new Error('invalid sig')
	  if (b.cmp(q) >= q) throw new Error('invalid sig')
	}
	
	module.exports = verify
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var elliptic = __webpack_require__(13)
	var BN = __webpack_require__(7)
	
	module.exports = function createECDH (curve) {
	  return new ECDH(curve)
	}
	
	var aliases = {
	  secp256k1: {
	    name: 'secp256k1',
	    byteLength: 32
	  },
	  secp224r1: {
	    name: 'p224',
	    byteLength: 28
	  },
	  prime256v1: {
	    name: 'p256',
	    byteLength: 32
	  },
	  prime192v1: {
	    name: 'p192',
	    byteLength: 24
	  },
	  ed25519: {
	    name: 'ed25519',
	    byteLength: 32
	  },
	  secp384r1: {
	    name: 'p384',
	    byteLength: 48
	  },
	  secp521r1: {
	    name: 'p521',
	    byteLength: 66
	  }
	}
	
	aliases.p224 = aliases.secp224r1
	aliases.p256 = aliases.secp256r1 = aliases.prime256v1
	aliases.p192 = aliases.secp192r1 = aliases.prime192v1
	aliases.p384 = aliases.secp384r1
	aliases.p521 = aliases.secp521r1
	
	function ECDH (curve) {
	  this.curveType = aliases[curve]
	  if (!this.curveType) {
	    this.curveType = {
	      name: curve
	    }
	  }
	  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
	  this.keys = void 0
	}
	
	ECDH.prototype.generateKeys = function (enc, format) {
	  this.keys = this.curve.genKeyPair()
	  return this.getPublicKey(enc, format)
	}
	
	ECDH.prototype.computeSecret = function (other, inenc, enc) {
	  inenc = inenc || 'utf8'
	  if (!Buffer.isBuffer(other)) {
	    other = new Buffer(other, inenc)
	  }
	  var otherPub = this.curve.keyFromPublic(other).getPublic()
	  var out = otherPub.mul(this.keys.getPrivate()).getX()
	  return formatReturnValue(out, enc, this.curveType.byteLength)
	}
	
	ECDH.prototype.getPublicKey = function (enc, format) {
	  var key = this.keys.getPublic(format === 'compressed', true)
	  if (format === 'hybrid') {
	    if (key[key.length - 1] % 2) {
	      key[0] = 7
	    } else {
	      key[0] = 6
	    }
	  }
	  return formatReturnValue(key, enc)
	}
	
	ECDH.prototype.getPrivateKey = function (enc) {
	  return formatReturnValue(this.keys.getPrivate(), enc)
	}
	
	ECDH.prototype.setPublicKey = function (pub, enc) {
	  enc = enc || 'utf8'
	  if (!Buffer.isBuffer(pub)) {
	    pub = new Buffer(pub, enc)
	  }
	  this.keys._importPublic(pub)
	  return this
	}
	
	ECDH.prototype.setPrivateKey = function (priv, enc) {
	  enc = enc || 'utf8'
	  if (!Buffer.isBuffer(priv)) {
	    priv = new Buffer(priv, enc)
	  }
	
	  var _priv = new BN(priv)
	  _priv = _priv.toString(16)
	  this.keys = this.curve.genKeyPair()
	  this.keys._importPrivate(_priv)
	  return this
	}
	
	function formatReturnValue (bn, enc, len) {
	  if (!Array.isArray(bn)) {
	    bn = bn.toArray()
	  }
	  var buf = new Buffer(bn)
	  if (len && buf.length < len) {
	    var zeros = new Buffer(len - buf.length)
	    zeros.fill(0)
	    buf = Buffer.concat([zeros, buf])
	  }
	  if (!enc) {
	    return buf
	  } else {
	    return buf.toString(enc)
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict'
	var intSize = 4
	var zeroBuffer = new Buffer(intSize)
	zeroBuffer.fill(0)
	
	var charSize = 8
	var hashSize = 16
	
	function toArray (buf) {
	  if ((buf.length % intSize) !== 0) {
	    var len = buf.length + (intSize - (buf.length % intSize))
	    buf = Buffer.concat([buf, zeroBuffer], len)
	  }
	
	  var arr = new Array(buf.length >>> 2)
	  for (var i = 0, j = 0; i < buf.length; i += intSize, j++) {
	    arr[j] = buf.readInt32LE(i)
	  }
	
	  return arr
	}
	
	module.exports = function hash (buf, fn) {
	  var arr = fn(toArray(buf), buf.length * charSize)
	  buf = new Buffer(hashSize)
	  for (var i = 0; i < arr.length; i++) {
	    buf.writeInt32LE(arr[i], i << 2, true)
	  }
	  return buf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	var inherits = __webpack_require__(2)
	var Buffer = __webpack_require__(4).Buffer
	
	var Base = __webpack_require__(38)
	
	var ZEROS = Buffer.alloc(128)
	var blocksize = 64
	
	function Hmac (alg, key) {
	  Base.call(this, 'digest')
	  if (typeof key === 'string') {
	    key = Buffer.from(key)
	  }
	
	  this._alg = alg
	  this._key = key
	
	  if (key.length > blocksize) {
	    key = alg(key)
	  } else if (key.length < blocksize) {
	    key = Buffer.concat([key, ZEROS], blocksize)
	  }
	
	  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
	  var opad = this._opad = Buffer.allocUnsafe(blocksize)
	
	  for (var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36
	    opad[i] = key[i] ^ 0x5C
	  }
	
	  this._hash = [ipad]
	}
	
	inherits(Hmac, Base)
	
	Hmac.prototype._update = function (data) {
	  this._hash.push(data)
	}
	
	Hmac.prototype._final = function () {
	  var h = this._alg(Buffer.concat(this._hash))
	  return this._alg(Buffer.concat([this._opad, h]))
	}
	module.exports = Hmac


/***/ },
/* 456 */
10,
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(209)
	
	var zeroBuffer = new Buffer(128)
	zeroBuffer.fill(0)
	
	module.exports = Hmac
	
	function Hmac (alg, key) {
	  if(!(this instanceof Hmac)) return new Hmac(alg, key)
	  this._opad = opad
	  this._alg = alg
	
	  var blocksize = (alg === 'sha512') ? 128 : 64
	
	  key = this._key = !Buffer.isBuffer(key) ? new Buffer(key) : key
	
	  if(key.length > blocksize) {
	    key = createHash(alg).update(key).digest()
	  } else if(key.length < blocksize) {
	    key = Buffer.concat([key, zeroBuffer], blocksize)
	  }
	
	  var ipad = this._ipad = new Buffer(blocksize)
	  var opad = this._opad = new Buffer(blocksize)
	
	  for(var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36
	    opad[i] = key[i] ^ 0x5C
	  }
	
	  this._hash = createHash(alg).update(ipad)
	}
	
	Hmac.prototype.update = function (data, enc) {
	  this._hash.update(data, enc)
	  return this
	}
	
	Hmac.prototype.digest = function (enc) {
	  var h = this._hash.digest()
	  return createHash(this._alg).update(this._opad).update(h).digest(enc)
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var intSize = 4;
	var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
	var chrsz = 8;
	
	function toArray(buf, bigEndian) {
	  if ((buf.length % intSize) !== 0) {
	    var len = buf.length + (intSize - (buf.length % intSize));
	    buf = Buffer.concat([buf, zeroBuffer], len);
	  }
	
	  var arr = [];
	  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
	  for (var i = 0; i < buf.length; i += intSize) {
	    arr.push(fn.call(buf, i));
	  }
	  return arr;
	}
	
	function toBuffer(arr, size, bigEndian) {
	  var buf = new Buffer(size);
	  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
	  for (var i = 0; i < arr.length; i++) {
	    fn.call(buf, arr[i], i * 4, true);
	  }
	  return buf;
	}
	
	function hash(buf, fn, hashSize, bigEndian) {
	  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
	  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
	  return toBuffer(arr, hashSize, bigEndian);
	}
	
	module.exports = { hash: hash };
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	var helpers = __webpack_require__(458);
	
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length
	 */
	function core_md5(x, len)
	{
	  /* append padding */
	  x[len >> 5] |= 0x80 << ((len) % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	  var a =  1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d =  271733878;
	
	  for(var i = 0; i < x.length; i += 16)
	  {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;
	
	    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
	    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
	    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
	    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
	    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
	    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
	    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
	    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
	    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
	    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
	    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
	    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
	    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
	    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
	    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
	    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);
	
	    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
	    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
	    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
	    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
	    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
	    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
	    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
	    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
	    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
	    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
	    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
	    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
	    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
	    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
	    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
	    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);
	
	    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
	    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
	    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
	    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
	    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
	    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
	    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
	    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
	    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
	    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
	    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
	    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
	    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
	    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
	    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
	    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);
	
	    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
	    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
	    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
	    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
	    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
	    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
	    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
	    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
	    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
	    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
	    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
	    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
	    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
	    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
	    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
	    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);
	
	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	  }
	  return Array(a, b, c, d);
	
	}
	
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	function md5_cmn(q, a, b, x, s, t)
	{
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
	}
	function md5_ff(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}
	function md5_gg(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}
	function md5_hh(a, b, c, d, x, s, t)
	{
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5_ii(a, b, c, d, x, s, t)
	{
	  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
	}
	
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add(x, y)
	{
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xFFFF);
	}
	
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function bit_rol(num, cnt)
	{
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	module.exports = function md5(buf) {
	  return helpers.hash(buf, core_md5, 16);
	};


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(130);
	var Transform = __webpack_require__(131);
	var inherits = __webpack_require__(2);
	var modes = __webpack_require__(132);
	var StreamCipher = __webpack_require__(216);
	var ebtk = __webpack_require__(210);
	
	inherits(Decipher, Transform);
	function Decipher(mode, key, iv) {
	  if (!(this instanceof Decipher)) {
	    return new Decipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._last = void 0;
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Decipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.decrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Decipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  if (!chunk) {
	    return next;
	  }
	
	  this.push(unpad(this._mode.decrypt(this, chunk)));
	
	  next();
	};
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 16) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  if (this.cache.length) {
	    return this.cache;
	  }
	};
	function unpad(last) {
	  var padded = last[15];
	  if (padded === 16) {
	    return;
	  }
	  return last.slice(0, 16 - padded);
	}
	
	var modelist = {
	  ECB: __webpack_require__(214),
	  CBC: __webpack_require__(211),
	  CFB: __webpack_require__(212),
	  OFB: __webpack_require__(215),
	  CTR: __webpack_require__(213)
	};
	
	module.exports = function (crypto) {
	  function createDecipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv, true);
	    }
	    return new Decipher(modelist[config.mode], password, iv);
	  }
	
	  function createDecipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createDecipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createDecipher: createDecipher,
	    createDecipheriv: createDecipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(130);
	var Transform = __webpack_require__(131);
	var inherits = __webpack_require__(2);
	var modes = __webpack_require__(132);
	var ebtk = __webpack_require__(210);
	var StreamCipher = __webpack_require__(216);
	inherits(Cipher, Transform);
	function Cipher(mode, key, iv) {
	  if (!(this instanceof Cipher)) {
	    return new Cipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Cipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.encrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Cipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  this.push(this._mode.encrypt(this, chunk));
	  this._cipher.scrub();
	  next();
	};
	
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 15) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  var len = 16 - this.cache.length;
	  var padBuff = new Buffer(len);
	
	  var i = -1;
	  while (++i < len) {
	    padBuff.writeUInt8(len, i);
	  }
	  var out = Buffer.concat([this.cache, padBuff]);
	  return out;
	};
	var modelist = {
	  ECB: __webpack_require__(214),
	  CBC: __webpack_require__(211),
	  CFB: __webpack_require__(212),
	  OFB: __webpack_require__(215),
	  CTR: __webpack_require__(213)
	};
	module.exports = function (crypto) {
	  function createCipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv);
	    }
	    return new Cipher(modelist[config.mode], password, iv);
	  }
	  function createCipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createCipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createCipher: createCipher,
	    createCipheriv: createCipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function (crypto, exports) {
	  exports = exports || {};
	  var ciphers = __webpack_require__(461)(crypto);
	  exports.createCipher = ciphers.createCipher;
	  exports.createCipheriv = ciphers.createCipheriv;
	  var deciphers = __webpack_require__(460)(crypto);
	  exports.createDecipher = deciphers.createDecipher;
	  exports.createDecipheriv = deciphers.createDecipheriv;
	  var modes = __webpack_require__(132);
	  function listCiphers () {
	    return Object.keys(modes);
	  }
	  exports.listCiphers = listCiphers;
	};
	


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = ripemd160
	
	
	
	/*
	CryptoJS v3.1.2
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.
	
	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	
	// Constants table
	var zl = [
	    0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	    7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	    3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	    1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	    4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13];
	var zr = [
	    5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	    6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	    15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	    8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	    12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11];
	var sl = [
	     11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	    7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	    11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	      11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	    9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ];
	var sr = [
	    8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	    9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	    9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	    15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	    8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ];
	
	var hl =  [ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E];
	var hr =  [ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000];
	
	var bytesToWords = function (bytes) {
	  var words = [];
	  for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
	    words[b >>> 5] |= bytes[i] << (24 - b % 32);
	  }
	  return words;
	};
	
	var wordsToBytes = function (words) {
	  var bytes = [];
	  for (var b = 0; b < words.length * 32; b += 8) {
	    bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	  }
	  return bytes;
	};
	
	var processBlock = function (H, M, offset) {
	
	  // Swap endian
	  for (var i = 0; i < 16; i++) {
	    var offset_i = offset + i;
	    var M_offset_i = M[offset_i];
	
	    // Swap
	    M[offset_i] = (
	        (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	        (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	    );
	  }
	
	  // Working variables
	  var al, bl, cl, dl, el;
	  var ar, br, cr, dr, er;
	
	  ar = al = H[0];
	  br = bl = H[1];
	  cr = cl = H[2];
	  dr = dl = H[3];
	  er = el = H[4];
	  // Computation
	  var t;
	  for (var i = 0; i < 80; i += 1) {
	    t = (al +  M[offset+zl[i]])|0;
	    if (i<16){
	        t +=  f1(bl,cl,dl) + hl[0];
	    } else if (i<32) {
	        t +=  f2(bl,cl,dl) + hl[1];
	    } else if (i<48) {
	        t +=  f3(bl,cl,dl) + hl[2];
	    } else if (i<64) {
	        t +=  f4(bl,cl,dl) + hl[3];
	    } else {// if (i<80) {
	        t +=  f5(bl,cl,dl) + hl[4];
	    }
	    t = t|0;
	    t =  rotl(t,sl[i]);
	    t = (t+el)|0;
	    al = el;
	    el = dl;
	    dl = rotl(cl, 10);
	    cl = bl;
	    bl = t;
	
	    t = (ar + M[offset+zr[i]])|0;
	    if (i<16){
	        t +=  f5(br,cr,dr) + hr[0];
	    } else if (i<32) {
	        t +=  f4(br,cr,dr) + hr[1];
	    } else if (i<48) {
	        t +=  f3(br,cr,dr) + hr[2];
	    } else if (i<64) {
	        t +=  f2(br,cr,dr) + hr[3];
	    } else {// if (i<80) {
	        t +=  f1(br,cr,dr) + hr[4];
	    }
	    t = t|0;
	    t =  rotl(t,sr[i]) ;
	    t = (t+er)|0;
	    ar = er;
	    er = dr;
	    dr = rotl(cr, 10);
	    cr = br;
	    br = t;
	  }
	  // Intermediate hash value
	  t    = (H[1] + cl + dr)|0;
	  H[1] = (H[2] + dl + er)|0;
	  H[2] = (H[3] + el + ar)|0;
	  H[3] = (H[4] + al + br)|0;
	  H[4] = (H[0] + bl + cr)|0;
	  H[0] =  t;
	};
	
	function f1(x, y, z) {
	  return ((x) ^ (y) ^ (z));
	}
	
	function f2(x, y, z) {
	  return (((x)&(y)) | ((~x)&(z)));
	}
	
	function f3(x, y, z) {
	  return (((x) | (~(y))) ^ (z));
	}
	
	function f4(x, y, z) {
	  return (((x) & (z)) | ((y)&(~(z))));
	}
	
	function f5(x, y, z) {
	  return ((x) ^ ((y) |(~(z))));
	}
	
	function rotl(x,n) {
	  return (x<<n) | (x>>>(32-n));
	}
	
	function ripemd160(message) {
	  var H = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0];
	
	  if (typeof message == 'string')
	    message = new Buffer(message, 'utf8');
	
	  var m = bytesToWords(message);
	
	  var nBitsLeft = message.length * 8;
	  var nBitsTotal = message.length * 8;
	
	  // Add padding
	  m[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	  m[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	      (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	      (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	  );
	
	  for (var i=0 ; i<m.length; i += 16) {
	    processBlock(H, m, i);
	  }
	
	  // Swap endian
	  for (var i = 0; i < 5; i++) {
	      // Shortcut
	    var H_i = H[i];
	
	    // Swap
	    H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	          (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	  }
	
	  var digestbytes = wordsToBytes(H);
	  return new Buffer(digestbytes);
	}
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 464 */
/***/ function(module, exports) {

	module.exports = function (Buffer) {
	
	  //prototype class for hash functions
	  function Hash (blockSize, finalSize) {
	    this._block = new Buffer(blockSize) //new Uint32Array(blockSize/4)
	    this._finalSize = finalSize
	    this._blockSize = blockSize
	    this._len = 0
	    this._s = 0
	  }
	
	  Hash.prototype.init = function () {
	    this._s = 0
	    this._len = 0
	  }
	
	  Hash.prototype.update = function (data, enc) {
	    if ("string" === typeof data) {
	      enc = enc || "utf8"
	      data = new Buffer(data, enc)
	    }
	
	    var l = this._len += data.length
	    var s = this._s = (this._s || 0)
	    var f = 0
	    var buffer = this._block
	
	    while (s < l) {
	      var t = Math.min(data.length, f + this._blockSize - (s % this._blockSize))
	      var ch = (t - f)
	
	      for (var i = 0; i < ch; i++) {
	        buffer[(s % this._blockSize) + i] = data[i + f]
	      }
	
	      s += ch
	      f += ch
	
	      if ((s % this._blockSize) === 0) {
	        this._update(buffer)
	      }
	    }
	    this._s = s
	
	    return this
	  }
	
	  Hash.prototype.digest = function (enc) {
	    // Suppose the length of the message M, in bits, is l
	    var l = this._len * 8
	
	    // Append the bit 1 to the end of the message
	    this._block[this._len % this._blockSize] = 0x80
	
	    // and then k zero bits, where k is the smallest non-negative solution to the equation (l + 1 + k) === finalSize mod blockSize
	    this._block.fill(0, this._len % this._blockSize + 1)
	
	    if (l % (this._blockSize * 8) >= this._finalSize * 8) {
	      this._update(this._block)
	      this._block.fill(0)
	    }
	
	    // to this append the block which is equal to the number l written in binary
	    // TODO: handle case where l is > Math.pow(2, 29)
	    this._block.writeInt32BE(l, this._blockSize - 4)
	
	    var hash = this._update(this._block) || this._hash()
	
	    return enc ? hash.toString(enc) : hash
	  }
	
	  Hash.prototype._update = function () {
	    throw new Error('_update must be implemented by subclass')
	  }
	
	  return Hash
	}


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	var exports = module.exports = function (alg) {
	  var Alg = exports[alg]
	  if(!Alg) throw new Error(alg + ' is not supported (we accept pull requests)')
	  return new Alg()
	}
	
	var Buffer = __webpack_require__(1).Buffer
	var Hash   = __webpack_require__(464)(Buffer)
	
	exports.sha1 = __webpack_require__(466)(Buffer, Hash)
	exports.sha256 = __webpack_require__(467)(Buffer, Hash)
	exports.sha512 = __webpack_require__(468)(Buffer, Hash)


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */
	
	var inherits = __webpack_require__(108).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var A = 0|0
	  var B = 4|0
	  var C = 8|0
	  var D = 12|0
	  var E = 16|0
	
	  var W = new (typeof Int32Array === 'undefined' ? Array : Int32Array)(80)
	
	  var POOL = []
	
	  function Sha1 () {
	    if(POOL.length)
	      return POOL.pop().init()
	
	    if(!(this instanceof Sha1)) return new Sha1()
	    this._w = W
	    Hash.call(this, 16*4, 14*4)
	
	    this._h = null
	    this.init()
	  }
	
	  inherits(Sha1, Hash)
	
	  Sha1.prototype.init = function () {
	    this._a = 0x67452301
	    this._b = 0xefcdab89
	    this._c = 0x98badcfe
	    this._d = 0x10325476
	    this._e = 0xc3d2e1f0
	
	    Hash.prototype.init.call(this)
	    return this
	  }
	
	  Sha1.prototype._POOL = POOL
	  Sha1.prototype._update = function (X) {
	
	    var a, b, c, d, e, _a, _b, _c, _d, _e
	
	    a = _a = this._a
	    b = _b = this._b
	    c = _c = this._c
	    d = _d = this._d
	    e = _e = this._e
	
	    var w = this._w
	
	    for(var j = 0; j < 80; j++) {
	      var W = w[j] = j < 16 ? X.readInt32BE(j*4)
	        : rol(w[j - 3] ^ w[j -  8] ^ w[j - 14] ^ w[j - 16], 1)
	
	      var t = add(
	        add(rol(a, 5), sha1_ft(j, b, c, d)),
	        add(add(e, W), sha1_kt(j))
	      )
	
	      e = d
	      d = c
	      c = rol(b, 30)
	      b = a
	      a = t
	    }
	
	    this._a = add(a, _a)
	    this._b = add(b, _b)
	    this._c = add(c, _c)
	    this._d = add(d, _d)
	    this._e = add(e, _e)
	  }
	
	  Sha1.prototype._hash = function () {
	    if(POOL.length < 100) POOL.push(this)
	    var H = new Buffer(20)
	    //console.log(this._a|0, this._b|0, this._c|0, this._d|0, this._e|0)
	    H.writeInt32BE(this._a|0, A)
	    H.writeInt32BE(this._b|0, B)
	    H.writeInt32BE(this._c|0, C)
	    H.writeInt32BE(this._d|0, D)
	    H.writeInt32BE(this._e|0, E)
	    return H
	  }
	
	  /*
	   * Perform the appropriate triplet combination function for the current
	   * iteration
	   */
	  function sha1_ft(t, b, c, d) {
	    if(t < 20) return (b & c) | ((~b) & d);
	    if(t < 40) return b ^ c ^ d;
	    if(t < 60) return (b & c) | (b & d) | (c & d);
	    return b ^ c ^ d;
	  }
	
	  /*
	   * Determine the appropriate additive constant for the current iteration
	   */
	  function sha1_kt(t) {
	    return (t < 20) ?  1518500249 : (t < 40) ?  1859775393 :
	           (t < 60) ? -1894007588 : -899497514;
	  }
	
	  /*
	   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	   * to work around bugs in some JS interpreters.
	   * //dominictarr: this is 10 years old, so maybe this can be dropped?)
	   *
	   */
	  function add(x, y) {
	    return (x + y ) | 0
	  //lets see how this goes on testling.
	  //  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  //  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  //  return (msw << 16) | (lsw & 0xFFFF);
	  }
	
	  /*
	   * Bitwise rotate a 32-bit number to the left.
	   */
	  function rol(num, cnt) {
	    return (num << cnt) | (num >>> (32 - cnt));
	  }
	
	  return Sha1
	}


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(108).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var K = [
	      0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
	      0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
	      0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
	      0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
	      0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
	      0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
	      0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
	      0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
	      0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
	      0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
	      0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
	      0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
	      0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
	      0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
	      0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
	      0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
	    ]
	
	  var W = new Array(64)
	
	  function Sha256() {
	    this.init()
	
	    this._w = W //new Array(64)
	
	    Hash.call(this, 16*4, 14*4)
	  }
	
	  inherits(Sha256, Hash)
	
	  Sha256.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, n) {
	    return (X >>> n) | (X << (32 - n));
	  }
	
	  function R (X, n) {
	    return (X >>> n);
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  function Sigma0256 (x) {
	    return (S(x, 2) ^ S(x, 13) ^ S(x, 22));
	  }
	
	  function Sigma1256 (x) {
	    return (S(x, 6) ^ S(x, 11) ^ S(x, 25));
	  }
	
	  function Gamma0256 (x) {
	    return (S(x, 7) ^ S(x, 18) ^ R(x, 3));
	  }
	
	  function Gamma1256 (x) {
	    return (S(x, 17) ^ S(x, 19) ^ R(x, 10));
	  }
	
	  Sha256.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var T1, T2
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    for (var j = 0; j < 64; j++) {
	      var w = W[j] = j < 16
	        ? M.readInt32BE(j * 4)
	        : Gamma1256(W[j - 2]) + W[j - 7] + Gamma0256(W[j - 15]) + W[j - 16]
	
	      T1 = h + Sigma1256(e) + Ch(e, f, g) + K[j] + w
	
	      T2 = Sigma0256(a) + Maj(a, b, c);
	      h = g; g = f; f = e; e = d + T1; d = c; c = b; b = a; a = T1 + T2;
	    }
	
	    this._a = (a + this._a) | 0
	    this._b = (b + this._b) | 0
	    this._c = (c + this._c) | 0
	    this._d = (d + this._d) | 0
	    this._e = (e + this._e) | 0
	    this._f = (f + this._f) | 0
	    this._g = (g + this._g) | 0
	    this._h = (h + this._h) | 0
	
	  };
	
	  Sha256.prototype._hash = function () {
	    var H = new Buffer(32)
	
	    H.writeInt32BE(this._a,  0)
	    H.writeInt32BE(this._b,  4)
	    H.writeInt32BE(this._c,  8)
	    H.writeInt32BE(this._d, 12)
	    H.writeInt32BE(this._e, 16)
	    H.writeInt32BE(this._f, 20)
	    H.writeInt32BE(this._g, 24)
	    H.writeInt32BE(this._h, 28)
	
	    return H
	  }
	
	  return Sha256
	
	}


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(108).inherits
	
	module.exports = function (Buffer, Hash) {
	  var K = [
	    0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	    0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	    0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	    0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	    0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	    0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	    0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	    0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	    0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	    0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	    0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	    0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	    0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	    0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	    0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	    0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	    0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	    0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	    0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	    0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	    0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	    0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	    0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	    0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	    0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	    0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	    0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	    0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	    0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	    0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	    0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	    0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	    0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	    0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	    0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	    0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	    0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	    0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	    0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	    0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	  ]
	
	  var W = new Array(160)
	
	  function Sha512() {
	    this.init()
	    this._w = W
	
	    Hash.call(this, 128, 112)
	  }
	
	  inherits(Sha512, Hash)
	
	  Sha512.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._al = 0xf3bcc908|0
	    this._bl = 0x84caa73b|0
	    this._cl = 0xfe94f82b|0
	    this._dl = 0x5f1d36f1|0
	    this._el = 0xade682d1|0
	    this._fl = 0x2b3e6c1f|0
	    this._gl = 0xfb41bd6b|0
	    this._hl = 0x137e2179|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, Xl, n) {
	    return (X >>> n) | (Xl << (32 - n))
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  Sha512.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var al, bl, cl, dl, el, fl, gl, hl
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    al = this._al | 0
	    bl = this._bl | 0
	    cl = this._cl | 0
	    dl = this._dl | 0
	    el = this._el | 0
	    fl = this._fl | 0
	    gl = this._gl | 0
	    hl = this._hl | 0
	
	    for (var i = 0; i < 80; i++) {
	      var j = i * 2
	
	      var Wi, Wil
	
	      if (i < 16) {
	        Wi = W[j] = M.readInt32BE(j * 4)
	        Wil = W[j + 1] = M.readInt32BE(j * 4 + 4)
	
	      } else {
	        var x  = W[j - 15*2]
	        var xl = W[j - 15*2 + 1]
	        var gamma0  = S(x, xl, 1) ^ S(x, xl, 8) ^ (x >>> 7)
	        var gamma0l = S(xl, x, 1) ^ S(xl, x, 8) ^ S(xl, x, 7)
	
	        x  = W[j - 2*2]
	        xl = W[j - 2*2 + 1]
	        var gamma1  = S(x, xl, 19) ^ S(xl, x, 29) ^ (x >>> 6)
	        var gamma1l = S(xl, x, 19) ^ S(x, xl, 29) ^ S(xl, x, 6)
	
	        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	        var Wi7  = W[j - 7*2]
	        var Wi7l = W[j - 7*2 + 1]
	
	        var Wi16  = W[j - 16*2]
	        var Wi16l = W[j - 16*2 + 1]
	
	        Wil = gamma0l + Wi7l
	        Wi  = gamma0  + Wi7 + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0)
	        Wil = Wil + gamma1l
	        Wi  = Wi  + gamma1  + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0)
	        Wil = Wil + Wi16l
	        Wi  = Wi  + Wi16 + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0)
	
	        W[j] = Wi
	        W[j + 1] = Wil
	      }
	
	      var maj = Maj(a, b, c)
	      var majl = Maj(al, bl, cl)
	
	      var sigma0h = S(a, al, 28) ^ S(al, a, 2) ^ S(al, a, 7)
	      var sigma0l = S(al, a, 28) ^ S(a, al, 2) ^ S(a, al, 7)
	      var sigma1h = S(e, el, 14) ^ S(e, el, 18) ^ S(el, e, 9)
	      var sigma1l = S(el, e, 14) ^ S(el, e, 18) ^ S(e, el, 9)
	
	      // t1 = h + sigma1 + ch + K[i] + W[i]
	      var Ki = K[j]
	      var Kil = K[j + 1]
	
	      var ch = Ch(e, f, g)
	      var chl = Ch(el, fl, gl)
	
	      var t1l = hl + sigma1l
	      var t1 = h + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0)
	      t1l = t1l + chl
	      t1 = t1 + ch + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0)
	      t1l = t1l + Kil
	      t1 = t1 + Ki + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0)
	      t1l = t1l + Wil
	      t1 = t1 + Wi + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0)
	
	      // t2 = sigma0 + maj
	      var t2l = sigma0l + majl
	      var t2 = sigma0h + maj + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0)
	
	      h  = g
	      hl = gl
	      g  = f
	      gl = fl
	      f  = e
	      fl = el
	      el = (dl + t1l) | 0
	      e  = (d + t1 + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	      d  = c
	      dl = cl
	      c  = b
	      cl = bl
	      b  = a
	      bl = al
	      al = (t1l + t2l) | 0
	      a  = (t1 + t2 + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0
	    }
	
	    this._al = (this._al + al) | 0
	    this._bl = (this._bl + bl) | 0
	    this._cl = (this._cl + cl) | 0
	    this._dl = (this._dl + dl) | 0
	    this._el = (this._el + el) | 0
	    this._fl = (this._fl + fl) | 0
	    this._gl = (this._gl + gl) | 0
	    this._hl = (this._hl + hl) | 0
	
	    this._a = (this._a + a + ((this._al >>> 0) < (al >>> 0) ? 1 : 0)) | 0
	    this._b = (this._b + b + ((this._bl >>> 0) < (bl >>> 0) ? 1 : 0)) | 0
	    this._c = (this._c + c + ((this._cl >>> 0) < (cl >>> 0) ? 1 : 0)) | 0
	    this._d = (this._d + d + ((this._dl >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	    this._e = (this._e + e + ((this._el >>> 0) < (el >>> 0) ? 1 : 0)) | 0
	    this._f = (this._f + f + ((this._fl >>> 0) < (fl >>> 0) ? 1 : 0)) | 0
	    this._g = (this._g + g + ((this._gl >>> 0) < (gl >>> 0) ? 1 : 0)) | 0
	    this._h = (this._h + h + ((this._hl >>> 0) < (hl >>> 0) ? 1 : 0)) | 0
	  }
	
	  Sha512.prototype._hash = function () {
	    var H = new Buffer(64)
	
	    function writeInt64BE(h, l, offset) {
	      H.writeInt32BE(h, offset)
	      H.writeInt32BE(l, offset + 4)
	    }
	
	    writeInt64BE(this._a, this._al, 0)
	    writeInt64BE(this._b, this._bl, 8)
	    writeInt64BE(this._c, this._cl, 16)
	    writeInt64BE(this._d, this._dl, 24)
	    writeInt64BE(this._e, this._el, 32)
	    writeInt64BE(this._f, this._fl, 40)
	    writeInt64BE(this._g, this._gl, 48)
	    writeInt64BE(this._h, this._hl, 56)
	
	    return H
	  }
	
	  return Sha512
	
	}


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	var pbkdf2Export = __webpack_require__(589)
	
	module.exports = function (crypto, exports) {
	  exports = exports || {}
	
	  var exported = pbkdf2Export(crypto)
	
	  exports.pbkdf2 = exported.pbkdf2
	  exports.pbkdf2Sync = exported.pbkdf2Sync
	
	  return exports
	}


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer) {(function() {
	  var g = ('undefined' === typeof window ? global : window) || {}
	  _crypto = (
	    g.crypto || g.msCrypto || __webpack_require__(788)
	  )
	  module.exports = function(size) {
	    // Modern Browsers
	    if(_crypto.getRandomValues) {
	      var bytes = new Buffer(size); //in browserify, this is an extended Uint8Array
	      /* This will not work in older browsers.
	       * See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
	       */
	    
	      _crypto.getRandomValues(bytes);
	      return bytes;
	    }
	    else if (_crypto.randomBytes) {
	      return _crypto.randomBytes(size)
	    }
	    else
	      throw new Error(
	        'secure random number generation not supported by this browser\n'+
	        'use chrome, FireFox or Internet Explorer 11'
	      )
	  }
	}())
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(1).Buffer))

/***/ },
/* 471 */
/***/ function(module, exports) {

	'use strict';
	var token = '%[a-f0-9]{2}';
	var singleMatcher = new RegExp(token, 'gi');
	var multiMatcher = new RegExp('(' + token + ')+', 'gi');
	
	function decodeComponents(components, split) {
		try {
			// Try to decode the entire string first
			return decodeURIComponent(components.join(''));
		} catch (err) {
			// Do nothing
		}
	
		if (components.length === 1) {
			return components;
		}
	
		split = split || 1;
	
		// Split the array in 2 parts
		var left = components.slice(0, split);
		var right = components.slice(split);
	
		return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
	}
	
	function decode(input) {
		try {
			return decodeURIComponent(input);
		} catch (err) {
			var tokens = input.match(singleMatcher);
	
			for (var i = 1; i < tokens.length; i++) {
				input = decodeComponents(tokens, i).join('');
	
				tokens = input.match(singleMatcher);
			}
	
			return input;
		}
	}
	
	function customDecodeURIComponent(input) {
		// Keep track of all the replacements and prefill the map with the `BOM`
		var replaceMap = {
			'%FE%FF': '\uFFFD\uFFFD',
			'%FF%FE': '\uFFFD\uFFFD'
		};
	
		var match = multiMatcher.exec(input);
		while (match) {
			try {
				// Decode as big chunks as possible
				replaceMap[match[0]] = decodeURIComponent(match[0]);
			} catch (err) {
				var result = decode(match[0]);
	
				if (result !== match[0]) {
					replaceMap[match[0]] = result;
				}
			}
	
			match = multiMatcher.exec(input);
		}
	
		// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
		replaceMap['%C2'] = '\uFFFD';
	
		var entries = Object.keys(replaceMap);
	
		for (var i = 0; i < entries.length; i++) {
			// Replace all decoded components
			var key = entries[i];
			input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
		}
	
		return input;
	}
	
	module.exports = function (encodedURI) {
		if (typeof encodedURI !== 'string') {
			throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
		}
	
		try {
			encodedURI = encodedURI.replace(/\+/g, ' ');
	
			// Try the built in decoder first
			return decodeURIComponent(encodedURI);
		} catch (err) {
			// Fallback to a more advanced decoder
			return customDecodeURIComponent(encodedURI);
		}
	};


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.deepmerge = factory());
	}(this, (function () { 'use strict';
	
	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};
	
	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}
	
	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);
	
		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}
	
	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
	
	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}
	
	function emptyTarget(val) {
		return Array.isArray(val) ? [] : {}
	}
	
	function cloneUnlessOtherwiseSpecified(value, options) {
		return (options.clone !== false && options.isMergeableObject(value))
			? deepmerge(emptyTarget(value), value, options)
			: value
	}
	
	function defaultArrayMerge(target, source, options) {
		return target.concat(source).map(function(element) {
			return cloneUnlessOtherwiseSpecified(element, options)
		})
	}
	
	function mergeObject(target, source, options) {
		var destination = {};
		if (options.isMergeableObject(target)) {
			Object.keys(target).forEach(function(key) {
				destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
			});
		}
		Object.keys(source).forEach(function(key) {
			if (!options.isMergeableObject(source[key]) || !target[key]) {
				destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
			} else {
				destination[key] = deepmerge(target[key], source[key], options);
			}
		});
		return destination
	}
	
	function deepmerge(target, source, options) {
		options = options || {};
		options.arrayMerge = options.arrayMerge || defaultArrayMerge;
		options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	
		var sourceIsArray = Array.isArray(source);
		var targetIsArray = Array.isArray(target);
		var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
	
		if (!sourceAndTargetTypesMatch) {
			return cloneUnlessOtherwiseSpecified(source, options)
		} else if (sourceIsArray) {
			return options.arrayMerge(target, source, options)
		} else {
			return mergeObject(target, source, options)
		}
	}
	
	deepmerge.all = function deepmergeAll(array, options) {
		if (!Array.isArray(array)) {
			throw new Error('first argument should be an array')
		}
	
		return array.reduce(function(prev, next) {
			return deepmerge(prev, next, options)
		}, {})
	};
	
	var deepmerge_1 = deepmerge;
	
	return deepmerge_1;
	
	})));


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var assert = __webpack_require__(21);
	var inherits = __webpack_require__(2);
	
	var proto = {};
	
	function CBCState(iv) {
	  assert.equal(iv.length, 8, 'Invalid IV length');
	
	  this.iv = new Array(8);
	  for (var i = 0; i < this.iv.length; i++)
	    this.iv[i] = iv[i];
	}
	
	function instantiate(Base) {
	  function CBC(options) {
	    Base.call(this, options);
	    this._cbcInit();
	  }
	  inherits(CBC, Base);
	
	  var keys = Object.keys(proto);
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    CBC.prototype[key] = proto[key];
	  }
	
	  CBC.create = function create(options) {
	    return new CBC(options);
	  };
	
	  return CBC;
	}
	
	exports.instantiate = instantiate;
	
	proto._cbcInit = function _cbcInit() {
	  var state = new CBCState(this.options.iv);
	  this._cbcState = state;
	};
	
	proto._update = function _update(inp, inOff, out, outOff) {
	  var state = this._cbcState;
	  var superProto = this.constructor.super_.prototype;
	
	  var iv = state.iv;
	  if (this.type === 'encrypt') {
	    for (var i = 0; i < this.blockSize; i++)
	      iv[i] ^= inp[inOff + i];
	
	    superProto._update.call(this, iv, 0, out, outOff);
	
	    for (var i = 0; i < this.blockSize; i++)
	      iv[i] = out[outOff + i];
	  } else {
	    superProto._update.call(this, inp, inOff, out, outOff);
	
	    for (var i = 0; i < this.blockSize; i++)
	      out[outOff + i] ^= iv[i];
	
	    for (var i = 0; i < this.blockSize; i++)
	      iv[i] = inp[inOff + i];
	  }
	};


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var assert = __webpack_require__(21);
	
	function Cipher(options) {
	  this.options = options;
	
	  this.type = this.options.type;
	  this.blockSize = 8;
	  this._init();
	
	  this.buffer = new Array(this.blockSize);
	  this.bufferOff = 0;
	}
	module.exports = Cipher;
	
	Cipher.prototype._init = function _init() {
	  // Might be overrided
	};
	
	Cipher.prototype.update = function update(data) {
	  if (data.length === 0)
	    return [];
	
	  if (this.type === 'decrypt')
	    return this._updateDecrypt(data);
	  else
	    return this._updateEncrypt(data);
	};
	
	Cipher.prototype._buffer = function _buffer(data, off) {
	  // Append data to buffer
	  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
	  for (var i = 0; i < min; i++)
	    this.buffer[this.bufferOff + i] = data[off + i];
	  this.bufferOff += min;
	
	  // Shift next
	  return min;
	};
	
	Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
	  this._update(this.buffer, 0, out, off);
	  this.bufferOff = 0;
	  return this.blockSize;
	};
	
	Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
	  var inputOff = 0;
	  var outputOff = 0;
	
	  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
	  var out = new Array(count * this.blockSize);
	
	  if (this.bufferOff !== 0) {
	    inputOff += this._buffer(data, inputOff);
	
	    if (this.bufferOff === this.buffer.length)
	      outputOff += this._flushBuffer(out, outputOff);
	  }
	
	  // Write blocks
	  var max = data.length - ((data.length - inputOff) % this.blockSize);
	  for (; inputOff < max; inputOff += this.blockSize) {
	    this._update(data, inputOff, out, outputOff);
	    outputOff += this.blockSize;
	  }
	
	  // Queue rest
	  for (; inputOff < data.length; inputOff++, this.bufferOff++)
	    this.buffer[this.bufferOff] = data[inputOff];
	
	  return out;
	};
	
	Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
	  var inputOff = 0;
	  var outputOff = 0;
	
	  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
	  var out = new Array(count * this.blockSize);
	
	  // TODO(indutny): optimize it, this is far from optimal
	  for (; count > 0; count--) {
	    inputOff += this._buffer(data, inputOff);
	    outputOff += this._flushBuffer(out, outputOff);
	  }
	
	  // Buffer rest of the input
	  inputOff += this._buffer(data, inputOff);
	
	  return out;
	};
	
	Cipher.prototype.final = function final(buffer) {
	  var first;
	  if (buffer)
	    first = this.update(buffer);
	
	  var last;
	  if (this.type === 'encrypt')
	    last = this._finalEncrypt();
	  else
	    last = this._finalDecrypt();
	
	  if (first)
	    return first.concat(last);
	  else
	    return last;
	};
	
	Cipher.prototype._pad = function _pad(buffer, off) {
	  if (off === 0)
	    return false;
	
	  while (off < buffer.length)
	    buffer[off++] = 0;
	
	  return true;
	};
	
	Cipher.prototype._finalEncrypt = function _finalEncrypt() {
	  if (!this._pad(this.buffer, this.bufferOff))
	    return [];
	
	  var out = new Array(this.blockSize);
	  this._update(this.buffer, 0, out, 0);
	  return out;
	};
	
	Cipher.prototype._unpad = function _unpad(buffer) {
	  return buffer;
	};
	
	Cipher.prototype._finalDecrypt = function _finalDecrypt() {
	  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
	  var out = new Array(this.blockSize);
	  this._flushBuffer(out, 0);
	
	  return this._unpad(out);
	};


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var assert = __webpack_require__(21);
	var inherits = __webpack_require__(2);
	
	var des = __webpack_require__(133);
	var utils = des.utils;
	var Cipher = des.Cipher;
	
	function DESState() {
	  this.tmp = new Array(2);
	  this.keys = null;
	}
	
	function DES(options) {
	  Cipher.call(this, options);
	
	  var state = new DESState();
	  this._desState = state;
	
	  this.deriveKeys(state, options.key);
	}
	inherits(DES, Cipher);
	module.exports = DES;
	
	DES.create = function create(options) {
	  return new DES(options);
	};
	
	var shiftTable = [
	  1, 1, 2, 2, 2, 2, 2, 2,
	  1, 2, 2, 2, 2, 2, 2, 1
	];
	
	DES.prototype.deriveKeys = function deriveKeys(state, key) {
	  state.keys = new Array(16 * 2);
	
	  assert.equal(key.length, this.blockSize, 'Invalid key length');
	
	  var kL = utils.readUInt32BE(key, 0);
	  var kR = utils.readUInt32BE(key, 4);
	
	  utils.pc1(kL, kR, state.tmp, 0);
	  kL = state.tmp[0];
	  kR = state.tmp[1];
	  for (var i = 0; i < state.keys.length; i += 2) {
	    var shift = shiftTable[i >>> 1];
	    kL = utils.r28shl(kL, shift);
	    kR = utils.r28shl(kR, shift);
	    utils.pc2(kL, kR, state.keys, i);
	  }
	};
	
	DES.prototype._update = function _update(inp, inOff, out, outOff) {
	  var state = this._desState;
	
	  var l = utils.readUInt32BE(inp, inOff);
	  var r = utils.readUInt32BE(inp, inOff + 4);
	
	  // Initial Permutation
	  utils.ip(l, r, state.tmp, 0);
	  l = state.tmp[0];
	  r = state.tmp[1];
	
	  if (this.type === 'encrypt')
	    this._encrypt(state, l, r, state.tmp, 0);
	  else
	    this._decrypt(state, l, r, state.tmp, 0);
	
	  l = state.tmp[0];
	  r = state.tmp[1];
	
	  utils.writeUInt32BE(out, l, outOff);
	  utils.writeUInt32BE(out, r, outOff + 4);
	};
	
	DES.prototype._pad = function _pad(buffer, off) {
	  var value = buffer.length - off;
	  for (var i = off; i < buffer.length; i++)
	    buffer[i] = value;
	
	  return true;
	};
	
	DES.prototype._unpad = function _unpad(buffer) {
	  var pad = buffer[buffer.length - 1];
	  for (var i = buffer.length - pad; i < buffer.length; i++)
	    assert.equal(buffer[i], pad);
	
	  return buffer.slice(0, buffer.length - pad);
	};
	
	DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
	  var l = lStart;
	  var r = rStart;
	
	  // Apply f() x16 times
	  for (var i = 0; i < state.keys.length; i += 2) {
	    var keyL = state.keys[i];
	    var keyR = state.keys[i + 1];
	
	    // f(r, k)
	    utils.expand(r, state.tmp, 0);
	
	    keyL ^= state.tmp[0];
	    keyR ^= state.tmp[1];
	    var s = utils.substitute(keyL, keyR);
	    var f = utils.permute(s);
	
	    var t = r;
	    r = (l ^ f) >>> 0;
	    l = t;
	  }
	
	  // Reverse Initial Permutation
	  utils.rip(r, l, out, off);
	};
	
	DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
	  var l = rStart;
	  var r = lStart;
	
	  // Apply f() x16 times
	  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
	    var keyL = state.keys[i];
	    var keyR = state.keys[i + 1];
	
	    // f(r, k)
	    utils.expand(l, state.tmp, 0);
	
	    keyL ^= state.tmp[0];
	    keyR ^= state.tmp[1];
	    var s = utils.substitute(keyL, keyR);
	    var f = utils.permute(s);
	
	    var t = l;
	    l = (r ^ f) >>> 0;
	    r = t;
	  }
	
	  // Reverse Initial Permutation
	  utils.rip(l, r, out, off);
	};


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var assert = __webpack_require__(21);
	var inherits = __webpack_require__(2);
	
	var des = __webpack_require__(133);
	var Cipher = des.Cipher;
	var DES = des.DES;
	
	function EDEState(type, key) {
	  assert.equal(key.length, 24, 'Invalid key length');
	
	  var k1 = key.slice(0, 8);
	  var k2 = key.slice(8, 16);
	  var k3 = key.slice(16, 24);
	
	  if (type === 'encrypt') {
	    this.ciphers = [
	      DES.create({ type: 'encrypt', key: k1 }),
	      DES.create({ type: 'decrypt', key: k2 }),
	      DES.create({ type: 'encrypt', key: k3 })
	    ];
	  } else {
	    this.ciphers = [
	      DES.create({ type: 'decrypt', key: k3 }),
	      DES.create({ type: 'encrypt', key: k2 }),
	      DES.create({ type: 'decrypt', key: k1 })
	    ];
	  }
	}
	
	function EDE(options) {
	  Cipher.call(this, options);
	
	  var state = new EDEState(this.type, this.options.key);
	  this._edeState = state;
	}
	inherits(EDE, Cipher);
	
	module.exports = EDE;
	
	EDE.create = function create(options) {
	  return new EDE(options);
	};
	
	EDE.prototype._update = function _update(inp, inOff, out, outOff) {
	  var state = this._edeState;
	
	  state.ciphers[0]._update(inp, inOff, out, outOff);
	  state.ciphers[1]._update(out, outOff, out, outOff);
	  state.ciphers[2]._update(out, outOff, out, outOff);
	};
	
	EDE.prototype._pad = DES.prototype._pad;
	EDE.prototype._unpad = DES.prototype._unpad;


/***/ },
/* 477 */
/***/ function(module, exports) {

	'use strict';
	
	exports.readUInt32BE = function readUInt32BE(bytes, off) {
	  var res =  (bytes[0 + off] << 24) |
	             (bytes[1 + off] << 16) |
	             (bytes[2 + off] << 8) |
	             bytes[3 + off];
	  return res >>> 0;
	};
	
	exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
	  bytes[0 + off] = value >>> 24;
	  bytes[1 + off] = (value >>> 16) & 0xff;
	  bytes[2 + off] = (value >>> 8) & 0xff;
	  bytes[3 + off] = value & 0xff;
	};
	
	exports.ip = function ip(inL, inR, out, off) {
	  var outL = 0;
	  var outR = 0;
	
	  for (var i = 6; i >= 0; i -= 2) {
	    for (var j = 0; j <= 24; j += 8) {
	      outL <<= 1;
	      outL |= (inR >>> (j + i)) & 1;
	    }
	    for (var j = 0; j <= 24; j += 8) {
	      outL <<= 1;
	      outL |= (inL >>> (j + i)) & 1;
	    }
	  }
	
	  for (var i = 6; i >= 0; i -= 2) {
	    for (var j = 1; j <= 25; j += 8) {
	      outR <<= 1;
	      outR |= (inR >>> (j + i)) & 1;
	    }
	    for (var j = 1; j <= 25; j += 8) {
	      outR <<= 1;
	      outR |= (inL >>> (j + i)) & 1;
	    }
	  }
	
	  out[off + 0] = outL >>> 0;
	  out[off + 1] = outR >>> 0;
	};
	
	exports.rip = function rip(inL, inR, out, off) {
	  var outL = 0;
	  var outR = 0;
	
	  for (var i = 0; i < 4; i++) {
	    for (var j = 24; j >= 0; j -= 8) {
	      outL <<= 1;
	      outL |= (inR >>> (j + i)) & 1;
	      outL <<= 1;
	      outL |= (inL >>> (j + i)) & 1;
	    }
	  }
	  for (var i = 4; i < 8; i++) {
	    for (var j = 24; j >= 0; j -= 8) {
	      outR <<= 1;
	      outR |= (inR >>> (j + i)) & 1;
	      outR <<= 1;
	      outR |= (inL >>> (j + i)) & 1;
	    }
	  }
	
	  out[off + 0] = outL >>> 0;
	  out[off + 1] = outR >>> 0;
	};
	
	exports.pc1 = function pc1(inL, inR, out, off) {
	  var outL = 0;
	  var outR = 0;
	
	  // 7, 15, 23, 31, 39, 47, 55, 63
	  // 6, 14, 22, 30, 39, 47, 55, 63
	  // 5, 13, 21, 29, 39, 47, 55, 63
	  // 4, 12, 20, 28
	  for (var i = 7; i >= 5; i--) {
	    for (var j = 0; j <= 24; j += 8) {
	      outL <<= 1;
	      outL |= (inR >> (j + i)) & 1;
	    }
	    for (var j = 0; j <= 24; j += 8) {
	      outL <<= 1;
	      outL |= (inL >> (j + i)) & 1;
	    }
	  }
	  for (var j = 0; j <= 24; j += 8) {
	    outL <<= 1;
	    outL |= (inR >> (j + i)) & 1;
	  }
	
	  // 1, 9, 17, 25, 33, 41, 49, 57
	  // 2, 10, 18, 26, 34, 42, 50, 58
	  // 3, 11, 19, 27, 35, 43, 51, 59
	  // 36, 44, 52, 60
	  for (var i = 1; i <= 3; i++) {
	    for (var j = 0; j <= 24; j += 8) {
	      outR <<= 1;
	      outR |= (inR >> (j + i)) & 1;
	    }
	    for (var j = 0; j <= 24; j += 8) {
	      outR <<= 1;
	      outR |= (inL >> (j + i)) & 1;
	    }
	  }
	  for (var j = 0; j <= 24; j += 8) {
	    outR <<= 1;
	    outR |= (inL >> (j + i)) & 1;
	  }
	
	  out[off + 0] = outL >>> 0;
	  out[off + 1] = outR >>> 0;
	};
	
	exports.r28shl = function r28shl(num, shift) {
	  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
	};
	
	var pc2table = [
	  // inL => outL
	  14, 11, 17, 4, 27, 23, 25, 0,
	  13, 22, 7, 18, 5, 9, 16, 24,
	  2, 20, 12, 21, 1, 8, 15, 26,
	
	  // inR => outR
	  15, 4, 25, 19, 9, 1, 26, 16,
	  5, 11, 23, 8, 12, 7, 17, 0,
	  22, 3, 10, 14, 6, 20, 27, 24
	];
	
	exports.pc2 = function pc2(inL, inR, out, off) {
	  var outL = 0;
	  var outR = 0;
	
	  var len = pc2table.length >>> 1;
	  for (var i = 0; i < len; i++) {
	    outL <<= 1;
	    outL |= (inL >>> pc2table[i]) & 0x1;
	  }
	  for (var i = len; i < pc2table.length; i++) {
	    outR <<= 1;
	    outR |= (inR >>> pc2table[i]) & 0x1;
	  }
	
	  out[off + 0] = outL >>> 0;
	  out[off + 1] = outR >>> 0;
	};
	
	exports.expand = function expand(r, out, off) {
	  var outL = 0;
	  var outR = 0;
	
	  outL = ((r & 1) << 5) | (r >>> 27);
	  for (var i = 23; i >= 15; i -= 4) {
	    outL <<= 6;
	    outL |= (r >>> i) & 0x3f;
	  }
	  for (var i = 11; i >= 3; i -= 4) {
	    outR |= (r >>> i) & 0x3f;
	    outR <<= 6;
	  }
	  outR |= ((r & 0x1f) << 1) | (r >>> 31);
	
	  out[off + 0] = outL >>> 0;
	  out[off + 1] = outR >>> 0;
	};
	
	var sTable = [
	  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
	  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
	  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
	  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,
	
	  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
	  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
	  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
	  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,
	
	  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
	  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
	  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
	  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,
	
	  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
	  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
	  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
	  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,
	
	  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
	  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
	  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
	  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,
	
	  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
	  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
	  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
	  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,
	
	  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
	  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
	  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
	  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,
	
	  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
	  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
	  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
	  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
	];
	
	exports.substitute = function substitute(inL, inR) {
	  var out = 0;
	  for (var i = 0; i < 4; i++) {
	    var b = (inL >>> (18 - i * 6)) & 0x3f;
	    var sb = sTable[i * 0x40 + b];
	
	    out <<= 4;
	    out |= sb;
	  }
	  for (var i = 0; i < 4; i++) {
	    var b = (inR >>> (18 - i * 6)) & 0x3f;
	    var sb = sTable[4 * 0x40 + i * 0x40 + b];
	
	    out <<= 4;
	    out |= sb;
	  }
	  return out >>> 0;
	};
	
	var permuteTable = [
	  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
	  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
	];
	
	exports.permute = function permute(num) {
	  var out = 0;
	  for (var i = 0; i < permuteTable.length; i++) {
	    out <<= 1;
	    out |= (num >>> permuteTable[i]) & 0x1;
	  }
	  return out >>> 0;
	};
	
	exports.padSplit = function padSplit(num, size, group) {
	  var str = num.toString(2);
	  while (str.length < size)
	    str = '0' + str;
	
	  var out = [];
	  for (var i = 0; i < size; i += group)
	    out.push(str.slice(i, i + group));
	  return out.join(' ');
	};


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var generatePrime = __webpack_require__(217)
	var primes = __webpack_require__(554)
	
	var DH = __webpack_require__(479)
	
	function getDiffieHellman (mod) {
	  var prime = new Buffer(primes[mod].prime, 'hex')
	  var gen = new Buffer(primes[mod].gen, 'hex')
	
	  return new DH(prime, gen)
	}
	
	var ENCODINGS = {
	  'binary': true, 'hex': true, 'base64': true
	}
	
	function createDiffieHellman (prime, enc, generator, genc) {
	  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
	    return createDiffieHellman(prime, 'binary', enc, generator)
	  }
	
	  enc = enc || 'binary'
	  genc = genc || 'binary'
	  generator = generator || new Buffer([2])
	
	  if (!Buffer.isBuffer(generator)) {
	    generator = new Buffer(generator, genc)
	  }
	
	  if (typeof prime === 'number') {
	    return new DH(generatePrime(prime, generator), generator, true)
	  }
	
	  if (!Buffer.isBuffer(prime)) {
	    prime = new Buffer(prime, enc)
	  }
	
	  return new DH(prime, generator, true)
	}
	
	exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
	exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var BN = __webpack_require__(7);
	var MillerRabin = __webpack_require__(247);
	var millerRabin = new MillerRabin();
	var TWENTYFOUR = new BN(24);
	var ELEVEN = new BN(11);
	var TEN = new BN(10);
	var THREE = new BN(3);
	var SEVEN = new BN(7);
	var primes = __webpack_require__(217);
	var randomBytes = __webpack_require__(54);
	module.exports = DH;
	
	function setPublicKey(pub, enc) {
	  enc = enc || 'utf8';
	  if (!Buffer.isBuffer(pub)) {
	    pub = new Buffer(pub, enc);
	  }
	  this._pub = new BN(pub);
	  return this;
	}
	
	function setPrivateKey(priv, enc) {
	  enc = enc || 'utf8';
	  if (!Buffer.isBuffer(priv)) {
	    priv = new Buffer(priv, enc);
	  }
	  this._priv = new BN(priv);
	  return this;
	}
	
	var primeCache = {};
	function checkPrime(prime, generator) {
	  var gen = generator.toString('hex');
	  var hex = [gen, prime.toString(16)].join('_');
	  if (hex in primeCache) {
	    return primeCache[hex];
	  }
	  var error = 0;
	
	  if (prime.isEven() ||
	    !primes.simpleSieve ||
	    !primes.fermatTest(prime) ||
	    !millerRabin.test(prime)) {
	    //not a prime so +1
	    error += 1;
	
	    if (gen === '02' || gen === '05') {
	      // we'd be able to check the generator
	      // it would fail so +8
	      error += 8;
	    } else {
	      //we wouldn't be able to test the generator
	      // so +4
	      error += 4;
	    }
	    primeCache[hex] = error;
	    return error;
	  }
	  if (!millerRabin.test(prime.shrn(1))) {
	    //not a safe prime
	    error += 2;
	  }
	  var rem;
	  switch (gen) {
	    case '02':
	      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
	        // unsuidable generator
	        error += 8;
	      }
	      break;
	    case '05':
	      rem = prime.mod(TEN);
	      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
	        // prime mod 10 needs to equal 3 or 7
	        error += 8;
	      }
	      break;
	    default:
	      error += 4;
	  }
	  primeCache[hex] = error;
	  return error;
	}
	
	function DH(prime, generator, malleable) {
	  this.setGenerator(generator);
	  this.__prime = new BN(prime);
	  this._prime = BN.mont(this.__prime);
	  this._primeLen = prime.length;
	  this._pub = undefined;
	  this._priv = undefined;
	  this._primeCode = undefined;
	  if (malleable) {
	    this.setPublicKey = setPublicKey;
	    this.setPrivateKey = setPrivateKey;
	  } else {
	    this._primeCode = 8;
	  }
	}
	Object.defineProperty(DH.prototype, 'verifyError', {
	  enumerable: true,
	  get: function () {
	    if (typeof this._primeCode !== 'number') {
	      this._primeCode = checkPrime(this.__prime, this.__gen);
	    }
	    return this._primeCode;
	  }
	});
	DH.prototype.generateKeys = function () {
	  if (!this._priv) {
	    this._priv = new BN(randomBytes(this._primeLen));
	  }
	  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
	  return this.getPublicKey();
	};
	
	DH.prototype.computeSecret = function (other) {
	  other = new BN(other);
	  other = other.toRed(this._prime);
	  var secret = other.redPow(this._priv).fromRed();
	  var out = new Buffer(secret.toArray());
	  var prime = this.getPrime();
	  if (out.length < prime.length) {
	    var front = new Buffer(prime.length - out.length);
	    front.fill(0);
	    out = Buffer.concat([front, out]);
	  }
	  return out;
	};
	
	DH.prototype.getPublicKey = function getPublicKey(enc) {
	  return formatReturnValue(this._pub, enc);
	};
	
	DH.prototype.getPrivateKey = function getPrivateKey(enc) {
	  return formatReturnValue(this._priv, enc);
	};
	
	DH.prototype.getPrime = function (enc) {
	  return formatReturnValue(this.__prime, enc);
	};
	
	DH.prototype.getGenerator = function (enc) {
	  return formatReturnValue(this._gen, enc);
	};
	
	DH.prototype.setGenerator = function (gen, enc) {
	  enc = enc || 'utf8';
	  if (!Buffer.isBuffer(gen)) {
	    gen = new Buffer(gen, enc);
	  }
	  this.__gen = gen;
	  this._gen = new BN(gen);
	  return this;
	};
	
	function formatReturnValue(bn, enc) {
	  var buf = new Buffer(bn.toArray());
	  if (!enc) {
	    return buf;
	  } else {
	    return buf.toString(enc);
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(39), __webpack_require__(9), __webpack_require__(11));
		else if(typeof define === 'function' && define.amd)
			define(["drizzle-react", "react", "prop-types"], factory);
		else if(typeof exports === 'object')
			exports["drizzle-react-components"] = factory(require("drizzle-react"), require("react"), require("prop-types"));
		else
			root["drizzle-react-components"] = factory(root["drizzle-react"], root["react"], root["prop-types"]);
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 3);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LoadingContainer = exports.ContractForm = exports.ContractData = exports.AccountData = undefined;
	
	var _AccountData = __webpack_require__(4);
	
	var _AccountData2 = _interopRequireDefault(_AccountData);
	
	var _ContractData = __webpack_require__(5);
	
	var _ContractData2 = _interopRequireDefault(_ContractData);
	
	var _ContractForm = __webpack_require__(6);
	
	var _ContractForm2 = _interopRequireDefault(_ContractForm);
	
	var _LoadingContainer = __webpack_require__(7);
	
	var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AccountData = _AccountData2.default;
	exports.ContractData = _ContractData2.default;
	exports.ContractForm = _ContractForm2.default;
	exports.LoadingContainer = _LoadingContainer2.default;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _drizzleReact = __webpack_require__(0);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * Create component.
	 */
	
	var AccountData = function (_Component) {
	  _inherits(AccountData, _Component);
	
	  function AccountData(props, context) {
	    _classCallCheck(this, AccountData);
	
	    var _this = _possibleConstructorReturn(this, (AccountData.__proto__ || Object.getPrototypeOf(AccountData)).call(this, props));
	
	    _this.precisionRound = _this.precisionRound.bind(_this);
	    return _this;
	  }
	
	  _createClass(AccountData, [{
	    key: 'precisionRound',
	    value: function precisionRound(number, precision) {
	      var factor = Math.pow(10, precision);
	      return Math.round(number * factor) / factor;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // No accounts found.
	      if (Object.keys(this.props.accounts).length === 0) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          'Initializing...'
	        );
	      }
	
	      // Get account address and balance.
	      var address = this.props.accounts[this.props.accountIndex];
	      var balance = this.props.accountBalances[address];
	      var units = this.props.units ? this.props.units.charAt(0).toUpperCase() + this.props.units.slice(1) : 'Wei';
	
	      // Convert to given units.
	      if (this.props.units) {
	        balance = this.context.drizzle.web3.utils.fromWei(balance, this.props.units);
	      }
	
	      // Adjust to given precision.
	      if (this.props.precision) {
	        balance = this.precisionRound(balance, this.props.precision);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h4',
	          null,
	          address
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          balance,
	          ' ',
	          units
	        )
	      );
	    }
	  }]);
	
	  return AccountData;
	}(_react.Component);
	
	AccountData.contextTypes = {
	  drizzle: _propTypes2.default.object
	
	  /*
	   * Export connected component.
	   */
	
	};var mapStateToProps = function mapStateToProps(state) {
	  return {
	    accounts: state.accounts,
	    accountBalances: state.accountBalances
	  };
	};
	
	exports.default = (0, _drizzleReact.drizzleConnect)(AccountData, mapStateToProps);
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _drizzleReact = __webpack_require__(0);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * Create component.
	 */
	
	var ContractData = function (_Component) {
	  _inherits(ContractData, _Component);
	
	  function ContractData(props, context) {
	    var _this$contracts$_this;
	
	    _classCallCheck(this, ContractData);
	
	    var _this = _possibleConstructorReturn(this, (ContractData.__proto__ || Object.getPrototypeOf(ContractData)).call(this, props));
	
	    _this.contracts = context.drizzle.contracts;
	
	    // Get the contract ABI
	    var abi = _this.contracts[_this.props.contract].abi;
	
	    // Fetch initial value from chain and return cache key for reactive updates.
	    var methodArgs = _this.props.methodArgs ? _this.props.methodArgs : [];
	    _this.dataKey = (_this$contracts$_this = _this.contracts[_this.props.contract].methods[_this.props.method]).cacheCall.apply(_this$contracts$_this, _toConsumableArray(methodArgs));
	
	    // Iterate over abi for correct function.
	    for (var i = 0; i < abi.length; i++) {
	      if (abi[i].name === _this.props.method) {
	        _this.fnABI = abi[i];
	
	        break;
	      }
	    }
	    return _this;
	  }
	
	  _createClass(ContractData, [{
	    key: 'render',
	    value: function render() {
	      // Contract is not yet intialized.
	      if (!this.props.contracts[this.props.contract].initialized) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          'Initializing...'
	        );
	      }
	
	      // If the cache key we received earlier isn't in the store yet; the initial value is still being fetched.
	      if (!(this.dataKey in this.props.contracts[this.props.contract][this.props.method])) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          'Fetching...'
	        );
	      }
	
	      // Show a loading spinner for future updates.
	      var pendingSpinner = this.props.contracts[this.props.contract].synced ? '' : ' 🔄';
	
	      // Optionally hide loading spinner (EX: ERC20 token symbol).
	      if (this.props.hideIndicator) {
	        pendingSpinner = '';
	      }
	
	      var displayData = this.props.contracts[this.props.contract][this.props.method][this.dataKey].value;
	
	      // Optionally convert to UTF8
	      if (this.props.toUtf8) {
	        displayData = this.context.drizzle.web3.utils.hexToUtf8(displayData);
	      }
	
	      // Optionally convert to Ascii
	      if (this.props.toAscii) {
	        displayData = this.context.drizzle.web3.utils.hexToAscii(displayData);
	      }
	
	      // If return value is an array
	      if (typeof displayData === 'array') {
	        var displayListItems = displayData.map(function (datum, index) {
	          _react2.default.createElement(
	            'li',
	            { key: index },
	            datum,
	            pendingSpinner
	          );
	        });
	
	        return _react2.default.createElement(
	          'ul',
	          null,
	          displayListItems
	        );
	      }
	
	      // If retun value is an object
	      if ((typeof displayData === 'undefined' ? 'undefined' : _typeof(displayData)) === 'object') {
	        var i = 0;
	        var displayObjectProps = [];
	
	        Object.keys(displayData).forEach(function (key) {
	          if (i != key) {
	            displayObjectProps.push(_react2.default.createElement(
	              'li',
	              { key: i },
	              _react2.default.createElement(
	                'strong',
	                null,
	                key
	              ),
	              pendingSpinner,
	              _react2.default.createElement('br', null),
	              displayData[key]
	            ));
	          }
	
	          i++;
	        });
	
	        return _react2.default.createElement(
	          'ul',
	          null,
	          displayObjectProps
	        );
	      }
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        displayData,
	        pendingSpinner
	      );
	    }
	  }]);
	
	  return ContractData;
	}(_react.Component);
	
	ContractData.contextTypes = {
	  drizzle: _propTypes2.default.object
	
	  /*
	   * Export connected component.
	   */
	
	};var mapStateToProps = function mapStateToProps(state) {
	  return {
	    contracts: state.contracts
	  };
	};
	
	exports.default = (0, _drizzleReact.drizzleConnect)(ContractData, mapStateToProps);
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _drizzleReact = __webpack_require__(0);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * Create component.
	 */
	
	var ContractForm = function (_Component) {
	  _inherits(ContractForm, _Component);
	
	  function ContractForm(props, context) {
	    _classCallCheck(this, ContractForm);
	
	    var _this = _possibleConstructorReturn(this, (ContractForm.__proto__ || Object.getPrototypeOf(ContractForm)).call(this, props));
	
	    _this.handleInputChange = _this.handleInputChange.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	
	    _this.contracts = context.drizzle.contracts;
	
	    // Get the contract ABI
	    var abi = _this.contracts[_this.props.contract].abi;
	
	    _this.inputs = [];
	    var initialState = {};
	
	    // Iterate over abi for correct function.
	    for (var i = 0; i < abi.length; i++) {
	      if (abi[i].name === _this.props.method) {
	        _this.inputs = abi[i].inputs;
	
	        for (var i = 0; i < _this.inputs.length; i++) {
	          initialState[_this.inputs[i].name] = '';
	        }
	
	        break;
	      }
	    }
	
	    _this.state = initialState;
	    return _this;
	  }
	
	  _createClass(ContractForm, [{
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var _contracts$props$cont2;
	
	      if (this.props.sendArgs) {
	        var _contracts$props$cont;
	
	        return (_contracts$props$cont = this.contracts[this.props.contract].methods[this.props.method]).cacheSend.apply(_contracts$props$cont, _toConsumableArray(Object.values(this.state)).concat([this.props.sendArgs]));
	      }
	
	      (_contracts$props$cont2 = this.contracts[this.props.contract].methods[this.props.method]).cacheSend.apply(_contracts$props$cont2, _toConsumableArray(Object.values(this.state)));
	    }
	  }, {
	    key: 'handleInputChange',
	    value: function handleInputChange(event) {
	      this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }
	  }, {
	    key: 'translateType',
	    value: function translateType(type) {
	      switch (true) {
	        case /^uint/.test(type):
	          return 'number';
	          break;
	        case /^string/.test(type) || /^bytes/.test(type):
	          return 'text';
	          break;
	        case /^bool/.test(type):
	          return 'checkbox';
	          break;
	        default:
	          return 'text';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'form',
	        { className: 'pure-form pure-form-stacked' },
	        this.inputs.map(function (input, index) {
	          var inputType = _this2.translateType(input.type);
	          var inputLabel = _this2.props.labels ? _this2.props.labels[index] : input.name;
	          // check if input type is struct and if so loop out struct fields as well
	          return _react2.default.createElement('input', { key: input.name, type: inputType, name: input.name, value: _this2.state[input.name], placeholder: inputLabel, onChange: _this2.handleInputChange });
	        }),
	        _react2.default.createElement(
	          'button',
	          { key: 'submit', className: 'pure-button', type: 'button', onClick: this.handleSubmit },
	          'Submit'
	        )
	      );
	    }
	  }]);
	
	  return ContractForm;
	}(_react.Component);
	
	ContractForm.contextTypes = {
	  drizzle: _propTypes2.default.object
	
	  /*
	   * Export connected component.
	   */
	
	};var mapStateToProps = function mapStateToProps(state) {
	  return {
	    contracts: state.contracts
	  };
	};
	
	exports.default = (0, _drizzleReact.drizzleConnect)(ContractForm, mapStateToProps);
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _drizzleReact = __webpack_require__(0);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * Create component.
	 */
	
	var LoadingContainer = function (_Component) {
	  _inherits(LoadingContainer, _Component);
	
	  function LoadingContainer() {
	    _classCallCheck(this, LoadingContainer);
	
	    return _possibleConstructorReturn(this, (LoadingContainer.__proto__ || Object.getPrototypeOf(LoadingContainer)).apply(this, arguments));
	  }
	
	  _createClass(LoadingContainer, [{
	    key: 'render',
	    value: function render() {
	      if (this.props.web3.status === 'failed') {
	        if (this.props.errorComp) {
	          return this.props.errorComp;
	        }
	
	        return _react2.default.createElement(
	          'main',
	          { className: 'container loading-screen' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pure-g' },
	            _react2.default.createElement(
	              'div',
	              { className: 'pure-u-1-1' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                '\u26A0\uFE0F'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'This browser has no connection to the Ethereum network. Please use the Chrome/FireFox extension MetaMask, or dedicated Ethereum browsers Mist or Parity.'
	              )
	            )
	          )
	        );
	      }
	
	      if (this.props.web3.status === 'initialized' && Object.keys(this.props.accounts).length === 0) {
	        return _react2.default.createElement(
	          'main',
	          { className: 'container loading-screen' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pure-g' },
	            _react2.default.createElement(
	              'div',
	              { className: 'pure-u-1-1' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                '\uD83E\uDD8A'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'We can\'t find any Ethereum accounts!'
	                ),
	                ' Please check and make sure Metamask or you browser are pointed at the correct network and your account is unlocked.'
	              )
	            )
	          )
	        );
	      }
	
	      if (this.props.drizzleStatus.initialized) {
	        return _react.Children.only(this.props.children);
	      }
	
	      if (this.props.loadingComp) {
	        return this.props.loadingComp;
	      }
	
	      return _react2.default.createElement(
	        'main',
	        { className: 'container loading-screen' },
	        _react2.default.createElement(
	          'div',
	          { className: 'pure-g' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pure-u-1-1' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              '\u2699\uFE0F'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Loading dapp...'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return LoadingContainer;
	}(_react.Component);
	
	LoadingContainer.contextTypes = {
	  drizzle: _propTypes2.default.object
	
	  /*
	   * Export connected component.
	   */
	
	};var mapStateToProps = function mapStateToProps(state) {
	  return {
	    accounts: state.accounts,
	    drizzleStatus: state.drizzleStatus,
	    web3: state.web3
	  };
	};
	
	exports.default = (0, _drizzleReact.drizzleConnect)(LoadingContainer, mapStateToProps);
	
	/***/ })
	/******/ ]);
	});

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _io = /*#__PURE__*/__webpack_require__(45);
	
	Object.defineProperty(exports, 'take', {
	  enumerable: true,
	  get: function get() {
	    return _io.take;
	  }
	});
	Object.defineProperty(exports, 'takem', {
	  enumerable: true,
	  get: function get() {
	    return _io.takem;
	  }
	});
	Object.defineProperty(exports, 'put', {
	  enumerable: true,
	  get: function get() {
	    return _io.put;
	  }
	});
	Object.defineProperty(exports, 'all', {
	  enumerable: true,
	  get: function get() {
	    return _io.all;
	  }
	});
	Object.defineProperty(exports, 'race', {
	  enumerable: true,
	  get: function get() {
	    return _io.race;
	  }
	});
	Object.defineProperty(exports, 'call', {
	  enumerable: true,
	  get: function get() {
	    return _io.call;
	  }
	});
	Object.defineProperty(exports, 'apply', {
	  enumerable: true,
	  get: function get() {
	    return _io.apply;
	  }
	});
	Object.defineProperty(exports, 'cps', {
	  enumerable: true,
	  get: function get() {
	    return _io.cps;
	  }
	});
	Object.defineProperty(exports, 'fork', {
	  enumerable: true,
	  get: function get() {
	    return _io.fork;
	  }
	});
	Object.defineProperty(exports, 'spawn', {
	  enumerable: true,
	  get: function get() {
	    return _io.spawn;
	  }
	});
	Object.defineProperty(exports, 'join', {
	  enumerable: true,
	  get: function get() {
	    return _io.join;
	  }
	});
	Object.defineProperty(exports, 'cancel', {
	  enumerable: true,
	  get: function get() {
	    return _io.cancel;
	  }
	});
	Object.defineProperty(exports, 'select', {
	  enumerable: true,
	  get: function get() {
	    return _io.select;
	  }
	});
	Object.defineProperty(exports, 'actionChannel', {
	  enumerable: true,
	  get: function get() {
	    return _io.actionChannel;
	  }
	});
	Object.defineProperty(exports, 'cancelled', {
	  enumerable: true,
	  get: function get() {
	    return _io.cancelled;
	  }
	});
	Object.defineProperty(exports, 'flush', {
	  enumerable: true,
	  get: function get() {
	    return _io.flush;
	  }
	});
	Object.defineProperty(exports, 'getContext', {
	  enumerable: true,
	  get: function get() {
	    return _io.getContext;
	  }
	});
	Object.defineProperty(exports, 'setContext', {
	  enumerable: true,
	  get: function get() {
	    return _io.setContext;
	  }
	});
	Object.defineProperty(exports, 'takeEvery', {
	  enumerable: true,
	  get: function get() {
	    return _io.takeEvery;
	  }
	});
	Object.defineProperty(exports, 'takeLatest', {
	  enumerable: true,
	  get: function get() {
	    return _io.takeLatest;
	  }
	});
	Object.defineProperty(exports, 'throttle', {
	  enumerable: true,
	  get: function get() {
	    return _io.throttle;
	  }
	});

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.utils = exports.effects = exports.detach = exports.CANCEL = exports.delay = exports.throttle = exports.takeLatest = exports.takeEvery = exports.buffers = exports.channel = exports.eventChannel = exports.END = exports.runSaga = undefined;
	
	var _runSaga = /*#__PURE__*/__webpack_require__(219);
	
	Object.defineProperty(exports, 'runSaga', {
	  enumerable: true,
	  get: function get() {
	    return _runSaga.runSaga;
	  }
	});
	
	var _channel = /*#__PURE__*/__webpack_require__(52);
	
	Object.defineProperty(exports, 'END', {
	  enumerable: true,
	  get: function get() {
	    return _channel.END;
	  }
	});
	Object.defineProperty(exports, 'eventChannel', {
	  enumerable: true,
	  get: function get() {
	    return _channel.eventChannel;
	  }
	});
	Object.defineProperty(exports, 'channel', {
	  enumerable: true,
	  get: function get() {
	    return _channel.channel;
	  }
	});
	
	var _buffers = /*#__PURE__*/__webpack_require__(91);
	
	Object.defineProperty(exports, 'buffers', {
	  enumerable: true,
	  get: function get() {
	    return _buffers.buffers;
	  }
	});
	
	var _sagaHelpers = /*#__PURE__*/__webpack_require__(220);
	
	Object.defineProperty(exports, 'takeEvery', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.takeEvery;
	  }
	});
	Object.defineProperty(exports, 'takeLatest', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.takeLatest;
	  }
	});
	Object.defineProperty(exports, 'throttle', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.throttle;
	  }
	});
	
	var _utils = /*#__PURE__*/__webpack_require__(24);
	
	Object.defineProperty(exports, 'delay', {
	  enumerable: true,
	  get: function get() {
	    return _utils.delay;
	  }
	});
	Object.defineProperty(exports, 'CANCEL', {
	  enumerable: true,
	  get: function get() {
	    return _utils.CANCEL;
	  }
	});
	
	var _io = /*#__PURE__*/__webpack_require__(45);
	
	Object.defineProperty(exports, 'detach', {
	  enumerable: true,
	  get: function get() {
	    return _io.detach;
	  }
	});
	
	var _middleware = /*#__PURE__*/__webpack_require__(483);
	
	var _middleware2 = /*#__PURE__*/_interopRequireDefault(_middleware);
	
	var _effects = /*#__PURE__*/__webpack_require__(481);
	
	var effects = /*#__PURE__*/_interopRequireWildcard(_effects);
	
	var _utils2 = /*#__PURE__*/__webpack_require__(487);
	
	var utils = /*#__PURE__*/_interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _middleware2.default;
	exports.effects = effects;
	exports.utils = utils;

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = sagaMiddlewareFactory;
	
	var _utils = /*#__PURE__*/__webpack_require__(24);
	
	var _channel = /*#__PURE__*/__webpack_require__(52);
	
	var _runSaga = /*#__PURE__*/__webpack_require__(219);
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function sagaMiddlewareFactory() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var _ref$context = _ref.context,
	      context = _ref$context === undefined ? {} : _ref$context,
	      options = _objectWithoutProperties(_ref, ['context']);
	
	  var sagaMonitor = options.sagaMonitor,
	      logger = options.logger,
	      onError = options.onError;
	
	
	  if (_utils.is.func(options)) {
	    if (true) {
	      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
	    } else {
	      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
	    }
	  }
	
	  if (logger && !_utils.is.func(logger)) {
	    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
	  }
	
	  if (false) {
	    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
	  }
	
	  if (onError && !_utils.is.func(onError)) {
	    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
	  }
	
	  if (options.emitter && !_utils.is.func(options.emitter)) {
	    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
	  }
	
	  function sagaMiddleware(_ref2) {
	    var getState = _ref2.getState,
	        dispatch = _ref2.dispatch;
	
	    var sagaEmitter = (0, _channel.emitter)();
	    sagaEmitter.emit = (options.emitter || _utils.ident)(sagaEmitter.emit);
	
	    sagaMiddleware.run = _runSaga.runSaga.bind(null, {
	      context: context,
	      subscribe: sagaEmitter.subscribe,
	      dispatch: dispatch,
	      getState: getState,
	      sagaMonitor: sagaMonitor,
	      logger: logger,
	      onError: onError
	    });
	
	    return function (next) {
	      return function (action) {
	        if (sagaMonitor && sagaMonitor.actionDispatched) {
	          sagaMonitor.actionDispatched(action);
	        }
	        var result = next(action); // hit reducers
	        sagaEmitter.emit(action);
	        return result;
	      };
	    };
	  }
	
	  sagaMiddleware.run = function () {
	    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
	  };
	
	  sagaMiddleware.setContext = function (props) {
	    (0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)('sagaMiddleware', props));
	    _utils.object.assign(context, props);
	  };
	
	  return sagaMiddleware;
	}

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = takeEvery;
	
	var _fsmIterator = /*#__PURE__*/__webpack_require__(134);
	
	var _fsmIterator2 = /*#__PURE__*/_interopRequireDefault(_fsmIterator);
	
	var _io = /*#__PURE__*/__webpack_require__(45);
	
	var _channel = /*#__PURE__*/__webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function takeEvery(patternOrChannel, worker) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var yTake = { done: false, value: (0, _io.take)(patternOrChannel) };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	
	  var action = void 0,
	      setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return (0, _fsmIterator2.default)({
	    q1: function q1() {
	      return ['q2', yTake, setAction];
	    },
	    q2: function q2() {
	      return action === _channel.END ? [_fsmIterator.qEnd] : ['q1', yFork(action)];
	    }
	  }, 'q1', 'takeEvery(' + (0, _fsmIterator.safeName)(patternOrChannel) + ', ' + worker.name + ')');
	}

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = takeLatest;
	
	var _fsmIterator = /*#__PURE__*/__webpack_require__(134);
	
	var _fsmIterator2 = /*#__PURE__*/_interopRequireDefault(_fsmIterator);
	
	var _io = /*#__PURE__*/__webpack_require__(45);
	
	var _channel = /*#__PURE__*/__webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function takeLatest(patternOrChannel, worker) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var yTake = { done: false, value: (0, _io.take)(patternOrChannel) };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	  var yCancel = function yCancel(task) {
	    return { done: false, value: (0, _io.cancel)(task) };
	  };
	
	  var task = void 0,
	      action = void 0;
	  var setTask = function setTask(t) {
	    return task = t;
	  };
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return (0, _fsmIterator2.default)({
	    q1: function q1() {
	      return ['q2', yTake, setAction];
	    },
	    q2: function q2() {
	      return action === _channel.END ? [_fsmIterator.qEnd] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
	    },
	    q3: function q3() {
	      return ['q1', yFork(action), setTask];
	    }
	  }, 'q1', 'takeLatest(' + (0, _fsmIterator.safeName)(patternOrChannel) + ', ' + worker.name + ')');
	}

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = throttle;
	
	var _fsmIterator = /*#__PURE__*/__webpack_require__(134);
	
	var _fsmIterator2 = /*#__PURE__*/_interopRequireDefault(_fsmIterator);
	
	var _io = /*#__PURE__*/__webpack_require__(45);
	
	var _channel = /*#__PURE__*/__webpack_require__(52);
	
	var _buffers = /*#__PURE__*/__webpack_require__(91);
	
	var _utils = /*#__PURE__*/__webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function throttle(delayLength, pattern, worker) {
	  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    args[_key - 3] = arguments[_key];
	  }
	
	  var action = void 0,
	      channel = void 0;
	
	  var yActionChannel = { done: false, value: (0, _io.actionChannel)(pattern, _buffers.buffers.sliding(1)) };
	  var yTake = function yTake() {
	    return { done: false, value: (0, _io.take)(channel) };
	  };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	  var yDelay = { done: false, value: (0, _io.call)(_utils.delay, delayLength) };
	
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	  var setChannel = function setChannel(ch) {
	    return channel = ch;
	  };
	
	  return (0, _fsmIterator2.default)({
	    q1: function q1() {
	      return ['q2', yActionChannel, setChannel];
	    },
	    q2: function q2() {
	      return ['q3', yTake(), setAction];
	    },
	    q3: function q3() {
	      return action === _channel.END ? [_fsmIterator.qEnd] : ['q4', yFork(action)];
	    },
	    q4: function q4() {
	      return ['q2', yDelay];
	    }
	  }, 'q1', 'throttle(' + (0, _fsmIterator.safeName)(pattern) + ', ' + worker.name + ')');
	}

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = /*#__PURE__*/__webpack_require__(24);
	
	Object.defineProperty(exports, 'TASK', {
	  enumerable: true,
	  get: function get() {
	    return _utils.TASK;
	  }
	});
	Object.defineProperty(exports, 'SAGA_ACTION', {
	  enumerable: true,
	  get: function get() {
	    return _utils.SAGA_ACTION;
	  }
	});
	Object.defineProperty(exports, 'noop', {
	  enumerable: true,
	  get: function get() {
	    return _utils.noop;
	  }
	});
	Object.defineProperty(exports, 'is', {
	  enumerable: true,
	  get: function get() {
	    return _utils.is;
	  }
	});
	Object.defineProperty(exports, 'deferred', {
	  enumerable: true,
	  get: function get() {
	    return _utils.deferred;
	  }
	});
	Object.defineProperty(exports, 'arrayOfDeffered', {
	  enumerable: true,
	  get: function get() {
	    return _utils.arrayOfDeffered;
	  }
	});
	Object.defineProperty(exports, 'createMockTask', {
	  enumerable: true,
	  get: function get() {
	    return _utils.createMockTask;
	  }
	});
	Object.defineProperty(exports, 'cloneableGenerator', {
	  enumerable: true,
	  get: function get() {
	    return _utils.cloneableGenerator;
	  }
	});
	
	var _io = /*#__PURE__*/__webpack_require__(45);
	
	Object.defineProperty(exports, 'asEffect', {
	  enumerable: true,
	  get: function get() {
	    return _io.asEffect;
	  }
	});
	
	var _proc = /*#__PURE__*/__webpack_require__(218);
	
	Object.defineProperty(exports, 'CHANNEL_END', {
	  enumerable: true,
	  get: function get() {
	    return _proc.CHANNEL_END;
	  }
	});

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var $$observable = _interopDefault(__webpack_require__(312));
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = {
	  INIT: '@@redux/INIT' + Math.random().toString(36).substring(7).split('').join('.'),
	  REPLACE: '@@redux/REPLACE' + Math.random().toString(36).substring(7).split('').join('.')
	};
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) return false;
	
	  var proto = obj;
	  while (Object.getPrototypeOf(proto) !== null) {
	    proto = Object.getPrototypeOf(proto);
	  }
	
	  return Object.getPrototypeOf(obj) === proto;
	}
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    if (isDispatching) {
	      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
	    }
	
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected the listener to be a function.');
	    }
	
	    if (isDispatching) {
	      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      if (isDispatching) {
	        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!isPlainObject(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.REPLACE });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object' || observer === null) {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[$$observable] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[$$observable] = observable, _ref2;
	}
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	  } catch (e) {} // eslint-disable-line no-empty
	}
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionDescription = actionType && 'action "' + String(actionType) + '"' || 'an action';
	
	  return 'Given ' + actionDescription + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!isPlainObject(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (action && action.type === ActionTypes.REPLACE) return;
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        warning('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        warning(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}
	
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(this, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if ((typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}
	
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function () {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      var store = createStore.apply(undefined, args);
	      var _dispatch = function dispatch() {
	        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
	      };
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch() {
	          return _dispatch.apply(undefined, arguments);
	        }
	      };
	      var chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = compose.apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}
	
	/*
	 * This is a dummy function to check if the function name has been altered by minification.
	 * If the function has been minified and NODE_ENV !== 'production', warn the user.
	 */
	function isCrushed() {}
	
	if (false) {
	  warning("You are currently using minified code outside of NODE_ENV === 'production'. " + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = createStore;
	exports.combineReducers = combineReducers;
	exports.bindActionCreators = bindActionCreators;
	exports.applyMiddleware = applyMiddleware;
	exports.compose = compose;
	exports.__DO_NOT_USE__ActionTypes = ActionTypes;


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var BN = __webpack_require__(7);
	var elliptic = __webpack_require__(13);
	var utils = elliptic.utils;
	var getNAF = utils.getNAF;
	var getJSF = utils.getJSF;
	var assert = utils.assert;
	
	function BaseCurve(type, conf) {
	  this.type = type;
	  this.p = new BN(conf.p, 16);
	
	  // Use Montgomery, when there is no fast reduction for the prime
	  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);
	
	  // Useful for many curves
	  this.zero = new BN(0).toRed(this.red);
	  this.one = new BN(1).toRed(this.red);
	  this.two = new BN(2).toRed(this.red);
	
	  // Curve configuration, optional
	  this.n = conf.n && new BN(conf.n, 16);
	  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
	
	  // Temporary arrays
	  this._wnafT1 = new Array(4);
	  this._wnafT2 = new Array(4);
	  this._wnafT3 = new Array(4);
	  this._wnafT4 = new Array(4);
	
	  // Generalized Greg Maxwell's trick
	  var adjustCount = this.n && this.p.div(this.n);
	  if (!adjustCount || adjustCount.cmpn(100) > 0) {
	    this.redN = null;
	  } else {
	    this._maxwellTrick = true;
	    this.redN = this.n.toRed(this.red);
	  }
	}
	module.exports = BaseCurve;
	
	BaseCurve.prototype.point = function point() {
	  throw new Error('Not implemented');
	};
	
	BaseCurve.prototype.validate = function validate() {
	  throw new Error('Not implemented');
	};
	
	BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
	  assert(p.precomputed);
	  var doubles = p._getDoubles();
	
	  var naf = getNAF(k, 1);
	  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
	  I /= 3;
	
	  // Translate into more windowed form
	  var repr = [];
	  for (var j = 0; j < naf.length; j += doubles.step) {
	    var nafW = 0;
	    for (var k = j + doubles.step - 1; k >= j; k--)
	      nafW = (nafW << 1) + naf[k];
	    repr.push(nafW);
	  }
	
	  var a = this.jpoint(null, null, null);
	  var b = this.jpoint(null, null, null);
	  for (var i = I; i > 0; i--) {
	    for (var j = 0; j < repr.length; j++) {
	      var nafW = repr[j];
	      if (nafW === i)
	        b = b.mixedAdd(doubles.points[j]);
	      else if (nafW === -i)
	        b = b.mixedAdd(doubles.points[j].neg());
	    }
	    a = a.add(b);
	  }
	  return a.toP();
	};
	
	BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
	  var w = 4;
	
	  // Precompute window
	  var nafPoints = p._getNAFPoints(w);
	  w = nafPoints.wnd;
	  var wnd = nafPoints.points;
	
	  // Get NAF form
	  var naf = getNAF(k, w);
	
	  // Add `this`*(N+1) for every w-NAF index
	  var acc = this.jpoint(null, null, null);
	  for (var i = naf.length - 1; i >= 0; i--) {
	    // Count zeroes
	    for (var k = 0; i >= 0 && naf[i] === 0; i--)
	      k++;
	    if (i >= 0)
	      k++;
	    acc = acc.dblp(k);
	
	    if (i < 0)
	      break;
	    var z = naf[i];
	    assert(z !== 0);
	    if (p.type === 'affine') {
	      // J +- P
	      if (z > 0)
	        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
	      else
	        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
	    } else {
	      // J +- J
	      if (z > 0)
	        acc = acc.add(wnd[(z - 1) >> 1]);
	      else
	        acc = acc.add(wnd[(-z - 1) >> 1].neg());
	    }
	  }
	  return p.type === 'affine' ? acc.toP() : acc;
	};
	
	BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
	                                                       points,
	                                                       coeffs,
	                                                       len,
	                                                       jacobianResult) {
	  var wndWidth = this._wnafT1;
	  var wnd = this._wnafT2;
	  var naf = this._wnafT3;
	
	  // Fill all arrays
	  var max = 0;
	  for (var i = 0; i < len; i++) {
	    var p = points[i];
	    var nafPoints = p._getNAFPoints(defW);
	    wndWidth[i] = nafPoints.wnd;
	    wnd[i] = nafPoints.points;
	  }
	
	  // Comb small window NAFs
	  for (var i = len - 1; i >= 1; i -= 2) {
	    var a = i - 1;
	    var b = i;
	    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
	      naf[a] = getNAF(coeffs[a], wndWidth[a]);
	      naf[b] = getNAF(coeffs[b], wndWidth[b]);
	      max = Math.max(naf[a].length, max);
	      max = Math.max(naf[b].length, max);
	      continue;
	    }
	
	    var comb = [
	      points[a], /* 1 */
	      null, /* 3 */
	      null, /* 5 */
	      points[b] /* 7 */
	    ];
	
	    // Try to avoid Projective points, if possible
	    if (points[a].y.cmp(points[b].y) === 0) {
	      comb[1] = points[a].add(points[b]);
	      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
	    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
	      comb[1] = points[a].toJ().mixedAdd(points[b]);
	      comb[2] = points[a].add(points[b].neg());
	    } else {
	      comb[1] = points[a].toJ().mixedAdd(points[b]);
	      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
	    }
	
	    var index = [
	      -3, /* -1 -1 */
	      -1, /* -1 0 */
	      -5, /* -1 1 */
	      -7, /* 0 -1 */
	      0, /* 0 0 */
	      7, /* 0 1 */
	      5, /* 1 -1 */
	      1, /* 1 0 */
	      3  /* 1 1 */
	    ];
	
	    var jsf = getJSF(coeffs[a], coeffs[b]);
	    max = Math.max(jsf[0].length, max);
	    naf[a] = new Array(max);
	    naf[b] = new Array(max);
	    for (var j = 0; j < max; j++) {
	      var ja = jsf[0][j] | 0;
	      var jb = jsf[1][j] | 0;
	
	      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
	      naf[b][j] = 0;
	      wnd[a] = comb;
	    }
	  }
	
	  var acc = this.jpoint(null, null, null);
	  var tmp = this._wnafT4;
	  for (var i = max; i >= 0; i--) {
	    var k = 0;
	
	    while (i >= 0) {
	      var zero = true;
	      for (var j = 0; j < len; j++) {
	        tmp[j] = naf[j][i] | 0;
	        if (tmp[j] !== 0)
	          zero = false;
	      }
	      if (!zero)
	        break;
	      k++;
	      i--;
	    }
	    if (i >= 0)
	      k++;
	    acc = acc.dblp(k);
	    if (i < 0)
	      break;
	
	    for (var j = 0; j < len; j++) {
	      var z = tmp[j];
	      var p;
	      if (z === 0)
	        continue;
	      else if (z > 0)
	        p = wnd[j][(z - 1) >> 1];
	      else if (z < 0)
	        p = wnd[j][(-z - 1) >> 1].neg();
	
	      if (p.type === 'affine')
	        acc = acc.mixedAdd(p);
	      else
	        acc = acc.add(p);
	    }
	  }
	  // Zeroify references
	  for (var i = 0; i < len; i++)
	    wnd[i] = null;
	
	  if (jacobianResult)
	    return acc;
	  else
	    return acc.toP();
	};
	
	function BasePoint(curve, type) {
	  this.curve = curve;
	  this.type = type;
	  this.precomputed = null;
	}
	BaseCurve.BasePoint = BasePoint;
	
	BasePoint.prototype.eq = function eq(/*other*/) {
	  throw new Error('Not implemented');
	};
	
	BasePoint.prototype.validate = function validate() {
	  return this.curve.validate(this);
	};
	
	BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
	  bytes = utils.toArray(bytes, enc);
	
	  var len = this.p.byteLength();
	
	  // uncompressed, hybrid-odd, hybrid-even
	  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
	      bytes.length - 1 === 2 * len) {
	    if (bytes[0] === 0x06)
	      assert(bytes[bytes.length - 1] % 2 === 0);
	    else if (bytes[0] === 0x07)
	      assert(bytes[bytes.length - 1] % 2 === 1);
	
	    var res =  this.point(bytes.slice(1, 1 + len),
	                          bytes.slice(1 + len, 1 + 2 * len));
	
	    return res;
	  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
	              bytes.length - 1 === len) {
	    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
	  }
	  throw new Error('Unknown point format');
	};
	
	BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
	  return this.encode(enc, true);
	};
	
	BasePoint.prototype._encode = function _encode(compact) {
	  var len = this.curve.p.byteLength();
	  var x = this.getX().toArray('be', len);
	
	  if (compact)
	    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);
	
	  return [ 0x04 ].concat(x, this.getY().toArray('be', len)) ;
	};
	
	BasePoint.prototype.encode = function encode(enc, compact) {
	  return utils.encode(this._encode(compact), enc);
	};
	
	BasePoint.prototype.precompute = function precompute(power) {
	  if (this.precomputed)
	    return this;
	
	  var precomputed = {
	    doubles: null,
	    naf: null,
	    beta: null
	  };
	  precomputed.naf = this._getNAFPoints(8);
	  precomputed.doubles = this._getDoubles(4, power);
	  precomputed.beta = this._getBeta();
	  this.precomputed = precomputed;
	
	  return this;
	};
	
	BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
	  if (!this.precomputed)
	    return false;
	
	  var doubles = this.precomputed.doubles;
	  if (!doubles)
	    return false;
	
	  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
	};
	
	BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
	  if (this.precomputed && this.precomputed.doubles)
	    return this.precomputed.doubles;
	
	  var doubles = [ this ];
	  var acc = this;
	  for (var i = 0; i < power; i += step) {
	    for (var j = 0; j < step; j++)
	      acc = acc.dbl();
	    doubles.push(acc);
	  }
	  return {
	    step: step,
	    points: doubles
	  };
	};
	
	BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
	  if (this.precomputed && this.precomputed.naf)
	    return this.precomputed.naf;
	
	  var res = [ this ];
	  var max = (1 << wnd) - 1;
	  var dbl = max === 1 ? null : this.dbl();
	  for (var i = 1; i < max; i++)
	    res[i] = res[i - 1].add(dbl);
	  return {
	    wnd: wnd,
	    points: res
	  };
	};
	
	BasePoint.prototype._getBeta = function _getBeta() {
	  return null;
	};
	
	BasePoint.prototype.dblp = function dblp(k) {
	  var r = this;
	  for (var i = 0; i < k; i++)
	    r = r.dbl();
	  return r;
	};


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var curve = __webpack_require__(92);
	var elliptic = __webpack_require__(13);
	var BN = __webpack_require__(7);
	var inherits = __webpack_require__(2);
	var Base = curve.base;
	
	var assert = elliptic.utils.assert;
	
	function EdwardsCurve(conf) {
	  // NOTE: Important as we are creating point in Base.call()
	  this.twisted = (conf.a | 0) !== 1;
	  this.mOneA = this.twisted && (conf.a | 0) === -1;
	  this.extended = this.mOneA;
	
	  Base.call(this, 'edwards', conf);
	
	  this.a = new BN(conf.a, 16).umod(this.red.m);
	  this.a = this.a.toRed(this.red);
	  this.c = new BN(conf.c, 16).toRed(this.red);
	  this.c2 = this.c.redSqr();
	  this.d = new BN(conf.d, 16).toRed(this.red);
	  this.dd = this.d.redAdd(this.d);
	
	  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
	  this.oneC = (conf.c | 0) === 1;
	}
	inherits(EdwardsCurve, Base);
	module.exports = EdwardsCurve;
	
	EdwardsCurve.prototype._mulA = function _mulA(num) {
	  if (this.mOneA)
	    return num.redNeg();
	  else
	    return this.a.redMul(num);
	};
	
	EdwardsCurve.prototype._mulC = function _mulC(num) {
	  if (this.oneC)
	    return num;
	  else
	    return this.c.redMul(num);
	};
	
	// Just for compatibility with Short curve
	EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
	  return this.point(x, y, z, t);
	};
	
	EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
	  x = new BN(x, 16);
	  if (!x.red)
	    x = x.toRed(this.red);
	
	  var x2 = x.redSqr();
	  var rhs = this.c2.redSub(this.a.redMul(x2));
	  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
	
	  var y2 = rhs.redMul(lhs.redInvm());
	  var y = y2.redSqrt();
	  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
	    throw new Error('invalid point');
	
	  var isOdd = y.fromRed().isOdd();
	  if (odd && !isOdd || !odd && isOdd)
	    y = y.redNeg();
	
	  return this.point(x, y);
	};
	
	EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
	  y = new BN(y, 16);
	  if (!y.red)
	    y = y.toRed(this.red);
	
	  // x^2 = (y^2 - 1) / (d y^2 + 1)
	  var y2 = y.redSqr();
	  var lhs = y2.redSub(this.one);
	  var rhs = y2.redMul(this.d).redAdd(this.one);
	  var x2 = lhs.redMul(rhs.redInvm());
	
	  if (x2.cmp(this.zero) === 0) {
	    if (odd)
	      throw new Error('invalid point');
	    else
	      return this.point(this.zero, y);
	  }
	
	  var x = x2.redSqrt();
	  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
	    throw new Error('invalid point');
	
	  if (x.isOdd() !== odd)
	    x = x.redNeg();
	
	  return this.point(x, y);
	};
	
	EdwardsCurve.prototype.validate = function validate(point) {
	  if (point.isInfinity())
	    return true;
	
	  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
	  point.normalize();
	
	  var x2 = point.x.redSqr();
	  var y2 = point.y.redSqr();
	  var lhs = x2.redMul(this.a).redAdd(y2);
	  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
	
	  return lhs.cmp(rhs) === 0;
	};
	
	function Point(curve, x, y, z, t) {
	  Base.BasePoint.call(this, curve, 'projective');
	  if (x === null && y === null && z === null) {
	    this.x = this.curve.zero;
	    this.y = this.curve.one;
	    this.z = this.curve.one;
	    this.t = this.curve.zero;
	    this.zOne = true;
	  } else {
	    this.x = new BN(x, 16);
	    this.y = new BN(y, 16);
	    this.z = z ? new BN(z, 16) : this.curve.one;
	    this.t = t && new BN(t, 16);
	    if (!this.x.red)
	      this.x = this.x.toRed(this.curve.red);
	    if (!this.y.red)
	      this.y = this.y.toRed(this.curve.red);
	    if (!this.z.red)
	      this.z = this.z.toRed(this.curve.red);
	    if (this.t && !this.t.red)
	      this.t = this.t.toRed(this.curve.red);
	    this.zOne = this.z === this.curve.one;
	
	    // Use extended coordinates
	    if (this.curve.extended && !this.t) {
	      this.t = this.x.redMul(this.y);
	      if (!this.zOne)
	        this.t = this.t.redMul(this.z.redInvm());
	    }
	  }
	}
	inherits(Point, Base.BasePoint);
	
	EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
	  return Point.fromJSON(this, obj);
	};
	
	EdwardsCurve.prototype.point = function point(x, y, z, t) {
	  return new Point(this, x, y, z, t);
	};
	
	Point.fromJSON = function fromJSON(curve, obj) {
	  return new Point(curve, obj[0], obj[1], obj[2]);
	};
	
	Point.prototype.inspect = function inspect() {
	  if (this.isInfinity())
	    return '<EC Point Infinity>';
	  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
	      ' y: ' + this.y.fromRed().toString(16, 2) +
	      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
	};
	
	Point.prototype.isInfinity = function isInfinity() {
	  // XXX This code assumes that zero is always zero in red
	  return this.x.cmpn(0) === 0 &&
	         this.y.cmp(this.z) === 0;
	};
	
	Point.prototype._extDbl = function _extDbl() {
	  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
	  //     #doubling-dbl-2008-hwcd
	  // 4M + 4S
	
	  // A = X1^2
	  var a = this.x.redSqr();
	  // B = Y1^2
	  var b = this.y.redSqr();
	  // C = 2 * Z1^2
	  var c = this.z.redSqr();
	  c = c.redIAdd(c);
	  // D = a * A
	  var d = this.curve._mulA(a);
	  // E = (X1 + Y1)^2 - A - B
	  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
	  // G = D + B
	  var g = d.redAdd(b);
	  // F = G - C
	  var f = g.redSub(c);
	  // H = D - B
	  var h = d.redSub(b);
	  // X3 = E * F
	  var nx = e.redMul(f);
	  // Y3 = G * H
	  var ny = g.redMul(h);
	  // T3 = E * H
	  var nt = e.redMul(h);
	  // Z3 = F * G
	  var nz = f.redMul(g);
	  return this.curve.point(nx, ny, nz, nt);
	};
	
	Point.prototype._projDbl = function _projDbl() {
	  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
	  //     #doubling-dbl-2008-bbjlp
	  //     #doubling-dbl-2007-bl
	  // and others
	  // Generally 3M + 4S or 2M + 4S
	
	  // B = (X1 + Y1)^2
	  var b = this.x.redAdd(this.y).redSqr();
	  // C = X1^2
	  var c = this.x.redSqr();
	  // D = Y1^2
	  var d = this.y.redSqr();
	
	  var nx;
	  var ny;
	  var nz;
	  if (this.curve.twisted) {
	    // E = a * C
	    var e = this.curve._mulA(c);
	    // F = E + D
	    var f = e.redAdd(d);
	    if (this.zOne) {
	      // X3 = (B - C - D) * (F - 2)
	      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
	      // Y3 = F * (E - D)
	      ny = f.redMul(e.redSub(d));
	      // Z3 = F^2 - 2 * F
	      nz = f.redSqr().redSub(f).redSub(f);
	    } else {
	      // H = Z1^2
	      var h = this.z.redSqr();
	      // J = F - 2 * H
	      var j = f.redSub(h).redISub(h);
	      // X3 = (B-C-D)*J
	      nx = b.redSub(c).redISub(d).redMul(j);
	      // Y3 = F * (E - D)
	      ny = f.redMul(e.redSub(d));
	      // Z3 = F * J
	      nz = f.redMul(j);
	    }
	  } else {
	    // E = C + D
	    var e = c.redAdd(d);
	    // H = (c * Z1)^2
	    var h = this.curve._mulC(this.c.redMul(this.z)).redSqr();
	    // J = E - 2 * H
	    var j = e.redSub(h).redSub(h);
	    // X3 = c * (B - E) * J
	    nx = this.curve._mulC(b.redISub(e)).redMul(j);
	    // Y3 = c * E * (C - D)
	    ny = this.curve._mulC(e).redMul(c.redISub(d));
	    // Z3 = E * J
	    nz = e.redMul(j);
	  }
	  return this.curve.point(nx, ny, nz);
	};
	
	Point.prototype.dbl = function dbl() {
	  if (this.isInfinity())
	    return this;
	
	  // Double in extended coordinates
	  if (this.curve.extended)
	    return this._extDbl();
	  else
	    return this._projDbl();
	};
	
	Point.prototype._extAdd = function _extAdd(p) {
	  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
	  //     #addition-add-2008-hwcd-3
	  // 8M
	
	  // A = (Y1 - X1) * (Y2 - X2)
	  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
	  // B = (Y1 + X1) * (Y2 + X2)
	  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
	  // C = T1 * k * T2
	  var c = this.t.redMul(this.curve.dd).redMul(p.t);
	  // D = Z1 * 2 * Z2
	  var d = this.z.redMul(p.z.redAdd(p.z));
	  // E = B - A
	  var e = b.redSub(a);
	  // F = D - C
	  var f = d.redSub(c);
	  // G = D + C
	  var g = d.redAdd(c);
	  // H = B + A
	  var h = b.redAdd(a);
	  // X3 = E * F
	  var nx = e.redMul(f);
	  // Y3 = G * H
	  var ny = g.redMul(h);
	  // T3 = E * H
	  var nt = e.redMul(h);
	  // Z3 = F * G
	  var nz = f.redMul(g);
	  return this.curve.point(nx, ny, nz, nt);
	};
	
	Point.prototype._projAdd = function _projAdd(p) {
	  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
	  //     #addition-add-2008-bbjlp
	  //     #addition-add-2007-bl
	  // 10M + 1S
	
	  // A = Z1 * Z2
	  var a = this.z.redMul(p.z);
	  // B = A^2
	  var b = a.redSqr();
	  // C = X1 * X2
	  var c = this.x.redMul(p.x);
	  // D = Y1 * Y2
	  var d = this.y.redMul(p.y);
	  // E = d * C * D
	  var e = this.curve.d.redMul(c).redMul(d);
	  // F = B - E
	  var f = b.redSub(e);
	  // G = B + E
	  var g = b.redAdd(e);
	  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
	  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
	  var nx = a.redMul(f).redMul(tmp);
	  var ny;
	  var nz;
	  if (this.curve.twisted) {
	    // Y3 = A * G * (D - a * C)
	    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
	    // Z3 = F * G
	    nz = f.redMul(g);
	  } else {
	    // Y3 = A * G * (D - C)
	    ny = a.redMul(g).redMul(d.redSub(c));
	    // Z3 = c * F * G
	    nz = this.curve._mulC(f).redMul(g);
	  }
	  return this.curve.point(nx, ny, nz);
	};
	
	Point.prototype.add = function add(p) {
	  if (this.isInfinity())
	    return p;
	  if (p.isInfinity())
	    return this;
	
	  if (this.curve.extended)
	    return this._extAdd(p);
	  else
	    return this._projAdd(p);
	};
	
	Point.prototype.mul = function mul(k) {
	  if (this._hasDoubles(k))
	    return this.curve._fixedNafMul(this, k);
	  else
	    return this.curve._wnafMul(this, k);
	};
	
	Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
	  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
	};
	
	Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
	  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
	};
	
	Point.prototype.normalize = function normalize() {
	  if (this.zOne)
	    return this;
	
	  // Normalize coordinates
	  var zi = this.z.redInvm();
	  this.x = this.x.redMul(zi);
	  this.y = this.y.redMul(zi);
	  if (this.t)
	    this.t = this.t.redMul(zi);
	  this.z = this.curve.one;
	  this.zOne = true;
	  return this;
	};
	
	Point.prototype.neg = function neg() {
	  return this.curve.point(this.x.redNeg(),
	                          this.y,
	                          this.z,
	                          this.t && this.t.redNeg());
	};
	
	Point.prototype.getX = function getX() {
	  this.normalize();
	  return this.x.fromRed();
	};
	
	Point.prototype.getY = function getY() {
	  this.normalize();
	  return this.y.fromRed();
	};
	
	Point.prototype.eq = function eq(other) {
	  return this === other ||
	         this.getX().cmp(other.getX()) === 0 &&
	         this.getY().cmp(other.getY()) === 0;
	};
	
	Point.prototype.eqXToP = function eqXToP(x) {
	  var rx = x.toRed(this.curve.red).redMul(this.z);
	  if (this.x.cmp(rx) === 0)
	    return true;
	
	  var xc = x.clone();
	  var t = this.curve.redN.redMul(this.z);
	  for (;;) {
	    xc.iadd(this.curve.n);
	    if (xc.cmp(this.curve.p) >= 0)
	      return false;
	
	    rx.redIAdd(t);
	    if (this.x.cmp(rx) === 0)
	      return true;
	  }
	  return false;
	};
	
	// Compatibility with BaseCurve
	Point.prototype.toP = Point.prototype.normalize;
	Point.prototype.mixedAdd = Point.prototype.add;


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var curve = __webpack_require__(92);
	var BN = __webpack_require__(7);
	var inherits = __webpack_require__(2);
	var Base = curve.base;
	
	var elliptic = __webpack_require__(13);
	var utils = elliptic.utils;
	
	function MontCurve(conf) {
	  Base.call(this, 'mont', conf);
	
	  this.a = new BN(conf.a, 16).toRed(this.red);
	  this.b = new BN(conf.b, 16).toRed(this.red);
	  this.i4 = new BN(4).toRed(this.red).redInvm();
	  this.two = new BN(2).toRed(this.red);
	  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
	}
	inherits(MontCurve, Base);
	module.exports = MontCurve;
	
	MontCurve.prototype.validate = function validate(point) {
	  var x = point.normalize().x;
	  var x2 = x.redSqr();
	  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
	  var y = rhs.redSqrt();
	
	  return y.redSqr().cmp(rhs) === 0;
	};
	
	function Point(curve, x, z) {
	  Base.BasePoint.call(this, curve, 'projective');
	  if (x === null && z === null) {
	    this.x = this.curve.one;
	    this.z = this.curve.zero;
	  } else {
	    this.x = new BN(x, 16);
	    this.z = new BN(z, 16);
	    if (!this.x.red)
	      this.x = this.x.toRed(this.curve.red);
	    if (!this.z.red)
	      this.z = this.z.toRed(this.curve.red);
	  }
	}
	inherits(Point, Base.BasePoint);
	
	MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
	  return this.point(utils.toArray(bytes, enc), 1);
	};
	
	MontCurve.prototype.point = function point(x, z) {
	  return new Point(this, x, z);
	};
	
	MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
	  return Point.fromJSON(this, obj);
	};
	
	Point.prototype.precompute = function precompute() {
	  // No-op
	};
	
	Point.prototype._encode = function _encode() {
	  return this.getX().toArray('be', this.curve.p.byteLength());
	};
	
	Point.fromJSON = function fromJSON(curve, obj) {
	  return new Point(curve, obj[0], obj[1] || curve.one);
	};
	
	Point.prototype.inspect = function inspect() {
	  if (this.isInfinity())
	    return '<EC Point Infinity>';
	  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
	      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
	};
	
	Point.prototype.isInfinity = function isInfinity() {
	  // XXX This code assumes that zero is always zero in red
	  return this.z.cmpn(0) === 0;
	};
	
	Point.prototype.dbl = function dbl() {
	  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
	  // 2M + 2S + 4A
	
	  // A = X1 + Z1
	  var a = this.x.redAdd(this.z);
	  // AA = A^2
	  var aa = a.redSqr();
	  // B = X1 - Z1
	  var b = this.x.redSub(this.z);
	  // BB = B^2
	  var bb = b.redSqr();
	  // C = AA - BB
	  var c = aa.redSub(bb);
	  // X3 = AA * BB
	  var nx = aa.redMul(bb);
	  // Z3 = C * (BB + A24 * C)
	  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
	  return this.curve.point(nx, nz);
	};
	
	Point.prototype.add = function add() {
	  throw new Error('Not supported on Montgomery curve');
	};
	
	Point.prototype.diffAdd = function diffAdd(p, diff) {
	  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
	  // 4M + 2S + 6A
	
	  // A = X2 + Z2
	  var a = this.x.redAdd(this.z);
	  // B = X2 - Z2
	  var b = this.x.redSub(this.z);
	  // C = X3 + Z3
	  var c = p.x.redAdd(p.z);
	  // D = X3 - Z3
	  var d = p.x.redSub(p.z);
	  // DA = D * A
	  var da = d.redMul(a);
	  // CB = C * B
	  var cb = c.redMul(b);
	  // X5 = Z1 * (DA + CB)^2
	  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
	  // Z5 = X1 * (DA - CB)^2
	  var nz = diff.x.redMul(da.redISub(cb).redSqr());
	  return this.curve.point(nx, nz);
	};
	
	Point.prototype.mul = function mul(k) {
	  var t = k.clone();
	  var a = this; // (N / 2) * Q + Q
	  var b = this.curve.point(null, null); // (N / 2) * Q
	  var c = this; // Q
	
	  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
	    bits.push(t.andln(1));
	
	  for (var i = bits.length - 1; i >= 0; i--) {
	    if (bits[i] === 0) {
	      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
	      a = a.diffAdd(b, c);
	      // N * Q = 2 * ((N / 2) * Q + Q))
	      b = b.dbl();
	    } else {
	      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
	      b = a.diffAdd(b, c);
	      // N * Q + Q = 2 * ((N / 2) * Q + Q)
	      a = a.dbl();
	    }
	  }
	  return b;
	};
	
	Point.prototype.mulAdd = function mulAdd() {
	  throw new Error('Not supported on Montgomery curve');
	};
	
	Point.prototype.jumlAdd = function jumlAdd() {
	  throw new Error('Not supported on Montgomery curve');
	};
	
	Point.prototype.eq = function eq(other) {
	  return this.getX().cmp(other.getX()) === 0;
	};
	
	Point.prototype.normalize = function normalize() {
	  this.x = this.x.redMul(this.z.redInvm());
	  this.z = this.curve.one;
	  return this;
	};
	
	Point.prototype.getX = function getX() {
	  // Normalize coordinates
	  this.normalize();
	
	  return this.x.fromRed();
	};


/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var curve = __webpack_require__(92);
	var elliptic = __webpack_require__(13);
	var BN = __webpack_require__(7);
	var inherits = __webpack_require__(2);
	var Base = curve.base;
	
	var assert = elliptic.utils.assert;
	
	function ShortCurve(conf) {
	  Base.call(this, 'short', conf);
	
	  this.a = new BN(conf.a, 16).toRed(this.red);
	  this.b = new BN(conf.b, 16).toRed(this.red);
	  this.tinv = this.two.redInvm();
	
	  this.zeroA = this.a.fromRed().cmpn(0) === 0;
	  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
	
	  // If the curve is endomorphic, precalculate beta and lambda
	  this.endo = this._getEndomorphism(conf);
	  this._endoWnafT1 = new Array(4);
	  this._endoWnafT2 = new Array(4);
	}
	inherits(ShortCurve, Base);
	module.exports = ShortCurve;
	
	ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
	  // No efficient endomorphism
	  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
	    return;
	
	  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
	  var beta;
	  var lambda;
	  if (conf.beta) {
	    beta = new BN(conf.beta, 16).toRed(this.red);
	  } else {
	    var betas = this._getEndoRoots(this.p);
	    // Choose the smallest beta
	    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
	    beta = beta.toRed(this.red);
	  }
	  if (conf.lambda) {
	    lambda = new BN(conf.lambda, 16);
	  } else {
	    // Choose the lambda that is matching selected beta
	    var lambdas = this._getEndoRoots(this.n);
	    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
	      lambda = lambdas[0];
	    } else {
	      lambda = lambdas[1];
	      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
	    }
	  }
	
	  // Get basis vectors, used for balanced length-two representation
	  var basis;
	  if (conf.basis) {
	    basis = conf.basis.map(function(vec) {
	      return {
	        a: new BN(vec.a, 16),
	        b: new BN(vec.b, 16)
	      };
	    });
	  } else {
	    basis = this._getEndoBasis(lambda);
	  }
	
	  return {
	    beta: beta,
	    lambda: lambda,
	    basis: basis
	  };
	};
	
	ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
	  // Find roots of for x^2 + x + 1 in F
	  // Root = (-1 +- Sqrt(-3)) / 2
	  //
	  var red = num === this.p ? this.red : BN.mont(num);
	  var tinv = new BN(2).toRed(red).redInvm();
	  var ntinv = tinv.redNeg();
	
	  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);
	
	  var l1 = ntinv.redAdd(s).fromRed();
	  var l2 = ntinv.redSub(s).fromRed();
	  return [ l1, l2 ];
	};
	
	ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
	  // aprxSqrt >= sqrt(this.n)
	  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
	
	  // 3.74
	  // Run EGCD, until r(L + 1) < aprxSqrt
	  var u = lambda;
	  var v = this.n.clone();
	  var x1 = new BN(1);
	  var y1 = new BN(0);
	  var x2 = new BN(0);
	  var y2 = new BN(1);
	
	  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
	  var a0;
	  var b0;
	  // First vector
	  var a1;
	  var b1;
	  // Second vector
	  var a2;
	  var b2;
	
	  var prevR;
	  var i = 0;
	  var r;
	  var x;
	  while (u.cmpn(0) !== 0) {
	    var q = v.div(u);
	    r = v.sub(q.mul(u));
	    x = x2.sub(q.mul(x1));
	    var y = y2.sub(q.mul(y1));
	
	    if (!a1 && r.cmp(aprxSqrt) < 0) {
	      a0 = prevR.neg();
	      b0 = x1;
	      a1 = r.neg();
	      b1 = x;
	    } else if (a1 && ++i === 2) {
	      break;
	    }
	    prevR = r;
	
	    v = u;
	    u = r;
	    x2 = x1;
	    x1 = x;
	    y2 = y1;
	    y1 = y;
	  }
	  a2 = r.neg();
	  b2 = x;
	
	  var len1 = a1.sqr().add(b1.sqr());
	  var len2 = a2.sqr().add(b2.sqr());
	  if (len2.cmp(len1) >= 0) {
	    a2 = a0;
	    b2 = b0;
	  }
	
	  // Normalize signs
	  if (a1.negative) {
	    a1 = a1.neg();
	    b1 = b1.neg();
	  }
	  if (a2.negative) {
	    a2 = a2.neg();
	    b2 = b2.neg();
	  }
	
	  return [
	    { a: a1, b: b1 },
	    { a: a2, b: b2 }
	  ];
	};
	
	ShortCurve.prototype._endoSplit = function _endoSplit(k) {
	  var basis = this.endo.basis;
	  var v1 = basis[0];
	  var v2 = basis[1];
	
	  var c1 = v2.b.mul(k).divRound(this.n);
	  var c2 = v1.b.neg().mul(k).divRound(this.n);
	
	  var p1 = c1.mul(v1.a);
	  var p2 = c2.mul(v2.a);
	  var q1 = c1.mul(v1.b);
	  var q2 = c2.mul(v2.b);
	
	  // Calculate answer
	  var k1 = k.sub(p1).sub(p2);
	  var k2 = q1.add(q2).neg();
	  return { k1: k1, k2: k2 };
	};
	
	ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
	  x = new BN(x, 16);
	  if (!x.red)
	    x = x.toRed(this.red);
	
	  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
	  var y = y2.redSqrt();
	  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
	    throw new Error('invalid point');
	
	  // XXX Is there any way to tell if the number is odd without converting it
	  // to non-red form?
	  var isOdd = y.fromRed().isOdd();
	  if (odd && !isOdd || !odd && isOdd)
	    y = y.redNeg();
	
	  return this.point(x, y);
	};
	
	ShortCurve.prototype.validate = function validate(point) {
	  if (point.inf)
	    return true;
	
	  var x = point.x;
	  var y = point.y;
	
	  var ax = this.a.redMul(x);
	  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
	  return y.redSqr().redISub(rhs).cmpn(0) === 0;
	};
	
	ShortCurve.prototype._endoWnafMulAdd =
	    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
	  var npoints = this._endoWnafT1;
	  var ncoeffs = this._endoWnafT2;
	  for (var i = 0; i < points.length; i++) {
	    var split = this._endoSplit(coeffs[i]);
	    var p = points[i];
	    var beta = p._getBeta();
	
	    if (split.k1.negative) {
	      split.k1.ineg();
	      p = p.neg(true);
	    }
	    if (split.k2.negative) {
	      split.k2.ineg();
	      beta = beta.neg(true);
	    }
	
	    npoints[i * 2] = p;
	    npoints[i * 2 + 1] = beta;
	    ncoeffs[i * 2] = split.k1;
	    ncoeffs[i * 2 + 1] = split.k2;
	  }
	  var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
	
	  // Clean-up references to points and coefficients
	  for (var j = 0; j < i * 2; j++) {
	    npoints[j] = null;
	    ncoeffs[j] = null;
	  }
	  return res;
	};
	
	function Point(curve, x, y, isRed) {
	  Base.BasePoint.call(this, curve, 'affine');
	  if (x === null && y === null) {
	    this.x = null;
	    this.y = null;
	    this.inf = true;
	  } else {
	    this.x = new BN(x, 16);
	    this.y = new BN(y, 16);
	    // Force redgomery representation when loading from JSON
	    if (isRed) {
	      this.x.forceRed(this.curve.red);
	      this.y.forceRed(this.curve.red);
	    }
	    if (!this.x.red)
	      this.x = this.x.toRed(this.curve.red);
	    if (!this.y.red)
	      this.y = this.y.toRed(this.curve.red);
	    this.inf = false;
	  }
	}
	inherits(Point, Base.BasePoint);
	
	ShortCurve.prototype.point = function point(x, y, isRed) {
	  return new Point(this, x, y, isRed);
	};
	
	ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
	  return Point.fromJSON(this, obj, red);
	};
	
	Point.prototype._getBeta = function _getBeta() {
	  if (!this.curve.endo)
	    return;
	
	  var pre = this.precomputed;
	  if (pre && pre.beta)
	    return pre.beta;
	
	  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
	  if (pre) {
	    var curve = this.curve;
	    var endoMul = function(p) {
	      return curve.point(p.x.redMul(curve.endo.beta), p.y);
	    };
	    pre.beta = beta;
	    beta.precomputed = {
	      beta: null,
	      naf: pre.naf && {
	        wnd: pre.naf.wnd,
	        points: pre.naf.points.map(endoMul)
	      },
	      doubles: pre.doubles && {
	        step: pre.doubles.step,
	        points: pre.doubles.points.map(endoMul)
	      }
	    };
	  }
	  return beta;
	};
	
	Point.prototype.toJSON = function toJSON() {
	  if (!this.precomputed)
	    return [ this.x, this.y ];
	
	  return [ this.x, this.y, this.precomputed && {
	    doubles: this.precomputed.doubles && {
	      step: this.precomputed.doubles.step,
	      points: this.precomputed.doubles.points.slice(1)
	    },
	    naf: this.precomputed.naf && {
	      wnd: this.precomputed.naf.wnd,
	      points: this.precomputed.naf.points.slice(1)
	    }
	  } ];
	};
	
	Point.fromJSON = function fromJSON(curve, obj, red) {
	  if (typeof obj === 'string')
	    obj = JSON.parse(obj);
	  var res = curve.point(obj[0], obj[1], red);
	  if (!obj[2])
	    return res;
	
	  function obj2point(obj) {
	    return curve.point(obj[0], obj[1], red);
	  }
	
	  var pre = obj[2];
	  res.precomputed = {
	    beta: null,
	    doubles: pre.doubles && {
	      step: pre.doubles.step,
	      points: [ res ].concat(pre.doubles.points.map(obj2point))
	    },
	    naf: pre.naf && {
	      wnd: pre.naf.wnd,
	      points: [ res ].concat(pre.naf.points.map(obj2point))
	    }
	  };
	  return res;
	};
	
	Point.prototype.inspect = function inspect() {
	  if (this.isInfinity())
	    return '<EC Point Infinity>';
	  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
	      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
	};
	
	Point.prototype.isInfinity = function isInfinity() {
	  return this.inf;
	};
	
	Point.prototype.add = function add(p) {
	  // O + P = P
	  if (this.inf)
	    return p;
	
	  // P + O = P
	  if (p.inf)
	    return this;
	
	  // P + P = 2P
	  if (this.eq(p))
	    return this.dbl();
	
	  // P + (-P) = O
	  if (this.neg().eq(p))
	    return this.curve.point(null, null);
	
	  // P + Q = O
	  if (this.x.cmp(p.x) === 0)
	    return this.curve.point(null, null);
	
	  var c = this.y.redSub(p.y);
	  if (c.cmpn(0) !== 0)
	    c = c.redMul(this.x.redSub(p.x).redInvm());
	  var nx = c.redSqr().redISub(this.x).redISub(p.x);
	  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
	  return this.curve.point(nx, ny);
	};
	
	Point.prototype.dbl = function dbl() {
	  if (this.inf)
	    return this;
	
	  // 2P = O
	  var ys1 = this.y.redAdd(this.y);
	  if (ys1.cmpn(0) === 0)
	    return this.curve.point(null, null);
	
	  var a = this.curve.a;
	
	  var x2 = this.x.redSqr();
	  var dyinv = ys1.redInvm();
	  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
	
	  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
	  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
	  return this.curve.point(nx, ny);
	};
	
	Point.prototype.getX = function getX() {
	  return this.x.fromRed();
	};
	
	Point.prototype.getY = function getY() {
	  return this.y.fromRed();
	};
	
	Point.prototype.mul = function mul(k) {
	  k = new BN(k, 16);
	
	  if (this._hasDoubles(k))
	    return this.curve._fixedNafMul(this, k);
	  else if (this.curve.endo)
	    return this.curve._endoWnafMulAdd([ this ], [ k ]);
	  else
	    return this.curve._wnafMul(this, k);
	};
	
	Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
	  var points = [ this, p2 ];
	  var coeffs = [ k1, k2 ];
	  if (this.curve.endo)
	    return this.curve._endoWnafMulAdd(points, coeffs);
	  else
	    return this.curve._wnafMulAdd(1, points, coeffs, 2);
	};
	
	Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
	  var points = [ this, p2 ];
	  var coeffs = [ k1, k2 ];
	  if (this.curve.endo)
	    return this.curve._endoWnafMulAdd(points, coeffs, true);
	  else
	    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
	};
	
	Point.prototype.eq = function eq(p) {
	  return this === p ||
	         this.inf === p.inf &&
	             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
	};
	
	Point.prototype.neg = function neg(_precompute) {
	  if (this.inf)
	    return this;
	
	  var res = this.curve.point(this.x, this.y.redNeg());
	  if (_precompute && this.precomputed) {
	    var pre = this.precomputed;
	    var negate = function(p) {
	      return p.neg();
	    };
	    res.precomputed = {
	      naf: pre.naf && {
	        wnd: pre.naf.wnd,
	        points: pre.naf.points.map(negate)
	      },
	      doubles: pre.doubles && {
	        step: pre.doubles.step,
	        points: pre.doubles.points.map(negate)
	      }
	    };
	  }
	  return res;
	};
	
	Point.prototype.toJ = function toJ() {
	  if (this.inf)
	    return this.curve.jpoint(null, null, null);
	
	  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
	  return res;
	};
	
	function JPoint(curve, x, y, z) {
	  Base.BasePoint.call(this, curve, 'jacobian');
	  if (x === null && y === null && z === null) {
	    this.x = this.curve.one;
	    this.y = this.curve.one;
	    this.z = new BN(0);
	  } else {
	    this.x = new BN(x, 16);
	    this.y = new BN(y, 16);
	    this.z = new BN(z, 16);
	  }
	  if (!this.x.red)
	    this.x = this.x.toRed(this.curve.red);
	  if (!this.y.red)
	    this.y = this.y.toRed(this.curve.red);
	  if (!this.z.red)
	    this.z = this.z.toRed(this.curve.red);
	
	  this.zOne = this.z === this.curve.one;
	}
	inherits(JPoint, Base.BasePoint);
	
	ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
	  return new JPoint(this, x, y, z);
	};
	
	JPoint.prototype.toP = function toP() {
	  if (this.isInfinity())
	    return this.curve.point(null, null);
	
	  var zinv = this.z.redInvm();
	  var zinv2 = zinv.redSqr();
	  var ax = this.x.redMul(zinv2);
	  var ay = this.y.redMul(zinv2).redMul(zinv);
	
	  return this.curve.point(ax, ay);
	};
	
	JPoint.prototype.neg = function neg() {
	  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
	};
	
	JPoint.prototype.add = function add(p) {
	  // O + P = P
	  if (this.isInfinity())
	    return p;
	
	  // P + O = P
	  if (p.isInfinity())
	    return this;
	
	  // 12M + 4S + 7A
	  var pz2 = p.z.redSqr();
	  var z2 = this.z.redSqr();
	  var u1 = this.x.redMul(pz2);
	  var u2 = p.x.redMul(z2);
	  var s1 = this.y.redMul(pz2.redMul(p.z));
	  var s2 = p.y.redMul(z2.redMul(this.z));
	
	  var h = u1.redSub(u2);
	  var r = s1.redSub(s2);
	  if (h.cmpn(0) === 0) {
	    if (r.cmpn(0) !== 0)
	      return this.curve.jpoint(null, null, null);
	    else
	      return this.dbl();
	  }
	
	  var h2 = h.redSqr();
	  var h3 = h2.redMul(h);
	  var v = u1.redMul(h2);
	
	  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
	  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
	  var nz = this.z.redMul(p.z).redMul(h);
	
	  return this.curve.jpoint(nx, ny, nz);
	};
	
	JPoint.prototype.mixedAdd = function mixedAdd(p) {
	  // O + P = P
	  if (this.isInfinity())
	    return p.toJ();
	
	  // P + O = P
	  if (p.isInfinity())
	    return this;
	
	  // 8M + 3S + 7A
	  var z2 = this.z.redSqr();
	  var u1 = this.x;
	  var u2 = p.x.redMul(z2);
	  var s1 = this.y;
	  var s2 = p.y.redMul(z2).redMul(this.z);
	
	  var h = u1.redSub(u2);
	  var r = s1.redSub(s2);
	  if (h.cmpn(0) === 0) {
	    if (r.cmpn(0) !== 0)
	      return this.curve.jpoint(null, null, null);
	    else
	      return this.dbl();
	  }
	
	  var h2 = h.redSqr();
	  var h3 = h2.redMul(h);
	  var v = u1.redMul(h2);
	
	  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
	  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
	  var nz = this.z.redMul(h);
	
	  return this.curve.jpoint(nx, ny, nz);
	};
	
	JPoint.prototype.dblp = function dblp(pow) {
	  if (pow === 0)
	    return this;
	  if (this.isInfinity())
	    return this;
	  if (!pow)
	    return this.dbl();
	
	  if (this.curve.zeroA || this.curve.threeA) {
	    var r = this;
	    for (var i = 0; i < pow; i++)
	      r = r.dbl();
	    return r;
	  }
	
	  // 1M + 2S + 1A + N * (4S + 5M + 8A)
	  // N = 1 => 6M + 6S + 9A
	  var a = this.curve.a;
	  var tinv = this.curve.tinv;
	
	  var jx = this.x;
	  var jy = this.y;
	  var jz = this.z;
	  var jz4 = jz.redSqr().redSqr();
	
	  // Reuse results
	  var jyd = jy.redAdd(jy);
	  for (var i = 0; i < pow; i++) {
	    var jx2 = jx.redSqr();
	    var jyd2 = jyd.redSqr();
	    var jyd4 = jyd2.redSqr();
	    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
	
	    var t1 = jx.redMul(jyd2);
	    var nx = c.redSqr().redISub(t1.redAdd(t1));
	    var t2 = t1.redISub(nx);
	    var dny = c.redMul(t2);
	    dny = dny.redIAdd(dny).redISub(jyd4);
	    var nz = jyd.redMul(jz);
	    if (i + 1 < pow)
	      jz4 = jz4.redMul(jyd4);
	
	    jx = nx;
	    jz = nz;
	    jyd = dny;
	  }
	
	  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
	};
	
	JPoint.prototype.dbl = function dbl() {
	  if (this.isInfinity())
	    return this;
	
	  if (this.curve.zeroA)
	    return this._zeroDbl();
	  else if (this.curve.threeA)
	    return this._threeDbl();
	  else
	    return this._dbl();
	};
	
	JPoint.prototype._zeroDbl = function _zeroDbl() {
	  var nx;
	  var ny;
	  var nz;
	  // Z = 1
	  if (this.zOne) {
	    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
	    //     #doubling-mdbl-2007-bl
	    // 1M + 5S + 14A
	
	    // XX = X1^2
	    var xx = this.x.redSqr();
	    // YY = Y1^2
	    var yy = this.y.redSqr();
	    // YYYY = YY^2
	    var yyyy = yy.redSqr();
	    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
	    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
	    s = s.redIAdd(s);
	    // M = 3 * XX + a; a = 0
	    var m = xx.redAdd(xx).redIAdd(xx);
	    // T = M ^ 2 - 2*S
	    var t = m.redSqr().redISub(s).redISub(s);
	
	    // 8 * YYYY
	    var yyyy8 = yyyy.redIAdd(yyyy);
	    yyyy8 = yyyy8.redIAdd(yyyy8);
	    yyyy8 = yyyy8.redIAdd(yyyy8);
	
	    // X3 = T
	    nx = t;
	    // Y3 = M * (S - T) - 8 * YYYY
	    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
	    // Z3 = 2*Y1
	    nz = this.y.redAdd(this.y);
	  } else {
	    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
	    //     #doubling-dbl-2009-l
	    // 2M + 5S + 13A
	
	    // A = X1^2
	    var a = this.x.redSqr();
	    // B = Y1^2
	    var b = this.y.redSqr();
	    // C = B^2
	    var c = b.redSqr();
	    // D = 2 * ((X1 + B)^2 - A - C)
	    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
	    d = d.redIAdd(d);
	    // E = 3 * A
	    var e = a.redAdd(a).redIAdd(a);
	    // F = E^2
	    var f = e.redSqr();
	
	    // 8 * C
	    var c8 = c.redIAdd(c);
	    c8 = c8.redIAdd(c8);
	    c8 = c8.redIAdd(c8);
	
	    // X3 = F - 2 * D
	    nx = f.redISub(d).redISub(d);
	    // Y3 = E * (D - X3) - 8 * C
	    ny = e.redMul(d.redISub(nx)).redISub(c8);
	    // Z3 = 2 * Y1 * Z1
	    nz = this.y.redMul(this.z);
	    nz = nz.redIAdd(nz);
	  }
	
	  return this.curve.jpoint(nx, ny, nz);
	};
	
	JPoint.prototype._threeDbl = function _threeDbl() {
	  var nx;
	  var ny;
	  var nz;
	  // Z = 1
	  if (this.zOne) {
	    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
	    //     #doubling-mdbl-2007-bl
	    // 1M + 5S + 15A
	
	    // XX = X1^2
	    var xx = this.x.redSqr();
	    // YY = Y1^2
	    var yy = this.y.redSqr();
	    // YYYY = YY^2
	    var yyyy = yy.redSqr();
	    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
	    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
	    s = s.redIAdd(s);
	    // M = 3 * XX + a
	    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
	    // T = M^2 - 2 * S
	    var t = m.redSqr().redISub(s).redISub(s);
	    // X3 = T
	    nx = t;
	    // Y3 = M * (S - T) - 8 * YYYY
	    var yyyy8 = yyyy.redIAdd(yyyy);
	    yyyy8 = yyyy8.redIAdd(yyyy8);
	    yyyy8 = yyyy8.redIAdd(yyyy8);
	    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
	    // Z3 = 2 * Y1
	    nz = this.y.redAdd(this.y);
	  } else {
	    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
	    // 3M + 5S
	
	    // delta = Z1^2
	    var delta = this.z.redSqr();
	    // gamma = Y1^2
	    var gamma = this.y.redSqr();
	    // beta = X1 * gamma
	    var beta = this.x.redMul(gamma);
	    // alpha = 3 * (X1 - delta) * (X1 + delta)
	    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
	    alpha = alpha.redAdd(alpha).redIAdd(alpha);
	    // X3 = alpha^2 - 8 * beta
	    var beta4 = beta.redIAdd(beta);
	    beta4 = beta4.redIAdd(beta4);
	    var beta8 = beta4.redAdd(beta4);
	    nx = alpha.redSqr().redISub(beta8);
	    // Z3 = (Y1 + Z1)^2 - gamma - delta
	    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
	    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
	    var ggamma8 = gamma.redSqr();
	    ggamma8 = ggamma8.redIAdd(ggamma8);
	    ggamma8 = ggamma8.redIAdd(ggamma8);
	    ggamma8 = ggamma8.redIAdd(ggamma8);
	    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
	  }
	
	  return this.curve.jpoint(nx, ny, nz);
	};
	
	JPoint.prototype._dbl = function _dbl() {
	  var a = this.curve.a;
	
	  // 4M + 6S + 10A
	  var jx = this.x;
	  var jy = this.y;
	  var jz = this.z;
	  var jz4 = jz.redSqr().redSqr();
	
	  var jx2 = jx.redSqr();
	  var jy2 = jy.redSqr();
	
	  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
	
	  var jxd4 = jx.redAdd(jx);
	  jxd4 = jxd4.redIAdd(jxd4);
	  var t1 = jxd4.redMul(jy2);
	  var nx = c.redSqr().redISub(t1.redAdd(t1));
	  var t2 = t1.redISub(nx);
	
	  var jyd8 = jy2.redSqr();
	  jyd8 = jyd8.redIAdd(jyd8);
	  jyd8 = jyd8.redIAdd(jyd8);
	  jyd8 = jyd8.redIAdd(jyd8);
	  var ny = c.redMul(t2).redISub(jyd8);
	  var nz = jy.redAdd(jy).redMul(jz);
	
	  return this.curve.jpoint(nx, ny, nz);
	};
	
	JPoint.prototype.trpl = function trpl() {
	  if (!this.curve.zeroA)
	    return this.dbl().add(this);
	
	  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
	  // 5M + 10S + ...
	
	  // XX = X1^2
	  var xx = this.x.redSqr();
	  // YY = Y1^2
	  var yy = this.y.redSqr();
	  // ZZ = Z1^2
	  var zz = this.z.redSqr();
	  // YYYY = YY^2
	  var yyyy = yy.redSqr();
	  // M = 3 * XX + a * ZZ2; a = 0
	  var m = xx.redAdd(xx).redIAdd(xx);
	  // MM = M^2
	  var mm = m.redSqr();
	  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
	  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
	  e = e.redIAdd(e);
	  e = e.redAdd(e).redIAdd(e);
	  e = e.redISub(mm);
	  // EE = E^2
	  var ee = e.redSqr();
	  // T = 16*YYYY
	  var t = yyyy.redIAdd(yyyy);
	  t = t.redIAdd(t);
	  t = t.redIAdd(t);
	  t = t.redIAdd(t);
	  // U = (M + E)^2 - MM - EE - T
	  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
	  // X3 = 4 * (X1 * EE - 4 * YY * U)
	  var yyu4 = yy.redMul(u);
	  yyu4 = yyu4.redIAdd(yyu4);
	  yyu4 = yyu4.redIAdd(yyu4);
	  var nx = this.x.redMul(ee).redISub(yyu4);
	  nx = nx.redIAdd(nx);
	  nx = nx.redIAdd(nx);
	  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
	  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
	  ny = ny.redIAdd(ny);
	  ny = ny.redIAdd(ny);
	  ny = ny.redIAdd(ny);
	  // Z3 = (Z1 + E)^2 - ZZ - EE
	  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
	
	  return this.curve.jpoint(nx, ny, nz);
	};
	
	JPoint.prototype.mul = function mul(k, kbase) {
	  k = new BN(k, kbase);
	
	  return this.curve._wnafMul(this, k);
	};
	
	JPoint.prototype.eq = function eq(p) {
	  if (p.type === 'affine')
	    return this.eq(p.toJ());
	
	  if (this === p)
	    return true;
	
	  // x1 * z2^2 == x2 * z1^2
	  var z2 = this.z.redSqr();
	  var pz2 = p.z.redSqr();
	  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
	    return false;
	
	  // y1 * z2^3 == y2 * z1^3
	  var z3 = z2.redMul(this.z);
	  var pz3 = pz2.redMul(p.z);
	  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
	};
	
	JPoint.prototype.eqXToP = function eqXToP(x) {
	  var zs = this.z.redSqr();
	  var rx = x.toRed(this.curve.red).redMul(zs);
	  if (this.x.cmp(rx) === 0)
	    return true;
	
	  var xc = x.clone();
	  var t = this.curve.redN.redMul(zs);
	  for (;;) {
	    xc.iadd(this.curve.n);
	    if (xc.cmp(this.curve.p) >= 0)
	      return false;
	
	    rx.redIAdd(t);
	    if (this.x.cmp(rx) === 0)
	      return true;
	  }
	  return false;
	};
	
	JPoint.prototype.inspect = function inspect() {
	  if (this.isInfinity())
	    return '<EC JPoint Infinity>';
	  return '<EC JPoint x: ' + this.x.toString(16, 2) +
	      ' y: ' + this.y.toString(16, 2) +
	      ' z: ' + this.z.toString(16, 2) + '>';
	};
	
	JPoint.prototype.isInfinity = function isInfinity() {
	  // XXX This code assumes that zero is always zero in red
	  return this.z.cmpn(0) === 0;
	};


/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var curves = exports;
	
	var hash = __webpack_require__(137);
	var elliptic = __webpack_require__(13);
	
	var assert = elliptic.utils.assert;
	
	function PresetCurve(options) {
	  if (options.type === 'short')
	    this.curve = new elliptic.curve.short(options);
	  else if (options.type === 'edwards')
	    this.curve = new elliptic.curve.edwards(options);
	  else
	    this.curve = new elliptic.curve.mont(options);
	  this.g = this.curve.g;
	  this.n = this.curve.n;
	  this.hash = options.hash;
	
	  assert(this.g.validate(), 'Invalid curve');
	  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
	}
	curves.PresetCurve = PresetCurve;
	
	function defineCurve(name, options) {
	  Object.defineProperty(curves, name, {
	    configurable: true,
	    enumerable: true,
	    get: function() {
	      var curve = new PresetCurve(options);
	      Object.defineProperty(curves, name, {
	        configurable: true,
	        enumerable: true,
	        value: curve
	      });
	      return curve;
	    }
	  });
	}
	
	defineCurve('p192', {
	  type: 'short',
	  prime: 'p192',
	  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
	  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
	  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
	  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
	  hash: hash.sha256,
	  gRed: false,
	  g: [
	    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
	    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
	  ]
	});
	
	defineCurve('p224', {
	  type: 'short',
	  prime: 'p224',
	  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
	  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
	  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
	  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
	  hash: hash.sha256,
	  gRed: false,
	  g: [
	    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
	    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
	  ]
	});
	
	defineCurve('p256', {
	  type: 'short',
	  prime: null,
	  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
	  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
	  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
	  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
	  hash: hash.sha256,
	  gRed: false,
	  g: [
	    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
	    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
	  ]
	});
	
	defineCurve('p384', {
	  type: 'short',
	  prime: null,
	  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
	     'fffffffe ffffffff 00000000 00000000 ffffffff',
	  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
	     'fffffffe ffffffff 00000000 00000000 fffffffc',
	  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
	     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
	  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
	     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
	  hash: hash.sha384,
	  gRed: false,
	  g: [
	    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
	    '5502f25d bf55296c 3a545e38 72760ab7',
	    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
	    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f'
	  ]
	});
	
	defineCurve('p521', {
	  type: 'short',
	  prime: null,
	  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
	     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
	     'ffffffff ffffffff ffffffff ffffffff ffffffff',
	  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
	     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
	     'ffffffff ffffffff ffffffff ffffffff fffffffc',
	  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
	     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
	     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
	  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
	     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
	     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
	  hash: hash.sha512,
	  gRed: false,
	  g: [
	    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
	    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
	    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
	    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
	    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
	    '3fad0761 353c7086 a272c240 88be9476 9fd16650'
	  ]
	});
	
	defineCurve('curve25519', {
	  type: 'mont',
	  prime: 'p25519',
	  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
	  a: '76d06',
	  b: '1',
	  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
	  hash: hash.sha256,
	  gRed: false,
	  g: [
	    '9'
	  ]
	});
	
	defineCurve('ed25519', {
	  type: 'edwards',
	  prime: 'p25519',
	  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
	  a: '-1',
	  c: '1',
	  // -121665 * (121666^(-1)) (mod P)
	  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
	  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
	  hash: hash.sha256,
	  gRed: false,
	  g: [
	    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
	
	    // 4/5
	    '6666666666666666666666666666666666666666666666666666666666666658'
	  ]
	});
	
	var pre;
	try {
	  pre = __webpack_require__(500);
	} catch (e) {
	  pre = undefined;
	}
	
	defineCurve('secp256k1', {
	  type: 'short',
	  prime: 'k256',
	  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
	  a: '0',
	  b: '7',
	  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
	  h: '1',
	  hash: hash.sha256,
	
	  // Precomputed endomorphism
	  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
	  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
	  basis: [
	    {
	      a: '3086d221a7d46bcde86c90e49284eb15',
	      b: '-e4437ed6010e88286f547fa90abfe4c3'
	    },
	    {
	      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
	      b: '3086d221a7d46bcde86c90e49284eb15'
	    }
	  ],
	
	  gRed: false,
	  g: [
	    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
	    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
	    pre
	  ]
	});


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var BN = __webpack_require__(7);
	var HmacDRBG = __webpack_require__(547);
	var elliptic = __webpack_require__(13);
	var utils = elliptic.utils;
	var assert = utils.assert;
	
	var KeyPair = __webpack_require__(495);
	var Signature = __webpack_require__(496);
	
	function EC(options) {
	  if (!(this instanceof EC))
	    return new EC(options);
	
	  // Shortcut `elliptic.ec(curve-name)`
	  if (typeof options === 'string') {
	    assert(elliptic.curves.hasOwnProperty(options), 'Unknown curve ' + options);
	
	    options = elliptic.curves[options];
	  }
	
	  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
	  if (options instanceof elliptic.curves.PresetCurve)
	    options = { curve: options };
	
	  this.curve = options.curve.curve;
	  this.n = this.curve.n;
	  this.nh = this.n.ushrn(1);
	  this.g = this.curve.g;
	
	  // Point on curve
	  this.g = options.curve.g;
	  this.g.precompute(options.curve.n.bitLength() + 1);
	
	  // Hash for function for DRBG
	  this.hash = options.hash || options.curve.hash;
	}
	module.exports = EC;
	
	EC.prototype.keyPair = function keyPair(options) {
	  return new KeyPair(this, options);
	};
	
	EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
	  return KeyPair.fromPrivate(this, priv, enc);
	};
	
	EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
	  return KeyPair.fromPublic(this, pub, enc);
	};
	
	EC.prototype.genKeyPair = function genKeyPair(options) {
	  if (!options)
	    options = {};
	
	  // Instantiate Hmac_DRBG
	  var drbg = new HmacDRBG({
	    hash: this.hash,
	    pers: options.pers,
	    persEnc: options.persEnc || 'utf8',
	    entropy: options.entropy || elliptic.rand(this.hash.hmacStrength),
	    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
	    nonce: this.n.toArray()
	  });
	
	  var bytes = this.n.byteLength();
	  var ns2 = this.n.sub(new BN(2));
	  do {
	    var priv = new BN(drbg.generate(bytes));
	    if (priv.cmp(ns2) > 0)
	      continue;
	
	    priv.iaddn(1);
	    return this.keyFromPrivate(priv);
	  } while (true);
	};
	
	EC.prototype._truncateToN = function truncateToN(msg, truncOnly) {
	  var delta = msg.byteLength() * 8 - this.n.bitLength();
	  if (delta > 0)
	    msg = msg.ushrn(delta);
	  if (!truncOnly && msg.cmp(this.n) >= 0)
	    return msg.sub(this.n);
	  else
	    return msg;
	};
	
	EC.prototype.sign = function sign(msg, key, enc, options) {
	  if (typeof enc === 'object') {
	    options = enc;
	    enc = null;
	  }
	  if (!options)
	    options = {};
	
	  key = this.keyFromPrivate(key, enc);
	  msg = this._truncateToN(new BN(msg, 16));
	
	  // Zero-extend key to provide enough entropy
	  var bytes = this.n.byteLength();
	  var bkey = key.getPrivate().toArray('be', bytes);
	
	  // Zero-extend nonce to have the same byte size as N
	  var nonce = msg.toArray('be', bytes);
	
	  // Instantiate Hmac_DRBG
	  var drbg = new HmacDRBG({
	    hash: this.hash,
	    entropy: bkey,
	    nonce: nonce,
	    pers: options.pers,
	    persEnc: options.persEnc || 'utf8'
	  });
	
	  // Number of bytes to generate
	  var ns1 = this.n.sub(new BN(1));
	
	  for (var iter = 0; true; iter++) {
	    var k = options.k ?
	        options.k(iter) :
	        new BN(drbg.generate(this.n.byteLength()));
	    k = this._truncateToN(k, true);
	    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
	      continue;
	
	    var kp = this.g.mul(k);
	    if (kp.isInfinity())
	      continue;
	
	    var kpX = kp.getX();
	    var r = kpX.umod(this.n);
	    if (r.cmpn(0) === 0)
	      continue;
	
	    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
	    s = s.umod(this.n);
	    if (s.cmpn(0) === 0)
	      continue;
	
	    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
	                        (kpX.cmp(r) !== 0 ? 2 : 0);
	
	    // Use complement of `s`, if it is > `n / 2`
	    if (options.canonical && s.cmp(this.nh) > 0) {
	      s = this.n.sub(s);
	      recoveryParam ^= 1;
	    }
	
	    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
	  }
	};
	
	EC.prototype.verify = function verify(msg, signature, key, enc) {
	  msg = this._truncateToN(new BN(msg, 16));
	  key = this.keyFromPublic(key, enc);
	  signature = new Signature(signature, 'hex');
	
	  // Perform primitive values validation
	  var r = signature.r;
	  var s = signature.s;
	  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
	    return false;
	  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
	    return false;
	
	  // Validate signature
	  var sinv = s.invm(this.n);
	  var u1 = sinv.mul(msg).umod(this.n);
	  var u2 = sinv.mul(r).umod(this.n);
	
	  if (!this.curve._maxwellTrick) {
	    var p = this.g.mulAdd(u1, key.getPublic(), u2);
	    if (p.isInfinity())
	      return false;
	
	    return p.getX().umod(this.n).cmp(r) === 0;
	  }
	
	  // NOTE: Greg Maxwell's trick, inspired by:
	  // https://git.io/vad3K
	
	  var p = this.g.jmulAdd(u1, key.getPublic(), u2);
	  if (p.isInfinity())
	    return false;
	
	  // Compare `p.x` of Jacobian point with `r`,
	  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
	  // inverse of `p.z^2`
	  return p.eqXToP(r);
	};
	
	EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
	  assert((3 & j) === j, 'The recovery param is more than two bits');
	  signature = new Signature(signature, enc);
	
	  var n = this.n;
	  var e = new BN(msg);
	  var r = signature.r;
	  var s = signature.s;
	
	  // A set LSB signifies that the y-coordinate is odd
	  var isYOdd = j & 1;
	  var isSecondKey = j >> 1;
	  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
	    throw new Error('Unable to find sencond key candinate');
	
	  // 1.1. Let x = r + jn.
	  if (isSecondKey)
	    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
	  else
	    r = this.curve.pointFromX(r, isYOdd);
	
	  var rInv = signature.r.invm(n);
	  var s1 = n.sub(e).mul(rInv).umod(n);
	  var s2 = s.mul(rInv).umod(n);
	
	  // 1.6.1 Compute Q = r^-1 (sR -  eG)
	  //               Q = r^-1 (sR + -eG)
	  return this.g.mulAdd(s1, r, s2);
	};
	
	EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
	  signature = new Signature(signature, enc);
	  if (signature.recoveryParam !== null)
	    return signature.recoveryParam;
	
	  for (var i = 0; i < 4; i++) {
	    var Qprime;
	    try {
	      Qprime = this.recoverPubKey(e, signature, i);
	    } catch (e) {
	      continue;
	    }
	
	    if (Qprime.eq(Q))
	      return i;
	  }
	  throw new Error('Unable to find valid recovery factor');
	};


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var BN = __webpack_require__(7);
	var elliptic = __webpack_require__(13);
	var utils = elliptic.utils;
	var assert = utils.assert;
	
	function KeyPair(ec, options) {
	  this.ec = ec;
	  this.priv = null;
	  this.pub = null;
	
	  // KeyPair(ec, { priv: ..., pub: ... })
	  if (options.priv)
	    this._importPrivate(options.priv, options.privEnc);
	  if (options.pub)
	    this._importPublic(options.pub, options.pubEnc);
	}
	module.exports = KeyPair;
	
	KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
	  if (pub instanceof KeyPair)
	    return pub;
	
	  return new KeyPair(ec, {
	    pub: pub,
	    pubEnc: enc
	  });
	};
	
	KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
	  if (priv instanceof KeyPair)
	    return priv;
	
	  return new KeyPair(ec, {
	    priv: priv,
	    privEnc: enc
	  });
	};
	
	KeyPair.prototype.validate = function validate() {
	  var pub = this.getPublic();
	
	  if (pub.isInfinity())
	    return { result: false, reason: 'Invalid public key' };
	  if (!pub.validate())
	    return { result: false, reason: 'Public key is not a point' };
	  if (!pub.mul(this.ec.curve.n).isInfinity())
	    return { result: false, reason: 'Public key * N != O' };
	
	  return { result: true, reason: null };
	};
	
	KeyPair.prototype.getPublic = function getPublic(compact, enc) {
	  // compact is optional argument
	  if (typeof compact === 'string') {
	    enc = compact;
	    compact = null;
	  }
	
	  if (!this.pub)
	    this.pub = this.ec.g.mul(this.priv);
	
	  if (!enc)
	    return this.pub;
	
	  return this.pub.encode(enc, compact);
	};
	
	KeyPair.prototype.getPrivate = function getPrivate(enc) {
	  if (enc === 'hex')
	    return this.priv.toString(16, 2);
	  else
	    return this.priv;
	};
	
	KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
	  this.priv = new BN(key, enc || 16);
	
	  // Ensure that the priv won't be bigger than n, otherwise we may fail
	  // in fixed multiplication method
	  this.priv = this.priv.umod(this.ec.curve.n);
	};
	
	KeyPair.prototype._importPublic = function _importPublic(key, enc) {
	  if (key.x || key.y) {
	    // Montgomery points only have an `x` coordinate.
	    // Weierstrass/Edwards points on the other hand have both `x` and
	    // `y` coordinates.
	    if (this.ec.curve.type === 'mont') {
	      assert(key.x, 'Need x coordinate');
	    } else if (this.ec.curve.type === 'short' ||
	               this.ec.curve.type === 'edwards') {
	      assert(key.x && key.y, 'Need both x and y coordinate');
	    }
	    this.pub = this.ec.curve.point(key.x, key.y);
	    return;
	  }
	  this.pub = this.ec.curve.decodePoint(key, enc);
	};
	
	// ECDH
	KeyPair.prototype.derive = function derive(pub) {
	  return pub.mul(this.priv).getX();
	};
	
	// ECDSA
	KeyPair.prototype.sign = function sign(msg, enc, options) {
	  return this.ec.sign(msg, this, enc, options);
	};
	
	KeyPair.prototype.verify = function verify(msg, signature) {
	  return this.ec.verify(msg, signature, this);
	};
	
	KeyPair.prototype.inspect = function inspect() {
	  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
	         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
	};


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var BN = __webpack_require__(7);
	
	var elliptic = __webpack_require__(13);
	var utils = elliptic.utils;
	var assert = utils.assert;
	
	function Signature(options, enc) {
	  if (options instanceof Signature)
	    return options;
	
	  if (this._importDER(options, enc))
	    return;
	
	  assert(options.r && options.s, 'Signature without r or s');
	  this.r = new BN(options.r, 16);
	  this.s = new BN(options.s, 16);
	  if (options.recoveryParam === undefined)
	    this.recoveryParam = null;
	  else
	    this.recoveryParam = options.recoveryParam;
	}
	module.exports = Signature;
	
	function Position() {
	  this.place = 0;
	}
	
	function getLength(buf, p) {
	  var initial = buf[p.place++];
	  if (!(initial & 0x80)) {
	    return initial;
	  }
	  var octetLen = initial & 0xf;
	  var val = 0;
	  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
	    val <<= 8;
	    val |= buf[off];
	  }
	  p.place = off;
	  return val;
	}
	
	function rmPadding(buf) {
	  var i = 0;
	  var len = buf.length - 1;
	  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
	    i++;
	  }
	  if (i === 0) {
	    return buf;
	  }
	  return buf.slice(i);
	}
	
	Signature.prototype._importDER = function _importDER(data, enc) {
	  data = utils.toArray(data, enc);
	  var p = new Position();
	  if (data[p.place++] !== 0x30) {
	    return false;
	  }
	  var len = getLength(data, p);
	  if ((len + p.place) !== data.length) {
	    return false;
	  }
	  if (data[p.place++] !== 0x02) {
	    return false;
	  }
	  var rlen = getLength(data, p);
	  var r = data.slice(p.place, rlen + p.place);
	  p.place += rlen;
	  if (data[p.place++] !== 0x02) {
	    return false;
	  }
	  var slen = getLength(data, p);
	  if (data.length !== slen + p.place) {
	    return false;
	  }
	  var s = data.slice(p.place, slen + p.place);
	  if (r[0] === 0 && (r[1] & 0x80)) {
	    r = r.slice(1);
	  }
	  if (s[0] === 0 && (s[1] & 0x80)) {
	    s = s.slice(1);
	  }
	
	  this.r = new BN(r);
	  this.s = new BN(s);
	  this.recoveryParam = null;
	
	  return true;
	};
	
	function constructLength(arr, len) {
	  if (len < 0x80) {
	    arr.push(len);
	    return;
	  }
	  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
	  arr.push(octets | 0x80);
	  while (--octets) {
	    arr.push((len >>> (octets << 3)) & 0xff);
	  }
	  arr.push(len);
	}
	
	Signature.prototype.toDER = function toDER(enc) {
	  var r = this.r.toArray();
	  var s = this.s.toArray();
	
	  // Pad values
	  if (r[0] & 0x80)
	    r = [ 0 ].concat(r);
	  // Pad values
	  if (s[0] & 0x80)
	    s = [ 0 ].concat(s);
	
	  r = rmPadding(r);
	  s = rmPadding(s);
	
	  while (!s[0] && !(s[1] & 0x80)) {
	    s = s.slice(1);
	  }
	  var arr = [ 0x02 ];
	  constructLength(arr, r.length);
	  arr = arr.concat(r);
	  arr.push(0x02);
	  constructLength(arr, s.length);
	  var backHalf = arr.concat(s);
	  var res = [ 0x30 ];
	  constructLength(res, backHalf.length);
	  res = res.concat(backHalf);
	  return utils.encode(res, enc);
	};


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hash = __webpack_require__(137);
	var elliptic = __webpack_require__(13);
	var utils = elliptic.utils;
	var assert = utils.assert;
	var parseBytes = utils.parseBytes;
	var KeyPair = __webpack_require__(498);
	var Signature = __webpack_require__(499);
	
	function EDDSA(curve) {
	  assert(curve === 'ed25519', 'only tested with ed25519 so far');
	
	  if (!(this instanceof EDDSA))
	    return new EDDSA(curve);
	
	  var curve = elliptic.curves[curve].curve;
	  this.curve = curve;
	  this.g = curve.g;
	  this.g.precompute(curve.n.bitLength() + 1);
	
	  this.pointClass = curve.point().constructor;
	  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
	  this.hash = hash.sha512;
	}
	
	module.exports = EDDSA;
	
	/**
	* @param {Array|String} message - message bytes
	* @param {Array|String|KeyPair} secret - secret bytes or a keypair
	* @returns {Signature} - signature
	*/
	EDDSA.prototype.sign = function sign(message, secret) {
	  message = parseBytes(message);
	  var key = this.keyFromSecret(secret);
	  var r = this.hashInt(key.messagePrefix(), message);
	  var R = this.g.mul(r);
	  var Rencoded = this.encodePoint(R);
	  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
	               .mul(key.priv());
	  var S = r.add(s_).umod(this.curve.n);
	  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
	};
	
	/**
	* @param {Array} message - message bytes
	* @param {Array|String|Signature} sig - sig bytes
	* @param {Array|String|Point|KeyPair} pub - public key
	* @returns {Boolean} - true if public key matches sig of message
	*/
	EDDSA.prototype.verify = function verify(message, sig, pub) {
	  message = parseBytes(message);
	  sig = this.makeSignature(sig);
	  var key = this.keyFromPublic(pub);
	  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
	  var SG = this.g.mul(sig.S());
	  var RplusAh = sig.R().add(key.pub().mul(h));
	  return RplusAh.eq(SG);
	};
	
	EDDSA.prototype.hashInt = function hashInt() {
	  var hash = this.hash();
	  for (var i = 0; i < arguments.length; i++)
	    hash.update(arguments[i]);
	  return utils.intFromLE(hash.digest()).umod(this.curve.n);
	};
	
	EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
	  return KeyPair.fromPublic(this, pub);
	};
	
	EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
	  return KeyPair.fromSecret(this, secret);
	};
	
	EDDSA.prototype.makeSignature = function makeSignature(sig) {
	  if (sig instanceof Signature)
	    return sig;
	  return new Signature(this, sig);
	};
	
	/**
	* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
	*
	* EDDSA defines methods for encoding and decoding points and integers. These are
	* helper convenience methods, that pass along to utility functions implied
	* parameters.
	*
	*/
	EDDSA.prototype.encodePoint = function encodePoint(point) {
	  var enc = point.getY().toArray('le', this.encodingLength);
	  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
	  return enc;
	};
	
	EDDSA.prototype.decodePoint = function decodePoint(bytes) {
	  bytes = utils.parseBytes(bytes);
	
	  var lastIx = bytes.length - 1;
	  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
	  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
	
	  var y = utils.intFromLE(normed);
	  return this.curve.pointFromY(y, xIsOdd);
	};
	
	EDDSA.prototype.encodeInt = function encodeInt(num) {
	  return num.toArray('le', this.encodingLength);
	};
	
	EDDSA.prototype.decodeInt = function decodeInt(bytes) {
	  return utils.intFromLE(bytes);
	};
	
	EDDSA.prototype.isPoint = function isPoint(val) {
	  return val instanceof this.pointClass;
	};


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var elliptic = __webpack_require__(13);
	var utils = elliptic.utils;
	var assert = utils.assert;
	var parseBytes = utils.parseBytes;
	var cachedProperty = utils.cachedProperty;
	
	/**
	* @param {EDDSA} eddsa - instance
	* @param {Object} params - public/private key parameters
	*
	* @param {Array<Byte>} [params.secret] - secret seed bytes
	* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
	* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
	*
	*/
	function KeyPair(eddsa, params) {
	  this.eddsa = eddsa;
	  this._secret = parseBytes(params.secret);
	  if (eddsa.isPoint(params.pub))
	    this._pub = params.pub;
	  else
	    this._pubBytes = parseBytes(params.pub);
	}
	
	KeyPair.fromPublic = function fromPublic(eddsa, pub) {
	  if (pub instanceof KeyPair)
	    return pub;
	  return new KeyPair(eddsa, { pub: pub });
	};
	
	KeyPair.fromSecret = function fromSecret(eddsa, secret) {
	  if (secret instanceof KeyPair)
	    return secret;
	  return new KeyPair(eddsa, { secret: secret });
	};
	
	KeyPair.prototype.secret = function secret() {
	  return this._secret;
	};
	
	cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
	  return this.eddsa.encodePoint(this.pub());
	});
	
	cachedProperty(KeyPair, 'pub', function pub() {
	  if (this._pubBytes)
	    return this.eddsa.decodePoint(this._pubBytes);
	  return this.eddsa.g.mul(this.priv());
	});
	
	cachedProperty(KeyPair, 'privBytes', function privBytes() {
	  var eddsa = this.eddsa;
	  var hash = this.hash();
	  var lastIx = eddsa.encodingLength - 1;
	
	  var a = hash.slice(0, eddsa.encodingLength);
	  a[0] &= 248;
	  a[lastIx] &= 127;
	  a[lastIx] |= 64;
	
	  return a;
	});
	
	cachedProperty(KeyPair, 'priv', function priv() {
	  return this.eddsa.decodeInt(this.privBytes());
	});
	
	cachedProperty(KeyPair, 'hash', function hash() {
	  return this.eddsa.hash().update(this.secret()).digest();
	});
	
	cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
	  return this.hash().slice(this.eddsa.encodingLength);
	});
	
	KeyPair.prototype.sign = function sign(message) {
	  assert(this._secret, 'KeyPair can only verify');
	  return this.eddsa.sign(message, this);
	};
	
	KeyPair.prototype.verify = function verify(message, sig) {
	  return this.eddsa.verify(message, sig, this);
	};
	
	KeyPair.prototype.getSecret = function getSecret(enc) {
	  assert(this._secret, 'KeyPair is public only');
	  return utils.encode(this.secret(), enc);
	};
	
	KeyPair.prototype.getPublic = function getPublic(enc) {
	  return utils.encode(this.pubBytes(), enc);
	};
	
	module.exports = KeyPair;


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var BN = __webpack_require__(7);
	var elliptic = __webpack_require__(13);
	var utils = elliptic.utils;
	var assert = utils.assert;
	var cachedProperty = utils.cachedProperty;
	var parseBytes = utils.parseBytes;
	
	/**
	* @param {EDDSA} eddsa - eddsa instance
	* @param {Array<Bytes>|Object} sig -
	* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
	* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
	* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
	* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
	*/
	function Signature(eddsa, sig) {
	  this.eddsa = eddsa;
	
	  if (typeof sig !== 'object')
	    sig = parseBytes(sig);
	
	  if (Array.isArray(sig)) {
	    sig = {
	      R: sig.slice(0, eddsa.encodingLength),
	      S: sig.slice(eddsa.encodingLength)
	    };
	  }
	
	  assert(sig.R && sig.S, 'Signature without R or S');
	
	  if (eddsa.isPoint(sig.R))
	    this._R = sig.R;
	  if (sig.S instanceof BN)
	    this._S = sig.S;
	
	  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
	  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
	}
	
	cachedProperty(Signature, 'S', function S() {
	  return this.eddsa.decodeInt(this.Sencoded());
	});
	
	cachedProperty(Signature, 'R', function R() {
	  return this.eddsa.decodePoint(this.Rencoded());
	});
	
	cachedProperty(Signature, 'Rencoded', function Rencoded() {
	  return this.eddsa.encodePoint(this.R());
	});
	
	cachedProperty(Signature, 'Sencoded', function Sencoded() {
	  return this.eddsa.encodeInt(this.S());
	});
	
	Signature.prototype.toBytes = function toBytes() {
	  return this.Rencoded().concat(this.Sencoded());
	};
	
	Signature.prototype.toHex = function toHex() {
	  return utils.encode(this.toBytes(), 'hex').toUpperCase();
	};
	
	module.exports = Signature;


/***/ },
/* 500 */
/***/ function(module, exports) {

	module.exports = {
	  doubles: {
	    step: 4,
	    points: [
	      [
	        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
	        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
	      ],
	      [
	        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
	        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
	      ],
	      [
	        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
	        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
	      ],
	      [
	        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
	        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
	      ],
	      [
	        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
	        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
	      ],
	      [
	        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
	        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
	      ],
	      [
	        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
	        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
	      ],
	      [
	        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
	        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
	      ],
	      [
	        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
	        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
	      ],
	      [
	        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
	        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
	      ],
	      [
	        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
	        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
	      ],
	      [
	        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
	        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
	      ],
	      [
	        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
	        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
	      ],
	      [
	        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
	        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
	      ],
	      [
	        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
	        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
	      ],
	      [
	        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
	        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
	      ],
	      [
	        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
	        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
	      ],
	      [
	        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
	        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
	      ],
	      [
	        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
	        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
	      ],
	      [
	        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
	        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
	      ],
	      [
	        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
	        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
	      ],
	      [
	        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
	        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
	      ],
	      [
	        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
	        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
	      ],
	      [
	        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
	        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
	      ],
	      [
	        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
	        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
	      ],
	      [
	        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
	        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
	      ],
	      [
	        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
	        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
	      ],
	      [
	        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
	        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
	      ],
	      [
	        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
	        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
	      ],
	      [
	        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
	        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
	      ],
	      [
	        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
	        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
	      ],
	      [
	        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
	        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
	      ],
	      [
	        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
	        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
	      ],
	      [
	        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
	        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
	      ],
	      [
	        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
	        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
	      ],
	      [
	        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
	        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
	      ],
	      [
	        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
	        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
	      ],
	      [
	        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
	        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
	      ],
	      [
	        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
	        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
	      ],
	      [
	        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
	        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
	      ],
	      [
	        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
	        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
	      ],
	      [
	        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
	        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
	      ],
	      [
	        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
	        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
	      ],
	      [
	        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
	        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
	      ],
	      [
	        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
	        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
	      ],
	      [
	        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
	        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
	      ],
	      [
	        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
	        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
	      ],
	      [
	        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
	        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
	      ],
	      [
	        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
	        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
	      ],
	      [
	        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
	        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
	      ],
	      [
	        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
	        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
	      ],
	      [
	        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
	        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
	      ],
	      [
	        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
	        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
	      ],
	      [
	        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
	        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
	      ],
	      [
	        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
	        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
	      ],
	      [
	        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
	        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
	      ],
	      [
	        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
	        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
	      ],
	      [
	        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
	        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
	      ],
	      [
	        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
	        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
	      ],
	      [
	        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
	        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
	      ],
	      [
	        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
	        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
	      ],
	      [
	        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
	        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
	      ],
	      [
	        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
	        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
	      ],
	      [
	        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
	        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
	      ],
	      [
	        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
	        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
	      ]
	    ]
	  },
	  naf: {
	    wnd: 7,
	    points: [
	      [
	        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
	        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
	      ],
	      [
	        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
	        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
	      ],
	      [
	        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
	        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
	      ],
	      [
	        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
	        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
	      ],
	      [
	        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
	        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
	      ],
	      [
	        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
	        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
	      ],
	      [
	        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
	        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
	      ],
	      [
	        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
	        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
	      ],
	      [
	        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
	        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
	      ],
	      [
	        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
	        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
	      ],
	      [
	        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
	        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
	      ],
	      [
	        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
	        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
	      ],
	      [
	        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
	        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
	      ],
	      [
	        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
	        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
	      ],
	      [
	        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
	        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
	      ],
	      [
	        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
	        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
	      ],
	      [
	        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
	        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
	      ],
	      [
	        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
	        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
	      ],
	      [
	        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
	        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
	      ],
	      [
	        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
	        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
	      ],
	      [
	        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
	        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
	      ],
	      [
	        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
	        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
	      ],
	      [
	        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
	        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
	      ],
	      [
	        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
	        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
	      ],
	      [
	        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
	        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
	      ],
	      [
	        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
	        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
	      ],
	      [
	        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
	        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
	      ],
	      [
	        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
	        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
	      ],
	      [
	        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
	        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
	      ],
	      [
	        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
	        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
	      ],
	      [
	        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
	        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
	      ],
	      [
	        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
	        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
	      ],
	      [
	        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
	        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
	      ],
	      [
	        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
	        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
	      ],
	      [
	        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
	        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
	      ],
	      [
	        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
	        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
	      ],
	      [
	        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
	        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
	      ],
	      [
	        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
	        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
	      ],
	      [
	        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
	        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
	      ],
	      [
	        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
	        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
	      ],
	      [
	        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
	        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
	      ],
	      [
	        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
	        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
	      ],
	      [
	        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
	        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
	      ],
	      [
	        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
	        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
	      ],
	      [
	        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
	        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
	      ],
	      [
	        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
	        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
	      ],
	      [
	        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
	        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
	      ],
	      [
	        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
	        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
	      ],
	      [
	        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
	        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
	      ],
	      [
	        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
	        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
	      ],
	      [
	        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
	        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
	      ],
	      [
	        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
	        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
	      ],
	      [
	        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
	        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
	      ],
	      [
	        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
	        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
	      ],
	      [
	        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
	        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
	      ],
	      [
	        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
	        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
	      ],
	      [
	        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
	        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
	      ],
	      [
	        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
	        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
	      ],
	      [
	        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
	        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
	      ],
	      [
	        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
	        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
	      ],
	      [
	        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
	        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
	      ],
	      [
	        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
	        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
	      ],
	      [
	        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
	        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
	      ],
	      [
	        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
	        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
	      ],
	      [
	        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
	        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
	      ],
	      [
	        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
	        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
	      ],
	      [
	        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
	        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
	      ],
	      [
	        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
	        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
	      ],
	      [
	        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
	        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
	      ],
	      [
	        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
	        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
	      ],
	      [
	        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
	        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
	      ],
	      [
	        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
	        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
	      ],
	      [
	        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
	        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
	      ],
	      [
	        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
	        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
	      ],
	      [
	        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
	        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
	      ],
	      [
	        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
	        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
	      ],
	      [
	        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
	        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
	      ],
	      [
	        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
	        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
	      ],
	      [
	        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
	        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
	      ],
	      [
	        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
	        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
	      ],
	      [
	        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
	        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
	      ],
	      [
	        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
	        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
	      ],
	      [
	        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
	        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
	      ],
	      [
	        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
	        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
	      ],
	      [
	        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
	        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
	      ],
	      [
	        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
	        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
	      ],
	      [
	        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
	        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
	      ],
	      [
	        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
	        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
	      ],
	      [
	        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
	        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
	      ],
	      [
	        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
	        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
	      ],
	      [
	        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
	        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
	      ],
	      [
	        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
	        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
	      ],
	      [
	        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
	        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
	      ],
	      [
	        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
	        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
	      ],
	      [
	        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
	        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
	      ],
	      [
	        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
	        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
	      ],
	      [
	        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
	        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
	      ],
	      [
	        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
	        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
	      ],
	      [
	        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
	        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
	      ],
	      [
	        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
	        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
	      ],
	      [
	        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
	        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
	      ],
	      [
	        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
	        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
	      ],
	      [
	        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
	        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
	      ],
	      [
	        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
	        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
	      ],
	      [
	        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
	        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
	      ],
	      [
	        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
	        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
	      ],
	      [
	        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
	        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
	      ],
	      [
	        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
	        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
	      ],
	      [
	        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
	        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
	      ],
	      [
	        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
	        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
	      ],
	      [
	        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
	        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
	      ],
	      [
	        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
	        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
	      ],
	      [
	        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
	        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
	      ],
	      [
	        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
	        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
	      ],
	      [
	        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
	        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
	      ],
	      [
	        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
	        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
	      ],
	      [
	        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
	        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
	      ],
	      [
	        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
	        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
	      ],
	      [
	        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
	        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
	      ],
	      [
	        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
	        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
	      ],
	      [
	        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
	        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
	      ],
	      [
	        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
	        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
	      ],
	      [
	        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
	        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
	      ],
	      [
	        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
	        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
	      ],
	      [
	        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
	        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
	      ],
	      [
	        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
	        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
	      ],
	      [
	        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
	        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
	      ]
	    ]
	  }
	};


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = exports;
	var BN = __webpack_require__(7);
	var minAssert = __webpack_require__(21);
	var minUtils = __webpack_require__(248);
	
	utils.assert = minAssert;
	utils.toArray = minUtils.toArray;
	utils.zero2 = minUtils.zero2;
	utils.toHex = minUtils.toHex;
	utils.encode = minUtils.encode;
	
	// Represent num in a w-NAF form
	function getNAF(num, w) {
	  var naf = [];
	  var ws = 1 << (w + 1);
	  var k = num.clone();
	  while (k.cmpn(1) >= 0) {
	    var z;
	    if (k.isOdd()) {
	      var mod = k.andln(ws - 1);
	      if (mod > (ws >> 1) - 1)
	        z = (ws >> 1) - mod;
	      else
	        z = mod;
	      k.isubn(z);
	    } else {
	      z = 0;
	    }
	    naf.push(z);
	
	    // Optimization, shift by word if possible
	    var shift = (k.cmpn(0) !== 0 && k.andln(ws - 1) === 0) ? (w + 1) : 1;
	    for (var i = 1; i < shift; i++)
	      naf.push(0);
	    k.iushrn(shift);
	  }
	
	  return naf;
	}
	utils.getNAF = getNAF;
	
	// Represent k1, k2 in a Joint Sparse Form
	function getJSF(k1, k2) {
	  var jsf = [
	    [],
	    []
	  ];
	
	  k1 = k1.clone();
	  k2 = k2.clone();
	  var d1 = 0;
	  var d2 = 0;
	  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {
	
	    // First phase
	    var m14 = (k1.andln(3) + d1) & 3;
	    var m24 = (k2.andln(3) + d2) & 3;
	    if (m14 === 3)
	      m14 = -1;
	    if (m24 === 3)
	      m24 = -1;
	    var u1;
	    if ((m14 & 1) === 0) {
	      u1 = 0;
	    } else {
	      var m8 = (k1.andln(7) + d1) & 7;
	      if ((m8 === 3 || m8 === 5) && m24 === 2)
	        u1 = -m14;
	      else
	        u1 = m14;
	    }
	    jsf[0].push(u1);
	
	    var u2;
	    if ((m24 & 1) === 0) {
	      u2 = 0;
	    } else {
	      var m8 = (k2.andln(7) + d2) & 7;
	      if ((m8 === 3 || m8 === 5) && m14 === 2)
	        u2 = -m24;
	      else
	        u2 = m24;
	    }
	    jsf[1].push(u2);
	
	    // Second phase
	    if (2 * d1 === u1 + 1)
	      d1 = 1 - d1;
	    if (2 * d2 === u2 + 1)
	      d2 = 1 - d2;
	    k1.iushrn(1);
	    k2.iushrn(1);
	  }
	
	  return jsf;
	}
	utils.getJSF = getJSF;
	
	function cachedProperty(obj, name, computer) {
	  var key = '_' + name;
	  obj.prototype[name] = function cachedProperty() {
	    return this[key] !== undefined ? this[key] :
	           this[key] = computer.call(this);
	  };
	}
	utils.cachedProperty = cachedProperty;
	
	function parseBytes(bytes) {
	  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
	                                     bytes;
	}
	utils.parseBytes = parseBytes;
	
	function intFromLE(bytes) {
	  return new BN(bytes, 'hex', 'le');
	}
	utils.intFromLE = intFromLE;
	


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ethjsUtil = __webpack_require__(507);
	
	module.exports = {
	  incrementHexNumber: incrementHexNumber,
	  formatHex: formatHex
	};
	
	function incrementHexNumber(hexNum) {
	  return formatHex(ethjsUtil.intToHex(parseInt(hexNum, 16) + 1));
	}
	
	function formatHex(hexNum) {
	  var stripped = ethjsUtil.stripHexPrefix(hexNum);
	  while (stripped[0] === '0') {
	    stripped = stripped.substr(1);
	  }
	  return '0x' + stripped;
	}

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(434);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _promise = __webpack_require__(181);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _asyncToGenerator2 = __webpack_require__(387);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(383);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(388);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(389);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(391);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(390);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// const EthQuery = require('ethjs-query')
	var EthQuery = __webpack_require__(505);
	var AsyncEventEmitter = __webpack_require__(338);
	var pify = __webpack_require__(591);
	var hexUtils = __webpack_require__(502);
	var incrementHexNumber = hexUtils.incrementHexNumber;
	
	var RpcBlockTracker = function (_AsyncEventEmitter) {
	  (0, _inherits3.default)(RpcBlockTracker, _AsyncEventEmitter);
	
	  function RpcBlockTracker() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, RpcBlockTracker);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (RpcBlockTracker.__proto__ || (0, _getPrototypeOf2.default)(RpcBlockTracker)).call(this));
	
	    if (!opts.provider) throw new Error('RpcBlockTracker - no provider specified.');
	    _this._provider = opts.provider;
	    _this._query = new EthQuery(opts.provider);
	    // config
	    _this._pollingInterval = opts.pollingInterval || 4e3; // 4 sec
	    _this._syncingTimeout = opts.syncingTimeout || 60 * 1e3; // 1 min
	    // state
	    _this._trackingBlock = null;
	    _this._trackingBlockTimestamp = null;
	    _this._currentBlock = null;
	    _this._isRunning = false;
	    // bind methods for cleaner syntax later
	    _this.emit = _this.emit.bind(_this);
	    _this._performSync = _this._performSync.bind(_this);
	    _this._handleNewBlockNotification = _this._handleNewBlockNotification.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(RpcBlockTracker, [{
	    key: 'getTrackingBlock',
	    value: function getTrackingBlock() {
	      return this._trackingBlock;
	    }
	  }, {
	    key: 'getCurrentBlock',
	    value: function getCurrentBlock() {
	      return this._currentBlock;
	    }
	  }, {
	    key: 'awaitCurrentBlock',
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	        var _this2 = this;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!this._currentBlock) {
	                  _context.next = 2;
	                  break;
	                }
	
	                return _context.abrupt('return', this._currentBlock);
	
	              case 2:
	                _context.next = 4;
	                return new _promise2.default(function (resolve) {
	                  return _this2.once('sync', resolve);
	                });
	
	              case 4:
	                return _context.abrupt('return', this._currentBlock);
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function awaitCurrentBlock() {
	        return _ref.apply(this, arguments);
	      }
	
	      return awaitCurrentBlock;
	    }()
	  }, {
	    key: 'start',
	    value: function () {
	      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
	        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (!this._isRunning) {
	                  _context2.next = 2;
	                  break;
	                }
	
	                return _context2.abrupt('return');
	
	              case 2:
	                this._isRunning = true;
	                // if this._currentBlock
	
	                if (!opts.fromBlock) {
	                  _context2.next = 12;
	                  break;
	                }
	
	                _context2.t0 = this;
	                _context2.next = 7;
	                return this._fetchBlockByNumber(opts.fromBlock);
	
	              case 7:
	                _context2.t1 = _context2.sent;
	                _context2.next = 10;
	                return _context2.t0._setTrackingBlock.call(_context2.t0, _context2.t1);
	
	              case 10:
	                _context2.next = 18;
	                break;
	
	              case 12:
	                _context2.t2 = this;
	                _context2.next = 15;
	                return this._fetchLatestBlock();
	
	              case 15:
	                _context2.t3 = _context2.sent;
	                _context2.next = 18;
	                return _context2.t2._setTrackingBlock.call(_context2.t2, _context2.t3);
	
	              case 18:
	                if (!this._provider.on) {
	                  _context2.next = 23;
	                  break;
	                }
	
	                _context2.next = 21;
	                return this._initSubscription();
	
	              case 21:
	                _context2.next = 24;
	                break;
	
	              case 23:
	                this._performSync().catch(function (err) {
	                  if (err) console.error(err);
	                });
	
	              case 24:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function start() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return start;
	    }()
	  }, {
	    key: 'stop',
	    value: function () {
	      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                this._isRunning = false;
	
	                if (!this._provider.on) {
	                  _context3.next = 4;
	                  break;
	                }
	
	                _context3.next = 4;
	                return this._removeSubscription();
	
	              case 4:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function stop() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return stop;
	    }()
	
	    //
	    // private
	    //
	
	  }, {
	    key: '_setTrackingBlock',
	    value: function () {
	      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(newBlock) {
	        var previous, now;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                if (!(this._trackingBlock && this._trackingBlock.hash === newBlock.hash)) {
	                  _context4.next = 2;
	                  break;
	                }
	
	                return _context4.abrupt('return');
	
	              case 2:
	                // check for large timestamp lapse
	                previous = this._trackingBlockTimestamp;
	                now = Date.now();
	                // check for desynchronization (computer sleep or no internet)
	
	                if (!(previous && now - previous > this._syncingTimeout)) {
	                  _context4.next = 10;
	                  break;
	                }
	
	                this._trackingBlockTimestamp = null;
	                _context4.next = 8;
	                return this._warpToLatest();
	
	              case 8:
	                _context4.next = 14;
	                break;
	
	              case 10:
	                this._trackingBlock = newBlock;
	                this._trackingBlockTimestamp = now;
	                _context4.next = 14;
	                return pify(this.emit)('block', newBlock);
	
	              case 14:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function _setTrackingBlock(_x3) {
	        return _ref4.apply(this, arguments);
	      }
	
	      return _setTrackingBlock;
	    }()
	  }, {
	    key: '_setCurrentBlock',
	    value: function () {
	      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(newBlock) {
	        var oldBlock;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                if (!(this._currentBlock && this._currentBlock.hash === newBlock.hash)) {
	                  _context5.next = 2;
	                  break;
	                }
	
	                return _context5.abrupt('return');
	
	              case 2:
	                oldBlock = this._currentBlock;
	
	                this._currentBlock = newBlock;
	                _context5.next = 6;
	                return pify(this.emit)('latest', newBlock);
	
	              case 6:
	                _context5.next = 8;
	                return pify(this.emit)('sync', { newBlock: newBlock, oldBlock: oldBlock });
	
	              case 8:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function _setCurrentBlock(_x4) {
	        return _ref5.apply(this, arguments);
	      }
	
	      return _setCurrentBlock;
	    }()
	  }, {
	    key: '_warpToLatest',
	    value: function () {
	      var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _context6.t0 = this;
	                _context6.next = 3;
	                return this._fetchLatestBlock();
	
	              case 3:
	                _context6.t1 = _context6.sent;
	                _context6.next = 6;
	                return _context6.t0._setTrackingBlock.call(_context6.t0, _context6.t1);
	
	              case 6:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, this);
	      }));
	
	      function _warpToLatest() {
	        return _ref6.apply(this, arguments);
	      }
	
	      return _warpToLatest;
	    }()
	  }, {
	    key: '_pollForNextBlock',
	    value: function () {
	      var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
	        var _this3 = this;
	
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                setTimeout(function () {
	                  return _this3._performSync();
	                }, this._pollingInterval);
	
	              case 1:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      function _pollForNextBlock() {
	        return _ref7.apply(this, arguments);
	      }
	
	      return _pollForNextBlock;
	    }()
	  }, {
	    key: '_performSync',
	    value: function () {
	      var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8() {
	        var trackingBlock, nextNumber, newBlock;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                if (this._isRunning) {
	                  _context8.next = 2;
	                  break;
	                }
	
	                return _context8.abrupt('return');
	
	              case 2:
	                trackingBlock = this.getTrackingBlock();
	
	                if (trackingBlock) {
	                  _context8.next = 5;
	                  break;
	                }
	
	                throw new Error('RpcBlockTracker - tracking block is missing');
	
	              case 5:
	                nextNumber = incrementHexNumber(trackingBlock.number);
	                _context8.prev = 6;
	                _context8.next = 9;
	                return this._fetchBlockByNumber(nextNumber);
	
	              case 9:
	                newBlock = _context8.sent;
	
	                if (!newBlock) {
	                  _context8.next = 16;
	                  break;
	                }
	
	                _context8.next = 13;
	                return this._setTrackingBlock(newBlock);
	
	              case 13:
	                // ask for next block
	                this._performSync();
	                _context8.next = 19;
	                break;
	
	              case 16:
	                _context8.next = 18;
	                return this._setCurrentBlock(trackingBlock);
	
	              case 18:
	                // setup poll for next block
	                this._pollForNextBlock();
	
	              case 19:
	                _context8.next = 31;
	                break;
	
	              case 21:
	                _context8.prev = 21;
	                _context8.t0 = _context8['catch'](6);
	
	                if (!(_context8.t0.message.includes('index out of range') || _context8.t0.message.includes("Couldn't find block by reference"))) {
	                  _context8.next = 29;
	                  break;
	                }
	
	                _context8.next = 26;
	                return this._setCurrentBlock(trackingBlock);
	
	              case 26:
	                // setup poll for next block
	                this._pollForNextBlock();
	                _context8.next = 31;
	                break;
	
	              case 29:
	                console.error(_context8.t0);
	                this._pollForNextBlock();
	
	              case 31:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, this, [[6, 21]]);
	      }));
	
	      function _performSync() {
	        return _ref8.apply(this, arguments);
	      }
	
	      return _performSync;
	    }()
	  }, {
	    key: '_handleNewBlockNotification',
	    value: function () {
	      var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(err, notification) {
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                if (!(notification.id != this._subscriptionId)) {
	                  _context9.next = 2;
	                  break;
	                }
	
	                return _context9.abrupt('return');
	
	              case 2:
	                if (!err) {
	                  _context9.next = 7;
	                  break;
	                }
	
	                _context9.next = 5;
	                return pify(this.emit)('error', err);
	
	              case 5:
	                _context9.next = 7;
	                return this._removeSubscription();
	
	              case 7:
	                _context9.t0 = this;
	                _context9.next = 10;
	                return this._fetchBlockByNumber(notification.result.number);
	
	              case 10:
	                _context9.t1 = _context9.sent;
	                _context9.next = 13;
	                return _context9.t0._setTrackingBlock.call(_context9.t0, _context9.t1);
	
	              case 13:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, this);
	      }));
	
	      function _handleNewBlockNotification(_x5, _x6) {
	        return _ref9.apply(this, arguments);
	      }
	
	      return _handleNewBlockNotification;
	    }()
	  }, {
	    key: '_initSubscription',
	    value: function () {
	      var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10() {
	        var result;
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                this._provider.on('data', this._handleNewBlockNotification);
	
	                _context10.next = 3;
	                return pify(this._provider.sendAsync || this._provider.send)({
	                  jsonrpc: '2.0',
	                  id: new Date().getTime(),
	                  method: 'eth_subscribe',
	                  params: ['newHeads']
	                });
	
	              case 3:
	                result = _context10.sent;
	
	
	                this._subscriptionId = result.result;
	
	              case 5:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, this);
	      }));
	
	      function _initSubscription() {
	        return _ref10.apply(this, arguments);
	      }
	
	      return _initSubscription;
	    }()
	  }, {
	    key: '_removeSubscription',
	    value: function () {
	      var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11() {
	        return _regenerator2.default.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	                if (this._subscriptionId) {
	                  _context11.next = 2;
	                  break;
	                }
	
	                throw new Error("Not subscribed.");
	
	              case 2:
	
	                this._provider.removeListener('data', this._handleNewBlockNotification);
	
	                _context11.next = 5;
	                return pify(this._provider.sendAsync || this._provider.send)({
	                  jsonrpc: '2.0',
	                  id: new Date().getTime(),
	                  method: 'eth_unsubscribe',
	                  params: [this._subscriptionId]
	                });
	
	              case 5:
	
	                delete this._subscriptionId;
	
	              case 6:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, this);
	      }));
	
	      function _removeSubscription() {
	        return _ref11.apply(this, arguments);
	      }
	
	      return _removeSubscription;
	    }()
	  }, {
	    key: '_fetchLatestBlock',
	    value: function _fetchLatestBlock() {
	      return pify(this._query.getBlockByNumber).call(this._query, 'latest', true);
	    }
	  }, {
	    key: '_fetchBlockByNumber',
	    value: function _fetchBlockByNumber(hexNumber) {
	      var cleanHex = hexUtils.formatHex(hexNumber);
	      return pify(this._query.getBlockByNumber).call(this._query, cleanHex, true);
	    }
	  }]);
	  return RpcBlockTracker;
	}(AsyncEventEmitter);
	
	module.exports = RpcBlockTracker;
	
	// ├─ difficulty: 0x2892ddca
	// ├─ extraData: 0xd983010507846765746887676f312e372e348777696e646f7773
	// ├─ gasLimit: 0x47e7c4
	// ├─ gasUsed: 0x6384
	// ├─ hash: 0xf60903687b1559b9c80f2d935b4c4f468ad95c3076928c432ec34f2ef3d4eec9
	// ├─ logsBloom: 0x00000000000000000000000000000000000000000000000000000000000020000000000000000000000000040000000000000000000000000000000000000000000000000000000000000001000000000000000000000000000000000000000000000200000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000040000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000000000000000000
	// ├─ miner: 0x01711853335f857442ef6f349b2467c531731318
	// ├─ mixHash: 0xf0d9bec999600eec92e8e4da8fc1182e357468c9ed2f849aa17e0e900412b352
	// ├─ nonce: 0xd556d5a5504198e4
	// ├─ number: 0x72ac8
	// ├─ parentHash: 0xf5239c3ce1085194521435a5052494c02bbb1002b019684dcf368490ea6208e5
	// ├─ receiptsRoot: 0x78c6f8236094b392bcc43b47b0dc1ce93ecd2875bfb5e4e4c3431e5af698ff99
	// ├─ sha3Uncles: 0x1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347
	// ├─ size: 0x2ad
	// ├─ stateRoot: 0x0554f145c481df2fa02ecd2da17071672740c3aa948c896f1465e6772f741ac6
	// ├─ timestamp: 0x58955844
	// ├─ totalDifficulty: 0x751d0dfa03c1
	// ├─ transactions
	// │  └─ 0
	// │     ├─ blockHash: 0xf60903687b1559b9c80f2d935b4c4f468ad95c3076928c432ec34f2ef3d4eec9
	// │     ├─ blockNumber: 0x72ac8
	// │     ├─ from: 0x201354729f8d0f8b64e9a0c353c672c6a66b3857
	// │     ├─ gas: 0x15f90
	// │     ├─ gasPrice: 0x4a817c800
	// │     ├─ hash: 0xd5a15d7c2449150db4f74f42a6ca0702150a24c46c5b406a7e1b3e44908ef44d
	// │     ├─ input: 0xe1fa8e849bc10d87fb03c6b0603b05a3e29043c7e0b7c927119576a4bec457e96c7d7cde
	// │     ├─ nonce: 0x323e
	// │     ├─ to: 0xd10e3be2bc8f959bc8c41cf65f60de721cf89adf
	// │     ├─ transactionIndex: 0x0
	// │     ├─ value: 0x0
	// │     ├─ v: 0x29
	// │     ├─ r: 0xf35f8ab241e6bb3ccaffd21b268dbfc7fcb5df1c1fb83ee5306207e4a1a3e954
	// │     └─ s: 0x1610cdac2782c91065fd43584cd8974f7f3b4e6d46a2aafe7b101788285bf3f2
	// ├─ transactionsRoot: 0xb090c32d840dec1e9752719f21bbae4a73e58333aecb89bc3b8ed559fb2712a3
	// └─ uncles

/***/ },
/* 504 */
/***/ function(module, exports) {

	var generate = function generate(num, fn) {
	  var a = [];
	  for (var i = 0; i < num; ++i) {
	    a.push(fn(i));
	  }return a;
	};
	
	var replicate = function replicate(num, val) {
	  return generate(num, function () {
	    return val;
	  });
	};
	
	var concat = function concat(a, b) {
	  return a.concat(b);
	};
	
	var flatten = function flatten(a) {
	  var r = [];
	  for (var j = 0, J = a.length; j < J; ++j) {
	    for (var i = 0, I = a[j].length; i < I; ++i) {
	      r.push(a[j][i]);
	    }
	  }return r;
	};
	
	var chunksOf = function chunksOf(n, a) {
	  var b = [];
	  for (var i = 0, l = a.length; i < l; i += n) {
	    b.push(a.slice(i, i + n));
	  }return b;
	};
	
	module.exports = {
	  generate: generate,
	  replicate: replicate,
	  concat: concat,
	  flatten: flatten,
	  chunksOf: chunksOf
	};

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	const extend = __webpack_require__(325)
	const createRandomId = __webpack_require__(559)()
	
	module.exports = EthQuery
	
	
	function EthQuery(provider){
	  const self = this
	  self.currentProvider = provider
	}
	
	//
	// base queries
	//
	
	// default block
	EthQuery.prototype.getBalance =                          generateFnWithDefaultBlockFor(2, 'eth_getBalance')
	EthQuery.prototype.getCode =                             generateFnWithDefaultBlockFor(2, 'eth_getCode')
	EthQuery.prototype.getTransactionCount =                 generateFnWithDefaultBlockFor(2, 'eth_getTransactionCount')
	EthQuery.prototype.getStorageAt =                        generateFnWithDefaultBlockFor(3, 'eth_getStorageAt')
	EthQuery.prototype.call =                                generateFnWithDefaultBlockFor(2, 'eth_call')
	// standard
	EthQuery.prototype.protocolVersion =                     generateFnFor('eth_protocolVersion')
	EthQuery.prototype.syncing =                             generateFnFor('eth_syncing')
	EthQuery.prototype.coinbase =                            generateFnFor('eth_coinbase')
	EthQuery.prototype.mining =                              generateFnFor('eth_mining')
	EthQuery.prototype.hashrate =                            generateFnFor('eth_hashrate')
	EthQuery.prototype.gasPrice =                            generateFnFor('eth_gasPrice')
	EthQuery.prototype.accounts =                            generateFnFor('eth_accounts')
	EthQuery.prototype.blockNumber =                         generateFnFor('eth_blockNumber')
	EthQuery.prototype.getBlockTransactionCountByHash =      generateFnFor('eth_getBlockTransactionCountByHash')
	EthQuery.prototype.getBlockTransactionCountByNumber =    generateFnFor('eth_getBlockTransactionCountByNumber')
	EthQuery.prototype.getUncleCountByBlockHash =            generateFnFor('eth_getUncleCountByBlockHash')
	EthQuery.prototype.getUncleCountByBlockNumber =          generateFnFor('eth_getUncleCountByBlockNumber')
	EthQuery.prototype.sign =                                generateFnFor('eth_sign')
	EthQuery.prototype.sendTransaction =                     generateFnFor('eth_sendTransaction')
	EthQuery.prototype.sendRawTransaction =                  generateFnFor('eth_sendRawTransaction')
	EthQuery.prototype.estimateGas =                         generateFnFor('eth_estimateGas')
	EthQuery.prototype.getBlockByHash =                      generateFnFor('eth_getBlockByHash')
	EthQuery.prototype.getBlockByNumber =                    generateFnFor('eth_getBlockByNumber')
	EthQuery.prototype.getTransactionByHash =                generateFnFor('eth_getTransactionByHash')
	EthQuery.prototype.getTransactionByBlockHashAndIndex =   generateFnFor('eth_getTransactionByBlockHashAndIndex')
	EthQuery.prototype.getTransactionByBlockNumberAndIndex = generateFnFor('eth_getTransactionByBlockNumberAndIndex')
	EthQuery.prototype.getTransactionReceipt =               generateFnFor('eth_getTransactionReceipt')
	EthQuery.prototype.getUncleByBlockHashAndIndex =         generateFnFor('eth_getUncleByBlockHashAndIndex')
	EthQuery.prototype.getUncleByBlockNumberAndIndex =       generateFnFor('eth_getUncleByBlockNumberAndIndex')
	EthQuery.prototype.getCompilers =                        generateFnFor('eth_getCompilers')
	EthQuery.prototype.compileLLL =                          generateFnFor('eth_compileLLL')
	EthQuery.prototype.compileSolidity =                     generateFnFor('eth_compileSolidity')
	EthQuery.prototype.compileSerpent =                      generateFnFor('eth_compileSerpent')
	EthQuery.prototype.newFilter =                           generateFnFor('eth_newFilter')
	EthQuery.prototype.newBlockFilter =                      generateFnFor('eth_newBlockFilter')
	EthQuery.prototype.newPendingTransactionFilter =         generateFnFor('eth_newPendingTransactionFilter')
	EthQuery.prototype.uninstallFilter =                     generateFnFor('eth_uninstallFilter')
	EthQuery.prototype.getFilterChanges =                    generateFnFor('eth_getFilterChanges')
	EthQuery.prototype.getFilterLogs =                       generateFnFor('eth_getFilterLogs')
	EthQuery.prototype.getLogs =                             generateFnFor('eth_getLogs')
	EthQuery.prototype.getWork =                             generateFnFor('eth_getWork')
	EthQuery.prototype.submitWork =                          generateFnFor('eth_submitWork')
	EthQuery.prototype.submitHashrate =                      generateFnFor('eth_submitHashrate')
	
	// network level
	
	EthQuery.prototype.sendAsync = function(opts, cb){
	  const self = this
	  self.currentProvider.sendAsync(createPayload(opts), function(err, response){
	    if (!err && response.error) err = new Error('EthQuery - RPC Error - '+response.error.message)
	    if (err) return cb(err)
	    cb(null, response.result)
	  })
	}
	
	// util
	
	function generateFnFor(methodName){
	  return function(){
	    const self = this
	    var args = [].slice.call(arguments)
	    var cb = args.pop()
	    self.sendAsync({
	      method: methodName,
	      params: args,
	    }, cb)
	  }
	}
	
	function generateFnWithDefaultBlockFor(argCount, methodName){
	  return function(){
	    const self = this
	    var args = [].slice.call(arguments)
	    var cb = args.pop()
	    // set optional default block param
	    if (args.length < argCount) args.push('latest')
	    self.sendAsync({
	      method: methodName,
	      params: args,
	    }, cb)
	  }
	}
	
	function createPayload(data){
	  return extend({
	    // defaults
	    id: createRandomId(),
	    jsonrpc: '2.0',
	    params: [],
	    // user-specified
	  }, data)
	}


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var BN = __webpack_require__(7);
	var numberToBN = __webpack_require__(249);
	
	var zero = new BN(0);
	var negative1 = new BN(-1);
	
	// complete ethereum unit map
	var unitMap = {
	  'noether': '0', // eslint-disable-line
	  'wei': '1', // eslint-disable-line
	  'kwei': '1000', // eslint-disable-line
	  'Kwei': '1000', // eslint-disable-line
	  'babbage': '1000', // eslint-disable-line
	  'femtoether': '1000', // eslint-disable-line
	  'mwei': '1000000', // eslint-disable-line
	  'Mwei': '1000000', // eslint-disable-line
	  'lovelace': '1000000', // eslint-disable-line
	  'picoether': '1000000', // eslint-disable-line
	  'gwei': '1000000000', // eslint-disable-line
	  'Gwei': '1000000000', // eslint-disable-line
	  'shannon': '1000000000', // eslint-disable-line
	  'nanoether': '1000000000', // eslint-disable-line
	  'nano': '1000000000', // eslint-disable-line
	  'szabo': '1000000000000', // eslint-disable-line
	  'microether': '1000000000000', // eslint-disable-line
	  'micro': '1000000000000', // eslint-disable-line
	  'finney': '1000000000000000', // eslint-disable-line
	  'milliether': '1000000000000000', // eslint-disable-line
	  'milli': '1000000000000000', // eslint-disable-line
	  'ether': '1000000000000000000', // eslint-disable-line
	  'kether': '1000000000000000000000', // eslint-disable-line
	  'grand': '1000000000000000000000', // eslint-disable-line
	  'mether': '1000000000000000000000000', // eslint-disable-line
	  'gether': '1000000000000000000000000000', // eslint-disable-line
	  'tether': '1000000000000000000000000000000' };
	
	/**
	 * Returns value of unit in Wei
	 *
	 * @method getValueOfUnit
	 * @param {String} unit the unit to convert to, default ether
	 * @returns {BigNumber} value of the unit (in Wei)
	 * @throws error if the unit is not correct:w
	 */
	function getValueOfUnit(unitInput) {
	  var unit = unitInput ? unitInput.toLowerCase() : 'ether';
	  var unitValue = unitMap[unit]; // eslint-disable-line
	
	  if (typeof unitValue !== 'string') {
	    throw new Error('[ethjs-unit] the unit provided ' + unitInput + ' doesn\'t exists, please use the one of the following units ' + JSON.stringify(unitMap, null, 2));
	  }
	
	  return new BN(unitValue, 10);
	}
	
	function numberToString(arg) {
	  if (typeof arg === 'string') {
	    if (!arg.match(/^-?[0-9.]+$/)) {
	      throw new Error('while converting number to string, invalid number value \'' + arg + '\', should be a number matching (^-?[0-9.]+).');
	    }
	    return arg;
	  } else if (typeof arg === 'number') {
	    return String(arg);
	  } else if (typeof arg === 'object' && arg.toString && (arg.toTwos || arg.dividedToIntegerBy)) {
	    if (arg.toPrecision) {
	      return String(arg.toPrecision());
	    } else {
	      // eslint-disable-line
	      return arg.toString(10);
	    }
	  }
	  throw new Error('while converting number to string, invalid number value \'' + arg + '\' type ' + typeof arg + '.');
	}
	
	function fromWei(weiInput, unit, optionsInput) {
	  var wei = numberToBN(weiInput); // eslint-disable-line
	  var negative = wei.lt(zero); // eslint-disable-line
	  var base = getValueOfUnit(unit);
	  var baseLength = unitMap[unit].length - 1 || 1;
	  var options = optionsInput || {};
	
	  if (negative) {
	    wei = wei.mul(negative1);
	  }
	
	  var fraction = wei.mod(base).toString(10); // eslint-disable-line
	
	  while (fraction.length < baseLength) {
	    fraction = '0' + fraction;
	  }
	
	  if (!options.pad) {
	    fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
	  }
	
	  var whole = wei.div(base).toString(10); // eslint-disable-line
	
	  if (options.commify) {
	    whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	  }
	
	  var value = '' + whole + (fraction == '0' ? '' : '.' + fraction); // eslint-disable-line
	
	  if (negative) {
	    value = '-' + value;
	  }
	
	  return value;
	}
	
	function toWei(etherInput, unit) {
	  var ether = numberToString(etherInput); // eslint-disable-line
	  var base = getValueOfUnit(unit);
	  var baseLength = unitMap[unit].length - 1 || 1;
	
	  // Is it negative?
	  var negative = ether.substring(0, 1) === '-'; // eslint-disable-line
	  if (negative) {
	    ether = ether.substring(1);
	  }
	
	  if (ether === '.') {
	    throw new Error('[ethjs-unit] while converting number ' + etherInput + ' to wei, invalid value');
	  }
	
	  // Split it into a whole and fractional part
	  var comps = ether.split('.'); // eslint-disable-line
	  if (comps.length > 2) {
	    throw new Error('[ethjs-unit] while converting number ' + etherInput + ' to wei,  too many decimal points');
	  }
	
	  var whole = comps[0],
	      fraction = comps[1]; // eslint-disable-line
	
	  if (!whole) {
	    whole = '0';
	  }
	  if (!fraction) {
	    fraction = '0';
	  }
	  if (fraction.length > baseLength) {
	    throw new Error('[ethjs-unit] while converting number ' + etherInput + ' to wei, too many decimal places');
	  }
	
	  while (fraction.length < baseLength) {
	    fraction += '0';
	  }
	
	  whole = new BN(whole);
	  fraction = new BN(fraction);
	  var wei = whole.mul(base).add(fraction); // eslint-disable-line
	
	  if (negative) {
	    wei = wei.mul(negative1);
	  }
	
	  return new BN(wei.toString(10), 10);
	}
	
	module.exports = {
	  unitMap: unitMap,
	  numberToString: numberToString,
	  getValueOfUnit: getValueOfUnit,
	  fromWei: fromWei,
	  toWei: toWei
	};

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var isHexPrefixed = __webpack_require__(234);
	var stripHexPrefix = __webpack_require__(311);
	
	/**
	 * Pads a `String` to have an even length
	 * @param {String} value
	 * @return {String} output
	 */
	function padToEven(value) {
	  var a = value; // eslint-disable-line
	
	  if (typeof a !== 'string') {
	    throw new Error('[ethjs-util] while padding to even, value must be string, is currently ' + typeof a + ', while padToEven.');
	  }
	
	  if (a.length % 2) {
	    a = '0' + a;
	  }
	
	  return a;
	}
	
	/**
	 * Converts a `Number` into a hex `String`
	 * @param {Number} i
	 * @return {String}
	 */
	function intToHex(i) {
	  var hex = i.toString(16); // eslint-disable-line
	
	  return '0x' + padToEven(hex);
	}
	
	/**
	 * Converts an `Number` to a `Buffer`
	 * @param {Number} i
	 * @return {Buffer}
	 */
	function intToBuffer(i) {
	  var hex = intToHex(i);
	
	  return new Buffer(hex.slice(2), 'hex');
	}
	
	/**
	 * Get the binary size of a string
	 * @param {String} str
	 * @return {Number}
	 */
	function getBinarySize(str) {
	  if (typeof str !== 'string') {
	    throw new Error('[ethjs-util] while getting binary size, method getBinarySize requires input \'str\' to be type String, got \'' + typeof str + '\'.');
	  }
	
	  return Buffer.byteLength(str, 'utf8');
	}
	
	/**
	 * Returns TRUE if the first specified array contains all elements
	 * from the second one. FALSE otherwise.
	 *
	 * @param {array} superset
	 * @param {array} subset
	 *
	 * @returns {boolean}
	 */
	function arrayContainsArray(superset, subset, some) {
	  if (Array.isArray(superset) !== true) {
	    throw new Error('[ethjs-util] method arrayContainsArray requires input \'superset\' to be an array got type \'' + typeof superset + '\'');
	  }
	  if (Array.isArray(subset) !== true) {
	    throw new Error('[ethjs-util] method arrayContainsArray requires input \'subset\' to be an array got type \'' + typeof subset + '\'');
	  }
	
	  return subset[Boolean(some) && 'some' || 'every'](function (value) {
	    return superset.indexOf(value) >= 0;
	  });
	}
	
	/**
	 * Should be called to get utf8 from it's hex representation
	 *
	 * @method toUtf8
	 * @param {String} string in hex
	 * @returns {String} ascii string representation of hex value
	 */
	function toUtf8(hex) {
	  var bufferValue = new Buffer(padToEven(stripHexPrefix(hex).replace(/^0+|0+$/g, '')), 'hex');
	
	  return bufferValue.toString('utf8');
	}
	
	/**
	 * Should be called to get ascii from it's hex representation
	 *
	 * @method toAscii
	 * @param {String} string in hex
	 * @returns {String} ascii string representation of hex value
	 */
	function toAscii(hex) {
	  var str = ''; // eslint-disable-line
	  var i = 0,
	      l = hex.length; // eslint-disable-line
	
	  if (hex.substring(0, 2) === '0x') {
	    i = 2;
	  }
	
	  for (; i < l; i += 2) {
	    var code = parseInt(hex.substr(i, 2), 16);
	    str += String.fromCharCode(code);
	  }
	
	  return str;
	}
	
	/**
	 * Should be called to get hex representation (prefixed by 0x) of utf8 string
	 *
	 * @method fromUtf8
	 * @param {String} string
	 * @param {Number} optional padding
	 * @returns {String} hex representation of input string
	 */
	function fromUtf8(stringValue) {
	  var str = new Buffer(stringValue, 'utf8');
	
	  return '0x' + padToEven(str.toString('hex')).replace(/^0+|0+$/g, '');
	}
	
	/**
	 * Should be called to get hex representation (prefixed by 0x) of ascii string
	 *
	 * @method fromAscii
	 * @param {String} string
	 * @param {Number} optional padding
	 * @returns {String} hex representation of input string
	 */
	function fromAscii(stringValue) {
	  var hex = ''; // eslint-disable-line
	  for (var i = 0; i < stringValue.length; i++) {
	    // eslint-disable-line
	    var code = stringValue.charCodeAt(i);
	    var n = code.toString(16);
	    hex += n.length < 2 ? '0' + n : n;
	  }
	
	  return '0x' + hex;
	}
	
	/**
	 * getKeys([{a: 1, b: 2}, {a: 3, b: 4}], 'a') => [1, 3]
	 *
	 * @method getKeys get specific key from inner object array of objects
	 * @param {String} params
	 * @param {String} key
	 * @param {Boolean} allowEmpty
	 * @returns {Array} output just a simple array of output keys
	 */
	function getKeys(params, key, allowEmpty) {
	  if (!Array.isArray(params)) {
	    throw new Error('[ethjs-util] method getKeys expecting type Array as \'params\' input, got \'' + typeof params + '\'');
	  }
	  if (typeof key !== 'string') {
	    throw new Error('[ethjs-util] method getKeys expecting type String for input \'key\' got \'' + typeof key + '\'.');
	  }
	
	  var result = []; // eslint-disable-line
	
	  for (var i = 0; i < params.length; i++) {
	    // eslint-disable-line
	    var value = params[i][key]; // eslint-disable-line
	    if (allowEmpty && !value) {
	      value = '';
	    } else if (typeof value !== 'string') {
	      throw new Error('invalid abi');
	    }
	    result.push(value);
	  }
	
	  return result;
	}
	
	/**
	 * Is the string a hex string.
	 *
	 * @method check if string is hex string of specific length
	 * @param {String} value
	 * @param {Number} length
	 * @returns {Boolean} output the string is a hex string
	 */
	function isHexString(value, length) {
	  if (typeof value !== 'string' || !value.match(/^0x[0-9A-Fa-f]*$/)) {
	    return false;
	  }
	
	  if (length && value.length !== 2 + 2 * length) {
	    return false;
	  }
	
	  return true;
	}
	
	module.exports = {
	  arrayContainsArray: arrayContainsArray,
	  intToBuffer: intToBuffer,
	  getBinarySize: getBinarySize,
	  isHexPrefixed: isHexPrefixed,
	  stripHexPrefix: stripHexPrefix,
	  padToEven: padToEven,
	  intToHex: intToHex,
	  fromAscii: fromAscii,
	  fromUtf8: fromUtf8,
	  toAscii: toAscii,
	  toUtf8: toUtf8,
	  getKeys: getKeys,
	  isHexString: isHexString
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 508 */
135,
/* 509 */
135,
/* 510 */
135,
/* 511 */
135,
/* 512 */
135,
/* 513 */
135,
/* 514 */
135,
/* 515 */
135,
/* 516 */
135,
/* 517 */
135,
/* 518 */
135,
/* 519 */
135,
/* 520 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(520);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(530);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(15);
	
	var createArrayFromMixed = __webpack_require__(523);
	var getMarkupWrap = __webpack_require__(525);
	var invariant = __webpack_require__(3);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(15);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 526 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 527 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(527);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 529 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(529);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 531 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(233)
	
	module.exports = forEach
	
	var toString = Object.prototype.toString
	var hasOwnProperty = Object.prototype.hasOwnProperty
	
	function forEach(list, iterator, context) {
	    if (!isFunction(iterator)) {
	        throw new TypeError('iterator must be a function')
	    }
	
	    if (arguments.length < 3) {
	        context = this
	    }
	    
	    if (toString.call(list) === '[object Array]')
	        forEachArray(list, iterator, context)
	    else if (typeof list === 'string')
	        forEachString(list, iterator, context)
	    else
	        forEachObject(list, iterator, context)
	}
	
	function forEachArray(array, iterator, context) {
	    for (var i = 0, len = array.length; i < len; i++) {
	        if (hasOwnProperty.call(array, i)) {
	            iterator.call(context, array[i], i, array)
	        }
	    }
	}
	
	function forEachString(string, iterator, context) {
	    for (var i = 0, len = string.length; i < len; i++) {
	        // no such thing as a sparse string.
	        iterator.call(context, string.charAt(i), i, string)
	    }
	}
	
	function forEachObject(object, iterator, context) {
	    for (var k in object) {
	        if (hasOwnProperty.call(object, k)) {
	            iterator.call(context, object[k], k, object)
	        }
	    }
	}


/***/ },
/* 533 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var win;
	
	if (typeof window !== "undefined") {
	    win = window;
	} else if (typeof global !== "undefined") {
	    win = global;
	} else if (typeof self !== "undefined"){
	    win = self;
	} else {
	    win = {};
	}
	
	module.exports = win;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict'
	var Transform = __webpack_require__(82).Transform
	var inherits = __webpack_require__(2)
	
	function HashBase (blockSize) {
	  Transform.call(this)
	
	  this._block = new Buffer(blockSize)
	  this._blockSize = blockSize
	  this._blockOffset = 0
	  this._length = [0, 0, 0, 0]
	
	  this._finalized = false
	}
	
	inherits(HashBase, Transform)
	
	HashBase.prototype._transform = function (chunk, encoding, callback) {
	  var error = null
	  try {
	    if (encoding !== 'buffer') chunk = new Buffer(chunk, encoding)
	    this.update(chunk)
	  } catch (err) {
	    error = err
	  }
	
	  callback(error)
	}
	
	HashBase.prototype._flush = function (callback) {
	  var error = null
	  try {
	    this.push(this._digest())
	  } catch (err) {
	    error = err
	  }
	
	  callback(error)
	}
	
	HashBase.prototype.update = function (data, encoding) {
	  if (!Buffer.isBuffer(data) && typeof data !== 'string') throw new TypeError('Data must be a string or a buffer')
	  if (this._finalized) throw new Error('Digest already called')
	  if (!Buffer.isBuffer(data)) data = new Buffer(data, encoding || 'binary')
	
	  // consume data
	  var block = this._block
	  var offset = 0
	  while (this._blockOffset + data.length - offset >= this._blockSize) {
	    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
	    this._update()
	    this._blockOffset = 0
	  }
	  while (offset < data.length) block[this._blockOffset++] = data[offset++]
	
	  // update length
	  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
	    this._length[j] += carry
	    carry = (this._length[j] / 0x0100000000) | 0
	    if (carry > 0) this._length[j] -= 0x0100000000 * carry
	  }
	
	  return this
	}
	
	HashBase.prototype._update = function (data) {
	  throw new Error('_update is not implemented')
	}
	
	HashBase.prototype.digest = function (encoding) {
	  if (this._finalized) throw new Error('Digest already called')
	  this._finalized = true
	
	  var digest = this._digest()
	  if (encoding !== undefined) digest = digest.toString(encoding)
	  return digest
	}
	
	HashBase.prototype._digest = function () {
	  throw new Error('_digest is not implemented')
	}
	
	module.exports = HashBase
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(27);
	var assert = __webpack_require__(21);
	
	function Hmac(hash, key, enc) {
	  if (!(this instanceof Hmac))
	    return new Hmac(hash, key, enc);
	  this.Hash = hash;
	  this.blockSize = hash.blockSize / 8;
	  this.outSize = hash.outSize / 8;
	  this.inner = null;
	  this.outer = null;
	
	  this._init(utils.toArray(key, enc));
	}
	module.exports = Hmac;
	
	Hmac.prototype._init = function init(key) {
	  // Shorten key, if needed
	  if (key.length > this.blockSize)
	    key = new this.Hash().update(key).digest();
	  assert(key.length <= this.blockSize);
	
	  // Add padding to key
	  for (var i = key.length; i < this.blockSize; i++)
	    key.push(0);
	
	  for (i = 0; i < key.length; i++)
	    key[i] ^= 0x36;
	  this.inner = new this.Hash().update(key);
	
	  // 0x36 ^ 0x5c = 0x6a
	  for (i = 0; i < key.length; i++)
	    key[i] ^= 0x6a;
	  this.outer = new this.Hash().update(key);
	};
	
	Hmac.prototype.update = function update(msg, enc) {
	  this.inner.update(msg, enc);
	  return this;
	};
	
	Hmac.prototype.digest = function digest(enc) {
	  this.outer.update(this.inner.digest());
	  return this.outer.digest(enc);
	};


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(27);
	var common = __webpack_require__(75);
	
	var rotl32 = utils.rotl32;
	var sum32 = utils.sum32;
	var sum32_3 = utils.sum32_3;
	var sum32_4 = utils.sum32_4;
	var BlockHash = common.BlockHash;
	
	function RIPEMD160() {
	  if (!(this instanceof RIPEMD160))
	    return new RIPEMD160();
	
	  BlockHash.call(this);
	
	  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
	  this.endian = 'little';
	}
	utils.inherits(RIPEMD160, BlockHash);
	exports.ripemd160 = RIPEMD160;
	
	RIPEMD160.blockSize = 512;
	RIPEMD160.outSize = 160;
	RIPEMD160.hmacStrength = 192;
	RIPEMD160.padLength = 64;
	
	RIPEMD160.prototype._update = function update(msg, start) {
	  var A = this.h[0];
	  var B = this.h[1];
	  var C = this.h[2];
	  var D = this.h[3];
	  var E = this.h[4];
	  var Ah = A;
	  var Bh = B;
	  var Ch = C;
	  var Dh = D;
	  var Eh = E;
	  for (var j = 0; j < 80; j++) {
	    var T = sum32(
	      rotl32(
	        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
	        s[j]),
	      E);
	    A = E;
	    E = D;
	    D = rotl32(C, 10);
	    C = B;
	    B = T;
	    T = sum32(
	      rotl32(
	        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
	        sh[j]),
	      Eh);
	    Ah = Eh;
	    Eh = Dh;
	    Dh = rotl32(Ch, 10);
	    Ch = Bh;
	    Bh = T;
	  }
	  T = sum32_3(this.h[1], C, Dh);
	  this.h[1] = sum32_3(this.h[2], D, Eh);
	  this.h[2] = sum32_3(this.h[3], E, Ah);
	  this.h[3] = sum32_3(this.h[4], A, Bh);
	  this.h[4] = sum32_3(this.h[0], B, Ch);
	  this.h[0] = T;
	};
	
	RIPEMD160.prototype._digest = function digest(enc) {
	  if (enc === 'hex')
	    return utils.toHex32(this.h, 'little');
	  else
	    return utils.split32(this.h, 'little');
	};
	
	function f(j, x, y, z) {
	  if (j <= 15)
	    return x ^ y ^ z;
	  else if (j <= 31)
	    return (x & y) | ((~x) & z);
	  else if (j <= 47)
	    return (x | (~y)) ^ z;
	  else if (j <= 63)
	    return (x & z) | (y & (~z));
	  else
	    return x ^ (y | (~z));
	}
	
	function K(j) {
	  if (j <= 15)
	    return 0x00000000;
	  else if (j <= 31)
	    return 0x5a827999;
	  else if (j <= 47)
	    return 0x6ed9eba1;
	  else if (j <= 63)
	    return 0x8f1bbcdc;
	  else
	    return 0xa953fd4e;
	}
	
	function Kh(j) {
	  if (j <= 15)
	    return 0x50a28be6;
	  else if (j <= 31)
	    return 0x5c4dd124;
	  else if (j <= 47)
	    return 0x6d703ef3;
	  else if (j <= 63)
	    return 0x7a6d76e9;
	  else
	    return 0x00000000;
	}
	
	var r = [
	  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
	  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
	  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
	  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
	  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
	];
	
	var rh = [
	  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
	  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
	  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
	  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
	  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
	];
	
	var s = [
	  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
	  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
	  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
	  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
	  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
	];
	
	var sh = [
	  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
	  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
	  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
	  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
	  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
	];


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.sha1 = __webpack_require__(538);
	exports.sha224 = __webpack_require__(539);
	exports.sha256 = __webpack_require__(227);
	exports.sha384 = __webpack_require__(540);
	exports.sha512 = __webpack_require__(228);


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(27);
	var common = __webpack_require__(75);
	var shaCommon = __webpack_require__(229);
	
	var rotl32 = utils.rotl32;
	var sum32 = utils.sum32;
	var sum32_5 = utils.sum32_5;
	var ft_1 = shaCommon.ft_1;
	var BlockHash = common.BlockHash;
	
	var sha1_K = [
	  0x5A827999, 0x6ED9EBA1,
	  0x8F1BBCDC, 0xCA62C1D6
	];
	
	function SHA1() {
	  if (!(this instanceof SHA1))
	    return new SHA1();
	
	  BlockHash.call(this);
	  this.h = [
	    0x67452301, 0xefcdab89, 0x98badcfe,
	    0x10325476, 0xc3d2e1f0 ];
	  this.W = new Array(80);
	}
	
	utils.inherits(SHA1, BlockHash);
	module.exports = SHA1;
	
	SHA1.blockSize = 512;
	SHA1.outSize = 160;
	SHA1.hmacStrength = 80;
	SHA1.padLength = 64;
	
	SHA1.prototype._update = function _update(msg, start) {
	  var W = this.W;
	
	  for (var i = 0; i < 16; i++)
	    W[i] = msg[start + i];
	
	  for(; i < W.length; i++)
	    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
	
	  var a = this.h[0];
	  var b = this.h[1];
	  var c = this.h[2];
	  var d = this.h[3];
	  var e = this.h[4];
	
	  for (i = 0; i < W.length; i++) {
	    var s = ~~(i / 20);
	    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
	    e = d;
	    d = c;
	    c = rotl32(b, 30);
	    b = a;
	    a = t;
	  }
	
	  this.h[0] = sum32(this.h[0], a);
	  this.h[1] = sum32(this.h[1], b);
	  this.h[2] = sum32(this.h[2], c);
	  this.h[3] = sum32(this.h[3], d);
	  this.h[4] = sum32(this.h[4], e);
	};
	
	SHA1.prototype._digest = function digest(enc) {
	  if (enc === 'hex')
	    return utils.toHex32(this.h, 'big');
	  else
	    return utils.split32(this.h, 'big');
	};


/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(27);
	var SHA256 = __webpack_require__(227);
	
	function SHA224() {
	  if (!(this instanceof SHA224))
	    return new SHA224();
	
	  SHA256.call(this);
	  this.h = [
	    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
	    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
	}
	utils.inherits(SHA224, SHA256);
	module.exports = SHA224;
	
	SHA224.blockSize = 512;
	SHA224.outSize = 224;
	SHA224.hmacStrength = 192;
	SHA224.padLength = 64;
	
	SHA224.prototype._digest = function digest(enc) {
	  // Just truncate output
	  if (enc === 'hex')
	    return utils.toHex32(this.h.slice(0, 7), 'big');
	  else
	    return utils.split32(this.h.slice(0, 7), 'big');
	};
	


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(27);
	
	var SHA512 = __webpack_require__(228);
	
	function SHA384() {
	  if (!(this instanceof SHA384))
	    return new SHA384();
	
	  SHA512.call(this);
	  this.h = [
	    0xcbbb9d5d, 0xc1059ed8,
	    0x629a292a, 0x367cd507,
	    0x9159015a, 0x3070dd17,
	    0x152fecd8, 0xf70e5939,
	    0x67332667, 0xffc00b31,
	    0x8eb44a87, 0x68581511,
	    0xdb0c2e0d, 0x64f98fa7,
	    0x47b5481d, 0xbefa4fa4 ];
	}
	utils.inherits(SHA384, SHA512);
	module.exports = SHA384;
	
	SHA384.blockSize = 1024;
	SHA384.outSize = 384;
	SHA384.hmacStrength = 192;
	SHA384.padLength = 128;
	
	SHA384.prototype._digest = function digest(enc) {
	  if (enc === 'hex')
	    return utils.toHex32(this.h.slice(0, 12), 'big');
	  else
	    return utils.split32(this.h.slice(0, 12), 'big');
	};


/***/ },
/* 541 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(138);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(42);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(53);
	
	var _DOMUtils = __webpack_require__(97);
	
	var _DOMStateStorage = __webpack_require__(230);
	
	var _PathUtils = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(138);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(53);
	
	var _PathUtils = __webpack_require__(40);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(139);
	
	var _BrowserProtocol = __webpack_require__(138);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(543);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(97);
	
	var _createHistory = __webpack_require__(140);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(42);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(139);
	
	var _DOMUtils = __webpack_require__(97);
	
	var _HashProtocol = __webpack_require__(542);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(140);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(42);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(53);
	
	var _PathUtils = __webpack_require__(40);
	
	var _createHistory = __webpack_require__(140);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(96);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hash = __webpack_require__(137);
	var utils = __webpack_require__(248);
	var assert = __webpack_require__(21);
	
	function HmacDRBG(options) {
	  if (!(this instanceof HmacDRBG))
	    return new HmacDRBG(options);
	  this.hash = options.hash;
	  this.predResist = !!options.predResist;
	
	  this.outLen = this.hash.outSize;
	  this.minEntropy = options.minEntropy || this.hash.hmacStrength;
	
	  this._reseed = null;
	  this.reseedInterval = null;
	  this.K = null;
	  this.V = null;
	
	  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
	  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
	  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
	  assert(entropy.length >= (this.minEntropy / 8),
	         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
	  this._init(entropy, nonce, pers);
	}
	module.exports = HmacDRBG;
	
	HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
	  var seed = entropy.concat(nonce).concat(pers);
	
	  this.K = new Array(this.outLen / 8);
	  this.V = new Array(this.outLen / 8);
	  for (var i = 0; i < this.V.length; i++) {
	    this.K[i] = 0x00;
	    this.V[i] = 0x01;
	  }
	
	  this._update(seed);
	  this._reseed = 1;
	  this.reseedInterval = 0x1000000000000;  // 2^48
	};
	
	HmacDRBG.prototype._hmac = function hmac() {
	  return new hash.hmac(this.hash, this.K);
	};
	
	HmacDRBG.prototype._update = function update(seed) {
	  var kmac = this._hmac()
	                 .update(this.V)
	                 .update([ 0x00 ]);
	  if (seed)
	    kmac = kmac.update(seed);
	  this.K = kmac.digest();
	  this.V = this._hmac().update(this.V).digest();
	  if (!seed)
	    return;
	
	  this.K = this._hmac()
	               .update(this.V)
	               .update([ 0x01 ])
	               .update(seed)
	               .digest();
	  this.V = this._hmac().update(this.V).digest();
	};
	
	HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
	  // Optional entropy enc
	  if (typeof entropyEnc !== 'string') {
	    addEnc = add;
	    add = entropyEnc;
	    entropyEnc = null;
	  }
	
	  entropy = utils.toArray(entropy, entropyEnc);
	  add = utils.toArray(add, addEnc);
	
	  assert(entropy.length >= (this.minEntropy / 8),
	         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
	
	  this._update(entropy.concat(add || []));
	  this._reseed = 1;
	};
	
	HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
	  if (this._reseed > this.reseedInterval)
	    throw new Error('Reseed is required');
	
	  // Optional encoding
	  if (typeof enc !== 'string') {
	    addEnc = add;
	    add = enc;
	    enc = null;
	  }
	
	  // Optional additional data
	  if (add) {
	    add = utils.toArray(add, addEnc || 'hex');
	    this._update(add);
	  }
	
	  var temp = [];
	  while (temp.length < len) {
	    this.V = this._hmac().update(this.V).digest();
	    temp = temp.concat(this.V);
	  }
	
	  var res = temp.slice(0, len);
	  this._update(add);
	  this._reseed++;
	  return utils.encode(res, enc);
	};


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ },
/* 549 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 550 */
/***/ function(module, exports) {

	
	var indexOf = [].indexOf;
	
	module.exports = function(arr, obj){
	  if (indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	var isObject = __webpack_require__(552);
	
	function isObjectObject(o) {
	  return isObject(o) === true
	    && Object.prototype.toString.call(o) === '[object Object]';
	}
	
	module.exports = function isPlainObject(o) {
	  var ctor,prot;
	
	  if (isObjectObject(o) === false) return false;
	
	  // If has modified constructor
	  ctor = o.constructor;
	  if (typeof ctor !== 'function') return false;
	
	  // If has modified prototype
	  prot = ctor.prototype;
	  if (isObjectObject(prot) === false) return false;
	
	  // If constructor does not have an Object-specific method
	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }
	
	  // Most likely a plain Object
	  return true;
	};


/***/ },
/* 552 */
/***/ function(module, exports) {

	/*!
	 * isobject <https://github.com/jonschlinkert/isobject>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	module.exports = function isObject(val) {
	  return val != null && typeof val === 'object' && Array.isArray(val) === false;
	};


/***/ },
/* 553 */
/***/ function(module, exports) {

	module.exports = {
		"contractName": "WorldGame",
		"abi": [
			{
				"constant": true,
				"inputs": [
					{
						"name": "",
						"type": "uint32"
					}
				],
				"name": "blockHash32Map",
				"outputs": [
					{
						"name": "",
						"type": "uint32"
					}
				],
				"payable": false,
				"stateMutability": "view",
				"type": "function",
				"signature": "0x5d156e7c"
			},
			{
				"constant": true,
				"inputs": [
					{
						"name": "",
						"type": "uint256"
					}
				],
				"name": "regionRewards",
				"outputs": [
					{
						"name": "",
						"type": "uint32"
					}
				],
				"payable": false,
				"stateMutability": "view",
				"type": "function",
				"signature": "0x73f9c314"
			},
			{
				"constant": true,
				"inputs": [
					{
						"name": "",
						"type": "uint256"
					},
					{
						"name": "",
						"type": "uint256"
					}
				],
				"name": "regionNeighbors",
				"outputs": [
					{
						"name": "",
						"type": "uint32"
					}
				],
				"payable": false,
				"stateMutability": "view",
				"type": "function",
				"signature": "0xc5554f6c"
			},
			{
				"constant": true,
				"inputs": [
					{
						"name": "",
						"type": "uint256"
					}
				],
				"name": "gameDataArray",
				"outputs": [
					{
						"name": "turnTeamId",
						"type": "uint32"
					},
					{
						"name": "turnNum",
						"type": "uint32"
					},
					{
						"name": "maxBlocksPerTurn",
						"type": "uint32"
					},
					{
						"name": "playerCount",
						"type": "uint32"
					},
					{
						"name": "undeployedSoldiers",
						"type": "uint256"
					},
					{
						"name": "regionOwners",
						"type": "uint256"
					},
					{
						"name": "actionCount",
						"type": "uint32"
					},
					{
						"name": "fromRegionList",
						"type": "uint256"
					},
					{
						"name": "toRegionList",
						"type": "uint256"
					},
					{
						"name": "moveSoldierCountList",
						"type": "uint256"
					},
					{
						"name": "submitBlockList",
						"type": "uint256"
					},
					{
						"name": "teamAvatars",
						"type": "bytes8"
					}
				],
				"payable": false,
				"stateMutability": "view",
				"type": "function",
				"signature": "0xdfecc3da"
			},
			{
				"inputs": [],
				"payable": false,
				"stateMutability": "nonpayable",
				"type": "constructor",
				"signature": "constructor"
			},
			{
				"payable": true,
				"stateMutability": "payable",
				"type": "fallback"
			},
			{
				"anonymous": false,
				"inputs": [
					{
						"indexed": false,
						"name": "gameId",
						"type": "uint256"
					},
					{
						"indexed": false,
						"name": "turnNum",
						"type": "uint32"
					},
					{
						"indexed": false,
						"name": "teamAvatars",
						"type": "bytes8"
					}
				],
				"name": "NewGame",
				"type": "event",
				"signature": "0x7b500020844755355aa28dffd1c18d8b8e19f27484cf8e3678b3715b2a84f119"
			},
			{
				"anonymous": false,
				"inputs": [
					{
						"indexed": false,
						"name": "gameId",
						"type": "uint256"
					},
					{
						"indexed": false,
						"name": "turnNum",
						"type": "uint32"
					},
					{
						"indexed": false,
						"name": "nextTeamId",
						"type": "uint32"
					}
				],
				"name": "NextTurn",
				"type": "event",
				"signature": "0xaf26d387915e958f9e0527ca62daeba4f1dbedcfa353788bc92cb1d168eafa4e"
			},
			{
				"anonymous": false,
				"inputs": [
					{
						"indexed": false,
						"name": "gameId",
						"type": "uint256"
					},
					{
						"indexed": false,
						"name": "winningTeamId",
						"type": "uint32"
					}
				],
				"name": "Winner",
				"type": "event",
				"signature": "0xf3576487e22fe2d358509a56b99d4924c4fc146200d92b58ab61bf8b82fcdec3"
			},
			{
				"constant": false,
				"inputs": [
					{
						"name": "stop",
						"type": "bool"
					}
				],
				"name": "stopNewGames",
				"outputs": [],
				"payable": false,
				"stateMutability": "nonpayable",
				"type": "function",
				"signature": "0x20d636da"
			},
			{
				"constant": false,
				"inputs": [
					{
						"name": "playerCount",
						"type": "uint32"
					},
					{
						"name": "maxBlocksPerTurn",
						"type": "uint32"
					},
					{
						"name": "playerAddresses",
						"type": "address[8]"
					},
					{
						"name": "teamAvatars",
						"type": "bytes8"
					}
				],
				"name": "newGame",
				"outputs": [
					{
						"name": "",
						"type": "uint256"
					}
				],
				"payable": false,
				"stateMutability": "nonpayable",
				"type": "function",
				"signature": "0x11d17981"
			},
			{
				"constant": false,
				"inputs": [
					{
						"name": "gameId",
						"type": "uint256"
					},
					{
						"name": "turnNum",
						"type": "uint32"
					},
					{
						"name": "regionFrom",
						"type": "uint32"
					},
					{
						"name": "regionTo",
						"type": "uint32"
					},
					{
						"name": "moveSoldierCount",
						"type": "uint32"
					}
				],
				"name": "attackOrMove",
				"outputs": [],
				"payable": false,
				"stateMutability": "nonpayable",
				"type": "function",
				"signature": "0x1e710c1b"
			},
			{
				"constant": false,
				"inputs": [
					{
						"name": "gameId",
						"type": "uint256"
					},
					{
						"name": "turnNum",
						"type": "uint32"
					},
					{
						"name": "regionDeploy",
						"type": "uint32"
					},
					{
						"name": "deploySoldierCount",
						"type": "uint32"
					}
				],
				"name": "deploySoldiersAndEndTurn",
				"outputs": [],
				"payable": false,
				"stateMutability": "nonpayable",
				"type": "function",
				"signature": "0xb14580ff"
			},
			{
				"constant": false,
				"inputs": [
					{
						"name": "gameId",
						"type": "uint256"
					},
					{
						"name": "turnNum",
						"type": "uint32"
					}
				],
				"name": "forceEndOfTurn",
				"outputs": [],
				"payable": false,
				"stateMutability": "nonpayable",
				"type": "function",
				"signature": "0x13e9c3a0"
			},
			{
				"constant": false,
				"inputs": [
					{
						"name": "gameId",
						"type": "uint256"
					},
					{
						"name": "teamId",
						"type": "uint32"
					}
				],
				"name": "declareWinner",
				"outputs": [],
				"payable": false,
				"stateMutability": "nonpayable",
				"type": "function",
				"signature": "0x63e8360d"
			},
			{
				"constant": false,
				"inputs": [
					{
						"name": "blockNum",
						"type": "uint32"
					}
				],
				"name": "cacheBlockHash32",
				"outputs": [
					{
						"name": "",
						"type": "uint32"
					}
				],
				"payable": false,
				"stateMutability": "nonpayable",
				"type": "function",
				"signature": "0xd76a606c"
			},
			{
				"constant": true,
				"inputs": [
					{
						"name": "blockNum",
						"type": "uint32"
					}
				],
				"name": "readBlockHash32",
				"outputs": [
					{
						"name": "",
						"type": "uint32"
					}
				],
				"payable": false,
				"stateMutability": "view",
				"type": "function",
				"signature": "0x69b0e1db"
			},
			{
				"constant": true,
				"inputs": [],
				"name": "numberOfGames",
				"outputs": [
					{
						"name": "",
						"type": "uint256"
					}
				],
				"payable": false,
				"stateMutability": "view",
				"type": "function",
				"signature": "0xf6928070"
			},
			{
				"constant": true,
				"inputs": [
					{
						"name": "offset",
						"type": "uint256"
					}
				],
				"name": "listGamesForAddress",
				"outputs": [
					{
						"name": "",
						"type": "uint256[10]"
					},
					{
						"name": "",
						"type": "uint32"
					},
					{
						"name": "",
						"type": "uint256"
					}
				],
				"payable": false,
				"stateMutability": "view",
				"type": "function",
				"signature": "0xa19d8df9"
			},
			{
				"constant": true,
				"inputs": [
					{
						"name": "gameId",
						"type": "uint256"
					}
				],
				"name": "soldiersByRegion",
				"outputs": [
					{
						"name": "",
						"type": "uint32[25]"
					},
					{
						"name": "",
						"type": "uint32[25]"
					}
				],
				"payable": false,
				"stateMutability": "view",
				"type": "function",
				"signature": "0xe97b9249"
			},
			{
				"constant": true,
				"inputs": [
					{
						"name": "gameId",
						"type": "uint256"
					}
				],
				"name": "turnAndPlayerInfo",
				"outputs": [
					{
						"name": "",
						"type": "uint32"
					},
					{
						"name": "",
						"type": "uint32"
					},
					{
						"name": "",
						"type": "uint32"
					},
					{
						"name": "",
						"type": "uint32"
					},
					{
						"name": "",
						"type": "address[8]"
					},
					{
						"name": "",
						"type": "bytes8"
					}
				],
				"payable": false,
				"stateMutability": "view",
				"type": "function",
				"signature": "0x7c83e731"
			},
			{
				"constant": true,
				"inputs": [
					{
						"name": "gameId",
						"type": "uint256"
					}
				],
				"name": "undeployedSoldiers",
				"outputs": [
					{
						"name": "",
						"type": "uint32[8]"
					},
					{
						"name": "",
						"type": "uint32[8]"
					}
				],
				"payable": false,
				"stateMutability": "view",
				"type": "function",
				"signature": "0x8935185f"
			},
			{
				"constant": true,
				"inputs": [
					{
						"name": "gameId",
						"type": "uint256"
					}
				],
				"name": "pendingActions",
				"outputs": [
					{
						"name": "",
						"type": "uint32"
					},
					{
						"name": "",
						"type": "uint32[8]"
					},
					{
						"name": "",
						"type": "uint32[8]"
					},
					{
						"name": "",
						"type": "uint32[8]"
					},
					{
						"name": "",
						"type": "uint32[8]"
					}
				],
				"payable": false,
				"stateMutability": "view",
				"type": "function",
				"signature": "0x03117ba2"
			},
			{
				"constant": true,
				"inputs": [
					{
						"name": "gameId",
						"type": "uint256"
					}
				],
				"name": "pendingActionOutcomes",
				"outputs": [
					{
						"name": "",
						"type": "uint32"
					},
					{
						"name": "",
						"type": "uint32"
					},
					{
						"name": "",
						"type": "uint32[8]"
					},
					{
						"name": "",
						"type": "uint32[8]"
					},
					{
						"name": "",
						"type": "uint32[8]"
					}
				],
				"payable": false,
				"stateMutability": "view",
				"type": "function",
				"signature": "0xbf29233f"
			}
		],
		"bytecode": "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",
		"deployedBytecode": "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",
		"sourceMap": "104:47830:2:-;;;7132:116;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;7163:5:2;:18;;-1:-1:-1;;;;;;7163:18:2;7171:10;7163:18;;;7191:21;:19;;;;:21;:::i;:::-;7222:19;:17;;;;:19;:::i;:::-;104:47830;;32234:10560;32283:15;:72;;-1:-1:-1;;;;32283:72:2;;;32335:19;32283:72;32365:65;;;;;295:3;;32306:14;32440:39;:54;;;;;;;;;-1:-1:-1;;;;;;32440:54:2;;;;;;;;;295:3;32480:1;-1:-1:-1;32504:39:2;:54;;;;;;;;;-1:-1:-1;;;;;;32504:54:2;;;;;;;;;295:3;32568:15;-1:-1:-1;32568:39:2;:54;;;;;;;;;-1:-1:-1;;;;;;32568:54:2;;;;;;;;;32693:19;32633:80;;32816:83;32723;-1:-1:-1;;32633:80:2;;;;;-1:-1:-1;;32723:83:2;;;;;-1:-1:-1;;;;;;32816:83:2;;;;295:3;32633:15;-1:-1:-1;32909:47:2;:62;;;;;;;;;-1:-1:-1;;;;;;32909:62:2;;;;;;;;;295:3;32981:15;-1:-1:-1;32981:47:2;:62;;;;;;;;;-1:-1:-1;;;;;;32981:62:2;;;;;;;;;33054:47;:83;;33235:80;33147:78;-1:-1:-1;;33054:83:2;;;-1:-1:-1;33054:83:2;-1:-1:-1;;33147:78:2;;;;;-1:-1:-1;;;;;;33235:80:2;;;;295:3;33054:15;;33325:47;:62;;;;;;;;;-1:-1:-1;;;;;;33325:62:2;;;;;;;;;295:3;33397:15;;:47;:62;;-1:-1:-1;;;;;;33397:62:2;;;;;;;;;;;;;;;;;33470:44;:72;;-1:-1:-1;;;;;;;;;;;;;;33552:80:2;;;;;33642:77;;;;;;33729:88;;;;;295:3;33470:15;33493:19;33827:44;:59;;-1:-1:-1;;;;;;33827:59:2;;;;;;;;;;;;;;;;;33897:44;:77;;-1:-1:-1;;;;;;;;;;33897:77:2;;;33954:19;33897:77;33984:80;;;;;;34074:88;;;;;295:3;33897:15;33920:19;34172:44;:59;;;;;;;;;-1:-1:-1;;;;;;34172:59:2;;;;;;;;;295:3;34241:15;34172:47;34241:44;:59;;;;;;;;;-1:-1:-1;;;;;;34241:59:2;;;;;;;;;34311:42;:78;;34399;34366:22;-1:-1:-1;;34311:78:2;;;;;-1:-1:-1;;34399:78:2;;;;;295:3;;34334:17;34487:42;:57;;;;;;;;;-1:-1:-1;;;;;;34487:57:2;;;;;;;;;295:3;34530:1;34577:17;34554:42;:57;;;;;;;;;-1:-1:-1;;;;;;34554:57:2;;;;;;;;;295:3;34621:15;34644:17;34621:42;:57;;-1:-1:-1;;;;;;34621:57:2;;;;;;;;;;;;;;;;;34689:55;:88;;-1:-1:-1;;;;;;;;;;34689:88:2;;;34757:19;34689:88;34787;;;;;;34885:99;;;;;295:3;34689:15;34712:30;34994:55;:70;;;;;;;;;-1:-1:-1;;;;;;34994:70:2;;;;;;;;;295:3;35074:15;35097:30;35074:55;:70;;-1:-1:-1;;;;;;35074:70:2;;;;;;;;;;;;;;;;;35155:55;:99;;-1:-1:-1;;;;35155:99:2;;;35223:30;35155:99;35264:92;;;;;295:3;35155:15;35178:30;35366:55;:70;;;;;;;;;-1:-1:-1;;;;;;35366:70:2;;;;;;;;;295:3;35422:1;35469:30;35446:55;:70;;;;;;;;;-1:-1:-1;;;;;;35446:70:2;;;;;;;;;295:3;35526:15;35549:30;35526:55;:70;;-1:-1:-1;;;;;;35526:70:2;;;;;;;;;;;;;;;;;35607:48;:92;;-1:-1:-1;;;;35607:92:2;;;35668:30;35607:92;35709:85;;;;;295:3;35607:15;35630:23;35804:48;:63;;;;;;;;;-1:-1:-1;;;;;;35804:63:2;;;;;;;;;295:3;35853:1;35804:51;35877:48;:63;;;;;;;;;-1:-1:-1;;;;;;35877:63:2;;;;;;;;;295:3;35950:15;35877:51;35950:48;:63;;-1:-1:-1;;;;;;35950:63:2;;;;;;;;;;;;;;;;;36024:48;:85;;-1:-1:-1;;;;36024:85:2;;;35950:51;36024:85;36119:81;;;;;295:3;36024:15;36047:23;36210:48;:63;;;;;;;;;-1:-1:-1;;;;;;36210:63:2;;;;;;;;;295:3;36259:1;36306:23;36283:48;:63;;;;;;;;;-1:-1:-1;;;;;;36283:63:2;;;;;;;;;295:3;36356:15;36379:23;36356:48;:63;;-1:-1:-1;;;;;;36356:63:2;;;;;;;;;;;;;;;;;36430:47;:78;;-1:-1:-1;;;;;;;;;;36430:78:2;;;36490:17;36430:78;36518:83;;;;;;36611:80;;;;;295:3;36430:15;36453:22;36701:47;:62;;;;;;;;;-1:-1:-1;;;;;;36701:62:2;;;;;;;;;295:3;36773:15;36796:22;36773:47;:62;;-1:-1:-1;;;;;;36773:62:2;;;;;;;;;;;;;;;;;36846:47;:83;;-1:-1:-1;;;;;;;;;;;;;;;;36846:83:2;;;36906:22;36846:83;36939:80;;;;;;37029;;;;;;37119:83;;;;;295:3;36846:15;36869:22;37212:47;:62;;-1:-1:-1;;;;;;37212:62:2;;;;;;;;;;;;;;;;;;;37285:47;:83;;-1:-1:-1;;;;;;;;;;;;;;;;37285:83:2;;;37345:22;37285:83;37378:80;;;;37468:74;;;;37552:82;;;;;;37644:83;;;;;;;;37438:19;37738:82;;;;;37612:21;37738:82;37830:83;;;;;37923;;;37468:74;37923:83;;;295:3;37285:15;37704:22;38016:47;:62;;;;;;;;;-1:-1:-1;;;;;;38016:62:2;;;;;;;;;295:3;38088:15;38111:22;38088:47;:62;;-1:-1:-1;;;;;;38088:62:2;;;;;;;;;;;;;;;;;;;38161:44;:80;;-1:-1:-1;;;;;;;;;;;;;;;;38161:80:2;;;38218:22;38161:80;38251;;;;38341:77;;;;;;38428;;;;;;38515:78;;;;;;38572:20;38604:80;;;;38308:22;38604:80;38694;;;;38784:71;;;;38865:77;;;;;38952;;;;;;;;38841:13;39040:77;;;;;38184:19;39040:77;39127:78;;;39215:77;;;;39302:71;;;;;;;;295:3;;38161:15;39383:44;:59;;-1:-1:-1;;;;;;39383:59:2;;;;;;;;;;;;;;;;;39453:45;:78;;-1:-1:-1;;;;39453:78:2;;;39511:19;39453:78;39541;;;;;295:3;39453:15;39476:20;39629:45;:60;;;;;;;;;-1:-1:-1;;;;;;39629:60:2;;;;;;;;;295:3;39675:1;39722:20;39699:45;:60;;;;;;;;;-1:-1:-1;;;;;;39699:60:2;;;;;;;;;295:3;39769:15;39792:20;39769:45;:60;;-1:-1:-1;;;;;;39769:60:2;;;;;;;;;;;;;;;;;;;39840:38;:71;;-1:-1:-1;;;;;;;;;;;;;;;;39840:71:2;;;39769:48;39840:71;39921;;;;40002:74;;;;40086:73;;;;40169:74;;;;;;;;40254:46;:73;;;;;39863:13;40254:73;40337:82;;;;;40429;;;;;40521;;;;;;;295:3;39840:15;40137:21;40613:46;:61;;-1:-1:-1;;;;;;40613:61:2;;;;;;;;;;;;;;;;;;;40685:47;:74;;-1:-1:-1;;;;;;;;;;;;;;;;40685:74:2;;;40745:13;40685:74;40769:82;;;;40861:86;;;;;;40957;;;;;;41053:73;;;;;;;41137:50;:89;;;;;;;;41236:86;;;;;;;295:3;40685:15;40921:25;41332:50;:65;;;;;;;;;-1:-1:-1;;;;;;41332:65:2;;;;;;;;;295:3;41383:1;41430:25;41407:50;:65;;;;;;;;;-1:-1:-1;;;;;;41407:65:2;;;;;;;;;295:3;41482:15;41505:25;41482:50;:65;;-1:-1:-1;;;;;;41482:65:2;;;;;;;;;;;;;;;;;41558:50;:89;;-1:-1:-1;;;;;;;;;;;;;;;;41558:89:2;;;41621:25;41558:89;41657:86;;;;;;41753:76;;;;;;41839:83;;;;;295:3;41558:15;41581:25;41932:50;:65;;-1:-1:-1;;;;;;41932:65:2;;;;;;;;;;;;;;;;;42008:44;:83;;-1:-1:-1;;;;;;;;;;42008:83:2;;;42065:25;42008:83;42101:70;;;;;;42181:81;;;;;295:3;42008:15;42031:19;42272:44;:59;;;;;;;;;-1:-1:-1;;;;;;42272:59:2;;;;;;;;;295:3;42341:15;42364:19;42341:44;:59;;;;;;;;;-1:-1:-1;;;;;;42341:59:2;;;;;;;;;42411:37;:70;;42577:73;42491:76;42461:19;-1:-1:-1;;42411:70:2;;;;;;;-1:-1:-1;;42491:76:2;;;;;-1:-1:-1;;;;;;42577:73:2;;-1:-1:-1;;;;;;42660:65:2;;;295:3;42411:15;42434:12;42735:37;42773:1;42735:40;;;;;;;;;;;;:52;;;;;;;;;;;;;;;;;;32234:10560::o;42921:1493::-;42968:13;:41;;-1:-1:-1;;42968:41:2;43008:1;42968:41;-1:-1:-1;;43019:49:2;;;;;43126:1;;43099:22;43078:45;;;;;;;;;;;;;;;;;;;;:49;;;;;;;;;;;;;;;;;;43182:2;43137:13;43158:19;43151:27;;;;;;;;43137:42;;;;;;;;;;;;;;;;;;;;:47;;;;;;;;;;;;;;;;;;43239:1;43194:13;43215:19;43208:27;;;;;;;;43194:42;;;;;;;;;;;;;;;;;;;;:46;;;;;;;;;;;;;;;;;;43293:1;43250:13;43271:17;43264:25;;;;;;;;43250:40;;;;;;;;;;;;;;;;;;;;:44;;;;;;;;;;;;;;;;;;43360:1;43304:13;43325:30;43318:38;;;;;;;;43304:53;;;;;;;;;;;;;;;;;;;;:57;;;;;;;;;;;;;;;;;;43427:1;43371:13;43392:30;43385:38;;;;;;;;43371:53;;;;;;;;;;;;;;;;;;;;:57;;;;;;;;;;;;;;;;;;43487:1;43438:13;43459:23;43452:31;;;;;;;;43438:46;;;;;;;;;;;;;;;;;;;;:50;;;;;;;;;;;;;;;;;;43547:1;43498:13;43519:23;43512:31;;;;;;;;43498:46;;;;;;;;;;;;;;;;;;;;:50;;;;;;;;;;;;;;;;;;43606:2;43558:13;43579:22;43572:30;;;;;;;;43558:45;;;;;;;;;;;;;;;;;;;;:50;;;;;;;;;;;;;;;;;;43666:1;43618:13;43639:22;43632:30;;;;;;;;43618:45;;;;;;;;;;;;;;;;;;;;:49;;;;;;;;;;;;;;;;;;43725:1;43677:13;43698:22;43691:30;;;;;;;;43677:45;;;;;;;;;;;;;;;;;;;;:49;;;;;;;;;;;;;;;;;;43784:1;43736:13;43757:22;43750:30;;;;;;;;43736:45;;;;;;;;;;;;;;;;;;;;:49;;;;;;;;;;;;;;;;;;43840:1;43795:13;43816:19;43809:27;;;;;;;;43795:42;;;;;;;;;;;;;;;;;;;;:46;;;;;;;;;;;;;;;;;;43896:1;43851:13;43872:19;43865:27;;;;;;;;43851:42;;;;;;;;;;;;;;;;;;;;:46;;;;;;;;;;;;;;;;;;43952:1;43907:13;43928:19;43921:27;;;;;;;;43907:42;;;;;;;;;;;;;;;;;;;;:46;;;;;;;;;;;;;;;;;;44009:1;43963:13;43984:20;43977:28;;;;;;;;43963:43;;;;;;;;;;;;;;;;;;;;:47;;;;;;;;;;;;;;;;;;44059:1;44020:13;44041;44034:21;;;;;;;;44020:36;;;;;;;;;;;;;;;;;;;;:40;;;;;;;;;;;;;;;;;;44117:2;44070:13;44091:21;44084:29;;;;;;;;44070:44;;;;;;;;;;;;;;;;;;;;:49;;;;;;;;;;;;;;;;;;44177:1;44129:13;44150:22;44143:30;;;;;;;;44129:45;;;;;;;;;;;;;;;;;;;;:49;;;;;;;;;;;;;;;;;;44239:1;44188:13;44209:25;44202:33;;;;;;;;44188:48;;;;;;;;;;;;;;;;;;;;:52;;;;;;;;;;;;;;;;;;44301:1;44250:13;44271:25;44264:33;;;;;;;;44250:48;;;;;;;;;;;;;;;;;;;;:52;;;;;;;;;;;;;;;;;;44357:1;44312:13;44333:19;44326:27;;;;;;;;44312:42;;;;;;;;;;;;;;;;;;;;:46;;;;;;;;;;;;;;;;;;44406:1;44368:13;44389:12;44382:20;;;;;;;;44368:35;;;;;;;;104:47830;;;;;;;",
		"deployedSourceMap": "104:47830:2:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;7369:40;;;-1:-1:-1;;;;;7369:40:2;;;;;;;;;;;;;;;;;;;;;;;;;;;21039:1120;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;21039:1120:2;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;21039:1120:2;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;21039:1120:2;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;21039:1120:2;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;21039:1120:2;;;;;;;;;;;;;;;;;;;;7844:2072;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;7844:2072:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;7844:2072:2;;-1:-1:-1;;;7844:2072:2;;-1:-1:-1;;7844:2072:2;;-1:-1:-1;7844:2072:2;;-1:-1:-1;;7844:2072:2;;;;;;;;;;;;;;;;;14294:867;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;14294:867:2;;;;;;;;;;;10289:1619;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;10289:1619:2;;;;;;;;;;;;;;;;;;;;;;;;7497:102;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;7497:102:2;;;;;;;1891:48;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;1891:48:2;;;;;;;;;;;;;;;;;;;;;;;;;;15303:505;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;15303:505:2;;;;;;;;;16513:259;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;16513:259:2;;;;;;;2201:41;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;2201:41:2;;;;;19418:434;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;19418:434:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;-1:-1;;;;;19418:434:2;;;;;;;;-1:-1:-1;19418:434:2;;;;;;;;;-1:-1:-1;19418:434:2;-1:-1:-1;;;;;;19418:434:2;20075:583;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;20075:583:2;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;20075:583:2;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;20075:583:2;;;;;;;;;;;;;;;;;17205:1246;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;17205:1246:2;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;17205:1246:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;12259:1863;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;12259:1863:2;;;;;;;;;;;;;;;;;;;22513:1775;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;22513:1775:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;2055:58:2;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;2055:58:2;;;;;;;16005:327;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;16005:327:2;;;;;;;2332:31;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;2332:31:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;2332:31:2;;;;;;;;;;;;;;;;;18702:440;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;18702:440:2;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;-1:-1;;84:18;;18702:440:2;;;;64:39:-1;;;-1:-1;18702:440:2;-1:-1:-1;18702:440:2;;-1:-1:-1;18702:440:2;;;;52:2:-1;8:100;;16848:98:2;;8:9:-1;5:2;;;30:1;27;20:12;5:2;16848:98:2;;;;21039:1120;21139:6;21159:28;;:::i;:::-;21202;;:::i;:::-;21245;;:::i;:::-;21288;;:::i;:::-;21333:21;21389:50;;:::i;:::-;21449:48;;:::i;:::-;21507:56;;:::i;:::-;21573:51;;:::i;:::-;21640:8;21357:13;21371:6;21357:21;;;;;;;;;;;;;;;;;;;;21333:45;;21651:1;21640:12;;21635:339;641:1;21654:24;;;;21635:339;;;21719:33;21729:4;:19;;;21750:1;21719:9;:33::i;:::-;21699:14;:17;;;;;;;;;;:53;;;;:17;;;;;;:53;21794:17;;;;21784:31;;21813:1;21784:9;:31::i;:::-;21766:12;:15;;;;;;;;;;:49;;;;:15;;;;;;:49;21865:25;;;;21855:39;;21892:1;21855:9;:39::i;:::-;21829:20;:23;;;;;;;;;;:65;;;;:23;;;;;;:65;21939:20;;;;21929:34;;21961:1;21929:9;:34::i;:::-;21908:15;:18;;;;;;;;;;:55;;;;:18;;;;;;:55;21680:3;;21635:339;;;-1:-1:-1;22005:16:2;;;;;;;;;22036:14;;-1:-1:-1;22065:12:2;;-1:-1:-1;22092:20:2;-1:-1:-1;22065:12:2;;-1:-1:-1;21039:1120:2;-1:-1:-1;;21039:1120:2:o;7844:2072::-;8063:7;7000;;8063;;7000;;;;;:16;6992:54;;;;;-1:-1:-1;;;;;6992:54:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;1038:2;8160:40;;;;;8152:108;;;;;-1:-1:-1;;;;;8152:108:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8462:1353;;;;;;;;;-1:-1:-1;8462:1353:2;;;8584:12;8462:1353;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1619:66;8462:1353;;;;;;;;-1:-1:-1;;8462:1353:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;8462:1353:2;;;;;;;;;8443:13;27:10:-1;;9819:1:2;23:18:-1;;;45:23;;;8443:1373:2;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;8443:1373:2;;;;;-1:-1:-1;;8443:1373:2;;;;;-1:-1:-1;;8443:1373:2;;;;-1:-1:-1;;8443:1373:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;9819:1;;23:18:-1;8462:1353:2;8443:1373;;;;;;;;;:::i;:::-;-1:-1:-1;8443:1373:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;-1:-1:-1;8443:1373:2;;;;;;;;;-1:-1:-1;;8443:1373:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;8443:1373:2;;;;;;;;;;;9836:50;;;8443:1377;;;;9836:50;;;9859:12;9836:50;;;;;;;-1:-1:-1;;9836:50:2;;;;;;;;8443:1377;;-1:-1:-1;9836:50:2;;;;;;;;;;9903:6;7844:2072;-1:-1:-1;;;;;7844:2072:2:o;14294:867::-;14431:21;14409:6;5334:21;5358:13;5372:6;5358:21;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;5478:20:2;;;:23;;-1:-1:-1;;;;;5478:23:2;5464:10;:37;;:91;;-1:-1:-1;5532:20:2;;;;:23;;-1:-1:-1;;;;;5532:23:2;5518:10;:37;5464:91;:145;;;-1:-1:-1;5586:20:2;;;5607:1;5586:23;;-1:-1:-1;;;;;5586:23:2;5572:10;:37;5464:145;:199;;;-1:-1:-1;5640:20:2;;;5661:1;5640:23;;-1:-1:-1;;;;;5640:23:2;5626:10;:37;5464:199;:253;;;-1:-1:-1;5694:20:2;;;5715:1;5694:23;;-1:-1:-1;;;;;5694:23:2;5680:10;:37;5464:253;:307;;;-1:-1:-1;5748:20:2;;;5769:1;5748:23;;-1:-1:-1;;;;;5748:23:2;5734:10;:37;5464:307;:361;;;-1:-1:-1;5802:20:2;;;5823:1;5802:23;;-1:-1:-1;;;;;5802:23:2;5788:10;:37;5464:361;:415;;;-1:-1:-1;5856:20:2;;;5877:1;5856:23;;-1:-1:-1;;;;;5856:23:2;5842:10;:37;5464:415;5443:485;;;;;;;-1:-1:-1;;;;;5443:485:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;14455:13;:21;;14469:6;;14455:21;;;;;;;;;;;;;;;;;;;14494:12;;14455:21;;-1:-1:-1;14494:23:2;;;;:12;;;;;:23;14486:54;;;;;-1:-1:-1;;;;;14486:54:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;14581:12;;14573:44;;14581:12;;;;;;;14595:21;;;;14573:7;:44::i;:::-;14558:59;;:12;:59;14550:109;;;;;-1:-1:-1;;;;;14550:109:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;14756:16;;;;14775:1;14756:16;;;;:20;14752:80;;;14792:29;14814:6;14792:21;:29::i;:::-;14902:25;14920:6;14902:17;:25::i;:::-;14884:43;;-1:-1:-1;;14884:43:2;;;;;;-1:-1:-1;;14937:35:2;;14959:12;14937:35;;;;;;;;;;;15066:25;15084:6;15066:17;:25::i;:::-;15124:12;;15107:47;;;;;;15124:12;;;;;;15107:47;;;;15138:15;;;15107:47;;;;;;;;;;;;;;14294:867;;;;;:::o;10289:1619::-;10573:21;10628:8;10496:6;10504:7;4847:21;4871:13;4885:6;4871:21;;;;;;;;;;;;;;;;;;;;;;;5008:15;;4871:21;;-1:-1:-1;4987:20:2;;;;5008:15;;4987:37;;;;;;;;;-1:-1:-1;;;;;4987:37:2;4973:10;:51;4952:121;;;;;-1:-1:-1;;;;;4952:121:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;5149:12;;:23;;;;:12;;;;;:23;5141:54;;;;;-1:-1:-1;;;;;5141:54:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;10536:10;10548:8;364:2;6153:25;;;;:52;;;;-1:-1:-1;364:2:2;6182:23;;;;6153:52;6145:86;;;;;;;-1:-1:-1;;;;;6145:86:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;6364:8;6330:42;;:15;6346:10;6330:27;;;;;;;;;;;;:30;;;:42;;:101;;;6423:8;6389:42;;:15;6405:10;6389:27;;;;;;;;;;;;:30;;;;;;:42;6330:101;:160;;;;6482:8;6448:42;;:15;6464:10;6448:27;;;;;;;;;;;;:30;;;;;;:42;6330:160;:219;;;;6541:8;6507:42;;:15;6523:10;6507:27;;;;;;;;;;;;:30;;;;;;:42;6330:219;:278;;;;6600:8;6566:42;;:15;6582:10;6566:27;;;;;;;;;;;;:30;;;;;;:42;6330:278;6309:380;;;;;;;-1:-1:-1;;;;;6309:380:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;10597:13;:21;;10611:6;;10597:21;;;;;;;;;;;;;;;;10573:45;;10703:1;10699:5;;10694:270;10710:16;;;;;;;;10706:20;;;;10694:270;;;10854:31;10864:4;:17;;;10883:1;10854:9;:31::i;:::-;10842:43;;;;;;;;10817:136;;;;;-1:-1:-1;;;;;10817:136:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;10728:3;;;;;10694:270;;;10981:16;;;;641:1;10981:39;:16;;;:39;10973:87;;;;;-1:-1:-1;;;;;10973:87:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;11112:16;11078:50;;:4;:19;;11098:10;11078:31;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:50;11070:92;;;;;-1:-1:-1;;;;;11070:92:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;11199:39;11208:4;:17;;;11227:10;11199:8;:39::i;:::-;11180:15;;:58;:15;;;:58;;;11172:98;;;;;-1:-1:-1;;;;;11172:98:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;11338:16;;;;;;;;;-1:-1:-1;11442:16:2;;11407:19;;;;:31;;;;;;;;;;;;;;;;;;;;:51;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;11538:45;11548:4;:19;;;11569:1;11572:10;11538:9;:45::i;:::-;11516:19;;;:67;11623:17;;;;11613:41;;11642:1;11645:8;11613:9;:41::i;:::-;11593:17;;;:61;11702:25;;;;11692:57;;11729:1;11732:16;11692:9;:57::i;:::-;11664:25;;;:85;11792:20;;;;11782:56;;11814:1;11824:12;11782:9;:56::i;:::-;11759:20;;;:79;-1:-1:-1;;;11883:16:2;;;;:18;;;;;;;;;-1:-1:-1;;11883:18:2;;;;;;-1:-1:-1;;;;;;;;10289:1619:2:o;7497:102::-;6825:5;;-1:-1:-1;;;;;6825:5:2;6811:10;:19;6803:66;;;;;-1:-1:-1;;;;;6803:66:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;7578:7;:14;;;;;;;-1:-1:-1;;7578:14:2;;;;;;;;;7497:102::o;1891:48::-;;;;;;;;;;;;;;;:::o;15303:505::-;15416:21;15480:13;15515:8;15394:6;5334:21;5358:13;5372:6;5358:21;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;5478:20:2;;;:23;;-1:-1:-1;;;;;5478:23:2;5464:10;:37;;:91;;-1:-1:-1;5532:20:2;;;;:23;;-1:-1:-1;;;;;5532:23:2;5518:10;:37;5464:91;:145;;;-1:-1:-1;5586:20:2;;;5607:1;5586:23;;-1:-1:-1;;;;;5586:23:2;5572:10;:37;5464:145;:199;;;-1:-1:-1;5640:20:2;;;5661:1;5640:23;;-1:-1:-1;;;;;5640:23:2;5626:10;:37;5464:199;:253;;;-1:-1:-1;5694:20:2;;;5715:1;5694:23;;-1:-1:-1;;;;;5694:23:2;5680:10;:37;5464:253;:307;;;-1:-1:-1;5748:20:2;;;5769:1;5748:23;;-1:-1:-1;;;;;5748:23:2;5734:10;:37;5464:307;:361;;;-1:-1:-1;5802:20:2;;;5823:1;5802:23;;-1:-1:-1;;;;;5802:23:2;5788:10;:37;5464:361;:415;;;-1:-1:-1;5856:20:2;;;5877:1;5856:23;;-1:-1:-1;;;;;5856:23:2;5842:10;:37;5464:415;5443:485;;;;;;;-1:-1:-1;;;;;5443:485:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;15440:13;:21;;15454:6;;15440:21;;;;;;;;;;;;;;;;15416:45;;15496:4;15480:20;;15526:1;15515:12;;15510:161;364:2;15529:16;;;;15510:161;;;15604:6;15570:40;;:30;15579:4;:17;;;15598:1;15570:8;:30::i;:::-;:40;;;15566:95;;15641:5;15630:16;;15566:95;15547:3;;;;;15510:161;;;15689:8;15681:44;;;;;;;-1:-1:-1;;;;;15681:44:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;15740:8;15736:66;;;15769:22;;;;;;;;;;;;;;;;;;;;;;;;;;15736:66;15303:505;;;;;;;:::o;16513:259::-;16575:6;16621:19;;;;;;16656:16;;;16652:85;;;-1:-1:-1;16702:24:2;;;;;;;;:14;:24;;;;;;;16652:85;16754:11;16513:259;-1:-1:-1;;16513:259:2:o;2201:41::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;19418:434::-;19508:6;19516;19524;19532;19540:20;;:::i;:::-;19562:6;19585:21;19609:13;19623:6;19609:21;;;;;;;;;;;;;;;;;;;;;;;19661:15;;19819:16;;;;19640:205;;;19661:15;19640:205;;;;;;19609:21;;-1:-1:-1;19661:15:2;;;;;19691:12;;;;;;19718:21;;;;;;19754:16;;;;;;;;19661:15;19785:20;;;19819:16;;;19640:205;19785:20;;19718:21;;19785:20;19640:205;;;;-1:-1:-1;;;;;19640:205:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;19418:434;;;;;;;;:::o;20075:583::-;20166:19;;:::i;:::-;20187;;:::i;:::-;20223:21;20279:49;;:::i;:::-;20338:43;;:::i;:::-;20396:8;20247:13;20261:6;20247:21;;;;;;;;;;;;;;;;;;;;20223:45;;20407:1;20396:12;;20391:201;538:1;20410:15;;;;20391:201;;;20474:37;20484:4;:23;;;20509:1;20474:9;:37::i;:::-;20446:22;:25;;;;;;;;;;:65;;;;:25;;;;;;:65;20547:33;20570:6;20578:1;20547:22;:33::i;:::-;20525:16;:19;;;;;;;;;;:55;;;;:19;;;;;;:55;20427:3;;20391:201;;;-1:-1:-1;20610:22:2;;20634:16;;-1:-1:-1;20075:583:2;-1:-1:-1;;;20075:583:2:o;17205:1246::-;17297:11;;:::i;:::-;17310:6;17318:7;17342:29;;:::i;:::-;17381:18;17409:14;17553:21;17824:9;17918:21;17986:8;17460:1;17437:13;:20;;;;:24;17433:961;;;17577:13;:20;-1:-1:-1;;17577:24:2;;-1:-1:-1;17628:1:2;17619:10;;:36;;;;;17642:13;17633:6;:22;17619:36;17615:97;;;17691:6;17675:22;;17615:97;17836:13;17852:1;17836:17;17824:29;;17819:565;17859:1;17855;:5;17819:565;;;17942:13;:21;;-1:-1:-1;;17894:5:2;;;-1:-1:-1;17894:5:2;;17942:21;;;;;;;;;;;;;;;;17918:45;;17997:1;17986:12;;17981:280;18004:16;;;;;;;;;18000:20;;;;17981:280;;;18080:10;18053:20;;;:23;;;;;;;;;;;;-1:-1:-1;;;;;18053:23:2;:37;18049:194;;;18144:6;18118:10;:23;;;;;;;;;;;;;:32;18176:13;;;;;18215:5;;18049:194;18022:3;;17981:280;;;18283:11;:17;;18298:2;18283:17;:39;;;;18316:6;18304:9;:18;18283:39;18279:91;;;18346:5;;18279:91;-1:-1:-1;;17862:3:2;;;;17819:565;;;-1:-1:-1;18412:10:2;;18424:11;;-1:-1:-1;18437:6:2;;-1:-1:-1;17205:1246:2;;-1:-1:-1;;;;;17205:1246:2:o;12259:1863::-;12488:21;12543:29;12456:6;12464:7;4847:21;4871:13;4885:6;4871:21;;;;;;;;;;;;;;;;;;;;;;;5008:15;;4871:21;;-1:-1:-1;4987:20:2;;;;5008:15;;4987:37;;;;;;;;;-1:-1:-1;;;;;4987:37:2;4973:10;:51;4952:121;;;;;-1:-1:-1;;;;;4952:121:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;5149:12;;:23;;;;:12;;;;;:23;5141:54;;;;;-1:-1:-1;;;;;5141:54:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;12512:13;:21;;12526:6;;12512:21;;;;;;;;;;;;;;;;;;;12585:23;;;;12610:15;;12512:21;;-1:-1:-1;12575:51:2;;12610:15;;12575:9;:51::i;:::-;12543:83;-1:-1:-1;12645:44:2;;;;;;;;;12637:87;;;;;-1:-1:-1;;;;;12637:87:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;12756:25;;;295:3;12756:25;:52;;;;-1:-1:-1;12785:23:2;;;;12756:52;12755:131;;;-1:-1:-1;12871:15:2;;12835:17;;;;12871:15;;;;;12826:41;;12854:12;12826:8;:41::i;:::-;:60;;;12755:131;:202;;;;216:3;12903:54;;:41;12912:4;:17;;;12931:12;12903:8;:41::i;:::-;:54;;;12755:202;12734:321;;;;;;;-1:-1:-1;;;;;12734:321:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;13152:16;;;;13171:1;13152:16;;;;:20;13148:80;;;13188:29;13210:6;13188:21;:29::i;:::-;13297:25;;;295:3;13297:25;13293:500;;13367:17;;;;13400:15;;13358:58;;13367:17;13386:12;;13400:15;;13358:8;:58::i;:::-;13338:17;;;:78;13483:23;;;;13525:15;;13456:168;;13483:23;13525:15;;13559:51;13567:22;13591:18;13559:7;:51::i;:::-;13456:9;:168::i;:::-;13430:23;;;:194;13674:108;13699:19;;;:33;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;13750:18;13674:7;:108::i;:::-;13638:19;;;:33;;;;;;;;;;;;;;;;;;;;;:144;;;;;;;;;;;;;;;;;;13293:500;13863:25;13881:6;13863:17;:25::i;:::-;13845:43;;-1:-1:-1;;13845:43:2;;;;;;-1:-1:-1;;13898:35:2;;13920:12;13898:35;;;;;;;;;;;14027:25;14045:6;14027:17;:25::i;:::-;14085:12;;14068:47;;;;;;14085:12;;;;;;14068:47;;;;14099:15;;;14068:47;;;;;;;;;;;;;;12259:1863;;;;;;;;;:::o;22513:1775::-;22620:6;22640;22660:28;;:::i;:::-;22703;;:::i;:::-;22746;;:::i;:::-;22791:21;22847:51;;:::i;:::-;22908:57;;:::i;:::-;22975;;:::i;:::-;23048:8;23107:15;23240:13;23472:25;23499;22815:13;22829:6;22815:21;;;;;;;;;;;;;;;;;;;;22791:45;;23059:1;23048:12;;23043:1045;641:1;23062:24;;;;23043:1045;;;23125:31;23135:4;:17;;;23154:1;23125:9;:31::i;:::-;23107:49;;23191:34;23201:4;:20;;;23223:1;23191:9;:34::i;:::-;23170:15;:18;;;;;;;;;;:55;;;;:18;;;;;;;;;:55;23297:15;;23265:17;;;;23297:15;;;23256:37;;23284:8;23256;:37::i;:::-;:56;;;:127;;;;216:3;23333:50;;:37;23342:4;:17;;;23361:8;23333;:37::i;:::-;:50;;;23256:127;23240:143;;23402:8;:49;;;-1:-1:-1;23429:15:2;:18;;;;;;;;;;;;;;23450:1;23429:22;23414:37;;:12;:37;23402:49;23398:680;;;23528:408;23617:15;:18;;;;;;;;;;;;;;23708:39;23718:4;:25;;;23745:1;23708:9;:39::i;:::-;23818:19;;;:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23910:8;23528:22;:408::i;:::-;23471:465;;-1:-1:-1;23471:465:2;-1:-1:-1;23471:465:2;23955:21;:24;;;;;;;;;;:45;;;;:24;;;;;;;;;:45;24045:18;;24018:21;;:24;;;;;;;;;:45;;;;:24;;;;;;:45;23398:680;23088:3;;;;;23043:1045;;;-1:-1:-1;;;24154:16:2;;;;;24126:12;;24154:16;;;;;-1:-1:-1;24185:15:2;;-1:-1:-1;24215:21:2;;-1:-1:-1;24250:21:2;-1:-1:-1;22513:1775:2;;-1:-1:-1;;;;22513:1775:2:o;2055:58::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;16005:327::-;16106:24;;;;16063:6;16106:24;;;:14;:24;;;;;;16063:6;;16106:24;16145:20;;16141:152;;;-1:-1:-1;;16206:19:2;;;;16240:24;;;;16199:27;16240:24;;;;;:42;;-1:-1:-1;;16240:42:2;16206:19;;16240:42;;;;;;;;;16206:19;16005:327::o;2332:31::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;2332:31:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;18702:440::-;18791:20;;:::i;:::-;18813;;:::i;:::-;18850:21;18906:44;;:::i;:::-;18965:8;18874:13;18888:6;18874:21;;;;;;;;;;;;;;;;;;;;18850:45;;18976:1;18965:12;;18960:119;364:2;18979:16;;;;18960:119;;;19038:30;19047:4;:17;;;19066:1;19038:8;:30::i;:::-;19016:16;:19;;;;;;;;;;:52;;;;:19;;;;;;:52;18997:3;;18960:119;;;19089:46;;;;;;;;;;19097:16;;19115:19;;;;19089:46;19115:19;;19089:46;;19115:19;-1:-1:-1;19089:46:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;18702:440;;;;;;:::o;16848:98::-;16919:13;:20;16848:98;;:::o;44653:192::-;44772:2;44764:10;;1127;44799:22;;;;;;;44798:39;;44653:192;;;;;;:::o;47219:188::-;47281:6;47310:7;;;47331;;;;;;;;47327:46;;47361:1;47354:8;;;;47327:46;-1:-1:-1;1289:10:2;;47219:188;-1:-1:-1;;;47219:188:2:o;24397:1968::-;24490:21;24625:8;24680:17;24747:15;24810:13;25167:25;25194;24514:13;24528:6;24514:21;;;;;;;;;;;;;;;;;;;;24490:45;;24636:1;24625:12;;24620:1669;24643:16;;;;;;;;24639:20;;;;24620:1669;;;24700:33;24710:4;:19;;;24731:1;24700:9;:33::i;:::-;24680:53;;24765:31;24775:4;:17;;;24794:1;24765:9;:31::i;:::-;24867:15;;24835:17;;;;24747:49;;-1:-1:-1;24867:15:2;;;24826:37;;24747:49;24826:8;:37::i;:::-;:56;;;:126;;;;216:3;24902:50;;:37;24911:4;:17;;;24930:8;24902;:37::i;:::-;:50;;;24826:126;24810:142;;25223:388;25304:34;25314:4;:20;;;25336:1;25304:9;:34::i;:::-;25403:39;25413:4;:25;;;25440:1;25403:9;:39::i;:::-;25505:19;;;:29;;;;;;;;;25223:388;25166:445;;;;25630:18;:23;;25652:1;25630:23;25626:653;;;25806:18;25774:19;;;:29;;;;;;;;;;;;;;;;;;;;;:50;;;;;;;;;;;;;;;;;;25862:54;25871:4;:17;;;25890:8;25900:4;:15;;;;;;;;;;;;25862:8;:54::i;:::-;25842:17;;;:74;25626:653;;;26077:119;26106:19;;;:31;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;26160:18;26077:7;:119::i;:::-;26043:19;;;:31;;;;;;;;;;;;;;;;;;;;;:153;;;;;;;;;;;;;;;;;;26246:18;26214:4;:19;;26234:8;26214:29;;;;;;;;;;;;;;;;;;;;;;:50;;;;;;;;;;;;;;;;;;25626:653;24661:3;;;;;24620:1669;;;-1:-1:-1;;;26338:16:2;;;;:20;;-1:-1:-1;;26338:20:2;;;-1:-1:-1;;;;24397:1968:2:o;26483:888::-;26588:6;26611:21;26666:41;;:::i;:::-;26717:16;26751:8;26827:18;27080:17;26635:13;26649:6;26635:21;;;;;;;;;;;;;;;;;;;;26611:45;;26736:5;26717:24;;26787:1;26783:5;;26778:292;364:2;26790:16;;;;26778:292;;;26848:30;26857:4;:17;;;26876:1;26848:8;:30::i;:::-;26827:51;-1:-1:-1;26896:24:2;;;216:3;26896:24;26892:168;;;26954:4;26940:18;;26892:168;;;27041:4;27009:16;:29;;;;;;;;;;:36;;;:29;;;;;:36;26892:168;26808:3;;;;;26778:292;;;-1:-1:-1;27100:15:2;;;;-1:-1:-1;27100:15:2;;27125:212;27141:16;;;;;;;;;27137:20;;;;27125:212;;;27210:16;;;;;;;;;;27205:1;27192:14;;27191:35;;;;;;;;;27178:48;;27244:11;:43;;;-1:-1:-1;27259:16:2;:28;;;;;;;;;;;;;;27244:43;27240:87;;;27307:5;;27240:87;27159:3;;;;;27125:212;;;27354:10;26483:888;-1:-1:-1;;;;;;;26483:888:2:o;31443:663::-;31504:21;31618:13;31726:19;31852:29;31528:13;31542:6;31528:21;;;;;;;;;;;;;;;;;;;;;;;31634:15;;31528:21;;-1:-1:-1;31634:15:2;;;-1:-1:-1;31748:38:2;31771:6;31634:15;31748:22;:38::i;:::-;31726:60;;31884:42;31894:4;:23;;;31919:6;31884:9;:42::i;:::-;31852:74;;31962:137;31985:4;:23;;;32023:6;32044:45;32052:22;32076:12;32044:7;:45::i;31962:137::-;31936:4;:23;;:163;;;;31443:663;;;;;:::o;45675:189::-;45819:22;45793:1;45785:9;;;;45819:22;;;;;1222:4;45818:38;;45675:189::o;45168:268::-;45335:22;45404:14;;;45302:2;45294:10;;;;45335:22;;;;45404:24;;;45335:22;;45333:25;45376:23;;;;45375:54;;45168:268::o;30606:720::-;30717:6;30740:21;30862:18;30973:17;31041:8;30764:13;30778:6;30764:21;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;30764:21:2;-1:-1:-1;30993:33:2;;-1:-1:-1;30764:21:2;;-1:-1:-1;31036:206:2;364:2;31055:16;;;;31036:206;;;31130:6;31096:40;;:30;31105:4;:17;;;31124:1;31096:8;:30::i;:::-;:40;;;31092:140;;;31171:13;:16;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;31156:31;;;;31205:12;;;;;;;31092:140;31073:3;;31036:206;;;-1:-1:-1;945:2:2;31261:24;;31260:58;;;;;-1:-1:-1;;;;30606:720:2:o;46188:329::-;46278:7;;;46313:3;46305:11;;;;46297:54;;;;;-1:-1:-1;;;;;46297:54:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;1222:4:2;46385:1;46377:9;;;;46417:21;;;;;;;;;46415:24;46457:23;;;;46485:14;;:24;46456:54;;46188:329::o;46775:184::-;46837:6;;46859:8;;;;;;;;46855:79;;-1:-1:-1;;46894:7:2;;;;46915:8;;46855:79;-1:-1:-1;46951:1:2;;46775:184;-1:-1:-1;;;46775:184:2:o;27859:2521::-;28062:6;28070;28719:18;28786:20;28824;29251:12;29309;29840:25;30156;28101:8;:42;;;;28128:11;28142:1;28128:15;28113:30;;:12;:30;28101:42;28093:93;;;;;;;-1:-1:-1;;;;;28093:93:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;28201:8;28197:2177;;;28306:40;28314:16;28332:13;28306:7;:40::i;:::-;28298:52;-1:-1:-1;28348:1:2;;-1:-1:-1;28298:52:2;;28197:2177;28740:32;28756:11;28770:1;28756:15;28740;:32::i;:::-;28719:53;-1:-1:-1;28809:1:2;;-1:-1:-1;28809:1:2;;-1:-1:-1;28955:16:2;;;;28951:796;;;29007:1;;-1:-1:-1;842:1:2;29042:46;29050:13;739:1;29042:7;:46::i;:::-;:73;;;;;;;;;;29026:89;;28951:796;;;29273:17;;;;;-1:-1:-1;29287:3:2;29273:17;;;29332:16;;;29331:24;;;;-1:-1:-1;29448:32:2;29456:16;29273:17;29448:7;:32::i;:::-;:38;;;;;;;;;;;-1:-1:-1;29701:30:2;29622:54;29630:13;739:1;29645:30;;29622:7;:54::i;:::-;:110;;;;;;;;;;29606:126;;28951:796;29888:13;29869:32;;:16;:32;;;29868:92;;29959:1;29868:92;;;29942:13;29923:16;:32;29868:92;29840:120;;30201:13;30185:29;;:13;:29;;;30184:117;;30291:1;30270:18;:22;;;:30;;30299:1;30270:30;;;30295:1;30270:30;30184:117;;;;;30252:13;30236;:29;30184:117;30156:145;;30324:18;30344;30316:47;;;;28197:2177;27859:2521;;;;;;;;;;;;;;:::o;47683:249::-;47745:6;;47767:7;;;;47763:46;;;47797:1;47790:8;;;;47763:46;47835:2;47830;:7;47819:18;;47861:2;47851:12;;47855:2;47851:6;;:1;:6;;;;;;;;;;:12;;;47847:51;;;47886:1;47879:8;;;;104:47830;;;;;;;;;;;;29:2:-1;21:6;17:15;117:4;105:10;97:6;88:34;-1:-1;104:47830:2;;;-1:-1:-1;;104:47830:2:o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;104:47830:2;-1:-1:-1;;;;;104:47830:2;;;;;;;;;;;-1:-1:-1;104:47830:2;;;;;;;-1:-1:-1;104:47830:2;;;-1:-1:-1;104:47830:2;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;104:47830:2;;;-1:-1:-1;104:47830:2;:::i;:::-;;;;;;;;;;;;29:2:-1;21:6;17:15;117:4;105:10;97:6;88:34;-1:-1;104:47830:2;;;-1:-1:-1;;104:47830:2:o;:::-;;;;;;;;;;;;29:2:-1;21:6;17:15;117:4;105:10;97:6;88:34;-1:-1;104:47830:2;;;-1:-1:-1;;104:47830:2:o;:::-;;;;;;;;;;;;;-1:-1:-1;;104:47830:2;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;104:47830:2;;;;;;",
		"source": "pragma solidity ^0.4.0;\n\n/** @title World game. Battle to control territory and take over the world. */\ncontract WorldGame {\n\n    /* Constant to indicate that a region has no owner */\n    uint32 constant NOT_OWNED = 255;\n\n    /* Constant to indicate no region */\n    uint32 constant NO_REGION = 255;\n\n    /* Number of regions */\n    uint32 constant REGION_COUNT = 25;\n\n    /* Maxmimum number of neighbors per region */\n    uint32 constant MAX_NEIGHBORS = 5;\n\n    /* Maximum number of players per game */\n    uint32 constant MAX_PLAYERS = 8;\n\n    /* Maximum number for actions per turn in a game */\n    uint32 constant MAX_ACTIONS_PER_TURN = 8;\n\n    /* Defender advantage in battle numerator */\n    uint32 constant DEFENDER_ADVANTAGE_NUM = 5;\n\n    /* Defender advantage in battle denominator  */\n    uint32 constant DEFENDER_ADVANTAGE_DENOM = 4;\n\n    /* Reward bonus multiplier denominator  */\n    uint32 constant REWARD_BONUS_MULTIPLIER_DENOM = 20;\n\n    /* Minimum value for maxBlocksPerTurn */\n    uint32 constant MAX_BLOCKS_THRESHOLD = 20;\n\n    /* 32 bit mask used for helper functions */\n    uint256 constant MASK_32_BITS = 0xffffffff;\n\n    /* 8 bit mask used for helper functions */\n    uint256 constant MASK_8_BITS = 0xff;\n\n    /* Max uint32 value */\n    uint32 constant MAX_UINT32 = 0xffffffff;\n\n    /* Constant to indicate that all regions have no owner */\n    uint256 constant ALL_REGIONS_NOT_OWNED = 0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff;\n\n    /* Initial number of soldier each player starts with. Each play begins with 20 soldiers. */\n    uint256 constant BEGIN_SOLDIERS_COUNTS = 0x0000001400000014000000140000001400000014000000140000001400000014;\n    \n    /* Contract owner used for circuit breaker. */\n    address private owner;\n\n    /* Whether circuit breaker is active. */\n    bool private stopped;\n\n    /* Historical cache of block hashes. */\n    mapping (uint32 => uint32) public blockHash32Map;\n\n    /* Describes which adjacent neighbors each region has. E.g. EASTERN_EUROPE is next to WESTERN_EUROPE. */\n    uint32[MAX_NEIGHBORS][REGION_COUNT] public regionNeighbors;\n\n    /* Describes the reward amount given each round for controlling a region. */\n    uint32[REGION_COUNT] public regionRewards;\n\n    /* Array of game data.  Each entry in the area represents a different game. */\n    GameData[] public gameDataArray;\n\n    /* Enum with all the regions of the game */\n    enum Regions {\n        HAWAII,\n        WESTERN_CANADA,\n        EASTERN_CANADA,\n        WESTERN_USA,\n        EASTERN_USA,\n        GREENLAND,\n        NORTHERN_SOUTH_AMERICA,\n        SOUTHERN_SOUTH_AMERICA,\n        WEST_ANTARCTICA,\n        EAST_ANTARCTICA,\n        WESTERN_EUROPE,\n        EASTERN_EUROPE,\n        CENTRAL_RUSSIA,\n        EASTERN_RUSSIA,\n        WEST_AFRICA,\n        MIDDLE_EAST,\n        EAST_AFRICA,\n        SOUTH_AFRICA,\n        INDIA,\n        EASTERN_CHINA,\n        SOUTHEAST_ASIA,\n        WESTERN_AUSTRALIA,\n        EASTERN_AUSTRALIA,\n        NEW_ZEALAND,\n        FIJI\n    }\n\n    /* Data for an individual game. */\n    struct GameData {\n\n        /* Team ID for who's turn it is. */\n        uint32 turnTeamId;\n\n        /* A unique ID to identify this turn. */\n        uint32 turnNum;\n\n        /* Maxmimum number of blocks per turn. */\n        uint32 maxBlocksPerTurn;\n\n        /* Number of players in this game. */\n        uint32 playerCount;\n\n        /* Address of each player. */\n        address[MAX_PLAYERS] playerAddresses;\n\n        /* Soldiers held by a player in reserve, but not deployed to a region. */\n        uint256 undeployedSoldiers;\n\n        /* Which player controls each region. */\n        uint256 regionOwners;\n\n        /* Number of soldiers deployed to each region. */\n        uint32[REGION_COUNT] regionSoldiers;\n\n        /* Number of actions taken this turn. */\n        uint32 actionCount;\n\n        /* Region user is moving soldiers from. Listed by action ID. */\n        uint256 fromRegionList;\n\n        /* Region user is moving soldiers to. Listed by action ID.  */\n        uint256 toRegionList;\n\n        /* Number of soldiers to move. Listed by action ID. */\n        uint256 moveSoldierCountList;\n\n        /* Block number when action was submitted. Listed by action ID. */\n        uint256 submitBlockList;\n\n        /* Avatars to use for each team. */\n        bytes8 teamAvatars;\n    }\n    \n    /* Event indicating that a new game has started. */\n    event NewGame(uint256 gameId, uint32 turnNum, bytes8 teamAvatars);\n\n    /* Event when it's the next player's turn. */\n    event NextTurn(uint256 gameId, uint32 turnNum, uint32 nextTeamId);\n\n    /* Event when a player wins the game! */\n    event Winner(uint256 gameId, uint32 winningTeamId);\n\n    /* Modifier that only allows player to take action if it's their turn. */\n    modifier onlyIfPlayersTurn(uint256 gameId, uint32 turnNum) {\n        GameData storage game = gameDataArray[gameId];\n\n        /* Ensure it's message sender's turn. */\n        require(\n            msg.sender == game.playerAddresses[game.turnTeamId], \n            \"Sender not authorized.\"\n        );\n\n        /* Don't allow action to occur on wrong turn. */\n        require(game.turnNum == turnNum, \"Wrong turn number.\");\n\n        _;\n    }\n\n    /* Modifier that checks if sender is a player in this game. */\n    modifier onlyPlayers(uint256 gameId) {\n        GameData storage game = gameDataArray[gameId];\n\n        /* Ensure sender in a player in the game. */\n        require(\n            msg.sender == game.playerAddresses[0] || \n            msg.sender == game.playerAddresses[1] || \n            msg.sender == game.playerAddresses[2] || \n            msg.sender == game.playerAddresses[3] || \n            msg.sender == game.playerAddresses[4] || \n            msg.sender == game.playerAddresses[5] || \n            msg.sender == game.playerAddresses[6] || \n            msg.sender == game.playerAddresses[7], \n            \"Sender not authorized.\"\n        );\n\n        _;\n    }\n\n    /* Modifier to only allow moving soldiers between adjacent regions that exist. */\n    modifier onlyNeighbors(uint32 regionFrom, uint32 regionTo) {\n\n        /* Ensure regions exist. */\n        require(regionFrom < REGION_COUNT && regionTo < REGION_COUNT, \"Must be valid regions\");\n\n        /* Only allow moving soldiers between adjacent regions. */\n        require(\n            regionNeighbors[regionFrom][0] == regionTo || \n            regionNeighbors[regionFrom][1] == regionTo || \n            regionNeighbors[regionFrom][2] == regionTo || \n            regionNeighbors[regionFrom][3] == regionTo || \n            regionNeighbors[regionFrom][4] == regionTo,\n            \"Regions must be neighbors in order to move between them\"\n        );\n\n        _;\n    }\n\n    /* Modifier that only allows owner to call function. */\n    modifier isOwner() {\n        require(msg.sender == owner, \"Only owner can call this function.\");\n\n        _;\n    }\n\n    /* Modifier that stops function in case of emergency. */\n    modifier stopInEmergency() {\n        require(stopped == false, \"Stopped due to emergency.\");\n\n        _;\n    }\n\n    /* Constructor initializes common data about regions. */\n    constructor() public {\n        owner = msg.sender;\n        initRegionNeighbors();\n        initRegionRewards();\n    }\n\n    /* Fallback function. Added so ether sent to this contract is reverted. */\n    function() public payable {\n        revert(\"Invalid call to game contract.\");\n    }\n\n    /* Trigger circuit breaker to prevent new games from being created. */\n    function stopNewGames(bool stop)\n        public \n        isOwner()\n    {\n        stopped = stop;\n    }\n\n    /// @notice Create a new game instance\n    /// @param playerCount number of players\n    /// @param playerAddresses address of each player\n    /// @param teamAvatars avatar to use for each player\n    /// @return Id of the game instance\n    function newGame(\n        uint32 playerCount, \n        uint32 maxBlocksPerTurn, \n        address[MAX_PLAYERS] playerAddresses, \n        bytes8 teamAvatars\n    )\n        public\n        stopInEmergency() \n        returns(uint256) \n    {\n        /* Ensure maxBlocksPerTurn isn't set maliciously low. */\n        require(maxBlocksPerTurn >= MAX_BLOCKS_THRESHOLD, \"Users must be given enough time to complete their turn.\");\n\n        /* \n            Initialize a new game with some default values.\n            Push returns array length so subtract 1 to get array index.\n        */\n        uint256 gameId = gameDataArray.push(GameData(\n            /* uint32 turnTeamId */\n            uint32(0), \n            /* uint32 turnNum */\n            uint32(block.number), \n            /* uint32 maxBlocksPerTurn */\n            maxBlocksPerTurn,\n            /* uint32 playerCount */\n            playerCount,\n            /* address[MAX_PLAYERS] playerAddresses */\n            playerAddresses, \n            /* uint256 undeployedSoldiers */\n            BEGIN_SOLDIERS_COUNTS, \n            /* uint256 regionOwners */\n            ALL_REGIONS_NOT_OWNED, \n            /* uint32[REGION_COUNT] regionSoldiers */\n            [\n                uint32(0), uint32(0), uint32(0), uint32(0), uint32(0), uint32(0), \n                uint32(0), uint32(0), uint32(0), uint32(0), uint32(0), uint32(0), \n                uint32(0), uint32(0), uint32(0), uint32(0), uint32(0), uint32(0), \n                uint32(0), uint32(0), uint32(0), uint32(0), uint32(0), uint32(0), \n                uint32(0)\n            ], \n            /* uint32 actionCount */\n            uint32(0),\n            /* uint256 fromRegionList */\n            uint256(0), \n            /* uint256 toRegionList */\n            uint256(0), \n            /* uint256 moveSoldierCountList */\n            uint256(0), \n            /* uint256 submitBlockList */\n            uint256(0),\n            /* bytes8 teamAvatars */\n            teamAvatars\n        )) - 1;\n\n        emit NewGame(gameId, uint32(block.number), teamAvatars);\n        return gameId;\n    }\n\n    /// @notice Move soldiers from one region to an adjacent region.  Attack if moving to enemy territory. \n    /// @param gameId Id of game \n    /// @param turnNum Turn action should occur during \n    /// @param regionFrom Move soldiers from this region\n    /// @param regionTo Move soldiers to this region\n    /// @param moveSoldierCount Number of soldiers to move\n    function attackOrMove(\n        uint256 gameId, \n        uint32 turnNum, \n        uint32 regionFrom, \n        uint32 regionTo, \n        uint32 moveSoldierCount\n    )\n        public \n        onlyIfPlayersTurn(gameId, turnNum) \n        onlyNeighbors(regionFrom, regionTo) \n    {\n        GameData storage game = gameDataArray[gameId];\n        uint32 i;\n\n        /* Loop through all queued actions. */\n        for (i = 0; i < game.actionCount; i++) {\n            /* Ensure region doesn't already have a queued action. */\n            require(\n                regionTo != getData32(game.toRegionList, i), \n                \"Region already has queued action.\"\n            );\n        }\n        require(game.actionCount < MAX_ACTIONS_PER_TURN, \"Only 8 actions are allowed per turn\");\n        require(game.regionSoldiers[regionFrom] > moveSoldierCount, \"Must have sufficient soldiers\");\n        require(game.turnTeamId == getData8(game.regionOwners, regionFrom), \"Must own region moving from\");\n\n        /* Index to use for creating a new action */\n        i = game.actionCount;\n\n        /* Remove soldiers from region */\n        game.regionSoldiers[regionFrom] -= moveSoldierCount;\n\n        /* Queue a new action for this turn */\n        game.fromRegionList = setData32(game.fromRegionList, i, regionFrom);\n        game.toRegionList = setData32(game.toRegionList, i, regionTo);\n        game.moveSoldierCountList = setData32(game.moveSoldierCountList, i, moveSoldierCount);\n        game.submitBlockList = setData32(game.submitBlockList, i, uint32(block.number));\n\n        /* Update action count */\n        game.actionCount++;\n    }\n\n    /// @notice Execute actions that have been queued for this turn.\n    /// @param gameId Id of game \n    /// @param turnNum Turn deploySoldiersAndEndTurn should occur during \n    /// @param regionDeploy Region where you'd like to deploy soldiers to\n    /// @param deploySoldierCount Number of soldiers you'd like to deploy at end of your turn\n    function deploySoldiersAndEndTurn(\n        uint256 gameId, \n        uint32 turnNum, \n        uint32 regionDeploy, \n        uint32 deploySoldierCount\n    )\n        public \n        onlyIfPlayersTurn(gameId, turnNum) \n    {\n        GameData storage game = gameDataArray[gameId];\n        uint32 undeployedSoldierCount = getData32(game.undeployedSoldiers, game.turnTeamId);\n\n        require(undeployedSoldierCount >= deploySoldierCount, \"Must have sufficient soldiers.\");\n        require(\n            (regionDeploy == NO_REGION && deploySoldierCount == 0) || \n            getData8(game.regionOwners, regionDeploy) == game.turnTeamId || \n            getData8(game.regionOwners, regionDeploy) == NOT_OWNED,\n            \"You can only deploy soldiers to a region you own, or that is unoccupied.\"\n        );\n\n        /* If there's any queued actions then execute them before ending turn. */\n        if (game.actionCount > 0) {\n            executePendingActions(gameId);\n        }\n\n        /* Deploy soldiers if a region is specified */\n        if (regionDeploy != NO_REGION) {\n            game.regionOwners = setData8(game.regionOwners, regionDeploy, game.turnTeamId);\n            game.undeployedSoldiers = setData32(\n                game.undeployedSoldiers, \n                game.turnTeamId, \n                subSafe(undeployedSoldierCount, deploySoldierCount)\n            );\n            game.regionSoldiers[regionDeploy] = addSafe(\n                game.regionSoldiers[regionDeploy],\n                deploySoldierCount\n            );\n        }\n\n        /* It's the next player's turn */\n        game.turnTeamId = getNextTurnTeamId(gameId);\n        game.turnNum = uint32(block.number);\n\n        /* Give bonus soldiers to next team based on what regions they control. */\n        giveRegionRewards(gameId);\n\n        emit NextTurn(gameId, game.turnNum, game.turnTeamId);\n    }\n\n    /// @notice Force turn to end for player who's taking too long.\n    /// @param gameId Id of game \n    /// @param turnNum Turn forceEndOfTurn should occur during \n    function forceEndOfTurn(\n        uint256 gameId, \n        uint32 turnNum\n    )\n        public \n        onlyPlayers(gameId)\n    {\n        GameData storage game = gameDataArray[gameId];\n        require(game.turnNum == turnNum, \"Wrong turn number.\");\n        require(block.number > addSafe(game.turnNum, game.maxBlocksPerTurn), \"Player still has time to finish turn.\");\n\n        /* If there's any queued actions then execute them before ending turn. */\n        if (game.actionCount > 0) {\n            executePendingActions(gameId);\n        }\n\n        /* It's the next player's turn */\n        game.turnTeamId = getNextTurnTeamId(gameId);\n        game.turnNum = uint32(block.number);\n\n        /* Give bonus soldiers to next team based on what regions they control. */\n        giveRegionRewards(gameId);\n\n        emit NextTurn(gameId, game.turnNum, game.turnTeamId);\n    }\n\n    /// @notice Declare victory for a team.\n    /// @param gameId Id of game\n    /// @param teamId Team you'd like to declare as winner\n    function declareWinner(uint256 gameId, uint32 teamId) \n        public \n        onlyPlayers(gameId)\n    {\n        GameData storage game = gameDataArray[gameId];\n        \n        bool isWinner = true;\n        for (uint32 i = 0; i < REGION_COUNT; i++) {\n            if (getData8(game.regionOwners, i) != teamId) {\n                isWinner = false;\n            }\n        }\n\n        require(isWinner, \"We don't have a winner.\");\n\n        if (isWinner) {\n            emit Winner(gameId, teamId);\n        }\n    }\n\n    /// @notice Caches the hash for a specific block in a map.  Only uses last 32 bits.\n    /// @param blockNum Block number\n    /// @return Last 32 bits of block hash, or 0 if not available\n    function cacheBlockHash32(uint32 blockNum) public returns(uint32) {\n        uint32 cachedBlockHash = blockHash32Map[blockNum];\n\n        if (cachedBlockHash == 0) {\n            cachedBlockHash = uint32(blockhash(blockNum));\n            blockHash32Map[blockNum] = cachedBlockHash;\n        }\n\n        return cachedBlockHash;\n    }\n\n    /// @notice Get hash for a specific block.  Only uses last 32 bits.\n    /// @param blockNum Block number\n    /// @return Last 32 bits of block hash, or 0 if not available\n    function readBlockHash32(uint32 blockNum) public view returns(uint32) {\n        uint32 blockHash32 = uint32(blockhash(blockNum));\n\n        if (blockHash32 == 0) {\n            blockHash32 = blockHash32Map[blockNum];\n        }\n\n        return blockHash32;\n    }\n\n    /// @notice Returns total number of games that have been created.\n    function numberOfGames() public view returns(uint256) {\n        return gameDataArray.length;\n    }\n\n    /// @notice Returns recent game ids where msg.sender is a player.\n    /// @param offset Position in game data array to start search from\n    /// @return List of game ids\n    /// @return Number of game ids\n    /// @return Position in loop when ended\n    function listGamesForAddress(uint256 offset) \n        public \n        view \n        returns(uint256[10], uint32, uint256) \n    {\n        uint256[10] memory gameIdList;\n        uint32 gameIdCount;\n        uint256 gameId;\n        if (gameDataArray.length > 0) {\n\n            /* Start position to search backwards through gameDataArray */\n            uint256 startPosition = gameDataArray.length - 1;\n            if (offset > 0 && offset < startPosition) {\n                startPosition = offset;\n            }\n\n            /* Add one to \"i\" to prevent underflow.  Then sub one from \"i\" to get gameId. */\n            for (uint256 i = startPosition + 1; i > 0; i--) {\n                gameId = i - 1;\n\n                GameData storage game = gameDataArray[gameId];\n                for (uint32 j = 0; j < game.playerCount; j++) {\n                    if (game.playerAddresses[j] == msg.sender) {\n                        gameIdList[gameIdCount] = gameId;\n                        gameIdCount++;\n                        break;\n                    }\n                }\n\n                if (gameIdCount == 10 || gasleft() < 100000) {\n                    break;\n                }\n            }\n        }\n\n        return (gameIdList, gameIdCount, gameId);\n    }\n\n    /// @notice Returns the number of soldiers deployed to each region and region owners.\n    /// @param gameId Id of game \n    /// @return List of which player owns each region\n    /// @return List of number of soldiers deployed to each region\n    function soldiersByRegion(uint256 gameId) \n        public \n        view \n        returns(uint32[REGION_COUNT], uint32[REGION_COUNT]) \n    {\n        GameData storage game = gameDataArray[gameId];\n\n        uint32[REGION_COUNT] memory regionOwnersList;\n        for (uint32 i = 0; i < REGION_COUNT; i++) {\n            regionOwnersList[i] = getData8(game.regionOwners, i);\n        }\n\n        return (regionOwnersList, game.regionSoldiers);\n    }\n\n    /// @notice Returns information about current turn and players.\n    /// @param gameId Id of game \n    /// @return Id of current player\n    /// @return Turn number\n    /// @return Max blocks per turn\n    /// @return Number of players\n    /// @return Player addresses\n    function turnAndPlayerInfo(uint256 gameId) \n        public \n        view \n        returns(uint32, uint32, uint32, uint32, address[MAX_PLAYERS], bytes8) \n    {\n        GameData storage game = gameDataArray[gameId];\n        return (\n            game.turnTeamId, \n            game.turnNum, \n            game.maxBlocksPerTurn, \n            game.playerCount, \n            game.playerAddresses,\n            game.teamAvatars\n        );\n    }\n\n    /// @notice Returns the number of undeployed soldiers for each player.\n    /// @param gameId Id of game \n    /// @return Number of undeployed soldiers for each player\n    /// @return Reward points for each player\n    function undeployedSoldiers(uint256 gameId) \n        public \n        view \n        returns(uint32[MAX_PLAYERS], uint32[MAX_PLAYERS]) \n    {\n        GameData storage game = gameDataArray[gameId];\n\n        uint32[MAX_PLAYERS] memory undeployedSoldiersList;\n        uint32[MAX_PLAYERS] memory regionRewardList;\n        for (uint32 i = 0; i < MAX_PLAYERS; i++) {\n            undeployedSoldiersList[i] = getData32(game.undeployedSoldiers, i);\n            regionRewardList[i] = calculateRegionRewards(gameId, i); \n        }\n\n        return (undeployedSoldiersList, regionRewardList);\n    }\n\n    /// @notice Returns pending actions that have been queued for current turn.\n    /// @param gameId Id of game \n    /// @return Number of pending actions\n    /// @return List of regions moving soldiers from\n    /// @return List of regions moving soldiers to\n    /// @return List with number of soldiers to move\n    /// @return List with block number when action was queued\n    function pendingActions(uint256 gameId) \n        public \n        view \n        returns(\n            uint32,\n            uint32[MAX_ACTIONS_PER_TURN], \n            uint32[MAX_ACTIONS_PER_TURN], \n            uint32[MAX_ACTIONS_PER_TURN], \n            uint32[MAX_ACTIONS_PER_TURN]\n    ) {\n        GameData storage game = gameDataArray[gameId];\n\n        uint32[MAX_ACTIONS_PER_TURN] memory fromRegionList;\n        uint32[MAX_ACTIONS_PER_TURN] memory toRegionList;\n        uint32[MAX_ACTIONS_PER_TURN] memory moveSoldierCountList;\n        uint32[MAX_ACTIONS_PER_TURN] memory submitBlockList;\n\n        for (uint32 i = 0; i < MAX_ACTIONS_PER_TURN; i++) {\n            fromRegionList[i] = getData32(game.fromRegionList, i);\n            toRegionList[i] = getData32(game.toRegionList, i);\n            moveSoldierCountList[i] = getData32(game.moveSoldierCountList, i);\n            submitBlockList[i] = getData32(game.submitBlockList, i);\n        }\n\n        return (\n            game.actionCount, \n            fromRegionList, \n            toRegionList, \n            moveSoldierCountList, \n            submitBlockList\n        );\n    }\n\n    /// @notice Returns pending actions that have been queued for current turn.\n    /// @param gameId Id of game \n    /// @return Current block numbber\n    /// @return Number of pending actions\n    /// @return List with block number when action was queued\n    /// @return Number of remaining attackers\n    /// @return Number of remaining defenders\n    function pendingActionOutcomes(uint256 gameId) \n        public \n        view \n        returns(\n            uint32,\n            uint32,\n            uint32[MAX_ACTIONS_PER_TURN], \n            uint32[MAX_ACTIONS_PER_TURN], \n            uint32[MAX_ACTIONS_PER_TURN]\n    ) {\n        GameData storage game = gameDataArray[gameId];\n\n        uint32[MAX_ACTIONS_PER_TURN] memory submitBlockList;\n        uint32[MAX_ACTIONS_PER_TURN] memory remainingAttackerList;\n        uint32[MAX_ACTIONS_PER_TURN] memory remainingDefenderList;\n\n        for (uint32 i = 0; i < MAX_ACTIONS_PER_TURN; i++) {\n            uint32 toRegion = getData32(game.toRegionList, i);\n            submitBlockList[i] = getData32(game.submitBlockList, i);\n\n            bool friendly = getData8(game.regionOwners, toRegion) == game.turnTeamId || \n                getData8(game.regionOwners, toRegion) == NOT_OWNED;\n\n            if (friendly || block.number > submitBlockList[i] + 1) {\n                (uint32 remainingAttackers, uint32 remainingDefenders) = getOutcomeAttackOrMove(\n                    /* uint32 submitBlock */\n                    submitBlockList[i], \n                    /* uint32 moveSoldierCount */\n                    getData32(game.moveSoldierCountList, i), \n                    /* uint32 defenderCount  */\n                    game.regionSoldiers[toRegion],\n                    /* bool friendly  */\n                    friendly\n                );\n\n                remainingAttackerList[i] = remainingAttackers;\n                remainingDefenderList[i] = remainingDefenders;\n            }\n        }\n\n        return (\n            uint32(block.number), \n            game.actionCount, \n            submitBlockList, \n            remainingAttackerList,\n            remainingDefenderList\n        );\n    }\n\n    /// @notice Execute actions that have been queued for this turn.\n    /// @param gameId Id of game \n    function executePendingActions(\n        uint256 gameId\n    ) \n        private \n    {\n        GameData storage game = gameDataArray[gameId];\n\n        /* Loops through all queued actions executing them one by one. */\n        for (uint32 i = 0; i < game.actionCount; i++) {\n            uint32 regionFrom = getData32(game.fromRegionList, i);\n            uint32 regionTo = getData32(game.toRegionList, i);\n            bool friendly = getData8(game.regionOwners, regionTo) == game.turnTeamId ||\n                getData8(game.regionOwners, regionTo) == NOT_OWNED;\n\n            /* \n                If attacking enemy territory, then uses randomness to determine outcome.\n                If moving to friendly territory then just moves the soldiers. \n            */\n            (uint32 remainingAttackers, uint32 remainingDefenders) = getOutcomeAttackOrMove(\n                /* uint32 submitBlock */\n                getData32(game.submitBlockList, i), \n                /* uint32 moveSoldierCount */\n                getData32(game.moveSoldierCountList, i), \n                /* uint32 defenderCount  */\n                game.regionSoldiers[regionTo],\n                /* bool friendly  */\n                friendly\n            );\n\n            if (remainingDefenders == 0) {\n                /* Attacker wins (or move was friendly).  Remaining attackers move to new region. */\n                game.regionSoldiers[regionTo] = remainingAttackers;\n                game.regionOwners = setData8(game.regionOwners, regionTo, game.turnTeamId);\n            }\n            else {\n                /* Defender wins.  Remaining attackers return back home. */\n                game.regionSoldiers[regionFrom] = addSafe(\n                    game.regionSoldiers[regionFrom], \n                    remainingAttackers\n                );\n                game.regionSoldiers[regionTo] = remainingDefenders;\n            }\n        }\n\n        /* Reset action count to 0. */\n        game.actionCount = 0;\n    }\n\n    /// @notice Player who's turn is next. \n    /// @param gameId Id of game\n    /// @return Next player's turn\n    function getNextTurnTeamId(\n        uint256 gameId\n    ) \n        private \n        view \n        returns(uint32) \n    {\n        GameData storage game = gameDataArray[gameId];\n        bool[MAX_PLAYERS] memory playerOwnsRegion;\n        bool hasNotOwned = false;\n        uint32 i;\n        \n        for (i = 0; i < REGION_COUNT; i++) {\n            uint32 regionOwner = getData8(game.regionOwners, i);\n            if (regionOwner == NOT_OWNED) {\n                hasNotOwned = true;\n            }\n            else {\n                playerOwnsRegion[regionOwner] = true;\n            }\n        }\n\n        uint32 turnTeamId = game.turnTeamId;\n        for (i = 0; i < game.playerCount; i++) {\n            turnTeamId = (turnTeamId + 1) % game.playerCount;\n            if (hasNotOwned || playerOwnsRegion[turnTeamId]) {\n                break;\n            }\n        }\n\n        return turnTeamId;\n    }\n\n    /// @notice Declare victory for a team.\n    /// @param submitBlock Block number when action was submitted to queue\n    /// @param moveSoldierCount Number of soldiers to move or attack\n    /// @param defenderCount Number of soldiers defending destination region\n    /// @param friendly Whether this is an attack, or friendly move\n    /// @return remainingAttackers Number of attacking soldiers remaining \n    /// @return remainingDefenders Number of defending soldiers remaining\n    function getOutcomeAttackOrMove(\n        uint32 submitBlock, \n        uint32 moveSoldierCount, \n        uint32 defenderCount, \n        bool friendly\n    ) \n        private \n        view \n        returns(uint32, uint32) \n    {\n        require(friendly || block.number > submitBlock + 1, \"Attacks must be at least 2 blocks old.\");\n\n        if (friendly) {\n            /* If friendly, just move all soldiers to attacking side. */\n            return (addSafe(moveSoldierCount, defenderCount), 0);\n        }\n        else {\n            /* \n                Determine outcome of attack.\n                Use blockHash of the block after action was submitted as a source of randomness.\n\n                Only most recent 256 blockhashes are available.\n                If too much time has ellapsed, then blockHash will be 0 and attacker loses.\n            */\n            uint32 blockHash32 = readBlockHash32(submitBlock + 1);\n            uint32 deadDefenders = 0;\n            uint32 deadAttackers = 0;\n\n            /* If blockHash32 is no longer available then attacker loses by default. */\n            if (blockHash32 == 0) {\n                deadDefenders = 0;\n                deadAttackers = mulSafe(defenderCount, DEFENDER_ADVANTAGE_NUM) / DEFENDER_ADVANTAGE_DENOM;\n            }\n            /* If blockHash32 is available then use it as a source of randomness. */\n            else {\n                uint32 randA = uint32(blockHash32 % 256);\n                uint32 randB = uint32((blockHash32 >> 8) % 256);\n\n                /* Determine effectiveness of attack. */\n                deadDefenders = mulSafe(moveSoldierCount, randA) / 256;\n\n                /* Determine effectiveness of defence.  Gives slight extra advantage to defender. */\n                deadAttackers = mulSafe(defenderCount, DEFENDER_ADVANTAGE_NUM * randB) / \n                    (256 * DEFENDER_ADVANTAGE_DENOM);\n            }\n\n            /* Determine remaining attackers by subtracting dead attackers. */\n            uint32 remainingAttackers = (moveSoldierCount > deadAttackers) ? \n                (moveSoldierCount - deadAttackers) : 0;\n\n            /* \n                Determine remaining defenders by subtracting dead defenders.\n                If all attackers are dead then keep at least 1 defender.\n            */\n            uint32 remainingDefenders = (defenderCount > deadDefenders) ? \n                (defenderCount - deadDefenders) : (remainingAttackers > 0 ? 0 : 1);\n\n            return (remainingAttackers, remainingDefenders);\n        }\n    }\n\n    /// @notice Calculate a team's reward amount based on what regions they control.\n    /// @param gameId Id of game\n    /// @param teamId Team you'd like to calculate rewards for\n    /// @return Reward amount for team\n    function calculateRegionRewards(uint256 gameId, uint32 teamId) \n        private \n        view \n        returns(uint32) \n    {\n        GameData storage game = gameDataArray[gameId];\n\n        /* Reward total based on what regions player controls. */\n        uint32 rewardTotal = 0;\n\n        /* Bonus multiplier of 5% given per additional region controller.  */\n        uint32 bonusScore = REWARD_BONUS_MULTIPLIER_DENOM - 1;\n        for (uint32 i = 0; i < REGION_COUNT; i++) {\n            if (getData8(game.regionOwners, i) == teamId) {\n                rewardTotal += regionRewards[i];\n                bonusScore++;\n            }\n        }\n\n        return ((rewardTotal * bonusScore) / REWARD_BONUS_MULTIPLIER_DENOM);\n    }\n\n    /// @notice Reward team with soldiers based on what regions they control.\n    /// @param gameId Id of game\n    function giveRegionRewards(uint256 gameId) private {\n        GameData storage game = gameDataArray[gameId];\n\n        /* Team who's turn it is that gets the reward. */\n        uint32 teamId = game.turnTeamId;\n\n        /* Reward total based on what regions player controls. */\n        uint32 rewardAmount = calculateRegionRewards(gameId, teamId);\n\n        /* Add reward to undeployed soldiers count. */\n        uint32 undeployedSoldierCount = getData32(game.undeployedSoldiers, teamId);\n        game.undeployedSoldiers = setData32(\n            game.undeployedSoldiers, \n            teamId, \n            addSafe(undeployedSoldierCount, rewardAmount)\n        );\n    }\n\n    /// @notice Initialize neighbor relationships between all regions\n    /// @dev This data shared by all game instances\n    function initRegionNeighbors() private {\n        regionNeighbors[uint32(Regions.HAWAII)][0] = uint32(Regions.WESTERN_USA);\n        regionNeighbors[uint32(Regions.HAWAII)][1] = uint32(Regions.FIJI);\n        regionNeighbors[uint32(Regions.HAWAII)][2] = NO_REGION;\n        regionNeighbors[uint32(Regions.HAWAII)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.HAWAII)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.WESTERN_CANADA)][0] = uint32(Regions.WESTERN_USA);\n        regionNeighbors[uint32(Regions.WESTERN_CANADA)][1] = uint32(Regions.EASTERN_CANADA);\n        regionNeighbors[uint32(Regions.WESTERN_CANADA)][2] = uint32(Regions.EASTERN_RUSSIA);\n        regionNeighbors[uint32(Regions.WESTERN_CANADA)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.WESTERN_CANADA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.EASTERN_CANADA)][0] = uint32(Regions.WESTERN_CANADA);\n        regionNeighbors[uint32(Regions.EASTERN_CANADA)][1] = uint32(Regions.GREENLAND);\n        regionNeighbors[uint32(Regions.EASTERN_CANADA)][2] = uint32(Regions.EASTERN_USA);\n        regionNeighbors[uint32(Regions.EASTERN_CANADA)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.EASTERN_CANADA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.WESTERN_USA)][0] = uint32(Regions.HAWAII);\n        regionNeighbors[uint32(Regions.WESTERN_USA)][1] = uint32(Regions.WESTERN_CANADA);\n        regionNeighbors[uint32(Regions.WESTERN_USA)][2] = uint32(Regions.EASTERN_USA);\n        regionNeighbors[uint32(Regions.WESTERN_USA)][3] = uint32(Regions.NORTHERN_SOUTH_AMERICA);\n        regionNeighbors[uint32(Regions.WESTERN_USA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.EASTERN_USA)][0] = uint32(Regions.WESTERN_USA);\n        regionNeighbors[uint32(Regions.EASTERN_USA)][1] = uint32(Regions.EASTERN_CANADA);\n        regionNeighbors[uint32(Regions.EASTERN_USA)][2] = uint32(Regions.NORTHERN_SOUTH_AMERICA);\n        regionNeighbors[uint32(Regions.EASTERN_USA)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.EASTERN_USA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.GREENLAND)][0] = uint32(Regions.EASTERN_CANADA);\n        regionNeighbors[uint32(Regions.GREENLAND)][1] = uint32(Regions.WESTERN_EUROPE);\n        regionNeighbors[uint32(Regions.GREENLAND)][2] = NO_REGION;\n        regionNeighbors[uint32(Regions.GREENLAND)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.GREENLAND)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.NORTHERN_SOUTH_AMERICA)][0] = uint32(Regions.WESTERN_USA);\n        regionNeighbors[uint32(Regions.NORTHERN_SOUTH_AMERICA)][1] = uint32(Regions.EASTERN_USA);\n        regionNeighbors[uint32(Regions.NORTHERN_SOUTH_AMERICA)][2] = uint32(Regions.SOUTHERN_SOUTH_AMERICA);\n        regionNeighbors[uint32(Regions.NORTHERN_SOUTH_AMERICA)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.NORTHERN_SOUTH_AMERICA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.SOUTHERN_SOUTH_AMERICA)][0] = uint32(Regions.NORTHERN_SOUTH_AMERICA);\n        regionNeighbors[uint32(Regions.SOUTHERN_SOUTH_AMERICA)][1] = uint32(Regions.WEST_ANTARCTICA);\n        regionNeighbors[uint32(Regions.SOUTHERN_SOUTH_AMERICA)][2] = NO_REGION;\n        regionNeighbors[uint32(Regions.SOUTHERN_SOUTH_AMERICA)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.SOUTHERN_SOUTH_AMERICA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.WEST_ANTARCTICA)][0] = uint32(Regions.SOUTHERN_SOUTH_AMERICA);\n        regionNeighbors[uint32(Regions.WEST_ANTARCTICA)][1] = uint32(Regions.EAST_ANTARCTICA);\n        regionNeighbors[uint32(Regions.WEST_ANTARCTICA)][2] = NO_REGION;\n        regionNeighbors[uint32(Regions.WEST_ANTARCTICA)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.WEST_ANTARCTICA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.EAST_ANTARCTICA)][0] = uint32(Regions.WEST_ANTARCTICA);\n        regionNeighbors[uint32(Regions.EAST_ANTARCTICA)][1] = uint32(Regions.NEW_ZEALAND);\n        regionNeighbors[uint32(Regions.EAST_ANTARCTICA)][2] = NO_REGION;\n        regionNeighbors[uint32(Regions.EAST_ANTARCTICA)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.EAST_ANTARCTICA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.WESTERN_EUROPE)][0] = uint32(Regions.GREENLAND);\n        regionNeighbors[uint32(Regions.WESTERN_EUROPE)][1] = uint32(Regions.EASTERN_EUROPE);\n        regionNeighbors[uint32(Regions.WESTERN_EUROPE)][2] = uint32(Regions.WEST_AFRICA);\n        regionNeighbors[uint32(Regions.WESTERN_EUROPE)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.WESTERN_EUROPE)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.EASTERN_EUROPE)][0] = uint32(Regions.WESTERN_EUROPE);\n        regionNeighbors[uint32(Regions.EASTERN_EUROPE)][1] = uint32(Regions.WEST_AFRICA);\n        regionNeighbors[uint32(Regions.EASTERN_EUROPE)][2] = uint32(Regions.MIDDLE_EAST);\n        regionNeighbors[uint32(Regions.EASTERN_EUROPE)][3] = uint32(Regions.CENTRAL_RUSSIA);\n        regionNeighbors[uint32(Regions.EASTERN_EUROPE)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.CENTRAL_RUSSIA)][0] = uint32(Regions.EASTERN_EUROPE);\n        regionNeighbors[uint32(Regions.CENTRAL_RUSSIA)][1] = uint32(Regions.MIDDLE_EAST);\n        regionNeighbors[uint32(Regions.CENTRAL_RUSSIA)][2] = uint32(Regions.INDIA);\n        regionNeighbors[uint32(Regions.CENTRAL_RUSSIA)][3] = uint32(Regions.EASTERN_CHINA);\n        regionNeighbors[uint32(Regions.CENTRAL_RUSSIA)][4] = uint32(Regions.EASTERN_RUSSIA);\n\n        regionNeighbors[uint32(Regions.EASTERN_RUSSIA)][0] = uint32(Regions.EASTERN_CHINA);\n        regionNeighbors[uint32(Regions.EASTERN_RUSSIA)][1] = uint32(Regions.CENTRAL_RUSSIA);\n        regionNeighbors[uint32(Regions.EASTERN_RUSSIA)][2] = uint32(Regions.WESTERN_CANADA);\n        regionNeighbors[uint32(Regions.EASTERN_RUSSIA)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.EASTERN_RUSSIA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.WEST_AFRICA)][0] = uint32(Regions.WESTERN_EUROPE);\n        regionNeighbors[uint32(Regions.WEST_AFRICA)][1] = uint32(Regions.EASTERN_EUROPE);\n        regionNeighbors[uint32(Regions.WEST_AFRICA)][2] = uint32(Regions.MIDDLE_EAST);\n        regionNeighbors[uint32(Regions.WEST_AFRICA)][3] = uint32(Regions.EAST_AFRICA);\n        regionNeighbors[uint32(Regions.WEST_AFRICA)][4] = uint32(Regions.SOUTH_AFRICA);\n\n        regionNeighbors[uint32(Regions.MIDDLE_EAST)][0] = uint32(Regions.EASTERN_EUROPE);\n        regionNeighbors[uint32(Regions.MIDDLE_EAST)][1] = uint32(Regions.CENTRAL_RUSSIA);\n        regionNeighbors[uint32(Regions.MIDDLE_EAST)][2] = uint32(Regions.INDIA);\n        regionNeighbors[uint32(Regions.MIDDLE_EAST)][3] = uint32(Regions.EAST_AFRICA);\n        regionNeighbors[uint32(Regions.MIDDLE_EAST)][4] = uint32(Regions.WEST_AFRICA);\n\n        regionNeighbors[uint32(Regions.EAST_AFRICA)][0] = uint32(Regions.WEST_AFRICA);\n        regionNeighbors[uint32(Regions.EAST_AFRICA)][1] = uint32(Regions.SOUTH_AFRICA);\n        regionNeighbors[uint32(Regions.EAST_AFRICA)][2] = uint32(Regions.MIDDLE_EAST);\n        regionNeighbors[uint32(Regions.EAST_AFRICA)][3] = uint32(Regions.INDIA);\n        regionNeighbors[uint32(Regions.EAST_AFRICA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.SOUTH_AFRICA)][0] = uint32(Regions.WEST_AFRICA);\n        regionNeighbors[uint32(Regions.SOUTH_AFRICA)][1] = uint32(Regions.EAST_AFRICA);\n        regionNeighbors[uint32(Regions.SOUTH_AFRICA)][2] = NO_REGION;\n        regionNeighbors[uint32(Regions.SOUTH_AFRICA)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.SOUTH_AFRICA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.INDIA)][0] = uint32(Regions.EAST_AFRICA);\n        regionNeighbors[uint32(Regions.INDIA)][1] = uint32(Regions.MIDDLE_EAST);\n        regionNeighbors[uint32(Regions.INDIA)][2] = uint32(Regions.CENTRAL_RUSSIA);\n        regionNeighbors[uint32(Regions.INDIA)][3] = uint32(Regions.EASTERN_CHINA);\n        regionNeighbors[uint32(Regions.INDIA)][4] = uint32(Regions.SOUTHEAST_ASIA);\n\n        regionNeighbors[uint32(Regions.EASTERN_CHINA)][0] = uint32(Regions.INDIA);\n        regionNeighbors[uint32(Regions.EASTERN_CHINA)][1] = uint32(Regions.CENTRAL_RUSSIA);\n        regionNeighbors[uint32(Regions.EASTERN_CHINA)][2] = uint32(Regions.EASTERN_RUSSIA);\n        regionNeighbors[uint32(Regions.EASTERN_CHINA)][3] = uint32(Regions.SOUTHEAST_ASIA);\n        regionNeighbors[uint32(Regions.EASTERN_CHINA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.SOUTHEAST_ASIA)][0] = uint32(Regions.INDIA);\n        regionNeighbors[uint32(Regions.SOUTHEAST_ASIA)][1] = uint32(Regions.EASTERN_CHINA);\n        regionNeighbors[uint32(Regions.SOUTHEAST_ASIA)][2] = uint32(Regions.WESTERN_AUSTRALIA);\n        regionNeighbors[uint32(Regions.SOUTHEAST_ASIA)][3] = uint32(Regions.EASTERN_AUSTRALIA);\n        regionNeighbors[uint32(Regions.SOUTHEAST_ASIA)][4] = uint32(Regions.FIJI);\n\n        regionNeighbors[uint32(Regions.WESTERN_AUSTRALIA)][0] = uint32(Regions.EASTERN_AUSTRALIA);\n        regionNeighbors[uint32(Regions.WESTERN_AUSTRALIA)][1] = uint32(Regions.SOUTHEAST_ASIA);\n        regionNeighbors[uint32(Regions.WESTERN_AUSTRALIA)][2] = NO_REGION;\n        regionNeighbors[uint32(Regions.WESTERN_AUSTRALIA)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.WESTERN_AUSTRALIA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.EASTERN_AUSTRALIA)][0] = uint32(Regions.WESTERN_AUSTRALIA);\n        regionNeighbors[uint32(Regions.EASTERN_AUSTRALIA)][1] = uint32(Regions.SOUTHEAST_ASIA);\n        regionNeighbors[uint32(Regions.EASTERN_AUSTRALIA)][2] = uint32(Regions.FIJI);\n        regionNeighbors[uint32(Regions.EASTERN_AUSTRALIA)][3] = uint32(Regions.NEW_ZEALAND);\n        regionNeighbors[uint32(Regions.EASTERN_AUSTRALIA)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.NEW_ZEALAND)][0] = uint32(Regions.EASTERN_AUSTRALIA);\n        regionNeighbors[uint32(Regions.NEW_ZEALAND)][1] = uint32(Regions.FIJI);\n        regionNeighbors[uint32(Regions.NEW_ZEALAND)][2] = uint32(Regions.EAST_ANTARCTICA);\n        regionNeighbors[uint32(Regions.NEW_ZEALAND)][3] = NO_REGION;\n        regionNeighbors[uint32(Regions.NEW_ZEALAND)][4] = NO_REGION;\n\n        regionNeighbors[uint32(Regions.FIJI)][0] = uint32(Regions.NEW_ZEALAND);\n        regionNeighbors[uint32(Regions.FIJI)][1] = uint32(Regions.EASTERN_AUSTRALIA);\n        regionNeighbors[uint32(Regions.FIJI)][2] = uint32(Regions.SOUTHEAST_ASIA);\n        regionNeighbors[uint32(Regions.FIJI)][3] = uint32(Regions.HAWAII);\n        regionNeighbors[uint32(Regions.FIJI)][4] = NO_REGION;\n    }\n\n    /// @notice Initialize rewards given for controlling each region\n    /// @dev This data shared by all game instances\n    function initRegionRewards() private {\n        regionRewards[uint32(Regions.HAWAII)] = 3;\n        regionRewards[uint32(Regions.WESTERN_CANADA)] = 6;\n        regionRewards[uint32(Regions.EASTERN_CANADA)] = 5;\n        regionRewards[uint32(Regions.WESTERN_USA)] = 11;\n        regionRewards[uint32(Regions.EASTERN_USA)] = 8;\n        regionRewards[uint32(Regions.GREENLAND)] = 3;\n        regionRewards[uint32(Regions.NORTHERN_SOUTH_AMERICA)] = 3;\n        regionRewards[uint32(Regions.SOUTHERN_SOUTH_AMERICA)] = 4;\n        regionRewards[uint32(Regions.WEST_ANTARCTICA)] = 2;\n        regionRewards[uint32(Regions.EAST_ANTARCTICA)] = 2;\n        regionRewards[uint32(Regions.WESTERN_EUROPE)] = 10;\n        regionRewards[uint32(Regions.EASTERN_EUROPE)] = 6;\n        regionRewards[uint32(Regions.CENTRAL_RUSSIA)] = 4;\n        regionRewards[uint32(Regions.EASTERN_RUSSIA)] = 3;\n        regionRewards[uint32(Regions.WEST_AFRICA)] = 3;\n        regionRewards[uint32(Regions.MIDDLE_EAST)] = 4;\n        regionRewards[uint32(Regions.EAST_AFRICA)] = 3;\n        regionRewards[uint32(Regions.SOUTH_AFRICA)] = 5;\n        regionRewards[uint32(Regions.INDIA)] = 7;\n        regionRewards[uint32(Regions.EASTERN_CHINA)] = 10;\n        regionRewards[uint32(Regions.SOUTHEAST_ASIA)] = 5;\n        regionRewards[uint32(Regions.WESTERN_AUSTRALIA)] = 4;\n        regionRewards[uint32(Regions.EASTERN_AUSTRALIA)] = 6;\n        regionRewards[uint32(Regions.NEW_ZEALAND)] = 4;\n        regionRewards[uint32(Regions.FIJI)] = 2;\n    }\n\n    /// @notice Reads data using a uint256 to store an array of 8 uint32s\n    /// @param combinedData A uint256 which contains data for 8 uint32s\n    /// @param index Position in array to read\n    /// @return Value at position index\n    function getData32(uint256 combinedData, uint32 index) internal pure returns(uint32) {\n        uint32 offset = index * 32;\n        return uint32((combinedData >> offset) & MASK_32_BITS);\n    }\n\n    /// @notice Writes data using a uint256 to store an array of 8 uint32s\n    /// @param combinedData A uint256 which contains data for 8 uint32s\n    /// @param index Position in array to write\n    /// @param value Value to write at position index.  Value must fit in a uint32.\n    /// @return Updated combined data\n    function setData32(uint256 combinedData, uint32 index, uint32 value) internal pure returns(uint256) {\n        uint32 offset = index * 32;\n        uint256 zeromask = ~(MASK_32_BITS << offset);\n        return (combinedData & zeromask) | (uint256(value) << offset);\n    }\n\n    /// @notice Reads data using a uint256 to store an array of 32 uint8s\n    /// @param combinedData A uint256 which contains data for 32 uint8s\n    /// @param index Position in array to read\n    /// @return Value at position index\n    function getData8(uint256 combinedData, uint32 index) internal pure returns(uint32) {\n        uint32 offset = index * 8;\n        return uint32((combinedData >> offset) & MASK_8_BITS);\n    }\n\n    /// @notice Writes data using a uint256 to store an array of 32 uint8s\n    /// @param combinedData A uint256 which contains data for 32 uint8s\n    /// @param index Position in array to write\n    /// @param value Value to write at position index.  Value must be less than 256.\n    /// @return Updated combined data\n    function setData8(uint256 combinedData, uint32 index, uint32 value) internal pure returns(uint256) {\n        require(value < 256, \"Only 8 bits allowed for value.\");\n        uint32 offset = index * 8;\n        uint256 zeromask = ~(MASK_8_BITS << offset);\n        return (combinedData & zeromask) | (uint256(value) << offset);\n    }\n\n    /// @notice Safe subtraction that returns 0 on underflow.\n    /// @dev We intentially don't assert so as to not block program execution.\n    /// @param _a Value to subtract from\n    /// @param _b Value to subtract\n    /// @return Result of _a - _b\n    function subSafe(uint32 _a, uint32 _b) internal pure returns (uint32) {\n        if (_b <= _a) {\n            uint32 c = _a - _b;\n            return c;\n        }\n\n        return 0;\n    }\n\n    /// @notice Safe addition that returns MAX_UINT32 on overflow\n    /// @dev We intentially don't assert so as to not block program execution.\n    /// @param _a First value to add\n    /// @param _b Second value to add\n    /// @return Result of _a + _b\n    function addSafe(uint32 _a, uint32 _b) internal pure returns (uint32) {\n        uint32 c = _a + _b;\n        if (c >= _a) {\n            return c;\n        }\n\n        return MAX_UINT32;\n    }\n\n    /// @notice Safe multiplication that returns MAX_UINT32 on overflow\n    /// @dev We intentially don't assert so as to not block program execution.\n    /// @param _a First value to multiply\n    /// @param _b Second value to multiply\n    /// @return Result of _a * _b\n    function mulSafe(uint32 _a, uint32 _b) internal pure returns (uint32) {\n        if (_a == 0) {\n            return 0;\n        }\n\n        uint32 c = _a * _b;\n        if (c / _a == _b) {\n            return c;\n        }\n\n        return MAX_UINT32;\n    }\n}\n",
		"sourcePath": "/Users/justinhamilton/ethereum/worldgame/contracts/WorldGame.sol",
		"ast": {
			"absolutePath": "/Users/justinhamilton/ethereum/worldgame/contracts/WorldGame.sol",
			"exportedSymbols": {
				"WorldGame": [
					4288
				]
			},
			"id": 4289,
			"nodeType": "SourceUnit",
			"nodes": [
				{
					"id": 120,
					"literals": [
						"solidity",
						"^",
						"0.4",
						".0"
					],
					"nodeType": "PragmaDirective",
					"src": "0:23:2"
				},
				{
					"baseContracts": [],
					"contractDependencies": [],
					"contractKind": "contract",
					"documentation": "@title World game. Battle to control territory and take over the world. ",
					"fullyImplemented": true,
					"id": 4288,
					"linearizedBaseContracts": [
						4288
					],
					"name": "WorldGame",
					"nodeType": "ContractDefinition",
					"nodes": [
						{
							"constant": true,
							"id": 123,
							"name": "NOT_OWNED",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "188:31:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							},
							"typeName": {
								"id": 121,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "188:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "323535",
								"id": 122,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "216:3:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_255_by_1",
									"typeString": "int_const 255"
								},
								"value": "255"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 126,
							"name": "NO_REGION",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "267:31:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							},
							"typeName": {
								"id": 124,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "267:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "323535",
								"id": 125,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "295:3:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_255_by_1",
									"typeString": "int_const 255"
								},
								"value": "255"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 129,
							"name": "REGION_COUNT",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "333:33:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							},
							"typeName": {
								"id": 127,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "333:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "3235",
								"id": 128,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "364:2:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_25_by_1",
									"typeString": "int_const 25"
								},
								"value": "25"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 132,
							"name": "MAX_NEIGHBORS",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "423:33:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							},
							"typeName": {
								"id": 130,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "423:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "35",
								"id": 131,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "455:1:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_5_by_1",
									"typeString": "int_const 5"
								},
								"value": "5"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 135,
							"name": "MAX_PLAYERS",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "508:31:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							},
							"typeName": {
								"id": 133,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "508:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "38",
								"id": 134,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "538:1:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_8_by_1",
									"typeString": "int_const 8"
								},
								"value": "8"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 138,
							"name": "MAX_ACTIONS_PER_TURN",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "602:40:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							},
							"typeName": {
								"id": 136,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "602:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "38",
								"id": 137,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "641:1:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_8_by_1",
									"typeString": "int_const 8"
								},
								"value": "8"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 141,
							"name": "DEFENDER_ADVANTAGE_NUM",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "698:42:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							},
							"typeName": {
								"id": 139,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "698:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "35",
								"id": 140,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "739:1:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_5_by_1",
									"typeString": "int_const 5"
								},
								"value": "5"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 144,
							"name": "DEFENDER_ADVANTAGE_DENOM",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "799:44:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							},
							"typeName": {
								"id": 142,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "799:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "34",
								"id": 143,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "842:1:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_4_by_1",
									"typeString": "int_const 4"
								},
								"value": "4"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 147,
							"name": "REWARD_BONUS_MULTIPLIER_DENOM",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "897:50:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							},
							"typeName": {
								"id": 145,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "897:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "3230",
								"id": 146,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "945:2:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_20_by_1",
									"typeString": "int_const 20"
								},
								"value": "20"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 150,
							"name": "MAX_BLOCKS_THRESHOLD",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "999:41:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							},
							"typeName": {
								"id": 148,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "999:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "3230",
								"id": 149,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "1038:2:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_20_by_1",
									"typeString": "int_const 20"
								},
								"value": "20"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 153,
							"name": "MASK_32_BITS",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "1095:42:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							},
							"typeName": {
								"id": 151,
								"name": "uint256",
								"nodeType": "ElementaryTypeName",
								"src": "1095:7:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "30786666666666666666",
								"id": 152,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "1127:10:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_4294967295_by_1",
									"typeString": "int_const 4294967295"
								},
								"value": "0xffffffff"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 156,
							"name": "MASK_8_BITS",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "1191:35:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							},
							"typeName": {
								"id": 154,
								"name": "uint256",
								"nodeType": "ElementaryTypeName",
								"src": "1191:7:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "30786666",
								"id": 155,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "1222:4:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_255_by_1",
									"typeString": "int_const 255"
								},
								"value": "0xff"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 159,
							"name": "MAX_UINT32",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "1260:39:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							},
							"typeName": {
								"id": 157,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "1260:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "30786666666666666666",
								"id": 158,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "1289:10:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_4294967295_by_1",
									"typeString": "int_const 4294967295"
								},
								"value": "0xffffffff"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 162,
							"name": "ALL_REGIONS_NOT_OWNED",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "1368:107:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							},
							"typeName": {
								"id": 160,
								"name": "uint256",
								"nodeType": "ElementaryTypeName",
								"src": "1368:7:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "307866666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666",
								"id": 161,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "1409:66:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_115792089237316195423570985008687907853269984665640564039457584007913129639935_by_1",
									"typeString": "int_const 1157...(70 digits omitted)...9935"
								},
								"value": "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 165,
							"name": "BEGIN_SOLDIERS_COUNTS",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "1578:107:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							},
							"typeName": {
								"id": 163,
								"name": "uint256",
								"nodeType": "ElementaryTypeName",
								"src": "1578:7:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "307830303030303031343030303030303134303030303030313430303030303031343030303030303134303030303030313430303030303031343030303030303134",
								"id": 164,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "1619:66:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_539198933468554830630303949770532107640973245947105932686537879715860_by_1",
									"typeString": "int_const 5391...(61 digits omitted)...5860"
								},
								"value": "0x0000001400000014000000140000001400000014000000140000001400000014"
							},
							"visibility": "internal"
						},
						{
							"constant": false,
							"id": 167,
							"name": "owner",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "1747:21:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							},
							"typeName": {
								"id": 166,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "1747:7:2",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"value": null,
							"visibility": "private"
						},
						{
							"constant": false,
							"id": 169,
							"name": "stopped",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "1820:20:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							},
							"typeName": {
								"id": 168,
								"name": "bool",
								"nodeType": "ElementaryTypeName",
								"src": "1820:4:2",
								"typeDescriptions": {
									"typeIdentifier": "t_bool",
									"typeString": "bool"
								}
							},
							"value": null,
							"visibility": "private"
						},
						{
							"constant": false,
							"id": 173,
							"name": "blockHash32Map",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "1891:48:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_uint32_$_t_uint32_$",
								"typeString": "mapping(uint32 => uint32)"
							},
							"typeName": {
								"id": 172,
								"keyType": {
									"id": 170,
									"name": "uint32",
									"nodeType": "ElementaryTypeName",
									"src": "1900:6:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									}
								},
								"nodeType": "Mapping",
								"src": "1891:26:2",
								"typeDescriptions": {
									"typeIdentifier": "t_mapping$_t_uint32_$_t_uint32_$",
									"typeString": "mapping(uint32 => uint32)"
								},
								"valueType": {
									"id": 171,
									"name": "uint32",
									"nodeType": "ElementaryTypeName",
									"src": "1910:6:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									}
								}
							},
							"value": null,
							"visibility": "public"
						},
						{
							"constant": false,
							"id": 179,
							"name": "regionNeighbors",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "2055:58:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
								"typeString": "uint32[5][25]"
							},
							"typeName": {
								"baseType": {
									"baseType": {
										"id": 174,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "2055:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 176,
									"length": {
										"argumentTypes": null,
										"id": 175,
										"name": "MAX_NEIGHBORS",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 132,
										"src": "2062:13:2",
										"typeDescriptions": {
											"typeIdentifier": null,
											"typeString": null
										}
									},
									"nodeType": "ArrayTypeName",
									"src": "2055:21:2",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$5_storage_ptr",
										"typeString": "uint32[5]"
									}
								},
								"id": 178,
								"length": {
									"argumentTypes": null,
									"id": 177,
									"name": "REGION_COUNT",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 129,
									"src": "2077:12:2",
									"typeDescriptions": {
										"typeIdentifier": null,
										"typeString": null
									}
								},
								"nodeType": "ArrayTypeName",
								"src": "2055:35:2",
								"typeDescriptions": {
									"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage_ptr",
									"typeString": "uint32[5][25]"
								}
							},
							"value": null,
							"visibility": "public"
						},
						{
							"constant": false,
							"id": 183,
							"name": "regionRewards",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "2201:41:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_array$_t_uint32_$25_storage",
								"typeString": "uint32[25]"
							},
							"typeName": {
								"baseType": {
									"id": 180,
									"name": "uint32",
									"nodeType": "ElementaryTypeName",
									"src": "2201:6:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									}
								},
								"id": 182,
								"length": {
									"argumentTypes": null,
									"id": 181,
									"name": "REGION_COUNT",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 129,
									"src": "2208:12:2",
									"typeDescriptions": {
										"typeIdentifier": null,
										"typeString": null
									}
								},
								"nodeType": "ArrayTypeName",
								"src": "2201:20:2",
								"typeDescriptions": {
									"typeIdentifier": "t_array$_t_uint32_$25_storage_ptr",
									"typeString": "uint32[25]"
								}
							},
							"value": null,
							"visibility": "public"
						},
						{
							"constant": false,
							"id": 186,
							"name": "gameDataArray",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "2332:31:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
								"typeString": "struct WorldGame.GameData[]"
							},
							"typeName": {
								"baseType": {
									"contractScope": null,
									"id": 184,
									"name": "GameData",
									"nodeType": "UserDefinedTypeName",
									"referencedDeclaration": 245,
									"src": "2332:8:2",
									"typeDescriptions": {
										"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
										"typeString": "struct WorldGame.GameData"
									}
								},
								"id": 185,
								"length": null,
								"nodeType": "ArrayTypeName",
								"src": "2332:10:2",
								"typeDescriptions": {
									"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage_ptr",
									"typeString": "struct WorldGame.GameData[]"
								}
							},
							"value": null,
							"visibility": "public"
						},
						{
							"canonicalName": "WorldGame.Regions",
							"id": 212,
							"members": [
								{
									"id": 187,
									"name": "HAWAII",
									"nodeType": "EnumValue",
									"src": "2441:6:2"
								},
								{
									"id": 188,
									"name": "WESTERN_CANADA",
									"nodeType": "EnumValue",
									"src": "2457:14:2"
								},
								{
									"id": 189,
									"name": "EASTERN_CANADA",
									"nodeType": "EnumValue",
									"src": "2481:14:2"
								},
								{
									"id": 190,
									"name": "WESTERN_USA",
									"nodeType": "EnumValue",
									"src": "2505:11:2"
								},
								{
									"id": 191,
									"name": "EASTERN_USA",
									"nodeType": "EnumValue",
									"src": "2526:11:2"
								},
								{
									"id": 192,
									"name": "GREENLAND",
									"nodeType": "EnumValue",
									"src": "2547:9:2"
								},
								{
									"id": 193,
									"name": "NORTHERN_SOUTH_AMERICA",
									"nodeType": "EnumValue",
									"src": "2566:22:2"
								},
								{
									"id": 194,
									"name": "SOUTHERN_SOUTH_AMERICA",
									"nodeType": "EnumValue",
									"src": "2598:22:2"
								},
								{
									"id": 195,
									"name": "WEST_ANTARCTICA",
									"nodeType": "EnumValue",
									"src": "2630:15:2"
								},
								{
									"id": 196,
									"name": "EAST_ANTARCTICA",
									"nodeType": "EnumValue",
									"src": "2655:15:2"
								},
								{
									"id": 197,
									"name": "WESTERN_EUROPE",
									"nodeType": "EnumValue",
									"src": "2680:14:2"
								},
								{
									"id": 198,
									"name": "EASTERN_EUROPE",
									"nodeType": "EnumValue",
									"src": "2704:14:2"
								},
								{
									"id": 199,
									"name": "CENTRAL_RUSSIA",
									"nodeType": "EnumValue",
									"src": "2728:14:2"
								},
								{
									"id": 200,
									"name": "EASTERN_RUSSIA",
									"nodeType": "EnumValue",
									"src": "2752:14:2"
								},
								{
									"id": 201,
									"name": "WEST_AFRICA",
									"nodeType": "EnumValue",
									"src": "2776:11:2"
								},
								{
									"id": 202,
									"name": "MIDDLE_EAST",
									"nodeType": "EnumValue",
									"src": "2797:11:2"
								},
								{
									"id": 203,
									"name": "EAST_AFRICA",
									"nodeType": "EnumValue",
									"src": "2818:11:2"
								},
								{
									"id": 204,
									"name": "SOUTH_AFRICA",
									"nodeType": "EnumValue",
									"src": "2839:12:2"
								},
								{
									"id": 205,
									"name": "INDIA",
									"nodeType": "EnumValue",
									"src": "2861:5:2"
								},
								{
									"id": 206,
									"name": "EASTERN_CHINA",
									"nodeType": "EnumValue",
									"src": "2876:13:2"
								},
								{
									"id": 207,
									"name": "SOUTHEAST_ASIA",
									"nodeType": "EnumValue",
									"src": "2899:14:2"
								},
								{
									"id": 208,
									"name": "WESTERN_AUSTRALIA",
									"nodeType": "EnumValue",
									"src": "2923:17:2"
								},
								{
									"id": 209,
									"name": "EASTERN_AUSTRALIA",
									"nodeType": "EnumValue",
									"src": "2950:17:2"
								},
								{
									"id": 210,
									"name": "NEW_ZEALAND",
									"nodeType": "EnumValue",
									"src": "2977:11:2"
								},
								{
									"id": 211,
									"name": "FIJI",
									"nodeType": "EnumValue",
									"src": "2998:4:2"
								}
							],
							"name": "Regions",
							"nodeType": "EnumDefinition",
							"src": "2418:590:2"
						},
						{
							"canonicalName": "WorldGame.GameData",
							"id": 245,
							"members": [
								{
									"constant": false,
									"id": 214,
									"name": "turnTeamId",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "3124:17:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 213,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "3124:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 216,
									"name": "turnNum",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "3201:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 215,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "3201:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 218,
									"name": "maxBlocksPerTurn",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "3276:23:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 217,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "3276:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 220,
									"name": "playerCount",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "3356:18:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 219,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "3356:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 224,
									"name": "playerAddresses",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "3423:36:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_address_$8_storage_ptr",
										"typeString": "address[8]"
									},
									"typeName": {
										"baseType": {
											"id": 221,
											"name": "address",
											"nodeType": "ElementaryTypeName",
											"src": "3423:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"id": 223,
										"length": {
											"argumentTypes": null,
											"id": 222,
											"name": "MAX_PLAYERS",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 135,
											"src": "3431:11:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "3423:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_address_$8_storage_ptr",
											"typeString": "address[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 226,
									"name": "undeployedSoldiers",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "3552:26:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 225,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "3552:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 228,
									"name": "regionOwners",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "3638:20:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 227,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "3638:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 232,
									"name": "regionSoldiers",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "3727:35:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$25_storage_ptr",
										"typeString": "uint32[25]"
									},
									"typeName": {
										"baseType": {
											"id": 229,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "3727:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 231,
										"length": {
											"argumentTypes": null,
											"id": 230,
											"name": "REGION_COUNT",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 129,
											"src": "3734:12:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "3727:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$25_storage_ptr",
											"typeString": "uint32[25]"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 234,
									"name": "actionCount",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "3822:18:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 233,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "3822:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 236,
									"name": "fromRegionList",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "3923:22:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 235,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "3923:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 238,
									"name": "toRegionList",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "4027:20:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 237,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "4027:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 240,
									"name": "moveSoldierCountList",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "4121:28:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 239,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "4121:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 242,
									"name": "submitBlockList",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "4235:23:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 241,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "4235:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 244,
									"name": "teamAvatars",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "4313:18:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes8",
										"typeString": "bytes8"
									},
									"typeName": {
										"id": 243,
										"name": "bytes8",
										"nodeType": "ElementaryTypeName",
										"src": "4313:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes8",
											"typeString": "bytes8"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"name": "GameData",
							"nodeType": "StructDefinition",
							"scope": 4288,
							"src": "3053:1285:2",
							"visibility": "public"
						},
						{
							"anonymous": false,
							"documentation": null,
							"id": 253,
							"name": "NewGame",
							"nodeType": "EventDefinition",
							"parameters": {
								"id": 252,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 247,
										"indexed": false,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 253,
										"src": "4418:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 246,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "4418:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 249,
										"indexed": false,
										"name": "turnNum",
										"nodeType": "VariableDeclaration",
										"scope": 253,
										"src": "4434:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 248,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "4434:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 251,
										"indexed": false,
										"name": "teamAvatars",
										"nodeType": "VariableDeclaration",
										"scope": 253,
										"src": "4450:18:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes8",
											"typeString": "bytes8"
										},
										"typeName": {
											"id": 250,
											"name": "bytes8",
											"nodeType": "ElementaryTypeName",
											"src": "4450:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes8",
												"typeString": "bytes8"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "4417:52:2"
							},
							"src": "4404:66:2"
						},
						{
							"anonymous": false,
							"documentation": null,
							"id": 261,
							"name": "NextTurn",
							"nodeType": "EventDefinition",
							"parameters": {
								"id": 260,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 255,
										"indexed": false,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 261,
										"src": "4541:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 254,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "4541:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 257,
										"indexed": false,
										"name": "turnNum",
										"nodeType": "VariableDeclaration",
										"scope": 261,
										"src": "4557:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 256,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "4557:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 259,
										"indexed": false,
										"name": "nextTeamId",
										"nodeType": "VariableDeclaration",
										"scope": 261,
										"src": "4573:17:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 258,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "4573:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "4540:51:2"
							},
							"src": "4526:66:2"
						},
						{
							"anonymous": false,
							"documentation": null,
							"id": 267,
							"name": "Winner",
							"nodeType": "EventDefinition",
							"parameters": {
								"id": 266,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 263,
										"indexed": false,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 267,
										"src": "4656:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 262,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "4656:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 265,
										"indexed": false,
										"name": "winningTeamId",
										"nodeType": "VariableDeclaration",
										"scope": 267,
										"src": "4672:20:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 264,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "4672:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "4655:38:2"
							},
							"src": "4643:51:2"
						},
						{
							"body": {
								"id": 300,
								"nodeType": "Block",
								"src": "4837:377:2",
								"statements": [
									{
										"assignments": [
											274
										],
										"declarations": [
											{
												"constant": false,
												"id": 274,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 301,
												"src": "4847:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 273,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "4847:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 278,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 275,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "4871:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 277,
											"indexExpression": {
												"argumentTypes": null,
												"id": 276,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 269,
												"src": "4885:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "4871:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "4847:45:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													},
													"id": 287,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 280,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4372,
															"src": "4973:3:2",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 281,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "sender",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "4973:10:2",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 282,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 274,
																"src": "4987:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 283,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "playerAddresses",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 224,
															"src": "4987:20:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_address_$8_storage",
																"typeString": "address[8] storage ref"
															}
														},
														"id": 286,
														"indexExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 284,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 274,
																"src": "5008:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 285,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "turnTeamId",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 214,
															"src": "5008:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "4987:37:2",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"src": "4973:51:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "53656e646572206e6f7420617574686f72697a65642e",
													"id": 288,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "5039:24:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_fecfa93da3bfbc5d9ecf62a2ecd3bca847c5dad14f588ad8fef4719729dd5f22",
														"typeString": "literal_string \"Sender not authorized.\""
													},
													"value": "Sender not authorized."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_fecfa93da3bfbc5d9ecf62a2ecd3bca847c5dad14f588ad8fef4719729dd5f22",
														"typeString": "literal_string \"Sender not authorized.\""
													}
												],
												"id": 279,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "4952:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 289,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "4952:121:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 290,
										"nodeType": "ExpressionStatement",
										"src": "4952:121:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 295,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 292,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 274,
															"src": "5149:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 293,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "turnNum",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 216,
														"src": "5149:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"id": 294,
														"name": "turnNum",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 271,
														"src": "5165:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "5149:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "57726f6e67207475726e206e756d6265722e",
													"id": 296,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "5174:20:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_20e508097488cdf7adfa5bc3dc0f21225c46901f081af1aafe3b036f12f6c46b",
														"typeString": "literal_string \"Wrong turn number.\""
													},
													"value": "Wrong turn number."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_20e508097488cdf7adfa5bc3dc0f21225c46901f081af1aafe3b036f12f6c46b",
														"typeString": "literal_string \"Wrong turn number.\""
													}
												],
												"id": 291,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "5141:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 297,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "5141:54:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 298,
										"nodeType": "ExpressionStatement",
										"src": "5141:54:2"
									},
									{
										"id": 299,
										"nodeType": "PlaceholderStatement",
										"src": "5206:1:2"
									}
								]
							},
							"documentation": null,
							"id": 301,
							"name": "onlyIfPlayersTurn",
							"nodeType": "ModifierDefinition",
							"parameters": {
								"id": 272,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 269,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 301,
										"src": "4805:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 268,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "4805:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 271,
										"name": "turnNum",
										"nodeType": "VariableDeclaration",
										"scope": 301,
										"src": "4821:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 270,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "4821:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "4804:32:2"
							},
							"src": "4778:436:2",
							"visibility": "internal"
						},
						{
							"body": {
								"id": 379,
								"nodeType": "Block",
								"src": "5324:623:2",
								"statements": [
									{
										"assignments": [
											306
										],
										"declarations": [
											{
												"constant": false,
												"id": 306,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 380,
												"src": "5334:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 305,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "5334:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 310,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 307,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "5358:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 309,
											"indexExpression": {
												"argumentTypes": null,
												"id": 308,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 303,
												"src": "5372:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "5358:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "5334:45:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 374,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"id": 366,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"id": 358,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																},
																"id": 350,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	},
																	"id": 342,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		},
																		"id": 334,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"commonType": {
																				"typeIdentifier": "t_bool",
																				"typeString": "bool"
																			},
																			"id": 326,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"leftExpression": {
																				"argumentTypes": null,
																				"commonType": {
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				},
																				"id": 318,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": false,
																				"lValueRequested": false,
																				"leftExpression": {
																					"argumentTypes": null,
																					"expression": {
																						"argumentTypes": null,
																						"id": 312,
																						"name": "msg",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 4372,
																						"src": "5464:3:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_magic_message",
																							"typeString": "msg"
																						}
																					},
																					"id": 313,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"lValueRequested": false,
																					"memberName": "sender",
																					"nodeType": "MemberAccess",
																					"referencedDeclaration": null,
																					"src": "5464:10:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_address",
																						"typeString": "address"
																					}
																				},
																				"nodeType": "BinaryOperation",
																				"operator": "==",
																				"rightExpression": {
																					"argumentTypes": null,
																					"baseExpression": {
																						"argumentTypes": null,
																						"expression": {
																							"argumentTypes": null,
																							"id": 314,
																							"name": "game",
																							"nodeType": "Identifier",
																							"overloadedDeclarations": [],
																							"referencedDeclaration": 306,
																							"src": "5478:4:2",
																							"typeDescriptions": {
																								"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																								"typeString": "struct WorldGame.GameData storage pointer"
																							}
																						},
																						"id": 315,
																						"isConstant": false,
																						"isLValue": true,
																						"isPure": false,
																						"lValueRequested": false,
																						"memberName": "playerAddresses",
																						"nodeType": "MemberAccess",
																						"referencedDeclaration": 224,
																						"src": "5478:20:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_array$_t_address_$8_storage",
																							"typeString": "address[8] storage ref"
																						}
																					},
																					"id": 317,
																					"indexExpression": {
																						"argumentTypes": null,
																						"hexValue": "30",
																						"id": 316,
																						"isConstant": false,
																						"isLValue": false,
																						"isPure": true,
																						"kind": "number",
																						"lValueRequested": false,
																						"nodeType": "Literal",
																						"src": "5499:1:2",
																						"subdenomination": null,
																						"typeDescriptions": {
																							"typeIdentifier": "t_rational_0_by_1",
																							"typeString": "int_const 0"
																						},
																						"value": "0"
																					},
																					"isConstant": false,
																					"isLValue": true,
																					"isPure": false,
																					"lValueRequested": false,
																					"nodeType": "IndexAccess",
																					"src": "5478:23:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_address",
																						"typeString": "address"
																					}
																				},
																				"src": "5464:37:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_bool",
																					"typeString": "bool"
																				}
																			},
																			"nodeType": "BinaryOperation",
																			"operator": "||",
																			"rightExpression": {
																				"argumentTypes": null,
																				"commonType": {
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				},
																				"id": 325,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": false,
																				"lValueRequested": false,
																				"leftExpression": {
																					"argumentTypes": null,
																					"expression": {
																						"argumentTypes": null,
																						"id": 319,
																						"name": "msg",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 4372,
																						"src": "5518:3:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_magic_message",
																							"typeString": "msg"
																						}
																					},
																					"id": 320,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"lValueRequested": false,
																					"memberName": "sender",
																					"nodeType": "MemberAccess",
																					"referencedDeclaration": null,
																					"src": "5518:10:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_address",
																						"typeString": "address"
																					}
																				},
																				"nodeType": "BinaryOperation",
																				"operator": "==",
																				"rightExpression": {
																					"argumentTypes": null,
																					"baseExpression": {
																						"argumentTypes": null,
																						"expression": {
																							"argumentTypes": null,
																							"id": 321,
																							"name": "game",
																							"nodeType": "Identifier",
																							"overloadedDeclarations": [],
																							"referencedDeclaration": 306,
																							"src": "5532:4:2",
																							"typeDescriptions": {
																								"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																								"typeString": "struct WorldGame.GameData storage pointer"
																							}
																						},
																						"id": 322,
																						"isConstant": false,
																						"isLValue": true,
																						"isPure": false,
																						"lValueRequested": false,
																						"memberName": "playerAddresses",
																						"nodeType": "MemberAccess",
																						"referencedDeclaration": 224,
																						"src": "5532:20:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_array$_t_address_$8_storage",
																							"typeString": "address[8] storage ref"
																						}
																					},
																					"id": 324,
																					"indexExpression": {
																						"argumentTypes": null,
																						"hexValue": "31",
																						"id": 323,
																						"isConstant": false,
																						"isLValue": false,
																						"isPure": true,
																						"kind": "number",
																						"lValueRequested": false,
																						"nodeType": "Literal",
																						"src": "5553:1:2",
																						"subdenomination": null,
																						"typeDescriptions": {
																							"typeIdentifier": "t_rational_1_by_1",
																							"typeString": "int_const 1"
																						},
																						"value": "1"
																					},
																					"isConstant": false,
																					"isLValue": true,
																					"isPure": false,
																					"lValueRequested": false,
																					"nodeType": "IndexAccess",
																					"src": "5532:23:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_address",
																						"typeString": "address"
																					}
																				},
																				"src": "5518:37:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_bool",
																					"typeString": "bool"
																				}
																			},
																			"src": "5464:91:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_bool",
																				"typeString": "bool"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "||",
																		"rightExpression": {
																			"argumentTypes": null,
																			"commonType": {
																				"typeIdentifier": "t_address",
																				"typeString": "address"
																			},
																			"id": 333,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"leftExpression": {
																				"argumentTypes": null,
																				"expression": {
																					"argumentTypes": null,
																					"id": 327,
																					"name": "msg",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 4372,
																					"src": "5572:3:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_magic_message",
																						"typeString": "msg"
																					}
																				},
																				"id": 328,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": false,
																				"lValueRequested": false,
																				"memberName": "sender",
																				"nodeType": "MemberAccess",
																				"referencedDeclaration": null,
																				"src": "5572:10:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				}
																			},
																			"nodeType": "BinaryOperation",
																			"operator": "==",
																			"rightExpression": {
																				"argumentTypes": null,
																				"baseExpression": {
																					"argumentTypes": null,
																					"expression": {
																						"argumentTypes": null,
																						"id": 329,
																						"name": "game",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 306,
																						"src": "5586:4:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																							"typeString": "struct WorldGame.GameData storage pointer"
																						}
																					},
																					"id": 330,
																					"isConstant": false,
																					"isLValue": true,
																					"isPure": false,
																					"lValueRequested": false,
																					"memberName": "playerAddresses",
																					"nodeType": "MemberAccess",
																					"referencedDeclaration": 224,
																					"src": "5586:20:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_array$_t_address_$8_storage",
																						"typeString": "address[8] storage ref"
																					}
																				},
																				"id": 332,
																				"indexExpression": {
																					"argumentTypes": null,
																					"hexValue": "32",
																					"id": 331,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": true,
																					"kind": "number",
																					"lValueRequested": false,
																					"nodeType": "Literal",
																					"src": "5607:1:2",
																					"subdenomination": null,
																					"typeDescriptions": {
																						"typeIdentifier": "t_rational_2_by_1",
																						"typeString": "int_const 2"
																					},
																					"value": "2"
																				},
																				"isConstant": false,
																				"isLValue": true,
																				"isPure": false,
																				"lValueRequested": false,
																				"nodeType": "IndexAccess",
																				"src": "5586:23:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				}
																			},
																			"src": "5572:37:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_bool",
																				"typeString": "bool"
																			}
																		},
																		"src": "5464:145:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "||",
																	"rightExpression": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_address",
																			"typeString": "address"
																		},
																		"id": 341,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"expression": {
																				"argumentTypes": null,
																				"id": 335,
																				"name": "msg",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 4372,
																				"src": "5626:3:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_magic_message",
																					"typeString": "msg"
																				}
																			},
																			"id": 336,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"memberName": "sender",
																			"nodeType": "MemberAccess",
																			"referencedDeclaration": null,
																			"src": "5626:10:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_address",
																				"typeString": "address"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "==",
																		"rightExpression": {
																			"argumentTypes": null,
																			"baseExpression": {
																				"argumentTypes": null,
																				"expression": {
																					"argumentTypes": null,
																					"id": 337,
																					"name": "game",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 306,
																					"src": "5640:4:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																						"typeString": "struct WorldGame.GameData storage pointer"
																					}
																				},
																				"id": 338,
																				"isConstant": false,
																				"isLValue": true,
																				"isPure": false,
																				"lValueRequested": false,
																				"memberName": "playerAddresses",
																				"nodeType": "MemberAccess",
																				"referencedDeclaration": 224,
																				"src": "5640:20:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_array$_t_address_$8_storage",
																					"typeString": "address[8] storage ref"
																				}
																			},
																			"id": 340,
																			"indexExpression": {
																				"argumentTypes": null,
																				"hexValue": "33",
																				"id": 339,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "5661:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_3_by_1",
																					"typeString": "int_const 3"
																				},
																				"value": "3"
																			},
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"nodeType": "IndexAccess",
																			"src": "5640:23:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_address",
																				"typeString": "address"
																			}
																		},
																		"src": "5626:37:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	},
																	"src": "5464:199:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "||",
																"rightExpression": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_address",
																		"typeString": "address"
																	},
																	"id": 349,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 343,
																			"name": "msg",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 4372,
																			"src": "5680:3:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_magic_message",
																				"typeString": "msg"
																			}
																		},
																		"id": 344,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "sender",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": null,
																		"src": "5680:10:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_address",
																			"typeString": "address"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "==",
																	"rightExpression": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"expression": {
																				"argumentTypes": null,
																				"id": 345,
																				"name": "game",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 306,
																				"src": "5694:4:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																					"typeString": "struct WorldGame.GameData storage pointer"
																				}
																			},
																			"id": 346,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"memberName": "playerAddresses",
																			"nodeType": "MemberAccess",
																			"referencedDeclaration": 224,
																			"src": "5694:20:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_address_$8_storage",
																				"typeString": "address[8] storage ref"
																			}
																		},
																		"id": 348,
																		"indexExpression": {
																			"argumentTypes": null,
																			"hexValue": "34",
																			"id": 347,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "5715:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_4_by_1",
																				"typeString": "int_const 4"
																			},
																			"value": "4"
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"nodeType": "IndexAccess",
																		"src": "5694:23:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_address",
																			"typeString": "address"
																		}
																	},
																	"src": "5680:37:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"src": "5464:253:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "||",
															"rightExpression": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																"id": 357,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 351,
																		"name": "msg",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 4372,
																		"src": "5734:3:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_magic_message",
																			"typeString": "msg"
																		}
																	},
																	"id": 352,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "sender",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": null,
																	"src": "5734:10:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_address",
																		"typeString": "address"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "==",
																"rightExpression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 353,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 306,
																			"src": "5748:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 354,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "playerAddresses",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 224,
																		"src": "5748:20:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_address_$8_storage",
																			"typeString": "address[8] storage ref"
																		}
																	},
																	"id": 356,
																	"indexExpression": {
																		"argumentTypes": null,
																		"hexValue": "35",
																		"id": 355,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "5769:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_5_by_1",
																			"typeString": "int_const 5"
																		},
																		"value": "5"
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "5748:23:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_address",
																		"typeString": "address"
																	}
																},
																"src": "5734:37:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"src": "5464:307:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "||",
														"rightExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															},
															"id": 365,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 359,
																	"name": "msg",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4372,
																	"src": "5788:3:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_magic_message",
																		"typeString": "msg"
																	}
																},
																"id": 360,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "sender",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "5788:10:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "==",
															"rightExpression": {
																"argumentTypes": null,
																"baseExpression": {
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 361,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 306,
																		"src": "5802:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 362,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "playerAddresses",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 224,
																	"src": "5802:20:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_array$_t_address_$8_storage",
																		"typeString": "address[8] storage ref"
																	}
																},
																"id": 364,
																"indexExpression": {
																	"argumentTypes": null,
																	"hexValue": "36",
																	"id": 363,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "5823:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_6_by_1",
																		"typeString": "int_const 6"
																	},
																	"value": "6"
																},
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "IndexAccess",
																"src": "5802:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																}
															},
															"src": "5788:37:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"src": "5464:361:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "||",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														},
														"id": 373,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 367,
																"name": "msg",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4372,
																"src": "5842:3:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_message",
																	"typeString": "msg"
																}
															},
															"id": 368,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "sender",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "5842:10:2",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 369,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 306,
																	"src": "5856:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 370,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "playerAddresses",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 224,
																"src": "5856:20:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_address_$8_storage",
																	"typeString": "address[8] storage ref"
																}
															},
															"id": 372,
															"indexExpression": {
																"argumentTypes": null,
																"hexValue": "37",
																"id": 371,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "5877:1:2",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_7_by_1",
																	"typeString": "int_const 7"
																},
																"value": "7"
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "5856:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"src": "5842:37:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "5464:415:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "53656e646572206e6f7420617574686f72697a65642e",
													"id": 375,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "5894:24:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_fecfa93da3bfbc5d9ecf62a2ecd3bca847c5dad14f588ad8fef4719729dd5f22",
														"typeString": "literal_string \"Sender not authorized.\""
													},
													"value": "Sender not authorized."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_fecfa93da3bfbc5d9ecf62a2ecd3bca847c5dad14f588ad8fef4719729dd5f22",
														"typeString": "literal_string \"Sender not authorized.\""
													}
												],
												"id": 311,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "5443:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 376,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "5443:485:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 377,
										"nodeType": "ExpressionStatement",
										"src": "5443:485:2"
									},
									{
										"id": 378,
										"nodeType": "PlaceholderStatement",
										"src": "5939:1:2"
									}
								]
							},
							"documentation": null,
							"id": 380,
							"name": "onlyPlayers",
							"nodeType": "ModifierDefinition",
							"parameters": {
								"id": 304,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 303,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 380,
										"src": "5308:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 302,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "5308:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "5307:16:2"
							},
							"src": "5287:660:2",
							"visibility": "internal"
						},
						{
							"body": {
								"id": 441,
								"nodeType": "Block",
								"src": "6098:610:2",
								"statements": [
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 393,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 389,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 387,
															"name": "regionFrom",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 382,
															"src": "6153:10:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "<",
														"rightExpression": {
															"argumentTypes": null,
															"id": 388,
															"name": "REGION_COUNT",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 129,
															"src": "6166:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "6153:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "&&",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 392,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 390,
															"name": "regionTo",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 384,
															"src": "6182:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "<",
														"rightExpression": {
															"argumentTypes": null,
															"id": 391,
															"name": "REGION_COUNT",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 129,
															"src": "6193:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "6182:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "6153:52:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "4d7573742062652076616c696420726567696f6e73",
													"id": 394,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "6207:23:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_351e10a4a8ce9dc50b4687ddaeb98edc1974c79c38c195ffb6987b31581cf2be",
														"typeString": "literal_string \"Must be valid regions\""
													},
													"value": "Must be valid regions"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_351e10a4a8ce9dc50b4687ddaeb98edc1974c79c38c195ffb6987b31581cf2be",
														"typeString": "literal_string \"Must be valid regions\""
													}
												],
												"id": 386,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "6145:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 395,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "6145:86:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 396,
										"nodeType": "ExpressionStatement",
										"src": "6145:86:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 436,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"id": 428,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"id": 420,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																},
																"id": 412,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 404,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"baseExpression": {
																				"argumentTypes": null,
																				"id": 398,
																				"name": "regionNeighbors",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 179,
																				"src": "6330:15:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
																					"typeString": "uint32[5] storage ref[25] storage ref"
																				}
																			},
																			"id": 400,
																			"indexExpression": {
																				"argumentTypes": null,
																				"id": 399,
																				"name": "regionFrom",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 382,
																				"src": "6346:10:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"nodeType": "IndexAccess",
																			"src": "6330:27:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_uint32_$5_storage",
																				"typeString": "uint32[5] storage ref"
																			}
																		},
																		"id": 402,
																		"indexExpression": {
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 401,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "6358:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"nodeType": "IndexAccess",
																		"src": "6330:30:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "==",
																	"rightExpression": {
																		"argumentTypes": null,
																		"id": 403,
																		"name": "regionTo",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 384,
																		"src": "6364:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "6330:42:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "||",
																"rightExpression": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 411,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"baseExpression": {
																				"argumentTypes": null,
																				"id": 405,
																				"name": "regionNeighbors",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 179,
																				"src": "6389:15:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
																					"typeString": "uint32[5] storage ref[25] storage ref"
																				}
																			},
																			"id": 407,
																			"indexExpression": {
																				"argumentTypes": null,
																				"id": 406,
																				"name": "regionFrom",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 382,
																				"src": "6405:10:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"nodeType": "IndexAccess",
																			"src": "6389:27:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_uint32_$5_storage",
																				"typeString": "uint32[5] storage ref"
																			}
																		},
																		"id": 409,
																		"indexExpression": {
																			"argumentTypes": null,
																			"hexValue": "31",
																			"id": 408,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "6417:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_1_by_1",
																				"typeString": "int_const 1"
																			},
																			"value": "1"
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"nodeType": "IndexAccess",
																		"src": "6389:30:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "==",
																	"rightExpression": {
																		"argumentTypes": null,
																		"id": 410,
																		"name": "regionTo",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 384,
																		"src": "6423:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "6389:42:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"src": "6330:101:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "||",
															"rightExpression": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 419,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"id": 413,
																			"name": "regionNeighbors",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 179,
																			"src": "6448:15:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
																				"typeString": "uint32[5] storage ref[25] storage ref"
																			}
																		},
																		"id": 415,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 414,
																			"name": "regionFrom",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 382,
																			"src": "6464:10:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"nodeType": "IndexAccess",
																		"src": "6448:27:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_uint32_$5_storage",
																			"typeString": "uint32[5] storage ref"
																		}
																	},
																	"id": 417,
																	"indexExpression": {
																		"argumentTypes": null,
																		"hexValue": "32",
																		"id": 416,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "6476:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_2_by_1",
																			"typeString": "int_const 2"
																		},
																		"value": "2"
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "6448:30:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "==",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 418,
																	"name": "regionTo",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 384,
																	"src": "6482:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "6448:42:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"src": "6330:160:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "||",
														"rightExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 427,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"baseExpression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 421,
																		"name": "regionNeighbors",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 179,
																		"src": "6507:15:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
																			"typeString": "uint32[5] storage ref[25] storage ref"
																		}
																	},
																	"id": 423,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 422,
																		"name": "regionFrom",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 382,
																		"src": "6523:10:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "6507:27:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_array$_t_uint32_$5_storage",
																		"typeString": "uint32[5] storage ref"
																	}
																},
																"id": 425,
																"indexExpression": {
																	"argumentTypes": null,
																	"hexValue": "33",
																	"id": 424,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "6535:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_3_by_1",
																		"typeString": "int_const 3"
																	},
																	"value": "3"
																},
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "IndexAccess",
																"src": "6507:30:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "==",
															"rightExpression": {
																"argumentTypes": null,
																"id": 426,
																"name": "regionTo",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 384,
																"src": "6541:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "6507:42:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"src": "6330:219:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "||",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 435,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"baseExpression": {
																	"argumentTypes": null,
																	"id": 429,
																	"name": "regionNeighbors",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 179,
																	"src": "6566:15:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
																		"typeString": "uint32[5] storage ref[25] storage ref"
																	}
																},
																"id": 431,
																"indexExpression": {
																	"argumentTypes": null,
																	"id": 430,
																	"name": "regionFrom",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 382,
																	"src": "6582:10:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "IndexAccess",
																"src": "6566:27:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$5_storage",
																	"typeString": "uint32[5] storage ref"
																}
															},
															"id": 433,
															"indexExpression": {
																"argumentTypes": null,
																"hexValue": "34",
																"id": 432,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "6594:1:2",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_4_by_1",
																	"typeString": "int_const 4"
																},
																"value": "4"
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "6566:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"id": 434,
															"name": "regionTo",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 384,
															"src": "6600:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "6566:42:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "6330:278:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "526567696f6e73206d757374206265206e65696768626f727320696e206f7264657220746f206d6f7665206265747765656e207468656d",
													"id": 437,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "6622:57:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_dd170a6e7613547202242bfeea5b51fbbf149a248552a23a442afe848c942fba",
														"typeString": "literal_string \"Regions must be neighbors in order to move between them\""
													},
													"value": "Regions must be neighbors in order to move between them"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_dd170a6e7613547202242bfeea5b51fbbf149a248552a23a442afe848c942fba",
														"typeString": "literal_string \"Regions must be neighbors in order to move between them\""
													}
												],
												"id": 397,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "6309:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 438,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "6309:380:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 439,
										"nodeType": "ExpressionStatement",
										"src": "6309:380:2"
									},
									{
										"id": 440,
										"nodeType": "PlaceholderStatement",
										"src": "6700:1:2"
									}
								]
							},
							"documentation": null,
							"id": 442,
							"name": "onlyNeighbors",
							"nodeType": "ModifierDefinition",
							"parameters": {
								"id": 385,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 382,
										"name": "regionFrom",
										"nodeType": "VariableDeclaration",
										"scope": 442,
										"src": "6062:17:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 381,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "6062:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 384,
										"name": "regionTo",
										"nodeType": "VariableDeclaration",
										"scope": 442,
										"src": "6081:15:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 383,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "6081:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "6061:36:2"
							},
							"src": "6039:669:2",
							"visibility": "internal"
						},
						{
							"body": {
								"id": 453,
								"nodeType": "Block",
								"src": "6793:95:2",
								"statements": [
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													},
													"id": 448,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 445,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4372,
															"src": "6811:3:2",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 446,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "sender",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "6811:10:2",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"id": 447,
														"name": "owner",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 167,
														"src": "6825:5:2",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"src": "6811:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "4f6e6c79206f776e65722063616e2063616c6c20746869732066756e6374696f6e2e",
													"id": 449,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "6832:36:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_0fcea41e877c4f84237ea6b9061acc9b3fc97555de5ba31615eb7b8cf7110239",
														"typeString": "literal_string \"Only owner can call this function.\""
													},
													"value": "Only owner can call this function."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_0fcea41e877c4f84237ea6b9061acc9b3fc97555de5ba31615eb7b8cf7110239",
														"typeString": "literal_string \"Only owner can call this function.\""
													}
												],
												"id": 444,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "6803:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 450,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "6803:66:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 451,
										"nodeType": "ExpressionStatement",
										"src": "6803:66:2"
									},
									{
										"id": 452,
										"nodeType": "PlaceholderStatement",
										"src": "6880:1:2"
									}
								]
							},
							"documentation": null,
							"id": 454,
							"name": "isOwner",
							"nodeType": "ModifierDefinition",
							"parameters": {
								"id": 443,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "6790:2:2"
							},
							"src": "6774:114:2",
							"visibility": "internal"
						},
						{
							"body": {
								"id": 464,
								"nodeType": "Block",
								"src": "6982:83:2",
								"statements": [
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 459,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 457,
														"name": "stopped",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 169,
														"src": "7000:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "66616c7365",
														"id": 458,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "bool",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "7011:5:2",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"value": "false"
													},
													"src": "7000:16:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "53746f707065642064756520746f20656d657267656e63792e",
													"id": 460,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "7018:27:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_bc72763c55e911df61bed4f8abc18c7a42a2a3aedfe3e2e2d746c483b2855302",
														"typeString": "literal_string \"Stopped due to emergency.\""
													},
													"value": "Stopped due to emergency."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_bc72763c55e911df61bed4f8abc18c7a42a2a3aedfe3e2e2d746c483b2855302",
														"typeString": "literal_string \"Stopped due to emergency.\""
													}
												],
												"id": 456,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "6992:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 461,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "6992:54:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 462,
										"nodeType": "ExpressionStatement",
										"src": "6992:54:2"
									},
									{
										"id": 463,
										"nodeType": "PlaceholderStatement",
										"src": "7057:1:2"
									}
								]
							},
							"documentation": null,
							"id": 465,
							"name": "stopInEmergency",
							"nodeType": "ModifierDefinition",
							"parameters": {
								"id": 455,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "6979:2:2"
							},
							"src": "6955:110:2",
							"visibility": "internal"
						},
						{
							"body": {
								"id": 479,
								"nodeType": "Block",
								"src": "7153:95:2",
								"statements": [
									{
										"expression": {
											"argumentTypes": null,
											"id": 471,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"id": 468,
												"name": "owner",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 167,
												"src": "7163:5:2",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 469,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4372,
													"src": "7171:3:2",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 470,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "7171:10:2",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"src": "7163:18:2",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"id": 472,
										"nodeType": "ExpressionStatement",
										"src": "7163:18:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [],
											"expression": {
												"argumentTypes": [],
												"id": 473,
												"name": "initRegionNeighbors",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 3841,
												"src": "7191:19:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_nonpayable$__$returns$__$",
													"typeString": "function ()"
												}
											},
											"id": 474,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "7191:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 475,
										"nodeType": "ExpressionStatement",
										"src": "7191:21:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [],
											"expression": {
												"argumentTypes": [],
												"id": 476,
												"name": "initRegionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4070,
												"src": "7222:17:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_nonpayable$__$returns$__$",
													"typeString": "function ()"
												}
											},
											"id": 477,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "7222:19:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 478,
										"nodeType": "ExpressionStatement",
										"src": "7222:19:2"
									}
								]
							},
							"documentation": null,
							"id": 480,
							"implemented": true,
							"isConstructor": true,
							"isDeclaredConst": false,
							"modifiers": [],
							"name": "",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 466,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "7143:2:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 467,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "7153:0:2"
							},
							"scope": 4288,
							"src": "7132:116:2",
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 487,
								"nodeType": "Block",
								"src": "7359:57:2",
								"statements": [
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "496e76616c69642063616c6c20746f2067616d6520636f6e74726163742e",
													"id": 484,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "7376:32:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_0999c503c462f0fbf489a8c62dc28f53cf7245a2e9460e5005042ac0654e4198",
														"typeString": "literal_string \"Invalid call to game contract.\""
													},
													"value": "Invalid call to game contract."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_stringliteral_0999c503c462f0fbf489a8c62dc28f53cf7245a2e9460e5005042ac0654e4198",
														"typeString": "literal_string \"Invalid call to game contract.\""
													}
												],
												"id": 483,
												"name": "revert",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4377,
													4378
												],
												"referencedDeclaration": 4378,
												"src": "7369:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_revert_pure$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (string memory) pure"
												}
											},
											"id": 485,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "7369:40:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 486,
										"nodeType": "ExpressionStatement",
										"src": "7369:40:2"
									}
								]
							},
							"documentation": null,
							"id": 488,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": false,
							"modifiers": [],
							"name": "",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 481,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "7341:2:2"
							},
							"payable": true,
							"returnParameters": {
								"id": 482,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "7359:0:2"
							},
							"scope": 4288,
							"src": "7333:83:2",
							"stateMutability": "payable",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 499,
								"nodeType": "Block",
								"src": "7568:31:2",
								"statements": [
									{
										"expression": {
											"argumentTypes": null,
											"id": 497,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"id": 495,
												"name": "stopped",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 169,
												"src": "7578:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 496,
												"name": "stop",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 490,
												"src": "7588:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											"src": "7578:14:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"id": 498,
										"nodeType": "ExpressionStatement",
										"src": "7578:14:2"
									}
								]
							},
							"documentation": null,
							"id": 500,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": false,
							"modifiers": [
								{
									"arguments": [],
									"id": 493,
									"modifierName": {
										"argumentTypes": null,
										"id": 492,
										"name": "isOwner",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 454,
										"src": "7554:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_modifier$__$",
											"typeString": "modifier ()"
										}
									},
									"nodeType": "ModifierInvocation",
									"src": "7554:9:2"
								}
							],
							"name": "stopNewGames",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 491,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 490,
										"name": "stop",
										"nodeType": "VariableDeclaration",
										"scope": 500,
										"src": "7519:9:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"typeName": {
											"id": 489,
											"name": "bool",
											"nodeType": "ElementaryTypeName",
											"src": "7519:4:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "7518:11:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 494,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "7568:0:2"
							},
							"scope": 4288,
							"src": "7497:102:2",
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 649,
								"nodeType": "Block",
								"src": "8077:1839:2",
								"statements": [
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 520,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 518,
														"name": "maxBlocksPerTurn",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 504,
														"src": "8160:16:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": ">=",
													"rightExpression": {
														"argumentTypes": null,
														"id": 519,
														"name": "MAX_BLOCKS_THRESHOLD",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 150,
														"src": "8180:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "8160:40:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "5573657273206d75737420626520676976656e20656e6f7567682074696d6520746f20636f6d706c657465207468656972207475726e2e",
													"id": 521,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "8202:57:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_60d8d8641b4cffefeb677de5b0387d801ee63766e104b1488ca4c43419940433",
														"typeString": "literal_string \"Users must be given enough time to complete their turn.\""
													},
													"value": "Users must be given enough time to complete their turn."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_60d8d8641b4cffefeb677de5b0387d801ee63766e104b1488ca4c43419940433",
														"typeString": "literal_string \"Users must be given enough time to complete their turn.\""
													}
												],
												"id": 517,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "8152:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 522,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "8152:108:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 523,
										"nodeType": "ExpressionStatement",
										"src": "8152:108:2"
									},
									{
										"assignments": [
											525
										],
										"declarations": [
											{
												"constant": false,
												"id": 525,
												"name": "gameId",
												"nodeType": "VariableDeclaration",
												"scope": 650,
												"src": "8426:14:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"typeName": {
													"id": 524,
													"name": "uint256",
													"nodeType": "ElementaryTypeName",
													"src": "8426:7:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 637,
										"initialValue": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"id": 636,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"hexValue": "30",
																		"id": 530,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "8527:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		},
																		"value": "0"
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		}
																	],
																	"id": 529,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"nodeType": "ElementaryTypeNameExpression",
																	"src": "8520:6:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_uint32_$",
																		"typeString": "type(uint32)"
																	},
																	"typeName": "uint32"
																},
																"id": 531,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "typeConversion",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "8520:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 533,
																			"name": "block",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 4362,
																			"src": "8584:5:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_magic_block",
																				"typeString": "block"
																			}
																		},
																		"id": 534,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "number",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": null,
																		"src": "8584:12:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	],
																	"id": 532,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"nodeType": "ElementaryTypeNameExpression",
																	"src": "8577:6:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_uint32_$",
																		"typeString": "type(uint32)"
																	},
																	"typeName": "uint32"
																},
																"id": 535,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "typeConversion",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "8577:20:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"id": 536,
																"name": "maxBlocksPerTurn",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 504,
																"src": "8654:16:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"id": 537,
																"name": "playerCount",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 502,
																"src": "8721:11:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"id": 538,
																"name": "playerAddresses",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 508,
																"src": "8801:15:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_address_$8_memory_ptr",
																	"typeString": "address[8] memory"
																}
															},
															{
																"argumentTypes": null,
																"id": 539,
																"name": "BEGIN_SOLDIERS_COUNTS",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 165,
																"src": "8876:21:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 540,
																"name": "ALL_REGIONS_NOT_OWNED",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 162,
																"src": "8951:21:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"components": [
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 542,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9066:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 541,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9059:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 543,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9059:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 545,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9077:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 544,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9070:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 546,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9070:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 548,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9088:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 547,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9081:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 549,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9081:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 551,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9099:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 550,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9092:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 552,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9092:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 554,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9110:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 553,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9103:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 555,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9103:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 557,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9121:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 556,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9114:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 558,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9114:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 560,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9149:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 559,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9142:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 561,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9142:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 563,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9160:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 562,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9153:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 564,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9153:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 566,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9171:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 565,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9164:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 567,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9164:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 569,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9182:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 568,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9175:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 570,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9175:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 572,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9193:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 571,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9186:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 573,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9186:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 575,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9204:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 574,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9197:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 576,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9197:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 578,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9232:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 577,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9225:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 579,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9225:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 581,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9243:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 580,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9236:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 582,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9236:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 584,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9254:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 583,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9247:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 585,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9247:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 587,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9265:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 586,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9258:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 588,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9258:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 590,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9276:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 589,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9269:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 591,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9269:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 593,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9287:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 592,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9280:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 594,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9280:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 596,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9315:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 595,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9308:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 597,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9308:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 599,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9326:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 598,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9319:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 600,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9319:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 602,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9337:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 601,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9330:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 603,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9330:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 605,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9348:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 604,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9341:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 606,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9341:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 608,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9359:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 607,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9352:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 609,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9352:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 611,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9370:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 610,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9363:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 612,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9363:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 614,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9398:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 613,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9391:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 615,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9391:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"id": 616,
																"isConstant": false,
																"isInlineArray": true,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"nodeType": "TupleExpression",
																"src": "9041:373:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
																	"typeString": "uint32[25] memory"
																}
															},
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"hexValue": "30",
																		"id": 618,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "9473:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		},
																		"value": "0"
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		}
																	],
																	"id": 617,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"nodeType": "ElementaryTypeNameExpression",
																	"src": "9466:6:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_uint32_$",
																		"typeString": "type(uint32)"
																	},
																	"typeName": "uint32"
																},
																"id": 619,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "typeConversion",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "9466:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"hexValue": "30",
																		"id": 621,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "9538:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		},
																		"value": "0"
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		}
																	],
																	"id": 620,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"nodeType": "ElementaryTypeNameExpression",
																	"src": "9530:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_uint256_$",
																		"typeString": "type(uint256)"
																	},
																	"typeName": "uint256"
																},
																"id": 622,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "typeConversion",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "9530:10:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"hexValue": "30",
																		"id": 624,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "9602:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		},
																		"value": "0"
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		}
																	],
																	"id": 623,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"nodeType": "ElementaryTypeNameExpression",
																	"src": "9594:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_uint256_$",
																		"typeString": "type(uint256)"
																	},
																	"typeName": "uint256"
																},
																"id": 625,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "typeConversion",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "9594:10:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"hexValue": "30",
																		"id": 627,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "9674:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		},
																		"value": "0"
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		}
																	],
																	"id": 626,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"nodeType": "ElementaryTypeNameExpression",
																	"src": "9666:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_uint256_$",
																		"typeString": "type(uint256)"
																	},
																	"typeName": "uint256"
																},
																"id": 628,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "typeConversion",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "9666:10:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"hexValue": "30",
																		"id": 630,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "9741:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		},
																		"value": "0"
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		}
																	],
																	"id": 629,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"nodeType": "ElementaryTypeNameExpression",
																	"src": "9733:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_uint256_$",
																		"typeString": "type(uint256)"
																	},
																	"typeName": "uint256"
																},
																"id": 631,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "typeConversion",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "9733:10:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 632,
																"name": "teamAvatars",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 510,
																"src": "9794:11:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bytes8",
																	"typeString": "bytes8"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_array$_t_address_$8_memory_ptr",
																	"typeString": "address[8] memory"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
																	"typeString": "uint32[25] memory"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_bytes8",
																	"typeString": "bytes8"
																}
															],
															"id": 528,
															"name": "GameData",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 245,
															"src": "8462:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_struct$_GameData_$245_storage_ptr_$",
																"typeString": "type(struct WorldGame.GameData storage pointer)"
															}
														},
														"id": 633,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "structConstructorCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "8462:1353:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_memory",
															"typeString": "struct WorldGame.GameData memory"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_struct$_GameData_$245_memory",
															"typeString": "struct WorldGame.GameData memory"
														}
													],
													"expression": {
														"argumentTypes": null,
														"id": 526,
														"name": "gameDataArray",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 186,
														"src": "8443:13:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
															"typeString": "struct WorldGame.GameData storage ref[] storage ref"
														}
													},
													"id": 527,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "push",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "8443:18:2",
													"typeDescriptions": {
														"typeIdentifier": "t_function_arraypush_nonpayable$_t_struct$_GameData_$245_storage_$returns$_t_uint256_$",
														"typeString": "function (struct WorldGame.GameData storage ref) returns (uint256)"
													}
												},
												"id": 634,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "8443:1373:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "-",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 635,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "9819:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"src": "8443:1377:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "8426:1394:2"
									},
									{
										"eventCall": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 639,
													"name": "gameId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 525,
													"src": "9844:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 641,
																"name": "block",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4362,
																"src": "9859:5:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_block",
																	"typeString": "block"
																}
															},
															"id": 642,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "number",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "9859:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														],
														"id": 640,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "9852:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 643,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "9852:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"id": 644,
													"name": "teamAvatars",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 510,
													"src": "9874:11:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bytes8",
														"typeString": "bytes8"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													{
														"typeIdentifier": "t_bytes8",
														"typeString": "bytes8"
													}
												],
												"id": 638,
												"name": "NewGame",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 253,
												"src": "9836:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_event_nonpayable$_t_uint256_$_t_uint32_$_t_bytes8_$returns$__$",
													"typeString": "function (uint256,uint32,bytes8)"
												}
											},
											"id": 645,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "9836:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 646,
										"nodeType": "EmitStatement",
										"src": "9831:55:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 647,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 525,
											"src": "9903:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"functionReturnParameters": 516,
										"id": 648,
										"nodeType": "Return",
										"src": "9896:13:2"
									}
								]
							},
							"documentation": "@notice Create a new game instance\n @param playerCount number of players\n @param playerAddresses address of each player\n @param teamAvatars avatar to use for each player\n @return Id of the game instance",
							"id": 650,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": false,
							"modifiers": [
								{
									"arguments": [],
									"id": 513,
									"modifierName": {
										"argumentTypes": null,
										"id": 512,
										"name": "stopInEmergency",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 465,
										"src": "8028:15:2",
										"typeDescriptions": {
											"typeIdentifier": "t_modifier$__$",
											"typeString": "modifier ()"
										}
									},
									"nodeType": "ModifierInvocation",
									"src": "8028:17:2"
								}
							],
							"name": "newGame",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 511,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 502,
										"name": "playerCount",
										"nodeType": "VariableDeclaration",
										"scope": 650,
										"src": "7870:18:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 501,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "7870:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 504,
										"name": "maxBlocksPerTurn",
										"nodeType": "VariableDeclaration",
										"scope": 650,
										"src": "7899:23:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 503,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "7899:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 508,
										"name": "playerAddresses",
										"nodeType": "VariableDeclaration",
										"scope": 650,
										"src": "7933:36:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_address_$8_memory_ptr",
											"typeString": "address[8]"
										},
										"typeName": {
											"baseType": {
												"id": 505,
												"name": "address",
												"nodeType": "ElementaryTypeName",
												"src": "7933:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"id": 507,
											"length": {
												"argumentTypes": null,
												"id": 506,
												"name": "MAX_PLAYERS",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 135,
												"src": "7941:11:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "7933:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_address_$8_storage_ptr",
												"typeString": "address[8]"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 510,
										"name": "teamAvatars",
										"nodeType": "VariableDeclaration",
										"scope": 650,
										"src": "7980:18:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes8",
											"typeString": "bytes8"
										},
										"typeName": {
											"id": 509,
											"name": "bytes8",
											"nodeType": "ElementaryTypeName",
											"src": "7980:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes8",
												"typeString": "bytes8"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "7860:144:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 516,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 515,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 650,
										"src": "8063:7:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 514,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "8063:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "8062:9:2"
							},
							"scope": 4288,
							"src": "7844:2072:2",
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 799,
								"nodeType": "Block",
								"src": "10563:1345:2",
								"statements": [
									{
										"assignments": [
											672
										],
										"declarations": [
											{
												"constant": false,
												"id": 672,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 800,
												"src": "10573:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 671,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "10573:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 676,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 673,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "10597:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 675,
											"indexExpression": {
												"argumentTypes": null,
												"id": 674,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 652,
												"src": "10611:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "10597:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "10573:45:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 678,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 800,
												"src": "10628:8:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 677,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "10628:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 679,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "10628:8:2"
									},
									{
										"body": {
											"id": 702,
											"nodeType": "Block",
											"src": "10733:231:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 698,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"id": 692,
																	"name": "regionTo",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 658,
																	"src": "10842:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "!=",
																"rightExpression": {
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"expression": {
																				"argumentTypes": null,
																				"id": 694,
																				"name": "game",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 672,
																				"src": "10864:4:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																					"typeString": "struct WorldGame.GameData storage pointer"
																				}
																			},
																			"id": 695,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"memberName": "toRegionList",
																			"nodeType": "MemberAccess",
																			"referencedDeclaration": 238,
																			"src": "10864:17:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint256",
																				"typeString": "uint256"
																			}
																		},
																		{
																			"argumentTypes": null,
																			"id": 696,
																			"name": "i",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 678,
																			"src": "10883:1:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_uint256",
																				"typeString": "uint256"
																			},
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		],
																		"id": 693,
																		"name": "getData32",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 4095,
																		"src": "10854:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																			"typeString": "function (uint256,uint32) pure returns (uint32)"
																		}
																	},
																	"id": 697,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"kind": "functionCall",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "10854:31:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "10842:43:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															{
																"argumentTypes": null,
																"hexValue": "526567696f6e20616c7265616479206861732071756575656420616374696f6e2e",
																"id": 699,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "string",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "10904:35:2",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_stringliteral_42a4306f24c3d258ad9d7c6f5cbd7e7e358c2aaef61dbd71507a29be5a0ec3dc",
																	"typeString": "literal_string \"Region already has queued action.\""
																},
																"value": "Region already has queued action."
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																},
																{
																	"typeIdentifier": "t_stringliteral_42a4306f24c3d258ad9d7c6f5cbd7e7e358c2aaef61dbd71507a29be5a0ec3dc",
																	"typeString": "literal_string \"Region already has queued action.\""
																}
															],
															"id": 691,
															"name": "require",
															"nodeType": "Identifier",
															"overloadedDeclarations": [
																4375,
																4376
															],
															"referencedDeclaration": 4376,
															"src": "10817:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
																"typeString": "function (bool,string memory) pure"
															}
														},
														"id": 700,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "10817:136:2",
														"typeDescriptions": {
															"typeIdentifier": "t_tuple$__$",
															"typeString": "tuple()"
														}
													},
													"id": 701,
													"nodeType": "ExpressionStatement",
													"src": "10817:136:2"
												}
											]
										},
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 687,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 684,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 678,
												"src": "10706:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "<",
											"rightExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 685,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 672,
													"src": "10710:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 686,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "actionCount",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 234,
												"src": "10710:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "10706:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"id": 703,
										"initializationExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 682,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftHandSide": {
													"argumentTypes": null,
													"id": 680,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 678,
													"src": "10699:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "Assignment",
												"operator": "=",
												"rightHandSide": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 681,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "10703:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "10699:5:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 683,
											"nodeType": "ExpressionStatement",
											"src": "10699:5:2"
										},
										"loopExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 689,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "UnaryOperation",
												"operator": "++",
												"prefix": false,
												"src": "10728:3:2",
												"subExpression": {
													"argumentTypes": null,
													"id": 688,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 678,
													"src": "10728:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 690,
											"nodeType": "ExpressionStatement",
											"src": "10728:3:2"
										},
										"nodeType": "ForStatement",
										"src": "10694:270:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 708,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 705,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 672,
															"src": "10981:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 706,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "actionCount",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 234,
														"src": "10981:16:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "<",
													"rightExpression": {
														"argumentTypes": null,
														"id": 707,
														"name": "MAX_ACTIONS_PER_TURN",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 138,
														"src": "11000:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "10981:39:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "4f6e6c79203820616374696f6e732061726520616c6c6f77656420706572207475726e",
													"id": 709,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "11022:37:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_471f30d10f0a85b9c4f591704f45bf517809a8bcc20d3354ac5a73fdad6f1f40",
														"typeString": "literal_string \"Only 8 actions are allowed per turn\""
													},
													"value": "Only 8 actions are allowed per turn"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_471f30d10f0a85b9c4f591704f45bf517809a8bcc20d3354ac5a73fdad6f1f40",
														"typeString": "literal_string \"Only 8 actions are allowed per turn\""
													}
												],
												"id": 704,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "10973:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 710,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "10973:87:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 711,
										"nodeType": "ExpressionStatement",
										"src": "10973:87:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 718,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 713,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 672,
																"src": "11078:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 714,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "regionSoldiers",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 232,
															"src": "11078:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_uint32_$25_storage",
																"typeString": "uint32[25] storage ref"
															}
														},
														"id": 716,
														"indexExpression": {
															"argumentTypes": null,
															"id": 715,
															"name": "regionFrom",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 656,
															"src": "11098:10:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "11078:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": ">",
													"rightExpression": {
														"argumentTypes": null,
														"id": 717,
														"name": "moveSoldierCount",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 660,
														"src": "11112:16:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "11078:50:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "4d75737420686176652073756666696369656e7420736f6c6469657273",
													"id": 719,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "11130:31:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_12962f6126f4a079dde7c9188f2cd55cd58b74d5bc86e5589fef81f690b5cfd1",
														"typeString": "literal_string \"Must have sufficient soldiers\""
													},
													"value": "Must have sufficient soldiers"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_12962f6126f4a079dde7c9188f2cd55cd58b74d5bc86e5589fef81f690b5cfd1",
														"typeString": "literal_string \"Must have sufficient soldiers\""
													}
												],
												"id": 712,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "11070:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 720,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "11070:92:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 721,
										"nodeType": "ExpressionStatement",
										"src": "11070:92:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 730,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 723,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 672,
															"src": "11180:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 724,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "turnTeamId",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 214,
														"src": "11180:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 726,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 672,
																	"src": "11208:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 727,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "regionOwners",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 228,
																"src": "11208:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 728,
																"name": "regionFrom",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 656,
																"src": "11227:10:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 725,
															"name": "getData8",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4158,
															"src": "11199:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 729,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "11199:39:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "11180:58:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "4d757374206f776e20726567696f6e206d6f76696e672066726f6d",
													"id": 731,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "11240:29:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_6f4e4f7daf7ce42b7f9639ac00f41ccd25d08f2d8f5a894d0b853675c2a00939",
														"typeString": "literal_string \"Must own region moving from\""
													},
													"value": "Must own region moving from"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_6f4e4f7daf7ce42b7f9639ac00f41ccd25d08f2d8f5a894d0b853675c2a00939",
														"typeString": "literal_string \"Must own region moving from\""
													}
												],
												"id": 722,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "11172:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 732,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "11172:98:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 733,
										"nodeType": "ExpressionStatement",
										"src": "11172:98:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 737,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"id": 734,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 678,
												"src": "11334:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 735,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 672,
													"src": "11338:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 736,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "actionCount",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 234,
												"src": "11338:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "11334:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 738,
										"nodeType": "ExpressionStatement",
										"src": "11334:20:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 745,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 739,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 672,
														"src": "11407:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 742,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "regionSoldiers",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 232,
													"src": "11407:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 743,
												"indexExpression": {
													"argumentTypes": null,
													"id": 741,
													"name": "regionFrom",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 656,
													"src": "11427:10:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "11407:31:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "-=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 744,
												"name": "moveSoldierCount",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 660,
												"src": "11442:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "11407:51:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 746,
										"nodeType": "ExpressionStatement",
										"src": "11407:51:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 756,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 747,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 672,
													"src": "11516:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 749,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"memberName": "fromRegionList",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 236,
												"src": "11516:19:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 751,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 672,
															"src": "11548:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 752,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "fromRegionList",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 236,
														"src": "11548:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													{
														"argumentTypes": null,
														"id": 753,
														"name": "i",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 678,
														"src": "11569:1:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													{
														"argumentTypes": null,
														"id": 754,
														"name": "regionFrom",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 656,
														"src": "11572:10:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														{
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														{
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													],
													"id": 750,
													"name": "setData32",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4133,
													"src": "11538:9:2",
													"typeDescriptions": {
														"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
														"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
													}
												},
												"id": 755,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "11538:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"src": "11516:67:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"id": 757,
										"nodeType": "ExpressionStatement",
										"src": "11516:67:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 767,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 758,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 672,
													"src": "11593:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 760,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"memberName": "toRegionList",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 238,
												"src": "11593:17:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 762,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 672,
															"src": "11623:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 763,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "toRegionList",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 238,
														"src": "11623:17:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													{
														"argumentTypes": null,
														"id": 764,
														"name": "i",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 678,
														"src": "11642:1:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													{
														"argumentTypes": null,
														"id": 765,
														"name": "regionTo",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 658,
														"src": "11645:8:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														{
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														{
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													],
													"id": 761,
													"name": "setData32",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4133,
													"src": "11613:9:2",
													"typeDescriptions": {
														"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
														"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
													}
												},
												"id": 766,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "11613:41:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"src": "11593:61:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"id": 768,
										"nodeType": "ExpressionStatement",
										"src": "11593:61:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 778,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 769,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 672,
													"src": "11664:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 771,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"memberName": "moveSoldierCountList",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 240,
												"src": "11664:25:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 773,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 672,
															"src": "11702:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 774,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "moveSoldierCountList",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 240,
														"src": "11702:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													{
														"argumentTypes": null,
														"id": 775,
														"name": "i",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 678,
														"src": "11729:1:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													{
														"argumentTypes": null,
														"id": 776,
														"name": "moveSoldierCount",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 660,
														"src": "11732:16:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														{
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														{
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													],
													"id": 772,
													"name": "setData32",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4133,
													"src": "11692:9:2",
													"typeDescriptions": {
														"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
														"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
													}
												},
												"id": 777,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "11692:57:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"src": "11664:85:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"id": 779,
										"nodeType": "ExpressionStatement",
										"src": "11664:85:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 792,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 780,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 672,
													"src": "11759:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 782,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"memberName": "submitBlockList",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 242,
												"src": "11759:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 784,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 672,
															"src": "11792:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 785,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "submitBlockList",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 242,
														"src": "11792:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													{
														"argumentTypes": null,
														"id": 786,
														"name": "i",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 678,
														"src": "11814:1:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													{
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 788,
																	"name": "block",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4362,
																	"src": "11824:5:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_magic_block",
																		"typeString": "block"
																	}
																},
																"id": 789,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "number",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "11824:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															],
															"id": 787,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "11817:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 790,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "11817:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														{
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														{
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													],
													"id": 783,
													"name": "setData32",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4133,
													"src": "11782:9:2",
													"typeDescriptions": {
														"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
														"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
													}
												},
												"id": 791,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "11782:56:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"src": "11759:79:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"id": 793,
										"nodeType": "ExpressionStatement",
										"src": "11759:79:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 797,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "11883:18:2",
											"subExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 794,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 672,
													"src": "11883:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 796,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"memberName": "actionCount",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 234,
												"src": "11883:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 798,
										"nodeType": "ExpressionStatement",
										"src": "11883:18:2"
									}
								]
							},
							"documentation": "@notice Move soldiers from one region to an adjacent region.  Attack if moving to enemy territory. \n @param gameId Id of game \n @param turnNum Turn action should occur during \n @param regionFrom Move soldiers from this region\n @param regionTo Move soldiers to this region\n @param moveSoldierCount Number of soldiers to move",
							"id": 800,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": false,
							"modifiers": [
								{
									"arguments": [
										{
											"argumentTypes": null,
											"id": 663,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 652,
											"src": "10496:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										{
											"argumentTypes": null,
											"id": 664,
											"name": "turnNum",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 654,
											"src": "10504:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										}
									],
									"id": 665,
									"modifierName": {
										"argumentTypes": null,
										"id": 662,
										"name": "onlyIfPlayersTurn",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 301,
										"src": "10478:17:2",
										"typeDescriptions": {
											"typeIdentifier": "t_modifier$_t_uint256_$_t_uint32_$",
											"typeString": "modifier (uint256,uint32)"
										}
									},
									"nodeType": "ModifierInvocation",
									"src": "10478:34:2"
								},
								{
									"arguments": [
										{
											"argumentTypes": null,
											"id": 667,
											"name": "regionFrom",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 656,
											"src": "10536:10:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										{
											"argumentTypes": null,
											"id": 668,
											"name": "regionTo",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 658,
											"src": "10548:8:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										}
									],
									"id": 669,
									"modifierName": {
										"argumentTypes": null,
										"id": 666,
										"name": "onlyNeighbors",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 442,
										"src": "10522:13:2",
										"typeDescriptions": {
											"typeIdentifier": "t_modifier$_t_uint32_$_t_uint32_$",
											"typeString": "modifier (uint32,uint32)"
										}
									},
									"nodeType": "ModifierInvocation",
									"src": "10522:35:2"
								}
							],
							"name": "attackOrMove",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 661,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 652,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 800,
										"src": "10320:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 651,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "10320:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 654,
										"name": "turnNum",
										"nodeType": "VariableDeclaration",
										"scope": 800,
										"src": "10345:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 653,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "10345:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 656,
										"name": "regionFrom",
										"nodeType": "VariableDeclaration",
										"scope": 800,
										"src": "10370:17:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 655,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "10370:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 658,
										"name": "regionTo",
										"nodeType": "VariableDeclaration",
										"scope": 800,
										"src": "10398:15:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 657,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "10398:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 660,
										"name": "moveSoldierCount",
										"nodeType": "VariableDeclaration",
										"scope": 800,
										"src": "10424:23:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 659,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "10424:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "10310:143:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 670,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "10563:0:2"
							},
							"scope": 4288,
							"src": "10289:1619:2",
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 951,
								"nodeType": "Block",
								"src": "12478:1644:2",
								"statements": [
									{
										"assignments": [
											816
										],
										"declarations": [
											{
												"constant": false,
												"id": 816,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 952,
												"src": "12488:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 815,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "12488:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 820,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 817,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "12512:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 819,
											"indexExpression": {
												"argumentTypes": null,
												"id": 818,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 802,
												"src": "12526:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "12512:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "12488:45:2"
									},
									{
										"assignments": [
											822
										],
										"declarations": [
											{
												"constant": false,
												"id": 822,
												"name": "undeployedSoldierCount",
												"nodeType": "VariableDeclaration",
												"scope": 952,
												"src": "12543:29:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 821,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "12543:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 829,
										"initialValue": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 824,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 816,
														"src": "12585:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 825,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "undeployedSoldiers",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 226,
													"src": "12585:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 826,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 816,
														"src": "12610:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 827,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "turnTeamId",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 214,
													"src": "12610:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												],
												"id": 823,
												"name": "getData32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4095,
												"src": "12575:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
													"typeString": "function (uint256,uint32) pure returns (uint32)"
												}
											},
											"id": 828,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "12575:51:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "12543:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 833,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 831,
														"name": "undeployedSoldierCount",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 822,
														"src": "12645:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": ">=",
													"rightExpression": {
														"argumentTypes": null,
														"id": 832,
														"name": "deploySoldierCount",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 808,
														"src": "12671:18:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "12645:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "4d75737420686176652073756666696369656e7420736f6c64696572732e",
													"id": 834,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "12691:32:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_0a6a6a35e9a076634cdab1c6b7d95a290e79ba710b2a21232b485da02b0fe1e8",
														"typeString": "literal_string \"Must have sufficient soldiers.\""
													},
													"value": "Must have sufficient soldiers."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_0a6a6a35e9a076634cdab1c6b7d95a290e79ba710b2a21232b485da02b0fe1e8",
														"typeString": "literal_string \"Must have sufficient soldiers.\""
													}
												],
												"id": 830,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "12637:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 835,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "12637:87:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 836,
										"nodeType": "ExpressionStatement",
										"src": "12637:87:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 862,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"id": 854,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"components": [
																{
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	},
																	"id": 844,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"id": 840,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"id": 838,
																			"name": "regionDeploy",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 806,
																			"src": "12756:12:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "==",
																		"rightExpression": {
																			"argumentTypes": null,
																			"id": 839,
																			"name": "NO_REGION",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 126,
																			"src": "12772:9:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"src": "12756:25:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "&&",
																	"rightExpression": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"id": 843,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"id": 841,
																			"name": "deploySoldierCount",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 808,
																			"src": "12785:18:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "==",
																		"rightExpression": {
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 842,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "12807:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		},
																		"src": "12785:23:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	},
																	"src": "12756:52:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																}
															],
															"id": 845,
															"isConstant": false,
															"isInlineArray": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "TupleExpression",
															"src": "12755:54:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "||",
														"rightExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 853,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 847,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 816,
																			"src": "12835:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 848,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "regionOwners",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 228,
																		"src": "12835:17:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"id": 849,
																		"name": "regionDeploy",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 806,
																		"src": "12854:12:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 846,
																	"name": "getData8",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4158,
																	"src": "12826:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																		"typeString": "function (uint256,uint32) pure returns (uint32)"
																	}
																},
																"id": 850,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "12826:41:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "==",
															"rightExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 851,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 816,
																	"src": "12871:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 852,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "turnTeamId",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 214,
																"src": "12871:15:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "12826:60:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"src": "12755:131:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "||",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 861,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 856,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 816,
																		"src": "12912:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 857,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "regionOwners",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 228,
																	"src": "12912:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 858,
																	"name": "regionDeploy",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 806,
																	"src": "12931:12:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 855,
																"name": "getData8",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4158,
																"src": "12903:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 859,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "12903:41:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"id": 860,
															"name": "NOT_OWNED",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 123,
															"src": "12948:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "12903:54:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "12755:202:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "596f752063616e206f6e6c79206465706c6f7920736f6c646965727320746f206120726567696f6e20796f75206f776e2c206f72207468617420697320756e6f636375706965642e",
													"id": 863,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "12971:74:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_c0de4a8692b68d0ec3870e60f28f1b34ccc9dab26c018a4f9d418a52d18b2872",
														"typeString": "literal_string \"You can only deploy soldiers to a region you own, or that is unoccupied.\""
													},
													"value": "You can only deploy soldiers to a region you own, or that is unoccupied."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_c0de4a8692b68d0ec3870e60f28f1b34ccc9dab26c018a4f9d418a52d18b2872",
														"typeString": "literal_string \"You can only deploy soldiers to a region you own, or that is unoccupied.\""
													}
												],
												"id": 837,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "12734:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 864,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "12734:321:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 865,
										"nodeType": "ExpressionStatement",
										"src": "12734:321:2"
									},
									{
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 869,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 866,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 816,
													"src": "13152:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 867,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "actionCount",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 234,
												"src": "13152:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": ">",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 868,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "13171:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"src": "13152:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": null,
										"id": 875,
										"nodeType": "IfStatement",
										"src": "13148:80:2",
										"trueBody": {
											"id": 874,
											"nodeType": "Block",
											"src": "13174:54:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"id": 871,
																"name": "gameId",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 802,
																"src": "13210:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															],
															"id": 870,
															"name": "executePendingActions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1847,
															"src": "13188:21:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$returns$__$",
																"typeString": "function (uint256)"
															}
														},
														"id": 872,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "13188:29:2",
														"typeDescriptions": {
															"typeIdentifier": "t_tuple$__$",
															"typeString": "tuple()"
														}
													},
													"id": 873,
													"nodeType": "ExpressionStatement",
													"src": "13188:29:2"
												}
											]
										}
									},
									{
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 878,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 876,
												"name": "regionDeploy",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 806,
												"src": "13297:12:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "!=",
											"rightExpression": {
												"argumentTypes": null,
												"id": 877,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "13313:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "13297:25:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": null,
										"id": 921,
										"nodeType": "IfStatement",
										"src": "13293:500:2",
										"trueBody": {
											"id": 920,
											"nodeType": "Block",
											"src": "13324:469:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"id": 889,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 879,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 816,
																"src": "13338:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 881,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"memberName": "regionOwners",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 228,
															"src": "13338:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 883,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 816,
																		"src": "13367:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 884,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "regionOwners",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 228,
																	"src": "13367:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 885,
																	"name": "regionDeploy",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 806,
																	"src": "13386:12:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 886,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 816,
																		"src": "13400:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 887,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "turnTeamId",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 214,
																	"src": "13400:15:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 882,
																"name": "setData8",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4203,
																"src": "13358:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
																	"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
																}
															},
															"id": 888,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "13358:58:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"src": "13338:78:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"id": 890,
													"nodeType": "ExpressionStatement",
													"src": "13338:78:2"
												},
												{
													"expression": {
														"argumentTypes": null,
														"id": 904,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 891,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 816,
																"src": "13430:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 893,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"memberName": "undeployedSoldiers",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 226,
															"src": "13430:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 895,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 816,
																		"src": "13483:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 896,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "undeployedSoldiers",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 226,
																	"src": "13483:23:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 897,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 816,
																		"src": "13525:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 898,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "turnTeamId",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 214,
																	"src": "13525:15:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"id": 900,
																			"name": "undeployedSoldierCount",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 822,
																			"src": "13567:22:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		{
																			"argumentTypes": null,
																			"id": 901,
																			"name": "deploySoldierCount",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 808,
																			"src": "13591:18:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			},
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		],
																		"id": 899,
																		"name": "subSafe",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 4228,
																		"src": "13559:7:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																			"typeString": "function (uint32,uint32) pure returns (uint32)"
																		}
																	},
																	"id": 902,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"kind": "functionCall",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "13559:51:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 894,
																"name": "setData32",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4133,
																"src": "13456:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
																	"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
																}
															},
															"id": 903,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "13456:168:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"src": "13430:194:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"id": 905,
													"nodeType": "ExpressionStatement",
													"src": "13430:194:2"
												},
												{
													"expression": {
														"argumentTypes": null,
														"id": 918,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 906,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 816,
																	"src": "13638:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 909,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "regionSoldiers",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 232,
																"src": "13638:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$25_storage",
																	"typeString": "uint32[25] storage ref"
																}
															},
															"id": 910,
															"indexExpression": {
																"argumentTypes": null,
																"id": 908,
																"name": "regionDeploy",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 806,
																"src": "13658:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"nodeType": "IndexAccess",
															"src": "13638:33:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 912,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 816,
																			"src": "13699:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 913,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "regionSoldiers",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 232,
																		"src": "13699:19:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_uint32_$25_storage",
																			"typeString": "uint32[25] storage ref"
																		}
																	},
																	"id": 915,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 914,
																		"name": "regionDeploy",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 806,
																		"src": "13719:12:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "13699:33:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 916,
																	"name": "deploySoldierCount",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 808,
																	"src": "13750:18:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 911,
																"name": "addSafe",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4253,
																"src": "13674:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint32,uint32) pure returns (uint32)"
																}
															},
															"id": 917,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "13674:108:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "13638:144:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 919,
													"nodeType": "ExpressionStatement",
													"src": "13638:144:2"
												}
											]
										}
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 928,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 922,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 816,
													"src": "13845:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 924,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"memberName": "turnTeamId",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 214,
												"src": "13845:15:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"id": 926,
														"name": "gameId",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 802,
														"src": "13881:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													],
													"id": 925,
													"name": "getNextTurnTeamId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1948,
													"src": "13863:17:2",
													"typeDescriptions": {
														"typeIdentifier": "t_function_internal_view$_t_uint256_$returns$_t_uint32_$",
														"typeString": "function (uint256) view returns (uint32)"
													}
												},
												"id": 927,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "13863:25:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "13845:43:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 929,
										"nodeType": "ExpressionStatement",
										"src": "13845:43:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 937,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 930,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 816,
													"src": "13898:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 932,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"memberName": "turnNum",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 216,
												"src": "13898:12:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 934,
															"name": "block",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4362,
															"src": "13920:5:2",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_block",
																"typeString": "block"
															}
														},
														"id": 935,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "number",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "13920:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													],
													"id": 933,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "13913:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 936,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "13913:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "13898:35:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 938,
										"nodeType": "ExpressionStatement",
										"src": "13898:35:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 940,
													"name": "gameId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 802,
													"src": "14045:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"id": 939,
												"name": "giveRegionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2210,
												"src": "14027:17:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$returns$__$",
													"typeString": "function (uint256)"
												}
											},
											"id": 941,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "14027:25:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 942,
										"nodeType": "ExpressionStatement",
										"src": "14027:25:2"
									},
									{
										"eventCall": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 944,
													"name": "gameId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 802,
													"src": "14077:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 945,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 816,
														"src": "14085:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 946,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "turnNum",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 216,
													"src": "14085:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 947,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 816,
														"src": "14099:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 948,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "turnTeamId",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 214,
													"src": "14099:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												],
												"id": 943,
												"name": "NextTurn",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 261,
												"src": "14068:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_event_nonpayable$_t_uint256_$_t_uint32_$_t_uint32_$returns$__$",
													"typeString": "function (uint256,uint32,uint32)"
												}
											},
											"id": 949,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "14068:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 950,
										"nodeType": "EmitStatement",
										"src": "14063:52:2"
									}
								]
							},
							"documentation": "@notice Execute actions that have been queued for this turn.\n @param gameId Id of game \n @param turnNum Turn deploySoldiersAndEndTurn should occur during \n @param regionDeploy Region where you'd like to deploy soldiers to\n @param deploySoldierCount Number of soldiers you'd like to deploy at end of your turn",
							"id": 952,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": false,
							"modifiers": [
								{
									"arguments": [
										{
											"argumentTypes": null,
											"id": 811,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 802,
											"src": "12456:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										{
											"argumentTypes": null,
											"id": 812,
											"name": "turnNum",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 804,
											"src": "12464:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										}
									],
									"id": 813,
									"modifierName": {
										"argumentTypes": null,
										"id": 810,
										"name": "onlyIfPlayersTurn",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 301,
										"src": "12438:17:2",
										"typeDescriptions": {
											"typeIdentifier": "t_modifier$_t_uint256_$_t_uint32_$",
											"typeString": "modifier (uint256,uint32)"
										}
									},
									"nodeType": "ModifierInvocation",
									"src": "12438:34:2"
								}
							],
							"name": "deploySoldiersAndEndTurn",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 809,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 802,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 952,
										"src": "12302:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 801,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "12302:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 804,
										"name": "turnNum",
										"nodeType": "VariableDeclaration",
										"scope": 952,
										"src": "12327:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 803,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "12327:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 806,
										"name": "regionDeploy",
										"nodeType": "VariableDeclaration",
										"scope": 952,
										"src": "12352:19:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 805,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "12352:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 808,
										"name": "deploySoldierCount",
										"nodeType": "VariableDeclaration",
										"scope": 952,
										"src": "12382:25:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 807,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "12382:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "12292:121:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 814,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "12478:0:2"
							},
							"scope": 4288,
							"src": "12259:1863:2",
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 1028,
								"nodeType": "Block",
								"src": "14421:740:2",
								"statements": [
									{
										"assignments": [
											963
										],
										"declarations": [
											{
												"constant": false,
												"id": 963,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 1029,
												"src": "14431:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 962,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "14431:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 967,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 964,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "14455:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 966,
											"indexExpression": {
												"argumentTypes": null,
												"id": 965,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 954,
												"src": "14469:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "14455:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "14431:45:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 972,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 969,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 963,
															"src": "14494:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 970,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "turnNum",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 216,
														"src": "14494:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"id": 971,
														"name": "turnNum",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 956,
														"src": "14510:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "14494:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "57726f6e67207475726e206e756d6265722e",
													"id": 973,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "14519:20:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_20e508097488cdf7adfa5bc3dc0f21225c46901f081af1aafe3b036f12f6c46b",
														"typeString": "literal_string \"Wrong turn number.\""
													},
													"value": "Wrong turn number."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_20e508097488cdf7adfa5bc3dc0f21225c46901f081af1aafe3b036f12f6c46b",
														"typeString": "literal_string \"Wrong turn number.\""
													}
												],
												"id": 968,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "14486:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 974,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "14486:54:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 975,
										"nodeType": "ExpressionStatement",
										"src": "14486:54:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 985,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 977,
															"name": "block",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4362,
															"src": "14558:5:2",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_block",
																"typeString": "block"
															}
														},
														"id": 978,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "number",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "14558:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": ">",
													"rightExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 980,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 963,
																	"src": "14581:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 981,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "turnNum",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 216,
																"src": "14581:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 982,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 963,
																	"src": "14595:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 983,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "maxBlocksPerTurn",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 218,
																"src": "14595:21:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 979,
															"name": "addSafe",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4253,
															"src": "14573:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint32,uint32) pure returns (uint32)"
															}
														},
														"id": 984,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "14573:44:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "14558:59:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "506c61796572207374696c6c206861732074696d6520746f2066696e697368207475726e2e",
													"id": 986,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "14619:39:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_20d46139a085b6032013f1ca843b0a034e4a9de1b7ad1a9807e3295f560733f3",
														"typeString": "literal_string \"Player still has time to finish turn.\""
													},
													"value": "Player still has time to finish turn."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_20d46139a085b6032013f1ca843b0a034e4a9de1b7ad1a9807e3295f560733f3",
														"typeString": "literal_string \"Player still has time to finish turn.\""
													}
												],
												"id": 976,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "14550:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 987,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "14550:109:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 988,
										"nodeType": "ExpressionStatement",
										"src": "14550:109:2"
									},
									{
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 992,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 989,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 963,
													"src": "14756:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 990,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "actionCount",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 234,
												"src": "14756:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": ">",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 991,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "14775:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"src": "14756:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": null,
										"id": 998,
										"nodeType": "IfStatement",
										"src": "14752:80:2",
										"trueBody": {
											"id": 997,
											"nodeType": "Block",
											"src": "14778:54:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"id": 994,
																"name": "gameId",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 954,
																"src": "14814:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															],
															"id": 993,
															"name": "executePendingActions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1847,
															"src": "14792:21:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$returns$__$",
																"typeString": "function (uint256)"
															}
														},
														"id": 995,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "14792:29:2",
														"typeDescriptions": {
															"typeIdentifier": "t_tuple$__$",
															"typeString": "tuple()"
														}
													},
													"id": 996,
													"nodeType": "ExpressionStatement",
													"src": "14792:29:2"
												}
											]
										}
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 1005,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 999,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 963,
													"src": "14884:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1001,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"memberName": "turnTeamId",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 214,
												"src": "14884:15:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"id": 1003,
														"name": "gameId",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 954,
														"src": "14920:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													],
													"id": 1002,
													"name": "getNextTurnTeamId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1948,
													"src": "14902:17:2",
													"typeDescriptions": {
														"typeIdentifier": "t_function_internal_view$_t_uint256_$returns$_t_uint32_$",
														"typeString": "function (uint256) view returns (uint32)"
													}
												},
												"id": 1004,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "14902:25:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "14884:43:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1006,
										"nodeType": "ExpressionStatement",
										"src": "14884:43:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 1014,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1007,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 963,
													"src": "14937:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1009,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"memberName": "turnNum",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 216,
												"src": "14937:12:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 1011,
															"name": "block",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4362,
															"src": "14959:5:2",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_block",
																"typeString": "block"
															}
														},
														"id": 1012,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "number",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "14959:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													],
													"id": 1010,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "14952:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 1013,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "14952:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "14937:35:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1015,
										"nodeType": "ExpressionStatement",
										"src": "14937:35:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 1017,
													"name": "gameId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 954,
													"src": "15084:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"id": 1016,
												"name": "giveRegionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2210,
												"src": "15066:17:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$returns$__$",
													"typeString": "function (uint256)"
												}
											},
											"id": 1018,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "15066:25:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 1019,
										"nodeType": "ExpressionStatement",
										"src": "15066:25:2"
									},
									{
										"eventCall": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 1021,
													"name": "gameId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 954,
													"src": "15116:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1022,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 963,
														"src": "15124:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 1023,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "turnNum",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 216,
													"src": "15124:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1024,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 963,
														"src": "15138:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 1025,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "turnTeamId",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 214,
													"src": "15138:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												],
												"id": 1020,
												"name": "NextTurn",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 261,
												"src": "15107:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_event_nonpayable$_t_uint256_$_t_uint32_$_t_uint32_$returns$__$",
													"typeString": "function (uint256,uint32,uint32)"
												}
											},
											"id": 1026,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "15107:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 1027,
										"nodeType": "EmitStatement",
										"src": "15102:52:2"
									}
								]
							},
							"documentation": "@notice Force turn to end for player who's taking too long.\n @param gameId Id of game \n @param turnNum Turn forceEndOfTurn should occur during ",
							"id": 1029,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": false,
							"modifiers": [
								{
									"arguments": [
										{
											"argumentTypes": null,
											"id": 959,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 954,
											"src": "14409:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										}
									],
									"id": 960,
									"modifierName": {
										"argumentTypes": null,
										"id": 958,
										"name": "onlyPlayers",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 380,
										"src": "14397:11:2",
										"typeDescriptions": {
											"typeIdentifier": "t_modifier$_t_uint256_$",
											"typeString": "modifier (uint256)"
										}
									},
									"nodeType": "ModifierInvocation",
									"src": "14397:19:2"
								}
							],
							"name": "forceEndOfTurn",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 957,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 954,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 1029,
										"src": "14327:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 953,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "14327:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 956,
										"name": "turnNum",
										"nodeType": "VariableDeclaration",
										"scope": 1029,
										"src": "14352:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 955,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "14352:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "14317:55:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 961,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "14421:0:2"
							},
							"scope": 4288,
							"src": "14294:867:2",
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 1087,
								"nodeType": "Block",
								"src": "15406:402:2",
								"statements": [
									{
										"assignments": [
											1040
										],
										"declarations": [
											{
												"constant": false,
												"id": 1040,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 1088,
												"src": "15416:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 1039,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "15416:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1044,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1041,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "15440:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 1043,
											"indexExpression": {
												"argumentTypes": null,
												"id": 1042,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1031,
												"src": "15454:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "15440:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "15416:45:2"
									},
									{
										"assignments": [
											1046
										],
										"declarations": [
											{
												"constant": false,
												"id": 1046,
												"name": "isWinner",
												"nodeType": "VariableDeclaration",
												"scope": 1088,
												"src": "15480:13:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"typeName": {
													"id": 1045,
													"name": "bool",
													"nodeType": "ElementaryTypeName",
													"src": "15480:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1048,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "74727565",
											"id": 1047,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "15496:4:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "true"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "15480:20:2"
									},
									{
										"body": {
											"id": 1072,
											"nodeType": "Block",
											"src": "15552:119:2",
											"statements": [
												{
													"condition": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 1065,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1060,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1040,
																		"src": "15579:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1061,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "regionOwners",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 228,
																	"src": "15579:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1062,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1050,
																	"src": "15598:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1059,
																"name": "getData8",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4158,
																"src": "15570:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1063,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "15570:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "!=",
														"rightExpression": {
															"argumentTypes": null,
															"id": 1064,
															"name": "teamId",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1033,
															"src": "15604:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "15570:40:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"falseBody": null,
													"id": 1071,
													"nodeType": "IfStatement",
													"src": "15566:95:2",
													"trueBody": {
														"id": 1070,
														"nodeType": "Block",
														"src": "15612:49:2",
														"statements": [
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 1068,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"id": 1066,
																		"name": "isWinner",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1046,
																		"src": "15630:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"hexValue": "66616c7365",
																		"id": 1067,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "bool",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "15641:5:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		},
																		"value": "false"
																	},
																	"src": "15630:16:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"id": 1069,
																"nodeType": "ExpressionStatement",
																"src": "15630:16:2"
															}
														]
													}
												}
											]
										},
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 1055,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 1053,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1050,
												"src": "15529:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "<",
											"rightExpression": {
												"argumentTypes": null,
												"id": 1054,
												"name": "REGION_COUNT",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 129,
												"src": "15533:12:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "15529:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"id": 1073,
										"initializationExpression": {
											"assignments": [
												1050
											],
											"declarations": [
												{
													"constant": false,
													"id": 1050,
													"name": "i",
													"nodeType": "VariableDeclaration",
													"scope": 1088,
													"src": "15515:8:2",
													"stateVariable": false,
													"storageLocation": "default",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"typeName": {
														"id": 1049,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "15515:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"value": null,
													"visibility": "internal"
												}
											],
											"id": 1052,
											"initialValue": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1051,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "15526:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"nodeType": "VariableDeclarationStatement",
											"src": "15515:12:2"
										},
										"loopExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 1057,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "UnaryOperation",
												"operator": "++",
												"prefix": false,
												"src": "15547:3:2",
												"subExpression": {
													"argumentTypes": null,
													"id": 1056,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1050,
													"src": "15547:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1058,
											"nodeType": "ExpressionStatement",
											"src": "15547:3:2"
										},
										"nodeType": "ForStatement",
										"src": "15510:161:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 1075,
													"name": "isWinner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1046,
													"src": "15689:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "576520646f6e2774206861766520612077696e6e65722e",
													"id": 1076,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "15699:25:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_7ae151848de1ba529538a91ee6366416b7113724579a5d4c2e03650e29d43bf0",
														"typeString": "literal_string \"We don't have a winner.\""
													},
													"value": "We don't have a winner."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_7ae151848de1ba529538a91ee6366416b7113724579a5d4c2e03650e29d43bf0",
														"typeString": "literal_string \"We don't have a winner.\""
													}
												],
												"id": 1074,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "15681:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 1077,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "15681:44:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 1078,
										"nodeType": "ExpressionStatement",
										"src": "15681:44:2"
									},
									{
										"condition": {
											"argumentTypes": null,
											"id": 1079,
											"name": "isWinner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1046,
											"src": "15740:8:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": null,
										"id": 1086,
										"nodeType": "IfStatement",
										"src": "15736:66:2",
										"trueBody": {
											"id": 1085,
											"nodeType": "Block",
											"src": "15750:52:2",
											"statements": [
												{
													"eventCall": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"id": 1081,
																"name": "gameId",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1031,
																"src": "15776:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1082,
																"name": "teamId",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1033,
																"src": "15784:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1080,
															"name": "Winner",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 267,
															"src": "15769:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_event_nonpayable$_t_uint256_$_t_uint32_$returns$__$",
																"typeString": "function (uint256,uint32)"
															}
														},
														"id": 1083,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "15769:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_tuple$__$",
															"typeString": "tuple()"
														}
													},
													"id": 1084,
													"nodeType": "EmitStatement",
													"src": "15764:27:2"
												}
											]
										}
									}
								]
							},
							"documentation": "@notice Declare victory for a team.\n @param gameId Id of game\n @param teamId Team you'd like to declare as winner",
							"id": 1088,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": false,
							"modifiers": [
								{
									"arguments": [
										{
											"argumentTypes": null,
											"id": 1036,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1031,
											"src": "15394:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										}
									],
									"id": 1037,
									"modifierName": {
										"argumentTypes": null,
										"id": 1035,
										"name": "onlyPlayers",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 380,
										"src": "15382:11:2",
										"typeDescriptions": {
											"typeIdentifier": "t_modifier$_t_uint256_$",
											"typeString": "modifier (uint256)"
										}
									},
									"nodeType": "ModifierInvocation",
									"src": "15382:19:2"
								}
							],
							"name": "declareWinner",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1034,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1031,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 1088,
										"src": "15326:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 1030,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "15326:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1033,
										"name": "teamId",
										"nodeType": "VariableDeclaration",
										"scope": 1088,
										"src": "15342:13:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1032,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "15342:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "15325:31:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1038,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "15406:0:2"
							},
							"scope": 4288,
							"src": "15303:505:2",
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 1122,
								"nodeType": "Block",
								"src": "16071:261:2",
								"statements": [
									{
										"assignments": [
											1096
										],
										"declarations": [
											{
												"constant": false,
												"id": 1096,
												"name": "cachedBlockHash",
												"nodeType": "VariableDeclaration",
												"scope": 1123,
												"src": "16081:22:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 1095,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "16081:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1100,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1097,
												"name": "blockHash32Map",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 173,
												"src": "16106:14:2",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_uint32_$_t_uint32_$",
													"typeString": "mapping(uint32 => uint32)"
												}
											},
											"id": 1099,
											"indexExpression": {
												"argumentTypes": null,
												"id": 1098,
												"name": "blockNum",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1090,
												"src": "16121:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "16106:24:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "16081:49:2"
									},
									{
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 1103,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 1101,
												"name": "cachedBlockHash",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1096,
												"src": "16145:15:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "==",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1102,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "16164:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"src": "16145:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": null,
										"id": 1119,
										"nodeType": "IfStatement",
										"src": "16141:152:2",
										"trueBody": {
											"id": 1118,
											"nodeType": "Block",
											"src": "16167:126:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"id": 1110,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"id": 1104,
															"name": "cachedBlockHash",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1096,
															"src": "16181:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"id": 1107,
																			"name": "blockNum",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1090,
																			"src": "16216:8:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		],
																		"id": 1106,
																		"name": "blockhash",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 4363,
																		"src": "16206:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_function_blockhash_view$_t_uint256_$returns$_t_bytes32_$",
																			"typeString": "function (uint256) view returns (bytes32)"
																		}
																	},
																	"id": 1108,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"kind": "functionCall",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "16206:19:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bytes32",
																		"typeString": "bytes32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_bytes32",
																		"typeString": "bytes32"
																	}
																],
																"id": 1105,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"nodeType": "ElementaryTypeNameExpression",
																"src": "16199:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_uint32_$",
																	"typeString": "type(uint32)"
																},
																"typeName": "uint32"
															},
															"id": 1109,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "typeConversion",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "16199:27:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "16181:45:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1111,
													"nodeType": "ExpressionStatement",
													"src": "16181:45:2"
												},
												{
													"expression": {
														"argumentTypes": null,
														"id": 1116,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 1112,
																"name": "blockHash32Map",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 173,
																"src": "16240:14:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_mapping$_t_uint32_$_t_uint32_$",
																	"typeString": "mapping(uint32 => uint32)"
																}
															},
															"id": 1114,
															"indexExpression": {
																"argumentTypes": null,
																"id": 1113,
																"name": "blockNum",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1090,
																"src": "16255:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"nodeType": "IndexAccess",
															"src": "16240:24:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"id": 1115,
															"name": "cachedBlockHash",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1096,
															"src": "16267:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "16240:42:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1117,
													"nodeType": "ExpressionStatement",
													"src": "16240:42:2"
												}
											]
										}
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 1120,
											"name": "cachedBlockHash",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1096,
											"src": "16310:15:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"functionReturnParameters": 1094,
										"id": 1121,
										"nodeType": "Return",
										"src": "16303:22:2"
									}
								]
							},
							"documentation": "@notice Caches the hash for a specific block in a map.  Only uses last 32 bits.\n @param blockNum Block number\n @return Last 32 bits of block hash, or 0 if not available",
							"id": 1123,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": false,
							"modifiers": [],
							"name": "cacheBlockHash32",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1091,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1090,
										"name": "blockNum",
										"nodeType": "VariableDeclaration",
										"scope": 1123,
										"src": "16031:15:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1089,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "16031:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "16030:17:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1094,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1093,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1123,
										"src": "16063:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1092,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "16063:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "16062:8:2"
							},
							"scope": 4288,
							"src": "16005:327:2",
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 1151,
								"nodeType": "Block",
								"src": "16583:189:2",
								"statements": [
									{
										"assignments": [
											1131
										],
										"declarations": [
											{
												"constant": false,
												"id": 1131,
												"name": "blockHash32",
												"nodeType": "VariableDeclaration",
												"scope": 1152,
												"src": "16593:18:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 1130,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "16593:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1137,
										"initialValue": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"id": 1134,
															"name": "blockNum",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1125,
															"src": "16631:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														],
														"id": 1133,
														"name": "blockhash",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4363,
														"src": "16621:9:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_blockhash_view$_t_uint256_$returns$_t_bytes32_$",
															"typeString": "function (uint256) view returns (bytes32)"
														}
													},
													"id": 1135,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "16621:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bytes32",
														"typeString": "bytes32"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bytes32",
														"typeString": "bytes32"
													}
												],
												"id": 1132,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "16614:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 1136,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "16614:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "16593:48:2"
									},
									{
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 1140,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 1138,
												"name": "blockHash32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1131,
												"src": "16656:11:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "==",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1139,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "16671:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"src": "16656:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": null,
										"id": 1148,
										"nodeType": "IfStatement",
										"src": "16652:85:2",
										"trueBody": {
											"id": 1147,
											"nodeType": "Block",
											"src": "16674:63:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"id": 1145,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"id": 1141,
															"name": "blockHash32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1131,
															"src": "16688:11:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 1142,
																"name": "blockHash32Map",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 173,
																"src": "16702:14:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_mapping$_t_uint32_$_t_uint32_$",
																	"typeString": "mapping(uint32 => uint32)"
																}
															},
															"id": 1144,
															"indexExpression": {
																"argumentTypes": null,
																"id": 1143,
																"name": "blockNum",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1125,
																"src": "16717:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "16702:24:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "16688:38:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1146,
													"nodeType": "ExpressionStatement",
													"src": "16688:38:2"
												}
											]
										}
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 1149,
											"name": "blockHash32",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1131,
											"src": "16754:11:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"functionReturnParameters": 1129,
										"id": 1150,
										"nodeType": "Return",
										"src": "16747:18:2"
									}
								]
							},
							"documentation": "@notice Get hash for a specific block.  Only uses last 32 bits.\n @param blockNum Block number\n @return Last 32 bits of block hash, or 0 if not available",
							"id": 1152,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "readBlockHash32",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1126,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1125,
										"name": "blockNum",
										"nodeType": "VariableDeclaration",
										"scope": 1152,
										"src": "16538:15:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1124,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "16538:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "16537:17:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1129,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1128,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1152,
										"src": "16575:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1127,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "16575:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "16574:8:2"
							},
							"scope": 4288,
							"src": "16513:259:2",
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 1160,
								"nodeType": "Block",
								"src": "16902:44:2",
								"statements": [
									{
										"expression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 1157,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "16919:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 1158,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "length",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "16919:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"functionReturnParameters": 1156,
										"id": 1159,
										"nodeType": "Return",
										"src": "16912:27:2"
									}
								]
							},
							"documentation": "@notice Returns total number of games that have been created.",
							"id": 1161,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "numberOfGames",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1153,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "16870:2:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1156,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1155,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1161,
										"src": "16893:7:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 1154,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "16893:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "16892:9:2"
							},
							"scope": 4288,
							"src": "16848:98:2",
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 1286,
								"nodeType": "Block",
								"src": "17332:1119:2",
								"statements": [
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1178,
												"name": "gameIdList",
												"nodeType": "VariableDeclaration",
												"scope": 1287,
												"src": "17342:29:2",
												"stateVariable": false,
												"storageLocation": "memory",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$10_memory_ptr",
													"typeString": "uint256[10]"
												},
												"typeName": {
													"baseType": {
														"id": 1176,
														"name": "uint256",
														"nodeType": "ElementaryTypeName",
														"src": "17342:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"id": 1177,
													"length": {
														"argumentTypes": null,
														"hexValue": "3130",
														"id": 1175,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "17350:2:2",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": null,
															"typeString": null
														},
														"value": "10"
													},
													"nodeType": "ArrayTypeName",
													"src": "17342:11:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint256_$10_storage_ptr",
														"typeString": "uint256[10]"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1179,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "17342:29:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1181,
												"name": "gameIdCount",
												"nodeType": "VariableDeclaration",
												"scope": 1287,
												"src": "17381:18:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 1180,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "17381:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1182,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "17381:18:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1184,
												"name": "gameId",
												"nodeType": "VariableDeclaration",
												"scope": 1287,
												"src": "17409:14:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"typeName": {
													"id": 1183,
													"name": "uint256",
													"nodeType": "ElementaryTypeName",
													"src": "17409:7:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1185,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "17409:14:2"
									},
									{
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"id": 1189,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1186,
													"name": "gameDataArray",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 186,
													"src": "17437:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
														"typeString": "struct WorldGame.GameData storage ref[] storage ref"
													}
												},
												"id": 1187,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "length",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "17437:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": ">",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1188,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "17460:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"src": "17437:24:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": null,
										"id": 1280,
										"nodeType": "IfStatement",
										"src": "17433:961:2",
										"trueBody": {
											"id": 1279,
											"nodeType": "Block",
											"src": "17463:931:2",
											"statements": [
												{
													"assignments": [
														1191
													],
													"declarations": [
														{
															"constant": false,
															"id": 1191,
															"name": "startPosition",
															"nodeType": "VariableDeclaration",
															"scope": 1287,
															"src": "17553:21:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"typeName": {
																"id": 1190,
																"name": "uint256",
																"nodeType": "ElementaryTypeName",
																"src": "17553:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 1196,
													"initialValue": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 1195,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1192,
																"name": "gameDataArray",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 186,
																"src": "17577:13:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
																	"typeString": "struct WorldGame.GameData storage ref[] storage ref"
																}
															},
															"id": 1193,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "length",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "17577:20:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "-",
														"rightExpression": {
															"argumentTypes": null,
															"hexValue": "31",
															"id": 1194,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "17600:1:2",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_1_by_1",
																"typeString": "int_const 1"
															},
															"value": "1"
														},
														"src": "17577:24:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "17553:48:2"
												},
												{
													"condition": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"id": 1203,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"id": 1199,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"id": 1197,
																"name": "offset",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1163,
																"src": "17619:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": ">",
															"rightExpression": {
																"argumentTypes": null,
																"hexValue": "30",
																"id": 1198,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "17628:1:2",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_0_by_1",
																	"typeString": "int_const 0"
																},
																"value": "0"
															},
															"src": "17619:10:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "&&",
														"rightExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"id": 1202,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"id": 1200,
																"name": "offset",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1163,
																"src": "17633:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "<",
															"rightExpression": {
																"argumentTypes": null,
																"id": 1201,
																"name": "startPosition",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1191,
																"src": "17642:13:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"src": "17633:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"src": "17619:36:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"falseBody": null,
													"id": 1209,
													"nodeType": "IfStatement",
													"src": "17615:97:2",
													"trueBody": {
														"id": 1208,
														"nodeType": "Block",
														"src": "17657:55:2",
														"statements": [
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 1206,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"id": 1204,
																		"name": "startPosition",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1191,
																		"src": "17675:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"id": 1205,
																		"name": "offset",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1163,
																		"src": "17691:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"src": "17675:22:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"id": 1207,
																"nodeType": "ExpressionStatement",
																"src": "17675:22:2"
															}
														]
													}
												},
												{
													"body": {
														"id": 1277,
														"nodeType": "Block",
														"src": "17867:517:2",
														"statements": [
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 1226,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"id": 1222,
																		"name": "gameId",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1184,
																		"src": "17885:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		"id": 1225,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"id": 1223,
																			"name": "i",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1211,
																			"src": "17894:1:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint256",
																				"typeString": "uint256"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "-",
																		"rightExpression": {
																			"argumentTypes": null,
																			"hexValue": "31",
																			"id": 1224,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "17898:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_1_by_1",
																				"typeString": "int_const 1"
																			},
																			"value": "1"
																		},
																		"src": "17894:5:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"src": "17885:14:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"id": 1227,
																"nodeType": "ExpressionStatement",
																"src": "17885:14:2"
															},
															{
																"assignments": [
																	1229
																],
																"declarations": [
																	{
																		"constant": false,
																		"id": 1229,
																		"name": "game",
																		"nodeType": "VariableDeclaration",
																		"scope": 1287,
																		"src": "17918:21:2",
																		"stateVariable": false,
																		"storageLocation": "storage",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData"
																		},
																		"typeName": {
																			"contractScope": null,
																			"id": 1228,
																			"name": "GameData",
																			"nodeType": "UserDefinedTypeName",
																			"referencedDeclaration": 245,
																			"src": "17918:8:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData"
																			}
																		},
																		"value": null,
																		"visibility": "internal"
																	}
																],
																"id": 1233,
																"initialValue": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 1230,
																		"name": "gameDataArray",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 186,
																		"src": "17942:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
																			"typeString": "struct WorldGame.GameData storage ref[] storage ref"
																		}
																	},
																	"id": 1232,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 1231,
																		"name": "gameId",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1184,
																		"src": "17956:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "17942:21:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage",
																		"typeString": "struct WorldGame.GameData storage ref"
																	}
																},
																"nodeType": "VariableDeclarationStatement",
																"src": "17918:45:2"
															},
															{
																"body": {
																	"id": 1264,
																	"nodeType": "Block",
																	"src": "18027:234:2",
																	"statements": [
																		{
																			"condition": {
																				"argumentTypes": null,
																				"commonType": {
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				},
																				"id": 1251,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": false,
																				"lValueRequested": false,
																				"leftExpression": {
																					"argumentTypes": null,
																					"baseExpression": {
																						"argumentTypes": null,
																						"expression": {
																							"argumentTypes": null,
																							"id": 1245,
																							"name": "game",
																							"nodeType": "Identifier",
																							"overloadedDeclarations": [],
																							"referencedDeclaration": 1229,
																							"src": "18053:4:2",
																							"typeDescriptions": {
																								"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																								"typeString": "struct WorldGame.GameData storage pointer"
																							}
																						},
																						"id": 1246,
																						"isConstant": false,
																						"isLValue": true,
																						"isPure": false,
																						"lValueRequested": false,
																						"memberName": "playerAddresses",
																						"nodeType": "MemberAccess",
																						"referencedDeclaration": 224,
																						"src": "18053:20:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_array$_t_address_$8_storage",
																							"typeString": "address[8] storage ref"
																						}
																					},
																					"id": 1248,
																					"indexExpression": {
																						"argumentTypes": null,
																						"id": 1247,
																						"name": "j",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 1235,
																						"src": "18074:1:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_uint32",
																							"typeString": "uint32"
																						}
																					},
																					"isConstant": false,
																					"isLValue": true,
																					"isPure": false,
																					"lValueRequested": false,
																					"nodeType": "IndexAccess",
																					"src": "18053:23:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_address",
																						"typeString": "address"
																					}
																				},
																				"nodeType": "BinaryOperation",
																				"operator": "==",
																				"rightExpression": {
																					"argumentTypes": null,
																					"expression": {
																						"argumentTypes": null,
																						"id": 1249,
																						"name": "msg",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 4372,
																						"src": "18080:3:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_magic_message",
																							"typeString": "msg"
																						}
																					},
																					"id": 1250,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"lValueRequested": false,
																					"memberName": "sender",
																					"nodeType": "MemberAccess",
																					"referencedDeclaration": null,
																					"src": "18080:10:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_address",
																						"typeString": "address"
																					}
																				},
																				"src": "18053:37:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_bool",
																					"typeString": "bool"
																				}
																			},
																			"falseBody": null,
																			"id": 1263,
																			"nodeType": "IfStatement",
																			"src": "18049:194:2",
																			"trueBody": {
																				"id": 1262,
																				"nodeType": "Block",
																				"src": "18092:151:2",
																				"statements": [
																					{
																						"expression": {
																							"argumentTypes": null,
																							"id": 1256,
																							"isConstant": false,
																							"isLValue": false,
																							"isPure": false,
																							"lValueRequested": false,
																							"leftHandSide": {
																								"argumentTypes": null,
																								"baseExpression": {
																									"argumentTypes": null,
																									"id": 1252,
																									"name": "gameIdList",
																									"nodeType": "Identifier",
																									"overloadedDeclarations": [],
																									"referencedDeclaration": 1178,
																									"src": "18118:10:2",
																									"typeDescriptions": {
																										"typeIdentifier": "t_array$_t_uint256_$10_memory_ptr",
																										"typeString": "uint256[10] memory"
																									}
																								},
																								"id": 1254,
																								"indexExpression": {
																									"argumentTypes": null,
																									"id": 1253,
																									"name": "gameIdCount",
																									"nodeType": "Identifier",
																									"overloadedDeclarations": [],
																									"referencedDeclaration": 1181,
																									"src": "18129:11:2",
																									"typeDescriptions": {
																										"typeIdentifier": "t_uint32",
																										"typeString": "uint32"
																									}
																								},
																								"isConstant": false,
																								"isLValue": true,
																								"isPure": false,
																								"lValueRequested": true,
																								"nodeType": "IndexAccess",
																								"src": "18118:23:2",
																								"typeDescriptions": {
																									"typeIdentifier": "t_uint256",
																									"typeString": "uint256"
																								}
																							},
																							"nodeType": "Assignment",
																							"operator": "=",
																							"rightHandSide": {
																								"argumentTypes": null,
																								"id": 1255,
																								"name": "gameId",
																								"nodeType": "Identifier",
																								"overloadedDeclarations": [],
																								"referencedDeclaration": 1184,
																								"src": "18144:6:2",
																								"typeDescriptions": {
																									"typeIdentifier": "t_uint256",
																									"typeString": "uint256"
																								}
																							},
																							"src": "18118:32:2",
																							"typeDescriptions": {
																								"typeIdentifier": "t_uint256",
																								"typeString": "uint256"
																							}
																						},
																						"id": 1257,
																						"nodeType": "ExpressionStatement",
																						"src": "18118:32:2"
																					},
																					{
																						"expression": {
																							"argumentTypes": null,
																							"id": 1259,
																							"isConstant": false,
																							"isLValue": false,
																							"isPure": false,
																							"lValueRequested": false,
																							"nodeType": "UnaryOperation",
																							"operator": "++",
																							"prefix": false,
																							"src": "18176:13:2",
																							"subExpression": {
																								"argumentTypes": null,
																								"id": 1258,
																								"name": "gameIdCount",
																								"nodeType": "Identifier",
																								"overloadedDeclarations": [],
																								"referencedDeclaration": 1181,
																								"src": "18176:11:2",
																								"typeDescriptions": {
																									"typeIdentifier": "t_uint32",
																									"typeString": "uint32"
																								}
																							},
																							"typeDescriptions": {
																								"typeIdentifier": "t_uint32",
																								"typeString": "uint32"
																							}
																						},
																						"id": 1260,
																						"nodeType": "ExpressionStatement",
																						"src": "18176:13:2"
																					},
																					{
																						"id": 1261,
																						"nodeType": "Break",
																						"src": "18215:5:2"
																					}
																				]
																			}
																		}
																	]
																},
																"condition": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 1241,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 1238,
																		"name": "j",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1235,
																		"src": "18000:1:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "<",
																	"rightExpression": {
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 1239,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1229,
																			"src": "18004:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 1240,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "playerCount",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 220,
																		"src": "18004:16:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "18000:20:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"id": 1265,
																"initializationExpression": {
																	"assignments": [
																		1235
																	],
																	"declarations": [
																		{
																			"constant": false,
																			"id": 1235,
																			"name": "j",
																			"nodeType": "VariableDeclaration",
																			"scope": 1287,
																			"src": "17986:8:2",
																			"stateVariable": false,
																			"storageLocation": "default",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			},
																			"typeName": {
																				"id": 1234,
																				"name": "uint32",
																				"nodeType": "ElementaryTypeName",
																				"src": "17986:6:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			"value": null,
																			"visibility": "internal"
																		}
																	],
																	"id": 1237,
																	"initialValue": {
																		"argumentTypes": null,
																		"hexValue": "30",
																		"id": 1236,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "17997:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		},
																		"value": "0"
																	},
																	"nodeType": "VariableDeclarationStatement",
																	"src": "17986:12:2"
																},
																"loopExpression": {
																	"expression": {
																		"argumentTypes": null,
																		"id": 1243,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"nodeType": "UnaryOperation",
																		"operator": "++",
																		"prefix": false,
																		"src": "18022:3:2",
																		"subExpression": {
																			"argumentTypes": null,
																			"id": 1242,
																			"name": "j",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1235,
																			"src": "18022:1:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"id": 1244,
																	"nodeType": "ExpressionStatement",
																	"src": "18022:3:2"
																},
																"nodeType": "ForStatement",
																"src": "17981:280:2"
															},
															{
																"condition": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	},
																	"id": 1273,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"id": 1268,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"id": 1266,
																			"name": "gameIdCount",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1181,
																			"src": "18283:11:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "==",
																		"rightExpression": {
																			"argumentTypes": null,
																			"hexValue": "3130",
																			"id": 1267,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "18298:2:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_10_by_1",
																				"typeString": "int_const 10"
																			},
																			"value": "10"
																		},
																		"src": "18283:17:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "||",
																	"rightExpression": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		"id": 1272,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"arguments": [],
																			"expression": {
																				"argumentTypes": [],
																				"id": 1269,
																				"name": "gasleft",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 4365,
																				"src": "18304:7:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_function_gasleft_view$__$returns$_t_uint256_$",
																					"typeString": "function () view returns (uint256)"
																				}
																			},
																			"id": 1270,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"kind": "functionCall",
																			"lValueRequested": false,
																			"names": [],
																			"nodeType": "FunctionCall",
																			"src": "18304:9:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint256",
																				"typeString": "uint256"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "<",
																		"rightExpression": {
																			"argumentTypes": null,
																			"hexValue": "313030303030",
																			"id": 1271,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "18316:6:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_100000_by_1",
																				"typeString": "int_const 100000"
																			},
																			"value": "100000"
																		},
																		"src": "18304:18:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	},
																	"src": "18283:39:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"falseBody": null,
																"id": 1276,
																"nodeType": "IfStatement",
																"src": "18279:91:2",
																"trueBody": {
																	"id": 1275,
																	"nodeType": "Block",
																	"src": "18324:46:2",
																	"statements": [
																		{
																			"id": 1274,
																			"nodeType": "Break",
																			"src": "18346:5:2"
																		}
																	]
																}
															}
														]
													},
													"condition": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 1218,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 1216,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1211,
															"src": "17855:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": ">",
														"rightExpression": {
															"argumentTypes": null,
															"hexValue": "30",
															"id": 1217,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "17859:1:2",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														},
														"src": "17855:5:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"id": 1278,
													"initializationExpression": {
														"assignments": [
															1211
														],
														"declarations": [
															{
																"constant": false,
																"id": 1211,
																"name": "i",
																"nodeType": "VariableDeclaration",
																"scope": 1287,
																"src": "17824:9:2",
																"stateVariable": false,
																"storageLocation": "default",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																"typeName": {
																	"id": 1210,
																	"name": "uint256",
																	"nodeType": "ElementaryTypeName",
																	"src": "17824:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"value": null,
																"visibility": "internal"
															}
														],
														"id": 1215,
														"initialValue": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"id": 1214,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"id": 1212,
																"name": "startPosition",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1191,
																"src": "17836:13:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "+",
															"rightExpression": {
																"argumentTypes": null,
																"hexValue": "31",
																"id": 1213,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "17852:1:2",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_1_by_1",
																	"typeString": "int_const 1"
																},
																"value": "1"
															},
															"src": "17836:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "VariableDeclarationStatement",
														"src": "17824:29:2"
													},
													"loopExpression": {
														"expression": {
															"argumentTypes": null,
															"id": 1220,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "UnaryOperation",
															"operator": "--",
															"prefix": false,
															"src": "17862:3:2",
															"subExpression": {
																"argumentTypes": null,
																"id": 1219,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1211,
																"src": "17862:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"id": 1221,
														"nodeType": "ExpressionStatement",
														"src": "17862:3:2"
													},
													"nodeType": "ForStatement",
													"src": "17819:565:2"
												}
											]
										}
									},
									{
										"expression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"id": 1281,
													"name": "gameIdList",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1178,
													"src": "18412:10:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint256_$10_memory_ptr",
														"typeString": "uint256[10] memory"
													}
												},
												{
													"argumentTypes": null,
													"id": 1282,
													"name": "gameIdCount",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1181,
													"src": "18424:11:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"id": 1283,
													"name": "gameId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1184,
													"src": "18437:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"id": 1284,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "18411:33:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$_t_array$_t_uint256_$10_memory_ptr_$_t_uint32_$_t_uint256_$",
												"typeString": "tuple(uint256[10] memory,uint32,uint256)"
											}
										},
										"functionReturnParameters": 1173,
										"id": 1285,
										"nodeType": "Return",
										"src": "18404:40:2"
									}
								]
							},
							"documentation": "@notice Returns recent game ids where msg.sender is a player.\n @param offset Position in game data array to start search from\n @return List of game ids\n @return Number of game ids\n @return Position in loop when ended",
							"id": 1287,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "listGamesForAddress",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1164,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1163,
										"name": "offset",
										"nodeType": "VariableDeclaration",
										"scope": 1287,
										"src": "17234:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 1162,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "17234:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "17233:16:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1173,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1168,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1287,
										"src": "17297:11:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint256_$10_memory_ptr",
											"typeString": "uint256[10]"
										},
										"typeName": {
											"baseType": {
												"id": 1165,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "17297:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"id": 1167,
											"length": {
												"argumentTypes": null,
												"hexValue": "3130",
												"id": 1166,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "17305:2:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												},
												"value": "10"
											},
											"nodeType": "ArrayTypeName",
											"src": "17297:11:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint256_$10_storage_ptr",
												"typeString": "uint256[10]"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1170,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1287,
										"src": "17310:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1169,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "17310:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1172,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1287,
										"src": "17318:7:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 1171,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "17318:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "17296:30:2"
							},
							"scope": 4288,
							"src": "17205:1246:2",
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 1339,
								"nodeType": "Block",
								"src": "18840:302:2",
								"statements": [
									{
										"assignments": [
											1301
										],
										"declarations": [
											{
												"constant": false,
												"id": 1301,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 1340,
												"src": "18850:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 1300,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "18850:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1305,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1302,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "18874:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 1304,
											"indexExpression": {
												"argumentTypes": null,
												"id": 1303,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1289,
												"src": "18888:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "18874:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "18850:45:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1310,
												"name": "regionOwnersList",
												"nodeType": "VariableDeclaration",
												"scope": 1340,
												"src": "18906:44:2",
												"stateVariable": false,
												"storageLocation": "memory",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
													"typeString": "uint32[25]"
												},
												"typeName": {
													"baseType": {
														"id": 1308,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "18906:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1309,
													"length": {
														"argumentTypes": null,
														"id": 1307,
														"name": "REGION_COUNT",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 129,
														"src": "18913:12:2",
														"typeDescriptions": {
															"typeIdentifier": null,
															"typeString": null
														}
													},
													"nodeType": "ArrayTypeName",
													"src": "18906:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage_ptr",
														"typeString": "uint32[25]"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1311,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "18906:44:2"
									},
									{
										"body": {
											"id": 1332,
											"nodeType": "Block",
											"src": "19002:77:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"id": 1330,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 1322,
																"name": "regionOwnersList",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1310,
																"src": "19016:16:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
																	"typeString": "uint32[25] memory"
																}
															},
															"id": 1324,
															"indexExpression": {
																"argumentTypes": null,
																"id": 1323,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1313,
																"src": "19033:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"nodeType": "IndexAccess",
															"src": "19016:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1326,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1301,
																		"src": "19047:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1327,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "regionOwners",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 228,
																	"src": "19047:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1328,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1313,
																	"src": "19066:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1325,
																"name": "getData8",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4158,
																"src": "19038:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1329,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "19038:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "19016:52:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1331,
													"nodeType": "ExpressionStatement",
													"src": "19016:52:2"
												}
											]
										},
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 1318,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 1316,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1313,
												"src": "18979:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "<",
											"rightExpression": {
												"argumentTypes": null,
												"id": 1317,
												"name": "REGION_COUNT",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 129,
												"src": "18983:12:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "18979:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"id": 1333,
										"initializationExpression": {
											"assignments": [
												1313
											],
											"declarations": [
												{
													"constant": false,
													"id": 1313,
													"name": "i",
													"nodeType": "VariableDeclaration",
													"scope": 1340,
													"src": "18965:8:2",
													"stateVariable": false,
													"storageLocation": "default",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"typeName": {
														"id": 1312,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "18965:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"value": null,
													"visibility": "internal"
												}
											],
											"id": 1315,
											"initialValue": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1314,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "18976:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"nodeType": "VariableDeclarationStatement",
											"src": "18965:12:2"
										},
										"loopExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 1320,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "UnaryOperation",
												"operator": "++",
												"prefix": false,
												"src": "18997:3:2",
												"subExpression": {
													"argumentTypes": null,
													"id": 1319,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1313,
													"src": "18997:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1321,
											"nodeType": "ExpressionStatement",
											"src": "18997:3:2"
										},
										"nodeType": "ForStatement",
										"src": "18960:119:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"id": 1334,
													"name": "regionOwnersList",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1310,
													"src": "19097:16:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
														"typeString": "uint32[25] memory"
													}
												},
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1335,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1301,
														"src": "19115:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 1336,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "regionSoldiers",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 232,
													"src": "19115:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												}
											],
											"id": 1337,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "19096:39:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$_t_array$_t_uint32_$25_memory_ptr_$_t_array$_t_uint32_$25_storage_$",
												"typeString": "tuple(uint32[25] memory,uint32[25] storage ref)"
											}
										},
										"functionReturnParameters": 1299,
										"id": 1338,
										"nodeType": "Return",
										"src": "19089:46:2"
									}
								]
							},
							"documentation": "@notice Returns the number of soldiers deployed to each region and region owners.\n @param gameId Id of game \n @return List of which player owns each region\n @return List of number of soldiers deployed to each region",
							"id": 1340,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "soldiersByRegion",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1290,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1289,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 1340,
										"src": "18728:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 1288,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "18728:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "18727:16:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1299,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1294,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1340,
										"src": "18791:20:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
											"typeString": "uint32[25]"
										},
										"typeName": {
											"baseType": {
												"id": 1291,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "18791:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1293,
											"length": {
												"argumentTypes": null,
												"id": 1292,
												"name": "REGION_COUNT",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 129,
												"src": "18798:12:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "18791:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$25_storage_ptr",
												"typeString": "uint32[25]"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1298,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1340,
										"src": "18813:20:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
											"typeString": "uint32[25]"
										},
										"typeName": {
											"baseType": {
												"id": 1295,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "18813:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1297,
											"length": {
												"argumentTypes": null,
												"id": 1296,
												"name": "REGION_COUNT",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 129,
												"src": "18820:12:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "18813:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$25_storage_ptr",
												"typeString": "uint32[25]"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "18790:44:2"
							},
							"scope": 4288,
							"src": "18702:440:2",
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 1379,
								"nodeType": "Block",
								"src": "19575:277:2",
								"statements": [
									{
										"assignments": [
											1360
										],
										"declarations": [
											{
												"constant": false,
												"id": 1360,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 1380,
												"src": "19585:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 1359,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "19585:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1364,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1361,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "19609:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 1363,
											"indexExpression": {
												"argumentTypes": null,
												"id": 1362,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1342,
												"src": "19623:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "19609:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "19585:45:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1365,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1360,
														"src": "19661:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 1366,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "turnTeamId",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 214,
													"src": "19661:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1367,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1360,
														"src": "19691:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 1368,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "turnNum",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 216,
													"src": "19691:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1369,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1360,
														"src": "19718:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 1370,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "maxBlocksPerTurn",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 218,
													"src": "19718:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1371,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1360,
														"src": "19754:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 1372,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "playerCount",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 220,
													"src": "19754:16:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1373,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1360,
														"src": "19785:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 1374,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "playerAddresses",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 224,
													"src": "19785:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_address_$8_storage",
														"typeString": "address[8] storage ref"
													}
												},
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1375,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1360,
														"src": "19819:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 1376,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "teamAvatars",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 244,
													"src": "19819:16:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bytes8",
														"typeString": "bytes8"
													}
												}
											],
											"id": 1377,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "19647:198:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$_t_uint32_$_t_uint32_$_t_uint32_$_t_uint32_$_t_array$_t_address_$8_storage_$_t_bytes8_$",
												"typeString": "tuple(uint32,uint32,uint32,uint32,address[8] storage ref,bytes8)"
											}
										},
										"functionReturnParameters": 1358,
										"id": 1378,
										"nodeType": "Return",
										"src": "19640:205:2"
									}
								]
							},
							"documentation": "@notice Returns information about current turn and players.\n @param gameId Id of game \n @return Id of current player\n @return Turn number\n @return Max blocks per turn\n @return Number of players\n @return Player addresses",
							"id": 1380,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "turnAndPlayerInfo",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1343,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1342,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 1380,
										"src": "19445:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 1341,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "19445:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "19444:16:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1358,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1345,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1380,
										"src": "19508:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1344,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "19508:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1347,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1380,
										"src": "19516:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1346,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "19516:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1349,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1380,
										"src": "19524:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1348,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "19524:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1351,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1380,
										"src": "19532:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1350,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "19532:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1355,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1380,
										"src": "19540:20:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_address_$8_memory_ptr",
											"typeString": "address[8]"
										},
										"typeName": {
											"baseType": {
												"id": 1352,
												"name": "address",
												"nodeType": "ElementaryTypeName",
												"src": "19540:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"id": 1354,
											"length": {
												"argumentTypes": null,
												"id": 1353,
												"name": "MAX_PLAYERS",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 135,
												"src": "19548:11:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "19540:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_address_$8_storage_ptr",
												"typeString": "address[8]"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1357,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1380,
										"src": "19562:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes8",
											"typeString": "bytes8"
										},
										"typeName": {
											"id": 1356,
											"name": "bytes8",
											"nodeType": "ElementaryTypeName",
											"src": "19562:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes8",
												"typeString": "bytes8"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "19507:62:2"
							},
							"scope": 4288,
							"src": "19418:434:2",
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 1446,
								"nodeType": "Block",
								"src": "20213:445:2",
								"statements": [
									{
										"assignments": [
											1394
										],
										"declarations": [
											{
												"constant": false,
												"id": 1394,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 1447,
												"src": "20223:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 1393,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "20223:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1398,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1395,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "20247:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 1397,
											"indexExpression": {
												"argumentTypes": null,
												"id": 1396,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1382,
												"src": "20261:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "20247:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "20223:45:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1403,
												"name": "undeployedSoldiersList",
												"nodeType": "VariableDeclaration",
												"scope": 1447,
												"src": "20279:49:2",
												"stateVariable": false,
												"storageLocation": "memory",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8]"
												},
												"typeName": {
													"baseType": {
														"id": 1401,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "20279:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1402,
													"length": {
														"argumentTypes": null,
														"id": 1400,
														"name": "MAX_PLAYERS",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 135,
														"src": "20286:11:2",
														"typeDescriptions": {
															"typeIdentifier": null,
															"typeString": null
														}
													},
													"nodeType": "ArrayTypeName",
													"src": "20279:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
														"typeString": "uint32[8]"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1404,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "20279:49:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1409,
												"name": "regionRewardList",
												"nodeType": "VariableDeclaration",
												"scope": 1447,
												"src": "20338:43:2",
												"stateVariable": false,
												"storageLocation": "memory",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8]"
												},
												"typeName": {
													"baseType": {
														"id": 1407,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "20338:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1408,
													"length": {
														"argumentTypes": null,
														"id": 1406,
														"name": "MAX_PLAYERS",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 135,
														"src": "20345:11:2",
														"typeDescriptions": {
															"typeIdentifier": null,
															"typeString": null
														}
													},
													"nodeType": "ArrayTypeName",
													"src": "20338:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
														"typeString": "uint32[8]"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1410,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "20338:43:2"
									},
									{
										"body": {
											"id": 1440,
											"nodeType": "Block",
											"src": "20432:160:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"id": 1429,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 1421,
																"name": "undeployedSoldiersList",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1403,
																"src": "20446:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																	"typeString": "uint32[8] memory"
																}
															},
															"id": 1423,
															"indexExpression": {
																"argumentTypes": null,
																"id": 1422,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1412,
																"src": "20469:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"nodeType": "IndexAccess",
															"src": "20446:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1425,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1394,
																		"src": "20484:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1426,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "undeployedSoldiers",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 226,
																	"src": "20484:23:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1427,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1412,
																	"src": "20509:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1424,
																"name": "getData32",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4095,
																"src": "20474:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1428,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "20474:37:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "20446:65:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1430,
													"nodeType": "ExpressionStatement",
													"src": "20446:65:2"
												},
												{
													"expression": {
														"argumentTypes": null,
														"id": 1438,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 1431,
																"name": "regionRewardList",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1409,
																"src": "20525:16:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																	"typeString": "uint32[8] memory"
																}
															},
															"id": 1433,
															"indexExpression": {
																"argumentTypes": null,
																"id": 1432,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1412,
																"src": "20542:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"nodeType": "IndexAccess",
															"src": "20525:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"id": 1435,
																	"name": "gameId",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1382,
																	"src": "20570:6:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1436,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1412,
																	"src": "20578:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1434,
																"name": "calculateRegionRewards",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2164,
																"src": "20547:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_view$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) view returns (uint32)"
																}
															},
															"id": 1437,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "20547:33:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "20525:55:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1439,
													"nodeType": "ExpressionStatement",
													"src": "20525:55:2"
												}
											]
										},
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 1417,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 1415,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1412,
												"src": "20410:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "<",
											"rightExpression": {
												"argumentTypes": null,
												"id": 1416,
												"name": "MAX_PLAYERS",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 135,
												"src": "20414:11:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "20410:15:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"id": 1441,
										"initializationExpression": {
											"assignments": [
												1412
											],
											"declarations": [
												{
													"constant": false,
													"id": 1412,
													"name": "i",
													"nodeType": "VariableDeclaration",
													"scope": 1447,
													"src": "20396:8:2",
													"stateVariable": false,
													"storageLocation": "default",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"typeName": {
														"id": 1411,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "20396:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"value": null,
													"visibility": "internal"
												}
											],
											"id": 1414,
											"initialValue": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1413,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "20407:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"nodeType": "VariableDeclarationStatement",
											"src": "20396:12:2"
										},
										"loopExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 1419,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "UnaryOperation",
												"operator": "++",
												"prefix": false,
												"src": "20427:3:2",
												"subExpression": {
													"argumentTypes": null,
													"id": 1418,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1412,
													"src": "20427:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1420,
											"nodeType": "ExpressionStatement",
											"src": "20427:3:2"
										},
										"nodeType": "ForStatement",
										"src": "20391:201:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"id": 1442,
													"name": "undeployedSoldiersList",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1403,
													"src": "20610:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
														"typeString": "uint32[8] memory"
													}
												},
												{
													"argumentTypes": null,
													"id": 1443,
													"name": "regionRewardList",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1409,
													"src": "20634:16:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
														"typeString": "uint32[8] memory"
													}
												}
											],
											"id": 1444,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "20609:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$_t_array$_t_uint32_$8_memory_ptr_$_t_array$_t_uint32_$8_memory_ptr_$",
												"typeString": "tuple(uint32[8] memory,uint32[8] memory)"
											}
										},
										"functionReturnParameters": 1392,
										"id": 1445,
										"nodeType": "Return",
										"src": "20602:49:2"
									}
								]
							},
							"documentation": "@notice Returns the number of undeployed soldiers for each player.\n @param gameId Id of game \n @return Number of undeployed soldiers for each player\n @return Reward points for each player",
							"id": 1447,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "undeployedSoldiers",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1383,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1382,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 1447,
										"src": "20103:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 1381,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "20103:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "20102:16:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1392,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1387,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1447,
										"src": "20166:19:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
											"typeString": "uint32[8]"
										},
										"typeName": {
											"baseType": {
												"id": 1384,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "20166:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1386,
											"length": {
												"argumentTypes": null,
												"id": 1385,
												"name": "MAX_PLAYERS",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 135,
												"src": "20173:11:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "20166:19:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
												"typeString": "uint32[8]"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1391,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1447,
										"src": "20187:19:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
											"typeString": "uint32[8]"
										},
										"typeName": {
											"baseType": {
												"id": 1388,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "20187:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1390,
											"length": {
												"argumentTypes": null,
												"id": 1389,
												"name": "MAX_PLAYERS",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 135,
												"src": "20194:11:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "20187:19:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
												"typeString": "uint32[8]"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "20165:42:2"
							},
							"scope": 4288,
							"src": "20075:583:2",
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 1560,
								"nodeType": "Block",
								"src": "21323:836:2",
								"statements": [
									{
										"assignments": [
											1471
										],
										"declarations": [
											{
												"constant": false,
												"id": 1471,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 1561,
												"src": "21333:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 1470,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "21333:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1475,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1472,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "21357:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 1474,
											"indexExpression": {
												"argumentTypes": null,
												"id": 1473,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1449,
												"src": "21371:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "21357:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "21333:45:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1480,
												"name": "fromRegionList",
												"nodeType": "VariableDeclaration",
												"scope": 1561,
												"src": "21389:50:2",
												"stateVariable": false,
												"storageLocation": "memory",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8]"
												},
												"typeName": {
													"baseType": {
														"id": 1478,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "21389:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1479,
													"length": {
														"argumentTypes": null,
														"id": 1477,
														"name": "MAX_ACTIONS_PER_TURN",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 138,
														"src": "21396:20:2",
														"typeDescriptions": {
															"typeIdentifier": null,
															"typeString": null
														}
													},
													"nodeType": "ArrayTypeName",
													"src": "21389:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
														"typeString": "uint32[8]"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1481,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "21389:50:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1486,
												"name": "toRegionList",
												"nodeType": "VariableDeclaration",
												"scope": 1561,
												"src": "21449:48:2",
												"stateVariable": false,
												"storageLocation": "memory",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8]"
												},
												"typeName": {
													"baseType": {
														"id": 1484,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "21449:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1485,
													"length": {
														"argumentTypes": null,
														"id": 1483,
														"name": "MAX_ACTIONS_PER_TURN",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 138,
														"src": "21456:20:2",
														"typeDescriptions": {
															"typeIdentifier": null,
															"typeString": null
														}
													},
													"nodeType": "ArrayTypeName",
													"src": "21449:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
														"typeString": "uint32[8]"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1487,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "21449:48:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1492,
												"name": "moveSoldierCountList",
												"nodeType": "VariableDeclaration",
												"scope": 1561,
												"src": "21507:56:2",
												"stateVariable": false,
												"storageLocation": "memory",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8]"
												},
												"typeName": {
													"baseType": {
														"id": 1490,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "21507:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1491,
													"length": {
														"argumentTypes": null,
														"id": 1489,
														"name": "MAX_ACTIONS_PER_TURN",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 138,
														"src": "21514:20:2",
														"typeDescriptions": {
															"typeIdentifier": null,
															"typeString": null
														}
													},
													"nodeType": "ArrayTypeName",
													"src": "21507:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
														"typeString": "uint32[8]"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1493,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "21507:56:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1498,
												"name": "submitBlockList",
												"nodeType": "VariableDeclaration",
												"scope": 1561,
												"src": "21573:51:2",
												"stateVariable": false,
												"storageLocation": "memory",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8]"
												},
												"typeName": {
													"baseType": {
														"id": 1496,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "21573:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1497,
													"length": {
														"argumentTypes": null,
														"id": 1495,
														"name": "MAX_ACTIONS_PER_TURN",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 138,
														"src": "21580:20:2",
														"typeDescriptions": {
															"typeIdentifier": null,
															"typeString": null
														}
													},
													"nodeType": "ArrayTypeName",
													"src": "21573:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
														"typeString": "uint32[8]"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1499,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "21573:51:2"
									},
									{
										"body": {
											"id": 1550,
											"nodeType": "Block",
											"src": "21685:289:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"id": 1518,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 1510,
																"name": "fromRegionList",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1480,
																"src": "21699:14:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																	"typeString": "uint32[8] memory"
																}
															},
															"id": 1512,
															"indexExpression": {
																"argumentTypes": null,
																"id": 1511,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1501,
																"src": "21714:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"nodeType": "IndexAccess",
															"src": "21699:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1514,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1471,
																		"src": "21729:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1515,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "fromRegionList",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 236,
																	"src": "21729:19:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1516,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1501,
																	"src": "21750:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1513,
																"name": "getData32",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4095,
																"src": "21719:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1517,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "21719:33:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "21699:53:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1519,
													"nodeType": "ExpressionStatement",
													"src": "21699:53:2"
												},
												{
													"expression": {
														"argumentTypes": null,
														"id": 1528,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 1520,
																"name": "toRegionList",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1486,
																"src": "21766:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																	"typeString": "uint32[8] memory"
																}
															},
															"id": 1522,
															"indexExpression": {
																"argumentTypes": null,
																"id": 1521,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1501,
																"src": "21779:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"nodeType": "IndexAccess",
															"src": "21766:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1524,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1471,
																		"src": "21794:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1525,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "toRegionList",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 238,
																	"src": "21794:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1526,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1501,
																	"src": "21813:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1523,
																"name": "getData32",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4095,
																"src": "21784:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1527,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "21784:31:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "21766:49:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1529,
													"nodeType": "ExpressionStatement",
													"src": "21766:49:2"
												},
												{
													"expression": {
														"argumentTypes": null,
														"id": 1538,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 1530,
																"name": "moveSoldierCountList",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1492,
																"src": "21829:20:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																	"typeString": "uint32[8] memory"
																}
															},
															"id": 1532,
															"indexExpression": {
																"argumentTypes": null,
																"id": 1531,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1501,
																"src": "21850:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"nodeType": "IndexAccess",
															"src": "21829:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1534,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1471,
																		"src": "21865:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1535,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "moveSoldierCountList",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 240,
																	"src": "21865:25:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1536,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1501,
																	"src": "21892:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1533,
																"name": "getData32",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4095,
																"src": "21855:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1537,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "21855:39:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "21829:65:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1539,
													"nodeType": "ExpressionStatement",
													"src": "21829:65:2"
												},
												{
													"expression": {
														"argumentTypes": null,
														"id": 1548,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 1540,
																"name": "submitBlockList",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1498,
																"src": "21908:15:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																	"typeString": "uint32[8] memory"
																}
															},
															"id": 1542,
															"indexExpression": {
																"argumentTypes": null,
																"id": 1541,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1501,
																"src": "21924:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"nodeType": "IndexAccess",
															"src": "21908:18:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1544,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1471,
																		"src": "21939:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1545,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "submitBlockList",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 242,
																	"src": "21939:20:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1546,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1501,
																	"src": "21961:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1543,
																"name": "getData32",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4095,
																"src": "21929:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1547,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "21929:34:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "21908:55:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1549,
													"nodeType": "ExpressionStatement",
													"src": "21908:55:2"
												}
											]
										},
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 1506,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 1504,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1501,
												"src": "21654:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "<",
											"rightExpression": {
												"argumentTypes": null,
												"id": 1505,
												"name": "MAX_ACTIONS_PER_TURN",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 138,
												"src": "21658:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "21654:24:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"id": 1551,
										"initializationExpression": {
											"assignments": [
												1501
											],
											"declarations": [
												{
													"constant": false,
													"id": 1501,
													"name": "i",
													"nodeType": "VariableDeclaration",
													"scope": 1561,
													"src": "21640:8:2",
													"stateVariable": false,
													"storageLocation": "default",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"typeName": {
														"id": 1500,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "21640:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"value": null,
													"visibility": "internal"
												}
											],
											"id": 1503,
											"initialValue": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1502,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "21651:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"nodeType": "VariableDeclarationStatement",
											"src": "21640:12:2"
										},
										"loopExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 1508,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "UnaryOperation",
												"operator": "++",
												"prefix": false,
												"src": "21680:3:2",
												"subExpression": {
													"argumentTypes": null,
													"id": 1507,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1501,
													"src": "21680:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1509,
											"nodeType": "ExpressionStatement",
											"src": "21680:3:2"
										},
										"nodeType": "ForStatement",
										"src": "21635:339:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1552,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1471,
														"src": "22005:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 1553,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "actionCount",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 234,
													"src": "22005:16:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"id": 1554,
													"name": "fromRegionList",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1480,
													"src": "22036:14:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
														"typeString": "uint32[8] memory"
													}
												},
												{
													"argumentTypes": null,
													"id": 1555,
													"name": "toRegionList",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1486,
													"src": "22065:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
														"typeString": "uint32[8] memory"
													}
												},
												{
													"argumentTypes": null,
													"id": 1556,
													"name": "moveSoldierCountList",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1492,
													"src": "22092:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
														"typeString": "uint32[8] memory"
													}
												},
												{
													"argumentTypes": null,
													"id": 1557,
													"name": "submitBlockList",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1498,
													"src": "22127:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
														"typeString": "uint32[8] memory"
													}
												}
											],
											"id": 1558,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "21991:161:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$_t_uint32_$_t_array$_t_uint32_$8_memory_ptr_$_t_array$_t_uint32_$8_memory_ptr_$_t_array$_t_uint32_$8_memory_ptr_$_t_array$_t_uint32_$8_memory_ptr_$",
												"typeString": "tuple(uint32,uint32[8] memory,uint32[8] memory,uint32[8] memory,uint32[8] memory)"
											}
										},
										"functionReturnParameters": 1469,
										"id": 1559,
										"nodeType": "Return",
										"src": "21984:168:2"
									}
								]
							},
							"documentation": "@notice Returns pending actions that have been queued for current turn.\n @param gameId Id of game \n @return Number of pending actions\n @return List of regions moving soldiers from\n @return List of regions moving soldiers to\n @return List with number of soldiers to move\n @return List with block number when action was queued",
							"id": 1561,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "pendingActions",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1450,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1449,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 1561,
										"src": "21063:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 1448,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "21063:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "21062:16:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1469,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1452,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1561,
										"src": "21139:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1451,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "21139:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1456,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1561,
										"src": "21159:28:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
											"typeString": "uint32[8]"
										},
										"typeName": {
											"baseType": {
												"id": 1453,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "21159:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1455,
											"length": {
												"argumentTypes": null,
												"id": 1454,
												"name": "MAX_ACTIONS_PER_TURN",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 138,
												"src": "21166:20:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "21159:28:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
												"typeString": "uint32[8]"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1460,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1561,
										"src": "21202:28:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
											"typeString": "uint32[8]"
										},
										"typeName": {
											"baseType": {
												"id": 1457,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "21202:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1459,
											"length": {
												"argumentTypes": null,
												"id": 1458,
												"name": "MAX_ACTIONS_PER_TURN",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 138,
												"src": "21209:20:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "21202:28:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
												"typeString": "uint32[8]"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1464,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1561,
										"src": "21245:28:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
											"typeString": "uint32[8]"
										},
										"typeName": {
											"baseType": {
												"id": 1461,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "21245:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1463,
											"length": {
												"argumentTypes": null,
												"id": 1462,
												"name": "MAX_ACTIONS_PER_TURN",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 138,
												"src": "21252:20:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "21245:28:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
												"typeString": "uint32[8]"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1468,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1561,
										"src": "21288:28:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
											"typeString": "uint32[8]"
										},
										"typeName": {
											"baseType": {
												"id": 1465,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "21288:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1467,
											"length": {
												"argumentTypes": null,
												"id": 1466,
												"name": "MAX_ACTIONS_PER_TURN",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 138,
												"src": "21295:20:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "21288:28:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
												"typeString": "uint32[8]"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "21125:197:2"
							},
							"scope": 4288,
							"src": "21039:1120:2",
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 1710,
								"nodeType": "Block",
								"src": "22781:1507:2",
								"statements": [
									{
										"assignments": [
											1583
										],
										"declarations": [
											{
												"constant": false,
												"id": 1583,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 1711,
												"src": "22791:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 1582,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "22791:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1587,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1584,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "22815:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 1586,
											"indexExpression": {
												"argumentTypes": null,
												"id": 1585,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1563,
												"src": "22829:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "22815:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "22791:45:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1592,
												"name": "submitBlockList",
												"nodeType": "VariableDeclaration",
												"scope": 1711,
												"src": "22847:51:2",
												"stateVariable": false,
												"storageLocation": "memory",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8]"
												},
												"typeName": {
													"baseType": {
														"id": 1590,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "22847:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1591,
													"length": {
														"argumentTypes": null,
														"id": 1589,
														"name": "MAX_ACTIONS_PER_TURN",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 138,
														"src": "22854:20:2",
														"typeDescriptions": {
															"typeIdentifier": null,
															"typeString": null
														}
													},
													"nodeType": "ArrayTypeName",
													"src": "22847:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
														"typeString": "uint32[8]"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1593,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "22847:51:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1598,
												"name": "remainingAttackerList",
												"nodeType": "VariableDeclaration",
												"scope": 1711,
												"src": "22908:57:2",
												"stateVariable": false,
												"storageLocation": "memory",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8]"
												},
												"typeName": {
													"baseType": {
														"id": 1596,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "22908:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1597,
													"length": {
														"argumentTypes": null,
														"id": 1595,
														"name": "MAX_ACTIONS_PER_TURN",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 138,
														"src": "22915:20:2",
														"typeDescriptions": {
															"typeIdentifier": null,
															"typeString": null
														}
													},
													"nodeType": "ArrayTypeName",
													"src": "22908:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
														"typeString": "uint32[8]"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1599,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "22908:57:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1604,
												"name": "remainingDefenderList",
												"nodeType": "VariableDeclaration",
												"scope": 1711,
												"src": "22975:57:2",
												"stateVariable": false,
												"storageLocation": "memory",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8]"
												},
												"typeName": {
													"baseType": {
														"id": 1602,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "22975:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1603,
													"length": {
														"argumentTypes": null,
														"id": 1601,
														"name": "MAX_ACTIONS_PER_TURN",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 138,
														"src": "22982:20:2",
														"typeDescriptions": {
															"typeIdentifier": null,
															"typeString": null
														}
													},
													"nodeType": "ArrayTypeName",
													"src": "22975:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
														"typeString": "uint32[8]"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1605,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "22975:57:2"
									},
									{
										"body": {
											"id": 1697,
											"nodeType": "Block",
											"src": "23093:995:2",
											"statements": [
												{
													"assignments": [
														1617
													],
													"declarations": [
														{
															"constant": false,
															"id": 1617,
															"name": "toRegion",
															"nodeType": "VariableDeclaration",
															"scope": 1711,
															"src": "23107:15:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"typeName": {
																"id": 1616,
																"name": "uint32",
																"nodeType": "ElementaryTypeName",
																"src": "23107:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 1623,
													"initialValue": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1619,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1583,
																	"src": "23135:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1620,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "toRegionList",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 238,
																"src": "23135:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1621,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1607,
																"src": "23154:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1618,
															"name": "getData32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4095,
															"src": "23125:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 1622,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "23125:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "23107:49:2"
												},
												{
													"expression": {
														"argumentTypes": null,
														"id": 1632,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 1624,
																"name": "submitBlockList",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1592,
																"src": "23170:15:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																	"typeString": "uint32[8] memory"
																}
															},
															"id": 1626,
															"indexExpression": {
																"argumentTypes": null,
																"id": 1625,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1607,
																"src": "23186:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"nodeType": "IndexAccess",
															"src": "23170:18:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1628,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1583,
																		"src": "23201:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1629,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "submitBlockList",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 242,
																	"src": "23201:20:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1630,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1607,
																	"src": "23223:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1627,
																"name": "getData32",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4095,
																"src": "23191:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1631,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "23191:34:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "23170:55:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1633,
													"nodeType": "ExpressionStatement",
													"src": "23170:55:2"
												},
												{
													"assignments": [
														1635
													],
													"declarations": [
														{
															"constant": false,
															"id": 1635,
															"name": "friendly",
															"nodeType": "VariableDeclaration",
															"scope": 1711,
															"src": "23240:13:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"typeName": {
																"id": 1634,
																"name": "bool",
																"nodeType": "ElementaryTypeName",
																"src": "23240:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 1652,
													"initialValue": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"id": 1651,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 1643,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 1637,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1583,
																			"src": "23265:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 1638,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "regionOwners",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 228,
																		"src": "23265:17:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"id": 1639,
																		"name": "toRegion",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1617,
																		"src": "23284:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 1636,
																	"name": "getData8",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4158,
																	"src": "23256:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																		"typeString": "function (uint256,uint32) pure returns (uint32)"
																	}
																},
																"id": 1640,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "23256:37:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "==",
															"rightExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1641,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1583,
																	"src": "23297:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1642,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "turnTeamId",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 214,
																"src": "23297:15:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "23256:56:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "||",
														"rightExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 1650,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 1645,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1583,
																			"src": "23342:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 1646,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "regionOwners",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 228,
																		"src": "23342:17:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"id": 1647,
																		"name": "toRegion",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1617,
																		"src": "23361:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 1644,
																	"name": "getData8",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4158,
																	"src": "23333:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																		"typeString": "function (uint256,uint32) pure returns (uint32)"
																	}
																},
																"id": 1648,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "23333:37:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "==",
															"rightExpression": {
																"argumentTypes": null,
																"id": 1649,
																"name": "NOT_OWNED",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 123,
																"src": "23374:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "23333:50:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"src": "23256:127:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "23240:143:2"
												},
												{
													"condition": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"id": 1662,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 1653,
															"name": "friendly",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1635,
															"src": "23402:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "||",
														"rightExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"id": 1661,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1654,
																	"name": "block",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4362,
																	"src": "23414:5:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_magic_block",
																		"typeString": "block"
																	}
																},
																"id": 1655,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "number",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "23414:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": ">",
															"rightExpression": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 1660,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 1656,
																		"name": "submitBlockList",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1592,
																		"src": "23429:15:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																			"typeString": "uint32[8] memory"
																		}
																	},
																	"id": 1658,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 1657,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1607,
																		"src": "23445:1:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "23429:18:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "+",
																"rightExpression": {
																	"argumentTypes": null,
																	"hexValue": "31",
																	"id": 1659,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "23450:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_1_by_1",
																		"typeString": "int_const 1"
																	},
																	"value": "1"
																},
																"src": "23429:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "23414:37:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"src": "23402:49:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"falseBody": null,
													"id": 1696,
													"nodeType": "IfStatement",
													"src": "23398:680:2",
													"trueBody": {
														"id": 1695,
														"nodeType": "Block",
														"src": "23453:625:2",
														"statements": [
															{
																"assignments": [
																	1664,
																	1666
																],
																"declarations": [
																	{
																		"constant": false,
																		"id": 1664,
																		"name": "remainingAttackers",
																		"nodeType": "VariableDeclaration",
																		"scope": 1711,
																		"src": "23472:25:2",
																		"stateVariable": false,
																		"storageLocation": "default",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"typeName": {
																			"id": 1663,
																			"name": "uint32",
																			"nodeType": "ElementaryTypeName",
																			"src": "23472:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"value": null,
																		"visibility": "internal"
																	},
																	{
																		"constant": false,
																		"id": 1666,
																		"name": "remainingDefenders",
																		"nodeType": "VariableDeclaration",
																		"scope": 1711,
																		"src": "23499:25:2",
																		"stateVariable": false,
																		"storageLocation": "default",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"typeName": {
																			"id": 1665,
																			"name": "uint32",
																			"nodeType": "ElementaryTypeName",
																			"src": "23499:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"value": null,
																		"visibility": "internal"
																	}
																],
																"id": 1682,
																"initialValue": {
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"baseExpression": {
																				"argumentTypes": null,
																				"id": 1668,
																				"name": "submitBlockList",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1592,
																				"src": "23617:15:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																					"typeString": "uint32[8] memory"
																				}
																			},
																			"id": 1670,
																			"indexExpression": {
																				"argumentTypes": null,
																				"id": 1669,
																				"name": "i",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1607,
																				"src": "23633:1:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"nodeType": "IndexAccess",
																			"src": "23617:18:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		{
																			"argumentTypes": null,
																			"arguments": [
																				{
																					"argumentTypes": null,
																					"expression": {
																						"argumentTypes": null,
																						"id": 1672,
																						"name": "game",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 1583,
																						"src": "23718:4:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																							"typeString": "struct WorldGame.GameData storage pointer"
																						}
																					},
																					"id": 1673,
																					"isConstant": false,
																					"isLValue": true,
																					"isPure": false,
																					"lValueRequested": false,
																					"memberName": "moveSoldierCountList",
																					"nodeType": "MemberAccess",
																					"referencedDeclaration": 240,
																					"src": "23718:25:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint256",
																						"typeString": "uint256"
																					}
																				},
																				{
																					"argumentTypes": null,
																					"id": 1674,
																					"name": "i",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 1607,
																					"src": "23745:1:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				}
																			],
																			"expression": {
																				"argumentTypes": [
																					{
																						"typeIdentifier": "t_uint256",
																						"typeString": "uint256"
																					},
																					{
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				],
																				"id": 1671,
																				"name": "getData32",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 4095,
																				"src": "23708:9:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																					"typeString": "function (uint256,uint32) pure returns (uint32)"
																				}
																			},
																			"id": 1675,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"kind": "functionCall",
																			"lValueRequested": false,
																			"names": [],
																			"nodeType": "FunctionCall",
																			"src": "23708:39:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		{
																			"argumentTypes": null,
																			"baseExpression": {
																				"argumentTypes": null,
																				"expression": {
																					"argumentTypes": null,
																					"id": 1676,
																					"name": "game",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 1583,
																					"src": "23818:4:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																						"typeString": "struct WorldGame.GameData storage pointer"
																					}
																				},
																				"id": 1677,
																				"isConstant": false,
																				"isLValue": true,
																				"isPure": false,
																				"lValueRequested": false,
																				"memberName": "regionSoldiers",
																				"nodeType": "MemberAccess",
																				"referencedDeclaration": 232,
																				"src": "23818:19:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_array$_t_uint32_$25_storage",
																					"typeString": "uint32[25] storage ref"
																				}
																			},
																			"id": 1679,
																			"indexExpression": {
																				"argumentTypes": null,
																				"id": 1678,
																				"name": "toRegion",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1617,
																				"src": "23838:8:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"nodeType": "IndexAccess",
																			"src": "23818:29:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		{
																			"argumentTypes": null,
																			"id": 1680,
																			"name": "friendly",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1635,
																			"src": "23910:8:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_bool",
																				"typeString": "bool"
																			}
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			},
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			},
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			},
																			{
																				"typeIdentifier": "t_bool",
																				"typeString": "bool"
																			}
																		],
																		"id": 1667,
																		"name": "getOutcomeAttackOrMove",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2100,
																		"src": "23528:22:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_function_internal_view$_t_uint32_$_t_uint32_$_t_uint32_$_t_bool_$returns$_t_uint32_$_t_uint32_$",
																			"typeString": "function (uint32,uint32,uint32,bool) view returns (uint32,uint32)"
																		}
																	},
																	"id": 1681,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"kind": "functionCall",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "23528:408:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_tuple$_t_uint32_$_t_uint32_$",
																		"typeString": "tuple(uint32,uint32)"
																	}
																},
																"nodeType": "VariableDeclarationStatement",
																"src": "23471:465:2"
															},
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 1687,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"id": 1683,
																			"name": "remainingAttackerList",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1598,
																			"src": "23955:21:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																				"typeString": "uint32[8] memory"
																			}
																		},
																		"id": 1685,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 1684,
																			"name": "i",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1607,
																			"src": "23977:1:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": true,
																		"nodeType": "IndexAccess",
																		"src": "23955:24:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"id": 1686,
																		"name": "remainingAttackers",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1664,
																		"src": "23982:18:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "23955:45:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"id": 1688,
																"nodeType": "ExpressionStatement",
																"src": "23955:45:2"
															},
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 1693,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"id": 1689,
																			"name": "remainingDefenderList",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1604,
																			"src": "24018:21:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																				"typeString": "uint32[8] memory"
																			}
																		},
																		"id": 1691,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 1690,
																			"name": "i",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1607,
																			"src": "24040:1:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": true,
																		"nodeType": "IndexAccess",
																		"src": "24018:24:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"id": 1692,
																		"name": "remainingDefenders",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1666,
																		"src": "24045:18:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "24018:45:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"id": 1694,
																"nodeType": "ExpressionStatement",
																"src": "24018:45:2"
															}
														]
													}
												}
											]
										},
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 1612,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 1610,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1607,
												"src": "23062:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "<",
											"rightExpression": {
												"argumentTypes": null,
												"id": 1611,
												"name": "MAX_ACTIONS_PER_TURN",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 138,
												"src": "23066:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "23062:24:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"id": 1698,
										"initializationExpression": {
											"assignments": [
												1607
											],
											"declarations": [
												{
													"constant": false,
													"id": 1607,
													"name": "i",
													"nodeType": "VariableDeclaration",
													"scope": 1711,
													"src": "23048:8:2",
													"stateVariable": false,
													"storageLocation": "default",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"typeName": {
														"id": 1606,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "23048:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"value": null,
													"visibility": "internal"
												}
											],
											"id": 1609,
											"initialValue": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1608,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "23059:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"nodeType": "VariableDeclarationStatement",
											"src": "23048:12:2"
										},
										"loopExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 1614,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "UnaryOperation",
												"operator": "++",
												"prefix": false,
												"src": "23088:3:2",
												"subExpression": {
													"argumentTypes": null,
													"id": 1613,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1607,
													"src": "23088:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1615,
											"nodeType": "ExpressionStatement",
											"src": "23088:3:2"
										},
										"nodeType": "ForStatement",
										"src": "23043:1045:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1700,
																"name": "block",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4362,
																"src": "24126:5:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_block",
																	"typeString": "block"
																}
															},
															"id": 1701,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "number",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "24126:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														],
														"id": 1699,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "24119:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 1702,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "24119:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1703,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1583,
														"src": "24154:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 1704,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "actionCount",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 234,
													"src": "24154:16:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"id": 1705,
													"name": "submitBlockList",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1592,
													"src": "24185:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
														"typeString": "uint32[8] memory"
													}
												},
												{
													"argumentTypes": null,
													"id": 1706,
													"name": "remainingAttackerList",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1598,
													"src": "24215:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
														"typeString": "uint32[8] memory"
													}
												},
												{
													"argumentTypes": null,
													"id": 1707,
													"name": "remainingDefenderList",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1604,
													"src": "24250:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
														"typeString": "uint32[8] memory"
													}
												}
											],
											"id": 1708,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "24105:176:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$_t_uint32_$_t_uint32_$_t_array$_t_uint32_$8_memory_ptr_$_t_array$_t_uint32_$8_memory_ptr_$_t_array$_t_uint32_$8_memory_ptr_$",
												"typeString": "tuple(uint32,uint32,uint32[8] memory,uint32[8] memory,uint32[8] memory)"
											}
										},
										"functionReturnParameters": 1581,
										"id": 1709,
										"nodeType": "Return",
										"src": "24098:183:2"
									}
								]
							},
							"documentation": "@notice Returns pending actions that have been queued for current turn.\n @param gameId Id of game \n @return Current block numbber\n @return Number of pending actions\n @return List with block number when action was queued\n @return Number of remaining attackers\n @return Number of remaining defenders",
							"id": 1711,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "pendingActionOutcomes",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1564,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1563,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 1711,
										"src": "22544:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 1562,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "22544:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "22543:16:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1581,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1566,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1711,
										"src": "22620:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1565,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "22620:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1568,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1711,
										"src": "22640:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1567,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "22640:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1572,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1711,
										"src": "22660:28:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
											"typeString": "uint32[8]"
										},
										"typeName": {
											"baseType": {
												"id": 1569,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "22660:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1571,
											"length": {
												"argumentTypes": null,
												"id": 1570,
												"name": "MAX_ACTIONS_PER_TURN",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 138,
												"src": "22667:20:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "22660:28:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
												"typeString": "uint32[8]"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1576,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1711,
										"src": "22703:28:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
											"typeString": "uint32[8]"
										},
										"typeName": {
											"baseType": {
												"id": 1573,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "22703:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1575,
											"length": {
												"argumentTypes": null,
												"id": 1574,
												"name": "MAX_ACTIONS_PER_TURN",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 138,
												"src": "22710:20:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "22703:28:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
												"typeString": "uint32[8]"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1580,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1711,
										"src": "22746:28:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
											"typeString": "uint32[8]"
										},
										"typeName": {
											"baseType": {
												"id": 1577,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "22746:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1579,
											"length": {
												"argumentTypes": null,
												"id": 1578,
												"name": "MAX_ACTIONS_PER_TURN",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 138,
												"src": "22753:20:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "22746:28:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
												"typeString": "uint32[8]"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "22606:174:2"
							},
							"scope": 4288,
							"src": "22513:1775:2",
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 1846,
								"nodeType": "Block",
								"src": "24480:1885:2",
								"statements": [
									{
										"assignments": [
											1717
										],
										"declarations": [
											{
												"constant": false,
												"id": 1717,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 1847,
												"src": "24490:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 1716,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "24490:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1721,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1718,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "24514:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 1720,
											"indexExpression": {
												"argumentTypes": null,
												"id": 1719,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1713,
												"src": "24528:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "24514:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "24490:45:2"
									},
									{
										"body": {
											"id": 1838,
											"nodeType": "Block",
											"src": "24666:1623:2",
											"statements": [
												{
													"assignments": [
														1734
													],
													"declarations": [
														{
															"constant": false,
															"id": 1734,
															"name": "regionFrom",
															"nodeType": "VariableDeclaration",
															"scope": 1847,
															"src": "24680:17:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"typeName": {
																"id": 1733,
																"name": "uint32",
																"nodeType": "ElementaryTypeName",
																"src": "24680:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 1740,
													"initialValue": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1736,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1717,
																	"src": "24710:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1737,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "fromRegionList",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 236,
																"src": "24710:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1738,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1723,
																"src": "24731:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1735,
															"name": "getData32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4095,
															"src": "24700:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 1739,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "24700:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "24680:53:2"
												},
												{
													"assignments": [
														1742
													],
													"declarations": [
														{
															"constant": false,
															"id": 1742,
															"name": "regionTo",
															"nodeType": "VariableDeclaration",
															"scope": 1847,
															"src": "24747:15:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"typeName": {
																"id": 1741,
																"name": "uint32",
																"nodeType": "ElementaryTypeName",
																"src": "24747:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 1748,
													"initialValue": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1744,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1717,
																	"src": "24775:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1745,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "toRegionList",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 238,
																"src": "24775:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1746,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1723,
																"src": "24794:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1743,
															"name": "getData32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4095,
															"src": "24765:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 1747,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "24765:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "24747:49:2"
												},
												{
													"assignments": [
														1750
													],
													"declarations": [
														{
															"constant": false,
															"id": 1750,
															"name": "friendly",
															"nodeType": "VariableDeclaration",
															"scope": 1847,
															"src": "24810:13:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"typeName": {
																"id": 1749,
																"name": "bool",
																"nodeType": "ElementaryTypeName",
																"src": "24810:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 1767,
													"initialValue": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"id": 1766,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 1758,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 1752,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1717,
																			"src": "24835:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 1753,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "regionOwners",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 228,
																		"src": "24835:17:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"id": 1754,
																		"name": "regionTo",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1742,
																		"src": "24854:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 1751,
																	"name": "getData8",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4158,
																	"src": "24826:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																		"typeString": "function (uint256,uint32) pure returns (uint32)"
																	}
																},
																"id": 1755,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "24826:37:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "==",
															"rightExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1756,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1717,
																	"src": "24867:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1757,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "turnTeamId",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 214,
																"src": "24867:15:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "24826:56:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "||",
														"rightExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 1765,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 1760,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1717,
																			"src": "24911:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 1761,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "regionOwners",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 228,
																		"src": "24911:17:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"id": 1762,
																		"name": "regionTo",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1742,
																		"src": "24930:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 1759,
																	"name": "getData8",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4158,
																	"src": "24902:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																		"typeString": "function (uint256,uint32) pure returns (uint32)"
																	}
																},
																"id": 1763,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "24902:37:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "==",
															"rightExpression": {
																"argumentTypes": null,
																"id": 1764,
																"name": "NOT_OWNED",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 123,
																"src": "24943:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "24902:50:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"src": "24826:126:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "24810:142:2"
												},
												{
													"assignments": [
														1769,
														1771
													],
													"declarations": [
														{
															"constant": false,
															"id": 1769,
															"name": "remainingAttackers",
															"nodeType": "VariableDeclaration",
															"scope": 1847,
															"src": "25167:25:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"typeName": {
																"id": 1768,
																"name": "uint32",
																"nodeType": "ElementaryTypeName",
																"src": "25167:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"value": null,
															"visibility": "internal"
														},
														{
															"constant": false,
															"id": 1771,
															"name": "remainingDefenders",
															"nodeType": "VariableDeclaration",
															"scope": 1847,
															"src": "25194:25:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"typeName": {
																"id": 1770,
																"name": "uint32",
																"nodeType": "ElementaryTypeName",
																"src": "25194:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 1789,
													"initialValue": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 1774,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1717,
																			"src": "25314:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 1775,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "submitBlockList",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 242,
																		"src": "25314:20:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"id": 1776,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1723,
																		"src": "25336:1:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 1773,
																	"name": "getData32",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4095,
																	"src": "25304:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																		"typeString": "function (uint256,uint32) pure returns (uint32)"
																	}
																},
																"id": 1777,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "25304:34:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 1779,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1717,
																			"src": "25413:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 1780,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "moveSoldierCountList",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 240,
																		"src": "25413:25:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"id": 1781,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1723,
																		"src": "25440:1:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 1778,
																	"name": "getData32",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4095,
																	"src": "25403:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																		"typeString": "function (uint256,uint32) pure returns (uint32)"
																	}
																},
																"id": 1782,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "25403:39:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"baseExpression": {
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1783,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1717,
																		"src": "25505:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1784,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "regionSoldiers",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 232,
																	"src": "25505:19:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_array$_t_uint32_$25_storage",
																		"typeString": "uint32[25] storage ref"
																	}
																},
																"id": 1786,
																"indexExpression": {
																	"argumentTypes": null,
																	"id": 1785,
																	"name": "regionTo",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1742,
																	"src": "25525:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "IndexAccess",
																"src": "25505:29:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"id": 1787,
																"name": "friendly",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1750,
																"src": "25589:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"id": 1772,
															"name": "getOutcomeAttackOrMove",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2100,
															"src": "25223:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_view$_t_uint32_$_t_uint32_$_t_uint32_$_t_bool_$returns$_t_uint32_$_t_uint32_$",
																"typeString": "function (uint32,uint32,uint32,bool) view returns (uint32,uint32)"
															}
														},
														"id": 1788,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "25223:388:2",
														"typeDescriptions": {
															"typeIdentifier": "t_tuple$_t_uint32_$_t_uint32_$",
															"typeString": "tuple(uint32,uint32)"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "25166:445:2"
												},
												{
													"condition": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 1792,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 1790,
															"name": "remainingDefenders",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1771,
															"src": "25630:18:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"hexValue": "30",
															"id": 1791,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "25652:1:2",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														},
														"src": "25630:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"falseBody": {
														"id": 1836,
														"nodeType": "Block",
														"src": "25949:330:2",
														"statements": [
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 1826,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"expression": {
																				"argumentTypes": null,
																				"id": 1814,
																				"name": "game",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1717,
																				"src": "26043:4:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																					"typeString": "struct WorldGame.GameData storage pointer"
																				}
																			},
																			"id": 1817,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"memberName": "regionSoldiers",
																			"nodeType": "MemberAccess",
																			"referencedDeclaration": 232,
																			"src": "26043:19:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_uint32_$25_storage",
																				"typeString": "uint32[25] storage ref"
																			}
																		},
																		"id": 1818,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 1816,
																			"name": "regionFrom",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1734,
																			"src": "26063:10:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": true,
																		"nodeType": "IndexAccess",
																		"src": "26043:31:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"baseExpression": {
																					"argumentTypes": null,
																					"expression": {
																						"argumentTypes": null,
																						"id": 1820,
																						"name": "game",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 1717,
																						"src": "26106:4:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																							"typeString": "struct WorldGame.GameData storage pointer"
																						}
																					},
																					"id": 1821,
																					"isConstant": false,
																					"isLValue": true,
																					"isPure": false,
																					"lValueRequested": false,
																					"memberName": "regionSoldiers",
																					"nodeType": "MemberAccess",
																					"referencedDeclaration": 232,
																					"src": "26106:19:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_array$_t_uint32_$25_storage",
																						"typeString": "uint32[25] storage ref"
																					}
																				},
																				"id": 1823,
																				"indexExpression": {
																					"argumentTypes": null,
																					"id": 1822,
																					"name": "regionFrom",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 1734,
																					"src": "26126:10:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				},
																				"isConstant": false,
																				"isLValue": true,
																				"isPure": false,
																				"lValueRequested": false,
																				"nodeType": "IndexAccess",
																				"src": "26106:31:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			{
																				"argumentTypes": null,
																				"id": 1824,
																				"name": "remainingAttackers",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1769,
																				"src": "26160:18:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				},
																				{
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			],
																			"id": 1819,
																			"name": "addSafe",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 4253,
																			"src": "26077:7:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																				"typeString": "function (uint32,uint32) pure returns (uint32)"
																			}
																		},
																		"id": 1825,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"kind": "functionCall",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "26077:119:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "26043:153:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"id": 1827,
																"nodeType": "ExpressionStatement",
																"src": "26043:153:2"
															},
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 1834,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"expression": {
																				"argumentTypes": null,
																				"id": 1828,
																				"name": "game",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1717,
																				"src": "26214:4:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																					"typeString": "struct WorldGame.GameData storage pointer"
																				}
																			},
																			"id": 1831,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"memberName": "regionSoldiers",
																			"nodeType": "MemberAccess",
																			"referencedDeclaration": 232,
																			"src": "26214:19:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_uint32_$25_storage",
																				"typeString": "uint32[25] storage ref"
																			}
																		},
																		"id": 1832,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 1830,
																			"name": "regionTo",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1742,
																			"src": "26234:8:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": true,
																		"nodeType": "IndexAccess",
																		"src": "26214:29:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"id": 1833,
																		"name": "remainingDefenders",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1771,
																		"src": "26246:18:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "26214:50:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"id": 1835,
																"nodeType": "ExpressionStatement",
																"src": "26214:50:2"
															}
														]
													},
													"id": 1837,
													"nodeType": "IfStatement",
													"src": "25626:653:2",
													"trueBody": {
														"id": 1813,
														"nodeType": "Block",
														"src": "25655:276:2",
														"statements": [
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 1799,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"expression": {
																				"argumentTypes": null,
																				"id": 1793,
																				"name": "game",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1717,
																				"src": "25774:4:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																					"typeString": "struct WorldGame.GameData storage pointer"
																				}
																			},
																			"id": 1796,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"memberName": "regionSoldiers",
																			"nodeType": "MemberAccess",
																			"referencedDeclaration": 232,
																			"src": "25774:19:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_uint32_$25_storage",
																				"typeString": "uint32[25] storage ref"
																			}
																		},
																		"id": 1797,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 1795,
																			"name": "regionTo",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1742,
																			"src": "25794:8:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": true,
																		"nodeType": "IndexAccess",
																		"src": "25774:29:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"id": 1798,
																		"name": "remainingAttackers",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1769,
																		"src": "25806:18:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "25774:50:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"id": 1800,
																"nodeType": "ExpressionStatement",
																"src": "25774:50:2"
															},
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 1811,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 1801,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1717,
																			"src": "25842:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 1803,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": true,
																		"memberName": "regionOwners",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 228,
																		"src": "25842:17:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"expression": {
																					"argumentTypes": null,
																					"id": 1805,
																					"name": "game",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 1717,
																					"src": "25871:4:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																						"typeString": "struct WorldGame.GameData storage pointer"
																					}
																				},
																				"id": 1806,
																				"isConstant": false,
																				"isLValue": true,
																				"isPure": false,
																				"lValueRequested": false,
																				"memberName": "regionOwners",
																				"nodeType": "MemberAccess",
																				"referencedDeclaration": 228,
																				"src": "25871:17:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint256",
																					"typeString": "uint256"
																				}
																			},
																			{
																				"argumentTypes": null,
																				"id": 1807,
																				"name": "regionTo",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1742,
																				"src": "25890:8:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			{
																				"argumentTypes": null,
																				"expression": {
																					"argumentTypes": null,
																					"id": 1808,
																					"name": "game",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 1717,
																					"src": "25900:4:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																						"typeString": "struct WorldGame.GameData storage pointer"
																					}
																				},
																				"id": 1809,
																				"isConstant": false,
																				"isLValue": true,
																				"isPure": false,
																				"lValueRequested": false,
																				"memberName": "turnTeamId",
																				"nodeType": "MemberAccess",
																				"referencedDeclaration": 214,
																				"src": "25900:15:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_uint256",
																					"typeString": "uint256"
																				},
																				{
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				},
																				{
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			],
																			"id": 1804,
																			"name": "setData8",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 4203,
																			"src": "25862:8:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
																				"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
																			}
																		},
																		"id": 1810,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"kind": "functionCall",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "25862:54:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"src": "25842:74:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"id": 1812,
																"nodeType": "ExpressionStatement",
																"src": "25842:74:2"
															}
														]
													}
												}
											]
										},
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 1729,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 1726,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1723,
												"src": "24639:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "<",
											"rightExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1727,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1717,
													"src": "24643:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1728,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "actionCount",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 234,
												"src": "24643:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "24639:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"id": 1839,
										"initializationExpression": {
											"assignments": [
												1723
											],
											"declarations": [
												{
													"constant": false,
													"id": 1723,
													"name": "i",
													"nodeType": "VariableDeclaration",
													"scope": 1847,
													"src": "24625:8:2",
													"stateVariable": false,
													"storageLocation": "default",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"typeName": {
														"id": 1722,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "24625:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"value": null,
													"visibility": "internal"
												}
											],
											"id": 1725,
											"initialValue": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1724,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "24636:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"nodeType": "VariableDeclarationStatement",
											"src": "24625:12:2"
										},
										"loopExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 1731,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "UnaryOperation",
												"operator": "++",
												"prefix": false,
												"src": "24661:3:2",
												"subExpression": {
													"argumentTypes": null,
													"id": 1730,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1723,
													"src": "24661:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1732,
											"nodeType": "ExpressionStatement",
											"src": "24661:3:2"
										},
										"nodeType": "ForStatement",
										"src": "24620:1669:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 1844,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1840,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1717,
													"src": "26338:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1842,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"memberName": "actionCount",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 234,
												"src": "26338:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1843,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "26357:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"src": "26338:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1845,
										"nodeType": "ExpressionStatement",
										"src": "26338:20:2"
									}
								]
							},
							"documentation": "@notice Execute actions that have been queued for this turn.\n @param gameId Id of game ",
							"id": 1847,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": false,
							"modifiers": [],
							"name": "executePendingActions",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1714,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1713,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 1847,
										"src": "24437:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 1712,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "24437:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "24427:30:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1715,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "24480:0:2"
							},
							"scope": 4288,
							"src": "24397:1968:2",
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "private"
						},
						{
							"body": {
								"id": 1947,
								"nodeType": "Block",
								"src": "26601:770:2",
								"statements": [
									{
										"assignments": [
											1855
										],
										"declarations": [
											{
												"constant": false,
												"id": 1855,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 1948,
												"src": "26611:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 1854,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "26611:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1859,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1856,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "26635:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 1858,
											"indexExpression": {
												"argumentTypes": null,
												"id": 1857,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1849,
												"src": "26649:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "26635:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "26611:45:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1864,
												"name": "playerOwnsRegion",
												"nodeType": "VariableDeclaration",
												"scope": 1948,
												"src": "26666:41:2",
												"stateVariable": false,
												"storageLocation": "memory",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_bool_$8_memory_ptr",
													"typeString": "bool[8]"
												},
												"typeName": {
													"baseType": {
														"id": 1862,
														"name": "bool",
														"nodeType": "ElementaryTypeName",
														"src": "26666:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"id": 1863,
													"length": {
														"argumentTypes": null,
														"id": 1861,
														"name": "MAX_PLAYERS",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 135,
														"src": "26671:11:2",
														"typeDescriptions": {
															"typeIdentifier": null,
															"typeString": null
														}
													},
													"nodeType": "ArrayTypeName",
													"src": "26666:17:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_bool_$8_storage_ptr",
														"typeString": "bool[8]"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1865,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "26666:41:2"
									},
									{
										"assignments": [
											1867
										],
										"declarations": [
											{
												"constant": false,
												"id": 1867,
												"name": "hasNotOwned",
												"nodeType": "VariableDeclaration",
												"scope": 1948,
												"src": "26717:16:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"typeName": {
													"id": 1866,
													"name": "bool",
													"nodeType": "ElementaryTypeName",
													"src": "26717:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1869,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "66616c7365",
											"id": 1868,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "26736:5:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "false"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "26717:24:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1871,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 1948,
												"src": "26751:8:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 1870,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "26751:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1872,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "26751:8:2"
									},
									{
										"body": {
											"id": 1907,
											"nodeType": "Block",
											"src": "26813:257:2",
											"statements": [
												{
													"assignments": [
														1884
													],
													"declarations": [
														{
															"constant": false,
															"id": 1884,
															"name": "regionOwner",
															"nodeType": "VariableDeclaration",
															"scope": 1948,
															"src": "26827:18:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"typeName": {
																"id": 1883,
																"name": "uint32",
																"nodeType": "ElementaryTypeName",
																"src": "26827:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 1890,
													"initialValue": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1886,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1855,
																	"src": "26857:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1887,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "regionOwners",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 228,
																"src": "26857:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1888,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1871,
																"src": "26876:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1885,
															"name": "getData8",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4158,
															"src": "26848:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 1889,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "26848:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "26827:51:2"
												},
												{
													"condition": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 1893,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 1891,
															"name": "regionOwner",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1884,
															"src": "26896:11:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"id": 1892,
															"name": "NOT_OWNED",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 123,
															"src": "26911:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "26896:24:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"falseBody": {
														"id": 1905,
														"nodeType": "Block",
														"src": "26991:69:2",
														"statements": [
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 1903,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"id": 1899,
																			"name": "playerOwnsRegion",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1864,
																			"src": "27009:16:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_bool_$8_memory_ptr",
																				"typeString": "bool[8] memory"
																			}
																		},
																		"id": 1901,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 1900,
																			"name": "regionOwner",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1884,
																			"src": "27026:11:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": true,
																		"nodeType": "IndexAccess",
																		"src": "27009:29:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"hexValue": "74727565",
																		"id": 1902,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "bool",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "27041:4:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		},
																		"value": "true"
																	},
																	"src": "27009:36:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"id": 1904,
																"nodeType": "ExpressionStatement",
																"src": "27009:36:2"
															}
														]
													},
													"id": 1906,
													"nodeType": "IfStatement",
													"src": "26892:168:2",
													"trueBody": {
														"id": 1898,
														"nodeType": "Block",
														"src": "26922:51:2",
														"statements": [
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 1896,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"id": 1894,
																		"name": "hasNotOwned",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1867,
																		"src": "26940:11:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"hexValue": "74727565",
																		"id": 1895,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "bool",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "26954:4:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		},
																		"value": "true"
																	},
																	"src": "26940:18:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"id": 1897,
																"nodeType": "ExpressionStatement",
																"src": "26940:18:2"
															}
														]
													}
												}
											]
										},
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 1879,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 1877,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1871,
												"src": "26790:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "<",
											"rightExpression": {
												"argumentTypes": null,
												"id": 1878,
												"name": "REGION_COUNT",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 129,
												"src": "26794:12:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "26790:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"id": 1908,
										"initializationExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 1875,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftHandSide": {
													"argumentTypes": null,
													"id": 1873,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1871,
													"src": "26783:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "Assignment",
												"operator": "=",
												"rightHandSide": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 1874,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "26787:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "26783:5:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1876,
											"nodeType": "ExpressionStatement",
											"src": "26783:5:2"
										},
										"loopExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 1881,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "UnaryOperation",
												"operator": "++",
												"prefix": false,
												"src": "26808:3:2",
												"subExpression": {
													"argumentTypes": null,
													"id": 1880,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1871,
													"src": "26808:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1882,
											"nodeType": "ExpressionStatement",
											"src": "26808:3:2"
										},
										"nodeType": "ForStatement",
										"src": "26778:292:2"
									},
									{
										"assignments": [
											1910
										],
										"declarations": [
											{
												"constant": false,
												"id": 1910,
												"name": "turnTeamId",
												"nodeType": "VariableDeclaration",
												"scope": 1948,
												"src": "27080:17:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 1909,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "27080:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1913,
										"initialValue": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 1911,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1855,
												"src": "27100:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 1912,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "turnTeamId",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 214,
											"src": "27100:15:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "27080:35:2"
									},
									{
										"body": {
											"id": 1943,
											"nodeType": "Block",
											"src": "27164:173:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"id": 1933,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"id": 1925,
															"name": "turnTeamId",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1910,
															"src": "27178:10:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 1932,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"components": [
																	{
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"id": 1928,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"id": 1926,
																			"name": "turnTeamId",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1910,
																			"src": "27192:10:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "+",
																		"rightExpression": {
																			"argumentTypes": null,
																			"hexValue": "31",
																			"id": 1927,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "27205:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_1_by_1",
																				"typeString": "int_const 1"
																			},
																			"value": "1"
																		},
																		"src": "27192:14:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"id": 1929,
																"isConstant": false,
																"isInlineArray": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "TupleExpression",
																"src": "27191:16:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "%",
															"rightExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1930,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1855,
																	"src": "27210:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1931,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "playerCount",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 220,
																"src": "27210:16:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "27191:35:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "27178:48:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1934,
													"nodeType": "ExpressionStatement",
													"src": "27178:48:2"
												},
												{
													"condition": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"id": 1939,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 1935,
															"name": "hasNotOwned",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1867,
															"src": "27244:11:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "||",
														"rightExpression": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 1936,
																"name": "playerOwnsRegion",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1864,
																"src": "27259:16:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_bool_$8_memory_ptr",
																	"typeString": "bool[8] memory"
																}
															},
															"id": 1938,
															"indexExpression": {
																"argumentTypes": null,
																"id": 1937,
																"name": "turnTeamId",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1910,
																"src": "27276:10:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "27259:28:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"src": "27244:43:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"falseBody": null,
													"id": 1942,
													"nodeType": "IfStatement",
													"src": "27240:87:2",
													"trueBody": {
														"id": 1941,
														"nodeType": "Block",
														"src": "27289:38:2",
														"statements": [
															{
																"id": 1940,
																"nodeType": "Break",
																"src": "27307:5:2"
															}
														]
													}
												}
											]
										},
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 1921,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 1918,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1871,
												"src": "27137:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "<",
											"rightExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1919,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1855,
													"src": "27141:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1920,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "playerCount",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 220,
												"src": "27141:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "27137:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"id": 1944,
										"initializationExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 1916,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftHandSide": {
													"argumentTypes": null,
													"id": 1914,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1871,
													"src": "27130:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "Assignment",
												"operator": "=",
												"rightHandSide": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 1915,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "27134:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "27130:5:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1917,
											"nodeType": "ExpressionStatement",
											"src": "27130:5:2"
										},
										"loopExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 1923,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "UnaryOperation",
												"operator": "++",
												"prefix": false,
												"src": "27159:3:2",
												"subExpression": {
													"argumentTypes": null,
													"id": 1922,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1871,
													"src": "27159:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1924,
											"nodeType": "ExpressionStatement",
											"src": "27159:3:2"
										},
										"nodeType": "ForStatement",
										"src": "27125:212:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 1945,
											"name": "turnTeamId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1910,
											"src": "27354:10:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"functionReturnParameters": 1853,
										"id": 1946,
										"nodeType": "Return",
										"src": "27347:17:2"
									}
								]
							},
							"documentation": "@notice Player who's turn is next. \n @param gameId Id of game\n @return Next player's turn",
							"id": 1948,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "getNextTurnTeamId",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1850,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1849,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 1948,
										"src": "26519:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 1848,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "26519:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "26509:30:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1853,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1852,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1948,
										"src": "26588:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1851,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "26588:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "26587:8:2"
							},
							"scope": 4288,
							"src": "26483:888:2",
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "private"
						},
						{
							"body": {
								"id": 2099,
								"nodeType": "Block",
								"src": "28083:2297:2",
								"statements": [
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 1971,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 1964,
														"name": "friendly",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1956,
														"src": "28101:8:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "||",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 1970,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1965,
																"name": "block",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4362,
																"src": "28113:5:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_block",
																	"typeString": "block"
																}
															},
															"id": 1966,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "number",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "28113:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": ">",
														"rightExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 1969,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"id": 1967,
																"name": "submitBlock",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1950,
																"src": "28128:11:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "+",
															"rightExpression": {
																"argumentTypes": null,
																"hexValue": "31",
																"id": 1968,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "28142:1:2",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_1_by_1",
																	"typeString": "int_const 1"
																},
																"value": "1"
															},
															"src": "28128:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "28113:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "28101:42:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "41747461636b73206d757374206265206174206c65617374203220626c6f636b73206f6c642e",
													"id": 1972,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "28145:40:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_91584ee78cdc6e0673b4f0284dd0b9cb25973d2723f266294efc182f77e28ea8",
														"typeString": "literal_string \"Attacks must be at least 2 blocks old.\""
													},
													"value": "Attacks must be at least 2 blocks old."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_91584ee78cdc6e0673b4f0284dd0b9cb25973d2723f266294efc182f77e28ea8",
														"typeString": "literal_string \"Attacks must be at least 2 blocks old.\""
													}
												],
												"id": 1963,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "28093:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 1973,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "28093:93:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 1974,
										"nodeType": "ExpressionStatement",
										"src": "28093:93:2"
									},
									{
										"condition": {
											"argumentTypes": null,
											"id": 1975,
											"name": "friendly",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1956,
											"src": "28201:8:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": {
											"id": 2097,
											"nodeType": "Block",
											"src": "28375:1999:2",
											"statements": [
												{
													"assignments": [
														1985
													],
													"declarations": [
														{
															"constant": false,
															"id": 1985,
															"name": "blockHash32",
															"nodeType": "VariableDeclaration",
															"scope": 2100,
															"src": "28719:18:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"typeName": {
																"id": 1984,
																"name": "uint32",
																"nodeType": "ElementaryTypeName",
																"src": "28719:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 1991,
													"initialValue": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 1989,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"id": 1987,
																	"name": "submitBlock",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1950,
																	"src": "28756:11:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "+",
																"rightExpression": {
																	"argumentTypes": null,
																	"hexValue": "31",
																	"id": 1988,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "28770:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_1_by_1",
																		"typeString": "int_const 1"
																	},
																	"value": "1"
																},
																"src": "28756:15:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1986,
															"name": "readBlockHash32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1152,
															"src": "28740:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_view$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint32) view returns (uint32)"
															}
														},
														"id": 1990,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "28740:32:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "28719:53:2"
												},
												{
													"assignments": [
														1993
													],
													"declarations": [
														{
															"constant": false,
															"id": 1993,
															"name": "deadDefenders",
															"nodeType": "VariableDeclaration",
															"scope": 2100,
															"src": "28786:20:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"typeName": {
																"id": 1992,
																"name": "uint32",
																"nodeType": "ElementaryTypeName",
																"src": "28786:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 1995,
													"initialValue": {
														"argumentTypes": null,
														"hexValue": "30",
														"id": 1994,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "28809:1:2",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "28786:24:2"
												},
												{
													"assignments": [
														1997
													],
													"declarations": [
														{
															"constant": false,
															"id": 1997,
															"name": "deadAttackers",
															"nodeType": "VariableDeclaration",
															"scope": 2100,
															"src": "28824:20:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"typeName": {
																"id": 1996,
																"name": "uint32",
																"nodeType": "ElementaryTypeName",
																"src": "28824:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 1999,
													"initialValue": {
														"argumentTypes": null,
														"hexValue": "30",
														"id": 1998,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "28847:1:2",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "28824:24:2"
												},
												{
													"condition": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 2002,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 2000,
															"name": "blockHash32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1985,
															"src": "28955:11:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"hexValue": "30",
															"id": 2001,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "28970:1:2",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														},
														"src": "28955:16:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"falseBody": {
														"id": 2059,
														"nodeType": "Block",
														"src": "29233:514:2",
														"statements": [
															{
																"assignments": [
																	2018
																],
																"declarations": [
																	{
																		"constant": false,
																		"id": 2018,
																		"name": "randA",
																		"nodeType": "VariableDeclaration",
																		"scope": 2100,
																		"src": "29251:12:2",
																		"stateVariable": false,
																		"storageLocation": "default",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"typeName": {
																			"id": 2017,
																			"name": "uint32",
																			"nodeType": "ElementaryTypeName",
																			"src": "29251:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"value": null,
																		"visibility": "internal"
																	}
																],
																"id": 2024,
																"initialValue": {
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"commonType": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			},
																			"id": 2022,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"leftExpression": {
																				"argumentTypes": null,
																				"id": 2020,
																				"name": "blockHash32",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1985,
																				"src": "29273:11:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			"nodeType": "BinaryOperation",
																			"operator": "%",
																			"rightExpression": {
																				"argumentTypes": null,
																				"hexValue": "323536",
																				"id": 2021,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "29287:3:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_256_by_1",
																					"typeString": "int_const 256"
																				},
																				"value": "256"
																			},
																			"src": "29273:17:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		],
																		"id": 2019,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "29266:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 2023,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "29266:25:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "VariableDeclarationStatement",
																"src": "29251:40:2"
															},
															{
																"assignments": [
																	2026
																],
																"declarations": [
																	{
																		"constant": false,
																		"id": 2026,
																		"name": "randB",
																		"nodeType": "VariableDeclaration",
																		"scope": 2100,
																		"src": "29309:12:2",
																		"stateVariable": false,
																		"storageLocation": "default",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"typeName": {
																			"id": 2025,
																			"name": "uint32",
																			"nodeType": "ElementaryTypeName",
																			"src": "29309:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"value": null,
																		"visibility": "internal"
																	}
																],
																"id": 2035,
																"initialValue": {
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"commonType": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			},
																			"id": 2033,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"leftExpression": {
																				"argumentTypes": null,
																				"components": [
																					{
																						"argumentTypes": null,
																						"commonType": {
																							"typeIdentifier": "t_uint32",
																							"typeString": "uint32"
																						},
																						"id": 2030,
																						"isConstant": false,
																						"isLValue": false,
																						"isPure": false,
																						"lValueRequested": false,
																						"leftExpression": {
																							"argumentTypes": null,
																							"id": 2028,
																							"name": "blockHash32",
																							"nodeType": "Identifier",
																							"overloadedDeclarations": [],
																							"referencedDeclaration": 1985,
																							"src": "29332:11:2",
																							"typeDescriptions": {
																								"typeIdentifier": "t_uint32",
																								"typeString": "uint32"
																							}
																						},
																						"nodeType": "BinaryOperation",
																						"operator": ">>",
																						"rightExpression": {
																							"argumentTypes": null,
																							"hexValue": "38",
																							"id": 2029,
																							"isConstant": false,
																							"isLValue": false,
																							"isPure": true,
																							"kind": "number",
																							"lValueRequested": false,
																							"nodeType": "Literal",
																							"src": "29347:1:2",
																							"subdenomination": null,
																							"typeDescriptions": {
																								"typeIdentifier": "t_rational_8_by_1",
																								"typeString": "int_const 8"
																							},
																							"value": "8"
																						},
																						"src": "29332:16:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_uint32",
																							"typeString": "uint32"
																						}
																					}
																				],
																				"id": 2031,
																				"isConstant": false,
																				"isInlineArray": false,
																				"isLValue": false,
																				"isPure": false,
																				"lValueRequested": false,
																				"nodeType": "TupleExpression",
																				"src": "29331:18:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			"nodeType": "BinaryOperation",
																			"operator": "%",
																			"rightExpression": {
																				"argumentTypes": null,
																				"hexValue": "323536",
																				"id": 2032,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "29352:3:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_256_by_1",
																					"typeString": "int_const 256"
																				},
																				"value": "256"
																			},
																			"src": "29331:24:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		],
																		"id": 2027,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "29324:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 2034,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "29324:32:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "VariableDeclarationStatement",
																"src": "29309:47:2"
															},
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 2043,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"id": 2036,
																		"name": "deadDefenders",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1993,
																		"src": "29432:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"id": 2042,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"arguments": [
																				{
																					"argumentTypes": null,
																					"id": 2038,
																					"name": "moveSoldierCount",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 1952,
																					"src": "29456:16:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				},
																				{
																					"argumentTypes": null,
																					"id": 2039,
																					"name": "randA",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 2018,
																					"src": "29474:5:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				}
																			],
																			"expression": {
																				"argumentTypes": [
																					{
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					},
																					{
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				],
																				"id": 2037,
																				"name": "mulSafe",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 4287,
																				"src": "29448:7:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																					"typeString": "function (uint32,uint32) pure returns (uint32)"
																				}
																			},
																			"id": 2040,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"kind": "functionCall",
																			"lValueRequested": false,
																			"names": [],
																			"nodeType": "FunctionCall",
																			"src": "29448:32:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "/",
																		"rightExpression": {
																			"argumentTypes": null,
																			"hexValue": "323536",
																			"id": 2041,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "29483:3:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_256_by_1",
																				"typeString": "int_const 256"
																			},
																			"value": "256"
																		},
																		"src": "29448:38:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "29432:54:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"id": 2044,
																"nodeType": "ExpressionStatement",
																"src": "29432:54:2"
															},
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 2057,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"id": 2045,
																		"name": "deadAttackers",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1997,
																		"src": "29606:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"id": 2056,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"arguments": [
																				{
																					"argumentTypes": null,
																					"id": 2047,
																					"name": "defenderCount",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 1954,
																					"src": "29630:13:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				},
																				{
																					"argumentTypes": null,
																					"commonType": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					},
																					"id": 2050,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"lValueRequested": false,
																					"leftExpression": {
																						"argumentTypes": null,
																						"id": 2048,
																						"name": "DEFENDER_ADVANTAGE_NUM",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 141,
																						"src": "29645:22:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_uint32",
																							"typeString": "uint32"
																						}
																					},
																					"nodeType": "BinaryOperation",
																					"operator": "*",
																					"rightExpression": {
																						"argumentTypes": null,
																						"id": 2049,
																						"name": "randB",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 2026,
																						"src": "29670:5:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_uint32",
																							"typeString": "uint32"
																						}
																					},
																					"src": "29645:30:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				}
																			],
																			"expression": {
																				"argumentTypes": [
																					{
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					},
																					{
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				],
																				"id": 2046,
																				"name": "mulSafe",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 4287,
																				"src": "29622:7:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																					"typeString": "function (uint32,uint32) pure returns (uint32)"
																				}
																			},
																			"id": 2051,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"kind": "functionCall",
																			"lValueRequested": false,
																			"names": [],
																			"nodeType": "FunctionCall",
																			"src": "29622:54:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "/",
																		"rightExpression": {
																			"argumentTypes": null,
																			"components": [
																				{
																					"argumentTypes": null,
																					"commonType": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					},
																					"id": 2054,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": true,
																					"lValueRequested": false,
																					"leftExpression": {
																						"argumentTypes": null,
																						"hexValue": "323536",
																						"id": 2052,
																						"isConstant": false,
																						"isLValue": false,
																						"isPure": true,
																						"kind": "number",
																						"lValueRequested": false,
																						"nodeType": "Literal",
																						"src": "29701:3:2",
																						"subdenomination": null,
																						"typeDescriptions": {
																							"typeIdentifier": "t_rational_256_by_1",
																							"typeString": "int_const 256"
																						},
																						"value": "256"
																					},
																					"nodeType": "BinaryOperation",
																					"operator": "*",
																					"rightExpression": {
																						"argumentTypes": null,
																						"id": 2053,
																						"name": "DEFENDER_ADVANTAGE_DENOM",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 144,
																						"src": "29707:24:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_uint32",
																							"typeString": "uint32"
																						}
																					},
																					"src": "29701:30:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				}
																			],
																			"id": 2055,
																			"isConstant": false,
																			"isInlineArray": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "TupleExpression",
																			"src": "29700:32:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"src": "29622:110:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "29606:126:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"id": 2058,
																"nodeType": "ExpressionStatement",
																"src": "29606:126:2"
															}
														]
													},
													"id": 2060,
													"nodeType": "IfStatement",
													"src": "28951:796:2",
													"trueBody": {
														"id": 2016,
														"nodeType": "Block",
														"src": "28973:157:2",
														"statements": [
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 2005,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"id": 2003,
																		"name": "deadDefenders",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1993,
																		"src": "28991:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"hexValue": "30",
																		"id": 2004,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "29007:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		},
																		"value": "0"
																	},
																	"src": "28991:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"id": 2006,
																"nodeType": "ExpressionStatement",
																"src": "28991:17:2"
															},
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 2014,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"id": 2007,
																		"name": "deadAttackers",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1997,
																		"src": "29026:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"id": 2013,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"arguments": [
																				{
																					"argumentTypes": null,
																					"id": 2009,
																					"name": "defenderCount",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 1954,
																					"src": "29050:13:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				},
																				{
																					"argumentTypes": null,
																					"id": 2010,
																					"name": "DEFENDER_ADVANTAGE_NUM",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 141,
																					"src": "29065:22:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				}
																			],
																			"expression": {
																				"argumentTypes": [
																					{
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					},
																					{
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				],
																				"id": 2008,
																				"name": "mulSafe",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 4287,
																				"src": "29042:7:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																					"typeString": "function (uint32,uint32) pure returns (uint32)"
																				}
																			},
																			"id": 2011,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"kind": "functionCall",
																			"lValueRequested": false,
																			"names": [],
																			"nodeType": "FunctionCall",
																			"src": "29042:46:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "/",
																		"rightExpression": {
																			"argumentTypes": null,
																			"id": 2012,
																			"name": "DEFENDER_ADVANTAGE_DENOM",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 144,
																			"src": "29091:24:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"src": "29042:73:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "29026:89:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"id": 2015,
																"nodeType": "ExpressionStatement",
																"src": "29026:89:2"
															}
														]
													}
												},
												{
													"assignments": [
														2062
													],
													"declarations": [
														{
															"constant": false,
															"id": 2062,
															"name": "remainingAttackers",
															"nodeType": "VariableDeclaration",
															"scope": 2100,
															"src": "29840:25:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"typeName": {
																"id": 2061,
																"name": "uint32",
																"nodeType": "ElementaryTypeName",
																"src": "29840:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 2073,
													"initialValue": {
														"argumentTypes": null,
														"condition": {
															"argumentTypes": null,
															"components": [
																{
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 2065,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 2063,
																		"name": "moveSoldierCount",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1952,
																		"src": "29869:16:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": ">",
																	"rightExpression": {
																		"argumentTypes": null,
																		"id": 2064,
																		"name": "deadAttackers",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1997,
																		"src": "29888:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "29869:32:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																}
															],
															"id": 2066,
															"isConstant": false,
															"isInlineArray": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "TupleExpression",
															"src": "29868:34:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"falseExpression": {
															"argumentTypes": null,
															"hexValue": "30",
															"id": 2071,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "29959:1:2",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														},
														"id": 2072,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "Conditional",
														"src": "29868:92:2",
														"trueExpression": {
															"argumentTypes": null,
															"components": [
																{
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 2069,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 2067,
																		"name": "moveSoldierCount",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1952,
																		"src": "29923:16:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "-",
																	"rightExpression": {
																		"argumentTypes": null,
																		"id": 2068,
																		"name": "deadAttackers",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1997,
																		"src": "29942:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "29923:32:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"id": 2070,
															"isConstant": false,
															"isInlineArray": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "TupleExpression",
															"src": "29922:34:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "29840:120:2"
												},
												{
													"assignments": [
														2075
													],
													"declarations": [
														{
															"constant": false,
															"id": 2075,
															"name": "remainingDefenders",
															"nodeType": "VariableDeclaration",
															"scope": 2100,
															"src": "30156:25:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"typeName": {
																"id": 2074,
																"name": "uint32",
																"nodeType": "ElementaryTypeName",
																"src": "30156:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 2092,
													"initialValue": {
														"argumentTypes": null,
														"condition": {
															"argumentTypes": null,
															"components": [
																{
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 2078,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 2076,
																		"name": "defenderCount",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1954,
																		"src": "30185:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": ">",
																	"rightExpression": {
																		"argumentTypes": null,
																		"id": 2077,
																		"name": "deadDefenders",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1993,
																		"src": "30201:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "30185:29:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																}
															],
															"id": 2079,
															"isConstant": false,
															"isInlineArray": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "TupleExpression",
															"src": "30184:31:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"falseExpression": {
															"argumentTypes": null,
															"components": [
																{
																	"argumentTypes": null,
																	"condition": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"id": 2086,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"id": 2084,
																			"name": "remainingAttackers",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 2062,
																			"src": "30270:18:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": ">",
																		"rightExpression": {
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 2085,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "30291:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		},
																		"src": "30270:22:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	},
																	"falseExpression": {
																		"argumentTypes": null,
																		"hexValue": "31",
																		"id": 2088,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "30299:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_1_by_1",
																			"typeString": "int_const 1"
																		},
																		"value": "1"
																	},
																	"id": 2089,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "Conditional",
																	"src": "30270:30:2",
																	"trueExpression": {
																		"argumentTypes": null,
																		"hexValue": "30",
																		"id": 2087,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "30295:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		},
																		"value": "0"
																	},
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint8",
																		"typeString": "uint8"
																	}
																}
															],
															"id": 2090,
															"isConstant": false,
															"isInlineArray": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "TupleExpression",
															"src": "30269:32:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint8",
																"typeString": "uint8"
															}
														},
														"id": 2091,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "Conditional",
														"src": "30184:117:2",
														"trueExpression": {
															"argumentTypes": null,
															"components": [
																{
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 2082,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 2080,
																		"name": "defenderCount",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1954,
																		"src": "30236:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "-",
																	"rightExpression": {
																		"argumentTypes": null,
																		"id": 2081,
																		"name": "deadDefenders",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1993,
																		"src": "30252:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "30236:29:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"id": 2083,
															"isConstant": false,
															"isInlineArray": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "TupleExpression",
															"src": "30235:31:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "30156:145:2"
												},
												{
													"expression": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"id": 2093,
																"name": "remainingAttackers",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2062,
																"src": "30324:18:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"id": 2094,
																"name": "remainingDefenders",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2075,
																"src": "30344:18:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"id": 2095,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "30323:40:2",
														"typeDescriptions": {
															"typeIdentifier": "t_tuple$_t_uint32_$_t_uint32_$",
															"typeString": "tuple(uint32,uint32)"
														}
													},
													"functionReturnParameters": 1962,
													"id": 2096,
													"nodeType": "Return",
													"src": "30316:47:2"
												}
											]
										},
										"id": 2098,
										"nodeType": "IfStatement",
										"src": "28197:2177:2",
										"trueBody": {
											"id": 1983,
											"nodeType": "Block",
											"src": "28211:150:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"id": 1977,
																		"name": "moveSoldierCount",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1952,
																		"src": "28314:16:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"id": 1978,
																		"name": "defenderCount",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1954,
																		"src": "28332:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 1976,
																	"name": "addSafe",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4253,
																	"src": "28306:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																		"typeString": "function (uint32,uint32) pure returns (uint32)"
																	}
																},
																"id": 1979,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "28306:40:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"hexValue": "30",
																"id": 1980,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "28348:1:2",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_0_by_1",
																	"typeString": "int_const 0"
																},
																"value": "0"
															}
														],
														"id": 1981,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "28305:45:2",
														"typeDescriptions": {
															"typeIdentifier": "t_tuple$_t_uint32_$_t_rational_0_by_1_$",
															"typeString": "tuple(uint32,int_const 0)"
														}
													},
													"functionReturnParameters": 1962,
													"id": 1982,
													"nodeType": "Return",
													"src": "28298:52:2"
												}
											]
										}
									}
								]
							},
							"documentation": "@notice Declare victory for a team.\n @param submitBlock Block number when action was submitted to queue\n @param moveSoldierCount Number of soldiers to move or attack\n @param defenderCount Number of soldiers defending destination region\n @param friendly Whether this is an attack, or friendly move\n @return remainingAttackers Number of attacking soldiers remaining \n @return remainingDefenders Number of defending soldiers remaining",
							"id": 2100,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "getOutcomeAttackOrMove",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1957,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1950,
										"name": "submitBlock",
										"nodeType": "VariableDeclaration",
										"scope": 2100,
										"src": "27900:18:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1949,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "27900:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1952,
										"name": "moveSoldierCount",
										"nodeType": "VariableDeclaration",
										"scope": 2100,
										"src": "27929:23:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1951,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "27929:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1954,
										"name": "defenderCount",
										"nodeType": "VariableDeclaration",
										"scope": 2100,
										"src": "27963:20:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1953,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "27963:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1956,
										"name": "friendly",
										"nodeType": "VariableDeclaration",
										"scope": 2100,
										"src": "27994:13:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"typeName": {
											"id": 1955,
											"name": "bool",
											"nodeType": "ElementaryTypeName",
											"src": "27994:4:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "27890:123:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1962,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1959,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 2100,
										"src": "28062:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1958,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "28062:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1961,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 2100,
										"src": "28070:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1960,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "28070:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "28061:16:2"
							},
							"scope": 4288,
							"src": "27859:2521:2",
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "private"
						},
						{
							"body": {
								"id": 2163,
								"nodeType": "Block",
								"src": "30730:596:2",
								"statements": [
									{
										"assignments": [
											2110
										],
										"declarations": [
											{
												"constant": false,
												"id": 2110,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 2164,
												"src": "30740:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 2109,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "30740:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 2114,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 2111,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "30764:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 2113,
											"indexExpression": {
												"argumentTypes": null,
												"id": 2112,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2102,
												"src": "30778:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "30764:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "30740:45:2"
									},
									{
										"assignments": [
											2116
										],
										"declarations": [
											{
												"constant": false,
												"id": 2116,
												"name": "rewardTotal",
												"nodeType": "VariableDeclaration",
												"scope": 2164,
												"src": "30862:18:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 2115,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "30862:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 2118,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 2117,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "30883:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "30862:22:2"
									},
									{
										"assignments": [
											2120
										],
										"declarations": [
											{
												"constant": false,
												"id": 2120,
												"name": "bonusScore",
												"nodeType": "VariableDeclaration",
												"scope": 2164,
												"src": "30973:17:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 2119,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "30973:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 2124,
										"initialValue": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 2123,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 2121,
												"name": "REWARD_BONUS_MULTIPLIER_DENOM",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 147,
												"src": "30993:29:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "-",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2122,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "31025:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"src": "30993:33:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "30973:53:2"
									},
									{
										"body": {
											"id": 2153,
											"nodeType": "Block",
											"src": "31078:164:2",
											"statements": [
												{
													"condition": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 2141,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 2136,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2110,
																		"src": "31105:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 2137,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "regionOwners",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 228,
																	"src": "31105:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 2138,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 2126,
																	"src": "31124:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 2135,
																"name": "getData8",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4158,
																"src": "31096:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 2139,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "31096:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"id": 2140,
															"name": "teamId",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2104,
															"src": "31130:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "31096:40:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"falseBody": null,
													"id": 2152,
													"nodeType": "IfStatement",
													"src": "31092:140:2",
													"trueBody": {
														"id": 2151,
														"nodeType": "Block",
														"src": "31138:94:2",
														"statements": [
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 2146,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"id": 2142,
																		"name": "rewardTotal",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2116,
																		"src": "31156:11:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "+=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"id": 2143,
																			"name": "regionRewards",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 183,
																			"src": "31171:13:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_uint32_$25_storage",
																				"typeString": "uint32[25] storage ref"
																			}
																		},
																		"id": 2145,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 2144,
																			"name": "i",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 2126,
																			"src": "31185:1:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"nodeType": "IndexAccess",
																		"src": "31171:16:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "31156:31:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"id": 2147,
																"nodeType": "ExpressionStatement",
																"src": "31156:31:2"
															},
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 2149,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "UnaryOperation",
																	"operator": "++",
																	"prefix": false,
																	"src": "31205:12:2",
																	"subExpression": {
																		"argumentTypes": null,
																		"id": 2148,
																		"name": "bonusScore",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2120,
																		"src": "31205:10:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"id": 2150,
																"nodeType": "ExpressionStatement",
																"src": "31205:12:2"
															}
														]
													}
												}
											]
										},
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 2131,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 2129,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2126,
												"src": "31055:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "<",
											"rightExpression": {
												"argumentTypes": null,
												"id": 2130,
												"name": "REGION_COUNT",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 129,
												"src": "31059:12:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "31055:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"id": 2154,
										"initializationExpression": {
											"assignments": [
												2126
											],
											"declarations": [
												{
													"constant": false,
													"id": 2126,
													"name": "i",
													"nodeType": "VariableDeclaration",
													"scope": 2164,
													"src": "31041:8:2",
													"stateVariable": false,
													"storageLocation": "default",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"typeName": {
														"id": 2125,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "31041:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"value": null,
													"visibility": "internal"
												}
											],
											"id": 2128,
											"initialValue": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2127,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "31052:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"nodeType": "VariableDeclarationStatement",
											"src": "31041:12:2"
										},
										"loopExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 2133,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "UnaryOperation",
												"operator": "++",
												"prefix": false,
												"src": "31073:3:2",
												"subExpression": {
													"argumentTypes": null,
													"id": 2132,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2126,
													"src": "31073:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 2134,
											"nodeType": "ExpressionStatement",
											"src": "31073:3:2"
										},
										"nodeType": "ForStatement",
										"src": "31036:206:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 2160,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 2157,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"id": 2155,
																	"name": "rewardTotal",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 2116,
																	"src": "31261:11:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "*",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 2156,
																	"name": "bonusScore",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 2120,
																	"src": "31275:10:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "31261:24:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"id": 2158,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "31260:26:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "/",
													"rightExpression": {
														"argumentTypes": null,
														"id": 2159,
														"name": "REWARD_BONUS_MULTIPLIER_DENOM",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 147,
														"src": "31289:29:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "31260:58:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												}
											],
											"id": 2161,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "31259:60:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"functionReturnParameters": 2108,
										"id": 2162,
										"nodeType": "Return",
										"src": "31252:67:2"
									}
								]
							},
							"documentation": "@notice Calculate a team's reward amount based on what regions they control.\n @param gameId Id of game\n @param teamId Team you'd like to calculate rewards for\n @return Reward amount for team",
							"id": 2164,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "calculateRegionRewards",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 2105,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 2102,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 2164,
										"src": "30638:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 2101,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "30638:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 2104,
										"name": "teamId",
										"nodeType": "VariableDeclaration",
										"scope": 2164,
										"src": "30654:13:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 2103,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "30654:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "30637:31:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 2108,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 2107,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 2164,
										"src": "30717:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 2106,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "30717:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "30716:8:2"
							},
							"scope": 4288,
							"src": "30606:720:2",
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "private"
						},
						{
							"body": {
								"id": 2209,
								"nodeType": "Block",
								"src": "31494:612:2",
								"statements": [
									{
										"assignments": [
											2170
										],
										"declarations": [
											{
												"constant": false,
												"id": 2170,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 2210,
												"src": "31504:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 2169,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "31504:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 2174,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 2171,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "31528:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 2173,
											"indexExpression": {
												"argumentTypes": null,
												"id": 2172,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2166,
												"src": "31542:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "31528:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "31504:45:2"
									},
									{
										"assignments": [
											2176
										],
										"declarations": [
											{
												"constant": false,
												"id": 2176,
												"name": "teamId",
												"nodeType": "VariableDeclaration",
												"scope": 2210,
												"src": "31618:13:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 2175,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "31618:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 2179,
										"initialValue": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 2177,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2170,
												"src": "31634:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 2178,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "turnTeamId",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 214,
											"src": "31634:15:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "31618:31:2"
									},
									{
										"assignments": [
											2181
										],
										"declarations": [
											{
												"constant": false,
												"id": 2181,
												"name": "rewardAmount",
												"nodeType": "VariableDeclaration",
												"scope": 2210,
												"src": "31726:19:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 2180,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "31726:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 2186,
										"initialValue": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 2183,
													"name": "gameId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2166,
													"src": "31771:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"id": 2184,
													"name": "teamId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2176,
													"src": "31779:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												],
												"id": 2182,
												"name": "calculateRegionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2164,
												"src": "31748:22:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_view$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
													"typeString": "function (uint256,uint32) view returns (uint32)"
												}
											},
											"id": 2185,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "31748:38:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "31726:60:2"
									},
									{
										"assignments": [
											2188
										],
										"declarations": [
											{
												"constant": false,
												"id": 2188,
												"name": "undeployedSoldierCount",
												"nodeType": "VariableDeclaration",
												"scope": 2210,
												"src": "31852:29:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 2187,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "31852:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 2194,
										"initialValue": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2190,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2170,
														"src": "31894:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 2191,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "undeployedSoldiers",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 226,
													"src": "31894:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"id": 2192,
													"name": "teamId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2176,
													"src": "31919:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												],
												"id": 2189,
												"name": "getData32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4095,
												"src": "31884:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
													"typeString": "function (uint256,uint32) pure returns (uint32)"
												}
											},
											"id": 2193,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "31884:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "31852:74:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2207,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 2195,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2170,
													"src": "31936:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 2197,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"memberName": "undeployedSoldiers",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 226,
												"src": "31936:23:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2199,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2170,
															"src": "31985:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 2200,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "undeployedSoldiers",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 226,
														"src": "31985:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													{
														"argumentTypes": null,
														"id": 2201,
														"name": "teamId",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2176,
														"src": "32023:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													{
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"id": 2203,
																"name": "undeployedSoldierCount",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2188,
																"src": "32052:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"id": 2204,
																"name": "rewardAmount",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2181,
																"src": "32076:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 2202,
															"name": "addSafe",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4253,
															"src": "32044:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint32,uint32) pure returns (uint32)"
															}
														},
														"id": 2205,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "32044:45:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														{
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														{
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													],
													"id": 2198,
													"name": "setData32",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4133,
													"src": "31962:9:2",
													"typeDescriptions": {
														"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
														"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
													}
												},
												"id": 2206,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "31962:137:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"src": "31936:163:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"id": 2208,
										"nodeType": "ExpressionStatement",
										"src": "31936:163:2"
									}
								]
							},
							"documentation": "@notice Reward team with soldiers based on what regions they control.\n @param gameId Id of game",
							"id": 2210,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": false,
							"modifiers": [],
							"name": "giveRegionRewards",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 2167,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 2166,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 2210,
										"src": "31470:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 2165,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "31470:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "31469:16:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 2168,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "31494:0:2"
							},
							"scope": 4288,
							"src": "31443:663:2",
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "private"
						},
						{
							"body": {
								"id": 3840,
								"nodeType": "Block",
								"src": "32273:10521:2",
								"statements": [
									{
										"expression": {
											"argumentTypes": null,
											"id": 2225,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2213,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "32283:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2219,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2215,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "32306:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2216,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "HAWAII",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "32306:14:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2214,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "32299:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2217,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "32299:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "32283:39:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2220,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2218,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "32323:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "32283:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2222,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "32335:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2223,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_USA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "32335:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2221,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "32328:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2224,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "32328:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "32283:72:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2226,
										"nodeType": "ExpressionStatement",
										"src": "32283:72:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2239,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2227,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "32365:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2233,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2229,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "32388:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2230,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "HAWAII",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "32388:14:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2228,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "32381:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2231,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "32381:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "32365:39:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2234,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2232,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "32405:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "32365:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2236,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "32417:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2237,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "FIJI",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "32417:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2235,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "32410:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2238,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "32410:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "32365:65:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2240,
										"nodeType": "ExpressionStatement",
										"src": "32365:65:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2250,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2241,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "32440:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2247,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2243,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "32463:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2244,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "HAWAII",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "32463:14:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2242,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "32456:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2245,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "32456:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "32440:39:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2248,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2246,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "32480:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "32440:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2249,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "32485:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "32440:54:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2251,
										"nodeType": "ExpressionStatement",
										"src": "32440:54:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2261,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2252,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "32504:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2258,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2254,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "32527:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2255,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "HAWAII",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "32527:14:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2253,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "32520:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2256,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "32520:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "32504:39:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2259,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 2257,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "32544:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "32504:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2260,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "32549:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "32504:54:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2262,
										"nodeType": "ExpressionStatement",
										"src": "32504:54:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2272,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2263,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "32568:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2269,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2265,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "32591:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2266,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "HAWAII",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "32591:14:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2264,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "32584:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2267,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "32584:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "32568:39:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2270,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 2268,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "32608:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "32568:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2271,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "32613:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "32568:54:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2273,
										"nodeType": "ExpressionStatement",
										"src": "32568:54:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2286,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2274,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "32633:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2280,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2276,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "32656:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2277,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_CANADA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "32656:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2275,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "32649:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2278,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "32649:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "32633:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2281,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2279,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "32681:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "32633:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2283,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "32693:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2284,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_USA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "32693:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2282,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "32686:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2285,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "32686:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "32633:80:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2287,
										"nodeType": "ExpressionStatement",
										"src": "32633:80:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2300,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2288,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "32723:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2294,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2290,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "32746:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2291,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_CANADA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "32746:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2289,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "32739:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2292,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "32739:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "32723:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2295,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2293,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "32771:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "32723:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2297,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "32783:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2298,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_CANADA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "32783:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2296,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "32776:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2299,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "32776:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "32723:83:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2301,
										"nodeType": "ExpressionStatement",
										"src": "32723:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2314,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2302,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "32816:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2308,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2304,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "32839:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2305,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_CANADA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "32839:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2303,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "32832:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2306,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "32832:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "32816:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2309,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2307,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "32864:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "32816:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2311,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "32876:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2312,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_RUSSIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "32876:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2310,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "32869:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2313,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "32869:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "32816:83:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2315,
										"nodeType": "ExpressionStatement",
										"src": "32816:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2325,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2316,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "32909:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2322,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2318,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "32932:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2319,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_CANADA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "32932:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2317,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "32925:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2320,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "32925:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "32909:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2323,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 2321,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "32957:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "32909:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2324,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "32962:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "32909:62:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2326,
										"nodeType": "ExpressionStatement",
										"src": "32909:62:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2336,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2327,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "32981:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2333,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2329,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "33004:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2330,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_CANADA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "33004:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2328,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "32997:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2331,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "32997:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "32981:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2334,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 2332,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "33029:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "32981:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2335,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "33034:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "32981:62:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2337,
										"nodeType": "ExpressionStatement",
										"src": "32981:62:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2350,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2338,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "33054:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2344,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2340,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "33077:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2341,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_CANADA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "33077:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2339,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "33070:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2342,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "33070:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "33054:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2345,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2343,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "33102:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "33054:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2347,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "33114:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2348,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_CANADA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "33114:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2346,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "33107:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2349,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "33107:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "33054:83:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2351,
										"nodeType": "ExpressionStatement",
										"src": "33054:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2364,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2352,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "33147:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2358,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2354,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "33170:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2355,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_CANADA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "33170:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2353,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "33163:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2356,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "33163:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "33147:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2359,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2357,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "33195:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "33147:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2361,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "33207:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2362,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "GREENLAND",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "33207:17:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2360,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "33200:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2363,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "33200:25:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "33147:78:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2365,
										"nodeType": "ExpressionStatement",
										"src": "33147:78:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2378,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2366,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "33235:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2372,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2368,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "33258:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2369,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_CANADA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "33258:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2367,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "33251:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2370,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "33251:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "33235:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2373,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2371,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "33283:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "33235:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2375,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "33295:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2376,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_USA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "33295:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2374,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "33288:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2377,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "33288:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "33235:80:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2379,
										"nodeType": "ExpressionStatement",
										"src": "33235:80:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2389,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2380,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "33325:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2386,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2382,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "33348:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2383,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_CANADA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "33348:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2381,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "33341:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2384,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "33341:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "33325:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2387,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 2385,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "33373:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "33325:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2388,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "33378:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "33325:62:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2390,
										"nodeType": "ExpressionStatement",
										"src": "33325:62:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2400,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2391,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "33397:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2397,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2393,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "33420:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2394,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_CANADA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "33420:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2392,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "33413:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2395,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "33413:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "33397:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2398,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 2396,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "33445:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "33397:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2399,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "33450:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "33397:62:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2401,
										"nodeType": "ExpressionStatement",
										"src": "33397:62:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2414,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2402,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "33470:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2408,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2404,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "33493:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2405,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_USA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "33493:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2403,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "33486:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2406,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "33486:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "33470:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2409,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2407,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "33515:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "33470:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2411,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "33527:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2412,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "HAWAII",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "33527:14:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2410,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "33520:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2413,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "33520:22:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "33470:72:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2415,
										"nodeType": "ExpressionStatement",
										"src": "33470:72:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2428,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2416,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "33552:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2422,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2418,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "33575:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2419,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_USA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "33575:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2417,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "33568:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2420,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "33568:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "33552:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2423,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2421,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "33597:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "33552:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2425,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "33609:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2426,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_CANADA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "33609:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2424,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "33602:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2427,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "33602:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "33552:80:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2429,
										"nodeType": "ExpressionStatement",
										"src": "33552:80:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2442,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2430,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "33642:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2436,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2432,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "33665:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2433,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_USA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "33665:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2431,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "33658:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2434,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "33658:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "33642:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2437,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2435,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "33687:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "33642:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2439,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "33699:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2440,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_USA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "33699:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2438,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "33692:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2441,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "33692:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "33642:77:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2443,
										"nodeType": "ExpressionStatement",
										"src": "33642:77:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2456,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2444,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "33729:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2450,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2446,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "33752:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2447,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_USA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "33752:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2445,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "33745:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2448,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "33745:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "33729:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2451,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 2449,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "33774:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "33729:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2453,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "33786:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2454,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "NORTHERN_SOUTH_AMERICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "33786:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2452,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "33779:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2455,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "33779:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "33729:88:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2457,
										"nodeType": "ExpressionStatement",
										"src": "33729:88:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2467,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2458,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "33827:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2464,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2460,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "33850:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2461,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_USA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "33850:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2459,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "33843:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2462,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "33843:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "33827:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2465,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 2463,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "33872:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "33827:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2466,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "33877:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "33827:59:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2468,
										"nodeType": "ExpressionStatement",
										"src": "33827:59:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2481,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2469,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "33897:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2475,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2471,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "33920:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2472,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_USA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "33920:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2470,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "33913:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2473,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "33913:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "33897:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2476,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2474,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "33942:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "33897:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2478,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "33954:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2479,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_USA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "33954:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2477,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "33947:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2480,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "33947:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "33897:77:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2482,
										"nodeType": "ExpressionStatement",
										"src": "33897:77:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2495,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2483,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "33984:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2489,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2485,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "34007:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2486,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_USA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "34007:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2484,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "34000:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2487,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "34000:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "33984:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2490,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2488,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "34029:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "33984:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2492,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "34041:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2493,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_CANADA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "34041:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2491,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "34034:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2494,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "34034:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "33984:80:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2496,
										"nodeType": "ExpressionStatement",
										"src": "33984:80:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2509,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2497,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "34074:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2503,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2499,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "34097:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2500,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_USA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "34097:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2498,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "34090:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2501,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "34090:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "34074:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2504,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2502,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "34119:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "34074:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2506,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "34131:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2507,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "NORTHERN_SOUTH_AMERICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "34131:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2505,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "34124:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2508,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "34124:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "34074:88:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2510,
										"nodeType": "ExpressionStatement",
										"src": "34074:88:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2520,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2511,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "34172:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2517,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2513,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "34195:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2514,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_USA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "34195:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2512,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "34188:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2515,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "34188:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "34172:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2518,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 2516,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "34217:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "34172:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2519,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "34222:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "34172:59:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2521,
										"nodeType": "ExpressionStatement",
										"src": "34172:59:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2531,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2522,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "34241:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2528,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2524,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "34264:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2525,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_USA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "34264:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2523,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "34257:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2526,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "34257:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "34241:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2529,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 2527,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "34286:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "34241:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2530,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "34291:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "34241:59:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2532,
										"nodeType": "ExpressionStatement",
										"src": "34241:59:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2545,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2533,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "34311:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2539,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2535,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "34334:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2536,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "GREENLAND",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "34334:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2534,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "34327:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2537,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "34327:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "34311:42:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2540,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2538,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "34354:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "34311:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2542,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "34366:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2543,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_CANADA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "34366:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2541,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "34359:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2544,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "34359:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "34311:78:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2546,
										"nodeType": "ExpressionStatement",
										"src": "34311:78:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2559,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2547,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "34399:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2553,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2549,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "34422:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2550,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "GREENLAND",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "34422:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2548,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "34415:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2551,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "34415:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "34399:42:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2554,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2552,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "34442:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "34399:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2556,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "34454:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2557,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_EUROPE",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "34454:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2555,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "34447:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2558,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "34447:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "34399:78:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2560,
										"nodeType": "ExpressionStatement",
										"src": "34399:78:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2570,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2561,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "34487:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2567,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2563,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "34510:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2564,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "GREENLAND",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "34510:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2562,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "34503:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2565,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "34503:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "34487:42:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2568,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2566,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "34530:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "34487:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2569,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "34535:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "34487:57:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2571,
										"nodeType": "ExpressionStatement",
										"src": "34487:57:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2581,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2572,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "34554:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2578,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2574,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "34577:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2575,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "GREENLAND",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "34577:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2573,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "34570:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2576,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "34570:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "34554:42:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2579,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 2577,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "34597:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "34554:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2580,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "34602:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "34554:57:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2582,
										"nodeType": "ExpressionStatement",
										"src": "34554:57:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2592,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2583,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "34621:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2589,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2585,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "34644:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2586,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "GREENLAND",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "34644:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2584,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "34637:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2587,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "34637:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "34621:42:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2590,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 2588,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "34664:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "34621:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2591,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "34669:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "34621:57:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2593,
										"nodeType": "ExpressionStatement",
										"src": "34621:57:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2606,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2594,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "34689:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2600,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2596,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "34712:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2597,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "NORTHERN_SOUTH_AMERICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "34712:30:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2595,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "34705:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2598,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "34705:38:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "34689:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2601,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2599,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "34745:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "34689:58:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2603,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "34757:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2604,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_USA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "34757:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2602,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "34750:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2605,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "34750:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "34689:88:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2607,
										"nodeType": "ExpressionStatement",
										"src": "34689:88:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2620,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2608,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "34787:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2614,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2610,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "34810:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2611,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "NORTHERN_SOUTH_AMERICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "34810:30:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2609,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "34803:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2612,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "34803:38:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "34787:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2615,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2613,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "34843:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "34787:58:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2617,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "34855:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2618,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_USA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "34855:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2616,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "34848:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2619,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "34848:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "34787:88:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2621,
										"nodeType": "ExpressionStatement",
										"src": "34787:88:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2634,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2622,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "34885:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2628,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2624,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "34908:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2625,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "NORTHERN_SOUTH_AMERICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "34908:30:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2623,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "34901:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2626,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "34901:38:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "34885:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2629,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2627,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "34941:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "34885:58:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2631,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "34953:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2632,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "SOUTHERN_SOUTH_AMERICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "34953:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2630,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "34946:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2633,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "34946:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "34885:99:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2635,
										"nodeType": "ExpressionStatement",
										"src": "34885:99:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2645,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2636,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "34994:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2642,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2638,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "35017:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2639,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "NORTHERN_SOUTH_AMERICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "35017:30:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2637,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "35010:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2640,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "35010:38:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "34994:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2643,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 2641,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "35050:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "34994:58:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2644,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "35055:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "34994:70:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2646,
										"nodeType": "ExpressionStatement",
										"src": "34994:70:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2656,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2647,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "35074:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2653,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2649,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "35097:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2650,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "NORTHERN_SOUTH_AMERICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "35097:30:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2648,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "35090:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2651,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "35090:38:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "35074:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2654,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 2652,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "35130:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "35074:58:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2655,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "35135:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "35074:70:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2657,
										"nodeType": "ExpressionStatement",
										"src": "35074:70:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2670,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2658,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "35155:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2664,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2660,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "35178:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2661,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTHERN_SOUTH_AMERICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "35178:30:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2659,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "35171:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2662,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "35171:38:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "35155:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2665,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2663,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "35211:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "35155:58:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2667,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "35223:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2668,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "NORTHERN_SOUTH_AMERICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "35223:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2666,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "35216:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2669,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "35216:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "35155:99:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2671,
										"nodeType": "ExpressionStatement",
										"src": "35155:99:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2684,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2672,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "35264:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2678,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2674,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "35287:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2675,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTHERN_SOUTH_AMERICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "35287:30:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2673,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "35280:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2676,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "35280:38:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "35264:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2679,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2677,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "35320:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "35264:58:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2681,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "35332:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2682,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WEST_ANTARCTICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "35332:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2680,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "35325:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2683,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "35325:31:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "35264:92:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2685,
										"nodeType": "ExpressionStatement",
										"src": "35264:92:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2695,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2686,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "35366:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2692,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2688,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "35389:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2689,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTHERN_SOUTH_AMERICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "35389:30:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2687,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "35382:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2690,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "35382:38:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "35366:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2693,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2691,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "35422:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "35366:58:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2694,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "35427:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "35366:70:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2696,
										"nodeType": "ExpressionStatement",
										"src": "35366:70:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2706,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2697,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "35446:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2703,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2699,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "35469:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2700,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTHERN_SOUTH_AMERICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "35469:30:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2698,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "35462:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2701,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "35462:38:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "35446:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2704,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 2702,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "35502:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "35446:58:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2705,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "35507:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "35446:70:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2707,
										"nodeType": "ExpressionStatement",
										"src": "35446:70:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2717,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2708,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "35526:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2714,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2710,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "35549:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2711,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTHERN_SOUTH_AMERICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "35549:30:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2709,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "35542:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2712,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "35542:38:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "35526:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2715,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 2713,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "35582:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "35526:58:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2716,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "35587:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "35526:70:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2718,
										"nodeType": "ExpressionStatement",
										"src": "35526:70:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2731,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2719,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "35607:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2725,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2721,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "35630:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2722,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WEST_ANTARCTICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "35630:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2720,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "35623:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2723,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "35623:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "35607:48:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2726,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2724,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "35656:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "35607:51:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2728,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "35668:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2729,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "SOUTHERN_SOUTH_AMERICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "35668:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2727,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "35661:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2730,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "35661:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "35607:92:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2732,
										"nodeType": "ExpressionStatement",
										"src": "35607:92:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2745,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2733,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "35709:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2739,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2735,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "35732:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2736,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WEST_ANTARCTICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "35732:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2734,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "35725:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2737,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "35725:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "35709:48:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2740,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2738,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "35758:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "35709:51:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2742,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "35770:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2743,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EAST_ANTARCTICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "35770:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2741,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "35763:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2744,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "35763:31:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "35709:85:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2746,
										"nodeType": "ExpressionStatement",
										"src": "35709:85:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2756,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2747,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "35804:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2753,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2749,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "35827:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2750,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WEST_ANTARCTICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "35827:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2748,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "35820:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2751,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "35820:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "35804:48:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2754,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2752,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "35853:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "35804:51:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2755,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "35858:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "35804:63:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2757,
										"nodeType": "ExpressionStatement",
										"src": "35804:63:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2767,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2758,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "35877:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2764,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2760,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "35900:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2761,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WEST_ANTARCTICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "35900:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2759,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "35893:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2762,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "35893:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "35877:48:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2765,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 2763,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "35926:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "35877:51:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2766,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "35931:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "35877:63:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2768,
										"nodeType": "ExpressionStatement",
										"src": "35877:63:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2778,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2769,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "35950:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2775,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2771,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "35973:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2772,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WEST_ANTARCTICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "35973:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2770,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "35966:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2773,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "35966:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "35950:48:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2776,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 2774,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "35999:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "35950:51:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2777,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "36004:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "35950:63:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2779,
										"nodeType": "ExpressionStatement",
										"src": "35950:63:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2792,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2780,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "36024:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2786,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2782,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "36047:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2783,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EAST_ANTARCTICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "36047:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2781,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "36040:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2784,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "36040:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "36024:48:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2787,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2785,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "36073:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "36024:51:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2789,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "36085:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2790,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WEST_ANTARCTICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "36085:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2788,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "36078:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2791,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "36078:31:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "36024:85:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2793,
										"nodeType": "ExpressionStatement",
										"src": "36024:85:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2806,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2794,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "36119:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2800,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2796,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "36142:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2797,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EAST_ANTARCTICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "36142:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2795,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "36135:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2798,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "36135:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "36119:48:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2801,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2799,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "36168:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "36119:51:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2803,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "36180:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2804,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "NEW_ZEALAND",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "36180:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2802,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "36173:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2805,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "36173:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "36119:81:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2807,
										"nodeType": "ExpressionStatement",
										"src": "36119:81:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2817,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2808,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "36210:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2814,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2810,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "36233:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2811,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EAST_ANTARCTICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "36233:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2809,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "36226:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2812,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "36226:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "36210:48:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2815,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2813,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "36259:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "36210:51:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2816,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "36264:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "36210:63:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2818,
										"nodeType": "ExpressionStatement",
										"src": "36210:63:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2828,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2819,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "36283:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2825,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2821,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "36306:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2822,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EAST_ANTARCTICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "36306:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2820,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "36299:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2823,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "36299:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "36283:48:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2826,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 2824,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "36332:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "36283:51:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2827,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "36337:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "36283:63:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2829,
										"nodeType": "ExpressionStatement",
										"src": "36283:63:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2839,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2830,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "36356:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2836,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2832,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "36379:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2833,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EAST_ANTARCTICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "36379:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2831,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "36372:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2834,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "36372:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "36356:48:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2837,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 2835,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "36405:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "36356:51:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2838,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "36410:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "36356:63:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2840,
										"nodeType": "ExpressionStatement",
										"src": "36356:63:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2853,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2841,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "36430:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2847,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2843,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "36453:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2844,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_EUROPE",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "36453:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2842,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "36446:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2845,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "36446:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "36430:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2848,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2846,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "36478:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "36430:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2850,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "36490:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2851,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "GREENLAND",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "36490:17:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2849,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "36483:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2852,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "36483:25:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "36430:78:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2854,
										"nodeType": "ExpressionStatement",
										"src": "36430:78:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2867,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2855,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "36518:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2861,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2857,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "36541:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2858,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_EUROPE",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "36541:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2856,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "36534:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2859,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "36534:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "36518:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2862,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2860,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "36566:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "36518:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2864,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "36578:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2865,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_EUROPE",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "36578:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2863,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "36571:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2866,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "36571:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "36518:83:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2868,
										"nodeType": "ExpressionStatement",
										"src": "36518:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2881,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2869,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "36611:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2875,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2871,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "36634:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2872,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_EUROPE",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "36634:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2870,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "36627:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2873,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "36627:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "36611:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2876,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2874,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "36659:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "36611:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2878,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "36671:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2879,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WEST_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "36671:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2877,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "36664:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2880,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "36664:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "36611:80:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2882,
										"nodeType": "ExpressionStatement",
										"src": "36611:80:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2892,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2883,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "36701:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2889,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2885,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "36724:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2886,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_EUROPE",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "36724:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2884,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "36717:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2887,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "36717:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "36701:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2890,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 2888,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "36749:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "36701:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2891,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "36754:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "36701:62:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2893,
										"nodeType": "ExpressionStatement",
										"src": "36701:62:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2903,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2894,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "36773:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2900,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2896,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "36796:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2897,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_EUROPE",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "36796:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2895,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "36789:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2898,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "36789:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "36773:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2901,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 2899,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "36821:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "36773:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2902,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "36826:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "36773:62:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2904,
										"nodeType": "ExpressionStatement",
										"src": "36773:62:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2917,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2905,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "36846:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2911,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2907,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "36869:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2908,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_EUROPE",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "36869:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2906,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "36862:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2909,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "36862:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "36846:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2912,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2910,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "36894:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "36846:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2914,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "36906:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2915,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_EUROPE",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "36906:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2913,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "36899:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2916,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "36899:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "36846:83:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2918,
										"nodeType": "ExpressionStatement",
										"src": "36846:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2931,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2919,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "36939:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2925,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2921,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "36962:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2922,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_EUROPE",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "36962:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2920,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "36955:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2923,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "36955:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "36939:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2926,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2924,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "36987:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "36939:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2928,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "36999:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2929,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WEST_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "36999:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2927,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "36992:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2930,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "36992:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "36939:80:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2932,
										"nodeType": "ExpressionStatement",
										"src": "36939:80:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2945,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2933,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "37029:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2939,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2935,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "37052:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2936,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_EUROPE",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "37052:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2934,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "37045:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2937,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "37045:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "37029:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2940,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2938,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "37077:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "37029:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2942,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "37089:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2943,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "MIDDLE_EAST",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "37089:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2941,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "37082:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2944,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "37082:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "37029:80:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2946,
										"nodeType": "ExpressionStatement",
										"src": "37029:80:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2959,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2947,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "37119:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2953,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2949,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "37142:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2950,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_EUROPE",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "37142:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2948,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "37135:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2951,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "37135:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "37119:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2954,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 2952,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "37167:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "37119:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2956,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "37179:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2957,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "CENTRAL_RUSSIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "37179:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2955,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "37172:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2958,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "37172:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "37119:83:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2960,
										"nodeType": "ExpressionStatement",
										"src": "37119:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2970,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2961,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "37212:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2967,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2963,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "37235:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2964,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_EUROPE",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "37235:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2962,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "37228:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2965,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "37228:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "37212:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2968,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 2966,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "37260:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "37212:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2969,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "37265:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "37212:62:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2971,
										"nodeType": "ExpressionStatement",
										"src": "37212:62:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2984,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2972,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "37285:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2978,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2974,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "37308:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2975,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "CENTRAL_RUSSIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "37308:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2973,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "37301:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2976,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "37301:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "37285:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2979,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2977,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "37333:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "37285:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2981,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "37345:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2982,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_EUROPE",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "37345:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2980,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "37338:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2983,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "37338:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "37285:83:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2985,
										"nodeType": "ExpressionStatement",
										"src": "37285:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2998,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2986,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "37378:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2992,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2988,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "37401:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2989,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "CENTRAL_RUSSIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "37401:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2987,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "37394:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2990,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "37394:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "37378:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2993,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2991,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "37426:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "37378:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2995,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "37438:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2996,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "MIDDLE_EAST",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "37438:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2994,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "37431:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2997,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "37431:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "37378:80:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2999,
										"nodeType": "ExpressionStatement",
										"src": "37378:80:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3012,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3000,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "37468:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3006,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3002,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "37491:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3003,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "CENTRAL_RUSSIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "37491:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3001,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "37484:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3004,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "37484:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "37468:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3007,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3005,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "37516:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "37468:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3009,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "37528:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3010,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "INDIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "37528:13:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3008,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "37521:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3011,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "37521:21:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "37468:74:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3013,
										"nodeType": "ExpressionStatement",
										"src": "37468:74:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3026,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3014,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "37552:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3020,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3016,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "37575:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3017,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "CENTRAL_RUSSIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "37575:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3015,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "37568:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3018,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "37568:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "37552:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3021,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3019,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "37600:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "37552:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3023,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "37612:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3024,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_CHINA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "37612:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3022,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "37605:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3025,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "37605:29:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "37552:82:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3027,
										"nodeType": "ExpressionStatement",
										"src": "37552:82:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3040,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3028,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "37644:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3034,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3030,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "37667:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3031,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "CENTRAL_RUSSIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "37667:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3029,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "37660:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3032,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "37660:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "37644:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3035,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3033,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "37692:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "37644:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3037,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "37704:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3038,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_RUSSIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "37704:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3036,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "37697:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3039,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "37697:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "37644:83:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3041,
										"nodeType": "ExpressionStatement",
										"src": "37644:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3054,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3042,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "37738:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3048,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3044,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "37761:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3045,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_RUSSIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "37761:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3043,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "37754:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3046,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "37754:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "37738:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3049,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 3047,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "37786:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "37738:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3051,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "37798:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3052,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_CHINA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "37798:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3050,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "37791:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3053,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "37791:29:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "37738:82:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3055,
										"nodeType": "ExpressionStatement",
										"src": "37738:82:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3068,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3056,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "37830:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3062,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3058,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "37853:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3059,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_RUSSIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "37853:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3057,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "37846:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3060,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "37846:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "37830:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3063,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 3061,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "37878:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "37830:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3065,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "37890:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3066,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "CENTRAL_RUSSIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "37890:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3064,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "37883:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3067,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "37883:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "37830:83:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3069,
										"nodeType": "ExpressionStatement",
										"src": "37830:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3082,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3070,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "37923:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3076,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3072,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "37946:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3073,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_RUSSIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "37946:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3071,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "37939:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3074,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "37939:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "37923:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3077,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3075,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "37971:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "37923:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3079,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "37983:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3080,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_CANADA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "37983:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3078,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "37976:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3081,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "37976:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "37923:83:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3083,
										"nodeType": "ExpressionStatement",
										"src": "37923:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3093,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3084,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "38016:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3090,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3086,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "38039:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3087,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_RUSSIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "38039:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3085,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "38032:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3088,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "38032:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "38016:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3091,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3089,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "38064:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "38016:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3092,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "38069:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "38016:62:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3094,
										"nodeType": "ExpressionStatement",
										"src": "38016:62:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3104,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3095,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "38088:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3101,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3097,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "38111:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3098,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_RUSSIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "38111:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3096,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "38104:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3099,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "38104:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "38088:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3102,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3100,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "38136:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "38088:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3103,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "38141:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "38088:62:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3105,
										"nodeType": "ExpressionStatement",
										"src": "38088:62:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3118,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3106,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "38161:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3112,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3108,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "38184:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3109,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WEST_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "38184:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3107,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "38177:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3110,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "38177:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "38161:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3113,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 3111,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "38206:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "38161:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3115,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "38218:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3116,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_EUROPE",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "38218:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3114,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "38211:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3117,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "38211:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "38161:80:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3119,
										"nodeType": "ExpressionStatement",
										"src": "38161:80:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3132,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3120,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "38251:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3126,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3122,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "38274:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3123,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WEST_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "38274:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3121,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "38267:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3124,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "38267:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "38251:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3127,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 3125,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "38296:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "38251:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3129,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "38308:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3130,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_EUROPE",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "38308:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3128,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "38301:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3131,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "38301:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "38251:80:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3133,
										"nodeType": "ExpressionStatement",
										"src": "38251:80:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3146,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3134,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "38341:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3140,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3136,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "38364:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3137,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WEST_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "38364:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3135,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "38357:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3138,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "38357:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "38341:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3141,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3139,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "38386:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "38341:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3143,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "38398:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3144,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "MIDDLE_EAST",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "38398:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3142,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "38391:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3145,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "38391:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "38341:77:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3147,
										"nodeType": "ExpressionStatement",
										"src": "38341:77:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3160,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3148,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "38428:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3154,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3150,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "38451:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3151,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WEST_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "38451:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3149,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "38444:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3152,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "38444:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "38428:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3155,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3153,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "38473:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "38428:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3157,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "38485:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3158,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EAST_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "38485:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3156,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "38478:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3159,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "38478:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "38428:77:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3161,
										"nodeType": "ExpressionStatement",
										"src": "38428:77:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3174,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3162,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "38515:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3168,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3164,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "38538:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3165,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WEST_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "38538:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3163,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "38531:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3166,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "38531:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "38515:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3169,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3167,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "38560:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "38515:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3171,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "38572:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3172,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "SOUTH_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "38572:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3170,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "38565:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3173,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "38565:28:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "38515:78:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3175,
										"nodeType": "ExpressionStatement",
										"src": "38515:78:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3188,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3176,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "38604:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3182,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3178,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "38627:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3179,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "MIDDLE_EAST",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "38627:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3177,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "38620:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3180,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "38620:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "38604:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3183,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 3181,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "38649:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "38604:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3185,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "38661:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3186,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_EUROPE",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "38661:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3184,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "38654:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3187,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "38654:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "38604:80:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3189,
										"nodeType": "ExpressionStatement",
										"src": "38604:80:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3202,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3190,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "38694:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3196,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3192,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "38717:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3193,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "MIDDLE_EAST",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "38717:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3191,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "38710:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3194,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "38710:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "38694:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3197,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 3195,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "38739:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "38694:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3199,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "38751:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3200,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "CENTRAL_RUSSIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "38751:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3198,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "38744:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3201,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "38744:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "38694:80:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3203,
										"nodeType": "ExpressionStatement",
										"src": "38694:80:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3216,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3204,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "38784:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3210,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3206,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "38807:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3207,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "MIDDLE_EAST",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "38807:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3205,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "38800:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3208,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "38800:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "38784:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3211,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3209,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "38829:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "38784:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3213,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "38841:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3214,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "INDIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "38841:13:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3212,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "38834:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3215,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "38834:21:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "38784:71:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3217,
										"nodeType": "ExpressionStatement",
										"src": "38784:71:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3230,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3218,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "38865:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3224,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3220,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "38888:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3221,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "MIDDLE_EAST",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "38888:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3219,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "38881:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3222,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "38881:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "38865:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3225,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3223,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "38910:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "38865:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3227,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "38922:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3228,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EAST_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "38922:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3226,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "38915:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3229,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "38915:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "38865:77:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3231,
										"nodeType": "ExpressionStatement",
										"src": "38865:77:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3244,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3232,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "38952:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3238,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3234,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "38975:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3235,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "MIDDLE_EAST",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "38975:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3233,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "38968:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3236,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "38968:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "38952:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3239,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3237,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "38997:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "38952:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3241,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "39009:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3242,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WEST_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "39009:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3240,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "39002:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3243,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "39002:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "38952:77:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3245,
										"nodeType": "ExpressionStatement",
										"src": "38952:77:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3258,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3246,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "39040:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3252,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3248,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "39063:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3249,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EAST_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "39063:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3247,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "39056:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3250,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "39056:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "39040:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3253,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 3251,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "39085:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "39040:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3255,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "39097:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3256,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WEST_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "39097:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3254,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "39090:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3257,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "39090:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "39040:77:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3259,
										"nodeType": "ExpressionStatement",
										"src": "39040:77:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3272,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3260,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "39127:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3266,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3262,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "39150:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3263,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EAST_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "39150:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3261,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "39143:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3264,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "39143:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "39127:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3267,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 3265,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "39172:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "39127:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3269,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "39184:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3270,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "SOUTH_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "39184:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3268,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "39177:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3271,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "39177:28:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "39127:78:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3273,
										"nodeType": "ExpressionStatement",
										"src": "39127:78:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3286,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3274,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "39215:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3280,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3276,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "39238:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3277,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EAST_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "39238:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3275,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "39231:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3278,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "39231:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "39215:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3281,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3279,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "39260:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "39215:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3283,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "39272:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3284,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "MIDDLE_EAST",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "39272:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3282,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "39265:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3285,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "39265:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "39215:77:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3287,
										"nodeType": "ExpressionStatement",
										"src": "39215:77:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3300,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3288,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "39302:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3294,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3290,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "39325:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3291,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EAST_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "39325:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3289,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "39318:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3292,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "39318:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "39302:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3295,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3293,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "39347:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "39302:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3297,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "39359:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3298,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "INDIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "39359:13:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3296,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "39352:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3299,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "39352:21:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "39302:71:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3301,
										"nodeType": "ExpressionStatement",
										"src": "39302:71:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3311,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3302,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "39383:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3308,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3304,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "39406:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3305,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EAST_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "39406:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3303,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "39399:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3306,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "39399:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "39383:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3309,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3307,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "39428:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "39383:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3310,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "39433:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "39383:59:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3312,
										"nodeType": "ExpressionStatement",
										"src": "39383:59:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3325,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3313,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "39453:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3319,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3315,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "39476:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3316,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTH_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "39476:20:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3314,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "39469:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3317,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "39469:28:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "39453:45:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3320,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 3318,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "39499:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "39453:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3322,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "39511:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3323,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WEST_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "39511:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3321,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "39504:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3324,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "39504:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "39453:78:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3326,
										"nodeType": "ExpressionStatement",
										"src": "39453:78:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3339,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3327,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "39541:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3333,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3329,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "39564:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3330,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTH_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "39564:20:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3328,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "39557:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3331,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "39557:28:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "39541:45:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3334,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 3332,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "39587:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "39541:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3336,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "39599:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3337,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EAST_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "39599:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3335,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "39592:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3338,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "39592:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "39541:78:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3340,
										"nodeType": "ExpressionStatement",
										"src": "39541:78:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3350,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3341,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "39629:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3347,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3343,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "39652:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3344,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTH_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "39652:20:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3342,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "39645:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3345,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "39645:28:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "39629:45:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3348,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3346,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "39675:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "39629:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3349,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "39680:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "39629:60:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3351,
										"nodeType": "ExpressionStatement",
										"src": "39629:60:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3361,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3352,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "39699:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3358,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3354,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "39722:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3355,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTH_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "39722:20:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3353,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "39715:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3356,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "39715:28:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "39699:45:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3359,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3357,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "39745:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "39699:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3360,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "39750:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "39699:60:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3362,
										"nodeType": "ExpressionStatement",
										"src": "39699:60:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3372,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3363,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "39769:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3369,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3365,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "39792:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3366,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTH_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "39792:20:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3364,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "39785:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3367,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "39785:28:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "39769:45:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3370,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3368,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "39815:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "39769:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3371,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "39820:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "39769:60:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3373,
										"nodeType": "ExpressionStatement",
										"src": "39769:60:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3386,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3374,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "39840:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3380,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3376,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "39863:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3377,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "INDIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "39863:13:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3375,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "39856:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3378,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "39856:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "39840:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3381,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 3379,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "39879:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "39840:41:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3383,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "39891:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3384,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EAST_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "39891:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3382,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "39884:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3385,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "39884:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "39840:71:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3387,
										"nodeType": "ExpressionStatement",
										"src": "39840:71:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3400,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3388,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "39921:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3394,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3390,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "39944:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3391,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "INDIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "39944:13:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3389,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "39937:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3392,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "39937:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "39921:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3395,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 3393,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "39960:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "39921:41:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3397,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "39972:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3398,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "MIDDLE_EAST",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "39972:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3396,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "39965:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3399,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "39965:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "39921:71:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3401,
										"nodeType": "ExpressionStatement",
										"src": "39921:71:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3414,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3402,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "40002:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3408,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3404,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "40025:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3405,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "INDIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "40025:13:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3403,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "40018:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3406,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "40018:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "40002:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3409,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3407,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "40041:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "40002:41:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3411,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "40053:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3412,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "CENTRAL_RUSSIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "40053:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3410,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "40046:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3413,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "40046:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "40002:74:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3415,
										"nodeType": "ExpressionStatement",
										"src": "40002:74:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3428,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3416,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "40086:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3422,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3418,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "40109:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3419,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "INDIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "40109:13:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3417,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "40102:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3420,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "40102:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "40086:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3423,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3421,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "40125:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "40086:41:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3425,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "40137:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3426,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_CHINA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "40137:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3424,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "40130:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3427,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "40130:29:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "40086:73:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3429,
										"nodeType": "ExpressionStatement",
										"src": "40086:73:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3442,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3430,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "40169:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3436,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3432,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "40192:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3433,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "INDIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "40192:13:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3431,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "40185:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3434,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "40185:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "40169:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3437,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3435,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "40208:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "40169:41:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3439,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "40220:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3440,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "SOUTHEAST_ASIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "40220:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3438,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "40213:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3441,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "40213:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "40169:74:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3443,
										"nodeType": "ExpressionStatement",
										"src": "40169:74:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3456,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3444,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "40254:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3450,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3446,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "40277:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3447,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_CHINA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "40277:21:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3445,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "40270:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3448,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "40270:29:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "40254:46:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3451,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 3449,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "40301:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "40254:49:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3453,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "40313:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3454,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "INDIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "40313:13:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3452,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "40306:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3455,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "40306:21:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "40254:73:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3457,
										"nodeType": "ExpressionStatement",
										"src": "40254:73:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3470,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3458,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "40337:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3464,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3460,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "40360:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3461,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_CHINA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "40360:21:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3459,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "40353:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3462,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "40353:29:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "40337:46:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3465,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 3463,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "40384:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "40337:49:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3467,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "40396:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3468,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "CENTRAL_RUSSIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "40396:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3466,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "40389:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3469,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "40389:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "40337:82:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3471,
										"nodeType": "ExpressionStatement",
										"src": "40337:82:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3484,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3472,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "40429:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3478,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3474,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "40452:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3475,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_CHINA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "40452:21:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3473,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "40445:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3476,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "40445:29:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "40429:46:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3479,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3477,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "40476:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "40429:49:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3481,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "40488:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3482,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_RUSSIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "40488:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3480,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "40481:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3483,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "40481:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "40429:82:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3485,
										"nodeType": "ExpressionStatement",
										"src": "40429:82:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3498,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3486,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "40521:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3492,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3488,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "40544:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3489,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_CHINA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "40544:21:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3487,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "40537:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3490,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "40537:29:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "40521:46:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3493,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3491,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "40568:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "40521:49:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3495,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "40580:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3496,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "SOUTHEAST_ASIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "40580:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3494,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "40573:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3497,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "40573:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "40521:82:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3499,
										"nodeType": "ExpressionStatement",
										"src": "40521:82:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3509,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3500,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "40613:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3506,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3502,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "40636:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3503,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_CHINA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "40636:21:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3501,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "40629:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3504,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "40629:29:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "40613:46:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3507,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3505,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "40660:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "40613:49:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3508,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "40665:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "40613:61:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3510,
										"nodeType": "ExpressionStatement",
										"src": "40613:61:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3523,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3511,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "40685:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3517,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3513,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "40708:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3514,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTHEAST_ASIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "40708:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3512,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "40701:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3515,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "40701:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "40685:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3518,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 3516,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "40733:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "40685:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3520,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "40745:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3521,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "INDIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "40745:13:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3519,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "40738:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3522,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "40738:21:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "40685:74:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3524,
										"nodeType": "ExpressionStatement",
										"src": "40685:74:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3537,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3525,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "40769:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3531,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3527,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "40792:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3528,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTHEAST_ASIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "40792:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3526,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "40785:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3529,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "40785:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "40769:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3532,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 3530,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "40817:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "40769:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3534,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "40829:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3535,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_CHINA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "40829:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3533,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "40822:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3536,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "40822:29:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "40769:82:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3538,
										"nodeType": "ExpressionStatement",
										"src": "40769:82:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3551,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3539,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "40861:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3545,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3541,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "40884:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3542,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTHEAST_ASIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "40884:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3540,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "40877:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3543,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "40877:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "40861:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3546,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3544,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "40909:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "40861:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3548,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "40921:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3549,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_AUSTRALIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "40921:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3547,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "40914:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3550,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "40914:33:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "40861:86:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3552,
										"nodeType": "ExpressionStatement",
										"src": "40861:86:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3565,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3553,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "40957:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3559,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3555,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "40980:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3556,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTHEAST_ASIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "40980:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3554,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "40973:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3557,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "40973:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "40957:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3560,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3558,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "41005:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "40957:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3562,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "41017:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3563,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_AUSTRALIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "41017:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3561,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "41010:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3564,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "41010:33:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "40957:86:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3566,
										"nodeType": "ExpressionStatement",
										"src": "40957:86:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3579,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3567,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "41053:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3573,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3569,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "41076:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3570,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTHEAST_ASIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "41076:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3568,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "41069:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3571,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "41069:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "41053:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3574,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3572,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "41101:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "41053:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3576,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "41113:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3577,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "FIJI",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "41113:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3575,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "41106:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3578,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "41106:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "41053:73:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3580,
										"nodeType": "ExpressionStatement",
										"src": "41053:73:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3593,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3581,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "41137:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3587,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3583,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "41160:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3584,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_AUSTRALIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "41160:25:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3582,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "41153:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3585,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "41153:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "41137:50:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3588,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 3586,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "41188:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "41137:53:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3590,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "41200:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3591,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_AUSTRALIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "41200:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3589,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "41193:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3592,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "41193:33:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "41137:89:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3594,
										"nodeType": "ExpressionStatement",
										"src": "41137:89:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3607,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3595,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "41236:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3601,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3597,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "41259:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3598,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_AUSTRALIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "41259:25:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3596,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "41252:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3599,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "41252:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "41236:50:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3602,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 3600,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "41287:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "41236:53:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3604,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "41299:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3605,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "SOUTHEAST_ASIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "41299:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3603,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "41292:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3606,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "41292:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "41236:86:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3608,
										"nodeType": "ExpressionStatement",
										"src": "41236:86:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3618,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3609,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "41332:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3615,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3611,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "41355:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3612,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_AUSTRALIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "41355:25:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3610,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "41348:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3613,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "41348:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "41332:50:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3616,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3614,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "41383:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "41332:53:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3617,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "41388:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "41332:65:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3619,
										"nodeType": "ExpressionStatement",
										"src": "41332:65:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3629,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3620,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "41407:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3626,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3622,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "41430:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3623,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_AUSTRALIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "41430:25:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3621,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "41423:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3624,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "41423:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "41407:50:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3627,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3625,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "41458:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "41407:53:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3628,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "41463:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "41407:65:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3630,
										"nodeType": "ExpressionStatement",
										"src": "41407:65:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3640,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3631,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "41482:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3637,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3633,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "41505:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3634,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_AUSTRALIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "41505:25:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3632,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "41498:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3635,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "41498:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "41482:50:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3638,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3636,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "41533:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "41482:53:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3639,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "41538:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "41482:65:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3641,
										"nodeType": "ExpressionStatement",
										"src": "41482:65:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3654,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3642,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "41558:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3648,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3644,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "41581:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3645,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_AUSTRALIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "41581:25:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3643,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "41574:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3646,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "41574:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "41558:50:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3649,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 3647,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "41609:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "41558:53:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3651,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "41621:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3652,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_AUSTRALIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "41621:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3650,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "41614:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3653,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "41614:33:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "41558:89:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3655,
										"nodeType": "ExpressionStatement",
										"src": "41558:89:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3668,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3656,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "41657:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3662,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3658,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "41680:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3659,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_AUSTRALIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "41680:25:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3657,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "41673:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3660,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "41673:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "41657:50:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3663,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 3661,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "41708:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "41657:53:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3665,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "41720:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3666,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "SOUTHEAST_ASIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "41720:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3664,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "41713:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3667,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "41713:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "41657:86:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3669,
										"nodeType": "ExpressionStatement",
										"src": "41657:86:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3682,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3670,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "41753:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3676,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3672,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "41776:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3673,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_AUSTRALIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "41776:25:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3671,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "41769:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3674,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "41769:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "41753:50:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3677,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3675,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "41804:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "41753:53:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3679,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "41816:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3680,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "FIJI",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "41816:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3678,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "41809:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3681,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "41809:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "41753:76:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3683,
										"nodeType": "ExpressionStatement",
										"src": "41753:76:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3696,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3684,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "41839:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3690,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3686,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "41862:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3687,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_AUSTRALIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "41862:25:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3685,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "41855:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3688,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "41855:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "41839:50:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3691,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3689,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "41890:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "41839:53:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3693,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "41902:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3694,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "NEW_ZEALAND",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "41902:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3692,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "41895:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3695,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "41895:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "41839:83:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3697,
										"nodeType": "ExpressionStatement",
										"src": "41839:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3707,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3698,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "41932:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3704,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3700,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "41955:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3701,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_AUSTRALIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "41955:25:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3699,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "41948:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3702,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "41948:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "41932:50:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3705,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3703,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "41983:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "41932:53:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3706,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "41988:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "41932:65:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3708,
										"nodeType": "ExpressionStatement",
										"src": "41932:65:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3721,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3709,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "42008:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3715,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3711,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "42031:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3712,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "NEW_ZEALAND",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "42031:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3710,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "42024:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3713,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "42024:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "42008:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3716,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 3714,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "42053:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "42008:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3718,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "42065:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3719,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_AUSTRALIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "42065:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3717,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "42058:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3720,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "42058:33:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "42008:83:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3722,
										"nodeType": "ExpressionStatement",
										"src": "42008:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3735,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3723,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "42101:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3729,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3725,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "42124:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3726,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "NEW_ZEALAND",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "42124:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3724,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "42117:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3727,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "42117:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "42101:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3730,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 3728,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "42146:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "42101:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3732,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "42158:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3733,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "FIJI",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "42158:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3731,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "42151:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3734,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "42151:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "42101:70:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3736,
										"nodeType": "ExpressionStatement",
										"src": "42101:70:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3749,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3737,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "42181:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3743,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3739,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "42204:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3740,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "NEW_ZEALAND",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "42204:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3738,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "42197:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3741,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "42197:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "42181:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3744,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3742,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "42226:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "42181:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3746,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "42238:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3747,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EAST_ANTARCTICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "42238:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3745,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "42231:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3748,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "42231:31:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "42181:81:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3750,
										"nodeType": "ExpressionStatement",
										"src": "42181:81:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3760,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3751,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "42272:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3757,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3753,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "42295:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3754,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "NEW_ZEALAND",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "42295:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3752,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "42288:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3755,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "42288:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "42272:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3758,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3756,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "42317:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "42272:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3759,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "42322:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "42272:59:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3761,
										"nodeType": "ExpressionStatement",
										"src": "42272:59:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3771,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3762,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "42341:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3768,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3764,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "42364:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3765,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "NEW_ZEALAND",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "42364:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3763,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "42357:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3766,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "42357:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "42341:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3769,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3767,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "42386:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "42341:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3770,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "42391:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "42341:59:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3772,
										"nodeType": "ExpressionStatement",
										"src": "42341:59:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3785,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3773,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "42411:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3779,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3775,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "42434:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3776,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "FIJI",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "42434:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3774,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "42427:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3777,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "42427:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "42411:37:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3780,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 3778,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "42449:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "42411:40:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3782,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "42461:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3783,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "NEW_ZEALAND",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "42461:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3781,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "42454:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3784,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "42454:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "42411:70:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3786,
										"nodeType": "ExpressionStatement",
										"src": "42411:70:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3799,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3787,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "42491:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3793,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3789,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "42514:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3790,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "FIJI",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "42514:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3788,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "42507:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3791,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "42507:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "42491:37:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3794,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 3792,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "42529:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "42491:40:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3796,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "42541:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3797,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_AUSTRALIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "42541:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3795,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "42534:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3798,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "42534:33:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "42491:76:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3800,
										"nodeType": "ExpressionStatement",
										"src": "42491:76:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3813,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3801,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "42577:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3807,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3803,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "42600:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3804,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "FIJI",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "42600:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3802,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "42593:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3805,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "42593:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "42577:37:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3808,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3806,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "42615:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "42577:40:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3810,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "42627:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3811,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "SOUTHEAST_ASIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "42627:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3809,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "42620:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3812,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "42620:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "42577:73:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3814,
										"nodeType": "ExpressionStatement",
										"src": "42577:73:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3827,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3815,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "42660:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3821,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3817,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "42683:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3818,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "FIJI",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "42683:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3816,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "42676:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3819,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "42676:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "42660:37:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3822,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3820,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "42698:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "42660:40:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3824,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "42710:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3825,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "HAWAII",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "42710:14:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3823,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "42703:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3826,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "42703:22:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "42660:65:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3828,
										"nodeType": "ExpressionStatement",
										"src": "42660:65:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3838,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3829,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "42735:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3835,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3831,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "42758:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3832,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "FIJI",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "42758:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3830,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "42751:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3833,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "42751:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "42735:37:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3836,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3834,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "42773:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "42735:40:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3837,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "42778:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "42735:52:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3839,
										"nodeType": "ExpressionStatement",
										"src": "42735:52:2"
									}
								]
							},
							"documentation": "@notice Initialize neighbor relationships between all regions\n @dev This data shared by all game instances",
							"id": 3841,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": false,
							"modifiers": [],
							"name": "initRegionNeighbors",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 2211,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "32262:2:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 2212,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "32273:0:2"
							},
							"scope": 4288,
							"src": "32234:10560:2",
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "private"
						},
						{
							"body": {
								"id": 4069,
								"nodeType": "Block",
								"src": "42958:1456:2",
								"statements": [
									{
										"expression": {
											"argumentTypes": null,
											"id": 3851,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3844,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "42968:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3849,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3846,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "42989:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3847,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "HAWAII",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "42989:14:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3845,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "42982:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3848,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "42982:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "42968:37:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3850,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43008:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"src": "42968:41:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3852,
										"nodeType": "ExpressionStatement",
										"src": "42968:41:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3860,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3853,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43019:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3858,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3855,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43040:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3856,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_CANADA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43040:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3854,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43033:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3857,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43033:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43019:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "36",
												"id": 3859,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43067:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_6_by_1",
													"typeString": "int_const 6"
												},
												"value": "6"
											},
											"src": "43019:49:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3861,
										"nodeType": "ExpressionStatement",
										"src": "43019:49:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3869,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3862,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43078:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3867,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3864,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43099:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3865,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_CANADA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43099:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3863,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43092:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3866,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43092:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43078:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "35",
												"id": 3868,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43126:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_5_by_1",
													"typeString": "int_const 5"
												},
												"value": "5"
											},
											"src": "43078:49:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3870,
										"nodeType": "ExpressionStatement",
										"src": "43078:49:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3878,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3871,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43137:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3876,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3873,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43158:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3874,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_USA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43158:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3872,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43151:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3875,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43151:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43137:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "3131",
												"id": 3877,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43182:2:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_11_by_1",
													"typeString": "int_const 11"
												},
												"value": "11"
											},
											"src": "43137:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3879,
										"nodeType": "ExpressionStatement",
										"src": "43137:47:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3887,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3880,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43194:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3885,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3882,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43215:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3883,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_USA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43215:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3881,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43208:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3884,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43208:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43194:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "38",
												"id": 3886,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43239:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_8_by_1",
													"typeString": "int_const 8"
												},
												"value": "8"
											},
											"src": "43194:46:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3888,
										"nodeType": "ExpressionStatement",
										"src": "43194:46:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3896,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3889,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43250:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3894,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3891,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43271:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3892,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "GREENLAND",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43271:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3890,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43264:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3893,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43264:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43250:40:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3895,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43293:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"src": "43250:44:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3897,
										"nodeType": "ExpressionStatement",
										"src": "43250:44:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3905,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3898,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43304:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3903,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3900,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43325:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3901,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "NORTHERN_SOUTH_AMERICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43325:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3899,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43318:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3902,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43318:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43304:53:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3904,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43360:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"src": "43304:57:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3906,
										"nodeType": "ExpressionStatement",
										"src": "43304:57:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3914,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3907,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43371:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3912,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3909,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43392:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3910,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTHERN_SOUTH_AMERICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43392:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3908,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43385:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3911,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43385:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43371:53:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3913,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43427:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"src": "43371:57:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3915,
										"nodeType": "ExpressionStatement",
										"src": "43371:57:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3923,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3916,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43438:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3921,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3918,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43459:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3919,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WEST_ANTARCTICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43459:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3917,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43452:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3920,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43452:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43438:46:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3922,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43487:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"src": "43438:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3924,
										"nodeType": "ExpressionStatement",
										"src": "43438:50:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3932,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3925,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43498:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3930,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3927,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43519:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3928,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EAST_ANTARCTICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43519:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3926,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43512:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3929,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43512:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43498:46:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3931,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43547:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"src": "43498:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3933,
										"nodeType": "ExpressionStatement",
										"src": "43498:50:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3941,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3934,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43558:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3939,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3936,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43579:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3937,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_EUROPE",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43579:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3935,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43572:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3938,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43572:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43558:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "3130",
												"id": 3940,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43606:2:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_10_by_1",
													"typeString": "int_const 10"
												},
												"value": "10"
											},
											"src": "43558:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3942,
										"nodeType": "ExpressionStatement",
										"src": "43558:50:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3950,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3943,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43618:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3948,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3945,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43639:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3946,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_EUROPE",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43639:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3944,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43632:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3947,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43632:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43618:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "36",
												"id": 3949,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43666:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_6_by_1",
													"typeString": "int_const 6"
												},
												"value": "6"
											},
											"src": "43618:49:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3951,
										"nodeType": "ExpressionStatement",
										"src": "43618:49:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3959,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3952,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43677:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3957,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3954,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43698:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3955,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "CENTRAL_RUSSIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43698:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3953,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43691:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3956,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43691:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43677:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3958,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43725:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"src": "43677:49:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3960,
										"nodeType": "ExpressionStatement",
										"src": "43677:49:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3968,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3961,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43736:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3966,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3963,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43757:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3964,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_RUSSIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43757:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3962,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43750:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3965,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43750:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43736:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3967,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43784:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"src": "43736:49:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3969,
										"nodeType": "ExpressionStatement",
										"src": "43736:49:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3977,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3970,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43795:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3975,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3972,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43816:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3973,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WEST_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43816:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3971,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43809:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3974,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43809:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43795:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3976,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43840:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"src": "43795:46:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3978,
										"nodeType": "ExpressionStatement",
										"src": "43795:46:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3986,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3979,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43851:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3984,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3981,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43872:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3982,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "MIDDLE_EAST",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43872:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3980,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43865:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3983,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43865:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43851:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3985,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43896:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"src": "43851:46:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3987,
										"nodeType": "ExpressionStatement",
										"src": "43851:46:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3995,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3988,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43907:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3993,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3990,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43928:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3991,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EAST_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43928:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3989,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43921:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3992,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43921:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43907:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3994,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43952:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"src": "43907:46:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3996,
										"nodeType": "ExpressionStatement",
										"src": "43907:46:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 4004,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3997,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43963:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 4002,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3999,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43984:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 4000,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTH_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43984:20:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3998,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43977:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 4001,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43977:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43963:43:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "35",
												"id": 4003,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "44009:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_5_by_1",
													"typeString": "int_const 5"
												},
												"value": "5"
											},
											"src": "43963:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 4005,
										"nodeType": "ExpressionStatement",
										"src": "43963:47:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 4013,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 4006,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "44020:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 4011,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 4008,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "44041:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 4009,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "INDIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "44041:13:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 4007,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "44034:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 4010,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "44034:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "44020:36:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "37",
												"id": 4012,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "44059:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_7_by_1",
													"typeString": "int_const 7"
												},
												"value": "7"
											},
											"src": "44020:40:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 4014,
										"nodeType": "ExpressionStatement",
										"src": "44020:40:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 4022,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 4015,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "44070:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 4020,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 4017,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "44091:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 4018,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_CHINA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "44091:21:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 4016,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "44084:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 4019,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "44084:29:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "44070:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "3130",
												"id": 4021,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "44117:2:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_10_by_1",
													"typeString": "int_const 10"
												},
												"value": "10"
											},
											"src": "44070:49:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 4023,
										"nodeType": "ExpressionStatement",
										"src": "44070:49:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 4031,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 4024,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "44129:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 4029,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 4026,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "44150:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 4027,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTHEAST_ASIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "44150:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 4025,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "44143:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 4028,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "44143:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "44129:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "35",
												"id": 4030,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "44177:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_5_by_1",
													"typeString": "int_const 5"
												},
												"value": "5"
											},
											"src": "44129:49:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 4032,
										"nodeType": "ExpressionStatement",
										"src": "44129:49:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 4040,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 4033,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "44188:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 4038,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 4035,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "44209:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 4036,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_AUSTRALIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "44209:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 4034,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "44202:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 4037,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "44202:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "44188:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 4039,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "44239:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"src": "44188:52:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 4041,
										"nodeType": "ExpressionStatement",
										"src": "44188:52:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 4049,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 4042,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "44250:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 4047,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 4044,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "44271:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 4045,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_AUSTRALIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "44271:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 4043,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "44264:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 4046,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "44264:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "44250:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "36",
												"id": 4048,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "44301:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_6_by_1",
													"typeString": "int_const 6"
												},
												"value": "6"
											},
											"src": "44250:52:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 4050,
										"nodeType": "ExpressionStatement",
										"src": "44250:52:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 4058,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 4051,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "44312:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 4056,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 4053,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "44333:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 4054,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "NEW_ZEALAND",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "44333:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 4052,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "44326:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 4055,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "44326:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "44312:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 4057,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "44357:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"src": "44312:46:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 4059,
										"nodeType": "ExpressionStatement",
										"src": "44312:46:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 4067,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 4060,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "44368:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 4065,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 4062,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "44389:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 4063,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "FIJI",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "44389:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 4061,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "44382:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 4064,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "44382:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "44368:35:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 4066,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "44406:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"src": "44368:39:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 4068,
										"nodeType": "ExpressionStatement",
										"src": "44368:39:2"
									}
								]
							},
							"documentation": "@notice Initialize rewards given for controlling each region\n @dev This data shared by all game instances",
							"id": 4070,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": false,
							"modifiers": [],
							"name": "initRegionRewards",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 3842,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "42947:2:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 3843,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "42958:0:2"
							},
							"scope": 4288,
							"src": "42921:1493:2",
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "private"
						},
						{
							"body": {
								"id": 4094,
								"nodeType": "Block",
								"src": "44738:107:2",
								"statements": [
									{
										"assignments": [
											4080
										],
										"declarations": [
											{
												"constant": false,
												"id": 4080,
												"name": "offset",
												"nodeType": "VariableDeclaration",
												"scope": 4095,
												"src": "44748:13:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 4079,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "44748:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 4084,
										"initialValue": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 4083,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 4081,
												"name": "index",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4074,
												"src": "44764:5:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "*",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "3332",
												"id": 4082,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "44772:2:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_32_by_1",
													"typeString": "int_const 32"
												},
												"value": "32"
											},
											"src": "44764:10:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "44748:26:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 4091,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																"id": 4088,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"id": 4086,
																	"name": "combinedData",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4072,
																	"src": "44799:12:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": ">>",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 4087,
																	"name": "offset",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4080,
																	"src": "44815:6:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "44799:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															}
														],
														"id": 4089,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "44798:24:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "&",
													"rightExpression": {
														"argumentTypes": null,
														"id": 4090,
														"name": "MASK_32_BITS",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 153,
														"src": "44825:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "44798:39:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"id": 4085,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "44791:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 4092,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "44791:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"functionReturnParameters": 4078,
										"id": 4093,
										"nodeType": "Return",
										"src": "44784:54:2"
									}
								]
							},
							"documentation": "@notice Reads data using a uint256 to store an array of 8 uint32s\n @param combinedData A uint256 which contains data for 8 uint32s\n @param index Position in array to read\n @return Value at position index",
							"id": 4095,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "getData32",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 4075,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4072,
										"name": "combinedData",
										"nodeType": "VariableDeclaration",
										"scope": 4095,
										"src": "44672:20:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 4071,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "44672:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 4074,
										"name": "index",
										"nodeType": "VariableDeclaration",
										"scope": 4095,
										"src": "44694:12:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4073,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "44694:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "44671:36:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 4078,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4077,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 4095,
										"src": "44730:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4076,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "44730:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "44729:8:2"
							},
							"scope": 4288,
							"src": "44653:192:2",
							"stateMutability": "pure",
							"superFunction": null,
							"visibility": "internal"
						},
						{
							"body": {
								"id": 4132,
								"nodeType": "Block",
								"src": "45268:168:2",
								"statements": [
									{
										"assignments": [
											4107
										],
										"declarations": [
											{
												"constant": false,
												"id": 4107,
												"name": "offset",
												"nodeType": "VariableDeclaration",
												"scope": 4133,
												"src": "45278:13:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 4106,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "45278:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 4111,
										"initialValue": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 4110,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 4108,
												"name": "index",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4099,
												"src": "45294:5:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "*",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "3332",
												"id": 4109,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "45302:2:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_32_by_1",
													"typeString": "int_const 32"
												},
												"value": "32"
											},
											"src": "45294:10:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "45278:26:2"
									},
									{
										"assignments": [
											4113
										],
										"declarations": [
											{
												"constant": false,
												"id": 4113,
												"name": "zeromask",
												"nodeType": "VariableDeclaration",
												"scope": 4133,
												"src": "45314:16:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"typeName": {
													"id": 4112,
													"name": "uint256",
													"nodeType": "ElementaryTypeName",
													"src": "45314:7:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 4119,
										"initialValue": {
											"argumentTypes": null,
											"id": 4118,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "~",
											"prefix": true,
											"src": "45333:25:2",
											"subExpression": {
												"argumentTypes": null,
												"components": [
													{
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 4116,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 4114,
															"name": "MASK_32_BITS",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 153,
															"src": "45335:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "<<",
														"rightExpression": {
															"argumentTypes": null,
															"id": 4115,
															"name": "offset",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4107,
															"src": "45351:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "45335:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"id": 4117,
												"isConstant": false,
												"isInlineArray": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "TupleExpression",
												"src": "45334:24:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "45314:44:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"id": 4130,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"components": [
													{
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 4122,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 4120,
															"name": "combinedData",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4097,
															"src": "45376:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "&",
														"rightExpression": {
															"argumentTypes": null,
															"id": 4121,
															"name": "zeromask",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4113,
															"src": "45391:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"src": "45376:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"id": 4123,
												"isConstant": false,
												"isInlineArray": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "TupleExpression",
												"src": "45375:25:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "|",
											"rightExpression": {
												"argumentTypes": null,
												"components": [
													{
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 4128,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"id": 4125,
																	"name": "value",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4101,
																	"src": "45412:5:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 4124,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"nodeType": "ElementaryTypeNameExpression",
																"src": "45404:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_uint256_$",
																	"typeString": "type(uint256)"
																},
																"typeName": "uint256"
															},
															"id": 4126,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "typeConversion",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "45404:14:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "<<",
														"rightExpression": {
															"argumentTypes": null,
															"id": 4127,
															"name": "offset",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4107,
															"src": "45422:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "45404:24:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"id": 4129,
												"isConstant": false,
												"isInlineArray": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "TupleExpression",
												"src": "45403:26:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"src": "45375:54:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"functionReturnParameters": 4105,
										"id": 4131,
										"nodeType": "Return",
										"src": "45368:61:2"
									}
								]
							},
							"documentation": "@notice Writes data using a uint256 to store an array of 8 uint32s\n @param combinedData A uint256 which contains data for 8 uint32s\n @param index Position in array to write\n @param value Value to write at position index.  Value must fit in a uint32.\n @return Updated combined data",
							"id": 4133,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "setData32",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 4102,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4097,
										"name": "combinedData",
										"nodeType": "VariableDeclaration",
										"scope": 4133,
										"src": "45187:20:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 4096,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "45187:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 4099,
										"name": "index",
										"nodeType": "VariableDeclaration",
										"scope": 4133,
										"src": "45209:12:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4098,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "45209:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 4101,
										"name": "value",
										"nodeType": "VariableDeclaration",
										"scope": 4133,
										"src": "45223:12:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4100,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "45223:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "45186:50:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 4105,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4104,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 4133,
										"src": "45259:7:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 4103,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "45259:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "45258:9:2"
							},
							"scope": 4288,
							"src": "45168:268:2",
							"stateMutability": "pure",
							"superFunction": null,
							"visibility": "internal"
						},
						{
							"body": {
								"id": 4157,
								"nodeType": "Block",
								"src": "45759:105:2",
								"statements": [
									{
										"assignments": [
											4143
										],
										"declarations": [
											{
												"constant": false,
												"id": 4143,
												"name": "offset",
												"nodeType": "VariableDeclaration",
												"scope": 4158,
												"src": "45769:13:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 4142,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "45769:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 4147,
										"initialValue": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 4146,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 4144,
												"name": "index",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4137,
												"src": "45785:5:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "*",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "38",
												"id": 4145,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "45793:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_8_by_1",
													"typeString": "int_const 8"
												},
												"value": "8"
											},
											"src": "45785:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "45769:25:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 4154,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																"id": 4151,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"id": 4149,
																	"name": "combinedData",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4135,
																	"src": "45819:12:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": ">>",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 4150,
																	"name": "offset",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4143,
																	"src": "45835:6:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "45819:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															}
														],
														"id": 4152,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "45818:24:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "&",
													"rightExpression": {
														"argumentTypes": null,
														"id": 4153,
														"name": "MASK_8_BITS",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 156,
														"src": "45845:11:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "45818:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"id": 4148,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "45811:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 4155,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "45811:46:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"functionReturnParameters": 4141,
										"id": 4156,
										"nodeType": "Return",
										"src": "45804:53:2"
									}
								]
							},
							"documentation": "@notice Reads data using a uint256 to store an array of 32 uint8s\n @param combinedData A uint256 which contains data for 32 uint8s\n @param index Position in array to read\n @return Value at position index",
							"id": 4158,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "getData8",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 4138,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4135,
										"name": "combinedData",
										"nodeType": "VariableDeclaration",
										"scope": 4158,
										"src": "45693:20:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 4134,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "45693:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 4137,
										"name": "index",
										"nodeType": "VariableDeclaration",
										"scope": 4158,
										"src": "45715:12:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4136,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "45715:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "45692:36:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 4141,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4140,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 4158,
										"src": "45751:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4139,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "45751:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "45750:8:2"
							},
							"scope": 4288,
							"src": "45675:189:2",
							"stateMutability": "pure",
							"superFunction": null,
							"visibility": "internal"
						},
						{
							"body": {
								"id": 4202,
								"nodeType": "Block",
								"src": "46287:230:2",
								"statements": [
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 4172,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 4170,
														"name": "value",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4164,
														"src": "46305:5:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "<",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "323536",
														"id": 4171,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "46313:3:2",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_256_by_1",
															"typeString": "int_const 256"
														},
														"value": "256"
													},
													"src": "46305:11:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "4f6e6c792038206269747320616c6c6f77656420666f722076616c75652e",
													"id": 4173,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "46318:32:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_ddaa73a8054ce9a07c21854101a82fc39840680a3f8f5b0458eb5a042c29fb07",
														"typeString": "literal_string \"Only 8 bits allowed for value.\""
													},
													"value": "Only 8 bits allowed for value."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_ddaa73a8054ce9a07c21854101a82fc39840680a3f8f5b0458eb5a042c29fb07",
														"typeString": "literal_string \"Only 8 bits allowed for value.\""
													}
												],
												"id": 4169,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "46297:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 4174,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "46297:54:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 4175,
										"nodeType": "ExpressionStatement",
										"src": "46297:54:2"
									},
									{
										"assignments": [
											4177
										],
										"declarations": [
											{
												"constant": false,
												"id": 4177,
												"name": "offset",
												"nodeType": "VariableDeclaration",
												"scope": 4203,
												"src": "46361:13:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 4176,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "46361:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 4181,
										"initialValue": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 4180,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 4178,
												"name": "index",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4162,
												"src": "46377:5:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "*",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "38",
												"id": 4179,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "46385:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_8_by_1",
													"typeString": "int_const 8"
												},
												"value": "8"
											},
											"src": "46377:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "46361:25:2"
									},
									{
										"assignments": [
											4183
										],
										"declarations": [
											{
												"constant": false,
												"id": 4183,
												"name": "zeromask",
												"nodeType": "VariableDeclaration",
												"scope": 4203,
												"src": "46396:16:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"typeName": {
													"id": 4182,
													"name": "uint256",
													"nodeType": "ElementaryTypeName",
													"src": "46396:7:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 4189,
										"initialValue": {
											"argumentTypes": null,
											"id": 4188,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "~",
											"prefix": true,
											"src": "46415:24:2",
											"subExpression": {
												"argumentTypes": null,
												"components": [
													{
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 4186,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 4184,
															"name": "MASK_8_BITS",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 156,
															"src": "46417:11:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "<<",
														"rightExpression": {
															"argumentTypes": null,
															"id": 4185,
															"name": "offset",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4177,
															"src": "46432:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "46417:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"id": 4187,
												"isConstant": false,
												"isInlineArray": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "TupleExpression",
												"src": "46416:23:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "46396:43:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"id": 4200,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"components": [
													{
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 4192,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 4190,
															"name": "combinedData",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4160,
															"src": "46457:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "&",
														"rightExpression": {
															"argumentTypes": null,
															"id": 4191,
															"name": "zeromask",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4183,
															"src": "46472:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"src": "46457:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"id": 4193,
												"isConstant": false,
												"isInlineArray": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "TupleExpression",
												"src": "46456:25:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "|",
											"rightExpression": {
												"argumentTypes": null,
												"components": [
													{
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 4198,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"id": 4195,
																	"name": "value",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4164,
																	"src": "46493:5:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 4194,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"nodeType": "ElementaryTypeNameExpression",
																"src": "46485:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_uint256_$",
																	"typeString": "type(uint256)"
																},
																"typeName": "uint256"
															},
															"id": 4196,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "typeConversion",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "46485:14:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "<<",
														"rightExpression": {
															"argumentTypes": null,
															"id": 4197,
															"name": "offset",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4177,
															"src": "46503:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "46485:24:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"id": 4199,
												"isConstant": false,
												"isInlineArray": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "TupleExpression",
												"src": "46484:26:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"src": "46456:54:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"functionReturnParameters": 4168,
										"id": 4201,
										"nodeType": "Return",
										"src": "46449:61:2"
									}
								]
							},
							"documentation": "@notice Writes data using a uint256 to store an array of 32 uint8s\n @param combinedData A uint256 which contains data for 32 uint8s\n @param index Position in array to write\n @param value Value to write at position index.  Value must be less than 256.\n @return Updated combined data",
							"id": 4203,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "setData8",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 4165,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4160,
										"name": "combinedData",
										"nodeType": "VariableDeclaration",
										"scope": 4203,
										"src": "46206:20:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 4159,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "46206:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 4162,
										"name": "index",
										"nodeType": "VariableDeclaration",
										"scope": 4203,
										"src": "46228:12:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4161,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "46228:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 4164,
										"name": "value",
										"nodeType": "VariableDeclaration",
										"scope": 4203,
										"src": "46242:12:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4163,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "46242:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "46205:50:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 4168,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4167,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 4203,
										"src": "46278:7:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 4166,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "46278:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "46277:9:2"
							},
							"scope": 4288,
							"src": "46188:329:2",
							"stateMutability": "pure",
							"superFunction": null,
							"visibility": "internal"
						},
						{
							"body": {
								"id": 4227,
								"nodeType": "Block",
								"src": "46845:114:2",
								"statements": [
									{
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 4214,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 4212,
												"name": "_b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4207,
												"src": "46859:2:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "<=",
											"rightExpression": {
												"argumentTypes": null,
												"id": 4213,
												"name": "_a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4205,
												"src": "46865:2:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "46859:8:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": null,
										"id": 4224,
										"nodeType": "IfStatement",
										"src": "46855:79:2",
										"trueBody": {
											"id": 4223,
											"nodeType": "Block",
											"src": "46869:65:2",
											"statements": [
												{
													"assignments": [
														4216
													],
													"declarations": [
														{
															"constant": false,
															"id": 4216,
															"name": "c",
															"nodeType": "VariableDeclaration",
															"scope": 4228,
															"src": "46883:8:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"typeName": {
																"id": 4215,
																"name": "uint32",
																"nodeType": "ElementaryTypeName",
																"src": "46883:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 4220,
													"initialValue": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 4219,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 4217,
															"name": "_a",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4205,
															"src": "46894:2:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "-",
														"rightExpression": {
															"argumentTypes": null,
															"id": 4218,
															"name": "_b",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4207,
															"src": "46899:2:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "46894:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "46883:18:2"
												},
												{
													"expression": {
														"argumentTypes": null,
														"id": 4221,
														"name": "c",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4216,
														"src": "46922:1:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"functionReturnParameters": 4211,
													"id": 4222,
													"nodeType": "Return",
													"src": "46915:8:2"
												}
											]
										}
									},
									{
										"expression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 4225,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "46951:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"functionReturnParameters": 4211,
										"id": 4226,
										"nodeType": "Return",
										"src": "46944:8:2"
									}
								]
							},
							"documentation": "@notice Safe subtraction that returns 0 on underflow.\n @dev We intentially don't assert so as to not block program execution.\n @param _a Value to subtract from\n @param _b Value to subtract\n @return Result of _a - _b",
							"id": 4228,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "subSafe",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 4208,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4205,
										"name": "_a",
										"nodeType": "VariableDeclaration",
										"scope": 4228,
										"src": "46792:9:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4204,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "46792:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 4207,
										"name": "_b",
										"nodeType": "VariableDeclaration",
										"scope": 4228,
										"src": "46803:9:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4206,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "46803:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "46791:22:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 4211,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4210,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 4228,
										"src": "46837:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4209,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "46837:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "46836:8:2"
							},
							"scope": 4288,
							"src": "46775:184:2",
							"stateMutability": "pure",
							"superFunction": null,
							"visibility": "internal"
						},
						{
							"body": {
								"id": 4252,
								"nodeType": "Block",
								"src": "47289:118:2",
								"statements": [
									{
										"assignments": [
											4238
										],
										"declarations": [
											{
												"constant": false,
												"id": 4238,
												"name": "c",
												"nodeType": "VariableDeclaration",
												"scope": 4253,
												"src": "47299:8:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 4237,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "47299:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 4242,
										"initialValue": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 4241,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 4239,
												"name": "_a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4230,
												"src": "47310:2:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "+",
											"rightExpression": {
												"argumentTypes": null,
												"id": 4240,
												"name": "_b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4232,
												"src": "47315:2:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "47310:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "47299:18:2"
									},
									{
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 4245,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 4243,
												"name": "c",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4238,
												"src": "47331:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": ">=",
											"rightExpression": {
												"argumentTypes": null,
												"id": 4244,
												"name": "_a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4230,
												"src": "47336:2:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "47331:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": null,
										"id": 4249,
										"nodeType": "IfStatement",
										"src": "47327:46:2",
										"trueBody": {
											"id": 4248,
											"nodeType": "Block",
											"src": "47340:33:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"id": 4246,
														"name": "c",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4238,
														"src": "47361:1:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"functionReturnParameters": 4236,
													"id": 4247,
													"nodeType": "Return",
													"src": "47354:8:2"
												}
											]
										}
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 4250,
											"name": "MAX_UINT32",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 159,
											"src": "47390:10:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"functionReturnParameters": 4236,
										"id": 4251,
										"nodeType": "Return",
										"src": "47383:17:2"
									}
								]
							},
							"documentation": "@notice Safe addition that returns MAX_UINT32 on overflow\n @dev We intentially don't assert so as to not block program execution.\n @param _a First value to add\n @param _b Second value to add\n @return Result of _a + _b",
							"id": 4253,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "addSafe",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 4233,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4230,
										"name": "_a",
										"nodeType": "VariableDeclaration",
										"scope": 4253,
										"src": "47236:9:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4229,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "47236:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 4232,
										"name": "_b",
										"nodeType": "VariableDeclaration",
										"scope": 4253,
										"src": "47247:9:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4231,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "47247:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "47235:22:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 4236,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4235,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 4253,
										"src": "47281:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4234,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "47281:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "47280:8:2"
							},
							"scope": 4288,
							"src": "47219:188:2",
							"stateMutability": "pure",
							"superFunction": null,
							"visibility": "internal"
						},
						{
							"body": {
								"id": 4286,
								"nodeType": "Block",
								"src": "47753:179:2",
								"statements": [
									{
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 4264,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 4262,
												"name": "_a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4255,
												"src": "47767:2:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "==",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 4263,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "47773:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"src": "47767:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": null,
										"id": 4268,
										"nodeType": "IfStatement",
										"src": "47763:46:2",
										"trueBody": {
											"id": 4267,
											"nodeType": "Block",
											"src": "47776:33:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"hexValue": "30",
														"id": 4265,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "47797:1:2",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													},
													"functionReturnParameters": 4261,
													"id": 4266,
													"nodeType": "Return",
													"src": "47790:8:2"
												}
											]
										}
									},
									{
										"assignments": [
											4270
										],
										"declarations": [
											{
												"constant": false,
												"id": 4270,
												"name": "c",
												"nodeType": "VariableDeclaration",
												"scope": 4287,
												"src": "47819:8:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 4269,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "47819:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 4274,
										"initialValue": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 4273,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 4271,
												"name": "_a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4255,
												"src": "47830:2:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "*",
											"rightExpression": {
												"argumentTypes": null,
												"id": 4272,
												"name": "_b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4257,
												"src": "47835:2:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "47830:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "47819:18:2"
									},
									{
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 4279,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"id": 4277,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 4275,
													"name": "c",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4270,
													"src": "47851:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "/",
												"rightExpression": {
													"argumentTypes": null,
													"id": 4276,
													"name": "_a",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4255,
													"src": "47855:2:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"src": "47851:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "==",
											"rightExpression": {
												"argumentTypes": null,
												"id": 4278,
												"name": "_b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4257,
												"src": "47861:2:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "47851:12:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": null,
										"id": 4283,
										"nodeType": "IfStatement",
										"src": "47847:51:2",
										"trueBody": {
											"id": 4282,
											"nodeType": "Block",
											"src": "47865:33:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"id": 4280,
														"name": "c",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4270,
														"src": "47886:1:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"functionReturnParameters": 4261,
													"id": 4281,
													"nodeType": "Return",
													"src": "47879:8:2"
												}
											]
										}
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 4284,
											"name": "MAX_UINT32",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 159,
											"src": "47915:10:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"functionReturnParameters": 4261,
										"id": 4285,
										"nodeType": "Return",
										"src": "47908:17:2"
									}
								]
							},
							"documentation": "@notice Safe multiplication that returns MAX_UINT32 on overflow\n @dev We intentially don't assert so as to not block program execution.\n @param _a First value to multiply\n @param _b Second value to multiply\n @return Result of _a * _b",
							"id": 4287,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "mulSafe",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 4258,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4255,
										"name": "_a",
										"nodeType": "VariableDeclaration",
										"scope": 4287,
										"src": "47700:9:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4254,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "47700:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 4257,
										"name": "_b",
										"nodeType": "VariableDeclaration",
										"scope": 4287,
										"src": "47711:9:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4256,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "47711:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "47699:22:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 4261,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4260,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 4287,
										"src": "47745:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4259,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "47745:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "47744:8:2"
							},
							"scope": 4288,
							"src": "47683:249:2",
							"stateMutability": "pure",
							"superFunction": null,
							"visibility": "internal"
						}
					],
					"scope": 4289,
					"src": "104:47830:2"
				}
			],
			"src": "0:47935:2"
		},
		"legacyAST": {
			"absolutePath": "/Users/justinhamilton/ethereum/worldgame/contracts/WorldGame.sol",
			"exportedSymbols": {
				"WorldGame": [
					4288
				]
			},
			"id": 4289,
			"nodeType": "SourceUnit",
			"nodes": [
				{
					"id": 120,
					"literals": [
						"solidity",
						"^",
						"0.4",
						".0"
					],
					"nodeType": "PragmaDirective",
					"src": "0:23:2"
				},
				{
					"baseContracts": [],
					"contractDependencies": [],
					"contractKind": "contract",
					"documentation": "@title World game. Battle to control territory and take over the world. ",
					"fullyImplemented": true,
					"id": 4288,
					"linearizedBaseContracts": [
						4288
					],
					"name": "WorldGame",
					"nodeType": "ContractDefinition",
					"nodes": [
						{
							"constant": true,
							"id": 123,
							"name": "NOT_OWNED",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "188:31:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							},
							"typeName": {
								"id": 121,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "188:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "323535",
								"id": 122,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "216:3:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_255_by_1",
									"typeString": "int_const 255"
								},
								"value": "255"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 126,
							"name": "NO_REGION",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "267:31:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							},
							"typeName": {
								"id": 124,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "267:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "323535",
								"id": 125,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "295:3:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_255_by_1",
									"typeString": "int_const 255"
								},
								"value": "255"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 129,
							"name": "REGION_COUNT",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "333:33:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							},
							"typeName": {
								"id": 127,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "333:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "3235",
								"id": 128,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "364:2:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_25_by_1",
									"typeString": "int_const 25"
								},
								"value": "25"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 132,
							"name": "MAX_NEIGHBORS",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "423:33:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							},
							"typeName": {
								"id": 130,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "423:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "35",
								"id": 131,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "455:1:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_5_by_1",
									"typeString": "int_const 5"
								},
								"value": "5"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 135,
							"name": "MAX_PLAYERS",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "508:31:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							},
							"typeName": {
								"id": 133,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "508:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "38",
								"id": 134,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "538:1:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_8_by_1",
									"typeString": "int_const 8"
								},
								"value": "8"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 138,
							"name": "MAX_ACTIONS_PER_TURN",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "602:40:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							},
							"typeName": {
								"id": 136,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "602:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "38",
								"id": 137,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "641:1:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_8_by_1",
									"typeString": "int_const 8"
								},
								"value": "8"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 141,
							"name": "DEFENDER_ADVANTAGE_NUM",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "698:42:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							},
							"typeName": {
								"id": 139,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "698:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "35",
								"id": 140,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "739:1:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_5_by_1",
									"typeString": "int_const 5"
								},
								"value": "5"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 144,
							"name": "DEFENDER_ADVANTAGE_DENOM",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "799:44:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							},
							"typeName": {
								"id": 142,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "799:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "34",
								"id": 143,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "842:1:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_4_by_1",
									"typeString": "int_const 4"
								},
								"value": "4"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 147,
							"name": "REWARD_BONUS_MULTIPLIER_DENOM",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "897:50:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							},
							"typeName": {
								"id": 145,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "897:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "3230",
								"id": 146,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "945:2:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_20_by_1",
									"typeString": "int_const 20"
								},
								"value": "20"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 150,
							"name": "MAX_BLOCKS_THRESHOLD",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "999:41:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							},
							"typeName": {
								"id": 148,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "999:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "3230",
								"id": 149,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "1038:2:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_20_by_1",
									"typeString": "int_const 20"
								},
								"value": "20"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 153,
							"name": "MASK_32_BITS",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "1095:42:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							},
							"typeName": {
								"id": 151,
								"name": "uint256",
								"nodeType": "ElementaryTypeName",
								"src": "1095:7:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "30786666666666666666",
								"id": 152,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "1127:10:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_4294967295_by_1",
									"typeString": "int_const 4294967295"
								},
								"value": "0xffffffff"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 156,
							"name": "MASK_8_BITS",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "1191:35:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							},
							"typeName": {
								"id": 154,
								"name": "uint256",
								"nodeType": "ElementaryTypeName",
								"src": "1191:7:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "30786666",
								"id": 155,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "1222:4:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_255_by_1",
									"typeString": "int_const 255"
								},
								"value": "0xff"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 159,
							"name": "MAX_UINT32",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "1260:39:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint32",
								"typeString": "uint32"
							},
							"typeName": {
								"id": 157,
								"name": "uint32",
								"nodeType": "ElementaryTypeName",
								"src": "1260:6:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint32",
									"typeString": "uint32"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "30786666666666666666",
								"id": 158,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "1289:10:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_4294967295_by_1",
									"typeString": "int_const 4294967295"
								},
								"value": "0xffffffff"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 162,
							"name": "ALL_REGIONS_NOT_OWNED",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "1368:107:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							},
							"typeName": {
								"id": 160,
								"name": "uint256",
								"nodeType": "ElementaryTypeName",
								"src": "1368:7:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "307866666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666666",
								"id": 161,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "1409:66:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_115792089237316195423570985008687907853269984665640564039457584007913129639935_by_1",
									"typeString": "int_const 1157...(70 digits omitted)...9935"
								},
								"value": "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"
							},
							"visibility": "internal"
						},
						{
							"constant": true,
							"id": 165,
							"name": "BEGIN_SOLDIERS_COUNTS",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "1578:107:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							},
							"typeName": {
								"id": 163,
								"name": "uint256",
								"nodeType": "ElementaryTypeName",
								"src": "1578:7:2",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								}
							},
							"value": {
								"argumentTypes": null,
								"hexValue": "307830303030303031343030303030303134303030303030313430303030303031343030303030303134303030303030313430303030303031343030303030303134",
								"id": 164,
								"isConstant": false,
								"isLValue": false,
								"isPure": true,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "1619:66:2",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": "t_rational_539198933468554830630303949770532107640973245947105932686537879715860_by_1",
									"typeString": "int_const 5391...(61 digits omitted)...5860"
								},
								"value": "0x0000001400000014000000140000001400000014000000140000001400000014"
							},
							"visibility": "internal"
						},
						{
							"constant": false,
							"id": 167,
							"name": "owner",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "1747:21:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							},
							"typeName": {
								"id": 166,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "1747:7:2",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"value": null,
							"visibility": "private"
						},
						{
							"constant": false,
							"id": 169,
							"name": "stopped",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "1820:20:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							},
							"typeName": {
								"id": 168,
								"name": "bool",
								"nodeType": "ElementaryTypeName",
								"src": "1820:4:2",
								"typeDescriptions": {
									"typeIdentifier": "t_bool",
									"typeString": "bool"
								}
							},
							"value": null,
							"visibility": "private"
						},
						{
							"constant": false,
							"id": 173,
							"name": "blockHash32Map",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "1891:48:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_uint32_$_t_uint32_$",
								"typeString": "mapping(uint32 => uint32)"
							},
							"typeName": {
								"id": 172,
								"keyType": {
									"id": 170,
									"name": "uint32",
									"nodeType": "ElementaryTypeName",
									"src": "1900:6:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									}
								},
								"nodeType": "Mapping",
								"src": "1891:26:2",
								"typeDescriptions": {
									"typeIdentifier": "t_mapping$_t_uint32_$_t_uint32_$",
									"typeString": "mapping(uint32 => uint32)"
								},
								"valueType": {
									"id": 171,
									"name": "uint32",
									"nodeType": "ElementaryTypeName",
									"src": "1910:6:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									}
								}
							},
							"value": null,
							"visibility": "public"
						},
						{
							"constant": false,
							"id": 179,
							"name": "regionNeighbors",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "2055:58:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
								"typeString": "uint32[5][25]"
							},
							"typeName": {
								"baseType": {
									"baseType": {
										"id": 174,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "2055:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"id": 176,
									"length": {
										"argumentTypes": null,
										"id": 175,
										"name": "MAX_NEIGHBORS",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 132,
										"src": "2062:13:2",
										"typeDescriptions": {
											"typeIdentifier": null,
											"typeString": null
										}
									},
									"nodeType": "ArrayTypeName",
									"src": "2055:21:2",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$5_storage_ptr",
										"typeString": "uint32[5]"
									}
								},
								"id": 178,
								"length": {
									"argumentTypes": null,
									"id": 177,
									"name": "REGION_COUNT",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 129,
									"src": "2077:12:2",
									"typeDescriptions": {
										"typeIdentifier": null,
										"typeString": null
									}
								},
								"nodeType": "ArrayTypeName",
								"src": "2055:35:2",
								"typeDescriptions": {
									"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage_ptr",
									"typeString": "uint32[5][25]"
								}
							},
							"value": null,
							"visibility": "public"
						},
						{
							"constant": false,
							"id": 183,
							"name": "regionRewards",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "2201:41:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_array$_t_uint32_$25_storage",
								"typeString": "uint32[25]"
							},
							"typeName": {
								"baseType": {
									"id": 180,
									"name": "uint32",
									"nodeType": "ElementaryTypeName",
									"src": "2201:6:2",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									}
								},
								"id": 182,
								"length": {
									"argumentTypes": null,
									"id": 181,
									"name": "REGION_COUNT",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 129,
									"src": "2208:12:2",
									"typeDescriptions": {
										"typeIdentifier": null,
										"typeString": null
									}
								},
								"nodeType": "ArrayTypeName",
								"src": "2201:20:2",
								"typeDescriptions": {
									"typeIdentifier": "t_array$_t_uint32_$25_storage_ptr",
									"typeString": "uint32[25]"
								}
							},
							"value": null,
							"visibility": "public"
						},
						{
							"constant": false,
							"id": 186,
							"name": "gameDataArray",
							"nodeType": "VariableDeclaration",
							"scope": 4288,
							"src": "2332:31:2",
							"stateVariable": true,
							"storageLocation": "default",
							"typeDescriptions": {
								"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
								"typeString": "struct WorldGame.GameData[]"
							},
							"typeName": {
								"baseType": {
									"contractScope": null,
									"id": 184,
									"name": "GameData",
									"nodeType": "UserDefinedTypeName",
									"referencedDeclaration": 245,
									"src": "2332:8:2",
									"typeDescriptions": {
										"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
										"typeString": "struct WorldGame.GameData"
									}
								},
								"id": 185,
								"length": null,
								"nodeType": "ArrayTypeName",
								"src": "2332:10:2",
								"typeDescriptions": {
									"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage_ptr",
									"typeString": "struct WorldGame.GameData[]"
								}
							},
							"value": null,
							"visibility": "public"
						},
						{
							"canonicalName": "WorldGame.Regions",
							"id": 212,
							"members": [
								{
									"id": 187,
									"name": "HAWAII",
									"nodeType": "EnumValue",
									"src": "2441:6:2"
								},
								{
									"id": 188,
									"name": "WESTERN_CANADA",
									"nodeType": "EnumValue",
									"src": "2457:14:2"
								},
								{
									"id": 189,
									"name": "EASTERN_CANADA",
									"nodeType": "EnumValue",
									"src": "2481:14:2"
								},
								{
									"id": 190,
									"name": "WESTERN_USA",
									"nodeType": "EnumValue",
									"src": "2505:11:2"
								},
								{
									"id": 191,
									"name": "EASTERN_USA",
									"nodeType": "EnumValue",
									"src": "2526:11:2"
								},
								{
									"id": 192,
									"name": "GREENLAND",
									"nodeType": "EnumValue",
									"src": "2547:9:2"
								},
								{
									"id": 193,
									"name": "NORTHERN_SOUTH_AMERICA",
									"nodeType": "EnumValue",
									"src": "2566:22:2"
								},
								{
									"id": 194,
									"name": "SOUTHERN_SOUTH_AMERICA",
									"nodeType": "EnumValue",
									"src": "2598:22:2"
								},
								{
									"id": 195,
									"name": "WEST_ANTARCTICA",
									"nodeType": "EnumValue",
									"src": "2630:15:2"
								},
								{
									"id": 196,
									"name": "EAST_ANTARCTICA",
									"nodeType": "EnumValue",
									"src": "2655:15:2"
								},
								{
									"id": 197,
									"name": "WESTERN_EUROPE",
									"nodeType": "EnumValue",
									"src": "2680:14:2"
								},
								{
									"id": 198,
									"name": "EASTERN_EUROPE",
									"nodeType": "EnumValue",
									"src": "2704:14:2"
								},
								{
									"id": 199,
									"name": "CENTRAL_RUSSIA",
									"nodeType": "EnumValue",
									"src": "2728:14:2"
								},
								{
									"id": 200,
									"name": "EASTERN_RUSSIA",
									"nodeType": "EnumValue",
									"src": "2752:14:2"
								},
								{
									"id": 201,
									"name": "WEST_AFRICA",
									"nodeType": "EnumValue",
									"src": "2776:11:2"
								},
								{
									"id": 202,
									"name": "MIDDLE_EAST",
									"nodeType": "EnumValue",
									"src": "2797:11:2"
								},
								{
									"id": 203,
									"name": "EAST_AFRICA",
									"nodeType": "EnumValue",
									"src": "2818:11:2"
								},
								{
									"id": 204,
									"name": "SOUTH_AFRICA",
									"nodeType": "EnumValue",
									"src": "2839:12:2"
								},
								{
									"id": 205,
									"name": "INDIA",
									"nodeType": "EnumValue",
									"src": "2861:5:2"
								},
								{
									"id": 206,
									"name": "EASTERN_CHINA",
									"nodeType": "EnumValue",
									"src": "2876:13:2"
								},
								{
									"id": 207,
									"name": "SOUTHEAST_ASIA",
									"nodeType": "EnumValue",
									"src": "2899:14:2"
								},
								{
									"id": 208,
									"name": "WESTERN_AUSTRALIA",
									"nodeType": "EnumValue",
									"src": "2923:17:2"
								},
								{
									"id": 209,
									"name": "EASTERN_AUSTRALIA",
									"nodeType": "EnumValue",
									"src": "2950:17:2"
								},
								{
									"id": 210,
									"name": "NEW_ZEALAND",
									"nodeType": "EnumValue",
									"src": "2977:11:2"
								},
								{
									"id": 211,
									"name": "FIJI",
									"nodeType": "EnumValue",
									"src": "2998:4:2"
								}
							],
							"name": "Regions",
							"nodeType": "EnumDefinition",
							"src": "2418:590:2"
						},
						{
							"canonicalName": "WorldGame.GameData",
							"id": 245,
							"members": [
								{
									"constant": false,
									"id": 214,
									"name": "turnTeamId",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "3124:17:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 213,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "3124:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 216,
									"name": "turnNum",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "3201:14:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 215,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "3201:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 218,
									"name": "maxBlocksPerTurn",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "3276:23:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 217,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "3276:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 220,
									"name": "playerCount",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "3356:18:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 219,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "3356:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 224,
									"name": "playerAddresses",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "3423:36:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_address_$8_storage_ptr",
										"typeString": "address[8]"
									},
									"typeName": {
										"baseType": {
											"id": 221,
											"name": "address",
											"nodeType": "ElementaryTypeName",
											"src": "3423:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"id": 223,
										"length": {
											"argumentTypes": null,
											"id": 222,
											"name": "MAX_PLAYERS",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 135,
											"src": "3431:11:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "3423:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_address_$8_storage_ptr",
											"typeString": "address[8]"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 226,
									"name": "undeployedSoldiers",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "3552:26:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 225,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "3552:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 228,
									"name": "regionOwners",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "3638:20:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 227,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "3638:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 232,
									"name": "regionSoldiers",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "3727:35:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_uint32_$25_storage_ptr",
										"typeString": "uint32[25]"
									},
									"typeName": {
										"baseType": {
											"id": 229,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "3727:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 231,
										"length": {
											"argumentTypes": null,
											"id": 230,
											"name": "REGION_COUNT",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 129,
											"src": "3734:12:2",
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											}
										},
										"nodeType": "ArrayTypeName",
										"src": "3727:20:2",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$25_storage_ptr",
											"typeString": "uint32[25]"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 234,
									"name": "actionCount",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "3822:18:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint32",
										"typeString": "uint32"
									},
									"typeName": {
										"id": 233,
										"name": "uint32",
										"nodeType": "ElementaryTypeName",
										"src": "3822:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 236,
									"name": "fromRegionList",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "3923:22:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 235,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "3923:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 238,
									"name": "toRegionList",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "4027:20:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 237,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "4027:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 240,
									"name": "moveSoldierCountList",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "4121:28:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 239,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "4121:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 242,
									"name": "submitBlockList",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "4235:23:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 241,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "4235:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 244,
									"name": "teamAvatars",
									"nodeType": "VariableDeclaration",
									"scope": 245,
									"src": "4313:18:2",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes8",
										"typeString": "bytes8"
									},
									"typeName": {
										"id": 243,
										"name": "bytes8",
										"nodeType": "ElementaryTypeName",
										"src": "4313:6:2",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes8",
											"typeString": "bytes8"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"name": "GameData",
							"nodeType": "StructDefinition",
							"scope": 4288,
							"src": "3053:1285:2",
							"visibility": "public"
						},
						{
							"anonymous": false,
							"documentation": null,
							"id": 253,
							"name": "NewGame",
							"nodeType": "EventDefinition",
							"parameters": {
								"id": 252,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 247,
										"indexed": false,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 253,
										"src": "4418:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 246,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "4418:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 249,
										"indexed": false,
										"name": "turnNum",
										"nodeType": "VariableDeclaration",
										"scope": 253,
										"src": "4434:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 248,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "4434:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 251,
										"indexed": false,
										"name": "teamAvatars",
										"nodeType": "VariableDeclaration",
										"scope": 253,
										"src": "4450:18:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes8",
											"typeString": "bytes8"
										},
										"typeName": {
											"id": 250,
											"name": "bytes8",
											"nodeType": "ElementaryTypeName",
											"src": "4450:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes8",
												"typeString": "bytes8"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "4417:52:2"
							},
							"src": "4404:66:2"
						},
						{
							"anonymous": false,
							"documentation": null,
							"id": 261,
							"name": "NextTurn",
							"nodeType": "EventDefinition",
							"parameters": {
								"id": 260,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 255,
										"indexed": false,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 261,
										"src": "4541:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 254,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "4541:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 257,
										"indexed": false,
										"name": "turnNum",
										"nodeType": "VariableDeclaration",
										"scope": 261,
										"src": "4557:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 256,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "4557:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 259,
										"indexed": false,
										"name": "nextTeamId",
										"nodeType": "VariableDeclaration",
										"scope": 261,
										"src": "4573:17:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 258,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "4573:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "4540:51:2"
							},
							"src": "4526:66:2"
						},
						{
							"anonymous": false,
							"documentation": null,
							"id": 267,
							"name": "Winner",
							"nodeType": "EventDefinition",
							"parameters": {
								"id": 266,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 263,
										"indexed": false,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 267,
										"src": "4656:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 262,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "4656:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 265,
										"indexed": false,
										"name": "winningTeamId",
										"nodeType": "VariableDeclaration",
										"scope": 267,
										"src": "4672:20:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 264,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "4672:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "4655:38:2"
							},
							"src": "4643:51:2"
						},
						{
							"body": {
								"id": 300,
								"nodeType": "Block",
								"src": "4837:377:2",
								"statements": [
									{
										"assignments": [
											274
										],
										"declarations": [
											{
												"constant": false,
												"id": 274,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 301,
												"src": "4847:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 273,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "4847:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 278,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 275,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "4871:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 277,
											"indexExpression": {
												"argumentTypes": null,
												"id": 276,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 269,
												"src": "4885:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "4871:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "4847:45:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													},
													"id": 287,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 280,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4372,
															"src": "4973:3:2",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 281,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "sender",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "4973:10:2",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 282,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 274,
																"src": "4987:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 283,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "playerAddresses",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 224,
															"src": "4987:20:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_address_$8_storage",
																"typeString": "address[8] storage ref"
															}
														},
														"id": 286,
														"indexExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 284,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 274,
																"src": "5008:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 285,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "turnTeamId",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 214,
															"src": "5008:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "4987:37:2",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"src": "4973:51:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "53656e646572206e6f7420617574686f72697a65642e",
													"id": 288,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "5039:24:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_fecfa93da3bfbc5d9ecf62a2ecd3bca847c5dad14f588ad8fef4719729dd5f22",
														"typeString": "literal_string \"Sender not authorized.\""
													},
													"value": "Sender not authorized."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_fecfa93da3bfbc5d9ecf62a2ecd3bca847c5dad14f588ad8fef4719729dd5f22",
														"typeString": "literal_string \"Sender not authorized.\""
													}
												],
												"id": 279,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "4952:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 289,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "4952:121:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 290,
										"nodeType": "ExpressionStatement",
										"src": "4952:121:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 295,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 292,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 274,
															"src": "5149:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 293,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "turnNum",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 216,
														"src": "5149:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"id": 294,
														"name": "turnNum",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 271,
														"src": "5165:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "5149:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "57726f6e67207475726e206e756d6265722e",
													"id": 296,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "5174:20:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_20e508097488cdf7adfa5bc3dc0f21225c46901f081af1aafe3b036f12f6c46b",
														"typeString": "literal_string \"Wrong turn number.\""
													},
													"value": "Wrong turn number."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_20e508097488cdf7adfa5bc3dc0f21225c46901f081af1aafe3b036f12f6c46b",
														"typeString": "literal_string \"Wrong turn number.\""
													}
												],
												"id": 291,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "5141:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 297,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "5141:54:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 298,
										"nodeType": "ExpressionStatement",
										"src": "5141:54:2"
									},
									{
										"id": 299,
										"nodeType": "PlaceholderStatement",
										"src": "5206:1:2"
									}
								]
							},
							"documentation": null,
							"id": 301,
							"name": "onlyIfPlayersTurn",
							"nodeType": "ModifierDefinition",
							"parameters": {
								"id": 272,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 269,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 301,
										"src": "4805:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 268,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "4805:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 271,
										"name": "turnNum",
										"nodeType": "VariableDeclaration",
										"scope": 301,
										"src": "4821:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 270,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "4821:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "4804:32:2"
							},
							"src": "4778:436:2",
							"visibility": "internal"
						},
						{
							"body": {
								"id": 379,
								"nodeType": "Block",
								"src": "5324:623:2",
								"statements": [
									{
										"assignments": [
											306
										],
										"declarations": [
											{
												"constant": false,
												"id": 306,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 380,
												"src": "5334:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 305,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "5334:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 310,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 307,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "5358:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 309,
											"indexExpression": {
												"argumentTypes": null,
												"id": 308,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 303,
												"src": "5372:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "5358:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "5334:45:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 374,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"id": 366,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"id": 358,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																},
																"id": 350,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	},
																	"id": 342,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		},
																		"id": 334,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"commonType": {
																				"typeIdentifier": "t_bool",
																				"typeString": "bool"
																			},
																			"id": 326,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"leftExpression": {
																				"argumentTypes": null,
																				"commonType": {
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				},
																				"id": 318,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": false,
																				"lValueRequested": false,
																				"leftExpression": {
																					"argumentTypes": null,
																					"expression": {
																						"argumentTypes": null,
																						"id": 312,
																						"name": "msg",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 4372,
																						"src": "5464:3:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_magic_message",
																							"typeString": "msg"
																						}
																					},
																					"id": 313,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"lValueRequested": false,
																					"memberName": "sender",
																					"nodeType": "MemberAccess",
																					"referencedDeclaration": null,
																					"src": "5464:10:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_address",
																						"typeString": "address"
																					}
																				},
																				"nodeType": "BinaryOperation",
																				"operator": "==",
																				"rightExpression": {
																					"argumentTypes": null,
																					"baseExpression": {
																						"argumentTypes": null,
																						"expression": {
																							"argumentTypes": null,
																							"id": 314,
																							"name": "game",
																							"nodeType": "Identifier",
																							"overloadedDeclarations": [],
																							"referencedDeclaration": 306,
																							"src": "5478:4:2",
																							"typeDescriptions": {
																								"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																								"typeString": "struct WorldGame.GameData storage pointer"
																							}
																						},
																						"id": 315,
																						"isConstant": false,
																						"isLValue": true,
																						"isPure": false,
																						"lValueRequested": false,
																						"memberName": "playerAddresses",
																						"nodeType": "MemberAccess",
																						"referencedDeclaration": 224,
																						"src": "5478:20:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_array$_t_address_$8_storage",
																							"typeString": "address[8] storage ref"
																						}
																					},
																					"id": 317,
																					"indexExpression": {
																						"argumentTypes": null,
																						"hexValue": "30",
																						"id": 316,
																						"isConstant": false,
																						"isLValue": false,
																						"isPure": true,
																						"kind": "number",
																						"lValueRequested": false,
																						"nodeType": "Literal",
																						"src": "5499:1:2",
																						"subdenomination": null,
																						"typeDescriptions": {
																							"typeIdentifier": "t_rational_0_by_1",
																							"typeString": "int_const 0"
																						},
																						"value": "0"
																					},
																					"isConstant": false,
																					"isLValue": true,
																					"isPure": false,
																					"lValueRequested": false,
																					"nodeType": "IndexAccess",
																					"src": "5478:23:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_address",
																						"typeString": "address"
																					}
																				},
																				"src": "5464:37:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_bool",
																					"typeString": "bool"
																				}
																			},
																			"nodeType": "BinaryOperation",
																			"operator": "||",
																			"rightExpression": {
																				"argumentTypes": null,
																				"commonType": {
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				},
																				"id": 325,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": false,
																				"lValueRequested": false,
																				"leftExpression": {
																					"argumentTypes": null,
																					"expression": {
																						"argumentTypes": null,
																						"id": 319,
																						"name": "msg",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 4372,
																						"src": "5518:3:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_magic_message",
																							"typeString": "msg"
																						}
																					},
																					"id": 320,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"lValueRequested": false,
																					"memberName": "sender",
																					"nodeType": "MemberAccess",
																					"referencedDeclaration": null,
																					"src": "5518:10:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_address",
																						"typeString": "address"
																					}
																				},
																				"nodeType": "BinaryOperation",
																				"operator": "==",
																				"rightExpression": {
																					"argumentTypes": null,
																					"baseExpression": {
																						"argumentTypes": null,
																						"expression": {
																							"argumentTypes": null,
																							"id": 321,
																							"name": "game",
																							"nodeType": "Identifier",
																							"overloadedDeclarations": [],
																							"referencedDeclaration": 306,
																							"src": "5532:4:2",
																							"typeDescriptions": {
																								"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																								"typeString": "struct WorldGame.GameData storage pointer"
																							}
																						},
																						"id": 322,
																						"isConstant": false,
																						"isLValue": true,
																						"isPure": false,
																						"lValueRequested": false,
																						"memberName": "playerAddresses",
																						"nodeType": "MemberAccess",
																						"referencedDeclaration": 224,
																						"src": "5532:20:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_array$_t_address_$8_storage",
																							"typeString": "address[8] storage ref"
																						}
																					},
																					"id": 324,
																					"indexExpression": {
																						"argumentTypes": null,
																						"hexValue": "31",
																						"id": 323,
																						"isConstant": false,
																						"isLValue": false,
																						"isPure": true,
																						"kind": "number",
																						"lValueRequested": false,
																						"nodeType": "Literal",
																						"src": "5553:1:2",
																						"subdenomination": null,
																						"typeDescriptions": {
																							"typeIdentifier": "t_rational_1_by_1",
																							"typeString": "int_const 1"
																						},
																						"value": "1"
																					},
																					"isConstant": false,
																					"isLValue": true,
																					"isPure": false,
																					"lValueRequested": false,
																					"nodeType": "IndexAccess",
																					"src": "5532:23:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_address",
																						"typeString": "address"
																					}
																				},
																				"src": "5518:37:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_bool",
																					"typeString": "bool"
																				}
																			},
																			"src": "5464:91:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_bool",
																				"typeString": "bool"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "||",
																		"rightExpression": {
																			"argumentTypes": null,
																			"commonType": {
																				"typeIdentifier": "t_address",
																				"typeString": "address"
																			},
																			"id": 333,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"leftExpression": {
																				"argumentTypes": null,
																				"expression": {
																					"argumentTypes": null,
																					"id": 327,
																					"name": "msg",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 4372,
																					"src": "5572:3:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_magic_message",
																						"typeString": "msg"
																					}
																				},
																				"id": 328,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": false,
																				"lValueRequested": false,
																				"memberName": "sender",
																				"nodeType": "MemberAccess",
																				"referencedDeclaration": null,
																				"src": "5572:10:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				}
																			},
																			"nodeType": "BinaryOperation",
																			"operator": "==",
																			"rightExpression": {
																				"argumentTypes": null,
																				"baseExpression": {
																					"argumentTypes": null,
																					"expression": {
																						"argumentTypes": null,
																						"id": 329,
																						"name": "game",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 306,
																						"src": "5586:4:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																							"typeString": "struct WorldGame.GameData storage pointer"
																						}
																					},
																					"id": 330,
																					"isConstant": false,
																					"isLValue": true,
																					"isPure": false,
																					"lValueRequested": false,
																					"memberName": "playerAddresses",
																					"nodeType": "MemberAccess",
																					"referencedDeclaration": 224,
																					"src": "5586:20:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_array$_t_address_$8_storage",
																						"typeString": "address[8] storage ref"
																					}
																				},
																				"id": 332,
																				"indexExpression": {
																					"argumentTypes": null,
																					"hexValue": "32",
																					"id": 331,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": true,
																					"kind": "number",
																					"lValueRequested": false,
																					"nodeType": "Literal",
																					"src": "5607:1:2",
																					"subdenomination": null,
																					"typeDescriptions": {
																						"typeIdentifier": "t_rational_2_by_1",
																						"typeString": "int_const 2"
																					},
																					"value": "2"
																				},
																				"isConstant": false,
																				"isLValue": true,
																				"isPure": false,
																				"lValueRequested": false,
																				"nodeType": "IndexAccess",
																				"src": "5586:23:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				}
																			},
																			"src": "5572:37:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_bool",
																				"typeString": "bool"
																			}
																		},
																		"src": "5464:145:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "||",
																	"rightExpression": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_address",
																			"typeString": "address"
																		},
																		"id": 341,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"expression": {
																				"argumentTypes": null,
																				"id": 335,
																				"name": "msg",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 4372,
																				"src": "5626:3:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_magic_message",
																					"typeString": "msg"
																				}
																			},
																			"id": 336,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"memberName": "sender",
																			"nodeType": "MemberAccess",
																			"referencedDeclaration": null,
																			"src": "5626:10:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_address",
																				"typeString": "address"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "==",
																		"rightExpression": {
																			"argumentTypes": null,
																			"baseExpression": {
																				"argumentTypes": null,
																				"expression": {
																					"argumentTypes": null,
																					"id": 337,
																					"name": "game",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 306,
																					"src": "5640:4:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																						"typeString": "struct WorldGame.GameData storage pointer"
																					}
																				},
																				"id": 338,
																				"isConstant": false,
																				"isLValue": true,
																				"isPure": false,
																				"lValueRequested": false,
																				"memberName": "playerAddresses",
																				"nodeType": "MemberAccess",
																				"referencedDeclaration": 224,
																				"src": "5640:20:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_array$_t_address_$8_storage",
																					"typeString": "address[8] storage ref"
																				}
																			},
																			"id": 340,
																			"indexExpression": {
																				"argumentTypes": null,
																				"hexValue": "33",
																				"id": 339,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "5661:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_3_by_1",
																					"typeString": "int_const 3"
																				},
																				"value": "3"
																			},
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"nodeType": "IndexAccess",
																			"src": "5640:23:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_address",
																				"typeString": "address"
																			}
																		},
																		"src": "5626:37:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	},
																	"src": "5464:199:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "||",
																"rightExpression": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_address",
																		"typeString": "address"
																	},
																	"id": 349,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 343,
																			"name": "msg",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 4372,
																			"src": "5680:3:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_magic_message",
																				"typeString": "msg"
																			}
																		},
																		"id": 344,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "sender",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": null,
																		"src": "5680:10:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_address",
																			"typeString": "address"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "==",
																	"rightExpression": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"expression": {
																				"argumentTypes": null,
																				"id": 345,
																				"name": "game",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 306,
																				"src": "5694:4:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																					"typeString": "struct WorldGame.GameData storage pointer"
																				}
																			},
																			"id": 346,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"memberName": "playerAddresses",
																			"nodeType": "MemberAccess",
																			"referencedDeclaration": 224,
																			"src": "5694:20:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_address_$8_storage",
																				"typeString": "address[8] storage ref"
																			}
																		},
																		"id": 348,
																		"indexExpression": {
																			"argumentTypes": null,
																			"hexValue": "34",
																			"id": 347,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "5715:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_4_by_1",
																				"typeString": "int_const 4"
																			},
																			"value": "4"
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"nodeType": "IndexAccess",
																		"src": "5694:23:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_address",
																			"typeString": "address"
																		}
																	},
																	"src": "5680:37:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"src": "5464:253:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "||",
															"rightExpression": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																"id": 357,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 351,
																		"name": "msg",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 4372,
																		"src": "5734:3:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_magic_message",
																			"typeString": "msg"
																		}
																	},
																	"id": 352,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "sender",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": null,
																	"src": "5734:10:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_address",
																		"typeString": "address"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "==",
																"rightExpression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 353,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 306,
																			"src": "5748:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 354,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "playerAddresses",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 224,
																		"src": "5748:20:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_address_$8_storage",
																			"typeString": "address[8] storage ref"
																		}
																	},
																	"id": 356,
																	"indexExpression": {
																		"argumentTypes": null,
																		"hexValue": "35",
																		"id": 355,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "5769:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_5_by_1",
																			"typeString": "int_const 5"
																		},
																		"value": "5"
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "5748:23:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_address",
																		"typeString": "address"
																	}
																},
																"src": "5734:37:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"src": "5464:307:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "||",
														"rightExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															},
															"id": 365,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 359,
																	"name": "msg",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4372,
																	"src": "5788:3:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_magic_message",
																		"typeString": "msg"
																	}
																},
																"id": 360,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "sender",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "5788:10:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "==",
															"rightExpression": {
																"argumentTypes": null,
																"baseExpression": {
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 361,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 306,
																		"src": "5802:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 362,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "playerAddresses",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 224,
																	"src": "5802:20:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_array$_t_address_$8_storage",
																		"typeString": "address[8] storage ref"
																	}
																},
																"id": 364,
																"indexExpression": {
																	"argumentTypes": null,
																	"hexValue": "36",
																	"id": 363,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "5823:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_6_by_1",
																		"typeString": "int_const 6"
																	},
																	"value": "6"
																},
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "IndexAccess",
																"src": "5802:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																}
															},
															"src": "5788:37:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"src": "5464:361:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "||",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														},
														"id": 373,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 367,
																"name": "msg",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4372,
																"src": "5842:3:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_message",
																	"typeString": "msg"
																}
															},
															"id": 368,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "sender",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "5842:10:2",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 369,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 306,
																	"src": "5856:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 370,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "playerAddresses",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 224,
																"src": "5856:20:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_address_$8_storage",
																	"typeString": "address[8] storage ref"
																}
															},
															"id": 372,
															"indexExpression": {
																"argumentTypes": null,
																"hexValue": "37",
																"id": 371,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "5877:1:2",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_7_by_1",
																	"typeString": "int_const 7"
																},
																"value": "7"
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "5856:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"src": "5842:37:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "5464:415:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "53656e646572206e6f7420617574686f72697a65642e",
													"id": 375,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "5894:24:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_fecfa93da3bfbc5d9ecf62a2ecd3bca847c5dad14f588ad8fef4719729dd5f22",
														"typeString": "literal_string \"Sender not authorized.\""
													},
													"value": "Sender not authorized."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_fecfa93da3bfbc5d9ecf62a2ecd3bca847c5dad14f588ad8fef4719729dd5f22",
														"typeString": "literal_string \"Sender not authorized.\""
													}
												],
												"id": 311,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "5443:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 376,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "5443:485:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 377,
										"nodeType": "ExpressionStatement",
										"src": "5443:485:2"
									},
									{
										"id": 378,
										"nodeType": "PlaceholderStatement",
										"src": "5939:1:2"
									}
								]
							},
							"documentation": null,
							"id": 380,
							"name": "onlyPlayers",
							"nodeType": "ModifierDefinition",
							"parameters": {
								"id": 304,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 303,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 380,
										"src": "5308:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 302,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "5308:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "5307:16:2"
							},
							"src": "5287:660:2",
							"visibility": "internal"
						},
						{
							"body": {
								"id": 441,
								"nodeType": "Block",
								"src": "6098:610:2",
								"statements": [
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 393,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 389,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 387,
															"name": "regionFrom",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 382,
															"src": "6153:10:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "<",
														"rightExpression": {
															"argumentTypes": null,
															"id": 388,
															"name": "REGION_COUNT",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 129,
															"src": "6166:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "6153:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "&&",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 392,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 390,
															"name": "regionTo",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 384,
															"src": "6182:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "<",
														"rightExpression": {
															"argumentTypes": null,
															"id": 391,
															"name": "REGION_COUNT",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 129,
															"src": "6193:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "6182:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "6153:52:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "4d7573742062652076616c696420726567696f6e73",
													"id": 394,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "6207:23:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_351e10a4a8ce9dc50b4687ddaeb98edc1974c79c38c195ffb6987b31581cf2be",
														"typeString": "literal_string \"Must be valid regions\""
													},
													"value": "Must be valid regions"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_351e10a4a8ce9dc50b4687ddaeb98edc1974c79c38c195ffb6987b31581cf2be",
														"typeString": "literal_string \"Must be valid regions\""
													}
												],
												"id": 386,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "6145:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 395,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "6145:86:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 396,
										"nodeType": "ExpressionStatement",
										"src": "6145:86:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 436,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"id": 428,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"id": 420,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																},
																"id": 412,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 404,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"baseExpression": {
																				"argumentTypes": null,
																				"id": 398,
																				"name": "regionNeighbors",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 179,
																				"src": "6330:15:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
																					"typeString": "uint32[5] storage ref[25] storage ref"
																				}
																			},
																			"id": 400,
																			"indexExpression": {
																				"argumentTypes": null,
																				"id": 399,
																				"name": "regionFrom",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 382,
																				"src": "6346:10:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"nodeType": "IndexAccess",
																			"src": "6330:27:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_uint32_$5_storage",
																				"typeString": "uint32[5] storage ref"
																			}
																		},
																		"id": 402,
																		"indexExpression": {
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 401,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "6358:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"nodeType": "IndexAccess",
																		"src": "6330:30:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "==",
																	"rightExpression": {
																		"argumentTypes": null,
																		"id": 403,
																		"name": "regionTo",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 384,
																		"src": "6364:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "6330:42:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "||",
																"rightExpression": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 411,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"baseExpression": {
																				"argumentTypes": null,
																				"id": 405,
																				"name": "regionNeighbors",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 179,
																				"src": "6389:15:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
																					"typeString": "uint32[5] storage ref[25] storage ref"
																				}
																			},
																			"id": 407,
																			"indexExpression": {
																				"argumentTypes": null,
																				"id": 406,
																				"name": "regionFrom",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 382,
																				"src": "6405:10:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"nodeType": "IndexAccess",
																			"src": "6389:27:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_uint32_$5_storage",
																				"typeString": "uint32[5] storage ref"
																			}
																		},
																		"id": 409,
																		"indexExpression": {
																			"argumentTypes": null,
																			"hexValue": "31",
																			"id": 408,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "6417:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_1_by_1",
																				"typeString": "int_const 1"
																			},
																			"value": "1"
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"nodeType": "IndexAccess",
																		"src": "6389:30:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "==",
																	"rightExpression": {
																		"argumentTypes": null,
																		"id": 410,
																		"name": "regionTo",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 384,
																		"src": "6423:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "6389:42:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"src": "6330:101:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "||",
															"rightExpression": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 419,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"id": 413,
																			"name": "regionNeighbors",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 179,
																			"src": "6448:15:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
																				"typeString": "uint32[5] storage ref[25] storage ref"
																			}
																		},
																		"id": 415,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 414,
																			"name": "regionFrom",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 382,
																			"src": "6464:10:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"nodeType": "IndexAccess",
																		"src": "6448:27:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_uint32_$5_storage",
																			"typeString": "uint32[5] storage ref"
																		}
																	},
																	"id": 417,
																	"indexExpression": {
																		"argumentTypes": null,
																		"hexValue": "32",
																		"id": 416,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "6476:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_2_by_1",
																			"typeString": "int_const 2"
																		},
																		"value": "2"
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "6448:30:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "==",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 418,
																	"name": "regionTo",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 384,
																	"src": "6482:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "6448:42:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"src": "6330:160:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "||",
														"rightExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 427,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"baseExpression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 421,
																		"name": "regionNeighbors",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 179,
																		"src": "6507:15:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
																			"typeString": "uint32[5] storage ref[25] storage ref"
																		}
																	},
																	"id": 423,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 422,
																		"name": "regionFrom",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 382,
																		"src": "6523:10:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "6507:27:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_array$_t_uint32_$5_storage",
																		"typeString": "uint32[5] storage ref"
																	}
																},
																"id": 425,
																"indexExpression": {
																	"argumentTypes": null,
																	"hexValue": "33",
																	"id": 424,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "6535:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_3_by_1",
																		"typeString": "int_const 3"
																	},
																	"value": "3"
																},
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "IndexAccess",
																"src": "6507:30:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "==",
															"rightExpression": {
																"argumentTypes": null,
																"id": 426,
																"name": "regionTo",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 384,
																"src": "6541:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "6507:42:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"src": "6330:219:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "||",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 435,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"baseExpression": {
																	"argumentTypes": null,
																	"id": 429,
																	"name": "regionNeighbors",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 179,
																	"src": "6566:15:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
																		"typeString": "uint32[5] storage ref[25] storage ref"
																	}
																},
																"id": 431,
																"indexExpression": {
																	"argumentTypes": null,
																	"id": 430,
																	"name": "regionFrom",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 382,
																	"src": "6582:10:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "IndexAccess",
																"src": "6566:27:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$5_storage",
																	"typeString": "uint32[5] storage ref"
																}
															},
															"id": 433,
															"indexExpression": {
																"argumentTypes": null,
																"hexValue": "34",
																"id": 432,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "6594:1:2",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_4_by_1",
																	"typeString": "int_const 4"
																},
																"value": "4"
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "6566:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"id": 434,
															"name": "regionTo",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 384,
															"src": "6600:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "6566:42:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "6330:278:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "526567696f6e73206d757374206265206e65696768626f727320696e206f7264657220746f206d6f7665206265747765656e207468656d",
													"id": 437,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "6622:57:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_dd170a6e7613547202242bfeea5b51fbbf149a248552a23a442afe848c942fba",
														"typeString": "literal_string \"Regions must be neighbors in order to move between them\""
													},
													"value": "Regions must be neighbors in order to move between them"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_dd170a6e7613547202242bfeea5b51fbbf149a248552a23a442afe848c942fba",
														"typeString": "literal_string \"Regions must be neighbors in order to move between them\""
													}
												],
												"id": 397,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "6309:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 438,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "6309:380:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 439,
										"nodeType": "ExpressionStatement",
										"src": "6309:380:2"
									},
									{
										"id": 440,
										"nodeType": "PlaceholderStatement",
										"src": "6700:1:2"
									}
								]
							},
							"documentation": null,
							"id": 442,
							"name": "onlyNeighbors",
							"nodeType": "ModifierDefinition",
							"parameters": {
								"id": 385,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 382,
										"name": "regionFrom",
										"nodeType": "VariableDeclaration",
										"scope": 442,
										"src": "6062:17:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 381,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "6062:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 384,
										"name": "regionTo",
										"nodeType": "VariableDeclaration",
										"scope": 442,
										"src": "6081:15:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 383,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "6081:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "6061:36:2"
							},
							"src": "6039:669:2",
							"visibility": "internal"
						},
						{
							"body": {
								"id": 453,
								"nodeType": "Block",
								"src": "6793:95:2",
								"statements": [
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													},
													"id": 448,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 445,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4372,
															"src": "6811:3:2",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 446,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "sender",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "6811:10:2",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"id": 447,
														"name": "owner",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 167,
														"src": "6825:5:2",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"src": "6811:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "4f6e6c79206f776e65722063616e2063616c6c20746869732066756e6374696f6e2e",
													"id": 449,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "6832:36:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_0fcea41e877c4f84237ea6b9061acc9b3fc97555de5ba31615eb7b8cf7110239",
														"typeString": "literal_string \"Only owner can call this function.\""
													},
													"value": "Only owner can call this function."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_0fcea41e877c4f84237ea6b9061acc9b3fc97555de5ba31615eb7b8cf7110239",
														"typeString": "literal_string \"Only owner can call this function.\""
													}
												],
												"id": 444,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "6803:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 450,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "6803:66:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 451,
										"nodeType": "ExpressionStatement",
										"src": "6803:66:2"
									},
									{
										"id": 452,
										"nodeType": "PlaceholderStatement",
										"src": "6880:1:2"
									}
								]
							},
							"documentation": null,
							"id": 454,
							"name": "isOwner",
							"nodeType": "ModifierDefinition",
							"parameters": {
								"id": 443,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "6790:2:2"
							},
							"src": "6774:114:2",
							"visibility": "internal"
						},
						{
							"body": {
								"id": 464,
								"nodeType": "Block",
								"src": "6982:83:2",
								"statements": [
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 459,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 457,
														"name": "stopped",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 169,
														"src": "7000:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "66616c7365",
														"id": 458,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "bool",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "7011:5:2",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"value": "false"
													},
													"src": "7000:16:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "53746f707065642064756520746f20656d657267656e63792e",
													"id": 460,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "7018:27:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_bc72763c55e911df61bed4f8abc18c7a42a2a3aedfe3e2e2d746c483b2855302",
														"typeString": "literal_string \"Stopped due to emergency.\""
													},
													"value": "Stopped due to emergency."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_bc72763c55e911df61bed4f8abc18c7a42a2a3aedfe3e2e2d746c483b2855302",
														"typeString": "literal_string \"Stopped due to emergency.\""
													}
												],
												"id": 456,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "6992:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 461,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "6992:54:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 462,
										"nodeType": "ExpressionStatement",
										"src": "6992:54:2"
									},
									{
										"id": 463,
										"nodeType": "PlaceholderStatement",
										"src": "7057:1:2"
									}
								]
							},
							"documentation": null,
							"id": 465,
							"name": "stopInEmergency",
							"nodeType": "ModifierDefinition",
							"parameters": {
								"id": 455,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "6979:2:2"
							},
							"src": "6955:110:2",
							"visibility": "internal"
						},
						{
							"body": {
								"id": 479,
								"nodeType": "Block",
								"src": "7153:95:2",
								"statements": [
									{
										"expression": {
											"argumentTypes": null,
											"id": 471,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"id": 468,
												"name": "owner",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 167,
												"src": "7163:5:2",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 469,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4372,
													"src": "7171:3:2",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 470,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "7171:10:2",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"src": "7163:18:2",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"id": 472,
										"nodeType": "ExpressionStatement",
										"src": "7163:18:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [],
											"expression": {
												"argumentTypes": [],
												"id": 473,
												"name": "initRegionNeighbors",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 3841,
												"src": "7191:19:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_nonpayable$__$returns$__$",
													"typeString": "function ()"
												}
											},
											"id": 474,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "7191:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 475,
										"nodeType": "ExpressionStatement",
										"src": "7191:21:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [],
											"expression": {
												"argumentTypes": [],
												"id": 476,
												"name": "initRegionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4070,
												"src": "7222:17:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_nonpayable$__$returns$__$",
													"typeString": "function ()"
												}
											},
											"id": 477,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "7222:19:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 478,
										"nodeType": "ExpressionStatement",
										"src": "7222:19:2"
									}
								]
							},
							"documentation": null,
							"id": 480,
							"implemented": true,
							"isConstructor": true,
							"isDeclaredConst": false,
							"modifiers": [],
							"name": "",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 466,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "7143:2:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 467,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "7153:0:2"
							},
							"scope": 4288,
							"src": "7132:116:2",
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 487,
								"nodeType": "Block",
								"src": "7359:57:2",
								"statements": [
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "496e76616c69642063616c6c20746f2067616d6520636f6e74726163742e",
													"id": 484,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "7376:32:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_0999c503c462f0fbf489a8c62dc28f53cf7245a2e9460e5005042ac0654e4198",
														"typeString": "literal_string \"Invalid call to game contract.\""
													},
													"value": "Invalid call to game contract."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_stringliteral_0999c503c462f0fbf489a8c62dc28f53cf7245a2e9460e5005042ac0654e4198",
														"typeString": "literal_string \"Invalid call to game contract.\""
													}
												],
												"id": 483,
												"name": "revert",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4377,
													4378
												],
												"referencedDeclaration": 4378,
												"src": "7369:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_revert_pure$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (string memory) pure"
												}
											},
											"id": 485,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "7369:40:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 486,
										"nodeType": "ExpressionStatement",
										"src": "7369:40:2"
									}
								]
							},
							"documentation": null,
							"id": 488,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": false,
							"modifiers": [],
							"name": "",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 481,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "7341:2:2"
							},
							"payable": true,
							"returnParameters": {
								"id": 482,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "7359:0:2"
							},
							"scope": 4288,
							"src": "7333:83:2",
							"stateMutability": "payable",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 499,
								"nodeType": "Block",
								"src": "7568:31:2",
								"statements": [
									{
										"expression": {
											"argumentTypes": null,
											"id": 497,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"id": 495,
												"name": "stopped",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 169,
												"src": "7578:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 496,
												"name": "stop",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 490,
												"src": "7588:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											"src": "7578:14:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"id": 498,
										"nodeType": "ExpressionStatement",
										"src": "7578:14:2"
									}
								]
							},
							"documentation": null,
							"id": 500,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": false,
							"modifiers": [
								{
									"arguments": [],
									"id": 493,
									"modifierName": {
										"argumentTypes": null,
										"id": 492,
										"name": "isOwner",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 454,
										"src": "7554:7:2",
										"typeDescriptions": {
											"typeIdentifier": "t_modifier$__$",
											"typeString": "modifier ()"
										}
									},
									"nodeType": "ModifierInvocation",
									"src": "7554:9:2"
								}
							],
							"name": "stopNewGames",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 491,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 490,
										"name": "stop",
										"nodeType": "VariableDeclaration",
										"scope": 500,
										"src": "7519:9:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"typeName": {
											"id": 489,
											"name": "bool",
											"nodeType": "ElementaryTypeName",
											"src": "7519:4:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "7518:11:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 494,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "7568:0:2"
							},
							"scope": 4288,
							"src": "7497:102:2",
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 649,
								"nodeType": "Block",
								"src": "8077:1839:2",
								"statements": [
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 520,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 518,
														"name": "maxBlocksPerTurn",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 504,
														"src": "8160:16:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": ">=",
													"rightExpression": {
														"argumentTypes": null,
														"id": 519,
														"name": "MAX_BLOCKS_THRESHOLD",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 150,
														"src": "8180:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "8160:40:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "5573657273206d75737420626520676976656e20656e6f7567682074696d6520746f20636f6d706c657465207468656972207475726e2e",
													"id": 521,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "8202:57:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_60d8d8641b4cffefeb677de5b0387d801ee63766e104b1488ca4c43419940433",
														"typeString": "literal_string \"Users must be given enough time to complete their turn.\""
													},
													"value": "Users must be given enough time to complete their turn."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_60d8d8641b4cffefeb677de5b0387d801ee63766e104b1488ca4c43419940433",
														"typeString": "literal_string \"Users must be given enough time to complete their turn.\""
													}
												],
												"id": 517,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "8152:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 522,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "8152:108:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 523,
										"nodeType": "ExpressionStatement",
										"src": "8152:108:2"
									},
									{
										"assignments": [
											525
										],
										"declarations": [
											{
												"constant": false,
												"id": 525,
												"name": "gameId",
												"nodeType": "VariableDeclaration",
												"scope": 650,
												"src": "8426:14:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"typeName": {
													"id": 524,
													"name": "uint256",
													"nodeType": "ElementaryTypeName",
													"src": "8426:7:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 637,
										"initialValue": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"id": 636,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"hexValue": "30",
																		"id": 530,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "8527:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		},
																		"value": "0"
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		}
																	],
																	"id": 529,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"nodeType": "ElementaryTypeNameExpression",
																	"src": "8520:6:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_uint32_$",
																		"typeString": "type(uint32)"
																	},
																	"typeName": "uint32"
																},
																"id": 531,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "typeConversion",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "8520:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 533,
																			"name": "block",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 4362,
																			"src": "8584:5:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_magic_block",
																				"typeString": "block"
																			}
																		},
																		"id": 534,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "number",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": null,
																		"src": "8584:12:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	],
																	"id": 532,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"nodeType": "ElementaryTypeNameExpression",
																	"src": "8577:6:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_uint32_$",
																		"typeString": "type(uint32)"
																	},
																	"typeName": "uint32"
																},
																"id": 535,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "typeConversion",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "8577:20:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"id": 536,
																"name": "maxBlocksPerTurn",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 504,
																"src": "8654:16:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"id": 537,
																"name": "playerCount",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 502,
																"src": "8721:11:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"id": 538,
																"name": "playerAddresses",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 508,
																"src": "8801:15:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_address_$8_memory_ptr",
																	"typeString": "address[8] memory"
																}
															},
															{
																"argumentTypes": null,
																"id": 539,
																"name": "BEGIN_SOLDIERS_COUNTS",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 165,
																"src": "8876:21:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 540,
																"name": "ALL_REGIONS_NOT_OWNED",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 162,
																"src": "8951:21:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"components": [
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 542,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9066:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 541,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9059:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 543,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9059:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 545,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9077:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 544,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9070:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 546,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9070:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 548,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9088:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 547,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9081:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 549,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9081:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 551,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9099:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 550,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9092:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 552,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9092:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 554,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9110:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 553,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9103:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 555,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9103:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 557,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9121:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 556,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9114:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 558,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9114:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 560,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9149:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 559,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9142:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 561,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9142:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 563,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9160:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 562,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9153:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 564,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9153:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 566,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9171:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 565,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9164:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 567,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9164:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 569,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9182:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 568,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9175:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 570,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9175:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 572,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9193:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 571,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9186:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 573,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9186:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 575,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9204:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 574,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9197:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 576,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9197:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 578,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9232:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 577,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9225:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 579,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9225:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 581,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9243:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 580,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9236:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 582,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9236:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 584,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9254:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 583,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9247:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 585,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9247:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 587,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9265:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 586,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9258:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 588,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9258:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 590,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9276:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 589,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9269:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 591,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9269:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 593,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9287:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 592,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9280:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 594,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9280:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 596,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9315:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 595,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9308:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 597,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9308:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 599,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9326:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 598,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9319:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 600,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9319:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 602,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9337:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 601,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9330:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 603,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9330:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 605,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9348:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 604,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9341:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 606,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9341:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 608,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9359:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 607,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9352:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 609,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9352:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 611,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9370:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 610,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9363:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 612,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9363:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"hexValue": "30",
																				"id": 614,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "9398:1:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				},
																				"value": "0"
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_rational_0_by_1",
																					"typeString": "int_const 0"
																				}
																			],
																			"id": 613,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "ElementaryTypeNameExpression",
																			"src": "9391:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_type$_t_uint32_$",
																				"typeString": "type(uint32)"
																			},
																			"typeName": "uint32"
																		},
																		"id": 615,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "typeConversion",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "9391:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"id": 616,
																"isConstant": false,
																"isInlineArray": true,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"nodeType": "TupleExpression",
																"src": "9041:373:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
																	"typeString": "uint32[25] memory"
																}
															},
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"hexValue": "30",
																		"id": 618,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "9473:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		},
																		"value": "0"
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		}
																	],
																	"id": 617,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"nodeType": "ElementaryTypeNameExpression",
																	"src": "9466:6:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_uint32_$",
																		"typeString": "type(uint32)"
																	},
																	"typeName": "uint32"
																},
																"id": 619,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "typeConversion",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "9466:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"hexValue": "30",
																		"id": 621,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "9538:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		},
																		"value": "0"
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		}
																	],
																	"id": 620,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"nodeType": "ElementaryTypeNameExpression",
																	"src": "9530:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_uint256_$",
																		"typeString": "type(uint256)"
																	},
																	"typeName": "uint256"
																},
																"id": 622,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "typeConversion",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "9530:10:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"hexValue": "30",
																		"id": 624,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "9602:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		},
																		"value": "0"
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		}
																	],
																	"id": 623,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"nodeType": "ElementaryTypeNameExpression",
																	"src": "9594:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_uint256_$",
																		"typeString": "type(uint256)"
																	},
																	"typeName": "uint256"
																},
																"id": 625,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "typeConversion",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "9594:10:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"hexValue": "30",
																		"id": 627,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "9674:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		},
																		"value": "0"
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		}
																	],
																	"id": 626,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"nodeType": "ElementaryTypeNameExpression",
																	"src": "9666:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_uint256_$",
																		"typeString": "type(uint256)"
																	},
																	"typeName": "uint256"
																},
																"id": 628,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "typeConversion",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "9666:10:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"hexValue": "30",
																		"id": 630,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "9741:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		},
																		"value": "0"
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		}
																	],
																	"id": 629,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"nodeType": "ElementaryTypeNameExpression",
																	"src": "9733:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_uint256_$",
																		"typeString": "type(uint256)"
																	},
																	"typeName": "uint256"
																},
																"id": 631,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "typeConversion",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "9733:10:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 632,
																"name": "teamAvatars",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 510,
																"src": "9794:11:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bytes8",
																	"typeString": "bytes8"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_array$_t_address_$8_memory_ptr",
																	"typeString": "address[8] memory"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
																	"typeString": "uint32[25] memory"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_bytes8",
																	"typeString": "bytes8"
																}
															],
															"id": 528,
															"name": "GameData",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 245,
															"src": "8462:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_struct$_GameData_$245_storage_ptr_$",
																"typeString": "type(struct WorldGame.GameData storage pointer)"
															}
														},
														"id": 633,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "structConstructorCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "8462:1353:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_memory",
															"typeString": "struct WorldGame.GameData memory"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_struct$_GameData_$245_memory",
															"typeString": "struct WorldGame.GameData memory"
														}
													],
													"expression": {
														"argumentTypes": null,
														"id": 526,
														"name": "gameDataArray",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 186,
														"src": "8443:13:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
															"typeString": "struct WorldGame.GameData storage ref[] storage ref"
														}
													},
													"id": 527,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "push",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "8443:18:2",
													"typeDescriptions": {
														"typeIdentifier": "t_function_arraypush_nonpayable$_t_struct$_GameData_$245_storage_$returns$_t_uint256_$",
														"typeString": "function (struct WorldGame.GameData storage ref) returns (uint256)"
													}
												},
												"id": 634,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "8443:1373:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "-",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 635,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "9819:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"src": "8443:1377:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "8426:1394:2"
									},
									{
										"eventCall": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 639,
													"name": "gameId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 525,
													"src": "9844:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 641,
																"name": "block",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4362,
																"src": "9859:5:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_block",
																	"typeString": "block"
																}
															},
															"id": 642,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "number",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "9859:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														],
														"id": 640,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "9852:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 643,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "9852:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"id": 644,
													"name": "teamAvatars",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 510,
													"src": "9874:11:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bytes8",
														"typeString": "bytes8"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													{
														"typeIdentifier": "t_bytes8",
														"typeString": "bytes8"
													}
												],
												"id": 638,
												"name": "NewGame",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 253,
												"src": "9836:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_event_nonpayable$_t_uint256_$_t_uint32_$_t_bytes8_$returns$__$",
													"typeString": "function (uint256,uint32,bytes8)"
												}
											},
											"id": 645,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "9836:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 646,
										"nodeType": "EmitStatement",
										"src": "9831:55:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 647,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 525,
											"src": "9903:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"functionReturnParameters": 516,
										"id": 648,
										"nodeType": "Return",
										"src": "9896:13:2"
									}
								]
							},
							"documentation": "@notice Create a new game instance\n @param playerCount number of players\n @param playerAddresses address of each player\n @param teamAvatars avatar to use for each player\n @return Id of the game instance",
							"id": 650,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": false,
							"modifiers": [
								{
									"arguments": [],
									"id": 513,
									"modifierName": {
										"argumentTypes": null,
										"id": 512,
										"name": "stopInEmergency",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 465,
										"src": "8028:15:2",
										"typeDescriptions": {
											"typeIdentifier": "t_modifier$__$",
											"typeString": "modifier ()"
										}
									},
									"nodeType": "ModifierInvocation",
									"src": "8028:17:2"
								}
							],
							"name": "newGame",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 511,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 502,
										"name": "playerCount",
										"nodeType": "VariableDeclaration",
										"scope": 650,
										"src": "7870:18:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 501,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "7870:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 504,
										"name": "maxBlocksPerTurn",
										"nodeType": "VariableDeclaration",
										"scope": 650,
										"src": "7899:23:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 503,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "7899:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 508,
										"name": "playerAddresses",
										"nodeType": "VariableDeclaration",
										"scope": 650,
										"src": "7933:36:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_address_$8_memory_ptr",
											"typeString": "address[8]"
										},
										"typeName": {
											"baseType": {
												"id": 505,
												"name": "address",
												"nodeType": "ElementaryTypeName",
												"src": "7933:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"id": 507,
											"length": {
												"argumentTypes": null,
												"id": 506,
												"name": "MAX_PLAYERS",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 135,
												"src": "7941:11:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "7933:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_address_$8_storage_ptr",
												"typeString": "address[8]"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 510,
										"name": "teamAvatars",
										"nodeType": "VariableDeclaration",
										"scope": 650,
										"src": "7980:18:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes8",
											"typeString": "bytes8"
										},
										"typeName": {
											"id": 509,
											"name": "bytes8",
											"nodeType": "ElementaryTypeName",
											"src": "7980:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes8",
												"typeString": "bytes8"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "7860:144:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 516,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 515,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 650,
										"src": "8063:7:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 514,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "8063:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "8062:9:2"
							},
							"scope": 4288,
							"src": "7844:2072:2",
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 799,
								"nodeType": "Block",
								"src": "10563:1345:2",
								"statements": [
									{
										"assignments": [
											672
										],
										"declarations": [
											{
												"constant": false,
												"id": 672,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 800,
												"src": "10573:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 671,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "10573:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 676,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 673,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "10597:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 675,
											"indexExpression": {
												"argumentTypes": null,
												"id": 674,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 652,
												"src": "10611:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "10597:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "10573:45:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 678,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 800,
												"src": "10628:8:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 677,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "10628:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 679,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "10628:8:2"
									},
									{
										"body": {
											"id": 702,
											"nodeType": "Block",
											"src": "10733:231:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 698,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"id": 692,
																	"name": "regionTo",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 658,
																	"src": "10842:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "!=",
																"rightExpression": {
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"expression": {
																				"argumentTypes": null,
																				"id": 694,
																				"name": "game",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 672,
																				"src": "10864:4:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																					"typeString": "struct WorldGame.GameData storage pointer"
																				}
																			},
																			"id": 695,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"memberName": "toRegionList",
																			"nodeType": "MemberAccess",
																			"referencedDeclaration": 238,
																			"src": "10864:17:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint256",
																				"typeString": "uint256"
																			}
																		},
																		{
																			"argumentTypes": null,
																			"id": 696,
																			"name": "i",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 678,
																			"src": "10883:1:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_uint256",
																				"typeString": "uint256"
																			},
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		],
																		"id": 693,
																		"name": "getData32",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 4095,
																		"src": "10854:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																			"typeString": "function (uint256,uint32) pure returns (uint32)"
																		}
																	},
																	"id": 697,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"kind": "functionCall",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "10854:31:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "10842:43:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															{
																"argumentTypes": null,
																"hexValue": "526567696f6e20616c7265616479206861732071756575656420616374696f6e2e",
																"id": 699,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "string",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "10904:35:2",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_stringliteral_42a4306f24c3d258ad9d7c6f5cbd7e7e358c2aaef61dbd71507a29be5a0ec3dc",
																	"typeString": "literal_string \"Region already has queued action.\""
																},
																"value": "Region already has queued action."
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																},
																{
																	"typeIdentifier": "t_stringliteral_42a4306f24c3d258ad9d7c6f5cbd7e7e358c2aaef61dbd71507a29be5a0ec3dc",
																	"typeString": "literal_string \"Region already has queued action.\""
																}
															],
															"id": 691,
															"name": "require",
															"nodeType": "Identifier",
															"overloadedDeclarations": [
																4375,
																4376
															],
															"referencedDeclaration": 4376,
															"src": "10817:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
																"typeString": "function (bool,string memory) pure"
															}
														},
														"id": 700,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "10817:136:2",
														"typeDescriptions": {
															"typeIdentifier": "t_tuple$__$",
															"typeString": "tuple()"
														}
													},
													"id": 701,
													"nodeType": "ExpressionStatement",
													"src": "10817:136:2"
												}
											]
										},
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 687,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 684,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 678,
												"src": "10706:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "<",
											"rightExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 685,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 672,
													"src": "10710:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 686,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "actionCount",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 234,
												"src": "10710:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "10706:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"id": 703,
										"initializationExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 682,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftHandSide": {
													"argumentTypes": null,
													"id": 680,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 678,
													"src": "10699:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "Assignment",
												"operator": "=",
												"rightHandSide": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 681,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "10703:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "10699:5:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 683,
											"nodeType": "ExpressionStatement",
											"src": "10699:5:2"
										},
										"loopExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 689,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "UnaryOperation",
												"operator": "++",
												"prefix": false,
												"src": "10728:3:2",
												"subExpression": {
													"argumentTypes": null,
													"id": 688,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 678,
													"src": "10728:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 690,
											"nodeType": "ExpressionStatement",
											"src": "10728:3:2"
										},
										"nodeType": "ForStatement",
										"src": "10694:270:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 708,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 705,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 672,
															"src": "10981:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 706,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "actionCount",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 234,
														"src": "10981:16:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "<",
													"rightExpression": {
														"argumentTypes": null,
														"id": 707,
														"name": "MAX_ACTIONS_PER_TURN",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 138,
														"src": "11000:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "10981:39:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "4f6e6c79203820616374696f6e732061726520616c6c6f77656420706572207475726e",
													"id": 709,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "11022:37:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_471f30d10f0a85b9c4f591704f45bf517809a8bcc20d3354ac5a73fdad6f1f40",
														"typeString": "literal_string \"Only 8 actions are allowed per turn\""
													},
													"value": "Only 8 actions are allowed per turn"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_471f30d10f0a85b9c4f591704f45bf517809a8bcc20d3354ac5a73fdad6f1f40",
														"typeString": "literal_string \"Only 8 actions are allowed per turn\""
													}
												],
												"id": 704,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "10973:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 710,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "10973:87:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 711,
										"nodeType": "ExpressionStatement",
										"src": "10973:87:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 718,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 713,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 672,
																"src": "11078:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 714,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "regionSoldiers",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 232,
															"src": "11078:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_uint32_$25_storage",
																"typeString": "uint32[25] storage ref"
															}
														},
														"id": 716,
														"indexExpression": {
															"argumentTypes": null,
															"id": 715,
															"name": "regionFrom",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 656,
															"src": "11098:10:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "11078:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": ">",
													"rightExpression": {
														"argumentTypes": null,
														"id": 717,
														"name": "moveSoldierCount",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 660,
														"src": "11112:16:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "11078:50:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "4d75737420686176652073756666696369656e7420736f6c6469657273",
													"id": 719,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "11130:31:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_12962f6126f4a079dde7c9188f2cd55cd58b74d5bc86e5589fef81f690b5cfd1",
														"typeString": "literal_string \"Must have sufficient soldiers\""
													},
													"value": "Must have sufficient soldiers"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_12962f6126f4a079dde7c9188f2cd55cd58b74d5bc86e5589fef81f690b5cfd1",
														"typeString": "literal_string \"Must have sufficient soldiers\""
													}
												],
												"id": 712,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "11070:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 720,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "11070:92:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 721,
										"nodeType": "ExpressionStatement",
										"src": "11070:92:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 730,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 723,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 672,
															"src": "11180:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 724,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "turnTeamId",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 214,
														"src": "11180:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 726,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 672,
																	"src": "11208:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 727,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "regionOwners",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 228,
																"src": "11208:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 728,
																"name": "regionFrom",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 656,
																"src": "11227:10:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 725,
															"name": "getData8",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4158,
															"src": "11199:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 729,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "11199:39:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "11180:58:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "4d757374206f776e20726567696f6e206d6f76696e672066726f6d",
													"id": 731,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "11240:29:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_6f4e4f7daf7ce42b7f9639ac00f41ccd25d08f2d8f5a894d0b853675c2a00939",
														"typeString": "literal_string \"Must own region moving from\""
													},
													"value": "Must own region moving from"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_6f4e4f7daf7ce42b7f9639ac00f41ccd25d08f2d8f5a894d0b853675c2a00939",
														"typeString": "literal_string \"Must own region moving from\""
													}
												],
												"id": 722,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "11172:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 732,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "11172:98:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 733,
										"nodeType": "ExpressionStatement",
										"src": "11172:98:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 737,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"id": 734,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 678,
												"src": "11334:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 735,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 672,
													"src": "11338:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 736,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "actionCount",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 234,
												"src": "11338:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "11334:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 738,
										"nodeType": "ExpressionStatement",
										"src": "11334:20:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 745,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 739,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 672,
														"src": "11407:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 742,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "regionSoldiers",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 232,
													"src": "11407:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 743,
												"indexExpression": {
													"argumentTypes": null,
													"id": 741,
													"name": "regionFrom",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 656,
													"src": "11427:10:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "11407:31:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "-=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 744,
												"name": "moveSoldierCount",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 660,
												"src": "11442:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "11407:51:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 746,
										"nodeType": "ExpressionStatement",
										"src": "11407:51:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 756,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 747,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 672,
													"src": "11516:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 749,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"memberName": "fromRegionList",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 236,
												"src": "11516:19:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 751,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 672,
															"src": "11548:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 752,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "fromRegionList",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 236,
														"src": "11548:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													{
														"argumentTypes": null,
														"id": 753,
														"name": "i",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 678,
														"src": "11569:1:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													{
														"argumentTypes": null,
														"id": 754,
														"name": "regionFrom",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 656,
														"src": "11572:10:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														{
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														{
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													],
													"id": 750,
													"name": "setData32",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4133,
													"src": "11538:9:2",
													"typeDescriptions": {
														"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
														"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
													}
												},
												"id": 755,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "11538:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"src": "11516:67:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"id": 757,
										"nodeType": "ExpressionStatement",
										"src": "11516:67:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 767,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 758,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 672,
													"src": "11593:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 760,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"memberName": "toRegionList",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 238,
												"src": "11593:17:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 762,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 672,
															"src": "11623:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 763,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "toRegionList",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 238,
														"src": "11623:17:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													{
														"argumentTypes": null,
														"id": 764,
														"name": "i",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 678,
														"src": "11642:1:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													{
														"argumentTypes": null,
														"id": 765,
														"name": "regionTo",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 658,
														"src": "11645:8:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														{
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														{
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													],
													"id": 761,
													"name": "setData32",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4133,
													"src": "11613:9:2",
													"typeDescriptions": {
														"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
														"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
													}
												},
												"id": 766,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "11613:41:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"src": "11593:61:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"id": 768,
										"nodeType": "ExpressionStatement",
										"src": "11593:61:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 778,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 769,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 672,
													"src": "11664:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 771,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"memberName": "moveSoldierCountList",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 240,
												"src": "11664:25:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 773,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 672,
															"src": "11702:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 774,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "moveSoldierCountList",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 240,
														"src": "11702:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													{
														"argumentTypes": null,
														"id": 775,
														"name": "i",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 678,
														"src": "11729:1:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													{
														"argumentTypes": null,
														"id": 776,
														"name": "moveSoldierCount",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 660,
														"src": "11732:16:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														{
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														{
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													],
													"id": 772,
													"name": "setData32",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4133,
													"src": "11692:9:2",
													"typeDescriptions": {
														"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
														"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
													}
												},
												"id": 777,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "11692:57:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"src": "11664:85:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"id": 779,
										"nodeType": "ExpressionStatement",
										"src": "11664:85:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 792,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 780,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 672,
													"src": "11759:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 782,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"memberName": "submitBlockList",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 242,
												"src": "11759:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 784,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 672,
															"src": "11792:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 785,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "submitBlockList",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 242,
														"src": "11792:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													{
														"argumentTypes": null,
														"id": 786,
														"name": "i",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 678,
														"src": "11814:1:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													{
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 788,
																	"name": "block",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4362,
																	"src": "11824:5:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_magic_block",
																		"typeString": "block"
																	}
																},
																"id": 789,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "number",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "11824:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															],
															"id": 787,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "11817:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 790,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "11817:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														{
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														{
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													],
													"id": 783,
													"name": "setData32",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4133,
													"src": "11782:9:2",
													"typeDescriptions": {
														"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
														"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
													}
												},
												"id": 791,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "11782:56:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"src": "11759:79:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"id": 793,
										"nodeType": "ExpressionStatement",
										"src": "11759:79:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 797,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "++",
											"prefix": false,
											"src": "11883:18:2",
											"subExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 794,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 672,
													"src": "11883:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 796,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"memberName": "actionCount",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 234,
												"src": "11883:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 798,
										"nodeType": "ExpressionStatement",
										"src": "11883:18:2"
									}
								]
							},
							"documentation": "@notice Move soldiers from one region to an adjacent region.  Attack if moving to enemy territory. \n @param gameId Id of game \n @param turnNum Turn action should occur during \n @param regionFrom Move soldiers from this region\n @param regionTo Move soldiers to this region\n @param moveSoldierCount Number of soldiers to move",
							"id": 800,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": false,
							"modifiers": [
								{
									"arguments": [
										{
											"argumentTypes": null,
											"id": 663,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 652,
											"src": "10496:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										{
											"argumentTypes": null,
											"id": 664,
											"name": "turnNum",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 654,
											"src": "10504:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										}
									],
									"id": 665,
									"modifierName": {
										"argumentTypes": null,
										"id": 662,
										"name": "onlyIfPlayersTurn",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 301,
										"src": "10478:17:2",
										"typeDescriptions": {
											"typeIdentifier": "t_modifier$_t_uint256_$_t_uint32_$",
											"typeString": "modifier (uint256,uint32)"
										}
									},
									"nodeType": "ModifierInvocation",
									"src": "10478:34:2"
								},
								{
									"arguments": [
										{
											"argumentTypes": null,
											"id": 667,
											"name": "regionFrom",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 656,
											"src": "10536:10:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										{
											"argumentTypes": null,
											"id": 668,
											"name": "regionTo",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 658,
											"src": "10548:8:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										}
									],
									"id": 669,
									"modifierName": {
										"argumentTypes": null,
										"id": 666,
										"name": "onlyNeighbors",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 442,
										"src": "10522:13:2",
										"typeDescriptions": {
											"typeIdentifier": "t_modifier$_t_uint32_$_t_uint32_$",
											"typeString": "modifier (uint32,uint32)"
										}
									},
									"nodeType": "ModifierInvocation",
									"src": "10522:35:2"
								}
							],
							"name": "attackOrMove",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 661,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 652,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 800,
										"src": "10320:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 651,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "10320:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 654,
										"name": "turnNum",
										"nodeType": "VariableDeclaration",
										"scope": 800,
										"src": "10345:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 653,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "10345:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 656,
										"name": "regionFrom",
										"nodeType": "VariableDeclaration",
										"scope": 800,
										"src": "10370:17:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 655,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "10370:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 658,
										"name": "regionTo",
										"nodeType": "VariableDeclaration",
										"scope": 800,
										"src": "10398:15:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 657,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "10398:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 660,
										"name": "moveSoldierCount",
										"nodeType": "VariableDeclaration",
										"scope": 800,
										"src": "10424:23:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 659,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "10424:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "10310:143:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 670,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "10563:0:2"
							},
							"scope": 4288,
							"src": "10289:1619:2",
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 951,
								"nodeType": "Block",
								"src": "12478:1644:2",
								"statements": [
									{
										"assignments": [
											816
										],
										"declarations": [
											{
												"constant": false,
												"id": 816,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 952,
												"src": "12488:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 815,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "12488:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 820,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 817,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "12512:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 819,
											"indexExpression": {
												"argumentTypes": null,
												"id": 818,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 802,
												"src": "12526:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "12512:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "12488:45:2"
									},
									{
										"assignments": [
											822
										],
										"declarations": [
											{
												"constant": false,
												"id": 822,
												"name": "undeployedSoldierCount",
												"nodeType": "VariableDeclaration",
												"scope": 952,
												"src": "12543:29:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 821,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "12543:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 829,
										"initialValue": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 824,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 816,
														"src": "12585:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 825,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "undeployedSoldiers",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 226,
													"src": "12585:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 826,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 816,
														"src": "12610:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 827,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "turnTeamId",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 214,
													"src": "12610:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												],
												"id": 823,
												"name": "getData32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4095,
												"src": "12575:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
													"typeString": "function (uint256,uint32) pure returns (uint32)"
												}
											},
											"id": 828,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "12575:51:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "12543:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 833,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 831,
														"name": "undeployedSoldierCount",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 822,
														"src": "12645:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": ">=",
													"rightExpression": {
														"argumentTypes": null,
														"id": 832,
														"name": "deploySoldierCount",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 808,
														"src": "12671:18:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "12645:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "4d75737420686176652073756666696369656e7420736f6c64696572732e",
													"id": 834,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "12691:32:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_0a6a6a35e9a076634cdab1c6b7d95a290e79ba710b2a21232b485da02b0fe1e8",
														"typeString": "literal_string \"Must have sufficient soldiers.\""
													},
													"value": "Must have sufficient soldiers."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_0a6a6a35e9a076634cdab1c6b7d95a290e79ba710b2a21232b485da02b0fe1e8",
														"typeString": "literal_string \"Must have sufficient soldiers.\""
													}
												],
												"id": 830,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "12637:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 835,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "12637:87:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 836,
										"nodeType": "ExpressionStatement",
										"src": "12637:87:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 862,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"id": 854,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"components": [
																{
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	},
																	"id": 844,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"id": 840,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"id": 838,
																			"name": "regionDeploy",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 806,
																			"src": "12756:12:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "==",
																		"rightExpression": {
																			"argumentTypes": null,
																			"id": 839,
																			"name": "NO_REGION",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 126,
																			"src": "12772:9:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"src": "12756:25:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "&&",
																	"rightExpression": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"id": 843,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"id": 841,
																			"name": "deploySoldierCount",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 808,
																			"src": "12785:18:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "==",
																		"rightExpression": {
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 842,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "12807:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		},
																		"src": "12785:23:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	},
																	"src": "12756:52:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																}
															],
															"id": 845,
															"isConstant": false,
															"isInlineArray": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "TupleExpression",
															"src": "12755:54:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "||",
														"rightExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 853,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 847,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 816,
																			"src": "12835:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 848,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "regionOwners",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 228,
																		"src": "12835:17:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"id": 849,
																		"name": "regionDeploy",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 806,
																		"src": "12854:12:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 846,
																	"name": "getData8",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4158,
																	"src": "12826:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																		"typeString": "function (uint256,uint32) pure returns (uint32)"
																	}
																},
																"id": 850,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "12826:41:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "==",
															"rightExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 851,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 816,
																	"src": "12871:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 852,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "turnTeamId",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 214,
																"src": "12871:15:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "12826:60:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"src": "12755:131:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "||",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 861,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 856,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 816,
																		"src": "12912:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 857,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "regionOwners",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 228,
																	"src": "12912:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 858,
																	"name": "regionDeploy",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 806,
																	"src": "12931:12:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 855,
																"name": "getData8",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4158,
																"src": "12903:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 859,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "12903:41:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"id": 860,
															"name": "NOT_OWNED",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 123,
															"src": "12948:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "12903:54:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "12755:202:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "596f752063616e206f6e6c79206465706c6f7920736f6c646965727320746f206120726567696f6e20796f75206f776e2c206f72207468617420697320756e6f636375706965642e",
													"id": 863,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "12971:74:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_c0de4a8692b68d0ec3870e60f28f1b34ccc9dab26c018a4f9d418a52d18b2872",
														"typeString": "literal_string \"You can only deploy soldiers to a region you own, or that is unoccupied.\""
													},
													"value": "You can only deploy soldiers to a region you own, or that is unoccupied."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_c0de4a8692b68d0ec3870e60f28f1b34ccc9dab26c018a4f9d418a52d18b2872",
														"typeString": "literal_string \"You can only deploy soldiers to a region you own, or that is unoccupied.\""
													}
												],
												"id": 837,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "12734:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 864,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "12734:321:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 865,
										"nodeType": "ExpressionStatement",
										"src": "12734:321:2"
									},
									{
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 869,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 866,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 816,
													"src": "13152:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 867,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "actionCount",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 234,
												"src": "13152:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": ">",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 868,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "13171:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"src": "13152:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": null,
										"id": 875,
										"nodeType": "IfStatement",
										"src": "13148:80:2",
										"trueBody": {
											"id": 874,
											"nodeType": "Block",
											"src": "13174:54:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"id": 871,
																"name": "gameId",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 802,
																"src": "13210:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															],
															"id": 870,
															"name": "executePendingActions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1847,
															"src": "13188:21:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$returns$__$",
																"typeString": "function (uint256)"
															}
														},
														"id": 872,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "13188:29:2",
														"typeDescriptions": {
															"typeIdentifier": "t_tuple$__$",
															"typeString": "tuple()"
														}
													},
													"id": 873,
													"nodeType": "ExpressionStatement",
													"src": "13188:29:2"
												}
											]
										}
									},
									{
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 878,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 876,
												"name": "regionDeploy",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 806,
												"src": "13297:12:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "!=",
											"rightExpression": {
												"argumentTypes": null,
												"id": 877,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "13313:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "13297:25:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": null,
										"id": 921,
										"nodeType": "IfStatement",
										"src": "13293:500:2",
										"trueBody": {
											"id": 920,
											"nodeType": "Block",
											"src": "13324:469:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"id": 889,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 879,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 816,
																"src": "13338:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 881,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"memberName": "regionOwners",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 228,
															"src": "13338:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 883,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 816,
																		"src": "13367:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 884,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "regionOwners",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 228,
																	"src": "13367:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 885,
																	"name": "regionDeploy",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 806,
																	"src": "13386:12:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 886,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 816,
																		"src": "13400:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 887,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "turnTeamId",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 214,
																	"src": "13400:15:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 882,
																"name": "setData8",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4203,
																"src": "13358:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
																	"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
																}
															},
															"id": 888,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "13358:58:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"src": "13338:78:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"id": 890,
													"nodeType": "ExpressionStatement",
													"src": "13338:78:2"
												},
												{
													"expression": {
														"argumentTypes": null,
														"id": 904,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 891,
																"name": "game",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 816,
																"src": "13430:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																	"typeString": "struct WorldGame.GameData storage pointer"
																}
															},
															"id": 893,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"memberName": "undeployedSoldiers",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 226,
															"src": "13430:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 895,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 816,
																		"src": "13483:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 896,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "undeployedSoldiers",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 226,
																	"src": "13483:23:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 897,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 816,
																		"src": "13525:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 898,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "turnTeamId",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 214,
																	"src": "13525:15:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"id": 900,
																			"name": "undeployedSoldierCount",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 822,
																			"src": "13567:22:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		{
																			"argumentTypes": null,
																			"id": 901,
																			"name": "deploySoldierCount",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 808,
																			"src": "13591:18:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			},
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		],
																		"id": 899,
																		"name": "subSafe",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 4228,
																		"src": "13559:7:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																			"typeString": "function (uint32,uint32) pure returns (uint32)"
																		}
																	},
																	"id": 902,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"kind": "functionCall",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "13559:51:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 894,
																"name": "setData32",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4133,
																"src": "13456:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
																	"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
																}
															},
															"id": 903,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "13456:168:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"src": "13430:194:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"id": 905,
													"nodeType": "ExpressionStatement",
													"src": "13430:194:2"
												},
												{
													"expression": {
														"argumentTypes": null,
														"id": 918,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 906,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 816,
																	"src": "13638:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 909,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "regionSoldiers",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 232,
																"src": "13638:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$25_storage",
																	"typeString": "uint32[25] storage ref"
																}
															},
															"id": 910,
															"indexExpression": {
																"argumentTypes": null,
																"id": 908,
																"name": "regionDeploy",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 806,
																"src": "13658:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"nodeType": "IndexAccess",
															"src": "13638:33:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 912,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 816,
																			"src": "13699:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 913,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "regionSoldiers",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 232,
																		"src": "13699:19:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_uint32_$25_storage",
																			"typeString": "uint32[25] storage ref"
																		}
																	},
																	"id": 915,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 914,
																		"name": "regionDeploy",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 806,
																		"src": "13719:12:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "13699:33:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 916,
																	"name": "deploySoldierCount",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 808,
																	"src": "13750:18:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 911,
																"name": "addSafe",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4253,
																"src": "13674:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint32,uint32) pure returns (uint32)"
																}
															},
															"id": 917,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "13674:108:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "13638:144:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 919,
													"nodeType": "ExpressionStatement",
													"src": "13638:144:2"
												}
											]
										}
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 928,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 922,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 816,
													"src": "13845:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 924,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"memberName": "turnTeamId",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 214,
												"src": "13845:15:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"id": 926,
														"name": "gameId",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 802,
														"src": "13881:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													],
													"id": 925,
													"name": "getNextTurnTeamId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1948,
													"src": "13863:17:2",
													"typeDescriptions": {
														"typeIdentifier": "t_function_internal_view$_t_uint256_$returns$_t_uint32_$",
														"typeString": "function (uint256) view returns (uint32)"
													}
												},
												"id": 927,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "13863:25:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "13845:43:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 929,
										"nodeType": "ExpressionStatement",
										"src": "13845:43:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 937,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 930,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 816,
													"src": "13898:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 932,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"memberName": "turnNum",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 216,
												"src": "13898:12:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 934,
															"name": "block",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4362,
															"src": "13920:5:2",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_block",
																"typeString": "block"
															}
														},
														"id": 935,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "number",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "13920:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													],
													"id": 933,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "13913:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 936,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "13913:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "13898:35:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 938,
										"nodeType": "ExpressionStatement",
										"src": "13898:35:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 940,
													"name": "gameId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 802,
													"src": "14045:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"id": 939,
												"name": "giveRegionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2210,
												"src": "14027:17:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$returns$__$",
													"typeString": "function (uint256)"
												}
											},
											"id": 941,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "14027:25:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 942,
										"nodeType": "ExpressionStatement",
										"src": "14027:25:2"
									},
									{
										"eventCall": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 944,
													"name": "gameId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 802,
													"src": "14077:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 945,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 816,
														"src": "14085:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 946,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "turnNum",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 216,
													"src": "14085:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 947,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 816,
														"src": "14099:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 948,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "turnTeamId",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 214,
													"src": "14099:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												],
												"id": 943,
												"name": "NextTurn",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 261,
												"src": "14068:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_event_nonpayable$_t_uint256_$_t_uint32_$_t_uint32_$returns$__$",
													"typeString": "function (uint256,uint32,uint32)"
												}
											},
											"id": 949,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "14068:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 950,
										"nodeType": "EmitStatement",
										"src": "14063:52:2"
									}
								]
							},
							"documentation": "@notice Execute actions that have been queued for this turn.\n @param gameId Id of game \n @param turnNum Turn deploySoldiersAndEndTurn should occur during \n @param regionDeploy Region where you'd like to deploy soldiers to\n @param deploySoldierCount Number of soldiers you'd like to deploy at end of your turn",
							"id": 952,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": false,
							"modifiers": [
								{
									"arguments": [
										{
											"argumentTypes": null,
											"id": 811,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 802,
											"src": "12456:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										{
											"argumentTypes": null,
											"id": 812,
											"name": "turnNum",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 804,
											"src": "12464:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										}
									],
									"id": 813,
									"modifierName": {
										"argumentTypes": null,
										"id": 810,
										"name": "onlyIfPlayersTurn",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 301,
										"src": "12438:17:2",
										"typeDescriptions": {
											"typeIdentifier": "t_modifier$_t_uint256_$_t_uint32_$",
											"typeString": "modifier (uint256,uint32)"
										}
									},
									"nodeType": "ModifierInvocation",
									"src": "12438:34:2"
								}
							],
							"name": "deploySoldiersAndEndTurn",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 809,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 802,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 952,
										"src": "12302:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 801,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "12302:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 804,
										"name": "turnNum",
										"nodeType": "VariableDeclaration",
										"scope": 952,
										"src": "12327:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 803,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "12327:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 806,
										"name": "regionDeploy",
										"nodeType": "VariableDeclaration",
										"scope": 952,
										"src": "12352:19:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 805,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "12352:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 808,
										"name": "deploySoldierCount",
										"nodeType": "VariableDeclaration",
										"scope": 952,
										"src": "12382:25:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 807,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "12382:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "12292:121:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 814,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "12478:0:2"
							},
							"scope": 4288,
							"src": "12259:1863:2",
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 1028,
								"nodeType": "Block",
								"src": "14421:740:2",
								"statements": [
									{
										"assignments": [
											963
										],
										"declarations": [
											{
												"constant": false,
												"id": 963,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 1029,
												"src": "14431:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 962,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "14431:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 967,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 964,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "14455:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 966,
											"indexExpression": {
												"argumentTypes": null,
												"id": 965,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 954,
												"src": "14469:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "14455:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "14431:45:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 972,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 969,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 963,
															"src": "14494:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 970,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "turnNum",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 216,
														"src": "14494:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"id": 971,
														"name": "turnNum",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 956,
														"src": "14510:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "14494:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "57726f6e67207475726e206e756d6265722e",
													"id": 973,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "14519:20:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_20e508097488cdf7adfa5bc3dc0f21225c46901f081af1aafe3b036f12f6c46b",
														"typeString": "literal_string \"Wrong turn number.\""
													},
													"value": "Wrong turn number."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_20e508097488cdf7adfa5bc3dc0f21225c46901f081af1aafe3b036f12f6c46b",
														"typeString": "literal_string \"Wrong turn number.\""
													}
												],
												"id": 968,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "14486:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 974,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "14486:54:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 975,
										"nodeType": "ExpressionStatement",
										"src": "14486:54:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 985,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 977,
															"name": "block",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4362,
															"src": "14558:5:2",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_block",
																"typeString": "block"
															}
														},
														"id": 978,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "number",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "14558:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": ">",
													"rightExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 980,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 963,
																	"src": "14581:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 981,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "turnNum",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 216,
																"src": "14581:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 982,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 963,
																	"src": "14595:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 983,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "maxBlocksPerTurn",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 218,
																"src": "14595:21:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 979,
															"name": "addSafe",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4253,
															"src": "14573:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint32,uint32) pure returns (uint32)"
															}
														},
														"id": 984,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "14573:44:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "14558:59:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "506c61796572207374696c6c206861732074696d6520746f2066696e697368207475726e2e",
													"id": 986,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "14619:39:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_20d46139a085b6032013f1ca843b0a034e4a9de1b7ad1a9807e3295f560733f3",
														"typeString": "literal_string \"Player still has time to finish turn.\""
													},
													"value": "Player still has time to finish turn."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_20d46139a085b6032013f1ca843b0a034e4a9de1b7ad1a9807e3295f560733f3",
														"typeString": "literal_string \"Player still has time to finish turn.\""
													}
												],
												"id": 976,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "14550:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 987,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "14550:109:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 988,
										"nodeType": "ExpressionStatement",
										"src": "14550:109:2"
									},
									{
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 992,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 989,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 963,
													"src": "14756:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 990,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "actionCount",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 234,
												"src": "14756:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": ">",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 991,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "14775:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"src": "14756:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": null,
										"id": 998,
										"nodeType": "IfStatement",
										"src": "14752:80:2",
										"trueBody": {
											"id": 997,
											"nodeType": "Block",
											"src": "14778:54:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"id": 994,
																"name": "gameId",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 954,
																"src": "14814:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															],
															"id": 993,
															"name": "executePendingActions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1847,
															"src": "14792:21:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$returns$__$",
																"typeString": "function (uint256)"
															}
														},
														"id": 995,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "14792:29:2",
														"typeDescriptions": {
															"typeIdentifier": "t_tuple$__$",
															"typeString": "tuple()"
														}
													},
													"id": 996,
													"nodeType": "ExpressionStatement",
													"src": "14792:29:2"
												}
											]
										}
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 1005,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 999,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 963,
													"src": "14884:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1001,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"memberName": "turnTeamId",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 214,
												"src": "14884:15:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"id": 1003,
														"name": "gameId",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 954,
														"src": "14920:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													],
													"id": 1002,
													"name": "getNextTurnTeamId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1948,
													"src": "14902:17:2",
													"typeDescriptions": {
														"typeIdentifier": "t_function_internal_view$_t_uint256_$returns$_t_uint32_$",
														"typeString": "function (uint256) view returns (uint32)"
													}
												},
												"id": 1004,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "14902:25:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "14884:43:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1006,
										"nodeType": "ExpressionStatement",
										"src": "14884:43:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 1014,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1007,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 963,
													"src": "14937:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1009,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"memberName": "turnNum",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 216,
												"src": "14937:12:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 1011,
															"name": "block",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4362,
															"src": "14959:5:2",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_block",
																"typeString": "block"
															}
														},
														"id": 1012,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "number",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "14959:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													],
													"id": 1010,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "14952:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 1013,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "14952:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "14937:35:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1015,
										"nodeType": "ExpressionStatement",
										"src": "14937:35:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 1017,
													"name": "gameId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 954,
													"src": "15084:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"id": 1016,
												"name": "giveRegionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2210,
												"src": "15066:17:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$returns$__$",
													"typeString": "function (uint256)"
												}
											},
											"id": 1018,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "15066:25:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 1019,
										"nodeType": "ExpressionStatement",
										"src": "15066:25:2"
									},
									{
										"eventCall": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 1021,
													"name": "gameId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 954,
													"src": "15116:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1022,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 963,
														"src": "15124:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 1023,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "turnNum",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 216,
													"src": "15124:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1024,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 963,
														"src": "15138:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 1025,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "turnTeamId",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 214,
													"src": "15138:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												],
												"id": 1020,
												"name": "NextTurn",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 261,
												"src": "15107:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_event_nonpayable$_t_uint256_$_t_uint32_$_t_uint32_$returns$__$",
													"typeString": "function (uint256,uint32,uint32)"
												}
											},
											"id": 1026,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "15107:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 1027,
										"nodeType": "EmitStatement",
										"src": "15102:52:2"
									}
								]
							},
							"documentation": "@notice Force turn to end for player who's taking too long.\n @param gameId Id of game \n @param turnNum Turn forceEndOfTurn should occur during ",
							"id": 1029,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": false,
							"modifiers": [
								{
									"arguments": [
										{
											"argumentTypes": null,
											"id": 959,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 954,
											"src": "14409:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										}
									],
									"id": 960,
									"modifierName": {
										"argumentTypes": null,
										"id": 958,
										"name": "onlyPlayers",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 380,
										"src": "14397:11:2",
										"typeDescriptions": {
											"typeIdentifier": "t_modifier$_t_uint256_$",
											"typeString": "modifier (uint256)"
										}
									},
									"nodeType": "ModifierInvocation",
									"src": "14397:19:2"
								}
							],
							"name": "forceEndOfTurn",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 957,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 954,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 1029,
										"src": "14327:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 953,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "14327:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 956,
										"name": "turnNum",
										"nodeType": "VariableDeclaration",
										"scope": 1029,
										"src": "14352:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 955,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "14352:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "14317:55:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 961,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "14421:0:2"
							},
							"scope": 4288,
							"src": "14294:867:2",
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 1087,
								"nodeType": "Block",
								"src": "15406:402:2",
								"statements": [
									{
										"assignments": [
											1040
										],
										"declarations": [
											{
												"constant": false,
												"id": 1040,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 1088,
												"src": "15416:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 1039,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "15416:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1044,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1041,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "15440:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 1043,
											"indexExpression": {
												"argumentTypes": null,
												"id": 1042,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1031,
												"src": "15454:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "15440:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "15416:45:2"
									},
									{
										"assignments": [
											1046
										],
										"declarations": [
											{
												"constant": false,
												"id": 1046,
												"name": "isWinner",
												"nodeType": "VariableDeclaration",
												"scope": 1088,
												"src": "15480:13:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"typeName": {
													"id": 1045,
													"name": "bool",
													"nodeType": "ElementaryTypeName",
													"src": "15480:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1048,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "74727565",
											"id": 1047,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "15496:4:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "true"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "15480:20:2"
									},
									{
										"body": {
											"id": 1072,
											"nodeType": "Block",
											"src": "15552:119:2",
											"statements": [
												{
													"condition": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 1065,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1060,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1040,
																		"src": "15579:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1061,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "regionOwners",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 228,
																	"src": "15579:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1062,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1050,
																	"src": "15598:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1059,
																"name": "getData8",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4158,
																"src": "15570:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1063,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "15570:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "!=",
														"rightExpression": {
															"argumentTypes": null,
															"id": 1064,
															"name": "teamId",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1033,
															"src": "15604:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "15570:40:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"falseBody": null,
													"id": 1071,
													"nodeType": "IfStatement",
													"src": "15566:95:2",
													"trueBody": {
														"id": 1070,
														"nodeType": "Block",
														"src": "15612:49:2",
														"statements": [
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 1068,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"id": 1066,
																		"name": "isWinner",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1046,
																		"src": "15630:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"hexValue": "66616c7365",
																		"id": 1067,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "bool",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "15641:5:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		},
																		"value": "false"
																	},
																	"src": "15630:16:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"id": 1069,
																"nodeType": "ExpressionStatement",
																"src": "15630:16:2"
															}
														]
													}
												}
											]
										},
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 1055,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 1053,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1050,
												"src": "15529:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "<",
											"rightExpression": {
												"argumentTypes": null,
												"id": 1054,
												"name": "REGION_COUNT",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 129,
												"src": "15533:12:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "15529:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"id": 1073,
										"initializationExpression": {
											"assignments": [
												1050
											],
											"declarations": [
												{
													"constant": false,
													"id": 1050,
													"name": "i",
													"nodeType": "VariableDeclaration",
													"scope": 1088,
													"src": "15515:8:2",
													"stateVariable": false,
													"storageLocation": "default",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"typeName": {
														"id": 1049,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "15515:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"value": null,
													"visibility": "internal"
												}
											],
											"id": 1052,
											"initialValue": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1051,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "15526:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"nodeType": "VariableDeclarationStatement",
											"src": "15515:12:2"
										},
										"loopExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 1057,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "UnaryOperation",
												"operator": "++",
												"prefix": false,
												"src": "15547:3:2",
												"subExpression": {
													"argumentTypes": null,
													"id": 1056,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1050,
													"src": "15547:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1058,
											"nodeType": "ExpressionStatement",
											"src": "15547:3:2"
										},
										"nodeType": "ForStatement",
										"src": "15510:161:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 1075,
													"name": "isWinner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1046,
													"src": "15689:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "576520646f6e2774206861766520612077696e6e65722e",
													"id": 1076,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "15699:25:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_7ae151848de1ba529538a91ee6366416b7113724579a5d4c2e03650e29d43bf0",
														"typeString": "literal_string \"We don't have a winner.\""
													},
													"value": "We don't have a winner."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_7ae151848de1ba529538a91ee6366416b7113724579a5d4c2e03650e29d43bf0",
														"typeString": "literal_string \"We don't have a winner.\""
													}
												],
												"id": 1074,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "15681:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 1077,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "15681:44:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 1078,
										"nodeType": "ExpressionStatement",
										"src": "15681:44:2"
									},
									{
										"condition": {
											"argumentTypes": null,
											"id": 1079,
											"name": "isWinner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1046,
											"src": "15740:8:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": null,
										"id": 1086,
										"nodeType": "IfStatement",
										"src": "15736:66:2",
										"trueBody": {
											"id": 1085,
											"nodeType": "Block",
											"src": "15750:52:2",
											"statements": [
												{
													"eventCall": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"id": 1081,
																"name": "gameId",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1031,
																"src": "15776:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1082,
																"name": "teamId",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1033,
																"src": "15784:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1080,
															"name": "Winner",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 267,
															"src": "15769:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_event_nonpayable$_t_uint256_$_t_uint32_$returns$__$",
																"typeString": "function (uint256,uint32)"
															}
														},
														"id": 1083,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "15769:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_tuple$__$",
															"typeString": "tuple()"
														}
													},
													"id": 1084,
													"nodeType": "EmitStatement",
													"src": "15764:27:2"
												}
											]
										}
									}
								]
							},
							"documentation": "@notice Declare victory for a team.\n @param gameId Id of game\n @param teamId Team you'd like to declare as winner",
							"id": 1088,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": false,
							"modifiers": [
								{
									"arguments": [
										{
											"argumentTypes": null,
											"id": 1036,
											"name": "gameId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1031,
											"src": "15394:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										}
									],
									"id": 1037,
									"modifierName": {
										"argumentTypes": null,
										"id": 1035,
										"name": "onlyPlayers",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 380,
										"src": "15382:11:2",
										"typeDescriptions": {
											"typeIdentifier": "t_modifier$_t_uint256_$",
											"typeString": "modifier (uint256)"
										}
									},
									"nodeType": "ModifierInvocation",
									"src": "15382:19:2"
								}
							],
							"name": "declareWinner",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1034,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1031,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 1088,
										"src": "15326:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 1030,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "15326:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1033,
										"name": "teamId",
										"nodeType": "VariableDeclaration",
										"scope": 1088,
										"src": "15342:13:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1032,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "15342:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "15325:31:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1038,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "15406:0:2"
							},
							"scope": 4288,
							"src": "15303:505:2",
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 1122,
								"nodeType": "Block",
								"src": "16071:261:2",
								"statements": [
									{
										"assignments": [
											1096
										],
										"declarations": [
											{
												"constant": false,
												"id": 1096,
												"name": "cachedBlockHash",
												"nodeType": "VariableDeclaration",
												"scope": 1123,
												"src": "16081:22:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 1095,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "16081:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1100,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1097,
												"name": "blockHash32Map",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 173,
												"src": "16106:14:2",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_uint32_$_t_uint32_$",
													"typeString": "mapping(uint32 => uint32)"
												}
											},
											"id": 1099,
											"indexExpression": {
												"argumentTypes": null,
												"id": 1098,
												"name": "blockNum",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1090,
												"src": "16121:8:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "16106:24:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "16081:49:2"
									},
									{
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 1103,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 1101,
												"name": "cachedBlockHash",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1096,
												"src": "16145:15:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "==",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1102,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "16164:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"src": "16145:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": null,
										"id": 1119,
										"nodeType": "IfStatement",
										"src": "16141:152:2",
										"trueBody": {
											"id": 1118,
											"nodeType": "Block",
											"src": "16167:126:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"id": 1110,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"id": 1104,
															"name": "cachedBlockHash",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1096,
															"src": "16181:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"id": 1107,
																			"name": "blockNum",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1090,
																			"src": "16216:8:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		],
																		"id": 1106,
																		"name": "blockhash",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 4363,
																		"src": "16206:9:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_function_blockhash_view$_t_uint256_$returns$_t_bytes32_$",
																			"typeString": "function (uint256) view returns (bytes32)"
																		}
																	},
																	"id": 1108,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"kind": "functionCall",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "16206:19:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bytes32",
																		"typeString": "bytes32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_bytes32",
																		"typeString": "bytes32"
																	}
																],
																"id": 1105,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"nodeType": "ElementaryTypeNameExpression",
																"src": "16199:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_uint32_$",
																	"typeString": "type(uint32)"
																},
																"typeName": "uint32"
															},
															"id": 1109,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "typeConversion",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "16199:27:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "16181:45:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1111,
													"nodeType": "ExpressionStatement",
													"src": "16181:45:2"
												},
												{
													"expression": {
														"argumentTypes": null,
														"id": 1116,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 1112,
																"name": "blockHash32Map",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 173,
																"src": "16240:14:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_mapping$_t_uint32_$_t_uint32_$",
																	"typeString": "mapping(uint32 => uint32)"
																}
															},
															"id": 1114,
															"indexExpression": {
																"argumentTypes": null,
																"id": 1113,
																"name": "blockNum",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1090,
																"src": "16255:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"nodeType": "IndexAccess",
															"src": "16240:24:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"id": 1115,
															"name": "cachedBlockHash",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1096,
															"src": "16267:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "16240:42:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1117,
													"nodeType": "ExpressionStatement",
													"src": "16240:42:2"
												}
											]
										}
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 1120,
											"name": "cachedBlockHash",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1096,
											"src": "16310:15:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"functionReturnParameters": 1094,
										"id": 1121,
										"nodeType": "Return",
										"src": "16303:22:2"
									}
								]
							},
							"documentation": "@notice Caches the hash for a specific block in a map.  Only uses last 32 bits.\n @param blockNum Block number\n @return Last 32 bits of block hash, or 0 if not available",
							"id": 1123,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": false,
							"modifiers": [],
							"name": "cacheBlockHash32",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1091,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1090,
										"name": "blockNum",
										"nodeType": "VariableDeclaration",
										"scope": 1123,
										"src": "16031:15:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1089,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "16031:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "16030:17:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1094,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1093,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1123,
										"src": "16063:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1092,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "16063:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "16062:8:2"
							},
							"scope": 4288,
							"src": "16005:327:2",
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 1151,
								"nodeType": "Block",
								"src": "16583:189:2",
								"statements": [
									{
										"assignments": [
											1131
										],
										"declarations": [
											{
												"constant": false,
												"id": 1131,
												"name": "blockHash32",
												"nodeType": "VariableDeclaration",
												"scope": 1152,
												"src": "16593:18:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 1130,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "16593:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1137,
										"initialValue": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"id": 1134,
															"name": "blockNum",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1125,
															"src": "16631:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														],
														"id": 1133,
														"name": "blockhash",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4363,
														"src": "16621:9:2",
														"typeDescriptions": {
															"typeIdentifier": "t_function_blockhash_view$_t_uint256_$returns$_t_bytes32_$",
															"typeString": "function (uint256) view returns (bytes32)"
														}
													},
													"id": 1135,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "16621:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bytes32",
														"typeString": "bytes32"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bytes32",
														"typeString": "bytes32"
													}
												],
												"id": 1132,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "16614:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 1136,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "16614:27:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "16593:48:2"
									},
									{
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 1140,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 1138,
												"name": "blockHash32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1131,
												"src": "16656:11:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "==",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1139,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "16671:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"src": "16656:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": null,
										"id": 1148,
										"nodeType": "IfStatement",
										"src": "16652:85:2",
										"trueBody": {
											"id": 1147,
											"nodeType": "Block",
											"src": "16674:63:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"id": 1145,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"id": 1141,
															"name": "blockHash32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1131,
															"src": "16688:11:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 1142,
																"name": "blockHash32Map",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 173,
																"src": "16702:14:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_mapping$_t_uint32_$_t_uint32_$",
																	"typeString": "mapping(uint32 => uint32)"
																}
															},
															"id": 1144,
															"indexExpression": {
																"argumentTypes": null,
																"id": 1143,
																"name": "blockNum",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1125,
																"src": "16717:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "16702:24:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "16688:38:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1146,
													"nodeType": "ExpressionStatement",
													"src": "16688:38:2"
												}
											]
										}
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 1149,
											"name": "blockHash32",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1131,
											"src": "16754:11:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"functionReturnParameters": 1129,
										"id": 1150,
										"nodeType": "Return",
										"src": "16747:18:2"
									}
								]
							},
							"documentation": "@notice Get hash for a specific block.  Only uses last 32 bits.\n @param blockNum Block number\n @return Last 32 bits of block hash, or 0 if not available",
							"id": 1152,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "readBlockHash32",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1126,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1125,
										"name": "blockNum",
										"nodeType": "VariableDeclaration",
										"scope": 1152,
										"src": "16538:15:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1124,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "16538:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "16537:17:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1129,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1128,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1152,
										"src": "16575:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1127,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "16575:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "16574:8:2"
							},
							"scope": 4288,
							"src": "16513:259:2",
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 1160,
								"nodeType": "Block",
								"src": "16902:44:2",
								"statements": [
									{
										"expression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 1157,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "16919:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 1158,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "length",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "16919:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"functionReturnParameters": 1156,
										"id": 1159,
										"nodeType": "Return",
										"src": "16912:27:2"
									}
								]
							},
							"documentation": "@notice Returns total number of games that have been created.",
							"id": 1161,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "numberOfGames",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1153,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "16870:2:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1156,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1155,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1161,
										"src": "16893:7:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 1154,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "16893:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "16892:9:2"
							},
							"scope": 4288,
							"src": "16848:98:2",
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 1286,
								"nodeType": "Block",
								"src": "17332:1119:2",
								"statements": [
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1178,
												"name": "gameIdList",
												"nodeType": "VariableDeclaration",
												"scope": 1287,
												"src": "17342:29:2",
												"stateVariable": false,
												"storageLocation": "memory",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint256_$10_memory_ptr",
													"typeString": "uint256[10]"
												},
												"typeName": {
													"baseType": {
														"id": 1176,
														"name": "uint256",
														"nodeType": "ElementaryTypeName",
														"src": "17342:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"id": 1177,
													"length": {
														"argumentTypes": null,
														"hexValue": "3130",
														"id": 1175,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "17350:2:2",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": null,
															"typeString": null
														},
														"value": "10"
													},
													"nodeType": "ArrayTypeName",
													"src": "17342:11:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint256_$10_storage_ptr",
														"typeString": "uint256[10]"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1179,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "17342:29:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1181,
												"name": "gameIdCount",
												"nodeType": "VariableDeclaration",
												"scope": 1287,
												"src": "17381:18:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 1180,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "17381:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1182,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "17381:18:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1184,
												"name": "gameId",
												"nodeType": "VariableDeclaration",
												"scope": 1287,
												"src": "17409:14:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"typeName": {
													"id": 1183,
													"name": "uint256",
													"nodeType": "ElementaryTypeName",
													"src": "17409:7:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1185,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "17409:14:2"
									},
									{
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"id": 1189,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1186,
													"name": "gameDataArray",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 186,
													"src": "17437:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
														"typeString": "struct WorldGame.GameData storage ref[] storage ref"
													}
												},
												"id": 1187,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "length",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "17437:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": ">",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1188,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "17460:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"src": "17437:24:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": null,
										"id": 1280,
										"nodeType": "IfStatement",
										"src": "17433:961:2",
										"trueBody": {
											"id": 1279,
											"nodeType": "Block",
											"src": "17463:931:2",
											"statements": [
												{
													"assignments": [
														1191
													],
													"declarations": [
														{
															"constant": false,
															"id": 1191,
															"name": "startPosition",
															"nodeType": "VariableDeclaration",
															"scope": 1287,
															"src": "17553:21:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"typeName": {
																"id": 1190,
																"name": "uint256",
																"nodeType": "ElementaryTypeName",
																"src": "17553:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 1196,
													"initialValue": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 1195,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1192,
																"name": "gameDataArray",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 186,
																"src": "17577:13:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
																	"typeString": "struct WorldGame.GameData storage ref[] storage ref"
																}
															},
															"id": 1193,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "length",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "17577:20:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "-",
														"rightExpression": {
															"argumentTypes": null,
															"hexValue": "31",
															"id": 1194,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "17600:1:2",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_1_by_1",
																"typeString": "int_const 1"
															},
															"value": "1"
														},
														"src": "17577:24:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "17553:48:2"
												},
												{
													"condition": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"id": 1203,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"id": 1199,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"id": 1197,
																"name": "offset",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1163,
																"src": "17619:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": ">",
															"rightExpression": {
																"argumentTypes": null,
																"hexValue": "30",
																"id": 1198,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "17628:1:2",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_0_by_1",
																	"typeString": "int_const 0"
																},
																"value": "0"
															},
															"src": "17619:10:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "&&",
														"rightExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"id": 1202,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"id": 1200,
																"name": "offset",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1163,
																"src": "17633:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "<",
															"rightExpression": {
																"argumentTypes": null,
																"id": 1201,
																"name": "startPosition",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1191,
																"src": "17642:13:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"src": "17633:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"src": "17619:36:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"falseBody": null,
													"id": 1209,
													"nodeType": "IfStatement",
													"src": "17615:97:2",
													"trueBody": {
														"id": 1208,
														"nodeType": "Block",
														"src": "17657:55:2",
														"statements": [
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 1206,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"id": 1204,
																		"name": "startPosition",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1191,
																		"src": "17675:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"id": 1205,
																		"name": "offset",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1163,
																		"src": "17691:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"src": "17675:22:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"id": 1207,
																"nodeType": "ExpressionStatement",
																"src": "17675:22:2"
															}
														]
													}
												},
												{
													"body": {
														"id": 1277,
														"nodeType": "Block",
														"src": "17867:517:2",
														"statements": [
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 1226,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"id": 1222,
																		"name": "gameId",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1184,
																		"src": "17885:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		"id": 1225,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"id": 1223,
																			"name": "i",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1211,
																			"src": "17894:1:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint256",
																				"typeString": "uint256"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "-",
																		"rightExpression": {
																			"argumentTypes": null,
																			"hexValue": "31",
																			"id": 1224,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "17898:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_1_by_1",
																				"typeString": "int_const 1"
																			},
																			"value": "1"
																		},
																		"src": "17894:5:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"src": "17885:14:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"id": 1227,
																"nodeType": "ExpressionStatement",
																"src": "17885:14:2"
															},
															{
																"assignments": [
																	1229
																],
																"declarations": [
																	{
																		"constant": false,
																		"id": 1229,
																		"name": "game",
																		"nodeType": "VariableDeclaration",
																		"scope": 1287,
																		"src": "17918:21:2",
																		"stateVariable": false,
																		"storageLocation": "storage",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData"
																		},
																		"typeName": {
																			"contractScope": null,
																			"id": 1228,
																			"name": "GameData",
																			"nodeType": "UserDefinedTypeName",
																			"referencedDeclaration": 245,
																			"src": "17918:8:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData"
																			}
																		},
																		"value": null,
																		"visibility": "internal"
																	}
																],
																"id": 1233,
																"initialValue": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 1230,
																		"name": "gameDataArray",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 186,
																		"src": "17942:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
																			"typeString": "struct WorldGame.GameData storage ref[] storage ref"
																		}
																	},
																	"id": 1232,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 1231,
																		"name": "gameId",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1184,
																		"src": "17956:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "17942:21:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage",
																		"typeString": "struct WorldGame.GameData storage ref"
																	}
																},
																"nodeType": "VariableDeclarationStatement",
																"src": "17918:45:2"
															},
															{
																"body": {
																	"id": 1264,
																	"nodeType": "Block",
																	"src": "18027:234:2",
																	"statements": [
																		{
																			"condition": {
																				"argumentTypes": null,
																				"commonType": {
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				},
																				"id": 1251,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": false,
																				"lValueRequested": false,
																				"leftExpression": {
																					"argumentTypes": null,
																					"baseExpression": {
																						"argumentTypes": null,
																						"expression": {
																							"argumentTypes": null,
																							"id": 1245,
																							"name": "game",
																							"nodeType": "Identifier",
																							"overloadedDeclarations": [],
																							"referencedDeclaration": 1229,
																							"src": "18053:4:2",
																							"typeDescriptions": {
																								"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																								"typeString": "struct WorldGame.GameData storage pointer"
																							}
																						},
																						"id": 1246,
																						"isConstant": false,
																						"isLValue": true,
																						"isPure": false,
																						"lValueRequested": false,
																						"memberName": "playerAddresses",
																						"nodeType": "MemberAccess",
																						"referencedDeclaration": 224,
																						"src": "18053:20:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_array$_t_address_$8_storage",
																							"typeString": "address[8] storage ref"
																						}
																					},
																					"id": 1248,
																					"indexExpression": {
																						"argumentTypes": null,
																						"id": 1247,
																						"name": "j",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 1235,
																						"src": "18074:1:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_uint32",
																							"typeString": "uint32"
																						}
																					},
																					"isConstant": false,
																					"isLValue": true,
																					"isPure": false,
																					"lValueRequested": false,
																					"nodeType": "IndexAccess",
																					"src": "18053:23:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_address",
																						"typeString": "address"
																					}
																				},
																				"nodeType": "BinaryOperation",
																				"operator": "==",
																				"rightExpression": {
																					"argumentTypes": null,
																					"expression": {
																						"argumentTypes": null,
																						"id": 1249,
																						"name": "msg",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 4372,
																						"src": "18080:3:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_magic_message",
																							"typeString": "msg"
																						}
																					},
																					"id": 1250,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"lValueRequested": false,
																					"memberName": "sender",
																					"nodeType": "MemberAccess",
																					"referencedDeclaration": null,
																					"src": "18080:10:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_address",
																						"typeString": "address"
																					}
																				},
																				"src": "18053:37:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_bool",
																					"typeString": "bool"
																				}
																			},
																			"falseBody": null,
																			"id": 1263,
																			"nodeType": "IfStatement",
																			"src": "18049:194:2",
																			"trueBody": {
																				"id": 1262,
																				"nodeType": "Block",
																				"src": "18092:151:2",
																				"statements": [
																					{
																						"expression": {
																							"argumentTypes": null,
																							"id": 1256,
																							"isConstant": false,
																							"isLValue": false,
																							"isPure": false,
																							"lValueRequested": false,
																							"leftHandSide": {
																								"argumentTypes": null,
																								"baseExpression": {
																									"argumentTypes": null,
																									"id": 1252,
																									"name": "gameIdList",
																									"nodeType": "Identifier",
																									"overloadedDeclarations": [],
																									"referencedDeclaration": 1178,
																									"src": "18118:10:2",
																									"typeDescriptions": {
																										"typeIdentifier": "t_array$_t_uint256_$10_memory_ptr",
																										"typeString": "uint256[10] memory"
																									}
																								},
																								"id": 1254,
																								"indexExpression": {
																									"argumentTypes": null,
																									"id": 1253,
																									"name": "gameIdCount",
																									"nodeType": "Identifier",
																									"overloadedDeclarations": [],
																									"referencedDeclaration": 1181,
																									"src": "18129:11:2",
																									"typeDescriptions": {
																										"typeIdentifier": "t_uint32",
																										"typeString": "uint32"
																									}
																								},
																								"isConstant": false,
																								"isLValue": true,
																								"isPure": false,
																								"lValueRequested": true,
																								"nodeType": "IndexAccess",
																								"src": "18118:23:2",
																								"typeDescriptions": {
																									"typeIdentifier": "t_uint256",
																									"typeString": "uint256"
																								}
																							},
																							"nodeType": "Assignment",
																							"operator": "=",
																							"rightHandSide": {
																								"argumentTypes": null,
																								"id": 1255,
																								"name": "gameId",
																								"nodeType": "Identifier",
																								"overloadedDeclarations": [],
																								"referencedDeclaration": 1184,
																								"src": "18144:6:2",
																								"typeDescriptions": {
																									"typeIdentifier": "t_uint256",
																									"typeString": "uint256"
																								}
																							},
																							"src": "18118:32:2",
																							"typeDescriptions": {
																								"typeIdentifier": "t_uint256",
																								"typeString": "uint256"
																							}
																						},
																						"id": 1257,
																						"nodeType": "ExpressionStatement",
																						"src": "18118:32:2"
																					},
																					{
																						"expression": {
																							"argumentTypes": null,
																							"id": 1259,
																							"isConstant": false,
																							"isLValue": false,
																							"isPure": false,
																							"lValueRequested": false,
																							"nodeType": "UnaryOperation",
																							"operator": "++",
																							"prefix": false,
																							"src": "18176:13:2",
																							"subExpression": {
																								"argumentTypes": null,
																								"id": 1258,
																								"name": "gameIdCount",
																								"nodeType": "Identifier",
																								"overloadedDeclarations": [],
																								"referencedDeclaration": 1181,
																								"src": "18176:11:2",
																								"typeDescriptions": {
																									"typeIdentifier": "t_uint32",
																									"typeString": "uint32"
																								}
																							},
																							"typeDescriptions": {
																								"typeIdentifier": "t_uint32",
																								"typeString": "uint32"
																							}
																						},
																						"id": 1260,
																						"nodeType": "ExpressionStatement",
																						"src": "18176:13:2"
																					},
																					{
																						"id": 1261,
																						"nodeType": "Break",
																						"src": "18215:5:2"
																					}
																				]
																			}
																		}
																	]
																},
																"condition": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 1241,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 1238,
																		"name": "j",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1235,
																		"src": "18000:1:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "<",
																	"rightExpression": {
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 1239,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1229,
																			"src": "18004:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 1240,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "playerCount",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 220,
																		"src": "18004:16:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "18000:20:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"id": 1265,
																"initializationExpression": {
																	"assignments": [
																		1235
																	],
																	"declarations": [
																		{
																			"constant": false,
																			"id": 1235,
																			"name": "j",
																			"nodeType": "VariableDeclaration",
																			"scope": 1287,
																			"src": "17986:8:2",
																			"stateVariable": false,
																			"storageLocation": "default",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			},
																			"typeName": {
																				"id": 1234,
																				"name": "uint32",
																				"nodeType": "ElementaryTypeName",
																				"src": "17986:6:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			"value": null,
																			"visibility": "internal"
																		}
																	],
																	"id": 1237,
																	"initialValue": {
																		"argumentTypes": null,
																		"hexValue": "30",
																		"id": 1236,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "17997:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		},
																		"value": "0"
																	},
																	"nodeType": "VariableDeclarationStatement",
																	"src": "17986:12:2"
																},
																"loopExpression": {
																	"expression": {
																		"argumentTypes": null,
																		"id": 1243,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"nodeType": "UnaryOperation",
																		"operator": "++",
																		"prefix": false,
																		"src": "18022:3:2",
																		"subExpression": {
																			"argumentTypes": null,
																			"id": 1242,
																			"name": "j",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1235,
																			"src": "18022:1:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"id": 1244,
																	"nodeType": "ExpressionStatement",
																	"src": "18022:3:2"
																},
																"nodeType": "ForStatement",
																"src": "17981:280:2"
															},
															{
																"condition": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	},
																	"id": 1273,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"id": 1268,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"id": 1266,
																			"name": "gameIdCount",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1181,
																			"src": "18283:11:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "==",
																		"rightExpression": {
																			"argumentTypes": null,
																			"hexValue": "3130",
																			"id": 1267,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "18298:2:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_10_by_1",
																				"typeString": "int_const 10"
																			},
																			"value": "10"
																		},
																		"src": "18283:17:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "||",
																	"rightExpression": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		"id": 1272,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"arguments": [],
																			"expression": {
																				"argumentTypes": [],
																				"id": 1269,
																				"name": "gasleft",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 4365,
																				"src": "18304:7:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_function_gasleft_view$__$returns$_t_uint256_$",
																					"typeString": "function () view returns (uint256)"
																				}
																			},
																			"id": 1270,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"kind": "functionCall",
																			"lValueRequested": false,
																			"names": [],
																			"nodeType": "FunctionCall",
																			"src": "18304:9:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint256",
																				"typeString": "uint256"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "<",
																		"rightExpression": {
																			"argumentTypes": null,
																			"hexValue": "313030303030",
																			"id": 1271,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "18316:6:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_100000_by_1",
																				"typeString": "int_const 100000"
																			},
																			"value": "100000"
																		},
																		"src": "18304:18:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	},
																	"src": "18283:39:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"falseBody": null,
																"id": 1276,
																"nodeType": "IfStatement",
																"src": "18279:91:2",
																"trueBody": {
																	"id": 1275,
																	"nodeType": "Block",
																	"src": "18324:46:2",
																	"statements": [
																		{
																			"id": 1274,
																			"nodeType": "Break",
																			"src": "18346:5:2"
																		}
																	]
																}
															}
														]
													},
													"condition": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 1218,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 1216,
															"name": "i",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1211,
															"src": "17855:1:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": ">",
														"rightExpression": {
															"argumentTypes": null,
															"hexValue": "30",
															"id": 1217,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "17859:1:2",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														},
														"src": "17855:5:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"id": 1278,
													"initializationExpression": {
														"assignments": [
															1211
														],
														"declarations": [
															{
																"constant": false,
																"id": 1211,
																"name": "i",
																"nodeType": "VariableDeclaration",
																"scope": 1287,
																"src": "17824:9:2",
																"stateVariable": false,
																"storageLocation": "default",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																"typeName": {
																	"id": 1210,
																	"name": "uint256",
																	"nodeType": "ElementaryTypeName",
																	"src": "17824:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"value": null,
																"visibility": "internal"
															}
														],
														"id": 1215,
														"initialValue": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"id": 1214,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"id": 1212,
																"name": "startPosition",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1191,
																"src": "17836:13:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "+",
															"rightExpression": {
																"argumentTypes": null,
																"hexValue": "31",
																"id": 1213,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "17852:1:2",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_1_by_1",
																	"typeString": "int_const 1"
																},
																"value": "1"
															},
															"src": "17836:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "VariableDeclarationStatement",
														"src": "17824:29:2"
													},
													"loopExpression": {
														"expression": {
															"argumentTypes": null,
															"id": 1220,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "UnaryOperation",
															"operator": "--",
															"prefix": false,
															"src": "17862:3:2",
															"subExpression": {
																"argumentTypes": null,
																"id": 1219,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1211,
																"src": "17862:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"id": 1221,
														"nodeType": "ExpressionStatement",
														"src": "17862:3:2"
													},
													"nodeType": "ForStatement",
													"src": "17819:565:2"
												}
											]
										}
									},
									{
										"expression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"id": 1281,
													"name": "gameIdList",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1178,
													"src": "18412:10:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint256_$10_memory_ptr",
														"typeString": "uint256[10] memory"
													}
												},
												{
													"argumentTypes": null,
													"id": 1282,
													"name": "gameIdCount",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1181,
													"src": "18424:11:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"id": 1283,
													"name": "gameId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1184,
													"src": "18437:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"id": 1284,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "18411:33:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$_t_array$_t_uint256_$10_memory_ptr_$_t_uint32_$_t_uint256_$",
												"typeString": "tuple(uint256[10] memory,uint32,uint256)"
											}
										},
										"functionReturnParameters": 1173,
										"id": 1285,
										"nodeType": "Return",
										"src": "18404:40:2"
									}
								]
							},
							"documentation": "@notice Returns recent game ids where msg.sender is a player.\n @param offset Position in game data array to start search from\n @return List of game ids\n @return Number of game ids\n @return Position in loop when ended",
							"id": 1287,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "listGamesForAddress",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1164,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1163,
										"name": "offset",
										"nodeType": "VariableDeclaration",
										"scope": 1287,
										"src": "17234:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 1162,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "17234:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "17233:16:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1173,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1168,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1287,
										"src": "17297:11:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint256_$10_memory_ptr",
											"typeString": "uint256[10]"
										},
										"typeName": {
											"baseType": {
												"id": 1165,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "17297:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"id": 1167,
											"length": {
												"argumentTypes": null,
												"hexValue": "3130",
												"id": 1166,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "17305:2:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												},
												"value": "10"
											},
											"nodeType": "ArrayTypeName",
											"src": "17297:11:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint256_$10_storage_ptr",
												"typeString": "uint256[10]"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1170,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1287,
										"src": "17310:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1169,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "17310:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1172,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1287,
										"src": "17318:7:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 1171,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "17318:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "17296:30:2"
							},
							"scope": 4288,
							"src": "17205:1246:2",
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 1339,
								"nodeType": "Block",
								"src": "18840:302:2",
								"statements": [
									{
										"assignments": [
											1301
										],
										"declarations": [
											{
												"constant": false,
												"id": 1301,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 1340,
												"src": "18850:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 1300,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "18850:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1305,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1302,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "18874:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 1304,
											"indexExpression": {
												"argumentTypes": null,
												"id": 1303,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1289,
												"src": "18888:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "18874:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "18850:45:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1310,
												"name": "regionOwnersList",
												"nodeType": "VariableDeclaration",
												"scope": 1340,
												"src": "18906:44:2",
												"stateVariable": false,
												"storageLocation": "memory",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
													"typeString": "uint32[25]"
												},
												"typeName": {
													"baseType": {
														"id": 1308,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "18906:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1309,
													"length": {
														"argumentTypes": null,
														"id": 1307,
														"name": "REGION_COUNT",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 129,
														"src": "18913:12:2",
														"typeDescriptions": {
															"typeIdentifier": null,
															"typeString": null
														}
													},
													"nodeType": "ArrayTypeName",
													"src": "18906:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage_ptr",
														"typeString": "uint32[25]"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1311,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "18906:44:2"
									},
									{
										"body": {
											"id": 1332,
											"nodeType": "Block",
											"src": "19002:77:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"id": 1330,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 1322,
																"name": "regionOwnersList",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1310,
																"src": "19016:16:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
																	"typeString": "uint32[25] memory"
																}
															},
															"id": 1324,
															"indexExpression": {
																"argumentTypes": null,
																"id": 1323,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1313,
																"src": "19033:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"nodeType": "IndexAccess",
															"src": "19016:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1326,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1301,
																		"src": "19047:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1327,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "regionOwners",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 228,
																	"src": "19047:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1328,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1313,
																	"src": "19066:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1325,
																"name": "getData8",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4158,
																"src": "19038:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1329,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "19038:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "19016:52:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1331,
													"nodeType": "ExpressionStatement",
													"src": "19016:52:2"
												}
											]
										},
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 1318,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 1316,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1313,
												"src": "18979:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "<",
											"rightExpression": {
												"argumentTypes": null,
												"id": 1317,
												"name": "REGION_COUNT",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 129,
												"src": "18983:12:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "18979:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"id": 1333,
										"initializationExpression": {
											"assignments": [
												1313
											],
											"declarations": [
												{
													"constant": false,
													"id": 1313,
													"name": "i",
													"nodeType": "VariableDeclaration",
													"scope": 1340,
													"src": "18965:8:2",
													"stateVariable": false,
													"storageLocation": "default",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"typeName": {
														"id": 1312,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "18965:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"value": null,
													"visibility": "internal"
												}
											],
											"id": 1315,
											"initialValue": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1314,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "18976:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"nodeType": "VariableDeclarationStatement",
											"src": "18965:12:2"
										},
										"loopExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 1320,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "UnaryOperation",
												"operator": "++",
												"prefix": false,
												"src": "18997:3:2",
												"subExpression": {
													"argumentTypes": null,
													"id": 1319,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1313,
													"src": "18997:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1321,
											"nodeType": "ExpressionStatement",
											"src": "18997:3:2"
										},
										"nodeType": "ForStatement",
										"src": "18960:119:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"id": 1334,
													"name": "regionOwnersList",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1310,
													"src": "19097:16:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
														"typeString": "uint32[25] memory"
													}
												},
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1335,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1301,
														"src": "19115:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 1336,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "regionSoldiers",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 232,
													"src": "19115:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												}
											],
											"id": 1337,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "19096:39:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$_t_array$_t_uint32_$25_memory_ptr_$_t_array$_t_uint32_$25_storage_$",
												"typeString": "tuple(uint32[25] memory,uint32[25] storage ref)"
											}
										},
										"functionReturnParameters": 1299,
										"id": 1338,
										"nodeType": "Return",
										"src": "19089:46:2"
									}
								]
							},
							"documentation": "@notice Returns the number of soldiers deployed to each region and region owners.\n @param gameId Id of game \n @return List of which player owns each region\n @return List of number of soldiers deployed to each region",
							"id": 1340,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "soldiersByRegion",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1290,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1289,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 1340,
										"src": "18728:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 1288,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "18728:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "18727:16:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1299,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1294,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1340,
										"src": "18791:20:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
											"typeString": "uint32[25]"
										},
										"typeName": {
											"baseType": {
												"id": 1291,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "18791:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1293,
											"length": {
												"argumentTypes": null,
												"id": 1292,
												"name": "REGION_COUNT",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 129,
												"src": "18798:12:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "18791:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$25_storage_ptr",
												"typeString": "uint32[25]"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1298,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1340,
										"src": "18813:20:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$25_memory_ptr",
											"typeString": "uint32[25]"
										},
										"typeName": {
											"baseType": {
												"id": 1295,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "18813:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1297,
											"length": {
												"argumentTypes": null,
												"id": 1296,
												"name": "REGION_COUNT",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 129,
												"src": "18820:12:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "18813:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$25_storage_ptr",
												"typeString": "uint32[25]"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "18790:44:2"
							},
							"scope": 4288,
							"src": "18702:440:2",
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 1379,
								"nodeType": "Block",
								"src": "19575:277:2",
								"statements": [
									{
										"assignments": [
											1360
										],
										"declarations": [
											{
												"constant": false,
												"id": 1360,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 1380,
												"src": "19585:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 1359,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "19585:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1364,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1361,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "19609:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 1363,
											"indexExpression": {
												"argumentTypes": null,
												"id": 1362,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1342,
												"src": "19623:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "19609:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "19585:45:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1365,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1360,
														"src": "19661:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 1366,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "turnTeamId",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 214,
													"src": "19661:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1367,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1360,
														"src": "19691:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 1368,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "turnNum",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 216,
													"src": "19691:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1369,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1360,
														"src": "19718:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 1370,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "maxBlocksPerTurn",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 218,
													"src": "19718:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1371,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1360,
														"src": "19754:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 1372,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "playerCount",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 220,
													"src": "19754:16:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1373,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1360,
														"src": "19785:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 1374,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "playerAddresses",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 224,
													"src": "19785:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_address_$8_storage",
														"typeString": "address[8] storage ref"
													}
												},
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1375,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1360,
														"src": "19819:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 1376,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "teamAvatars",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 244,
													"src": "19819:16:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bytes8",
														"typeString": "bytes8"
													}
												}
											],
											"id": 1377,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "19647:198:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$_t_uint32_$_t_uint32_$_t_uint32_$_t_uint32_$_t_array$_t_address_$8_storage_$_t_bytes8_$",
												"typeString": "tuple(uint32,uint32,uint32,uint32,address[8] storage ref,bytes8)"
											}
										},
										"functionReturnParameters": 1358,
										"id": 1378,
										"nodeType": "Return",
										"src": "19640:205:2"
									}
								]
							},
							"documentation": "@notice Returns information about current turn and players.\n @param gameId Id of game \n @return Id of current player\n @return Turn number\n @return Max blocks per turn\n @return Number of players\n @return Player addresses",
							"id": 1380,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "turnAndPlayerInfo",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1343,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1342,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 1380,
										"src": "19445:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 1341,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "19445:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "19444:16:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1358,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1345,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1380,
										"src": "19508:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1344,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "19508:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1347,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1380,
										"src": "19516:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1346,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "19516:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1349,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1380,
										"src": "19524:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1348,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "19524:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1351,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1380,
										"src": "19532:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1350,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "19532:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1355,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1380,
										"src": "19540:20:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_address_$8_memory_ptr",
											"typeString": "address[8]"
										},
										"typeName": {
											"baseType": {
												"id": 1352,
												"name": "address",
												"nodeType": "ElementaryTypeName",
												"src": "19540:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"id": 1354,
											"length": {
												"argumentTypes": null,
												"id": 1353,
												"name": "MAX_PLAYERS",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 135,
												"src": "19548:11:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "19540:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_address_$8_storage_ptr",
												"typeString": "address[8]"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1357,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1380,
										"src": "19562:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes8",
											"typeString": "bytes8"
										},
										"typeName": {
											"id": 1356,
											"name": "bytes8",
											"nodeType": "ElementaryTypeName",
											"src": "19562:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes8",
												"typeString": "bytes8"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "19507:62:2"
							},
							"scope": 4288,
							"src": "19418:434:2",
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 1446,
								"nodeType": "Block",
								"src": "20213:445:2",
								"statements": [
									{
										"assignments": [
											1394
										],
										"declarations": [
											{
												"constant": false,
												"id": 1394,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 1447,
												"src": "20223:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 1393,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "20223:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1398,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1395,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "20247:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 1397,
											"indexExpression": {
												"argumentTypes": null,
												"id": 1396,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1382,
												"src": "20261:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "20247:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "20223:45:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1403,
												"name": "undeployedSoldiersList",
												"nodeType": "VariableDeclaration",
												"scope": 1447,
												"src": "20279:49:2",
												"stateVariable": false,
												"storageLocation": "memory",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8]"
												},
												"typeName": {
													"baseType": {
														"id": 1401,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "20279:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1402,
													"length": {
														"argumentTypes": null,
														"id": 1400,
														"name": "MAX_PLAYERS",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 135,
														"src": "20286:11:2",
														"typeDescriptions": {
															"typeIdentifier": null,
															"typeString": null
														}
													},
													"nodeType": "ArrayTypeName",
													"src": "20279:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
														"typeString": "uint32[8]"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1404,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "20279:49:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1409,
												"name": "regionRewardList",
												"nodeType": "VariableDeclaration",
												"scope": 1447,
												"src": "20338:43:2",
												"stateVariable": false,
												"storageLocation": "memory",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8]"
												},
												"typeName": {
													"baseType": {
														"id": 1407,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "20338:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1408,
													"length": {
														"argumentTypes": null,
														"id": 1406,
														"name": "MAX_PLAYERS",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 135,
														"src": "20345:11:2",
														"typeDescriptions": {
															"typeIdentifier": null,
															"typeString": null
														}
													},
													"nodeType": "ArrayTypeName",
													"src": "20338:19:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
														"typeString": "uint32[8]"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1410,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "20338:43:2"
									},
									{
										"body": {
											"id": 1440,
											"nodeType": "Block",
											"src": "20432:160:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"id": 1429,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 1421,
																"name": "undeployedSoldiersList",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1403,
																"src": "20446:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																	"typeString": "uint32[8] memory"
																}
															},
															"id": 1423,
															"indexExpression": {
																"argumentTypes": null,
																"id": 1422,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1412,
																"src": "20469:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"nodeType": "IndexAccess",
															"src": "20446:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1425,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1394,
																		"src": "20484:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1426,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "undeployedSoldiers",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 226,
																	"src": "20484:23:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1427,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1412,
																	"src": "20509:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1424,
																"name": "getData32",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4095,
																"src": "20474:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1428,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "20474:37:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "20446:65:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1430,
													"nodeType": "ExpressionStatement",
													"src": "20446:65:2"
												},
												{
													"expression": {
														"argumentTypes": null,
														"id": 1438,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 1431,
																"name": "regionRewardList",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1409,
																"src": "20525:16:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																	"typeString": "uint32[8] memory"
																}
															},
															"id": 1433,
															"indexExpression": {
																"argumentTypes": null,
																"id": 1432,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1412,
																"src": "20542:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"nodeType": "IndexAccess",
															"src": "20525:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"id": 1435,
																	"name": "gameId",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1382,
																	"src": "20570:6:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1436,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1412,
																	"src": "20578:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1434,
																"name": "calculateRegionRewards",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2164,
																"src": "20547:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_view$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) view returns (uint32)"
																}
															},
															"id": 1437,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "20547:33:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "20525:55:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1439,
													"nodeType": "ExpressionStatement",
													"src": "20525:55:2"
												}
											]
										},
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 1417,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 1415,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1412,
												"src": "20410:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "<",
											"rightExpression": {
												"argumentTypes": null,
												"id": 1416,
												"name": "MAX_PLAYERS",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 135,
												"src": "20414:11:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "20410:15:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"id": 1441,
										"initializationExpression": {
											"assignments": [
												1412
											],
											"declarations": [
												{
													"constant": false,
													"id": 1412,
													"name": "i",
													"nodeType": "VariableDeclaration",
													"scope": 1447,
													"src": "20396:8:2",
													"stateVariable": false,
													"storageLocation": "default",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"typeName": {
														"id": 1411,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "20396:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"value": null,
													"visibility": "internal"
												}
											],
											"id": 1414,
											"initialValue": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1413,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "20407:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"nodeType": "VariableDeclarationStatement",
											"src": "20396:12:2"
										},
										"loopExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 1419,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "UnaryOperation",
												"operator": "++",
												"prefix": false,
												"src": "20427:3:2",
												"subExpression": {
													"argumentTypes": null,
													"id": 1418,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1412,
													"src": "20427:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1420,
											"nodeType": "ExpressionStatement",
											"src": "20427:3:2"
										},
										"nodeType": "ForStatement",
										"src": "20391:201:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"id": 1442,
													"name": "undeployedSoldiersList",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1403,
													"src": "20610:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
														"typeString": "uint32[8] memory"
													}
												},
												{
													"argumentTypes": null,
													"id": 1443,
													"name": "regionRewardList",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1409,
													"src": "20634:16:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
														"typeString": "uint32[8] memory"
													}
												}
											],
											"id": 1444,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "20609:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$_t_array$_t_uint32_$8_memory_ptr_$_t_array$_t_uint32_$8_memory_ptr_$",
												"typeString": "tuple(uint32[8] memory,uint32[8] memory)"
											}
										},
										"functionReturnParameters": 1392,
										"id": 1445,
										"nodeType": "Return",
										"src": "20602:49:2"
									}
								]
							},
							"documentation": "@notice Returns the number of undeployed soldiers for each player.\n @param gameId Id of game \n @return Number of undeployed soldiers for each player\n @return Reward points for each player",
							"id": 1447,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "undeployedSoldiers",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1383,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1382,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 1447,
										"src": "20103:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 1381,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "20103:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "20102:16:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1392,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1387,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1447,
										"src": "20166:19:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
											"typeString": "uint32[8]"
										},
										"typeName": {
											"baseType": {
												"id": 1384,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "20166:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1386,
											"length": {
												"argumentTypes": null,
												"id": 1385,
												"name": "MAX_PLAYERS",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 135,
												"src": "20173:11:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "20166:19:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
												"typeString": "uint32[8]"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1391,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1447,
										"src": "20187:19:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
											"typeString": "uint32[8]"
										},
										"typeName": {
											"baseType": {
												"id": 1388,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "20187:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1390,
											"length": {
												"argumentTypes": null,
												"id": 1389,
												"name": "MAX_PLAYERS",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 135,
												"src": "20194:11:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "20187:19:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
												"typeString": "uint32[8]"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "20165:42:2"
							},
							"scope": 4288,
							"src": "20075:583:2",
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 1560,
								"nodeType": "Block",
								"src": "21323:836:2",
								"statements": [
									{
										"assignments": [
											1471
										],
										"declarations": [
											{
												"constant": false,
												"id": 1471,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 1561,
												"src": "21333:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 1470,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "21333:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1475,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1472,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "21357:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 1474,
											"indexExpression": {
												"argumentTypes": null,
												"id": 1473,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1449,
												"src": "21371:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "21357:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "21333:45:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1480,
												"name": "fromRegionList",
												"nodeType": "VariableDeclaration",
												"scope": 1561,
												"src": "21389:50:2",
												"stateVariable": false,
												"storageLocation": "memory",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8]"
												},
												"typeName": {
													"baseType": {
														"id": 1478,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "21389:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1479,
													"length": {
														"argumentTypes": null,
														"id": 1477,
														"name": "MAX_ACTIONS_PER_TURN",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 138,
														"src": "21396:20:2",
														"typeDescriptions": {
															"typeIdentifier": null,
															"typeString": null
														}
													},
													"nodeType": "ArrayTypeName",
													"src": "21389:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
														"typeString": "uint32[8]"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1481,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "21389:50:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1486,
												"name": "toRegionList",
												"nodeType": "VariableDeclaration",
												"scope": 1561,
												"src": "21449:48:2",
												"stateVariable": false,
												"storageLocation": "memory",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8]"
												},
												"typeName": {
													"baseType": {
														"id": 1484,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "21449:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1485,
													"length": {
														"argumentTypes": null,
														"id": 1483,
														"name": "MAX_ACTIONS_PER_TURN",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 138,
														"src": "21456:20:2",
														"typeDescriptions": {
															"typeIdentifier": null,
															"typeString": null
														}
													},
													"nodeType": "ArrayTypeName",
													"src": "21449:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
														"typeString": "uint32[8]"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1487,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "21449:48:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1492,
												"name": "moveSoldierCountList",
												"nodeType": "VariableDeclaration",
												"scope": 1561,
												"src": "21507:56:2",
												"stateVariable": false,
												"storageLocation": "memory",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8]"
												},
												"typeName": {
													"baseType": {
														"id": 1490,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "21507:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1491,
													"length": {
														"argumentTypes": null,
														"id": 1489,
														"name": "MAX_ACTIONS_PER_TURN",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 138,
														"src": "21514:20:2",
														"typeDescriptions": {
															"typeIdentifier": null,
															"typeString": null
														}
													},
													"nodeType": "ArrayTypeName",
													"src": "21507:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
														"typeString": "uint32[8]"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1493,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "21507:56:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1498,
												"name": "submitBlockList",
												"nodeType": "VariableDeclaration",
												"scope": 1561,
												"src": "21573:51:2",
												"stateVariable": false,
												"storageLocation": "memory",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8]"
												},
												"typeName": {
													"baseType": {
														"id": 1496,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "21573:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1497,
													"length": {
														"argumentTypes": null,
														"id": 1495,
														"name": "MAX_ACTIONS_PER_TURN",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 138,
														"src": "21580:20:2",
														"typeDescriptions": {
															"typeIdentifier": null,
															"typeString": null
														}
													},
													"nodeType": "ArrayTypeName",
													"src": "21573:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
														"typeString": "uint32[8]"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1499,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "21573:51:2"
									},
									{
										"body": {
											"id": 1550,
											"nodeType": "Block",
											"src": "21685:289:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"id": 1518,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 1510,
																"name": "fromRegionList",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1480,
																"src": "21699:14:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																	"typeString": "uint32[8] memory"
																}
															},
															"id": 1512,
															"indexExpression": {
																"argumentTypes": null,
																"id": 1511,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1501,
																"src": "21714:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"nodeType": "IndexAccess",
															"src": "21699:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1514,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1471,
																		"src": "21729:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1515,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "fromRegionList",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 236,
																	"src": "21729:19:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1516,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1501,
																	"src": "21750:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1513,
																"name": "getData32",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4095,
																"src": "21719:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1517,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "21719:33:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "21699:53:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1519,
													"nodeType": "ExpressionStatement",
													"src": "21699:53:2"
												},
												{
													"expression": {
														"argumentTypes": null,
														"id": 1528,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 1520,
																"name": "toRegionList",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1486,
																"src": "21766:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																	"typeString": "uint32[8] memory"
																}
															},
															"id": 1522,
															"indexExpression": {
																"argumentTypes": null,
																"id": 1521,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1501,
																"src": "21779:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"nodeType": "IndexAccess",
															"src": "21766:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1524,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1471,
																		"src": "21794:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1525,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "toRegionList",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 238,
																	"src": "21794:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1526,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1501,
																	"src": "21813:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1523,
																"name": "getData32",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4095,
																"src": "21784:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1527,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "21784:31:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "21766:49:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1529,
													"nodeType": "ExpressionStatement",
													"src": "21766:49:2"
												},
												{
													"expression": {
														"argumentTypes": null,
														"id": 1538,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 1530,
																"name": "moveSoldierCountList",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1492,
																"src": "21829:20:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																	"typeString": "uint32[8] memory"
																}
															},
															"id": 1532,
															"indexExpression": {
																"argumentTypes": null,
																"id": 1531,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1501,
																"src": "21850:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"nodeType": "IndexAccess",
															"src": "21829:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1534,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1471,
																		"src": "21865:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1535,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "moveSoldierCountList",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 240,
																	"src": "21865:25:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1536,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1501,
																	"src": "21892:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1533,
																"name": "getData32",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4095,
																"src": "21855:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1537,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "21855:39:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "21829:65:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1539,
													"nodeType": "ExpressionStatement",
													"src": "21829:65:2"
												},
												{
													"expression": {
														"argumentTypes": null,
														"id": 1548,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 1540,
																"name": "submitBlockList",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1498,
																"src": "21908:15:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																	"typeString": "uint32[8] memory"
																}
															},
															"id": 1542,
															"indexExpression": {
																"argumentTypes": null,
																"id": 1541,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1501,
																"src": "21924:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"nodeType": "IndexAccess",
															"src": "21908:18:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1544,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1471,
																		"src": "21939:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1545,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "submitBlockList",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 242,
																	"src": "21939:20:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1546,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1501,
																	"src": "21961:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1543,
																"name": "getData32",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4095,
																"src": "21929:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1547,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "21929:34:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "21908:55:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1549,
													"nodeType": "ExpressionStatement",
													"src": "21908:55:2"
												}
											]
										},
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 1506,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 1504,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1501,
												"src": "21654:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "<",
											"rightExpression": {
												"argumentTypes": null,
												"id": 1505,
												"name": "MAX_ACTIONS_PER_TURN",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 138,
												"src": "21658:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "21654:24:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"id": 1551,
										"initializationExpression": {
											"assignments": [
												1501
											],
											"declarations": [
												{
													"constant": false,
													"id": 1501,
													"name": "i",
													"nodeType": "VariableDeclaration",
													"scope": 1561,
													"src": "21640:8:2",
													"stateVariable": false,
													"storageLocation": "default",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"typeName": {
														"id": 1500,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "21640:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"value": null,
													"visibility": "internal"
												}
											],
											"id": 1503,
											"initialValue": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1502,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "21651:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"nodeType": "VariableDeclarationStatement",
											"src": "21640:12:2"
										},
										"loopExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 1508,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "UnaryOperation",
												"operator": "++",
												"prefix": false,
												"src": "21680:3:2",
												"subExpression": {
													"argumentTypes": null,
													"id": 1507,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1501,
													"src": "21680:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1509,
											"nodeType": "ExpressionStatement",
											"src": "21680:3:2"
										},
										"nodeType": "ForStatement",
										"src": "21635:339:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1552,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1471,
														"src": "22005:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 1553,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "actionCount",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 234,
													"src": "22005:16:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"id": 1554,
													"name": "fromRegionList",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1480,
													"src": "22036:14:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
														"typeString": "uint32[8] memory"
													}
												},
												{
													"argumentTypes": null,
													"id": 1555,
													"name": "toRegionList",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1486,
													"src": "22065:12:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
														"typeString": "uint32[8] memory"
													}
												},
												{
													"argumentTypes": null,
													"id": 1556,
													"name": "moveSoldierCountList",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1492,
													"src": "22092:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
														"typeString": "uint32[8] memory"
													}
												},
												{
													"argumentTypes": null,
													"id": 1557,
													"name": "submitBlockList",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1498,
													"src": "22127:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
														"typeString": "uint32[8] memory"
													}
												}
											],
											"id": 1558,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "21991:161:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$_t_uint32_$_t_array$_t_uint32_$8_memory_ptr_$_t_array$_t_uint32_$8_memory_ptr_$_t_array$_t_uint32_$8_memory_ptr_$_t_array$_t_uint32_$8_memory_ptr_$",
												"typeString": "tuple(uint32,uint32[8] memory,uint32[8] memory,uint32[8] memory,uint32[8] memory)"
											}
										},
										"functionReturnParameters": 1469,
										"id": 1559,
										"nodeType": "Return",
										"src": "21984:168:2"
									}
								]
							},
							"documentation": "@notice Returns pending actions that have been queued for current turn.\n @param gameId Id of game \n @return Number of pending actions\n @return List of regions moving soldiers from\n @return List of regions moving soldiers to\n @return List with number of soldiers to move\n @return List with block number when action was queued",
							"id": 1561,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "pendingActions",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1450,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1449,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 1561,
										"src": "21063:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 1448,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "21063:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "21062:16:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1469,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1452,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1561,
										"src": "21139:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1451,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "21139:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1456,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1561,
										"src": "21159:28:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
											"typeString": "uint32[8]"
										},
										"typeName": {
											"baseType": {
												"id": 1453,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "21159:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1455,
											"length": {
												"argumentTypes": null,
												"id": 1454,
												"name": "MAX_ACTIONS_PER_TURN",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 138,
												"src": "21166:20:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "21159:28:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
												"typeString": "uint32[8]"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1460,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1561,
										"src": "21202:28:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
											"typeString": "uint32[8]"
										},
										"typeName": {
											"baseType": {
												"id": 1457,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "21202:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1459,
											"length": {
												"argumentTypes": null,
												"id": 1458,
												"name": "MAX_ACTIONS_PER_TURN",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 138,
												"src": "21209:20:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "21202:28:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
												"typeString": "uint32[8]"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1464,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1561,
										"src": "21245:28:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
											"typeString": "uint32[8]"
										},
										"typeName": {
											"baseType": {
												"id": 1461,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "21245:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1463,
											"length": {
												"argumentTypes": null,
												"id": 1462,
												"name": "MAX_ACTIONS_PER_TURN",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 138,
												"src": "21252:20:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "21245:28:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
												"typeString": "uint32[8]"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1468,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1561,
										"src": "21288:28:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
											"typeString": "uint32[8]"
										},
										"typeName": {
											"baseType": {
												"id": 1465,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "21288:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1467,
											"length": {
												"argumentTypes": null,
												"id": 1466,
												"name": "MAX_ACTIONS_PER_TURN",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 138,
												"src": "21295:20:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "21288:28:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
												"typeString": "uint32[8]"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "21125:197:2"
							},
							"scope": 4288,
							"src": "21039:1120:2",
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 1710,
								"nodeType": "Block",
								"src": "22781:1507:2",
								"statements": [
									{
										"assignments": [
											1583
										],
										"declarations": [
											{
												"constant": false,
												"id": 1583,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 1711,
												"src": "22791:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 1582,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "22791:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1587,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1584,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "22815:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 1586,
											"indexExpression": {
												"argumentTypes": null,
												"id": 1585,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1563,
												"src": "22829:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "22815:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "22791:45:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1592,
												"name": "submitBlockList",
												"nodeType": "VariableDeclaration",
												"scope": 1711,
												"src": "22847:51:2",
												"stateVariable": false,
												"storageLocation": "memory",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8]"
												},
												"typeName": {
													"baseType": {
														"id": 1590,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "22847:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1591,
													"length": {
														"argumentTypes": null,
														"id": 1589,
														"name": "MAX_ACTIONS_PER_TURN",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 138,
														"src": "22854:20:2",
														"typeDescriptions": {
															"typeIdentifier": null,
															"typeString": null
														}
													},
													"nodeType": "ArrayTypeName",
													"src": "22847:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
														"typeString": "uint32[8]"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1593,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "22847:51:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1598,
												"name": "remainingAttackerList",
												"nodeType": "VariableDeclaration",
												"scope": 1711,
												"src": "22908:57:2",
												"stateVariable": false,
												"storageLocation": "memory",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8]"
												},
												"typeName": {
													"baseType": {
														"id": 1596,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "22908:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1597,
													"length": {
														"argumentTypes": null,
														"id": 1595,
														"name": "MAX_ACTIONS_PER_TURN",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 138,
														"src": "22915:20:2",
														"typeDescriptions": {
															"typeIdentifier": null,
															"typeString": null
														}
													},
													"nodeType": "ArrayTypeName",
													"src": "22908:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
														"typeString": "uint32[8]"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1599,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "22908:57:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1604,
												"name": "remainingDefenderList",
												"nodeType": "VariableDeclaration",
												"scope": 1711,
												"src": "22975:57:2",
												"stateVariable": false,
												"storageLocation": "memory",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
													"typeString": "uint32[8]"
												},
												"typeName": {
													"baseType": {
														"id": 1602,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "22975:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1603,
													"length": {
														"argumentTypes": null,
														"id": 1601,
														"name": "MAX_ACTIONS_PER_TURN",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 138,
														"src": "22982:20:2",
														"typeDescriptions": {
															"typeIdentifier": null,
															"typeString": null
														}
													},
													"nodeType": "ArrayTypeName",
													"src": "22975:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
														"typeString": "uint32[8]"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1605,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "22975:57:2"
									},
									{
										"body": {
											"id": 1697,
											"nodeType": "Block",
											"src": "23093:995:2",
											"statements": [
												{
													"assignments": [
														1617
													],
													"declarations": [
														{
															"constant": false,
															"id": 1617,
															"name": "toRegion",
															"nodeType": "VariableDeclaration",
															"scope": 1711,
															"src": "23107:15:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"typeName": {
																"id": 1616,
																"name": "uint32",
																"nodeType": "ElementaryTypeName",
																"src": "23107:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 1623,
													"initialValue": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1619,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1583,
																	"src": "23135:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1620,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "toRegionList",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 238,
																"src": "23135:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1621,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1607,
																"src": "23154:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1618,
															"name": "getData32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4095,
															"src": "23125:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 1622,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "23125:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "23107:49:2"
												},
												{
													"expression": {
														"argumentTypes": null,
														"id": 1632,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 1624,
																"name": "submitBlockList",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1592,
																"src": "23170:15:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																	"typeString": "uint32[8] memory"
																}
															},
															"id": 1626,
															"indexExpression": {
																"argumentTypes": null,
																"id": 1625,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1607,
																"src": "23186:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"nodeType": "IndexAccess",
															"src": "23170:18:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1628,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1583,
																		"src": "23201:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1629,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "submitBlockList",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 242,
																	"src": "23201:20:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 1630,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1607,
																	"src": "23223:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 1627,
																"name": "getData32",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4095,
																"src": "23191:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 1631,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "23191:34:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "23170:55:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1633,
													"nodeType": "ExpressionStatement",
													"src": "23170:55:2"
												},
												{
													"assignments": [
														1635
													],
													"declarations": [
														{
															"constant": false,
															"id": 1635,
															"name": "friendly",
															"nodeType": "VariableDeclaration",
															"scope": 1711,
															"src": "23240:13:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"typeName": {
																"id": 1634,
																"name": "bool",
																"nodeType": "ElementaryTypeName",
																"src": "23240:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 1652,
													"initialValue": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"id": 1651,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 1643,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 1637,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1583,
																			"src": "23265:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 1638,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "regionOwners",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 228,
																		"src": "23265:17:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"id": 1639,
																		"name": "toRegion",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1617,
																		"src": "23284:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 1636,
																	"name": "getData8",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4158,
																	"src": "23256:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																		"typeString": "function (uint256,uint32) pure returns (uint32)"
																	}
																},
																"id": 1640,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "23256:37:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "==",
															"rightExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1641,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1583,
																	"src": "23297:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1642,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "turnTeamId",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 214,
																"src": "23297:15:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "23256:56:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "||",
														"rightExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 1650,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 1645,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1583,
																			"src": "23342:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 1646,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "regionOwners",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 228,
																		"src": "23342:17:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"id": 1647,
																		"name": "toRegion",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1617,
																		"src": "23361:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 1644,
																	"name": "getData8",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4158,
																	"src": "23333:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																		"typeString": "function (uint256,uint32) pure returns (uint32)"
																	}
																},
																"id": 1648,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "23333:37:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "==",
															"rightExpression": {
																"argumentTypes": null,
																"id": 1649,
																"name": "NOT_OWNED",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 123,
																"src": "23374:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "23333:50:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"src": "23256:127:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "23240:143:2"
												},
												{
													"condition": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"id": 1662,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 1653,
															"name": "friendly",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1635,
															"src": "23402:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "||",
														"rightExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"id": 1661,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1654,
																	"name": "block",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4362,
																	"src": "23414:5:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_magic_block",
																		"typeString": "block"
																	}
																},
																"id": 1655,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "number",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "23414:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": ">",
															"rightExpression": {
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 1660,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 1656,
																		"name": "submitBlockList",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1592,
																		"src": "23429:15:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																			"typeString": "uint32[8] memory"
																		}
																	},
																	"id": 1658,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 1657,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1607,
																		"src": "23445:1:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "23429:18:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "+",
																"rightExpression": {
																	"argumentTypes": null,
																	"hexValue": "31",
																	"id": 1659,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "23450:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_1_by_1",
																		"typeString": "int_const 1"
																	},
																	"value": "1"
																},
																"src": "23429:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "23414:37:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"src": "23402:49:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"falseBody": null,
													"id": 1696,
													"nodeType": "IfStatement",
													"src": "23398:680:2",
													"trueBody": {
														"id": 1695,
														"nodeType": "Block",
														"src": "23453:625:2",
														"statements": [
															{
																"assignments": [
																	1664,
																	1666
																],
																"declarations": [
																	{
																		"constant": false,
																		"id": 1664,
																		"name": "remainingAttackers",
																		"nodeType": "VariableDeclaration",
																		"scope": 1711,
																		"src": "23472:25:2",
																		"stateVariable": false,
																		"storageLocation": "default",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"typeName": {
																			"id": 1663,
																			"name": "uint32",
																			"nodeType": "ElementaryTypeName",
																			"src": "23472:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"value": null,
																		"visibility": "internal"
																	},
																	{
																		"constant": false,
																		"id": 1666,
																		"name": "remainingDefenders",
																		"nodeType": "VariableDeclaration",
																		"scope": 1711,
																		"src": "23499:25:2",
																		"stateVariable": false,
																		"storageLocation": "default",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"typeName": {
																			"id": 1665,
																			"name": "uint32",
																			"nodeType": "ElementaryTypeName",
																			"src": "23499:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"value": null,
																		"visibility": "internal"
																	}
																],
																"id": 1682,
																"initialValue": {
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"baseExpression": {
																				"argumentTypes": null,
																				"id": 1668,
																				"name": "submitBlockList",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1592,
																				"src": "23617:15:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																					"typeString": "uint32[8] memory"
																				}
																			},
																			"id": 1670,
																			"indexExpression": {
																				"argumentTypes": null,
																				"id": 1669,
																				"name": "i",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1607,
																				"src": "23633:1:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"nodeType": "IndexAccess",
																			"src": "23617:18:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		{
																			"argumentTypes": null,
																			"arguments": [
																				{
																					"argumentTypes": null,
																					"expression": {
																						"argumentTypes": null,
																						"id": 1672,
																						"name": "game",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 1583,
																						"src": "23718:4:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																							"typeString": "struct WorldGame.GameData storage pointer"
																						}
																					},
																					"id": 1673,
																					"isConstant": false,
																					"isLValue": true,
																					"isPure": false,
																					"lValueRequested": false,
																					"memberName": "moveSoldierCountList",
																					"nodeType": "MemberAccess",
																					"referencedDeclaration": 240,
																					"src": "23718:25:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint256",
																						"typeString": "uint256"
																					}
																				},
																				{
																					"argumentTypes": null,
																					"id": 1674,
																					"name": "i",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 1607,
																					"src": "23745:1:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				}
																			],
																			"expression": {
																				"argumentTypes": [
																					{
																						"typeIdentifier": "t_uint256",
																						"typeString": "uint256"
																					},
																					{
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				],
																				"id": 1671,
																				"name": "getData32",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 4095,
																				"src": "23708:9:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																					"typeString": "function (uint256,uint32) pure returns (uint32)"
																				}
																			},
																			"id": 1675,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"kind": "functionCall",
																			"lValueRequested": false,
																			"names": [],
																			"nodeType": "FunctionCall",
																			"src": "23708:39:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		{
																			"argumentTypes": null,
																			"baseExpression": {
																				"argumentTypes": null,
																				"expression": {
																					"argumentTypes": null,
																					"id": 1676,
																					"name": "game",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 1583,
																					"src": "23818:4:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																						"typeString": "struct WorldGame.GameData storage pointer"
																					}
																				},
																				"id": 1677,
																				"isConstant": false,
																				"isLValue": true,
																				"isPure": false,
																				"lValueRequested": false,
																				"memberName": "regionSoldiers",
																				"nodeType": "MemberAccess",
																				"referencedDeclaration": 232,
																				"src": "23818:19:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_array$_t_uint32_$25_storage",
																					"typeString": "uint32[25] storage ref"
																				}
																			},
																			"id": 1679,
																			"indexExpression": {
																				"argumentTypes": null,
																				"id": 1678,
																				"name": "toRegion",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1617,
																				"src": "23838:8:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"nodeType": "IndexAccess",
																			"src": "23818:29:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		{
																			"argumentTypes": null,
																			"id": 1680,
																			"name": "friendly",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1635,
																			"src": "23910:8:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_bool",
																				"typeString": "bool"
																			}
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			},
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			},
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			},
																			{
																				"typeIdentifier": "t_bool",
																				"typeString": "bool"
																			}
																		],
																		"id": 1667,
																		"name": "getOutcomeAttackOrMove",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2100,
																		"src": "23528:22:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_function_internal_view$_t_uint32_$_t_uint32_$_t_uint32_$_t_bool_$returns$_t_uint32_$_t_uint32_$",
																			"typeString": "function (uint32,uint32,uint32,bool) view returns (uint32,uint32)"
																		}
																	},
																	"id": 1681,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"kind": "functionCall",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "23528:408:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_tuple$_t_uint32_$_t_uint32_$",
																		"typeString": "tuple(uint32,uint32)"
																	}
																},
																"nodeType": "VariableDeclarationStatement",
																"src": "23471:465:2"
															},
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 1687,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"id": 1683,
																			"name": "remainingAttackerList",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1598,
																			"src": "23955:21:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																				"typeString": "uint32[8] memory"
																			}
																		},
																		"id": 1685,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 1684,
																			"name": "i",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1607,
																			"src": "23977:1:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": true,
																		"nodeType": "IndexAccess",
																		"src": "23955:24:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"id": 1686,
																		"name": "remainingAttackers",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1664,
																		"src": "23982:18:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "23955:45:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"id": 1688,
																"nodeType": "ExpressionStatement",
																"src": "23955:45:2"
															},
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 1693,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"id": 1689,
																			"name": "remainingDefenderList",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1604,
																			"src": "24018:21:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
																				"typeString": "uint32[8] memory"
																			}
																		},
																		"id": 1691,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 1690,
																			"name": "i",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1607,
																			"src": "24040:1:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": true,
																		"nodeType": "IndexAccess",
																		"src": "24018:24:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"id": 1692,
																		"name": "remainingDefenders",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1666,
																		"src": "24045:18:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "24018:45:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"id": 1694,
																"nodeType": "ExpressionStatement",
																"src": "24018:45:2"
															}
														]
													}
												}
											]
										},
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 1612,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 1610,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1607,
												"src": "23062:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "<",
											"rightExpression": {
												"argumentTypes": null,
												"id": 1611,
												"name": "MAX_ACTIONS_PER_TURN",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 138,
												"src": "23066:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "23062:24:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"id": 1698,
										"initializationExpression": {
											"assignments": [
												1607
											],
											"declarations": [
												{
													"constant": false,
													"id": 1607,
													"name": "i",
													"nodeType": "VariableDeclaration",
													"scope": 1711,
													"src": "23048:8:2",
													"stateVariable": false,
													"storageLocation": "default",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"typeName": {
														"id": 1606,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "23048:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"value": null,
													"visibility": "internal"
												}
											],
											"id": 1609,
											"initialValue": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1608,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "23059:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"nodeType": "VariableDeclarationStatement",
											"src": "23048:12:2"
										},
										"loopExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 1614,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "UnaryOperation",
												"operator": "++",
												"prefix": false,
												"src": "23088:3:2",
												"subExpression": {
													"argumentTypes": null,
													"id": 1613,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1607,
													"src": "23088:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1615,
											"nodeType": "ExpressionStatement",
											"src": "23088:3:2"
										},
										"nodeType": "ForStatement",
										"src": "23043:1045:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1700,
																"name": "block",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4362,
																"src": "24126:5:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_block",
																	"typeString": "block"
																}
															},
															"id": 1701,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "number",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "24126:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														],
														"id": 1699,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "24119:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 1702,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "24119:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1703,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1583,
														"src": "24154:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 1704,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "actionCount",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 234,
													"src": "24154:16:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												{
													"argumentTypes": null,
													"id": 1705,
													"name": "submitBlockList",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1592,
													"src": "24185:15:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
														"typeString": "uint32[8] memory"
													}
												},
												{
													"argumentTypes": null,
													"id": 1706,
													"name": "remainingAttackerList",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1598,
													"src": "24215:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
														"typeString": "uint32[8] memory"
													}
												},
												{
													"argumentTypes": null,
													"id": 1707,
													"name": "remainingDefenderList",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1604,
													"src": "24250:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
														"typeString": "uint32[8] memory"
													}
												}
											],
											"id": 1708,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "24105:176:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$_t_uint32_$_t_uint32_$_t_array$_t_uint32_$8_memory_ptr_$_t_array$_t_uint32_$8_memory_ptr_$_t_array$_t_uint32_$8_memory_ptr_$",
												"typeString": "tuple(uint32,uint32,uint32[8] memory,uint32[8] memory,uint32[8] memory)"
											}
										},
										"functionReturnParameters": 1581,
										"id": 1709,
										"nodeType": "Return",
										"src": "24098:183:2"
									}
								]
							},
							"documentation": "@notice Returns pending actions that have been queued for current turn.\n @param gameId Id of game \n @return Current block numbber\n @return Number of pending actions\n @return List with block number when action was queued\n @return Number of remaining attackers\n @return Number of remaining defenders",
							"id": 1711,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "pendingActionOutcomes",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1564,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1563,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 1711,
										"src": "22544:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 1562,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "22544:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "22543:16:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1581,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1566,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1711,
										"src": "22620:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1565,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "22620:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1568,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1711,
										"src": "22640:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1567,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "22640:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1572,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1711,
										"src": "22660:28:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
											"typeString": "uint32[8]"
										},
										"typeName": {
											"baseType": {
												"id": 1569,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "22660:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1571,
											"length": {
												"argumentTypes": null,
												"id": 1570,
												"name": "MAX_ACTIONS_PER_TURN",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 138,
												"src": "22667:20:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "22660:28:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
												"typeString": "uint32[8]"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1576,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1711,
										"src": "22703:28:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
											"typeString": "uint32[8]"
										},
										"typeName": {
											"baseType": {
												"id": 1573,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "22703:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1575,
											"length": {
												"argumentTypes": null,
												"id": 1574,
												"name": "MAX_ACTIONS_PER_TURN",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 138,
												"src": "22710:20:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "22703:28:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
												"typeString": "uint32[8]"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1580,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1711,
										"src": "22746:28:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_uint32_$8_memory_ptr",
											"typeString": "uint32[8]"
										},
										"typeName": {
											"baseType": {
												"id": 1577,
												"name": "uint32",
												"nodeType": "ElementaryTypeName",
												"src": "22746:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1579,
											"length": {
												"argumentTypes": null,
												"id": 1578,
												"name": "MAX_ACTIONS_PER_TURN",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 138,
												"src": "22753:20:2",
												"typeDescriptions": {
													"typeIdentifier": null,
													"typeString": null
												}
											},
											"nodeType": "ArrayTypeName",
											"src": "22746:28:2",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_uint32_$8_storage_ptr",
												"typeString": "uint32[8]"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "22606:174:2"
							},
							"scope": 4288,
							"src": "22513:1775:2",
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						{
							"body": {
								"id": 1846,
								"nodeType": "Block",
								"src": "24480:1885:2",
								"statements": [
									{
										"assignments": [
											1717
										],
										"declarations": [
											{
												"constant": false,
												"id": 1717,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 1847,
												"src": "24490:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 1716,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "24490:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1721,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1718,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "24514:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 1720,
											"indexExpression": {
												"argumentTypes": null,
												"id": 1719,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1713,
												"src": "24528:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "24514:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "24490:45:2"
									},
									{
										"body": {
											"id": 1838,
											"nodeType": "Block",
											"src": "24666:1623:2",
											"statements": [
												{
													"assignments": [
														1734
													],
													"declarations": [
														{
															"constant": false,
															"id": 1734,
															"name": "regionFrom",
															"nodeType": "VariableDeclaration",
															"scope": 1847,
															"src": "24680:17:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"typeName": {
																"id": 1733,
																"name": "uint32",
																"nodeType": "ElementaryTypeName",
																"src": "24680:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 1740,
													"initialValue": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1736,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1717,
																	"src": "24710:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1737,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "fromRegionList",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 236,
																"src": "24710:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1738,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1723,
																"src": "24731:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1735,
															"name": "getData32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4095,
															"src": "24700:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 1739,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "24700:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "24680:53:2"
												},
												{
													"assignments": [
														1742
													],
													"declarations": [
														{
															"constant": false,
															"id": 1742,
															"name": "regionTo",
															"nodeType": "VariableDeclaration",
															"scope": 1847,
															"src": "24747:15:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"typeName": {
																"id": 1741,
																"name": "uint32",
																"nodeType": "ElementaryTypeName",
																"src": "24747:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 1748,
													"initialValue": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1744,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1717,
																	"src": "24775:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1745,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "toRegionList",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 238,
																"src": "24775:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1746,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1723,
																"src": "24794:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1743,
															"name": "getData32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4095,
															"src": "24765:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 1747,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "24765:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "24747:49:2"
												},
												{
													"assignments": [
														1750
													],
													"declarations": [
														{
															"constant": false,
															"id": 1750,
															"name": "friendly",
															"nodeType": "VariableDeclaration",
															"scope": 1847,
															"src": "24810:13:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"typeName": {
																"id": 1749,
																"name": "bool",
																"nodeType": "ElementaryTypeName",
																"src": "24810:4:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 1767,
													"initialValue": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"id": 1766,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 1758,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 1752,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1717,
																			"src": "24835:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 1753,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "regionOwners",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 228,
																		"src": "24835:17:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"id": 1754,
																		"name": "regionTo",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1742,
																		"src": "24854:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 1751,
																	"name": "getData8",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4158,
																	"src": "24826:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																		"typeString": "function (uint256,uint32) pure returns (uint32)"
																	}
																},
																"id": 1755,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "24826:37:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "==",
															"rightExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1756,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1717,
																	"src": "24867:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1757,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "turnTeamId",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 214,
																"src": "24867:15:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "24826:56:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "||",
														"rightExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 1765,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 1760,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1717,
																			"src": "24911:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 1761,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "regionOwners",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 228,
																		"src": "24911:17:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"id": 1762,
																		"name": "regionTo",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1742,
																		"src": "24930:8:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 1759,
																	"name": "getData8",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4158,
																	"src": "24902:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																		"typeString": "function (uint256,uint32) pure returns (uint32)"
																	}
																},
																"id": 1763,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "24902:37:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "==",
															"rightExpression": {
																"argumentTypes": null,
																"id": 1764,
																"name": "NOT_OWNED",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 123,
																"src": "24943:9:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "24902:50:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"src": "24826:126:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "24810:142:2"
												},
												{
													"assignments": [
														1769,
														1771
													],
													"declarations": [
														{
															"constant": false,
															"id": 1769,
															"name": "remainingAttackers",
															"nodeType": "VariableDeclaration",
															"scope": 1847,
															"src": "25167:25:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"typeName": {
																"id": 1768,
																"name": "uint32",
																"nodeType": "ElementaryTypeName",
																"src": "25167:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"value": null,
															"visibility": "internal"
														},
														{
															"constant": false,
															"id": 1771,
															"name": "remainingDefenders",
															"nodeType": "VariableDeclaration",
															"scope": 1847,
															"src": "25194:25:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"typeName": {
																"id": 1770,
																"name": "uint32",
																"nodeType": "ElementaryTypeName",
																"src": "25194:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 1789,
													"initialValue": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 1774,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1717,
																			"src": "25314:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 1775,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "submitBlockList",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 242,
																		"src": "25314:20:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"id": 1776,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1723,
																		"src": "25336:1:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 1773,
																	"name": "getData32",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4095,
																	"src": "25304:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																		"typeString": "function (uint256,uint32) pure returns (uint32)"
																	}
																},
																"id": 1777,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "25304:34:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 1779,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1717,
																			"src": "25413:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 1780,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "moveSoldierCountList",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 240,
																		"src": "25413:25:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"id": 1781,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1723,
																		"src": "25440:1:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 1778,
																	"name": "getData32",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4095,
																	"src": "25403:9:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																		"typeString": "function (uint256,uint32) pure returns (uint32)"
																	}
																},
																"id": 1782,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "25403:39:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"baseExpression": {
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 1783,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1717,
																		"src": "25505:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 1784,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "regionSoldiers",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 232,
																	"src": "25505:19:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_array$_t_uint32_$25_storage",
																		"typeString": "uint32[25] storage ref"
																	}
																},
																"id": 1786,
																"indexExpression": {
																	"argumentTypes": null,
																	"id": 1785,
																	"name": "regionTo",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1742,
																	"src": "25525:8:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "IndexAccess",
																"src": "25505:29:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"id": 1787,
																"name": "friendly",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1750,
																"src": "25589:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"id": 1772,
															"name": "getOutcomeAttackOrMove",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2100,
															"src": "25223:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_view$_t_uint32_$_t_uint32_$_t_uint32_$_t_bool_$returns$_t_uint32_$_t_uint32_$",
																"typeString": "function (uint32,uint32,uint32,bool) view returns (uint32,uint32)"
															}
														},
														"id": 1788,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "25223:388:2",
														"typeDescriptions": {
															"typeIdentifier": "t_tuple$_t_uint32_$_t_uint32_$",
															"typeString": "tuple(uint32,uint32)"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "25166:445:2"
												},
												{
													"condition": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 1792,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 1790,
															"name": "remainingDefenders",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1771,
															"src": "25630:18:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"hexValue": "30",
															"id": 1791,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "25652:1:2",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														},
														"src": "25630:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"falseBody": {
														"id": 1836,
														"nodeType": "Block",
														"src": "25949:330:2",
														"statements": [
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 1826,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"expression": {
																				"argumentTypes": null,
																				"id": 1814,
																				"name": "game",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1717,
																				"src": "26043:4:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																					"typeString": "struct WorldGame.GameData storage pointer"
																				}
																			},
																			"id": 1817,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"memberName": "regionSoldiers",
																			"nodeType": "MemberAccess",
																			"referencedDeclaration": 232,
																			"src": "26043:19:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_uint32_$25_storage",
																				"typeString": "uint32[25] storage ref"
																			}
																		},
																		"id": 1818,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 1816,
																			"name": "regionFrom",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1734,
																			"src": "26063:10:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": true,
																		"nodeType": "IndexAccess",
																		"src": "26043:31:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"baseExpression": {
																					"argumentTypes": null,
																					"expression": {
																						"argumentTypes": null,
																						"id": 1820,
																						"name": "game",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 1717,
																						"src": "26106:4:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																							"typeString": "struct WorldGame.GameData storage pointer"
																						}
																					},
																					"id": 1821,
																					"isConstant": false,
																					"isLValue": true,
																					"isPure": false,
																					"lValueRequested": false,
																					"memberName": "regionSoldiers",
																					"nodeType": "MemberAccess",
																					"referencedDeclaration": 232,
																					"src": "26106:19:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_array$_t_uint32_$25_storage",
																						"typeString": "uint32[25] storage ref"
																					}
																				},
																				"id": 1823,
																				"indexExpression": {
																					"argumentTypes": null,
																					"id": 1822,
																					"name": "regionFrom",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 1734,
																					"src": "26126:10:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				},
																				"isConstant": false,
																				"isLValue": true,
																				"isPure": false,
																				"lValueRequested": false,
																				"nodeType": "IndexAccess",
																				"src": "26106:31:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			{
																				"argumentTypes": null,
																				"id": 1824,
																				"name": "remainingAttackers",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1769,
																				"src": "26160:18:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				},
																				{
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			],
																			"id": 1819,
																			"name": "addSafe",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 4253,
																			"src": "26077:7:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																				"typeString": "function (uint32,uint32) pure returns (uint32)"
																			}
																		},
																		"id": 1825,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"kind": "functionCall",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "26077:119:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "26043:153:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"id": 1827,
																"nodeType": "ExpressionStatement",
																"src": "26043:153:2"
															},
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 1834,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"expression": {
																				"argumentTypes": null,
																				"id": 1828,
																				"name": "game",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1717,
																				"src": "26214:4:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																					"typeString": "struct WorldGame.GameData storage pointer"
																				}
																			},
																			"id": 1831,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"memberName": "regionSoldiers",
																			"nodeType": "MemberAccess",
																			"referencedDeclaration": 232,
																			"src": "26214:19:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_uint32_$25_storage",
																				"typeString": "uint32[25] storage ref"
																			}
																		},
																		"id": 1832,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 1830,
																			"name": "regionTo",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1742,
																			"src": "26234:8:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": true,
																		"nodeType": "IndexAccess",
																		"src": "26214:29:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"id": 1833,
																		"name": "remainingDefenders",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1771,
																		"src": "26246:18:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "26214:50:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"id": 1835,
																"nodeType": "ExpressionStatement",
																"src": "26214:50:2"
															}
														]
													},
													"id": 1837,
													"nodeType": "IfStatement",
													"src": "25626:653:2",
													"trueBody": {
														"id": 1813,
														"nodeType": "Block",
														"src": "25655:276:2",
														"statements": [
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 1799,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"expression": {
																				"argumentTypes": null,
																				"id": 1793,
																				"name": "game",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1717,
																				"src": "25774:4:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																					"typeString": "struct WorldGame.GameData storage pointer"
																				}
																			},
																			"id": 1796,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"memberName": "regionSoldiers",
																			"nodeType": "MemberAccess",
																			"referencedDeclaration": 232,
																			"src": "25774:19:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_uint32_$25_storage",
																				"typeString": "uint32[25] storage ref"
																			}
																		},
																		"id": 1797,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 1795,
																			"name": "regionTo",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1742,
																			"src": "25794:8:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": true,
																		"nodeType": "IndexAccess",
																		"src": "25774:29:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"id": 1798,
																		"name": "remainingAttackers",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1769,
																		"src": "25806:18:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "25774:50:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"id": 1800,
																"nodeType": "ExpressionStatement",
																"src": "25774:50:2"
															},
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 1811,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 1801,
																			"name": "game",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1717,
																			"src": "25842:4:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																				"typeString": "struct WorldGame.GameData storage pointer"
																			}
																		},
																		"id": 1803,
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": true,
																		"memberName": "regionOwners",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": 228,
																		"src": "25842:17:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"arguments": [
																			{
																				"argumentTypes": null,
																				"expression": {
																					"argumentTypes": null,
																					"id": 1805,
																					"name": "game",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 1717,
																					"src": "25871:4:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																						"typeString": "struct WorldGame.GameData storage pointer"
																					}
																				},
																				"id": 1806,
																				"isConstant": false,
																				"isLValue": true,
																				"isPure": false,
																				"lValueRequested": false,
																				"memberName": "regionOwners",
																				"nodeType": "MemberAccess",
																				"referencedDeclaration": 228,
																				"src": "25871:17:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint256",
																					"typeString": "uint256"
																				}
																			},
																			{
																				"argumentTypes": null,
																				"id": 1807,
																				"name": "regionTo",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1742,
																				"src": "25890:8:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			{
																				"argumentTypes": null,
																				"expression": {
																					"argumentTypes": null,
																					"id": 1808,
																					"name": "game",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 1717,
																					"src": "25900:4:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																						"typeString": "struct WorldGame.GameData storage pointer"
																					}
																				},
																				"id": 1809,
																				"isConstant": false,
																				"isLValue": true,
																				"isPure": false,
																				"lValueRequested": false,
																				"memberName": "turnTeamId",
																				"nodeType": "MemberAccess",
																				"referencedDeclaration": 214,
																				"src": "25900:15:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			}
																		],
																		"expression": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_uint256",
																					"typeString": "uint256"
																				},
																				{
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				},
																				{
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			],
																			"id": 1804,
																			"name": "setData8",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 4203,
																			"src": "25862:8:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
																				"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
																			}
																		},
																		"id": 1810,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"kind": "functionCall",
																		"lValueRequested": false,
																		"names": [],
																		"nodeType": "FunctionCall",
																		"src": "25862:54:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"src": "25842:74:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"id": 1812,
																"nodeType": "ExpressionStatement",
																"src": "25842:74:2"
															}
														]
													}
												}
											]
										},
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 1729,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 1726,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1723,
												"src": "24639:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "<",
											"rightExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1727,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1717,
													"src": "24643:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1728,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "actionCount",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 234,
												"src": "24643:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "24639:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"id": 1839,
										"initializationExpression": {
											"assignments": [
												1723
											],
											"declarations": [
												{
													"constant": false,
													"id": 1723,
													"name": "i",
													"nodeType": "VariableDeclaration",
													"scope": 1847,
													"src": "24625:8:2",
													"stateVariable": false,
													"storageLocation": "default",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"typeName": {
														"id": 1722,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "24625:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"value": null,
													"visibility": "internal"
												}
											],
											"id": 1725,
											"initialValue": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1724,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "24636:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"nodeType": "VariableDeclarationStatement",
											"src": "24625:12:2"
										},
										"loopExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 1731,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "UnaryOperation",
												"operator": "++",
												"prefix": false,
												"src": "24661:3:2",
												"subExpression": {
													"argumentTypes": null,
													"id": 1730,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1723,
													"src": "24661:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1732,
											"nodeType": "ExpressionStatement",
											"src": "24661:3:2"
										},
										"nodeType": "ForStatement",
										"src": "24620:1669:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 1844,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1840,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1717,
													"src": "26338:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1842,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"memberName": "actionCount",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 234,
												"src": "26338:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 1843,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "26357:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"src": "26338:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 1845,
										"nodeType": "ExpressionStatement",
										"src": "26338:20:2"
									}
								]
							},
							"documentation": "@notice Execute actions that have been queued for this turn.\n @param gameId Id of game ",
							"id": 1847,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": false,
							"modifiers": [],
							"name": "executePendingActions",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1714,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1713,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 1847,
										"src": "24437:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 1712,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "24437:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "24427:30:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1715,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "24480:0:2"
							},
							"scope": 4288,
							"src": "24397:1968:2",
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "private"
						},
						{
							"body": {
								"id": 1947,
								"nodeType": "Block",
								"src": "26601:770:2",
								"statements": [
									{
										"assignments": [
											1855
										],
										"declarations": [
											{
												"constant": false,
												"id": 1855,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 1948,
												"src": "26611:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 1854,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "26611:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1859,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 1856,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "26635:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 1858,
											"indexExpression": {
												"argumentTypes": null,
												"id": 1857,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1849,
												"src": "26649:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "26635:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "26611:45:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1864,
												"name": "playerOwnsRegion",
												"nodeType": "VariableDeclaration",
												"scope": 1948,
												"src": "26666:41:2",
												"stateVariable": false,
												"storageLocation": "memory",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_bool_$8_memory_ptr",
													"typeString": "bool[8]"
												},
												"typeName": {
													"baseType": {
														"id": 1862,
														"name": "bool",
														"nodeType": "ElementaryTypeName",
														"src": "26666:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"id": 1863,
													"length": {
														"argumentTypes": null,
														"id": 1861,
														"name": "MAX_PLAYERS",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 135,
														"src": "26671:11:2",
														"typeDescriptions": {
															"typeIdentifier": null,
															"typeString": null
														}
													},
													"nodeType": "ArrayTypeName",
													"src": "26666:17:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_bool_$8_storage_ptr",
														"typeString": "bool[8]"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1865,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "26666:41:2"
									},
									{
										"assignments": [
											1867
										],
										"declarations": [
											{
												"constant": false,
												"id": 1867,
												"name": "hasNotOwned",
												"nodeType": "VariableDeclaration",
												"scope": 1948,
												"src": "26717:16:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"typeName": {
													"id": 1866,
													"name": "bool",
													"nodeType": "ElementaryTypeName",
													"src": "26717:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1869,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "66616c7365",
											"id": 1868,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "26736:5:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "false"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "26717:24:2"
									},
									{
										"assignments": [],
										"declarations": [
											{
												"constant": false,
												"id": 1871,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 1948,
												"src": "26751:8:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 1870,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "26751:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1872,
										"initialValue": null,
										"nodeType": "VariableDeclarationStatement",
										"src": "26751:8:2"
									},
									{
										"body": {
											"id": 1907,
											"nodeType": "Block",
											"src": "26813:257:2",
											"statements": [
												{
													"assignments": [
														1884
													],
													"declarations": [
														{
															"constant": false,
															"id": 1884,
															"name": "regionOwner",
															"nodeType": "VariableDeclaration",
															"scope": 1948,
															"src": "26827:18:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"typeName": {
																"id": 1883,
																"name": "uint32",
																"nodeType": "ElementaryTypeName",
																"src": "26827:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 1890,
													"initialValue": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1886,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1855,
																	"src": "26857:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1887,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "regionOwners",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 228,
																"src": "26857:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															{
																"argumentTypes": null,
																"id": 1888,
																"name": "i",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1871,
																"src": "26876:1:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1885,
															"name": "getData8",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4158,
															"src": "26848:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint256,uint32) pure returns (uint32)"
															}
														},
														"id": 1889,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "26848:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "26827:51:2"
												},
												{
													"condition": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 1893,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 1891,
															"name": "regionOwner",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1884,
															"src": "26896:11:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"id": 1892,
															"name": "NOT_OWNED",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 123,
															"src": "26911:9:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "26896:24:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"falseBody": {
														"id": 1905,
														"nodeType": "Block",
														"src": "26991:69:2",
														"statements": [
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 1903,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"id": 1899,
																			"name": "playerOwnsRegion",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1864,
																			"src": "27009:16:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_bool_$8_memory_ptr",
																				"typeString": "bool[8] memory"
																			}
																		},
																		"id": 1901,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 1900,
																			"name": "regionOwner",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1884,
																			"src": "27026:11:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": true,
																		"nodeType": "IndexAccess",
																		"src": "27009:29:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"hexValue": "74727565",
																		"id": 1902,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "bool",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "27041:4:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		},
																		"value": "true"
																	},
																	"src": "27009:36:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"id": 1904,
																"nodeType": "ExpressionStatement",
																"src": "27009:36:2"
															}
														]
													},
													"id": 1906,
													"nodeType": "IfStatement",
													"src": "26892:168:2",
													"trueBody": {
														"id": 1898,
														"nodeType": "Block",
														"src": "26922:51:2",
														"statements": [
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 1896,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"id": 1894,
																		"name": "hasNotOwned",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1867,
																		"src": "26940:11:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"hexValue": "74727565",
																		"id": 1895,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "bool",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "26954:4:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		},
																		"value": "true"
																	},
																	"src": "26940:18:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"id": 1897,
																"nodeType": "ExpressionStatement",
																"src": "26940:18:2"
															}
														]
													}
												}
											]
										},
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 1879,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 1877,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1871,
												"src": "26790:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "<",
											"rightExpression": {
												"argumentTypes": null,
												"id": 1878,
												"name": "REGION_COUNT",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 129,
												"src": "26794:12:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "26790:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"id": 1908,
										"initializationExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 1875,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftHandSide": {
													"argumentTypes": null,
													"id": 1873,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1871,
													"src": "26783:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "Assignment",
												"operator": "=",
												"rightHandSide": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 1874,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "26787:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "26783:5:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1876,
											"nodeType": "ExpressionStatement",
											"src": "26783:5:2"
										},
										"loopExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 1881,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "UnaryOperation",
												"operator": "++",
												"prefix": false,
												"src": "26808:3:2",
												"subExpression": {
													"argumentTypes": null,
													"id": 1880,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1871,
													"src": "26808:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1882,
											"nodeType": "ExpressionStatement",
											"src": "26808:3:2"
										},
										"nodeType": "ForStatement",
										"src": "26778:292:2"
									},
									{
										"assignments": [
											1910
										],
										"declarations": [
											{
												"constant": false,
												"id": 1910,
												"name": "turnTeamId",
												"nodeType": "VariableDeclaration",
												"scope": 1948,
												"src": "27080:17:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 1909,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "27080:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 1913,
										"initialValue": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 1911,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1855,
												"src": "27100:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 1912,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "turnTeamId",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 214,
											"src": "27100:15:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "27080:35:2"
									},
									{
										"body": {
											"id": 1943,
											"nodeType": "Block",
											"src": "27164:173:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"id": 1933,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftHandSide": {
															"argumentTypes": null,
															"id": 1925,
															"name": "turnTeamId",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1910,
															"src": "27178:10:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "Assignment",
														"operator": "=",
														"rightHandSide": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 1932,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"components": [
																	{
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"id": 1928,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"id": 1926,
																			"name": "turnTeamId",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 1910,
																			"src": "27192:10:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "+",
																		"rightExpression": {
																			"argumentTypes": null,
																			"hexValue": "31",
																			"id": 1927,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "27205:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_1_by_1",
																				"typeString": "int_const 1"
																			},
																			"value": "1"
																		},
																		"src": "27192:14:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"id": 1929,
																"isConstant": false,
																"isInlineArray": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "TupleExpression",
																"src": "27191:16:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "%",
															"rightExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 1930,
																	"name": "game",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1855,
																	"src": "27210:4:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																		"typeString": "struct WorldGame.GameData storage pointer"
																	}
																},
																"id": 1931,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "playerCount",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 220,
																"src": "27210:16:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"src": "27191:35:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "27178:48:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"id": 1934,
													"nodeType": "ExpressionStatement",
													"src": "27178:48:2"
												},
												{
													"condition": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"id": 1939,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 1935,
															"name": "hasNotOwned",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1867,
															"src": "27244:11:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "||",
														"rightExpression": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 1936,
																"name": "playerOwnsRegion",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1864,
																"src": "27259:16:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_array$_t_bool_$8_memory_ptr",
																	"typeString": "bool[8] memory"
																}
															},
															"id": 1938,
															"indexExpression": {
																"argumentTypes": null,
																"id": 1937,
																"name": "turnTeamId",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1910,
																"src": "27276:10:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "27259:28:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"src": "27244:43:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"falseBody": null,
													"id": 1942,
													"nodeType": "IfStatement",
													"src": "27240:87:2",
													"trueBody": {
														"id": 1941,
														"nodeType": "Block",
														"src": "27289:38:2",
														"statements": [
															{
																"id": 1940,
																"nodeType": "Break",
																"src": "27307:5:2"
															}
														]
													}
												}
											]
										},
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 1921,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 1918,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1871,
												"src": "27137:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "<",
											"rightExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1919,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1855,
													"src": "27141:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 1920,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "playerCount",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 220,
												"src": "27141:16:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "27137:20:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"id": 1944,
										"initializationExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 1916,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftHandSide": {
													"argumentTypes": null,
													"id": 1914,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1871,
													"src": "27130:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "Assignment",
												"operator": "=",
												"rightHandSide": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 1915,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "27134:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "27130:5:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1917,
											"nodeType": "ExpressionStatement",
											"src": "27130:5:2"
										},
										"loopExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 1923,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "UnaryOperation",
												"operator": "++",
												"prefix": false,
												"src": "27159:3:2",
												"subExpression": {
													"argumentTypes": null,
													"id": 1922,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1871,
													"src": "27159:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 1924,
											"nodeType": "ExpressionStatement",
											"src": "27159:3:2"
										},
										"nodeType": "ForStatement",
										"src": "27125:212:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 1945,
											"name": "turnTeamId",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1910,
											"src": "27354:10:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"functionReturnParameters": 1853,
										"id": 1946,
										"nodeType": "Return",
										"src": "27347:17:2"
									}
								]
							},
							"documentation": "@notice Player who's turn is next. \n @param gameId Id of game\n @return Next player's turn",
							"id": 1948,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "getNextTurnTeamId",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1850,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1849,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 1948,
										"src": "26519:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 1848,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "26519:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "26509:30:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1853,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1852,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 1948,
										"src": "26588:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1851,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "26588:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "26587:8:2"
							},
							"scope": 4288,
							"src": "26483:888:2",
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "private"
						},
						{
							"body": {
								"id": 2099,
								"nodeType": "Block",
								"src": "28083:2297:2",
								"statements": [
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 1971,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 1964,
														"name": "friendly",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1956,
														"src": "28101:8:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "||",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 1970,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1965,
																"name": "block",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4362,
																"src": "28113:5:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_block",
																	"typeString": "block"
																}
															},
															"id": 1966,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "number",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "28113:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": ">",
														"rightExpression": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"id": 1969,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"id": 1967,
																"name": "submitBlock",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1950,
																"src": "28128:11:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "+",
															"rightExpression": {
																"argumentTypes": null,
																"hexValue": "31",
																"id": 1968,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "28142:1:2",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_1_by_1",
																	"typeString": "int_const 1"
																},
																"value": "1"
															},
															"src": "28128:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "28113:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "28101:42:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "41747461636b73206d757374206265206174206c65617374203220626c6f636b73206f6c642e",
													"id": 1972,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "28145:40:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_91584ee78cdc6e0673b4f0284dd0b9cb25973d2723f266294efc182f77e28ea8",
														"typeString": "literal_string \"Attacks must be at least 2 blocks old.\""
													},
													"value": "Attacks must be at least 2 blocks old."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_91584ee78cdc6e0673b4f0284dd0b9cb25973d2723f266294efc182f77e28ea8",
														"typeString": "literal_string \"Attacks must be at least 2 blocks old.\""
													}
												],
												"id": 1963,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "28093:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 1973,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "28093:93:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 1974,
										"nodeType": "ExpressionStatement",
										"src": "28093:93:2"
									},
									{
										"condition": {
											"argumentTypes": null,
											"id": 1975,
											"name": "friendly",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1956,
											"src": "28201:8:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": {
											"id": 2097,
											"nodeType": "Block",
											"src": "28375:1999:2",
											"statements": [
												{
													"assignments": [
														1985
													],
													"declarations": [
														{
															"constant": false,
															"id": 1985,
															"name": "blockHash32",
															"nodeType": "VariableDeclaration",
															"scope": 2100,
															"src": "28719:18:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"typeName": {
																"id": 1984,
																"name": "uint32",
																"nodeType": "ElementaryTypeName",
																"src": "28719:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 1991,
													"initialValue": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 1989,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"id": 1987,
																	"name": "submitBlock",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 1950,
																	"src": "28756:11:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "+",
																"rightExpression": {
																	"argumentTypes": null,
																	"hexValue": "31",
																	"id": 1988,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "number",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "28770:1:2",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_rational_1_by_1",
																		"typeString": "int_const 1"
																	},
																	"value": "1"
																},
																"src": "28756:15:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 1986,
															"name": "readBlockHash32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1152,
															"src": "28740:15:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_view$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint32) view returns (uint32)"
															}
														},
														"id": 1990,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "28740:32:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "28719:53:2"
												},
												{
													"assignments": [
														1993
													],
													"declarations": [
														{
															"constant": false,
															"id": 1993,
															"name": "deadDefenders",
															"nodeType": "VariableDeclaration",
															"scope": 2100,
															"src": "28786:20:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"typeName": {
																"id": 1992,
																"name": "uint32",
																"nodeType": "ElementaryTypeName",
																"src": "28786:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 1995,
													"initialValue": {
														"argumentTypes": null,
														"hexValue": "30",
														"id": 1994,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "28809:1:2",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "28786:24:2"
												},
												{
													"assignments": [
														1997
													],
													"declarations": [
														{
															"constant": false,
															"id": 1997,
															"name": "deadAttackers",
															"nodeType": "VariableDeclaration",
															"scope": 2100,
															"src": "28824:20:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"typeName": {
																"id": 1996,
																"name": "uint32",
																"nodeType": "ElementaryTypeName",
																"src": "28824:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 1999,
													"initialValue": {
														"argumentTypes": null,
														"hexValue": "30",
														"id": 1998,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "28847:1:2",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "28824:24:2"
												},
												{
													"condition": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 2002,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 2000,
															"name": "blockHash32",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1985,
															"src": "28955:11:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"hexValue": "30",
															"id": 2001,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "28970:1:2",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														},
														"src": "28955:16:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"falseBody": {
														"id": 2059,
														"nodeType": "Block",
														"src": "29233:514:2",
														"statements": [
															{
																"assignments": [
																	2018
																],
																"declarations": [
																	{
																		"constant": false,
																		"id": 2018,
																		"name": "randA",
																		"nodeType": "VariableDeclaration",
																		"scope": 2100,
																		"src": "29251:12:2",
																		"stateVariable": false,
																		"storageLocation": "default",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"typeName": {
																			"id": 2017,
																			"name": "uint32",
																			"nodeType": "ElementaryTypeName",
																			"src": "29251:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"value": null,
																		"visibility": "internal"
																	}
																],
																"id": 2024,
																"initialValue": {
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"commonType": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			},
																			"id": 2022,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"leftExpression": {
																				"argumentTypes": null,
																				"id": 2020,
																				"name": "blockHash32",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 1985,
																				"src": "29273:11:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			"nodeType": "BinaryOperation",
																			"operator": "%",
																			"rightExpression": {
																				"argumentTypes": null,
																				"hexValue": "323536",
																				"id": 2021,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "29287:3:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_256_by_1",
																					"typeString": "int_const 256"
																				},
																				"value": "256"
																			},
																			"src": "29273:17:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		],
																		"id": 2019,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "29266:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 2023,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "29266:25:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "VariableDeclarationStatement",
																"src": "29251:40:2"
															},
															{
																"assignments": [
																	2026
																],
																"declarations": [
																	{
																		"constant": false,
																		"id": 2026,
																		"name": "randB",
																		"nodeType": "VariableDeclaration",
																		"scope": 2100,
																		"src": "29309:12:2",
																		"stateVariable": false,
																		"storageLocation": "default",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"typeName": {
																			"id": 2025,
																			"name": "uint32",
																			"nodeType": "ElementaryTypeName",
																			"src": "29309:6:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"value": null,
																		"visibility": "internal"
																	}
																],
																"id": 2035,
																"initialValue": {
																	"argumentTypes": null,
																	"arguments": [
																		{
																			"argumentTypes": null,
																			"commonType": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			},
																			"id": 2033,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"leftExpression": {
																				"argumentTypes": null,
																				"components": [
																					{
																						"argumentTypes": null,
																						"commonType": {
																							"typeIdentifier": "t_uint32",
																							"typeString": "uint32"
																						},
																						"id": 2030,
																						"isConstant": false,
																						"isLValue": false,
																						"isPure": false,
																						"lValueRequested": false,
																						"leftExpression": {
																							"argumentTypes": null,
																							"id": 2028,
																							"name": "blockHash32",
																							"nodeType": "Identifier",
																							"overloadedDeclarations": [],
																							"referencedDeclaration": 1985,
																							"src": "29332:11:2",
																							"typeDescriptions": {
																								"typeIdentifier": "t_uint32",
																								"typeString": "uint32"
																							}
																						},
																						"nodeType": "BinaryOperation",
																						"operator": ">>",
																						"rightExpression": {
																							"argumentTypes": null,
																							"hexValue": "38",
																							"id": 2029,
																							"isConstant": false,
																							"isLValue": false,
																							"isPure": true,
																							"kind": "number",
																							"lValueRequested": false,
																							"nodeType": "Literal",
																							"src": "29347:1:2",
																							"subdenomination": null,
																							"typeDescriptions": {
																								"typeIdentifier": "t_rational_8_by_1",
																								"typeString": "int_const 8"
																							},
																							"value": "8"
																						},
																						"src": "29332:16:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_uint32",
																							"typeString": "uint32"
																						}
																					}
																				],
																				"id": 2031,
																				"isConstant": false,
																				"isInlineArray": false,
																				"isLValue": false,
																				"isPure": false,
																				"lValueRequested": false,
																				"nodeType": "TupleExpression",
																				"src": "29331:18:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_uint32",
																					"typeString": "uint32"
																				}
																			},
																			"nodeType": "BinaryOperation",
																			"operator": "%",
																			"rightExpression": {
																				"argumentTypes": null,
																				"hexValue": "323536",
																				"id": 2032,
																				"isConstant": false,
																				"isLValue": false,
																				"isPure": true,
																				"kind": "number",
																				"lValueRequested": false,
																				"nodeType": "Literal",
																				"src": "29352:3:2",
																				"subdenomination": null,
																				"typeDescriptions": {
																					"typeIdentifier": "t_rational_256_by_1",
																					"typeString": "int_const 256"
																				},
																				"value": "256"
																			},
																			"src": "29331:24:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		}
																	],
																	"expression": {
																		"argumentTypes": [
																			{
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		],
																		"id": 2027,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"lValueRequested": false,
																		"nodeType": "ElementaryTypeNameExpression",
																		"src": "29324:6:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_type$_t_uint32_$",
																			"typeString": "type(uint32)"
																		},
																		"typeName": "uint32"
																	},
																	"id": 2034,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"kind": "typeConversion",
																	"lValueRequested": false,
																	"names": [],
																	"nodeType": "FunctionCall",
																	"src": "29324:32:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "VariableDeclarationStatement",
																"src": "29309:47:2"
															},
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 2043,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"id": 2036,
																		"name": "deadDefenders",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1993,
																		"src": "29432:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"id": 2042,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"arguments": [
																				{
																					"argumentTypes": null,
																					"id": 2038,
																					"name": "moveSoldierCount",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 1952,
																					"src": "29456:16:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				},
																				{
																					"argumentTypes": null,
																					"id": 2039,
																					"name": "randA",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 2018,
																					"src": "29474:5:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				}
																			],
																			"expression": {
																				"argumentTypes": [
																					{
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					},
																					{
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				],
																				"id": 2037,
																				"name": "mulSafe",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 4287,
																				"src": "29448:7:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																					"typeString": "function (uint32,uint32) pure returns (uint32)"
																				}
																			},
																			"id": 2040,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"kind": "functionCall",
																			"lValueRequested": false,
																			"names": [],
																			"nodeType": "FunctionCall",
																			"src": "29448:32:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "/",
																		"rightExpression": {
																			"argumentTypes": null,
																			"hexValue": "323536",
																			"id": 2041,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "29483:3:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_256_by_1",
																				"typeString": "int_const 256"
																			},
																			"value": "256"
																		},
																		"src": "29448:38:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "29432:54:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"id": 2044,
																"nodeType": "ExpressionStatement",
																"src": "29432:54:2"
															},
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 2057,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"id": 2045,
																		"name": "deadAttackers",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1997,
																		"src": "29606:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"id": 2056,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"arguments": [
																				{
																					"argumentTypes": null,
																					"id": 2047,
																					"name": "defenderCount",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 1954,
																					"src": "29630:13:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				},
																				{
																					"argumentTypes": null,
																					"commonType": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					},
																					"id": 2050,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"lValueRequested": false,
																					"leftExpression": {
																						"argumentTypes": null,
																						"id": 2048,
																						"name": "DEFENDER_ADVANTAGE_NUM",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 141,
																						"src": "29645:22:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_uint32",
																							"typeString": "uint32"
																						}
																					},
																					"nodeType": "BinaryOperation",
																					"operator": "*",
																					"rightExpression": {
																						"argumentTypes": null,
																						"id": 2049,
																						"name": "randB",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 2026,
																						"src": "29670:5:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_uint32",
																							"typeString": "uint32"
																						}
																					},
																					"src": "29645:30:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				}
																			],
																			"expression": {
																				"argumentTypes": [
																					{
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					},
																					{
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				],
																				"id": 2046,
																				"name": "mulSafe",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 4287,
																				"src": "29622:7:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																					"typeString": "function (uint32,uint32) pure returns (uint32)"
																				}
																			},
																			"id": 2051,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"kind": "functionCall",
																			"lValueRequested": false,
																			"names": [],
																			"nodeType": "FunctionCall",
																			"src": "29622:54:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "/",
																		"rightExpression": {
																			"argumentTypes": null,
																			"components": [
																				{
																					"argumentTypes": null,
																					"commonType": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					},
																					"id": 2054,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": true,
																					"lValueRequested": false,
																					"leftExpression": {
																						"argumentTypes": null,
																						"hexValue": "323536",
																						"id": 2052,
																						"isConstant": false,
																						"isLValue": false,
																						"isPure": true,
																						"kind": "number",
																						"lValueRequested": false,
																						"nodeType": "Literal",
																						"src": "29701:3:2",
																						"subdenomination": null,
																						"typeDescriptions": {
																							"typeIdentifier": "t_rational_256_by_1",
																							"typeString": "int_const 256"
																						},
																						"value": "256"
																					},
																					"nodeType": "BinaryOperation",
																					"operator": "*",
																					"rightExpression": {
																						"argumentTypes": null,
																						"id": 2053,
																						"name": "DEFENDER_ADVANTAGE_DENOM",
																						"nodeType": "Identifier",
																						"overloadedDeclarations": [],
																						"referencedDeclaration": 144,
																						"src": "29707:24:2",
																						"typeDescriptions": {
																							"typeIdentifier": "t_uint32",
																							"typeString": "uint32"
																						}
																					},
																					"src": "29701:30:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				}
																			],
																			"id": 2055,
																			"isConstant": false,
																			"isInlineArray": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"nodeType": "TupleExpression",
																			"src": "29700:32:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"src": "29622:110:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "29606:126:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"id": 2058,
																"nodeType": "ExpressionStatement",
																"src": "29606:126:2"
															}
														]
													},
													"id": 2060,
													"nodeType": "IfStatement",
													"src": "28951:796:2",
													"trueBody": {
														"id": 2016,
														"nodeType": "Block",
														"src": "28973:157:2",
														"statements": [
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 2005,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"id": 2003,
																		"name": "deadDefenders",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1993,
																		"src": "28991:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"hexValue": "30",
																		"id": 2004,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "29007:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		},
																		"value": "0"
																	},
																	"src": "28991:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"id": 2006,
																"nodeType": "ExpressionStatement",
																"src": "28991:17:2"
															},
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 2014,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"id": 2007,
																		"name": "deadAttackers",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1997,
																		"src": "29026:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"id": 2013,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"arguments": [
																				{
																					"argumentTypes": null,
																					"id": 2009,
																					"name": "defenderCount",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 1954,
																					"src": "29050:13:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				},
																				{
																					"argumentTypes": null,
																					"id": 2010,
																					"name": "DEFENDER_ADVANTAGE_NUM",
																					"nodeType": "Identifier",
																					"overloadedDeclarations": [],
																					"referencedDeclaration": 141,
																					"src": "29065:22:2",
																					"typeDescriptions": {
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				}
																			],
																			"expression": {
																				"argumentTypes": [
																					{
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					},
																					{
																						"typeIdentifier": "t_uint32",
																						"typeString": "uint32"
																					}
																				],
																				"id": 2008,
																				"name": "mulSafe",
																				"nodeType": "Identifier",
																				"overloadedDeclarations": [],
																				"referencedDeclaration": 4287,
																				"src": "29042:7:2",
																				"typeDescriptions": {
																					"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																					"typeString": "function (uint32,uint32) pure returns (uint32)"
																				}
																			},
																			"id": 2011,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"kind": "functionCall",
																			"lValueRequested": false,
																			"names": [],
																			"nodeType": "FunctionCall",
																			"src": "29042:46:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "/",
																		"rightExpression": {
																			"argumentTypes": null,
																			"id": 2012,
																			"name": "DEFENDER_ADVANTAGE_DENOM",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 144,
																			"src": "29091:24:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"src": "29042:73:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "29026:89:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"id": 2015,
																"nodeType": "ExpressionStatement",
																"src": "29026:89:2"
															}
														]
													}
												},
												{
													"assignments": [
														2062
													],
													"declarations": [
														{
															"constant": false,
															"id": 2062,
															"name": "remainingAttackers",
															"nodeType": "VariableDeclaration",
															"scope": 2100,
															"src": "29840:25:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"typeName": {
																"id": 2061,
																"name": "uint32",
																"nodeType": "ElementaryTypeName",
																"src": "29840:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 2073,
													"initialValue": {
														"argumentTypes": null,
														"condition": {
															"argumentTypes": null,
															"components": [
																{
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 2065,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 2063,
																		"name": "moveSoldierCount",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1952,
																		"src": "29869:16:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": ">",
																	"rightExpression": {
																		"argumentTypes": null,
																		"id": 2064,
																		"name": "deadAttackers",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1997,
																		"src": "29888:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "29869:32:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																}
															],
															"id": 2066,
															"isConstant": false,
															"isInlineArray": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "TupleExpression",
															"src": "29868:34:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"falseExpression": {
															"argumentTypes": null,
															"hexValue": "30",
															"id": 2071,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "29959:1:2",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														},
														"id": 2072,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "Conditional",
														"src": "29868:92:2",
														"trueExpression": {
															"argumentTypes": null,
															"components": [
																{
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 2069,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 2067,
																		"name": "moveSoldierCount",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1952,
																		"src": "29923:16:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "-",
																	"rightExpression": {
																		"argumentTypes": null,
																		"id": 2068,
																		"name": "deadAttackers",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1997,
																		"src": "29942:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "29923:32:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"id": 2070,
															"isConstant": false,
															"isInlineArray": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "TupleExpression",
															"src": "29922:34:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "29840:120:2"
												},
												{
													"assignments": [
														2075
													],
													"declarations": [
														{
															"constant": false,
															"id": 2075,
															"name": "remainingDefenders",
															"nodeType": "VariableDeclaration",
															"scope": 2100,
															"src": "30156:25:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"typeName": {
																"id": 2074,
																"name": "uint32",
																"nodeType": "ElementaryTypeName",
																"src": "30156:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 2092,
													"initialValue": {
														"argumentTypes": null,
														"condition": {
															"argumentTypes": null,
															"components": [
																{
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 2078,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 2076,
																		"name": "defenderCount",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1954,
																		"src": "30185:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": ">",
																	"rightExpression": {
																		"argumentTypes": null,
																		"id": 2077,
																		"name": "deadDefenders",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1993,
																		"src": "30201:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "30185:29:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																}
															],
															"id": 2079,
															"isConstant": false,
															"isInlineArray": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "TupleExpression",
															"src": "30184:31:2",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														},
														"falseExpression": {
															"argumentTypes": null,
															"components": [
																{
																	"argumentTypes": null,
																	"condition": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		"id": 2086,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"id": 2084,
																			"name": "remainingAttackers",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 2062,
																			"src": "30270:18:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": ">",
																		"rightExpression": {
																			"argumentTypes": null,
																			"hexValue": "30",
																			"id": 2085,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "30291:1:2",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_0_by_1",
																				"typeString": "int_const 0"
																			},
																			"value": "0"
																		},
																		"src": "30270:22:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_bool",
																			"typeString": "bool"
																		}
																	},
																	"falseExpression": {
																		"argumentTypes": null,
																		"hexValue": "31",
																		"id": 2088,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "30299:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_1_by_1",
																			"typeString": "int_const 1"
																		},
																		"value": "1"
																	},
																	"id": 2089,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "Conditional",
																	"src": "30270:30:2",
																	"trueExpression": {
																		"argumentTypes": null,
																		"hexValue": "30",
																		"id": 2087,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "30295:1:2",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_0_by_1",
																			"typeString": "int_const 0"
																		},
																		"value": "0"
																	},
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint8",
																		"typeString": "uint8"
																	}
																}
															],
															"id": 2090,
															"isConstant": false,
															"isInlineArray": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "TupleExpression",
															"src": "30269:32:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint8",
																"typeString": "uint8"
															}
														},
														"id": 2091,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "Conditional",
														"src": "30184:117:2",
														"trueExpression": {
															"argumentTypes": null,
															"components": [
																{
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	},
																	"id": 2082,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 2080,
																		"name": "defenderCount",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1954,
																		"src": "30236:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "-",
																	"rightExpression": {
																		"argumentTypes": null,
																		"id": 2081,
																		"name": "deadDefenders",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1993,
																		"src": "30252:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "30236:29:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"id": 2083,
															"isConstant": false,
															"isInlineArray": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "TupleExpression",
															"src": "30235:31:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "30156:145:2"
												},
												{
													"expression": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"id": 2093,
																"name": "remainingAttackers",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2062,
																"src": "30324:18:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"id": 2094,
																"name": "remainingDefenders",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2075,
																"src": "30344:18:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"id": 2095,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "30323:40:2",
														"typeDescriptions": {
															"typeIdentifier": "t_tuple$_t_uint32_$_t_uint32_$",
															"typeString": "tuple(uint32,uint32)"
														}
													},
													"functionReturnParameters": 1962,
													"id": 2096,
													"nodeType": "Return",
													"src": "30316:47:2"
												}
											]
										},
										"id": 2098,
										"nodeType": "IfStatement",
										"src": "28197:2177:2",
										"trueBody": {
											"id": 1983,
											"nodeType": "Block",
											"src": "28211:150:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"arguments": [
																	{
																		"argumentTypes": null,
																		"id": 1977,
																		"name": "moveSoldierCount",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1952,
																		"src": "28314:16:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	{
																		"argumentTypes": null,
																		"id": 1978,
																		"name": "defenderCount",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 1954,
																		"src": "28332:13:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	}
																],
																"expression": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		},
																		{
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	],
																	"id": 1976,
																	"name": "addSafe",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4253,
																	"src": "28306:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																		"typeString": "function (uint32,uint32) pure returns (uint32)"
																	}
																},
																"id": 1979,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"kind": "functionCall",
																"lValueRequested": false,
																"names": [],
																"nodeType": "FunctionCall",
																"src": "28306:40:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"hexValue": "30",
																"id": 1980,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "28348:1:2",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_0_by_1",
																	"typeString": "int_const 0"
																},
																"value": "0"
															}
														],
														"id": 1981,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "28305:45:2",
														"typeDescriptions": {
															"typeIdentifier": "t_tuple$_t_uint32_$_t_rational_0_by_1_$",
															"typeString": "tuple(uint32,int_const 0)"
														}
													},
													"functionReturnParameters": 1962,
													"id": 1982,
													"nodeType": "Return",
													"src": "28298:52:2"
												}
											]
										}
									}
								]
							},
							"documentation": "@notice Declare victory for a team.\n @param submitBlock Block number when action was submitted to queue\n @param moveSoldierCount Number of soldiers to move or attack\n @param defenderCount Number of soldiers defending destination region\n @param friendly Whether this is an attack, or friendly move\n @return remainingAttackers Number of attacking soldiers remaining \n @return remainingDefenders Number of defending soldiers remaining",
							"id": 2100,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "getOutcomeAttackOrMove",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 1957,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1950,
										"name": "submitBlock",
										"nodeType": "VariableDeclaration",
										"scope": 2100,
										"src": "27900:18:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1949,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "27900:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1952,
										"name": "moveSoldierCount",
										"nodeType": "VariableDeclaration",
										"scope": 2100,
										"src": "27929:23:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1951,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "27929:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1954,
										"name": "defenderCount",
										"nodeType": "VariableDeclaration",
										"scope": 2100,
										"src": "27963:20:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1953,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "27963:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1956,
										"name": "friendly",
										"nodeType": "VariableDeclaration",
										"scope": 2100,
										"src": "27994:13:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"typeName": {
											"id": 1955,
											"name": "bool",
											"nodeType": "ElementaryTypeName",
											"src": "27994:4:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "27890:123:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 1962,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 1959,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 2100,
										"src": "28062:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1958,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "28062:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 1961,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 2100,
										"src": "28070:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 1960,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "28070:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "28061:16:2"
							},
							"scope": 4288,
							"src": "27859:2521:2",
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "private"
						},
						{
							"body": {
								"id": 2163,
								"nodeType": "Block",
								"src": "30730:596:2",
								"statements": [
									{
										"assignments": [
											2110
										],
										"declarations": [
											{
												"constant": false,
												"id": 2110,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 2164,
												"src": "30740:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 2109,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "30740:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 2114,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 2111,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "30764:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 2113,
											"indexExpression": {
												"argumentTypes": null,
												"id": 2112,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2102,
												"src": "30778:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "30764:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "30740:45:2"
									},
									{
										"assignments": [
											2116
										],
										"declarations": [
											{
												"constant": false,
												"id": 2116,
												"name": "rewardTotal",
												"nodeType": "VariableDeclaration",
												"scope": 2164,
												"src": "30862:18:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 2115,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "30862:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 2118,
										"initialValue": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 2117,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "30883:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "30862:22:2"
									},
									{
										"assignments": [
											2120
										],
										"declarations": [
											{
												"constant": false,
												"id": 2120,
												"name": "bonusScore",
												"nodeType": "VariableDeclaration",
												"scope": 2164,
												"src": "30973:17:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 2119,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "30973:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 2124,
										"initialValue": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 2123,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 2121,
												"name": "REWARD_BONUS_MULTIPLIER_DENOM",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 147,
												"src": "30993:29:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "-",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2122,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "31025:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"src": "30993:33:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "30973:53:2"
									},
									{
										"body": {
											"id": 2153,
											"nodeType": "Block",
											"src": "31078:164:2",
											"statements": [
												{
													"condition": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 2141,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 2136,
																		"name": "game",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2110,
																		"src": "31105:4:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																			"typeString": "struct WorldGame.GameData storage pointer"
																		}
																	},
																	"id": 2137,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "regionOwners",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 228,
																	"src": "31105:17:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"id": 2138,
																	"name": "i",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 2126,
																	"src": "31124:1:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 2135,
																"name": "getData8",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 4158,
																"src": "31096:8:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
																	"typeString": "function (uint256,uint32) pure returns (uint32)"
																}
															},
															"id": 2139,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "31096:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"id": 2140,
															"name": "teamId",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2104,
															"src": "31130:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "31096:40:2",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"falseBody": null,
													"id": 2152,
													"nodeType": "IfStatement",
													"src": "31092:140:2",
													"trueBody": {
														"id": 2151,
														"nodeType": "Block",
														"src": "31138:94:2",
														"statements": [
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 2146,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftHandSide": {
																		"argumentTypes": null,
																		"id": 2142,
																		"name": "rewardTotal",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2116,
																		"src": "31156:11:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"nodeType": "Assignment",
																	"operator": "+=",
																	"rightHandSide": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"id": 2143,
																			"name": "regionRewards",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 183,
																			"src": "31171:13:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_array$_t_uint32_$25_storage",
																				"typeString": "uint32[25] storage ref"
																			}
																		},
																		"id": 2145,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 2144,
																			"name": "i",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 2126,
																			"src": "31185:1:2",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint32",
																				"typeString": "uint32"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"nodeType": "IndexAccess",
																		"src": "31171:16:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"src": "31156:31:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"id": 2147,
																"nodeType": "ExpressionStatement",
																"src": "31156:31:2"
															},
															{
																"expression": {
																	"argumentTypes": null,
																	"id": 2149,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "UnaryOperation",
																	"operator": "++",
																	"prefix": false,
																	"src": "31205:12:2",
																	"subExpression": {
																		"argumentTypes": null,
																		"id": 2148,
																		"name": "bonusScore",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2120,
																		"src": "31205:10:2",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint32",
																			"typeString": "uint32"
																		}
																	},
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"id": 2150,
																"nodeType": "ExpressionStatement",
																"src": "31205:12:2"
															}
														]
													}
												}
											]
										},
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 2131,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 2129,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2126,
												"src": "31055:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "<",
											"rightExpression": {
												"argumentTypes": null,
												"id": 2130,
												"name": "REGION_COUNT",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 129,
												"src": "31059:12:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "31055:16:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"id": 2154,
										"initializationExpression": {
											"assignments": [
												2126
											],
											"declarations": [
												{
													"constant": false,
													"id": 2126,
													"name": "i",
													"nodeType": "VariableDeclaration",
													"scope": 2164,
													"src": "31041:8:2",
													"stateVariable": false,
													"storageLocation": "default",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"typeName": {
														"id": 2125,
														"name": "uint32",
														"nodeType": "ElementaryTypeName",
														"src": "31041:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"value": null,
													"visibility": "internal"
												}
											],
											"id": 2128,
											"initialValue": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2127,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "31052:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"nodeType": "VariableDeclarationStatement",
											"src": "31041:12:2"
										},
										"loopExpression": {
											"expression": {
												"argumentTypes": null,
												"id": 2133,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "UnaryOperation",
												"operator": "++",
												"prefix": false,
												"src": "31073:3:2",
												"subExpression": {
													"argumentTypes": null,
													"id": 2132,
													"name": "i",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2126,
													"src": "31073:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"id": 2134,
											"nodeType": "ExpressionStatement",
											"src": "31073:3:2"
										},
										"nodeType": "ForStatement",
										"src": "31036:206:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"components": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 2160,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																"id": 2157,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"id": 2155,
																	"name": "rewardTotal",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 2116,
																	"src": "31261:11:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": "*",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 2156,
																	"name": "bonusScore",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 2120,
																	"src": "31275:10:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "31261:24:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"id": 2158,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "31260:26:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "/",
													"rightExpression": {
														"argumentTypes": null,
														"id": 2159,
														"name": "REWARD_BONUS_MULTIPLIER_DENOM",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 147,
														"src": "31289:29:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"src": "31260:58:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												}
											],
											"id": 2161,
											"isConstant": false,
											"isInlineArray": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "TupleExpression",
											"src": "31259:60:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"functionReturnParameters": 2108,
										"id": 2162,
										"nodeType": "Return",
										"src": "31252:67:2"
									}
								]
							},
							"documentation": "@notice Calculate a team's reward amount based on what regions they control.\n @param gameId Id of game\n @param teamId Team you'd like to calculate rewards for\n @return Reward amount for team",
							"id": 2164,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "calculateRegionRewards",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 2105,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 2102,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 2164,
										"src": "30638:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 2101,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "30638:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 2104,
										"name": "teamId",
										"nodeType": "VariableDeclaration",
										"scope": 2164,
										"src": "30654:13:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 2103,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "30654:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "30637:31:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 2108,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 2107,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 2164,
										"src": "30717:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 2106,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "30717:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "30716:8:2"
							},
							"scope": 4288,
							"src": "30606:720:2",
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "private"
						},
						{
							"body": {
								"id": 2209,
								"nodeType": "Block",
								"src": "31494:612:2",
								"statements": [
									{
										"assignments": [
											2170
										],
										"declarations": [
											{
												"constant": false,
												"id": 2170,
												"name": "game",
												"nodeType": "VariableDeclaration",
												"scope": 2210,
												"src": "31504:21:2",
												"stateVariable": false,
												"storageLocation": "storage",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData"
												},
												"typeName": {
													"contractScope": null,
													"id": 2169,
													"name": "GameData",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 245,
													"src": "31504:8:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 2174,
										"initialValue": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 2171,
												"name": "gameDataArray",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 186,
												"src": "31528:13:2",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_struct$_GameData_$245_storage_$dyn_storage",
													"typeString": "struct WorldGame.GameData storage ref[] storage ref"
												}
											},
											"id": 2173,
											"indexExpression": {
												"argumentTypes": null,
												"id": 2172,
												"name": "gameId",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2166,
												"src": "31542:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "31528:21:2",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_GameData_$245_storage",
												"typeString": "struct WorldGame.GameData storage ref"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "31504:45:2"
									},
									{
										"assignments": [
											2176
										],
										"declarations": [
											{
												"constant": false,
												"id": 2176,
												"name": "teamId",
												"nodeType": "VariableDeclaration",
												"scope": 2210,
												"src": "31618:13:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 2175,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "31618:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 2179,
										"initialValue": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 2177,
												"name": "game",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2170,
												"src": "31634:4:2",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
													"typeString": "struct WorldGame.GameData storage pointer"
												}
											},
											"id": 2178,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "turnTeamId",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 214,
											"src": "31634:15:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "31618:31:2"
									},
									{
										"assignments": [
											2181
										],
										"declarations": [
											{
												"constant": false,
												"id": 2181,
												"name": "rewardAmount",
												"nodeType": "VariableDeclaration",
												"scope": 2210,
												"src": "31726:19:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 2180,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "31726:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 2186,
										"initialValue": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 2183,
													"name": "gameId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2166,
													"src": "31771:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"id": 2184,
													"name": "teamId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2176,
													"src": "31779:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												],
												"id": 2182,
												"name": "calculateRegionRewards",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2164,
												"src": "31748:22:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_view$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
													"typeString": "function (uint256,uint32) view returns (uint32)"
												}
											},
											"id": 2185,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "31748:38:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "31726:60:2"
									},
									{
										"assignments": [
											2188
										],
										"declarations": [
											{
												"constant": false,
												"id": 2188,
												"name": "undeployedSoldierCount",
												"nodeType": "VariableDeclaration",
												"scope": 2210,
												"src": "31852:29:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 2187,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "31852:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 2194,
										"initialValue": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2190,
														"name": "game",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2170,
														"src": "31894:4:2",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
															"typeString": "struct WorldGame.GameData storage pointer"
														}
													},
													"id": 2191,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "undeployedSoldiers",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 226,
													"src": "31894:23:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"id": 2192,
													"name": "teamId",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2176,
													"src": "31919:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													{
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												],
												"id": 2189,
												"name": "getData32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4095,
												"src": "31884:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$returns$_t_uint32_$",
													"typeString": "function (uint256,uint32) pure returns (uint32)"
												}
											},
											"id": 2193,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "31884:42:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "31852:74:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2207,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 2195,
													"name": "game",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2170,
													"src": "31936:4:2",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
														"typeString": "struct WorldGame.GameData storage pointer"
													}
												},
												"id": 2197,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"memberName": "undeployedSoldiers",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 226,
												"src": "31936:23:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2199,
															"name": "game",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2170,
															"src": "31985:4:2",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_GameData_$245_storage_ptr",
																"typeString": "struct WorldGame.GameData storage pointer"
															}
														},
														"id": 2200,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "undeployedSoldiers",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 226,
														"src": "31985:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													{
														"argumentTypes": null,
														"id": 2201,
														"name": "teamId",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2176,
														"src": "32023:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													{
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"id": 2203,
																"name": "undeployedSoldierCount",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2188,
																"src": "32052:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															{
																"argumentTypes": null,
																"id": 2204,
																"name": "rewardAmount",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2181,
																"src": "32076:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																},
																{
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															],
															"id": 2202,
															"name": "addSafe",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4253,
															"src": "32044:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint32_$_t_uint32_$returns$_t_uint32_$",
																"typeString": "function (uint32,uint32) pure returns (uint32)"
															}
														},
														"id": 2205,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "32044:45:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														{
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														{
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													],
													"id": 2198,
													"name": "setData32",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4133,
													"src": "31962:9:2",
													"typeDescriptions": {
														"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint32_$_t_uint32_$returns$_t_uint256_$",
														"typeString": "function (uint256,uint32,uint32) pure returns (uint256)"
													}
												},
												"id": 2206,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "31962:137:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"src": "31936:163:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"id": 2208,
										"nodeType": "ExpressionStatement",
										"src": "31936:163:2"
									}
								]
							},
							"documentation": "@notice Reward team with soldiers based on what regions they control.\n @param gameId Id of game",
							"id": 2210,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": false,
							"modifiers": [],
							"name": "giveRegionRewards",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 2167,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 2166,
										"name": "gameId",
										"nodeType": "VariableDeclaration",
										"scope": 2210,
										"src": "31470:14:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 2165,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "31470:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "31469:16:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 2168,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "31494:0:2"
							},
							"scope": 4288,
							"src": "31443:663:2",
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "private"
						},
						{
							"body": {
								"id": 3840,
								"nodeType": "Block",
								"src": "32273:10521:2",
								"statements": [
									{
										"expression": {
											"argumentTypes": null,
											"id": 2225,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2213,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "32283:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2219,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2215,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "32306:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2216,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "HAWAII",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "32306:14:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2214,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "32299:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2217,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "32299:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "32283:39:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2220,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2218,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "32323:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "32283:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2222,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "32335:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2223,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_USA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "32335:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2221,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "32328:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2224,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "32328:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "32283:72:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2226,
										"nodeType": "ExpressionStatement",
										"src": "32283:72:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2239,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2227,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "32365:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2233,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2229,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "32388:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2230,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "HAWAII",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "32388:14:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2228,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "32381:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2231,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "32381:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "32365:39:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2234,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2232,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "32405:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "32365:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2236,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "32417:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2237,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "FIJI",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "32417:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2235,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "32410:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2238,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "32410:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "32365:65:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2240,
										"nodeType": "ExpressionStatement",
										"src": "32365:65:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2250,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2241,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "32440:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2247,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2243,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "32463:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2244,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "HAWAII",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "32463:14:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2242,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "32456:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2245,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "32456:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "32440:39:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2248,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2246,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "32480:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "32440:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2249,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "32485:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "32440:54:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2251,
										"nodeType": "ExpressionStatement",
										"src": "32440:54:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2261,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2252,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "32504:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2258,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2254,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "32527:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2255,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "HAWAII",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "32527:14:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2253,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "32520:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2256,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "32520:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "32504:39:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2259,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 2257,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "32544:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "32504:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2260,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "32549:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "32504:54:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2262,
										"nodeType": "ExpressionStatement",
										"src": "32504:54:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2272,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2263,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "32568:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2269,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2265,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "32591:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2266,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "HAWAII",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "32591:14:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2264,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "32584:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2267,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "32584:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "32568:39:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2270,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 2268,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "32608:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "32568:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2271,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "32613:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "32568:54:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2273,
										"nodeType": "ExpressionStatement",
										"src": "32568:54:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2286,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2274,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "32633:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2280,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2276,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "32656:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2277,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_CANADA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "32656:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2275,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "32649:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2278,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "32649:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "32633:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2281,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2279,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "32681:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "32633:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2283,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "32693:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2284,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_USA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "32693:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2282,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "32686:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2285,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "32686:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "32633:80:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2287,
										"nodeType": "ExpressionStatement",
										"src": "32633:80:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2300,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2288,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "32723:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2294,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2290,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "32746:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2291,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_CANADA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "32746:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2289,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "32739:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2292,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "32739:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "32723:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2295,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2293,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "32771:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "32723:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2297,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "32783:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2298,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_CANADA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "32783:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2296,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "32776:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2299,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "32776:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "32723:83:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2301,
										"nodeType": "ExpressionStatement",
										"src": "32723:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2314,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2302,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "32816:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2308,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2304,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "32839:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2305,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_CANADA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "32839:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2303,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "32832:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2306,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "32832:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "32816:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2309,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2307,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "32864:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "32816:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2311,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "32876:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2312,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_RUSSIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "32876:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2310,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "32869:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2313,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "32869:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "32816:83:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2315,
										"nodeType": "ExpressionStatement",
										"src": "32816:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2325,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2316,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "32909:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2322,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2318,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "32932:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2319,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_CANADA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "32932:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2317,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "32925:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2320,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "32925:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "32909:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2323,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 2321,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "32957:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "32909:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2324,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "32962:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "32909:62:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2326,
										"nodeType": "ExpressionStatement",
										"src": "32909:62:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2336,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2327,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "32981:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2333,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2329,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "33004:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2330,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_CANADA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "33004:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2328,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "32997:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2331,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "32997:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "32981:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2334,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 2332,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "33029:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "32981:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2335,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "33034:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "32981:62:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2337,
										"nodeType": "ExpressionStatement",
										"src": "32981:62:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2350,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2338,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "33054:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2344,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2340,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "33077:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2341,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_CANADA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "33077:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2339,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "33070:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2342,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "33070:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "33054:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2345,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2343,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "33102:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "33054:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2347,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "33114:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2348,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_CANADA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "33114:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2346,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "33107:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2349,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "33107:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "33054:83:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2351,
										"nodeType": "ExpressionStatement",
										"src": "33054:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2364,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2352,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "33147:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2358,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2354,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "33170:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2355,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_CANADA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "33170:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2353,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "33163:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2356,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "33163:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "33147:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2359,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2357,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "33195:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "33147:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2361,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "33207:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2362,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "GREENLAND",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "33207:17:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2360,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "33200:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2363,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "33200:25:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "33147:78:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2365,
										"nodeType": "ExpressionStatement",
										"src": "33147:78:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2378,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2366,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "33235:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2372,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2368,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "33258:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2369,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_CANADA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "33258:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2367,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "33251:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2370,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "33251:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "33235:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2373,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2371,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "33283:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "33235:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2375,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "33295:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2376,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_USA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "33295:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2374,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "33288:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2377,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "33288:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "33235:80:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2379,
										"nodeType": "ExpressionStatement",
										"src": "33235:80:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2389,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2380,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "33325:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2386,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2382,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "33348:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2383,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_CANADA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "33348:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2381,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "33341:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2384,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "33341:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "33325:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2387,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 2385,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "33373:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "33325:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2388,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "33378:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "33325:62:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2390,
										"nodeType": "ExpressionStatement",
										"src": "33325:62:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2400,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2391,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "33397:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2397,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2393,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "33420:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2394,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_CANADA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "33420:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2392,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "33413:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2395,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "33413:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "33397:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2398,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 2396,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "33445:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "33397:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2399,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "33450:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "33397:62:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2401,
										"nodeType": "ExpressionStatement",
										"src": "33397:62:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2414,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2402,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "33470:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2408,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2404,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "33493:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2405,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_USA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "33493:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2403,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "33486:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2406,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "33486:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "33470:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2409,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2407,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "33515:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "33470:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2411,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "33527:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2412,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "HAWAII",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "33527:14:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2410,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "33520:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2413,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "33520:22:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "33470:72:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2415,
										"nodeType": "ExpressionStatement",
										"src": "33470:72:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2428,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2416,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "33552:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2422,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2418,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "33575:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2419,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_USA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "33575:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2417,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "33568:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2420,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "33568:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "33552:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2423,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2421,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "33597:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "33552:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2425,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "33609:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2426,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_CANADA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "33609:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2424,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "33602:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2427,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "33602:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "33552:80:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2429,
										"nodeType": "ExpressionStatement",
										"src": "33552:80:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2442,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2430,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "33642:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2436,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2432,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "33665:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2433,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_USA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "33665:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2431,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "33658:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2434,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "33658:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "33642:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2437,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2435,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "33687:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "33642:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2439,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "33699:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2440,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_USA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "33699:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2438,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "33692:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2441,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "33692:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "33642:77:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2443,
										"nodeType": "ExpressionStatement",
										"src": "33642:77:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2456,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2444,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "33729:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2450,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2446,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "33752:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2447,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_USA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "33752:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2445,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "33745:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2448,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "33745:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "33729:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2451,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 2449,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "33774:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "33729:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2453,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "33786:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2454,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "NORTHERN_SOUTH_AMERICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "33786:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2452,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "33779:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2455,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "33779:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "33729:88:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2457,
										"nodeType": "ExpressionStatement",
										"src": "33729:88:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2467,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2458,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "33827:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2464,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2460,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "33850:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2461,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_USA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "33850:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2459,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "33843:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2462,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "33843:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "33827:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2465,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 2463,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "33872:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "33827:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2466,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "33877:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "33827:59:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2468,
										"nodeType": "ExpressionStatement",
										"src": "33827:59:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2481,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2469,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "33897:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2475,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2471,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "33920:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2472,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_USA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "33920:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2470,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "33913:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2473,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "33913:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "33897:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2476,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2474,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "33942:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "33897:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2478,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "33954:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2479,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_USA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "33954:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2477,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "33947:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2480,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "33947:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "33897:77:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2482,
										"nodeType": "ExpressionStatement",
										"src": "33897:77:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2495,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2483,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "33984:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2489,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2485,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "34007:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2486,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_USA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "34007:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2484,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "34000:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2487,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "34000:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "33984:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2490,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2488,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "34029:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "33984:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2492,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "34041:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2493,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_CANADA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "34041:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2491,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "34034:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2494,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "34034:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "33984:80:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2496,
										"nodeType": "ExpressionStatement",
										"src": "33984:80:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2509,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2497,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "34074:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2503,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2499,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "34097:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2500,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_USA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "34097:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2498,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "34090:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2501,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "34090:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "34074:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2504,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2502,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "34119:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "34074:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2506,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "34131:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2507,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "NORTHERN_SOUTH_AMERICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "34131:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2505,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "34124:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2508,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "34124:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "34074:88:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2510,
										"nodeType": "ExpressionStatement",
										"src": "34074:88:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2520,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2511,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "34172:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2517,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2513,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "34195:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2514,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_USA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "34195:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2512,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "34188:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2515,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "34188:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "34172:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2518,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 2516,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "34217:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "34172:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2519,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "34222:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "34172:59:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2521,
										"nodeType": "ExpressionStatement",
										"src": "34172:59:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2531,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2522,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "34241:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2528,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2524,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "34264:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2525,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_USA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "34264:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2523,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "34257:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2526,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "34257:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "34241:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2529,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 2527,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "34286:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "34241:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2530,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "34291:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "34241:59:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2532,
										"nodeType": "ExpressionStatement",
										"src": "34241:59:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2545,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2533,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "34311:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2539,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2535,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "34334:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2536,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "GREENLAND",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "34334:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2534,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "34327:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2537,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "34327:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "34311:42:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2540,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2538,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "34354:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "34311:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2542,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "34366:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2543,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_CANADA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "34366:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2541,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "34359:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2544,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "34359:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "34311:78:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2546,
										"nodeType": "ExpressionStatement",
										"src": "34311:78:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2559,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2547,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "34399:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2553,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2549,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "34422:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2550,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "GREENLAND",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "34422:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2548,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "34415:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2551,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "34415:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "34399:42:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2554,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2552,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "34442:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "34399:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2556,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "34454:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2557,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_EUROPE",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "34454:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2555,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "34447:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2558,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "34447:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "34399:78:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2560,
										"nodeType": "ExpressionStatement",
										"src": "34399:78:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2570,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2561,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "34487:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2567,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2563,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "34510:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2564,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "GREENLAND",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "34510:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2562,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "34503:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2565,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "34503:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "34487:42:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2568,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2566,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "34530:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "34487:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2569,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "34535:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "34487:57:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2571,
										"nodeType": "ExpressionStatement",
										"src": "34487:57:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2581,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2572,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "34554:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2578,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2574,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "34577:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2575,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "GREENLAND",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "34577:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2573,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "34570:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2576,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "34570:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "34554:42:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2579,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 2577,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "34597:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "34554:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2580,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "34602:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "34554:57:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2582,
										"nodeType": "ExpressionStatement",
										"src": "34554:57:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2592,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2583,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "34621:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2589,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2585,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "34644:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2586,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "GREENLAND",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "34644:17:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2584,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "34637:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2587,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "34637:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "34621:42:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2590,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 2588,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "34664:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "34621:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2591,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "34669:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "34621:57:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2593,
										"nodeType": "ExpressionStatement",
										"src": "34621:57:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2606,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2594,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "34689:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2600,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2596,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "34712:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2597,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "NORTHERN_SOUTH_AMERICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "34712:30:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2595,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "34705:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2598,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "34705:38:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "34689:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2601,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2599,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "34745:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "34689:58:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2603,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "34757:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2604,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_USA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "34757:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2602,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "34750:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2605,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "34750:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "34689:88:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2607,
										"nodeType": "ExpressionStatement",
										"src": "34689:88:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2620,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2608,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "34787:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2614,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2610,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "34810:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2611,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "NORTHERN_SOUTH_AMERICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "34810:30:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2609,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "34803:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2612,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "34803:38:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "34787:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2615,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2613,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "34843:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "34787:58:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2617,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "34855:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2618,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_USA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "34855:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2616,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "34848:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2619,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "34848:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "34787:88:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2621,
										"nodeType": "ExpressionStatement",
										"src": "34787:88:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2634,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2622,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "34885:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2628,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2624,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "34908:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2625,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "NORTHERN_SOUTH_AMERICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "34908:30:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2623,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "34901:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2626,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "34901:38:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "34885:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2629,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2627,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "34941:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "34885:58:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2631,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "34953:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2632,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "SOUTHERN_SOUTH_AMERICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "34953:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2630,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "34946:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2633,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "34946:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "34885:99:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2635,
										"nodeType": "ExpressionStatement",
										"src": "34885:99:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2645,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2636,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "34994:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2642,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2638,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "35017:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2639,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "NORTHERN_SOUTH_AMERICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "35017:30:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2637,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "35010:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2640,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "35010:38:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "34994:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2643,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 2641,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "35050:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "34994:58:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2644,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "35055:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "34994:70:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2646,
										"nodeType": "ExpressionStatement",
										"src": "34994:70:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2656,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2647,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "35074:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2653,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2649,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "35097:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2650,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "NORTHERN_SOUTH_AMERICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "35097:30:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2648,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "35090:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2651,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "35090:38:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "35074:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2654,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 2652,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "35130:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "35074:58:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2655,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "35135:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "35074:70:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2657,
										"nodeType": "ExpressionStatement",
										"src": "35074:70:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2670,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2658,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "35155:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2664,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2660,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "35178:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2661,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTHERN_SOUTH_AMERICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "35178:30:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2659,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "35171:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2662,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "35171:38:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "35155:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2665,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2663,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "35211:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "35155:58:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2667,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "35223:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2668,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "NORTHERN_SOUTH_AMERICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "35223:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2666,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "35216:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2669,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "35216:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "35155:99:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2671,
										"nodeType": "ExpressionStatement",
										"src": "35155:99:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2684,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2672,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "35264:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2678,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2674,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "35287:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2675,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTHERN_SOUTH_AMERICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "35287:30:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2673,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "35280:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2676,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "35280:38:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "35264:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2679,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2677,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "35320:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "35264:58:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2681,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "35332:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2682,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WEST_ANTARCTICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "35332:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2680,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "35325:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2683,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "35325:31:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "35264:92:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2685,
										"nodeType": "ExpressionStatement",
										"src": "35264:92:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2695,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2686,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "35366:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2692,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2688,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "35389:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2689,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTHERN_SOUTH_AMERICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "35389:30:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2687,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "35382:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2690,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "35382:38:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "35366:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2693,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2691,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "35422:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "35366:58:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2694,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "35427:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "35366:70:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2696,
										"nodeType": "ExpressionStatement",
										"src": "35366:70:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2706,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2697,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "35446:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2703,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2699,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "35469:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2700,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTHERN_SOUTH_AMERICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "35469:30:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2698,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "35462:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2701,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "35462:38:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "35446:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2704,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 2702,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "35502:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "35446:58:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2705,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "35507:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "35446:70:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2707,
										"nodeType": "ExpressionStatement",
										"src": "35446:70:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2717,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2708,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "35526:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2714,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2710,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "35549:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2711,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTHERN_SOUTH_AMERICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "35549:30:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2709,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "35542:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2712,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "35542:38:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "35526:55:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2715,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 2713,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "35582:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "35526:58:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2716,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "35587:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "35526:70:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2718,
										"nodeType": "ExpressionStatement",
										"src": "35526:70:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2731,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2719,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "35607:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2725,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2721,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "35630:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2722,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WEST_ANTARCTICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "35630:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2720,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "35623:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2723,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "35623:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "35607:48:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2726,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2724,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "35656:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "35607:51:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2728,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "35668:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2729,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "SOUTHERN_SOUTH_AMERICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "35668:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2727,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "35661:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2730,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "35661:38:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "35607:92:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2732,
										"nodeType": "ExpressionStatement",
										"src": "35607:92:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2745,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2733,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "35709:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2739,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2735,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "35732:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2736,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WEST_ANTARCTICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "35732:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2734,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "35725:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2737,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "35725:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "35709:48:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2740,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2738,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "35758:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "35709:51:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2742,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "35770:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2743,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EAST_ANTARCTICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "35770:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2741,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "35763:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2744,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "35763:31:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "35709:85:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2746,
										"nodeType": "ExpressionStatement",
										"src": "35709:85:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2756,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2747,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "35804:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2753,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2749,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "35827:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2750,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WEST_ANTARCTICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "35827:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2748,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "35820:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2751,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "35820:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "35804:48:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2754,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2752,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "35853:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "35804:51:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2755,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "35858:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "35804:63:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2757,
										"nodeType": "ExpressionStatement",
										"src": "35804:63:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2767,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2758,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "35877:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2764,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2760,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "35900:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2761,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WEST_ANTARCTICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "35900:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2759,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "35893:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2762,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "35893:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "35877:48:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2765,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 2763,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "35926:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "35877:51:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2766,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "35931:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "35877:63:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2768,
										"nodeType": "ExpressionStatement",
										"src": "35877:63:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2778,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2769,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "35950:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2775,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2771,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "35973:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2772,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WEST_ANTARCTICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "35973:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2770,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "35966:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2773,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "35966:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "35950:48:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2776,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 2774,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "35999:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "35950:51:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2777,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "36004:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "35950:63:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2779,
										"nodeType": "ExpressionStatement",
										"src": "35950:63:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2792,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2780,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "36024:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2786,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2782,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "36047:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2783,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EAST_ANTARCTICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "36047:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2781,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "36040:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2784,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "36040:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "36024:48:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2787,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2785,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "36073:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "36024:51:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2789,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "36085:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2790,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WEST_ANTARCTICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "36085:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2788,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "36078:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2791,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "36078:31:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "36024:85:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2793,
										"nodeType": "ExpressionStatement",
										"src": "36024:85:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2806,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2794,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "36119:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2800,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2796,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "36142:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2797,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EAST_ANTARCTICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "36142:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2795,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "36135:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2798,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "36135:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "36119:48:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2801,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2799,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "36168:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "36119:51:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2803,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "36180:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2804,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "NEW_ZEALAND",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "36180:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2802,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "36173:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2805,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "36173:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "36119:81:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2807,
										"nodeType": "ExpressionStatement",
										"src": "36119:81:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2817,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2808,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "36210:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2814,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2810,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "36233:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2811,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EAST_ANTARCTICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "36233:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2809,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "36226:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2812,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "36226:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "36210:48:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2815,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2813,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "36259:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "36210:51:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2816,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "36264:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "36210:63:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2818,
										"nodeType": "ExpressionStatement",
										"src": "36210:63:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2828,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2819,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "36283:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2825,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2821,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "36306:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2822,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EAST_ANTARCTICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "36306:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2820,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "36299:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2823,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "36299:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "36283:48:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2826,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 2824,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "36332:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "36283:51:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2827,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "36337:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "36283:63:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2829,
										"nodeType": "ExpressionStatement",
										"src": "36283:63:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2839,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2830,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "36356:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2836,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2832,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "36379:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2833,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EAST_ANTARCTICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "36379:23:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2831,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "36372:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2834,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "36372:31:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "36356:48:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2837,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 2835,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "36405:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "36356:51:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2838,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "36410:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "36356:63:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2840,
										"nodeType": "ExpressionStatement",
										"src": "36356:63:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2853,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2841,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "36430:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2847,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2843,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "36453:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2844,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_EUROPE",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "36453:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2842,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "36446:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2845,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "36446:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "36430:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2848,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2846,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "36478:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "36430:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2850,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "36490:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2851,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "GREENLAND",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "36490:17:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2849,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "36483:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2852,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "36483:25:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "36430:78:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2854,
										"nodeType": "ExpressionStatement",
										"src": "36430:78:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2867,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2855,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "36518:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2861,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2857,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "36541:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2858,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_EUROPE",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "36541:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2856,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "36534:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2859,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "36534:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "36518:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2862,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2860,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "36566:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "36518:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2864,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "36578:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2865,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_EUROPE",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "36578:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2863,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "36571:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2866,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "36571:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "36518:83:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2868,
										"nodeType": "ExpressionStatement",
										"src": "36518:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2881,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2869,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "36611:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2875,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2871,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "36634:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2872,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_EUROPE",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "36634:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2870,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "36627:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2873,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "36627:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "36611:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2876,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2874,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "36659:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "36611:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2878,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "36671:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2879,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WEST_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "36671:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2877,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "36664:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2880,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "36664:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "36611:80:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2882,
										"nodeType": "ExpressionStatement",
										"src": "36611:80:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2892,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2883,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "36701:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2889,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2885,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "36724:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2886,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_EUROPE",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "36724:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2884,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "36717:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2887,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "36717:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "36701:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2890,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 2888,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "36749:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "36701:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2891,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "36754:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "36701:62:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2893,
										"nodeType": "ExpressionStatement",
										"src": "36701:62:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2903,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2894,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "36773:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2900,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2896,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "36796:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2897,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_EUROPE",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "36796:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2895,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "36789:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2898,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "36789:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "36773:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2901,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 2899,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "36821:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "36773:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2902,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "36826:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "36773:62:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2904,
										"nodeType": "ExpressionStatement",
										"src": "36773:62:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2917,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2905,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "36846:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2911,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2907,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "36869:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2908,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_EUROPE",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "36869:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2906,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "36862:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2909,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "36862:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "36846:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2912,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2910,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "36894:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "36846:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2914,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "36906:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2915,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_EUROPE",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "36906:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2913,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "36899:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2916,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "36899:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "36846:83:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2918,
										"nodeType": "ExpressionStatement",
										"src": "36846:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2931,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2919,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "36939:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2925,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2921,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "36962:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2922,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_EUROPE",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "36962:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2920,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "36955:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2923,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "36955:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "36939:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2926,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2924,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "36987:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "36939:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2928,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "36999:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2929,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WEST_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "36999:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2927,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "36992:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2930,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "36992:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "36939:80:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2932,
										"nodeType": "ExpressionStatement",
										"src": "36939:80:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2945,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2933,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "37029:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2939,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2935,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "37052:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2936,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_EUROPE",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "37052:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2934,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "37045:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2937,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "37045:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "37029:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2940,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 2938,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "37077:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "37029:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2942,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "37089:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2943,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "MIDDLE_EAST",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "37089:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2941,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "37082:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2944,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "37082:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "37029:80:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2946,
										"nodeType": "ExpressionStatement",
										"src": "37029:80:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2959,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2947,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "37119:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2953,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2949,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "37142:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2950,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_EUROPE",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "37142:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2948,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "37135:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2951,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "37135:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "37119:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2954,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 2952,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "37167:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "37119:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2956,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "37179:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2957,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "CENTRAL_RUSSIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "37179:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2955,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "37172:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2958,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "37172:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "37119:83:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2960,
										"nodeType": "ExpressionStatement",
										"src": "37119:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2970,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2961,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "37212:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2967,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2963,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "37235:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2964,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_EUROPE",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "37235:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2962,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "37228:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2965,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "37228:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "37212:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2968,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 2966,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "37260:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "37212:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 2969,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "37265:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "37212:62:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2971,
										"nodeType": "ExpressionStatement",
										"src": "37212:62:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2984,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2972,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "37285:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2978,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2974,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "37308:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2975,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "CENTRAL_RUSSIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "37308:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2973,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "37301:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2976,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "37301:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "37285:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2979,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2977,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "37333:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "37285:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2981,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "37345:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2982,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_EUROPE",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "37345:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2980,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "37338:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2983,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "37338:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "37285:83:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2985,
										"nodeType": "ExpressionStatement",
										"src": "37285:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 2998,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2986,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "37378:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 2992,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 2988,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "37401:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 2989,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "CENTRAL_RUSSIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "37401:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 2987,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "37394:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 2990,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "37394:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "37378:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 2993,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2991,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "37426:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "37378:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2995,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "37438:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 2996,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "MIDDLE_EAST",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "37438:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 2994,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "37431:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 2997,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "37431:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "37378:80:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 2999,
										"nodeType": "ExpressionStatement",
										"src": "37378:80:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3012,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3000,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "37468:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3006,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3002,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "37491:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3003,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "CENTRAL_RUSSIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "37491:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3001,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "37484:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3004,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "37484:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "37468:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3007,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3005,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "37516:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "37468:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3009,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "37528:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3010,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "INDIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "37528:13:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3008,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "37521:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3011,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "37521:21:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "37468:74:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3013,
										"nodeType": "ExpressionStatement",
										"src": "37468:74:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3026,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3014,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "37552:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3020,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3016,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "37575:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3017,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "CENTRAL_RUSSIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "37575:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3015,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "37568:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3018,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "37568:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "37552:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3021,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3019,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "37600:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "37552:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3023,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "37612:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3024,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_CHINA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "37612:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3022,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "37605:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3025,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "37605:29:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "37552:82:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3027,
										"nodeType": "ExpressionStatement",
										"src": "37552:82:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3040,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3028,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "37644:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3034,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3030,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "37667:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3031,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "CENTRAL_RUSSIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "37667:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3029,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "37660:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3032,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "37660:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "37644:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3035,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3033,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "37692:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "37644:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3037,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "37704:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3038,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_RUSSIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "37704:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3036,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "37697:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3039,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "37697:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "37644:83:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3041,
										"nodeType": "ExpressionStatement",
										"src": "37644:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3054,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3042,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "37738:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3048,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3044,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "37761:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3045,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_RUSSIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "37761:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3043,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "37754:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3046,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "37754:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "37738:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3049,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 3047,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "37786:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "37738:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3051,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "37798:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3052,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_CHINA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "37798:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3050,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "37791:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3053,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "37791:29:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "37738:82:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3055,
										"nodeType": "ExpressionStatement",
										"src": "37738:82:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3068,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3056,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "37830:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3062,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3058,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "37853:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3059,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_RUSSIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "37853:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3057,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "37846:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3060,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "37846:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "37830:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3063,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 3061,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "37878:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "37830:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3065,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "37890:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3066,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "CENTRAL_RUSSIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "37890:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3064,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "37883:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3067,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "37883:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "37830:83:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3069,
										"nodeType": "ExpressionStatement",
										"src": "37830:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3082,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3070,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "37923:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3076,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3072,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "37946:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3073,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_RUSSIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "37946:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3071,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "37939:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3074,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "37939:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "37923:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3077,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3075,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "37971:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "37923:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3079,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "37983:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3080,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_CANADA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "37983:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3078,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "37976:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3081,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "37976:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "37923:83:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3083,
										"nodeType": "ExpressionStatement",
										"src": "37923:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3093,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3084,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "38016:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3090,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3086,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "38039:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3087,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_RUSSIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "38039:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3085,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "38032:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3088,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "38032:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "38016:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3091,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3089,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "38064:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "38016:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3092,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "38069:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "38016:62:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3094,
										"nodeType": "ExpressionStatement",
										"src": "38016:62:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3104,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3095,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "38088:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3101,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3097,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "38111:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3098,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_RUSSIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "38111:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3096,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "38104:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3099,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "38104:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "38088:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3102,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3100,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "38136:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "38088:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3103,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "38141:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "38088:62:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3105,
										"nodeType": "ExpressionStatement",
										"src": "38088:62:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3118,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3106,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "38161:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3112,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3108,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "38184:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3109,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WEST_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "38184:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3107,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "38177:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3110,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "38177:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "38161:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3113,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 3111,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "38206:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "38161:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3115,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "38218:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3116,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_EUROPE",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "38218:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3114,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "38211:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3117,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "38211:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "38161:80:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3119,
										"nodeType": "ExpressionStatement",
										"src": "38161:80:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3132,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3120,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "38251:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3126,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3122,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "38274:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3123,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WEST_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "38274:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3121,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "38267:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3124,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "38267:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "38251:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3127,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 3125,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "38296:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "38251:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3129,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "38308:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3130,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_EUROPE",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "38308:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3128,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "38301:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3131,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "38301:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "38251:80:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3133,
										"nodeType": "ExpressionStatement",
										"src": "38251:80:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3146,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3134,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "38341:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3140,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3136,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "38364:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3137,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WEST_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "38364:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3135,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "38357:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3138,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "38357:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "38341:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3141,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3139,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "38386:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "38341:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3143,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "38398:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3144,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "MIDDLE_EAST",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "38398:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3142,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "38391:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3145,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "38391:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "38341:77:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3147,
										"nodeType": "ExpressionStatement",
										"src": "38341:77:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3160,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3148,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "38428:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3154,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3150,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "38451:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3151,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WEST_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "38451:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3149,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "38444:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3152,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "38444:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "38428:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3155,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3153,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "38473:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "38428:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3157,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "38485:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3158,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EAST_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "38485:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3156,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "38478:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3159,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "38478:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "38428:77:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3161,
										"nodeType": "ExpressionStatement",
										"src": "38428:77:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3174,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3162,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "38515:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3168,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3164,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "38538:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3165,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WEST_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "38538:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3163,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "38531:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3166,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "38531:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "38515:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3169,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3167,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "38560:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "38515:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3171,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "38572:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3172,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "SOUTH_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "38572:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3170,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "38565:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3173,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "38565:28:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "38515:78:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3175,
										"nodeType": "ExpressionStatement",
										"src": "38515:78:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3188,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3176,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "38604:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3182,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3178,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "38627:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3179,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "MIDDLE_EAST",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "38627:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3177,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "38620:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3180,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "38620:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "38604:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3183,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 3181,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "38649:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "38604:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3185,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "38661:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3186,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_EUROPE",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "38661:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3184,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "38654:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3187,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "38654:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "38604:80:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3189,
										"nodeType": "ExpressionStatement",
										"src": "38604:80:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3202,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3190,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "38694:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3196,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3192,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "38717:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3193,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "MIDDLE_EAST",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "38717:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3191,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "38710:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3194,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "38710:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "38694:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3197,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 3195,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "38739:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "38694:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3199,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "38751:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3200,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "CENTRAL_RUSSIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "38751:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3198,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "38744:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3201,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "38744:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "38694:80:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3203,
										"nodeType": "ExpressionStatement",
										"src": "38694:80:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3216,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3204,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "38784:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3210,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3206,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "38807:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3207,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "MIDDLE_EAST",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "38807:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3205,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "38800:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3208,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "38800:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "38784:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3211,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3209,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "38829:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "38784:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3213,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "38841:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3214,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "INDIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "38841:13:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3212,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "38834:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3215,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "38834:21:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "38784:71:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3217,
										"nodeType": "ExpressionStatement",
										"src": "38784:71:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3230,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3218,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "38865:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3224,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3220,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "38888:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3221,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "MIDDLE_EAST",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "38888:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3219,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "38881:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3222,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "38881:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "38865:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3225,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3223,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "38910:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "38865:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3227,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "38922:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3228,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EAST_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "38922:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3226,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "38915:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3229,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "38915:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "38865:77:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3231,
										"nodeType": "ExpressionStatement",
										"src": "38865:77:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3244,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3232,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "38952:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3238,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3234,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "38975:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3235,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "MIDDLE_EAST",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "38975:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3233,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "38968:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3236,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "38968:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "38952:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3239,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3237,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "38997:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "38952:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3241,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "39009:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3242,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WEST_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "39009:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3240,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "39002:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3243,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "39002:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "38952:77:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3245,
										"nodeType": "ExpressionStatement",
										"src": "38952:77:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3258,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3246,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "39040:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3252,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3248,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "39063:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3249,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EAST_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "39063:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3247,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "39056:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3250,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "39056:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "39040:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3253,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 3251,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "39085:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "39040:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3255,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "39097:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3256,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WEST_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "39097:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3254,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "39090:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3257,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "39090:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "39040:77:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3259,
										"nodeType": "ExpressionStatement",
										"src": "39040:77:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3272,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3260,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "39127:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3266,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3262,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "39150:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3263,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EAST_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "39150:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3261,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "39143:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3264,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "39143:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "39127:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3267,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 3265,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "39172:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "39127:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3269,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "39184:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3270,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "SOUTH_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "39184:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3268,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "39177:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3271,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "39177:28:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "39127:78:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3273,
										"nodeType": "ExpressionStatement",
										"src": "39127:78:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3286,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3274,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "39215:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3280,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3276,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "39238:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3277,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EAST_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "39238:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3275,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "39231:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3278,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "39231:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "39215:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3281,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3279,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "39260:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "39215:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3283,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "39272:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3284,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "MIDDLE_EAST",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "39272:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3282,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "39265:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3285,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "39265:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "39215:77:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3287,
										"nodeType": "ExpressionStatement",
										"src": "39215:77:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3300,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3288,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "39302:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3294,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3290,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "39325:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3291,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EAST_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "39325:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3289,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "39318:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3292,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "39318:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "39302:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3295,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3293,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "39347:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "39302:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3297,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "39359:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3298,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "INDIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "39359:13:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3296,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "39352:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3299,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "39352:21:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "39302:71:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3301,
										"nodeType": "ExpressionStatement",
										"src": "39302:71:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3311,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3302,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "39383:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3308,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3304,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "39406:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3305,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EAST_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "39406:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3303,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "39399:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3306,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "39399:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "39383:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3309,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3307,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "39428:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "39383:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3310,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "39433:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "39383:59:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3312,
										"nodeType": "ExpressionStatement",
										"src": "39383:59:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3325,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3313,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "39453:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3319,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3315,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "39476:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3316,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTH_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "39476:20:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3314,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "39469:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3317,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "39469:28:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "39453:45:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3320,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 3318,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "39499:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "39453:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3322,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "39511:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3323,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WEST_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "39511:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3321,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "39504:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3324,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "39504:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "39453:78:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3326,
										"nodeType": "ExpressionStatement",
										"src": "39453:78:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3339,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3327,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "39541:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3333,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3329,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "39564:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3330,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTH_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "39564:20:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3328,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "39557:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3331,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "39557:28:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "39541:45:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3334,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 3332,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "39587:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "39541:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3336,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "39599:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3337,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EAST_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "39599:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3335,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "39592:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3338,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "39592:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "39541:78:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3340,
										"nodeType": "ExpressionStatement",
										"src": "39541:78:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3350,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3341,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "39629:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3347,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3343,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "39652:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3344,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTH_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "39652:20:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3342,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "39645:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3345,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "39645:28:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "39629:45:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3348,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3346,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "39675:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "39629:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3349,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "39680:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "39629:60:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3351,
										"nodeType": "ExpressionStatement",
										"src": "39629:60:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3361,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3352,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "39699:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3358,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3354,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "39722:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3355,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTH_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "39722:20:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3353,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "39715:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3356,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "39715:28:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "39699:45:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3359,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3357,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "39745:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "39699:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3360,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "39750:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "39699:60:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3362,
										"nodeType": "ExpressionStatement",
										"src": "39699:60:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3372,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3363,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "39769:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3369,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3365,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "39792:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3366,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTH_AFRICA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "39792:20:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3364,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "39785:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3367,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "39785:28:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "39769:45:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3370,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3368,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "39815:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "39769:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3371,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "39820:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "39769:60:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3373,
										"nodeType": "ExpressionStatement",
										"src": "39769:60:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3386,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3374,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "39840:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3380,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3376,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "39863:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3377,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "INDIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "39863:13:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3375,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "39856:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3378,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "39856:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "39840:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3381,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 3379,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "39879:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "39840:41:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3383,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "39891:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3384,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EAST_AFRICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "39891:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3382,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "39884:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3385,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "39884:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "39840:71:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3387,
										"nodeType": "ExpressionStatement",
										"src": "39840:71:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3400,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3388,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "39921:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3394,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3390,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "39944:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3391,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "INDIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "39944:13:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3389,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "39937:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3392,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "39937:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "39921:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3395,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 3393,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "39960:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "39921:41:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3397,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "39972:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3398,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "MIDDLE_EAST",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "39972:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3396,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "39965:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3399,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "39965:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "39921:71:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3401,
										"nodeType": "ExpressionStatement",
										"src": "39921:71:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3414,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3402,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "40002:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3408,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3404,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "40025:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3405,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "INDIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "40025:13:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3403,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "40018:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3406,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "40018:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "40002:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3409,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3407,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "40041:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "40002:41:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3411,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "40053:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3412,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "CENTRAL_RUSSIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "40053:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3410,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "40046:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3413,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "40046:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "40002:74:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3415,
										"nodeType": "ExpressionStatement",
										"src": "40002:74:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3428,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3416,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "40086:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3422,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3418,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "40109:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3419,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "INDIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "40109:13:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3417,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "40102:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3420,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "40102:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "40086:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3423,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3421,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "40125:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "40086:41:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3425,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "40137:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3426,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_CHINA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "40137:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3424,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "40130:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3427,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "40130:29:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "40086:73:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3429,
										"nodeType": "ExpressionStatement",
										"src": "40086:73:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3442,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3430,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "40169:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3436,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3432,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "40192:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3433,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "INDIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "40192:13:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3431,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "40185:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3434,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "40185:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "40169:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3437,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3435,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "40208:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "40169:41:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3439,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "40220:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3440,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "SOUTHEAST_ASIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "40220:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3438,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "40213:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3441,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "40213:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "40169:74:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3443,
										"nodeType": "ExpressionStatement",
										"src": "40169:74:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3456,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3444,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "40254:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3450,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3446,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "40277:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3447,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_CHINA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "40277:21:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3445,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "40270:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3448,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "40270:29:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "40254:46:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3451,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 3449,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "40301:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "40254:49:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3453,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "40313:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3454,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "INDIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "40313:13:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3452,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "40306:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3455,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "40306:21:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "40254:73:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3457,
										"nodeType": "ExpressionStatement",
										"src": "40254:73:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3470,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3458,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "40337:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3464,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3460,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "40360:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3461,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_CHINA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "40360:21:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3459,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "40353:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3462,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "40353:29:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "40337:46:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3465,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 3463,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "40384:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "40337:49:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3467,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "40396:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3468,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "CENTRAL_RUSSIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "40396:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3466,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "40389:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3469,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "40389:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "40337:82:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3471,
										"nodeType": "ExpressionStatement",
										"src": "40337:82:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3484,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3472,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "40429:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3478,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3474,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "40452:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3475,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_CHINA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "40452:21:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3473,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "40445:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3476,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "40445:29:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "40429:46:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3479,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3477,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "40476:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "40429:49:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3481,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "40488:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3482,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_RUSSIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "40488:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3480,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "40481:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3483,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "40481:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "40429:82:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3485,
										"nodeType": "ExpressionStatement",
										"src": "40429:82:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3498,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3486,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "40521:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3492,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3488,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "40544:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3489,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_CHINA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "40544:21:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3487,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "40537:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3490,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "40537:29:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "40521:46:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3493,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3491,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "40568:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "40521:49:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3495,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "40580:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3496,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "SOUTHEAST_ASIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "40580:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3494,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "40573:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3497,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "40573:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "40521:82:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3499,
										"nodeType": "ExpressionStatement",
										"src": "40521:82:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3509,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3500,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "40613:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3506,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3502,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "40636:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3503,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_CHINA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "40636:21:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3501,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "40629:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3504,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "40629:29:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "40613:46:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3507,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3505,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "40660:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "40613:49:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3508,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "40665:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "40613:61:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3510,
										"nodeType": "ExpressionStatement",
										"src": "40613:61:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3523,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3511,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "40685:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3517,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3513,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "40708:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3514,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTHEAST_ASIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "40708:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3512,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "40701:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3515,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "40701:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "40685:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3518,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 3516,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "40733:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "40685:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3520,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "40745:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3521,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "INDIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "40745:13:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3519,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "40738:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3522,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "40738:21:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "40685:74:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3524,
										"nodeType": "ExpressionStatement",
										"src": "40685:74:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3537,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3525,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "40769:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3531,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3527,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "40792:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3528,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTHEAST_ASIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "40792:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3526,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "40785:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3529,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "40785:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "40769:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3532,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 3530,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "40817:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "40769:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3534,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "40829:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3535,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_CHINA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "40829:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3533,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "40822:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3536,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "40822:29:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "40769:82:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3538,
										"nodeType": "ExpressionStatement",
										"src": "40769:82:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3551,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3539,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "40861:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3545,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3541,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "40884:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3542,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTHEAST_ASIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "40884:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3540,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "40877:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3543,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "40877:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "40861:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3546,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3544,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "40909:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "40861:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3548,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "40921:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3549,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_AUSTRALIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "40921:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3547,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "40914:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3550,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "40914:33:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "40861:86:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3552,
										"nodeType": "ExpressionStatement",
										"src": "40861:86:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3565,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3553,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "40957:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3559,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3555,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "40980:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3556,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTHEAST_ASIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "40980:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3554,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "40973:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3557,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "40973:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "40957:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3560,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3558,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "41005:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "40957:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3562,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "41017:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3563,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_AUSTRALIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "41017:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3561,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "41010:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3564,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "41010:33:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "40957:86:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3566,
										"nodeType": "ExpressionStatement",
										"src": "40957:86:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3579,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3567,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "41053:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3573,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3569,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "41076:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3570,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "SOUTHEAST_ASIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "41076:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3568,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "41069:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3571,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "41069:30:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "41053:47:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3574,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3572,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "41101:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "41053:50:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3576,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "41113:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3577,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "FIJI",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "41113:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3575,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "41106:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3578,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "41106:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "41053:73:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3580,
										"nodeType": "ExpressionStatement",
										"src": "41053:73:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3593,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3581,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "41137:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3587,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3583,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "41160:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3584,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_AUSTRALIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "41160:25:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3582,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "41153:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3585,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "41153:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "41137:50:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3588,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 3586,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "41188:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "41137:53:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3590,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "41200:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3591,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_AUSTRALIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "41200:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3589,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "41193:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3592,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "41193:33:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "41137:89:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3594,
										"nodeType": "ExpressionStatement",
										"src": "41137:89:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3607,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3595,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "41236:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3601,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3597,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "41259:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3598,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_AUSTRALIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "41259:25:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3596,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "41252:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3599,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "41252:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "41236:50:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3602,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 3600,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "41287:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "41236:53:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3604,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "41299:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3605,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "SOUTHEAST_ASIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "41299:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3603,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "41292:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3606,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "41292:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "41236:86:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3608,
										"nodeType": "ExpressionStatement",
										"src": "41236:86:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3618,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3609,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "41332:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3615,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3611,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "41355:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3612,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_AUSTRALIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "41355:25:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3610,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "41348:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3613,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "41348:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "41332:50:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3616,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3614,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "41383:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "41332:53:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3617,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "41388:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "41332:65:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3619,
										"nodeType": "ExpressionStatement",
										"src": "41332:65:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3629,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3620,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "41407:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3626,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3622,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "41430:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3623,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_AUSTRALIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "41430:25:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3621,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "41423:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3624,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "41423:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "41407:50:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3627,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3625,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "41458:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "41407:53:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3628,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "41463:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "41407:65:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3630,
										"nodeType": "ExpressionStatement",
										"src": "41407:65:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3640,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3631,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "41482:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3637,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3633,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "41505:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3634,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "WESTERN_AUSTRALIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "41505:25:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3632,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "41498:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3635,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "41498:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "41482:50:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3638,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3636,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "41533:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "41482:53:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3639,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "41538:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "41482:65:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3641,
										"nodeType": "ExpressionStatement",
										"src": "41482:65:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3654,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3642,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "41558:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3648,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3644,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "41581:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3645,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_AUSTRALIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "41581:25:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3643,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "41574:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3646,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "41574:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "41558:50:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3649,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 3647,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "41609:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "41558:53:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3651,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "41621:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3652,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "WESTERN_AUSTRALIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "41621:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3650,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "41614:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3653,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "41614:33:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "41558:89:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3655,
										"nodeType": "ExpressionStatement",
										"src": "41558:89:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3668,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3656,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "41657:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3662,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3658,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "41680:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3659,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_AUSTRALIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "41680:25:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3657,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "41673:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3660,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "41673:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "41657:50:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3663,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 3661,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "41708:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "41657:53:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3665,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "41720:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3666,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "SOUTHEAST_ASIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "41720:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3664,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "41713:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3667,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "41713:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "41657:86:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3669,
										"nodeType": "ExpressionStatement",
										"src": "41657:86:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3682,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3670,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "41753:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3676,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3672,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "41776:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3673,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_AUSTRALIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "41776:25:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3671,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "41769:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3674,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "41769:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "41753:50:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3677,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3675,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "41804:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "41753:53:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3679,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "41816:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3680,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "FIJI",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "41816:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3678,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "41809:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3681,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "41809:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "41753:76:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3683,
										"nodeType": "ExpressionStatement",
										"src": "41753:76:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3696,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3684,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "41839:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3690,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3686,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "41862:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3687,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_AUSTRALIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "41862:25:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3685,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "41855:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3688,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "41855:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "41839:50:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3691,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3689,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "41890:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "41839:53:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3693,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "41902:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3694,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "NEW_ZEALAND",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "41902:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3692,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "41895:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3695,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "41895:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "41839:83:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3697,
										"nodeType": "ExpressionStatement",
										"src": "41839:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3707,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3698,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "41932:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3704,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3700,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "41955:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3701,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "EASTERN_AUSTRALIA",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "41955:25:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3699,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "41948:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3702,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "41948:33:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "41932:50:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3705,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3703,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "41983:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "41932:53:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3706,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "41988:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "41932:65:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3708,
										"nodeType": "ExpressionStatement",
										"src": "41932:65:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3721,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3709,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "42008:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3715,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3711,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "42031:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3712,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "NEW_ZEALAND",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "42031:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3710,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "42024:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3713,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "42024:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "42008:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3716,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 3714,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "42053:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "42008:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3718,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "42065:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3719,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_AUSTRALIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "42065:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3717,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "42058:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3720,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "42058:33:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "42008:83:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3722,
										"nodeType": "ExpressionStatement",
										"src": "42008:83:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3735,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3723,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "42101:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3729,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3725,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "42124:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3726,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "NEW_ZEALAND",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "42124:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3724,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "42117:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3727,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "42117:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "42101:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3730,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 3728,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "42146:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "42101:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3732,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "42158:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3733,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "FIJI",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "42158:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3731,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "42151:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3734,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "42151:20:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "42101:70:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3736,
										"nodeType": "ExpressionStatement",
										"src": "42101:70:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3749,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3737,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "42181:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3743,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3739,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "42204:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3740,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "NEW_ZEALAND",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "42204:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3738,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "42197:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3741,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "42197:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "42181:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3744,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3742,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "42226:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "42181:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3746,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "42238:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3747,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EAST_ANTARCTICA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "42238:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3745,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "42231:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3748,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "42231:31:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "42181:81:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3750,
										"nodeType": "ExpressionStatement",
										"src": "42181:81:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3760,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3751,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "42272:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3757,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3753,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "42295:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3754,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "NEW_ZEALAND",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "42295:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3752,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "42288:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3755,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "42288:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "42272:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3758,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3756,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "42317:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "42272:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3759,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "42322:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "42272:59:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3761,
										"nodeType": "ExpressionStatement",
										"src": "42272:59:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3771,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3762,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "42341:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3768,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3764,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "42364:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3765,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "NEW_ZEALAND",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "42364:19:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3763,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "42357:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3766,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "42357:27:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "42341:44:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3769,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3767,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "42386:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "42341:47:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3770,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "42391:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "42341:59:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3772,
										"nodeType": "ExpressionStatement",
										"src": "42341:59:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3785,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3773,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "42411:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3779,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3775,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "42434:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3776,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "FIJI",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "42434:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3774,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "42427:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3777,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "42427:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "42411:37:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3780,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 3778,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "42449:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "42411:40:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3782,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "42461:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3783,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "NEW_ZEALAND",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "42461:19:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3781,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "42454:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3784,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "42454:27:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "42411:70:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3786,
										"nodeType": "ExpressionStatement",
										"src": "42411:70:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3799,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3787,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "42491:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3793,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3789,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "42514:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3790,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "FIJI",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "42514:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3788,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "42507:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3791,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "42507:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "42491:37:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3794,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 3792,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "42529:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1_by_1",
														"typeString": "int_const 1"
													},
													"value": "1"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "42491:40:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3796,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "42541:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3797,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "EASTERN_AUSTRALIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "42541:25:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3795,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "42534:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3798,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "42534:33:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "42491:76:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3800,
										"nodeType": "ExpressionStatement",
										"src": "42491:76:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3813,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3801,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "42577:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3807,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3803,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "42600:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3804,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "FIJI",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "42600:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3802,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "42593:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3805,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "42593:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "42577:37:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3808,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "32",
													"id": 3806,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "42615:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_2_by_1",
														"typeString": "int_const 2"
													},
													"value": "2"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "42577:40:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3810,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "42627:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3811,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "SOUTHEAST_ASIA",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "42627:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3809,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "42620:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3812,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "42620:30:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "42577:73:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3814,
										"nodeType": "ExpressionStatement",
										"src": "42577:73:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3827,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3815,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "42660:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3821,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3817,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "42683:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3818,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "FIJI",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "42683:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3816,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "42676:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3819,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "42676:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "42660:37:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3822,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "33",
													"id": 3820,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "42698:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_3_by_1",
														"typeString": "int_const 3"
													},
													"value": "3"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "42660:40:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 3824,
															"name": "Regions",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 212,
															"src": "42710:7:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																"typeString": "type(enum WorldGame.Regions)"
															}
														},
														"id": 3825,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"memberName": "HAWAII",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "42710:14:2",
														"typeDescriptions": {
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_enum$_Regions_$212",
															"typeString": "enum WorldGame.Regions"
														}
													],
													"id": 3823,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "42703:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_uint32_$",
														"typeString": "type(uint32)"
													},
													"typeName": "uint32"
												},
												"id": 3826,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "42703:22:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "42660:65:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3828,
										"nodeType": "ExpressionStatement",
										"src": "42660:65:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3838,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 3829,
														"name": "regionNeighbors",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 179,
														"src": "42735:15:2",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_array$_t_uint32_$5_storage_$25_storage",
															"typeString": "uint32[5] storage ref[25] storage ref"
														}
													},
													"id": 3835,
													"indexExpression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"id": 3831,
																	"name": "Regions",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 212,
																	"src": "42758:7:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																		"typeString": "type(enum WorldGame.Regions)"
																	}
																},
																"id": 3832,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"memberName": "FIJI",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "42758:12:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_enum$_Regions_$212",
																	"typeString": "enum WorldGame.Regions"
																}
															],
															"id": 3830,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "42751:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_uint32_$",
																"typeString": "type(uint32)"
															},
															"typeName": "uint32"
														},
														"id": 3833,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "42751:20:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "42735:37:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$5_storage",
														"typeString": "uint32[5] storage ref"
													}
												},
												"id": 3836,
												"indexExpression": {
													"argumentTypes": null,
													"hexValue": "34",
													"id": 3834,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "42773:1:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_4_by_1",
														"typeString": "int_const 4"
													},
													"value": "4"
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "42735:40:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"id": 3837,
												"name": "NO_REGION",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 126,
												"src": "42778:9:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "42735:52:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3839,
										"nodeType": "ExpressionStatement",
										"src": "42735:52:2"
									}
								]
							},
							"documentation": "@notice Initialize neighbor relationships between all regions\n @dev This data shared by all game instances",
							"id": 3841,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": false,
							"modifiers": [],
							"name": "initRegionNeighbors",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 2211,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "32262:2:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 2212,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "32273:0:2"
							},
							"scope": 4288,
							"src": "32234:10560:2",
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "private"
						},
						{
							"body": {
								"id": 4069,
								"nodeType": "Block",
								"src": "42958:1456:2",
								"statements": [
									{
										"expression": {
											"argumentTypes": null,
											"id": 3851,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3844,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "42968:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3849,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3846,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "42989:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3847,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "HAWAII",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "42989:14:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3845,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "42982:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3848,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "42982:22:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "42968:37:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3850,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43008:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"src": "42968:41:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3852,
										"nodeType": "ExpressionStatement",
										"src": "42968:41:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3860,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3853,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43019:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3858,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3855,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43040:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3856,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_CANADA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43040:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3854,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43033:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3857,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43033:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43019:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "36",
												"id": 3859,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43067:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_6_by_1",
													"typeString": "int_const 6"
												},
												"value": "6"
											},
											"src": "43019:49:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3861,
										"nodeType": "ExpressionStatement",
										"src": "43019:49:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3869,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3862,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43078:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3867,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3864,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43099:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3865,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_CANADA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43099:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3863,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43092:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3866,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43092:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43078:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "35",
												"id": 3868,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43126:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_5_by_1",
													"typeString": "int_const 5"
												},
												"value": "5"
											},
											"src": "43078:49:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3870,
										"nodeType": "ExpressionStatement",
										"src": "43078:49:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3878,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3871,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43137:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3876,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3873,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43158:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3874,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_USA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43158:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3872,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43151:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3875,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43151:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43137:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "3131",
												"id": 3877,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43182:2:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_11_by_1",
													"typeString": "int_const 11"
												},
												"value": "11"
											},
											"src": "43137:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3879,
										"nodeType": "ExpressionStatement",
										"src": "43137:47:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3887,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3880,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43194:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3885,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3882,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43215:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3883,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_USA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43215:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3881,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43208:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3884,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43208:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43194:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "38",
												"id": 3886,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43239:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_8_by_1",
													"typeString": "int_const 8"
												},
												"value": "8"
											},
											"src": "43194:46:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3888,
										"nodeType": "ExpressionStatement",
										"src": "43194:46:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3896,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3889,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43250:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3894,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3891,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43271:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3892,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "GREENLAND",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43271:17:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3890,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43264:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3893,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43264:25:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43250:40:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3895,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43293:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"src": "43250:44:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3897,
										"nodeType": "ExpressionStatement",
										"src": "43250:44:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3905,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3898,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43304:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3903,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3900,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43325:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3901,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "NORTHERN_SOUTH_AMERICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43325:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3899,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43318:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3902,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43318:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43304:53:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3904,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43360:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"src": "43304:57:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3906,
										"nodeType": "ExpressionStatement",
										"src": "43304:57:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3914,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3907,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43371:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3912,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3909,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43392:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3910,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTHERN_SOUTH_AMERICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43392:30:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3908,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43385:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3911,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43385:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43371:53:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3913,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43427:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"src": "43371:57:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3915,
										"nodeType": "ExpressionStatement",
										"src": "43371:57:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3923,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3916,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43438:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3921,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3918,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43459:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3919,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WEST_ANTARCTICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43459:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3917,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43452:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3920,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43452:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43438:46:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3922,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43487:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"src": "43438:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3924,
										"nodeType": "ExpressionStatement",
										"src": "43438:50:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3932,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3925,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43498:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3930,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3927,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43519:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3928,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EAST_ANTARCTICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43519:23:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3926,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43512:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3929,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43512:31:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43498:46:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 3931,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43547:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"src": "43498:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3933,
										"nodeType": "ExpressionStatement",
										"src": "43498:50:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3941,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3934,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43558:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3939,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3936,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43579:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3937,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_EUROPE",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43579:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3935,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43572:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3938,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43572:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43558:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "3130",
												"id": 3940,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43606:2:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_10_by_1",
													"typeString": "int_const 10"
												},
												"value": "10"
											},
											"src": "43558:50:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3942,
										"nodeType": "ExpressionStatement",
										"src": "43558:50:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3950,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3943,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43618:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3948,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3945,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43639:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3946,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_EUROPE",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43639:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3944,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43632:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3947,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43632:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43618:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "36",
												"id": 3949,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43666:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_6_by_1",
													"typeString": "int_const 6"
												},
												"value": "6"
											},
											"src": "43618:49:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3951,
										"nodeType": "ExpressionStatement",
										"src": "43618:49:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3959,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3952,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43677:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3957,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3954,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43698:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3955,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "CENTRAL_RUSSIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43698:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3953,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43691:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3956,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43691:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43677:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3958,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43725:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"src": "43677:49:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3960,
										"nodeType": "ExpressionStatement",
										"src": "43677:49:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3968,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3961,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43736:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3966,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3963,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43757:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3964,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_RUSSIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43757:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3962,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43750:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3965,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43750:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43736:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3967,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43784:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"src": "43736:49:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3969,
										"nodeType": "ExpressionStatement",
										"src": "43736:49:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3977,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3970,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43795:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3975,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3972,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43816:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3973,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WEST_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43816:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3971,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43809:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3974,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43809:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43795:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3976,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43840:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"src": "43795:46:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3978,
										"nodeType": "ExpressionStatement",
										"src": "43795:46:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3986,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3979,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43851:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3984,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3981,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43872:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3982,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "MIDDLE_EAST",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43872:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3980,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43865:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3983,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43865:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43851:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 3985,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43896:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"src": "43851:46:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3987,
										"nodeType": "ExpressionStatement",
										"src": "43851:46:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 3995,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3988,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43907:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 3993,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3990,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43928:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 3991,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EAST_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43928:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3989,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43921:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 3992,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43921:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43907:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "33",
												"id": 3994,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "43952:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_3_by_1",
													"typeString": "int_const 3"
												},
												"value": "3"
											},
											"src": "43907:46:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 3996,
										"nodeType": "ExpressionStatement",
										"src": "43907:46:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 4004,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 3997,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "43963:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 4002,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 3999,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "43984:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 4000,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTH_AFRICA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "43984:20:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 3998,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "43977:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 4001,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "43977:28:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "43963:43:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "35",
												"id": 4003,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "44009:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_5_by_1",
													"typeString": "int_const 5"
												},
												"value": "5"
											},
											"src": "43963:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 4005,
										"nodeType": "ExpressionStatement",
										"src": "43963:47:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 4013,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 4006,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "44020:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 4011,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 4008,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "44041:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 4009,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "INDIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "44041:13:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 4007,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "44034:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 4010,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "44034:21:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "44020:36:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "37",
												"id": 4012,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "44059:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_7_by_1",
													"typeString": "int_const 7"
												},
												"value": "7"
											},
											"src": "44020:40:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 4014,
										"nodeType": "ExpressionStatement",
										"src": "44020:40:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 4022,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 4015,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "44070:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 4020,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 4017,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "44091:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 4018,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_CHINA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "44091:21:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 4016,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "44084:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 4019,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "44084:29:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "44070:44:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "3130",
												"id": 4021,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "44117:2:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_10_by_1",
													"typeString": "int_const 10"
												},
												"value": "10"
											},
											"src": "44070:49:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 4023,
										"nodeType": "ExpressionStatement",
										"src": "44070:49:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 4031,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 4024,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "44129:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 4029,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 4026,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "44150:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 4027,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "SOUTHEAST_ASIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "44150:22:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 4025,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "44143:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 4028,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "44143:30:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "44129:45:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "35",
												"id": 4030,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "44177:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_5_by_1",
													"typeString": "int_const 5"
												},
												"value": "5"
											},
											"src": "44129:49:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 4032,
										"nodeType": "ExpressionStatement",
										"src": "44129:49:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 4040,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 4033,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "44188:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 4038,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 4035,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "44209:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 4036,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "WESTERN_AUSTRALIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "44209:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 4034,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "44202:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 4037,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "44202:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "44188:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 4039,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "44239:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"src": "44188:52:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 4041,
										"nodeType": "ExpressionStatement",
										"src": "44188:52:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 4049,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 4042,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "44250:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 4047,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 4044,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "44271:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 4045,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "EASTERN_AUSTRALIA",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "44271:25:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 4043,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "44264:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 4046,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "44264:33:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "44250:48:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "36",
												"id": 4048,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "44301:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_6_by_1",
													"typeString": "int_const 6"
												},
												"value": "6"
											},
											"src": "44250:52:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 4050,
										"nodeType": "ExpressionStatement",
										"src": "44250:52:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 4058,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 4051,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "44312:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 4056,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 4053,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "44333:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 4054,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "NEW_ZEALAND",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "44333:19:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 4052,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "44326:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 4055,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "44326:27:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "44312:42:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "34",
												"id": 4057,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "44357:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_4_by_1",
													"typeString": "int_const 4"
												},
												"value": "4"
											},
											"src": "44312:46:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 4059,
										"nodeType": "ExpressionStatement",
										"src": "44312:46:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 4067,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftHandSide": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 4060,
													"name": "regionRewards",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 183,
													"src": "44368:13:2",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_uint32_$25_storage",
														"typeString": "uint32[25] storage ref"
													}
												},
												"id": 4065,
												"indexExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 4062,
																"name": "Regions",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 212,
																"src": "44389:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_enum$_Regions_$212_$",
																	"typeString": "type(enum WorldGame.Regions)"
																}
															},
															"id": 4063,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"memberName": "FIJI",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "44389:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_enum$_Regions_$212",
																"typeString": "enum WorldGame.Regions"
															}
														],
														"id": 4061,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "44382:6:2",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint32_$",
															"typeString": "type(uint32)"
														},
														"typeName": "uint32"
													},
													"id": 4064,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "44382:20:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": true,
												"nodeType": "IndexAccess",
												"src": "44368:35:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "Assignment",
											"operator": "=",
											"rightHandSide": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 4066,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "44406:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"src": "44368:39:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"id": 4068,
										"nodeType": "ExpressionStatement",
										"src": "44368:39:2"
									}
								]
							},
							"documentation": "@notice Initialize rewards given for controlling each region\n @dev This data shared by all game instances",
							"id": 4070,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": false,
							"modifiers": [],
							"name": "initRegionRewards",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 3842,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "42947:2:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 3843,
								"nodeType": "ParameterList",
								"parameters": [],
								"src": "42958:0:2"
							},
							"scope": 4288,
							"src": "42921:1493:2",
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "private"
						},
						{
							"body": {
								"id": 4094,
								"nodeType": "Block",
								"src": "44738:107:2",
								"statements": [
									{
										"assignments": [
											4080
										],
										"declarations": [
											{
												"constant": false,
												"id": 4080,
												"name": "offset",
												"nodeType": "VariableDeclaration",
												"scope": 4095,
												"src": "44748:13:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 4079,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "44748:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 4084,
										"initialValue": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 4083,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 4081,
												"name": "index",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4074,
												"src": "44764:5:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "*",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "3332",
												"id": 4082,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "44772:2:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_32_by_1",
													"typeString": "int_const 32"
												},
												"value": "32"
											},
											"src": "44764:10:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "44748:26:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 4091,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																"id": 4088,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"id": 4086,
																	"name": "combinedData",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4072,
																	"src": "44799:12:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": ">>",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 4087,
																	"name": "offset",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4080,
																	"src": "44815:6:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "44799:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															}
														],
														"id": 4089,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "44798:24:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "&",
													"rightExpression": {
														"argumentTypes": null,
														"id": 4090,
														"name": "MASK_32_BITS",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 153,
														"src": "44825:12:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "44798:39:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"id": 4085,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "44791:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 4092,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "44791:47:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"functionReturnParameters": 4078,
										"id": 4093,
										"nodeType": "Return",
										"src": "44784:54:2"
									}
								]
							},
							"documentation": "@notice Reads data using a uint256 to store an array of 8 uint32s\n @param combinedData A uint256 which contains data for 8 uint32s\n @param index Position in array to read\n @return Value at position index",
							"id": 4095,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "getData32",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 4075,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4072,
										"name": "combinedData",
										"nodeType": "VariableDeclaration",
										"scope": 4095,
										"src": "44672:20:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 4071,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "44672:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 4074,
										"name": "index",
										"nodeType": "VariableDeclaration",
										"scope": 4095,
										"src": "44694:12:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4073,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "44694:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "44671:36:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 4078,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4077,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 4095,
										"src": "44730:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4076,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "44730:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "44729:8:2"
							},
							"scope": 4288,
							"src": "44653:192:2",
							"stateMutability": "pure",
							"superFunction": null,
							"visibility": "internal"
						},
						{
							"body": {
								"id": 4132,
								"nodeType": "Block",
								"src": "45268:168:2",
								"statements": [
									{
										"assignments": [
											4107
										],
										"declarations": [
											{
												"constant": false,
												"id": 4107,
												"name": "offset",
												"nodeType": "VariableDeclaration",
												"scope": 4133,
												"src": "45278:13:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 4106,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "45278:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 4111,
										"initialValue": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 4110,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 4108,
												"name": "index",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4099,
												"src": "45294:5:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "*",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "3332",
												"id": 4109,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "45302:2:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_32_by_1",
													"typeString": "int_const 32"
												},
												"value": "32"
											},
											"src": "45294:10:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "45278:26:2"
									},
									{
										"assignments": [
											4113
										],
										"declarations": [
											{
												"constant": false,
												"id": 4113,
												"name": "zeromask",
												"nodeType": "VariableDeclaration",
												"scope": 4133,
												"src": "45314:16:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"typeName": {
													"id": 4112,
													"name": "uint256",
													"nodeType": "ElementaryTypeName",
													"src": "45314:7:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 4119,
										"initialValue": {
											"argumentTypes": null,
											"id": 4118,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "~",
											"prefix": true,
											"src": "45333:25:2",
											"subExpression": {
												"argumentTypes": null,
												"components": [
													{
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 4116,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 4114,
															"name": "MASK_32_BITS",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 153,
															"src": "45335:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "<<",
														"rightExpression": {
															"argumentTypes": null,
															"id": 4115,
															"name": "offset",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4107,
															"src": "45351:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "45335:22:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"id": 4117,
												"isConstant": false,
												"isInlineArray": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "TupleExpression",
												"src": "45334:24:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "45314:44:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"id": 4130,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"components": [
													{
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 4122,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 4120,
															"name": "combinedData",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4097,
															"src": "45376:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "&",
														"rightExpression": {
															"argumentTypes": null,
															"id": 4121,
															"name": "zeromask",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4113,
															"src": "45391:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"src": "45376:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"id": 4123,
												"isConstant": false,
												"isInlineArray": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "TupleExpression",
												"src": "45375:25:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "|",
											"rightExpression": {
												"argumentTypes": null,
												"components": [
													{
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 4128,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"id": 4125,
																	"name": "value",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4101,
																	"src": "45412:5:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 4124,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"nodeType": "ElementaryTypeNameExpression",
																"src": "45404:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_uint256_$",
																	"typeString": "type(uint256)"
																},
																"typeName": "uint256"
															},
															"id": 4126,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "typeConversion",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "45404:14:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "<<",
														"rightExpression": {
															"argumentTypes": null,
															"id": 4127,
															"name": "offset",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4107,
															"src": "45422:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "45404:24:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"id": 4129,
												"isConstant": false,
												"isInlineArray": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "TupleExpression",
												"src": "45403:26:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"src": "45375:54:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"functionReturnParameters": 4105,
										"id": 4131,
										"nodeType": "Return",
										"src": "45368:61:2"
									}
								]
							},
							"documentation": "@notice Writes data using a uint256 to store an array of 8 uint32s\n @param combinedData A uint256 which contains data for 8 uint32s\n @param index Position in array to write\n @param value Value to write at position index.  Value must fit in a uint32.\n @return Updated combined data",
							"id": 4133,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "setData32",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 4102,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4097,
										"name": "combinedData",
										"nodeType": "VariableDeclaration",
										"scope": 4133,
										"src": "45187:20:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 4096,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "45187:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 4099,
										"name": "index",
										"nodeType": "VariableDeclaration",
										"scope": 4133,
										"src": "45209:12:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4098,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "45209:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 4101,
										"name": "value",
										"nodeType": "VariableDeclaration",
										"scope": 4133,
										"src": "45223:12:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4100,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "45223:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "45186:50:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 4105,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4104,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 4133,
										"src": "45259:7:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 4103,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "45259:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "45258:9:2"
							},
							"scope": 4288,
							"src": "45168:268:2",
							"stateMutability": "pure",
							"superFunction": null,
							"visibility": "internal"
						},
						{
							"body": {
								"id": 4157,
								"nodeType": "Block",
								"src": "45759:105:2",
								"statements": [
									{
										"assignments": [
											4143
										],
										"declarations": [
											{
												"constant": false,
												"id": 4143,
												"name": "offset",
												"nodeType": "VariableDeclaration",
												"scope": 4158,
												"src": "45769:13:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 4142,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "45769:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 4147,
										"initialValue": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 4146,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 4144,
												"name": "index",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4137,
												"src": "45785:5:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "*",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "38",
												"id": 4145,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "45793:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_8_by_1",
													"typeString": "int_const 8"
												},
												"value": "8"
											},
											"src": "45785:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "45769:25:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 4154,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"components": [
															{
																"argumentTypes": null,
																"commonType": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																},
																"id": 4151,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftExpression": {
																	"argumentTypes": null,
																	"id": 4149,
																	"name": "combinedData",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4135,
																	"src": "45819:12:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"nodeType": "BinaryOperation",
																"operator": ">>",
																"rightExpression": {
																	"argumentTypes": null,
																	"id": 4150,
																	"name": "offset",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4143,
																	"src": "45835:6:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																},
																"src": "45819:22:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															}
														],
														"id": 4152,
														"isConstant": false,
														"isInlineArray": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "TupleExpression",
														"src": "45818:24:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "&",
													"rightExpression": {
														"argumentTypes": null,
														"id": 4153,
														"name": "MASK_8_BITS",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 156,
														"src": "45845:11:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "45818:38:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"id": 4148,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "45811:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_uint32_$",
													"typeString": "type(uint32)"
												},
												"typeName": "uint32"
											},
											"id": 4155,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "45811:46:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"functionReturnParameters": 4141,
										"id": 4156,
										"nodeType": "Return",
										"src": "45804:53:2"
									}
								]
							},
							"documentation": "@notice Reads data using a uint256 to store an array of 32 uint8s\n @param combinedData A uint256 which contains data for 32 uint8s\n @param index Position in array to read\n @return Value at position index",
							"id": 4158,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "getData8",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 4138,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4135,
										"name": "combinedData",
										"nodeType": "VariableDeclaration",
										"scope": 4158,
										"src": "45693:20:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 4134,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "45693:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 4137,
										"name": "index",
										"nodeType": "VariableDeclaration",
										"scope": 4158,
										"src": "45715:12:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4136,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "45715:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "45692:36:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 4141,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4140,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 4158,
										"src": "45751:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4139,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "45751:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "45750:8:2"
							},
							"scope": 4288,
							"src": "45675:189:2",
							"stateMutability": "pure",
							"superFunction": null,
							"visibility": "internal"
						},
						{
							"body": {
								"id": 4202,
								"nodeType": "Block",
								"src": "46287:230:2",
								"statements": [
									{
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													},
													"id": 4172,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 4170,
														"name": "value",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4164,
														"src": "46305:5:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "<",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "323536",
														"id": 4171,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "46313:3:2",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_256_by_1",
															"typeString": "int_const 256"
														},
														"value": "256"
													},
													"src": "46305:11:2",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "4f6e6c792038206269747320616c6c6f77656420666f722076616c75652e",
													"id": 4173,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "string",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "46318:32:2",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_stringliteral_ddaa73a8054ce9a07c21854101a82fc39840680a3f8f5b0458eb5a042c29fb07",
														"typeString": "literal_string \"Only 8 bits allowed for value.\""
													},
													"value": "Only 8 bits allowed for value."
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													{
														"typeIdentifier": "t_stringliteral_ddaa73a8054ce9a07c21854101a82fc39840680a3f8f5b0458eb5a042c29fb07",
														"typeString": "literal_string \"Only 8 bits allowed for value.\""
													}
												],
												"id": 4169,
												"name": "require",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													4375,
													4376
												],
												"referencedDeclaration": 4376,
												"src": "46297:7:2",
												"typeDescriptions": {
													"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
													"typeString": "function (bool,string memory) pure"
												}
											},
											"id": 4174,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "46297:54:2",
											"typeDescriptions": {
												"typeIdentifier": "t_tuple$__$",
												"typeString": "tuple()"
											}
										},
										"id": 4175,
										"nodeType": "ExpressionStatement",
										"src": "46297:54:2"
									},
									{
										"assignments": [
											4177
										],
										"declarations": [
											{
												"constant": false,
												"id": 4177,
												"name": "offset",
												"nodeType": "VariableDeclaration",
												"scope": 4203,
												"src": "46361:13:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 4176,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "46361:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 4181,
										"initialValue": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 4180,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 4178,
												"name": "index",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4162,
												"src": "46377:5:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "*",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "38",
												"id": 4179,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "46385:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_8_by_1",
													"typeString": "int_const 8"
												},
												"value": "8"
											},
											"src": "46377:9:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "46361:25:2"
									},
									{
										"assignments": [
											4183
										],
										"declarations": [
											{
												"constant": false,
												"id": 4183,
												"name": "zeromask",
												"nodeType": "VariableDeclaration",
												"scope": 4203,
												"src": "46396:16:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"typeName": {
													"id": 4182,
													"name": "uint256",
													"nodeType": "ElementaryTypeName",
													"src": "46396:7:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 4189,
										"initialValue": {
											"argumentTypes": null,
											"id": 4188,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "~",
											"prefix": true,
											"src": "46415:24:2",
											"subExpression": {
												"argumentTypes": null,
												"components": [
													{
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 4186,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 4184,
															"name": "MASK_8_BITS",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 156,
															"src": "46417:11:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "<<",
														"rightExpression": {
															"argumentTypes": null,
															"id": 4185,
															"name": "offset",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4177,
															"src": "46432:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "46417:21:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"id": 4187,
												"isConstant": false,
												"isInlineArray": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "TupleExpression",
												"src": "46416:23:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "46396:43:2"
									},
									{
										"expression": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"id": 4200,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"components": [
													{
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 4192,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 4190,
															"name": "combinedData",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4160,
															"src": "46457:12:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "&",
														"rightExpression": {
															"argumentTypes": null,
															"id": 4191,
															"name": "zeromask",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4183,
															"src": "46472:8:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"src": "46457:23:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"id": 4193,
												"isConstant": false,
												"isInlineArray": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "TupleExpression",
												"src": "46456:25:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "|",
											"rightExpression": {
												"argumentTypes": null,
												"components": [
													{
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 4198,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"id": 4195,
																	"name": "value",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 4164,
																	"src": "46493:5:2",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint32",
																		"typeString": "uint32"
																	}
																],
																"id": 4194,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"lValueRequested": false,
																"nodeType": "ElementaryTypeNameExpression",
																"src": "46485:7:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_type$_t_uint256_$",
																	"typeString": "type(uint256)"
																},
																"typeName": "uint256"
															},
															"id": 4196,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "typeConversion",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "46485:14:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "<<",
														"rightExpression": {
															"argumentTypes": null,
															"id": 4197,
															"name": "offset",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4177,
															"src": "46503:6:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "46485:24:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"id": 4199,
												"isConstant": false,
												"isInlineArray": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "TupleExpression",
												"src": "46484:26:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"src": "46456:54:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"functionReturnParameters": 4168,
										"id": 4201,
										"nodeType": "Return",
										"src": "46449:61:2"
									}
								]
							},
							"documentation": "@notice Writes data using a uint256 to store an array of 32 uint8s\n @param combinedData A uint256 which contains data for 32 uint8s\n @param index Position in array to write\n @param value Value to write at position index.  Value must be less than 256.\n @return Updated combined data",
							"id": 4203,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "setData8",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 4165,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4160,
										"name": "combinedData",
										"nodeType": "VariableDeclaration",
										"scope": 4203,
										"src": "46206:20:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 4159,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "46206:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 4162,
										"name": "index",
										"nodeType": "VariableDeclaration",
										"scope": 4203,
										"src": "46228:12:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4161,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "46228:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 4164,
										"name": "value",
										"nodeType": "VariableDeclaration",
										"scope": 4203,
										"src": "46242:12:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4163,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "46242:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "46205:50:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 4168,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4167,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 4203,
										"src": "46278:7:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"typeName": {
											"id": 4166,
											"name": "uint256",
											"nodeType": "ElementaryTypeName",
											"src": "46278:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "46277:9:2"
							},
							"scope": 4288,
							"src": "46188:329:2",
							"stateMutability": "pure",
							"superFunction": null,
							"visibility": "internal"
						},
						{
							"body": {
								"id": 4227,
								"nodeType": "Block",
								"src": "46845:114:2",
								"statements": [
									{
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 4214,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 4212,
												"name": "_b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4207,
												"src": "46859:2:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "<=",
											"rightExpression": {
												"argumentTypes": null,
												"id": 4213,
												"name": "_a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4205,
												"src": "46865:2:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "46859:8:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": null,
										"id": 4224,
										"nodeType": "IfStatement",
										"src": "46855:79:2",
										"trueBody": {
											"id": 4223,
											"nodeType": "Block",
											"src": "46869:65:2",
											"statements": [
												{
													"assignments": [
														4216
													],
													"declarations": [
														{
															"constant": false,
															"id": 4216,
															"name": "c",
															"nodeType": "VariableDeclaration",
															"scope": 4228,
															"src": "46883:8:2",
															"stateVariable": false,
															"storageLocation": "default",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															},
															"typeName": {
																"id": 4215,
																"name": "uint32",
																"nodeType": "ElementaryTypeName",
																"src": "46883:6:2",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint32",
																	"typeString": "uint32"
																}
															},
															"value": null,
															"visibility": "internal"
														}
													],
													"id": 4220,
													"initialValue": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														},
														"id": 4219,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 4217,
															"name": "_a",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4205,
															"src": "46894:2:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "-",
														"rightExpression": {
															"argumentTypes": null,
															"id": 4218,
															"name": "_b",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 4207,
															"src": "46899:2:2",
															"typeDescriptions": {
																"typeIdentifier": "t_uint32",
																"typeString": "uint32"
															}
														},
														"src": "46894:7:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"nodeType": "VariableDeclarationStatement",
													"src": "46883:18:2"
												},
												{
													"expression": {
														"argumentTypes": null,
														"id": 4221,
														"name": "c",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4216,
														"src": "46922:1:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"functionReturnParameters": 4211,
													"id": 4222,
													"nodeType": "Return",
													"src": "46915:8:2"
												}
											]
										}
									},
									{
										"expression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 4225,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "46951:1:2",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"functionReturnParameters": 4211,
										"id": 4226,
										"nodeType": "Return",
										"src": "46944:8:2"
									}
								]
							},
							"documentation": "@notice Safe subtraction that returns 0 on underflow.\n @dev We intentially don't assert so as to not block program execution.\n @param _a Value to subtract from\n @param _b Value to subtract\n @return Result of _a - _b",
							"id": 4228,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "subSafe",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 4208,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4205,
										"name": "_a",
										"nodeType": "VariableDeclaration",
										"scope": 4228,
										"src": "46792:9:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4204,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "46792:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 4207,
										"name": "_b",
										"nodeType": "VariableDeclaration",
										"scope": 4228,
										"src": "46803:9:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4206,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "46803:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "46791:22:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 4211,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4210,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 4228,
										"src": "46837:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4209,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "46837:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "46836:8:2"
							},
							"scope": 4288,
							"src": "46775:184:2",
							"stateMutability": "pure",
							"superFunction": null,
							"visibility": "internal"
						},
						{
							"body": {
								"id": 4252,
								"nodeType": "Block",
								"src": "47289:118:2",
								"statements": [
									{
										"assignments": [
											4238
										],
										"declarations": [
											{
												"constant": false,
												"id": 4238,
												"name": "c",
												"nodeType": "VariableDeclaration",
												"scope": 4253,
												"src": "47299:8:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 4237,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "47299:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 4242,
										"initialValue": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 4241,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 4239,
												"name": "_a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4230,
												"src": "47310:2:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "+",
											"rightExpression": {
												"argumentTypes": null,
												"id": 4240,
												"name": "_b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4232,
												"src": "47315:2:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "47310:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "47299:18:2"
									},
									{
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 4245,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 4243,
												"name": "c",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4238,
												"src": "47331:1:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": ">=",
											"rightExpression": {
												"argumentTypes": null,
												"id": 4244,
												"name": "_a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4230,
												"src": "47336:2:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "47331:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": null,
										"id": 4249,
										"nodeType": "IfStatement",
										"src": "47327:46:2",
										"trueBody": {
											"id": 4248,
											"nodeType": "Block",
											"src": "47340:33:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"id": 4246,
														"name": "c",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4238,
														"src": "47361:1:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"functionReturnParameters": 4236,
													"id": 4247,
													"nodeType": "Return",
													"src": "47354:8:2"
												}
											]
										}
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 4250,
											"name": "MAX_UINT32",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 159,
											"src": "47390:10:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"functionReturnParameters": 4236,
										"id": 4251,
										"nodeType": "Return",
										"src": "47383:17:2"
									}
								]
							},
							"documentation": "@notice Safe addition that returns MAX_UINT32 on overflow\n @dev We intentially don't assert so as to not block program execution.\n @param _a First value to add\n @param _b Second value to add\n @return Result of _a + _b",
							"id": 4253,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "addSafe",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 4233,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4230,
										"name": "_a",
										"nodeType": "VariableDeclaration",
										"scope": 4253,
										"src": "47236:9:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4229,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "47236:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 4232,
										"name": "_b",
										"nodeType": "VariableDeclaration",
										"scope": 4253,
										"src": "47247:9:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4231,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "47247:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "47235:22:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 4236,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4235,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 4253,
										"src": "47281:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4234,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "47281:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "47280:8:2"
							},
							"scope": 4288,
							"src": "47219:188:2",
							"stateMutability": "pure",
							"superFunction": null,
							"visibility": "internal"
						},
						{
							"body": {
								"id": 4286,
								"nodeType": "Block",
								"src": "47753:179:2",
								"statements": [
									{
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 4264,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 4262,
												"name": "_a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4255,
												"src": "47767:2:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "==",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 4263,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "47773:1:2",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"src": "47767:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": null,
										"id": 4268,
										"nodeType": "IfStatement",
										"src": "47763:46:2",
										"trueBody": {
											"id": 4267,
											"nodeType": "Block",
											"src": "47776:33:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"hexValue": "30",
														"id": 4265,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "47797:1:2",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													},
													"functionReturnParameters": 4261,
													"id": 4266,
													"nodeType": "Return",
													"src": "47790:8:2"
												}
											]
										}
									},
									{
										"assignments": [
											4270
										],
										"declarations": [
											{
												"constant": false,
												"id": 4270,
												"name": "c",
												"nodeType": "VariableDeclaration",
												"scope": 4287,
												"src": "47819:8:2",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"typeName": {
													"id": 4269,
													"name": "uint32",
													"nodeType": "ElementaryTypeName",
													"src": "47819:6:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 4274,
										"initialValue": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 4273,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 4271,
												"name": "_a",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4255,
												"src": "47830:2:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "*",
											"rightExpression": {
												"argumentTypes": null,
												"id": 4272,
												"name": "_b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4257,
												"src": "47835:2:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "47830:7:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "47819:18:2"
									},
									{
										"condition": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											},
											"id": 4279,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												},
												"id": 4277,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 4275,
													"name": "c",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4270,
													"src": "47851:1:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "/",
												"rightExpression": {
													"argumentTypes": null,
													"id": 4276,
													"name": "_a",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 4255,
													"src": "47855:2:2",
													"typeDescriptions": {
														"typeIdentifier": "t_uint32",
														"typeString": "uint32"
													}
												},
												"src": "47851:6:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "==",
											"rightExpression": {
												"argumentTypes": null,
												"id": 4278,
												"name": "_b",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 4257,
												"src": "47861:2:2",
												"typeDescriptions": {
													"typeIdentifier": "t_uint32",
													"typeString": "uint32"
												}
											},
											"src": "47851:12:2",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"falseBody": null,
										"id": 4283,
										"nodeType": "IfStatement",
										"src": "47847:51:2",
										"trueBody": {
											"id": 4282,
											"nodeType": "Block",
											"src": "47865:33:2",
											"statements": [
												{
													"expression": {
														"argumentTypes": null,
														"id": 4280,
														"name": "c",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 4270,
														"src": "47886:1:2",
														"typeDescriptions": {
															"typeIdentifier": "t_uint32",
															"typeString": "uint32"
														}
													},
													"functionReturnParameters": 4261,
													"id": 4281,
													"nodeType": "Return",
													"src": "47879:8:2"
												}
											]
										}
									},
									{
										"expression": {
											"argumentTypes": null,
											"id": 4284,
											"name": "MAX_UINT32",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 159,
											"src": "47915:10:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"functionReturnParameters": 4261,
										"id": 4285,
										"nodeType": "Return",
										"src": "47908:17:2"
									}
								]
							},
							"documentation": "@notice Safe multiplication that returns MAX_UINT32 on overflow\n @dev We intentially don't assert so as to not block program execution.\n @param _a First value to multiply\n @param _b Second value to multiply\n @return Result of _a * _b",
							"id": 4287,
							"implemented": true,
							"isConstructor": false,
							"isDeclaredConst": true,
							"modifiers": [],
							"name": "mulSafe",
							"nodeType": "FunctionDefinition",
							"parameters": {
								"id": 4258,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4255,
										"name": "_a",
										"nodeType": "VariableDeclaration",
										"scope": 4287,
										"src": "47700:9:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4254,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "47700:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									},
									{
										"constant": false,
										"id": 4257,
										"name": "_b",
										"nodeType": "VariableDeclaration",
										"scope": 4287,
										"src": "47711:9:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4256,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "47711:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "47699:22:2"
							},
							"payable": false,
							"returnParameters": {
								"id": 4261,
								"nodeType": "ParameterList",
								"parameters": [
									{
										"constant": false,
										"id": 4260,
										"name": "",
										"nodeType": "VariableDeclaration",
										"scope": 4287,
										"src": "47745:6:2",
										"stateVariable": false,
										"storageLocation": "default",
										"typeDescriptions": {
											"typeIdentifier": "t_uint32",
											"typeString": "uint32"
										},
										"typeName": {
											"id": 4259,
											"name": "uint32",
											"nodeType": "ElementaryTypeName",
											"src": "47745:6:2",
											"typeDescriptions": {
												"typeIdentifier": "t_uint32",
												"typeString": "uint32"
											}
										},
										"value": null,
										"visibility": "internal"
									}
								],
								"src": "47744:8:2"
							},
							"scope": 4288,
							"src": "47683:249:2",
							"stateMutability": "pure",
							"superFunction": null,
							"visibility": "internal"
						}
					],
					"scope": 4289,
					"src": "104:47830:2"
				}
			],
			"src": "0:47935:2"
		},
		"compiler": {
			"name": "solc",
			"version": "0.4.24+commit.e67f0147.Emscripten.clang"
		},
		"networks": {
			"3": {
				"events": {},
				"links": {},
				"address": "0x259139349dA1D9Cfd088c3b57Ef9B9f3576cfB8D",
				"transactionHash": "0x9916ba6679e4959d4b29b1ca7716b605d45163218b7b248df4dec3dc4b288785"
			},
			"4": {
				"events": {},
				"links": {},
				"address": "0x5137Bc501546968791522D17787e459076d0f036",
				"transactionHash": "0x611e085b0cf42cea521308dc7a2b1cd23760b43e1a858c5da0e0c7d2b7616abd"
			},
			"42": {
				"events": {},
				"links": {},
				"address": "0xc5ad4439464A10A001Ba98a8b60C360Be0b441AA",
				"transactionHash": "0x8f486ccddd7dad6972ddad2a1078a022a9d595fa20520cc1ddd7e9b1c24d24ed"
			},
			"1534033426853": {
				"events": {},
				"links": {},
				"address": "0x22e3c3ba6a631a1dd17645a0ba6c41c7a33738cb",
				"transactionHash": "0x145b7585dbbb81d700de1fbf2e72ba9b45fc696b21062d6deef0e04889b3d749"
			},
			"1534476764846": {
				"events": {},
				"links": {},
				"address": "0x2522eae578d5b36aac150d71f847d704f4b33339",
				"transactionHash": "0x509f826a34f0be603ac9b19ba6404517eba23a54d726fbac8a57ab6bc66d0791"
			},
			"1534727609521": {
				"events": {},
				"links": {},
				"address": "0x66033ff9d49a47c965f0cdd991c7cfdc322e9426",
				"transactionHash": "0x78ed6993df4df7a1f315a8099fc5a22038c3b2f249a2d1d2e67130a71e95ee15"
			},
			"1534891437232": {
				"events": {},
				"links": {},
				"address": "0xe61c6aabb196A4FE6Aef017A65885F17237F2554",
				"transactionHash": "0x0495f3d3bfe687cc823022be6ad8720a02fb2e6668ce631bb8cd5a301976f6a7"
			},
			"1535413900904": {
				"events": {},
				"links": {},
				"address": "0x9DC25910461D1fBFbD3CE86bb1fa08E0422680CC",
				"transactionHash": "0x7ca6aa6dae2b969c4038a42f2e1bec250832e8af7924709b9558bff057b6724c"
			},
			"1535436387932": {
				"events": {},
				"links": {},
				"address": "0x761020Aed073d61b854Dd94f391210d4B494ae24",
				"transactionHash": "0x7ca6aa6dae2b969c4038a42f2e1bec250832e8af7924709b9558bff057b6724c"
			},
			"1535437564033": {
				"events": {},
				"links": {},
				"address": "0x6E82EC8319078852cf4851bF40EA9Ba3D60E9E26",
				"transactionHash": "0x4b96b3a551e497b5f665143eba7b763b9499530b3fa345cf31ba773e99e4c8ee"
			},
			"1535517793544": {
				"events": {},
				"links": {},
				"address": "0x5b1869D9A4C187F2EAa108f3062412ecf0526b24",
				"transactionHash": "0xc05d757fd3e66e734552d804fea1c00066a9339eecc7a79e75f0a67f3ac1e321"
			},
			"1535601734805": {
				"events": {},
				"links": {},
				"address": "0x5b1869D9A4C187F2EAa108f3062412ecf0526b24",
				"transactionHash": "0xc05d757fd3e66e734552d804fea1c00066a9339eecc7a79e75f0a67f3ac1e321"
			}
		},
		"schemaVersion": "3.0.0-beta.0",
		"updatedAt": "2018-08-30T04:02:29.217Z"
	};

/***/ },
/* 554 */
/***/ function(module, exports) {

	module.exports = {
		"modp1": {
			"gen": "02",
			"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
		},
		"modp2": {
			"gen": "02",
			"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
		},
		"modp5": {
			"gen": "02",
			"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
		},
		"modp14": {
			"gen": "02",
			"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
		},
		"modp15": {
			"gen": "02",
			"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
		},
		"modp16": {
			"gen": "02",
			"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
		},
		"modp17": {
			"gen": "02",
			"prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
		},
		"modp18": {
			"gen": "02",
			"prime": "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"
		}
	};

/***/ },
/* 555 */
/***/ function(module, exports) {

	module.exports = {
		"_args": [
			[
				"elliptic@6.4.0",
				"/Users/justinhamilton/ethereum/project"
			]
		],
		"_from": "elliptic@6.4.0",
		"_id": "elliptic@6.4.0",
		"_inBundle": false,
		"_integrity": "sha1-ysmvh2LIWDYYcAPI3+GT5eLq5d8=",
		"_location": "/elliptic",
		"_phantomChildren": {},
		"_requested": {
			"type": "version",
			"registry": true,
			"raw": "elliptic@6.4.0",
			"name": "elliptic",
			"escapedName": "elliptic",
			"rawSpec": "6.4.0",
			"saveSpec": null,
			"fetchSpec": "6.4.0"
		},
		"_requiredBy": [
			"/browserify-sign",
			"/create-ecdh",
			"/eth-lib",
			"/secp256k1",
			"/web3-eth-accounts/eth-lib"
		],
		"_resolved": "https://registry.npmjs.org/elliptic/-/elliptic-6.4.0.tgz",
		"_spec": "6.4.0",
		"_where": "/Users/justinhamilton/ethereum/project",
		"author": {
			"name": "Fedor Indutny",
			"email": "fedor@indutny.com"
		},
		"bugs": {
			"url": "https://github.com/indutny/elliptic/issues"
		},
		"dependencies": {
			"bn.js": "^4.4.0",
			"brorand": "^1.0.1",
			"hash.js": "^1.0.0",
			"hmac-drbg": "^1.0.0",
			"inherits": "^2.0.1",
			"minimalistic-assert": "^1.0.0",
			"minimalistic-crypto-utils": "^1.0.0"
		},
		"description": "EC cryptography",
		"devDependencies": {
			"brfs": "^1.4.3",
			"coveralls": "^2.11.3",
			"grunt": "^0.4.5",
			"grunt-browserify": "^5.0.0",
			"grunt-cli": "^1.2.0",
			"grunt-contrib-connect": "^1.0.0",
			"grunt-contrib-copy": "^1.0.0",
			"grunt-contrib-uglify": "^1.0.1",
			"grunt-mocha-istanbul": "^3.0.1",
			"grunt-saucelabs": "^8.6.2",
			"istanbul": "^0.4.2",
			"jscs": "^2.9.0",
			"jshint": "^2.6.0",
			"mocha": "^2.1.0"
		},
		"files": [
			"lib"
		],
		"homepage": "https://github.com/indutny/elliptic",
		"keywords": [
			"EC",
			"Elliptic",
			"curve",
			"Cryptography"
		],
		"license": "MIT",
		"main": "lib/elliptic.js",
		"name": "elliptic",
		"repository": {
			"type": "git",
			"url": "git+ssh://git@github.com/indutny/elliptic.git"
		},
		"scripts": {
			"jscs": "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js",
			"jshint": "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js",
			"lint": "npm run jscs && npm run jshint",
			"test": "npm run lint && npm run unit",
			"unit": "istanbul test _mocha --reporter=spec test/index.js",
			"version": "grunt dist && git add dist/"
		},
		"version": "6.4.0"
	};

/***/ },
/* 556 */
/***/ function(module, exports) {

	module.exports = {
		"2.16.840.1.101.3.4.1.1": "aes-128-ecb",
		"2.16.840.1.101.3.4.1.2": "aes-128-cbc",
		"2.16.840.1.101.3.4.1.3": "aes-128-ofb",
		"2.16.840.1.101.3.4.1.4": "aes-128-cfb",
		"2.16.840.1.101.3.4.1.21": "aes-192-ecb",
		"2.16.840.1.101.3.4.1.22": "aes-192-cbc",
		"2.16.840.1.101.3.4.1.23": "aes-192-ofb",
		"2.16.840.1.101.3.4.1.24": "aes-192-cfb",
		"2.16.840.1.101.3.4.1.41": "aes-256-ecb",
		"2.16.840.1.101.3.4.1.42": "aes-256-cbc",
		"2.16.840.1.101.3.4.1.43": "aes-256-ofb",
		"2.16.840.1.101.3.4.1.44": "aes-256-cfb"
	};

/***/ },
/* 557 */
/***/ function(module, exports) {

	module.exports = {
		"_args": [
			[
				"web3@1.0.0-beta.34",
				"/Users/justinhamilton/ethereum/project"
			]
		],
		"_from": "web3@1.0.0-beta.34",
		"_id": "web3@1.0.0-beta.34",
		"_inBundle": false,
		"_integrity": "sha1-NH5WG3hAmMtVYzFfSQR5odkfKrE=",
		"_location": "/web3",
		"_phantomChildren": {},
		"_requested": {
			"type": "version",
			"registry": true,
			"raw": "web3@1.0.0-beta.34",
			"name": "web3",
			"escapedName": "web3",
			"rawSpec": "1.0.0-beta.34",
			"saveSpec": null,
			"fetchSpec": "1.0.0-beta.34"
		},
		"_requiredBy": [
			"/",
			"/drizzle"
		],
		"_resolved": "https://registry.npmjs.org/web3/-/web3-1.0.0-beta.34.tgz",
		"_spec": "1.0.0-beta.34",
		"_where": "/Users/justinhamilton/ethereum/project",
		"author": {
			"name": "ethereum.org"
		},
		"authors": [
			{
				"name": "Fabian Vogelsteller",
				"email": "fabian@ethereum.org",
				"homepage": "http://frozeman.de"
			},
			{
				"name": "Marek Kotewicz",
				"email": "marek@parity.io",
				"url": "https://github.com/debris"
			},
			{
				"name": "Marian Oancea",
				"url": "https://github.com/cubedro"
			},
			{
				"name": "Gav Wood",
				"email": "g@parity.io",
				"homepage": "http://gavwood.com"
			},
			{
				"name": "Jeffery Wilcke",
				"email": "jeffrey.wilcke@ethereum.org",
				"url": "https://github.com/obscuren"
			}
		],
		"bugs": {
			"url": "https://github.com/ethereum/web3.js/issues"
		},
		"dependencies": {
			"web3-bzz": "1.0.0-beta.34",
			"web3-core": "1.0.0-beta.34",
			"web3-eth": "1.0.0-beta.34",
			"web3-eth-personal": "1.0.0-beta.34",
			"web3-net": "1.0.0-beta.34",
			"web3-shh": "1.0.0-beta.34",
			"web3-utils": "1.0.0-beta.34"
		},
		"description": "Ethereum JavaScript API",
		"keywords": [
			"Ethereum",
			"JavaScript",
			"API"
		],
		"license": "LGPL-3.0",
		"main": "src/index.js",
		"name": "web3",
		"namespace": "ethereum",
		"repository": {
			"type": "git",
			"url": "https://github.com/ethereum/web3.js/tree/master/packages/web3"
		},
		"types": "index.d.ts",
		"version": "1.0.0-beta.34"
	};

/***/ },
/* 558 */
/***/ function(module, exports) {

	module.exports = {
		"_from": "websocket@git://github.com/frozeman/WebSocket-Node.git#6c72925e3f8aaaea8dc8450f97627e85263999f2",
		"_id": "websocket@1.0.26",
		"_inBundle": false,
		"_integrity": "",
		"_location": "/websocket",
		"_phantomChildren": {},
		"_requested": {
			"type": "git",
			"raw": "websocket@git://github.com/frozeman/WebSocket-Node.git#6c72925e3f8aaaea8dc8450f97627e85263999f2",
			"name": "websocket",
			"escapedName": "websocket",
			"rawSpec": "git://github.com/frozeman/WebSocket-Node.git#6c72925e3f8aaaea8dc8450f97627e85263999f2",
			"saveSpec": "git://github.com/frozeman/WebSocket-Node.git#6c72925e3f8aaaea8dc8450f97627e85263999f2",
			"fetchSpec": "git://github.com/frozeman/WebSocket-Node.git",
			"gitCommittish": "6c72925e3f8aaaea8dc8450f97627e85263999f2"
		},
		"_requiredBy": [
			"/web3-providers-ws"
		],
		"_resolved": "git://github.com/frozeman/WebSocket-Node.git#6c72925e3f8aaaea8dc8450f97627e85263999f2",
		"_spec": "websocket@git://github.com/frozeman/WebSocket-Node.git#6c72925e3f8aaaea8dc8450f97627e85263999f2",
		"_where": "/Users/justinhamilton/ethereum/project",
		"author": {
			"name": "Brian McKelvey",
			"email": "brian@worlize.com",
			"url": "https://www.worlize.com/"
		},
		"browser": "lib/browser.js",
		"bugs": {
			"url": "https://github.com/theturtle32/WebSocket-Node/issues"
		},
		"bundleDependencies": false,
		"config": {
			"verbose": false
		},
		"contributors": [
			{
				"name": "Iñaki Baz Castillo",
				"email": "ibc@aliax.net",
				"url": "http://dev.sipdoc.net"
			}
		],
		"dependencies": {
			"debug": "^2.2.0",
			"nan": "^2.3.3",
			"typedarray-to-buffer": "^3.1.2",
			"yaeti": "^0.0.6"
		},
		"deprecated": false,
		"description": "Websocket Client & Server Library implementing the WebSocket protocol as specified in RFC 6455.",
		"devDependencies": {
			"buffer-equal": "^1.0.0",
			"faucet": "^0.0.1",
			"gulp": "git+https://github.com/gulpjs/gulp.git#4.0",
			"gulp-jshint": "^2.0.4",
			"jshint": "^2.0.0",
			"jshint-stylish": "^2.2.1",
			"tape": "^4.0.1"
		},
		"directories": {
			"lib": "./lib"
		},
		"engines": {
			"node": ">=0.10.0"
		},
		"homepage": "https://github.com/theturtle32/WebSocket-Node",
		"keywords": [
			"websocket",
			"websockets",
			"socket",
			"networking",
			"comet",
			"push",
			"RFC-6455",
			"realtime",
			"server",
			"client"
		],
		"license": "Apache-2.0",
		"main": "index",
		"name": "websocket",
		"repository": {
			"type": "git",
			"url": "git+https://github.com/theturtle32/WebSocket-Node.git"
		},
		"scripts": {
			"gulp": "gulp",
			"install": "(node-gyp rebuild 2> builderror.log) || (exit 0)",
			"test": "faucet test/unit"
		},
		"version": "1.0.26"
	};

/***/ },
/* 559 */
/***/ function(module, exports) {

	module.exports = IdIterator
	
	function IdIterator(opts){
	  opts = opts || {}
	  var max = opts.max || Number.MAX_SAFE_INTEGER
	  var idCounter = typeof opts.start !== 'undefined' ? opts.start : Math.floor(Math.random() * max)
	
	  return function createRandomId () {
	    idCounter = idCounter % max
	    return idCounter++
	  }
	
	}

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(564),
	    isArguments = __webpack_require__(573),
	    isArray = __webpack_require__(574),
	    isBuffer = __webpack_require__(575),
	    isIndex = __webpack_require__(568),
	    isTypedArray = __webpack_require__(577);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(98),
	    isObjectLike = __webpack_require__(99);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(98),
	    isLength = __webpack_require__(244),
	    isObjectLike = __webpack_require__(99);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(569),
	    nativeKeys = __webpack_require__(570);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 564 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 565 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(241);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(239);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 568 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 569 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(241);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(240);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)(module)))

/***/ },
/* 572 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(561),
	    isObjectLike = __webpack_require__(99);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 574 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(242),
	    stubFalse = __webpack_require__(580);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)(module)))

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(98),
	    isObject = __webpack_require__(245);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(562),
	    baseUnary = __webpack_require__(565),
	    nodeUtil = __webpack_require__(571);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(560),
	    baseKeys = __webpack_require__(563),
	    isArrayLike = __webpack_require__(243);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 579 */
/***/ function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 580 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict'
	var inherits = __webpack_require__(2)
	var HashBase = __webpack_require__(582)
	
	var ARRAY16 = new Array(16)
	
	function MD5 () {
	  HashBase.call(this, 64)
	
	  // state
	  this._a = 0x67452301
	  this._b = 0xefcdab89
	  this._c = 0x98badcfe
	  this._d = 0x10325476
	}
	
	inherits(MD5, HashBase)
	
	MD5.prototype._update = function () {
	  var M = ARRAY16
	  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)
	
	  var a = this._a
	  var b = this._b
	  var c = this._c
	  var d = this._d
	
	  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
	  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
	  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
	  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
	  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
	  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
	  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
	  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
	  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
	  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
	  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
	  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
	  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
	  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
	  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
	  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)
	
	  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
	  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
	  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
	  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
	  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
	  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
	  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
	  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
	  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
	  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
	  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
	  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
	  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
	  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
	  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
	  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)
	
	  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
	  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
	  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
	  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
	  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
	  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
	  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
	  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
	  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
	  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
	  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
	  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
	  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
	  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
	  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
	  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)
	
	  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
	  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
	  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
	  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
	  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
	  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
	  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
	  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
	  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
	  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
	  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
	  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
	  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
	  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
	  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
	  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)
	
	  this._a = (this._a + a) | 0
	  this._b = (this._b + b) | 0
	  this._c = (this._c + c) | 0
	  this._d = (this._d + d) | 0
	}
	
	MD5.prototype._digest = function () {
	  // create padding and handle blocks
	  this._block[this._blockOffset++] = 0x80
	  if (this._blockOffset > 56) {
	    this._block.fill(0, this._blockOffset, 64)
	    this._update()
	    this._blockOffset = 0
	  }
	
	  this._block.fill(0, this._blockOffset, 56)
	  this._block.writeUInt32LE(this._length[0], 56)
	  this._block.writeUInt32LE(this._length[1], 60)
	  this._update()
	
	  // produce result
	  var buffer = new Buffer(16)
	  buffer.writeInt32LE(this._a, 0)
	  buffer.writeInt32LE(this._b, 4)
	  buffer.writeInt32LE(this._c, 8)
	  buffer.writeInt32LE(this._d, 12)
	  return buffer
	}
	
	function rotl (x, n) {
	  return (x << n) | (x >>> (32 - n))
	}
	
	function fnF (a, b, c, d, m, k, s) {
	  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
	}
	
	function fnG (a, b, c, d, m, k, s) {
	  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
	}
	
	function fnH (a, b, c, d, m, k, s) {
	  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
	}
	
	function fnI (a, b, c, d, m, k, s) {
	  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
	}
	
	module.exports = MD5
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	var Buffer = __webpack_require__(4).Buffer
	var Transform = __webpack_require__(82).Transform
	var inherits = __webpack_require__(2)
	
	function throwIfNotStringOrBuffer (val, prefix) {
	  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
	    throw new TypeError(prefix + ' must be a string or a buffer')
	  }
	}
	
	function HashBase (blockSize) {
	  Transform.call(this)
	
	  this._block = Buffer.allocUnsafe(blockSize)
	  this._blockSize = blockSize
	  this._blockOffset = 0
	  this._length = [0, 0, 0, 0]
	
	  this._finalized = false
	}
	
	inherits(HashBase, Transform)
	
	HashBase.prototype._transform = function (chunk, encoding, callback) {
	  var error = null
	  try {
	    this.update(chunk, encoding)
	  } catch (err) {
	    error = err
	  }
	
	  callback(error)
	}
	
	HashBase.prototype._flush = function (callback) {
	  var error = null
	  try {
	    this.push(this.digest())
	  } catch (err) {
	    error = err
	  }
	
	  callback(error)
	}
	
	HashBase.prototype.update = function (data, encoding) {
	  throwIfNotStringOrBuffer(data, 'Data')
	  if (this._finalized) throw new Error('Digest already called')
	  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding)
	
	  // consume data
	  var block = this._block
	  var offset = 0
	  while (this._blockOffset + data.length - offset >= this._blockSize) {
	    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
	    this._update()
	    this._blockOffset = 0
	  }
	  while (offset < data.length) block[this._blockOffset++] = data[offset++]
	
	  // update length
	  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
	    this._length[j] += carry
	    carry = (this._length[j] / 0x0100000000) | 0
	    if (carry > 0) this._length[j] -= 0x0100000000 * carry
	  }
	
	  return this
	}
	
	HashBase.prototype._update = function () {
	  throw new Error('_update is not implemented')
	}
	
	HashBase.prototype.digest = function (encoding) {
	  if (this._finalized) throw new Error('Digest already called')
	  this._finalized = true
	
	  var digest = this._digest()
	  if (encoding !== undefined) digest = digest.toString(encoding)
	
	  // reset state
	  this._block.fill(0)
	  this._blockOffset = 0
	  for (var i = 0; i < 4; ++i) this._length[i] = 0
	
	  return digest
	}
	
	HashBase.prototype._digest = function () {
	  throw new Error('_digest is not implemented')
	}
	
	module.exports = HashBase


/***/ },
/* 583 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// This file is the concatenation of many js files.
	// See http://github.com/jimhigson/oboe.js for the raw source
	
	// having a local undefined, window, Object etc allows slightly better minification:
	(function  (window, Object, Array, Error, JSON, undefined ) {
	
	   // v2.1.3
	
	/*
	
	Copyright (c) 2013, Jim Higson
	
	All rights reserved.
	
	Redistribution and use in source and binary forms, with or without
	modification, are permitted provided that the following conditions are
	met:
	
	1.  Redistributions of source code must retain the above copyright
	    notice, this list of conditions and the following disclaimer.
	
	2.  Redistributions in binary form must reproduce the above copyright
	    notice, this list of conditions and the following disclaimer in the
	    documentation and/or other materials provided with the distribution.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
	IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED
	TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
	PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
	HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
	TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	
	*/
	
	/** 
	 * Partially complete a function.
	 * 
	 *  var add3 = partialComplete( function add(a,b){return a+b}, 3 );
	 *  
	 *  add3(4) // gives 7
	 *  
	 *  function wrap(left, right, cen){return left + " " + cen + " " + right;}
	 *  
	 *  var pirateGreeting = partialComplete( wrap , "I'm", ", a mighty pirate!" );
	 *  
	 *  pirateGreeting("Guybrush Threepwood"); 
	 *  // gives "I'm Guybrush Threepwood, a mighty pirate!"
	 */
	var partialComplete = varArgs(function( fn, args ) {
	
	      // this isn't the shortest way to write this but it does
	      // avoid creating a new array each time to pass to fn.apply,
	      // otherwise could just call boundArgs.concat(callArgs)       
	
	      var numBoundArgs = args.length;
	
	      return varArgs(function( callArgs ) {
	         
	         for (var i = 0; i < callArgs.length; i++) {
	            args[numBoundArgs + i] = callArgs[i];
	         }
	         
	         args.length = numBoundArgs + callArgs.length;         
	                     
	         return fn.apply(this, args);
	      }); 
	   }),
	
	/**
	 * Compose zero or more functions:
	 * 
	 *    compose(f1, f2, f3)(x) = f1(f2(f3(x))))
	 * 
	 * The last (inner-most) function may take more than one parameter:
	 * 
	 *    compose(f1, f2, f3)(x,y) = f1(f2(f3(x,y))))
	 */
	   compose = varArgs(function(fns) {
	
	      var fnsList = arrayAsList(fns);
	   
	      function next(params, curFn) {  
	         return [apply(params, curFn)];   
	      }
	            
	      return varArgs(function(startParams){
	        
	         return foldR(next, startParams, fnsList)[0];
	      });
	   });
	
	/**
	 * A more optimised version of compose that takes exactly two functions
	 * @param f1
	 * @param f2
	 */
	function compose2(f1, f2){
	   return function(){
	      return f1.call(this,f2.apply(this,arguments));
	   }
	}
	
	/**
	 * Generic form for a function to get a property from an object
	 * 
	 *    var o = {
	 *       foo:'bar'
	 *    }
	 *    
	 *    var getFoo = attr('foo')
	 *    
	 *    fetFoo(o) // returns 'bar'
	 * 
	 * @param {String} key the property name
	 */
	function attr(key) {
	   return function(o) { return o[key]; };
	}
	        
	/**
	 * Call a list of functions with the same args until one returns a 
	 * truthy result. Similar to the || operator.
	 * 
	 * So:
	 *      lazyUnion([f1,f2,f3 ... fn])( p1, p2 ... pn )
	 *      
	 * Is equivalent to: 
	 *      apply([p1, p2 ... pn], f1) || 
	 *      apply([p1, p2 ... pn], f2) || 
	 *      apply([p1, p2 ... pn], f3) ... apply(fn, [p1, p2 ... pn])  
	 *  
	 * @returns the first return value that is given that is truthy.
	 */
	   var lazyUnion = varArgs(function(fns) {
	
	      return varArgs(function(params){
	   
	         var maybeValue;
	   
	         for (var i = 0; i < len(fns); i++) {
	   
	            maybeValue = apply(params, fns[i]);
	   
	            if( maybeValue ) {
	               return maybeValue;
	            }
	         }
	      });
	   });   
	
	/**
	 * This file declares various pieces of functional programming.
	 * 
	 * This isn't a general purpose functional library, to keep things small it
	 * has just the parts useful for Oboe.js.
	 */
	
	
	/**
	 * Call a single function with the given arguments array.
	 * Basically, a functional-style version of the OO-style Function#apply for 
	 * when we don't care about the context ('this') of the call.
	 * 
	 * The order of arguments allows partial completion of the arguments array
	 */
	function apply(args, fn) {
	   return fn.apply(undefined, args);
	}
	
	/**
	 * Define variable argument functions but cut out all that tedious messing about 
	 * with the arguments object. Delivers the variable-length part of the arguments
	 * list as an array.
	 * 
	 * Eg:
	 * 
	 * var myFunction = varArgs(
	 *    function( fixedArgument, otherFixedArgument, variableNumberOfArguments ){
	 *       console.log( variableNumberOfArguments );
	 *    }
	 * )
	 * 
	 * myFunction('a', 'b', 1, 2, 3); // logs [1,2,3]
	 * 
	 * var myOtherFunction = varArgs(function( variableNumberOfArguments ){
	 *    console.log( variableNumberOfArguments );
	 * })
	 * 
	 * myFunction(1, 2, 3); // logs [1,2,3]
	 * 
	 */
	function varArgs(fn){
	
	   var numberOfFixedArguments = fn.length -1,
	       slice = Array.prototype.slice;          
	         
	                   
	   if( numberOfFixedArguments == 0 ) {
	      // an optimised case for when there are no fixed args:   
	   
	      return function(){
	         return fn.call(this, slice.call(arguments));
	      }
	      
	   } else if( numberOfFixedArguments == 1 ) {
	      // an optimised case for when there are is one fixed args:
	   
	      return function(){
	         return fn.call(this, arguments[0], slice.call(arguments, 1));
	      }
	   }
	   
	   // general case   
	
	   // we know how many arguments fn will always take. Create a
	   // fixed-size array to hold that many, to be re-used on
	   // every call to the returned function
	   var argsHolder = Array(fn.length);   
	                             
	   return function(){
	                            
	      for (var i = 0; i < numberOfFixedArguments; i++) {
	         argsHolder[i] = arguments[i];         
	      }
	
	      argsHolder[numberOfFixedArguments] = 
	         slice.call(arguments, numberOfFixedArguments);
	                                
	      return fn.apply( this, argsHolder);      
	   }       
	}
	
	
	/**
	 * Swap the order of parameters to a binary function
	 * 
	 * A bit like this flip: http://zvon.org/other/haskell/Outputprelude/flip_f.html
	 */
	function flip(fn){
	   return function(a, b){
	      return fn(b,a);
	   }
	}
	
	
	/**
	 * Create a function which is the intersection of two other functions.
	 * 
	 * Like the && operator, if the first is truthy, the second is never called,
	 * otherwise the return value from the second is returned.
	 */
	function lazyIntersection(fn1, fn2) {
	
	   return function (param) {
	                                                              
	      return fn1(param) && fn2(param);
	   };   
	}
	
	/**
	 * A function which does nothing
	 */
	function noop(){}
	
	/**
	 * A function which is always happy
	 */
	function always(){return true}
	
	/**
	 * Create a function which always returns the same
	 * value
	 * 
	 * var return3 = functor(3);
	 * 
	 * return3() // gives 3
	 * return3() // still gives 3
	 * return3() // will always give 3
	 */
	function functor(val){
	   return function(){
	      return val;
	   }
	}
	
	/**
	 * This file defines some loosely associated syntactic sugar for 
	 * Javascript programming 
	 */
	
	
	/**
	 * Returns true if the given candidate is of type T
	 */
	function isOfType(T, maybeSomething){
	   return maybeSomething && maybeSomething.constructor === T;
	}
	
	var len = attr('length'),    
	    isString = partialComplete(isOfType, String);
	
	/** 
	 * I don't like saying this:
	 * 
	 *    foo !=== undefined
	 *    
	 * because of the double-negative. I find this:
	 * 
	 *    defined(foo)
	 *    
	 * easier to read.
	 */ 
	function defined( value ) {
	   return value !== undefined;
	}
	
	/**
	 * Returns true if object o has a key named like every property in 
	 * the properties array. Will give false if any are missing, or if o 
	 * is not an object.
	 */
	function hasAllProperties(fieldList, o) {
	
	   return      (o instanceof Object) 
	            &&
	               all(function (field) {         
	                  return (field in o);         
	               }, fieldList);
	}
	/**
	 * Like cons in Lisp
	 */
	function cons(x, xs) {
	   
	   /* Internally lists are linked 2-element Javascript arrays.
	          
	      Ideally the return here would be Object.freeze([x,xs])
	      so that bugs related to mutation are found fast.
	      However, cons is right on the critical path for
	      performance and this slows oboe-mark down by
	      ~25%. Under theoretical future JS engines that freeze more
	      efficiently (possibly even use immutability to
	      run faster) this should be considered for
	      restoration.
	   */
	   
	   return [x,xs];
	}
	
	/**
	 * The empty list
	 */
	var emptyList = null,
	
	/**
	 * Get the head of a list.
	 * 
	 * Ie, head(cons(a,b)) = a
	 */
	    head = attr(0),
	
	/**
	 * Get the tail of a list.
	 * 
	 * Ie, tail(cons(a,b)) = b
	 */
	    tail = attr(1);
	
	
	/** 
	 * Converts an array to a list 
	 * 
	 *    asList([a,b,c])
	 * 
	 * is equivalent to:
	 *    
	 *    cons(a, cons(b, cons(c, emptyList))) 
	 **/
	function arrayAsList(inputArray){
	
	   return reverseList( 
	      inputArray.reduce(
	         flip(cons),
	         emptyList 
	      )
	   );
	}
	
	/**
	 * A varargs version of arrayAsList. Works a bit like list
	 * in LISP.
	 * 
	 *    list(a,b,c) 
	 *    
	 * is equivalent to:
	 * 
	 *    cons(a, cons(b, cons(c, emptyList)))
	 */
	var list = varArgs(arrayAsList);
	
	/**
	 * Convert a list back to a js native array
	 */
	function listAsArray(list){
	
	   return foldR( function(arraySoFar, listItem){
	      
	      arraySoFar.unshift(listItem);
	      return arraySoFar;
	           
	   }, [], list );
	   
	}
	
	/**
	 * Map a function over a list 
	 */
	function map(fn, list) {
	
	   return list
	            ? cons(fn(head(list)), map(fn,tail(list)))
	            : emptyList
	            ;
	}
	
	/**
	 * foldR implementation. Reduce a list down to a single value.
	 * 
	 * @pram {Function} fn     (rightEval, curVal) -> result 
	 */
	function foldR(fn, startValue, list) {
	      
	   return list 
	            ? fn(foldR(fn, startValue, tail(list)), head(list))
	            : startValue
	            ;
	}
	
	/**
	 * foldR implementation. Reduce a list down to a single value.
	 * 
	 * @pram {Function} fn     (rightEval, curVal) -> result 
	 */
	function foldR1(fn, list) {
	      
	   return tail(list) 
	            ? fn(foldR1(fn, tail(list)), head(list))
	            : head(list)
	            ;
	}
	
	
	/**
	 * Return a list like the one given but with the first instance equal 
	 * to item removed 
	 */
	function without(list, test, removedFn) {
	 
	   return withoutInner(list, removedFn || noop);
	 
	   function withoutInner(subList, removedFn) {
	      return subList  
	         ?  ( test(head(subList)) 
	                  ? (removedFn(head(subList)), tail(subList)) 
	                  : cons(head(subList), withoutInner(tail(subList), removedFn))
	            )
	         : emptyList
	         ;
	   }               
	}
	
	/** 
	 * Returns true if the given function holds for every item in 
	 * the list, false otherwise 
	 */
	function all(fn, list) {
	   
	   return !list || 
	          ( fn(head(list)) && all(fn, tail(list)) );
	}
	
	/**
	 * Call every function in a list of functions with the same arguments
	 * 
	 * This doesn't make any sense if we're doing pure functional because 
	 * it doesn't return anything. Hence, this is only really useful if the
	 * functions being called have side-effects. 
	 */
	function applyEach(fnList, args) {
	
	   if( fnList ) {  
	      head(fnList).apply(null, args);
	      
	      applyEach(tail(fnList), args);
	   }
	}
	
	/**
	 * Reverse the order of a list
	 */
	function reverseList(list){ 
	
	   // js re-implementation of 3rd solution from:
	   //    http://www.haskell.org/haskellwiki/99_questions/Solutions/5
	   function reverseInner( list, reversedAlready ) {
	      if( !list ) {
	         return reversedAlready;
	      }
	      
	      return reverseInner(tail(list), cons(head(list), reversedAlready))
	   }
	
	   return reverseInner(list, emptyList);
	}
	
	function first(test, list) {
	   return   list &&
	               (test(head(list)) 
	                  ? head(list) 
	                  : first(test,tail(list))); 
	}
	
	/* 
	   This is a slightly hacked-up browser only version of clarinet 
	   
	      *  some features removed to help keep browser Oboe under 
	         the 5k micro-library limit
	      *  plug directly into event bus
	   
	   For the original go here:
	      https://github.com/dscape/clarinet
	
	   We receive the events:
	      STREAM_DATA
	      STREAM_END
	      
	   We emit the events:
	      SAX_KEY
	      SAX_VALUE_OPEN
	      SAX_VALUE_CLOSE      
	      FAIL_EVENT      
	 */
	
	function clarinet(eventBus) {
	  "use strict";
	   
	  var 
	      // shortcut some events on the bus
	      emitSaxKey           = eventBus(SAX_KEY).emit,
	      emitValueOpen        = eventBus(SAX_VALUE_OPEN).emit,
	      emitValueClose       = eventBus(SAX_VALUE_CLOSE).emit,
	      emitFail             = eventBus(FAIL_EVENT).emit,
	              
	      MAX_BUFFER_LENGTH = 64 * 1024
	  ,   stringTokenPattern = /[\\"\n]/g
	  ,   _n = 0
	  
	      // states
	  ,   BEGIN                = _n++
	  ,   VALUE                = _n++ // general stuff
	  ,   OPEN_OBJECT          = _n++ // {
	  ,   CLOSE_OBJECT         = _n++ // }
	  ,   OPEN_ARRAY           = _n++ // [
	  ,   CLOSE_ARRAY          = _n++ // ]
	  ,   STRING               = _n++ // ""
	  ,   OPEN_KEY             = _n++ // , "a"
	  ,   CLOSE_KEY            = _n++ // :
	  ,   TRUE                 = _n++ // r
	  ,   TRUE2                = _n++ // u
	  ,   TRUE3                = _n++ // e
	  ,   FALSE                = _n++ // a
	  ,   FALSE2               = _n++ // l
	  ,   FALSE3               = _n++ // s
	  ,   FALSE4               = _n++ // e
	  ,   NULL                 = _n++ // u
	  ,   NULL2                = _n++ // l
	  ,   NULL3                = _n++ // l
	  ,   NUMBER_DECIMAL_POINT = _n++ // .
	  ,   NUMBER_DIGIT         = _n   // [0-9]
	
	      // setup initial parser values
	  ,   bufferCheckPosition  = MAX_BUFFER_LENGTH
	  ,   latestError                
	  ,   c                    
	  ,   p                    
	  ,   textNode             = undefined
	  ,   numberNode           = ""     
	  ,   slashed              = false
	  ,   closed               = false
	  ,   state                = BEGIN
	  ,   stack                = []
	  ,   unicodeS             = null
	  ,   unicodeI             = 0
	  ,   depth                = 0
	  ,   position             = 0
	  ,   column               = 0  //mostly for error reporting
	  ,   line                 = 1
	  ;
	
	  function checkBufferLength () {
	     
	    var maxActual = 0;
	     
	    if (textNode !== undefined && textNode.length > MAX_BUFFER_LENGTH) {
	      emitError("Max buffer length exceeded: textNode");
	      maxActual = Math.max(maxActual, textNode.length);
	    }
	    if (numberNode.length > MAX_BUFFER_LENGTH) {
	      emitError("Max buffer length exceeded: numberNode");
	      maxActual = Math.max(maxActual, numberNode.length);
	    }
	     
	    bufferCheckPosition = (MAX_BUFFER_LENGTH - maxActual)
	                               + position;
	  }
	
	  eventBus(STREAM_DATA).on(handleData);
	
	   /* At the end of the http content close the clarinet 
	    This will provide an error if the total content provided was not 
	    valid json, ie if not all arrays, objects and Strings closed properly */
	  eventBus(STREAM_END).on(handleStreamEnd);   
	
	  function emitError (errorString) {
	     if (textNode !== undefined) {
	        emitValueOpen(textNode);
	        emitValueClose();
	        textNode = undefined;
	     }
	
	     latestError = Error(errorString + "\nLn: "+line+
	                                       "\nCol: "+column+
	                                       "\nChr: "+c);
	     
	     emitFail(errorReport(undefined, undefined, latestError));
	  }
	
	  function handleStreamEnd() {
	    if( state == BEGIN ) {
	      // Handle the case where the stream closes without ever receiving
	      // any input. This isn't an error - response bodies can be blank,
	      // particularly for 204 http responses
	      
	      // Because of how Oboe is currently implemented, we parse a
	      // completely empty stream as containing an empty object.
	      // This is because Oboe's done event is only fired when the
	      // root object of the JSON stream closes.
	      
	      // This should be decoupled and attached instead to the input stream
	      // from the http (or whatever) resource ending.
	      // If this decoupling could happen the SAX parser could simply emit
	      // zero events on a completely empty input.
	      emitValueOpen({});
	      emitValueClose();
	
	      closed = true;
	      return;
	    }
	  
	    if (state !== VALUE || depth !== 0)
	      emitError("Unexpected end");
	 
	    if (textNode !== undefined) {
	      emitValueOpen(textNode);
	      emitValueClose();
	      textNode = undefined;
	    }
	     
	    closed = true;
	  }
	
	  function whitespace(c){
	     return c == '\r' || c == '\n' || c == ' ' || c == '\t';
	  }
	   
	  function handleData (chunk) {
	         
	    // this used to throw the error but inside Oboe we will have already
	    // gotten the error when it was emitted. The important thing is to
	    // not continue with the parse.
	    if (latestError)
	      return;
	      
	    if (closed) {
	       return emitError("Cannot write after close");
	    }
	
	    var i = 0;
	    c = chunk[0]; 
	
	    while (c) {
	      p = c;
	      c = chunk[i++];
	      if(!c) break;
	
	      position ++;
	      if (c == "\n") {
	        line ++;
	        column = 0;
	      } else column ++;
	      switch (state) {
	
	        case BEGIN:
	          if (c === "{") state = OPEN_OBJECT;
	          else if (c === "[") state = OPEN_ARRAY;
	          else if (!whitespace(c))
	            return emitError("Non-whitespace before {[.");
	        continue;
	
	        case OPEN_KEY:
	        case OPEN_OBJECT:
	          if (whitespace(c)) continue;
	          if(state === OPEN_KEY) stack.push(CLOSE_KEY);
	          else {
	            if(c === '}') {
	              emitValueOpen({});
	              emitValueClose();
	              state = stack.pop() || VALUE;
	              continue;
	            } else  stack.push(CLOSE_OBJECT);
	          }
	          if(c === '"')
	             state = STRING;
	          else
	             return emitError("Malformed object key should start with \" ");
	        continue;
	
	        case CLOSE_KEY:
	        case CLOSE_OBJECT:
	          if (whitespace(c)) continue;
	
	          if(c===':') {
	            if(state === CLOSE_OBJECT) {
	              stack.push(CLOSE_OBJECT);
	
	               if (textNode !== undefined) {
	                  // was previously (in upstream Clarinet) one event
	                  //  - object open came with the text of the first
	                  emitValueOpen({});
	                  emitSaxKey(textNode);
	                  textNode = undefined;
	               }
	               depth++;
	            } else {
	               if (textNode !== undefined) {
	                  emitSaxKey(textNode);
	                  textNode = undefined;
	               }
	            }
	             state  = VALUE;
	          } else if (c==='}') {
	             if (textNode !== undefined) {
	                emitValueOpen(textNode);
	                emitValueClose();
	                textNode = undefined;
	             }
	             emitValueClose();
	            depth--;
	            state = stack.pop() || VALUE;
	          } else if(c===',') {
	            if(state === CLOSE_OBJECT)
	              stack.push(CLOSE_OBJECT);
	             if (textNode !== undefined) {
	                emitValueOpen(textNode);
	                emitValueClose();
	                textNode = undefined;
	             }
	             state  = OPEN_KEY;
	          } else 
	             return emitError('Bad object');
	        continue;
	
	        case OPEN_ARRAY: // after an array there always a value
	        case VALUE:
	          if (whitespace(c)) continue;
	          if(state===OPEN_ARRAY) {
	            emitValueOpen([]);
	            depth++;             
	            state = VALUE;
	            if(c === ']') {
	              emitValueClose();
	              depth--;
	              state = stack.pop() || VALUE;
	              continue;
	            } else {
	              stack.push(CLOSE_ARRAY);
	            }
	          }
	               if(c === '"') state = STRING;
	          else if(c === '{') state = OPEN_OBJECT;
	          else if(c === '[') state = OPEN_ARRAY;
	          else if(c === 't') state = TRUE;
	          else if(c === 'f') state = FALSE;
	          else if(c === 'n') state = NULL;
	          else if(c === '-') { // keep and continue
	            numberNode += c;
	          } else if(c==='0') {
	            numberNode += c;
	            state = NUMBER_DIGIT;
	          } else if('123456789'.indexOf(c) !== -1) {
	            numberNode += c;
	            state = NUMBER_DIGIT;
	          } else               
	            return emitError("Bad value");
	        continue;
	
	        case CLOSE_ARRAY:
	          if(c===',') {
	            stack.push(CLOSE_ARRAY);
	             if (textNode !== undefined) {
	                emitValueOpen(textNode);
	                emitValueClose();
	                textNode = undefined;
	             }
	             state  = VALUE;
	          } else if (c===']') {
	             if (textNode !== undefined) {
	                emitValueOpen(textNode);
	                emitValueClose();
	                textNode = undefined;
	             }
	             emitValueClose();
	            depth--;
	            state = stack.pop() || VALUE;
	          } else if (whitespace(c))
	              continue;
	          else 
	             return emitError('Bad array');
	        continue;
	
	        case STRING:
	          if (textNode === undefined) {
	              textNode = "";
	          }
	
	          // thanks thejh, this is an about 50% performance improvement.
	          var starti              = i-1;
	           
	          STRING_BIGLOOP: while (true) {
	
	            // zero means "no unicode active". 1-4 mean "parse some more". end after 4.
	            while (unicodeI > 0) {
	              unicodeS += c;
	              c = chunk.charAt(i++);
	              if (unicodeI === 4) {
	                // TODO this might be slow? well, probably not used too often anyway
	                textNode += String.fromCharCode(parseInt(unicodeS, 16));
	                unicodeI = 0;
	                starti = i-1;
	              } else {
	                unicodeI++;
	              }
	              // we can just break here: no stuff we skipped that still has to be sliced out or so
	              if (!c) break STRING_BIGLOOP;
	            }
	            if (c === '"' && !slashed) {
	              state = stack.pop() || VALUE;
	              textNode += chunk.substring(starti, i-1);
	              break;
	            }
	            if (c === '\\' && !slashed) {
	              slashed = true;
	              textNode += chunk.substring(starti, i-1);
	               c = chunk.charAt(i++);
	              if (!c) break;
	            }
	            if (slashed) {
	              slashed = false;
	                   if (c === 'n') { textNode += '\n'; }
	              else if (c === 'r') { textNode += '\r'; }
	              else if (c === 't') { textNode += '\t'; }
	              else if (c === 'f') { textNode += '\f'; }
	              else if (c === 'b') { textNode += '\b'; }
	              else if (c === 'u') {
	                // \uxxxx. meh!
	                unicodeI = 1;
	                unicodeS = '';
	              } else {
	                textNode += c;
	              }
	              c = chunk.charAt(i++);
	              starti = i-1;
	              if (!c) break;
	              else continue;
	            }
	
	            stringTokenPattern.lastIndex = i;
	            var reResult = stringTokenPattern.exec(chunk);
	            if (!reResult) {
	              i = chunk.length+1;
	              textNode += chunk.substring(starti, i-1);
	              break;
	            }
	            i = reResult.index+1;
	            c = chunk.charAt(reResult.index);
	            if (!c) {
	              textNode += chunk.substring(starti, i-1);
	              break;
	            }
	          }
	        continue;
	
	        case TRUE:
	          if (!c)  continue; // strange buffers
	          if (c==='r') state = TRUE2;
	          else
	             return emitError( 'Invalid true started with t'+ c);
	        continue;
	
	        case TRUE2:
	          if (!c)  continue;
	          if (c==='u') state = TRUE3;
	          else
	             return emitError('Invalid true started with tr'+ c);
	        continue;
	
	        case TRUE3:
	          if (!c) continue;
	          if(c==='e') {
	            emitValueOpen(true);
	            emitValueClose();
	            state = stack.pop() || VALUE;
	          } else
	             return emitError('Invalid true started with tru'+ c);
	        continue;
	
	        case FALSE:
	          if (!c)  continue;
	          if (c==='a') state = FALSE2;
	          else
	             return emitError('Invalid false started with f'+ c);
	        continue;
	
	        case FALSE2:
	          if (!c)  continue;
	          if (c==='l') state = FALSE3;
	          else
	             return emitError('Invalid false started with fa'+ c);
	        continue;
	
	        case FALSE3:
	          if (!c)  continue;
	          if (c==='s') state = FALSE4;
	          else
	             return emitError('Invalid false started with fal'+ c);
	        continue;
	
	        case FALSE4:
	          if (!c)  continue;
	          if (c==='e') {
	            emitValueOpen(false);
	            emitValueClose();
	            state = stack.pop() || VALUE;
	          } else
	             return emitError('Invalid false started with fals'+ c);
	        continue;
	
	        case NULL:
	          if (!c)  continue;
	          if (c==='u') state = NULL2;
	          else
	             return emitError('Invalid null started with n'+ c);
	        continue;
	
	        case NULL2:
	          if (!c)  continue;
	          if (c==='l') state = NULL3;
	          else
	             return emitError('Invalid null started with nu'+ c);
	        continue;
	
	        case NULL3:
	          if (!c) continue;
	          if(c==='l') {
	            emitValueOpen(null);
	            emitValueClose();
	            state = stack.pop() || VALUE;
	          } else 
	             return emitError('Invalid null started with nul'+ c);
	        continue;
	
	        case NUMBER_DECIMAL_POINT:
	          if(c==='.') {
	            numberNode += c;
	            state       = NUMBER_DIGIT;
	          } else 
	             return emitError('Leading zero not followed by .');
	        continue;
	
	        case NUMBER_DIGIT:
	          if('0123456789'.indexOf(c) !== -1) numberNode += c;
	          else if (c==='.') {
	            if(numberNode.indexOf('.')!==-1)
	               return emitError('Invalid number has two dots');
	            numberNode += c;
	          } else if (c==='e' || c==='E') {
	            if(numberNode.indexOf('e')!==-1 ||
	               numberNode.indexOf('E')!==-1 )
	               return emitError('Invalid number has two exponential');
	            numberNode += c;
	          } else if (c==="+" || c==="-") {
	            if(!(p==='e' || p==='E'))
	               return emitError('Invalid symbol in number');
	            numberNode += c;
	          } else {
	            if (numberNode) {
	              emitValueOpen(parseFloat(numberNode));
	              emitValueClose();
	              numberNode = "";
	            }
	            i--; // go back one
	            state = stack.pop() || VALUE;
	          }
	        continue;
	
	        default:
	          return emitError("Unknown state: " + state);
	      }
	    }
	    if (position >= bufferCheckPosition)
	      checkBufferLength();
	  }
	}
	
	
	/** 
	 * A bridge used to assign stateless functions to listen to clarinet.
	 * 
	 * As well as the parameter from clarinet, each callback will also be passed
	 * the result of the last callback.
	 * 
	 * This may also be used to clear all listeners by assigning zero handlers:
	 * 
	 *    ascentManager( clarinet, {} )
	 */
	function ascentManager(oboeBus, handlers){
	   "use strict";
	   
	   var listenerId = {},
	       ascent;
	
	   function stateAfter(handler) {
	      return function(param){
	         ascent = handler( ascent, param);
	      }
	   }
	   
	   for( var eventName in handlers ) {
	
	      oboeBus(eventName).on(stateAfter(handlers[eventName]), listenerId);
	   }
	   
	   oboeBus(NODE_SWAP).on(function(newNode) {
	      
	      var oldHead = head(ascent),
	          key = keyOf(oldHead),
	          ancestors = tail(ascent),
	          parentNode;
	
	      if( ancestors ) {
	         parentNode = nodeOf(head(ancestors));
	         parentNode[key] = newNode;
	      }
	   });
	
	   oboeBus(NODE_DROP).on(function() {
	
	      var oldHead = head(ascent),
	          key = keyOf(oldHead),
	          ancestors = tail(ascent),
	          parentNode;
	
	      if( ancestors ) {
	         parentNode = nodeOf(head(ancestors));
	 
	         delete parentNode[key];
	      }
	   });
	
	   oboeBus(ABORTING).on(function(){
	      
	      for( var eventName in handlers ) {
	         oboeBus(eventName).un(listenerId);
	      }
	   });   
	}
	
	// based on gist https://gist.github.com/monsur/706839
	
	/**
	 * XmlHttpRequest's getAllResponseHeaders() method returns a string of response
	 * headers according to the format described here:
	 * http://www.w3.org/TR/XMLHttpRequest/#the-getallresponseheaders-method
	 * This method parses that string into a user-friendly key/value pair object.
	 */
	function parseResponseHeaders(headerStr) {
	   var headers = {};
	   
	   headerStr && headerStr.split('\u000d\u000a')
	      .forEach(function(headerPair){
	   
	         // Can't use split() here because it does the wrong thing
	         // if the header value has the string ": " in it.
	         var index = headerPair.indexOf('\u003a\u0020');
	         
	         headers[headerPair.substring(0, index)] 
	                     = headerPair.substring(index + 2);
	      });
	   
	   return headers;
	}
	
	/**
	 * Detect if a given URL is cross-origin in the scope of the
	 * current page.
	 * 
	 * Browser only (since cross-origin has no meaning in Node.js)
	 *
	 * @param {Object} pageLocation - as in window.location
	 * @param {Object} ajaxHost - an object like window.location describing the 
	 *    origin of the url that we want to ajax in
	 */
	function isCrossOrigin(pageLocation, ajaxHost) {
	
	   /*
	    * NB: defaultPort only knows http and https.
	    * Returns undefined otherwise.
	    */
	   function defaultPort(protocol) {
	      return {'http:':80, 'https:':443}[protocol];
	   }
	   
	   function portOf(location) {
	      // pageLocation should always have a protocol. ajaxHost if no port or
	      // protocol is specified, should use the port of the containing page
	      
	      return location.port || defaultPort(location.protocol||pageLocation.protocol);
	   }
	
	   // if ajaxHost doesn't give a domain, port is the same as pageLocation
	   // it can't give a protocol but not a domain
	   // it can't give a port but not a domain
	   
	   return !!(  (ajaxHost.protocol  && (ajaxHost.protocol  != pageLocation.protocol)) ||
	               (ajaxHost.host      && (ajaxHost.host      != pageLocation.host))     ||
	               (ajaxHost.host      && (portOf(ajaxHost) != portOf(pageLocation)))
	          );
	}
	
	/* turn any url into an object like window.location */
	function parseUrlOrigin(url) {
	   // url could be domain-relative
	   // url could give a domain
	
	   // cross origin means:
	   //    same domain
	   //    same port
	   //    some protocol
	   // so, same everything up to the first (single) slash 
	   // if such is given
	   //
	   // can ignore everything after that   
	   
	   var URL_HOST_PATTERN = /(\w+:)?(?:\/\/)([\w.-]+)?(?::(\d+))?\/?/,
	
	         // if no match, use an empty array so that
	         // subexpressions 1,2,3 are all undefined
	         // and will ultimately return all empty
	         // strings as the parse result:
	       urlHostMatch = URL_HOST_PATTERN.exec(url) || [];
	   
	   return {
	      protocol:   urlHostMatch[1] || '',
	      host:       urlHostMatch[2] || '',
	      port:       urlHostMatch[3] || ''
	   };
	}
	
	function httpTransport(){
	   return new XMLHttpRequest();
	}
	
	/**
	 * A wrapper around the browser XmlHttpRequest object that raises an 
	 * event whenever a new part of the response is available.
	 * 
	 * In older browsers progressive reading is impossible so all the 
	 * content is given in a single call. For newer ones several events
	 * should be raised, allowing progressive interpretation of the response.
	 *      
	 * @param {Function} oboeBus an event bus local to this Oboe instance
	 * @param {XMLHttpRequest} xhr the xhr to use as the transport. Under normal
	 *          operation, will have been created using httpTransport() above
	 *          but for tests a stub can be provided instead.
	 * @param {String} method one of 'GET' 'POST' 'PUT' 'PATCH' 'DELETE'
	 * @param {String} url the url to make a request to
	 * @param {String|Null} data some content to be sent with the request.
	 *                      Only valid if method is POST or PUT.
	 * @param {Object} [headers] the http request headers to send
	 * @param {boolean} withCredentials the XHR withCredentials property will be
	 *    set to this value
	 */  
	function streamingHttp(oboeBus, xhr, method, url, data, headers, withCredentials) {
	           
	   "use strict";
	   
	   var emitStreamData = oboeBus(STREAM_DATA).emit,
	       emitFail       = oboeBus(FAIL_EVENT).emit,
	       numberOfCharsAlreadyGivenToCallback = 0,
	       stillToSendStartEvent = true;
	
	   // When an ABORTING message is put on the event bus abort 
	   // the ajax request         
	   oboeBus( ABORTING ).on( function(){
	  
	      // if we keep the onreadystatechange while aborting the XHR gives 
	      // a callback like a successful call so first remove this listener
	      // by assigning null:
	      xhr.onreadystatechange = null;
	            
	      xhr.abort();
	   });
	
	   /** 
	    * Handle input from the underlying xhr: either a state change,
	    * the progress event or the request being complete.
	    */
	   function handleProgress() {
	                        
	      var textSoFar = xhr.responseText,
	          newText = textSoFar.substr(numberOfCharsAlreadyGivenToCallback);
	      
	      
	      /* Raise the event for new text.
	      
	         On older browsers, the new text is the whole response. 
	         On newer/better ones, the fragment part that we got since 
	         last progress. */
	         
	      if( newText ) {
	         emitStreamData( newText );
	      } 
	
	      numberOfCharsAlreadyGivenToCallback = len(textSoFar);
	   }
	   
	   
	   if('onprogress' in xhr){  // detect browser support for progressive delivery
	      xhr.onprogress = handleProgress;
	   }
	      
	   xhr.onreadystatechange = function() {
	
	      function sendStartIfNotAlready() {
	         // Internet Explorer is very unreliable as to when xhr.status etc can
	         // be read so has to be protected with try/catch and tried again on 
	         // the next readyState if it fails
	         try{
	            stillToSendStartEvent && oboeBus( HTTP_START ).emit(
	               xhr.status,
	               parseResponseHeaders(xhr.getAllResponseHeaders()) );
	            stillToSendStartEvent = false;
	         } catch(e){/* do nothing, will try again on next readyState*/}
	      }
	      
	      switch( xhr.readyState ) {
	               
	         case 2: // HEADERS_RECEIVED
	         case 3: // LOADING
	            return sendStartIfNotAlready();
	            
	         case 4: // DONE
	            sendStartIfNotAlready(); // if xhr.status hasn't been available yet, it must be NOW, huh IE?
	            
	            // is this a 2xx http code?
	            var successful = String(xhr.status)[0] == 2;
	            
	            if( successful ) {
	               // In Chrome 29 (not 28) no onprogress is emitted when a response
	               // is complete before the onload. We need to always do handleInput
	               // in case we get the load but have not had a final progress event.
	               // This looks like a bug and may change in future but let's take
	               // the safest approach and assume we might not have received a 
	               // progress event for each part of the response
	               handleProgress();
	               
	               oboeBus(STREAM_END).emit();
	            } else {
	
	               emitFail( errorReport(
	                  xhr.status, 
	                  xhr.responseText
	               ));
	            }
	      }
	   };
	   
	   try{
	   
	      xhr.open(method, url, true);
	   
	      for( var headerName in headers ){
	         xhr.setRequestHeader(headerName, headers[headerName]);
	      }
	      
	      if( !isCrossOrigin(window.location, parseUrlOrigin(url)) ) {
	         xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	      }
	
	      xhr.withCredentials = withCredentials;
	      
	      xhr.send(data);
	      
	   } catch( e ) {
	      
	      // To keep a consistent interface with Node, we can't emit an event here.
	      // Node's streaming http adaptor receives the error as an asynchronous
	      // event rather than as an exception. If we emitted now, the Oboe user
	      // has had no chance to add a .fail listener so there is no way
	      // the event could be useful. For both these reasons defer the
	      // firing to the next JS frame.  
	      window.setTimeout(
	         partialComplete(emitFail, errorReport(undefined, undefined, e))
	      ,  0
	      );
	   }            
	}
	
	var jsonPathSyntax = (function() {
	 
	   var
	   
	   /** 
	    * Export a regular expression as a simple function by exposing just 
	    * the Regex#exec. This allows regex tests to be used under the same 
	    * interface as differently implemented tests, or for a user of the
	    * tests to not concern themselves with their implementation as regular
	    * expressions.
	    * 
	    * This could also be expressed point-free as:
	    *   Function.prototype.bind.bind(RegExp.prototype.exec),
	    *   
	    * But that's far too confusing! (and not even smaller once minified 
	    * and gzipped)
	    */
	       regexDescriptor = function regexDescriptor(regex) {
	            return regex.exec.bind(regex);
	       }
	       
	   /**
	    * Join several regular expressions and express as a function.
	    * This allows the token patterns to reuse component regular expressions
	    * instead of being expressed in full using huge and confusing regular
	    * expressions.
	    */       
	   ,   jsonPathClause = varArgs(function( componentRegexes ) {
	
	            // The regular expressions all start with ^ because we 
	            // only want to find matches at the start of the 
	            // JSONPath fragment we are inspecting           
	            componentRegexes.unshift(/^/);
	            
	            return   regexDescriptor(
	                        RegExp(
	                           componentRegexes.map(attr('source')).join('')
	                        )
	                     );
	       })
	       
	   ,   possiblyCapturing =           /(\$?)/
	   ,   namedNode =                   /([\w-_]+|\*)/
	   ,   namePlaceholder =             /()/
	   ,   nodeInArrayNotation =         /\["([^"]+)"\]/
	   ,   numberedNodeInArrayNotation = /\[(\d+|\*)\]/
	   ,   fieldList =                      /{([\w ]*?)}/
	   ,   optionalFieldList =           /(?:{([\w ]*?)})?/
	    
	
	       //   foo or *                  
	   ,   jsonPathNamedNodeInObjectNotation   = jsonPathClause( 
	                                                possiblyCapturing, 
	                                                namedNode, 
	                                                optionalFieldList
	                                             )
	                                             
	       //   ["foo"]   
	   ,   jsonPathNamedNodeInArrayNotation    = jsonPathClause( 
	                                                possiblyCapturing, 
	                                                nodeInArrayNotation, 
	                                                optionalFieldList
	                                             )  
	
	       //   [2] or [*]       
	   ,   jsonPathNumberedNodeInArrayNotation = jsonPathClause( 
	                                                possiblyCapturing, 
	                                                numberedNodeInArrayNotation, 
	                                                optionalFieldList
	                                             )
	
	       //   {a b c}      
	   ,   jsonPathPureDuckTyping              = jsonPathClause( 
	                                                possiblyCapturing, 
	                                                namePlaceholder, 
	                                                fieldList
	                                             )
	   
	       //   ..
	   ,   jsonPathDoubleDot                   = jsonPathClause(/\.\./)                  
	   
	       //   .
	   ,   jsonPathDot                         = jsonPathClause(/\./)                    
	   
	       //   !
	   ,   jsonPathBang                        = jsonPathClause(
	                                                possiblyCapturing, 
	                                                /!/
	                                             )  
	   
	       //   nada!
	   ,   emptyString                         = jsonPathClause(/$/)                     
	   
	   ;
	   
	  
	   /* We export only a single function. When called, this function injects 
	      into another function the descriptors from above.             
	    */
	   return function (fn){      
	      return fn(      
	         lazyUnion(
	            jsonPathNamedNodeInObjectNotation
	         ,  jsonPathNamedNodeInArrayNotation
	         ,  jsonPathNumberedNodeInArrayNotation
	         ,  jsonPathPureDuckTyping 
	         )
	      ,  jsonPathDoubleDot
	      ,  jsonPathDot
	      ,  jsonPathBang
	      ,  emptyString 
	      );
	   }; 
	
	}());
	/**
	 * Get a new key->node mapping
	 * 
	 * @param {String|Number} key
	 * @param {Object|Array|String|Number|null} node a value found in the json
	 */
	function namedNode(key, node) {
	   return {key:key, node:node};
	}
	
	/** get the key of a namedNode */
	var keyOf = attr('key');
	
	/** get the node from a namedNode */
	var nodeOf = attr('node');
	/** 
	 * This file provides various listeners which can be used to build up
	 * a changing ascent based on the callbacks provided by Clarinet. It listens
	 * to the low-level events from Clarinet and emits higher-level ones.
	 *  
	 * The building up is stateless so to track a JSON file
	 * ascentManager.js is required to store the ascent state
	 * between calls.
	 */
	
	
	
	/** 
	 * A special value to use in the path list to represent the path 'to' a root 
	 * object (which doesn't really have any path). This prevents the need for 
	 * special-casing detection of the root object and allows it to be treated 
	 * like any other object. We might think of this as being similar to the 
	 * 'unnamed root' domain ".", eg if I go to 
	 * http://en.wikipedia.org./wiki/En/Main_page the dot after 'org' deliminates 
	 * the unnamed root of the DNS.
	 * 
	 * This is kept as an object to take advantage that in Javascript's OO objects 
	 * are guaranteed to be distinct, therefore no other object can possibly clash 
	 * with this one. Strings, numbers etc provide no such guarantee. 
	 **/
	var ROOT_PATH = {};
	
	
	/**
	 * Create a new set of handlers for clarinet's events, bound to the emit 
	 * function given.  
	 */ 
	function incrementalContentBuilder( oboeBus ) {
	
	   var emitNodeOpened = oboeBus(NODE_OPENED).emit,
	       emitNodeClosed = oboeBus(NODE_CLOSED).emit,
	       emitRootOpened = oboeBus(ROOT_PATH_FOUND).emit,
	       emitRootClosed = oboeBus(ROOT_NODE_FOUND).emit;
	
	   function arrayIndicesAreKeys( possiblyInconsistentAscent, newDeepestNode) {
	   
	      /* for values in arrays we aren't pre-warned of the coming paths 
	         (Clarinet gives no call to onkey like it does for values in objects) 
	         so if we are in an array we need to create this path ourselves. The 
	         key will be len(parentNode) because array keys are always sequential 
	         numbers. */
	
	      var parentNode = nodeOf( head( possiblyInconsistentAscent));
	      
	      return      isOfType( Array, parentNode)
	               ?
	                  keyFound(  possiblyInconsistentAscent, 
	                              len(parentNode), 
	                              newDeepestNode
	                  )
	               :  
	                  // nothing needed, return unchanged
	                  possiblyInconsistentAscent 
	               ;
	   }
	                 
	   function nodeOpened( ascent, newDeepestNode ) {
	      
	      if( !ascent ) {
	         // we discovered the root node,         
	         emitRootOpened( newDeepestNode);
	                    
	         return keyFound( ascent, ROOT_PATH, newDeepestNode);         
	      }
	
	      // we discovered a non-root node
	                 
	      var arrayConsistentAscent  = arrayIndicesAreKeys( ascent, newDeepestNode),      
	          ancestorBranches       = tail( arrayConsistentAscent),
	          previouslyUnmappedName = keyOf( head( arrayConsistentAscent));
	          
	      appendBuiltContent( 
	         ancestorBranches, 
	         previouslyUnmappedName, 
	         newDeepestNode 
	      );
	                                                                                                         
	      return cons( 
	               namedNode( previouslyUnmappedName, newDeepestNode ), 
	               ancestorBranches
	      );                                                                          
	   }
	
	
	   /**
	    * Add a new value to the object we are building up to represent the
	    * parsed JSON
	    */
	   function appendBuiltContent( ancestorBranches, key, node ){
	     
	      nodeOf( head( ancestorBranches))[key] = node;
	   }
	
	     
	   /**
	    * For when we find a new key in the json.
	    * 
	    * @param {String|Number|Object} newDeepestName the key. If we are in an 
	    *    array will be a number, otherwise a string. May take the special 
	    *    value ROOT_PATH if the root node has just been found
	    *    
	    * @param {String|Number|Object|Array|Null|undefined} [maybeNewDeepestNode] 
	    *    usually this won't be known so can be undefined. Can't use null 
	    *    to represent unknown because null is a valid value in JSON
	    **/  
	   function keyFound(ascent, newDeepestName, maybeNewDeepestNode) {
	
	      if( ascent ) { // if not root
	      
	         // If we have the key but (unless adding to an array) no known value
	         // yet. Put that key in the output but against no defined value:      
	         appendBuiltContent( ascent, newDeepestName, maybeNewDeepestNode );
	      }
	   
	      var ascentWithNewPath = cons( 
	                                 namedNode( newDeepestName, 
	                                            maybeNewDeepestNode), 
	                                 ascent
	                              );
	
	      emitNodeOpened( ascentWithNewPath);
	 
	      return ascentWithNewPath;
	   }
	
	
	   /**
	    * For when the current node ends.
	    */
	   function nodeClosed( ascent ) {
	
	      emitNodeClosed( ascent);
	       
	      return tail( ascent) ||
	             // If there are no nodes left in the ascent the root node
	             // just closed. Emit a special event for this: 
	             emitRootClosed(nodeOf(head(ascent)));
	   }      
	
	   var contentBuilderHandlers = {};
	   contentBuilderHandlers[SAX_VALUE_OPEN] = nodeOpened;
	   contentBuilderHandlers[SAX_VALUE_CLOSE] = nodeClosed;
	   contentBuilderHandlers[SAX_KEY] = keyFound;
	   return contentBuilderHandlers;
	}
	
	/**
	 * The jsonPath evaluator compiler used for Oboe.js. 
	 * 
	 * One function is exposed. This function takes a String JSONPath spec and 
	 * returns a function to test candidate ascents for matches.
	 * 
	 *  String jsonPath -> (List ascent) -> Boolean|Object
	 *
	 * This file is coded in a pure functional style. That is, no function has 
	 * side effects, every function evaluates to the same value for the same 
	 * arguments and no variables are reassigned.
	 */  
	// the call to jsonPathSyntax injects the token syntaxes that are needed 
	// inside the compiler
	var jsonPathCompiler = jsonPathSyntax(function (pathNodeSyntax, 
	                                                doubleDotSyntax, 
	                                                dotSyntax,
	                                                bangSyntax,
	                                                emptySyntax ) {
	
	   var CAPTURING_INDEX = 1;
	   var NAME_INDEX = 2;
	   var FIELD_LIST_INDEX = 3;
	
	   var headKey  = compose2(keyOf, head),
	       headNode = compose2(nodeOf, head);
	                   
	   /**
	    * Create an evaluator function for a named path node, expressed in the
	    * JSONPath like:
	    *    foo
	    *    ["bar"]
	    *    [2]   
	    */
	   function nameClause(previousExpr, detection ) {
	     
	      var name = detection[NAME_INDEX],
	            
	          matchesName = ( !name || name == '*' ) 
	                           ?  always
	                           :  function(ascent){return headKey(ascent) == name};
	     
	
	      return lazyIntersection(matchesName, previousExpr);
	   }
	
	   /**
	    * Create an evaluator function for a a duck-typed node, expressed like:
	    * 
	    *    {spin, taste, colour}
	    *    .particle{spin, taste, colour}
	    *    *{spin, taste, colour}
	    */
	   function duckTypeClause(previousExpr, detection) {
	
	      var fieldListStr = detection[FIELD_LIST_INDEX];
	
	      if (!fieldListStr) 
	         return previousExpr; // don't wrap at all, return given expr as-is      
	
	      var hasAllrequiredFields = partialComplete(
	                                    hasAllProperties, 
	                                    arrayAsList(fieldListStr.split(/\W+/))
	                                 ),
	                                 
	          isMatch =  compose2( 
	                        hasAllrequiredFields, 
	                        headNode
	                     );
	
	      return lazyIntersection(isMatch, previousExpr);
	   }
	
	   /**
	    * Expression for $, returns the evaluator function
	    */
	   function capture( previousExpr, detection ) {
	
	      // extract meaning from the detection      
	      var capturing = !!detection[CAPTURING_INDEX];
	
	      if (!capturing)          
	         return previousExpr; // don't wrap at all, return given expr as-is      
	      
	      return lazyIntersection(previousExpr, head);
	            
	   }            
	      
	   /**
	    * Create an evaluator function that moves onto the next item on the 
	    * lists. This function is the place where the logic to move up a 
	    * level in the ascent exists. 
	    * 
	    * Eg, for JSONPath ".foo" we need skip1(nameClause(always, [,'foo']))
	    */
	   function skip1(previousExpr) {
	   
	   
	      if( previousExpr == always ) {
	         /* If there is no previous expression this consume command 
	            is at the start of the jsonPath.
	            Since JSONPath specifies what we'd like to find but not 
	            necessarily everything leading down to it, when running
	            out of JSONPath to check against we default to true */
	         return always;
	      }
	
	      /** return true if the ascent we have contains only the JSON root,
	       *  false otherwise
	       */
	      function notAtRoot(ascent){
	         return headKey(ascent) != ROOT_PATH;
	      }
	      
	      return lazyIntersection(
	               /* If we're already at the root but there are more 
	                  expressions to satisfy, can't consume any more. No match.
	
	                  This check is why none of the other exprs have to be able 
	                  to handle empty lists; skip1 is the only evaluator that 
	                  moves onto the next token and it refuses to do so once it 
	                  reaches the last item in the list. */
	               notAtRoot,
	               
	               /* We are not at the root of the ascent yet.
	                  Move to the next level of the ascent by handing only 
	                  the tail to the previous expression */ 
	               compose2(previousExpr, tail) 
	      );
	                                                                                                               
	   }   
	   
	   /**
	    * Create an evaluator function for the .. (double dot) token. Consumes
	    * zero or more levels of the ascent, the fewest that are required to find
	    * a match when given to previousExpr.
	    */   
	   function skipMany(previousExpr) {
	
	      if( previousExpr == always ) {
	         /* If there is no previous expression this consume command 
	            is at the start of the jsonPath.
	            Since JSONPath specifies what we'd like to find but not 
	            necessarily everything leading down to it, when running
	            out of JSONPath to check against we default to true */            
	         return always;
	      }
	          
	      var 
	          // In JSONPath .. is equivalent to !.. so if .. reaches the root
	          // the match has succeeded. Ie, we might write ..foo or !..foo
	          // and both should match identically.
	          terminalCaseWhenArrivingAtRoot = rootExpr(),
	          terminalCaseWhenPreviousExpressionIsSatisfied = previousExpr,
	          recursiveCase = skip1(function(ascent) {
	             return cases(ascent);
	          }),
	
	          cases = lazyUnion(
	                     terminalCaseWhenArrivingAtRoot
	                  ,  terminalCaseWhenPreviousExpressionIsSatisfied
	                  ,  recursiveCase  
	                  );
	      
	      return cases;
	   }      
	   
	   /**
	    * Generate an evaluator for ! - matches only the root element of the json
	    * and ignores any previous expressions since nothing may precede !. 
	    */   
	   function rootExpr() {
	      
	      return function(ascent){
	         return headKey(ascent) == ROOT_PATH;
	      };
	   }   
	         
	   /**
	    * Generate a statement wrapper to sit around the outermost 
	    * clause evaluator.
	    * 
	    * Handles the case where the capturing is implicit because the JSONPath
	    * did not contain a '$' by returning the last node.
	    */   
	   function statementExpr(lastClause) {
	      
	      return function(ascent) {
	   
	         // kick off the evaluation by passing through to the last clause
	         var exprMatch = lastClause(ascent);
	                                                     
	         return exprMatch === true ? head(ascent) : exprMatch;
	      };
	   }      
	                          
	   /**
	    * For when a token has been found in the JSONPath input.
	    * Compiles the parser for that token and returns in combination with the
	    * parser already generated.
	    * 
	    * @param {Function} exprs  a list of the clause evaluator generators for
	    *                          the token that was found
	    * @param {Function} parserGeneratedSoFar the parser already found
	    * @param {Array} detection the match given by the regex engine when 
	    *                          the feature was found
	    */
	   function expressionsReader( exprs, parserGeneratedSoFar, detection ) {
	                     
	      // if exprs is zero-length foldR will pass back the 
	      // parserGeneratedSoFar as-is so we don't need to treat 
	      // this as a special case
	      
	      return   foldR( 
	                  function( parserGeneratedSoFar, expr ){
	         
	                     return expr(parserGeneratedSoFar, detection);
	                  }, 
	                  parserGeneratedSoFar, 
	                  exprs
	               );                     
	
	   }
	
	   /** 
	    *  If jsonPath matches the given detector function, creates a function which
	    *  evaluates against every clause in the clauseEvaluatorGenerators. The
	    *  created function is propagated to the onSuccess function, along with
	    *  the remaining unparsed JSONPath substring.
	    *  
	    *  The intended use is to create a clauseMatcher by filling in
	    *  the first two arguments, thus providing a function that knows
	    *  some syntax to match and what kind of generator to create if it
	    *  finds it. The parameter list once completed is:
	    *  
	    *    (jsonPath, parserGeneratedSoFar, onSuccess)
	    *  
	    *  onSuccess may be compileJsonPathToFunction, to recursively continue 
	    *  parsing after finding a match or returnFoundParser to stop here.
	    */
	   function generateClauseReaderIfTokenFound (
	     
	                        tokenDetector, clauseEvaluatorGenerators,
	                         
	                        jsonPath, parserGeneratedSoFar, onSuccess) {
	                        
	      var detected = tokenDetector(jsonPath);
	
	      if(detected) {
	         var compiledParser = expressionsReader(
	                                 clauseEvaluatorGenerators, 
	                                 parserGeneratedSoFar, 
	                                 detected
	                              ),
	         
	             remainingUnparsedJsonPath = jsonPath.substr(len(detected[0]));                
	                               
	         return onSuccess(remainingUnparsedJsonPath, compiledParser);
	      }         
	   }
	                 
	   /**
	    * Partially completes generateClauseReaderIfTokenFound above. 
	    */
	   function clauseMatcher(tokenDetector, exprs) {
	        
	      return   partialComplete( 
	                  generateClauseReaderIfTokenFound, 
	                  tokenDetector, 
	                  exprs 
	               );
	   }
	
	   /**
	    * clauseForJsonPath is a function which attempts to match against 
	    * several clause matchers in order until one matches. If non match the
	    * jsonPath expression is invalid and an error is thrown.
	    * 
	    * The parameter list is the same as a single clauseMatcher:
	    * 
	    *    (jsonPath, parserGeneratedSoFar, onSuccess)
	    */     
	   var clauseForJsonPath = lazyUnion(
	
	      clauseMatcher(pathNodeSyntax   , list( capture, 
	                                             duckTypeClause, 
	                                             nameClause, 
	                                             skip1 ))
	                                                     
	   ,  clauseMatcher(doubleDotSyntax  , list( skipMany))
	       
	       // dot is a separator only (like whitespace in other languages) but 
	       // rather than make it a special case, use an empty list of 
	       // expressions when this token is found
	   ,  clauseMatcher(dotSyntax        , list() )  
	                                                                                      
	   ,  clauseMatcher(bangSyntax       , list( capture,
	                                             rootExpr))
	                                                          
	   ,  clauseMatcher(emptySyntax      , list( statementExpr))
	   
	   ,  function (jsonPath) {
	         throw Error('"' + jsonPath + '" could not be tokenised')      
	      }
	   );
	
	
	   /**
	    * One of two possible values for the onSuccess argument of 
	    * generateClauseReaderIfTokenFound.
	    * 
	    * When this function is used, generateClauseReaderIfTokenFound simply 
	    * returns the compiledParser that it made, regardless of if there is 
	    * any remaining jsonPath to be compiled.
	    */
	   function returnFoundParser(_remainingJsonPath, compiledParser){ 
	      return compiledParser 
	   }     
	              
	   /**
	    * Recursively compile a JSONPath expression.
	    * 
	    * This function serves as one of two possible values for the onSuccess 
	    * argument of generateClauseReaderIfTokenFound, meaning continue to
	    * recursively compile. Otherwise, returnFoundParser is given and
	    * compilation terminates.
	    */
	   function compileJsonPathToFunction( uncompiledJsonPath, 
	                                       parserGeneratedSoFar ) {
	
	      /**
	       * On finding a match, if there is remaining text to be compiled
	       * we want to either continue parsing using a recursive call to 
	       * compileJsonPathToFunction. Otherwise, we want to stop and return 
	       * the parser that we have found so far.
	       */
	      var onFind =      uncompiledJsonPath
	                     ?  compileJsonPathToFunction 
	                     :  returnFoundParser;
	                   
	      return   clauseForJsonPath( 
	                  uncompiledJsonPath, 
	                  parserGeneratedSoFar, 
	                  onFind
	               );                              
	   }
	
	   /**
	    * This is the function that we expose to the rest of the library.
	    */
	   return function(jsonPath){
	        
	      try {
	         // Kick off the recursive parsing of the jsonPath 
	         return compileJsonPathToFunction(jsonPath, always);
	         
	      } catch( e ) {
	         throw Error( 'Could not compile "' + jsonPath + 
	                      '" because ' + e.message
	         );
	      }
	   }
	
	});
	
	/** 
	 * A pub/sub which is responsible for a single event type. A 
	 * multi-event type event bus is created by pubSub by collecting
	 * several of these.
	 * 
	 * @param {String} eventType                   
	 *    the name of the events managed by this singleEventPubSub
	 * @param {singleEventPubSub} [newListener]    
	 *    place to notify of new listeners
	 * @param {singleEventPubSub} [removeListener] 
	 *    place to notify of when listeners are removed
	 */
	function singleEventPubSub(eventType, newListener, removeListener){
	
	   /** we are optimised for emitting events over firing them.
	    *  As well as the tuple list which stores event ids and
	    *  listeners there is a list with just the listeners which 
	    *  can be iterated more quickly when we are emitting
	    */
	   var listenerTupleList,
	       listenerList;
	
	   function hasId(id){
	      return function(tuple) {
	         return tuple.id == id;      
	      };  
	   }
	              
	   return {
	
	      /**
	       * @param {Function} listener
	       * @param {*} listenerId 
	       *    an id that this listener can later by removed by. 
	       *    Can be of any type, to be compared to other ids using ==
	       */
	      on:function( listener, listenerId ) {
	         
	         var tuple = {
	            listener: listener
	         ,  id:       listenerId || listener // when no id is given use the
	                                             // listener function as the id
	         };
	
	         if( newListener ) {
	            newListener.emit(eventType, listener, tuple.id);
	         }
	         
	         listenerTupleList = cons( tuple,    listenerTupleList );
	         listenerList      = cons( listener, listenerList      );
	
	         return this; // chaining
	      },
	     
	      emit:function () {                                                                                           
	         applyEach( listenerList, arguments );
	      },
	      
	      un: function( listenerId ) {
	             
	         var removed;             
	              
	         listenerTupleList = without(
	            listenerTupleList,
	            hasId(listenerId),
	            function(tuple){
	               removed = tuple;
	            }
	         );    
	         
	         if( removed ) {
	            listenerList = without( listenerList, function(listener){
	               return listener == removed.listener;
	            });
	         
	            if( removeListener ) {
	               removeListener.emit(eventType, removed.listener, removed.id);
	            }
	         }
	      },
	      
	      listeners: function(){
	         // differs from Node EventEmitter: returns list, not array
	         return listenerList;
	      },
	      
	      hasListener: function(listenerId){
	         var test = listenerId? hasId(listenerId) : always;
	      
	         return defined(first( test, listenerTupleList));
	      }
	   };
	}
	/**
	 * pubSub is a curried interface for listening to and emitting
	 * events.
	 * 
	 * If we get a bus:
	 *    
	 *    var bus = pubSub();
	 * 
	 * We can listen to event 'foo' like:
	 * 
	 *    bus('foo').on(myCallback)
	 *    
	 * And emit event foo like:
	 * 
	 *    bus('foo').emit()
	 *    
	 * or, with a parameter:
	 * 
	 *    bus('foo').emit('bar')
	 *     
	 * All functions can be cached and don't need to be 
	 * bound. Ie:
	 * 
	 *    var fooEmitter = bus('foo').emit
	 *    fooEmitter('bar');  // emit an event
	 *    fooEmitter('baz');  // emit another
	 *    
	 * There's also an uncurried[1] shortcut for .emit and .on:
	 * 
	 *    bus.on('foo', callback)
	 *    bus.emit('foo', 'bar')
	 * 
	 * [1]: http://zvon.org/other/haskell/Outputprelude/uncurry_f.html
	 */
	function pubSub(){
	
	   var singles = {},
	       newListener = newSingle('newListener'),
	       removeListener = newSingle('removeListener'); 
	      
	   function newSingle(eventName) {
	      return singles[eventName] = singleEventPubSub(
	         eventName, 
	         newListener, 
	         removeListener
	      );   
	   }      
	
	   /** pubSub instances are functions */
	   function pubSubInstance( eventName ){   
	      
	      return singles[eventName] || newSingle( eventName );   
	   }
	
	   // add convenience EventEmitter-style uncurried form of 'emit' and 'on'
	   ['emit', 'on', 'un'].forEach(function(methodName){
	   
	      pubSubInstance[methodName] = varArgs(function(eventName, parameters){
	         apply( parameters, pubSubInstance( eventName )[methodName]);
	      });   
	   });
	         
	   return pubSubInstance;
	}
	
	/**
	 * This file declares some constants to use as names for event types.
	 */
	
	var // the events which are never exported are kept as 
	    // the smallest possible representation, in numbers:
	    _S = 1,
	
	    // fired whenever a new node starts in the JSON stream:
	    NODE_OPENED     = _S++,
	
	    // fired whenever a node closes in the JSON stream:
	    NODE_CLOSED     = _S++,
	
	    // called if a .node callback returns a value - 
	    NODE_SWAP       = _S++,
	    NODE_DROP       = _S++,
	
	    FAIL_EVENT      = 'fail',
	   
	    ROOT_NODE_FOUND = _S++,
	    ROOT_PATH_FOUND = _S++,
	   
	    HTTP_START      = 'start',
	    STREAM_DATA     = 'data',
	    STREAM_END      = 'end',
	    ABORTING        = _S++,
	
	    // SAX events butchered from Clarinet
	    SAX_KEY          = _S++,
	    SAX_VALUE_OPEN   = _S++,
	    SAX_VALUE_CLOSE  = _S++;
	    
	function errorReport(statusCode, body, error) {
	   try{
	      var jsonBody = JSON.parse(body);
	   }catch(e){}
	
	   return {
	      statusCode:statusCode,
	      body:body,
	      jsonBody:jsonBody,
	      thrown:error
	   };
	}    
	
	/** 
	 *  The pattern adaptor listens for newListener and removeListener
	 *  events. When patterns are added or removed it compiles the JSONPath
	 *  and wires them up.
	 *  
	 *  When nodes and paths are found it emits the fully-qualified match 
	 *  events with parameters ready to ship to the outside world
	 */
	
	function patternAdapter(oboeBus, jsonPathCompiler) {
	
	   var predicateEventMap = {
	      node:oboeBus(NODE_CLOSED)
	   ,  path:oboeBus(NODE_OPENED)
	   };
	     
	   function emitMatchingNode(emitMatch, node, ascent) {
	         
	      /* 
	         We're now calling to the outside world where Lisp-style 
	         lists will not be familiar. Convert to standard arrays. 
	   
	         Also, reverse the order because it is more common to 
	         list paths "root to leaf" than "leaf to root"  */
	      var descent     = reverseList(ascent);
	                
	      emitMatch(
	         node,
	         
	         // To make a path, strip off the last item which is the special
	         // ROOT_PATH token for the 'path' to the root node          
	         listAsArray(tail(map(keyOf,descent))),  // path
	         listAsArray(map(nodeOf, descent))       // ancestors    
	      );         
	   }
	
	   /* 
	    * Set up the catching of events such as NODE_CLOSED and NODE_OPENED and, if 
	    * matching the specified pattern, propagate to pattern-match events such as 
	    * oboeBus('node:!')
	    * 
	    * 
	    * 
	    * @param {Function} predicateEvent 
	    *          either oboeBus(NODE_CLOSED) or oboeBus(NODE_OPENED).
	    * @param {Function} compiledJsonPath          
	    */
	   function addUnderlyingListener( fullEventName, predicateEvent, compiledJsonPath ){
	   
	      var emitMatch = oboeBus(fullEventName).emit;
	   
	      predicateEvent.on( function (ascent) {
	
	         var maybeMatchingMapping = compiledJsonPath(ascent);
	
	         /* Possible values for maybeMatchingMapping are now:
	
	          false: 
	          we did not match 
	
	          an object/array/string/number/null: 
	          we matched and have the node that matched.
	          Because nulls are valid json values this can be null.
	
	          undefined:
	          we matched but don't have the matching node yet.
	          ie, we know there is an upcoming node that matches but we 
	          can't say anything else about it. 
	          */
	         if (maybeMatchingMapping !== false) {
	
	            emitMatchingNode(
	               emitMatch, 
	               nodeOf(maybeMatchingMapping), 
	               ascent
	            );
	         }
	      }, fullEventName);
	     
	      oboeBus('removeListener').on( function(removedEventName){
	
	         // if the fully qualified match event listener is later removed, clean up 
	         // by removing the underlying listener if it was the last using that pattern:
	      
	         if( removedEventName == fullEventName ) {
	         
	            if( !oboeBus(removedEventName).listeners(  )) {
	               predicateEvent.un( fullEventName );
	            }
	         }
	      });   
	   }
	
	   oboeBus('newListener').on( function(fullEventName){
	
	      var match = /(node|path):(.*)/.exec(fullEventName);
	      
	      if( match ) {
	         var predicateEvent = predicateEventMap[match[1]];
	                    
	         if( !predicateEvent.hasListener( fullEventName) ) {  
	                  
	            addUnderlyingListener(
	               fullEventName,
	               predicateEvent, 
	               jsonPathCompiler( match[2] )
	            );
	         }
	      }    
	   })
	
	}
	
	/**
	 * The instance API is the thing that is returned when oboe() is called.
	 * it allows:
	 *
	 *    - listeners for various events to be added and removed
	 *    - the http response header/headers to be read
	 */
	function instanceApi(oboeBus, contentSource){
	
	   var oboeApi,
	       fullyQualifiedNamePattern = /^(node|path):./,
	       rootNodeFinishedEvent = oboeBus(ROOT_NODE_FOUND),
	       emitNodeDrop = oboeBus(NODE_DROP).emit,
	       emitNodeSwap = oboeBus(NODE_SWAP).emit,
	
	       /**
	        * Add any kind of listener that the instance api exposes
	        */
	       addListener = varArgs(function( eventId, parameters ){
	
	            if( oboeApi[eventId] ) {
	
	               // for events added as .on(event, callback), if there is a
	               // .event() equivalent with special behaviour , pass through
	               // to that:
	               apply(parameters, oboeApi[eventId]);
	            } else {
	
	               // we have a standard Node.js EventEmitter 2-argument call.
	               // The first parameter is the listener.
	               var event = oboeBus(eventId),
	                   listener = parameters[0];
	
	               if( fullyQualifiedNamePattern.test(eventId) ) {
	
	                  // allow fully-qualified node/path listeners
	                  // to be added
	                  addForgettableCallback(event, listener);
	               } else  {
	
	                  // the event has no special handling, pass through
	                  // directly onto the event bus:
	                  event.on( listener);
	               }
	            }
	
	            return oboeApi; // chaining
	       }),
	
	       /**
	        * Remove any kind of listener that the instance api exposes
	        */
	       removeListener = function( eventId, p2, p3 ){
	
	            if( eventId == 'done' ) {
	
	               rootNodeFinishedEvent.un(p2);
	
	            } else if( eventId == 'node' || eventId == 'path' ) {
	
	               // allow removal of node and path
	               oboeBus.un(eventId + ':' + p2, p3);
	            } else {
	
	               // we have a standard Node.js EventEmitter 2-argument call.
	               // The second parameter is the listener. This may be a call
	               // to remove a fully-qualified node/path listener but requires
	               // no special handling
	               var listener = p2;
	
	               oboeBus(eventId).un(listener);
	            }
	
	            return oboeApi; // chaining
	       };
	
	   /**
	    * Add a callback, wrapped in a try/catch so as to not break the
	    * execution of Oboe if an exception is thrown (fail events are
	    * fired instead)
	    *
	    * The callback is used as the listener id so that it can later be
	    * removed using .un(callback)
	    */
	   function addProtectedCallback(eventName, callback) {
	      oboeBus(eventName).on(protectedCallback(callback), callback);
	      return oboeApi; // chaining
	   }
	
	   /**
	    * Add a callback where, if .forget() is called during the callback's
	    * execution, the callback will be de-registered
	    */
	   function addForgettableCallback(event, callback, listenerId) {
	
	      // listenerId is optional and if not given, the original
	      // callback will be used
	      listenerId = listenerId || callback;
	
	      var safeCallback = protectedCallback(callback);
	
	      event.on( function() {
	
	         var discard = false;
	
	         oboeApi.forget = function(){
	            discard = true;
	         };
	
	         apply( arguments, safeCallback );
	
	         delete oboeApi.forget;
	
	         if( discard ) {
	            event.un(listenerId);
	         }
	      }, listenerId);
	
	      return oboeApi; // chaining
	   }
	
	   /**
	    *  wrap a callback so that if it throws, Oboe.js doesn't crash but instead
	    *  throw the error in another event loop
	    */
	   function protectedCallback( callback ) {
	      return function() {
	         try{
	            return callback.apply(oboeApi, arguments);
	         }catch(e)  {
	            setTimeout(function() {
	              throw e;
	            });
	         }
	      }
	   }
	
	   /**
	    * Return the fully qualified event for when a pattern matches
	    * either a node or a path
	    *
	    * @param type {String} either 'node' or 'path'
	    */
	   function fullyQualifiedPatternMatchEvent(type, pattern) {
	      return oboeBus(type + ':' + pattern);
	   }
	
	   function wrapCallbackToSwapNodeIfSomethingReturned( callback ) {
	      return function() {
	         var returnValueFromCallback = callback.apply(this, arguments);
	
	         if( defined(returnValueFromCallback) ) {
	
	            if( returnValueFromCallback == oboe.drop ) {
	               emitNodeDrop();
	            } else {
	               emitNodeSwap(returnValueFromCallback);
	            }
	         }
	      }
	   }
	
	   function addSingleNodeOrPathListener(eventId, pattern, callback) {
	
	      var effectiveCallback;
	
	      if( eventId == 'node' ) {
	         effectiveCallback = wrapCallbackToSwapNodeIfSomethingReturned(callback);
	      } else {
	         effectiveCallback = callback;
	      }
	
	      addForgettableCallback(
	         fullyQualifiedPatternMatchEvent(eventId, pattern),
	         effectiveCallback,
	         callback
	      );
	   }
	
	   /**
	    * Add several listeners at a time, from a map
	    */
	   function addMultipleNodeOrPathListeners(eventId, listenerMap) {
	
	      for( var pattern in listenerMap ) {
	         addSingleNodeOrPathListener(eventId, pattern, listenerMap[pattern]);
	      }
	   }
	
	   /**
	    * implementation behind .onPath() and .onNode()
	    */
	   function addNodeOrPathListenerApi( eventId, jsonPathOrListenerMap, callback ){
	
	      if( isString(jsonPathOrListenerMap) ) {
	         addSingleNodeOrPathListener(eventId, jsonPathOrListenerMap, callback);
	
	      } else {
	         addMultipleNodeOrPathListeners(eventId, jsonPathOrListenerMap);
	      }
	
	      return oboeApi; // chaining
	   }
	
	
	   // some interface methods are only filled in after we receive
	   // values and are noops before that:
	   oboeBus(ROOT_PATH_FOUND).on( function(rootNode) {
	      oboeApi.root = functor(rootNode);
	   });
	
	   /**
	    * When content starts make the headers readable through the
	    * instance API
	    */
	   oboeBus(HTTP_START).on( function(_statusCode, headers) {
	
	      oboeApi.header =  function(name) {
	                           return name ? headers[name]
	                                       : headers
	                                       ;
	                        }
	   });
	
	   /**
	    * Construct and return the public API of the Oboe instance to be
	    * returned to the calling application
	    */
	   return oboeApi = {
	      on             : addListener,
	      addListener    : addListener,
	      removeListener : removeListener,
	      emit           : oboeBus.emit,
	
	      node           : partialComplete(addNodeOrPathListenerApi, 'node'),
	      path           : partialComplete(addNodeOrPathListenerApi, 'path'),
	
	      done           : partialComplete(addForgettableCallback, rootNodeFinishedEvent),
	      start          : partialComplete(addProtectedCallback, HTTP_START ),
	
	      // fail doesn't use protectedCallback because
	      // could lead to non-terminating loops
	      fail           : oboeBus(FAIL_EVENT).on,
	
	      // public api calling abort fires the ABORTING event
	      abort          : oboeBus(ABORTING).emit,
	
	      // initially return nothing for header and root
	      header         : noop,
	      root           : noop,
	
	      source         : contentSource
	   };
	}
	
	/**
	 * This file sits just behind the API which is used to attain a new
	 * Oboe instance. It creates the new components that are required
	 * and introduces them to each other.
	 */
	
	function wire (httpMethodName, contentSource, body, headers, withCredentials){
	
	   var oboeBus = pubSub();
	   
	   // Wire the input stream in if we are given a content source.
	   // This will usually be the case. If not, the instance created
	   // will have to be passed content from an external source.
	  
	   if( contentSource ) {
	
	      streamingHttp( oboeBus,
	                     httpTransport(), 
	                     httpMethodName,
	                     contentSource,
	                     body,
	                     headers,
	                     withCredentials
	      );
	   }
	
	   clarinet(oboeBus);
	
	   ascentManager(oboeBus, incrementalContentBuilder(oboeBus));
	      
	   patternAdapter(oboeBus, jsonPathCompiler);      
	      
	   return instanceApi(oboeBus, contentSource);
	}
	
	function applyDefaults( passthrough, url, httpMethodName, body, headers, withCredentials, cached ){
	
	   headers = headers ?
	      // Shallow-clone the headers array. This allows it to be
	      // modified without side effects to the caller. We don't
	      // want to change objects that the user passes in.
	      JSON.parse(JSON.stringify(headers))
	      : {};
	
	   if( body ) {
	      if( !isString(body) ) {
	
	         // If the body is not a string, stringify it. This allows objects to
	         // be given which will be sent as JSON.
	         body = JSON.stringify(body);
	
	         // Default Content-Type to JSON unless given otherwise.
	         headers['Content-Type'] = headers['Content-Type'] || 'application/json';
	      }
	   } else {
	      body = null;
	   }
	
	   // support cache busting like jQuery.ajax({cache:false})
	   function modifiedUrl(baseUrl, cached) {
	
	      if( cached === false ) {
	
	         if( baseUrl.indexOf('?') == -1 ) {
	            baseUrl += '?';
	         } else {
	            baseUrl += '&';
	         }
	
	         baseUrl += '_=' + new Date().getTime();
	      }
	      return baseUrl;
	   }
	
	   return passthrough( httpMethodName || 'GET', modifiedUrl(url, cached), body, headers, withCredentials || false );
	}
	
	// export public API
	function oboe(arg1) {
	
	   // We use duck-typing to detect if the parameter given is a stream, with the
	   // below list of parameters.
	   // Unpipe and unshift would normally be present on a stream but this breaks
	   // compatibility with Request streams.
	   // See https://github.com/jimhigson/oboe.js/issues/65
	   
	   var nodeStreamMethodNames = list('resume', 'pause', 'pipe'),
	       isStream = partialComplete(
	                     hasAllProperties
	                  ,  nodeStreamMethodNames
	                  );
	   
	   if( arg1 ) {
	      if (isStream(arg1) || isString(arg1)) {
	
	         //  simple version for GETs. Signature is:
	         //    oboe( url )
	         //  or, under node:
	         //    oboe( readableStream )
	         return applyDefaults(
	            wire,
	            arg1 // url
	         );
	
	      } else {
	
	         // method signature is:
	         //    oboe({method:m, url:u, body:b, headers:{...}})
	
	         return applyDefaults(
	            wire,
	            arg1.url,
	            arg1.method,
	            arg1.body,
	            arg1.headers,
	            arg1.withCredentials,
	            arg1.cached
	         );
	         
	      }
	   } else {
	      // wire up a no-AJAX, no-stream Oboe. Will have to have content 
	      // fed in externally and using .emit.
	      return wire();
	   }
	}
	
	/* oboe.drop is a special value. If a node callback returns this value the
	   parsed node is deleted from the JSON
	 */
	oboe.drop = function() {
	   return oboe.drop;
	};
	
	
	   if ( true ) {
	      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () { return oboe; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	   } else if (typeof exports === 'object') {
	      module.exports = oboe;
	   } else {
	      window.oboe = oboe;
	   }
	})((function(){
	   // Access to the window object throws an exception in HTML5 web workers so
	   // point it to "self" if it runs in a web worker
	      try {
	         return window;
	      } catch (e) {
	         return self;
	      }
	   }()), Object, Array, Error, JSON);


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
	// Fedor, you are amazing.
	'use strict'
	
	var asn1 = __webpack_require__(66)
	
	exports.certificate = __webpack_require__(586)
	
	var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
	  this.seq().obj(
	    this.key('version').int(),
	    this.key('modulus').int(),
	    this.key('publicExponent').int(),
	    this.key('privateExponent').int(),
	    this.key('prime1').int(),
	    this.key('prime2').int(),
	    this.key('exponent1').int(),
	    this.key('exponent2').int(),
	    this.key('coefficient').int()
	  )
	})
	exports.RSAPrivateKey = RSAPrivateKey
	
	var RSAPublicKey = asn1.define('RSAPublicKey', function () {
	  this.seq().obj(
	    this.key('modulus').int(),
	    this.key('publicExponent').int()
	  )
	})
	exports.RSAPublicKey = RSAPublicKey
	
	var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
	  this.seq().obj(
	    this.key('algorithm').use(AlgorithmIdentifier),
	    this.key('subjectPublicKey').bitstr()
	  )
	})
	exports.PublicKey = PublicKey
	
	var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
	  this.seq().obj(
	    this.key('algorithm').objid(),
	    this.key('none').null_().optional(),
	    this.key('curve').objid().optional(),
	    this.key('params').seq().obj(
	      this.key('p').int(),
	      this.key('q').int(),
	      this.key('g').int()
	    ).optional()
	  )
	})
	
	var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
	  this.seq().obj(
	    this.key('version').int(),
	    this.key('algorithm').use(AlgorithmIdentifier),
	    this.key('subjectPrivateKey').octstr()
	  )
	})
	exports.PrivateKey = PrivateKeyInfo
	var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
	  this.seq().obj(
	    this.key('algorithm').seq().obj(
	      this.key('id').objid(),
	      this.key('decrypt').seq().obj(
	        this.key('kde').seq().obj(
	          this.key('id').objid(),
	          this.key('kdeparams').seq().obj(
	            this.key('salt').octstr(),
	            this.key('iters').int()
	          )
	        ),
	        this.key('cipher').seq().obj(
	          this.key('algo').objid(),
	          this.key('iv').octstr()
	        )
	      )
	    ),
	    this.key('subjectPrivateKey').octstr()
	  )
	})
	
	exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo
	
	var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
	  this.seq().obj(
	    this.key('version').int(),
	    this.key('p').int(),
	    this.key('q').int(),
	    this.key('g').int(),
	    this.key('pub_key').int(),
	    this.key('priv_key').int()
	  )
	})
	exports.DSAPrivateKey = DSAPrivateKey
	
	exports.DSAparam = asn1.define('DSAparam', function () {
	  this.int()
	})
	
	var ECPrivateKey = asn1.define('ECPrivateKey', function () {
	  this.seq().obj(
	    this.key('version').int(),
	    this.key('privateKey').octstr(),
	    this.key('parameters').optional().explicit(0).use(ECParameters),
	    this.key('publicKey').optional().explicit(1).bitstr()
	  )
	})
	exports.ECPrivateKey = ECPrivateKey
	
	var ECParameters = asn1.define('ECParameters', function () {
	  this.choice({
	    namedCurve: this.objid()
	  })
	})
	
	exports.signature = asn1.define('signature', function () {
	  this.seq().obj(
	    this.key('r').int(),
	    this.key('s').int()
	  )
	})


/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
	// thanks to @Rantanen
	
	'use strict'
	
	var asn = __webpack_require__(66)
	
	var Time = asn.define('Time', function () {
	  this.choice({
	    utcTime: this.utctime(),
	    generalTime: this.gentime()
	  })
	})
	
	var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
	  this.seq().obj(
	    this.key('type').objid(),
	    this.key('value').any()
	  )
	})
	
	var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
	  this.seq().obj(
	    this.key('algorithm').objid(),
	    this.key('parameters').optional()
	  )
	})
	
	var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
	  this.seq().obj(
	    this.key('algorithm').use(AlgorithmIdentifier),
	    this.key('subjectPublicKey').bitstr()
	  )
	})
	
	var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
	  this.setof(AttributeTypeValue)
	})
	
	var RDNSequence = asn.define('RDNSequence', function () {
	  this.seqof(RelativeDistinguishedName)
	})
	
	var Name = asn.define('Name', function () {
	  this.choice({
	    rdnSequence: this.use(RDNSequence)
	  })
	})
	
	var Validity = asn.define('Validity', function () {
	  this.seq().obj(
	    this.key('notBefore').use(Time),
	    this.key('notAfter').use(Time)
	  )
	})
	
	var Extension = asn.define('Extension', function () {
	  this.seq().obj(
	    this.key('extnID').objid(),
	    this.key('critical').bool().def(false),
	    this.key('extnValue').octstr()
	  )
	})
	
	var TBSCertificate = asn.define('TBSCertificate', function () {
	  this.seq().obj(
	    this.key('version').explicit(0).int(),
	    this.key('serialNumber').int(),
	    this.key('signature').use(AlgorithmIdentifier),
	    this.key('issuer').use(Name),
	    this.key('validity').use(Validity),
	    this.key('subject').use(Name),
	    this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
	    this.key('issuerUniqueID').implicit(1).bitstr().optional(),
	    this.key('subjectUniqueID').implicit(2).bitstr().optional(),
	    this.key('extensions').explicit(3).seqof(Extension).optional()
	  )
	})
	
	var X509Certificate = asn.define('X509Certificate', function () {
	  this.seq().obj(
	    this.key('tbsCertificate').use(TBSCertificate),
	    this.key('signatureAlgorithm').use(AlgorithmIdentifier),
	    this.key('signatureValue').bitstr()
	  )
	})
	
	module.exports = X509Certificate


/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// adapted from https://github.com/apatil/pemstrip
	var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m
	var startRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----/m
	var fullRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m
	var evp = __webpack_require__(94)
	var ciphers = __webpack_require__(125)
	module.exports = function (okey, password) {
	  var key = okey.toString()
	  var match = key.match(findProc)
	  var decrypted
	  if (!match) {
	    var match2 = key.match(fullRegex)
	    decrypted = new Buffer(match2[2].replace(/[\r\n]/g, ''), 'base64')
	  } else {
	    var suite = 'aes' + match[1]
	    var iv = new Buffer(match[2], 'hex')
	    var cipherText = new Buffer(match[3].replace(/[\r\n]/g, ''), 'base64')
	    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
	    var out = []
	    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
	    out.push(cipher.update(cipherText))
	    out.push(cipher.final())
	    decrypted = Buffer.concat(out)
	  }
	  var tag = key.match(startRegex)[1]
	  return {
	    tag: tag,
	    data: decrypted
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	var trim = __webpack_require__(734)
	  , forEach = __webpack_require__(532)
	  , isArray = function(arg) {
	      return Object.prototype.toString.call(arg) === '[object Array]';
	    }
	
	module.exports = function (headers) {
	  if (!headers)
	    return {}
	
	  var result = {}
	
	  forEach(
	      trim(headers).split('\n')
	    , function (row) {
	        var index = row.indexOf(':')
	          , key = trim(row.slice(0, index)).toLowerCase()
	          , value = trim(row.slice(index + 1))
	
	        if (typeof(result[key]) === 'undefined') {
	          result[key] = value
	        } else if (isArray(result[key])) {
	          result[key].push(value)
	        } else {
	          result[key] = [ result[key], value ]
	        }
	      }
	  )
	
	  return result
	}

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function(crypto) {
	  function pbkdf2(password, salt, iterations, keylen, digest, callback) {
	    if ('function' === typeof digest) {
	      callback = digest
	      digest = undefined
	    }
	
	    if ('function' !== typeof callback)
	      throw new Error('No callback provided to pbkdf2')
	
	    setTimeout(function() {
	      var result
	
	      try {
	        result = pbkdf2Sync(password, salt, iterations, keylen, digest)
	      } catch (e) {
	        return callback(e)
	      }
	
	      callback(undefined, result)
	    })
	  }
	
	  function pbkdf2Sync(password, salt, iterations, keylen, digest) {
	    if ('number' !== typeof iterations)
	      throw new TypeError('Iterations not a number')
	
	    if (iterations < 0)
	      throw new TypeError('Bad iterations')
	
	    if ('number' !== typeof keylen)
	      throw new TypeError('Key length not a number')
	
	    if (keylen < 0)
	      throw new TypeError('Bad key length')
	
	    digest = digest || 'sha1'
	
	    if (!Buffer.isBuffer(password)) password = new Buffer(password)
	    if (!Buffer.isBuffer(salt)) salt = new Buffer(salt)
	
	    var hLen, l = 1, r, T
	    var DK = new Buffer(keylen)
	    var block1 = new Buffer(salt.length + 4)
	    salt.copy(block1, 0, 0, salt.length)
	
	    for (var i = 1; i <= l; i++) {
	      block1.writeUInt32BE(i, salt.length)
	
	      var U = crypto.createHmac(digest, password).update(block1).digest()
	
	      if (!hLen) {
	        hLen = U.length
	        T = new Buffer(hLen)
	        l = Math.ceil(keylen / hLen)
	        r = keylen - (l - 1) * hLen
	
	        if (keylen > (Math.pow(2, 32) - 1) * hLen)
	          throw new TypeError('keylen exceeds maximum length')
	      }
	
	      U.copy(T, 0, 0, hLen)
	
	      for (var j = 1; j < iterations; j++) {
	        U = crypto.createHmac(digest, password).update(U).digest()
	
	        for (var k = 0; k < hLen; k++) {
	          T[k] ^= U[k]
	        }
	      }
	
	      var destPos = (i - 1) * hLen
	      var len = (i == l ? r : hLen)
	      T.copy(DK, destPos, 0, len)
	    }
	
	    return DK
	  }
	
	  return {
	    pbkdf2: pbkdf2,
	    pbkdf2Sync: pbkdf2Sync
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {var checkParameters = __webpack_require__(251)
	var defaultEncoding = __webpack_require__(250)
	var sync = __webpack_require__(252)
	var Buffer = __webpack_require__(4).Buffer
	
	var ZERO_BUF
	var subtle = global.crypto && global.crypto.subtle
	var toBrowser = {
	  'sha': 'SHA-1',
	  'sha-1': 'SHA-1',
	  'sha1': 'SHA-1',
	  'sha256': 'SHA-256',
	  'sha-256': 'SHA-256',
	  'sha384': 'SHA-384',
	  'sha-384': 'SHA-384',
	  'sha-512': 'SHA-512',
	  'sha512': 'SHA-512'
	}
	var checks = []
	function checkNative (algo) {
	  if (global.process && !global.process.browser) {
	    return Promise.resolve(false)
	  }
	  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
	    return Promise.resolve(false)
	  }
	  if (checks[algo] !== undefined) {
	    return checks[algo]
	  }
	  ZERO_BUF = ZERO_BUF || Buffer.alloc(8)
	  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
	    .then(function () {
	      return true
	    }).catch(function () {
	      return false
	    })
	  checks[algo] = prom
	  return prom
	}
	function browserPbkdf2 (password, salt, iterations, length, algo) {
	  return subtle.importKey(
	    'raw', password, {name: 'PBKDF2'}, false, ['deriveBits']
	  ).then(function (key) {
	    return subtle.deriveBits({
	      name: 'PBKDF2',
	      salt: salt,
	      iterations: iterations,
	      hash: {
	        name: algo
	      }
	    }, key, length << 3)
	  }).then(function (res) {
	    return Buffer.from(res)
	  })
	}
	function resolvePromise (promise, callback) {
	  promise.then(function (out) {
	    process.nextTick(function () {
	      callback(null, out)
	    })
	  }, function (e) {
	    process.nextTick(function () {
	      callback(e)
	    })
	  })
	}
	module.exports = function (password, salt, iterations, keylen, digest, callback) {
	  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
	  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)
	
	  checkParameters(iterations, keylen)
	  if (typeof digest === 'function') {
	    callback = digest
	    digest = undefined
	  }
	  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')
	
	  digest = digest || 'sha1'
	  var algo = toBrowser[digest.toLowerCase()]
	  if (!algo || typeof global.Promise !== 'function') {
	    return process.nextTick(function () {
	      var out
	      try {
	        out = sync(password, salt, iterations, keylen, digest)
	      } catch (e) {
	        return callback(e)
	      }
	      callback(null, out)
	    })
	  }
	  resolvePromise(checkNative(algo).then(function (resp) {
	    if (resp) {
	      return browserPbkdf2(password, salt, iterations, keylen, algo)
	    } else {
	      return sync(password, salt, iterations, keylen, digest)
	    }
	  }), callback)
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(22)))

/***/ },
/* 591 */
/***/ function(module, exports) {

	'use strict';
	
	var processFn = function (fn, P, opts) {
		return function () {
			var that = this;
			var args = new Array(arguments.length);
	
			for (var i = 0; i < arguments.length; i++) {
				args[i] = arguments[i];
			}
	
			return new P(function (resolve, reject) {
				args.push(function (err, result) {
					if (err) {
						reject(err);
					} else if (opts.multiArgs) {
						var results = new Array(arguments.length - 1);
	
						for (var i = 1; i < arguments.length; i++) {
							results[i - 1] = arguments[i];
						}
	
						resolve(results);
					} else {
						resolve(result);
					}
				});
	
				fn.apply(that, args);
			});
		};
	};
	
	var pify = module.exports = function (obj, P, opts) {
		if (typeof P !== 'function') {
			opts = P;
			P = Promise;
		}
	
		opts = opts || {};
		opts.exclude = opts.exclude || [/.+Sync$/];
	
		var filter = function (key) {
			var match = function (pattern) {
				return typeof pattern === 'string' ? key === pattern : pattern.test(key);
			};
	
			return opts.include ? opts.include.some(match) : !opts.exclude.some(match);
		};
	
		var ret = typeof obj === 'function' ? function () {
			if (opts.excludeMain) {
				return obj.apply(this, arguments);
			}
	
			return processFn(obj, P, opts).apply(this, arguments);
		} : {};
	
		return Object.keys(obj).reduce(function (ret, key) {
			var x = obj[key];
	
			ret[key] = typeof x === 'function' && filter(key) ? processFn(x, P, opts) : x;
	
			return ret;
		}, ret);
	};
	
	pify.all = pify;


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(253);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(253);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(20);
	var invariant = __webpack_require__(3);
	var ReactPropTypesSecret = __webpack_require__(255);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(20);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	var assign = __webpack_require__(597);
	
	var ReactPropTypesSecret = __webpack_require__(255);
	var checkPropTypes = __webpack_require__(594);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 597 */
10,
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	exports.publicEncrypt = __webpack_require__(600);
	exports.privateDecrypt = __webpack_require__(599);
	
	exports.privateEncrypt = function privateEncrypt(key, buf) {
	  return exports.publicEncrypt(key, buf, true);
	};
	
	exports.publicDecrypt = function publicDecrypt(key, buf) {
	  return exports.privateDecrypt(key, buf, true);
	};

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var parseKeys = __webpack_require__(100);
	var mgf = __webpack_require__(256);
	var xor = __webpack_require__(258);
	var bn = __webpack_require__(7);
	var crt = __webpack_require__(127);
	var createHash = __webpack_require__(74);
	var withPublic = __webpack_require__(257);
	module.exports = function privateDecrypt(private_key, enc, reverse) {
	  var padding;
	  if (private_key.padding) {
	    padding = private_key.padding;
	  } else if (reverse) {
	    padding = 1;
	  } else {
	    padding = 4;
	  }
	  
	  var key = parseKeys(private_key);
	  var k = key.modulus.byteLength();
	  if (enc.length > k || new bn(enc).cmp(key.modulus) >= 0) {
	    throw new Error('decryption error');
	  }
	  var msg;
	  if (reverse) {
	    msg = withPublic(new bn(enc), key);
	  } else {
	    msg = crt(enc, key);
	  }
	  var zBuffer = new Buffer(k - msg.length);
	  zBuffer.fill(0);
	  msg = Buffer.concat([zBuffer, msg], k);
	  if (padding === 4) {
	    return oaep(key, msg);
	  } else if (padding === 1) {
	    return pkcs1(key, msg, reverse);
	  } else if (padding === 3) {
	    return msg;
	  } else {
	    throw new Error('unknown padding');
	  }
	};
	
	function oaep(key, msg){
	  var n = key.modulus;
	  var k = key.modulus.byteLength();
	  var mLen = msg.length;
	  var iHash = createHash('sha1').update(new Buffer('')).digest();
	  var hLen = iHash.length;
	  var hLen2 = 2 * hLen;
	  if (msg[0] !== 0) {
	    throw new Error('decryption error');
	  }
	  var maskedSeed = msg.slice(1, hLen + 1);
	  var maskedDb =  msg.slice(hLen + 1);
	  var seed = xor(maskedSeed, mgf(maskedDb, hLen));
	  var db = xor(maskedDb, mgf(seed, k - hLen - 1));
	  if (compare(iHash, db.slice(0, hLen))) {
	    throw new Error('decryption error');
	  }
	  var i = hLen;
	  while (db[i] === 0) {
	    i++;
	  }
	  if (db[i++] !== 1) {
	    throw new Error('decryption error');
	  }
	  return db.slice(i);
	}
	
	function pkcs1(key, msg, reverse){
	  var p1 = msg.slice(0, 2);
	  var i = 2;
	  var status = 0;
	  while (msg[i++] !== 0) {
	    if (i >= msg.length) {
	      status++;
	      break;
	    }
	  }
	  var ps = msg.slice(2, i - 1);
	  var p2 = msg.slice(i - 1, i);
	
	  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)){
	    status++;
	  }
	  if (ps.length < 8) {
	    status++;
	  }
	  if (status) {
	    throw new Error('decryption error');
	  }
	  return  msg.slice(i);
	}
	function compare(a, b){
	  a = new Buffer(a);
	  b = new Buffer(b);
	  var dif = 0;
	  var len = a.length;
	  if (a.length !== b.length) {
	    dif++;
	    len = Math.min(a.length, b.length);
	  }
	  var i = -1;
	  while (++i < len) {
	    dif += (a[i] ^ b[i]);
	  }
	  return dif;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var parseKeys = __webpack_require__(100);
	var randomBytes = __webpack_require__(54);
	var createHash = __webpack_require__(74);
	var mgf = __webpack_require__(256);
	var xor = __webpack_require__(258);
	var bn = __webpack_require__(7);
	var withPublic = __webpack_require__(257);
	var crt = __webpack_require__(127);
	
	var constants = {
	  RSA_PKCS1_OAEP_PADDING: 4,
	  RSA_PKCS1_PADDIN: 1,
	  RSA_NO_PADDING: 3
	};
	
	module.exports = function publicEncrypt(public_key, msg, reverse) {
	  var padding;
	  if (public_key.padding) {
	    padding = public_key.padding;
	  } else if (reverse) {
	    padding = 1;
	  } else {
	    padding = 4;
	  }
	  var key = parseKeys(public_key);
	  var paddedMsg;
	  if (padding === 4) {
	    paddedMsg = oaep(key, msg);
	  } else if (padding === 1) {
	    paddedMsg = pkcs1(key, msg, reverse);
	  } else if (padding === 3) {
	    paddedMsg = new bn(msg);
	    if (paddedMsg.cmp(key.modulus) >= 0) {
	      throw new Error('data too long for modulus');
	    }
	  } else {
	    throw new Error('unknown padding');
	  }
	  if (reverse) {
	    return crt(paddedMsg, key);
	  } else {
	    return withPublic(paddedMsg, key);
	  }
	};
	
	function oaep(key, msg){
	  var k = key.modulus.byteLength();
	  var mLen = msg.length;
	  var iHash = createHash('sha1').update(new Buffer('')).digest();
	  var hLen = iHash.length;
	  var hLen2 = 2 * hLen;
	  if (mLen > k - hLen2 - 2) {
	    throw new Error('message too long');
	  }
	  var ps = new Buffer(k - mLen - hLen2 - 2);
	  ps.fill(0);
	  var dblen = k - hLen - 1;
	  var seed = randomBytes(hLen);
	  var maskedDb = xor(Buffer.concat([iHash, ps, new Buffer([1]), msg], dblen), mgf(seed, dblen));
	  var maskedSeed = xor(seed, mgf(maskedDb, hLen));
	  return new bn(Buffer.concat([new Buffer([0]), maskedSeed, maskedDb], k));
	}
	function pkcs1(key, msg, reverse){
	  var mLen = msg.length;
	  var k = key.modulus.byteLength();
	  if (mLen > k - 11) {
	    throw new Error('message too long');
	  }
	  var ps;
	  if (reverse) {
	    ps = new Buffer(k - mLen - 3);
	    ps.fill(0xff);
	  } else {
	    ps = nonZero(k - mLen - 3);
	  }
	  return new bn(Buffer.concat([new Buffer([0, reverse?1:2]), ps, new Buffer([0]), msg], k));
	}
	function nonZero(len, crypto) {
	  var out = new Buffer(len);
	  var i = 0;
	  var cache = randomBytes(len*2);
	  var cur = 0;
	  var num;
	  while (i < len) {
	    if (cur === cache.length) {
	      cache = randomBytes(len*2);
	      cur = 0;
	    }
	    num = cache[cur++];
	    if (num) {
	      out[i++] = num;
	    }
	  }
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(310);
	var objectAssign = __webpack_require__(602);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 602 */
10,
/* 603 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ },
/* 604 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(603);
	exports.encode = exports.stringify = __webpack_require__(604);


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {'use strict'
	
	function oldBrowser () {
	  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
	}
	var safeBuffer = __webpack_require__(4)
	var randombytes = __webpack_require__(54)
	var Buffer = safeBuffer.Buffer
	var kBufferMaxLength = safeBuffer.kMaxLength
	var crypto = global.crypto || global.msCrypto
	var kMaxUint32 = Math.pow(2, 32) - 1
	function assertOffset (offset, length) {
	  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
	    throw new TypeError('offset must be a number')
	  }
	
	  if (offset > kMaxUint32 || offset < 0) {
	    throw new TypeError('offset must be a uint32')
	  }
	
	  if (offset > kBufferMaxLength || offset > length) {
	    throw new RangeError('offset out of range')
	  }
	}
	
	function assertSize (size, offset, length) {
	  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
	    throw new TypeError('size must be a number')
	  }
	
	  if (size > kMaxUint32 || size < 0) {
	    throw new TypeError('size must be a uint32')
	  }
	
	  if (size + offset > length || size > kBufferMaxLength) {
	    throw new RangeError('buffer too small')
	  }
	}
	if ((crypto && crypto.getRandomValues) || !process.browser) {
	  exports.randomFill = randomFill
	  exports.randomFillSync = randomFillSync
	} else {
	  exports.randomFill = oldBrowser
	  exports.randomFillSync = oldBrowser
	}
	function randomFill (buf, offset, size, cb) {
	  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
	    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
	  }
	
	  if (typeof offset === 'function') {
	    cb = offset
	    offset = 0
	    size = buf.length
	  } else if (typeof size === 'function') {
	    cb = size
	    size = buf.length - offset
	  } else if (typeof cb !== 'function') {
	    throw new TypeError('"cb" argument must be a function')
	  }
	  assertOffset(offset, buf.length)
	  assertSize(size, offset, buf.length)
	  return actualFill(buf, offset, size, cb)
	}
	
	function actualFill (buf, offset, size, cb) {
	  if (process.browser) {
	    var ourBuf = buf.buffer
	    var uint = new Uint8Array(ourBuf, offset, size)
	    crypto.getRandomValues(uint)
	    if (cb) {
	      process.nextTick(function () {
	        cb(null, buf)
	      })
	      return
	    }
	    return buf
	  }
	  if (cb) {
	    randombytes(size, function (err, bytes) {
	      if (err) {
	        return cb(err)
	      }
	      bytes.copy(buf, offset)
	      cb(null, buf)
	    })
	    return
	  }
	  var bytes = randombytes(size)
	  bytes.copy(buf, offset)
	  return buf
	}
	function randomFillSync (buf, offset, size) {
	  if (typeof offset === 'undefined') {
	    offset = 0
	  }
	  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
	    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
	  }
	
	  assertOffset(offset, buf.length)
	
	  if (size === undefined) size = buf.length - offset
	
	  assertSize(size, offset, buf.length)
	
	  return actualFill(buf, offset, size)
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(22)))

/***/ },
/* 607 */
/***/ function(module, exports) {

	module.exports = window.crypto;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(607);

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	var randomHex = function(size, callback) {
	    var crypto = __webpack_require__(608);
	    var isCallback = (typeof callback === 'function');
	
	    
	    if (size > 65536) {
	        if(isCallback) {
	            callback(new Error('Requested too many random bytes.'));
	        } else {
	            throw new Error('Requested too many random bytes.');
	        }
	    };
	
	
	    // is node
	    if (typeof crypto !== 'undefined' && crypto.randomBytes) {
	
	        if(isCallback) {
	            crypto.randomBytes(size, function(err, result){
	                if(!err) {
	                    callback(null, '0x'+ result.toString('hex'));
	                } else {
	                    callback(error);
	                }
	            })
	        } else {
	            return '0x'+ crypto.randomBytes(size).toString('hex');
	        }
	
	    // is browser
	    } else {
	        var cryptoLib;
	
	        if (typeof crypto !== 'undefined') {
	            cryptoLib = crypto;
	        } else if(typeof msCrypto !== 'undefined') {
	            cryptoLib = msCrypto;
	        }
	
	        if (cryptoLib && cryptoLib.getRandomValues) {
	            var randomBytes = cryptoLib.getRandomValues(new Uint8Array(size));
	            var returnValue = '0x'+ Array.from(randomBytes).map(function(arr){ return arr.toString(16); }).join('');
	
	            if(isCallback) {
	                callback(null, returnValue);
	            } else {
	                return returnValue;
	            }
	
	        // not crypto object
	        } else {
	            var error = new Error('No "crypto" object available. This Browser doesn\'t support generating secure random bytes.');
	
	            if(isCallback) {
	                callback(error);
	            } else {
	               throw error;
	            }
	        }
	    }
	};
	
	
	module.exports = randomHex;


/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(624);


/***/ },
/* 611 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(8);
	
	var focusNode = __webpack_require__(225);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(77);
	var ExecutionEnvironment = __webpack_require__(15);
	var FallbackCompositionState = __webpack_require__(619);
	var SyntheticCompositionEvent = __webpack_require__(656);
	var SyntheticInputEvent = __webpack_require__(659);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(259);
	var ExecutionEnvironment = __webpack_require__(15);
	var ReactInstrumentation = __webpack_require__(25);
	
	var camelizeStyleName = __webpack_require__(521);
	var dangerousStyleValue = __webpack_require__(665);
	var hyphenateStyleName = __webpack_require__(528);
	var memoizeStringOnly = __webpack_require__(531);
	var warning = __webpack_require__(5);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(76);
	var EventPropagators = __webpack_require__(77);
	var ExecutionEnvironment = __webpack_require__(15);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(28);
	var SyntheticEvent = __webpack_require__(33);
	
	var inputValueTracking = __webpack_require__(275);
	var getEventTarget = __webpack_require__(155);
	var isEventSupported = __webpack_require__(156);
	var isTextInputElement = __webpack_require__(277);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var DOMLazyTree = __webpack_require__(55);
	var ExecutionEnvironment = __webpack_require__(15);
	
	var createNodesFromMarkup = __webpack_require__(524);
	var emptyFunction = __webpack_require__(20);
	var invariant = __webpack_require__(3);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 617 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(77);
	var ReactDOMComponentTree = __webpack_require__(8);
	var SyntheticMouseEvent = __webpack_require__(103);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var PooledClass = __webpack_require__(46);
	
	var getTextContentAccessor = __webpack_require__(274);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(56);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(57);
	
	var instantiateReactComponent = __webpack_require__(276);
	var KeyEscapeUtils = __webpack_require__(147);
	var shouldUpdateReactComponent = __webpack_require__(157);
	var traverseAllChildren = __webpack_require__(279);
	var warning = __webpack_require__(5);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(292);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(143);
	var ReactDOMIDOperations = __webpack_require__(629);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(10);
	
	var React = __webpack_require__(60);
	var ReactComponentEnvironment = __webpack_require__(149);
	var ReactCurrentOwner = __webpack_require__(34);
	var ReactErrorUtils = __webpack_require__(150);
	var ReactInstanceMap = __webpack_require__(78);
	var ReactInstrumentation = __webpack_require__(25);
	var ReactNodeTypes = __webpack_require__(269);
	var ReactReconciler = __webpack_require__(57);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(95);
	var invariant = __webpack_require__(3);
	var shallowEqual = __webpack_require__(136);
	var shouldUpdateReactComponent = __webpack_require__(157);
	var warning = __webpack_require__(5);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDefaultInjection = __webpack_require__(637);
	var ReactMount = __webpack_require__(268);
	var ReactReconciler = __webpack_require__(57);
	var ReactUpdates = __webpack_require__(28);
	var ReactVersion = __webpack_require__(650);
	
	var findDOMNode = __webpack_require__(666);
	var getHostComponentFromComposite = __webpack_require__(273);
	var renderSubtreeIntoContainer = __webpack_require__(673);
	var warning = __webpack_require__(5);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(10);
	
	var AutoFocusUtils = __webpack_require__(612);
	var CSSPropertyOperations = __webpack_require__(614);
	var DOMLazyTree = __webpack_require__(55);
	var DOMNamespaces = __webpack_require__(144);
	var DOMProperty = __webpack_require__(56);
	var DOMPropertyOperations = __webpack_require__(261);
	var EventPluginHub = __webpack_require__(76);
	var EventPluginRegistry = __webpack_require__(145);
	var ReactBrowserEventEmitter = __webpack_require__(102);
	var ReactDOMComponentFlags = __webpack_require__(262);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDOMInput = __webpack_require__(630);
	var ReactDOMOption = __webpack_require__(631);
	var ReactDOMSelect = __webpack_require__(263);
	var ReactDOMTextarea = __webpack_require__(634);
	var ReactInstrumentation = __webpack_require__(25);
	var ReactMultiChild = __webpack_require__(643);
	var ReactServerRenderingTransaction = __webpack_require__(648);
	
	var emptyFunction = __webpack_require__(20);
	var escapeTextContentForBrowser = __webpack_require__(105);
	var invariant = __webpack_require__(3);
	var isEventSupported = __webpack_require__(156);
	var shallowEqual = __webpack_require__(136);
	var inputValueTracking = __webpack_require__(275);
	var validateDOMNesting = __webpack_require__(158);
	var warning = __webpack_require__(5);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(158);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var DOMLazyTree = __webpack_require__(55);
	var ReactDOMComponentTree = __webpack_require__(8);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 628 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(143);
	var ReactDOMComponentTree = __webpack_require__(8);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(10);
	
	var DOMPropertyOperations = __webpack_require__(261);
	var LinkedValueUtils = __webpack_require__(148);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(28);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var React = __webpack_require__(60);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDOMSelect = __webpack_require__(263);
	
	var warning = __webpack_require__(5);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(15);
	
	var getNodeForCharacterOffset = __webpack_require__(670);
	var getTextContentAccessor = __webpack_require__(274);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(10);
	
	var DOMChildrenOperations = __webpack_require__(143);
	var DOMLazyTree = __webpack_require__(55);
	var ReactDOMComponentTree = __webpack_require__(8);
	
	var escapeTextContentForBrowser = __webpack_require__(105);
	var invariant = __webpack_require__(3);
	var validateDOMNesting = __webpack_require__(158);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(10);
	
	var LinkedValueUtils = __webpack_require__(148);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(28);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var ReactUpdates = __webpack_require__(28);
	var Transaction = __webpack_require__(104);
	
	var emptyFunction = __webpack_require__(20);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(611);
	var BeforeInputEventPlugin = __webpack_require__(613);
	var ChangeEventPlugin = __webpack_require__(615);
	var DefaultEventPluginOrder = __webpack_require__(617);
	var EnterLeaveEventPlugin = __webpack_require__(618);
	var HTMLDOMPropertyConfig = __webpack_require__(620);
	var ReactComponentBrowserEnvironment = __webpack_require__(622);
	var ReactDOMComponent = __webpack_require__(625);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDOMEmptyComponent = __webpack_require__(627);
	var ReactDOMTreeTraversal = __webpack_require__(635);
	var ReactDOMTextComponent = __webpack_require__(633);
	var ReactDefaultBatchingStrategy = __webpack_require__(636);
	var ReactEventListener = __webpack_require__(640);
	var ReactInjection = __webpack_require__(641);
	var ReactReconcileTransaction = __webpack_require__(646);
	var SVGDOMPropertyConfig = __webpack_require__(651);
	var SelectEventPlugin = __webpack_require__(652);
	var SimpleEventPlugin = __webpack_require__(653);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 638 */
293,
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(76);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var EventListener = __webpack_require__(224);
	var ExecutionEnvironment = __webpack_require__(15);
	var PooledClass = __webpack_require__(46);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(28);
	
	var getEventTarget = __webpack_require__(155);
	var getUnboundedScrollPosition = __webpack_require__(526);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(56);
	var EventPluginHub = __webpack_require__(76);
	var EventPluginUtils = __webpack_require__(146);
	var ReactComponentEnvironment = __webpack_require__(149);
	var ReactEmptyComponent = __webpack_require__(264);
	var ReactBrowserEventEmitter = __webpack_require__(102);
	var ReactHostComponent = __webpack_require__(266);
	var ReactUpdates = __webpack_require__(28);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(664);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactComponentEnvironment = __webpack_require__(149);
	var ReactInstanceMap = __webpack_require__(78);
	var ReactInstrumentation = __webpack_require__(25);
	
	var ReactCurrentOwner = __webpack_require__(34);
	var ReactReconciler = __webpack_require__(57);
	var ReactChildReconciler = __webpack_require__(621);
	
	var emptyFunction = __webpack_require__(20);
	var flattenChildren = __webpack_require__(667);
	var invariant = __webpack_require__(3);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 645 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var CallbackQueue = __webpack_require__(260);
	var PooledClass = __webpack_require__(46);
	var ReactBrowserEventEmitter = __webpack_require__(102);
	var ReactInputSelection = __webpack_require__(267);
	var ReactInstrumentation = __webpack_require__(25);
	var Transaction = __webpack_require__(104);
	var ReactUpdateQueue = __webpack_require__(151);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(644);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var PooledClass = __webpack_require__(46);
	var Transaction = __webpack_require__(104);
	var ReactInstrumentation = __webpack_require__(25);
	var ReactServerUpdateQueue = __webpack_require__(649);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(151);
	
	var warning = __webpack_require__(5);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 650 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 651 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(77);
	var ExecutionEnvironment = __webpack_require__(15);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactInputSelection = __webpack_require__(267);
	var SyntheticEvent = __webpack_require__(33);
	
	var getActiveElement = __webpack_require__(226);
	var isTextInputElement = __webpack_require__(277);
	var shallowEqual = __webpack_require__(136);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var EventListener = __webpack_require__(224);
	var EventPropagators = __webpack_require__(77);
	var ReactDOMComponentTree = __webpack_require__(8);
	var SyntheticAnimationEvent = __webpack_require__(654);
	var SyntheticClipboardEvent = __webpack_require__(655);
	var SyntheticEvent = __webpack_require__(33);
	var SyntheticFocusEvent = __webpack_require__(658);
	var SyntheticKeyboardEvent = __webpack_require__(660);
	var SyntheticMouseEvent = __webpack_require__(103);
	var SyntheticDragEvent = __webpack_require__(657);
	var SyntheticTouchEvent = __webpack_require__(661);
	var SyntheticTransitionEvent = __webpack_require__(662);
	var SyntheticUIEvent = __webpack_require__(79);
	var SyntheticWheelEvent = __webpack_require__(663);
	
	var emptyFunction = __webpack_require__(20);
	var getEventCharCode = __webpack_require__(153);
	var invariant = __webpack_require__(3);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(33);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(33);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(33);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(103);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(79);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(33);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(79);
	
	var getEventCharCode = __webpack_require__(153);
	var getEventKey = __webpack_require__(668);
	var getEventModifierState = __webpack_require__(154);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(79);
	
	var getEventModifierState = __webpack_require__(154);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(33);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(103);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 664 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(259);
	var warning = __webpack_require__(5);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(34);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactInstanceMap = __webpack_require__(78);
	
	var getHostComponentFromComposite = __webpack_require__(273);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(147);
	var traverseAllChildren = __webpack_require__(279);
	var warning = __webpack_require__(5);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(292);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(153);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 669 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 670 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(15);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(105);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(268);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actions = __webpack_require__(280);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	}

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = syncHistoryWithStore;
	
	var _reducer = __webpack_require__(281);
	
	var defaultSelectLocationState = function defaultSelectLocationState(state) {
	  return state.routing;
	};
	
	/**
	 * This function synchronizes your history state with the Redux store.
	 * Location changes flow from history to the store. An enhanced history is
	 * returned with a listen method that responds to store updates for location.
	 *
	 * When this history is provided to the router, this means the location data
	 * will flow like this:
	 * history.push -> store.dispatch -> enhancedHistory.listen -> router
	 * This ensures that when the store state changes due to a replay or other
	 * event, the router will be updated appropriately and can transition to the
	 * correct router state.
	 */
	function syncHistoryWithStore(history, store) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref$selectLocationSt = _ref.selectLocationState,
	      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
	      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
	      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
	
	  // Ensure that the reducer is mounted on the store and functioning properly.
	  if (typeof selectLocationState(store.getState()) === 'undefined') {
	    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
	  }
	
	  var initialLocation = void 0;
	  var isTimeTraveling = void 0;
	  var unsubscribeFromStore = void 0;
	  var unsubscribeFromHistory = void 0;
	  var currentLocation = void 0;
	
	  // What does the store say about current location?
	  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
	    var locationState = selectLocationState(store.getState());
	    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
	  };
	
	  // Init initialLocation with potential location in store
	  initialLocation = getLocationInStore();
	
	  // If the store is replayed, update the URL in the browser to match.
	  if (adjustUrlOnReplay) {
	    var handleStoreChange = function handleStoreChange() {
	      var locationInStore = getLocationInStore(true);
	      if (currentLocation === locationInStore || initialLocation === locationInStore) {
	        return;
	      }
	
	      // Update address bar to reflect store state
	      isTimeTraveling = true;
	      currentLocation = locationInStore;
	      history.transitionTo(_extends({}, locationInStore, {
	        action: 'PUSH'
	      }));
	      isTimeTraveling = false;
	    };
	
	    unsubscribeFromStore = store.subscribe(handleStoreChange);
	    handleStoreChange();
	  }
	
	  // Whenever location changes, dispatch an action to get it in the store
	  var handleLocationChange = function handleLocationChange(location) {
	    // ... unless we just caused that location change
	    if (isTimeTraveling) {
	      return;
	    }
	
	    // Remember where we are
	    currentLocation = location;
	
	    // Are we being called for the first time?
	    if (!initialLocation) {
	      // Remember as a fallback in case state is reset
	      initialLocation = location;
	
	      // Respect persisted location, if any
	      if (getLocationInStore()) {
	        return;
	      }
	    }
	
	    // Tell the store to update by dispatching an action
	    store.dispatch({
	      type: _reducer.LOCATION_CHANGE,
	      payload: location
	    });
	  };
	  unsubscribeFromHistory = history.listen(handleLocationChange);
	
	  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
	  if (history.getCurrentLocation) {
	    handleLocationChange(history.getCurrentLocation());
	  }
	
	  // The enhanced history uses store as source of truth
	  return _extends({}, history, {
	    // The listeners are subscribed to the store instead of history
	    listen: function listen(listener) {
	      // Copy of last location.
	      var lastPublishedLocation = getLocationInStore(true);
	
	      // Keep track of whether we unsubscribed, as Redux store
	      // only applies changes in subscriptions on next dispatch
	      var unsubscribed = false;
	      var unsubscribeFromStore = store.subscribe(function () {
	        var currentLocation = getLocationInStore(true);
	        if (currentLocation === lastPublishedLocation) {
	          return;
	        }
	        lastPublishedLocation = currentLocation;
	        if (!unsubscribed) {
	          listener(lastPublishedLocation);
	        }
	      });
	
	      // History 2.x listeners expect a synchronous call. Make the first call to the
	      // listener after subscribing to the store, in case the listener causes a
	      // location change (e.g. when it redirects)
	      if (!history.getCurrentLocation) {
	        listener(lastPublishedLocation);
	      }
	
	      // Let user unsubscribe later
	      return function () {
	        unsubscribed = true;
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // It also provides a way to destroy internal listeners
	    unsubscribe: function unsubscribe() {
	      if (adjustUrlOnReplay) {
	        unsubscribeFromStore();
	      }
	      unsubscribeFromHistory();
	    }
	  });
	}

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(32);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__(282);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(32);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(11);
	
	var _routerWarning = __webpack_require__(59);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(284);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(80);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(32);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(11);
	
	var _routerWarning = __webpack_require__(59);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(41);
	
	var _InternalPropTypes = __webpack_require__(80);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(32);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(11);
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(41);
	
	var _InternalPropTypes = __webpack_require__(80);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(32);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(11);
	
	var _createTransitionManager2 = __webpack_require__(288);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(80);
	
	var _RouterContext = __webpack_require__(163);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(41);
	
	var _RouterUtils = __webpack_require__(285);
	
	var _routerWarning = __webpack_require__(59);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	
	  /**
	   * A <Router> is a high-level API for automatically setting up
	   * a router that renders a <RouterContext> with all the props
	   * it needs each time the URL changes.
	   */
	};var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__(160);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(163);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(59);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(544);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(287);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(58);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(160);
	
	var _PromiseUtils = __webpack_require__(283);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(58);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(545);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(287);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(58);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(96);
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(286);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(288);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(41);
	
	var _RouterUtils = __webpack_require__(285);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(160);
	
	var _PromiseUtils = __webpack_require__(283);
	
	var _PatternUtils = __webpack_require__(58);
	
	var _routerWarning = __webpack_require__(59);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(16);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(32);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__(548);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(161);
	
	var _PropTypes = __webpack_require__(162);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 692 */
147,
/* 693 */
[793, 81],
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(693);
	var ReactElement = __webpack_require__(61);
	
	var emptyFunction = __webpack_require__(20);
	var traverseAllChildren = __webpack_require__(703);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(61);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(61),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(254);
	
	module.exports = factory(isValidElement);

/***/ },
/* 697 */
650,
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(291),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(61),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(294);
	var factory = __webpack_require__(208);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 699 */
669,
/* 700 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(81);
	
	var ReactElement = __webpack_require__(61);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(81);
	
	var ReactCurrentOwner = __webpack_require__(34);
	var REACT_ELEMENT_TYPE = __webpack_require__(293);
	
	var getIteratorFn = __webpack_require__(699);
	var invariant = __webpack_require__(3);
	var KeyEscapeUtils = __webpack_require__(692);
	var warning = __webpack_require__(5);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(47);


/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(297);
	
	/*<replacement>*/
	var util = __webpack_require__(73);
	util.inherits = __webpack_require__(2);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(4).Buffer;
	var util = __webpack_require__(790);
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();
	
	if (util && util.inspect && util.inspect.custom) {
	  module.exports.prototype[util.inspect.custom] = function () {
	    var obj = util.inspect({ length: this.length });
	    return this.constructor.name + ' ' + obj;
	  };
	}

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(166).PassThrough


/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(166).Transform


/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(165);


/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.utils = exports.effects = exports.CANCEL = exports.delay = exports.throttle = exports.takeLatest = exports.takeEvery = exports.buffers = exports.channel = exports.eventChannel = exports.END = exports.runSaga = undefined;
	
	var _runSaga = __webpack_require__(302);
	
	Object.defineProperty(exports, 'runSaga', {
	  enumerable: true,
	  get: function get() {
	    return _runSaga.runSaga;
	  }
	});
	
	var _channel = __webpack_require__(62);
	
	Object.defineProperty(exports, 'END', {
	  enumerable: true,
	  get: function get() {
	    return _channel.END;
	  }
	});
	Object.defineProperty(exports, 'eventChannel', {
	  enumerable: true,
	  get: function get() {
	    return _channel.eventChannel;
	  }
	});
	Object.defineProperty(exports, 'channel', {
	  enumerable: true,
	  get: function get() {
	    return _channel.channel;
	  }
	});
	
	var _buffers = __webpack_require__(107);
	
	Object.defineProperty(exports, 'buffers', {
	  enumerable: true,
	  get: function get() {
	    return _buffers.buffers;
	  }
	});
	
	var _sagaHelpers = __webpack_require__(303);
	
	Object.defineProperty(exports, 'takeEvery', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.takeEvery;
	  }
	});
	Object.defineProperty(exports, 'takeLatest', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.takeLatest;
	  }
	});
	Object.defineProperty(exports, 'throttle', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.throttle;
	  }
	});
	
	var _utils = __webpack_require__(26);
	
	Object.defineProperty(exports, 'delay', {
	  enumerable: true,
	  get: function get() {
	    return _utils.delay;
	  }
	});
	Object.defineProperty(exports, 'CANCEL', {
	  enumerable: true,
	  get: function get() {
	    return _utils.CANCEL;
	  }
	});
	
	var _middleware = __webpack_require__(711);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	var _effects = __webpack_require__(300);
	
	var effects = _interopRequireWildcard(_effects);
	
	var _utils2 = __webpack_require__(715);
	
	var utils = _interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _middleware2.default;
	exports.effects = effects;
	exports.utils = utils;

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = sagaMiddlewareFactory;
	
	var _utils = __webpack_require__(26);
	
	var _channel = __webpack_require__(62);
	
	var _runSaga = __webpack_require__(302);
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function sagaMiddlewareFactory() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var _ref$context = _ref.context,
	      context = _ref$context === undefined ? {} : _ref$context,
	      options = _objectWithoutProperties(_ref, ['context']);
	
	  var sagaMonitor = options.sagaMonitor,
	      logger = options.logger,
	      onError = options.onError;
	
	
	  if (_utils.is.func(options)) {
	    if (true) {
	      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
	    } else {
	      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
	    }
	  }
	
	  if (logger && !_utils.is.func(logger)) {
	    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
	  }
	
	  if (false) {
	    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
	  }
	
	  if (onError && !_utils.is.func(onError)) {
	    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
	  }
	
	  if (options.emitter && !_utils.is.func(options.emitter)) {
	    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
	  }
	
	  function sagaMiddleware(_ref2) {
	    var getState = _ref2.getState,
	        dispatch = _ref2.dispatch;
	
	    var sagaEmitter = (0, _channel.emitter)();
	    sagaEmitter.emit = (options.emitter || _utils.ident)(sagaEmitter.emit);
	
	    sagaMiddleware.run = _runSaga.runSaga.bind(null, {
	      context: context,
	      subscribe: sagaEmitter.subscribe,
	      dispatch: dispatch,
	      getState: getState,
	      sagaMonitor: sagaMonitor,
	      logger: logger,
	      onError: onError
	    });
	
	    return function (next) {
	      return function (action) {
	        if (sagaMonitor && sagaMonitor.actionDispatched) {
	          sagaMonitor.actionDispatched(action);
	        }
	        var result = next(action); // hit reducers
	        sagaEmitter.emit(action);
	        return result;
	      };
	    };
	  }
	
	  sagaMiddleware.run = function () {
	    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
	  };
	
	  sagaMiddleware.setContext = function (props) {
	    (0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)('sagaMiddleware', props));
	    _utils.object.assign(context, props);
	  };
	
	  return sagaMiddleware;
	}

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = takeEvery;
	
	var _fsmIterator = __webpack_require__(167);
	
	var _fsmIterator2 = _interopRequireDefault(_fsmIterator);
	
	var _io = __webpack_require__(63);
	
	var _channel = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function takeEvery(patternOrChannel, worker) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var yTake = { done: false, value: (0, _io.take)(patternOrChannel) };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	
	  var action = void 0,
	      setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return (0, _fsmIterator2.default)({
	    q1: function q1() {
	      return ['q2', yTake, setAction];
	    },
	    q2: function q2() {
	      return action === _channel.END ? [_fsmIterator.qEnd] : ['q1', yFork(action)];
	    }
	  }, 'q1', 'takeEvery(' + (0, _fsmIterator.safeName)(patternOrChannel) + ', ' + worker.name + ')');
	}

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = takeLatest;
	
	var _fsmIterator = __webpack_require__(167);
	
	var _fsmIterator2 = _interopRequireDefault(_fsmIterator);
	
	var _io = __webpack_require__(63);
	
	var _channel = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function takeLatest(patternOrChannel, worker) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var yTake = { done: false, value: (0, _io.take)(patternOrChannel) };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	  var yCancel = function yCancel(task) {
	    return { done: false, value: (0, _io.cancel)(task) };
	  };
	
	  var task = void 0,
	      action = void 0;
	  var setTask = function setTask(t) {
	    return task = t;
	  };
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return (0, _fsmIterator2.default)({
	    q1: function q1() {
	      return ['q2', yTake, setAction];
	    },
	    q2: function q2() {
	      return action === _channel.END ? [_fsmIterator.qEnd] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
	    },
	    q3: function q3() {
	      return ['q1', yFork(action), setTask];
	    }
	  }, 'q1', 'takeLatest(' + (0, _fsmIterator.safeName)(patternOrChannel) + ', ' + worker.name + ')');
	}

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = throttle;
	
	var _fsmIterator = __webpack_require__(167);
	
	var _fsmIterator2 = _interopRequireDefault(_fsmIterator);
	
	var _io = __webpack_require__(63);
	
	var _channel = __webpack_require__(62);
	
	var _buffers = __webpack_require__(107);
	
	var _utils = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function throttle(delayLength, pattern, worker) {
	  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    args[_key - 3] = arguments[_key];
	  }
	
	  var action = void 0,
	      channel = void 0;
	
	  var yActionChannel = { done: false, value: (0, _io.actionChannel)(pattern, _buffers.buffers.sliding(1)) };
	  var yTake = function yTake() {
	    return { done: false, value: (0, _io.take)(channel) };
	  };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	  var yDelay = { done: false, value: (0, _io.call)(_utils.delay, delayLength) };
	
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	  var setChannel = function setChannel(ch) {
	    return channel = ch;
	  };
	
	  return (0, _fsmIterator2.default)({
	    q1: function q1() {
	      return ['q2', yActionChannel, setChannel];
	    },
	    q2: function q2() {
	      return ['q3', yTake(), setAction];
	    },
	    q3: function q3() {
	      return action === _channel.END ? [_fsmIterator.qEnd] : ['q4', yFork(action)];
	    },
	    q4: function q4() {
	      return ['q2', yDelay];
	    }
	  }, 'q1', 'throttle(' + (0, _fsmIterator.safeName)(pattern) + ', ' + worker.name + ')');
	}

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(26);
	
	Object.defineProperty(exports, 'TASK', {
	  enumerable: true,
	  get: function get() {
	    return _utils.TASK;
	  }
	});
	Object.defineProperty(exports, 'SAGA_ACTION', {
	  enumerable: true,
	  get: function get() {
	    return _utils.SAGA_ACTION;
	  }
	});
	Object.defineProperty(exports, 'noop', {
	  enumerable: true,
	  get: function get() {
	    return _utils.noop;
	  }
	});
	Object.defineProperty(exports, 'is', {
	  enumerable: true,
	  get: function get() {
	    return _utils.is;
	  }
	});
	Object.defineProperty(exports, 'deferred', {
	  enumerable: true,
	  get: function get() {
	    return _utils.deferred;
	  }
	});
	Object.defineProperty(exports, 'arrayOfDeffered', {
	  enumerable: true,
	  get: function get() {
	    return _utils.arrayOfDeffered;
	  }
	});
	Object.defineProperty(exports, 'createMockTask', {
	  enumerable: true,
	  get: function get() {
	    return _utils.createMockTask;
	  }
	});
	Object.defineProperty(exports, 'cloneableGenerator', {
	  enumerable: true,
	  get: function get() {
	    return _utils.cloneableGenerator;
	  }
	});
	
	var _io = __webpack_require__(63);
	
	Object.defineProperty(exports, 'asEffect', {
	  enumerable: true,
	  get: function get() {
	    return _io.asEffect;
	  }
	});
	
	var _proc = __webpack_require__(301);
	
	Object.defineProperty(exports, 'CHANNEL_END', {
	  enumerable: true,
	  get: function get() {
	    return _proc.CHANNEL_END;
	  }
	});

/***/ },
/* 716 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(305);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 718 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(306);
	
	var _isPlainObject = __webpack_require__(246);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(307);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(721);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}


/***/ },
/* 721 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(723)


/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var pbkdf2Sync = __webpack_require__(142).pbkdf2Sync
	
	var MAX_VALUE = 0x7fffffff
	
	// N = Cpu cost, r = Memory cost, p = parallelization cost
	function scrypt (key, salt, N, r, p, dkLen, progressCallback) {
	  if (N === 0 || (N & (N - 1)) !== 0) throw Error('N must be > 0 and a power of 2')
	
	  if (N > MAX_VALUE / 128 / r) throw Error('Parameter N is too large')
	  if (r > MAX_VALUE / 128 / p) throw Error('Parameter r is too large')
	
	  var XY = new Buffer(256 * r)
	  var V = new Buffer(128 * r * N)
	
	  // pseudo global
	  var B32 = new Int32Array(16) // salsa20_8
	  var x = new Int32Array(16) // salsa20_8
	  var _X = new Buffer(64) // blockmix_salsa8
	
	  // pseudo global
	  var B = pbkdf2Sync(key, salt, 1, p * 128 * r, 'sha256')
	
	  var tickCallback
	  if (progressCallback) {
	    var totalOps = p * N * 2
	    var currentOp = 0
	
	    tickCallback = function () {
	      ++currentOp
	
	      // send progress notifications once every 1,000 ops
	      if (currentOp % 1000 === 0) {
	        progressCallback({
	          current: currentOp,
	          total: totalOps,
	          percent: (currentOp / totalOps) * 100.0
	        })
	      }
	    }
	  }
	
	  for (var i = 0; i < p; i++) {
	    smix(B, i * 128 * r, r, N, V, XY)
	  }
	
	  return pbkdf2Sync(key, B, 1, dkLen, 'sha256')
	
	  // all of these functions are actually moved to the top
	  // due to function hoisting
	
	  function smix (B, Bi, r, N, V, XY) {
	    var Xi = 0
	    var Yi = 128 * r
	    var i
	
	    B.copy(XY, Xi, Bi, Bi + Yi)
	
	    for (i = 0; i < N; i++) {
	      XY.copy(V, i * Yi, Xi, Xi + Yi)
	      blockmix_salsa8(XY, Xi, Yi, r)
	
	      if (tickCallback) tickCallback()
	    }
	
	    for (i = 0; i < N; i++) {
	      var offset = Xi + (2 * r - 1) * 64
	      var j = XY.readUInt32LE(offset) & (N - 1)
	      blockxor(V, j * Yi, XY, Xi, Yi)
	      blockmix_salsa8(XY, Xi, Yi, r)
	
	      if (tickCallback) tickCallback()
	    }
	
	    XY.copy(B, Bi, Xi, Xi + Yi)
	  }
	
	  function blockmix_salsa8 (BY, Bi, Yi, r) {
	    var i
	
	    arraycopy(BY, Bi + (2 * r - 1) * 64, _X, 0, 64)
	
	    for (i = 0; i < 2 * r; i++) {
	      blockxor(BY, i * 64, _X, 0, 64)
	      salsa20_8(_X)
	      arraycopy(_X, 0, BY, Yi + (i * 64), 64)
	    }
	
	    for (i = 0; i < r; i++) {
	      arraycopy(BY, Yi + (i * 2) * 64, BY, Bi + (i * 64), 64)
	    }
	
	    for (i = 0; i < r; i++) {
	      arraycopy(BY, Yi + (i * 2 + 1) * 64, BY, Bi + (i + r) * 64, 64)
	    }
	  }
	
	  function R (a, b) {
	    return (a << b) | (a >>> (32 - b))
	  }
	
	  function salsa20_8 (B) {
	    var i
	
	    for (i = 0; i < 16; i++) {
	      B32[i] = (B[i * 4 + 0] & 0xff) << 0
	      B32[i] |= (B[i * 4 + 1] & 0xff) << 8
	      B32[i] |= (B[i * 4 + 2] & 0xff) << 16
	      B32[i] |= (B[i * 4 + 3] & 0xff) << 24
	      // B32[i] = B.readUInt32LE(i*4)   <--- this is signficantly slower even in Node.js
	    }
	
	    arraycopy(B32, 0, x, 0, 16)
	
	    for (i = 8; i > 0; i -= 2) {
	      x[ 4] ^= R(x[ 0] + x[12], 7)
	      x[ 8] ^= R(x[ 4] + x[ 0], 9)
	      x[12] ^= R(x[ 8] + x[ 4], 13)
	      x[ 0] ^= R(x[12] + x[ 8], 18)
	      x[ 9] ^= R(x[ 5] + x[ 1], 7)
	      x[13] ^= R(x[ 9] + x[ 5], 9)
	      x[ 1] ^= R(x[13] + x[ 9], 13)
	      x[ 5] ^= R(x[ 1] + x[13], 18)
	      x[14] ^= R(x[10] + x[ 6], 7)
	      x[ 2] ^= R(x[14] + x[10], 9)
	      x[ 6] ^= R(x[ 2] + x[14], 13)
	      x[10] ^= R(x[ 6] + x[ 2], 18)
	      x[ 3] ^= R(x[15] + x[11], 7)
	      x[ 7] ^= R(x[ 3] + x[15], 9)
	      x[11] ^= R(x[ 7] + x[ 3], 13)
	      x[15] ^= R(x[11] + x[ 7], 18)
	      x[ 1] ^= R(x[ 0] + x[ 3], 7)
	      x[ 2] ^= R(x[ 1] + x[ 0], 9)
	      x[ 3] ^= R(x[ 2] + x[ 1], 13)
	      x[ 0] ^= R(x[ 3] + x[ 2], 18)
	      x[ 6] ^= R(x[ 5] + x[ 4], 7)
	      x[ 7] ^= R(x[ 6] + x[ 5], 9)
	      x[ 4] ^= R(x[ 7] + x[ 6], 13)
	      x[ 5] ^= R(x[ 4] + x[ 7], 18)
	      x[11] ^= R(x[10] + x[ 9], 7)
	      x[ 8] ^= R(x[11] + x[10], 9)
	      x[ 9] ^= R(x[ 8] + x[11], 13)
	      x[10] ^= R(x[ 9] + x[ 8], 18)
	      x[12] ^= R(x[15] + x[14], 7)
	      x[13] ^= R(x[12] + x[15], 9)
	      x[14] ^= R(x[13] + x[12], 13)
	      x[15] ^= R(x[14] + x[13], 18)
	    }
	
	    for (i = 0; i < 16; ++i) B32[i] = x[i] + B32[i]
	
	    for (i = 0; i < 16; i++) {
	      var bi = i * 4
	      B[bi + 0] = (B32[i] >> 0 & 0xff)
	      B[bi + 1] = (B32[i] >> 8 & 0xff)
	      B[bi + 2] = (B32[i] >> 16 & 0xff)
	      B[bi + 3] = (B32[i] >> 24 & 0xff)
	      // B.writeInt32LE(B32[i], i*4)  //<--- this is signficantly slower even in Node.js
	    }
	  }
	
	  // naive approach... going back to loop unrolling may yield additional performance
	  function blockxor (S, Si, D, Di, len) {
	    for (var i = 0; i < len; i++) {
	      D[Di + i] ^= S[Si + i]
	    }
	  }
	}
	
	function arraycopy (src, srcPos, dest, destPos, length) {
	  if (Buffer.isBuffer(src) && Buffer.isBuffer(dest)) {
	    src.copy(dest, destPos, srcPos, srcPos + length)
	  } else {
	    while (length--) {
	      dest[destPos++] = src[srcPos++]
	    }
	  }
	}
	
	module.exports = scrypt
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(22)))

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
	 * in FIPS PUB 180-1
	 * This source code is derived from sha1.js of the same repository.
	 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
	 * operation was added.
	 */
	
	var inherits = __webpack_require__(2)
	var Hash = __webpack_require__(64)
	var Buffer = __webpack_require__(4).Buffer
	
	var K = [
	  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
	]
	
	var W = new Array(80)
	
	function Sha () {
	  this.init()
	  this._w = W
	
	  Hash.call(this, 64, 56)
	}
	
	inherits(Sha, Hash)
	
	Sha.prototype.init = function () {
	  this._a = 0x67452301
	  this._b = 0xefcdab89
	  this._c = 0x98badcfe
	  this._d = 0x10325476
	  this._e = 0xc3d2e1f0
	
	  return this
	}
	
	function rotl5 (num) {
	  return (num << 5) | (num >>> 27)
	}
	
	function rotl30 (num) {
	  return (num << 30) | (num >>> 2)
	}
	
	function ft (s, b, c, d) {
	  if (s === 0) return (b & c) | ((~b) & d)
	  if (s === 2) return (b & c) | (b & d) | (c & d)
	  return b ^ c ^ d
	}
	
	Sha.prototype._update = function (M) {
	  var W = this._w
	
	  var a = this._a | 0
	  var b = this._b | 0
	  var c = this._c | 0
	  var d = this._d | 0
	  var e = this._e | 0
	
	  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
	  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]
	
	  for (var j = 0; j < 80; ++j) {
	    var s = ~~(j / 20)
	    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0
	
	    e = d
	    d = c
	    c = rotl30(b)
	    b = a
	    a = t
	  }
	
	  this._a = (a + this._a) | 0
	  this._b = (b + this._b) | 0
	  this._c = (c + this._c) | 0
	  this._d = (d + this._d) | 0
	  this._e = (e + this._e) | 0
	}
	
	Sha.prototype._hash = function () {
	  var H = Buffer.allocUnsafe(20)
	
	  H.writeInt32BE(this._a | 0, 0)
	  H.writeInt32BE(this._b | 0, 4)
	  H.writeInt32BE(this._c | 0, 8)
	  H.writeInt32BE(this._d | 0, 12)
	  H.writeInt32BE(this._e | 0, 16)
	
	  return H
	}
	
	module.exports = Sha


/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */
	
	var inherits = __webpack_require__(2)
	var Hash = __webpack_require__(64)
	var Buffer = __webpack_require__(4).Buffer
	
	var K = [
	  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
	]
	
	var W = new Array(80)
	
	function Sha1 () {
	  this.init()
	  this._w = W
	
	  Hash.call(this, 64, 56)
	}
	
	inherits(Sha1, Hash)
	
	Sha1.prototype.init = function () {
	  this._a = 0x67452301
	  this._b = 0xefcdab89
	  this._c = 0x98badcfe
	  this._d = 0x10325476
	  this._e = 0xc3d2e1f0
	
	  return this
	}
	
	function rotl1 (num) {
	  return (num << 1) | (num >>> 31)
	}
	
	function rotl5 (num) {
	  return (num << 5) | (num >>> 27)
	}
	
	function rotl30 (num) {
	  return (num << 30) | (num >>> 2)
	}
	
	function ft (s, b, c, d) {
	  if (s === 0) return (b & c) | ((~b) & d)
	  if (s === 2) return (b & c) | (b & d) | (c & d)
	  return b ^ c ^ d
	}
	
	Sha1.prototype._update = function (M) {
	  var W = this._w
	
	  var a = this._a | 0
	  var b = this._b | 0
	  var c = this._c | 0
	  var d = this._d | 0
	  var e = this._e | 0
	
	  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
	  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])
	
	  for (var j = 0; j < 80; ++j) {
	    var s = ~~(j / 20)
	    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0
	
	    e = d
	    d = c
	    c = rotl30(b)
	    b = a
	    a = t
	  }
	
	  this._a = (a + this._a) | 0
	  this._b = (b + this._b) | 0
	  this._c = (c + this._c) | 0
	  this._d = (d + this._d) | 0
	  this._e = (e + this._e) | 0
	}
	
	Sha1.prototype._hash = function () {
	  var H = Buffer.allocUnsafe(20)
	
	  H.writeInt32BE(this._a | 0, 0)
	  H.writeInt32BE(this._b | 0, 4)
	  H.writeInt32BE(this._c | 0, 8)
	  H.writeInt32BE(this._d | 0, 12)
	  H.writeInt32BE(this._e | 0, 16)
	
	  return H
	}
	
	module.exports = Sha1


/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(2)
	var Sha256 = __webpack_require__(308)
	var Hash = __webpack_require__(64)
	var Buffer = __webpack_require__(4).Buffer
	
	var W = new Array(64)
	
	function Sha224 () {
	  this.init()
	
	  this._w = W // new Array(64)
	
	  Hash.call(this, 64, 56)
	}
	
	inherits(Sha224, Sha256)
	
	Sha224.prototype.init = function () {
	  this._a = 0xc1059ed8
	  this._b = 0x367cd507
	  this._c = 0x3070dd17
	  this._d = 0xf70e5939
	  this._e = 0xffc00b31
	  this._f = 0x68581511
	  this._g = 0x64f98fa7
	  this._h = 0xbefa4fa4
	
	  return this
	}
	
	Sha224.prototype._hash = function () {
	  var H = Buffer.allocUnsafe(28)
	
	  H.writeInt32BE(this._a, 0)
	  H.writeInt32BE(this._b, 4)
	  H.writeInt32BE(this._c, 8)
	  H.writeInt32BE(this._d, 12)
	  H.writeInt32BE(this._e, 16)
	  H.writeInt32BE(this._f, 20)
	  H.writeInt32BE(this._g, 24)
	
	  return H
	}
	
	module.exports = Sha224


/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(2)
	var SHA512 = __webpack_require__(309)
	var Hash = __webpack_require__(64)
	var Buffer = __webpack_require__(4).Buffer
	
	var W = new Array(160)
	
	function Sha384 () {
	  this.init()
	  this._w = W
	
	  Hash.call(this, 128, 112)
	}
	
	inherits(Sha384, SHA512)
	
	Sha384.prototype.init = function () {
	  this._ah = 0xcbbb9d5d
	  this._bh = 0x629a292a
	  this._ch = 0x9159015a
	  this._dh = 0x152fecd8
	  this._eh = 0x67332667
	  this._fh = 0x8eb44a87
	  this._gh = 0xdb0c2e0d
	  this._hh = 0x47b5481d
	
	  this._al = 0xc1059ed8
	  this._bl = 0x367cd507
	  this._cl = 0x3070dd17
	  this._dl = 0xf70e5939
	  this._el = 0xffc00b31
	  this._fl = 0x68581511
	  this._gl = 0x64f98fa7
	  this._hl = 0xbefa4fa4
	
	  return this
	}
	
	Sha384.prototype._hash = function () {
	  var H = Buffer.allocUnsafe(48)
	
	  function writeInt64BE (h, l, offset) {
	    H.writeInt32BE(h, offset)
	    H.writeInt32BE(l, offset + 4)
	  }
	
	  writeInt64BE(this._ah, this._al, 0)
	  writeInt64BE(this._bh, this._bl, 8)
	  writeInt64BE(this._ch, this._cl, 16)
	  writeInt64BE(this._dh, this._dl, 24)
	  writeInt64BE(this._eh, this._el, 32)
	  writeInt64BE(this._fh, this._fl, 40)
	
	  return H
	}
	
	module.exports = Sha384


/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	var unavailable = function unavailable() {
	  throw "This swarm.js function isn't available on the browser.";
	};
	
	var fsp = { readFile: unavailable };
	var files = { download: unavailable, safeDownloadArchived: unavailable, directoryTree: unavailable };
	var os = { platform: unavailable, arch: unavailable };
	var path = { join: unavailable, slice: unavailable };
	var child_process = { spawn: unavailable };
	var mimetype = { lookup: unavailable };
	var defaultArchives = {};
	var downloadUrl = null;
	var request = __webpack_require__(779);
	var bytes = __webpack_require__(222);
	var hash = __webpack_require__(731);
	var pick = __webpack_require__(730);
	var swarm = __webpack_require__(732);
	
	module.exports = swarm({
	  fsp: fsp,
	  files: files,
	  os: os,
	  path: path,
	  child_process: child_process,
	  defaultArchives: defaultArchives,
	  mimetype: mimetype,
	  request: request,
	  downloadUrl: downloadUrl,
	  bytes: bytes,
	  hash: hash,
	  pick: pick
	});

/***/ },
/* 730 */
/***/ function(module, exports) {

	var picker = function picker(type) {
	  return function () {
	    return new Promise(function (resolve, reject) {
	      var fileLoader = function fileLoader(e) {
	        var directory = {};
	        var totalFiles = e.target.files.length;
	        var loadedFiles = 0;
	        [].map.call(e.target.files, function (file) {
	          var reader = new FileReader();
	          reader.onload = function (e) {
	            var data = new Uint8Array(e.target.result);
	            if (type === "directory") {
	              var path = file.webkitRelativePath;
	              directory[path.slice(path.indexOf("/") + 1)] = {
	                type: "text/plain",
	                data: data
	              };
	              if (++loadedFiles === totalFiles) resolve(directory);
	            } else if (type === "file") {
	              var _path = file.webkitRelativePath;
	              resolve({ "type": mimetype.lookup(_path), "data": data });
	            } else {
	              resolve(data);
	            }
	          };
	          reader.readAsArrayBuffer(file);
	        });
	      };
	
	      var fileInput = void 0;
	      if (type === "directory") {
	        fileInput = document.createElement("input");
	        fileInput.addEventListener("change", fileLoader);
	        fileInput.type = "file";
	        fileInput.webkitdirectory = true;
	        fileInput.mozdirectory = true;
	        fileInput.msdirectory = true;
	        fileInput.odirectory = true;
	        fileInput.directory = true;
	      } else {
	        fileInput = document.createElement("input");
	        fileInput.addEventListener("change", fileLoader);
	        fileInput.type = "file";
	      };
	
	      var mouseEvent = document.createEvent("MouseEvents");
	      mouseEvent.initEvent("click", true, false);
	      fileInput.dispatchEvent(mouseEvent);
	    });
	  };
	};
	
	module.exports = {
	  data: picker("data"),
	  file: picker("file"),
	  directory: picker("directory")
	};

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	// Thanks https://github.com/axic/swarmhash
	
	var keccak = __webpack_require__(223).keccak256;
	var Bytes = __webpack_require__(222);
	
	var swarmHashBlock = function swarmHashBlock(length, data) {
	  var lengthEncoded = Bytes.reverse(Bytes.pad(6, Bytes.fromNumber(length)));
	  var bytes = Bytes.flatten([lengthEncoded, "0x0000", data]);
	  return keccak(bytes).slice(2);
	};
	
	// (Bytes | Uint8Array | String) -> String
	var swarmHash = function swarmHash(data) {
	  if (typeof data === "string" && data.slice(0, 2) !== "0x") {
	    data = Bytes.fromString(data);
	  } else if (typeof data !== "string" && data.length !== undefined) {
	    data = Bytes.fromUint8Array(data);
	  }
	
	  var length = Bytes.length(data);
	
	  if (length <= 4096) {
	    return swarmHashBlock(length, data);
	  }
	
	  var maxSize = 4096;
	  while (maxSize * (4096 / 32) < length) {
	    maxSize *= 4096 / 32;
	  }
	
	  var innerNodes = [];
	  for (var i = 0; i < length; i += maxSize) {
	    var size = maxSize < length - i ? maxSize : length - i;
	    innerNodes.push(swarmHash(Bytes.slice(data, i, i + size)));
	  }
	
	  return swarmHashBlock(length, Bytes.flatten(innerNodes));
	};
	
	module.exports = swarmHash;

/***/ },
/* 732 */
/***/ function(module, exports) {

	// TODO: this is a temporary fix to hide those libraries from the browser. A
	// slightly better long-term solution would be to split this file into two,
	// separating the functions that are used on Node.js from the functions that
	// are used only on the browser.
	module.exports = function (_ref) {
	  var fsp = _ref.fsp,
	      files = _ref.files,
	      os = _ref.os,
	      path = _ref.path,
	      child_process = _ref.child_process,
	      mimetype = _ref.mimetype,
	      defaultArchives = _ref.defaultArchives,
	      request = _ref.request,
	      downloadUrl = _ref.downloadUrl,
	      bytes = _ref.bytes,
	      hash = _ref.hash,
	      pick = _ref.pick;
	
	
	  // ∀ a . String -> JSON -> Map String a -o Map String a
	  //   Inserts a key/val pair in an object impurely.
	  var impureInsert = function impureInsert(key) {
	    return function (val) {
	      return function (map) {
	        return map[key] = val, map;
	      };
	    };
	  };
	
	  // String -> JSON -> Map String JSON
	  //   Merges an array of keys and an array of vals into an object.
	  var toMap = function toMap(keys) {
	    return function (vals) {
	      var map = {};
	      for (var i = 0, l = keys.length; i < l; ++i) {
	        map[keys[i]] = vals[i];
	      }return map;
	    };
	  };
	
	  // ∀ a . Map String a -> Map String a -> Map String a
	  //   Merges two maps into one.
	  var merge = function merge(a) {
	    return function (b) {
	      var map = {};
	      for (var key in a) {
	        map[key] = a[key];
	      }for (var _key in b) {
	        map[_key] = b[_key];
	      }return map;
	    };
	  };
	
	  // ∀ a . [a] -> [a] -> Bool
	  var equals = function equals(a) {
	    return function (b) {
	      if (a.length !== b.length) {
	        return false;
	      } else {
	        for (var i = 0, l = a.length; i < a; ++i) {
	          if (a[i] !== b[i]) return false;
	        }
	      }
	      return true;
	    };
	  };
	
	  // String -> String -> String
	  var rawUrl = function rawUrl(swarmUrl) {
	    return function (hash) {
	      return swarmUrl + "/bzzr:/" + hash;
	    };
	  };
	
	  // String -> String -> Promise Uint8Array
	  //   Gets the raw contents of a Swarm hash address.
	  var downloadData = function downloadData(swarmUrl) {
	    return function (hash) {
	      return request(rawUrl(swarmUrl)(hash), { responseType: "arraybuffer" }).then(function (arrayBuffer) {
	        var uint8Array = new Uint8Array(arrayBuffer);
	        var error404 = [52, 48, 52, 32, 112, 97, 103, 101, 32, 110, 111, 116, 32, 102, 111, 117, 110, 100, 10];
	        if (equals(uint8Array)(error404)) throw "Error 404.";
	        return uint8Array;
	      });
	    };
	  };
	
	  // type Entry = {"type": String, "hash": String}
	  // type File = {"type": String, "data": Uint8Array}
	
	  // String -> String -> Promise (Map String Entry)
	  //   Solves the manifest of a Swarm address recursively.
	  //   Returns a map from full paths to entries.
	  var downloadEntries = function downloadEntries(swarmUrl) {
	    return function (hash) {
	      var search = function search(hash) {
	        return function (path) {
	          return function (routes) {
	            // Formats an entry to the Swarm.js type.
	            var format = function format(entry) {
	              return {
	                type: entry.contentType,
	                hash: entry.hash };
	            };
	
	            // To download a single entry:
	            //   if type is bzz-manifest, go deeper
	            //   if not, add it to the routing table
	            var downloadEntry = function downloadEntry(entry) {
	              if (entry.path === undefined) {
	                return Promise.resolve();
	              } else {
	                return entry.contentType === "application/bzz-manifest+json" ? search(entry.hash)(path + entry.path)(routes) : Promise.resolve(impureInsert(path + entry.path)(format(entry))(routes));
	              }
	            };
	
	            // Downloads the initial manifest and then each entry.
	            return downloadData(swarmUrl)(hash).then(function (text) {
	              return JSON.parse(toString(text)).entries;
	            }).then(function (entries) {
	              return Promise.all(entries.map(downloadEntry));
	            }).then(function () {
	              return routes;
	            });
	          };
	        };
	      };
	
	      return search(hash)("")({});
	    };
	  };
	
	  // String -> String -> Promise (Map String String)
	  //   Same as `downloadEntries`, but returns only hashes (no types).
	  var downloadRoutes = function downloadRoutes(swarmUrl) {
	    return function (hash) {
	      return downloadEntries(swarmUrl)(hash).then(function (entries) {
	        return toMap(Object.keys(entries))(Object.keys(entries).map(function (route) {
	          return entries[route].hash;
	        }));
	      });
	    };
	  };
	
	  // String -> String -> Promise (Map String File)
	  //   Gets the entire directory tree in a Swarm address.
	  //   Returns a promise mapping paths to file contents.
	  var downloadDirectory = function downloadDirectory(swarmUrl) {
	    return function (hash) {
	      return downloadEntries(swarmUrl)(hash).then(function (entries) {
	        var paths = Object.keys(entries);
	        var hashs = paths.map(function (path) {
	          return entries[path].hash;
	        });
	        var types = paths.map(function (path) {
	          return entries[path].type;
	        });
	        var datas = hashs.map(downloadData(swarmUrl));
	        var files = function files(datas) {
	          return datas.map(function (data, i) {
	            return { type: types[i], data: data };
	          });
	        };
	        return Promise.all(datas).then(function (datas) {
	          return toMap(paths)(files(datas));
	        });
	      });
	    };
	  };
	
	  // String -> String -> String -> Promise String
	  //   Gets the raw contents of a Swarm hash address.
	  //   Returns a promise with the downloaded file path.
	  var downloadDataToDisk = function downloadDataToDisk(swarmUrl) {
	    return function (hash) {
	      return function (filePath) {
	        return files.download(rawUrl(swarmUrl)(hash))(filePath);
	      };
	    };
	  };
	
	  // String -> String -> String -> Promise (Map String String)
	  //   Gets the entire directory tree in a Swarm address.
	  //   Returns a promise mapping paths to file contents.
	  var downloadDirectoryToDisk = function downloadDirectoryToDisk(swarmUrl) {
	    return function (hash) {
	      return function (dirPath) {
	        return downloadRoutes(swarmUrl)(hash).then(function (routingTable) {
	          var downloads = [];
	          for (var route in routingTable) {
	            if (route.length > 0) {
	              var filePath = path.join(dirPath, route);
	              downloads.push(downloadDataToDisk(swarmUrl)(routingTable[route])(filePath));
	            };
	          };
	          return Promise.all(downloads).then(function () {
	            return dirPath;
	          });
	        });
	      };
	    };
	  };
	
	  // String -> Uint8Array -> Promise String
	  //   Uploads raw data to Swarm.
	  //   Returns a promise with the uploaded hash.
	  var uploadData = function uploadData(swarmUrl) {
	    return function (data) {
	      return request(swarmUrl + "/bzzr:/", {
	        body: typeof data === "string" ? fromString(data) : data,
	        method: "POST" });
	    };
	  };
	
	  // String -> String -> String -> File -> Promise String
	  //   Uploads a file to the Swarm manifest at a given hash, under a specific
	  //   route. Returns a promise containing the uploaded hash.
	  //   FIXME: for some reasons Swarm-Gateways is sometimes returning
	  //   error 404 (bad request), so we retry up to 3 times. Why?
	  var uploadToManifest = function uploadToManifest(swarmUrl) {
	    return function (hash) {
	      return function (route) {
	        return function (file) {
	          var attempt = function attempt(n) {
	            var slashRoute = route[0] === "/" ? route : "/" + route;
	            var url = swarmUrl + "/bzz:/" + hash + slashRoute;
	            var opt = {
	              method: "PUT",
	              headers: { "Content-Type": file.type },
	              body: file.data };
	            return request(url, opt).then(function (response) {
	              if (response.indexOf("error") !== -1) {
	                throw response;
	              }
	              return response;
	            }).catch(function (e) {
	              return n > 0 && attempt(n - 1);
	            });
	          };
	          return attempt(3);
	        };
	      };
	    };
	  };
	
	  // String -> {type: String, data: Uint8Array} -> Promise String
	  var uploadFile = function uploadFile(swarmUrl) {
	    return function (file) {
	      return uploadDirectory(swarmUrl)({ "": file });
	    };
	  };
	
	  // String -> String -> Promise String
	  var uploadFileFromDisk = function uploadFileFromDisk(swarmUrl) {
	    return function (filePath) {
	      return fsp.readFile(filePath).then(function (data) {
	        return uploadFile(swarmUrl)({ type: mimetype.lookup(filePath), data: data });
	      });
	    };
	  };
	
	  // String -> Map String File -> Promise String
	  //   Uploads a directory to Swarm. The directory is
	  //   represented as a map of routes and files.
	  //   A default path is encoded by having a "" route.
	  var uploadDirectory = function uploadDirectory(swarmUrl) {
	    return function (directory) {
	      return uploadData(swarmUrl)("{}").then(function (hash) {
	        var uploadRoute = function uploadRoute(route) {
	          return function (hash) {
	            return uploadToManifest(swarmUrl)(hash)(route)(directory[route]);
	          };
	        };
	        var uploadToHash = function uploadToHash(hash, route) {
	          return hash.then(uploadRoute(route));
	        };
	        return Object.keys(directory).reduce(uploadToHash, Promise.resolve(hash));
	      });
	    };
	  };
	
	  // String -> Promise String
	  var uploadDataFromDisk = function uploadDataFromDisk(swarmUrl) {
	    return function (filePath) {
	      return fsp.readFile(filePath).then(uploadData(swarmUrl));
	    };
	  };
	
	  // String -> Nullable String -> String -> Promise String
	  var uploadDirectoryFromDisk = function uploadDirectoryFromDisk(swarmUrl) {
	    return function (defaultPath) {
	      return function (dirPath) {
	        return files.directoryTree(dirPath).then(function (fullPaths) {
	          return Promise.all(fullPaths.map(function (path) {
	            return fsp.readFile(path);
	          })).then(function (datas) {
	            var paths = fullPaths.map(function (path) {
	              return path.slice(dirPath.length);
	            });
	            var types = fullPaths.map(function (path) {
	              return mimetype.lookup(path) || "text/plain";
	            });
	            return toMap(paths)(datas.map(function (data, i) {
	              return { type: types[i], data: data };
	            }));
	          });
	        }).then(function (directory) {
	          return merge(defaultPath ? { "": directory[defaultPath] } : {})(directory);
	        }).then(uploadDirectory(swarmUrl));
	      };
	    };
	  };
	
	  // String -> UploadInfo -> Promise String
	  //   Simplified multi-type upload which calls the correct
	  //   one based on the type of the argument given.
	  var _upload = function _upload(swarmUrl) {
	    return function (arg) {
	      // Upload raw data from browser
	      if (arg.pick === "data") {
	        return pick.data().then(uploadData(swarmUrl));
	
	        // Upload a file from browser
	      } else if (arg.pick === "file") {
	        return pick.file().then(uploadFile(swarmUrl));
	
	        // Upload a directory from browser
	      } else if (arg.pick === "directory") {
	        return pick.directory().then(uploadDirectory(swarmUrl));
	
	        // Upload directory/file from disk
	      } else if (arg.path) {
	        switch (arg.kind) {
	          case "data":
	            return uploadDataFromDisk(swarmUrl)(arg.path);
	          case "file":
	            return uploadFileFromDisk(swarmUrl)(arg.path);
	          case "directory":
	            return uploadDirectoryFromDisk(swarmUrl)(arg.defaultFile)(arg.path);
	        };
	
	        // Upload UTF-8 string or raw data (buffer)
	      } else if (arg.length || typeof arg === "string") {
	        return uploadData(swarmUrl)(arg);
	
	        // Upload directory with JSON
	      } else if (arg instanceof Object) {
	        return uploadDirectory(swarmUrl)(arg);
	      }
	
	      return Promise.reject(new Error("Bad arguments"));
	    };
	  };
	
	  // String -> String -> Nullable String -> Promise (String | Uint8Array | Map String Uint8Array)
	  //   Simplified multi-type download which calls the correct function based on
	  //   the type of the argument given, and on whether the Swwarm address has a
	  //   directory or a file.
	  var _download = function _download(swarmUrl) {
	    return function (hash) {
	      return function (path) {
	        return isDirectory(swarmUrl)(hash).then(function (isDir) {
	          if (isDir) {
	            return path ? downloadDirectoryToDisk(swarmUrl)(hash)(path) : downloadDirectory(swarmUrl)(hash);
	          } else {
	            return path ? downloadDataToDisk(swarmUrl)(hash)(path) : downloadData(swarmUrl)(hash);
	          }
	        });
	      };
	    };
	  };
	
	  // String -> Promise String
	  //   Downloads the Swarm binaries into a path. Returns a promise that only
	  //   resolves when the exact Swarm file is there, and verified to be correct.
	  //   If it was already there to begin with, skips the download.
	  var downloadBinary = function downloadBinary(path, archives) {
	    var system = os.platform().replace("win32", "windows") + "-" + (os.arch() === "x64" ? "amd64" : "386");
	    var archive = (archives || defaultArchives)[system];
	    var archiveUrl = downloadUrl + archive.archive + ".tar.gz";
	    var archiveMD5 = archive.archiveMD5;
	    var binaryMD5 = archive.binaryMD5;
	    return files.safeDownloadArchived(archiveUrl)(archiveMD5)(binaryMD5)(path);
	  };
	
	  // type SwarmSetup = {
	  //   account : String,
	  //   password : String,
	  //   dataDir : String,
	  //   binPath : String,
	  //   ensApi : String,
	  //   onDownloadProgress : Number ~> (),
	  //   archives : [{
	  //     archive: String,
	  //     binaryMD5: String,
	  //     archiveMD5: String
	  //   }]
	  // }
	
	  // SwarmSetup ~> Promise Process
	  //   Starts the Swarm process.
	  var startProcess = function startProcess(swarmSetup) {
	    return new Promise(function (resolve, reject) {
	      var spawn = child_process.spawn;
	
	
	      var hasString = function hasString(str) {
	        return function (buffer) {
	          return ('' + buffer).indexOf(str) !== -1;
	        };
	      };
	      var account = swarmSetup.account,
	          password = swarmSetup.password,
	          dataDir = swarmSetup.dataDir,
	          ensApi = swarmSetup.ensApi,
	          privateKey = swarmSetup.privateKey;
	
	
	      var STARTUP_TIMEOUT_SECS = 3;
	      var WAITING_PASSWORD = 0;
	      var STARTING = 1;
	      var LISTENING = 2;
	      var PASSWORD_PROMPT_HOOK = "Passphrase";
	      var LISTENING_HOOK = "Swarm http proxy started";
	
	      var state = WAITING_PASSWORD;
	
	      var swarmProcess = spawn(swarmSetup.binPath, ['--bzzaccount', account || privateKey, '--datadir', dataDir, '--ens-api', ensApi]);
	
	      var handleProcessOutput = function handleProcessOutput(data) {
	        if (state === WAITING_PASSWORD && hasString(PASSWORD_PROMPT_HOOK)(data)) {
	          setTimeout(function () {
	            state = STARTING;
	            swarmProcess.stdin.write(password + '\n');
	          }, 500);
	        } else if (hasString(LISTENING_HOOK)(data)) {
	          state = LISTENING;
	          clearTimeout(timeout);
	          resolve(swarmProcess);
	        }
	      };
	
	      swarmProcess.stdout.on('data', handleProcessOutput);
	      swarmProcess.stderr.on('data', handleProcessOutput);
	      //swarmProcess.on('close', () => setTimeout(restart, 2000));
	
	      var restart = function restart() {
	        return startProcess(swarmSetup).then(resolve).catch(reject);
	      };
	      var error = function error() {
	        return reject(new Error("Couldn't start swarm process."));
	      };
	      var timeout = setTimeout(error, 20000);
	    });
	  };
	
	  // Process ~> Promise ()
	  //   Stops the Swarm process.
	  var stopProcess = function stopProcess(process) {
	    return new Promise(function (resolve, reject) {
	      process.stderr.removeAllListeners('data');
	      process.stdout.removeAllListeners('data');
	      process.stdin.removeAllListeners('error');
	      process.removeAllListeners('error');
	      process.removeAllListeners('exit');
	      process.kill('SIGINT');
	
	      var killTimeout = setTimeout(function () {
	        return process.kill('SIGKILL');
	      }, 8000);
	
	      process.once('close', function () {
	        clearTimeout(killTimeout);
	        resolve();
	      });
	    });
	  };
	
	  // SwarmSetup -> (SwarmAPI -> Promise ()) -> Promise ()
	  //   Receives a Swarm configuration object and a callback function. It then
	  //   checks if a local Swarm node is running. If no local Swarm is found, it
	  //   downloads the Swarm binaries to the dataDir (if not there), checksums,
	  //   starts the Swarm process and calls the callback function with an API
	  //   object using the local node. That callback must return a promise which
	  //   will resolve when it is done using the API, so that this function can
	  //   close the Swarm process properly. Returns a promise that resolves when the
	  //   user is done with the API and the Swarm process is closed.
	  //   TODO: check if Swarm process is already running (improve `isAvailable`)
	  var local = function local(swarmSetup) {
	    return function (useAPI) {
	      return _isAvailable("http://localhost:8500").then(function (isAvailable) {
	        return isAvailable ? useAPI(at("http://localhost:8500")).then(function () {}) : downloadBinary(swarmSetup.binPath, swarmSetup.archives).onData(function (data) {
	          return (swarmSetup.onProgress || function () {})(data.length);
	        }).then(function () {
	          return startProcess(swarmSetup);
	        }).then(function (process) {
	          return useAPI(at("http://localhost:8500")).then(function () {
	            return process;
	          });
	        }).then(stopProcess);
	      });
	    };
	  };
	
	  // String ~> Promise Bool
	  //   Returns true if Swarm is available on `url`.
	  //   Perfoms a test upload to determine that.
	  //   TODO: improve this?
	  var _isAvailable = function _isAvailable(swarmUrl) {
	    var testFile = "test";
	    var testHash = "c9a99c7d326dcc6316f32fe2625b311f6dc49a175e6877681ded93137d3569e7";
	    return uploadData(swarmUrl)(testFile).then(function (hash) {
	      return hash === testHash;
	    }).catch(function () {
	      return false;
	    });
	  };
	
	  // String -> String ~> Promise Bool
	  //   Returns a Promise which is true if that Swarm address is a directory.
	  //   Determines that by checking that it (i) is a JSON, (ii) has a .entries.
	  //   TODO: improve this?
	  var isDirectory = function isDirectory(swarmUrl) {
	    return function (hash) {
	      return downloadData(swarmUrl)(hash).then(function (data) {
	        try {
	          return !!JSON.parse(toString(data)).entries;
	        } catch (e) {
	          return false;
	        }
	      });
	    };
	  };
	
	  // Uncurries a function; used to allow the f(x,y,z) style on exports.
	  var uncurry = function uncurry(f) {
	    return function (a, b, c, d, e) {
	      var p;
	      // Hardcoded because efficiency (`arguments` is very slow).
	      if (typeof a !== "undefined") p = f(a);
	      if (typeof b !== "undefined") p = f(b);
	      if (typeof c !== "undefined") p = f(c);
	      if (typeof d !== "undefined") p = f(d);
	      if (typeof e !== "undefined") p = f(e);
	      return p;
	    };
	  };
	
	  // () -> Promise Bool
	  //   Not sure how to mock Swarm to test it properly. Ideas?
	  var test = function test() {
	    return Promise.resolve(true);
	  };
	
	  // Uint8Array -> String
	  var toString = function toString(uint8Array) {
	    return bytes.toString(bytes.fromUint8Array(uint8Array));
	  };
	
	  // String -> Uint8Array
	  var fromString = function fromString(string) {
	    return bytes.toUint8Array(bytes.fromString(string));
	  };
	
	  // String -> SwarmAPI
	  //   Fixes the `swarmUrl`, returning an API where you don't have to pass it.
	  var at = function at(swarmUrl) {
	    return {
	      download: function download(hash, path) {
	        return _download(swarmUrl)(hash)(path);
	      },
	      downloadData: uncurry(downloadData(swarmUrl)),
	      downloadDataToDisk: uncurry(downloadDataToDisk(swarmUrl)),
	      downloadDirectory: uncurry(downloadDirectory(swarmUrl)),
	      downloadDirectoryToDisk: uncurry(downloadDirectoryToDisk(swarmUrl)),
	      downloadEntries: uncurry(downloadEntries(swarmUrl)),
	      downloadRoutes: uncurry(downloadRoutes(swarmUrl)),
	      isAvailable: function isAvailable() {
	        return _isAvailable(swarmUrl);
	      },
	      upload: function upload(arg) {
	        return _upload(swarmUrl)(arg);
	      },
	      uploadData: uncurry(uploadData(swarmUrl)),
	      uploadFile: uncurry(uploadFile(swarmUrl)),
	      uploadFileFromDisk: uncurry(uploadFile(swarmUrl)),
	      uploadDataFromDisk: uncurry(uploadDataFromDisk(swarmUrl)),
	      uploadDirectory: uncurry(uploadDirectory(swarmUrl)),
	      uploadDirectoryFromDisk: uncurry(uploadDirectoryFromDisk(swarmUrl)),
	      uploadToManifest: uncurry(uploadToManifest(swarmUrl)),
	      pick: pick,
	      hash: hash,
	      fromString: fromString,
	      toString: toString
	    };
	  };
	
	  return {
	    at: at,
	    local: local,
	    download: _download,
	    downloadBinary: downloadBinary,
	    downloadData: downloadData,
	    downloadDataToDisk: downloadDataToDisk,
	    downloadDirectory: downloadDirectory,
	    downloadDirectoryToDisk: downloadDirectoryToDisk,
	    downloadEntries: downloadEntries,
	    downloadRoutes: downloadRoutes,
	    isAvailable: _isAvailable,
	    startProcess: startProcess,
	    stopProcess: stopProcess,
	    upload: _upload,
	    uploadData: uploadData,
	    uploadDataFromDisk: uploadDataFromDisk,
	    uploadFile: uploadFile,
	    uploadFileFromDisk: uploadFileFromDisk,
	    uploadDirectory: uploadDirectory,
	    uploadDirectoryFromDisk: uploadDirectoryFromDisk,
	    uploadToManifest: uploadToManifest,
	    pick: pick,
	    hash: hash,
	    fromString: fromString,
	    toString: toString
	  };
	};


/***/ },
/* 733 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 734 */
/***/ function(module, exports) {

	
	exports = module.exports = trim;
	
	function trim(str){
	  return str.replace(/^\s*|\s*$/g, '');
	}
	
	exports.left = function(str){
	  return str.replace(/^\s*/, '');
	};
	
	exports.right = function(str){
	  return str.replace(/\s*$/, '');
	};


/***/ },
/* 735 */
/***/ function(module, exports) {

	module.exports = urlSetQuery
	function urlSetQuery (url, query) {
	  if (query) {
	    // remove optional leading symbols
	    query = query.trim().replace(/^(\?|#|&)/, '')
	
	    // don't append empty query
	    query = query ? ('?' + query) : query
	
	    var parts = url.split(/[\?\#]/)
	    var start = parts[0]
	    if (query && /\:\/\/[^\/]*$/.test(start)) {
	      // e.g. http://foo.com -> http://foo.com/
	      start = start + '/'
	    }
	    var match = url.match(/(\#.*)$/)
	    url = start + query
	    if (match) { // add hash back in
	      url = url + match[0]
	    }
	  }
	  return url
	}


/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)(module), (function() { return this; }())))

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var punycode = __webpack_require__(736);
	var util = __webpack_require__(738);
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // Special case for a simple path URL
	    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(605);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && util.isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!util.isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  // Copy chrome, IE, opera backslash-handling behavior.
	  // Back slashes before the query string get converted to forward slashes
	  // See: https://code.google.com/p/chromium/issues/detail?id=25916
	  var queryIndex = url.indexOf('?'),
	      splitter =
	          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
	      uSplit = url.split(splitter),
	      slashRegex = /\\/g;
	  uSplit[0] = uSplit[0].replace(slashRegex, '/');
	  url = uSplit.join(splitter);
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  if (!slashesDenoteHost && url.split('#').length === 1) {
	    // Try fast path regexp
	    var simplePath = simplePathPattern.exec(rest);
	    if (simplePath) {
	      this.path = rest;
	      this.href = rest;
	      this.pathname = simplePath[1];
	      if (simplePath[2]) {
	        this.search = simplePath[2];
	        if (parseQueryString) {
	          this.query = querystring.parse(this.search.substr(1));
	        } else {
	          this.query = this.search.substr(1);
	        }
	      } else if (parseQueryString) {
	        this.search = '';
	        this.query = {};
	      }
	      return this;
	    }
	  }
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a punycoded representation of "domain".
	      // It only converts parts of the domain name that
	      // have non-ASCII characters, i.e. it doesn't matter if
	      // you call it with a domain that already is ASCII-only.
	      this.hostname = punycode.toASCII(this.hostname);
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      if (rest.indexOf(ae) === -1)
	        continue;
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (util.isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      util.isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (util.isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  var tkeys = Object.keys(this);
	  for (var tk = 0; tk < tkeys.length; tk++) {
	    var tkey = tkeys[tk];
	    result[tkey] = this[tkey];
	  }
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    var rkeys = Object.keys(relative);
	    for (var rk = 0; rk < rkeys.length; rk++) {
	      var rkey = rkeys[rk];
	      if (rkey !== 'protocol')
	        result[rkey] = relative[rkey];
	    }
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      var keys = Object.keys(relative);
	      for (var v = 0; v < keys.length; v++) {
	        var k = keys[v];
	        result[k] = relative[k];
	      }
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!util.isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especially happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host || srcPath.length > 1) &&
	      (last === '.' || last === '..') || last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last === '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especially happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};


/***/ },
/* 738 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  isString: function(arg) {
	    return typeof(arg) === 'string';
	  },
	  isObject: function(arg) {
	    return typeof(arg) === 'object' && arg !== null;
	  },
	  isNull: function(arg) {
	    return arg === null;
	  },
	  isNullOrUndefined: function(arg) {
	    return arg == null;
	  }
	};


/***/ },
/* 739 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 740 */
2,
/* 741 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	var indexOf = __webpack_require__(550);
	
	var Object_keys = function (obj) {
	    if (Object.keys) return Object.keys(obj)
	    else {
	        var res = [];
	        for (var key in obj) res.push(key)
	        return res;
	    }
	};
	
	var forEach = function (xs, fn) {
	    if (xs.forEach) return xs.forEach(fn)
	    else for (var i = 0; i < xs.length; i++) {
	        fn(xs[i], i, xs);
	    }
	};
	
	var defineProp = (function() {
	    try {
	        Object.defineProperty({}, '_', {});
	        return function(obj, name, value) {
	            Object.defineProperty(obj, name, {
	                writable: true,
	                enumerable: false,
	                configurable: true,
	                value: value
	            })
	        };
	    } catch(e) {
	        return function(obj, name, value) {
	            obj[name] = value;
	        };
	    }
	}());
	
	var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
	'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
	'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
	'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
	'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];
	
	function Context() {}
	Context.prototype = {};
	
	var Script = exports.Script = function NodeScript (code) {
	    if (!(this instanceof Script)) return new Script(code);
	    this.code = code;
	};
	
	Script.prototype.runInContext = function (context) {
	    if (!(context instanceof Context)) {
	        throw new TypeError("needs a 'context' argument.");
	    }
	    
	    var iframe = document.createElement('iframe');
	    if (!iframe.style) iframe.style = {};
	    iframe.style.display = 'none';
	    
	    document.body.appendChild(iframe);
	    
	    var win = iframe.contentWindow;
	    var wEval = win.eval, wExecScript = win.execScript;
	
	    if (!wEval && wExecScript) {
	        // win.eval() magically appears when this is called in IE:
	        wExecScript.call(win, 'null');
	        wEval = win.eval;
	    }
	    
	    forEach(Object_keys(context), function (key) {
	        win[key] = context[key];
	    });
	    forEach(globals, function (key) {
	        if (context[key]) {
	            win[key] = context[key];
	        }
	    });
	    
	    var winKeys = Object_keys(win);
	
	    var res = wEval.call(win, this.code);
	    
	    forEach(Object_keys(win), function (key) {
	        // Avoid copying circular objects like `top` and `window` by only
	        // updating existing context properties or new properties in the `win`
	        // that was only introduced after the eval.
	        if (key in context || indexOf(winKeys, key) === -1) {
	            context[key] = win[key];
	        }
	    });
	
	    forEach(globals, function (key) {
	        if (!(key in context)) {
	            defineProp(context, key, win[key]);
	        }
	    });
	    
	    document.body.removeChild(iframe);
	    
	    return res;
	};
	
	Script.prototype.runInThisContext = function () {
	    return eval(this.code); // maybe...
	};
	
	Script.prototype.runInNewContext = function (context) {
	    var ctx = Script.createContext(context);
	    var res = this.runInContext(ctx);
	
	    forEach(Object_keys(ctx), function (key) {
	        context[key] = ctx[key];
	    });
	
	    return res;
	};
	
	forEach(Object_keys(Script.prototype), function (name) {
	    exports[name] = Script[name] = function (code) {
	        var s = Script(code);
	        return s[name].apply(s, [].slice.call(arguments, 1));
	    };
	});
	
	exports.createScript = function (code) {
	    return exports.Script(code);
	};
	
	exports.createContext = Script.createContext = function (context) {
	    var copy = new Context();
	    if(typeof context === 'object') {
	        forEach(Object_keys(context), function (key) {
	            copy[key] = context[key];
	        });
	    }
	    return copy;
	};


/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	/*
	    This file is part of web3.js.
	
	    web3.js is free software: you can redistribute it and/or modify
	    it under the terms of the GNU Lesser General Public License as published by
	    the Free Software Foundation, either version 3 of the License, or
	    (at your option) any later version.
	
	    web3.js is distributed in the hope that it will be useful,
	    but WITHOUT ANY WARRANTY; without even the implied warranty of
	    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	    GNU Lesser General Public License for more details.
	
	    You should have received a copy of the GNU Lesser General Public License
	    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	*/
	/**
	 * @file index.js
	 * @author Fabian Vogelsteller <fabian@ethereum.org>
	 * @date 2017
	 */
	
	"use strict";
	
	var _ = __webpack_require__(12);
	var swarm = __webpack_require__(729);
	
	
	var Bzz = function Bzz(provider) {
	
	    this.givenProvider = Bzz.givenProvider;
	
	    if (provider && provider._requestManager) {
	        provider = provider.currentProvider;
	    }
	
	    // only allow file picker when in browser
	    if(typeof document !== 'undefined') {
	        this.pick = swarm.pick;
	    }
	
	    this.setProvider(provider);
	};
	
	// set default ethereum provider
	/* jshint ignore:start */
	Bzz.givenProvider = null;
	if(typeof ethereumProvider !== 'undefined' && ethereumProvider.bzz) {
	    Bzz.givenProvider = ethereumProvider.bzz;
	}
	/* jshint ignore:end */
	
	Bzz.prototype.setProvider = function(provider) {
	    // is ethereum provider
	    if(_.isObject(provider) && _.isString(provider.bzz)) {
	        provider = provider.bzz;
	    // is no string, set default
	    }
	    // else if(!_.isString(provider)) {
	    //      provider = 'http://swarm-gateways.net'; // default to gateway
	    // }
	
	
	    if(_.isString(provider)) {
	        this.currentProvider = provider;
	    } else {
	        this.currentProvider = null;
	
	        var noProviderError = new Error('No provider set, please set one using bzz.setProvider().');
	
	        this.download = this.upload = this.isAvailable = function(){
	            throw noProviderError;
	        };
	
	        return false;
	    }
	
	    // add functions
	    this.download = swarm.at(provider).download;
	    this.upload = swarm.at(provider).upload;
	    this.isAvailable = swarm.at(provider).isAvailable;
	
	    return true;
	};
	
	
	module.exports = Bzz;
	


/***/ },
/* 744 */
/***/ function(module, exports) {

	/*
	    This file is part of web3.js.
	
	    web3.js is free software: you can redistribute it and/or modify
	    it under the terms of the GNU Lesser General Public License as published by
	    the Free Software Foundation, either version 3 of the License, or
	    (at your option) any later version.
	
	    web3.js is distributed in the hope that it will be useful,
	    but WITHOUT ANY WARRANTY; without even the implied warranty of
	    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	    GNU Lesser General Public License for more details.
	
	    You should have received a copy of the GNU Lesser General Public License
	    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	*/
	/**
	 * @file errors.js
	 * @author Fabian Vogelsteller <fabian@ethereum.org>
	 * @author Marek Kotewicz <marek@parity.io>
	 * @date 2017
	 */
	
	"use strict";
	
	module.exports = {
	    ErrorResponse: function (result) {
	        var message = !!result && !!result.error && !!result.error.message ? result.error.message : JSON.stringify(result);
	        return new Error('Returned error: ' + message);
	    },
	    InvalidNumberOfParams: function (got, expected, method) {
	        return new Error('Invalid number of parameters for "'+ method +'". Got '+ got +' expected '+ expected +'!');
	    },
	    InvalidConnection: function (host){
	        return new Error('CONNECTION ERROR: Couldn\'t connect to node '+ host +'.');
	    },
	    InvalidProvider: function () {
	        return new Error('Provider not set or invalid');
	    },
	    InvalidResponse: function (result){
	        var message = !!result && !!result.error && !!result.error.message ? result.error.message : 'Invalid JSON RPC response: ' + JSON.stringify(result);
	        return new Error(message);
	    },
	    ConnectionTimeout: function (ms){
	        return new Error('CONNECTION TIMEOUT: timeout of ' + ms + ' ms achived');
	    }
	};


/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	/*
	    This file is part of web3.js.
	
	    web3.js is free software: you can redistribute it and/or modify
	    it under the terms of the GNU Lesser General Public License as published by
	    the Free Software Foundation, either version 3 of the License, or
	    (at your option) any later version.
	
	    web3.js is distributed in the hope that it will be useful,
	    but WITHOUT ANY WARRANTY; without even the implied warranty of
	    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	    GNU Lesser General Public License for more details.
	
	    You should have received a copy of the GNU Lesser General Public License
	    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	*/
	/**
	 * @file formatters.js
	 * @author Fabian Vogelsteller <fabian@ethereum.org>
	 * @author Marek Kotewicz <marek@parity.io>
	 * @date 2017
	 */
	
	"use strict";
	
	
	var _ = __webpack_require__(12);
	var utils = __webpack_require__(23);
	var Iban = __webpack_require__(321);
	
	/**
	 * Should the format output to a big number
	 *
	 * @method outputBigNumberFormatter
	 * @param {String|Number|BigNumber} number
	 * @returns {BigNumber} object
	 */
	var outputBigNumberFormatter = function (number) {
	    return utils.toBN(number).toString(10);
	};
	
	var isPredefinedBlockNumber = function (blockNumber) {
	    return blockNumber === 'latest' || blockNumber === 'pending' || blockNumber === 'earliest';
	};
	
	var inputDefaultBlockNumberFormatter = function (blockNumber) {
	    if (this && (blockNumber === undefined || blockNumber === null)) {
	        return this.defaultBlock;
	    }
	    if (blockNumber === 'genesis' || blockNumber === 'earliest') {
	        return '0x0';
	    }
	    return inputBlockNumberFormatter(blockNumber);
	};
	
	var inputBlockNumberFormatter = function (blockNumber) {
	    if (blockNumber === undefined) {
	        return undefined;
	    } else if (isPredefinedBlockNumber(blockNumber)) {
	        return blockNumber;
	    }
	    return (utils.isHexStrict(blockNumber)) ? ((_.isString(blockNumber)) ? blockNumber.toLowerCase() : blockNumber) : utils.numberToHex(blockNumber);
	};
	
	/**
	 * Formats the input of a transaction and converts all values to HEX
	 *
	 * @method _txInputFormatter
	 * @param {Object} transaction options
	 * @returns object
	 */
	var _txInputFormatter = function (options){
	
	    if (options.to) { // it might be contract creation
	        options.to = inputAddressFormatter(options.to);
	    }
	
	    if (options.data && options.input) {
	        throw new Error('You can\'t have "data" and "input" as properties of transactions at the same time, please use either "data" or "input" instead.');
	    }
	
	    if (!options.data && options.input) {
	        options.data = options.input;
	        delete options.input;
	    }
	
	    if(options.data && !utils.isHex(options.data)) {
	        throw new Error('The data field must be HEX encoded data.');
	    }
	
	    // allow both
	    if (options.gas || options.gasLimit) {
	        options.gas = options.gas || options.gasLimit;
	    }
	
	    ['gasPrice', 'gas', 'value', 'nonce'].filter(function (key) {
	        return options[key] !== undefined;
	    }).forEach(function(key){
	        options[key] = utils.numberToHex(options[key]);
	    });
	
	    return options;
	};
	
	/**
	 * Formats the input of a transaction and converts all values to HEX
	 *
	 * @method inputCallFormatter
	 * @param {Object} transaction options
	 * @returns object
	*/
	var inputCallFormatter = function (options){
	
	    options = _txInputFormatter(options);
	
	    var from = options.from || (this ? this.defaultAccount : null);
	
	    if (from) {
	        options.from = inputAddressFormatter(from);
	    }
	
	
	    return options;
	};
	
	/**
	 * Formats the input of a transaction and converts all values to HEX
	 *
	 * @method inputTransactionFormatter
	 * @param {Object} options
	 * @returns object
	*/
	var inputTransactionFormatter = function (options) {
	
	    options = _txInputFormatter(options);
	
	    // check from, only if not number, or object
	    if (!_.isNumber(options.from) && !_.isObject(options.from)) {
	        options.from = options.from || (this ? this.defaultAccount : null);
	
	        if (!options.from && !_.isNumber(options.from)) {
	            throw new Error('The send transactions "from" field must be defined!');
	        }
	
	        options.from = inputAddressFormatter(options.from);
	    }
	
	    return options;
	};
	
	/**
	 * Hex encodes the data passed to eth_sign and personal_sign
	 *
	 * @method inputSignFormatter
	 * @param {String} data
	 * @returns {String}
	 */
	var inputSignFormatter = function (data) {
	    return (utils.isHexStrict(data)) ? data : utils.utf8ToHex(data);
	};
	
	/**
	 * Formats the output of a transaction to its proper values
	 *
	 * @method outputTransactionFormatter
	 * @param {Object} tx
	 * @returns {Object}
	*/
	var outputTransactionFormatter = function (tx){
	    if(tx.blockNumber !== null)
	        tx.blockNumber = utils.hexToNumber(tx.blockNumber);
	    if(tx.transactionIndex !== null)
	        tx.transactionIndex = utils.hexToNumber(tx.transactionIndex);
	    tx.nonce = utils.hexToNumber(tx.nonce);
	    tx.gas = utils.hexToNumber(tx.gas);
	    tx.gasPrice = outputBigNumberFormatter(tx.gasPrice);
	    tx.value = outputBigNumberFormatter(tx.value);
	
	    if(tx.to && utils.isAddress(tx.to)) { // tx.to could be `0x0` or `null` while contract creation
	        tx.to = utils.toChecksumAddress(tx.to);
	    } else {
	        tx.to = null; // set to `null` if invalid address
	    }
	
	    if(tx.from) {
	        tx.from = utils.toChecksumAddress(tx.from);
	    }
	
	    return tx;
	};
	
	/**
	 * Formats the output of a transaction receipt to its proper values
	 *
	 * @method outputTransactionReceiptFormatter
	 * @param {Object} receipt
	 * @returns {Object}
	*/
	var outputTransactionReceiptFormatter = function (receipt){
	    if(typeof receipt !== 'object') {
	        throw new Error('Received receipt is invalid: '+ receipt);
	    }
	
	    if(receipt.blockNumber !== null)
	        receipt.blockNumber = utils.hexToNumber(receipt.blockNumber);
	    if(receipt.transactionIndex !== null)
	        receipt.transactionIndex = utils.hexToNumber(receipt.transactionIndex);
	    receipt.cumulativeGasUsed = utils.hexToNumber(receipt.cumulativeGasUsed);
	    receipt.gasUsed = utils.hexToNumber(receipt.gasUsed);
	
	    if(_.isArray(receipt.logs)) {
	        receipt.logs = receipt.logs.map(outputLogFormatter);
	    }
	
	    if(receipt.contractAddress) {
	        receipt.contractAddress = utils.toChecksumAddress(receipt.contractAddress);
	    }
	
	    if(typeof receipt.status !== 'undefined') {
	        receipt.status = Boolean(parseInt(receipt.status));
	    }
	
	    return receipt;
	};
	
	/**
	 * Formats the output of a block to its proper values
	 *
	 * @method outputBlockFormatter
	 * @param {Object} block
	 * @returns {Object}
	*/
	var outputBlockFormatter = function(block) {
	
	    // transform to number
	    block.gasLimit = utils.hexToNumber(block.gasLimit);
	    block.gasUsed = utils.hexToNumber(block.gasUsed);
	    block.size = utils.hexToNumber(block.size);
	    block.timestamp = utils.hexToNumber(block.timestamp);
	    if (block.number !== null)
	        block.number = utils.hexToNumber(block.number);
	
	    if(block.difficulty)
	        block.difficulty = outputBigNumberFormatter(block.difficulty);
	    if(block.totalDifficulty)
	        block.totalDifficulty = outputBigNumberFormatter(block.totalDifficulty);
	
	    if (_.isArray(block.transactions)) {
	        block.transactions.forEach(function(item){
	            if(!_.isString(item))
	                return outputTransactionFormatter(item);
	        });
	    }
	
	    if (block.miner)
	        block.miner = utils.toChecksumAddress(block.miner);
	
	    return block;
	};
	
	/**
	 * Formats the input of a log
	 *
	 * @method inputLogFormatter
	 * @param {Object} log object
	 * @returns {Object} log
	*/
	var inputLogFormatter = function(options) {
	    var toTopic = function(value){
	
	        if(value === null || typeof value === 'undefined')
	            return null;
	
	        value = String(value);
	
	        if(value.indexOf('0x') === 0)
	            return value;
	        else
	            return utils.fromUtf8(value);
	    };
	
	    // make sure topics, get converted to hex
	    options.topics = options.topics || [];
	    options.topics = options.topics.map(function(topic){
	        return (_.isArray(topic)) ? topic.map(toTopic) : toTopic(topic);
	    });
	
	    toTopic = null;
	
	    if (options.address) {
	        options.address = (_.isArray(options.address)) ? options.address.map(function (addr) {
	            return inputAddressFormatter(addr);
	        }) : inputAddressFormatter(options.address);
	    }
	
	    return options;
	};
	
	/**
	 * Formats the output of a log
	 *
	 * @method outputLogFormatter
	 * @param {Object} log object
	 * @returns {Object} log
	*/
	var outputLogFormatter = function(log) {
	
	    // generate a custom log id
	    if(typeof log.blockHash === 'string' &&
	       typeof log.transactionHash === 'string' &&
	       typeof log.logIndex === 'string') {
	        var shaId = utils.sha3(log.blockHash.replace('0x','') + log.transactionHash.replace('0x','') + log.logIndex.replace('0x',''));
	        log.id = 'log_'+ shaId.replace('0x','').substr(0,8);
	    } else if(!log.id) {
	        log.id = null;
	    }
	
	    if (log.blockNumber !== null)
	        log.blockNumber = utils.hexToNumber(log.blockNumber);
	    if (log.transactionIndex !== null)
	        log.transactionIndex = utils.hexToNumber(log.transactionIndex);
	    if (log.logIndex !== null)
	        log.logIndex = utils.hexToNumber(log.logIndex);
	
	    if (log.address) {
	        log.address = utils.toChecksumAddress(log.address);
	    }
	
	    return log;
	};
	
	/**
	 * Formats the input of a whisper post and converts all values to HEX
	 *
	 * @method inputPostFormatter
	 * @param {Object} transaction object
	 * @returns {Object}
	*/
	var inputPostFormatter = function(post) {
	
	    // post.payload = utils.toHex(post.payload);
	
	    if (post.ttl)
	        post.ttl = utils.numberToHex(post.ttl);
	    if (post.workToProve)
	        post.workToProve = utils.numberToHex(post.workToProve);
	    if (post.priority)
	        post.priority = utils.numberToHex(post.priority);
	
	    // fallback
	    if (!_.isArray(post.topics)) {
	        post.topics = post.topics ? [post.topics] : [];
	    }
	
	    // format the following options
	    post.topics = post.topics.map(function(topic){
	        // convert only if not hex
	        return (topic.indexOf('0x') === 0) ? topic : utils.fromUtf8(topic);
	    });
	
	    return post;
	};
	
	/**
	 * Formats the output of a received post message
	 *
	 * @method outputPostFormatter
	 * @param {Object}
	 * @returns {Object}
	 */
	var outputPostFormatter = function(post){
	
	    post.expiry = utils.hexToNumber(post.expiry);
	    post.sent = utils.hexToNumber(post.sent);
	    post.ttl = utils.hexToNumber(post.ttl);
	    post.workProved = utils.hexToNumber(post.workProved);
	    // post.payloadRaw = post.payload;
	    // post.payload = utils.hexToAscii(post.payload);
	
	    // if (utils.isJson(post.payload)) {
	    //     post.payload = JSON.parse(post.payload);
	    // }
	
	    // format the following options
	    if (!post.topics) {
	        post.topics = [];
	    }
	    post.topics = post.topics.map(function(topic){
	        return utils.toUtf8(topic);
	    });
	
	    return post;
	};
	
	var inputAddressFormatter = function (address) {
	    var iban = new Iban(address);
	    if (iban.isValid() && iban.isDirect()) {
	        return iban.toAddress().toLowerCase();
	    } else if (utils.isAddress(address)) {
	        return '0x' + address.toLowerCase().replace('0x','');
	    }
	    throw new Error('Provided address "'+ address +'" is invalid, the capitalization checksum test failed, or its an indrect IBAN address which can\'t be converted.');
	};
	
	
	var outputSyncingFormatter = function(result) {
	
	    result.startingBlock = utils.hexToNumber(result.startingBlock);
	    result.currentBlock = utils.hexToNumber(result.currentBlock);
	    result.highestBlock = utils.hexToNumber(result.highestBlock);
	    if (result.knownStates) {
	        result.knownStates = utils.hexToNumber(result.knownStates);
	        result.pulledStates = utils.hexToNumber(result.pulledStates);
	    }
	
	    return result;
	};
	
	module.exports = {
	    inputDefaultBlockNumberFormatter: inputDefaultBlockNumberFormatter,
	    inputBlockNumberFormatter: inputBlockNumberFormatter,
	    inputCallFormatter: inputCallFormatter,
	    inputTransactionFormatter: inputTransactionFormatter,
	    inputAddressFormatter: inputAddressFormatter,
	    inputPostFormatter: inputPostFormatter,
	    inputLogFormatter: inputLogFormatter,
	    inputSignFormatter: inputSignFormatter,
	    outputBigNumberFormatter: outputBigNumberFormatter,
	    outputTransactionFormatter: outputTransactionFormatter,
	    outputTransactionReceiptFormatter: outputTransactionReceiptFormatter,
	    outputBlockFormatter: outputBlockFormatter,
	    outputLogFormatter: outputLogFormatter,
	    outputPostFormatter: outputPostFormatter,
	    outputSyncingFormatter: outputSyncingFormatter
	};
	


/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//
	// We store our EE objects in a plain object whose properties are event names.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// `~` to make sure that the built-in object properties are not overridden or
	// used as an attack vector.
	// We also assume that `Object.create(null)` is available when the event name
	// is an ES6 Symbol.
	//
	var prefix = typeof Object.create !== 'function' ? '~' : false;
	
	/**
	 * Representation of a single EventEmitter function.
	 *
	 * @param {Function} fn Event handler to be called.
	 * @param {Mixed} context Context for function execution.
	 * @param {Boolean} once Only emit once
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal EventEmitter interface that is molded against the Node.js
	 * EventEmitter interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() { /* Nothing to set */ }
	
	/**
	 * Holds the assigned EventEmitters by name.
	 *
	 * @type {Object}
	 * @private
	 */
	EventEmitter.prototype._events = undefined;
	
	/**
	 * Return a list of assigned event listeners.
	 *
	 * @param {String} event The events that should be listed.
	 * @param {Boolean} exists We only need to know if there are listeners.
	 * @returns {Array|Boolean}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event, exists) {
	  var evt = prefix ? prefix + event : event
	    , available = this._events && this._events[evt];
	
	  if (exists) return !!available;
	  if (!available) return [];
	  if (available.fn) return [available.fn];
	
	  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
	    ee[i] = available[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Emit an event to all registered event listeners.
	 *
	 * @param {String} event The name of the event.
	 * @returns {Boolean} Indication if we've emitted an event.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events || !this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if ('function' === typeof listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Register a new EventListener for the given event.
	 *
	 * @param {String} event Name of the event.
	 * @param {Functon} fn Callback function.
	 * @param {Mixed} context The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events) this._events = prefix ? {} : Object.create(null);
	  if (!this._events[evt]) this._events[evt] = listener;
	  else {
	    if (!this._events[evt].fn) this._events[evt].push(listener);
	    else this._events[evt] = [
	      this._events[evt], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Add an EventListener that's only called once.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} context The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events) this._events = prefix ? {} : Object.create(null);
	  if (!this._events[evt]) this._events[evt] = listener;
	  else {
	    if (!this._events[evt].fn) this._events[evt].push(listener);
	    else this._events[evt] = [
	      this._events[evt], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Remove event listeners.
	 *
	 * @param {String} event The event we want to remove.
	 * @param {Function} fn The listener that we need to find.
	 * @param {Mixed} context Only remove listeners matching this context.
	 * @param {Boolean} once Only remove once listeners.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events || !this._events[evt]) return this;
	
	  var listeners = this._events[evt]
	    , events = [];
	
	  if (fn) {
	    if (listeners.fn) {
	      if (
	           listeners.fn !== fn
	        || (once && !listeners.once)
	        || (context && listeners.context !== context)
	      ) {
	        events.push(listeners);
	      }
	    } else {
	      for (var i = 0, length = listeners.length; i < length; i++) {
	        if (
	             listeners[i].fn !== fn
	          || (once && !listeners[i].once)
	          || (context && listeners[i].context !== context)
	        ) {
	          events.push(listeners[i]);
	        }
	      }
	    }
	  }
	
	  //
	  // Reset the array, or remove it completely if we have no more listeners.
	  //
	  if (events.length) {
	    this._events[evt] = events.length === 1 ? events[0] : events;
	  } else {
	    delete this._events[evt];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners or only the listeners for the specified event.
	 *
	 * @param {String} event The event want to remove all listeners for.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  if (!this._events) return this;
	
	  if (event) delete this._events[prefix ? prefix + event : event];
	  else this._events = prefix ? {} : Object.create(null);
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Expose the module.
	//
	if (true) {
	  module.exports = EventEmitter;
	}


/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	/*
	    This file is part of web3.js.
	
	    web3.js is free software: you can redistribute it and/or modify
	    it under the terms of the GNU Lesser General Public License as published by
	    the Free Software Foundation, either version 3 of the License, or
	    (at your option) any later version.
	
	    web3.js is distributed in the hope that it will be useful,
	    but WITHOUT ANY WARRANTY; without even the implied warranty of
	    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	    GNU Lesser General Public License for more details.
	
	    You should have received a copy of the GNU Lesser General Public License
	    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	*/
	/**
	 * @file batch.js
	 * @author Marek Kotewicz <marek@ethdev.com>
	 * @date 2015
	 */
	
	"use strict";
	
	var Jsonrpc = __webpack_require__(315);
	var errors = __webpack_require__(14).errors;
	
	var Batch = function (requestManager) {
	    this.requestManager = requestManager;
	    this.requests = [];
	};
	
	/**
	 * Should be called to add create new request to batch request
	 *
	 * @method add
	 * @param {Object} jsonrpc requet object
	 */
	Batch.prototype.add = function (request) {
	    this.requests.push(request);
	};
	
	/**
	 * Should be called to execute batch request
	 *
	 * @method execute
	 */
	Batch.prototype.execute = function () {
	    var requests = this.requests;
	    this.requestManager.sendBatch(requests, function (err, results) {
	        results = results || [];
	        requests.map(function (request, index) {
	            return results[index] || {};
	        }).forEach(function (result, index) {
	            if (requests[index].callback) {
	
	                if (result && result.error) {
	                    return requests[index].callback(errors.ErrorResponse(result));
	                }
	
	                if (!Jsonrpc.isValidResponse(result)) {
	                    return requests[index].callback(errors.InvalidResponse(result));
	                }
	
	                requests[index].callback(null, (requests[index].format ? requests[index].format(result.result) : result.result));
	            }
	        });
	    });
	};
	
	module.exports = Batch;
	


/***/ },
/* 748 */
/***/ function(module, exports) {

	/*
	 This file is part of web3.js.
	
	 web3.js is free software: you can redistribute it and/or modify
	 it under the terms of the GNU Lesser General Public License as published by
	 the Free Software Foundation, either version 3 of the License, or
	 (at your option) any later version.
	
	 web3.js is distributed in the hope that it will be useful,
	 but WITHOUT ANY WARRANTY; without even the implied warranty of
	 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	 GNU Lesser General Public License for more details.
	
	 You should have received a copy of the GNU Lesser General Public License
	 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	 */
	/**
	 * @file givenProvider.js
	 * @author Fabian Vogelsteller <fabian@ethereum.org>
	 * @date 2017
	 */
	
	"use strict";
	
	var givenProvider = null;
	
	// ADD GIVEN PROVIDER
	/* jshint ignore:start */
	var global = Function('return this')();
	
	// EthereumProvider
	if(typeof global.ethereumProvider !== 'undefined') {
	    givenProvider = global.ethereumProvider;
	
	// Legacy web3.currentProvider
	} else if(typeof global.web3 !== 'undefined' && global.web3.currentProvider) {
	
	    if(global.web3.currentProvider.sendAsync) {
	        global.web3.currentProvider.send = global.web3.currentProvider.sendAsync;
	        delete global.web3.currentProvider.sendAsync;
	    }
	
	    // if connection is 'ipcProviderWrapper', add subscription support
	    if(!global.web3.currentProvider.on &&
	        global.web3.currentProvider.connection &&
	        global.web3.currentProvider.connection.constructor.name === 'ipcProviderWrapper') {
	
	        global.web3.currentProvider.on = function (type, callback) {
	
	            if(typeof callback !== 'function')
	                throw new Error('The second parameter callback must be a function.');
	
	            switch(type){
	                case 'data':
	                    this.connection.on('data', function(data) {
	                        var result = '';
	
	                        data = data.toString();
	
	                        try {
	                            result = JSON.parse(data);
	                        } catch(e) {
	                            return callback(new Error('Couldn\'t parse response data'+ data));
	                        }
	
	                        // notification
	                        if(!result.id && result.method.indexOf('_subscription') !== -1) {
	                            callback(null, result);
	                        }
	
	                    });
	                    break;
	
	                default:
	                    this.connection.on(type, callback);
	                    break;
	            }
	        };
	    }
	
	    givenProvider = global.web3.currentProvider;
	}
	/* jshint ignore:end */
	
	
	module.exports = givenProvider;


/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	/*
	    This file is part of web3.js.
	
	    web3.js is free software: you can redistribute it and/or modify
	    it under the terms of the GNU Lesser General Public License as published by
	    the Free Software Foundation, either version 3 of the License, or
	    (at your option) any later version.
	
	    web3.js is distributed in the hope that it will be useful,
	    but WITHOUT ANY WARRANTY; without even the implied warranty of
	    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	    GNU Lesser General Public License for more details.
	
	    You should have received a copy of the GNU Lesser General Public License
	    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	*/
	/**
	 * @file index.js
	 * @author Fabian Vogelsteller <fabian@ethereum.org>
	 * @date 2017
	 */
	
	"use strict";
	
	
	var _ = __webpack_require__(12);
	var errors = __webpack_require__(14).errors;
	var Jsonrpc = __webpack_require__(315);
	var BatchManager = __webpack_require__(747);
	var givenProvider = __webpack_require__(748);
	
	
	
	    /**
	 * It's responsible for passing messages to providers
	 * It's also responsible for polling the ethereum node for incoming messages
	 * Default poll timeout is 1 second
	 * Singleton
	 */
	var RequestManager = function RequestManager(provider) {
	    this.provider = null;
	    this.providers = RequestManager.providers;
	
	    this.setProvider(provider);
	    this.subscriptions = {};
	};
	
	
	
	RequestManager.givenProvider = givenProvider;
	
	RequestManager.providers = {
	    WebsocketProvider: __webpack_require__(771),
	    HttpProvider: __webpack_require__(769),
	    IpcProvider: __webpack_require__(770)
	};
	
	
	
	/**
	 * Should be used to set provider of request manager
	 *
	 * @method setProvider
	 * @param {Object} p
	 */
	RequestManager.prototype.setProvider = function (p, net) {
	    var _this = this;
	
	    // autodetect provider
	    if(p && typeof p === 'string' && this.providers) {
	
	        // HTTP
	        if(/^http(s)?:\/\//i.test(p)) {
	            p = new this.providers.HttpProvider(p);
	
	            // WS
	        } else if(/^ws(s)?:\/\//i.test(p)) {
	            p = new this.providers.WebsocketProvider(p);
	
	            // IPC
	        } else if(p && typeof net === 'object'  && typeof net.connect === 'function') {
	            p = new this.providers.IpcProvider(p, net);
	
	        } else if(p) {
	            throw new Error('Can\'t autodetect provider for "'+ p +'"');
	        }
	    }
	
	    // reset the old one before changing
	    if(this.provider)
	        this.clearSubscriptions();
	
	
	    this.provider = p || null;
	
	    // listen to incoming notifications
	    if(this.provider && this.provider.on) {
	        this.provider.on('data', function requestManagerNotification(result, deprecatedResult){
	            result = result || deprecatedResult; // this is for possible old providers, which may had the error first handler
	
	            // check for result.method, to prevent old providers errors to pass as result
	            if(result.method && _this.subscriptions[result.params.subscription] && _this.subscriptions[result.params.subscription].callback) {
	                _this.subscriptions[result.params.subscription].callback(null, result.params.result);
	            }
	        });
	        // TODO add error, end, timeout, connect??
	        // this.provider.on('error', function requestManagerNotification(result){
	        //     Object.keys(_this.subscriptions).forEach(function(id){
	        //         if(_this.subscriptions[id].callback)
	        //             _this.subscriptions[id].callback(err);
	        //     });
	        // }
	    }
	};
	
	
	/**
	 * Should be used to asynchronously send request
	 *
	 * @method sendAsync
	 * @param {Object} data
	 * @param {Function} callback
	 */
	RequestManager.prototype.send = function (data, callback) {
	    callback = callback || function(){};
	
	    if (!this.provider) {
	        return callback(errors.InvalidProvider());
	    }
	
	    var payload = Jsonrpc.toPayload(data.method, data.params);
	    this.provider[this.provider.sendAsync ? 'sendAsync' : 'send'](payload, function (err, result) {
	        if(result && result.id && payload.id !== result.id) return callback(new Error('Wrong response id "'+ result.id +'" (expected: "'+ payload.id +'") in '+ JSON.stringify(payload)));
	
	        if (err) {
	            return callback(err);
	        }
	
	        if (result && result.error) {
	            return callback(errors.ErrorResponse(result));
	        }
	
	        if (!Jsonrpc.isValidResponse(result)) {
	            return callback(errors.InvalidResponse(result));
	        }
	
	        callback(null, result.result);
	    });
	};
	
	/**
	 * Should be called to asynchronously send batch request
	 *
	 * @method sendBatch
	 * @param {Array} batch data
	 * @param {Function} callback
	 */
	RequestManager.prototype.sendBatch = function (data, callback) {
	    if (!this.provider) {
	        return callback(errors.InvalidProvider());
	    }
	
	    var payload = Jsonrpc.toBatchPayload(data);
	    this.provider[this.provider.sendAsync ? 'sendAsync' : 'send'](payload, function (err, results) {
	        if (err) {
	            return callback(err);
	        }
	
	        if (!_.isArray(results)) {
	            return callback(errors.InvalidResponse(results));
	        }
	
	        callback(null, results);
	    });
	};
	
	
	/**
	 * Waits for notifications
	 *
	 * @method addSubscription
	 * @param {String} id           the subscription id
	 * @param {String} name         the subscription name
	 * @param {String} type         the subscription namespace (eth, personal, etc)
	 * @param {Function} callback   the callback to call for incoming notifications
	 */
	RequestManager.prototype.addSubscription = function (id, name, type, callback) {
	    if(this.provider.on) {
	        this.subscriptions[id] = {
	            callback: callback,
	            type: type,
	            name: name
	        };
	
	    } else {
	        throw new Error('The provider doesn\'t support subscriptions: '+ this.provider.constructor.name);
	    }
	};
	
	/**
	 * Waits for notifications
	 *
	 * @method removeSubscription
	 * @param {String} id           the subscription id
	 * @param {Function} callback   fired once the subscription is removed
	 */
	RequestManager.prototype.removeSubscription = function (id, callback) {
	    var _this = this;
	
	    if(this.subscriptions[id]) {
	
	        this.send({
	            method: this.subscriptions[id].type + '_unsubscribe',
	            params: [id]
	        }, callback);
	
	        // remove subscription
	        delete _this.subscriptions[id];
	    }
	};
	
	/**
	 * Should be called to reset the subscriptions
	 *
	 * @method reset
	 */
	RequestManager.prototype.clearSubscriptions = function (keepIsSyncing) {
	    var _this = this;
	
	
	    // uninstall all subscriptions
	    Object.keys(this.subscriptions).forEach(function(id){
	        if(!keepIsSyncing || _this.subscriptions[id].name !== 'syncing')
	            _this.removeSubscription(id);
	    });
	
	
	    //  reset notification callbacks etc.
	    if(this.provider.reset)
	        this.provider.reset();
	};
	
	module.exports = {
	    Manager: RequestManager,
	    BatchManager: BatchManager
	};


/***/ },
/* 750 */
746,
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	/*
	    This file is part of web3.js.
	
	    web3.js is free software: you can redistribute it and/or modify
	    it under the terms of the GNU Lesser General Public License as published by
	    the Free Software Foundation, either version 3 of the License, or
	    (at your option) any later version.
	
	    web3.js is distributed in the hope that it will be useful,
	    but WITHOUT ANY WARRANTY; without even the implied warranty of
	    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	    GNU Lesser General Public License for more details.
	
	    You should have received a copy of the GNU Lesser General Public License
	    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	*/
	/**
	 * @file subscription.js
	 * @author Fabian Vogelsteller <fabian@ethereum.org>
	 * @date 2017
	 */
	
	"use strict";
	
	var _ = __webpack_require__(12);
	var errors = __webpack_require__(14).errors;
	var EventEmitter = __webpack_require__(750);
	
	
	function Subscription(options) {
	    EventEmitter.call(this);
	
	    this.id = null;
	    this.callback = null;
	    this.arguments = null;
	    this._reconnectIntervalId = null;
	
	    this.options = {
	        subscription: options.subscription,
	        type: options.type,
	        requestManager: options.requestManager
	    };
	}
	
	// INHERIT
	Subscription.prototype = Object.create(EventEmitter.prototype);
	Subscription.prototype.constructor = Subscription;
	
	
	/**
	 * Should be used to extract callback from array of arguments. Modifies input param
	 *
	 * @method extractCallback
	 * @param {Array} arguments
	 * @return {Function|Null} callback, if exists
	 */
	
	Subscription.prototype._extractCallback = function (args) {
	    if (_.isFunction(args[args.length - 1])) {
	        return args.pop(); // modify the args array!
	    }
	};
	
	/**
	 * Should be called to check if the number of arguments is correct
	 *
	 * @method validateArgs
	 * @param {Array} arguments
	 * @throws {Error} if it is not
	 */
	
	Subscription.prototype._validateArgs = function (args) {
	    var subscription = this.options.subscription;
	
	    if(!subscription)
	        subscription = {};
	
	    if(!subscription.params)
	        subscription.params = 0;
	
	    if (args.length !== subscription.params) {
	        throw errors.InvalidNumberOfParams(args.length, subscription.params + 1, args[0]);
	    }
	};
	
	/**
	 * Should be called to format input args of method
	 *
	 * @method formatInput
	 * @param {Array}
	 * @return {Array}
	 */
	
	Subscription.prototype._formatInput = function (args) {
	    var subscription = this.options.subscription;
	
	    if (!subscription) {
	        return args;
	    }
	
	    if (!subscription.inputFormatter) {
	        return args;
	    }
	
	    var formattedArgs = subscription.inputFormatter.map(function (formatter, index) {
	        return formatter ? formatter(args[index]) : args[index];
	    });
	
	    return formattedArgs;
	};
	
	/**
	 * Should be called to format output(result) of method
	 *
	 * @method formatOutput
	 * @param {Object}
	 * @return {Object}
	 */
	
	Subscription.prototype._formatOutput = function (result) {
	    var subscription = this.options.subscription;
	
	    return (subscription && subscription.outputFormatter && result) ? subscription.outputFormatter(result) : result;
	};
	
	/**
	 * Should create payload from given input args
	 *
	 * @method toPayload
	 * @param {Array} args
	 * @return {Object}
	 */
	Subscription.prototype._toPayload = function (args) {
	    var params = [];
	    this.callback = this._extractCallback(args);
	
	    if (!this.subscriptionMethod) {
	        this.subscriptionMethod = args.shift();
	
	        // replace subscription with given name
	        if (this.options.subscription.subscriptionName) {
	            this.subscriptionMethod = this.options.subscription.subscriptionName;
	        }
	    }
	
	    if (!this.arguments) {
	        this.arguments = this._formatInput(args);
	        this._validateArgs(this.arguments);
	        args = []; // make empty after validation
	
	    }
	
	    // re-add subscriptionName
	    params.push(this.subscriptionMethod);
	    params = params.concat(this.arguments);
	
	
	    if (args.length) {
	        throw new Error('Only a callback is allowed as parameter on an already instantiated subscription.');
	    }
	
	    return {
	        method: this.options.type + '_subscribe',
	        params: params
	    };
	};
	
	/**
	 * Unsubscribes and clears callbacks
	 *
	 * @method unsubscribe
	 * @return {Object}
	 */
	Subscription.prototype.unsubscribe = function(callback) {
	    this.options.requestManager.removeSubscription(this.id, callback);
	    this.id = null;
	    this.removeAllListeners();
	    clearInterval(this._reconnectIntervalId);
	};
	
	/**
	 * Subscribes and watches for changes
	 *
	 * @method subscribe
	 * @param {String} subscription the subscription
	 * @param {Object} options the options object with address topics and fromBlock
	 * @return {Object}
	 */
	Subscription.prototype.subscribe = function() {
	    var _this = this;
	    var args = Array.prototype.slice.call(arguments);
	    var payload = this._toPayload(args);
	
	    if(!payload) {
	        return this;
	    }
	
	    if(!this.options.requestManager.provider) {
	        var err1 = new Error('No provider set.');
	        this.callback(err1, null, this);
	        this.emit('error', err1);
	        return this;
	    }
	
	    // throw error, if provider doesnt support subscriptions
	    if(!this.options.requestManager.provider.on) {
	        var err2 = new Error('The current provider doesn\'t support subscriptions: '+ this.options.requestManager.provider.constructor.name);
	        this.callback(err2, null, this);
	        this.emit('error', err2);
	        return this;
	    }
	
	    // if id is there unsubscribe first
	    if (this.id) {
	        this.unsubscribe();
	    }
	
	    // store the params in the options object
	    this.options.params = payload.params[1];
	
	    // get past logs, if fromBlock is available
	    if(payload.params[0] === 'logs' && _.isObject(payload.params[1]) && payload.params[1].hasOwnProperty('fromBlock') && isFinite(payload.params[1].fromBlock)) {
	        // send the subscription request
	        this.options.requestManager.send({
	            method: 'eth_getLogs',
	            params: [payload.params[1]]
	        }, function (err, logs) {
	            if(!err) {
	                logs.forEach(function(log){
	                    var output = _this._formatOutput(log);
	                    _this.callback(null, output, _this);
	                    _this.emit('data', output);
	                });
	
	                // TODO subscribe here? after the past logs?
	
	            } else {
	                _this.callback(err, null, _this);
	                _this.emit('error', err);
	            }
	        });
	    }
	
	    // create subscription
	    // TODO move to separate function? so that past logs can go first?
	
	    if(typeof payload.params[1] === 'object')
	        delete payload.params[1].fromBlock;
	
	    this.options.requestManager.send(payload, function (err, result) {
	        if(!err && result) {
	            _this.id = result;
	
	            // call callback on notifications
	            _this.options.requestManager.addSubscription(_this.id, payload.params[0] , _this.options.type, function(err, result) {
	
	                if (!err) {
	                    if (!_.isArray(result)) {
	                        result = [result];
	                    }
	
	                    result.forEach(function(resultItem) {
	                        var output = _this._formatOutput(resultItem);
	
	                        if (_.isFunction(_this.options.subscription.subscriptionHandler)) {
	                            return _this.options.subscription.subscriptionHandler.call(_this, output);
	                        } else {
	                            _this.emit('data', output);
	                        }
	
	                        // call the callback, last so that unsubscribe there won't affect the emit above
	                        if (_.isFunction(_this.callback)) {
	                            _this.callback(null, output, _this);
	                        }
	                    });
	                } else {
	                    // unsubscribe, but keep listeners
	                    _this.options.requestManager.removeSubscription(_this.id);
	
	                    // re-subscribe, if connection fails
	                    if(_this.options.requestManager.provider.once) {
	                        _this._reconnectIntervalId = setInterval(function () {
	                            // TODO check if that makes sense!
	                            if (_this.options.requestManager.provider.reconnect) {
	                                _this.options.requestManager.provider.reconnect();
	                            }
	                        }, 500);
	
	                        _this.options.requestManager.provider.once('connect', function () {
	                            clearInterval(_this._reconnectIntervalId);
	                            _this.subscribe(_this.callback);
	                        });
	                    }
	                    _this.emit('error', err);
	
	                     // call the callback, last so that unsubscribe there won't affect the emit above
	                     if (_.isFunction(_this.callback)) {
	                        _this.callback(err, null, _this);
	                    }
	                }
	            });
	        } else if (_.isFunction(_this.callback)) {
	            _this.callback(err, null, _this);
	            _this.emit('error', err);
	        } else {
	            // emit the event even if no callback was provided
	            _this.emit('error', err);
	        }
	    });
	
	    // return an object to cancel the subscription
	    return this;
	};
	
	module.exports = Subscription;


/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 This file is part of web3.js.
	
	 web3.js is free software: you can redistribute it and/or modify
	 it under the terms of the GNU Lesser General Public License as published by
	 the Free Software Foundation, either version 3 of the License, or
	 (at your option) any later version.
	
	 web3.js is distributed in the hope that it will be useful,
	 but WITHOUT ANY WARRANTY; without even the implied warranty of
	 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	 GNU Lesser General Public License for more details.
	
	 You should have received a copy of the GNU Lesser General Public License
	 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	 */
	/**
	 * @file extend.js
	 * @author Fabian Vogelsteller <fabian@ethereum.org>
	 * @date 2017
	 */
	
	"use strict";
	
	
	var formatters = __webpack_require__(14).formatters;
	var Method = __webpack_require__(48);
	var utils = __webpack_require__(23);
	
	
	var extend = function (pckg) {
	    /* jshint maxcomplexity:5 */
	    var ex = function (extension) {
	
	        var extendedObject;
	        if (extension.property) {
	            if (!pckg[extension.property]) {
	                pckg[extension.property] = {};
	            }
	            extendedObject = pckg[extension.property];
	        } else {
	            extendedObject = pckg;
	        }
	
	        if (extension.methods) {
	            extension.methods.forEach(function (method) {
	                if(!(method instanceof Method)) {
	                    method = new Method(method);
	                }
	
	                method.attachToObject(extendedObject);
	                method.setRequestManager(pckg._requestManager);
	            });
	        }
	
	        return pckg;
	    };
	
	    ex.formatters = formatters;
	    ex.utils = utils;
	    ex.Method = Method;
	
	    return ex;
	};
	
	
	
	module.exports = extend;
	


/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	var f = __webpack_require__(29);
	var formatters = __webpack_require__(14).formatters;
	var SolidityType = __webpack_require__(50);
	
	/**
	 * SolidityTypeAddress is a protoype that represents address type
	 * It matches:
	 * address
	 * address[]
	 * address[4]
	 * address[][]
	 * address[3][]
	 * address[][6][], ...
	 */
	var SolidityTypeAddress = function () {
	    this._inputFormatter = function(){
	        var args = Array.prototype.slice.call(arguments);
	        args[0] = (!args[0] || args[0] === '0x0') ? '' : formatters.inputAddressFormatter(args[0]);
	        return f.formatInputInt.apply(this, args);
	    };
	    this._outputFormatter = f.formatOutputAddress;
	};
	
	SolidityTypeAddress.prototype = new SolidityType({});
	SolidityTypeAddress.prototype.constructor = SolidityTypeAddress;
	
	SolidityTypeAddress.prototype.isType = function (name) {
	    return !!name.match(/address(\[([0-9]*)\])?/);
	};
	
	module.exports = SolidityTypeAddress;


/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	var f = __webpack_require__(29);
	var SolidityType = __webpack_require__(50);
	
	/**
	 * SolidityTypeBool is a protoype that represents bool type
	 * It matches:
	 * bool
	 * bool[]
	 * bool[4]
	 * bool[][]
	 * bool[3][]
	 * bool[][6][], ...
	 */
	var SolidityTypeBool = function () {
	    this._inputFormatter = f.formatInputBool;
	    this._outputFormatter = f.formatOutputBool;
	};
	
	SolidityTypeBool.prototype = new SolidityType({});
	SolidityTypeBool.prototype.constructor = SolidityTypeBool;
	
	SolidityTypeBool.prototype.isType = function (name) {
	    return !!name.match(/^bool(\[([0-9]*)\])*$/);
	};
	
	module.exports = SolidityTypeBool;


/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	var f = __webpack_require__(29);
	var SolidityType = __webpack_require__(50);
	
	/**
	 * SolidityTypeBytes is a prototype that represents the bytes type.
	 * It matches:
	 * bytes
	 * bytes[]
	 * bytes[4]
	 * bytes[][]
	 * bytes[3][]
	 * bytes[][6][], ...
	 * bytes32
	 * bytes8[4]
	 * bytes[3][]
	 */
	var SolidityTypeBytes = function () {
	    this._inputFormatter = f.formatInputBytes;
	    this._outputFormatter = f.formatOutputBytes;
	};
	
	SolidityTypeBytes.prototype = new SolidityType({});
	SolidityTypeBytes.prototype.constructor = SolidityTypeBytes;
	
	SolidityTypeBytes.prototype.isType = function (name) {
	    return !!name.match(/^bytes([0-9]{1,})(\[([0-9]*)\])*$/);
	};
	
	module.exports = SolidityTypeBytes;


/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	var f = __webpack_require__(29);
	var SolidityType = __webpack_require__(50);
	
	var SolidityTypeDynamicBytes = function () {
	    this._inputFormatter = f.formatInputDynamicBytes;
	    this._outputFormatter = f.formatOutputDynamicBytes;
	};
	
	SolidityTypeDynamicBytes.prototype = new SolidityType({});
	SolidityTypeDynamicBytes.prototype.constructor = SolidityTypeDynamicBytes;
	
	SolidityTypeDynamicBytes.prototype.isType = function (name) {
	    return !!name.match(/^bytes(\[([0-9]*)\])*$/);
	};
	
	SolidityTypeDynamicBytes.prototype.isDynamicType = function () {
	    return true;
	};
	
	module.exports = SolidityTypeDynamicBytes;


/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	var f = __webpack_require__(29);
	var SolidityType = __webpack_require__(50);
	
	/**
	 * SolidityTypeInt is a protoype that represents int type
	 * It matches:
	 * int
	 * int[]
	 * int[4]
	 * int[][]
	 * int[3][]
	 * int[][6][], ...
	 * int32
	 * int64[]
	 * int8[4]
	 * int256[][]
	 * int[3][]
	 * int64[][6][], ...
	 */
	var SolidityTypeInt = function () {
	    this._inputFormatter = f.formatInputInt;
	    this._outputFormatter = f.formatOutputInt;
	};
	
	SolidityTypeInt.prototype = new SolidityType({});
	SolidityTypeInt.prototype.constructor = SolidityTypeInt;
	
	SolidityTypeInt.prototype.isType = function (name) {
	    return !!name.match(/^int([0-9]*)?(\[([0-9]*)\])*$/);
	};
	
	module.exports = SolidityTypeInt;


/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	var f = __webpack_require__(29);
	var SolidityType = __webpack_require__(50);
	
	var SolidityTypeString = function () {
	    this._inputFormatter = f.formatInputString;
	    this._outputFormatter = f.formatOutputString;
	};
	
	SolidityTypeString.prototype = new SolidityType({});
	SolidityTypeString.prototype.constructor = SolidityTypeString;
	
	SolidityTypeString.prototype.isType = function (name) {
	    return !!name.match(/^string(\[([0-9]*)\])*$/);
	};
	
	SolidityTypeString.prototype.isDynamicType = function () {
	    return true;
	};
	
	module.exports = SolidityTypeString;


/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	var f = __webpack_require__(29);
	var SolidityType = __webpack_require__(50);
	
	/**
	 * SolidityTypeUInt is a protoype that represents uint type
	 * It matches:
	 * uint
	 * uint[]
	 * uint[4]
	 * uint[][]
	 * uint[3][]
	 * uint[][6][], ...
	 * uint32
	 * uint64[]
	 * uint8[4]
	 * uint256[][]
	 * uint[3][]
	 * uint64[][6][], ...
	 */
	var SolidityTypeUInt = function () {
	    this._inputFormatter = f.formatInputInt;
	    this._outputFormatter = f.formatOutputUInt;
	};
	
	SolidityTypeUInt.prototype = new SolidityType({});
	SolidityTypeUInt.prototype.constructor = SolidityTypeUInt;
	
	SolidityTypeUInt.prototype.isType = function (name) {
	    return !!name.match(/^uint([0-9]*)?(\[([0-9]*)\])*$/);
	};
	
	module.exports = SolidityTypeUInt;


/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = __webpack_require__(54)
	exports.createHash = exports.Hash = __webpack_require__(74)
	exports.createHmac = exports.Hmac = __webpack_require__(207)
	
	var algos = __webpack_require__(449)
	var algoKeys = Object.keys(algos)
	var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(algoKeys)
	exports.getHashes = function () {
	  return hashes
	}
	
	var p = __webpack_require__(142)
	exports.pbkdf2 = p.pbkdf2
	exports.pbkdf2Sync = p.pbkdf2Sync
	
	var aes = __webpack_require__(445)
	
	exports.Cipher = aes.Cipher
	exports.createCipher = aes.createCipher
	exports.Cipheriv = aes.Cipheriv
	exports.createCipheriv = aes.createCipheriv
	exports.Decipher = aes.Decipher
	exports.createDecipher = aes.createDecipher
	exports.Decipheriv = aes.Decipheriv
	exports.createDecipheriv = aes.createDecipheriv
	exports.getCiphers = aes.getCiphers
	exports.listCiphers = aes.listCiphers
	
	var dh = __webpack_require__(478)
	
	exports.DiffieHellmanGroup = dh.DiffieHellmanGroup
	exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup
	exports.getDiffieHellman = dh.getDiffieHellman
	exports.createDiffieHellman = dh.createDiffieHellman
	exports.DiffieHellman = dh.DiffieHellman
	
	var sign = __webpack_require__(450)
	
	exports.createSign = sign.createSign
	exports.Sign = sign.Sign
	exports.createVerify = sign.createVerify
	exports.Verify = sign.Verify
	
	exports.createECDH = __webpack_require__(453)
	
	var publicEncrypt = __webpack_require__(598)
	
	exports.publicEncrypt = publicEncrypt.publicEncrypt
	exports.privateEncrypt = publicEncrypt.privateEncrypt
	exports.publicDecrypt = publicEncrypt.publicDecrypt
	exports.privateDecrypt = publicEncrypt.privateDecrypt
	
	// the least I can do is make error messages for the rest of the node.js/crypto api.
	// ;[
	//   'createCredentials'
	// ].forEach(function (name) {
	//   exports[name] = function () {
	//     throw new Error([
	//       'sorry, ' + name + ' is not implemented yet',
	//       'we accept pull requests',
	//       'https://github.com/crypto-browserify/crypto-browserify'
	//     ].join('\n'))
	//   }
	// })
	
	var rf = __webpack_require__(606)
	
	exports.randomFill = rf.randomFill
	exports.randomFillSync = rf.randomFillSync
	
	exports.createCredentials = function () {
	  throw new Error([
	    'sorry, createCredentials is not implemented yet',
	    'we accept pull requests',
	    'https://github.com/crypto-browserify/crypto-browserify'
	  ].join('\n'))
	}
	
	exports.constants = {
	  'DH_CHECK_P_NOT_SAFE_PRIME': 2,
	  'DH_CHECK_P_NOT_PRIME': 1,
	  'DH_UNABLE_TO_CHECK_GENERATOR': 4,
	  'DH_NOT_SUITABLE_GENERATOR': 8,
	  'NPN_ENABLED': 1,
	  'ALPN_ENABLED': 1,
	  'RSA_PKCS1_PADDING': 1,
	  'RSA_SSLV23_PADDING': 2,
	  'RSA_NO_PADDING': 3,
	  'RSA_PKCS1_OAEP_PADDING': 4,
	  'RSA_X931_PADDING': 5,
	  'RSA_PKCS1_PSS_PADDING': 6,
	  'POINT_CONVERSION_COMPRESSED': 2,
	  'POINT_CONVERSION_UNCOMPRESSED': 4,
	  'POINT_CONVERSION_HYBRID': 6
	}


/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var Bytes = __webpack_require__(172);
	var Nat = __webpack_require__(319);
	var elliptic = __webpack_require__(13);
	var rlp = __webpack_require__(320);
	var secp256k1 = new elliptic.ec("secp256k1"); // eslint-disable-line
	
	var _require = __webpack_require__(318),
	    keccak256 = _require.keccak256,
	    keccak256s = _require.keccak256s;
	
	var create = function create(entropy) {
	  var innerHex = keccak256(Bytes.concat(Bytes.random(32), entropy || Bytes.random(32)));
	  var middleHex = Bytes.concat(Bytes.concat(Bytes.random(32), innerHex), Bytes.random(32));
	  var outerHex = keccak256(middleHex);
	  return fromPrivate(outerHex);
	};
	
	var toChecksum = function toChecksum(address) {
	  var addressHash = keccak256s(address.slice(2));
	  var checksumAddress = "0x";
	  for (var i = 0; i < 40; i++) {
	    checksumAddress += parseInt(addressHash[i + 2], 16) > 7 ? address[i + 2].toUpperCase() : address[i + 2];
	  }return checksumAddress;
	};
	
	var fromPrivate = function fromPrivate(privateKey) {
	  var buffer = new Buffer(privateKey.slice(2), "hex");
	  var ecKey = secp256k1.keyFromPrivate(buffer);
	  var publicKey = "0x" + ecKey.getPublic(false, 'hex').slice(2);
	  var publicHash = keccak256(publicKey);
	  var address = toChecksum("0x" + publicHash.slice(-40));
	  return {
	    address: address,
	    privateKey: privateKey
	  };
	};
	
	var encodeSignature = function encodeSignature(_ref) {
	  var _ref2 = _slicedToArray(_ref, 3),
	      v = _ref2[0],
	      r = Bytes.pad(32, _ref2[1]),
	      s = Bytes.pad(32, _ref2[2]);
	
	  return Bytes.flatten([r, s, v]);
	};
	
	var decodeSignature = function decodeSignature(hex) {
	  return [Bytes.slice(64, Bytes.length(hex), hex), Bytes.slice(0, 32, hex), Bytes.slice(32, 64, hex)];
	};
	
	var makeSigner = function makeSigner(addToV) {
	  return function (hash, privateKey) {
	    var signature = secp256k1.keyFromPrivate(new Buffer(privateKey.slice(2), "hex")).sign(new Buffer(hash.slice(2), "hex"), { canonical: true });
	    return encodeSignature([Nat.fromString(Bytes.fromNumber(addToV + signature.recoveryParam)), Bytes.pad(32, Bytes.fromNat("0x" + signature.r.toString(16))), Bytes.pad(32, Bytes.fromNat("0x" + signature.s.toString(16)))]);
	  };
	};
	
	var sign = makeSigner(27); // v=27|28 instead of 0|1...
	
	var recover = function recover(hash, signature) {
	  var vals = decodeSignature(signature);
	  var vrs = { v: Bytes.toNumber(vals[0]), r: vals[1].slice(2), s: vals[2].slice(2) };
	  var ecPublicKey = secp256k1.recoverPubKey(new Buffer(hash.slice(2), "hex"), vrs, vrs.v < 2 ? vrs.v : 1 - vrs.v % 2); // because odd vals mean v=0... sadly that means v=0 means v=1... I hate that
	  var publicKey = "0x" + ecPublicKey.encode("hex", false).slice(2);
	  var publicHash = keccak256(publicKey);
	  var address = toChecksum("0x" + publicHash.slice(-40));
	  return address;
	};
	
	module.exports = {
	  create: create,
	  toChecksum: toChecksum,
	  fromPrivate: fromPrivate,
	  sign: sign,
	  makeSigner: makeSigner,
	  recover: recover,
	  encodeSignature: encodeSignature,
	  decodeSignature: decodeSignature
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 762 */
504,
/* 763 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	var rng;
	
	if (global.crypto && crypto.getRandomValues) {
	  // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
	  // Moderately fast, high quality
	  var _rnds8 = new Uint8Array(16);
	  rng = function whatwgRNG() {
	    crypto.getRandomValues(_rnds8);
	    return _rnds8;
	  };
	}
	
	if (!rng) {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var  _rnds = new Array(16);
	  rng = function() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return _rnds;
	  };
	}
	
	module.exports = rng;
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	//     uuid.js
	//
	//     Copyright (c) 2010-2012 Robert Kieffer
	//     MIT License - http://opensource.org/licenses/mit-license.php
	
	// Unique ID creation requires a high quality random # generator.  We feature
	// detect to determine the best RNG source, normalizing to a function that
	// returns 128-bits of randomness, since that's what's usually required
	var _rng = __webpack_require__(763);
	
	// Maps for number <-> hex string conversion
	var _byteToHex = [];
	var _hexToByte = {};
	for (var i = 0; i < 256; i++) {
	  _byteToHex[i] = (i + 0x100).toString(16).substr(1);
	  _hexToByte[_byteToHex[i]] = i;
	}
	
	// **`parse()` - Parse a UUID into it's component bytes**
	function parse(s, buf, offset) {
	  var i = (buf && offset) || 0, ii = 0;
	
	  buf = buf || [];
	  s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
	    if (ii < 16) { // Don't overflow!
	      buf[i + ii++] = _hexToByte[oct];
	    }
	  });
	
	  // Zero out remaining bytes if string was short
	  while (ii < 16) {
	    buf[i + ii++] = 0;
	  }
	
	  return buf;
	}
	
	// **`unparse()` - Convert UUID byte array (ala parse()) into a string**
	function unparse(buf, offset) {
	  var i = offset || 0, bth = _byteToHex;
	  return  bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]];
	}
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	// random #'s we need to init node and clockseq
	var _seedBytes = _rng();
	
	// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	var _nodeId = [
	  _seedBytes[0] | 0x01,
	  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
	];
	
	// Per 4.2.2, randomize (14 bit) clockseq
	var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;
	
	// Previous uuid creation time
	var _lastMSecs = 0, _lastNSecs = 0;
	
	// See https://github.com/broofa/node-uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  var node = options.node || _nodeId;
	  for (var n = 0; n < 6; n++) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : unparse(b);
	}
	
	// **`v4()` - Generate random UUID**
	
	// See https://github.com/broofa/node-uuid for API details
	function v4(options, buf, offset) {
	  // Deprecated - 'format' argument, as supported in v1.2
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options == 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || _rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ii++) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || unparse(rnds);
	}
	
	// Export public API
	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;
	uuid.parse = parse;
	uuid.unparse = unparse;
	
	module.exports = uuid;


/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer) {/*
	 This file is part of web3.js.
	
	 web3.js is free software: you can redistribute it and/or modify
	 it under the terms of the GNU Lesser General Public License as published by
	 the Free Software Foundation, either version 3 of the License, or
	 (at your option) any later version.
	
	 web3.js is distributed in the hope that it will be useful,
	 but WITHOUT ANY WARRANTY; without even the implied warranty of
	 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	 GNU Lesser General Public License for more details.
	
	 You should have received a copy of the GNU Lesser General Public License
	 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	 */
	/**
	 * @file accounts.js
	 * @author Fabian Vogelsteller <fabian@ethereum.org>
	 * @date 2017
	 */
	
	"use strict";
	
	var _ = __webpack_require__(12);
	var core = __webpack_require__(49);
	var Method = __webpack_require__(48);
	var Promise = __webpack_require__(173);
	var Account = __webpack_require__(761);
	var Hash = __webpack_require__(318);
	var RLP = __webpack_require__(320);
	var Nat = __webpack_require__(319);
	var Bytes = __webpack_require__(172);
	var cryp = (typeof global === 'undefined') ? __webpack_require__(760) : __webpack_require__(129);
	var scryptsy = __webpack_require__(722);
	var uuid = __webpack_require__(764);
	var utils = __webpack_require__(23);
	var helpers = __webpack_require__(14);
	
	var isNot = function(value) {
	    return (_.isUndefined(value) || _.isNull(value));
	};
	
	var trimLeadingZero = function (hex) {
	    while (hex && hex.startsWith('0x0')) {
	        hex = '0x' + hex.slice(3);
	    }
	    return hex;
	};
	
	var makeEven = function (hex) {
	    if(hex.length % 2 === 1) {
	        hex = hex.replace('0x', '0x0');
	    }
	    return hex;
	};
	
	
	var Accounts = function Accounts() {
	    var _this = this;
	
	    // sets _requestmanager
	    core.packageInit(this, arguments);
	
	    // remove unecessary core functions
	    delete this.BatchRequest;
	    delete this.extend;
	
	    var _ethereumCall = [
	        new Method({
	            name: 'getId',
	            call: 'net_version',
	            params: 0,
	            outputFormatter: utils.hexToNumber
	        }),
	        new Method({
	            name: 'getGasPrice',
	            call: 'eth_gasPrice',
	            params: 0
	        }),
	        new Method({
	            name: 'getTransactionCount',
	            call: 'eth_getTransactionCount',
	            params: 2,
	            inputFormatter: [function (address) {
	                if (utils.isAddress(address)) {
	                    return address;
	                } else {
	                    throw new Error('Address '+ address +' is not a valid address to get the "transactionCount".');
	                }
	            }, function () { return 'latest'; }]
	        })
	    ];
	    // attach methods to this._ethereumCall
	    this._ethereumCall = {};
	    _.each(_ethereumCall, function (method) {
	        method.attachToObject(_this._ethereumCall);
	        method.setRequestManager(_this._requestManager);
	    });
	
	
	    this.wallet = new Wallet(this);
	};
	
	Accounts.prototype._addAccountFunctions = function (account) {
	    var _this = this;
	
	    // add sign functions
	    account.signTransaction = function signTransaction(tx, callback) {
	        return _this.signTransaction(tx, account.privateKey, callback);
	    };
	    account.sign = function sign(data) {
	        return _this.sign(data, account.privateKey);
	    };
	
	    account.encrypt = function encrypt(password, options) {
	        return _this.encrypt(account.privateKey, password, options);
	    };
	
	
	    return account;
	};
	
	Accounts.prototype.create = function create(entropy) {
	    return this._addAccountFunctions(Account.create(entropy || utils.randomHex(32)));
	};
	
	Accounts.prototype.privateKeyToAccount = function privateKeyToAccount(privateKey) {
	    return this._addAccountFunctions(Account.fromPrivate(privateKey));
	};
	
	Accounts.prototype.signTransaction = function signTransaction(tx, privateKey, callback) {
	    var _this = this,
	        error = false,
	        result;
	
	    callback = callback || function () {};
	
	    if (!tx) {
	        error = new Error('No transaction object given!');
	
	        callback(error);
	        return Promise.reject(error);
	    }
	
	    function signed (tx) {
	
	        if (!tx.gas && !tx.gasLimit) {
	            error = new Error('"gas" is missing');
	        }
	
	        if (tx.nonce  < 0 ||
	            tx.gas  < 0 ||
	            tx.gasPrice  < 0 ||
	            tx.chainId  < 0) {
	            error = new Error('Gas, gasPrice, nonce or chainId is lower than 0');
	        }
	
	        if (error) {
	            callback(error);
	            return Promise.reject(new Error('"gas" is missing'));
	        }
	
	        try {
	            tx = helpers.formatters.inputCallFormatter(tx);
	
	            var transaction = tx;
	            transaction.to = tx.to || '0x';
	            transaction.data = tx.data || '0x';
	            transaction.value = tx.value || '0x';
	            transaction.chainId = utils.numberToHex(tx.chainId);
	
	            var rlpEncoded = RLP.encode([
	                Bytes.fromNat(transaction.nonce),
	                Bytes.fromNat(transaction.gasPrice),
	                Bytes.fromNat(transaction.gas),
	                transaction.to.toLowerCase(),
	                Bytes.fromNat(transaction.value),
	                transaction.data,
	                Bytes.fromNat(transaction.chainId || "0x1"),
	                "0x",
	                "0x"]);
	
	
	            var hash = Hash.keccak256(rlpEncoded);
	
	            var signature = Account.makeSigner(Nat.toNumber(transaction.chainId || "0x1") * 2 + 35)(Hash.keccak256(rlpEncoded), privateKey);
	
	            var rawTx = RLP.decode(rlpEncoded).slice(0, 6).concat(Account.decodeSignature(signature));
	
	            rawTx[6] = makeEven(trimLeadingZero(rawTx[6]));
	            rawTx[7] = makeEven(trimLeadingZero(rawTx[7]));
	            rawTx[8] = makeEven(trimLeadingZero(rawTx[8]));
	
	            var rawTransaction = RLP.encode(rawTx);
	
	            var values = RLP.decode(rawTransaction);
	            result = {
	                messageHash: hash,
	                v: trimLeadingZero(values[6]),
	                r: trimLeadingZero(values[7]),
	                s: trimLeadingZero(values[8]),
	                rawTransaction: rawTransaction
	            };
	
	        } catch(e) {
	            callback(e);
	            return Promise.reject(e);
	        }
	
	        callback(null, result);
	        return result;
	    }
	
	    // Resolve immediately if nonce, chainId and price are provided
	    if (tx.nonce !== undefined && tx.chainId !== undefined && tx.gasPrice !== undefined) {
	        return Promise.resolve(signed(tx));
	    }
	
	
	    // Otherwise, get the missing info from the Ethereum Node
	    return Promise.all([
	        isNot(tx.chainId) ? _this._ethereumCall.getId() : tx.chainId,
	        isNot(tx.gasPrice) ? _this._ethereumCall.getGasPrice() : tx.gasPrice,
	        isNot(tx.nonce) ? _this._ethereumCall.getTransactionCount(_this.privateKeyToAccount(privateKey).address) : tx.nonce
	    ]).then(function (args) {
	        if (isNot(args[0]) || isNot(args[1]) || isNot(args[2])) {
	            throw new Error('One of the values "chainId", "gasPrice", or "nonce" couldn\'t be fetched: '+ JSON.stringify(args));
	        }
	        return signed(_.extend(tx, {chainId: args[0], gasPrice: args[1], nonce: args[2]}));
	    });
	};
	
	/* jshint ignore:start */
	Accounts.prototype.recoverTransaction = function recoverTransaction(rawTx) {
	    var values = RLP.decode(rawTx);
	    var signature = Account.encodeSignature(values.slice(6,9));
	    var recovery = Bytes.toNumber(values[6]);
	    var extraData = recovery < 35 ? [] : [Bytes.fromNumber((recovery - 35) >> 1), "0x", "0x"];
	    var signingData = values.slice(0,6).concat(extraData);
	    var signingDataHex = RLP.encode(signingData);
	    return Account.recover(Hash.keccak256(signingDataHex), signature);
	};
	/* jshint ignore:end */
	
	Accounts.prototype.hashMessage = function hashMessage(data) {
	    var message = utils.isHexStrict(data) ? utils.hexToBytes(data) : data;
	    var messageBuffer = Buffer.from(message);
	    var preamble = "\x19Ethereum Signed Message:\n" + message.length;
	    var preambleBuffer = Buffer.from(preamble);
	    var ethMessage = Buffer.concat([preambleBuffer, messageBuffer]);
	    return Hash.keccak256s(ethMessage);
	};
	
	Accounts.prototype.sign = function sign(data, privateKey) {
	    var hash = this.hashMessage(data);
	    var signature = Account.sign(hash, privateKey);
	    var vrs = Account.decodeSignature(signature);
	    return {
	        message: data,
	        messageHash: hash,
	        v: vrs[0],
	        r: vrs[1],
	        s: vrs[2],
	        signature: signature
	    };
	};
	
	Accounts.prototype.recover = function recover(message, signature, preFixed) {
	    var args = [].slice.apply(arguments);
	
	
	    if (_.isObject(message)) {
	        return this.recover(message.messageHash, Account.encodeSignature([message.v, message.r, message.s]), true);
	    }
	
	    if (!preFixed) {
	        message = this.hashMessage(message);
	    }
	
	    if (args.length >= 4) {
	        preFixed = args.slice(-1)[0];
	        preFixed = _.isBoolean(preFixed) ? !!preFixed : false;
	
	        return this.recover(message, Account.encodeSignature(args.slice(1, 4)), preFixed); // v, r, s
	    }
	    return Account.recover(message, signature);
	};
	
	// Taken from https://github.com/ethereumjs/ethereumjs-wallet
	Accounts.prototype.decrypt = function (v3Keystore, password, nonStrict) {
	    /* jshint maxcomplexity: 10 */
	
	    if(!_.isString(password)) {
	        throw new Error('No password given.');
	    }
	
	    var json = (_.isObject(v3Keystore)) ? v3Keystore : JSON.parse(nonStrict ? v3Keystore.toLowerCase() : v3Keystore);
	
	    if (json.version !== 3) {
	        throw new Error('Not a valid V3 wallet');
	    }
	
	    var derivedKey;
	    var kdfparams;
	    if (json.crypto.kdf === 'scrypt') {
	        kdfparams = json.crypto.kdfparams;
	
	        // FIXME: support progress reporting callback
	        derivedKey = scryptsy(new Buffer(password), new Buffer(kdfparams.salt, 'hex'), kdfparams.n, kdfparams.r, kdfparams.p, kdfparams.dklen);
	    } else if (json.crypto.kdf === 'pbkdf2') {
	        kdfparams = json.crypto.kdfparams;
	
	        if (kdfparams.prf !== 'hmac-sha256') {
	            throw new Error('Unsupported parameters to PBKDF2');
	        }
	
	        derivedKey = cryp.pbkdf2Sync(new Buffer(password), new Buffer(kdfparams.salt, 'hex'), kdfparams.c, kdfparams.dklen, 'sha256');
	    } else {
	        throw new Error('Unsupported key derivation scheme');
	    }
	
	    var ciphertext = new Buffer(json.crypto.ciphertext, 'hex');
	
	    var mac = utils.sha3(Buffer.concat([ derivedKey.slice(16, 32), ciphertext ])).replace('0x','');
	    if (mac !== json.crypto.mac) {
	        throw new Error('Key derivation failed - possibly wrong password');
	    }
	
	    var decipher = cryp.createDecipheriv(json.crypto.cipher, derivedKey.slice(0, 16), new Buffer(json.crypto.cipherparams.iv, 'hex'));
	    var seed = '0x'+ Buffer.concat([ decipher.update(ciphertext), decipher.final() ]).toString('hex');
	
	    return this.privateKeyToAccount(seed);
	};
	
	Accounts.prototype.encrypt = function (privateKey, password, options) {
	    /* jshint maxcomplexity: 20 */
	    var account = this.privateKeyToAccount(privateKey);
	
	    options = options || {};
	    var salt = options.salt || cryp.randomBytes(32);
	    var iv = options.iv || cryp.randomBytes(16);
	
	    var derivedKey;
	    var kdf = options.kdf || 'scrypt';
	    var kdfparams = {
	        dklen: options.dklen || 32,
	        salt: salt.toString('hex')
	    };
	
	    if (kdf === 'pbkdf2') {
	        kdfparams.c = options.c || 262144;
	        kdfparams.prf = 'hmac-sha256';
	        derivedKey = cryp.pbkdf2Sync(new Buffer(password), salt, kdfparams.c, kdfparams.dklen, 'sha256');
	    } else if (kdf === 'scrypt') {
	        // FIXME: support progress reporting callback
	        kdfparams.n = options.n || 8192; // 2048 4096 8192 16384
	        kdfparams.r = options.r || 8;
	        kdfparams.p = options.p || 1;
	        derivedKey = scryptsy(new Buffer(password), salt, kdfparams.n, kdfparams.r, kdfparams.p, kdfparams.dklen);
	    } else {
	        throw new Error('Unsupported kdf');
	    }
	
	    var cipher = cryp.createCipheriv(options.cipher || 'aes-128-ctr', derivedKey.slice(0, 16), iv);
	    if (!cipher) {
	        throw new Error('Unsupported cipher');
	    }
	
	    var ciphertext = Buffer.concat([ cipher.update(new Buffer(account.privateKey.replace('0x',''), 'hex')), cipher.final() ]);
	
	    var mac = utils.sha3(Buffer.concat([ derivedKey.slice(16, 32), new Buffer(ciphertext, 'hex') ])).replace('0x','');
	
	    return {
	        version: 3,
	        id: uuid.v4({ random: options.uuid || cryp.randomBytes(16) }),
	        address: account.address.toLowerCase().replace('0x',''),
	        crypto: {
	            ciphertext: ciphertext.toString('hex'),
	            cipherparams: {
	                iv: iv.toString('hex')
	            },
	            cipher: options.cipher || 'aes-128-ctr',
	            kdf: kdf,
	            kdfparams: kdfparams,
	            mac: mac.toString('hex')
	        }
	    };
	};
	
	
	// Note: this is trying to follow closely the specs on
	// http://web3js.readthedocs.io/en/1.0/web3-eth-accounts.html
	
	function Wallet(accounts) {
	    this._accounts = accounts;
	    this.length = 0;
	    this.defaultKeyName = "web3js_wallet";
	}
	
	Wallet.prototype._findSafeIndex = function (pointer) {
	    pointer = pointer || 0;
	    if (_.has(this, pointer)) {
	        return this._findSafeIndex(pointer + 1);
	    } else {
	        return pointer;
	    }
	};
	
	Wallet.prototype._currentIndexes = function () {
	    var keys = Object.keys(this);
	    var indexes = keys
	        .map(function(key) { return parseInt(key); })
	        .filter(function(n) { return (n < 9e20); });
	
	    return indexes;
	};
	
	Wallet.prototype.create = function (numberOfAccounts, entropy) {
	    for (var i = 0; i < numberOfAccounts; ++i) {
	        this.add(this._accounts.create(entropy).privateKey);
	    }
	    return this;
	};
	
	Wallet.prototype.add = function (account) {
	
	    if (_.isString(account)) {
	        account = this._accounts.privateKeyToAccount(account);
	    }
	    if (!this[account.address]) {
	        account = this._accounts.privateKeyToAccount(account.privateKey);
	        account.index = this._findSafeIndex();
	
	        this[account.index] = account;
	        this[account.address] = account;
	        this[account.address.toLowerCase()] = account;
	
	        this.length++;
	
	        return account;
	    } else {
	        return this[account.address];
	    }
	};
	
	Wallet.prototype.remove = function (addressOrIndex) {
	    var account = this[addressOrIndex];
	
	    if (account && account.address) {
	        // address
	        this[account.address].privateKey = null;
	        delete this[account.address];
	        // address lowercase
	        this[account.address.toLowerCase()].privateKey = null;
	        delete this[account.address.toLowerCase()];
	        // index
	        this[account.index].privateKey = null;
	        delete this[account.index];
	
	        this.length--;
	
	        return true;
	    } else {
	        return false;
	    }
	};
	
	Wallet.prototype.clear = function () {
	    var _this = this;
	    var indexes = this._currentIndexes();
	
	    indexes.forEach(function(index) {
	        _this.remove(index);
	    });
	
	    return this;
	};
	
	Wallet.prototype.encrypt = function (password, options) {
	    var _this = this;
	    var indexes = this._currentIndexes();
	
	    var accounts = indexes.map(function(index) {
	        return _this[index].encrypt(password, options);
	    });
	
	    return accounts;
	};
	
	
	Wallet.prototype.decrypt = function (encryptedWallet, password) {
	    var _this = this;
	
	    encryptedWallet.forEach(function (keystore) {
	        var account = _this._accounts.decrypt(keystore, password);
	
	        if (account) {
	            _this.add(account);
	        } else {
	            throw new Error('Couldn\'t decrypt accounts. Password wrong?');
	        }
	    });
	
	    return this;
	};
	
	Wallet.prototype.save = function (password, keyName) {
	    localStorage.setItem(keyName || this.defaultKeyName, JSON.stringify(this.encrypt(password)));
	
	    return true;
	};
	
	Wallet.prototype.load = function (password, keyName) {
	    var keystore = localStorage.getItem(keyName || this.defaultKeyName);
	
	    if (keystore) {
	        try {
	            keystore = JSON.parse(keystore);
	        } catch(e) {
	
	        }
	    }
	
	    return this.decrypt(keystore || [], password);
	};
	
	if (typeof localStorage === 'undefined') {
	    delete Wallet.prototype.save;
	    delete Wallet.prototype.load;
	}
	
	
	module.exports = Accounts;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(1).Buffer))

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	/*
	    This file is part of web3.js.
	
	    web3.js is free software: you can redistribute it and/or modify
	    it under the terms of the GNU Lesser General Public License as published by
	    the Free Software Foundation, either version 3 of the License, or
	    (at your option) any later version.
	
	    web3.js is distributed in the hope that it will be useful,
	    but WITHOUT ANY WARRANTY; without even the implied warranty of
	    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	    GNU Lesser General Public License for more details.
	
	    You should have received a copy of the GNU Lesser General Public License
	    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	*/
	/**
	 * @file contract.js
	 *
	 * To initialize a contract use:
	 *
	 *  var Contract = require('web3-eth-contract');
	 *  Contract.setProvider('ws://localhost:8546');
	 *  var contract = new Contract(abi, address, ...);
	 *
	 * @author Fabian Vogelsteller <fabian@ethereum.org>
	 * @date 2017
	 */
	
	
	"use strict";
	
	
	var _ = __webpack_require__(12);
	var core = __webpack_require__(49);
	var Method = __webpack_require__(48);
	var utils = __webpack_require__(23);
	var Subscription = __webpack_require__(109).subscription;
	var formatters = __webpack_require__(14).formatters;
	var errors = __webpack_require__(14).errors;
	var promiEvent = __webpack_require__(314);
	var abi = __webpack_require__(316);
	
	
	/**
	 * Should be called to create new contract instance
	 *
	 * @method Contract
	 * @constructor
	 * @param {Array} jsonInterface
	 * @param {String} address
	 * @param {Object} options
	 */
	var Contract = function Contract(jsonInterface, address, options) {
	    var _this = this,
	        args = Array.prototype.slice.call(arguments);
	
	    if(!(this instanceof Contract)) {
	        throw new Error('Please use the "new" keyword to instantiate a web3.eth.contract() object!');
	    }
	
	    // sets _requestmanager
	    core.packageInit(this, [this.constructor.currentProvider]);
	
	    this.clearSubscriptions = this._requestManager.clearSubscriptions;
	
	
	
	    if(!jsonInterface || !(Array.isArray(jsonInterface))) {
	        throw new Error('You must provide the json interface of the contract when instantiating a contract object.');
	    }
	
	
	
	    // create the options object
	    this.options = {};
	
	    var lastArg = args[args.length - 1];
	    if(_.isObject(lastArg) && !_.isArray(lastArg)) {
	        options = lastArg;
	
	        this.options = _.extend(this.options, this._getOrSetDefaultOptions(options));
	        if(_.isObject(address)) {
	            address = null;
	        }
	    }
	
	    // set address
	    Object.defineProperty(this.options, 'address', {
	        set: function(value){
	            if(value) {
	                _this._address = utils.toChecksumAddress(formatters.inputAddressFormatter(value));
	            }
	        },
	        get: function(){
	            return _this._address;
	        },
	        enumerable: true
	    });
	
	    // add method and event signatures, when the jsonInterface gets set
	    Object.defineProperty(this.options, 'jsonInterface', {
	        set: function(value){
	            _this.methods = {};
	            _this.events = {};
	
	            _this._jsonInterface = value.map(function(method) {
	                var func,
	                    funcName;
	
	                if (method.name) {
	                    funcName = utils._jsonInterfaceMethodToString(method);
	                }
	
	
	                // function
	                if (method.type === 'function') {
	                    method.signature = abi.encodeFunctionSignature(funcName);
	                    func = _this._createTxObject.bind({
	                        method: method,
	                        parent: _this
	                    });
	
	
	                    // add method only if not one already exists
	                    if(!_this.methods[method.name]) {
	                        _this.methods[method.name] = func;
	                    } else {
	                        var cascadeFunc = _this._createTxObject.bind({
	                            method: method,
	                            parent: _this,
	                            nextMethod: _this.methods[method.name]
	                        });
	                        _this.methods[method.name] = cascadeFunc;
	                    }
	
	                    // definitely add the method based on its signature
	                    _this.methods[method.signature] = func;
	
	                    // add method by name
	                    _this.methods[funcName] = func;
	
	
	                // event
	                } else if (method.type === 'event') {
	                    method.signature = abi.encodeEventSignature(funcName);
	                    var event = _this._on.bind(_this, method.signature);
	
	                    // add method only if not already exists
	                    if(!_this.events[method.name] || _this.events[method.name].name === 'bound ')
	                        _this.events[method.name] = event;
	
	                    // definitely add the method based on its signature
	                    _this.events[method.signature] = event;
	
	                    // add event by name
	                    _this.events[funcName] = event;
	                }
	
	
	                return method;
	            });
	
	            // add allEvents
	            _this.events.allEvents = _this._on.bind(_this, 'allevents');
	
	            return _this._jsonInterface;
	        },
	        get: function(){
	            return _this._jsonInterface;
	        },
	        enumerable: true
	    });
	
	    // get default account from the Class
	    var defaultAccount = this.constructor.defaultAccount;
	    var defaultBlock = this.constructor.defaultBlock || 'latest';
	
	    Object.defineProperty(this, 'defaultAccount', {
	        get: function () {
	            return defaultAccount;
	        },
	        set: function (val) {
	            if(val) {
	                defaultAccount = utils.toChecksumAddress(formatters.inputAddressFormatter(val));
	            }
	
	            return val;
	        },
	        enumerable: true
	    });
	    Object.defineProperty(this, 'defaultBlock', {
	        get: function () {
	            return defaultBlock;
	        },
	        set: function (val) {
	            defaultBlock = val;
	
	            return val;
	        },
	        enumerable: true
	    });
	
	    // properties
	    this.methods = {};
	    this.events = {};
	
	    this._address = null;
	    this._jsonInterface = [];
	
	    // set getter/setter properties
	    this.options.address = address;
	    this.options.jsonInterface = jsonInterface;
	
	};
	
	Contract.setProvider = function(provider, accounts) {
	    // Contract.currentProvider = provider;
	    core.packageInit(this, [provider]);
	
	    this._ethAccounts = accounts;
	};
	
	
	/**
	 * Get the callback and modiufy the array if necessary
	 *
	 * @method _getCallback
	 * @param {Array} args
	 * @return {Function} the callback
	 */
	Contract.prototype._getCallback = function getCallback(args) {
	    if (args && _.isFunction(args[args.length - 1])) {
	        return args.pop(); // modify the args array!
	    }
	};
	
	/**
	 * Checks that no listener with name "newListener" or "removeListener" is added.
	 *
	 * @method _checkListener
	 * @param {String} type
	 * @param {String} event
	 * @return {Object} the contract instance
	 */
	Contract.prototype._checkListener = function(type, event){
	    if(event === type) {
	        throw new Error('The event "'+ type +'" is a reserved event name, you can\'t use it.');
	    }
	};
	
	
	/**
	 * Use default values, if options are not available
	 *
	 * @method _getOrSetDefaultOptions
	 * @param {Object} options the options gived by the user
	 * @return {Object} the options with gaps filled by defaults
	 */
	Contract.prototype._getOrSetDefaultOptions = function getOrSetDefaultOptions(options) {
	    var gasPrice = options.gasPrice ? String(options.gasPrice): null;
	    var from = options.from ? utils.toChecksumAddress(formatters.inputAddressFormatter(options.from)) : null;
	
	    options.data = options.data || this.options.data;
	
	    options.from = from || this.options.from;
	    options.gasPrice = gasPrice || this.options.gasPrice;
	    options.gas = options.gas || options.gasLimit || this.options.gas;
	
	    // TODO replace with only gasLimit?
	    delete options.gasLimit;
	
	    return options;
	};
	
	
	/**
	 * Should be used to encode indexed params and options to one final object
	 *
	 * @method _encodeEventABI
	 * @param {Object} event
	 * @param {Object} options
	 * @return {Object} everything combined together and encoded
	 */
	Contract.prototype._encodeEventABI = function (event, options) {
	    options = options || {};
	    var filter = options.filter || {},
	        result = {};
	
	    ['fromBlock', 'toBlock'].filter(function (f) {
	        return options[f] !== undefined;
	    }).forEach(function (f) {
	        result[f] = formatters.inputBlockNumberFormatter(options[f]);
	    });
	
	    // use given topics
	    if(_.isArray(options.topics)) {
	        result.topics = options.topics;
	
	    // create topics based on filter
	    } else {
	
	        result.topics = [];
	
	        // add event signature
	        if (event && !event.anonymous && event.name !== 'ALLEVENTS') {
	            result.topics.push(event.signature);
	        }
	
	        // add event topics (indexed arguments)
	        if (event.name !== 'ALLEVENTS') {
	            var indexedTopics = event.inputs.filter(function (i) {
	                return i.indexed === true;
	            }).map(function (i) {
	                var value = filter[i.name];
	                if (!value) {
	                    return null;
	                }
	
	                // TODO: https://github.com/ethereum/web3.js/issues/344
	
	                if (_.isArray(value)) {
	                    return value.map(function (v) {
	                        return abi.encodeParameter(i.type, v);
	                    });
	                }
	                return abi.encodeParameter(i.type, value);
	            });
	
	            result.topics = result.topics.concat(indexedTopics);
	        }
	
	        if(!result.topics.length)
	            delete result.topics;
	    }
	
	    if(this.options.address) {
	        result.address = this.options.address.toLowerCase();
	    }
	
	    return result;
	};
	
	/**
	 * Should be used to decode indexed params and options
	 *
	 * @method _decodeEventABI
	 * @param {Object} data
	 * @return {Object} result object with decoded indexed && not indexed params
	 */
	Contract.prototype._decodeEventABI = function (data) {
	    var event = this;
	
	    data.data = data.data || '';
	    data.topics = data.topics || [];
	    var result = formatters.outputLogFormatter(data);
	
	    // if allEvents get the right event
	    if(event.name === 'ALLEVENTS') {
	        event = event.jsonInterface.find(function (intf) {
	            return (intf.signature === data.topics[0]);
	        }) || {anonymous: true};
	    }
	
	    // create empty inputs if none are present (e.g. anonymous events on allEvents)
	    event.inputs = event.inputs || [];
	
	
	    var argTopics = event.anonymous ? data.topics : data.topics.slice(1);
	
	    result.returnValues = abi.decodeLog(event.inputs, data.data, argTopics);
	    delete result.returnValues.__length__;
	
	    // add name
	    result.event = event.name;
	
	    // add signature
	    result.signature = (event.anonymous || !data.topics[0]) ? null : data.topics[0];
	
	    // move the data and topics to "raw"
	    result.raw = {
	        data: result.data,
	        topics: result.topics
	    };
	    delete result.data;
	    delete result.topics;
	
	
	    return result;
	};
	
	/**
	 * Encodes an ABI for a method, including signature or the method.
	 * Or when constructor encodes only the constructor parameters.
	 *
	 * @method _encodeMethodABI
	 * @param {Mixed} args the arguments to encode
	 * @param {String} the encoded ABI
	 */
	Contract.prototype._encodeMethodABI = function _encodeMethodABI() {
	    var methodSignature = this._method.signature,
	        args = this.arguments || [];
	
	    var signature = false,
	        paramsABI = this._parent.options.jsonInterface.filter(function (json) {
	            return ((methodSignature === 'constructor' && json.type === methodSignature) ||
	                ((json.signature === methodSignature || json.signature === methodSignature.replace('0x','') || json.name === methodSignature) && json.type === 'function'));
	        }).map(function (json) {
	            var inputLength = (_.isArray(json.inputs)) ? json.inputs.length : 0;
	
	            if (inputLength !== args.length) {
	                throw new Error('The number of arguments is not matching the methods required number. You need to pass '+ inputLength +' arguments.');
	            }
	
	            if (json.type === 'function') {
	                signature = json.signature;
	            }
	            return _.isArray(json.inputs) ? json.inputs.map(function (input) { return input.type; }) : [];
	        }).map(function (types) {
	            return abi.encodeParameters(types, args).replace('0x','');
	        })[0] || '';
	
	    // return constructor
	    if(methodSignature === 'constructor') {
	        if(!this._deployData)
	            throw new Error('The contract has no contract data option set. This is necessary to append the constructor parameters.');
	
	        return this._deployData + paramsABI;
	
	    // return method
	    } else {
	
	        var returnValue = (signature) ? signature + paramsABI : paramsABI;
	
	        if(!returnValue) {
	            throw new Error('Couldn\'t find a matching contract method named "'+ this._method.name +'".');
	        } else {
	            return returnValue;
	        }
	    }
	
	};
	
	
	/**
	 * Decode method return values
	 *
	 * @method _decodeMethodReturn
	 * @param {Array} outputs
	 * @param {String} returnValues
	 * @return {Object} decoded output return values
	 */
	Contract.prototype._decodeMethodReturn = function (outputs, returnValues) {
	    if (!returnValues) {
	        return null;
	    }
	
	    returnValues = returnValues.length >= 2 ? returnValues.slice(2) : returnValues;
	    var result = abi.decodeParameters(outputs, returnValues);
	
	    if (result.__length__ === 1) {
	        return result[0];
	    } else {
	        delete result.__length__;
	        return result;
	    }
	};
	
	
	/**
	 * Deploys a contract and fire events based on its state: transactionHash, receipt
	 *
	 * All event listeners will be removed, once the last possible event is fired ("error", or "receipt")
	 *
	 * @method deploy
	 * @param {Object} options
	 * @param {Function} callback
	 * @return {Object} EventEmitter possible events are "error", "transactionHash" and "receipt"
	 */
	Contract.prototype.deploy = function(options, callback){
	
	    options = options || {};
	
	    options.arguments = options.arguments || [];
	    options = this._getOrSetDefaultOptions(options);
	
	
	    // return error, if no "data" is specified
	    if(!options.data) {
	        return utils._fireError(new Error('No "data" specified in neither the given options, nor the default options.'), null, null, callback);
	    }
	
	    var constructor = _.find(this.options.jsonInterface, function (method) {
	        return (method.type === 'constructor');
	    }) || {};
	    constructor.signature = 'constructor';
	
	    return this._createTxObject.apply({
	        method: constructor,
	        parent: this,
	        deployData: options.data,
	        _ethAccounts: this.constructor._ethAccounts
	    }, options.arguments);
	
	};
	
	/**
	 * Gets the event signature and outputformatters
	 *
	 * @method _generateEventOptions
	 * @param {Object} event
	 * @param {Object} options
	 * @param {Function} callback
	 * @return {Object} the event options object
	 */
	Contract.prototype._generateEventOptions = function() {
	    var args = Array.prototype.slice.call(arguments);
	
	    // get the callback
	    var callback = this._getCallback(args);
	
	    // get the options
	    var options = (_.isObject(args[args.length - 1])) ? args.pop() : {};
	
	    var event = (_.isString(args[0])) ? args[0] : 'allevents';
	    event = (event.toLowerCase() === 'allevents') ? {
	            name: 'ALLEVENTS',
	            jsonInterface: this.options.jsonInterface
	        } : this.options.jsonInterface.find(function (json) {
	            return (json.type === 'event' && (json.name === event || json.signature === '0x'+ event.replace('0x','')));
	        });
	
	    if (!event) {
	        throw new Error('Event "' + event.name + '" doesn\'t exist in this contract.');
	    }
	
	    if (!utils.isAddress(this.options.address)) {
	        throw new Error('This contract object doesn\'t have address set yet, please set an address first.');
	    }
	
	    return {
	        params: this._encodeEventABI(event, options),
	        event: event,
	        callback: callback
	    };
	};
	
	/**
	 * Adds event listeners and creates a subscription, and remove it once its fired.
	 *
	 * @method clone
	 * @return {Object} the event subscription
	 */
	Contract.prototype.clone = function() {
	    return new this.constructor(this.options.jsonInterface, this.options.address, this.options);
	};
	
	
	/**
	 * Adds event listeners and creates a subscription, and remove it once its fired.
	 *
	 * @method once
	 * @param {String} event
	 * @param {Object} options
	 * @param {Function} callback
	 * @return {Object} the event subscription
	 */
	Contract.prototype.once = function(event, options, callback) {
	    var args = Array.prototype.slice.call(arguments);
	
	    // get the callback
	    callback = this._getCallback(args);
	
	    if (!callback) {
	        throw new Error('Once requires a callback as the second parameter.');
	    }
	
	    // don't allow fromBlock
	    if (options)
	        delete options.fromBlock;
	
	    // don't return as once shouldn't provide "on"
	    this._on(event, options, function (err, res, sub) {
	        sub.unsubscribe();
	        if(_.isFunction(callback)){
	            callback(err, res, sub);
	        }
	    });
	
	    return undefined;
	};
	
	/**
	 * Adds event listeners and creates a subscription.
	 *
	 * @method _on
	 * @param {String} event
	 * @param {Object} options
	 * @param {Function} callback
	 * @return {Object} the event subscription
	 */
	Contract.prototype._on = function(){
	    var subOptions = this._generateEventOptions.apply(this, arguments);
	
	
	    // prevent the event "newListener" and "removeListener" from being overwritten
	    this._checkListener('newListener', subOptions.event.name, subOptions.callback);
	    this._checkListener('removeListener', subOptions.event.name, subOptions.callback);
	
	    // TODO check if listener already exists? and reuse subscription if options are the same.
	
	    // create new subscription
	    var subscription = new Subscription({
	        subscription: {
	            params: 1,
	            inputFormatter: [formatters.inputLogFormatter],
	            outputFormatter: this._decodeEventABI.bind(subOptions.event),
	            // DUBLICATE, also in web3-eth
	            subscriptionHandler: function (output) {
	                if(output.removed) {
	                    this.emit('changed', output);
	                } else {
	                    this.emit('data', output);
	                }
	
	                if (_.isFunction(this.callback)) {
	                    this.callback(null, output, this);
	                }
	            }
	        },
	        type: 'eth',
	        requestManager: this._requestManager
	    });
	    subscription.subscribe('logs', subOptions.params, subOptions.callback || function () {});
	
	    return subscription;
	};
	
	/**
	 * Get past events from contracts
	 *
	 * @method getPastEvents
	 * @param {String} event
	 * @param {Object} options
	 * @param {Function} callback
	 * @return {Object} the promievent
	 */
	Contract.prototype.getPastEvents = function(){
	    var subOptions = this._generateEventOptions.apply(this, arguments);
	
	    var getPastLogs = new Method({
	        name: 'getPastLogs',
	        call: 'eth_getLogs',
	        params: 1,
	        inputFormatter: [formatters.inputLogFormatter],
	        outputFormatter: this._decodeEventABI.bind(subOptions.event)
	    });
	    getPastLogs.setRequestManager(this._requestManager);
	    var call = getPastLogs.buildCall();
	
	    getPastLogs = null;
	
	    return call(subOptions.params, subOptions.callback);
	};
	
	
	/**
	 * returns the an object with call, send, estimate functions
	 *
	 * @method _createTxObject
	 * @returns {Object} an object with functions to call the methods
	 */
	Contract.prototype._createTxObject =  function _createTxObject(){
	    var args = Array.prototype.slice.call(arguments);
	    var txObject = {};
	
	    if(this.method.type === 'function') {
	
	        txObject.call = this.parent._executeMethod.bind(txObject, 'call');
	        txObject.call.request = this.parent._executeMethod.bind(txObject, 'call', true); // to make batch requests
	
	    }
	
	    txObject.send = this.parent._executeMethod.bind(txObject, 'send');
	    txObject.send.request = this.parent._executeMethod.bind(txObject, 'send', true); // to make batch requests
	    txObject.encodeABI = this.parent._encodeMethodABI.bind(txObject);
	    txObject.estimateGas = this.parent._executeMethod.bind(txObject, 'estimate');
	
	    if (args && this.method.inputs && args.length !== this.method.inputs.length) {
	        if (this.nextMethod) {
	            return this.nextMethod.apply(null, args);
	        }
	        throw errors.InvalidNumberOfParams(args.length, this.method.inputs.length, this.method.name);
	    }
	
	    txObject.arguments = args || [];
	    txObject._method = this.method;
	    txObject._parent = this.parent;
	    txObject._ethAccounts = this.parent.constructor._ethAccounts || this._ethAccounts;
	
	    if(this.deployData) {
	        txObject._deployData = this.deployData;
	    }
	
	    return txObject;
	};
	
	
	/**
	 * Generates the options for the execute call
	 *
	 * @method _processExecuteArguments
	 * @param {Array} args
	 * @param {Promise} defer
	 */
	Contract.prototype._processExecuteArguments = function _processExecuteArguments(args, defer) {
	    var processedArgs = {};
	
	    processedArgs.type = args.shift();
	
	    // get the callback
	    processedArgs.callback = this._parent._getCallback(args);
	
	    // get block number to use for call
	    if(processedArgs.type === 'call' && args[args.length - 1] !== true && (_.isString(args[args.length - 1]) || isFinite(args[args.length - 1])))
	        processedArgs.defaultBlock = args.pop();
	
	    // get the options
	    processedArgs.options = (_.isObject(args[args.length - 1])) ? args.pop() : {};
	
	    // get the generateRequest argument for batch requests
	    processedArgs.generateRequest = (args[args.length - 1] === true)? args.pop() : false;
	
	    processedArgs.options = this._parent._getOrSetDefaultOptions(processedArgs.options);
	    processedArgs.options.data = this.encodeABI();
	
	    // add contract address
	    if(!this._deployData && !utils.isAddress(this._parent.options.address))
	        throw new Error('This contract object doesn\'t have address set yet, please set an address first.');
	
	    if(!this._deployData)
	        processedArgs.options.to = this._parent.options.address;
	
	    // return error, if no "data" is specified
	    if(!processedArgs.options.data)
	        return utils._fireError(new Error('Couldn\'t find a matching contract method, or the number of parameters is wrong.'), defer.eventEmitter, defer.reject, processedArgs.callback);
	
	    return processedArgs;
	};
	
	/**
	 * Executes a call, transact or estimateGas on a contract function
	 *
	 * @method _executeMethod
	 * @param {String} type the type this execute function should execute
	 * @param {Boolean} makeRequest if true, it simply returns the request parameters, rather than executing it
	 */
	Contract.prototype._executeMethod = function _executeMethod(){
	    var _this = this,
	        args = this._parent._processExecuteArguments.call(this, Array.prototype.slice.call(arguments), defer),
	        defer = promiEvent((args.type !== 'send')),
	        ethAccounts = _this.constructor._ethAccounts || _this._ethAccounts;
	
	    // simple return request for batch requests
	    if(args.generateRequest) {
	
	        var payload = {
	            params: [formatters.inputCallFormatter.call(this._parent, args.options)],
	            callback: args.callback
	        };
	
	        if(args.type === 'call') {
	            payload.params.push(formatters.inputDefaultBlockNumberFormatter.call(this._parent, args.defaultBlock));
	            payload.method = 'eth_call';
	            payload.format = this._parent._decodeMethodReturn.bind(null, this._method.outputs);
	        } else {
	            payload.method = 'eth_sendTransaction';
	        }
	
	        return payload;
	
	    } else {
	
	        switch (args.type) {
	            case 'estimate':
	
	                var estimateGas = (new Method({
	                    name: 'estimateGas',
	                    call: 'eth_estimateGas',
	                    params: 1,
	                    inputFormatter: [formatters.inputCallFormatter],
	                    outputFormatter: utils.hexToNumber,
	                    requestManager: _this._parent._requestManager,
	                    accounts: ethAccounts, // is eth.accounts (necessary for wallet signing)
	                    defaultAccount: _this._parent.defaultAccount,
	                    defaultBlock: _this._parent.defaultBlock
	                })).createFunction();
	
	                return estimateGas(args.options, args.callback);
	
	            case 'call':
	
	                // TODO check errors: missing "from" should give error on deploy and send, call ?
	
	                var call = (new Method({
	                    name: 'call',
	                    call: 'eth_call',
	                    params: 2,
	                    inputFormatter: [formatters.inputCallFormatter, formatters.inputDefaultBlockNumberFormatter],
	                    // add output formatter for decoding
	                    outputFormatter: function (result) {
	                        return _this._parent._decodeMethodReturn(_this._method.outputs, result);
	                    },
	                    requestManager: _this._parent._requestManager,
	                    accounts: ethAccounts, // is eth.accounts (necessary for wallet signing)
	                    defaultAccount: _this._parent.defaultAccount,
	                    defaultBlock: _this._parent.defaultBlock
	                })).createFunction();
	
	                return call(args.options, args.defaultBlock, args.callback);
	
	            case 'send':
	
	                // return error, if no "from" is specified
	                if(!utils.isAddress(args.options.from)) {
	                    return utils._fireError(new Error('No "from" address specified in neither the given options, nor the default options.'), defer.eventEmitter, defer.reject, args.callback);
	                }
	
	                if (_.isBoolean(this._method.payable) && !this._method.payable && args.options.value && args.options.value > 0) {
	                    return utils._fireError(new Error('Can not send value to non-payable contract method or constructor'), defer.eventEmitter, defer.reject, args.callback);
	                }
	
	
	                // make sure receipt logs are decoded
	                var extraFormatters = {
	                    receiptFormatter: function (receipt) {
	                        if (_.isArray(receipt.logs)) {
	
	                            // decode logs
	                            var events = _.map(receipt.logs, function(log) {
	                                return _this._parent._decodeEventABI.call({
	                                    name: 'ALLEVENTS',
	                                    jsonInterface: _this._parent.options.jsonInterface
	                                }, log);
	                            });
	
	                            // make log names keys
	                            receipt.events = {};
	                            var count = 0;
	                            events.forEach(function (ev) {
	                                if (ev.event) {
	                                    // if > 1 of the same event, don't overwrite any existing events
	                                    if (receipt.events[ev.event]) {
	                                        if (Array.isArray(receipt.events[ ev.event ])) {
	                                            receipt.events[ ev.event ].push(ev);
	                                        } else {
	                                            receipt.events[ev.event] = [receipt.events[ev.event], ev];
	                                        }
	                                    } else {
	                                        receipt.events[ ev.event ] = ev;
	                                    }
	                                } else {
	                                    receipt.events[count] = ev;
	                                    count++;
	                                }
	                            });
	
	                            delete receipt.logs;
	                        }
	                        return receipt;
	                    },
	                    contractDeployFormatter: function (receipt) {
	                        var newContract = _this._parent.clone();
	                        newContract.options.address = receipt.contractAddress;
	                        return newContract;
	                    }
	                };
	
	                var sendTransaction = (new Method({
	                    name: 'sendTransaction',
	                    call: 'eth_sendTransaction',
	                    params: 1,
	                    inputFormatter: [formatters.inputTransactionFormatter],
	                    requestManager: _this._parent._requestManager,
	                    accounts: _this.constructor._ethAccounts || _this._ethAccounts, // is eth.accounts (necessary for wallet signing)
	                    defaultAccount: _this._parent.defaultAccount,
	                    defaultBlock: _this._parent.defaultBlock,
	                    extraFormatters: extraFormatters
	                })).createFunction();
	
	                return sendTransaction(args.options, args.callback);
	
	        }
	
	    }
	
	};
	
	module.exports = Contract;


/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 This file is part of web3.js.
	
	 web3.js is free software: you can redistribute it and/or modify
	 it under the terms of the GNU Lesser General Public License as published by
	 the Free Software Foundation, either version 3 of the License, or
	 (at your option) any later version.
	
	 web3.js is distributed in the hope that it will be useful,
	 but WITHOUT ANY WARRANTY; without even the implied warranty of
	 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	 GNU Lesser General Public License for more details.
	
	 You should have received a copy of the GNU Lesser General Public License
	 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	 */
	/**
	 * @file getNetworkType.js
	 * @author Fabian Vogelsteller <fabian@ethereum.org>
	 * @date 2017
	 */
	
	"use strict";
	
	var _ = __webpack_require__(12);
	
	var getNetworkType = function (callback) {
	    var _this = this,
	        id;
	
	
	    return this.net.getId()
	        .then(function (givenId) {
	
	            id = givenId;
	
	            return _this.getBlock(0);
	        })
	        .then(function (genesis) {
	            var returnValue = 'private';
	
	            if (genesis.hash === '0xd4e56740f876aef8c010b86a40d5f56745a118d0906a34e69aec8c0db1cb8fa3' &&
	                id === 1) {
	                returnValue = 'main';
	            }
	            if (genesis.hash === '0cd786a2425d16f152c658316c423e6ce1181e15c3295826d7c9904cba9ce303' &&
	                id === 2) {
	                returnValue = 'morden';
	            }
	            if (genesis.hash === '0x41941023680923e0fe4d74a34bdac8141f2540e3ae90623718e47d66d1ca4a2d' &&
	                id === 3) {
	                returnValue = 'ropsten';
	            }
	            if (genesis.hash === '0x6341fd3daf94b748c72ced5a5b26028f2474f5f00d824504e4fa37a75767e177' &&
	                id === 4) {
	                returnValue = 'rinkeby';
	            }
	            if (genesis.hash === '0xa3c565fc15c7478862d50ccd6561e3c06b24cc509bf388941c25ea985ce32cb9' &&
	                id === 42) {
	                returnValue = 'kovan';
	            }
	
	            if (_.isFunction(callback)) {
	                callback(null, returnValue);
	            }
	
	            return returnValue;
	        })
	        .catch(function (err) {
	            if (_.isFunction(callback)) {
	                callback(err);
	            } else {
	                throw err;
	            }
	        });
	};
	
	module.exports = getNetworkType;


/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 This file is part of web3.js.
	
	 web3.js is free software: you can redistribute it and/or modify
	 it under the terms of the GNU Lesser General Public License as published by
	 the Free Software Foundation, either version 3 of the License, or
	 (at your option) any later version.
	
	 web3.js is distributed in the hope that it will be useful,
	 but WITHOUT ANY WARRANTY; without even the implied warranty of
	 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	 GNU Lesser General Public License for more details.
	
	 You should have received a copy of the GNU Lesser General Public License
	 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	 */
	/**
	 * @file index.js
	 * @author Fabian Vogelsteller <fabian@ethereum.org>
	 * @date 2017
	 */
	
	"use strict";
	
	var _ = __webpack_require__(12);
	var core = __webpack_require__(49);
	var helpers = __webpack_require__(14);
	var Subscriptions = __webpack_require__(109).subscriptions;
	var Method = __webpack_require__(48);
	var utils = __webpack_require__(23);
	var Net = __webpack_require__(110);
	
	var Personal = __webpack_require__(322);
	var BaseContract = __webpack_require__(766);
	var Iban = __webpack_require__(321);
	var Accounts = __webpack_require__(765);
	var abi = __webpack_require__(316);
	
	var getNetworkType = __webpack_require__(767);
	var formatter = helpers.formatters;
	
	
	var blockCall = function (args) {
	    return (_.isString(args[0]) && args[0].indexOf('0x') === 0) ? "eth_getBlockByHash" : "eth_getBlockByNumber";
	};
	
	var transactionFromBlockCall = function (args) {
	    return (_.isString(args[0]) && args[0].indexOf('0x') === 0) ? 'eth_getTransactionByBlockHashAndIndex' : 'eth_getTransactionByBlockNumberAndIndex';
	};
	
	var uncleCall = function (args) {
	    return (_.isString(args[0]) && args[0].indexOf('0x') === 0) ? 'eth_getUncleByBlockHashAndIndex' : 'eth_getUncleByBlockNumberAndIndex';
	};
	
	var getBlockTransactionCountCall = function (args) {
	    return (_.isString(args[0]) && args[0].indexOf('0x') === 0) ? 'eth_getBlockTransactionCountByHash' : 'eth_getBlockTransactionCountByNumber';
	};
	
	var uncleCountCall = function (args) {
	    return (_.isString(args[0]) && args[0].indexOf('0x') === 0) ? 'eth_getUncleCountByBlockHash' : 'eth_getUncleCountByBlockNumber';
	};
	
	
	var Eth = function Eth() {
	    var _this = this;
	
	    // sets _requestmanager
	    core.packageInit(this, arguments);
	
	    // overwrite setProvider
	    var setProvider = this.setProvider;
	    this.setProvider = function () {
	        setProvider.apply(_this, arguments);
	        _this.net.setProvider.apply(_this, arguments);
	        _this.personal.setProvider.apply(_this, arguments);
	        _this.accounts.setProvider.apply(_this, arguments);
	        _this.Contract.setProvider(_this.currentProvider, _this.accounts);
	    };
	
	
	    var defaultAccount = null;
	    var defaultBlock = 'latest';
	
	    Object.defineProperty(this, 'defaultAccount', {
	        get: function () {
	            return defaultAccount;
	        },
	        set: function (val) {
	            if(val) {
	                defaultAccount = utils.toChecksumAddress(formatter.inputAddressFormatter(val));
	            }
	
	            // also set on the Contract object
	            _this.Contract.defaultAccount = defaultAccount;
	            _this.personal.defaultAccount = defaultAccount;
	
	            // update defaultBlock
	            methods.forEach(function(method) {
	                method.defaultAccount = defaultAccount;
	            });
	
	            return val;
	        },
	        enumerable: true
	    });
	    Object.defineProperty(this, 'defaultBlock', {
	        get: function () {
	            return defaultBlock;
	        },
	        set: function (val) {
	            defaultBlock = val;
	            // also set on the Contract object
	            _this.Contract.defaultBlock = defaultBlock;
	            _this.personal.defaultBlock = defaultBlock;
	
	            // update defaultBlock
	            methods.forEach(function(method) {
	                method.defaultBlock = defaultBlock;
	            });
	
	            return val;
	        },
	        enumerable: true
	    });
	
	
	    this.clearSubscriptions = _this._requestManager.clearSubscriptions;
	
	    // add net
	    this.net = new Net(this.currentProvider);
	    // add chain detection
	    this.net.getNetworkType = getNetworkType.bind(this);
	
	    // add accounts
	    this.accounts = new Accounts(this.currentProvider);
	
	    // add personal
	    this.personal = new Personal(this.currentProvider);
	    this.personal.defaultAccount = this.defaultAccount;
	
	    // create a proxy Contract type for this instance, as a Contract's provider
	    // is stored as a class member rather than an instance variable. If we do
	    // not create this proxy type, changing the provider in one instance of
	    // web3-eth would subsequently change the provider for _all_ contract
	    // instances!
	    var Contract = function Contract() {
	        BaseContract.apply(this, arguments);
	    };
	
	    Contract.setProvider = function() {
	        BaseContract.setProvider.apply(this, arguments);
	    };
	
	    // make our proxy Contract inherit from web3-eth-contract so that it has all
	    // the right functionality and so that instanceof and friends work properly
	    Contract.prototype = Object.create(BaseContract.prototype);
	    Contract.prototype.constructor = Contract;
	
	    // add contract
	    this.Contract = Contract;
	    this.Contract.defaultAccount = this.defaultAccount;
	    this.Contract.defaultBlock = this.defaultBlock;
	    this.Contract.setProvider(this.currentProvider, this.accounts);
	
	    // add IBAN
	    this.Iban = Iban;
	
	    // add ABI
	    this.abi = abi;
	
	
	    var methods = [
	        new Method({
	            name: 'getNodeInfo',
	            call: 'web3_clientVersion'
	        }),
	        new Method({
	            name: 'getProtocolVersion',
	            call: 'eth_protocolVersion',
	            params: 0
	        }),
	        new Method({
	            name: 'getCoinbase',
	            call: 'eth_coinbase',
	            params: 0
	        }),
	        new Method({
	            name: 'isMining',
	            call: 'eth_mining',
	            params: 0
	        }),
	        new Method({
	            name: 'getHashrate',
	            call: 'eth_hashrate',
	            params: 0,
	            outputFormatter: utils.hexToNumber
	        }),
	        new Method({
	            name: 'isSyncing',
	            call: 'eth_syncing',
	            params: 0,
	            outputFormatter: formatter.outputSyncingFormatter
	        }),
	        new Method({
	            name: 'getGasPrice',
	            call: 'eth_gasPrice',
	            params: 0,
	            outputFormatter: formatter.outputBigNumberFormatter
	        }),
	        new Method({
	            name: 'getAccounts',
	            call: 'eth_accounts',
	            params: 0,
	            outputFormatter: utils.toChecksumAddress
	        }),
	        new Method({
	            name: 'getBlockNumber',
	            call: 'eth_blockNumber',
	            params: 0,
	            outputFormatter: utils.hexToNumber
	        }),
	        new Method({
	            name: 'getBalance',
	            call: 'eth_getBalance',
	            params: 2,
	            inputFormatter: [formatter.inputAddressFormatter, formatter.inputDefaultBlockNumberFormatter],
	            outputFormatter: formatter.outputBigNumberFormatter
	        }),
	        new Method({
	            name: 'getStorageAt',
	            call: 'eth_getStorageAt',
	            params: 3,
	            inputFormatter: [formatter.inputAddressFormatter, utils.numberToHex, formatter.inputDefaultBlockNumberFormatter]
	        }),
	        new Method({
	            name: 'getCode',
	            call: 'eth_getCode',
	            params: 2,
	            inputFormatter: [formatter.inputAddressFormatter, formatter.inputDefaultBlockNumberFormatter]
	        }),
	        new Method({
	            name: 'getBlock',
	            call: blockCall,
	            params: 2,
	            inputFormatter: [formatter.inputBlockNumberFormatter, function (val) { return !!val; }],
	            outputFormatter: formatter.outputBlockFormatter
	        }),
	        new Method({
	            name: 'getUncle',
	            call: uncleCall,
	            params: 2,
	            inputFormatter: [formatter.inputBlockNumberFormatter, utils.numberToHex],
	            outputFormatter: formatter.outputBlockFormatter,
	
	        }),
	        new Method({
	            name: 'getBlockTransactionCount',
	            call: getBlockTransactionCountCall,
	            params: 1,
	            inputFormatter: [formatter.inputBlockNumberFormatter],
	            outputFormatter: utils.hexToNumber
	        }),
	        new Method({
	            name: 'getBlockUncleCount',
	            call: uncleCountCall,
	            params: 1,
	            inputFormatter: [formatter.inputBlockNumberFormatter],
	            outputFormatter: utils.hexToNumber
	        }),
	        new Method({
	            name: 'getTransaction',
	            call: 'eth_getTransactionByHash',
	            params: 1,
	            inputFormatter: [null],
	            outputFormatter: formatter.outputTransactionFormatter
	        }),
	        new Method({
	            name: 'getTransactionFromBlock',
	            call: transactionFromBlockCall,
	            params: 2,
	            inputFormatter: [formatter.inputBlockNumberFormatter, utils.numberToHex],
	            outputFormatter: formatter.outputTransactionFormatter
	        }),
	        new Method({
	            name: 'getTransactionReceipt',
	            call: 'eth_getTransactionReceipt',
	            params: 1,
	            inputFormatter: [null],
	            outputFormatter: formatter.outputTransactionReceiptFormatter
	        }),
	        new Method({
	            name: 'getTransactionCount',
	            call: 'eth_getTransactionCount',
	            params: 2,
	            inputFormatter: [formatter.inputAddressFormatter, formatter.inputDefaultBlockNumberFormatter],
	            outputFormatter: utils.hexToNumber
	        }),
	        new Method({
	            name: 'sendSignedTransaction',
	            call: 'eth_sendRawTransaction',
	            params: 1,
	            inputFormatter: [null]
	        }),
	        new Method({
	            name: 'signTransaction',
	            call: 'eth_signTransaction',
	            params: 1,
	            inputFormatter: [formatter.inputTransactionFormatter]
	        }),
	        new Method({
	            name: 'sendTransaction',
	            call: 'eth_sendTransaction',
	            params: 1,
	            inputFormatter: [formatter.inputTransactionFormatter]
	        }),
	        new Method({
	            name: 'sign',
	            call: 'eth_sign',
	            params: 2,
	            inputFormatter: [formatter.inputSignFormatter, formatter.inputAddressFormatter],
	            transformPayload: function (payload) {
	                payload.params.reverse();
	                return payload;
	            }
	        }),
	        new Method({
	            name: 'call',
	            call: 'eth_call',
	            params: 2,
	            inputFormatter: [formatter.inputCallFormatter, formatter.inputDefaultBlockNumberFormatter]
	        }),
	        new Method({
	            name: 'estimateGas',
	            call: 'eth_estimateGas',
	            params: 1,
	            inputFormatter: [formatter.inputCallFormatter],
	            outputFormatter: utils.hexToNumber
	        }),
	        new Method({
	            name: 'getCompilers',
	            call: 'eth_getCompilers',
	            params: 0
	        }),
	        new Method({
	            name: 'compile.solidity',
	            call: 'eth_compileSolidity',
	            params: 1
	        }),
	        new Method({
	            name: 'compile.lll',
	            call: 'eth_compileLLL',
	            params: 1
	        }),
	        new Method({
	            name: 'compile.serpent',
	            call: 'eth_compileSerpent',
	            params: 1
	        }),
	        new Method({
	            name: 'submitWork',
	            call: 'eth_submitWork',
	            params: 3
	        }),
	        new Method({
	            name: 'getWork',
	            call: 'eth_getWork',
	            params: 0
	        }),
	        new Method({
	            name: 'getPastLogs',
	            call: 'eth_getLogs',
	            params: 1,
	            inputFormatter: [formatter.inputLogFormatter],
	            outputFormatter: formatter.outputLogFormatter
	        }),
	
	        // subscriptions
	        new Subscriptions({
	            name: 'subscribe',
	            type: 'eth',
	            subscriptions: {
	                'newBlockHeaders': {
	                    // TODO rename on RPC side?
	                    subscriptionName: 'newHeads', // replace subscription with this name
	                    params: 0,
	                    outputFormatter: formatter.outputBlockFormatter
	                },
	                'pendingTransactions': {
	                    subscriptionName: 'newPendingTransactions', // replace subscription with this name
	                    params: 0
	                },
	                'logs': {
	                    params: 1,
	                    inputFormatter: [formatter.inputLogFormatter],
	                    outputFormatter: formatter.outputLogFormatter,
	                    // DUBLICATE, also in web3-eth-contract
	                    subscriptionHandler: function (output) {
	                        if(output.removed) {
	                            this.emit('changed', output);
	                        } else {
	                            this.emit('data', output);
	                        }
	
	                        if (_.isFunction(this.callback)) {
	                            this.callback(null, output, this);
	                        }
	                    }
	                },
	                'syncing': {
	                    params: 0,
	                    outputFormatter: formatter.outputSyncingFormatter,
	                    subscriptionHandler: function (output) {
	                        var _this = this;
	
	                        // fire TRUE at start
	                        if(this._isSyncing !== true) {
	                            this._isSyncing = true;
	                            this.emit('changed', _this._isSyncing);
	
	                            if (_.isFunction(this.callback)) {
	                                this.callback(null, _this._isSyncing, this);
	                            }
	
	                            setTimeout(function () {
	                                _this.emit('data', output);
	
	                                if (_.isFunction(_this.callback)) {
	                                    _this.callback(null, output, _this);
	                                }
	                            }, 0);
	
	                            // fire sync status
	                        } else {
	                            this.emit('data', output);
	                            if (_.isFunction(_this.callback)) {
	                                this.callback(null, output, this);
	                            }
	
	                            // wait for some time before fireing the FALSE
	                            clearTimeout(this._isSyncingTimeout);
	                            this._isSyncingTimeout = setTimeout(function () {
	                                if(output.currentBlock > output.highestBlock - 200) {
	                                    _this._isSyncing = false;
	                                    _this.emit('changed', _this._isSyncing);
	
	                                    if (_.isFunction(_this.callback)) {
	                                        _this.callback(null, _this._isSyncing, _this);
	                                    }
	                                }
	                            }, 500);
	                        }
	                    }
	                }
	            }
	        })
	    ];
	
	    methods.forEach(function(method) {
	        method.attachToObject(_this);
	        method.setRequestManager(_this._requestManager, _this.accounts); // second param means is eth.accounts (necessary for wallet signing)
	        method.defaultBlock = _this.defaultBlock;
	        method.defaultAccount = _this.defaultAccount;
	    });
	
	};
	
	core.addProviders(Eth);
	
	
	module.exports = Eth;
	


/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	/*
	    This file is part of web3.js.
	
	    web3.js is free software: you can redistribute it and/or modify
	    it under the terms of the GNU Lesser General Public License as published by
	    the Free Software Foundation, either version 3 of the License, or
	    (at your option) any later version.
	
	    web3.js is distributed in the hope that it will be useful,
	    but WITHOUT ANY WARRANTY; without even the implied warranty of
	    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	    GNU Lesser General Public License for more details.
	
	    You should have received a copy of the GNU Lesser General Public License
	    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	*/
	/** @file httpprovider.js
	 * @authors:
	 *   Marek Kotewicz <marek@parity.io>
	 *   Marian Oancea
	 *   Fabian Vogelsteller <fabian@ethereum.org>
	 * @date 2015
	 */
	
	var errors = __webpack_require__(14).errors;
	var XHR2 = __webpack_require__(786); // jshint ignore: line
	
	/**
	 * HttpProvider should be used to send rpc calls over http
	 */
	var HttpProvider = function HttpProvider(host, timeout, headers) {
	    this.host = host || 'http://localhost:8545';
	    this.timeout = timeout || 0;
	    this.connected = false;
	    this.headers = headers;
	};
	
	HttpProvider.prototype._prepareRequest = function(){
	    var request = new XHR2();
	
	    request.open('POST', this.host, true);
	    request.setRequestHeader('Content-Type','application/json');
	
	    if(this.headers) {
	        this.headers.forEach(function(header) {
	            request.setRequestHeader(header.name, header.value);
	        });
	    }
	
	    return request;
	};
	
	/**
	 * Should be used to make async request
	 *
	 * @method send
	 * @param {Object} payload
	 * @param {Function} callback triggered on end with (err, result)
	 */
	HttpProvider.prototype.send = function (payload, callback) {
	    var _this = this;
	    var request = this._prepareRequest();
	
	
	    request.onreadystatechange = function() {
	        if (request.readyState === 4 && request.timeout !== 1) {
	            var result = request.responseText;
	            var error = null;
	
	            try {
	                result = JSON.parse(result);
	            } catch(e) {
	                error = errors.InvalidResponse(request.responseText);
	            }
	
	            _this.connected = true;
	            callback(error, result);
	        }
	    };
	
	    request.ontimeout = function() {
	        _this.connected = false;
	        callback(errors.ConnectionTimeout(this.timeout));
	    };
	
	    try {
	        request.send(JSON.stringify(payload));
	    } catch(error) {
	        this.connected = false;
	        callback(errors.InvalidConnection(this.host));
	    }
	};
	
	
	module.exports = HttpProvider;


/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	/*
	    This file is part of web3.js.
	
	    web3.js is free software: you can redistribute it and/or modify
	    it under the terms of the GNU Lesser General Public License as published by
	    the Free Software Foundation, either version 3 of the License, or
	    (at your option) any later version.
	
	    web3.js is distributed in the hope that it will be useful,
	    but WITHOUT ANY WARRANTY; without even the implied warranty of
	    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	    GNU Lesser General Public License for more details.
	
	    You should have received a copy of the GNU Lesser General Public License
	    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	*/
	/** @file index.js
	 * @authors:
	 *   Fabian Vogelsteller <fabian@ethereum.org>
	 * @date 2017
	 */
	
	"use strict";
	
	var _ = __webpack_require__(12);
	var errors = __webpack_require__(14).errors;
	var oboe = __webpack_require__(584);
	
	
	var IpcProvider = function IpcProvider(path, net) {
	    var _this = this;
	    this.responseCallbacks = {};
	    this.notificationCallbacks = [];
	    this.path = path;
	
	    this.connection = net.connect({path: this.path});
	
	    this.addDefaultEvents();
	
	    // LISTEN FOR CONNECTION RESPONSES
	    var callback = function(result) {
	        /*jshint maxcomplexity: 6 */
	
	        var id = null;
	
	        // get the id which matches the returned id
	        if(_.isArray(result)) {
	            result.forEach(function(load){
	                if(_this.responseCallbacks[load.id])
	                    id = load.id;
	            });
	        } else {
	            id = result.id;
	        }
	
	        // notification
	        if(!id && result.method.indexOf('_subscription') !== -1) {
	            _this.notificationCallbacks.forEach(function(callback){
	                if(_.isFunction(callback))
	                    callback(result);
	            });
	
	            // fire the callback
	        } else if(_this.responseCallbacks[id]) {
	            _this.responseCallbacks[id](null, result);
	            delete _this.responseCallbacks[id];
	        }
	    };
	
	    // use oboe.js for Sockets
	    if (net.constructor.name === 'Socket') {
	        oboe(this.connection)
	        .done(callback);
	    } else {
	        this.connection.on('data', function(data){
	            _this._parseResponse(data.toString()).forEach(callback);
	        });
	    }
	};
	
	/**
	Will add the error and end event to timeout existing calls
	
	@method addDefaultEvents
	*/
	IpcProvider.prototype.addDefaultEvents = function(){
	    var _this = this;
	
	    this.connection.on('connect', function(){
	    });
	
	    this.connection.on('error', function(){
	        _this._timeout();
	    });
	
	    this.connection.on('end', function(){
	        _this._timeout();
	    });
	
	    this.connection.on('timeout', function(){
	        _this._timeout();
	    });
	};
	
	
	/**
	 Will parse the response and make an array out of it.
	
	 NOTE, this exists for backwards compatibility reasons.
	
	 @method _parseResponse
	 @param {String} data
	 */
	IpcProvider.prototype._parseResponse = function(data) {
	    var _this = this,
	        returnValues = [];
	
	    // DE-CHUNKER
	    var dechunkedData = data
	        .replace(/\}[\n\r]?\{/g,'}|--|{') // }{
	        .replace(/\}\][\n\r]?\[\{/g,'}]|--|[{') // }][{
	        .replace(/\}[\n\r]?\[\{/g,'}|--|[{') // }[{
	        .replace(/\}\][\n\r]?\{/g,'}]|--|{') // }]{
	        .split('|--|');
	
	    dechunkedData.forEach(function(data){
	
	        // prepend the last chunk
	        if(_this.lastChunk)
	            data = _this.lastChunk + data;
	
	        var result = null;
	
	        try {
	            result = JSON.parse(data);
	
	        } catch(e) {
	
	            _this.lastChunk = data;
	
	            // start timeout to cancel all requests
	            clearTimeout(_this.lastChunkTimeout);
	            _this.lastChunkTimeout = setTimeout(function(){
	                _this._timeout();
	                throw errors.InvalidResponse(data);
	            }, 1000 * 15);
	
	            return;
	        }
	
	        // cancel timeout and set chunk to null
	        clearTimeout(_this.lastChunkTimeout);
	        _this.lastChunk = null;
	
	        if(result)
	            returnValues.push(result);
	    });
	
	    return returnValues;
	};
	
	
	/**
	Get the adds a callback to the responseCallbacks object,
	which will be called if a response matching the response Id will arrive.
	
	@method _addResponseCallback
	*/
	IpcProvider.prototype._addResponseCallback = function(payload, callback) {
	    var id = payload.id || payload[0].id;
	    var method = payload.method || payload[0].method;
	
	    this.responseCallbacks[id] = callback;
	    this.responseCallbacks[id].method = method;
	};
	
	/**
	Timeout all requests when the end/error event is fired
	
	@method _timeout
	*/
	IpcProvider.prototype._timeout = function() {
	    for(var key in this.responseCallbacks) {
	        if(this.responseCallbacks.hasOwnProperty(key)){
	            this.responseCallbacks[key](errors.InvalidConnection('on IPC'));
	            delete this.responseCallbacks[key];
	        }
	    }
	};
	
	/**
	 Try to reconnect
	
	 @method reconnect
	 */
	IpcProvider.prototype.reconnect = function() {
	    this.connection.connect({path: this.path});
	};
	
	
	IpcProvider.prototype.send = function (payload, callback) {
	    // try reconnect, when connection is gone
	    if(!this.connection.writable)
	        this.connection.connect({path: this.path});
	
	
	    this.connection.write(JSON.stringify(payload));
	    this._addResponseCallback(payload, callback);
	};
	
	/**
	Subscribes to provider events.provider
	
	@method on
	@param {String} type    'notification', 'connect', 'error', 'end' or 'data'
	@param {Function} callback   the callback to call
	*/
	IpcProvider.prototype.on = function (type, callback) {
	
	    if(typeof callback !== 'function')
	        throw new Error('The second parameter callback must be a function.');
	
	    switch(type){
	        case 'data':
	            this.notificationCallbacks.push(callback);
	            break;
	
	        // adds error, end, timeout, connect
	        default:
	            this.connection.on(type, callback);
	            break;
	    }
	};
	
	/**
	 Subscribes to provider events.provider
	
	 @method on
	 @param {String} type    'connect', 'error', 'end' or 'data'
	 @param {Function} callback   the callback to call
	 */
	IpcProvider.prototype.once = function (type, callback) {
	
	    if(typeof callback !== 'function')
	        throw new Error('The second parameter callback must be a function.');
	
	    this.connection.once(type, callback);
	};
	
	/**
	Removes event listener
	
	@method removeListener
	@param {String} type    'data', 'connect', 'error', 'end' or 'data'
	@param {Function} callback   the callback to call
	*/
	IpcProvider.prototype.removeListener = function (type, callback) {
	    var _this = this;
	
	    switch(type){
	        case 'data':
	            this.notificationCallbacks.forEach(function(cb, index){
	                if(cb === callback)
	                    _this.notificationCallbacks.splice(index, 1);
	            });
	            break;
	
	        default:
	            this.connection.removeListener(type, callback);
	            break;
	    }
	};
	
	/**
	Removes all event listeners
	
	@method removeAllListeners
	@param {String} type    'data', 'connect', 'error', 'end' or 'data'
	*/
	IpcProvider.prototype.removeAllListeners = function (type) {
	    switch(type){
	        case 'data':
	            this.notificationCallbacks = [];
	            break;
	
	        default:
	            this.connection.removeAllListeners(type);
	            break;
	    }
	};
	
	/**
	Resets the providers, clears all callbacks
	
	@method reset
	*/
	IpcProvider.prototype.reset = function () {
	    this._timeout();
	    this.notificationCallbacks = [];
	
	    this.connection.removeAllListeners('error');
	    this.connection.removeAllListeners('end');
	    this.connection.removeAllListeners('timeout');
	
	    this.addDefaultEvents();
	};
	
	module.exports = IpcProvider;
	


/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*
	 This file is part of web3.js.
	
	 web3.js is free software: you can redistribute it and/or modify
	 it under the terms of the GNU Lesser General Public License as published by
	 the Free Software Foundation, either version 3 of the License, or
	 (at your option) any later version.
	
	 web3.js is distributed in the hope that it will be useful,
	 but WITHOUT ANY WARRANTY; without even the implied warranty of
	 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	 GNU Lesser General Public License for more details.
	
	 You should have received a copy of the GNU Lesser General Public License
	 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	 */
	/** @file WebsocketProvider.js
	 * @authors:
	 *   Fabian Vogelsteller <fabian@ethereum.org>
	 * @date 2017
	 */
	
	"use strict";
	
	var _ = __webpack_require__(12);
	var errors = __webpack_require__(14).errors;
	
	var Ws = null;
	var _btoa = null;
	var parseURL = null;
	if (typeof window !== 'undefined') {
	    Ws = window.WebSocket;
	    _btoa = btoa;
	    parseURL = function(url) {
	        return new URL(url);
	    };
	} else {
	    Ws = __webpack_require__(776).w3cwebsocket;
	    _btoa = function(str) {
	      return Buffer(str).toString('base64');
	    };
	    // Web3 supports Node.js 5, so we need to use the legacy URL API
	    parseURL = __webpack_require__(737).parse;
	}
	// Default connection ws://localhost:8546
	
	
	
	
	var WebsocketProvider = function WebsocketProvider(url, options)  {
	    var _this = this;
	    this.responseCallbacks = {};
	    this.notificationCallbacks = [];
	
	    options = options || {};
	    this._customTimeout = options.timeout;
	
	    // The w3cwebsocket implementation does not support Basic Auth
	    // username/password in the URL. So generate the basic auth header, and
	    // pass through with any additional headers supplied in constructor
	    var parsedURL = parseURL(url);
	    var headers = options.headers || {};
	    if (parsedURL.username && parsedURL.password) {
	        headers.authorization = 'Basic ' + _btoa(parsedURL.username + ':' + parsedURL.password);
	    }
	
	    this.connection = new Ws(url, undefined, undefined, headers);
	
	    this.addDefaultEvents();
	
	
	    // LISTEN FOR CONNECTION RESPONSES
	    this.connection.onmessage = function(e) {
	        /*jshint maxcomplexity: 6 */
	        var data = (typeof e.data === 'string') ? e.data : '';
	
	        _this._parseResponse(data).forEach(function(result){
	
	            var id = null;
	
	            // get the id which matches the returned id
	            if(_.isArray(result)) {
	                result.forEach(function(load){
	                    if(_this.responseCallbacks[load.id])
	                        id = load.id;
	                });
	            } else {
	                id = result.id;
	            }
	
	            // notification
	            if(!id && result.method.indexOf('_subscription') !== -1) {
	                _this.notificationCallbacks.forEach(function(callback){
	                    if(_.isFunction(callback))
	                        callback(result);
	                });
	
	                // fire the callback
	            } else if(_this.responseCallbacks[id]) {
	                _this.responseCallbacks[id](null, result);
	                delete _this.responseCallbacks[id];
	            }
	        });
	    };
	};
	
	/**
	 Will add the error and end event to timeout existing calls
	
	 @method addDefaultEvents
	 */
	WebsocketProvider.prototype.addDefaultEvents = function(){
	    var _this = this;
	
	    this.connection.onerror = function(){
	        _this._timeout();
	    };
	
	    this.connection.onclose = function(){
	        _this._timeout();
	
	        // reset all requests and callbacks
	        _this.reset();
	    };
	
	    // this.connection.on('timeout', function(){
	    //     _this._timeout();
	    // });
	};
	
	/**
	 Will parse the response and make an array out of it.
	
	 @method _parseResponse
	 @param {String} data
	 */
	WebsocketProvider.prototype._parseResponse = function(data) {
	    var _this = this,
	        returnValues = [];
	
	    // DE-CHUNKER
	    var dechunkedData = data
	        .replace(/\}[\n\r]?\{/g,'}|--|{') // }{
	        .replace(/\}\][\n\r]?\[\{/g,'}]|--|[{') // }][{
	        .replace(/\}[\n\r]?\[\{/g,'}|--|[{') // }[{
	        .replace(/\}\][\n\r]?\{/g,'}]|--|{') // }]{
	        .split('|--|');
	
	    dechunkedData.forEach(function(data){
	
	        // prepend the last chunk
	        if(_this.lastChunk)
	            data = _this.lastChunk + data;
	
	        var result = null;
	
	        try {
	            result = JSON.parse(data);
	
	        } catch(e) {
	
	            _this.lastChunk = data;
	
	            // start timeout to cancel all requests
	            clearTimeout(_this.lastChunkTimeout);
	            _this.lastChunkTimeout = setTimeout(function(){
	                _this._timeout();
	                throw errors.InvalidResponse(data);
	            }, 1000 * 15);
	
	            return;
	        }
	
	        // cancel timeout and set chunk to null
	        clearTimeout(_this.lastChunkTimeout);
	        _this.lastChunk = null;
	
	        if(result)
	            returnValues.push(result);
	    });
	
	    return returnValues;
	};
	
	
	/**
	 Adds a callback to the responseCallbacks object,
	 which will be called if a response matching the response Id will arrive.
	
	 @method _addResponseCallback
	 */
	WebsocketProvider.prototype._addResponseCallback = function(payload, callback) {
	    var id = payload.id || payload[0].id;
	    var method = payload.method || payload[0].method;
	
	    this.responseCallbacks[id] = callback;
	    this.responseCallbacks[id].method = method;
	
	    var _this = this;
	
	    // schedule triggering the error response if a custom timeout is set
	    if (this._customTimeout) {
	        setTimeout(function () {
	            if (_this.responseCallbacks[id]) {
	                _this.responseCallbacks[id](errors.ConnectionTimeout(_this._customTimeout));
	                delete _this.responseCallbacks[id];
	            }
	        }, this._customTimeout);
	    }
	};
	
	/**
	 Timeout all requests when the end/error event is fired
	
	 @method _timeout
	 */
	WebsocketProvider.prototype._timeout = function() {
	    for(var key in this.responseCallbacks) {
	        if(this.responseCallbacks.hasOwnProperty(key)){
	            this.responseCallbacks[key](errors.InvalidConnection('on WS'));
	            delete this.responseCallbacks[key];
	        }
	    }
	};
	
	
	WebsocketProvider.prototype.send = function (payload, callback) {
	    var _this = this;
	
	    if (this.connection.readyState === this.connection.CONNECTING) {
	        setTimeout(function () {
	            _this.send(payload, callback);
	        }, 10);
	        return;
	    }
	
	    // try reconnect, when connection is gone
	    // if(!this.connection.writable)
	    //     this.connection.connect({url: this.url});
	    if (this.connection.readyState !== this.connection.OPEN) {
	        console.error('connection not open on send()');
	        if (typeof this.connection.onerror === 'function') {
	            this.connection.onerror(new Error('connection not open'));
	        } else {
	            console.error('no error callback');
	        }
	        callback(new Error('connection not open'));
	        return;
	    }
	
	    this.connection.send(JSON.stringify(payload));
	    this._addResponseCallback(payload, callback);
	};
	
	/**
	 Subscribes to provider events.provider
	
	 @method on
	 @param {String} type    'notifcation', 'connect', 'error', 'end' or 'data'
	 @param {Function} callback   the callback to call
	 */
	WebsocketProvider.prototype.on = function (type, callback) {
	
	    if(typeof callback !== 'function')
	        throw new Error('The second parameter callback must be a function.');
	
	    switch(type){
	        case 'data':
	            this.notificationCallbacks.push(callback);
	            break;
	
	        case 'connect':
	            this.connection.onopen = callback;
	            break;
	
	        case 'end':
	            this.connection.onclose = callback;
	            break;
	
	        case 'error':
	            this.connection.onerror = callback;
	            break;
	
	        // default:
	        //     this.connection.on(type, callback);
	        //     break;
	    }
	};
	
	// TODO add once
	
	/**
	 Removes event listener
	
	 @method removeListener
	 @param {String} type    'notifcation', 'connect', 'error', 'end' or 'data'
	 @param {Function} callback   the callback to call
	 */
	WebsocketProvider.prototype.removeListener = function (type, callback) {
	    var _this = this;
	
	    switch(type){
	        case 'data':
	            this.notificationCallbacks.forEach(function(cb, index){
	                if(cb === callback)
	                    _this.notificationCallbacks.splice(index, 1);
	            });
	            break;
	
	        // TODO remvoving connect missing
	
	        // default:
	        //     this.connection.removeListener(type, callback);
	        //     break;
	    }
	};
	
	/**
	 Removes all event listeners
	
	 @method removeAllListeners
	 @param {String} type    'notifcation', 'connect', 'error', 'end' or 'data'
	 */
	WebsocketProvider.prototype.removeAllListeners = function (type) {
	    switch(type){
	        case 'data':
	            this.notificationCallbacks = [];
	            break;
	
	        // TODO remvoving connect properly missing
	
	        case 'connect':
	            this.connection.onopen = null;
	            break;
	
	        case 'end':
	            this.connection.onclose = null;
	            break;
	
	        case 'error':
	            this.connection.onerror = null;
	            break;
	
	        default:
	            // this.connection.removeAllListeners(type);
	            break;
	    }
	};
	
	/**
	 Resets the providers, clears all callbacks
	
	 @method reset
	 */
	WebsocketProvider.prototype.reset = function () {
	    this._timeout();
	    this.notificationCallbacks = [];
	
	    // this.connection.removeAllListeners('error');
	    // this.connection.removeAllListeners('end');
	    // this.connection.removeAllListeners('timeout');
	
	    this.addDefaultEvents();
	};
	
	module.exports = WebsocketProvider;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	/*
	    This file is part of web3.js.
	
	    web3.js is free software: you can redistribute it and/or modify
	    it under the terms of the GNU Lesser General Public License as published by
	    the Free Software Foundation, either version 3 of the License, or
	    (at your option) any later version.
	
	    web3.js is distributed in the hope that it will be useful,
	    but WITHOUT ANY WARRANTY; without even the implied warranty of
	    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	    GNU Lesser General Public License for more details.
	
	    You should have received a copy of the GNU Lesser General Public License
	    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	*/
	/**
	 * @file index.js
	 * @author Fabian Vogelsteller <fabian@ethereum.org>
	 * @date 2017
	 */
	
	"use strict";
	
	var core = __webpack_require__(49);
	var Subscriptions = __webpack_require__(109).subscriptions;
	var Method = __webpack_require__(48);
	// var formatters = require('web3-core-helpers').formatters;
	var Net = __webpack_require__(110);
	
	
	var Shh = function Shh() {
	    var _this = this;
	
	    // sets _requestmanager
	    core.packageInit(this, arguments);
	
	    // overwrite setProvider
	    var setProvider = this.setProvider;
	    this.setProvider = function () {
	        setProvider.apply(_this, arguments);
	        _this.net.setProvider.apply(_this, arguments);
	    };
	
	    this.clearSubscriptions = _this._requestManager.clearSubscriptions;
	
	    this.net = new Net(this.currentProvider);
	
	
	    [
	        new Subscriptions({
	            name: 'subscribe',
	            type: 'shh',
	            subscriptions: {
	                'messages': {
	                    params: 1
	                    // inputFormatter: [formatters.inputPostFormatter],
	                    // outputFormatter: formatters.outputPostFormatter
	                }
	            }
	        }),
	
	        new Method({
	            name: 'getVersion',
	            call: 'shh_version',
	            params: 0
	        }),
	        new Method({
	            name: 'getInfo',
	            call: 'shh_info',
	            params: 0
	        }),
	        new Method({
	            name: 'setMaxMessageSize',
	            call: 'shh_setMaxMessageSize',
	            params: 1
	        }),
	        new Method({
	            name: 'setMinPoW',
	            call: 'shh_setMinPoW',
	            params: 1
	        }),
	        new Method({
	            name: 'markTrustedPeer',
	            call: 'shh_markTrustedPeer',
	            params: 1
	        }),
	        new Method({
	            name: 'newKeyPair',
	            call: 'shh_newKeyPair',
	            params: 0
	        }),
	        new Method({
	            name: 'addPrivateKey',
	            call: 'shh_addPrivateKey',
	            params: 1
	        }),
	        new Method({
	            name: 'deleteKeyPair',
	            call: 'shh_deleteKeyPair',
	            params: 1
	        }),
	        new Method({
	            name: 'hasKeyPair',
	            call: 'shh_hasKeyPair',
	            params: 1
	        }),
	        new Method({
	            name: 'getPublicKey',
	            call: 'shh_getPublicKey',
	            params: 1
	        }),
	        new Method({
	            name: 'getPrivateKey',
	            call: 'shh_getPrivateKey',
	            params: 1
	        }),
	        new Method({
	            name: 'newSymKey',
	            call: 'shh_newSymKey',
	            params: 0
	        }),
	        new Method({
	            name: 'addSymKey',
	            call: 'shh_addSymKey',
	            params: 1
	        }),
	        new Method({
	            name: 'generateSymKeyFromPassword',
	            call: 'shh_generateSymKeyFromPassword',
	            params: 1
	        }),
	        new Method({
	            name: 'hasSymKey',
	            call: 'shh_hasSymKey',
	            params: 1
	        }),
	        new Method({
	            name: 'getSymKey',
	            call: 'shh_getSymKey',
	            params: 1
	        }),
	        new Method({
	            name: 'deleteSymKey',
	            call: 'shh_deleteSymKey',
	            params: 1
	        }),
	
	        new Method({
	            name: 'newMessageFilter',
	            call: 'shh_newMessageFilter',
	            params: 1
	        }),
	        new Method({
	            name: 'getFilterMessages',
	            call: 'shh_getFilterMessages',
	            params: 1
	        }),
	        new Method({
	            name: 'deleteMessageFilter',
	            call: 'shh_deleteMessageFilter',
	            params: 1
	        }),
	
	        new Method({
	            name: 'post',
	            call: 'shh_post',
	            params: 1,
	            inputFormatter: [null]
	        })
	    ].forEach(function(method) {
	        method.attachToObject(_this);
	        method.setRequestManager(_this._requestManager);
	    });
	};
	
	core.addProviders(Shh);
	
	
	
	module.exports = Shh;
	
	


/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/utf8js v2.0.0 by @mathias */
	;(function(root) {
	
		// Detect free variables `exports`
		var freeExports = typeof exports == 'object' && exports;
	
		// Detect free variable `module`
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
	
		// Detect free variable `global`, from Node.js or Browserified code,
		// and use it as `root`
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/*--------------------------------------------------------------------------*/
	
		var stringFromCharCode = String.fromCharCode;
	
		// Taken from https://mths.be/punycode
		function ucs2decode(string) {
			var output = [];
			var counter = 0;
			var length = string.length;
			var value;
			var extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		// Taken from https://mths.be/punycode
		function ucs2encode(array) {
			var length = array.length;
			var index = -1;
			var value;
			var output = '';
			while (++index < length) {
				value = array[index];
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
			}
			return output;
		}
	
		function checkScalarValue(codePoint) {
			if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
				throw Error(
					'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
					' is not a scalar value'
				);
			}
		}
		/*--------------------------------------------------------------------------*/
	
		function createByte(codePoint, shift) {
			return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
		}
	
		function encodeCodePoint(codePoint) {
			if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
				return stringFromCharCode(codePoint);
			}
			var symbol = '';
			if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
				symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
			}
			else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
				checkScalarValue(codePoint);
				symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
				symbol += createByte(codePoint, 6);
			}
			else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
				symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
				symbol += createByte(codePoint, 12);
				symbol += createByte(codePoint, 6);
			}
			symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
			return symbol;
		}
	
		function utf8encode(string) {
			var codePoints = ucs2decode(string);
			var length = codePoints.length;
			var index = -1;
			var codePoint;
			var byteString = '';
			while (++index < length) {
				codePoint = codePoints[index];
				byteString += encodeCodePoint(codePoint);
			}
			return byteString;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function readContinuationByte() {
			if (byteIndex >= byteCount) {
				throw Error('Invalid byte index');
			}
	
			var continuationByte = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			if ((continuationByte & 0xC0) == 0x80) {
				return continuationByte & 0x3F;
			}
	
			// If we end up here, it’s not a continuation byte
			throw Error('Invalid continuation byte');
		}
	
		function decodeSymbol() {
			var byte1;
			var byte2;
			var byte3;
			var byte4;
			var codePoint;
	
			if (byteIndex > byteCount) {
				throw Error('Invalid byte index');
			}
	
			if (byteIndex == byteCount) {
				return false;
			}
	
			// Read first byte
			byte1 = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			// 1-byte sequence (no continuation bytes)
			if ((byte1 & 0x80) == 0) {
				return byte1;
			}
	
			// 2-byte sequence
			if ((byte1 & 0xE0) == 0xC0) {
				var byte2 = readContinuationByte();
				codePoint = ((byte1 & 0x1F) << 6) | byte2;
				if (codePoint >= 0x80) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 3-byte sequence (may include unpaired surrogates)
			if ((byte1 & 0xF0) == 0xE0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
				if (codePoint >= 0x0800) {
					checkScalarValue(codePoint);
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 4-byte sequence
			if ((byte1 & 0xF8) == 0xF0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				byte4 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 0x12) | (byte2 << 0x0C) |
					(byte3 << 0x06) | byte4;
				if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
					return codePoint;
				}
			}
	
			throw Error('Invalid UTF-8 detected');
		}
	
		var byteArray;
		var byteCount;
		var byteIndex;
		function utf8decode(byteString) {
			byteArray = ucs2decode(byteString);
			byteCount = byteArray.length;
			byteIndex = 0;
			var codePoints = [];
			var tmp;
			while ((tmp = decodeSymbol()) !== false) {
				codePoints.push(tmp);
			}
			return ucs2encode(codePoints);
		}
	
		/*--------------------------------------------------------------------------*/
	
		var utf8 = {
			'version': '2.0.0',
			'encode': utf8encode,
			'decode': utf8decode
		};
	
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return utf8;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = utf8;
			} else { // in Narwhal or RingoJS v0.7.0-
				var object = {};
				var hasOwnProperty = object.hasOwnProperty;
				for (var key in utf8) {
					hasOwnProperty.call(utf8, key) && (freeExports[key] = utf8[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.utf8 = utf8;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)(module), (function() { return this; }())))

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 This file is part of web3.js.
	
	 web3.js is free software: you can redistribute it and/or modify
	 it under the terms of the GNU Lesser General Public License as published by
	 the Free Software Foundation, either version 3 of the License, or
	 (at your option) any later version.
	
	 web3.js is distributed in the hope that it will be useful,
	 but WITHOUT ANY WARRANTY; without even the implied warranty of
	 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	 GNU Lesser General Public License for more details.
	
	 You should have received a copy of the GNU Lesser General Public License
	 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	 */
	/**
	 * @file soliditySha3.js
	 * @author Fabian Vogelsteller <fabian@ethereum.org>
	 * @date 2017
	 */
	
	var _ = __webpack_require__(12);
	var BN = __webpack_require__(7);
	var utils = __webpack_require__(323);
	
	
	var _elementaryName = function (name) {
	    /*jshint maxcomplexity:false */
	
	    if (name.startsWith('int[')) {
	        return 'int256' + name.slice(3);
	    } else if (name === 'int') {
	        return 'int256';
	    } else if (name.startsWith('uint[')) {
	        return 'uint256' + name.slice(4);
	    } else if (name === 'uint') {
	        return 'uint256';
	    } else if (name.startsWith('fixed[')) {
	        return 'fixed128x128' + name.slice(5);
	    } else if (name === 'fixed') {
	        return 'fixed128x128';
	    } else if (name.startsWith('ufixed[')) {
	        return 'ufixed128x128' + name.slice(6);
	    } else if (name === 'ufixed') {
	        return 'ufixed128x128';
	    }
	    return name;
	};
	
	// Parse N from type<N>
	var _parseTypeN = function (type) {
	    var typesize = /^\D+(\d+).*$/.exec(type);
	    return typesize ? parseInt(typesize[1], 10) : null;
	};
	
	// Parse N from type[<N>]
	var _parseTypeNArray = function (type) {
	    var arraySize = /^\D+\d*\[(\d+)\]$/.exec(type);
	    return arraySize ? parseInt(arraySize[1], 10) : null;
	};
	
	var _parseNumber = function (arg) {
	    var type = typeof arg;
	    if (type === 'string') {
	        if (utils.isHexStrict(arg)) {
	            return new BN(arg.replace(/0x/i,''), 16);
	        } else {
	            return new BN(arg, 10);
	        }
	    } else if (type === 'number') {
	        return new BN(arg);
	    } else if (utils.isBigNumber(arg)) {
	        return new BN(arg.toString(10));
	    } else if (utils.isBN(arg)) {
	        return arg;
	    } else {
	        throw new Error(arg +' is not a number');
	    }
	};
	
	var _solidityPack = function (type, value, arraySize) {
	    /*jshint maxcomplexity:false */
	
	    var size, num;
	    type = _elementaryName(type);
	
	
	    if (type === 'bytes') {
	
	        if (value.replace(/^0x/i,'').length % 2 !== 0) {
	            throw new Error('Invalid bytes characters '+ value.length);
	        }
	
	        return value;
	    } else if (type === 'string') {
	        return utils.utf8ToHex(value);
	    } else if (type === 'bool') {
	        return value ? '01' : '00';
	    } else if (type.startsWith('address')) {
	        if(arraySize) {
	            size = 64;
	        } else {
	            size = 40;
	        }
	
	        if(!utils.isAddress(value)) {
	            throw new Error(value +' is not a valid address, or the checksum is invalid.');
	        }
	
	        return utils.leftPad(value.toLowerCase(), size);
	    }
	
	    size = _parseTypeN(type);
	
	    if (type.startsWith('bytes')) {
	
	        if(!size) {
	            throw new Error('bytes[] not yet supported in solidity');
	        }
	
	        // must be 32 byte slices when in an array
	        if(arraySize) {
	            size = 32;
	        }
	
	        if (size < 1 || size > 32 || size < value.replace(/^0x/i,'').length / 2 ) {
	            throw new Error('Invalid bytes' + size +' for '+ value);
	        }
	
	        return utils.rightPad(value, size * 2);
	    } else if (type.startsWith('uint')) {
	
	        if ((size % 8) || (size < 8) || (size > 256)) {
	            throw new Error('Invalid uint'+size+' size');
	        }
	
	        num = _parseNumber(value);
	        if (num.bitLength() > size) {
	            throw new Error('Supplied uint exceeds width: ' + size + ' vs ' + num.bitLength());
	        }
	
	        if(num.lt(new BN(0))) {
	            throw new Error('Supplied uint '+ num.toString() +' is negative');
	        }
	
	        return size ? utils.leftPad(num.toString('hex'), size/8 * 2) : num;
	    } else if (type.startsWith('int')) {
	
	        if ((size % 8) || (size < 8) || (size > 256)) {
	            throw new Error('Invalid int'+size+' size');
	        }
	
	        num = _parseNumber(value);
	        if (num.bitLength() > size) {
	            throw new Error('Supplied int exceeds width: ' + size + ' vs ' + num.bitLength());
	        }
	
	        if(num.lt(new BN(0))) {
	            return num.toTwos(size).toString('hex');
	        } else {
	            return size ? utils.leftPad(num.toString('hex'), size/8 * 2) : num;
	        }
	
	    } else {
	        // FIXME: support all other types
	        throw new Error('Unsupported or invalid type: ' + type);
	    }
	};
	
	
	var _processSoliditySha3Args = function (arg) {
	    /*jshint maxcomplexity:false */
	
	    if(_.isArray(arg)) {
	        throw new Error('Autodetection of array types is not supported.');
	    }
	
	    var type, value = '';
	    var hexArg, arraySize;
	
	    // if type is given
	    if (_.isObject(arg) && (arg.hasOwnProperty('v') || arg.hasOwnProperty('t') || arg.hasOwnProperty('value') || arg.hasOwnProperty('type'))) {
	        type = arg.hasOwnProperty('t') ? arg.t : arg.type;
	        value = arg.hasOwnProperty('v') ? arg.v : arg.value;
	
	    // otherwise try to guess the type
	    } else {
	
	        type = utils.toHex(arg, true);
	        value = utils.toHex(arg);
	
	        if (!type.startsWith('int') && !type.startsWith('uint')) {
	            type = 'bytes';
	        }
	    }
	
	    if ((type.startsWith('int') || type.startsWith('uint')) &&  typeof value === 'string' && !/^(-)?0x/i.test(value)) {
	        value = new BN(value);
	    }
	
	    // get the array size
	    if(_.isArray(value)) {
	        arraySize = _parseTypeNArray(type);
	        if(arraySize && value.length !== arraySize) {
	            throw new Error(type +' is not matching the given array '+ JSON.stringify(value));
	        } else {
	            arraySize = value.length;
	        }
	    }
	
	
	    if (_.isArray(value)) {
	        hexArg = value.map(function (val) {
	            return _solidityPack(type, val, arraySize).toString('hex').replace('0x','');
	        });
	        return hexArg.join('');
	    } else {
	        hexArg = _solidityPack(type, value, arraySize);
	        return hexArg.toString('hex').replace('0x','');
	    }
	
	};
	
	/**
	 * Hashes solidity values to a sha3 hash using keccak 256
	 *
	 * @method soliditySha3
	 * @return {Object} the sha3
	 */
	var soliditySha3 = function () {
	    /*jshint maxcomplexity:false */
	
	    var args = Array.prototype.slice.call(arguments);
	
	    var hexArgs = _.map(args, _processSoliditySha3Args);
	
	    // console.log(args, hexArgs);
	    // console.log('0x'+ hexArgs.join(''));
	
	    return utils.sha3('0x'+ hexArgs.join(''));
	};
	
	
	module.exports = soliditySha3;


/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	/*
	    This file is part of web3.js.
	
	    web3.js is free software: you can redistribute it and/or modify
	    it under the terms of the GNU Lesser General Public License as published by
	    the Free Software Foundation, either version 3 of the License, or
	    (at your option) any later version.
	
	    web3.js is distributed in the hope that it will be useful,
	    but WITHOUT ANY WARRANTY; without even the implied warranty of
	    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	    GNU Lesser General Public License for more details.
	
	    You should have received a copy of the GNU Lesser General Public License
	    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
	*/
	/**
	 * @file index.js
	 * @authors:
	 *   Fabian Vogelsteller <fabian@ethereum.org>
	 *   Gav Wood <gav@parity.io>
	 *   Jeffrey Wilcke <jeffrey.wilcke@ethereum.org>
	 *   Marek Kotewicz <marek@parity.io>
	 *   Marian Oancea <marian@ethereum.org>
	 * @date 2017
	 */
	
	"use strict";
	
	
	var version = __webpack_require__(557).version;
	var core = __webpack_require__(49);
	var Eth = __webpack_require__(768);
	var Net = __webpack_require__(110);
	var Personal = __webpack_require__(322);
	var Shh = __webpack_require__(772);
	var Bzz = __webpack_require__(743);
	var utils = __webpack_require__(23);
	
	var Web3 = function Web3() {
	    var _this = this;
	
	    // sets _requestmanager etc
	    core.packageInit(this, arguments);
	
	    this.version = version;
	    this.utils = utils;
	
	    this.eth = new Eth(this);
	    this.shh = new Shh(this);
	    this.bzz = new Bzz(this);
	
	    // overwrite package setProvider
	    var setProvider = this.setProvider;
	    this.setProvider = function (provider, net) {
	        setProvider.apply(_this, arguments);
	
	        this.eth.setProvider(provider, net);
	        this.shh.setProvider(provider, net);
	        this.bzz.setProvider(provider);
	
	        return true;
	    };
	};
	
	Web3.version = version;
	Web3.utils = utils;
	Web3.modules = {
	    Eth: Eth,
	    Net: Net,
	    Personal: Personal,
	    Shh: Shh,
	    Bzz: Bzz
	};
	
	core.addProviders(Web3);
	
	module.exports = Web3;
	


/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	var _global = (function() { return this || {}; })();
	var NativeWebSocket = _global.WebSocket || _global.MozWebSocket;
	var websocket_version = __webpack_require__(777);
	
	
	/**
	 * Expose a W3C WebSocket class with just one or two arguments.
	 */
	function W3CWebSocket(uri, protocols) {
		var native_instance;
	
		if (protocols) {
			native_instance = new NativeWebSocket(uri, protocols);
		}
		else {
			native_instance = new NativeWebSocket(uri);
		}
	
		/**
		 * 'native_instance' is an instance of nativeWebSocket (the browser's WebSocket
		 * class). Since it is an Object it will be returned as it is when creating an
		 * instance of W3CWebSocket via 'new W3CWebSocket()'.
		 *
		 * ECMAScript 5: http://bclary.com/2004/11/07/#a-13.2.2
		 */
		return native_instance;
	}
	if (NativeWebSocket) {
		['CONNECTING', 'OPEN', 'CLOSING', 'CLOSED'].forEach(function(prop) {
			Object.defineProperty(W3CWebSocket, prop, {
				get: function() { return NativeWebSocket[prop]; }
			});
		});
	}
	
	/**
	 * Module exports.
	 */
	module.exports = {
	    'w3cwebsocket' : NativeWebSocket ? W3CWebSocket : null,
	    'version'      : websocket_version
	};


/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(558).version;


/***/ },
/* 778 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	var request = __webpack_require__(780)
	
	module.exports = function (url, options) {
	  return new Promise(function (resolve, reject) {
	    request(url, options, function (err, data) {
	      if (err) reject(err);
	      else resolve(data);
	    });
	  });
	};


/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	var queryString = __webpack_require__(784)
	var setQuery = __webpack_require__(735)
	var assign = __webpack_require__(324)
	var ensureHeader = __webpack_require__(781)
	
	// this is replaced in the browser
	var request = __webpack_require__(783)
	
	var mimeTypeJson = 'application/json'
	var noop = function () {}
	
	module.exports = xhrRequest
	function xhrRequest (url, opt, cb) {
	  if (!url || typeof url !== 'string') {
	    throw new TypeError('must specify a URL')
	  }
	  if (typeof opt === 'function') {
	    cb = opt
	    opt = {}
	  }
	  if (cb && typeof cb !== 'function') {
	    throw new TypeError('expected cb to be undefined or a function')
	  }
	
	  cb = cb || noop
	  opt = opt || {}
	
	  var defaultResponse = opt.json ? 'json' : 'text'
	  opt = assign({ responseType: defaultResponse }, opt)
	
	  var headers = opt.headers || {}
	  var method = (opt.method || 'GET').toUpperCase()
	  var query = opt.query
	  if (query) {
	    if (typeof query !== 'string') {
	      query = queryString.stringify(query)
	    }
	    url = setQuery(url, query)
	  }
	
	  // allow json response
	  if (opt.responseType === 'json') {
	    ensureHeader(headers, 'Accept', mimeTypeJson)
	  }
	
	  // if body content is json
	  if (opt.json && method !== 'GET' && method !== 'HEAD') {
	    ensureHeader(headers, 'Content-Type', mimeTypeJson)
	    opt.body = JSON.stringify(opt.body)
	  }
	
	  opt.method = method
	  opt.url = url
	  opt.headers = headers
	  delete opt.query
	  delete opt.json
	
	  return request(opt, cb)
	}


/***/ },
/* 781 */
/***/ function(module, exports) {

	module.exports = ensureHeader
	function ensureHeader (headers, key, value) {
	  var lower = key.toLowerCase()
	  if (!headers[key] && !headers[lower]) {
	    headers[key] = value
	  }
	}


/***/ },
/* 782 */
/***/ function(module, exports) {

	module.exports = getResponse
	function getResponse (opt, resp) {
	  if (!resp) return null
	  return {
	    statusCode: resp.statusCode,
	    headers: resp.headers,
	    method: opt.method,
	    url: opt.url,
	    // the XHR object in browser, http response in Node
	    rawRequest: resp.rawRequest ? resp.rawRequest : resp
	  }
	}


/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	var xhr = __webpack_require__(785)
	var normalize = __webpack_require__(782)
	var noop = function () {}
	
	module.exports = xhrRequest
	function xhrRequest (opt, cb) {
	  delete opt.uri
	
	  // for better JSON.parse error handling than xhr module
	  var useJson = false
	  if (opt.responseType === 'json') {
	    opt.responseType = 'text'
	    useJson = true
	  }
	
	  var req = xhr(opt, function xhrRequestResult (err, resp, body) {
	    if (useJson && !err) {
	      try {
	        var text = resp.rawRequest.responseText
	        body = JSON.parse(text)
	      } catch (e) {
	        err = e
	      }
	    }
	
	    resp = normalize(opt, resp)
	    if (err) cb(err, null, resp)
	    else cb(err, body, resp)
	    cb = noop
	  })
	
	  // Patch abort() so that it also calls the callback, but with an error
	  var onabort = req.onabort
	  req.onabort = function () {
	    var ret = onabort.apply(req, Array.prototype.slice.call(arguments))
	    cb(new Error('XHR Aborted'))
	    cb = noop
	    return ret
	  }
	
	  return req
	}


/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(310);
	var objectAssign = __webpack_require__(324);
	var decodeComponent = __webpack_require__(471);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	function extract(str) {
		var queryStart = str.indexOf('?');
		if (queryStart === -1) {
			return '';
		}
		return str.slice(queryStart + 1);
	}
	
	function parse(str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^[?#&]/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeComponent(val);
	
			formatter(decodeComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	}
	
	exports.extract = extract;
	exports.parse = parse;
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		if (opts.sort === false) {
			opts.sort = function () {};
		}
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};
	
	exports.parseUrl = function (str, opts) {
		return {
			url: str.split('?')[0] || '',
			query: parse(extract(str), opts)
		};
	};


/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var window = __webpack_require__(533)
	var isFunction = __webpack_require__(233)
	var parseHeaders = __webpack_require__(588)
	var xtend = __webpack_require__(325)
	
	module.exports = createXHR
	createXHR.XMLHttpRequest = window.XMLHttpRequest || noop
	createXHR.XDomainRequest = "withCredentials" in (new createXHR.XMLHttpRequest()) ? createXHR.XMLHttpRequest : window.XDomainRequest
	
	forEachArray(["get", "put", "post", "patch", "head", "delete"], function(method) {
	    createXHR[method === "delete" ? "del" : method] = function(uri, options, callback) {
	        options = initParams(uri, options, callback)
	        options.method = method.toUpperCase()
	        return _createXHR(options)
	    }
	})
	
	function forEachArray(array, iterator) {
	    for (var i = 0; i < array.length; i++) {
	        iterator(array[i])
	    }
	}
	
	function isEmpty(obj){
	    for(var i in obj){
	        if(obj.hasOwnProperty(i)) return false
	    }
	    return true
	}
	
	function initParams(uri, options, callback) {
	    var params = uri
	
	    if (isFunction(options)) {
	        callback = options
	        if (typeof uri === "string") {
	            params = {uri:uri}
	        }
	    } else {
	        params = xtend(options, {uri: uri})
	    }
	
	    params.callback = callback
	    return params
	}
	
	function createXHR(uri, options, callback) {
	    options = initParams(uri, options, callback)
	    return _createXHR(options)
	}
	
	function _createXHR(options) {
	    if(typeof options.callback === "undefined"){
	        throw new Error("callback argument missing")
	    }
	
	    var called = false
	    var callback = function cbOnce(err, response, body){
	        if(!called){
	            called = true
	            options.callback(err, response, body)
	        }
	    }
	
	    function readystatechange() {
	        if (xhr.readyState === 4) {
	            setTimeout(loadFunc, 0)
	        }
	    }
	
	    function getBody() {
	        // Chrome with requestType=blob throws errors arround when even testing access to responseText
	        var body = undefined
	
	        if (xhr.response) {
	            body = xhr.response
	        } else {
	            body = xhr.responseText || getXml(xhr)
	        }
	
	        if (isJson) {
	            try {
	                body = JSON.parse(body)
	            } catch (e) {}
	        }
	
	        return body
	    }
	
	    function errorFunc(evt) {
	        clearTimeout(timeoutTimer)
	        if(!(evt instanceof Error)){
	            evt = new Error("" + (evt || "Unknown XMLHttpRequest Error") )
	        }
	        evt.statusCode = 0
	        return callback(evt, failureResponse)
	    }
	
	    // will load the data & process the response in a special response object
	    function loadFunc() {
	        if (aborted) return
	        var status
	        clearTimeout(timeoutTimer)
	        if(options.useXDR && xhr.status===undefined) {
	            //IE8 CORS GET successful response doesn't have a status field, but body is fine
	            status = 200
	        } else {
	            status = (xhr.status === 1223 ? 204 : xhr.status)
	        }
	        var response = failureResponse
	        var err = null
	
	        if (status !== 0){
	            response = {
	                body: getBody(),
	                statusCode: status,
	                method: method,
	                headers: {},
	                url: uri,
	                rawRequest: xhr
	            }
	            if(xhr.getAllResponseHeaders){ //remember xhr can in fact be XDR for CORS in IE
	                response.headers = parseHeaders(xhr.getAllResponseHeaders())
	            }
	        } else {
	            err = new Error("Internal XMLHttpRequest Error")
	        }
	        return callback(err, response, response.body)
	    }
	
	    var xhr = options.xhr || null
	
	    if (!xhr) {
	        if (options.cors || options.useXDR) {
	            xhr = new createXHR.XDomainRequest()
	        }else{
	            xhr = new createXHR.XMLHttpRequest()
	        }
	    }
	
	    var key
	    var aborted
	    var uri = xhr.url = options.uri || options.url
	    var method = xhr.method = options.method || "GET"
	    var body = options.body || options.data
	    var headers = xhr.headers = options.headers || {}
	    var sync = !!options.sync
	    var isJson = false
	    var timeoutTimer
	    var failureResponse = {
	        body: undefined,
	        headers: {},
	        statusCode: 0,
	        method: method,
	        url: uri,
	        rawRequest: xhr
	    }
	
	    if ("json" in options && options.json !== false) {
	        isJson = true
	        headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json") //Don't override existing accept header declared by user
	        if (method !== "GET" && method !== "HEAD") {
	            headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json") //Don't override existing accept header declared by user
	            body = JSON.stringify(options.json === true ? body : options.json)
	        }
	    }
	
	    xhr.onreadystatechange = readystatechange
	    xhr.onload = loadFunc
	    xhr.onerror = errorFunc
	    // IE9 must have onprogress be set to a unique function.
	    xhr.onprogress = function () {
	        // IE must die
	    }
	    xhr.onabort = function(){
	        aborted = true;
	    }
	    xhr.ontimeout = errorFunc
	    xhr.open(method, uri, !sync, options.username, options.password)
	    //has to be after open
	    if(!sync) {
	        xhr.withCredentials = !!options.withCredentials
	    }
	    // Cannot set timeout with sync request
	    // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
	    // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent
	    if (!sync && options.timeout > 0 ) {
	        timeoutTimer = setTimeout(function(){
	            if (aborted) return
	            aborted = true//IE9 may still call readystatechange
	            xhr.abort("timeout")
	            var e = new Error("XMLHttpRequest timeout")
	            e.code = "ETIMEDOUT"
	            errorFunc(e)
	        }, options.timeout )
	    }
	
	    if (xhr.setRequestHeader) {
	        for(key in headers){
	            if(headers.hasOwnProperty(key)){
	                xhr.setRequestHeader(key, headers[key])
	            }
	        }
	    } else if (options.headers && !isEmpty(options.headers)) {
	        throw new Error("Headers cannot be set on an XDomainRequest object")
	    }
	
	    if ("responseType" in options) {
	        xhr.responseType = options.responseType
	    }
	
	    if ("beforeSend" in options &&
	        typeof options.beforeSend === "function"
	    ) {
	        options.beforeSend(xhr)
	    }
	
	    // Microsoft Edge browser sends "undefined" when send is called with undefined value.
	    // XMLHttpRequest spec says to pass null as body to indicate no body
	    // See https://github.com/naugtur/xhr/issues/100.
	    xhr.send(body || null)
	
	    return xhr
	
	
	}
	
	function getXml(xhr) {
	    // xhr.responseXML will throw Exception "InvalidStateError" or "DOMException"
	    // See https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseXML.
	    try {
	        if (xhr.responseType === "document") {
	            return xhr.responseXML
	        }
	        var firefoxBugTakenEffect = xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror"
	        if (xhr.responseType === "" && !firefoxBugTakenEffect) {
	            return xhr.responseXML
	        }
	    } catch (e) {}
	
	    return null
	}
	
	function noop() {}


/***/ },
/* 786 */
/***/ function(module, exports) {

	module.exports = XMLHttpRequest;


/***/ },
/* 787 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 788 */
787,
/* 789 */
787,
/* 790 */
787,
/* 791 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	module.exports = __webpack_require__(__webpack_module_template_argument_0__);


/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var A = __webpack_require__(__webpack_module_template_argument_0__);
	
	var at = function at(bytes, index) {
	  return parseInt(bytes.slice(index * 2 + 2, index * 2 + 4), 16);
	};
	
	var random = function random(bytes) {
	  var rnd = void 0;
	  if (typeof window !== "undefined" && window.crypto && window.crypto.getRandomValues) rnd = window.crypto.getRandomValues(new Uint8Array(bytes));else if (true) rnd = __webpack_require__(129).randomBytes(bytes);else throw "Safe random numbers not available.";
	  var hex = "0x";
	  for (var i = 0; i < bytes; ++i) {
	    hex += ("00" + rnd[i].toString(16)).slice(-2);
	  }return hex;
	};
	
	var length = function length(a) {
	  return (a.length - 2) / 2;
	};
	
	var flatten = function flatten(a) {
	  return "0x" + a.reduce(function (r, s) {
	    return r + s.slice(2);
	  }, "");
	};
	
	var slice = function slice(i, j, bs) {
	  return "0x" + bs.slice(i * 2 + 2, j * 2 + 2);
	};
	
	var reverse = function reverse(hex) {
	  var rev = "0x";
	  for (var i = 0, l = length(hex); i < l; ++i) {
	    rev += hex.slice((l - i) * 2, (l - i + 1) * 2);
	  }
	  return rev;
	};
	
	var pad = function pad(l, hex) {
	  return hex.length === l * 2 + 2 ? hex : pad(l, "0x" + "0" + hex.slice(2));
	};
	
	var padRight = function padRight(l, hex) {
	  return hex.length === l * 2 + 2 ? hex : padRight(l, hex + "0");
	};
	
	var toArray = function toArray(hex) {
	  var arr = [];
	  for (var i = 2, l = hex.length; i < l; i += 2) {
	    arr.push(parseInt(hex.slice(i, i + 2), 16));
	  }return arr;
	};
	
	var fromArray = function fromArray(arr) {
	  var hex = "0x";
	  for (var i = 0, l = arr.length; i < l; ++i) {
	    var b = arr[i];
	    hex += (b < 16 ? "0" : "") + b.toString(16);
	  }
	  return hex;
	};
	
	var toUint8Array = function toUint8Array(hex) {
	  return new Uint8Array(toArray(hex));
	};
	
	var fromUint8Array = function fromUint8Array(arr) {
	  return fromArray([].slice.call(arr, 0));
	};
	
	var fromNumber = function fromNumber(num) {
	  var hex = num.toString(16);
	  return hex.length % 2 === 0 ? "0x" + hex : "0x0" + hex;
	};
	
	var toNumber = function toNumber(hex) {
	  return parseInt(hex.slice(2), 16);
	};
	
	var concat = function concat(a, b) {
	  return a.concat(b.slice(2));
	};
	
	var fromNat = function fromNat(bn) {
	  return bn === "0x0" ? "0x" : bn.length % 2 === 0 ? bn : "0x0" + bn.slice(2);
	};
	
	var toNat = function toNat(bn) {
	  return bn[2] === "0" ? "0x" + bn.slice(3) : bn;
	};
	
	var fromAscii = function fromAscii(ascii) {
	  var hex = "0x";
	  for (var i = 0; i < ascii.length; ++i) {
	    hex += ("00" + ascii.charCodeAt(i).toString(16)).slice(-2);
	  }return hex;
	};
	
	var toAscii = function toAscii(hex) {
	  var ascii = "";
	  for (var i = 2; i < hex.length; i += 2) {
	    ascii += String.fromCharCode(parseInt(hex.slice(i, i + 2), 16));
	  }return ascii;
	};
	
	// From https://gist.github.com/pascaldekloe/62546103a1576803dade9269ccf76330
	var fromString = function fromString(s) {
	  var makeByte = function makeByte(uint8) {
	    var b = uint8.toString(16);
	    return b.length < 2 ? "0" + b : b;
	  };
	  var bytes = "0x";
	  for (var ci = 0; ci != s.length; ci++) {
	    var c = s.charCodeAt(ci);
	    if (c < 128) {
	      bytes += makeByte(c);
	      continue;
	    }
	    if (c < 2048) {
	      bytes += makeByte(c >> 6 | 192);
	    } else {
	      if (c > 0xd7ff && c < 0xdc00) {
	        if (++ci == s.length) return null;
	        var c2 = s.charCodeAt(ci);
	        if (c2 < 0xdc00 || c2 > 0xdfff) return null;
	        c = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
	        bytes += makeByte(c >> 18 | 240);
	        bytes += makeByte(c >> 12 & 63 | 128);
	      } else {
	        // c <= 0xffff
	        bytes += makeByte(c >> 12 | 224);
	      }
	      bytes += makeByte(c >> 6 & 63 | 128);
	    }
	    bytes += makeByte(c & 63 | 128);
	  }
	  return bytes;
	};
	
	var toString = function toString(bytes) {
	  var s = '';
	  var i = 0;
	  var l = length(bytes);
	  while (i < l) {
	    var c = at(bytes, i++);
	    if (c > 127) {
	      if (c > 191 && c < 224) {
	        if (i >= l) return null;
	        c = (c & 31) << 6 | at(bytes, i) & 63;
	      } else if (c > 223 && c < 240) {
	        if (i + 1 >= l) return null;
	        c = (c & 15) << 12 | (at(bytes, i) & 63) << 6 | at(bytes, ++i) & 63;
	      } else if (c > 239 && c < 248) {
	        if (i + 2 >= l) return null;
	        c = (c & 7) << 18 | (at(bytes, i) & 63) << 12 | (at(bytes, ++i) & 63) << 6 | at(bytes, ++i) & 63;
	      } else return null;
	      ++i;
	    }
	    if (c <= 0xffff) s += String.fromCharCode(c);else if (c <= 0x10ffff) {
	      c -= 0x10000;
	      s += String.fromCharCode(c >> 10 | 0xd800);
	      s += String.fromCharCode(c & 0x3FF | 0xdc00);
	    } else return null;
	  }
	  return s;
	};
	
	module.exports = {
	  random: random,
	  length: length,
	  concat: concat,
	  flatten: flatten,
	  slice: slice,
	  reverse: reverse,
	  pad: pad,
	  padRight: padRight,
	  fromAscii: fromAscii,
	  toAscii: toAscii,
	  fromString: fromString,
	  toString: toString,
	  fromNumber: fromNumber,
	  toNumber: toNumber,
	  fromNat: fromNat,
	  toNat: toNat,
	  fromArray: fromArray,
	  toArray: toArray,
	  fromUint8Array: fromUint8Array,
	  toUint8Array: toUint8Array
	};

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.9753f4fc.js